/* tslint:disable */
/* eslint-disable */
/**
 * WoofWoof
 * API description
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 *
 * @export
 * @interface AbortVisitDto
 */
export interface AbortVisitDto {
    /**
     *
     * @type {string}
     * @memberof AbortVisitDto
     */
    'visitId': string;
    /**
     *
     * @type {string}
     * @memberof AbortVisitDto
     */
    'abortReason': AbortVisitDtoAbortReasonEnum;
    /**
     *
     * @type {string}
     * @memberof AbortVisitDto
     */
    'abortNote': string;
}

export const AbortVisitDtoAbortReasonEnum = {
    Reschedule: 'reschedule',
    ConnectionIssue: 'connection_issue',
    IncorrectProfessional: 'incorrect_professional',
    Other: 'other'
} as const;

export type AbortVisitDtoAbortReasonEnum = typeof AbortVisitDtoAbortReasonEnum[keyof typeof AbortVisitDtoAbortReasonEnum];

/**
 *
 * @export
 * @interface AcceptTermsConditionsDto
 */
export interface AcceptTermsConditionsDto {
    /**
     * Array of document IDs to accept (T&C and/or privacy policy)
     * @type {Array<string>}
     * @memberof AcceptTermsConditionsDto
     */
    'documentIds': Array<string>;
}
/**
 *
 * @export
 * @interface AcceptTermsConditionsResponseDto
 */
export interface AcceptTermsConditionsResponseDto {
    /**
     *
     * @type {boolean}
     * @memberof AcceptTermsConditionsResponseDto
     */
    'success': boolean;
    /**
     *
     * @type {string}
     * @memberof AcceptTermsConditionsResponseDto
     */
    'message': string;
}
/**
 *
 * @export
 * @interface AcceptedDocumentDto
 */
export interface AcceptedDocumentDto {
    /**
     * ID of the accepted document
     * @type {string}
     * @memberof AcceptedDocumentDto
     */
    'termId': string;
    /**
     * Date when the document was accepted
     * @type {string}
     * @memberof AcceptedDocumentDto
     */
    'approvedAt': string;
}
/**
 *
 * @export
 * @interface AcknowledgeVoiceProductionQualificationRenewalDto
 */
export interface AcknowledgeVoiceProductionQualificationRenewalDto {
    /**
     *
     * @type {number}
     * @memberof AcknowledgeVoiceProductionQualificationRenewalDto
     */
    'expectedRevision': number;
    /**
     *
     * @type {string}
     * @memberof AcknowledgeVoiceProductionQualificationRenewalDto
     */
    'acknowledgement': AcknowledgeVoiceProductionQualificationRenewalDtoAcknowledgementEnum;
}

export const AcknowledgeVoiceProductionQualificationRenewalDtoAcknowledgementEnum = {
    HumanAcknowledgedVoiceProductionQualificationRenewalDeadline: 'HUMAN_ACKNOWLEDGED_VOICE_PRODUCTION_QUALIFICATION_RENEWAL_DEADLINE'
} as const;

export type AcknowledgeVoiceProductionQualificationRenewalDtoAcknowledgementEnum = typeof AcknowledgeVoiceProductionQualificationRenewalDtoAcknowledgementEnum[keyof typeof AcknowledgeVoiceProductionQualificationRenewalDtoAcknowledgementEnum];

/**
 *
 * @export
 * @interface AcquisitionMetricsDto
 */
export interface AcquisitionMetricsDto {
    /**
     *
     * @type {number}
     * @memberof AcquisitionMetricsDto
     */
    'sessions': number;
    /**
     * Distinct users within this row or total. User counts are not additive across rows.
     * @type {number}
     * @memberof AcquisitionMetricsDto
     */
    'users': number;
    /**
     * Engaged sessions divided by sessions, 0-1.
     * @type {number}
     * @memberof AcquisitionMetricsDto
     */
    'engagementRate': number;
    /**
     * Count of GA4 key events (for example generate_lead, sign_up), not unique people.
     * @type {number}
     * @memberof AcquisitionMetricsDto
     */
    'keyEvents': number;
}
/**
 *
 * @export
 * @interface AcquisitionReportDto
 */
export interface AcquisitionReportDto {
    /**
     *
     * @type {string}
     * @memberof AcquisitionReportDto
     */
    'status': AcquisitionReportDtoStatusEnum;
    /**
     *
     * @type {number}
     * @memberof AcquisitionReportDto
     */
    'days': AcquisitionReportDtoDaysEnum;
    /**
     *
     * @type {string}
     * @memberof AcquisitionReportDto
     */
    'propertyId'?: string;
    /**
     * GA4 property reporting time zone.
     * @type {string}
     * @memberof AcquisitionReportDto
     */
    'timeZone'?: string;
    /**
     * When the backend read GA4 (ISO 8601).
     * @type {string}
     * @memberof AcquisitionReportDto
     */
    'fetchedAt'?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof AcquisitionReportDto
     */
    'caveats': Array<AcquisitionReportDtoCaveatsEnum>;
    /**
     *
     * @type {AcquisitionMetricsDto}
     * @memberof AcquisitionReportDto
     */
    'summary'?: AcquisitionMetricsDto;
    /**
     *
     * @type {AcquisitionTableDto}
     * @memberof AcquisitionReportDto
     */
    'sources'?: AcquisitionTableDto;
    /**
     *
     * @type {AcquisitionTableDto}
     * @memberof AcquisitionReportDto
     */
    'campaigns'?: AcquisitionTableDto;
    /**
     *
     * @type {AcquisitionTableDto}
     * @memberof AcquisitionReportDto
     */
    'landingPages'?: AcquisitionTableDto;
}

export const AcquisitionReportDtoStatusEnum = {
    Ok: 'ok',
    NotConfigured: 'not_configured',
    Misconfigured: 'misconfigured',
    PermissionDenied: 'permission_denied',
    Unavailable: 'unavailable'
} as const;

export type AcquisitionReportDtoStatusEnum = typeof AcquisitionReportDtoStatusEnum[keyof typeof AcquisitionReportDtoStatusEnum];
export const AcquisitionReportDtoDaysEnum = {
    NUMBER_7: 7,
    NUMBER_28: 28,
    NUMBER_90: 90
} as const;

export type AcquisitionReportDtoDaysEnum = typeof AcquisitionReportDtoDaysEnum[keyof typeof AcquisitionReportDtoDaysEnum];
export const AcquisitionReportDtoCaveatsEnum = {
    Sampled: 'sampled',
    Thresholded: 'thresholded',
    OtherRow: 'other_row'
} as const;

export type AcquisitionReportDtoCaveatsEnum = typeof AcquisitionReportDtoCaveatsEnum[keyof typeof AcquisitionReportDtoCaveatsEnum];

/**
 *
 * @export
 * @interface AcquisitionRowDto
 */
export interface AcquisitionRowDto {
    /**
     *
     * @type {number}
     * @memberof AcquisitionRowDto
     */
    'sessions': number;
    /**
     * Distinct users within this row or total. User counts are not additive across rows.
     * @type {number}
     * @memberof AcquisitionRowDto
     */
    'users': number;
    /**
     * Engaged sessions divided by sessions, 0-1.
     * @type {number}
     * @memberof AcquisitionRowDto
     */
    'engagementRate': number;
    /**
     * Count of GA4 key events (for example generate_lead, sign_up), not unique people.
     * @type {number}
     * @memberof AcquisitionRowDto
     */
    'keyEvents': number;
    /**
     * GA4 session source, e.g. facebook, ig, instagram, google.
     * @type {string}
     * @memberof AcquisitionRowDto
     */
    'source'?: string;
    /**
     * GA4 session medium, e.g. social, paid_social, organic.
     * @type {string}
     * @memberof AcquisitionRowDto
     */
    'medium'?: string;
    /**
     * utm_campaign or a GA4 placeholder such as (not set).
     * @type {string}
     * @memberof AcquisitionRowDto
     */
    'campaign'?: string;
    /**
     * utm_content or (not set).
     * @type {string}
     * @memberof AcquisitionRowDto
     */
    'content'?: string;
    /**
     * First page path of the session, without query string or fragment. Identical paths on different hosts of the property are combined.
     * @type {string}
     * @memberof AcquisitionRowDto
     */
    'path'?: string;
}
/**
 *
 * @export
 * @interface AcquisitionTableDto
 */
export interface AcquisitionTableDto {
    /**
     *
     * @type {Array<AcquisitionRowDto>}
     * @memberof AcquisitionTableDto
     */
    'rows': Array<AcquisitionRowDto>;
    /**
     * All matching GA4 rows; more than rows.length means the table was cut.
     * @type {number}
     * @memberof AcquisitionTableDto
     */
    'rowCount': number;
}
/**
 *
 * @export
 * @interface ActionItemDto
 */
export interface ActionItemDto {
    /**
     * Title of the action item
     * @type {string}
     * @memberof ActionItemDto
     */
    'title': string;
    /**
     * Description of the action item
     * @type {string}
     * @memberof ActionItemDto
     */
    'description': string;
    /**
     * Priority level of the action item
     * @type {string}
     * @memberof ActionItemDto
     */
    'priority': ActionItemDtoPriorityEnum;
    /**
     * Due date for the action item
     * @type {string}
     * @memberof ActionItemDto
     */
    'dueDate'?: string;
}

export const ActionItemDtoPriorityEnum = {
    High: 'high',
    Medium: 'medium',
    Low: 'low'
} as const;

export type ActionItemDtoPriorityEnum = typeof ActionItemDtoPriorityEnum[keyof typeof ActionItemDtoPriorityEnum];

/**
 *
 * @export
 * @interface ActiveInformationalServiceResponseDto
 */
export interface ActiveInformationalServiceResponseDto {
    /**
     *
     * @type {string}
     * @memberof ActiveInformationalServiceResponseDto
     */
    'serviceId': string;
    /**
     *
     * @type {string}
     * @memberof ActiveInformationalServiceResponseDto
     */
    'displayName': string;
    /**
     *
     * @type {number}
     * @memberof ActiveInformationalServiceResponseDto
     */
    'durationMinutes': number;
    /**
     *
     * @type {number}
     * @memberof ActiveInformationalServiceResponseDto
     */
    'priceAmountMinor': number;
    /**
     *
     * @type {number}
     * @memberof ActiveInformationalServiceResponseDto
     */
    'voiceBookable': ActiveInformationalServiceResponseDtoVoiceBookableEnum;
    /**
     *
     * @type {string}
     * @memberof ActiveInformationalServiceResponseDto
     */
    'bookingKind': ActiveInformationalServiceResponseDtoBookingKindEnum;
}

export const ActiveInformationalServiceResponseDtoVoiceBookableEnum = {
    NUMBER_null: null
} as const;

export type ActiveInformationalServiceResponseDtoVoiceBookableEnum = typeof ActiveInformationalServiceResponseDtoVoiceBookableEnum[keyof typeof ActiveInformationalServiceResponseDtoVoiceBookableEnum];
export const ActiveInformationalServiceResponseDtoBookingKindEnum = {
    InformationalNotVoiceBookable: 'INFORMATIONAL_NOT_VOICE_BOOKABLE'
} as const;

export type ActiveInformationalServiceResponseDtoBookingKindEnum = typeof ActiveInformationalServiceResponseDtoBookingKindEnum[keyof typeof ActiveInformationalServiceResponseDtoBookingKindEnum];

/**
 *
 * @export
 * @interface AddDraftNotesDto
 */
export interface AddDraftNotesDto {
    /**
     * Patient notes kept as a draft — saved for the organisation, not sent to the owner.
     * @type {string}
     * @memberof AddDraftNotesDto
     */
    'notesDraft': string;
    /**
     * Internal notes. Never patient-facing, so they are saved normally alongside the draft.
     * @type {string}
     * @memberof AddDraftNotesDto
     */
    'internalNotes'?: string;
}
/**
 *
 * @export
 * @interface AddFacilityMedicationDto
 */
export interface AddFacilityMedicationDto {
    /**
     * Strength value
     * @type {number}
     * @memberof AddFacilityMedicationDto
     */
    'strengthValue'?: number;
    /**
     *
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'strengthUnit'?: AddFacilityMedicationDtoStrengthUnitEnum;
    /**
     * Required when strengthUnit is OTHER
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'strengthUnitCustom'?: string;
    /**
     *
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'form'?: AddFacilityMedicationDtoFormEnum;
    /**
     * Required when form is OTHER
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'formCustom'?: string;
    /**
     * Amount given per administration, e.g. half a tablet
     * @type {number}
     * @memberof AddFacilityMedicationDto
     */
    'quantityValue'?: number;
    /**
     *
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'quantityCustom'?: string;
    /**
     * Recorded before the dose is known, e.g. pending a weigh-in
     * @type {boolean}
     * @memberof AddFacilityMedicationDto
     */
    'dosagePending'?: boolean;
    /**
     *
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'frequencyType'?: AddFacilityMedicationDtoFrequencyTypeEnum;
    /**
     *
     * @type {number}
     * @memberof AddFacilityMedicationDto
     */
    'frequencyValue'?: number;
    /**
     * Required when frequencyType is OTHER
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'frequencyCustom'?: string;
    /**
     *
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'durationType'?: AddFacilityMedicationDtoDurationTypeEnum;
    /**
     *
     * @type {number}
     * @memberof AddFacilityMedicationDto
     */
    'durationValue'?: number;
    /**
     * Required when durationType is OTHER
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'durationCustom'?: string;
    /**
     * Dosing that changes over the course, e.g. a steroid taper
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'dosageSchedule'?: string;
    /**
     * What the medication is for
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'indication'?: string;
    /**
     *
     * @type {boolean}
     * @memberof AddFacilityMedicationDto
     */
    'adverseReaction'?: boolean;
    /**
     *
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'adverseReactionNote'?: string;
    /**
     * When the patient started taking it
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'startedAt'?: string;
    /**
     * Medicine product ID from the medicine database
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'medicineProductId'?: string;
    /**
     * Name of the medication (required if medicineProductId not provided)
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'name'?: string;
    /**
     * Preparation type
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'preparationType'?: string;
    /**
     * Dosage amount (deprecated — use quantityValue)
     * @type {number}
     * @memberof AddFacilityMedicationDto
     */
    'dosage'?: number;
    /**
     * Dosage interval (deprecated — use frequencyType)
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'dosageInterval'?: AddFacilityMedicationDtoDosageIntervalEnum;
    /**
     * Additional notes about the medication
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'notes'?: string;
    /**
     *
     * @type {boolean}
     * @memberof AddFacilityMedicationDto
     */
    'reminderEnabled'?: boolean;
    /**
     *
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'reminderDescription'?: string;
    /**
     *
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'reminderScheduledAt'?: string;
    /**
     *
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'reminderRecurrenceType'?: AddFacilityMedicationDtoReminderRecurrenceTypeEnum;
    /**
     *
     * @type {CustomRecurrenceDto}
     * @memberof AddFacilityMedicationDto
     */
    'reminderCustomRecurrence'?: CustomRecurrenceDto;
    /**
     *
     * @type {Array<string>}
     * @memberof AddFacilityMedicationDto
     */
    'reminderNotificationChannels'?: Array<AddFacilityMedicationDtoReminderNotificationChannelsEnum>;
    /**
     *
     * @type {AddFacilityMedicationDtoStock}
     * @memberof AddFacilityMedicationDto
     */
    'stock'?: AddFacilityMedicationDtoStock | null;
    /**
     * Client UUID v4, one per submit series; required when `stock` is sent, claimed whenever sent (R3-4)
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'operationKey'?: string;
    /**
     *
     * @type {string}
     * @memberof AddFacilityMedicationDto
     */
    'visitId'?: string;
}

export const AddFacilityMedicationDtoStrengthUnitEnum = {
    Mg: 'MG',
    G: 'G',
    Mcg: 'MCG',
    Ml: 'ML',
    Iu: 'IU',
    Percent: 'PERCENT',
    None: 'NONE',
    Other: 'OTHER'
} as const;

export type AddFacilityMedicationDtoStrengthUnitEnum = typeof AddFacilityMedicationDtoStrengthUnitEnum[keyof typeof AddFacilityMedicationDtoStrengthUnitEnum];
export const AddFacilityMedicationDtoFormEnum = {
    Tablet: 'TABLET',
    Capsule: 'CAPSULE',
    Sachet: 'SACHET',
    Suspension: 'SUSPENSION',
    Solution: 'SOLUTION',
    Drops: 'DROPS',
    Injection: 'INJECTION',
    Ointment: 'OINTMENT',
    SpotOn: 'SPOT_ON',
    Spray: 'SPRAY',
    Powder: 'POWDER',
    Paste: 'PASTE',
    Other: 'OTHER'
} as const;

export type AddFacilityMedicationDtoFormEnum = typeof AddFacilityMedicationDtoFormEnum[keyof typeof AddFacilityMedicationDtoFormEnum];
export const AddFacilityMedicationDtoFrequencyTypeEnum = {
    TimesPerDay: 'TIMES_PER_DAY',
    EveryNHours: 'EVERY_N_HOURS',
    EveryNDays: 'EVERY_N_DAYS',
    TimesPerWeek: 'TIMES_PER_WEEK',
    TimesPerMonth: 'TIMES_PER_MONTH',
    AsNeeded: 'AS_NEEDED',
    Other: 'OTHER'
} as const;

export type AddFacilityMedicationDtoFrequencyTypeEnum = typeof AddFacilityMedicationDtoFrequencyTypeEnum[keyof typeof AddFacilityMedicationDtoFrequencyTypeEnum];
export const AddFacilityMedicationDtoDurationTypeEnum = {
    UntilFurtherNotice: 'UNTIL_FURTHER_NOTICE',
    Days: 'DAYS',
    Weeks: 'WEEKS',
    UntilFollowUp: 'UNTIL_FOLLOW_UP',
    SingleDose: 'SINGLE_DOSE',
    Other: 'OTHER'
} as const;

export type AddFacilityMedicationDtoDurationTypeEnum = typeof AddFacilityMedicationDtoDurationTypeEnum[keyof typeof AddFacilityMedicationDtoDurationTypeEnum];
export const AddFacilityMedicationDtoDosageIntervalEnum = {
    Day: 'Day',
    Week: 'Week',
    Month: 'Month'
} as const;

export type AddFacilityMedicationDtoDosageIntervalEnum = typeof AddFacilityMedicationDtoDosageIntervalEnum[keyof typeof AddFacilityMedicationDtoDosageIntervalEnum];
export const AddFacilityMedicationDtoReminderRecurrenceTypeEnum = {
    Single: 'SINGLE',
    Daily: 'DAILY',
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
    Custom: 'CUSTOM'
} as const;

export type AddFacilityMedicationDtoReminderRecurrenceTypeEnum = typeof AddFacilityMedicationDtoReminderRecurrenceTypeEnum[keyof typeof AddFacilityMedicationDtoReminderRecurrenceTypeEnum];
export const AddFacilityMedicationDtoReminderNotificationChannelsEnum = {
    Email: 'EMAIL',
    Sms: 'SMS'
} as const;

export type AddFacilityMedicationDtoReminderNotificationChannelsEnum = typeof AddFacilityMedicationDtoReminderNotificationChannelsEnum[keyof typeof AddFacilityMedicationDtoReminderNotificationChannelsEnum];

/**
 * Take the drug from the Warehouse (the clinic’s MANUAL issue); omitted or null takes nothing
 * @export
 * @interface AddFacilityMedicationDtoStock
 */
export interface AddFacilityMedicationDtoStock {
    /**
     * Warehouse Product (DRUG) id
     * @type {string}
     * @memberof AddFacilityMedicationDtoStock
     */
    'productId': string;
    /**
     * Quantity in the given measure, at most 3 decimals
     * @type {number}
     * @memberof AddFacilityMedicationDtoStock
     */
    'quantity': number;
    /**
     *
     * @type {WarehouseQuantityMeasure}
     * @memberof AddFacilityMedicationDtoStock
     */
    'measure': WarehouseQuantityMeasure;
    /**
     *
     * @type {WarehouseHandover}
     * @memberof AddFacilityMedicationDtoStock
     */
    'handover': WarehouseHandover;
    /**
     * Pinned Batch; omitted means FEFO
     * @type {string}
     * @memberof AddFacilityMedicationDtoStock
     */
    'batchId'?: string | null;
    /**
     * Handed-over Rx only: whether a prescription was issued (filled at the Facility)
     * @type {boolean}
     * @memberof AddFacilityMedicationDtoStock
     */
    'prescriptionIssued'?: boolean;
    /**
     * Handed-over only: who received the drug. Omitted or blank records the registered owner or the guest contact; with neither the write is 422 RECIPIENT_REQUIRED
     * @type {string}
     * @memberof AddFacilityMedicationDtoStock
     */
    'recipientName'?: string;
    /**
     * Handed-over only: the recipient\'s address. Omitted or blank records the registered owner\'s profile address when the owner received the drug; a handed-over Rx drug with no address is 422 RECIPIENT_ADDRESS_REQUIRED
     * @type {string}
     * @memberof AddFacilityMedicationDtoStock
     */
    'recipientAddress'?: string;
}


/**
 *
 * @export
 * @interface AddInternalNotesDto
 */
export interface AddInternalNotesDto {
    /**
     *
     * @type {string}
     * @memberof AddInternalNotesDto
     */
    'internalNotes': string;
}
/**
 *
 * @export
 * @interface AddNotesDto
 */
export interface AddNotesDto {
    /**
     *
     * @type {string}
     * @memberof AddNotesDto
     */
    'notes': string;
    /**
     *
     * @type {string}
     * @memberof AddNotesDto
     */
    'internalNotes'?: string;
}
/**
 *
 * @export
 * @interface AddOrganizationDto
 */
export interface AddOrganizationDto {
    /**
     *
     * @type {Array<InitializeOrganizationServiceBookingPolicyDto>}
     * @memberof AddOrganizationDto
     */
    'bookingPolicies'?: Array<InitializeOrganizationServiceBookingPolicyDto>;
    /**
     *
     * @type {Array<string>}
     * @memberof AddOrganizationDto
     */
    'enabledServices'?: Array<string>;
    /**
     *
     * @type {string}
     * @memberof AddOrganizationDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof AddOrganizationDto
     */
    'street': string;
    /**
     *
     * @type {string}
     * @memberof AddOrganizationDto
     */
    'zip': string;
    /**
     *
     * @type {string}
     * @memberof AddOrganizationDto
     */
    'city': string;
    /**
     *
     * @type {string}
     * @memberof AddOrganizationDto
     */
    'website'?: string;
    /**
     *
     * @type {string}
     * @memberof AddOrganizationDto
     */
    'phoneNumber': string;
    /**
     *
     * @type {string}
     * @memberof AddOrganizationDto
     */
    'email'?: string;
    /**
     *
     * @type {string}
     * @memberof AddOrganizationDto
     */
    'nip'?: string;
    /**
     *
     * @type {string}
     * @memberof AddOrganizationDto
     */
    'rating'?: string;
    /**
     *
     * @type {string}
     * @memberof AddOrganizationDto
     */
    'logoUrl': string;
    /**
     *
     * @type {Array<string>}
     * @memberof AddOrganizationDto
     */
    'images'?: Array<string>;
    /**
     *
     * @type {boolean}
     * @memberof AddOrganizationDto
     */
    'isActive'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AddOrganizationDto
     */
    'isPublished'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AddOrganizationDto
     */
    'isVerified'?: boolean;
    /**
     *
     * @type {string}
     * @memberof AddOrganizationDto
     */
    'type': AddOrganizationDtoTypeEnum;
    /**
     *
     * @type {Array<AvailabilitySlotDto>}
     * @memberof AddOrganizationDto
     */
    'workingHours'?: Array<AvailabilitySlotDto>;
    /**
     *
     * @type {Array<TimeOffDto>}
     * @memberof AddOrganizationDto
     */
    'timeOff'?: Array<TimeOffDto>;
    /**
     *
     * @type {string}
     * @memberof AddOrganizationDto
     */
    'description'?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof AddOrganizationDto
     */
    'specializations'?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof AddOrganizationDto
     */
    'socialMedia'?: Array<string>;
}

export const AddOrganizationDtoTypeEnum = {
    VeterinaryFacility: 'VETERINARY_FACILITY'
} as const;

export type AddOrganizationDtoTypeEnum = typeof AddOrganizationDtoTypeEnum[keyof typeof AddOrganizationDtoTypeEnum];

/**
 *
 * @export
 * @interface AddOrganizationTimeOffDto
 */
export interface AddOrganizationTimeOffDto {
    /**
     *
     * @type {AddOrganizationTimeOffDtoTimeOff}
     * @memberof AddOrganizationTimeOffDto
     */
    'timeOff': AddOrganizationTimeOffDtoTimeOff;
}
/**
 * Time off period to add for the professional in this organization
 * @export
 * @interface AddOrganizationTimeOffDtoTimeOff
 */
export interface AddOrganizationTimeOffDtoTimeOff {
    /**
     * ISO date string for the start date of time off
     * @type {string}
     * @memberof AddOrganizationTimeOffDtoTimeOff
     */
    'startDate': string;
    /**
     * ISO date string for the end date of time off
     * @type {string}
     * @memberof AddOrganizationTimeOffDtoTimeOff
     */
    'endDate': string;
    /**
     * Optional start time in HH:MM format for time-specific unavailability
     * @type {string}
     * @memberof AddOrganizationTimeOffDtoTimeOff
     */
    'startTime'?: string;
    /**
     * Optional end time in HH:MM format for time-specific unavailability
     * @type {string}
     * @memberof AddOrganizationTimeOffDtoTimeOff
     */
    'endTime'?: string;
}
/**
 *
 * @export
 * @interface AddPatientNotesDto
 */
export interface AddPatientNotesDto {
    /**
     *
     * @type {string}
     * @memberof AddPatientNotesDto
     */
    'notes': string;
}
/**
 *
 * @export
 * @interface AddProfileMedicationDto
 */
export interface AddProfileMedicationDto {
    /**
     * Strength value
     * @type {number}
     * @memberof AddProfileMedicationDto
     */
    'strengthValue'?: number;
    /**
     *
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'strengthUnit'?: AddProfileMedicationDtoStrengthUnitEnum;
    /**
     * Required when strengthUnit is OTHER
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'strengthUnitCustom'?: string;
    /**
     *
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'form'?: AddProfileMedicationDtoFormEnum;
    /**
     * Required when form is OTHER
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'formCustom'?: string;
    /**
     * Amount given per administration, e.g. half a tablet
     * @type {number}
     * @memberof AddProfileMedicationDto
     */
    'quantityValue'?: number;
    /**
     *
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'quantityCustom'?: string;
    /**
     * Recorded before the dose is known, e.g. pending a weigh-in
     * @type {boolean}
     * @memberof AddProfileMedicationDto
     */
    'dosagePending'?: boolean;
    /**
     *
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'frequencyType'?: AddProfileMedicationDtoFrequencyTypeEnum;
    /**
     *
     * @type {number}
     * @memberof AddProfileMedicationDto
     */
    'frequencyValue'?: number;
    /**
     * Required when frequencyType is OTHER
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'frequencyCustom'?: string;
    /**
     *
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'durationType'?: AddProfileMedicationDtoDurationTypeEnum;
    /**
     *
     * @type {number}
     * @memberof AddProfileMedicationDto
     */
    'durationValue'?: number;
    /**
     * Required when durationType is OTHER
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'durationCustom'?: string;
    /**
     * Dosing that changes over the course, e.g. a steroid taper
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'dosageSchedule'?: string;
    /**
     * What the medication is for
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'indication'?: string;
    /**
     *
     * @type {boolean}
     * @memberof AddProfileMedicationDto
     */
    'adverseReaction'?: boolean;
    /**
     *
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'adverseReactionNote'?: string;
    /**
     * When the patient started taking it
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'startedAt'?: string;
    /**
     * Medicine product ID from the medicine database
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'medicineProductId'?: string;
    /**
     * Name of the medication (required if medicineProductId not provided)
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'name'?: string;
    /**
     * Preparation type
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'preparationType'?: string;
    /**
     * Dosage amount (deprecated — use quantityValue)
     * @type {number}
     * @memberof AddProfileMedicationDto
     */
    'dosage'?: number;
    /**
     * Dosage interval (deprecated — use frequencyType)
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'dosageInterval'?: AddProfileMedicationDtoDosageIntervalEnum;
    /**
     * Additional notes about the medication
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'notes'?: string;
    /**
     *
     * @type {boolean}
     * @memberof AddProfileMedicationDto
     */
    'reminderEnabled'?: boolean;
    /**
     *
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'reminderDescription'?: string;
    /**
     *
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'reminderScheduledAt'?: string;
    /**
     *
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'reminderRecurrenceType'?: AddProfileMedicationDtoReminderRecurrenceTypeEnum;
    /**
     *
     * @type {CustomRecurrenceDto}
     * @memberof AddProfileMedicationDto
     */
    'reminderCustomRecurrence'?: CustomRecurrenceDto;
    /**
     *
     * @type {Array<string>}
     * @memberof AddProfileMedicationDto
     */
    'reminderNotificationChannels'?: Array<AddProfileMedicationDtoReminderNotificationChannelsEnum>;
    /**
     *
     * @type {string}
     * @memberof AddProfileMedicationDto
     */
    'visitId'?: string;
}

export const AddProfileMedicationDtoStrengthUnitEnum = {
    Mg: 'MG',
    G: 'G',
    Mcg: 'MCG',
    Ml: 'ML',
    Iu: 'IU',
    Percent: 'PERCENT',
    None: 'NONE',
    Other: 'OTHER'
} as const;

export type AddProfileMedicationDtoStrengthUnitEnum = typeof AddProfileMedicationDtoStrengthUnitEnum[keyof typeof AddProfileMedicationDtoStrengthUnitEnum];
export const AddProfileMedicationDtoFormEnum = {
    Tablet: 'TABLET',
    Capsule: 'CAPSULE',
    Sachet: 'SACHET',
    Suspension: 'SUSPENSION',
    Solution: 'SOLUTION',
    Drops: 'DROPS',
    Injection: 'INJECTION',
    Ointment: 'OINTMENT',
    SpotOn: 'SPOT_ON',
    Spray: 'SPRAY',
    Powder: 'POWDER',
    Paste: 'PASTE',
    Other: 'OTHER'
} as const;

export type AddProfileMedicationDtoFormEnum = typeof AddProfileMedicationDtoFormEnum[keyof typeof AddProfileMedicationDtoFormEnum];
export const AddProfileMedicationDtoFrequencyTypeEnum = {
    TimesPerDay: 'TIMES_PER_DAY',
    EveryNHours: 'EVERY_N_HOURS',
    EveryNDays: 'EVERY_N_DAYS',
    TimesPerWeek: 'TIMES_PER_WEEK',
    TimesPerMonth: 'TIMES_PER_MONTH',
    AsNeeded: 'AS_NEEDED',
    Other: 'OTHER'
} as const;

export type AddProfileMedicationDtoFrequencyTypeEnum = typeof AddProfileMedicationDtoFrequencyTypeEnum[keyof typeof AddProfileMedicationDtoFrequencyTypeEnum];
export const AddProfileMedicationDtoDurationTypeEnum = {
    UntilFurtherNotice: 'UNTIL_FURTHER_NOTICE',
    Days: 'DAYS',
    Weeks: 'WEEKS',
    UntilFollowUp: 'UNTIL_FOLLOW_UP',
    SingleDose: 'SINGLE_DOSE',
    Other: 'OTHER'
} as const;

export type AddProfileMedicationDtoDurationTypeEnum = typeof AddProfileMedicationDtoDurationTypeEnum[keyof typeof AddProfileMedicationDtoDurationTypeEnum];
export const AddProfileMedicationDtoDosageIntervalEnum = {
    Day: 'Day',
    Week: 'Week',
    Month: 'Month'
} as const;

export type AddProfileMedicationDtoDosageIntervalEnum = typeof AddProfileMedicationDtoDosageIntervalEnum[keyof typeof AddProfileMedicationDtoDosageIntervalEnum];
export const AddProfileMedicationDtoReminderRecurrenceTypeEnum = {
    Single: 'SINGLE',
    Daily: 'DAILY',
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
    Custom: 'CUSTOM'
} as const;

export type AddProfileMedicationDtoReminderRecurrenceTypeEnum = typeof AddProfileMedicationDtoReminderRecurrenceTypeEnum[keyof typeof AddProfileMedicationDtoReminderRecurrenceTypeEnum];
export const AddProfileMedicationDtoReminderNotificationChannelsEnum = {
    Email: 'EMAIL',
    Sms: 'SMS'
} as const;

export type AddProfileMedicationDtoReminderNotificationChannelsEnum = typeof AddProfileMedicationDtoReminderNotificationChannelsEnum[keyof typeof AddProfileMedicationDtoReminderNotificationChannelsEnum];

/**
 *
 * @export
 * @interface AddProfileTreatmentDto
 */
export interface AddProfileTreatmentDto {
    /**
     * Treatment name
     * @type {string}
     * @memberof AddProfileTreatmentDto
     */
    'name': string;
    /**
     * Treatment description
     * @type {string}
     * @memberof AddProfileTreatmentDto
     */
    'description'?: string;
    /**
     * Date and time of the treatment
     * @type {string}
     * @memberof AddProfileTreatmentDto
     */
    'treatmentDate': string;
    /**
     * Catalog treatment ID (if selected from catalog)
     * @type {string}
     * @memberof AddProfileTreatmentDto
     */
    'treatmentId'?: string;
    /**
     * Net price
     * @type {number}
     * @memberof AddProfileTreatmentDto
     */
    'priceNetto'?: number;
    /**
     * Gross price
     * @type {number}
     * @memberof AddProfileTreatmentDto
     */
    'priceBrutto'?: number;
    /**
     * VAT rate percentage
     * @type {number}
     * @memberof AddProfileTreatmentDto
     */
    'vatRate'?: number;
    /**
     * Medicines associated with this treatment
     * @type {Array<AssociatedMedicineDto>}
     * @memberof AddProfileTreatmentDto
     */
    'associatedMedicines'?: Array<AssociatedMedicineDto>;
    /**
     * Non-drug materials used (clinic context only; omitted leaves them as they are)
     * @type {Array<TreatmentMaterialInputDto>}
     * @memberof AddProfileTreatmentDto
     */
    'materials'?: Array<TreatmentMaterialInputDto>;
    /**
     * Organization ID
     * @type {string}
     * @memberof AddProfileTreatmentDto
     */
    'organizationId'?: string;
    /**
     * Visit ID
     * @type {string}
     * @memberof AddProfileTreatmentDto
     */
    'visitId'?: string;
    /**
     * Whether to create a reminder
     * @type {boolean}
     * @memberof AddProfileTreatmentDto
     */
    'reminderEnabled'?: boolean;
    /**
     * Reminder description
     * @type {string}
     * @memberof AddProfileTreatmentDto
     */
    'reminderDescription'?: string;
    /**
     * Reminder scheduled date
     * @type {string}
     * @memberof AddProfileTreatmentDto
     */
    'reminderScheduledAt'?: string;
    /**
     * Reminder recurrence type
     * @type {string}
     * @memberof AddProfileTreatmentDto
     */
    'reminderRecurrenceType'?: AddProfileTreatmentDtoReminderRecurrenceTypeEnum;
    /**
     *
     * @type {UpdateReminderDtoCustomRecurrence}
     * @memberof AddProfileTreatmentDto
     */
    'reminderCustomRecurrence'?: UpdateReminderDtoCustomRecurrence;
    /**
     * Reminder notification channels
     * @type {Array<string>}
     * @memberof AddProfileTreatmentDto
     */
    'reminderNotificationChannels'?: Array<AddProfileTreatmentDtoReminderNotificationChannelsEnum>;
    /**
     * Client UUID v4, one per submit series; required on a create when a clinic sends stock fields, claimed whenever a clinic sends it (R3-4)
     * @type {string}
     * @memberof AddProfileTreatmentDto
     */
    'operationKey'?: string;
}

export const AddProfileTreatmentDtoReminderRecurrenceTypeEnum = {
    Single: 'SINGLE',
    Daily: 'DAILY',
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
    Custom: 'CUSTOM'
} as const;

export type AddProfileTreatmentDtoReminderRecurrenceTypeEnum = typeof AddProfileTreatmentDtoReminderRecurrenceTypeEnum[keyof typeof AddProfileTreatmentDtoReminderRecurrenceTypeEnum];
export const AddProfileTreatmentDtoReminderNotificationChannelsEnum = {
    Email: 'EMAIL',
    Sms: 'SMS'
} as const;

export type AddProfileTreatmentDtoReminderNotificationChannelsEnum = typeof AddProfileTreatmentDtoReminderNotificationChannelsEnum[keyof typeof AddProfileTreatmentDtoReminderNotificationChannelsEnum];

/**
 *
 * @export
 * @interface AddSpecializationDto
 */
export interface AddSpecializationDto {
    /**
     * Specialization ID
     * @type {string}
     * @memberof AddSpecializationDto
     */
    'specializationId': string;
    /**
     * Custom duration in minutes for this specialization
     * @type {number}
     * @memberof AddSpecializationDto
     */
    'customDuration'?: number;
    /**
     * Additional notes about this specialization
     * @type {string}
     * @memberof AddSpecializationDto
     */
    'notes'?: string;
}
/**
 *
 * @export
 * @interface AdvanceVoiceLineProviderPrivacyRecoveryDto
 */
export interface AdvanceVoiceLineProviderPrivacyRecoveryDto {
    /**
     *
     * @type {string}
     * @memberof AdvanceVoiceLineProviderPrivacyRecoveryDto
     */
    'recoveryId': string;
    /**
     *
     * @type {number}
     * @memberof AdvanceVoiceLineProviderPrivacyRecoveryDto
     */
    'expectedRecoveryRevision': number;
    /**
     *
     * @type {VoiceLineProviderPrivacyRecoveryCheckpoint}
     * @memberof AdvanceVoiceLineProviderPrivacyRecoveryDto
     */
    'checkpoint': VoiceLineProviderPrivacyRecoveryCheckpoint;
}


/**
 *
 * @export
 * @interface AffectedProfessionalServicesDto
 */
export interface AffectedProfessionalServicesDto {
    /**
     * Professional ID
     * @type {string}
     * @memberof AffectedProfessionalServicesDto
     */
    'professionalId': string;
    /**
     * Professional name
     * @type {string}
     * @memberof AffectedProfessionalServicesDto
     */
    'professionalName': string;
    /**
     * List of affected services for this professional
     * @type {Array<AffectedServiceInfoDto>}
     * @memberof AffectedProfessionalServicesDto
     */
    'affectedServices': Array<AffectedServiceInfoDto>;
}
/**
 *
 * @export
 * @interface AffectedServiceDto
 */
export interface AffectedServiceDto {
    /**
     * Service ID
     * @type {string}
     * @memberof AffectedServiceDto
     */
    'serviceId': string;
    /**
     * Service name
     * @type {string}
     * @memberof AffectedServiceDto
     */
    'serviceName': string;
    /**
     * Specialization name
     * @type {string}
     * @memberof AffectedServiceDto
     */
    'specializationName': string;
}
/**
 *
 * @export
 * @interface AffectedServiceInfoDto
 */
export interface AffectedServiceInfoDto {
    /**
     * Service name
     * @type {string}
     * @memberof AffectedServiceInfoDto
     */
    'serviceName': string;
    /**
     * Specialization name
     * @type {string}
     * @memberof AffectedServiceInfoDto
     */
    'specializationName': string;
}
/**
 *
 * @export
 * @interface ApplyReceptionIncidentBlockDto
 */
export interface ApplyReceptionIncidentBlockDto {
    /**
     *
     * @type {string}
     * @memberof ApplyReceptionIncidentBlockDto
     */
    'reason': ApplyReceptionIncidentBlockDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof ApplyReceptionIncidentBlockDto
     */
    'note'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ApplyReceptionIncidentBlockDto
     */
    'organizationId'?: string | null;
    /**
     *
     * @type {number}
     * @memberof ApplyReceptionIncidentBlockDto
     */
    'expectedRevision': number;
    /**
     *
     * @type {boolean}
     * @memberof ApplyReceptionIncidentBlockDto
     */
    'admissionBlocked': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ApplyReceptionIncidentBlockDto
     */
    'bookingDisabled': boolean;
}

export const ApplyReceptionIncidentBlockDtoReasonEnum = {
    FirstActivation: 'FIRST_ACTIVATION',
    ProviderIncident: 'PROVIDER_INCIDENT',
    ProviderDrift: 'PROVIDER_DRIFT',
    PrivacyIncident: 'PRIVACY_INCIDENT',
    SafetyEvidenceInvalidated: 'SAFETY_EVIDENCE_INVALIDATED',
    EmergencyRouteCompromised: 'EMERGENCY_ROUTE_COMPROMISED',
    SpendProtection: 'SPEND_PROTECTION',
    AutomatedSecurityTrigger: 'AUTOMATED_SECURITY_TRIGGER',
    IncidentResolved: 'INCIDENT_RESOLVED'
} as const;

export type ApplyReceptionIncidentBlockDtoReasonEnum = typeof ApplyReceptionIncidentBlockDtoReasonEnum[keyof typeof ApplyReceptionIncidentBlockDtoReasonEnum];

/**
 *
 * @export
 * @interface ApplyReceptionSafetyOverrideDto
 */
export interface ApplyReceptionSafetyOverrideDto {
    /**
     *
     * @type {string}
     * @memberof ApplyReceptionSafetyOverrideDto
     */
    'reason': ApplyReceptionSafetyOverrideDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof ApplyReceptionSafetyOverrideDto
     */
    'note'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ApplyReceptionSafetyOverrideDto
     */
    'organizationId'?: string | null;
    /**
     *
     * @type {number}
     * @memberof ApplyReceptionSafetyOverrideDto
     */
    'expectedRevision': number;
    /**
     *
     * @type {boolean}
     * @memberof ApplyReceptionSafetyOverrideDto
     */
    'admissionBlocked': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ApplyReceptionSafetyOverrideDto
     */
    'bookingDisabled': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ApplyReceptionSafetyOverrideDto
     */
    'routingRevoked': boolean;
}

export const ApplyReceptionSafetyOverrideDtoReasonEnum = {
    FirstActivation: 'FIRST_ACTIVATION',
    ProviderIncident: 'PROVIDER_INCIDENT',
    ProviderDrift: 'PROVIDER_DRIFT',
    PrivacyIncident: 'PRIVACY_INCIDENT',
    SafetyEvidenceInvalidated: 'SAFETY_EVIDENCE_INVALIDATED',
    EmergencyRouteCompromised: 'EMERGENCY_ROUTE_COMPROMISED',
    SpendProtection: 'SPEND_PROTECTION',
    AutomatedSecurityTrigger: 'AUTOMATED_SECURITY_TRIGGER',
    IncidentResolved: 'INCIDENT_RESOLVED'
} as const;

export type ApplyReceptionSafetyOverrideDtoReasonEnum = typeof ApplyReceptionSafetyOverrideDtoReasonEnum[keyof typeof ApplyReceptionSafetyOverrideDtoReasonEnum];

/**
 *
 * @export
 * @interface ApproveEmergencyGuidanceDraftDto
 */
export interface ApproveEmergencyGuidanceDraftDto {
    /**
     *
     * @type {string}
     * @memberof ApproveEmergencyGuidanceDraftDto
     */
    'note'?: string | null;
    /**
     *
     * @type {number}
     * @memberof ApproveEmergencyGuidanceDraftDto
     */
    'expectedPublishedRevision': number;
    /**
     *
     * @type {string}
     * @memberof ApproveEmergencyGuidanceDraftDto
     */
    'approvedUntil': string;
    /**
     *
     * @type {string}
     * @memberof ApproveEmergencyGuidanceDraftDto
     */
    'reason': ApproveEmergencyGuidanceDraftDtoReasonEnum;
}

export const ApproveEmergencyGuidanceDraftDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    GuidanceUpdate: 'GUIDANCE_UPDATE',
    DestinationUpdate: 'DESTINATION_UPDATE',
    PeriodicReapproval: 'PERIODIC_REAPPROVAL',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type ApproveEmergencyGuidanceDraftDtoReasonEnum = typeof ApproveEmergencyGuidanceDraftDtoReasonEnum[keyof typeof ApproveEmergencyGuidanceDraftDtoReasonEnum];

/**
 *
 * @export
 * @interface ApproveReceptionActivationDto
 */
export interface ApproveReceptionActivationDto {
    /**
     *
     * @type {string}
     * @memberof ApproveReceptionActivationDto
     */
    'reason': ApproveReceptionActivationDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof ApproveReceptionActivationDto
     */
    'note'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ApproveReceptionActivationDto
     */
    'releaseId': string;
}

export const ApproveReceptionActivationDtoReasonEnum = {
    FirstActivation: 'FIRST_ACTIVATION',
    ProviderIncident: 'PROVIDER_INCIDENT',
    ProviderDrift: 'PROVIDER_DRIFT',
    PrivacyIncident: 'PRIVACY_INCIDENT',
    SafetyEvidenceInvalidated: 'SAFETY_EVIDENCE_INVALIDATED',
    EmergencyRouteCompromised: 'EMERGENCY_ROUTE_COMPROMISED',
    SpendProtection: 'SPEND_PROTECTION',
    AutomatedSecurityTrigger: 'AUTOMATED_SECURITY_TRIGGER',
    IncidentResolved: 'INCIDENT_RESOLVED'
} as const;

export type ApproveReceptionActivationDtoReasonEnum = typeof ApproveReceptionActivationDtoReasonEnum[keyof typeof ApproveReceptionActivationDtoReasonEnum];

/**
 *
 * @export
 * @interface ApproveReceptionReopenDto
 */
export interface ApproveReceptionReopenDto {
    /**
     *
     * @type {string}
     * @memberof ApproveReceptionReopenDto
     */
    'reason': ApproveReceptionReopenDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof ApproveReceptionReopenDto
     */
    'note'?: string | null;
}

export const ApproveReceptionReopenDtoReasonEnum = {
    FirstActivation: 'FIRST_ACTIVATION',
    ProviderIncident: 'PROVIDER_INCIDENT',
    ProviderDrift: 'PROVIDER_DRIFT',
    PrivacyIncident: 'PRIVACY_INCIDENT',
    SafetyEvidenceInvalidated: 'SAFETY_EVIDENCE_INVALIDATED',
    EmergencyRouteCompromised: 'EMERGENCY_ROUTE_COMPROMISED',
    SpendProtection: 'SPEND_PROTECTION',
    AutomatedSecurityTrigger: 'AUTOMATED_SECURITY_TRIGGER',
    IncidentResolved: 'INCIDENT_RESOLVED'
} as const;

export type ApproveReceptionReopenDtoReasonEnum = typeof ApproveReceptionReopenDtoReasonEnum[keyof typeof ApproveReceptionReopenDtoReasonEnum];

/**
 *
 * @export
 * @interface ApproveReceptionTerminationDto
 */
export interface ApproveReceptionTerminationDto {
    /**
     *
     * @type {string}
     * @memberof ApproveReceptionTerminationDto
     */
    'reason': ApproveReceptionTerminationDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof ApproveReceptionTerminationDto
     */
    'note'?: string | null;
    /**
     *
     * @type {boolean}
     * @memberof ApproveReceptionTerminationDto
     */
    'emergencyRouteCompromised': boolean;
}

export const ApproveReceptionTerminationDtoReasonEnum = {
    FirstActivation: 'FIRST_ACTIVATION',
    ProviderIncident: 'PROVIDER_INCIDENT',
    ProviderDrift: 'PROVIDER_DRIFT',
    PrivacyIncident: 'PRIVACY_INCIDENT',
    SafetyEvidenceInvalidated: 'SAFETY_EVIDENCE_INVALIDATED',
    EmergencyRouteCompromised: 'EMERGENCY_ROUTE_COMPROMISED',
    SpendProtection: 'SPEND_PROTECTION',
    AutomatedSecurityTrigger: 'AUTOMATED_SECURITY_TRIGGER',
    IncidentResolved: 'INCIDENT_RESOLVED'
} as const;

export type ApproveReceptionTerminationDtoReasonEnum = typeof ApproveReceptionTerminationDtoReasonEnum[keyof typeof ApproveReceptionTerminationDtoReasonEnum];

/**
 *
 * @export
 * @interface ApproveVoiceFallbackContentDto
 */
export interface ApproveVoiceFallbackContentDto {
    /**
     *
     * @type {string}
     * @memberof ApproveVoiceFallbackContentDto
     */
    'reason': string;
}
/**
 *
 * @export
 * @interface ApproveVoiceSmsPrivacyQualificationDto
 */
export interface ApproveVoiceSmsPrivacyQualificationDto {
    /**
     *
     * @type {string}
     * @memberof ApproveVoiceSmsPrivacyQualificationDto
     */
    'id': string;
    /**
     *
     * @type {number}
     * @memberof ApproveVoiceSmsPrivacyQualificationDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof ApproveVoiceSmsPrivacyQualificationDto
     */
    'scopeSha256': string;
    /**
     *
     * @type {string}
     * @memberof ApproveVoiceSmsPrivacyQualificationDto
     */
    'acknowledgement': ApproveVoiceSmsPrivacyQualificationDtoAcknowledgementEnum;
}

export const ApproveVoiceSmsPrivacyQualificationDtoAcknowledgementEnum = {
    ApproveExactBoundedSmsPrivacyScopeV1: 'APPROVE_EXACT_BOUNDED_SMS_PRIVACY_SCOPE_V1'
} as const;

export type ApproveVoiceSmsPrivacyQualificationDtoAcknowledgementEnum = typeof ApproveVoiceSmsPrivacyQualificationDtoAcknowledgementEnum[keyof typeof ApproveVoiceSmsPrivacyQualificationDtoAcknowledgementEnum];

/**
 *
 * @export
 * @interface ApproveVoiceSpendReopenDto
 */
export interface ApproveVoiceSpendReopenDto {
    /**
     * Kontrolowany powód operacji na sterowaniu przyjęciem Voice
     * @type {string}
     * @memberof ApproveVoiceSpendReopenDto
     */
    'reason': string;
    /**
     * Opcjonalna notatka operacyjna bez danych osobowych
     * @type {string}
     * @memberof ApproveVoiceSpendReopenDto
     */
    'note'?: string;
    /**
     * Identyfikator propozycji wcześniejszego otwarcia
     * @type {string}
     * @memberof ApproveVoiceSpendReopenDto
     */
    'proposalId': string;
}
/**
 *
 * @export
 * @interface ApproveWarehouseReceiptDto
 */
export interface ApproveWarehouseReceiptDto {
    /**
     * Client-generated UUID v4, kept across retries of the same submit. A replay with the same data returns the stored result; different data under the same key is 409 OPERATION_KEY_REUSED.
     * @type {string}
     * @memberof ApproveWarehouseReceiptDto
     */
    'operationKey': string;
}
/**
 *
 * @export
 * @interface AssessRecordedVoicePilotEvidenceDto
 */
export interface AssessRecordedVoicePilotEvidenceDto {
    /**
     *
     * @type {string}
     * @memberof AssessRecordedVoicePilotEvidenceDto
     */
    'evidenceDigest': string;
}
/**
 *
 * @export
 * @interface AssignVoiceLineDto
 */
export interface AssignVoiceLineDto {
    /**
     * Kontrolowany powód operacji na Voice Line
     * @type {string}
     * @memberof AssignVoiceLineDto
     */
    'reason': AssignVoiceLineDtoReasonEnum;
    /**
     * Opcjonalna notatka operacyjna bez danych osobowych (maks. 200 znaków)
     * @type {string}
     * @memberof AssignVoiceLineDto
     */
    'note'?: string;
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof AssignVoiceLineDto
     */
    'organizationId': string;
}

export const AssignVoiceLineDtoReasonEnum = {
    PilotProvisioning: 'PILOT_PROVISIONING',
    OrganizationReassignment: 'ORGANIZATION_REASSIGNMENT',
    OrganizationDeprovisioning: 'ORGANIZATION_DEPROVISIONING',
    ProviderReconciliation: 'PROVIDER_RECONCILIATION',
    ProviderDriftRemediation: 'PROVIDER_DRIFT_REMEDIATION'
} as const;

export type AssignVoiceLineDtoReasonEnum = typeof AssignVoiceLineDtoReasonEnum[keyof typeof AssignVoiceLineDtoReasonEnum];

/**
 *
 * @export
 * @interface AssignWarehouseBatchDto
 */
export interface AssignWarehouseBatchDto {
    /**
     * The real Batch of the same product
     * @type {string}
     * @memberof AssignWarehouseBatchDto
     */
    'batchId': string;
    /**
     * Part of the issue to assign, at most 3 decimals; the whole issue when absent
     * @type {number}
     * @memberof AssignWarehouseBatchDto
     */
    'quantity'?: number;
    /**
     *
     * @type {WarehouseQuantityMeasure}
     * @memberof AssignWarehouseBatchDto
     */
    'measure'?: WarehouseQuantityMeasure;
    /**
     * Client-generated UUID v4, kept across retries of the same submit. A replay with the same data returns the stored result; different data under the same key is 409 OPERATION_KEY_REUSED.
     * @type {string}
     * @memberof AssignWarehouseBatchDto
     */
    'operationKey': string;
}


/**
 *
 * @export
 * @interface AssistantActionDto
 */
export interface AssistantActionDto {
    /**
     * Action the frontend should perform.
     * @type {string}
     * @memberof AssistantActionDto
     */
    'type': AssistantActionDtoTypeEnum;
    /**
     *
     * @type {AssistantActionPayloadDto}
     * @memberof AssistantActionDto
     */
    'payload': AssistantActionPayloadDto;
}

export const AssistantActionDtoTypeEnum = {
    PatientNotes: 'fill_patient_notes',
    InternalNotes: 'fill_internal_notes',
    TextNote: 'fill_text_note'
} as const;

export type AssistantActionDtoTypeEnum = typeof AssistantActionDtoTypeEnum[keyof typeof AssistantActionDtoTypeEnum];

/**
 *
 * @export
 * @interface AssistantActionPayloadDto
 */
export interface AssistantActionPayloadDto {
    /**
     * Proposed notes content (Polish).
     * @type {string}
     * @memberof AssistantActionPayloadDto
     */
    'notes': string;
}
/**
 *
 * @export
 * @interface AssociatedMedicineDto
 */
export interface AssociatedMedicineDto {
    /**
     * Existing line id when editing; omit for a new line. Keeps the line’s stock issue.
     * @type {string}
     * @memberof AssociatedMedicineDto
     */
    'id'?: string;
    /**
     * Medicine product ID from medicine database. Absent for a medicine typed by hand, which the registry does not carry.
     * @type {string}
     * @memberof AssociatedMedicineDto
     */
    'medicineProductId'?: string;
    /**
     * Medicine product name
     * @type {string}
     * @memberof AssociatedMedicineDto
     */
    'medicineName': string;
    /**
     *
     * @type {number}
     * @memberof AssociatedMedicineDto
     */
    'dosage'?: number;
    /**
     *
     * @type {string}
     * @memberof AssociatedMedicineDto
     */
    'dosageInterval'?: AssociatedMedicineDtoDosageIntervalEnum;
    /**
     *
     * @type {string}
     * @memberof AssociatedMedicineDto
     */
    'notes'?: string;
    /**
     *
     * @type {string}
     * @memberof AssociatedMedicineDto
     */
    'preparationType'?: string;
    /**
     * Warehouse Product (DRUG) the drug is taken from
     * @type {string}
     * @memberof AssociatedMedicineDto
     */
    'productId'?: string | null;
    /**
     * Required with productId
     * @type {number}
     * @memberof AssociatedMedicineDto
     */
    'quantity'?: number;
    /**
     *
     * @type {WarehouseQuantityMeasure}
     * @memberof AssociatedMedicineDto
     */
    'measure'?: WarehouseQuantityMeasure;
    /**
     *
     * @type {WarehouseHandover}
     * @memberof AssociatedMedicineDto
     */
    'handover'?: WarehouseHandover;
    /**
     * Handed-over Rx only: whether a prescription was issued
     * @type {boolean}
     * @memberof AssociatedMedicineDto
     */
    'prescriptionIssued'?: boolean;
    /**
     * Handed-over only: who received the drug; omitted or blank records the owner or guest contact (else 422 RECIPIENT_REQUIRED)
     * @type {string}
     * @memberof AssociatedMedicineDto
     */
    'recipientName'?: string;
    /**
     * Handed-over only: the recipient\'s address; omitted or blank records the registered owner\'s profile address when the owner received the drug (a handed-over Rx drug with none is 422 RECIPIENT_ADDRESS_REQUIRED)
     * @type {string}
     * @memberof AssociatedMedicineDto
     */
    'recipientAddress'?: string;
}

export const AssociatedMedicineDtoDosageIntervalEnum = {
    Day: 'Day',
    Week: 'Week',
    Month: 'Month'
} as const;

export type AssociatedMedicineDtoDosageIntervalEnum = typeof AssociatedMedicineDtoDosageIntervalEnum[keyof typeof AssociatedMedicineDtoDosageIntervalEnum];

/**
 *
 * @export
 * @interface AvailabilitySlotDto
 */
export interface AvailabilitySlotDto {
    /**
     * Day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
     * @type {number}
     * @memberof AvailabilitySlotDto
     */
    'weekday': number;
    /**
     * Start time in HH:MM format
     * @type {string}
     * @memberof AvailabilitySlotDto
     */
    'start': string;
    /**
     * End time in HH:MM format
     * @type {string}
     * @memberof AvailabilitySlotDto
     */
    'end': string;
    /**
     * Optional visit types for this slot (for non-org professionals)
     * @type {Array<string>}
     * @memberof AvailabilitySlotDto
     */
    'visitTypes'?: Array<string>;
}
/**
 *
 * @export
 * @interface AvailableSlotsDto
 */
export interface AvailableSlotsDto {
    /**
     *
     * @type {Array<string>}
     * @memberof AvailableSlotsDto
     */
    'slots': Array<string>;
}
/**
 *
 * @export
 * @interface BatchRecipientDto
 */
export interface BatchRecipientDto {
    /**
     *
     * @type {string}
     * @memberof BatchRecipientDto
     */
    'movementId': string;
    /**
     *
     * @type {WarehouseMovementType}
     * @memberof BatchRecipientDto
     */
    'type': WarehouseMovementType;
    /**
     *
     * @type {WarehouseMovementSourceKind}
     * @memberof BatchRecipientDto
     */
    'sourceKind': WarehouseMovementSourceKind;
    /**
     *
     * @type {string}
     * @memberof BatchRecipientDto
     */
    'sourceId': string;
    /**
     *
     * @type {string}
     * @memberof BatchRecipientDto
     */
    'sourceLineId': string | null;
    /**
     * ISO-8601 instant
     * @type {string}
     * @memberof BatchRecipientDto
     */
    'occurredAt': string;
    /**
     * Warsaw calendar date
     * @type {string}
     * @memberof BatchRecipientDto
     */
    'date': string;
    /**
     * Issued quantity, positive milli-Units
     * @type {number}
     * @memberof BatchRecipientDto
     */
    'quantityMilli': number;
    /**
     * Pack size snapshot of this movement
     * @type {number}
     * @memberof BatchRecipientDto
     */
    'unitsPerPackage': number;
    /**
     *
     * @type {number}
     * @memberof BatchRecipientDto
     */
    'packages': number;
    /**
     *
     * @type {number}
     * @memberof BatchRecipientDto
     */
    'unitsMilli': number;
    /**
     *
     * @type {string}
     * @memberof BatchRecipientDto
     */
    'visitId': string | null;
    /**
     *
     * @type {string}
     * @memberof BatchRecipientDto
     */
    'visitDate': string | null;
    /**
     * Początek wizyty (ISO-8601, data i godzina); null bez wizyty
     * @type {string}
     * @memberof BatchRecipientDto
     */
    'visitStartAt': string | null;
    /**
     *
     * @type {string}
     * @memberof BatchRecipientDto
     */
    'patientName': string | null;
    /**
     * Profil pacjenta, do którego należy wizyta lub wpis; null dla wizyty gościa albo gdy pacjenta nie ma
     * @type {string}
     * @memberof BatchRecipientDto
     */
    'patientProfileId': string | null;
    /**
     *
     * @type {WarehouseHandover}
     * @memberof BatchRecipientDto
     */
    'handover'?: WarehouseHandover;
    /**
     *
     * @type {string}
     * @memberof BatchRecipientDto
     */
    'recipientName': string | null;
    /**
     * Handed-over drugs: the recipient address snapshot, printed with the recipient (Art. 103(3)(e) Reg. 2019/6); null on rows recorded before it was collected
     * @type {string}
     * @memberof BatchRecipientDto
     */
    'recipientAddress': string | null;
    /**
     *
     * @type {string}
     * @memberof BatchRecipientDto
     */
    'prescriberName': string | null;
    /**
     *
     * @type {boolean}
     * @memberof BatchRecipientDto
     */
    'prescriptionIssued': boolean | null;
    /**
     *
     * @type {string}
     * @memberof BatchRecipientDto
     */
    'prescriptionRealisedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof BatchRecipientDto
     */
    'documentNumber': string | null;
    /**
     * Set when this movement reposts a batch-less issue (assignmentOf): Warsaw date of the assignment
     * @type {string}
     * @memberof BatchRecipientDto
     */
    'batchAssignedOn': string | null;
}


/**
 *
 * @export
 * @interface BatchRecipientsBatchDto
 */
export interface BatchRecipientsBatchDto {
    /**
     *
     * @type {string}
     * @memberof BatchRecipientsBatchDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof BatchRecipientsBatchDto
     */
    'productId': string;
    /**
     * Snapshot of the Batch’s first movement
     * @type {string}
     * @memberof BatchRecipientsBatchDto
     */
    'productName': string;
    /**
     *
     * @type {string}
     * @memberof BatchRecipientsBatchDto
     */
    'batchNumber': string;
    /**
     *
     * @type {string}
     * @memberof BatchRecipientsBatchDto
     */
    'expiryDate': string;
    /**
     *
     * @type {WarehouseUnit}
     * @memberof BatchRecipientsBatchDto
     */
    'unit': WarehouseUnit;
    /**
     * Snapshot label of an OTHER unit
     * @type {string}
     * @memberof BatchRecipientsBatchDto
     */
    'unitCustom': string | null;
}


/**
 *
 * @export
 * @interface BatchRecipientsDto
 */
export interface BatchRecipientsDto {
    /**
     *
     * @type {BatchRecipientsBatchDto}
     * @memberof BatchRecipientsDto
     */
    'batch': BatchRecipientsBatchDto;
    /**
     *
     * @type {Array<BatchRecipientDto>}
     * @memberof BatchRecipientsDto
     */
    'recipients': Array<BatchRecipientDto>;
}
/**
 *
 * @export
 * @interface BookingServiceConfigDto
 */
export interface BookingServiceConfigDto {
    /**
     * Derived from the service: onsite/mobile without prepayment use AT_FACILITY; positive prepayment and online visits use ONLINE_REQUIRED.
     * @type {string}
     * @memberof BookingServiceConfigDto
     */
    'paymentTiming': string | null;
    /**
     * Service ID
     * @type {string}
     * @memberof BookingServiceConfigDto
     */
    'serviceId': string;
    /**
     * Service name
     * @type {string}
     * @memberof BookingServiceConfigDto
     */
    'serviceName': string;
    /**
     * Specialization ID this service is assigned to
     * @type {string}
     * @memberof BookingServiceConfigDto
     */
    'specializationId': string;
    /**
     * Service category
     * @type {string}
     * @memberof BookingServiceConfigDto
     */
    'category': BookingServiceConfigDtoCategoryEnum;
    /**
     * Visit type for this service
     * @type {string}
     * @memberof BookingServiceConfigDto
     */
    'visitType': BookingServiceConfigDtoVisitTypeEnum;
    /**
     * Service duration in minutes
     * @type {number}
     * @memberof BookingServiceConfigDto
     */
    'duration': number;
    /**
     * Default price for this service in PLN
     * @type {number}
     * @memberof BookingServiceConfigDto
     */
    'defaultPrice': number;
    /**
     * Notes about this service
     * @type {string}
     * @memberof BookingServiceConfigDto
     */
    'notes'?: string;
    /**
     * Description of the service
     * @type {string}
     * @memberof BookingServiceConfigDto
     */
    'description'?: string;
    /**
     * Reservation fee in PLN charged at booking. null = no fee.
     * @type {number}
     * @memberof BookingServiceConfigDto
     */
    'prepaidAmount'?: number;
}

export const BookingServiceConfigDtoCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type BookingServiceConfigDtoCategoryEnum = typeof BookingServiceConfigDtoCategoryEnum[keyof typeof BookingServiceConfigDtoCategoryEnum];
export const BookingServiceConfigDtoVisitTypeEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type BookingServiceConfigDtoVisitTypeEnum = typeof BookingServiceConfigDtoVisitTypeEnum[keyof typeof BookingServiceConfigDtoVisitTypeEnum];

/**
 *
 * @export
 * @interface CalendarProfessional
 */
export interface CalendarProfessional {
    /**
     *
     * @type {string}
     * @memberof CalendarProfessional
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof CalendarProfessional
     */
    'firstName': string;
    /**
     *
     * @type {string}
     * @memberof CalendarProfessional
     */
    'lastName': string;
}
/**
 *
 * @export
 * @interface CalendarProfile
 */
export interface CalendarProfile {
    /**
     *
     * @type {string}
     * @memberof CalendarProfile
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof CalendarProfile
     */
    'name': string;
}
/**
 *
 * @export
 * @interface CalendarUser
 */
export interface CalendarUser {
    /**
     *
     * @type {string}
     * @memberof CalendarUser
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof CalendarUser
     */
    'firstName': string;
    /**
     *
     * @type {string}
     * @memberof CalendarUser
     */
    'lastName': string;
}
/**
 *
 * @export
 * @interface CalendarVisitDto
 */
export interface CalendarVisitDto {
    /**
     *
     * @type {string}
     * @memberof CalendarVisitDto
     */
    'id': string;
    /**
     *
     * @type {CalendarUser}
     * @memberof CalendarVisitDto
     */
    'user': CalendarUser | null;
    /**
     *
     * @type {CalendarProfessional}
     * @memberof CalendarVisitDto
     */
    'professional': CalendarProfessional | null;
    /**
     *
     * @type {CalendarProfile}
     * @memberof CalendarVisitDto
     */
    'profile': CalendarProfile | null;
    /**
     *
     * @type {string}
     * @memberof CalendarVisitDto
     */
    'startTime': string;
    /**
     *
     * @type {string}
     * @memberof CalendarVisitDto
     */
    'endTime': string;
    /**
     *
     * @type {string}
     * @memberof CalendarVisitDto
     */
    'category': CalendarVisitDtoCategoryEnum;
    /**
     *
     * @type {string}
     * @memberof CalendarVisitDto
     */
    'visitType': CalendarVisitDtoVisitTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CalendarVisitDto
     */
    'status': CalendarVisitDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof CalendarVisitDto
     */
    'serviceName'?: string;
}

export const CalendarVisitDtoCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type CalendarVisitDtoCategoryEnum = typeof CalendarVisitDtoCategoryEnum[keyof typeof CalendarVisitDtoCategoryEnum];
export const CalendarVisitDtoVisitTypeEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type CalendarVisitDtoVisitTypeEnum = typeof CalendarVisitDtoVisitTypeEnum[keyof typeof CalendarVisitDtoVisitTypeEnum];
export const CalendarVisitDtoStatusEnum = {
    Created: 'CREATED',
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED',
    PendingApproval: 'PENDING_APPROVAL',
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED',
    Aborted: 'ABORTED'
} as const;

export type CalendarVisitDtoStatusEnum = typeof CalendarVisitDtoStatusEnum[keyof typeof CalendarVisitDtoStatusEnum];

/**
 *
 * @export
 * @interface CalendarVisitsResponseDto
 */
export interface CalendarVisitsResponseDto {
    /**
     *
     * @type {Array<CalendarVisitDto>}
     * @memberof CalendarVisitsResponseDto
     */
    'data': Array<CalendarVisitDto>;
    /**
     *
     * @type {number}
     * @memberof CalendarVisitsResponseDto
     */
    'total': number;
}
/**
 *
 * @export
 * @interface CallbackAccessResponseDto
 */
export interface CallbackAccessResponseDto {
    /**
     *
     * @type {string}
     * @memberof CallbackAccessResponseDto
     */
    'actorUserId': string;
    /**
     *
     * @type {boolean}
     * @memberof CallbackAccessResponseDto
     */
    'canReadQueue': boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallbackAccessResponseDto
     */
    'canMutateAsHandler': boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallbackAccessResponseDto
     */
    'canAdminister': boolean;
    /**
     *
     * @type {Array<CallbackEligibleHandlerDto>}
     * @memberof CallbackAccessResponseDto
     */
    'eligibleHandlers': Array<CallbackEligibleHandlerDto>;
}
/**
 *
 * @export
 * @interface CallbackAggregateVersionDto
 */
export interface CallbackAggregateVersionDto {
    /**
     *
     * @type {number}
     * @memberof CallbackAggregateVersionDto
     */
    'expectedClaimVersion': number;
}
/**
 *
 * @export
 * @interface CallbackAttemptResponseDto
 */
export interface CallbackAttemptResponseDto {
    /**
     *
     * @type {string}
     * @memberof CallbackAttemptResponseDto
     */
    'attemptId': string;
    /**
     *
     * @type {string}
     * @memberof CallbackAttemptResponseDto
     */
    'actorUserId': string;
    /**
     *
     * @type {string}
     * @memberof CallbackAttemptResponseDto
     */
    'result': CallbackAttemptResponseDtoResultEnum;
    /**
     *
     * @type {string}
     * @memberof CallbackAttemptResponseDto
     */
    'attemptedAt': string;
    /**
     *
     * @type {string}
     * @memberof CallbackAttemptResponseDto
     */
    'receptionWindowKey': string | null;
}

export const CallbackAttemptResponseDtoResultEnum = {
    Contacted: 'CONTACTED',
    NoAnswer: 'NO_ANSWER',
    Busy: 'BUSY',
    Voicemail: 'VOICEMAIL',
    Failed: 'FAILED'
} as const;

export type CallbackAttemptResponseDtoResultEnum = typeof CallbackAttemptResponseDtoResultEnum[keyof typeof CallbackAttemptResponseDtoResultEnum];

/**
 *
 * @export
 * @interface CallbackClaimVersionDto
 */
export interface CallbackClaimVersionDto {
    /**
     *
     * @type {number}
     * @memberof CallbackClaimVersionDto
     */
    'expectedClaimVersion': number;
}
/**
 *
 * @export
 * @interface CallbackEligibleHandlerDto
 */
export interface CallbackEligibleHandlerDto {
    /**
     *
     * @type {string}
     * @memberof CallbackEligibleHandlerDto
     */
    'userId': string;
    /**
     *
     * @type {string}
     * @memberof CallbackEligibleHandlerDto
     */
    'displayName': string;
}
/**
 *
 * @export
 * @interface CallbackHandlerAssignmentSnapshotDto
 */
export interface CallbackHandlerAssignmentSnapshotDto {
    /**
     *
     * @type {string}
     * @memberof CallbackHandlerAssignmentSnapshotDto
     */
    'assignmentId': string;
    /**
     *
     * @type {string}
     * @memberof CallbackHandlerAssignmentSnapshotDto
     */
    'userId': string;
    /**
     *
     * @type {number}
     * @memberof CallbackHandlerAssignmentSnapshotDto
     */
    'assignmentRevision': number;
}
/**
 *
 * @export
 * @interface CallbackRequestListResponseDto
 */
export interface CallbackRequestListResponseDto {
    /**
     *
     * @type {Array<CallbackRequestResponseDto>}
     * @memberof CallbackRequestListResponseDto
     */
    'items': Array<CallbackRequestResponseDto>;
    /**
     *
     * @type {number}
     * @memberof CallbackRequestListResponseDto
     */
    'total': number;
    /**
     *
     * @type {number}
     * @memberof CallbackRequestListResponseDto
     */
    'page': number;
    /**
     *
     * @type {number}
     * @memberof CallbackRequestListResponseDto
     */
    'limit': number;
}
/**
 *
 * @export
 * @interface CallbackRequestResponseDto
 */
export interface CallbackRequestResponseDto {
    /**
     *
     * @type {string}
     * @memberof CallbackRequestResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof CallbackRequestResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof CallbackRequestResponseDto
     */
    'status': CallbackRequestResponseDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof CallbackRequestResponseDto
     */
    'purpose': CallbackRequestResponseDtoPurposeEnum;
    /**
     * Potwierdzony numer kontaktowy E.164; null w podsumowaniu kolejki
     * @type {string}
     * @memberof CallbackRequestResponseDto
     */
    'confirmedContactE164': string | null;
    /**
     *
     * @type {string}
     * @memberof CallbackRequestResponseDto
     */
    'confirmedContactSuffix': string | null;
    /**
     *
     * @type {string}
     * @memberof CallbackRequestResponseDto
     */
    'callerName': string | null;
    /**
     *
     * @type {string}
     * @memberof CallbackRequestResponseDto
     */
    'callerApprovedNote': string | null;
    /**
     *
     * @type {CallbackRequestResponseDtoPreferredWindow}
     * @memberof CallbackRequestResponseDto
     */
    'preferredWindow': CallbackRequestResponseDtoPreferredWindow | null;
    /**
     *
     * @type {number}
     * @memberof CallbackRequestResponseDto
     */
    'claimVersion': number;
    /**
     *
     * @type {string}
     * @memberof CallbackRequestResponseDto
     */
    'claimedByUserId': string | null;
    /**
     *
     * @type {Array<CallbackAttemptResponseDto>}
     * @memberof CallbackRequestResponseDto
     */
    'attempts': Array<CallbackAttemptResponseDto>;
    /**
     *
     * @type {string}
     * @memberof CallbackRequestResponseDto
     */
    'firstAttemptDueAt': string;
    /**
     *
     * @type {string}
     * @memberof CallbackRequestResponseDto
     */
    'terminalReason': CallbackRequestResponseDtoTerminalReasonEnum;
    /**
     *
     * @type {string}
     * @memberof CallbackRequestResponseDto
     */
    'terminalAt': string | null;
    /**
     *
     * @type {string}
     * @memberof CallbackRequestResponseDto
     */
    'firstOverdueEscalatedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof CallbackRequestResponseDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof CallbackRequestResponseDto
     */
    'purgeAt': string;
}

export const CallbackRequestResponseDtoStatusEnum = {
    Open: 'OPEN',
    Claimed: 'CLAIMED',
    Completed: 'COMPLETED',
    Unreachable: 'UNREACHABLE',
    Cancelled: 'CANCELLED'
} as const;

export type CallbackRequestResponseDtoStatusEnum = typeof CallbackRequestResponseDtoStatusEnum[keyof typeof CallbackRequestResponseDtoStatusEnum];
export const CallbackRequestResponseDtoPurposeEnum = {
    NewBookingOrAvailability: 'NEW_BOOKING_OR_AVAILABILITY',
    ExistingVisit: 'EXISTING_VISIT',
    FacilityServiceOrPrice: 'FACILITY_SERVICE_OR_PRICE',
    PaymentInvoiceOrDocument: 'PAYMENT_INVOICE_OR_DOCUMENT',
    ClinicalStaffRequest: 'CLINICAL_STAFF_REQUEST',
    ComplaintOrFeedback: 'COMPLAINT_OR_FEEDBACK',
    OtherOrUnspecified: 'OTHER_OR_UNSPECIFIED'
} as const;

export type CallbackRequestResponseDtoPurposeEnum = typeof CallbackRequestResponseDtoPurposeEnum[keyof typeof CallbackRequestResponseDtoPurposeEnum];
export const CallbackRequestResponseDtoTerminalReasonEnum = {
    Contacted: 'CONTACTED',
    Unreachable: 'UNREACHABLE',
    OwnerAdminCancelled: 'OWNER_ADMIN_CANCELLED',
    RetentionExpired: 'RETENTION_EXPIRED'
} as const;

export type CallbackRequestResponseDtoTerminalReasonEnum = typeof CallbackRequestResponseDtoTerminalReasonEnum[keyof typeof CallbackRequestResponseDtoTerminalReasonEnum];

/**
 *
 * @export
 * @interface CallbackRequestResponseDtoPreferredWindow
 */
export interface CallbackRequestResponseDtoPreferredWindow {
    /**
     *
     * @type {string}
     * @memberof CallbackRequestResponseDtoPreferredWindow
     */
    'startsAt'?: string;
    /**
     *
     * @type {string}
     * @memberof CallbackRequestResponseDtoPreferredWindow
     */
    'endsAt'?: string;
}
/**
 *
 * @export
 * @interface CallbackSupportGrantQueueItemResponseDto
 */
export interface CallbackSupportGrantQueueItemResponseDto {
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantQueueItemResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantQueueItemResponseDto
     */
    'status': CallbackSupportGrantQueueItemResponseDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantQueueItemResponseDto
     */
    'reason': CallbackSupportGrantQueueItemResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantQueueItemResponseDto
     */
    'requestedAt': string;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantQueueItemResponseDto
     */
    'activeUntil': string | null;
}

export const CallbackSupportGrantQueueItemResponseDtoStatusEnum = {
    Requested: 'REQUESTED',
    Active: 'ACTIVE',
    Consumed: 'CONSUMED',
    Denied: 'DENIED',
    Revoked: 'REVOKED',
    Expired: 'EXPIRED'
} as const;

export type CallbackSupportGrantQueueItemResponseDtoStatusEnum = typeof CallbackSupportGrantQueueItemResponseDtoStatusEnum[keyof typeof CallbackSupportGrantQueueItemResponseDtoStatusEnum];
export const CallbackSupportGrantQueueItemResponseDtoReasonEnum = {
    CallbackQueueDiagnosis: 'CALLBACK_QUEUE_DIAGNOSIS',
    CallbackSlaIncidentInvestigation: 'CALLBACK_SLA_INCIDENT_INVESTIGATION',
    AccessControlVerification: 'ACCESS_CONTROL_VERIFICATION'
} as const;

export type CallbackSupportGrantQueueItemResponseDtoReasonEnum = typeof CallbackSupportGrantQueueItemResponseDtoReasonEnum[keyof typeof CallbackSupportGrantQueueItemResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface CallbackSupportGrantResponseDto
 */
export interface CallbackSupportGrantResponseDto {
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantResponseDto
     */
    'subjectUserId': string;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantResponseDto
     */
    'surface': CallbackSupportGrantResponseDtoSurfaceEnum;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantResponseDto
     */
    'status': CallbackSupportGrantResponseDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantResponseDto
     */
    'supportSessionId': string;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantResponseDto
     */
    'ticketReference': string;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantResponseDto
     */
    'reason': CallbackSupportGrantResponseDtoReasonEnum;
    /**
     *
     * @type {number}
     * @memberof CallbackSupportGrantResponseDto
     */
    'requestedMinutes': number;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantResponseDto
     */
    'requestedAt': string;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantResponseDto
     */
    'requestExpiresAt': string;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantResponseDto
     */
    'approvedByUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantResponseDto
     */
    'approvedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantResponseDto
     */
    'activeUntil': string | null;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantResponseDto
     */
    'consumedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantResponseDto
     */
    'deniedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof CallbackSupportGrantResponseDto
     */
    'revokedAt': string | null;
}

export const CallbackSupportGrantResponseDtoSurfaceEnum = {
    CallbackRequestPii: 'CALLBACK_REQUEST_PII'
} as const;

export type CallbackSupportGrantResponseDtoSurfaceEnum = typeof CallbackSupportGrantResponseDtoSurfaceEnum[keyof typeof CallbackSupportGrantResponseDtoSurfaceEnum];
export const CallbackSupportGrantResponseDtoStatusEnum = {
    Requested: 'REQUESTED',
    Active: 'ACTIVE',
    Consumed: 'CONSUMED',
    Denied: 'DENIED',
    Revoked: 'REVOKED',
    Expired: 'EXPIRED'
} as const;

export type CallbackSupportGrantResponseDtoStatusEnum = typeof CallbackSupportGrantResponseDtoStatusEnum[keyof typeof CallbackSupportGrantResponseDtoStatusEnum];
export const CallbackSupportGrantResponseDtoReasonEnum = {
    CallbackQueueDiagnosis: 'CALLBACK_QUEUE_DIAGNOSIS',
    CallbackSlaIncidentInvestigation: 'CALLBACK_SLA_INCIDENT_INVESTIGATION',
    AccessControlVerification: 'ACCESS_CONTROL_VERIFICATION'
} as const;

export type CallbackSupportGrantResponseDtoReasonEnum = typeof CallbackSupportGrantResponseDtoReasonEnum[keyof typeof CallbackSupportGrantResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface CampaignPaymentResponseDto
 */
export interface CampaignPaymentResponseDto {
    /**
     *
     * @type {string}
     * @memberof CampaignPaymentResponseDto
     */
    'paymentUrl': string;
    /**
     *
     * @type {string}
     * @memberof CampaignPaymentResponseDto
     */
    'paymentId': string;
    /**
     *
     * @type {number}
     * @memberof CampaignPaymentResponseDto
     */
    'totalAmount': number;
}
/**
 *
 * @export
 * @interface CancelByGuestDto
 */
export interface CancelByGuestDto {
    /**
     * Optional reason for cancelling the visit
     * @type {string}
     * @memberof CancelByGuestDto
     */
    'reason'?: string;
}
/**
 *
 * @export
 * @interface CancelReceptionClosureDto
 */
export interface CancelReceptionClosureDto {
    /**
     *
     * @type {number}
     * @memberof CancelReceptionClosureDto
     */
    'expectedPublishedRevision': number;
}
/**
 *
 * @export
 * @interface CancelStaffVisitDto
 */
export interface CancelStaffVisitDto {
    /**
     * Optional reason for cancelling the visit
     * @type {string}
     * @memberof CancelStaffVisitDto
     */
    'cancellationReason'?: string;
}
/**
 *
 * @export
 * @interface CancelVisitDto
 */
export interface CancelVisitDto {
    /**
     * Optional reason for cancelling the visit
     * @type {string}
     * @memberof CancelVisitDto
     */
    'cancellationReason'?: string;
}
/**
 *
 * @export
 * @interface CancelWarehouseDocumentDto
 */
export interface CancelWarehouseDocumentDto {
    /**
     * Why the document is cancelled
     * @type {string}
     * @memberof CancelWarehouseDocumentDto
     */
    'cancelReason'?: string;
}
/**
 *
 * @export
 * @interface CaptureVoicePilotEvidenceDto
 */
export interface CaptureVoicePilotEvidenceDto {
    /**
     *
     * @type {string}
     * @memberof CaptureVoicePilotEvidenceDto
     */
    'sourceExecutionReference': string;
}
/**
 *
 * @export
 * @interface ChangeMedicationStatusDto
 */
export interface ChangeMedicationStatusDto {
    /**
     * SCHEDULED is derived from the start date, not set by hand
     * @type {string}
     * @memberof ChangeMedicationStatusDto
     */
    'status': ChangeMedicationStatusDtoStatusEnum;
    /**
     * Required when status is STOPPED
     * @type {string}
     * @memberof ChangeMedicationStatusDto
     */
    'stopReason'?: ChangeMedicationStatusDtoStopReasonEnum;
    /**
     * Required when stopReason is OTHER
     * @type {string}
     * @memberof ChangeMedicationStatusDto
     */
    'stopReasonNote'?: string;
    /**
     * When the patient stopped, if that is not today
     * @type {string}
     * @memberof ChangeMedicationStatusDto
     */
    'endedAt'?: string;
    /**
     * Visit the change was made on, recorded in the visit course
     * @type {string}
     * @memberof ChangeMedicationStatusDto
     */
    'visitId'?: string;
}

export const ChangeMedicationStatusDtoStatusEnum = {
    Active: 'ACTIVE',
    Paused: 'PAUSED',
    Stopped: 'STOPPED'
} as const;

export type ChangeMedicationStatusDtoStatusEnum = typeof ChangeMedicationStatusDtoStatusEnum[keyof typeof ChangeMedicationStatusDtoStatusEnum];
export const ChangeMedicationStatusDtoStopReasonEnum = {
    CourseCompleted: 'COURSE_COMPLETED',
    Ineffective: 'INEFFECTIVE',
    AdverseReaction: 'ADVERSE_REACTION',
    OwnerDecision: 'OWNER_DECISION',
    Replaced: 'REPLACED',
    Other: 'OTHER'
} as const;

export type ChangeMedicationStatusDtoStopReasonEnum = typeof ChangeMedicationStatusDtoStopReasonEnum[keyof typeof ChangeMedicationStatusDtoStopReasonEnum];

/**
 *
 * @export
 * @interface ChangeVoiceMessagingOrganizationDto
 */
export interface ChangeVoiceMessagingOrganizationDto {
    /**
     *
     * @type {string}
     * @memberof ChangeVoiceMessagingOrganizationDto
     */
    'requestId': string;
    /**
     *
     * @type {number}
     * @memberof ChangeVoiceMessagingOrganizationDto
     */
    'expectedRevision': number;
}
/**
 *
 * @export
 * @interface ChangeWarehouseDemandRequestStatusDto
 */
export interface ChangeWarehouseDemandRequestStatusDto {
    /**
     *
     * @type {WarehouseDemandRequestTargetStatus}
     * @memberof ChangeWarehouseDemandRequestStatusDto
     */
    'status': WarehouseDemandRequestTargetStatus;
}


/**
 *
 * @export
 * @interface ChatMessageDto
 */
export interface ChatMessageDto {
    /**
     *
     * @type {string}
     * @memberof ChatMessageDto
     */
    'sid': string;
    /**
     *
     * @type {string}
     * @memberof ChatMessageDto
     */
    'body': string;
    /**
     *
     * @type {string}
     * @memberof ChatMessageDto
     */
    'author': string;
    /**
     *
     * @type {string}
     * @memberof ChatMessageDto
     */
    'timestamp': string;
    /**
     *
     * @type {string}
     * @memberof ChatMessageDto
     */
    'participantSid': string;
}
/**
 *
 * @export
 * @interface ChatMessagesResponse
 */
export interface ChatMessagesResponse {
    /**
     *
     * @type {Array<ChatMessageDto>}
     * @memberof ChatMessagesResponse
     */
    'messages': Array<ChatMessageDto>;
}
/**
 *
 * @export
 * @interface ChatTokenRequest
 */
export interface ChatTokenRequest {
    /**
     *
     * @type {string}
     * @memberof ChatTokenRequest
     */
    'conversationId': string;
}
/**
 *
 * @export
 * @interface ChatTokenResponse
 */
export interface ChatTokenResponse {
    /**
     *
     * @type {string}
     * @memberof ChatTokenResponse
     */
    'token': string;
    /**
     *
     * @type {string}
     * @memberof ChatTokenResponse
     */
    'conversationSid': string;
}
/**
 *
 * @export
 * @interface CheckOrganizationServiceUsageResponseDto
 */
export interface CheckOrganizationServiceUsageResponseDto {
    /**
     * Whether any professionals have the services configured
     * @type {boolean}
     * @memberof CheckOrganizationServiceUsageResponseDto
     */
    'hasAssignedServices': boolean;
    /**
     * Total number of affected service configurations
     * @type {number}
     * @memberof CheckOrganizationServiceUsageResponseDto
     */
    'affectedCount': number;
    /**
     * List of affected professionals and their services
     * @type {Array<AffectedProfessionalServicesDto>}
     * @memberof CheckOrganizationServiceUsageResponseDto
     */
    'professionals': Array<AffectedProfessionalServicesDto>;
}
/**
 *
 * @export
 * @interface CheckOrganizationSpecializationServicesResponseDto
 */
export interface CheckOrganizationSpecializationServicesResponseDto {
    /**
     * Whether any professionals have services assigned to the specializations
     * @type {boolean}
     * @memberof CheckOrganizationSpecializationServicesResponseDto
     */
    'hasAssignedServices': boolean;
    /**
     * Total number of affected services
     * @type {number}
     * @memberof CheckOrganizationSpecializationServicesResponseDto
     */
    'affectedCount': number;
    /**
     * List of affected professionals and their services
     * @type {Array<AffectedProfessionalServicesDto>}
     * @memberof CheckOrganizationSpecializationServicesResponseDto
     */
    'professionals': Array<AffectedProfessionalServicesDto>;
}
/**
 *
 * @export
 * @interface CheckProfessionalSpecializationServicesResponseDto
 */
export interface CheckProfessionalSpecializationServicesResponseDto {
    /**
     * Whether the professional has services assigned to the specializations
     * @type {boolean}
     * @memberof CheckProfessionalSpecializationServicesResponseDto
     */
    'hasAssignedServices': boolean;
    /**
     * List of affected services
     * @type {Array<AffectedServiceDto>}
     * @memberof CheckProfessionalSpecializationServicesResponseDto
     */
    'affectedServices': Array<AffectedServiceDto>;
}
/**
 *
 * @export
 * @interface CheckServiceUsageDto
 */
export interface CheckServiceUsageDto {
    /**
     * Array of service IDs to check
     * @type {Array<string>}
     * @memberof CheckServiceUsageDto
     */
    'serviceIds': Array<string>;
}
/**
 *
 * @export
 * @interface CheckSpecializationServicesDto
 */
export interface CheckSpecializationServicesDto {
    /**
     * Array of specialization IDs to check
     * @type {Array<string>}
     * @memberof CheckSpecializationServicesDto
     */
    'specializationIds': Array<string>;
}
/**
 *
 * @export
 * @interface CheckTermsAcceptanceResponseDto
 */
export interface CheckTermsAcceptanceResponseDto {
    /**
     * Whether the user needs to accept new terms
     * @type {boolean}
     * @memberof CheckTermsAcceptanceResponseDto
     */
    'requiresAcceptance': boolean;
    /**
     *
     * @type {CheckTermsAcceptanceResponseDtoActiveTerms}
     * @memberof CheckTermsAcceptanceResponseDto
     */
    'activeTerms'?: CheckTermsAcceptanceResponseDtoActiveTerms;
    /**
     *
     * @type {CheckTermsAcceptanceResponseDtoActivePrivacyPolicy}
     * @memberof CheckTermsAcceptanceResponseDto
     */
    'activePrivacyPolicy'?: CheckTermsAcceptanceResponseDtoActivePrivacyPolicy;
}
/**
 * The active privacy policy that needs to be accepted (if any)
 * @export
 * @interface CheckTermsAcceptanceResponseDtoActivePrivacyPolicy
 */
export interface CheckTermsAcceptanceResponseDtoActivePrivacyPolicy {
    /**
     *
     * @type {string}
     * @memberof CheckTermsAcceptanceResponseDtoActivePrivacyPolicy
     */
    'id': string;
    /**
     *
     * @type {number}
     * @memberof CheckTermsAcceptanceResponseDtoActivePrivacyPolicy
     */
    'version': number;
    /**
     *
     * @type {string}
     * @memberof CheckTermsAcceptanceResponseDtoActivePrivacyPolicy
     */
    'pageLink'?: string;
    /**
     *
     * @type {string}
     * @memberof CheckTermsAcceptanceResponseDtoActivePrivacyPolicy
     */
    'content'?: string;
    /**
     *
     * @type {string}
     * @memberof CheckTermsAcceptanceResponseDtoActivePrivacyPolicy
     */
    'type': CheckTermsAcceptanceResponseDtoActivePrivacyPolicyTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CheckTermsAcceptanceResponseDtoActivePrivacyPolicy
     */
    'documentCategory': CheckTermsAcceptanceResponseDtoActivePrivacyPolicyDocumentCategoryEnum;
    /**
     *
     * @type {boolean}
     * @memberof CheckTermsAcceptanceResponseDtoActivePrivacyPolicy
     */
    'active': boolean;
    /**
     *
     * @type {string}
     * @memberof CheckTermsAcceptanceResponseDtoActivePrivacyPolicy
     */
    'createdAt': string;
}

export const CheckTermsAcceptanceResponseDtoActivePrivacyPolicyTypeEnum = {
    User: 'USER',
    Professional: 'PROFESSIONAL'
} as const;

export type CheckTermsAcceptanceResponseDtoActivePrivacyPolicyTypeEnum = typeof CheckTermsAcceptanceResponseDtoActivePrivacyPolicyTypeEnum[keyof typeof CheckTermsAcceptanceResponseDtoActivePrivacyPolicyTypeEnum];
export const CheckTermsAcceptanceResponseDtoActivePrivacyPolicyDocumentCategoryEnum = {
    TermsConditions: 'TERMS_CONDITIONS',
    PrivacyPolicy: 'PRIVACY_POLICY'
} as const;

export type CheckTermsAcceptanceResponseDtoActivePrivacyPolicyDocumentCategoryEnum = typeof CheckTermsAcceptanceResponseDtoActivePrivacyPolicyDocumentCategoryEnum[keyof typeof CheckTermsAcceptanceResponseDtoActivePrivacyPolicyDocumentCategoryEnum];

/**
 * The active terms & conditions that need to be accepted (if any)
 * @export
 * @interface CheckTermsAcceptanceResponseDtoActiveTerms
 */
export interface CheckTermsAcceptanceResponseDtoActiveTerms {
    /**
     *
     * @type {string}
     * @memberof CheckTermsAcceptanceResponseDtoActiveTerms
     */
    'id': string;
    /**
     *
     * @type {number}
     * @memberof CheckTermsAcceptanceResponseDtoActiveTerms
     */
    'version': number;
    /**
     *
     * @type {string}
     * @memberof CheckTermsAcceptanceResponseDtoActiveTerms
     */
    'pageLink'?: string;
    /**
     *
     * @type {string}
     * @memberof CheckTermsAcceptanceResponseDtoActiveTerms
     */
    'content'?: string;
    /**
     *
     * @type {string}
     * @memberof CheckTermsAcceptanceResponseDtoActiveTerms
     */
    'type': CheckTermsAcceptanceResponseDtoActiveTermsTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CheckTermsAcceptanceResponseDtoActiveTerms
     */
    'documentCategory': CheckTermsAcceptanceResponseDtoActiveTermsDocumentCategoryEnum;
    /**
     *
     * @type {boolean}
     * @memberof CheckTermsAcceptanceResponseDtoActiveTerms
     */
    'active': boolean;
    /**
     *
     * @type {string}
     * @memberof CheckTermsAcceptanceResponseDtoActiveTerms
     */
    'createdAt': string;
}

export const CheckTermsAcceptanceResponseDtoActiveTermsTypeEnum = {
    User: 'USER',
    Professional: 'PROFESSIONAL'
} as const;

export type CheckTermsAcceptanceResponseDtoActiveTermsTypeEnum = typeof CheckTermsAcceptanceResponseDtoActiveTermsTypeEnum[keyof typeof CheckTermsAcceptanceResponseDtoActiveTermsTypeEnum];
export const CheckTermsAcceptanceResponseDtoActiveTermsDocumentCategoryEnum = {
    TermsConditions: 'TERMS_CONDITIONS',
    PrivacyPolicy: 'PRIVACY_POLICY'
} as const;

export type CheckTermsAcceptanceResponseDtoActiveTermsDocumentCategoryEnum = typeof CheckTermsAcceptanceResponseDtoActiveTermsDocumentCategoryEnum[keyof typeof CheckTermsAcceptanceResponseDtoActiveTermsDocumentCategoryEnum];

/**
 *
 * @export
 * @interface CleanupVoiceSmsPrivacyQualificationDto
 */
export interface CleanupVoiceSmsPrivacyQualificationDto {
    /**
     *
     * @type {string}
     * @memberof CleanupVoiceSmsPrivacyQualificationDto
     */
    'id': string;
    /**
     *
     * @type {number}
     * @memberof CleanupVoiceSmsPrivacyQualificationDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof CleanupVoiceSmsPrivacyQualificationDto
     */
    'scopeSha256': string;
    /**
     *
     * @type {string}
     * @memberof CleanupVoiceSmsPrivacyQualificationDto
     */
    'acknowledgement': CleanupVoiceSmsPrivacyQualificationDtoAcknowledgementEnum;
}

export const CleanupVoiceSmsPrivacyQualificationDtoAcknowledgementEnum = {
    CleanupOnlyExactRecordedSmsPrivacyEventsV1: 'CLEANUP_ONLY_EXACT_RECORDED_SMS_PRIVACY_EVENTS_V1'
} as const;

export type CleanupVoiceSmsPrivacyQualificationDtoAcknowledgementEnum = typeof CleanupVoiceSmsPrivacyQualificationDtoAcknowledgementEnum[keyof typeof CleanupVoiceSmsPrivacyQualificationDtoAcknowledgementEnum];

/**
 *
 * @export
 * @interface CompleteVoiceDsrDto
 */
export interface CompleteVoiceDsrDto {
    /**
     *
     * @type {number}
     * @memberof CompleteVoiceDsrDto
     */
    'expectedRevision': number;
    /**
     *
     * @type {string}
     * @memberof CompleteVoiceDsrDto
     */
    'fulfillmentReceipt'?: string;
}
/**
 *
 * @export
 * @interface ConflictingVisitDto
 */
export interface ConflictingVisitDto {
    /**
     * ID wizyty kolidującej z nowym harmonogramem
     * @type {string}
     * @memberof ConflictingVisitDto
     */
    'visitId': string;
    /**
     * Data i godzina rozpoczęcia wizyty
     * @type {string}
     * @memberof ConflictingVisitDto
     */
    'startTime': string;
    /**
     * Data i godzina zakończenia wizyty
     * @type {string}
     * @memberof ConflictingVisitDto
     */
    'endTime': string;
    /**
     * ID specjalisty powiązanego z wizytą (brak dla wizyt bez przypisanego specjalisty)
     * @type {string}
     * @memberof ConflictingVisitDto
     */
    'professionalId'?: string;
    /**
     * Imię pupila (z danych wizyty)
     * @type {string}
     * @memberof ConflictingVisitDto
     */
    'petName'?: string;
    /**
     * Imię i nazwisko specjalisty przypisanego do wizyty
     * @type {string}
     * @memberof ConflictingVisitDto
     */
    'professionalName'?: string;
    /**
     * Powód konfliktu
     * @type {string}
     * @memberof ConflictingVisitDto
     */
    'reason': string;
}
/**
 *
 * @export
 * @interface ConversationCancelDto
 */
export interface ConversationCancelDto {
    /**
     *
     * @type {string}
     * @memberof ConversationCancelDto
     */
    'conversationId': string;
}
/**
 *
 * @export
 * @interface ConversationCompleteDto
 */
export interface ConversationCompleteDto {
    /**
     *
     * @type {string}
     * @memberof ConversationCompleteDto
     */
    'conversationId'?: string;
    /**
     *
     * @type {string}
     * @memberof ConversationCompleteDto
     */
    'visitId'?: string;
    /**
     *
     * @type {string}
     * @memberof ConversationCompleteDto
     */
    'notes'?: string;
    /**
     *
     * @type {string}
     * @memberof ConversationCompleteDto
     */
    'internalNotes'?: string;
}
/**
 *
 * @export
 * @interface ConversationFeedbackDto
 */
export interface ConversationFeedbackDto {
    /**
     * The ID of the profile for which to save feedback
     * @type {string}
     * @memberof ConversationFeedbackDto
     */
    'profileId': string;
    /**
     * Whether the information was helpful
     * @type {boolean}
     * @memberof ConversationFeedbackDto
     */
    'isHelpful': boolean;
}
/**
 *
 * @export
 * @interface ConversationJointDto
 */
export interface ConversationJointDto {
    /**
     *
     * @type {string}
     * @memberof ConversationJointDto
     */
    'roomName': string;
}
/**
 *
 * @export
 * @interface ConversationMessage
 */
export interface ConversationMessage {
    /**
     * Role of the message sender (user or assistant)
     * @type {string}
     * @memberof ConversationMessage
     */
    'role': ConversationMessageRoleEnum;
    /**
     * Content of the message
     * @type {string}
     * @memberof ConversationMessage
     */
    'content': string;
}

export const ConversationMessageRoleEnum = {
    User: 'user',
    Assistant: 'assistant'
} as const;

export type ConversationMessageRoleEnum = typeof ConversationMessageRoleEnum[keyof typeof ConversationMessageRoleEnum];

/**
 *
 * @export
 * @interface ConversationMessageDto
 */
export interface ConversationMessageDto {
    /**
     * Role of the message sender
     * @type {string}
     * @memberof ConversationMessageDto
     */
    'role': ConversationMessageDtoRoleEnum;
    /**
     * Content of the message
     * @type {string}
     * @memberof ConversationMessageDto
     */
    'content': string;
}

export const ConversationMessageDtoRoleEnum = {
    Professional: 'professional',
    Assistant: 'assistant'
} as const;

export type ConversationMessageDtoRoleEnum = typeof ConversationMessageDtoRoleEnum[keyof typeof ConversationMessageDtoRoleEnum];

/**
 *
 * @export
 * @interface ConversationStartDto
 */
export interface ConversationStartDto {
    /**
     *
     * @type {string}
     * @memberof ConversationStartDto
     */
    'conversationId'?: string;
    /**
     *
     * @type {string}
     * @memberof ConversationStartDto
     */
    'visitId'?: string;
}
/**
 *
 * @export
 * @interface CreateCampaignDto
 */
export interface CreateCampaignDto {
    /**
     * Campaign name
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'name': string;
    /**
     * Campaign description
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'description'?: string;
    /**
     * Campaign keywords
     * @type {Array<string>}
     * @memberof CreateCampaignDto
     */
    'keywords'?: Array<string>;
    /**
     * Daily budget in PLN (zł)
     * @type {number}
     * @memberof CreateCampaignDto
     */
    'dailyBudget'?: number;
    /**
     * Campaign start date
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'startDate'?: string;
    /**
     * Campaign end date
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'endDate'?: string;
    /**
     * Promo code to apply
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'promoCode'?: string;
}
/**
 *
 * @export
 * @interface CreateEmergencyGuidanceDraftDto
 */
export interface CreateEmergencyGuidanceDraftDto {
    /**
     *
     * @type {string}
     * @memberof CreateEmergencyGuidanceDraftDto
     */
    'note'?: string | null;
    /**
     *
     * @type {number}
     * @memberof CreateEmergencyGuidanceDraftDto
     */
    'expectedPublishedRevision': number;
    /**
     *
     * @type {string}
     * @memberof CreateEmergencyGuidanceDraftDto
     */
    'guidance': string;
    /**
     *
     * @type {string}
     * @memberof CreateEmergencyGuidanceDraftDto
     */
    'destinationId': string;
    /**
     *
     * @type {string}
     * @memberof CreateEmergencyGuidanceDraftDto
     */
    'reason': CreateEmergencyGuidanceDraftDtoReasonEnum;
}

export const CreateEmergencyGuidanceDraftDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    GuidanceUpdate: 'GUIDANCE_UPDATE',
    DestinationUpdate: 'DESTINATION_UPDATE',
    PeriodicReapproval: 'PERIODIC_REAPPROVAL',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type CreateEmergencyGuidanceDraftDtoReasonEnum = typeof CreateEmergencyGuidanceDraftDtoReasonEnum[keyof typeof CreateEmergencyGuidanceDraftDtoReasonEnum];

/**
 *
 * @export
 * @interface CreateFeedbackDto
 */
export interface CreateFeedbackDto {
    /**
     *
     * @type {string}
     * @memberof CreateFeedbackDto
     */
    'suggestionId': string;
    /**
     *
     * @type {boolean}
     * @memberof CreateFeedbackDto
     */
    'isHelpful': boolean;
    /**
     *
     * @type {string}
     * @memberof CreateFeedbackDto
     */
    'comment'?: string;
}
/**
 *
 * @export
 * @interface CreateFormDto
 */
export interface CreateFormDto {
    /**
     * Form name
     * @type {string}
     * @memberof CreateFormDto
     */
    'name': string;
    /**
     * Form description
     * @type {string}
     * @memberof CreateFormDto
     */
    'description'?: string;
    /**
     * Form fields
     * @type {Array<FormFieldDto>}
     * @memberof CreateFormDto
     */
    'fields': Array<FormFieldDto>;
}
/**
 *
 * @export
 * @interface CreateFormSubmissionDto
 */
export interface CreateFormSubmissionDto {
    /**
     * Form ID
     * @type {string}
     * @memberof CreateFormSubmissionDto
     */
    'formId': string;
    /**
     * Visit ID
     * @type {string}
     * @memberof CreateFormSubmissionDto
     */
    'visitId': string;
    /**
     * Field responses
     * @type {Array<FieldResponseDto>}
     * @memberof CreateFormSubmissionDto
     */
    'responses': Array<FieldResponseDto>;
    /**
     * Submission status
     * @type {string}
     * @memberof CreateFormSubmissionDto
     */
    'status': CreateFormSubmissionDtoStatusEnum;
}

export const CreateFormSubmissionDtoStatusEnum = {
    Draft: 'draft',
    Submitted: 'submitted'
} as const;

export type CreateFormSubmissionDtoStatusEnum = typeof CreateFormSubmissionDtoStatusEnum[keyof typeof CreateFormSubmissionDtoStatusEnum];

/**
 *
 * @export
 * @interface CreateInvitationDto
 */
export interface CreateInvitationDto {
    /**
     *
     * @type {Array<string>}
     * @memberof CreateInvitationDto
     */
    'roles': Array<CreateInvitationDtoRolesEnum>;
    /**
     *
     * @type {string}
     * @memberof CreateInvitationDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof CreateInvitationDto
     */
    'email': string;
    /**
     *
     * @type {string}
     * @memberof CreateInvitationDto
     */
    'firstName': string;
    /**
     *
     * @type {string}
     * @memberof CreateInvitationDto
     */
    'lastName': string;
}

export const CreateInvitationDtoRolesEnum = {
    Professional: 'PROFESSIONAL',
    OrganizationAdmin: 'ORGANIZATION_ADMIN',
    OrganizationOwner: 'ORGANIZATION_OWNER'
} as const;

export type CreateInvitationDtoRolesEnum = typeof CreateInvitationDtoRolesEnum[keyof typeof CreateInvitationDtoRolesEnum];

/**
 *
 * @export
 * @interface CreateProfessionalDto
 */
export interface CreateProfessionalDto {
    /**
     *
     * @type {string}
     * @memberof CreateProfessionalDto
     */
    'firstName': string;
    /**
     *
     * @type {string}
     * @memberof CreateProfessionalDto
     */
    'middleName'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateProfessionalDto
     */
    'lastName': string;
    /**
     *
     * @type {string}
     * @memberof CreateProfessionalDto
     */
    'phoneNumber': string;
    /**
     *
     * @type {string}
     * @memberof CreateProfessionalDto
     */
    'dob'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateProfessionalDto
     */
    'avatar'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateProfessionalDto
     */
    'address'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateProfessionalDto
     */
    'companyName'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateProfessionalDto
     */
    'companyAddress'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateProfessionalDto
     */
    'companyCity'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateProfessionalDto
     */
    'companyZip'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateProfessionalDto
     */
    'vatNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateProfessionalDto
     */
    'pwzNumber': string;
    /**
     *
     * @type {string}
     * @memberof CreateProfessionalDto
     */
    'city'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateProfessionalDto
     */
    'zip'?: string;
    /**
     *
     * @type {boolean}
     * @memberof CreateProfessionalDto
     */
    'marketing'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CreateProfessionalDto
     */
    'terms': boolean;
}
/**
 *
 * @export
 * @interface CreateProfileDto
 */
export interface CreateProfileDto {
    /**
     *
     * @type {string}
     * @memberof CreateProfileDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof CreateProfileDto
     */
    'avatar'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateProfileDto
     */
    'background'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateProfileDto
     */
    'dob': string;
    /**
     *
     * @type {string}
     * @memberof CreateProfileDto
     */
    'breed': string;
    /**
     *
     * @type {number}
     * @memberof CreateProfileDto
     */
    'weight': number;
    /**
     *
     * @type {string}
     * @memberof CreateProfileDto
     */
    'chipNumber': string;
    /**
     *
     * @type {string}
     * @memberof CreateProfileDto
     */
    'gender': string;
    /**
     *
     * @type {string}
     * @memberof CreateProfileDto
     */
    'description'?: string;
}
/**
 *
 * @export
 * @interface CreateRatingDto
 */
export interface CreateRatingDto {
    /**
     * Visit ID being rated
     * @type {string}
     * @memberof CreateRatingDto
     */
    'visitId': string;
    /**
     * Rating for the professional (1-5 stars)
     * @type {number}
     * @memberof CreateRatingDto
     */
    'professionalRating': number;
    /**
     * Rating for the organization (1-5 stars)
     * @type {number}
     * @memberof CreateRatingDto
     */
    'organizationRating': number;
    /**
     * Optional review text
     * @type {string}
     * @memberof CreateRatingDto
     */
    'review'?: string;
}
/**
 *
 * @export
 * @interface CreateReceptionClosureDto
 */
export interface CreateReceptionClosureDto {
    /**
     *
     * @type {number}
     * @memberof CreateReceptionClosureDto
     */
    'expectedPublishedRevision': number;
    /**
     *
     * @type {string}
     * @memberof CreateReceptionClosureDto
     */
    'startsAt': string;
    /**
     *
     * @type {string}
     * @memberof CreateReceptionClosureDto
     */
    'endsAt': string;
    /**
     *
     * @type {string}
     * @memberof CreateReceptionClosureDto
     */
    'reason': CreateReceptionClosureDtoReasonEnum;
}

export const CreateReceptionClosureDtoReasonEnum = {
    ManualClosure: 'MANUAL_CLOSURE',
    StaffUnavailable: 'STAFF_UNAVAILABLE',
    FacilityEvent: 'FACILITY_EVENT'
} as const;

export type CreateReceptionClosureDtoReasonEnum = typeof CreateReceptionClosureDtoReasonEnum[keyof typeof CreateReceptionClosureDtoReasonEnum];

/**
 *
 * @export
 * @interface CreateReceptionPolicyDraftDto
 */
export interface CreateReceptionPolicyDraftDto {
    /**
     *
     * @type {string}
     * @memberof CreateReceptionPolicyDraftDto
     */
    'note'?: string | null;
    /**
     *
     * @type {number}
     * @memberof CreateReceptionPolicyDraftDto
     */
    'expectedPublishedRevision': number;
    /**
     *
     * @type {string}
     * @memberof CreateReceptionPolicyDraftDto
     */
    'reason': CreateReceptionPolicyDraftDtoReasonEnum;
    /**
     *
     * @type {ReceptionPolicyContentDto}
     * @memberof CreateReceptionPolicyDraftDto
     */
    'content': ReceptionPolicyContentDto;
}

export const CreateReceptionPolicyDraftDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    PolicyUpdate: 'POLICY_UPDATE',
    FactsUpdate: 'FACTS_UPDATE',
    BookingPolicyUpdate: 'BOOKING_POLICY_UPDATE',
    ReceptionScheduleUpdate: 'RECEPTION_SCHEDULE_UPDATE',
    CallbackHandlerUpdate: 'CALLBACK_HANDLER_UPDATE',
    SafetyReferenceUpdate: 'SAFETY_REFERENCE_UPDATE',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type CreateReceptionPolicyDraftDtoReasonEnum = typeof CreateReceptionPolicyDraftDtoReasonEnum[keyof typeof CreateReceptionPolicyDraftDtoReasonEnum];

/**
 *
 * @export
 * @interface CreateReminderDto
 */
export interface CreateReminderDto {
    /**
     * Profile ID the reminder belongs to. Omit for guest visits (reminder is keyed by visitId only).
     * @type {string}
     * @memberof CreateReminderDto
     */
    'profileId'?: string;
    /**
     * Reminder description (max 250 characters)
     * @type {string}
     * @memberof CreateReminderDto
     */
    'description': string;
    /**
     * Date and time of the first (or only) notification
     * @type {string}
     * @memberof CreateReminderDto
     */
    'scheduledAt': string;
    /**
     * Recurrence type
     * @type {string}
     * @memberof CreateReminderDto
     */
    'recurrenceType': CreateReminderDtoRecurrenceTypeEnum;
    /**
     *
     * @type {CreateReminderDtoCustomRecurrence}
     * @memberof CreateReminderDto
     */
    'customRecurrence'?: CreateReminderDtoCustomRecurrence;
    /**
     * Notification channels (at least one required)
     * @type {Array<string>}
     * @memberof CreateReminderDto
     */
    'notificationChannels': Array<CreateReminderDtoNotificationChannelsEnum>;
    /**
     * Organization ID (when reminder is created in org context)
     * @type {string}
     * @memberof CreateReminderDto
     */
    'organizationId'?: string;
    /**
     * Medication ID this reminder is linked to
     * @type {string}
     * @memberof CreateReminderDto
     */
    'medicationId'?: string;
    /**
     * Treatment ID this reminder is linked to
     * @type {string}
     * @memberof CreateReminderDto
     */
    'treatmentId'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateReminderDto
     */
    'visitId'?: string;
}

export const CreateReminderDtoRecurrenceTypeEnum = {
    Single: 'SINGLE',
    Daily: 'DAILY',
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
    Custom: 'CUSTOM'
} as const;

export type CreateReminderDtoRecurrenceTypeEnum = typeof CreateReminderDtoRecurrenceTypeEnum[keyof typeof CreateReminderDtoRecurrenceTypeEnum];
export const CreateReminderDtoNotificationChannelsEnum = {
    Email: 'EMAIL',
    Sms: 'SMS'
} as const;

export type CreateReminderDtoNotificationChannelsEnum = typeof CreateReminderDtoNotificationChannelsEnum[keyof typeof CreateReminderDtoNotificationChannelsEnum];

/**
 * Custom recurrence config (required when recurrenceType is CUSTOM)
 * @export
 * @interface CreateReminderDtoCustomRecurrence
 */
export interface CreateReminderDtoCustomRecurrence {
    /**
     * Interval value
     * @type {number}
     * @memberof CreateReminderDtoCustomRecurrence
     */
    'every': number;
    /**
     * Interval unit
     * @type {string}
     * @memberof CreateReminderDtoCustomRecurrence
     */
    'unit': CreateReminderDtoCustomRecurrenceUnitEnum;
    /**
     * Day of week (0=Sun, 1=Mon, ..., 6=Sat)
     * @type {number}
     * @memberof CreateReminderDtoCustomRecurrence
     */
    'dayOfWeek'?: number;
    /**
     * Week of month for monthly recurrence
     * @type {string}
     * @memberof CreateReminderDtoCustomRecurrence
     */
    'weekOfMonth'?: CreateReminderDtoCustomRecurrenceWeekOfMonthEnum;
}

export const CreateReminderDtoCustomRecurrenceUnitEnum = {
    Hour: 'hour',
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const;

export type CreateReminderDtoCustomRecurrenceUnitEnum = typeof CreateReminderDtoCustomRecurrenceUnitEnum[keyof typeof CreateReminderDtoCustomRecurrenceUnitEnum];
export const CreateReminderDtoCustomRecurrenceWeekOfMonthEnum = {
    First: 'first',
    Second: 'second',
    Third: 'third',
    Fourth: 'fourth',
    Last: 'last'
} as const;

export type CreateReminderDtoCustomRecurrenceWeekOfMonthEnum = typeof CreateReminderDtoCustomRecurrenceWeekOfMonthEnum[keyof typeof CreateReminderDtoCustomRecurrenceWeekOfMonthEnum];

/**
 *
 * @export
 * @interface CreateSpecializationServiceDto
 */
export interface CreateSpecializationServiceDto {
    /**
     * Derived from visit type and prepayment. Legacy input is accepted for compatibility but cannot override the derived policy.
     * @type {string}
     * @memberof CreateSpecializationServiceDto
     */
    'paymentTiming'?: CreateSpecializationServiceDtoPaymentTimingEnum;
    /**
     * Organization approval is always AUTO_CONFIRM. Legacy input cannot override it.
     * @type {string}
     * @memberof CreateSpecializationServiceDto
     */
    'confirmationPolicy'?: CreateSpecializationServiceDtoConfirmationPolicyEnum;
    /**
     * Name of the service
     * @type {string}
     * @memberof CreateSpecializationServiceDto
     */
    'name': string;
    /**
     * Description of the service
     * @type {string}
     * @memberof CreateSpecializationServiceDto
     */
    'description'?: string;
    /**
     * Specialization ID this service belongs to
     * @type {string}
     * @memberof CreateSpecializationServiceDto
     */
    'specializationId': string;
    /**
     * Category of the service
     * @type {string}
     * @memberof CreateSpecializationServiceDto
     */
    'category': CreateSpecializationServiceDtoCategoryEnum;
    /**
     * Visit type this service is for
     * @type {string}
     * @memberof CreateSpecializationServiceDto
     */
    'visitType': CreateSpecializationServiceDtoVisitTypeEnum;
    /**
     * Default price for this service in PLN
     * @type {number}
     * @memberof CreateSpecializationServiceDto
     */
    'defaultPrice': number;
    /**
     * Default duration for this service in minutes
     * @type {number}
     * @memberof CreateSpecializationServiceDto
     */
    'defaultDuration': number;
    /**
     * Reservation fee in PLN charged online at booking. Onsite/mobile only; 0..defaultPrice. Omit/null for no fee.
     * @type {number}
     * @memberof CreateSpecializationServiceDto
     */
    'prepaidAmount'?: number;
}

export const CreateSpecializationServiceDtoPaymentTimingEnum = {
    AtFacility: 'AT_FACILITY',
    OnlineRequired: 'ONLINE_REQUIRED'
} as const;

export type CreateSpecializationServiceDtoPaymentTimingEnum = typeof CreateSpecializationServiceDtoPaymentTimingEnum[keyof typeof CreateSpecializationServiceDtoPaymentTimingEnum];
export const CreateSpecializationServiceDtoConfirmationPolicyEnum = {
    AutoConfirm: 'AUTO_CONFIRM',
    RequiresApproval: 'REQUIRES_APPROVAL'
} as const;

export type CreateSpecializationServiceDtoConfirmationPolicyEnum = typeof CreateSpecializationServiceDtoConfirmationPolicyEnum[keyof typeof CreateSpecializationServiceDtoConfirmationPolicyEnum];
export const CreateSpecializationServiceDtoCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type CreateSpecializationServiceDtoCategoryEnum = typeof CreateSpecializationServiceDtoCategoryEnum[keyof typeof CreateSpecializationServiceDtoCategoryEnum];
export const CreateSpecializationServiceDtoVisitTypeEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type CreateSpecializationServiceDtoVisitTypeEnum = typeof CreateSpecializationServiceDtoVisitTypeEnum[keyof typeof CreateSpecializationServiceDtoVisitTypeEnum];

/**
 *
 * @export
 * @interface CreateTemplateDto
 */
export interface CreateTemplateDto {
    /**
     * Template name
     * @type {string}
     * @memberof CreateTemplateDto
     */
    'name': string;
    /**
     * Template description
     * @type {string}
     * @memberof CreateTemplateDto
     */
    'description': string;
    /**
     * Template category - can be predefined (veterinarian, dietitian, behaviorist, physiotherapist) or custom
     * @type {string}
     * @memberof CreateTemplateDto
     */
    'category'?: string;
    /**
     * Template type
     * @type {string}
     * @memberof CreateTemplateDto
     */
    'templateType': CreateTemplateDtoTemplateTypeEnum;
    /**
     * Template content in markdown format
     * @type {string}
     * @memberof CreateTemplateDto
     */
    'content': string;
    /**
     * Whether the template is shared with other professionals
     * @type {boolean}
     * @memberof CreateTemplateDto
     */
    'isShared': boolean;
}

export const CreateTemplateDtoTemplateTypeEnum = {
    InitialAssessment: 'initial_assessment',
    FollowUp: 'follow_up',
    General: 'general',
    Surgery: 'surgery',
    Vaccination: 'vaccination',
    Emergency: 'emergency',
    Diagnostic: 'diagnostic',
    Prescription: 'prescription',
    Discharge: 'discharge',
    Checkup: 'checkup'
} as const;

export type CreateTemplateDtoTemplateTypeEnum = typeof CreateTemplateDtoTemplateTypeEnum[keyof typeof CreateTemplateDtoTemplateTypeEnum];

/**
 *
 * @export
 * @interface CreateTermsConditionsDto
 */
export interface CreateTermsConditionsDto {
    /**
     * Version number (incremental)
     * @type {number}
     * @memberof CreateTermsConditionsDto
     */
    'version': number;
    /**
     * URL to the terms and conditions document
     * @type {string}
     * @memberof CreateTermsConditionsDto
     */
    'pageLink'?: string;
    /**
     * Markdown content of the terms and conditions
     * @type {string}
     * @memberof CreateTermsConditionsDto
     */
    'content'?: string;
    /**
     * Type of terms: USER or PROFESSIONAL
     * @type {string}
     * @memberof CreateTermsConditionsDto
     */
    'type': CreateTermsConditionsDtoTypeEnum;
    /**
     * Document category: TERMS_CONDITIONS or PRIVACY_POLICY
     * @type {string}
     * @memberof CreateTermsConditionsDto
     */
    'documentCategory'?: CreateTermsConditionsDtoDocumentCategoryEnum;
}

export const CreateTermsConditionsDtoTypeEnum = {
    User: 'USER',
    Professional: 'PROFESSIONAL'
} as const;

export type CreateTermsConditionsDtoTypeEnum = typeof CreateTermsConditionsDtoTypeEnum[keyof typeof CreateTermsConditionsDtoTypeEnum];
export const CreateTermsConditionsDtoDocumentCategoryEnum = {
    TermsConditions: 'TERMS_CONDITIONS',
    PrivacyPolicy: 'PRIVACY_POLICY'
} as const;

export type CreateTermsConditionsDtoDocumentCategoryEnum = typeof CreateTermsConditionsDtoDocumentCategoryEnum[keyof typeof CreateTermsConditionsDtoDocumentCategoryEnum];

/**
 *
 * @export
 * @interface CreateTextNoteDto
 */
export interface CreateTextNoteDto {
    /**
     * Text note body (HTML from the editor).
     * @type {string}
     * @memberof CreateTextNoteDto
     */
    'content': string;
}
/**
 *
 * @export
 * @interface CreateTreatmentDto
 */
export interface CreateTreatmentDto {
    /**
     * Treatment name
     * @type {string}
     * @memberof CreateTreatmentDto
     */
    'name': string;
    /**
     * Treatment description
     * @type {string}
     * @memberof CreateTreatmentDto
     */
    'description'?: string;
    /**
     * Net price (without VAT)
     * @type {number}
     * @memberof CreateTreatmentDto
     */
    'priceNetto'?: number;
    /**
     * Gross price (with VAT)
     * @type {number}
     * @memberof CreateTreatmentDto
     */
    'priceBrutto'?: number;
    /**
     * VAT rate percentage
     * @type {number}
     * @memberof CreateTreatmentDto
     */
    'vatRate'?: number;
    /**
     * Whether the treatment is active
     * @type {boolean}
     * @memberof CreateTreatmentDto
     */
    'isActive'?: boolean;
    /**
     * Medicines associated with this treatment
     * @type {Array<AssociatedMedicineDto>}
     * @memberof CreateTreatmentDto
     */
    'associatedMedicines'?: Array<AssociatedMedicineDto>;
    /**
     * Default non-drug materials used by this treatment
     * @type {Array<TreatmentMaterialInputDto>}
     * @memberof CreateTreatmentDto
     */
    'defaultMaterials'?: Array<TreatmentMaterialInputDto>;
}
/**
 *
 * @export
 * @interface CreateUserDto
 */
export interface CreateUserDto {
    /**
     *
     * @type {string}
     * @memberof CreateUserDto
     */
    'firstName': string;
    /**
     *
     * @type {string}
     * @memberof CreateUserDto
     */
    'middleName'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateUserDto
     */
    'lastName': string;
    /**
     *
     * @type {string}
     * @memberof CreateUserDto
     */
    'email'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateUserDto
     */
    'phoneNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateUserDto
     */
    'dob'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateUserDto
     */
    'avatar'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateUserDto
     */
    'address'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateUserDto
     */
    'city'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateUserDto
     */
    'zip'?: string;
    /**
     *
     * @type {boolean}
     * @memberof CreateUserDto
     */
    'marketing'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CreateUserDto
     */
    'terms': boolean;
}
/**
 *
 * @export
 * @interface CreateWarehouseAdjustmentDto
 */
export interface CreateWarehouseAdjustmentDto {
    /**
     *
     * @type {string}
     * @memberof CreateWarehouseAdjustmentDto
     */
    'productId': string;
    /**
     *
     * @type {WarehouseAdjustmentDirection}
     * @memberof CreateWarehouseAdjustmentDto
     */
    'direction': WarehouseAdjustmentDirection;
    /**
     * Positive quantity in the chosen measure, at most 3 decimals
     * @type {number}
     * @memberof CreateWarehouseAdjustmentDto
     */
    'quantity': number;
    /**
     *
     * @type {WarehouseQuantityMeasure}
     * @memberof CreateWarehouseAdjustmentDto
     */
    'measure': WarehouseQuantityMeasure;
    /**
     *
     * @type {WarehouseAdjustmentReason}
     * @memberof CreateWarehouseAdjustmentDto
     */
    'reason': WarehouseAdjustmentReason;
    /**
     *
     * @type {string}
     * @memberof CreateWarehouseAdjustmentDto
     */
    'note'?: string;
    /**
     * Existing batch to take from or add to (drugs only)
     * @type {string}
     * @memberof CreateWarehouseAdjustmentDto
     */
    'batchId'?: string;
    /**
     * New batch for a drug increase
     * @type {string}
     * @memberof CreateWarehouseAdjustmentDto
     */
    'batchNumber'?: string;
    /**
     * YYYY-MM-DD, new batch expiry for a drug increase
     * @type {string}
     * @memberof CreateWarehouseAdjustmentDto
     */
    'expiryDate'?: string;
    /**
     * YYYY-MM-DD; defaults to today in Warsaw
     * @type {string}
     * @memberof CreateWarehouseAdjustmentDto
     */
    'documentDate'?: string;
    /**
     * Client-generated UUID v4, kept across retries of the same submit. A replay with the same data returns the stored result; different data under the same key is 409 OPERATION_KEY_REUSED.
     * @type {string}
     * @memberof CreateWarehouseAdjustmentDto
     */
    'operationKey': string;
}


/**
 *
 * @export
 * @interface CreateWarehouseDemandRequestBatchDto
 */
export interface CreateWarehouseDemandRequestBatchDto {
    /**
     * Client-generated UUID v4, kept across retries of the same submit. A replay with the same data returns the stored result; different data under the same key is 409 OPERATION_KEY_REUSED.
     * @type {string}
     * @memberof CreateWarehouseDemandRequestBatchDto
     */
    'operationKey': string;
    /**
     * Wspólna uwaga, zapisana przy każdym zapotrzebowaniu.
     * @type {string}
     * @memberof CreateWarehouseDemandRequestBatchDto
     */
    'note'?: string;
    /**
     *
     * @type {Array<CreateWarehouseDemandRequestLineDto>}
     * @memberof CreateWarehouseDemandRequestBatchDto
     */
    'lines': Array<CreateWarehouseDemandRequestLineDto>;
}
/**
 *
 * @export
 * @interface CreateWarehouseDemandRequestDto
 */
export interface CreateWarehouseDemandRequestDto {
    /**
     * Produkt z magazynu. Podaj albo productId, albo requestedName.
     * @type {string}
     * @memberof CreateWarehouseDemandRequestDto
     */
    'productId'?: string;
    /**
     * Nazwa produktu spoza magazynu.
     * @type {string}
     * @memberof CreateWarehouseDemandRequestDto
     */
    'requestedName'?: string;
    /**
     * Ilość w jednostce z pola measure; dla produktu spoza magazynu w opakowaniach.
     * @type {number}
     * @memberof CreateWarehouseDemandRequestDto
     */
    'quantity'?: number;
    /**
     *
     * @type {WarehouseQuantityMeasure}
     * @memberof CreateWarehouseDemandRequestDto
     */
    'measure'?: WarehouseQuantityMeasure;
    /**
     * Client-generated UUID v4, kept across retries of the same submit. A replay with the same data returns the stored result; different data under the same key is 409 OPERATION_KEY_REUSED.
     * @type {string}
     * @memberof CreateWarehouseDemandRequestDto
     */
    'operationKey'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateWarehouseDemandRequestDto
     */
    'note'?: string;
}


/**
 *
 * @export
 * @interface CreateWarehouseDemandRequestLineDto
 */
export interface CreateWarehouseDemandRequestLineDto {
    /**
     * Produkt z magazynu. Podaj albo productId, albo requestedName.
     * @type {string}
     * @memberof CreateWarehouseDemandRequestLineDto
     */
    'productId'?: string;
    /**
     * Nazwa produktu spoza magazynu.
     * @type {string}
     * @memberof CreateWarehouseDemandRequestLineDto
     */
    'requestedName'?: string;
    /**
     * Ilość w jednostce z pola measure; dla produktu spoza magazynu w opakowaniach.
     * @type {number}
     * @memberof CreateWarehouseDemandRequestLineDto
     */
    'quantity'?: number;
    /**
     *
     * @type {WarehouseQuantityMeasure}
     * @memberof CreateWarehouseDemandRequestLineDto
     */
    'measure'?: WarehouseQuantityMeasure;
}


/**
 *
 * @export
 * @interface CreateWarehouseProductDto
 */
export interface CreateWarehouseProductDto {
    /**
     *
     * @type {WarehouseProductKind}
     * @memberof CreateWarehouseProductDto
     */
    'kind': WarehouseProductKind;
    /**
     *
     * @type {string}
     * @memberof CreateWarehouseProductDto
     */
    'name': string;
    /**
     * Medicine.productId from the RPL registry
     * @type {string}
     * @memberof CreateWarehouseProductDto
     */
    'medicineProductId'?: string;
    /**
     *
     * @type {boolean}
     * @memberof CreateWarehouseProductDto
     */
    'isRx'?: boolean;
    /**
     *
     * @type {WarehouseControlledCategory}
     * @memberof CreateWarehouseProductDto
     */
    'controlledCategory'?: WarehouseControlledCategory;
    /**
     *
     * @type {WarehouseUnit}
     * @memberof CreateWarehouseProductDto
     */
    'unit': WarehouseUnit;
    /**
     * Required when unit is OTHER
     * @type {string}
     * @memberof CreateWarehouseProductDto
     */
    'unitCustom'?: string;
    /**
     *
     * @type {number}
     * @memberof CreateWarehouseProductDto
     */
    'unitsPerPackage': number;
    /**
     *
     * @type {WarehouseDispenseMode}
     * @memberof CreateWarehouseProductDto
     */
    'dispenseMode'?: WarehouseDispenseMode;
    /**
     * Gross sale price of one package, grosze
     * @type {number}
     * @memberof CreateWarehouseProductDto
     */
    'packagePriceGrossMinor': number;
    /**
     * Gross sale price of one Unit; derived from the package price when absent
     * @type {number}
     * @memberof CreateWarehouseProductDto
     */
    'unitPriceGrossMinor'?: number;
    /**
     *
     * @type {WarehouseVatRate}
     * @memberof CreateWarehouseProductDto
     */
    'vatRate': WarehouseVatRate;
    /**
     * Minimum stock in minStockMeasure (≤3 decimals)
     * @type {number}
     * @memberof CreateWarehouseProductDto
     */
    'minStockQuantity'?: number;
    /**
     *
     * @type {WarehouseQuantityMeasure}
     * @memberof CreateWarehouseProductDto
     */
    'minStockMeasure'?: WarehouseQuantityMeasure;
    /**
     * Required for Rx drugs (MA_HOLDER_REQUIRED)
     * @type {string}
     * @memberof CreateWarehouseProductDto
     */
    'marketingAuthorisationNumber'?: string;
    /**
     * Podmiot odpowiedzialny; required for Rx drugs (MA_HOLDER_REQUIRED)
     * @type {string}
     * @memberof CreateWarehouseProductDto
     */
    'marketingAuthorisationHolder'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateWarehouseProductDto
     */
    'withdrawalPeriod'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateWarehouseProductDto
     */
    'form'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateWarehouseProductDto
     */
    'strength'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateWarehouseProductDto
     */
    'gtin'?: string;
}


/**
 *
 * @export
 * @interface CreateWarehouseReceiptDto
 */
export interface CreateWarehouseReceiptDto {
    /**
     * Business date, YYYY-MM-DD
     * @type {string}
     * @memberof CreateWarehouseReceiptDto
     */
    'documentDate': string;
    /**
     * Required to approve a PZ; ignored on a BO
     * @type {string}
     * @memberof CreateWarehouseReceiptDto
     */
    'supplierId'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateWarehouseReceiptDto
     */
    'supplierInvoiceNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateWarehouseReceiptDto
     */
    'note'?: string;
    /**
     *
     * @type {Array<WarehouseReceiptLineInputDto>}
     * @memberof CreateWarehouseReceiptDto
     */
    'lines': Array<WarehouseReceiptLineInputDto>;
    /**
     * PZ (supplier receipt) or BO (opening stock)
     * @type {string}
     * @memberof CreateWarehouseReceiptDto
     */
    'type': CreateWarehouseReceiptDtoTypeEnum;
}

export const CreateWarehouseReceiptDtoTypeEnum = {
    Pz: 'PZ',
    Bo: 'BO'
} as const;

export type CreateWarehouseReceiptDtoTypeEnum = typeof CreateWarehouseReceiptDtoTypeEnum[keyof typeof CreateWarehouseReceiptDtoTypeEnum];

/**
 *
 * @export
 * @interface CreateWarehouseSaleDto
 */
export interface CreateWarehouseSaleDto {
    /**
     * Client-generated UUID v4, kept across retries of the same submit. A replay with the same data returns the stored result; different data under the same key is 409 OPERATION_KEY_REUSED.
     * @type {string}
     * @memberof CreateWarehouseSaleDto
     */
    'operationKey': string;
    /**
     *
     * @type {Array<CreateWarehouseSaleLineDto>}
     * @memberof CreateWarehouseSaleDto
     */
    'lines': Array<CreateWarehouseSaleLineDto>;
    /**
     *
     * @type {string}
     * @memberof CreateWarehouseSaleDto
     */
    'buyerName'?: string;
    /**
     * Visit of the same organization
     * @type {string}
     * @memberof CreateWarehouseSaleDto
     */
    'visitId'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateWarehouseSaleDto
     */
    'note'?: string;
}
/**
 *
 * @export
 * @interface CreateWarehouseSaleLineDto
 */
export interface CreateWarehouseSaleLineDto {
    /**
     * Warehouse Product id; Rx Products are refused
     * @type {string}
     * @memberof CreateWarehouseSaleLineDto
     */
    'productId': string;
    /**
     * Quantity in `measure`, at most 3 decimal places
     * @type {number}
     * @memberof CreateWarehouseSaleLineDto
     */
    'quantity': number;
    /**
     *
     * @type {WarehouseQuantityMeasure}
     * @memberof CreateWarehouseSaleLineDto
     */
    'measure': WarehouseQuantityMeasure;
    /**
     * Gross price in grosze of one item of `measure` (one package or one Unit)
     * @type {number}
     * @memberof CreateWarehouseSaleLineDto
     */
    'unitPriceGrossMinor': number;
    /**
     * Pinned Batch id (drug lines only); FEFO when absent
     * @type {string}
     * @memberof CreateWarehouseSaleLineDto
     */
    'batchId'?: string;
}


/**
 *
 * @export
 * @interface CreateWarehouseSupplierDto
 */
export interface CreateWarehouseSupplierDto {
    /**
     *
     * @type {string}
     * @memberof CreateWarehouseSupplierDto
     */
    'name': string;
    /**
     * 10 digits; spaces and dashes are ignored
     * @type {string}
     * @memberof CreateWarehouseSupplierDto
     */
    'nip'?: string;
    /**
     *
     * @type {CreateWarehouseSupplierDtoAddress}
     * @memberof CreateWarehouseSupplierDto
     */
    'address'?: CreateWarehouseSupplierDtoAddress;
}
/**
 * Required before a PZ from this supplier can be approved
 * @export
 * @interface CreateWarehouseSupplierDtoAddress
 */
export interface CreateWarehouseSupplierDtoAddress {
    /**
     *
     * @type {string}
     * @memberof CreateWarehouseSupplierDtoAddress
     */
    'street': string;
    /**
     *
     * @type {string}
     * @memberof CreateWarehouseSupplierDtoAddress
     */
    'postalCode': string;
    /**
     *
     * @type {string}
     * @memberof CreateWarehouseSupplierDtoAddress
     */
    'city': string;
}
/**
 *
 * @export
 * @interface CreateWebinarDto
 */
export interface CreateWebinarDto {
    /**
     *
     * @type {string}
     * @memberof CreateWebinarDto
     */
    'title': string;
    /**
     *
     * @type {string}
     * @memberof CreateWebinarDto
     */
    'description': string;
    /**
     *
     * @type {string}
     * @memberof CreateWebinarDto
     */
    'slug': string;
    /**
     *
     * @type {string}
     * @memberof CreateWebinarDto
     */
    'startsAt': string;
    /**
     *
     * @type {number}
     * @memberof CreateWebinarDto
     */
    'durationMinutes': number;
    /**
     * Liczba miejsc dla uczestników, bez prowadzących i rejestratora.
     * @type {number}
     * @memberof CreateWebinarDto
     */
    'capacity': number;
    /**
     *
     * @type {Array<string>}
     * @memberof CreateWebinarDto
     */
    'presenterIds': Array<string>;
    /**
     * Główny prowadzący uprawniony do zarządzania nagrywaniem. Musi należeć do listy prowadzących.
     * @type {string}
     * @memberof CreateWebinarDto
     */
    'mainPresenterId'?: string | null;
    /**
     * Moderatorzy zatwierdzają wiadomości czatu publicznego. Nie mają kamery, mikrofonu ani udostępniania ekranu.
     * @type {Array<string>}
     * @memberof CreateWebinarDto
     */
    'moderatorIds'?: Array<string>;
}
/**
 *
 * @export
 * @interface CreateWebinarRehearsalInvitationDto
 */
export interface CreateWebinarRehearsalInvitationDto {
    /**
     *
     * @type {string}
     * @memberof CreateWebinarRehearsalInvitationDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof CreateWebinarRehearsalInvitationDto
     */
    'role': CreateWebinarRehearsalInvitationDtoRoleEnum;
}

export const CreateWebinarRehearsalInvitationDtoRoleEnum = {
    Host: 'host',
    Guest: 'guest',
    Moderator: 'moderator',
    Attendee: 'attendee'
} as const;

export type CreateWebinarRehearsalInvitationDtoRoleEnum = typeof CreateWebinarRehearsalInvitationDtoRoleEnum[keyof typeof CreateWebinarRehearsalInvitationDtoRoleEnum];

/**
 *
 * @export
 * @interface CreateWebinarStaffInvitationDto
 */
export interface CreateWebinarStaffInvitationDto {
    /**
     *
     * @type {string}
     * @memberof CreateWebinarStaffInvitationDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof CreateWebinarStaffInvitationDto
     */
    'email': string;
    /**
     *
     * @type {string}
     * @memberof CreateWebinarStaffInvitationDto
     */
    'role': CreateWebinarStaffInvitationDtoRoleEnum;
}

export const CreateWebinarStaffInvitationDtoRoleEnum = {
    Host: 'host',
    Guest: 'guest',
    Moderator: 'moderator'
} as const;

export type CreateWebinarStaffInvitationDtoRoleEnum = typeof CreateWebinarStaffInvitationDtoRoleEnum[keyof typeof CreateWebinarStaffInvitationDtoRoleEnum];

/**
 *
 * @export
 * @interface CurrentVoicePlatformCapabilitiesResponseDto
 */
export interface CurrentVoicePlatformCapabilitiesResponseDto {
    /**
     *
     * @type {Array<string>}
     * @memberof CurrentVoicePlatformCapabilitiesResponseDto
     */
    'capabilities': Array<CurrentVoicePlatformCapabilitiesResponseDtoCapabilitiesEnum>;
}

export const CurrentVoicePlatformCapabilitiesResponseDtoCapabilitiesEnum = {
    ProductPublisher: 'VOICE_PRODUCT_PUBLISHER',
    Operations: 'VOICE_OPERATIONS',
    PrivacyReviewer: 'VOICE_PRIVACY_REVIEWER',
    SafetyReviewer: 'VOICE_SAFETY_REVIEWER',
    IncidentCommander: 'VOICE_INCIDENT_COMMANDER'
} as const;

export type CurrentVoicePlatformCapabilitiesResponseDtoCapabilitiesEnum = typeof CurrentVoicePlatformCapabilitiesResponseDtoCapabilitiesEnum[keyof typeof CurrentVoicePlatformCapabilitiesResponseDtoCapabilitiesEnum];

/**
 *
 * @export
 * @interface CustomRecurrenceDto
 */
export interface CustomRecurrenceDto {
    /**
     * Interval value
     * @type {number}
     * @memberof CustomRecurrenceDto
     */
    'every': number;
    /**
     * Interval unit
     * @type {string}
     * @memberof CustomRecurrenceDto
     */
    'unit': CustomRecurrenceDtoUnitEnum;
    /**
     * Day of week (0=Sun, 1=Mon, ..., 6=Sat)
     * @type {number}
     * @memberof CustomRecurrenceDto
     */
    'dayOfWeek'?: number;
    /**
     * Week of month for monthly recurrence
     * @type {string}
     * @memberof CustomRecurrenceDto
     */
    'weekOfMonth'?: CustomRecurrenceDtoWeekOfMonthEnum;
}

export const CustomRecurrenceDtoUnitEnum = {
    Hour: 'hour',
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const;

export type CustomRecurrenceDtoUnitEnum = typeof CustomRecurrenceDtoUnitEnum[keyof typeof CustomRecurrenceDtoUnitEnum];
export const CustomRecurrenceDtoWeekOfMonthEnum = {
    First: 'first',
    Second: 'second',
    Third: 'third',
    Fourth: 'fourth',
    Last: 'last'
} as const;

export type CustomRecurrenceDtoWeekOfMonthEnum = typeof CustomRecurrenceDtoWeekOfMonthEnum[keyof typeof CustomRecurrenceDtoWeekOfMonthEnum];

/**
 *
 * @export
 * @interface CustomerDto
 */
export interface CustomerDto {
    /**
     *
     * @type {string}
     * @memberof CustomerDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof CustomerDto
     */
    'logoUrl': string;
    /**
     *
     * @type {string}
     * @memberof CustomerDto
     */
    'link': string;
}
/**
 *
 * @export
 * @interface DeleteOrganizationAvailabilityDto
 */
export interface DeleteOrganizationAvailabilityDto {
    /**
     * Success message
     * @type {string}
     * @memberof DeleteOrganizationAvailabilityDto
     */
    'message': string;
}
/**
 *
 * @export
 * @interface DocumentFileDto
 */
export interface DocumentFileDto {
    /**
     * Proof returned by the upload endpoint for attaching a new file
     * @type {string}
     * @memberof DocumentFileDto
     */
    'uploadToken'?: string;
    /**
     *
     * @type {string}
     * @memberof DocumentFileDto
     */
    'filename': string;
    /**
     *
     * @type {string}
     * @memberof DocumentFileDto
     */
    'url': string;
    /**
     *
     * @type {string}
     * @memberof DocumentFileDto
     */
    'originalFilename'?: string;
}
/**
 *
 * @export
 * @interface DocumentFileEntryDto
 */
export interface DocumentFileEntryDto {
    /**
     * Proof returned by the upload endpoint for attaching a new file
     * @type {string}
     * @memberof DocumentFileEntryDto
     */
    'uploadToken'?: string;
    /**
     *
     * @type {string}
     * @memberof DocumentFileEntryDto
     */
    'filename'?: string;
    /**
     *
     * @type {string}
     * @memberof DocumentFileEntryDto
     */
    'url'?: string;
    /**
     *
     * @type {string}
     * @memberof DocumentFileEntryDto
     */
    'originalFilename'?: string;
}
/**
 *
 * @export
 * @interface DocumentFileResponseDto
 */
export interface DocumentFileResponseDto {
    /**
     *
     * @type {string}
     * @memberof DocumentFileResponseDto
     */
    'filename': string;
    /**
     *
     * @type {string}
     * @memberof DocumentFileResponseDto
     */
    'url': string;
    /**
     *
     * @type {string}
     * @memberof DocumentFileResponseDto
     */
    'originalFilename'?: string;
    /**
     *
     * @type {string}
     * @memberof DocumentFileResponseDto
     */
    'description'?: string;
    /**
     *
     * @type {string}
     * @memberof DocumentFileResponseDto
     */
    'visitId'?: string;
    /**
     *
     * @type {string}
     * @memberof DocumentFileResponseDto
     */
    'uploadedAt'?: string;
    /**
     * True when the caller is allowed to delete this document (owner of the profile or professional from the organization where the linked visit took place)
     * @type {boolean}
     * @memberof DocumentFileResponseDto
     */
    'canDelete'?: boolean;
    /**
     *
     * @type {string}
     * @memberof DocumentFileResponseDto
     */
    'documentType'?: DocumentFileResponseDtoDocumentTypeEnum;
    /**
     * Text-note body (HTML). Present for TEXT_NOTE documents.
     * @type {string}
     * @memberof DocumentFileResponseDto
     */
    'content'?: string;
}

export const DocumentFileResponseDtoDocumentTypeEnum = {
    File: 'FILE',
    TextNote: 'TEXT_NOTE'
} as const;

export type DocumentFileResponseDtoDocumentTypeEnum = typeof DocumentFileResponseDtoDocumentTypeEnum[keyof typeof DocumentFileResponseDtoDocumentTypeEnum];

/**
 *
 * @export
 * @interface EmergencyGuidanceCurrentProfessionalReviewResponseDto
 */
export interface EmergencyGuidanceCurrentProfessionalReviewResponseDto {
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceCurrentProfessionalReviewResponseDto
     */
    'pendingDraftId': string | null;
}
/**
 *
 * @export
 * @interface EmergencyGuidanceCurrentStatusResponseDto
 */
export interface EmergencyGuidanceCurrentStatusResponseDto {
    /**
     *
     * @type {boolean}
     * @memberof EmergencyGuidanceCurrentStatusResponseDto
     */
    'ready': boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof EmergencyGuidanceCurrentStatusResponseDto
     */
    'reasons': Array<EmergencyGuidanceCurrentStatusResponseDtoReasonsEnum>;
    /**
     *
     * @type {EmergencyGuidanceRevisionResponseDto}
     * @memberof EmergencyGuidanceCurrentStatusResponseDto
     */
    'current': EmergencyGuidanceRevisionResponseDto | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceCurrentStatusResponseDto
     */
    'checkedAt': string;
}

export const EmergencyGuidanceCurrentStatusResponseDtoReasonsEnum = {
    Missing: 'EMERGENCY_GUIDANCE_MISSING',
    PublishedRevisionUnavailable: 'EMERGENCY_GUIDANCE_PUBLISHED_REVISION_UNAVAILABLE',
    ApprovalExpired: 'EMERGENCY_GUIDANCE_APPROVAL_EXPIRED',
    ProfessionalApprovalInvalid: 'EMERGENCY_GUIDANCE_PROFESSIONAL_APPROVAL_INVALID',
    ManagementApprovalInvalid: 'EMERGENCY_GUIDANCE_MANAGEMENT_APPROVAL_INVALID',
    DestinationUnavailable: 'EMERGENCY_GUIDANCE_DESTINATION_UNAVAILABLE',
    DestinationInvalid: 'EMERGENCY_GUIDANCE_DESTINATION_INVALID',
    DestinationExpired: 'EMERGENCY_GUIDANCE_DESTINATION_EXPIRED',
    DestinationChanged: 'EMERGENCY_GUIDANCE_DESTINATION_CHANGED',
    ContentHashInvalid: 'EMERGENCY_GUIDANCE_CONTENT_HASH_INVALID',
    RenderedAssetInvalid: 'EMERGENCY_GUIDANCE_RENDERED_ASSET_INVALID'
} as const;

export type EmergencyGuidanceCurrentStatusResponseDtoReasonsEnum = typeof EmergencyGuidanceCurrentStatusResponseDtoReasonsEnum[keyof typeof EmergencyGuidanceCurrentStatusResponseDtoReasonsEnum];

/**
 *
 * @export
 * @interface EmergencyGuidanceDraftResponseDto
 */
export interface EmergencyGuidanceDraftResponseDto {
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {number}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'expectedPublishedRevision': number;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'guidance': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'destinationId': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'canonicalE164': string;
    /**
     *
     * @type {number}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'destinationRoutingRevision': number;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'destinationFingerprint': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'authorReferenceKind': EmergencyGuidanceDraftResponseDtoAuthorReferenceKindEnum;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'authorUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'authorPseudonym': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'authorErasedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'authorRole': EmergencyGuidanceDraftResponseDtoAuthorRoleEnum;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'reason': EmergencyGuidanceDraftResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'note': string | null;
    /**
     *
     * @type {number}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'rollbackOfRevision': number | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceDraftResponseDto
     */
    'retainUntil': string;
}

export const EmergencyGuidanceDraftResponseDtoAuthorReferenceKindEnum = {
    UserId: 'USER_ID',
    ErasedPseudonym: 'ERASED_PSEUDONYM'
} as const;

export type EmergencyGuidanceDraftResponseDtoAuthorReferenceKindEnum = typeof EmergencyGuidanceDraftResponseDtoAuthorReferenceKindEnum[keyof typeof EmergencyGuidanceDraftResponseDtoAuthorReferenceKindEnum];
export const EmergencyGuidanceDraftResponseDtoAuthorRoleEnum = {
    Owner: 'OWNER',
    Admin: 'ADMIN'
} as const;

export type EmergencyGuidanceDraftResponseDtoAuthorRoleEnum = typeof EmergencyGuidanceDraftResponseDtoAuthorRoleEnum[keyof typeof EmergencyGuidanceDraftResponseDtoAuthorRoleEnum];
export const EmergencyGuidanceDraftResponseDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    GuidanceUpdate: 'GUIDANCE_UPDATE',
    DestinationUpdate: 'DESTINATION_UPDATE',
    PeriodicReapproval: 'PERIODIC_REAPPROVAL',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type EmergencyGuidanceDraftResponseDtoReasonEnum = typeof EmergencyGuidanceDraftResponseDtoReasonEnum[keyof typeof EmergencyGuidanceDraftResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface EmergencyGuidanceHistoryResponseDto
 */
export interface EmergencyGuidanceHistoryResponseDto {
    /**
     *
     * @type {EmergencyGuidanceRevisionResponseDto}
     * @memberof EmergencyGuidanceHistoryResponseDto
     */
    'current': EmergencyGuidanceRevisionResponseDto | null;
    /**
     *
     * @type {Array<EmergencyGuidanceRevisionResponseDto>}
     * @memberof EmergencyGuidanceHistoryResponseDto
     */
    'published': Array<EmergencyGuidanceRevisionResponseDto>;
    /**
     *
     * @type {Array<EmergencyGuidanceDraftResponseDto>}
     * @memberof EmergencyGuidanceHistoryResponseDto
     */
    'drafts': Array<EmergencyGuidanceDraftResponseDto>;
}
/**
 *
 * @export
 * @interface EmergencyGuidanceManagementApprovalResponseDto
 */
export interface EmergencyGuidanceManagementApprovalResponseDto {
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceManagementApprovalResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceManagementApprovalResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceManagementApprovalResponseDto
     */
    'draftId': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceManagementApprovalResponseDto
     */
    'approverReferenceKind': EmergencyGuidanceManagementApprovalResponseDtoApproverReferenceKindEnum;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceManagementApprovalResponseDto
     */
    'approverUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceManagementApprovalResponseDto
     */
    'approverPseudonym': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceManagementApprovalResponseDto
     */
    'approverErasedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceManagementApprovalResponseDto
     */
    'approverRole': EmergencyGuidanceManagementApprovalResponseDtoApproverRoleEnum;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceManagementApprovalResponseDto
     */
    'approvedAt': string;
}

export const EmergencyGuidanceManagementApprovalResponseDtoApproverReferenceKindEnum = {
    UserId: 'USER_ID',
    ErasedPseudonym: 'ERASED_PSEUDONYM'
} as const;

export type EmergencyGuidanceManagementApprovalResponseDtoApproverReferenceKindEnum = typeof EmergencyGuidanceManagementApprovalResponseDtoApproverReferenceKindEnum[keyof typeof EmergencyGuidanceManagementApprovalResponseDtoApproverReferenceKindEnum];
export const EmergencyGuidanceManagementApprovalResponseDtoApproverRoleEnum = {
    Owner: 'OWNER',
    Admin: 'ADMIN'
} as const;

export type EmergencyGuidanceManagementApprovalResponseDtoApproverRoleEnum = typeof EmergencyGuidanceManagementApprovalResponseDtoApproverRoleEnum[keyof typeof EmergencyGuidanceManagementApprovalResponseDtoApproverRoleEnum];

/**
 *
 * @export
 * @interface EmergencyGuidancePendingDraftItemResponseDto
 */
export interface EmergencyGuidancePendingDraftItemResponseDto {
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidancePendingDraftItemResponseDto
     */
    'draftId': string;
    /**
     *
     * @type {number}
     * @memberof EmergencyGuidancePendingDraftItemResponseDto
     */
    'expectedPublishedRevision': number;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidancePendingDraftItemResponseDto
     */
    'state': EmergencyGuidancePendingDraftItemResponseDtoStateEnum;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidancePendingDraftItemResponseDto
     */
    'authorReferenceKind': EmergencyGuidancePendingDraftItemResponseDtoAuthorReferenceKindEnum;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidancePendingDraftItemResponseDto
     */
    'authorUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidancePendingDraftItemResponseDto
     */
    'authorPseudonym': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidancePendingDraftItemResponseDto
     */
    'authorErasedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidancePendingDraftItemResponseDto
     */
    'authorRole': EmergencyGuidancePendingDraftItemResponseDtoAuthorRoleEnum;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidancePendingDraftItemResponseDto
     */
    'reason': EmergencyGuidancePendingDraftItemResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidancePendingDraftItemResponseDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidancePendingDraftItemResponseDto
     */
    'safeReasonCode': EmergencyGuidancePendingDraftItemResponseDtoSafeReasonCodeEnum;
}

export const EmergencyGuidancePendingDraftItemResponseDtoStateEnum = {
    Pending: 'PENDING',
    Stale: 'STALE'
} as const;

export type EmergencyGuidancePendingDraftItemResponseDtoStateEnum = typeof EmergencyGuidancePendingDraftItemResponseDtoStateEnum[keyof typeof EmergencyGuidancePendingDraftItemResponseDtoStateEnum];
export const EmergencyGuidancePendingDraftItemResponseDtoAuthorReferenceKindEnum = {
    UserId: 'USER_ID',
    ErasedPseudonym: 'ERASED_PSEUDONYM'
} as const;

export type EmergencyGuidancePendingDraftItemResponseDtoAuthorReferenceKindEnum = typeof EmergencyGuidancePendingDraftItemResponseDtoAuthorReferenceKindEnum[keyof typeof EmergencyGuidancePendingDraftItemResponseDtoAuthorReferenceKindEnum];
export const EmergencyGuidancePendingDraftItemResponseDtoAuthorRoleEnum = {
    Owner: 'OWNER',
    Admin: 'ADMIN'
} as const;

export type EmergencyGuidancePendingDraftItemResponseDtoAuthorRoleEnum = typeof EmergencyGuidancePendingDraftItemResponseDtoAuthorRoleEnum[keyof typeof EmergencyGuidancePendingDraftItemResponseDtoAuthorRoleEnum];
export const EmergencyGuidancePendingDraftItemResponseDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    GuidanceUpdate: 'GUIDANCE_UPDATE',
    DestinationUpdate: 'DESTINATION_UPDATE',
    PeriodicReapproval: 'PERIODIC_REAPPROVAL',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type EmergencyGuidancePendingDraftItemResponseDtoReasonEnum = typeof EmergencyGuidancePendingDraftItemResponseDtoReasonEnum[keyof typeof EmergencyGuidancePendingDraftItemResponseDtoReasonEnum];
export const EmergencyGuidancePendingDraftItemResponseDtoSafeReasonCodeEnum = {
    EmergencyGuidanceHeadChanged: 'EMERGENCY_GUIDANCE_HEAD_CHANGED'
} as const;

export type EmergencyGuidancePendingDraftItemResponseDtoSafeReasonCodeEnum = typeof EmergencyGuidancePendingDraftItemResponseDtoSafeReasonCodeEnum[keyof typeof EmergencyGuidancePendingDraftItemResponseDtoSafeReasonCodeEnum];

/**
 *
 * @export
 * @interface EmergencyGuidancePendingDraftsResponseDto
 */
export interface EmergencyGuidancePendingDraftsResponseDto {
    /**
     *
     * @type {number}
     * @memberof EmergencyGuidancePendingDraftsResponseDto
     */
    'currentPublishedRevision': number;
    /**
     *
     * @type {Array<EmergencyGuidancePendingDraftItemResponseDto>}
     * @memberof EmergencyGuidancePendingDraftsResponseDto
     */
    'items': Array<EmergencyGuidancePendingDraftItemResponseDto>;
}
/**
 *
 * @export
 * @interface EmergencyGuidanceProfessionalReviewResponseDto
 */
export interface EmergencyGuidanceProfessionalReviewResponseDto {
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceProfessionalReviewResponseDto
     */
    'id': string;
    /**
     *
     * @type {number}
     * @memberof EmergencyGuidanceProfessionalReviewResponseDto
     */
    'expectedPublishedRevision': number;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceProfessionalReviewResponseDto
     */
    'guidance': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceProfessionalReviewResponseDto
     */
    'destinationId': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceProfessionalReviewResponseDto
     */
    'canonicalE164': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceProfessionalReviewResponseDto
     */
    'managementApproverRole': EmergencyGuidanceProfessionalReviewResponseDtoManagementApproverRoleEnum;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceProfessionalReviewResponseDto
     */
    'managementApprovedAt': string;
}

export const EmergencyGuidanceProfessionalReviewResponseDtoManagementApproverRoleEnum = {
    Owner: 'OWNER',
    Admin: 'ADMIN'
} as const;

export type EmergencyGuidanceProfessionalReviewResponseDtoManagementApproverRoleEnum = typeof EmergencyGuidanceProfessionalReviewResponseDtoManagementApproverRoleEnum[keyof typeof EmergencyGuidanceProfessionalReviewResponseDtoManagementApproverRoleEnum];

/**
 *
 * @export
 * @interface EmergencyGuidanceReferenceDto
 */
export interface EmergencyGuidanceReferenceDto {
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceReferenceDto
     */
    'revisionId': string;
    /**
     *
     * @type {number}
     * @memberof EmergencyGuidanceReferenceDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceReferenceDto
     */
    'destinationFingerprint': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceReferenceDto
     */
    'approvedUntil': string;
}
/**
 *
 * @export
 * @interface EmergencyGuidanceRevisionResponseDto
 */
export interface EmergencyGuidanceRevisionResponseDto {
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {number}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'guidance': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'contentSha256': string;
    /**
     *
     * @type {object}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'renderedAsset': object;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'destinationId': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'canonicalE164': string;
    /**
     *
     * @type {number}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'destinationRoutingRevision': number;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'destinationFingerprint': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'sourceDraftId': string;
    /**
     *
     * @type {number}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'rollbackOfRevision': number | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'authorReferenceKind': EmergencyGuidanceRevisionResponseDtoAuthorReferenceKindEnum;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'authorUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'authorPseudonym': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'authorErasedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'authorRole': EmergencyGuidanceRevisionResponseDtoAuthorRoleEnum;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'managementApprovalId': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'managementApproverReferenceKind': EmergencyGuidanceRevisionResponseDtoManagementApproverReferenceKindEnum;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'managementApproverUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'managementApproverPseudonym': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'managementApproverErasedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'managementApproverRole': EmergencyGuidanceRevisionResponseDtoManagementApproverRoleEnum;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'managementApprovedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'approverReferenceKind': EmergencyGuidanceRevisionResponseDtoApproverReferenceKindEnum;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'approverUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'approverPseudonym': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'approverErasedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'professionalAssignmentId': string;
    /**
     *
     * @type {number}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'professionalAssignmentFence': number;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'reason': EmergencyGuidanceRevisionResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'note': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'approvedAt': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'approvedUntil': string;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'supersededAt': string | null;
    /**
     *
     * @type {string}
     * @memberof EmergencyGuidanceRevisionResponseDto
     */
    'retainUntil': string | null;
}

export const EmergencyGuidanceRevisionResponseDtoAuthorReferenceKindEnum = {
    UserId: 'USER_ID',
    ErasedPseudonym: 'ERASED_PSEUDONYM'
} as const;

export type EmergencyGuidanceRevisionResponseDtoAuthorReferenceKindEnum = typeof EmergencyGuidanceRevisionResponseDtoAuthorReferenceKindEnum[keyof typeof EmergencyGuidanceRevisionResponseDtoAuthorReferenceKindEnum];
export const EmergencyGuidanceRevisionResponseDtoAuthorRoleEnum = {
    Owner: 'OWNER',
    Admin: 'ADMIN'
} as const;

export type EmergencyGuidanceRevisionResponseDtoAuthorRoleEnum = typeof EmergencyGuidanceRevisionResponseDtoAuthorRoleEnum[keyof typeof EmergencyGuidanceRevisionResponseDtoAuthorRoleEnum];
export const EmergencyGuidanceRevisionResponseDtoManagementApproverReferenceKindEnum = {
    UserId: 'USER_ID',
    ErasedPseudonym: 'ERASED_PSEUDONYM'
} as const;

export type EmergencyGuidanceRevisionResponseDtoManagementApproverReferenceKindEnum = typeof EmergencyGuidanceRevisionResponseDtoManagementApproverReferenceKindEnum[keyof typeof EmergencyGuidanceRevisionResponseDtoManagementApproverReferenceKindEnum];
export const EmergencyGuidanceRevisionResponseDtoManagementApproverRoleEnum = {
    Owner: 'OWNER',
    Admin: 'ADMIN'
} as const;

export type EmergencyGuidanceRevisionResponseDtoManagementApproverRoleEnum = typeof EmergencyGuidanceRevisionResponseDtoManagementApproverRoleEnum[keyof typeof EmergencyGuidanceRevisionResponseDtoManagementApproverRoleEnum];
export const EmergencyGuidanceRevisionResponseDtoApproverReferenceKindEnum = {
    UserId: 'USER_ID',
    ErasedPseudonym: 'ERASED_PSEUDONYM'
} as const;

export type EmergencyGuidanceRevisionResponseDtoApproverReferenceKindEnum = typeof EmergencyGuidanceRevisionResponseDtoApproverReferenceKindEnum[keyof typeof EmergencyGuidanceRevisionResponseDtoApproverReferenceKindEnum];
export const EmergencyGuidanceRevisionResponseDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    GuidanceUpdate: 'GUIDANCE_UPDATE',
    DestinationUpdate: 'DESTINATION_UPDATE',
    PeriodicReapproval: 'PERIODIC_REAPPROVAL',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type EmergencyGuidanceRevisionResponseDtoReasonEnum = typeof EmergencyGuidanceRevisionResponseDtoReasonEnum[keyof typeof EmergencyGuidanceRevisionResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface EnrichPromptDto
 */
export interface EnrichPromptDto {
    /**
     * The query or prompt to enrich with document context
     * @type {string}
     * @memberof EnrichPromptDto
     */
    'query': string;
    /**
     * Profile ID to search documents for
     * @type {string}
     * @memberof EnrichPromptDto
     */
    'profileId': string;
    /**
     * Maximum number of document chunks to include
     * @type {number}
     * @memberof EnrichPromptDto
     */
    'maxDocuments'?: number;
    /**
     * Minimum similarity score (0-1) for including documents
     * @type {number}
     * @memberof EnrichPromptDto
     */
    'minSimilarity'?: number;
}
/**
 *
 * @export
 * @interface ExternalIdDto
 */
export interface ExternalIdDto {
    /**
     * Name of the external ID system
     * @type {string}
     * @memberof ExternalIdDto
     */
    'name': string;
    /**
     * Value of the external ID
     * @type {string}
     * @memberof ExternalIdDto
     */
    'value': string;
}
/**
 *
 * @export
 * @interface FacilityGreetingSelectionDto
 */
export interface FacilityGreetingSelectionDto {
    /**
     *
     * @type {string}
     * @memberof FacilityGreetingSelectionDto
     */
    'templateId': FacilityGreetingSelectionDtoTemplateIdEnum;
    /**
     *
     * @type {string}
     * @memberof FacilityGreetingSelectionDto
     */
    'salutation': FacilityGreetingSelectionDtoSalutationEnum;
}

export const FacilityGreetingSelectionDtoTemplateIdEnum = {
    FacilityWelcomeV1: 'FACILITY_WELCOME_V1'
} as const;

export type FacilityGreetingSelectionDtoTemplateIdEnum = typeof FacilityGreetingSelectionDtoTemplateIdEnum[keyof typeof FacilityGreetingSelectionDtoTemplateIdEnum];
export const FacilityGreetingSelectionDtoSalutationEnum = {
    DzienDobry: 'DZIEN_DOBRY',
    Witamy: 'WITAMY'
} as const;

export type FacilityGreetingSelectionDtoSalutationEnum = typeof FacilityGreetingSelectionDtoSalutationEnum[keyof typeof FacilityGreetingSelectionDtoSalutationEnum];

/**
 *
 * @export
 * @interface FactReadStatusDto
 */
export interface FactReadStatusDto {
    /**
     * ID of the fact to mark as read
     * @type {string}
     * @memberof FactReadStatusDto
     */
    'factId': string;
}
/**
 *
 * @export
 * @interface FieldResponseDto
 */
export interface FieldResponseDto {
    /**
     * ID of the form field being answered
     * @type {string}
     * @memberof FieldResponseDto
     */
    'fieldId': string;
    /**
     * Response value (string, string[], or boolean)
     * @type {object}
     * @memberof FieldResponseDto
     */
    'value': object;
    /**
     * Custom response text when allowCustomResponse is enabled
     * @type {string}
     * @memberof FieldResponseDto
     */
    'customValue'?: string;
}
/**
 *
 * @export
 * @interface FinalizeReceptionActivationDto
 */
export interface FinalizeReceptionActivationDto {
    /**
     *
     * @type {string}
     * @memberof FinalizeReceptionActivationDto
     */
    'releaseId': string;
}
/**
 *
 * @export
 * @interface FormFieldDto
 */
export interface FormFieldDto {
    /**
     * Field type
     * @type {string}
     * @memberof FormFieldDto
     */
    'type': FormFieldDtoTypeEnum;
    /**
     * Field label displayed to the user
     * @type {string}
     * @memberof FormFieldDto
     */
    'label': string;
    /**
     * Field description / helper text
     * @type {string}
     * @memberof FormFieldDto
     */
    'description'?: string;
    /**
     * Whether the field is required
     * @type {boolean}
     * @memberof FormFieldDto
     */
    'required': boolean;
    /**
     * Options for select/checkbox/radio fields
     * @type {Array<string>}
     * @memberof FormFieldDto
     */
    'options'?: Array<string>;
    /**
     * Whether multiple options can be selected (for select)
     * @type {boolean}
     * @memberof FormFieldDto
     */
    'allowMultiple'?: boolean;
    /**
     * Whether a custom response option is available (for checkbox/radio)
     * @type {boolean}
     * @memberof FormFieldDto
     */
    'allowCustomResponse'?: boolean;
    /**
     * Order of the field in the form
     * @type {number}
     * @memberof FormFieldDto
     */
    'order'?: number;
}

export const FormFieldDtoTypeEnum = {
    Text: 'text',
    Select: 'select',
    Checkbox: 'checkbox',
    Radio: 'radio',
    File: 'file'
} as const;

export type FormFieldDtoTypeEnum = typeof FormFieldDtoTypeEnum[keyof typeof FormFieldDtoTypeEnum];

/**
 *
 * @export
 * @interface ForwardRollbackEmergencyGuidanceDto
 */
export interface ForwardRollbackEmergencyGuidanceDto {
    /**
     *
     * @type {string}
     * @memberof ForwardRollbackEmergencyGuidanceDto
     */
    'note'?: string | null;
    /**
     *
     * @type {number}
     * @memberof ForwardRollbackEmergencyGuidanceDto
     */
    'sourcePublishedRevision': number;
    /**
     *
     * @type {number}
     * @memberof ForwardRollbackEmergencyGuidanceDto
     */
    'expectedPublishedRevision': number;
}
/**
 *
 * @export
 * @interface ForwardRollbackReceptionPolicyDto
 */
export interface ForwardRollbackReceptionPolicyDto {
    /**
     *
     * @type {string}
     * @memberof ForwardRollbackReceptionPolicyDto
     */
    'note'?: string | null;
    /**
     *
     * @type {number}
     * @memberof ForwardRollbackReceptionPolicyDto
     */
    'sourcePublishedRevision': number;
    /**
     *
     * @type {number}
     * @memberof ForwardRollbackReceptionPolicyDto
     */
    'expectedPublishedRevision': number;
}
/**
 *
 * @export
 * @interface GenerateKeywordsResponseDto
 */
export interface GenerateKeywordsResponseDto {
    /**
     *
     * @type {Array<string>}
     * @memberof GenerateKeywordsResponseDto
     */
    'keywords': Array<string>;
}
/**
 *
 * @export
 * @interface GenerateSuggestionRequestDto
 */
export interface GenerateSuggestionRequestDto {
    /**
     * Profile ID for which to generate a suggestion
     * @type {string}
     * @memberof GenerateSuggestionRequestDto
     */
    'profileId': string;
}
/**
 *
 * @export
 * @interface GenerateSuggestionResponseDto
 */
export interface GenerateSuggestionResponseDto {
    /**
     * ID of the generated suggestion
     * @type {string}
     * @memberof GenerateSuggestionResponseDto
     */
    'id': string;
    /**
     * Profile ID for which the suggestion was generated
     * @type {string}
     * @memberof GenerateSuggestionResponseDto
     */
    'profileId': string;
    /**
     *
     * @type {GenerateSuggestionResponseDtoSuggestion}
     * @memberof GenerateSuggestionResponseDto
     */
    'suggestion': GenerateSuggestionResponseDtoSuggestion;
    /**
     * Date when the suggestion was generated
     * @type {string}
     * @memberof GenerateSuggestionResponseDto
     */
    'generatedAt': string;
}
/**
 * Suggestion content including action items and recommendations
 * @export
 * @interface GenerateSuggestionResponseDtoSuggestion
 */
export interface GenerateSuggestionResponseDtoSuggestion {
    /**
     * List of action items
     * @type {Array<ActionItemDto>}
     * @memberof GenerateSuggestionResponseDtoSuggestion
     */
    'actionItems': Array<ActionItemDto>;
    /**
     * List of recommendations
     * @type {Array<RecommendationDto>}
     * @memberof GenerateSuggestionResponseDtoSuggestion
     */
    'recommendations': Array<RecommendationDto>;
}
/**
 *
 * @export
 * @interface GetAssociatedMedicineDto
 */
export interface GetAssociatedMedicineDto {
    /**
     * Line id, sent back on edit
     * @type {string}
     * @memberof GetAssociatedMedicineDto
     */
    'id'?: string;
    /**
     * Medicine product ID. Null for a medicine typed by hand.
     * @type {string}
     * @memberof GetAssociatedMedicineDto
     */
    'medicineProductId'?: string | null;
    /**
     * Medicine product name
     * @type {string}
     * @memberof GetAssociatedMedicineDto
     */
    'medicineName': string;
    /**
     * Dosage amount
     * @type {number}
     * @memberof GetAssociatedMedicineDto
     */
    'dosage'?: number | null;
    /**
     * Dosage interval
     * @type {string}
     * @memberof GetAssociatedMedicineDto
     */
    'dosageInterval'?: GetAssociatedMedicineDtoDosageIntervalEnum;
    /**
     * Administration notes
     * @type {string}
     * @memberof GetAssociatedMedicineDto
     */
    'notes'?: string | null;
    /**
     * Preparation type
     * @type {string}
     * @memberof GetAssociatedMedicineDto
     */
    'preparationType'?: string | null;
    /**
     * Warehouse Product id (clinic views only)
     * @type {string}
     * @memberof GetAssociatedMedicineDto
     */
    'productId'?: string;
    /**
     * Thousandths of a Unit
     * @type {number}
     * @memberof GetAssociatedMedicineDto
     */
    'quantityMilli'?: number;
    /**
     *
     * @type {WarehouseHandover}
     * @memberof GetAssociatedMedicineDto
     */
    'handover'?: WarehouseHandover;
    /**
     *
     * @type {boolean}
     * @memberof GetAssociatedMedicineDto
     */
    'prescriptionIssued'?: boolean;
    /**
     * Handed-over only: the supplied recipient
     * @type {string}
     * @memberof GetAssociatedMedicineDto
     */
    'recipientName'?: string;
    /**
     * Handed-over only: the supplied recipient\'s address
     * @type {string}
     * @memberof GetAssociatedMedicineDto
     */
    'recipientAddress'?: string;
}

export const GetAssociatedMedicineDtoDosageIntervalEnum = {
    Day: 'Day',
    Week: 'Week',
    Month: 'Month'
} as const;

export type GetAssociatedMedicineDtoDosageIntervalEnum = typeof GetAssociatedMedicineDtoDosageIntervalEnum[keyof typeof GetAssociatedMedicineDtoDosageIntervalEnum];

/**
 *
 * @export
 * @interface GetCampaignDto
 */
export interface GetCampaignDto {
    /**
     *
     * @type {string}
     * @memberof GetCampaignDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof GetCampaignDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof GetCampaignDto
     */
    'createdBy': string;
    /**
     *
     * @type {string}
     * @memberof GetCampaignDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof GetCampaignDto
     */
    'description'?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof GetCampaignDto
     */
    'keywords': Array<string>;
    /**
     *
     * @type {number}
     * @memberof GetCampaignDto
     */
    'dailyBudget': number;
    /**
     *
     * @type {number}
     * @memberof GetCampaignDto
     */
    'totalBudget': number;
    /**
     *
     * @type {string}
     * @memberof GetCampaignDto
     */
    'startDate': string;
    /**
     *
     * @type {string}
     * @memberof GetCampaignDto
     */
    'endDate': string;
    /**
     *
     * @type {Array<string>}
     * @memberof GetCampaignDto
     */
    'targetLocations': Array<string>;
    /**
     *
     * @type {string}
     * @memberof GetCampaignDto
     */
    'language': string;
    /**
     *
     * @type {string}
     * @memberof GetCampaignDto
     */
    'biddingStrategy': GetCampaignDtoBiddingStrategyEnum;
    /**
     *
     * @type {object}
     * @memberof GetCampaignDto
     */
    'networkSettings': object;
    /**
     *
     * @type {string}
     * @memberof GetCampaignDto
     */
    'status': GetCampaignDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof GetCampaignDto
     */
    'googleCampaignId'?: string;
    /**
     *
     * @type {string}
     * @memberof GetCampaignDto
     */
    'googleCustomerId'?: string;
    /**
     *
     * @type {string}
     * @memberof GetCampaignDto
     */
    'paymentId'?: string;
    /**
     *
     * @type {string}
     * @memberof GetCampaignDto
     */
    'promoCode'?: string;
    /**
     *
     * @type {number}
     * @memberof GetCampaignDto
     */
    'discountPercentage': number;
    /**
     *
     * @type {number}
     * @memberof GetCampaignDto
     */
    'discountAmount': number;
    /**
     *
     * @type {object}
     * @memberof GetCampaignDto
     */
    'metrics': object;
    /**
     *
     * @type {string}
     * @memberof GetCampaignDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof GetCampaignDto
     */
    'updatedAt': string;
}

export const GetCampaignDtoBiddingStrategyEnum = {
    TargetSpend: 'TARGET_SPEND',
    MaximizeConversions: 'MAXIMIZE_CONVERSIONS',
    ManualCpc: 'MANUAL_CPC',
    TargetCpa: 'TARGET_CPA',
    TargetRoas: 'TARGET_ROAS'
} as const;

export type GetCampaignDtoBiddingStrategyEnum = typeof GetCampaignDtoBiddingStrategyEnum[keyof typeof GetCampaignDtoBiddingStrategyEnum];
export const GetCampaignDtoStatusEnum = {
    Draft: 'DRAFT',
    PendingPayment: 'PENDING_PAYMENT',
    Active: 'ACTIVE',
    Paused: 'PAUSED',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED'
} as const;

export type GetCampaignDtoStatusEnum = typeof GetCampaignDtoStatusEnum[keyof typeof GetCampaignDtoStatusEnum];

/**
 *
 * @export
 * @interface GetCityDto
 */
export interface GetCityDto {
    /**
     * City name
     * @type {string}
     * @memberof GetCityDto
     */
    'name': string;
}
/**
 *
 * @export
 * @interface GetCouponsDto
 */
export interface GetCouponsDto {
    /**
     *
     * @type {string}
     * @memberof GetCouponsDto
     */
    'title': string;
    /**
     *
     * @type {string}
     * @memberof GetCouponsDto
     */
    'description': string;
    /**
     *
     * @type {CustomerDto}
     * @memberof GetCouponsDto
     */
    'customer': CustomerDto;
    /**
     *
     * @type {string}
     * @memberof GetCouponsDto
     */
    'code': string;
    /**
     *
     * @type {string}
     * @memberof GetCouponsDto
     */
    'endDate': string;
    /**
     *
     * @type {string}
     * @memberof GetCouponsDto
     */
    'discount'?: string;
}
/**
 *
 * @export
 * @interface GetCustomRecurrenceDto
 */
export interface GetCustomRecurrenceDto {
    /**
     * Interval value
     * @type {number}
     * @memberof GetCustomRecurrenceDto
     */
    'every': number;
    /**
     * Interval unit
     * @type {string}
     * @memberof GetCustomRecurrenceDto
     */
    'unit': GetCustomRecurrenceDtoUnitEnum;
    /**
     * Day of week (0=Sun, 1=Mon, ..., 6=Sat)
     * @type {number}
     * @memberof GetCustomRecurrenceDto
     */
    'dayOfWeek'?: number;
    /**
     * Week of month for monthly recurrence
     * @type {string}
     * @memberof GetCustomRecurrenceDto
     */
    'weekOfMonth'?: GetCustomRecurrenceDtoWeekOfMonthEnum;
}

export const GetCustomRecurrenceDtoUnitEnum = {
    Hour: 'hour',
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const;

export type GetCustomRecurrenceDtoUnitEnum = typeof GetCustomRecurrenceDtoUnitEnum[keyof typeof GetCustomRecurrenceDtoUnitEnum];
export const GetCustomRecurrenceDtoWeekOfMonthEnum = {
    First: 'first',
    Second: 'second',
    Third: 'third',
    Fourth: 'fourth',
    Last: 'last'
} as const;

export type GetCustomRecurrenceDtoWeekOfMonthEnum = typeof GetCustomRecurrenceDtoWeekOfMonthEnum[keyof typeof GetCustomRecurrenceDtoWeekOfMonthEnum];

/**
 *
 * @export
 * @interface GetFieldResponseDto
 */
export interface GetFieldResponseDto {
    /**
     * Form field ID
     * @type {string}
     * @memberof GetFieldResponseDto
     */
    'fieldId': string;
    /**
     * Response value
     * @type {object}
     * @memberof GetFieldResponseDto
     */
    'value': object;
    /**
     * Custom response text
     * @type {string}
     * @memberof GetFieldResponseDto
     */
    'customValue'?: string | null;
}
/**
 *
 * @export
 * @interface GetFormDto
 */
export interface GetFormDto {
    /**
     * Form ID
     * @type {string}
     * @memberof GetFormDto
     */
    'id': string;
    /**
     * Form name
     * @type {string}
     * @memberof GetFormDto
     */
    'name': string;
    /**
     * Form description
     * @type {string}
     * @memberof GetFormDto
     */
    'description'?: string;
    /**
     * Organization ID
     * @type {string}
     * @memberof GetFormDto
     */
    'organizationId': string;
    /**
     * Creator user ID
     * @type {string}
     * @memberof GetFormDto
     */
    'createdBy': string;
    /**
     * Form fields
     * @type {Array<GetFormFieldDto>}
     * @memberof GetFormDto
     */
    'fields': Array<GetFormFieldDto>;
    /**
     * Whether the form is active
     * @type {boolean}
     * @memberof GetFormDto
     */
    'isActive': boolean;
    /**
     * Creation date
     * @type {string}
     * @memberof GetFormDto
     */
    'createdAt': string;
    /**
     * Last update date
     * @type {string}
     * @memberof GetFormDto
     */
    'updatedAt': string;
}
/**
 *
 * @export
 * @interface GetFormFieldDto
 */
export interface GetFormFieldDto {
    /**
     * Field ID
     * @type {string}
     * @memberof GetFormFieldDto
     */
    'id': string;
    /**
     * Field type
     * @type {string}
     * @memberof GetFormFieldDto
     */
    'type': GetFormFieldDtoTypeEnum;
    /**
     * Field label
     * @type {string}
     * @memberof GetFormFieldDto
     */
    'label': string;
    /**
     * Field description
     * @type {string}
     * @memberof GetFormFieldDto
     */
    'description'?: string;
    /**
     * Whether the field is required
     * @type {boolean}
     * @memberof GetFormFieldDto
     */
    'required': boolean;
    /**
     * Options for select/checkbox/radio
     * @type {Array<string>}
     * @memberof GetFormFieldDto
     */
    'options'?: Array<string>;
    /**
     * Allow multiple selections
     * @type {boolean}
     * @memberof GetFormFieldDto
     */
    'allowMultiple'?: boolean;
    /**
     * Allow custom response
     * @type {boolean}
     * @memberof GetFormFieldDto
     */
    'allowCustomResponse'?: boolean;
    /**
     * Field order
     * @type {number}
     * @memberof GetFormFieldDto
     */
    'order': number;
}

export const GetFormFieldDtoTypeEnum = {
    Text: 'text',
    Select: 'select',
    Checkbox: 'checkbox',
    Radio: 'radio',
    File: 'file'
} as const;

export type GetFormFieldDtoTypeEnum = typeof GetFormFieldDtoTypeEnum[keyof typeof GetFormFieldDtoTypeEnum];

/**
 *
 * @export
 * @interface GetFormSubmissionDto
 */
export interface GetFormSubmissionDto {
    /**
     * Submission ID
     * @type {string}
     * @memberof GetFormSubmissionDto
     */
    'id': string;
    /**
     * Form ID
     * @type {string}
     * @memberof GetFormSubmissionDto
     */
    'formId': string;
    /**
     * Visit ID
     * @type {string}
     * @memberof GetFormSubmissionDto
     */
    'visitId': string;
    /**
     * User ID
     * @type {string}
     * @memberof GetFormSubmissionDto
     */
    'userId': string;
    /**
     * Organization ID
     * @type {string}
     * @memberof GetFormSubmissionDto
     */
    'organizationId': string;
    /**
     * Field responses
     * @type {Array<GetFieldResponseDto>}
     * @memberof GetFormSubmissionDto
     */
    'responses': Array<GetFieldResponseDto>;
    /**
     * Submission status
     * @type {string}
     * @memberof GetFormSubmissionDto
     */
    'status': GetFormSubmissionDtoStatusEnum;
    /**
     * Creation date
     * @type {string}
     * @memberof GetFormSubmissionDto
     */
    'createdAt': string;
    /**
     * Last update date
     * @type {string}
     * @memberof GetFormSubmissionDto
     */
    'updatedAt': string;
}

export const GetFormSubmissionDtoStatusEnum = {
    Draft: 'draft',
    Submitted: 'submitted'
} as const;

export type GetFormSubmissionDtoStatusEnum = typeof GetFormSubmissionDtoStatusEnum[keyof typeof GetFormSubmissionDtoStatusEnum];

/**
 *
 * @export
 * @interface GetLastBookedVisitDto
 */
export interface GetLastBookedVisitDto {
    /**
     * Time of the last booked visit
     * @type {string}
     * @memberof GetLastBookedVisitDto
     */
    'time': string;
    /**
     * Whether the visit was booked today
     * @type {boolean}
     * @memberof GetLastBookedVisitDto
     */
    'isToday': boolean;
}
/**
 *
 * @export
 * @interface GetMedicationHistoryDto
 */
export interface GetMedicationHistoryDto {
    /**
     *
     * @type {string}
     * @memberof GetMedicationHistoryDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof GetMedicationHistoryDto
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof GetMedicationHistoryDto
     */
    'status': GetMedicationHistoryDtoStatusEnum;
    /**
     *
     * @type {Array<MedicationEventDto>}
     * @memberof GetMedicationHistoryDto
     */
    'events': Array<MedicationEventDto>;
}

export const GetMedicationHistoryDtoStatusEnum = {
    Scheduled: 'SCHEDULED',
    Active: 'ACTIVE',
    Paused: 'PAUSED',
    Stopped: 'STOPPED'
} as const;

export type GetMedicationHistoryDtoStatusEnum = typeof GetMedicationHistoryDtoStatusEnum[keyof typeof GetMedicationHistoryDtoStatusEnum];

/**
 *
 * @export
 * @interface GetMedicineDto
 */
export interface GetMedicineDto {
    /**
     * Medicine ID
     * @type {string}
     * @memberof GetMedicineDto
     */
    'id': string;
    /**
     * Product ID
     * @type {string}
     * @memberof GetMedicineDto
     */
    'productId': string;
    /**
     * Product name
     * @type {string}
     * @memberof GetMedicineDto
     */
    'productName': string;
    /**
     * Common name
     * @type {string}
     * @memberof GetMedicineDto
     */
    'commonName'?: string;
    /**
     * Preparation type
     * @type {string}
     * @memberof GetMedicineDto
     */
    'preparationType'?: string;
    /**
     * Animal usage ban
     * @type {string}
     * @memberof GetMedicineDto
     */
    'animalUsageBan'?: string;
    /**
     * Previous name
     * @type {string}
     * @memberof GetMedicineDto
     */
    'previousName'?: string;
    /**
     * Administration route
     * @type {string}
     * @memberof GetMedicineDto
     */
    'administrationRoute'?: string;
    /**
     * Strength
     * @type {string}
     * @memberof GetMedicineDto
     */
    'strength'?: string;
    /**
     * Pharmaceutical form
     * @type {string}
     * @memberof GetMedicineDto
     */
    'pharmaceuticalForm'?: string;
    /**
     * Procedure type
     * @type {string}
     * @memberof GetMedicineDto
     */
    'procedureType'?: string;
    /**
     * License number
     * @type {string}
     * @memberof GetMedicineDto
     */
    'licenseNumber'?: string;
    /**
     * License validity
     * @type {string}
     * @memberof GetMedicineDto
     */
    'licenseValidity'?: string;
    /**
     * ATC code
     * @type {string}
     * @memberof GetMedicineDto
     */
    'atcCode'?: string;
    /**
     * Responsible entity
     * @type {string}
     * @memberof GetMedicineDto
     */
    'responsibleEntity'?: string;
    /**
     *
     * @type {GetMedicineDtoPackaging}
     * @memberof GetMedicineDto
     */
    'packaging'?: GetMedicineDtoPackaging;
    /**
     * Active substance
     * @type {string}
     * @memberof GetMedicineDto
     */
    'activeSubstance'?: string;
    /**
     * Manufacturer name
     * @type {string}
     * @memberof GetMedicineDto
     */
    'manufacturerName'?: string;
    /**
     * Manufacturer country
     * @type {string}
     * @memberof GetMedicineDto
     */
    'manufacturerCountry'?: string;
    /**
     * Importer name
     * @type {string}
     * @memberof GetMedicineDto
     */
    'importerName'?: string;
    /**
     * Importer country
     * @type {string}
     * @memberof GetMedicineDto
     */
    'importerCountry'?: string;
    /**
     * Manufacturer/Importer name
     * @type {string}
     * @memberof GetMedicineDto
     */
    'manufacturerImporterName'?: string;
    /**
     * Manufacturer/Importer country
     * @type {string}
     * @memberof GetMedicineDto
     */
    'manufacturerImporterCountry'?: string;
    /**
     * Responsible entity export
     * @type {string}
     * @memberof GetMedicineDto
     */
    'responsibleEntityExport'?: string;
    /**
     * Export country
     * @type {string}
     * @memberof GetMedicineDto
     */
    'exportCountry'?: string;
    /**
     * Legal basis
     * @type {string}
     * @memberof GetMedicineDto
     */
    'legalBasis'?: string;
    /**
     * Leaflet URL
     * @type {string}
     * @memberof GetMedicineDto
     */
    'leafletUrl'?: string;
    /**
     * Characteristic URL
     * @type {string}
     * @memberof GetMedicineDto
     */
    'characteristicUrl'?: string;
    /**
     * Label leaflet URL
     * @type {string}
     * @memberof GetMedicineDto
     */
    'labelLeafletUrl'?: string;
    /**
     * Parallel import leaflet URL
     * @type {string}
     * @memberof GetMedicineDto
     */
    'parallelImportLeafletUrl'?: string;
    /**
     * Parallel import label leaflet URL
     * @type {string}
     * @memberof GetMedicineDto
     */
    'parallelImportLabelLeafletUrl'?: string;
    /**
     * Parallel import packaging marking URL
     * @type {string}
     * @memberof GetMedicineDto
     */
    'parallelImportPackagingMarkingUrl'?: string;
    /**
     * Educational medical tools URL
     * @type {string}
     * @memberof GetMedicineDto
     */
    'educationalMedicalToolsUrl'?: string;
    /**
     * Educational patient tools URL
     * @type {string}
     * @memberof GetMedicineDto
     */
    'educationalPatientToolsUrl'?: string;
    /**
     * Import date
     * @type {string}
     * @memberof GetMedicineDto
     */
    'importDate'?: string;
    /**
     * Source file
     * @type {string}
     * @memberof GetMedicineDto
     */
    'sourceFile'?: string;
}
/**
 * Packaging information
 * @export
 * @interface GetMedicineDtoPackaging
 */
export interface GetMedicineDtoPackaging {
    /**
     * Raw packaging data
     * @type {string}
     * @memberof GetMedicineDtoPackaging
     */
    'raw'?: string;
    /**
     * Structured packaging data
     * @type {Array<PackagingItemDto>}
     * @memberof GetMedicineDtoPackaging
     */
    'structured'?: Array<PackagingItemDto>;
}
/**
 *
 * @export
 * @interface GetOrganizationAvailabilityDto
 */
export interface GetOrganizationAvailabilityDto {
    /**
     * Professional ID
     * @type {string}
     * @memberof GetOrganizationAvailabilityDto
     */
    'professionalId': string;
    /**
     * Organization ID
     * @type {string}
     * @memberof GetOrganizationAvailabilityDto
     */
    'organizationId': string;
    /**
     * Array of availability slots
     * @type {Array<SetOrganizationAvailabilityResponseDtoAvailabilitySlotsInner>}
     * @memberof GetOrganizationAvailabilityDto
     */
    'availabilitySlots'?: Array<SetOrganizationAvailabilityResponseDtoAvailabilitySlotsInner>;
    /**
     * Array of time off periods
     * @type {Array<SetOrganizationAvailabilityResponseDtoTimeOffInner>}
     * @memberof GetOrganizationAvailabilityDto
     */
    'timeOff'?: Array<SetOrganizationAvailabilityResponseDtoTimeOffInner>;
    /**
     * Whether the availability is active
     * @type {boolean}
     * @memberof GetOrganizationAvailabilityDto
     */
    'isActive': boolean;
    /**
     * Creation date
     * @type {string}
     * @memberof GetOrganizationAvailabilityDto
     */
    'createdAt'?: string;
    /**
     * Last update date
     * @type {string}
     * @memberof GetOrganizationAvailabilityDto
     */
    'updatedAt'?: string;
}
/**
 *
 * @export
 * @interface GetOrganizationCustomersDto
 */
export interface GetOrganizationCustomersDto {
    /**
     * Customer\'s user ID
     * @type {string}
     * @memberof GetOrganizationCustomersDto
     */
    'id': string;
    /**
     * Customer\'s first name
     * @type {string}
     * @memberof GetOrganizationCustomersDto
     */
    'firstName': string;
    /**
     * Customer\'s last name
     * @type {string}
     * @memberof GetOrganizationCustomersDto
     */
    'lastName': string;
    /**
     * Customer\'s email address
     * @type {string}
     * @memberof GetOrganizationCustomersDto
     */
    'email'?: string;
    /**
     * Customer\'s phone number
     * @type {string}
     * @memberof GetOrganizationCustomersDto
     */
    'phoneNumber'?: string;
}
/**
 *
 * @export
 * @interface GetOrganizationDto
 */
export interface GetOrganizationDto {
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDto
     */
    '_id': string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'street': string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'zip': string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'city': string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'website': string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'description': string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'phoneNumber': string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'email': string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'nip': string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'rating': string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'logoUrl': string;
    /**
     *
     * @type {Array<string>}
     * @memberof GetOrganizationDto
     */
    'images': Array<string>;
    /**
     *
     * @type {boolean}
     * @memberof GetOrganizationDto
     */
    'isActive': boolean;
    /**
     *
     * @type {boolean}
     * @memberof GetOrganizationDto
     */
    'isPublished': boolean;
    /**
     *
     * @type {boolean}
     * @memberof GetOrganizationDto
     */
    'isVerified': boolean;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'type': GetOrganizationDtoTypeEnum;
    /**
     *
     * @type {Array<object>}
     * @memberof GetOrganizationDto
     */
    'workingHours': Array<object>;
    /**
     *
     * @type {Array<object>}
     * @memberof GetOrganizationDto
     */
    'timeOff': Array<object>;
    /**
     *
     * @type {Array<string>}
     * @memberof GetOrganizationDto
     */
    'specializations': Array<string>;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'slug'?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof GetOrganizationDto
     */
    'enabledServices': Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof GetOrganizationDto
     */
    'enabledVisitTypes': Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof GetOrganizationDto
     */
    'enabledCategories': Array<string>;
    /**
     *
     * @type {Array<GetOrganizationDtoVisitTypeCategoryConfigsInner>}
     * @memberof GetOrganizationDto
     */
    'visitTypeCategoryConfigs'?: Array<GetOrganizationDtoVisitTypeCategoryConfigsInner>;
    /**
     *
     * @type {Array<string>}
     * @memberof GetOrganizationDto
     */
    'socialMedia': Array<string>;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'updatedAt': string;
}

export const GetOrganizationDtoTypeEnum = {
    VeterinaryFacility: 'VETERINARY_FACILITY'
} as const;

export type GetOrganizationDtoTypeEnum = typeof GetOrganizationDtoTypeEnum[keyof typeof GetOrganizationDtoTypeEnum];

/**
 *
 * @export
 * @interface GetOrganizationDtoVisitTypeCategoryConfigsInner
 */
export interface GetOrganizationDtoVisitTypeCategoryConfigsInner {
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDtoVisitTypeCategoryConfigsInner
     */
    'visitType'?: string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationDtoVisitTypeCategoryConfigsInner
     */
    'category'?: string;
}
/**
 *
 * @export
 * @interface GetOrganizationProfessionalBookingDto
 */
export interface GetOrganizationProfessionalBookingDto {
    /**
     * Professional ID
     * @type {string}
     * @memberof GetOrganizationProfessionalBookingDto
     */
    'id': string;
    /**
     * First name
     * @type {string}
     * @memberof GetOrganizationProfessionalBookingDto
     */
    'firstName': string;
    /**
     * Last name
     * @type {string}
     * @memberof GetOrganizationProfessionalBookingDto
     */
    'lastName': string;
    /**
     * Avatar URL
     * @type {string}
     * @memberof GetOrganizationProfessionalBookingDto
     */
    'avatar'?: string;
    /**
     * Professional categories with pricing
     * @type {Array<ProfessionalCategoryDto>}
     * @memberof GetOrganizationProfessionalBookingDto
     */
    'categories': Array<ProfessionalCategoryDto>;
    /**
     * Supported visit types by this professional
     * @type {Array<string>}
     * @memberof GetOrganizationProfessionalBookingDto
     */
    'visitTypes': Array<GetOrganizationProfessionalBookingDtoVisitTypesEnum>;
    /**
     * Specializations
     * @type {Array<SpecializationDto>}
     * @memberof GetOrganizationProfessionalBookingDto
     */
    'specializations': Array<SpecializationDto>;
    /**
     * Professional description
     * @type {string}
     * @memberof GetOrganizationProfessionalBookingDto
     */
    'description'?: string;
    /**
     * Availability slots
     * @type {Array<AvailabilitySlotDto>}
     * @memberof GetOrganizationProfessionalBookingDto
     */
    'availabilitySlots': Array<AvailabilitySlotDto>;
    /**
     * Professional service configurations
     * @type {Array<BookingServiceConfigDto>}
     * @memberof GetOrganizationProfessionalBookingDto
     */
    'services': Array<BookingServiceConfigDto>;
}

export const GetOrganizationProfessionalBookingDtoVisitTypesEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type GetOrganizationProfessionalBookingDtoVisitTypesEnum = typeof GetOrganizationProfessionalBookingDtoVisitTypesEnum[keyof typeof GetOrganizationProfessionalBookingDtoVisitTypesEnum];

/**
 *
 * @export
 * @interface GetOrganizationProfessionalsDto
 */
export interface GetOrganizationProfessionalsDto {
    /**
     * User\'s unique ID
     * @type {string}
     * @memberof GetOrganizationProfessionalsDto
     */
    'id': string;
    /**
     * User\'s first name
     * @type {string}
     * @memberof GetOrganizationProfessionalsDto
     */
    'firstName': string;
    /**
     * User\'s last name
     * @type {string}
     * @memberof GetOrganizationProfessionalsDto
     */
    'lastName': string;
    /**
     * URL to the user\'s avatar
     * @type {string}
     * @memberof GetOrganizationProfessionalsDto
     */
    'avatar'?: string;
    /**
     * User\'s description
     * @type {string}
     * @memberof GetOrganizationProfessionalsDto
     */
    'description'?: string;
    /**
     * Professional categories with pricing
     * @type {Array<ProfessionalCategoryDto>}
     * @memberof GetOrganizationProfessionalsDto
     */
    'categories': Array<ProfessionalCategoryDto>;
    /**
     * Supported visit types by this professional
     * @type {Array<string>}
     * @memberof GetOrganizationProfessionalsDto
     */
    'visitTypes': Array<GetOrganizationProfessionalsDtoVisitTypesEnum>;
    /**
     * Professional specializations
     * @type {Array<ProfessionalSpecializationDto>}
     * @memberof GetOrganizationProfessionalsDto
     */
    'specializations': Array<ProfessionalSpecializationDto>;
    /**
     * Professional organization-specific availability slots
     * @type {Array<AvailabilitySlotDto>}
     * @memberof GetOrganizationProfessionalsDto
     */
    'availabilitySlots': Array<AvailabilitySlotDto>;
    /**
     * Professional service configurations
     * @type {Array<ServiceConfigDto>}
     * @memberof GetOrganizationProfessionalsDto
     */
    'services': Array<ServiceConfigDto>;
    /**
     * Date of the last visit for this professional in the organization
     * @type {string}
     * @memberof GetOrganizationProfessionalsDto
     */
    'lastVisitDate'?: string;
    /**
     * Date of the next scheduled visit for this professional in the organization
     * @type {string}
     * @memberof GetOrganizationProfessionalsDto
     */
    'nextVisitDate'?: string;
    /**
     * Total number of completed visits for this professional in the organization
     * @type {number}
     * @memberof GetOrganizationProfessionalsDto
     */
    'numberOfVisits': number;
    /**
     * Total number of scheduled visits for this professional in the organization
     * @type {number}
     * @memberof GetOrganizationProfessionalsDto
     */
    'numberOfScheduledVisits': number;
}

export const GetOrganizationProfessionalsDtoVisitTypesEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type GetOrganizationProfessionalsDtoVisitTypesEnum = typeof GetOrganizationProfessionalsDtoVisitTypesEnum[keyof typeof GetOrganizationProfessionalsDtoVisitTypesEnum];

/**
 *
 * @export
 * @interface GetOrganizationProfilesDto
 */
export interface GetOrganizationProfilesDto {
    /**
     * Profile ID
     * @type {string}
     * @memberof GetOrganizationProfilesDto
     */
    'id': string;
    /**
     * Profile avatar URL
     * @type {string}
     * @memberof GetOrganizationProfilesDto
     */
    'profileAvatar'?: string;
    /**
     * Pet name
     * @type {string}
     * @memberof GetOrganizationProfilesDto
     */
    'name': string;
    /**
     * Pet breed
     * @type {string}
     * @memberof GetOrganizationProfilesDto
     */
    'breed': string;
    /**
     * User avatar URL
     * @type {string}
     * @memberof GetOrganizationProfilesDto
     */
    'userAvatar'?: string;
    /**
     * User first name
     * @type {string}
     * @memberof GetOrganizationProfilesDto
     */
    'firstName': string;
    /**
     * User last name
     * @type {string}
     * @memberof GetOrganizationProfilesDto
     */
    'lastName': string;
    /**
     * Date of the last visit in the organization
     * @type {string}
     * @memberof GetOrganizationProfilesDto
     */
    'lastVisitDate'?: string;
    /**
     * Date of the next scheduled visit in the organization
     * @type {string}
     * @memberof GetOrganizationProfilesDto
     */
    'nextVisitDate'?: string;
}
/**
 *
 * @export
 * @interface GetOrganizationProfilesForScheduleDto
 */
export interface GetOrganizationProfilesForScheduleDto {
    /**
     * Profile ID
     * @type {string}
     * @memberof GetOrganizationProfilesForScheduleDto
     */
    'id': string;
    /**
     * Pet name
     * @type {string}
     * @memberof GetOrganizationProfilesForScheduleDto
     */
    'name': string;
    /**
     * Pet avatar URL
     * @type {string}
     * @memberof GetOrganizationProfilesForScheduleDto
     */
    'avatar'?: string;
    /**
     * Pet breed
     * @type {string}
     * @memberof GetOrganizationProfilesForScheduleDto
     */
    'breed': string;
    /**
     * Pet category
     * @type {string}
     * @memberof GetOrganizationProfilesForScheduleDto
     */
    'petCategory': GetOrganizationProfilesForScheduleDtoPetCategoryEnum;
}

export const GetOrganizationProfilesForScheduleDtoPetCategoryEnum = {
    Dog: 'dog',
    Cat: 'cat',
    Other: 'other'
} as const;

export type GetOrganizationProfilesForScheduleDtoPetCategoryEnum = typeof GetOrganizationProfilesForScheduleDtoPetCategoryEnum[keyof typeof GetOrganizationProfilesForScheduleDtoPetCategoryEnum];

/**
 *
 * @export
 * @interface GetOrganizationSearchDto
 */
export interface GetOrganizationSearchDto {
    /**
     * Organization ID
     * @type {string}
     * @memberof GetOrganizationSearchDto
     */
    'id': string;
    /**
     * Organization name
     * @type {string}
     * @memberof GetOrganizationSearchDto
     */
    'name': string;
    /**
     * Email
     * @type {string}
     * @memberof GetOrganizationSearchDto
     */
    'email': string;
    /**
     * Street address
     * @type {string}
     * @memberof GetOrganizationSearchDto
     */
    'street': string;
    /**
     * ZIP code
     * @type {string}
     * @memberof GetOrganizationSearchDto
     */
    'zip': string;
    /**
     * City
     * @type {string}
     * @memberof GetOrganizationSearchDto
     */
    'city': string;
    /**
     * Website URL
     * @type {string}
     * @memberof GetOrganizationSearchDto
     */
    'website'?: string | null;
    /**
     * Organization description
     * @type {string}
     * @memberof GetOrganizationSearchDto
     */
    'description': string;
    /**
     * Phone number
     * @type {string}
     * @memberof GetOrganizationSearchDto
     */
    'phoneNumber': string;
    /**
     * Logo URL
     * @type {string}
     * @memberof GetOrganizationSearchDto
     */
    'logoUrl': string;
    /**
     * Organization images
     * @type {Array<string>}
     * @memberof GetOrganizationSearchDto
     */
    'images': Array<string>;
    /**
     * Working hours
     * @type {Array<AvailabilitySlotDto>}
     * @memberof GetOrganizationSearchDto
     */
    'workingHours': Array<AvailabilitySlotDto>;
    /**
     * Time off periods
     * @type {Array<TimeOffDto>}
     * @memberof GetOrganizationSearchDto
     */
    'timeOff': Array<TimeOffDto>;
    /**
     * Specializations
     * @type {Array<SpecializationDto>}
     * @memberof GetOrganizationSearchDto
     */
    'specializations': Array<SpecializationDto>;
    /**
     * Enabled visit types for the organization
     * @type {Array<string>}
     * @memberof GetOrganizationSearchDto
     */
    'enabledVisitTypes': Array<string>;
    /**
     * Enabled categories for the organization
     * @type {Array<string>}
     * @memberof GetOrganizationSearchDto
     */
    'enabledCategories': Array<string>;
    /**
     * Visit type and category configurations
     * @type {Array<GetOrganizationDtoVisitTypeCategoryConfigsInner>}
     * @memberof GetOrganizationSearchDto
     */
    'visitTypeCategoryConfigs'?: Array<GetOrganizationDtoVisitTypeCategoryConfigsInner>;
    /**
     * Organization slug
     * @type {string}
     * @memberof GetOrganizationSearchDto
     */
    'slug'?: string;
    /**
     * Whether the user has a recent visit at this organization
     * @type {boolean}
     * @memberof GetOrganizationSearchDto
     */
    'hasRecentVisit'?: boolean;
}
/**
 *
 * @export
 * @interface GetOrganizationTimeOffItemDto
 */
export interface GetOrganizationTimeOffItemDto {
    /**
     * Time off entry ID
     * @type {string}
     * @memberof GetOrganizationTimeOffItemDto
     */
    'id': string;
    /**
     * Professional ID
     * @type {string}
     * @memberof GetOrganizationTimeOffItemDto
     */
    'professionalId': string;
    /**
     * Professional full name
     * @type {string}
     * @memberof GetOrganizationTimeOffItemDto
     */
    'professionalName': string;
    /**
     * Start date ISO string
     * @type {string}
     * @memberof GetOrganizationTimeOffItemDto
     */
    'startDate': string;
    /**
     * End date ISO string
     * @type {string}
     * @memberof GetOrganizationTimeOffItemDto
     */
    'endDate': string;
    /**
     * Start time HH:MM
     * @type {string}
     * @memberof GetOrganizationTimeOffItemDto
     */
    'startTime'?: string;
    /**
     * End time HH:MM
     * @type {string}
     * @memberof GetOrganizationTimeOffItemDto
     */
    'endTime'?: string;
    /**
     * Professional avatar URL
     * @type {string}
     * @memberof GetOrganizationTimeOffItemDto
     */
    'professionalAvatar'?: string;
    /**
     * Optional explanation for the time off
     * @type {string}
     * @memberof GetOrganizationTimeOffItemDto
     */
    'description'?: string;
}
/**
 *
 * @export
 * @interface GetOrganizationTimeOffResponseDto
 */
export interface GetOrganizationTimeOffResponseDto {
    /**
     *
     * @type {Array<GetOrganizationTimeOffItemDto>}
     * @memberof GetOrganizationTimeOffResponseDto
     */
    'timeOff': Array<GetOrganizationTimeOffItemDto>;
}
/**
 *
 * @export
 * @interface GetOrganizationUsersDto
 */
export interface GetOrganizationUsersDto {
    /**
     * User\'s unique ID
     * @type {string}
     * @memberof GetOrganizationUsersDto
     */
    'id': string;
    /**
     * User\'s first name
     * @type {string}
     * @memberof GetOrganizationUsersDto
     */
    'firstName': string;
    /**
     * User\'s last name
     * @type {string}
     * @memberof GetOrganizationUsersDto
     */
    'lastName': string;
    /**
     * User\'s email address
     * @type {string}
     * @memberof GetOrganizationUsersDto
     */
    'email': string;
    /**
     * URL to the user\'s avatar
     * @type {string}
     * @memberof GetOrganizationUsersDto
     */
    'avatar'?: string;
    /**
     * User\'s roles
     * @type {Array<string>}
     * @memberof GetOrganizationUsersDto
     */
    'roles': Array<GetOrganizationUsersDtoRolesEnum>;
}

export const GetOrganizationUsersDtoRolesEnum = {
    Admin: 'ADMIN',
    Professional: 'PROFESSIONAL',
    User: 'USER',
    OrganizationAdmin: 'ORGANIZATION_ADMIN',
    OrganizationOwner: 'ORGANIZATION_OWNER'
} as const;

export type GetOrganizationUsersDtoRolesEnum = typeof GetOrganizationUsersDtoRolesEnum[keyof typeof GetOrganizationUsersDtoRolesEnum];

/**
 *
 * @export
 * @interface GetOrganizationUsersForScheduleDto
 */
export interface GetOrganizationUsersForScheduleDto {
    /**
     * User ID
     * @type {string}
     * @memberof GetOrganizationUsersForScheduleDto
     */
    'id': string;
    /**
     * User first name
     * @type {string}
     * @memberof GetOrganizationUsersForScheduleDto
     */
    'firstName': string;
    /**
     * User last name
     * @type {string}
     * @memberof GetOrganizationUsersForScheduleDto
     */
    'lastName': string;
    /**
     * User email address
     * @type {string}
     * @memberof GetOrganizationUsersForScheduleDto
     */
    'email': string;
    /**
     * User phone number
     * @type {string}
     * @memberof GetOrganizationUsersForScheduleDto
     */
    'phoneNumber'?: string;
    /**
     * User avatar URL
     * @type {string}
     * @memberof GetOrganizationUsersForScheduleDto
     */
    'avatar'?: string;
}
/**
 *
 * @export
 * @interface GetOrganizationsDto
 */
export interface GetOrganizationsDto {
    /**
     *
     * @type {string}
     * @memberof GetOrganizationsDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationsDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationsDto
     */
    'city': string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationsDto
     */
    'logoUrl': string;
    /**
     *
     * @type {number}
     * @memberof GetOrganizationsDto
     */
    'professionalsNumber': number;
    /**
     *
     * @type {Array<object>}
     * @memberof GetOrganizationsDto
     */
    'workingHours': Array<object>;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationsDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof GetOrganizationsDto
     */
    'updatedAt': string;
}
/**
 *
 * @export
 * @interface GetProfessionalConfigDto
 */
export interface GetProfessionalConfigDto {
    /**
     * Professional user ID
     * @type {string}
     * @memberof GetProfessionalConfigDto
     */
    'professionalId': string;
    /**
     * Organization ID
     * @type {string}
     * @memberof GetProfessionalConfigDto
     */
    'organizationId': string;
    /**
     * Visit types enabled for this professional in this organization
     * @type {Array<string>}
     * @memberof GetProfessionalConfigDto
     */
    'enabledVisitTypes': Array<GetProfessionalConfigDtoEnabledVisitTypesEnum>;
    /**
     * Categories enabled for this professional in this organization
     * @type {Array<string>}
     * @memberof GetProfessionalConfigDto
     */
    'enabledCategories': Array<GetProfessionalConfigDtoEnabledCategoriesEnum>;
    /**
     * Visit type and category configurations
     * @type {Array<GetProfessionalConfigDtoVisitTypeCategoryConfigsInner>}
     * @memberof GetProfessionalConfigDto
     */
    'visitTypeCategoryConfigs'?: Array<GetProfessionalConfigDtoVisitTypeCategoryConfigsInner>;
    /**
     * Service configurations for this professional
     * @type {Array<GetServiceConfigDto>}
     * @memberof GetProfessionalConfigDto
     */
    'serviceConfigs': Array<GetServiceConfigDto>;
    /**
     * Professional description for this organization
     * @type {string}
     * @memberof GetProfessionalConfigDto
     */
    'description'?: string;
    /**
     * Array of specialization IDs
     * @type {Array<string>}
     * @memberof GetProfessionalConfigDto
     */
    'specializations'?: Array<string>;
    /**
     * Whether this configuration is active
     * @type {boolean}
     * @memberof GetProfessionalConfigDto
     */
    'isActive': boolean;
    /**
     * Configuration creation date
     * @type {string}
     * @memberof GetProfessionalConfigDto
     */
    'createdAt': string;
    /**
     * Configuration last update date
     * @type {string}
     * @memberof GetProfessionalConfigDto
     */
    'updatedAt': string;
}

export const GetProfessionalConfigDtoEnabledVisitTypesEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type GetProfessionalConfigDtoEnabledVisitTypesEnum = typeof GetProfessionalConfigDtoEnabledVisitTypesEnum[keyof typeof GetProfessionalConfigDtoEnabledVisitTypesEnum];
export const GetProfessionalConfigDtoEnabledCategoriesEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type GetProfessionalConfigDtoEnabledCategoriesEnum = typeof GetProfessionalConfigDtoEnabledCategoriesEnum[keyof typeof GetProfessionalConfigDtoEnabledCategoriesEnum];

/**
 *
 * @export
 * @interface GetProfessionalConfigDtoVisitTypeCategoryConfigsInner
 */
export interface GetProfessionalConfigDtoVisitTypeCategoryConfigsInner {
    /**
     *
     * @type {string}
     * @memberof GetProfessionalConfigDtoVisitTypeCategoryConfigsInner
     */
    'visitType'?: GetProfessionalConfigDtoVisitTypeCategoryConfigsInnerVisitTypeEnum;
    /**
     *
     * @type {string}
     * @memberof GetProfessionalConfigDtoVisitTypeCategoryConfigsInner
     */
    'category'?: GetProfessionalConfigDtoVisitTypeCategoryConfigsInnerCategoryEnum;
}

export const GetProfessionalConfigDtoVisitTypeCategoryConfigsInnerVisitTypeEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type GetProfessionalConfigDtoVisitTypeCategoryConfigsInnerVisitTypeEnum = typeof GetProfessionalConfigDtoVisitTypeCategoryConfigsInnerVisitTypeEnum[keyof typeof GetProfessionalConfigDtoVisitTypeCategoryConfigsInnerVisitTypeEnum];
export const GetProfessionalConfigDtoVisitTypeCategoryConfigsInnerCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type GetProfessionalConfigDtoVisitTypeCategoryConfigsInnerCategoryEnum = typeof GetProfessionalConfigDtoVisitTypeCategoryConfigsInnerCategoryEnum[keyof typeof GetProfessionalConfigDtoVisitTypeCategoryConfigsInnerCategoryEnum];

/**
 *
 * @export
 * @interface GetProfessionalOrganizationAvailabilitiesDto
 */
export interface GetProfessionalOrganizationAvailabilitiesDto {
    /**
     * Array of organization availabilities for the professional
     * @type {Array<GetOrganizationAvailabilityDto>}
     * @memberof GetProfessionalOrganizationAvailabilitiesDto
     */
    'availabilities': Array<GetOrganizationAvailabilityDto>;
}
/**
 *
 * @export
 * @interface GetProfessionalProfileDto
 */
export interface GetProfessionalProfileDto {
    /**
     *
     * @type {string}
     * @memberof GetProfessionalProfileDto
     */
    'petCategory'?: GetProfessionalProfileDtoPetCategoryEnum;
    /**
     *
     * @type {string}
     * @memberof GetProfessionalProfileDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof GetProfessionalProfileDto
     */
    'avatar': string;
    /**
     *
     * @type {string}
     * @memberof GetProfessionalProfileDto
     */
    'background'?: string;
    /**
     *
     * @type {string}
     * @memberof GetProfessionalProfileDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof GetProfessionalProfileDto
     */
    'breed': string;
    /**
     *
     * @type {string}
     * @memberof GetProfessionalProfileDto
     */
    'dob': string;
    /**
     *
     * @type {number}
     * @memberof GetProfessionalProfileDto
     */
    'weight': number;
    /**
     *
     * @type {string}
     * @memberof GetProfessionalProfileDto
     */
    'chipNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof GetProfessionalProfileDto
     */
    'gender': string;
    /**
     *
     * @type {string}
     * @memberof GetProfessionalProfileDto
     */
    'description'?: string;
    /**
     *
     * @type {object}
     * @memberof GetProfessionalProfileDto
     */
    'lastVisit': object | null;
    /**
     *
     * @type {object}
     * @memberof GetProfessionalProfileDto
     */
    'futureVisit': object | null;
    /**
     *
     * @type {string}
     * @memberof GetProfessionalProfileDto
     */
    'userId': string;
    /**
     *
     * @type {Array<object>}
     * @memberof GetProfessionalProfileDto
     */
    'documents'?: Array<object>;
    /**
     *
     * @type {Array<object>}
     * @memberof GetProfessionalProfileDto
     */
    'medications': Array<object>;
}

export const GetProfessionalProfileDtoPetCategoryEnum = {
    Dog: 'dog',
    Cat: 'cat',
    Other: 'other'
} as const;

export type GetProfessionalProfileDtoPetCategoryEnum = typeof GetProfessionalProfileDtoPetCategoryEnum[keyof typeof GetProfessionalProfileDtoPetCategoryEnum];

/**
 *
 * @export
 * @interface GetProfileDto
 */
export interface GetProfileDto {
    /**
     *
     * @type {string}
     * @memberof GetProfileDto
     */
    'petCategory'?: GetProfileDtoPetCategoryEnum;
    /**
     *
     * @type {string}
     * @memberof GetProfileDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof GetProfileDto
     */
    'avatar': string;
    /**
     *
     * @type {string}
     * @memberof GetProfileDto
     */
    'background'?: string;
    /**
     *
     * @type {string}
     * @memberof GetProfileDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof GetProfileDto
     */
    'breed': string;
    /**
     *
     * @type {string}
     * @memberof GetProfileDto
     */
    'dob': string;
    /**
     *
     * @type {number}
     * @memberof GetProfileDto
     */
    'weight': number;
    /**
     *
     * @type {string}
     * @memberof GetProfileDto
     */
    'chipNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof GetProfileDto
     */
    'gender': string;
    /**
     *
     * @type {string}
     * @memberof GetProfileDto
     */
    'description'?: string;
    /**
     *
     * @type {object}
     * @memberof GetProfileDto
     */
    'lastVisit': object | null;
    /**
     *
     * @type {object}
     * @memberof GetProfileDto
     */
    'futureVisit': object | null;
    /**
     *
     * @type {string}
     * @memberof GetProfileDto
     */
    'userId': string;
    /**
     *
     * @type {Array<object>}
     * @memberof GetProfileDto
     */
    'documents'?: Array<object>;
    /**
     *
     * @type {Array<object>}
     * @memberof GetProfileDto
     */
    'medications': Array<object>;
}

export const GetProfileDtoPetCategoryEnum = {
    Dog: 'dog',
    Cat: 'cat',
    Other: 'other'
} as const;

export type GetProfileDtoPetCategoryEnum = typeof GetProfileDtoPetCategoryEnum[keyof typeof GetProfileDtoPetCategoryEnum];

/**
 *
 * @export
 * @interface GetProfileMedicationsDto
 */
export interface GetProfileMedicationsDto {
    /**
     * Unique identifier of the medication record
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'id': string;
    /**
     * Medicine product ID from the medicine database
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'medicineProductId'?: string;
    /**
     * Name of the medication
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'name'?: string;
    /**
     * Registry classification (Ludzki / Weterynaryjny) — not the form
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'preparationType'?: string;
    /**
     * Dosage amount (deprecated — use quantityValue)
     * @type {number}
     * @memberof GetProfileMedicationsDto
     */
    'dosage'?: number;
    /**
     * Dosage interval (deprecated — use frequencyType)
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'dosageInterval'?: GetProfileMedicationsDtoDosageIntervalEnum;
    /**
     *
     * @type {number}
     * @memberof GetProfileMedicationsDto
     */
    'strengthValue'?: number;
    /**
     *
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'strengthUnit'?: GetProfileMedicationsDtoStrengthUnitEnum;
    /**
     *
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'strengthUnitCustom'?: string;
    /**
     *
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'form'?: GetProfileMedicationsDtoFormEnum;
    /**
     *
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'formCustom'?: string;
    /**
     *
     * @type {number}
     * @memberof GetProfileMedicationsDto
     */
    'quantityValue'?: number;
    /**
     *
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'quantityCustom'?: string;
    /**
     * Recorded before the dose is known, e.g. pending a weigh-in
     * @type {boolean}
     * @memberof GetProfileMedicationsDto
     */
    'dosagePending': boolean;
    /**
     *
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'frequencyType'?: GetProfileMedicationsDtoFrequencyTypeEnum;
    /**
     *
     * @type {number}
     * @memberof GetProfileMedicationsDto
     */
    'frequencyValue'?: number;
    /**
     *
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'frequencyCustom'?: string;
    /**
     *
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'durationType'?: GetProfileMedicationsDtoDurationTypeEnum;
    /**
     *
     * @type {number}
     * @memberof GetProfileMedicationsDto
     */
    'durationValue'?: number;
    /**
     *
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'durationCustom'?: string;
    /**
     * Dosing that changes over the course, e.g. a steroid taper
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'dosageSchedule'?: string;
    /**
     * What the medication is for
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'indication'?: string;
    /**
     * Adverse reaction recorded
     * @type {boolean}
     * @memberof GetProfileMedicationsDto
     */
    'adverseReaction': boolean;
    /**
     *
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'adverseReactionNote'?: string;
    /**
     *
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'status': GetProfileMedicationsDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'startedAt'?: string;
    /**
     *
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'endedAt'?: string;
    /**
     *
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'stopReason'?: GetProfileMedicationsDtoStopReasonEnum;
    /**
     *
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'stopReasonNote'?: string;
    /**
     * Visit the medication was prescribed on
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'sourceVisitId'?: string;
    /**
     * When the prescribing visit took place
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'sourceVisitDate'?: string;
    /**
     * When the medication record was added. This is what the tables sort on, so it is also what they show — an order the reader cannot see is indistinguishable from no order.
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'createdAt'?: string;
    /**
     * Visit the medication was last changed on
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'lastUpdatedVisitId'?: string;
    /**
     * Additional notes about the medication
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'notes'?: string;
    /**
     *
     * @type {GetProfileMedicationsDtoLinkedReminder}
     * @memberof GetProfileMedicationsDto
     */
    'linkedReminder'?: GetProfileMedicationsDtoLinkedReminder;
    /**
     * Name of the user who added this medication
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'creatorName'?: string;
    /**
     * Name of the organization that added this medication
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'creatorOrganizationName'?: string;
    /**
     * Avatar of the user who added this medication
     * @type {string}
     * @memberof GetProfileMedicationsDto
     */
    'creatorAvatar'?: string;
    /**
     * Whether the profile owner may change this medication (owner view only)
     * @type {boolean}
     * @memberof GetProfileMedicationsDto
     */
    'canEdit'?: boolean;
    /**
     * Stock Issues of the viewing clinic (clinic views only; never for owners)
     * @type {Array<MedicationStockIssueDto>}
     * @memberof GetProfileMedicationsDto
     */
    'stockIssues'?: Array<MedicationStockIssueDto>;
    /**
     * Shortages this write left, on the entry just written
     * @type {Array<StockWarningDto>}
     * @memberof GetProfileMedicationsDto
     */
    'stockWarnings'?: Array<StockWarningDto>;
}

export const GetProfileMedicationsDtoDosageIntervalEnum = {
    Day: 'Day',
    Week: 'Week',
    Month: 'Month'
} as const;

export type GetProfileMedicationsDtoDosageIntervalEnum = typeof GetProfileMedicationsDtoDosageIntervalEnum[keyof typeof GetProfileMedicationsDtoDosageIntervalEnum];
export const GetProfileMedicationsDtoStrengthUnitEnum = {
    Mg: 'MG',
    G: 'G',
    Mcg: 'MCG',
    Ml: 'ML',
    Iu: 'IU',
    Percent: 'PERCENT',
    None: 'NONE',
    Other: 'OTHER'
} as const;

export type GetProfileMedicationsDtoStrengthUnitEnum = typeof GetProfileMedicationsDtoStrengthUnitEnum[keyof typeof GetProfileMedicationsDtoStrengthUnitEnum];
export const GetProfileMedicationsDtoFormEnum = {
    Tablet: 'TABLET',
    Capsule: 'CAPSULE',
    Sachet: 'SACHET',
    Suspension: 'SUSPENSION',
    Solution: 'SOLUTION',
    Drops: 'DROPS',
    Injection: 'INJECTION',
    Ointment: 'OINTMENT',
    SpotOn: 'SPOT_ON',
    Spray: 'SPRAY',
    Powder: 'POWDER',
    Paste: 'PASTE',
    Other: 'OTHER'
} as const;

export type GetProfileMedicationsDtoFormEnum = typeof GetProfileMedicationsDtoFormEnum[keyof typeof GetProfileMedicationsDtoFormEnum];
export const GetProfileMedicationsDtoFrequencyTypeEnum = {
    TimesPerDay: 'TIMES_PER_DAY',
    EveryNHours: 'EVERY_N_HOURS',
    EveryNDays: 'EVERY_N_DAYS',
    TimesPerWeek: 'TIMES_PER_WEEK',
    TimesPerMonth: 'TIMES_PER_MONTH',
    AsNeeded: 'AS_NEEDED',
    Other: 'OTHER'
} as const;

export type GetProfileMedicationsDtoFrequencyTypeEnum = typeof GetProfileMedicationsDtoFrequencyTypeEnum[keyof typeof GetProfileMedicationsDtoFrequencyTypeEnum];
export const GetProfileMedicationsDtoDurationTypeEnum = {
    UntilFurtherNotice: 'UNTIL_FURTHER_NOTICE',
    Days: 'DAYS',
    Weeks: 'WEEKS',
    UntilFollowUp: 'UNTIL_FOLLOW_UP',
    SingleDose: 'SINGLE_DOSE',
    Other: 'OTHER'
} as const;

export type GetProfileMedicationsDtoDurationTypeEnum = typeof GetProfileMedicationsDtoDurationTypeEnum[keyof typeof GetProfileMedicationsDtoDurationTypeEnum];
export const GetProfileMedicationsDtoStatusEnum = {
    Scheduled: 'SCHEDULED',
    Active: 'ACTIVE',
    Paused: 'PAUSED',
    Stopped: 'STOPPED'
} as const;

export type GetProfileMedicationsDtoStatusEnum = typeof GetProfileMedicationsDtoStatusEnum[keyof typeof GetProfileMedicationsDtoStatusEnum];
export const GetProfileMedicationsDtoStopReasonEnum = {
    CourseCompleted: 'COURSE_COMPLETED',
    Ineffective: 'INEFFECTIVE',
    AdverseReaction: 'ADVERSE_REACTION',
    OwnerDecision: 'OWNER_DECISION',
    Replaced: 'REPLACED',
    Other: 'OTHER'
} as const;

export type GetProfileMedicationsDtoStopReasonEnum = typeof GetProfileMedicationsDtoStopReasonEnum[keyof typeof GetProfileMedicationsDtoStopReasonEnum];

/**
 * Linked reminder for this medication
 * @export
 * @interface GetProfileMedicationsDtoLinkedReminder
 */
export interface GetProfileMedicationsDtoLinkedReminder {
    /**
     * Reminder ID
     * @type {string}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'id': string;
    /**
     * Profile ID. Null for guest-visit reminders.
     * @type {string}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'profileId': string | null;
    /**
     * Visit ID the reminder is scoped to (guest visits or when added during a visit).
     * @type {string}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'visitId'?: string | null;
    /**
     * Reminder description
     * @type {string}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'description': string;
    /**
     * First notification date and time
     * @type {string}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'scheduledAt': string;
    /**
     * Recurrence type
     * @type {string}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'recurrenceType': GetProfileMedicationsDtoLinkedReminderRecurrenceTypeEnum;
    /**
     *
     * @type {GetReminderDtoCustomRecurrence}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'customRecurrence'?: GetReminderDtoCustomRecurrence;
    /**
     * Notification channels
     * @type {Array<string>}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'notificationChannels': Array<GetProfileMedicationsDtoLinkedReminderNotificationChannelsEnum>;
    /**
     * Creator display name (professional name or Właściciel)
     * @type {string}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'creatorName': string;
    /**
     * Organization name (if created by org member)
     * @type {string}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'creatorOrganizationName'?: string;
    /**
     * Whether the reminder is still active
     * @type {boolean}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'isActive': boolean;
    /**
     * Next scheduled notification time
     * @type {string}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'nextSendAt': string;
    /**
     * Last time notification was sent
     * @type {string}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'lastSentAt'?: string;
    /**
     * Creation timestamp
     * @type {string}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'createdAt': string;
    /**
     * Medication ID this reminder is linked to
     * @type {string}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'medicationId'?: string;
    /**
     * Treatment ID this reminder is linked to
     * @type {string}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'treatmentId'?: string;
    /**
     * Organization ID that created this reminder
     * @type {string}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'organizationId'?: string;
    /**
     * User ID of the reminder creator
     * @type {string}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'createdBy': string;
    /**
     * Whether the current user can edit/delete this reminder. False means preview-only.
     * @type {boolean}
     * @memberof GetProfileMedicationsDtoLinkedReminder
     */
    'canEdit': boolean;
}

export const GetProfileMedicationsDtoLinkedReminderRecurrenceTypeEnum = {
    Single: 'SINGLE',
    Daily: 'DAILY',
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
    Custom: 'CUSTOM'
} as const;

export type GetProfileMedicationsDtoLinkedReminderRecurrenceTypeEnum = typeof GetProfileMedicationsDtoLinkedReminderRecurrenceTypeEnum[keyof typeof GetProfileMedicationsDtoLinkedReminderRecurrenceTypeEnum];
export const GetProfileMedicationsDtoLinkedReminderNotificationChannelsEnum = {
    Email: 'EMAIL',
    Sms: 'SMS'
} as const;

export type GetProfileMedicationsDtoLinkedReminderNotificationChannelsEnum = typeof GetProfileMedicationsDtoLinkedReminderNotificationChannelsEnum[keyof typeof GetProfileMedicationsDtoLinkedReminderNotificationChannelsEnum];

/**
 *
 * @export
 * @interface GetProfileTreatmentDto
 */
export interface GetProfileTreatmentDto {
    /**
     * Profile treatment ID
     * @type {string}
     * @memberof GetProfileTreatmentDto
     */
    'id': string;
    /**
     * Treatment name
     * @type {string}
     * @memberof GetProfileTreatmentDto
     */
    'name': string;
    /**
     * Treatment description
     * @type {string}
     * @memberof GetProfileTreatmentDto
     */
    'description': string;
    /**
     * Date and time of the treatment
     * @type {string}
     * @memberof GetProfileTreatmentDto
     */
    'treatmentDate': string;
    /**
     * Catalog treatment ID
     * @type {string}
     * @memberof GetProfileTreatmentDto
     */
    'treatmentId'?: string;
    /**
     * Net price
     * @type {number}
     * @memberof GetProfileTreatmentDto
     */
    'priceNetto'?: number;
    /**
     * Gross price
     * @type {number}
     * @memberof GetProfileTreatmentDto
     */
    'priceBrutto'?: number;
    /**
     * VAT rate
     * @type {number}
     * @memberof GetProfileTreatmentDto
     */
    'vatRate'?: number;
    /**
     * Associated medicines
     * @type {Array<GetAssociatedMedicineDto>}
     * @memberof GetProfileTreatmentDto
     */
    'associatedMedicines': Array<GetAssociatedMedicineDto>;
    /**
     * Organization ID
     * @type {string}
     * @memberof GetProfileTreatmentDto
     */
    'organizationId'?: string;
    /**
     * Creator user ID
     * @type {string}
     * @memberof GetProfileTreatmentDto
     */
    'createdBy': string;
    /**
     * Creator display name (professional name or Właściciel)
     * @type {string}
     * @memberof GetProfileTreatmentDto
     */
    'creatorName': string;
    /**
     * Organization name (if created by org member)
     * @type {string}
     * @memberof GetProfileTreatmentDto
     */
    'creatorOrganizationName'?: string;
    /**
     * Linked reminder ID
     * @type {string}
     * @memberof GetProfileTreatmentDto
     */
    'reminderId'?: string;
    /**
     *
     * @type {GetProfileTreatmentDtoLinkedReminder}
     * @memberof GetProfileTreatmentDto
     */
    'linkedReminder'?: GetProfileTreatmentDtoLinkedReminder;
    /**
     * Visit ID
     * @type {string}
     * @memberof GetProfileTreatmentDto
     */
    'visitId'?: string;
    /**
     * Whether current user can edit this treatment
     * @type {boolean}
     * @memberof GetProfileTreatmentDto
     */
    'canEdit': boolean;
    /**
     * Whether the prices are shown to this caller; another clinic\'s are not
     * @type {boolean}
     * @memberof GetProfileTreatmentDto
     */
    'pricesVisible': boolean;
    /**
     * Non-drug materials used (clinic views of its own entries only)
     * @type {Array<GetTreatmentMaterialDto>}
     * @memberof GetProfileTreatmentDto
     */
    'materials'?: Array<GetTreatmentMaterialDto>;
    /**
     * Shortages this write left, on the entry just written
     * @type {Array<StockWarningDto>}
     * @memberof GetProfileTreatmentDto
     */
    'stockWarnings'?: Array<StockWarningDto>;
}
/**
 * Linked reminder data
 * @export
 * @interface GetProfileTreatmentDtoLinkedReminder
 */
export interface GetProfileTreatmentDtoLinkedReminder {
    /**
     * Reminder ID
     * @type {string}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'id': string;
    /**
     * Profile ID. Null for guest-visit reminders.
     * @type {string}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'profileId': string | null;
    /**
     * Visit ID the reminder is scoped to (guest visits or when added during a visit).
     * @type {string}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'visitId'?: string | null;
    /**
     * Reminder description
     * @type {string}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'description': string;
    /**
     * First notification date and time
     * @type {string}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'scheduledAt': string;
    /**
     * Recurrence type
     * @type {string}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'recurrenceType': GetProfileTreatmentDtoLinkedReminderRecurrenceTypeEnum;
    /**
     *
     * @type {GetReminderDtoCustomRecurrence}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'customRecurrence'?: GetReminderDtoCustomRecurrence;
    /**
     * Notification channels
     * @type {Array<string>}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'notificationChannels': Array<GetProfileTreatmentDtoLinkedReminderNotificationChannelsEnum>;
    /**
     * Creator display name (professional name or Właściciel)
     * @type {string}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'creatorName': string;
    /**
     * Organization name (if created by org member)
     * @type {string}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'creatorOrganizationName'?: string;
    /**
     * Whether the reminder is still active
     * @type {boolean}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'isActive': boolean;
    /**
     * Next scheduled notification time
     * @type {string}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'nextSendAt': string;
    /**
     * Last time notification was sent
     * @type {string}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'lastSentAt'?: string;
    /**
     * Creation timestamp
     * @type {string}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'createdAt': string;
    /**
     * Medication ID this reminder is linked to
     * @type {string}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'medicationId'?: string;
    /**
     * Treatment ID this reminder is linked to
     * @type {string}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'treatmentId'?: string;
    /**
     * Organization ID that created this reminder
     * @type {string}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'organizationId'?: string;
    /**
     * User ID of the reminder creator
     * @type {string}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'createdBy': string;
    /**
     * Whether the current user can edit/delete this reminder. False means preview-only.
     * @type {boolean}
     * @memberof GetProfileTreatmentDtoLinkedReminder
     */
    'canEdit': boolean;
}

export const GetProfileTreatmentDtoLinkedReminderRecurrenceTypeEnum = {
    Single: 'SINGLE',
    Daily: 'DAILY',
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
    Custom: 'CUSTOM'
} as const;

export type GetProfileTreatmentDtoLinkedReminderRecurrenceTypeEnum = typeof GetProfileTreatmentDtoLinkedReminderRecurrenceTypeEnum[keyof typeof GetProfileTreatmentDtoLinkedReminderRecurrenceTypeEnum];
export const GetProfileTreatmentDtoLinkedReminderNotificationChannelsEnum = {
    Email: 'EMAIL',
    Sms: 'SMS'
} as const;

export type GetProfileTreatmentDtoLinkedReminderNotificationChannelsEnum = typeof GetProfileTreatmentDtoLinkedReminderNotificationChannelsEnum[keyof typeof GetProfileTreatmentDtoLinkedReminderNotificationChannelsEnum];

/**
 *
 * @export
 * @interface GetRatingDto
 */
export interface GetRatingDto {
    /**
     * Rating ID
     * @type {string}
     * @memberof GetRatingDto
     */
    'id': string;
    /**
     * User ID who created the rating. Null for guest-visit ratings.
     * @type {string}
     * @memberof GetRatingDto
     */
    'userId': string | null;
    /**
     * Visit ID that was rated
     * @type {string}
     * @memberof GetRatingDto
     */
    'visitId': string;
    /**
     * Professional ID who was rated
     * @type {string}
     * @memberof GetRatingDto
     */
    'professionalId': string;
    /**
     * Organization ID that was rated
     * @type {string}
     * @memberof GetRatingDto
     */
    'organizationId': string;
    /**
     * Rating for the professional (1-5 stars)
     * @type {number}
     * @memberof GetRatingDto
     */
    'professionalRating': number;
    /**
     * Rating for the organization (1-5 stars)
     * @type {number}
     * @memberof GetRatingDto
     */
    'organizationRating': number;
    /**
     * Review text
     * @type {string}
     * @memberof GetRatingDto
     */
    'review'?: string;
    /**
     * Rating creation date
     * @type {string}
     * @memberof GetRatingDto
     */
    'createdAt': string;
    /**
     * Rating last update date
     * @type {string}
     * @memberof GetRatingDto
     */
    'updatedAt': string;
}
/**
 *
 * @export
 * @interface GetReminderDto
 */
export interface GetReminderDto {
    /**
     * Reminder ID
     * @type {string}
     * @memberof GetReminderDto
     */
    'id': string;
    /**
     * Profile ID. Null for guest-visit reminders.
     * @type {string}
     * @memberof GetReminderDto
     */
    'profileId': string | null;
    /**
     * Visit ID the reminder is scoped to (guest visits or when added during a visit).
     * @type {string}
     * @memberof GetReminderDto
     */
    'visitId'?: string | null;
    /**
     * Reminder description
     * @type {string}
     * @memberof GetReminderDto
     */
    'description': string;
    /**
     * First notification date and time
     * @type {string}
     * @memberof GetReminderDto
     */
    'scheduledAt': string;
    /**
     * Recurrence type
     * @type {string}
     * @memberof GetReminderDto
     */
    'recurrenceType': GetReminderDtoRecurrenceTypeEnum;
    /**
     *
     * @type {GetReminderDtoCustomRecurrence}
     * @memberof GetReminderDto
     */
    'customRecurrence'?: GetReminderDtoCustomRecurrence;
    /**
     * Notification channels
     * @type {Array<string>}
     * @memberof GetReminderDto
     */
    'notificationChannels': Array<GetReminderDtoNotificationChannelsEnum>;
    /**
     * Creator display name (professional name or Właściciel)
     * @type {string}
     * @memberof GetReminderDto
     */
    'creatorName': string;
    /**
     * Organization name (if created by org member)
     * @type {string}
     * @memberof GetReminderDto
     */
    'creatorOrganizationName'?: string;
    /**
     * Whether the reminder is still active
     * @type {boolean}
     * @memberof GetReminderDto
     */
    'isActive': boolean;
    /**
     * Next scheduled notification time
     * @type {string}
     * @memberof GetReminderDto
     */
    'nextSendAt': string;
    /**
     * Last time notification was sent
     * @type {string}
     * @memberof GetReminderDto
     */
    'lastSentAt'?: string;
    /**
     * Creation timestamp
     * @type {string}
     * @memberof GetReminderDto
     */
    'createdAt': string;
    /**
     * Medication ID this reminder is linked to
     * @type {string}
     * @memberof GetReminderDto
     */
    'medicationId'?: string;
    /**
     * Treatment ID this reminder is linked to
     * @type {string}
     * @memberof GetReminderDto
     */
    'treatmentId'?: string;
    /**
     * Organization ID that created this reminder
     * @type {string}
     * @memberof GetReminderDto
     */
    'organizationId'?: string;
    /**
     * User ID of the reminder creator
     * @type {string}
     * @memberof GetReminderDto
     */
    'createdBy': string;
    /**
     * Whether the current user can edit/delete this reminder. False means preview-only.
     * @type {boolean}
     * @memberof GetReminderDto
     */
    'canEdit': boolean;
}

export const GetReminderDtoRecurrenceTypeEnum = {
    Single: 'SINGLE',
    Daily: 'DAILY',
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
    Custom: 'CUSTOM'
} as const;

export type GetReminderDtoRecurrenceTypeEnum = typeof GetReminderDtoRecurrenceTypeEnum[keyof typeof GetReminderDtoRecurrenceTypeEnum];
export const GetReminderDtoNotificationChannelsEnum = {
    Email: 'EMAIL',
    Sms: 'SMS'
} as const;

export type GetReminderDtoNotificationChannelsEnum = typeof GetReminderDtoNotificationChannelsEnum[keyof typeof GetReminderDtoNotificationChannelsEnum];

/**
 * Custom recurrence config
 * @export
 * @interface GetReminderDtoCustomRecurrence
 */
export interface GetReminderDtoCustomRecurrence {
    /**
     * Interval value
     * @type {number}
     * @memberof GetReminderDtoCustomRecurrence
     */
    'every': number;
    /**
     * Interval unit
     * @type {string}
     * @memberof GetReminderDtoCustomRecurrence
     */
    'unit': GetReminderDtoCustomRecurrenceUnitEnum;
    /**
     * Day of week (0=Sun, 1=Mon, ..., 6=Sat)
     * @type {number}
     * @memberof GetReminderDtoCustomRecurrence
     */
    'dayOfWeek'?: number;
    /**
     * Week of month for monthly recurrence
     * @type {string}
     * @memberof GetReminderDtoCustomRecurrence
     */
    'weekOfMonth'?: GetReminderDtoCustomRecurrenceWeekOfMonthEnum;
}

export const GetReminderDtoCustomRecurrenceUnitEnum = {
    Hour: 'hour',
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const;

export type GetReminderDtoCustomRecurrenceUnitEnum = typeof GetReminderDtoCustomRecurrenceUnitEnum[keyof typeof GetReminderDtoCustomRecurrenceUnitEnum];
export const GetReminderDtoCustomRecurrenceWeekOfMonthEnum = {
    First: 'first',
    Second: 'second',
    Third: 'third',
    Fourth: 'fourth',
    Last: 'last'
} as const;

export type GetReminderDtoCustomRecurrenceWeekOfMonthEnum = typeof GetReminderDtoCustomRecurrenceWeekOfMonthEnum[keyof typeof GetReminderDtoCustomRecurrenceWeekOfMonthEnum];

/**
 *
 * @export
 * @interface GetServiceConfigDto
 */
export interface GetServiceConfigDto {
    /**
     * Service ID
     * @type {string}
     * @memberof GetServiceConfigDto
     */
    'serviceId': string;
    /**
     * Custom duration in minutes for this service
     * @type {number}
     * @memberof GetServiceConfigDto
     */
    'customDuration'?: number;
    /**
     * Additional notes about this service
     * @type {string}
     * @memberof GetServiceConfigDto
     */
    'notes'?: string;
    /**
     * Whether this service is actively offered
     * @type {boolean}
     * @memberof GetServiceConfigDto
     */
    'isActive': boolean;
}
/**
 *
 * @export
 * @interface GetSpecializationsDto
 */
export interface GetSpecializationsDto {
    /**
     * Specialization ID
     * @type {string}
     * @memberof GetSpecializationsDto
     */
    'id': string;
    /**
     * Specialization name
     * @type {string}
     * @memberof GetSpecializationsDto
     */
    'name': string;
    /**
     * Price for this specialization in PLN
     * @type {number}
     * @memberof GetSpecializationsDto
     */
    'price': number;
    /**
     * Visit Category ID
     * @type {string}
     * @memberof GetSpecializationsDto
     */
    'visitCategoryId': string;
    /**
     * Visit length in minutes
     * @type {number}
     * @memberof GetSpecializationsDto
     */
    'visitLengthMinutes': number;
}
/**
 *
 * @export
 * @interface GetTemplateDto
 */
export interface GetTemplateDto {
    /**
     * Template ID
     * @type {string}
     * @memberof GetTemplateDto
     */
    'id': string;
    /**
     * Template name
     * @type {string}
     * @memberof GetTemplateDto
     */
    'name': string;
    /**
     * Template description
     * @type {string}
     * @memberof GetTemplateDto
     */
    'description'?: string;
    /**
     * Template category
     * @type {string}
     * @memberof GetTemplateDto
     */
    'category': string;
    /**
     * Template type
     * @type {string}
     * @memberof GetTemplateDto
     */
    'templateType': GetTemplateDtoTemplateTypeEnum;
    /**
     * Template content in markdown format
     * @type {string}
     * @memberof GetTemplateDto
     */
    'content': string;
    /**
     * Whether the template is shared with other professionals
     * @type {boolean}
     * @memberof GetTemplateDto
     */
    'isShared': boolean;
    /**
     * Organization ID that owns this template
     * @type {string}
     * @memberof GetTemplateDto
     */
    'organizationId': string;
    /**
     * ID of the user who created this template
     * @type {string}
     * @memberof GetTemplateDto
     */
    'createdBy'?: string;
    /**
     * Whether this is a default template
     * @type {boolean}
     * @memberof GetTemplateDto
     */
    'isDefault': boolean;
    /**
     * Template creation date
     * @type {string}
     * @memberof GetTemplateDto
     */
    'createdAt': string;
    /**
     * Template last update date
     * @type {string}
     * @memberof GetTemplateDto
     */
    'updatedAt': string;
}

export const GetTemplateDtoTemplateTypeEnum = {
    InitialAssessment: 'initial_assessment',
    FollowUp: 'follow_up',
    General: 'general',
    Surgery: 'surgery',
    Vaccination: 'vaccination',
    Emergency: 'emergency',
    Diagnostic: 'diagnostic',
    Prescription: 'prescription',
    Discharge: 'discharge',
    Checkup: 'checkup'
} as const;

export type GetTemplateDtoTemplateTypeEnum = typeof GetTemplateDtoTemplateTypeEnum[keyof typeof GetTemplateDtoTemplateTypeEnum];

/**
 *
 * @export
 * @interface GetTermsConditionsDto
 */
export interface GetTermsConditionsDto {
    /**
     *
     * @type {string}
     * @memberof GetTermsConditionsDto
     */
    'id': string;
    /**
     *
     * @type {number}
     * @memberof GetTermsConditionsDto
     */
    'version': number;
    /**
     *
     * @type {string}
     * @memberof GetTermsConditionsDto
     */
    'pageLink'?: string;
    /**
     *
     * @type {string}
     * @memberof GetTermsConditionsDto
     */
    'content'?: string;
    /**
     *
     * @type {string}
     * @memberof GetTermsConditionsDto
     */
    'type': GetTermsConditionsDtoTypeEnum;
    /**
     *
     * @type {string}
     * @memberof GetTermsConditionsDto
     */
    'documentCategory': GetTermsConditionsDtoDocumentCategoryEnum;
    /**
     *
     * @type {boolean}
     * @memberof GetTermsConditionsDto
     */
    'active': boolean;
    /**
     *
     * @type {string}
     * @memberof GetTermsConditionsDto
     */
    'createdAt': string;
}

export const GetTermsConditionsDtoTypeEnum = {
    User: 'USER',
    Professional: 'PROFESSIONAL'
} as const;

export type GetTermsConditionsDtoTypeEnum = typeof GetTermsConditionsDtoTypeEnum[keyof typeof GetTermsConditionsDtoTypeEnum];
export const GetTermsConditionsDtoDocumentCategoryEnum = {
    TermsConditions: 'TERMS_CONDITIONS',
    PrivacyPolicy: 'PRIVACY_POLICY'
} as const;

export type GetTermsConditionsDtoDocumentCategoryEnum = typeof GetTermsConditionsDtoDocumentCategoryEnum[keyof typeof GetTermsConditionsDtoDocumentCategoryEnum];

/**
 *
 * @export
 * @interface GetTreatmentDto
 */
export interface GetTreatmentDto {
    /**
     * Treatment ID
     * @type {string}
     * @memberof GetTreatmentDto
     */
    'id': string;
    /**
     * Treatment name
     * @type {string}
     * @memberof GetTreatmentDto
     */
    'name': string;
    /**
     * Treatment description
     * @type {string}
     * @memberof GetTreatmentDto
     */
    'description': string;
    /**
     * Net price
     * @type {number}
     * @memberof GetTreatmentDto
     */
    'priceNetto'?: number;
    /**
     * Gross price
     * @type {number}
     * @memberof GetTreatmentDto
     */
    'priceBrutto'?: number;
    /**
     * VAT rate percentage
     * @type {number}
     * @memberof GetTreatmentDto
     */
    'vatRate': number;
    /**
     * Whether the treatment is active
     * @type {boolean}
     * @memberof GetTreatmentDto
     */
    'isActive': boolean;
    /**
     * Associated medicines
     * @type {Array<GetAssociatedMedicineDto>}
     * @memberof GetTreatmentDto
     */
    'associatedMedicines': Array<GetAssociatedMedicineDto>;
    /**
     * Default non-drug materials
     * @type {Array<GetTreatmentMaterialDto>}
     * @memberof GetTreatmentDto
     */
    'defaultMaterials': Array<GetTreatmentMaterialDto>;
    /**
     * Organization ID
     * @type {string}
     * @memberof GetTreatmentDto
     */
    'organizationId': string;
    /**
     * User ID of the creator
     * @type {string}
     * @memberof GetTreatmentDto
     */
    'createdBy': string;
    /**
     * Creation timestamp
     * @type {string}
     * @memberof GetTreatmentDto
     */
    'createdAt': string;
}
/**
 *
 * @export
 * @interface GetTreatmentMaterialDto
 */
export interface GetTreatmentMaterialDto {
    /**
     * Line id (Performed Treatment only)
     * @type {string}
     * @memberof GetTreatmentMaterialDto
     */
    'id'?: string;
    /**
     * Warehouse Product id
     * @type {string}
     * @memberof GetTreatmentMaterialDto
     */
    'productId': string;
    /**
     * Product name
     * @type {string}
     * @memberof GetTreatmentMaterialDto
     */
    'productName'?: string;
    /**
     * Thousandths of a Unit
     * @type {number}
     * @memberof GetTreatmentMaterialDto
     */
    'quantityMilli': number;
}
/**
 *
 * @export
 * @interface GetTreatmentOverviewAssociatedMedicineDto
 */
export interface GetTreatmentOverviewAssociatedMedicineDto {
    /**
     * Line id; an edit sends it back so the line keeps its stock issue
     * @type {string}
     * @memberof GetTreatmentOverviewAssociatedMedicineDto
     */
    'id'?: string;
    /**
     * Medicine product ID. Null for a medicine typed by hand.
     * @type {string}
     * @memberof GetTreatmentOverviewAssociatedMedicineDto
     */
    'medicineProductId'?: string | null;
    /**
     * Medicine product name
     * @type {string}
     * @memberof GetTreatmentOverviewAssociatedMedicineDto
     */
    'medicineName': string;
    /**
     * Dosage amount
     * @type {number}
     * @memberof GetTreatmentOverviewAssociatedMedicineDto
     */
    'dosage'?: number | null;
    /**
     * Dosage interval
     * @type {string}
     * @memberof GetTreatmentOverviewAssociatedMedicineDto
     */
    'dosageInterval'?: GetTreatmentOverviewAssociatedMedicineDtoDosageIntervalEnum;
    /**
     * Administration notes
     * @type {string}
     * @memberof GetTreatmentOverviewAssociatedMedicineDto
     */
    'notes'?: string | null;
    /**
     * Preparation type
     * @type {string}
     * @memberof GetTreatmentOverviewAssociatedMedicineDto
     */
    'preparationType'?: string | null;
    /**
     * Warehouse Product id
     * @type {string}
     * @memberof GetTreatmentOverviewAssociatedMedicineDto
     */
    'productId'?: string;
    /**
     * Thousandths of a Unit
     * @type {number}
     * @memberof GetTreatmentOverviewAssociatedMedicineDto
     */
    'quantityMilli'?: number;
    /**
     *
     * @type {WarehouseHandover}
     * @memberof GetTreatmentOverviewAssociatedMedicineDto
     */
    'handover'?: WarehouseHandover;
    /**
     *
     * @type {boolean}
     * @memberof GetTreatmentOverviewAssociatedMedicineDto
     */
    'prescriptionIssued'?: boolean;
    /**
     * Handed-over only: the supplied recipient
     * @type {string}
     * @memberof GetTreatmentOverviewAssociatedMedicineDto
     */
    'recipientName'?: string;
    /**
     * Handed-over only: the supplied recipient\'s address
     * @type {string}
     * @memberof GetTreatmentOverviewAssociatedMedicineDto
     */
    'recipientAddress'?: string;
}

export const GetTreatmentOverviewAssociatedMedicineDtoDosageIntervalEnum = {
    Day: 'Day',
    Week: 'Week',
    Month: 'Month'
} as const;

export type GetTreatmentOverviewAssociatedMedicineDtoDosageIntervalEnum = typeof GetTreatmentOverviewAssociatedMedicineDtoDosageIntervalEnum[keyof typeof GetTreatmentOverviewAssociatedMedicineDtoDosageIntervalEnum];

/**
 *
 * @export
 * @interface GetTreatmentOverviewItemDto
 */
export interface GetTreatmentOverviewItemDto {
    /**
     * Profile treatment _id
     * @type {string}
     * @memberof GetTreatmentOverviewItemDto
     */
    'id': string;
    /**
     * Profile document _id; null for guest visit treatments
     * @type {string}
     * @memberof GetTreatmentOverviewItemDto
     */
    'profileId'?: string | null;
    /**
     * Visit ID used to mutate a profile-less guest treatment
     * @type {string}
     * @memberof GetTreatmentOverviewItemDto
     */
    'visitId'?: string | null;
    /**
     * Patient name
     * @type {string}
     * @memberof GetTreatmentOverviewItemDto
     */
    'profileName': string;
    /**
     * Patient avatar URL
     * @type {string}
     * @memberof GetTreatmentOverviewItemDto
     */
    'profileAvatar'?: string;
    /**
     * Treatment name
     * @type {string}
     * @memberof GetTreatmentOverviewItemDto
     */
    'name': string;
    /**
     * Treatment description
     * @type {string}
     * @memberof GetTreatmentOverviewItemDto
     */
    'description': string;
    /**
     * Date/time of treatment
     * @type {string}
     * @memberof GetTreatmentOverviewItemDto
     */
    'treatmentDate': string;
    /**
     * Associated medicines
     * @type {Array<GetTreatmentOverviewAssociatedMedicineDto>}
     * @memberof GetTreatmentOverviewItemDto
     */
    'associatedMedicines': Array<GetTreatmentOverviewAssociatedMedicineDto>;
    /**
     * Linked reminder ID
     * @type {string}
     * @memberof GetTreatmentOverviewItemDto
     */
    'reminderId'?: string;
    /**
     * Net price
     * @type {number}
     * @memberof GetTreatmentOverviewItemDto
     */
    'priceNetto'?: number;
    /**
     * Gross price
     * @type {number}
     * @memberof GetTreatmentOverviewItemDto
     */
    'priceBrutto'?: number;
    /**
     * VAT rate
     * @type {number}
     * @memberof GetTreatmentOverviewItemDto
     */
    'vatRate'?: number;
    /**
     * Professional name or Właściciel
     * @type {string}
     * @memberof GetTreatmentOverviewItemDto
     */
    'creatorName': string;
    /**
     * Organization name
     * @type {string}
     * @memberof GetTreatmentOverviewItemDto
     */
    'creatorOrganizationName'?: string;
    /**
     * Linked reminder data
     * @type {object}
     * @memberof GetTreatmentOverviewItemDto
     */
    'linkedReminder'?: object;
}
/**
 *
 * @export
 * @interface GetTreatmentOverviewResponseDto
 */
export interface GetTreatmentOverviewResponseDto {
    /**
     *
     * @type {Array<GetTreatmentOverviewItemDto>}
     * @memberof GetTreatmentOverviewResponseDto
     */
    'data': Array<GetTreatmentOverviewItemDto>;
    /**
     * Total count for pagination
     * @type {number}
     * @memberof GetTreatmentOverviewResponseDto
     */
    'total': number;
}
/**
 *
 * @export
 * @interface GetUserDto
 */
export interface GetUserDto {
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'firstName': string;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'middleName'?: string;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'lastName': string;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'email': string;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'dob': string;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'phoneNumber': string;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'avatar'?: string;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'address'?: string;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'companyName'?: string;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'companyAddress'?: string;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'companyCity'?: string;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'companyZip'?: string;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'vatNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'pwzNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'city': string;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'zip': string;
    /**
     *
     * @type {boolean}
     * @memberof GetUserDto
     */
    'verified': boolean;
    /**
     *
     * @type {boolean}
     * @memberof GetUserDto
     */
    'onboarded': boolean;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'uid': string;
    /**
     *
     * @type {Array<string>}
     * @memberof GetUserDto
     */
    'roles': Array<string>;
    /**
     *
     * @type {Array<OrganizationInUserDto>}
     * @memberof GetUserDto
     */
    'organizations': Array<OrganizationInUserDto>;
    /**
     *
     * @type {object}
     * @memberof GetUserDto
     */
    'agreements'?: object;
    /**
     *
     * @type {Array<string>}
     * @memberof GetUserDto
     */
    'factPreferences'?: Array<string>;
    /**
     *
     * @type {string}
     * @memberof GetUserDto
     */
    'description'?: string;
    /**
     * How the user was registered: SELF or INVITATION
     * @type {string}
     * @memberof GetUserDto
     */
    'registrationSource': GetUserDtoRegistrationSourceEnum;
    /**
     * ID of the accepted terms and conditions (deprecated)
     * @type {string}
     * @memberof GetUserDto
     */
    'acceptedTermsConditionsId'?: string;
    /**
     * Array of accepted documents with timestamps
     * @type {Array<AcceptedDocumentDto>}
     * @memberof GetUserDto
     */
    'acceptedDocuments': Array<AcceptedDocumentDto>;
    /**
     * Whether the user needs to accept new terms and conditions
     * @type {boolean}
     * @memberof GetUserDto
     */
    'requiresTermsAcceptance': boolean;
    /**
     * Whether the account is pending deletion
     * @type {boolean}
     * @memberof GetUserDto
     */
    'pendingDeletion'?: boolean;
}

export const GetUserDtoRegistrationSourceEnum = {
    Self: 'SELF',
    Invitation: 'INVITATION'
} as const;

export type GetUserDtoRegistrationSourceEnum = typeof GetUserDtoRegistrationSourceEnum[keyof typeof GetUserDtoRegistrationSourceEnum];

/**
 *
 * @export
 * @interface GetUserOrganizationsDto
 */
export interface GetUserOrganizationsDto {
    /**
     * Organization ID
     * @type {string}
     * @memberof GetUserOrganizationsDto
     */
    'id': string;
    /**
     * Organization name
     * @type {string}
     * @memberof GetUserOrganizationsDto
     */
    'name': string;
    /**
     * Organization street
     * @type {string}
     * @memberof GetUserOrganizationsDto
     */
    'street': string;
    /**
     * Organization zip code
     * @type {string}
     * @memberof GetUserOrganizationsDto
     */
    'zip': string;
    /**
     * Organization city
     * @type {string}
     * @memberof GetUserOrganizationsDto
     */
    'city': string;
    /**
     * Organization logo URL
     * @type {string}
     * @memberof GetUserOrganizationsDto
     */
    'logoUrl': string;
    /**
     * Whether the organization is verified
     * @type {boolean}
     * @memberof GetUserOrganizationsDto
     */
    'isVerified': boolean;
}
/**
 *
 * @export
 * @interface GetVisitById
 */
export interface GetVisitById {
    /**
     *
     * @type {User}
     * @memberof GetVisitById
     */
    'user': User | null;
    /**
     *
     * @type {Professional}
     * @memberof GetVisitById
     */
    'professional': Professional | null;
    /**
     *
     * @type {Profile}
     * @memberof GetVisitById
     */
    'profile': Profile | null;
    /**
     *
     * @type {string}
     * @memberof GetVisitById
     */
    'closedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof GetVisitById
     */
    'visitType': GetVisitByIdVisitTypeEnum;
    /**
     *
     * @type {string}
     * @memberof GetVisitById
     */
    'origin': GetVisitByIdOriginEnum;
    /**
     * Generation status of the AI note. null on legacy visits (no value tracked).
     * @type {string}
     * @memberof GetVisitById
     */
    'aiNoteStatus'?: GetVisitByIdAiNoteStatusEnum;
    /**
     *
     * @type {GetVisitByIdTranscription}
     * @memberof GetVisitById
     */
    'transcription'?: GetVisitByIdTranscription | null;
    /**
     *
     * @type {Organization}
     * @memberof GetVisitById
     */
    'organization': Organization | null;
    /**
     * Professional rating (1-5)
     * @type {number}
     * @memberof GetVisitById
     */
    'professionalRating'?: number;
    /**
     * Organization rating (1-5)
     * @type {number}
     * @memberof GetVisitById
     */
    'organizationRating'?: number;
    /**
     * Review/comment for the visit
     * @type {string}
     * @memberof GetVisitById
     */
    'review'?: string;
    /**
     *
     * @type {GetVisitByIdService}
     * @memberof GetVisitById
     */
    'service'?: GetVisitByIdService;
    /**
     *
     * @type {GetVisitByIdVisitAddress}
     * @memberof GetVisitById
     */
    'visitAddress'?: GetVisitByIdVisitAddress;
    /**
     * Required forms for this visit and their submission status
     * @type {Array<RequiredFormInfo>}
     * @memberof GetVisitById
     */
    'requiredForms'?: Array<RequiredFormInfo>;
    /**
     * Reason provided when the visit was cancelled
     * @type {string}
     * @memberof GetVisitById
     */
    'cancellationReason'?: string;
    /**
     * Who cancelled the visit
     * @type {string}
     * @memberof GetVisitById
     */
    'cancelledBy'?: GetVisitByIdCancelledByEnum;
    /**
     * Reason provided when the visit was rejected
     * @type {string}
     * @memberof GetVisitById
     */
    'rejectionReason'?: string;
    /**
     * Who rejected the visit. `owner` = pet owner clicked reject; `system` = cron auto-rejected after the approval window.
     * @type {string}
     * @memberof GetVisitById
     */
    'rejectedBy'?: GetVisitByIdRejectedByEnum;
    /**
     * Reservation fee charged at booking time (PLN). Set when the booked service has prepaidAmount > 0. Null otherwise.
     * @type {number}
     * @memberof GetVisitById
     */
    'reservationFeeAmount'?: number | null;
    /**
     *
     * @type {string}
     * @memberof GetVisitById
     */
    'id': string;
    /**
     *
     * @type {object}
     * @memberof GetVisitById
     */
    'conversation': object | null;
    /**
     *
     * @type {string}
     * @memberof GetVisitById
     */
    'startTime': string;
    /**
     *
     * @type {string}
     * @memberof GetVisitById
     */
    'endTime': string;
    /**
     *
     * @type {string}
     * @memberof GetVisitById
     */
    'category': GetVisitByIdCategoryEnum;
    /**
     *
     * @type {Payment}
     * @memberof GetVisitById
     */
    'payment': Payment | null;
    /**
     *
     * @type {string}
     * @memberof GetVisitById
     */
    'notes'?: string;
    /**
     *
     * @type {string}
     * @memberof GetVisitById
     */
    'notesDraft'?: string;
    /**
     *
     * @type {string}
     * @memberof GetVisitById
     */
    'notesDraftUpdatedAt'?: string | null;
    /**
     *
     * @type {boolean}
     * @memberof GetVisitById
     */
    'hasNotesDraft'?: boolean;
    /**
     *
     * @type {string}
     * @memberof GetVisitById
     */
    'internalNotes'?: string;
    /**
     *
     * @type {string}
     * @memberof GetVisitById
     */
    'description': string;
    /**
     *
     * @type {string}
     * @memberof GetVisitById
     */
    'status': GetVisitByIdStatusEnum;
    /**
     *
     * @type {string}
     * @memberof GetVisitById
     */
    'aiNote'?: string;
    /**
     *
     * @type {Array<object>}
     * @memberof GetVisitById
     */
    'documents': Array<object>;
    /**
     *
     * @type {PromoCode}
     * @memberof GetVisitById
     */
    'promoCode': PromoCode | null;
    /**
     *
     * @type {string}
     * @memberof GetVisitById
     */
    'provider': GetVisitByIdProviderEnum;
}

export const GetVisitByIdVisitTypeEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type GetVisitByIdVisitTypeEnum = typeof GetVisitByIdVisitTypeEnum[keyof typeof GetVisitByIdVisitTypeEnum];
export const GetVisitByIdOriginEnum = {
    Owner: 'OWNER',
    Staff: 'STAFF',
    WalkIn: 'WALK_IN',
    Voice: 'VOICE'
} as const;

export type GetVisitByIdOriginEnum = typeof GetVisitByIdOriginEnum[keyof typeof GetVisitByIdOriginEnum];
export const GetVisitByIdAiNoteStatusEnum = {
    Pending: 'pending',
    Success: 'success',
    Failed: 'failed'
} as const;

export type GetVisitByIdAiNoteStatusEnum = typeof GetVisitByIdAiNoteStatusEnum[keyof typeof GetVisitByIdAiNoteStatusEnum];
export const GetVisitByIdCancelledByEnum = {
    Owner: 'owner',
    Organization: 'organization'
} as const;

export type GetVisitByIdCancelledByEnum = typeof GetVisitByIdCancelledByEnum[keyof typeof GetVisitByIdCancelledByEnum];
export const GetVisitByIdRejectedByEnum = {
    Owner: 'owner',
    System: 'system'
} as const;

export type GetVisitByIdRejectedByEnum = typeof GetVisitByIdRejectedByEnum[keyof typeof GetVisitByIdRejectedByEnum];
export const GetVisitByIdCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type GetVisitByIdCategoryEnum = typeof GetVisitByIdCategoryEnum[keyof typeof GetVisitByIdCategoryEnum];
export const GetVisitByIdStatusEnum = {
    Created: 'CREATED',
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED',
    PendingApproval: 'PENDING_APPROVAL',
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED',
    Aborted: 'ABORTED'
} as const;

export type GetVisitByIdStatusEnum = typeof GetVisitByIdStatusEnum[keyof typeof GetVisitByIdStatusEnum];
export const GetVisitByIdProviderEnum = {
    Petsy: 'petsy'
} as const;

export type GetVisitByIdProviderEnum = typeof GetVisitByIdProviderEnum[keyof typeof GetVisitByIdProviderEnum];

/**
 * Service details
 * @export
 * @interface GetVisitByIdService
 */
export interface GetVisitByIdService {
    /**
     * Service name
     * @type {string}
     * @memberof GetVisitByIdService
     */
    'name': string;
    /**
     * Service duration in minutes
     * @type {number}
     * @memberof GetVisitByIdService
     */
    'duration': number;
    /**
     * Service price
     * @type {number}
     * @memberof GetVisitByIdService
     */
    'price': number;
    /**
     * Service description
     * @type {string}
     * @memberof GetVisitByIdService
     */
    'description'?: string;
}
/**
 * Live audio transcription captured during a physical visit
 * @export
 * @interface GetVisitByIdTranscription
 */
export interface GetVisitByIdTranscription {
    /**
     *
     * @type {string}
     * @memberof GetVisitByIdTranscription
     */
    'status': GetVisitByIdTranscriptionStatusEnum;
    /**
     *
     * @type {Array<VisitTranscriptionSessionDto>}
     * @memberof GetVisitByIdTranscription
     */
    'sessions': Array<VisitTranscriptionSessionDto>;
    /**
     *
     * @type {Array<VisitTranscriptionSegmentDto>}
     * @memberof GetVisitByIdTranscription
     */
    'segments': Array<VisitTranscriptionSegmentDto>;
    /**
     *
     * @type {string}
     * @memberof GetVisitByIdTranscription
     */
    'plainText': string;
    /**
     *
     * @type {string}
     * @memberof GetVisitByIdTranscription
     */
    'consentConfirmedAt'?: string | null;
    /**
     *
     * @type {string}
     * @memberof GetVisitByIdTranscription
     */
    'consentConfirmedBy'?: string | null;
    /**
     *
     * @type {string}
     * @memberof GetVisitByIdTranscription
     */
    'updatedAt'?: string | null;
    /**
     *
     * @type {string}
     * @memberof GetVisitByIdTranscription
     */
    'errorMessage'?: string | null;
    /**
     *
     * @type {string}
     * @memberof GetVisitByIdTranscription
     */
    'transcriptSummary'?: string | null;
    /**
     *
     * @type {string}
     * @memberof GetVisitByIdTranscription
     */
    'transcriptSummaryStatus'?: GetVisitByIdTranscriptionTranscriptSummaryStatusEnum;
}

export const GetVisitByIdTranscriptionStatusEnum = {
    Idle: 'idle',
    Recording: 'recording',
    Finalizing: 'finalizing',
    Completed: 'completed',
    Failed: 'failed'
} as const;

export type GetVisitByIdTranscriptionStatusEnum = typeof GetVisitByIdTranscriptionStatusEnum[keyof typeof GetVisitByIdTranscriptionStatusEnum];
export const GetVisitByIdTranscriptionTranscriptSummaryStatusEnum = {
    Pending: 'pending',
    Success: 'success',
    Failed: 'failed'
} as const;

export type GetVisitByIdTranscriptionTranscriptSummaryStatusEnum = typeof GetVisitByIdTranscriptionTranscriptSummaryStatusEnum[keyof typeof GetVisitByIdTranscriptionTranscriptSummaryStatusEnum];

/**
 * Address for mobile visits
 * @export
 * @interface GetVisitByIdVisitAddress
 */
export interface GetVisitByIdVisitAddress {
    /**
     * Street address for the mobile visit
     * @type {string}
     * @memberof GetVisitByIdVisitAddress
     */
    'street': string;
    /**
     * City for the mobile visit
     * @type {string}
     * @memberof GetVisitByIdVisitAddress
     */
    'city': string;
    /**
     * Zip code for the mobile visit
     * @type {string}
     * @memberof GetVisitByIdVisitAddress
     */
    'zipCode': string;
}
/**
 *
 * @export
 * @interface GetVisitCategoriesDto
 */
export interface GetVisitCategoriesDto {
    /**
     * Category ID
     * @type {string}
     * @memberof GetVisitCategoriesDto
     */
    'id': string;
    /**
     * Category name
     * @type {string}
     * @memberof GetVisitCategoriesDto
     */
    'name': GetVisitCategoriesDtoNameEnum;
    /**
     * Category price
     * @type {number}
     * @memberof GetVisitCategoriesDto
     */
    'price': number;
}

export const GetVisitCategoriesDtoNameEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type GetVisitCategoriesDtoNameEnum = typeof GetVisitCategoriesDtoNameEnum[keyof typeof GetVisitCategoriesDtoNameEnum];

/**
 *
 * @export
 * @interface GetVisitTypesDto
 */
export interface GetVisitTypesDto {
    /**
     *
     * @type {string}
     * @memberof GetVisitTypesDto
     */
    'type': GetVisitTypesDtoTypeEnum;
    /**
     *
     * @type {number}
     * @memberof GetVisitTypesDto
     */
    'price': number;
    /**
     *
     * @type {number}
     * @memberof GetVisitTypesDto
     */
    'visitLengthMinutes': number;
    /**
     *
     * @type {Array<string>}
     * @memberof GetVisitTypesDto
     */
    'categories': Array<GetVisitTypesDtoCategoriesEnum>;
}

export const GetVisitTypesDtoTypeEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type GetVisitTypesDtoTypeEnum = typeof GetVisitTypesDtoTypeEnum[keyof typeof GetVisitTypesDtoTypeEnum];
export const GetVisitTypesDtoCategoriesEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type GetVisitTypesDtoCategoriesEnum = typeof GetVisitTypesDtoCategoriesEnum[keyof typeof GetVisitTypesDtoCategoriesEnum];

/**
 *
 * @export
 * @interface GlobalUserDto
 */
export interface GlobalUserDto {
    /**
     * User ID
     * @type {string}
     * @memberof GlobalUserDto
     */
    'id': string;
    /**
     * User first name
     * @type {string}
     * @memberof GlobalUserDto
     */
    'firstName': string;
    /**
     * User last name
     * @type {string}
     * @memberof GlobalUserDto
     */
    'lastName': string;
    /**
     * User email
     * @type {string}
     * @memberof GlobalUserDto
     */
    'email'?: string;
    /**
     * User phone number
     * @type {string}
     * @memberof GlobalUserDto
     */
    'phoneNumber'?: string;
}
/**
 *
 * @export
 * @interface IngestVoiceCostReconciliationDto
 */
export interface IngestVoiceCostReconciliationDto {
    /**
     *
     * @type {string}
     * @memberof IngestVoiceCostReconciliationDto
     */
    'receiptId': string;
    /**
     *
     * @type {string}
     * @memberof IngestVoiceCostReconciliationDto
     */
    'leaseId': string;
    /**
     *
     * @type {string}
     * @memberof IngestVoiceCostReconciliationDto
     */
    'providerAccountSid': string;
    /**
     *
     * @type {string}
     * @memberof IngestVoiceCostReconciliationDto
     */
    'providerRegion': IngestVoiceCostReconciliationDtoProviderRegionEnum;
    /**
     *
     * @type {string}
     * @memberof IngestVoiceCostReconciliationDto
     */
    'providerEdge': IngestVoiceCostReconciliationDtoProviderEdgeEnum;
    /**
     *
     * @type {string}
     * @memberof IngestVoiceCostReconciliationDto
     */
    'ratePublicationId': string;
    /**
     *
     * @type {number}
     * @memberof IngestVoiceCostReconciliationDto
     */
    'ratePublicationRevision': number;
    /**
     *
     * @type {Array<VoiceCostReconciliationComponentEvidenceDto>}
     * @memberof IngestVoiceCostReconciliationDto
     */
    'components': Array<VoiceCostReconciliationComponentEvidenceDto>;
    /**
     *
     * @type {string}
     * @memberof IngestVoiceCostReconciliationDto
     */
    'observedAt': string;
    /**
     *
     * @type {string}
     * @memberof IngestVoiceCostReconciliationDto
     */
    'evidenceExpiresAt': string;
}

export const IngestVoiceCostReconciliationDtoProviderRegionEnum = {
    Ie1: 'IE1'
} as const;

export type IngestVoiceCostReconciliationDtoProviderRegionEnum = typeof IngestVoiceCostReconciliationDtoProviderRegionEnum[keyof typeof IngestVoiceCostReconciliationDtoProviderRegionEnum];
export const IngestVoiceCostReconciliationDtoProviderEdgeEnum = {
    Dublin: 'dublin'
} as const;

export type IngestVoiceCostReconciliationDtoProviderEdgeEnum = typeof IngestVoiceCostReconciliationDtoProviderEdgeEnum[keyof typeof IngestVoiceCostReconciliationDtoProviderEdgeEnum];

/**
 *
 * @export
 * @interface InitializeOrganizationServiceBookingPolicyDto
 */
export interface InitializeOrganizationServiceBookingPolicyDto {
    /**
     * Derived from visit type and prepayment. Legacy input is accepted for compatibility but cannot override the derived policy.
     * @type {string}
     * @memberof InitializeOrganizationServiceBookingPolicyDto
     */
    'paymentTiming': InitializeOrganizationServiceBookingPolicyDtoPaymentTimingEnum;
    /**
     * Organization approval is always AUTO_CONFIRM. Legacy input cannot override it.
     * @type {string}
     * @memberof InitializeOrganizationServiceBookingPolicyDto
     */
    'confirmationPolicy': InitializeOrganizationServiceBookingPolicyDtoConfirmationPolicyEnum;
    /**
     *
     * @type {string}
     * @memberof InitializeOrganizationServiceBookingPolicyDto
     */
    'serviceId': string;
}

export const InitializeOrganizationServiceBookingPolicyDtoPaymentTimingEnum = {
    AtFacility: 'AT_FACILITY',
    OnlineRequired: 'ONLINE_REQUIRED'
} as const;

export type InitializeOrganizationServiceBookingPolicyDtoPaymentTimingEnum = typeof InitializeOrganizationServiceBookingPolicyDtoPaymentTimingEnum[keyof typeof InitializeOrganizationServiceBookingPolicyDtoPaymentTimingEnum];
export const InitializeOrganizationServiceBookingPolicyDtoConfirmationPolicyEnum = {
    AutoConfirm: 'AUTO_CONFIRM',
    RequiresApproval: 'REQUIRES_APPROVAL'
} as const;

export type InitializeOrganizationServiceBookingPolicyDtoConfirmationPolicyEnum = typeof InitializeOrganizationServiceBookingPolicyDtoConfirmationPolicyEnum[keyof typeof InitializeOrganizationServiceBookingPolicyDtoConfirmationPolicyEnum];

/**
 *
 * @export
 * @interface InternalScheduleVisitDto
 */
export interface InternalScheduleVisitDto {
    /**
     * When true, a real (non-temporary) account is created server-side and a custom token is returned. When false, the visit is stored as a guest booking with userId/profileId null and userData/profileData embedded.
     * @type {boolean}
     * @memberof InternalScheduleVisitDto
     */
    'createAccount': boolean;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'startTime': string;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'category': InternalScheduleVisitDtoCategoryEnum;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'visitType'?: InternalScheduleVisitDtoVisitTypeEnum;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'description': string;
    /**
     *
     * @type {Array<DocumentFileDto>}
     * @memberof InternalScheduleVisitDto
     */
    'documents'?: Array<DocumentFileDto>;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'promoCode'?: string;
    /**
     *
     * @type {ExternalIdDto}
     * @memberof InternalScheduleVisitDto
     */
    'externalId'?: ExternalIdDto;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'firstName': string;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'lastName': string;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'phoneNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'email'?: string;
    /**
     *
     * @type {boolean}
     * @memberof InternalScheduleVisitDto
     */
    'marketing'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InternalScheduleVisitDto
     */
    'terms': boolean;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'profileName': string;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'dob'?: string;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'breed'?: string;
    /**
     *
     * @type {number}
     * @memberof InternalScheduleVisitDto
     */
    'weight'?: number;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'gender'?: string;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'petCategory'?: InternalScheduleVisitDtoPetCategoryEnum;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'professionalId'?: string;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'organizationId'?: string;
    /**
     *
     * @type {string}
     * @memberof InternalScheduleVisitDto
     */
    'serviceId'?: string;
    /**
     *
     * @type {VisitAddressDto}
     * @memberof InternalScheduleVisitDto
     */
    'visitAddress'?: VisitAddressDto;
}

export const InternalScheduleVisitDtoCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type InternalScheduleVisitDtoCategoryEnum = typeof InternalScheduleVisitDtoCategoryEnum[keyof typeof InternalScheduleVisitDtoCategoryEnum];
export const InternalScheduleVisitDtoVisitTypeEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type InternalScheduleVisitDtoVisitTypeEnum = typeof InternalScheduleVisitDtoVisitTypeEnum[keyof typeof InternalScheduleVisitDtoVisitTypeEnum];
export const InternalScheduleVisitDtoPetCategoryEnum = {
    Dog: 'dog',
    Cat: 'cat',
    Other: 'other'
} as const;

export type InternalScheduleVisitDtoPetCategoryEnum = typeof InternalScheduleVisitDtoPetCategoryEnum[keyof typeof InternalScheduleVisitDtoPetCategoryEnum];

/**
 *
 * @export
 * @interface InternalScheduleVisitResponseDto
 */
export interface InternalScheduleVisitResponseDto {
    /**
     * Created visit id
     * @type {string}
     * @memberof InternalScheduleVisitResponseDto
     */
    'visitId': string;
    /**
     * URL to redirect the user to for payment. Null when the visit does not require payment.
     * @type {string}
     * @memberof InternalScheduleVisitResponseDto
     */
    'paymentUrl': string | null;
    /**
     * Firebase custom token. Present only when createAccount=true so the frontend can sign the user in best-effort after the booking is persisted.
     * @type {string}
     * @memberof InternalScheduleVisitResponseDto
     */
    'customToken'?: string | null;
    /**
     * Opaque token used to access guest visit summary and payment actions. Present only for guest bookings.
     * @type {string}
     * @memberof InternalScheduleVisitResponseDto
     */
    'guestAccessToken'?: string | null;
    /**
     * Payment amount in cents
     * @type {number}
     * @memberof InternalScheduleVisitResponseDto
     */
    'amount': number;
}
/**
 *
 * @export
 * @interface InvalidateVoiceProductionQualificationDto
 */
export interface InvalidateVoiceProductionQualificationDto {
    /**
     *
     * @type {number}
     * @memberof InvalidateVoiceProductionQualificationDto
     */
    'expectedRevision': number;
    /**
     *
     * @type {string}
     * @memberof InvalidateVoiceProductionQualificationDto
     */
    'provenanceDigest': string;
    /**
     *
     * @type {string}
     * @memberof InvalidateVoiceProductionQualificationDto
     */
    'reason': InvalidateVoiceProductionQualificationDtoReasonEnum;
}

export const InvalidateVoiceProductionQualificationDtoReasonEnum = {
    ProviderDrift: 'PROVIDER_DRIFT',
    EvidenceRevoked: 'EVIDENCE_REVOKED',
    SourceCorrection: 'SOURCE_CORRECTION',
    SecurityIncident: 'SECURITY_INCIDENT'
} as const;

export type InvalidateVoiceProductionQualificationDtoReasonEnum = typeof InvalidateVoiceProductionQualificationDtoReasonEnum[keyof typeof InvalidateVoiceProductionQualificationDtoReasonEnum];

/**
 *
 * @export
 * @interface InvitationDto
 */
export interface InvitationDto {
    /**
     * Invitation ID
     * @type {string}
     * @memberof InvitationDto
     */
    'id': string;
    /**
     * Unique token for the invitation
     * @type {string}
     * @memberof InvitationDto
     */
    'token': string;
    /**
     * Email address of the invitee
     * @type {string}
     * @memberof InvitationDto
     */
    'email': string;
    /**
     * First name of the invitee
     * @type {string}
     * @memberof InvitationDto
     */
    'firstName': string;
    /**
     * Last name of the invitee
     * @type {string}
     * @memberof InvitationDto
     */
    'lastName': string;
    /**
     * Organization ID
     * @type {string}
     * @memberof InvitationDto
     */
    'organizationId': string;
    /**
     * Organization name
     * @type {string}
     * @memberof InvitationDto
     */
    'organizationName'?: string;
    /**
     * User ID (if accepted)
     * @type {string}
     * @memberof InvitationDto
     */
    'userId'?: string;
    /**
     * Status of the invitation
     * @type {string}
     * @memberof InvitationDto
     */
    'status': InvitationDtoStatusEnum;
    /**
     * Expiration date of the invitation
     * @type {string}
     * @memberof InvitationDto
     */
    'expiresAt': string;
    /**
     * ID of the user who sent the invitation
     * @type {string}
     * @memberof InvitationDto
     */
    'invitedBy': string;
    /**
     * Roles assigned to the user
     * @type {Array<string>}
     * @memberof InvitationDto
     */
    'roles': Array<string>;
    /**
     * Creation date of the invitation
     * @type {string}
     * @memberof InvitationDto
     */
    'createdAt': string;
    /**
     * Last update date of the invitation
     * @type {string}
     * @memberof InvitationDto
     */
    'updatedAt': string;
    /**
     * Indicates if this was a reminder sent for an existing invitation
     * @type {boolean}
     * @memberof InvitationDto
     */
    'isReminder'?: boolean;
}

export const InvitationDtoStatusEnum = {
    Sent: 'SENT',
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED',
    Expired: 'EXPIRED'
} as const;

export type InvitationDtoStatusEnum = typeof InvitationDtoStatusEnum[keyof typeof InvitationDtoStatusEnum];

/**
 *
 * @export
 * @interface InvitationSummaryDto
 */
export interface InvitationSummaryDto {
    /**
     * Invitation ID
     * @type {string}
     * @memberof InvitationSummaryDto
     */
    'id': string;
    /**
     * Email address of the invitee
     * @type {string}
     * @memberof InvitationSummaryDto
     */
    'email': string;
    /**
     * First name of the invitee
     * @type {string}
     * @memberof InvitationSummaryDto
     */
    'firstName': string;
    /**
     * Last name of the invitee
     * @type {string}
     * @memberof InvitationSummaryDto
     */
    'lastName': string;
    /**
     * Organization ID
     * @type {string}
     * @memberof InvitationSummaryDto
     */
    'organizationId': string;
    /**
     * Organization name
     * @type {string}
     * @memberof InvitationSummaryDto
     */
    'organizationName'?: string;
    /**
     * User ID (if accepted)
     * @type {string}
     * @memberof InvitationSummaryDto
     */
    'userId'?: string;
    /**
     * Status of the invitation
     * @type {string}
     * @memberof InvitationSummaryDto
     */
    'status': InvitationSummaryDtoStatusEnum;
    /**
     * Expiration date of the invitation
     * @type {string}
     * @memberof InvitationSummaryDto
     */
    'expiresAt': string;
    /**
     * ID of the user who sent the invitation
     * @type {string}
     * @memberof InvitationSummaryDto
     */
    'invitedBy': string;
    /**
     * Roles assigned to the user
     * @type {Array<string>}
     * @memberof InvitationSummaryDto
     */
    'roles': Array<string>;
    /**
     * Creation date of the invitation
     * @type {string}
     * @memberof InvitationSummaryDto
     */
    'createdAt': string;
    /**
     * Last update date of the invitation
     * @type {string}
     * @memberof InvitationSummaryDto
     */
    'updatedAt': string;
    /**
     * Indicates if this was a reminder sent for an existing invitation
     * @type {boolean}
     * @memberof InvitationSummaryDto
     */
    'isReminder'?: boolean;
}

export const InvitationSummaryDtoStatusEnum = {
    Sent: 'SENT',
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED',
    Expired: 'EXPIRED'
} as const;

export type InvitationSummaryDtoStatusEnum = typeof InvitationSummaryDtoStatusEnum[keyof typeof InvitationSummaryDtoStatusEnum];

/**
 *
 * @export
 * @interface LegacyDailyDto
 */
export interface LegacyDailyDto {
    /**
     *
     * @type {string}
     * @memberof LegacyDailyDto
     */
    'date': string;
    /**
     *
     * @type {number}
     * @memberof LegacyDailyDto
     */
    'count': number;
}
/**
 *
 * @export
 * @interface LegacyHourlyDto
 */
export interface LegacyHourlyDto {
    /**
     *
     * @type {number}
     * @memberof LegacyHourlyDto
     */
    'hour': number;
    /**
     *
     * @type {number}
     * @memberof LegacyHourlyDto
     */
    'count': number;
}
/**
 *
 * @export
 * @interface LegacyPatientStatsDto
 */
export interface LegacyPatientStatsDto {
    /**
     *
     * @type {number}
     * @memberof LegacyPatientStatsDto
     */
    'totalUniquePatients': number;
    /**
     *
     * @type {number}
     * @memberof LegacyPatientStatsDto
     */
    'newPatients': number;
    /**
     *
     * @type {number}
     * @memberof LegacyPatientStatsDto
     */
    'returningPatients': number;
    /**
     *
     * @type {number}
     * @memberof LegacyPatientStatsDto
     */
    'newVsReturningRatio': number;
}
/**
 *
 * @export
 * @interface LegacyProfessionalDto
 */
export interface LegacyProfessionalDto {
    /**
     *
     * @type {string}
     * @memberof LegacyProfessionalDto
     */
    'professionalId': string;
    /**
     *
     * @type {string}
     * @memberof LegacyProfessionalDto
     */
    'professionalName': string;
    /**
     *
     * @type {number}
     * @memberof LegacyProfessionalDto
     */
    'visitCount': number;
}
/**
 *
 * @export
 * @interface LegacyStatusDistributionDto
 */
export interface LegacyStatusDistributionDto {
    /**
     *
     * @type {number}
     * @memberof LegacyStatusDistributionDto
     */
    'completed': number;
    /**
     *
     * @type {number}
     * @memberof LegacyStatusDistributionDto
     */
    'cancelled': number;
    /**
     *
     * @type {number}
     * @memberof LegacyStatusDistributionDto
     */
    'pending': number;
    /**
     *
     * @type {number}
     * @memberof LegacyStatusDistributionDto
     */
    'pendingApproval': number;
    /**
     *
     * @type {number}
     * @memberof LegacyStatusDistributionDto
     */
    'accepted': number;
    /**
     *
     * @type {number}
     * @memberof LegacyStatusDistributionDto
     */
    'rejected': number;
    /**
     *
     * @type {number}
     * @memberof LegacyStatusDistributionDto
     */
    'created': number;
    /**
     *
     * @type {number}
     * @memberof LegacyStatusDistributionDto
     */
    'aborted': number;
    /**
     *
     * @type {number}
     * @memberof LegacyStatusDistributionDto
     */
    'unknown': number;
}
/**
 *
 * @export
 * @interface LegacyVisitTypeDto
 */
export interface LegacyVisitTypeDto {
    /**
     *
     * @type {string}
     * @memberof LegacyVisitTypeDto
     */
    'type': string;
    /**
     *
     * @type {number}
     * @memberof LegacyVisitTypeDto
     */
    'count': number;
    /**
     *
     * @type {number}
     * @memberof LegacyVisitTypeDto
     */
    'percentage': number;
}
/**
 *
 * @export
 * @interface LinkWarehouseDemandRequestProductDto
 */
export interface LinkWarehouseDemandRequestProductDto {
    /**
     * Produkt z katalogu, z którym łączy się zapotrzebowanie spoza magazynu.
     * @type {string}
     * @memberof LinkWarehouseDemandRequestProductDto
     */
    'productId': string;
}
/**
 *
 * @export
 * @interface MarketingAnalysisDto
 */
export interface MarketingAnalysisDto {
    /**
     *
     * @type {string}
     * @memberof MarketingAnalysisDto
     */
    'status': MarketingAnalysisDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof MarketingAnalysisDto
     */
    'snapshotId': string;
    /**
     *
     * @type {string}
     * @memberof MarketingAnalysisDto
     */
    'model': string;
    /**
     *
     * @type {string}
     * @memberof MarketingAnalysisDto
     */
    'generatedAt': string;
    /**
     *
     * @type {string}
     * @memberof MarketingAnalysisDto
     */
    'expiresAt': string;
    /**
     *
     * @type {Array<MarketingInsightDto>}
     * @memberof MarketingAnalysisDto
     */
    'insights': Array<MarketingInsightDto>;
    /**
     *
     * @type {Array<MarketingEvidenceDto>}
     * @memberof MarketingAnalysisDto
     */
    'evidence': Array<MarketingEvidenceDto>;
}

export const MarketingAnalysisDtoStatusEnum = {
    Ready: 'ready',
    Disabled: 'disabled',
    InsufficientData: 'insufficient_data',
    Unavailable: 'unavailable'
} as const;

export type MarketingAnalysisDtoStatusEnum = typeof MarketingAnalysisDtoStatusEnum[keyof typeof MarketingAnalysisDtoStatusEnum];

/**
 *
 * @export
 * @interface MarketingCampaignDto
 */
export interface MarketingCampaignDto {
    /**
     *
     * @type {string}
     * @memberof MarketingCampaignDto
     */
    'campaignId': string;
    /**
     *
     * @type {string}
     * @memberof MarketingCampaignDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof MarketingCampaignDto
     */
    'matchState': MarketingCampaignDtoMatchStateEnum;
    /**
     *
     * @type {number}
     * @memberof MarketingCampaignDto
     */
    'spend': number;
    /**
     *
     * @type {number}
     * @memberof MarketingCampaignDto
     */
    'clicks': number;
    /**
     *
     * @type {number}
     * @memberof MarketingCampaignDto
     */
    'impressions': number;
    /**
     *
     * @type {number}
     * @memberof MarketingCampaignDto
     */
    'averageCpc': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingCampaignDto
     */
    'ga4Contacts': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingCampaignDto
     */
    'ga4ProfessionalSignups': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingCampaignDto
     */
    'observedCostPerContact': number | null;
}

export const MarketingCampaignDtoMatchStateEnum = {
    Matched: 'matched',
    Unmatched: 'unmatched',
    Incompatible: 'incompatible'
} as const;

export type MarketingCampaignDtoMatchStateEnum = typeof MarketingCampaignDtoMatchStateEnum[keyof typeof MarketingCampaignDtoMatchStateEnum];

/**
 *
 * @export
 * @interface MarketingChannelDto
 */
export interface MarketingChannelDto {
    /**
     *
     * @type {string}
     * @memberof MarketingChannelDto
     */
    'sourceMedium': string;
    /**
     *
     * @type {number}
     * @memberof MarketingChannelDto
     */
    'sessions': number;
    /**
     *
     * @type {number}
     * @memberof MarketingChannelDto
     */
    'engagedSessions': number;
    /**
     *
     * @type {number}
     * @memberof MarketingChannelDto
     */
    'contacts': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingChannelDto
     */
    'professionalSignups': number | null;
}
/**
 *
 * @export
 * @interface MarketingDailyDto
 */
export interface MarketingDailyDto {
    /**
     *
     * @type {number}
     * @memberof MarketingDailyDto
     */
    'sessions': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingDailyDto
     */
    'engagedSessions': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingDailyDto
     */
    'engagementRate': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingDailyDto
     */
    'contacts': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingDailyDto
     */
    'professionalSignups': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingDailyDto
     */
    'registrationStarts': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingDailyDto
     */
    'adSpend': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingDailyDto
     */
    'adClicks': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingDailyDto
     */
    'adImpressions': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingDailyDto
     */
    'observedCostPerContact': number | null;
    /**
     *
     * @type {string}
     * @memberof MarketingDailyDto
     */
    'date': string;
}
/**
 *
 * @export
 * @interface MarketingEvidenceDto
 */
export interface MarketingEvidenceDto {
    /**
     *
     * @type {string}
     * @memberof MarketingEvidenceDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof MarketingEvidenceDto
     */
    'source': MarketingEvidenceDtoSourceEnum;
    /**
     *
     * @type {string}
     * @memberof MarketingEvidenceDto
     */
    'metric': string;
    /**
     *
     * @type {number}
     * @memberof MarketingEvidenceDto
     */
    'value': number;
    /**
     *
     * @type {string}
     * @memberof MarketingEvidenceDto
     */
    'unit': MarketingEvidenceDtoUnitEnum;
    /**
     *
     * @type {string}
     * @memberof MarketingEvidenceDto
     */
    'currency': string | null;
    /**
     *
     * @type {string}
     * @memberof MarketingEvidenceDto
     */
    'period': MarketingEvidenceDtoPeriodEnum;
    /**
     *
     * @type {string}
     * @memberof MarketingEvidenceDto
     */
    'scope': MarketingEvidenceDtoScopeEnum;
    /**
     *
     * @type {string}
     * @memberof MarketingEvidenceDto
     */
    'groupId': string | null;
    /**
     *
     * @type {string}
     * @memberof MarketingEvidenceDto
     */
    'groupLabel': string | null;
    /**
     *
     * @type {string}
     * @memberof MarketingEvidenceDto
     */
    'quality': MarketingEvidenceDtoQualityEnum;
}

export const MarketingEvidenceDtoSourceEnum = {
    Ga4: 'ga4',
    GoogleAds: 'google_ads'
} as const;

export type MarketingEvidenceDtoSourceEnum = typeof MarketingEvidenceDtoSourceEnum[keyof typeof MarketingEvidenceDtoSourceEnum];
export const MarketingEvidenceDtoUnitEnum = {
    Count: 'count',
    Ratio: 'ratio',
    Currency: 'currency'
} as const;

export type MarketingEvidenceDtoUnitEnum = typeof MarketingEvidenceDtoUnitEnum[keyof typeof MarketingEvidenceDtoUnitEnum];
export const MarketingEvidenceDtoPeriodEnum = {
    Current: 'current',
    Previous: 'previous'
} as const;

export type MarketingEvidenceDtoPeriodEnum = typeof MarketingEvidenceDtoPeriodEnum[keyof typeof MarketingEvidenceDtoPeriodEnum];
export const MarketingEvidenceDtoScopeEnum = {
    Total: 'total',
    Channel: 'channel',
    Campaign: 'campaign'
} as const;

export type MarketingEvidenceDtoScopeEnum = typeof MarketingEvidenceDtoScopeEnum[keyof typeof MarketingEvidenceDtoScopeEnum];
export const MarketingEvidenceDtoQualityEnum = {
    Complete: 'complete'
} as const;

export type MarketingEvidenceDtoQualityEnum = typeof MarketingEvidenceDtoQualityEnum[keyof typeof MarketingEvidenceDtoQualityEnum];

/**
 *
 * @export
 * @interface MarketingInsightDto
 */
export interface MarketingInsightDto {
    /**
     *
     * @type {string}
     * @memberof MarketingInsightDto
     */
    'priority': MarketingInsightDtoPriorityEnum;
    /**
     *
     * @type {string}
     * @memberof MarketingInsightDto
     */
    'title': string;
    /**
     *
     * @type {string}
     * @memberof MarketingInsightDto
     */
    'observation': string;
    /**
     *
     * @type {string}
     * @memberof MarketingInsightDto
     */
    'hypothesis': string;
    /**
     *
     * @type {string}
     * @memberof MarketingInsightDto
     */
    'nextTest': string;
    /**
     *
     * @type {string}
     * @memberof MarketingInsightDto
     */
    'successMetric': string;
    /**
     *
     * @type {Array<string>}
     * @memberof MarketingInsightDto
     */
    'caveats': Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof MarketingInsightDto
     */
    'evidenceIds': Array<string>;
}

export const MarketingInsightDtoPriorityEnum = {
    High: 'high',
    Medium: 'medium',
    Low: 'low'
} as const;

export type MarketingInsightDtoPriorityEnum = typeof MarketingInsightDtoPriorityEnum[keyof typeof MarketingInsightDtoPriorityEnum];

/**
 *
 * @export
 * @interface MarketingPeriodDto
 */
export interface MarketingPeriodDto {
    /**
     *
     * @type {string}
     * @memberof MarketingPeriodDto
     */
    'startDate': string;
    /**
     *
     * @type {string}
     * @memberof MarketingPeriodDto
     */
    'endDate': string;
}
/**
 *
 * @export
 * @interface MarketingReportDto
 */
export interface MarketingReportDto {
    /**
     *
     * @type {string}
     * @memberof MarketingReportDto
     */
    'reportId': string;
    /**
     *
     * @type {string}
     * @memberof MarketingReportDto
     */
    'generatedAt': string;
    /**
     *
     * @type {string}
     * @memberof MarketingReportDto
     */
    'expiresAt': string;
    /**
     *
     * @type {MarketingSnapshotDto}
     * @memberof MarketingReportDto
     */
    'current': MarketingSnapshotDto;
    /**
     *
     * @type {MarketingSnapshotDto}
     * @memberof MarketingReportDto
     */
    'previous'?: MarketingSnapshotDto | null;
    /**
     *
     * @type {Array<string>}
     * @memberof MarketingReportDto
     */
    'caveats': Array<string>;
}
/**
 *
 * @export
 * @interface MarketingReportRequestDto
 */
export interface MarketingReportRequestDto {
    /**
     *
     * @type {string}
     * @memberof MarketingReportRequestDto
     */
    'startDate': string;
    /**
     *
     * @type {string}
     * @memberof MarketingReportRequestDto
     */
    'endDate': string;
    /**
     *
     * @type {boolean}
     * @memberof MarketingReportRequestDto
     */
    'comparePrevious'?: boolean;
}
/**
 *
 * @export
 * @interface MarketingSnapshotDto
 */
export interface MarketingSnapshotDto {
    /**
     *
     * @type {MarketingPeriodDto}
     * @memberof MarketingSnapshotDto
     */
    'period': MarketingPeriodDto;
    /**
     *
     * @type {MarketingTotalsDto}
     * @memberof MarketingSnapshotDto
     */
    'totals': MarketingTotalsDto;
    /**
     *
     * @type {Array<MarketingDailyDto>}
     * @memberof MarketingSnapshotDto
     */
    'daily': Array<MarketingDailyDto>;
    /**
     *
     * @type {Array<MarketingChannelDto>}
     * @memberof MarketingSnapshotDto
     */
    'channels': Array<MarketingChannelDto>;
    /**
     *
     * @type {Array<MarketingCampaignDto>}
     * @memberof MarketingSnapshotDto
     */
    'campaigns': Array<MarketingCampaignDto>;
    /**
     *
     * @type {Array<MarketingSourceStatusDto>}
     * @memberof MarketingSnapshotDto
     */
    'sources': Array<MarketingSourceStatusDto>;
}
/**
 *
 * @export
 * @interface MarketingSourceStatusDto
 */
export interface MarketingSourceStatusDto {
    /**
     *
     * @type {string}
     * @memberof MarketingSourceStatusDto
     */
    'scopeDescription': string;
    /**
     *
     * @type {string}
     * @memberof MarketingSourceStatusDto
     */
    'source': MarketingSourceStatusDtoSourceEnum;
    /**
     *
     * @type {string}
     * @memberof MarketingSourceStatusDto
     */
    'state': MarketingSourceStatusDtoStateEnum;
    /**
     *
     * @type {string}
     * @memberof MarketingSourceStatusDto
     */
    'message': string;
    /**
     *
     * @type {string}
     * @memberof MarketingSourceStatusDto
     */
    'fetchedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof MarketingSourceStatusDto
     */
    'timeZone': string | null;
    /**
     *
     * @type {string}
     * @memberof MarketingSourceStatusDto
     */
    'currency': string | null;
    /**
     *
     * @type {Array<string>}
     * @memberof MarketingSourceStatusDto
     */
    'qualityFlags': Array<string>;
}

export const MarketingSourceStatusDtoSourceEnum = {
    Ga4: 'ga4',
    GoogleAds: 'google_ads'
} as const;

export type MarketingSourceStatusDtoSourceEnum = typeof MarketingSourceStatusDtoSourceEnum[keyof typeof MarketingSourceStatusDtoSourceEnum];
export const MarketingSourceStatusDtoStateEnum = {
    Ready: 'ready',
    Partial: 'partial',
    NotConfigured: 'not_configured',
    Unavailable: 'unavailable'
} as const;

export type MarketingSourceStatusDtoStateEnum = typeof MarketingSourceStatusDtoStateEnum[keyof typeof MarketingSourceStatusDtoStateEnum];

/**
 *
 * @export
 * @interface MarketingTotalsDto
 */
export interface MarketingTotalsDto {
    /**
     *
     * @type {number}
     * @memberof MarketingTotalsDto
     */
    'sessions': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingTotalsDto
     */
    'engagedSessions': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingTotalsDto
     */
    'engagementRate': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingTotalsDto
     */
    'contacts': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingTotalsDto
     */
    'professionalSignups': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingTotalsDto
     */
    'registrationStarts': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingTotalsDto
     */
    'adSpend': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingTotalsDto
     */
    'adClicks': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingTotalsDto
     */
    'adImpressions': number | null;
    /**
     *
     * @type {number}
     * @memberof MarketingTotalsDto
     */
    'observedCostPerContact': number | null;
}
/**
 *
 * @export
 * @interface MedicationDosingSuggestionDto
 */
export interface MedicationDosingSuggestionDto {
    /**
     *
     * @type {number}
     * @memberof MedicationDosingSuggestionDto
     */
    'strengthValue'?: number;
    /**
     *
     * @type {string}
     * @memberof MedicationDosingSuggestionDto
     */
    'strengthUnit'?: MedicationDosingSuggestionDtoStrengthUnitEnum;
    /**
     *
     * @type {string}
     * @memberof MedicationDosingSuggestionDto
     */
    'strengthUnitCustom'?: string;
    /**
     *
     * @type {string}
     * @memberof MedicationDosingSuggestionDto
     */
    'form'?: MedicationDosingSuggestionDtoFormEnum;
    /**
     *
     * @type {string}
     * @memberof MedicationDosingSuggestionDto
     */
    'formCustom'?: string;
    /**
     *
     * @type {number}
     * @memberof MedicationDosingSuggestionDto
     */
    'quantityValue'?: number;
    /**
     *
     * @type {string}
     * @memberof MedicationDosingSuggestionDto
     */
    'quantityCustom'?: string;
    /**
     *
     * @type {string}
     * @memberof MedicationDosingSuggestionDto
     */
    'frequencyType'?: MedicationDosingSuggestionDtoFrequencyTypeEnum;
    /**
     *
     * @type {number}
     * @memberof MedicationDosingSuggestionDto
     */
    'frequencyValue'?: number;
    /**
     *
     * @type {string}
     * @memberof MedicationDosingSuggestionDto
     */
    'frequencyCustom'?: string;
    /**
     *
     * @type {string}
     * @memberof MedicationDosingSuggestionDto
     */
    'durationType'?: MedicationDosingSuggestionDtoDurationTypeEnum;
    /**
     *
     * @type {number}
     * @memberof MedicationDosingSuggestionDto
     */
    'durationValue'?: number;
    /**
     *
     * @type {string}
     * @memberof MedicationDosingSuggestionDto
     */
    'durationCustom'?: string;
    /**
     *
     * @type {string}
     * @memberof MedicationDosingSuggestionDto
     */
    'dosageSchedule'?: string;
    /**
     * When that course started, else when it was recorded
     * @type {string}
     * @memberof MedicationDosingSuggestionDto
     */
    'prescribedAt': string;
    /**
     * Species of that Medication\'s patient; absent when the patient no longer exists
     * @type {string}
     * @memberof MedicationDosingSuggestionDto
     */
    'petCategory'?: MedicationDosingSuggestionDtoPetCategoryEnum;
    /**
     * That patient is of the same species as the one being prescribed for
     * @type {boolean}
     * @memberof MedicationDosingSuggestionDto
     */
    'sameSpecies': boolean;
}

export const MedicationDosingSuggestionDtoStrengthUnitEnum = {
    Mg: 'MG',
    G: 'G',
    Mcg: 'MCG',
    Ml: 'ML',
    Iu: 'IU',
    Percent: 'PERCENT',
    None: 'NONE',
    Other: 'OTHER'
} as const;

export type MedicationDosingSuggestionDtoStrengthUnitEnum = typeof MedicationDosingSuggestionDtoStrengthUnitEnum[keyof typeof MedicationDosingSuggestionDtoStrengthUnitEnum];
export const MedicationDosingSuggestionDtoFormEnum = {
    Tablet: 'TABLET',
    Capsule: 'CAPSULE',
    Sachet: 'SACHET',
    Suspension: 'SUSPENSION',
    Solution: 'SOLUTION',
    Drops: 'DROPS',
    Injection: 'INJECTION',
    Ointment: 'OINTMENT',
    SpotOn: 'SPOT_ON',
    Spray: 'SPRAY',
    Powder: 'POWDER',
    Paste: 'PASTE',
    Other: 'OTHER'
} as const;

export type MedicationDosingSuggestionDtoFormEnum = typeof MedicationDosingSuggestionDtoFormEnum[keyof typeof MedicationDosingSuggestionDtoFormEnum];
export const MedicationDosingSuggestionDtoFrequencyTypeEnum = {
    TimesPerDay: 'TIMES_PER_DAY',
    EveryNHours: 'EVERY_N_HOURS',
    EveryNDays: 'EVERY_N_DAYS',
    TimesPerWeek: 'TIMES_PER_WEEK',
    TimesPerMonth: 'TIMES_PER_MONTH',
    AsNeeded: 'AS_NEEDED',
    Other: 'OTHER'
} as const;

export type MedicationDosingSuggestionDtoFrequencyTypeEnum = typeof MedicationDosingSuggestionDtoFrequencyTypeEnum[keyof typeof MedicationDosingSuggestionDtoFrequencyTypeEnum];
export const MedicationDosingSuggestionDtoDurationTypeEnum = {
    UntilFurtherNotice: 'UNTIL_FURTHER_NOTICE',
    Days: 'DAYS',
    Weeks: 'WEEKS',
    UntilFollowUp: 'UNTIL_FOLLOW_UP',
    SingleDose: 'SINGLE_DOSE',
    Other: 'OTHER'
} as const;

export type MedicationDosingSuggestionDtoDurationTypeEnum = typeof MedicationDosingSuggestionDtoDurationTypeEnum[keyof typeof MedicationDosingSuggestionDtoDurationTypeEnum];
export const MedicationDosingSuggestionDtoPetCategoryEnum = {
    Dog: 'dog',
    Cat: 'cat',
    Other: 'other'
} as const;

export type MedicationDosingSuggestionDtoPetCategoryEnum = typeof MedicationDosingSuggestionDtoPetCategoryEnum[keyof typeof MedicationDosingSuggestionDtoPetCategoryEnum];

/**
 *
 * @export
 * @interface MedicationEventDto
 */
export interface MedicationEventDto {
    /**
     *
     * @type {string}
     * @memberof MedicationEventDto
     */
    'type': MedicationEventDtoTypeEnum;
    /**
     *
     * @type {string}
     * @memberof MedicationEventDto
     */
    'at': string;
    /**
     * Free-text note on the entry
     * @type {string}
     * @memberof MedicationEventDto
     */
    'note'?: string;
    /**
     * Visit the change was made on
     * @type {string}
     * @memberof MedicationEventDto
     */
    'visitId'?: string;
    /**
     * Fields that moved, before and after
     * @type {{ [key: string]: any; }}
     * @memberof MedicationEventDto
     */
    'changes'?: { [key: string]: any; };
    /**
     * Who made the change
     * @type {string}
     * @memberof MedicationEventDto
     */
    'authorName'?: string;
    /**
     *
     * @type {string}
     * @memberof MedicationEventDto
     */
    'authorOrganizationName'?: string;
    /**
     * Avatar of who made the change
     * @type {string}
     * @memberof MedicationEventDto
     */
    'authorAvatar'?: string;
}

export const MedicationEventDtoTypeEnum = {
    Created: 'CREATED',
    Edited: 'EDITED',
    DosageChanged: 'DOSAGE_CHANGED',
    Paused: 'PAUSED',
    Resumed: 'RESUMED',
    Stopped: 'STOPPED',
    Started: 'STARTED'
} as const;

export type MedicationEventDtoTypeEnum = typeof MedicationEventDtoTypeEnum[keyof typeof MedicationEventDtoTypeEnum];

/**
 *
 * @export
 * @interface MedicationStockInputDto
 */
export interface MedicationStockInputDto {
    /**
     * Warehouse Product (DRUG) id
     * @type {string}
     * @memberof MedicationStockInputDto
     */
    'productId': string;
    /**
     * Quantity in the given measure, at most 3 decimals
     * @type {number}
     * @memberof MedicationStockInputDto
     */
    'quantity': number;
    /**
     *
     * @type {WarehouseQuantityMeasure}
     * @memberof MedicationStockInputDto
     */
    'measure': WarehouseQuantityMeasure;
    /**
     *
     * @type {WarehouseHandover}
     * @memberof MedicationStockInputDto
     */
    'handover': WarehouseHandover;
    /**
     * Pinned Batch; omitted means FEFO
     * @type {string}
     * @memberof MedicationStockInputDto
     */
    'batchId'?: string | null;
    /**
     * Handed-over Rx only: whether a prescription was issued (filled at the Facility)
     * @type {boolean}
     * @memberof MedicationStockInputDto
     */
    'prescriptionIssued'?: boolean;
    /**
     * Handed-over only: who received the drug. Omitted or blank records the registered owner or the guest contact; with neither the write is 422 RECIPIENT_REQUIRED
     * @type {string}
     * @memberof MedicationStockInputDto
     */
    'recipientName'?: string;
    /**
     * Handed-over only: the recipient\'s address. Omitted or blank records the registered owner\'s profile address when the owner received the drug; a handed-over Rx drug with no address is 422 RECIPIENT_ADDRESS_REQUIRED
     * @type {string}
     * @memberof MedicationStockInputDto
     */
    'recipientAddress'?: string;
}


/**
 *
 * @export
 * @interface MedicationStockIssueDto
 */
export interface MedicationStockIssueDto {
    /**
     * Issue id (the movements’ lineId)
     * @type {string}
     * @memberof MedicationStockIssueDto
     */
    'id': string;
    /**
     *
     * @type {WarehouseStockIssueOrigin}
     * @memberof MedicationStockIssueDto
     */
    'origin': WarehouseStockIssueOrigin;
    /**
     * Performed Treatment, for TREATMENT issues
     * @type {string}
     * @memberof MedicationStockIssueDto
     */
    'treatmentRecordId'?: string;
    /**
     * Warehouse Product id
     * @type {string}
     * @memberof MedicationStockIssueDto
     */
    'productId': string;
    /**
     * Thousandths of a Unit taken
     * @type {number}
     * @memberof MedicationStockIssueDto
     */
    'quantityMilli': number;
    /**
     *
     * @type {WarehouseHandover}
     * @memberof MedicationStockIssueDto
     */
    'handover': WarehouseHandover;
    /**
     * Pinned Batch, if any
     * @type {string}
     * @memberof MedicationStockIssueDto
     */
    'batchId'?: string;
    /**
     *
     * @type {boolean}
     * @memberof MedicationStockIssueDto
     */
    'prescriptionIssued'?: boolean;
    /**
     * Handed-over only: the recipient supplied when the issue was saved
     * @type {string}
     * @memberof MedicationStockIssueDto
     */
    'recipientName'?: string;
    /**
     * Handed-over only: the recipient\'s address supplied when the issue was saved
     * @type {string}
     * @memberof MedicationStockIssueDto
     */
    'recipientAddress'?: string;
    /**
     * Visit the issue belongs to
     * @type {string}
     * @memberof MedicationStockIssueDto
     */
    'visitId'?: string;
    /**
     * Business date of the issue (ISO date-time)
     * @type {string}
     * @memberof MedicationStockIssueDto
     */
    'occurredAt': string;
}


/**
 *
 * @export
 * @interface MedicineControllerSearchMedicines200Response
 */
export interface MedicineControllerSearchMedicines200Response {
    /**
     *
     * @type {Array<GetMedicineDto>}
     * @memberof MedicineControllerSearchMedicines200Response
     */
    'medicines'?: Array<GetMedicineDto>;
    /**
     *
     * @type {number}
     * @memberof MedicineControllerSearchMedicines200Response
     */
    'total'?: number;
}
/**
 *
 * @export
 * @interface OrderDto
 */
export interface OrderDto {
    /**
     *
     * @type {number}
     * @memberof OrderDto
     */
    'id': number;
    /**
     *
     * @type {string}
     * @memberof OrderDto
     */
    'returnUrl': string;
}
/**
 *
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     *
     * @type {string}
     * @memberof Organization
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof Organization
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof Organization
     */
    'logoUrl': string;
    /**
     *
     * @type {string}
     * @memberof Organization
     */
    'street': string;
    /**
     *
     * @type {string}
     * @memberof Organization
     */
    'zip': string;
    /**
     *
     * @type {string}
     * @memberof Organization
     */
    'city': string;
    /**
     *
     * @type {string}
     * @memberof Organization
     */
    'phoneNumber': string;
    /**
     *
     * @type {string}
     * @memberof Organization
     */
    'email'?: string;
    /**
     *
     * @type {string}
     * @memberof Organization
     */
    'slug'?: string;
}
/**
 *
 * @export
 * @interface OrganizationAvailabilitySlotDto
 */
export interface OrganizationAvailabilitySlotDto {
    /**
     * Day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
     * @type {number}
     * @memberof OrganizationAvailabilitySlotDto
     */
    'weekday': number;
    /**
     * Start time in HH:MM format
     * @type {string}
     * @memberof OrganizationAvailabilitySlotDto
     */
    'start': string;
    /**
     * End time in HH:MM format
     * @type {string}
     * @memberof OrganizationAvailabilitySlotDto
     */
    'end': string;
    /**
     * Optional visit types for this slot
     * @type {Array<string>}
     * @memberof OrganizationAvailabilitySlotDto
     */
    'visitTypes'?: Array<string>;
}
/**
 *
 * @export
 * @interface OrganizationInUserDto
 */
export interface OrganizationInUserDto {
    /**
     *
     * @type {string}
     * @memberof OrganizationInUserDto
     */
    'organization': string;
    /**
     *
     * @type {Array<string>}
     * @memberof OrganizationInUserDto
     */
    'roles': Array<OrganizationInUserDtoRolesEnum>;
}

export const OrganizationInUserDtoRolesEnum = {
    Admin: 'ADMIN',
    Professional: 'PROFESSIONAL',
    User: 'USER',
    OrganizationAdmin: 'ORGANIZATION_ADMIN',
    OrganizationOwner: 'ORGANIZATION_OWNER'
} as const;

export type OrganizationInUserDtoRolesEnum = typeof OrganizationInUserDtoRolesEnum[keyof typeof OrganizationInUserDtoRolesEnum];

/**
 *
 * @export
 * @interface OrganizationRatingStatsDto
 */
export interface OrganizationRatingStatsDto {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationRatingStatsDto
     */
    'organizationId': string;
    /**
     * Average rating for the organization
     * @type {number}
     * @memberof OrganizationRatingStatsDto
     */
    'averageRating': number;
    /**
     * Total number of ratings
     * @type {number}
     * @memberof OrganizationRatingStatsDto
     */
    'totalRatings': number;
    /**
     * Distribution of ratings (1-5 stars)
     * @type {object}
     * @memberof OrganizationRatingStatsDto
     */
    'ratingDistribution': object;
}
/**
 *
 * @export
 * @interface OrganizationServiceBookingPolicyResponseDto
 */
export interface OrganizationServiceBookingPolicyResponseDto {
    /**
     *
     * @type {string}
     * @memberof OrganizationServiceBookingPolicyResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof OrganizationServiceBookingPolicyResponseDto
     */
    'serviceId': string;
    /**
     *
     * @type {string}
     * @memberof OrganizationServiceBookingPolicyResponseDto
     */
    'paymentTiming': OrganizationServiceBookingPolicyResponseDtoPaymentTimingEnum;
    /**
     *
     * @type {string}
     * @memberof OrganizationServiceBookingPolicyResponseDto
     */
    'confirmationPolicy': OrganizationServiceBookingPolicyResponseDtoConfirmationPolicyEnum;
    /**
     *
     * @type {number}
     * @memberof OrganizationServiceBookingPolicyResponseDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof OrganizationServiceBookingPolicyResponseDto
     */
    'updatedAt': string;
}

export const OrganizationServiceBookingPolicyResponseDtoPaymentTimingEnum = {
    AtFacility: 'AT_FACILITY',
    OnlineRequired: 'ONLINE_REQUIRED'
} as const;

export type OrganizationServiceBookingPolicyResponseDtoPaymentTimingEnum = typeof OrganizationServiceBookingPolicyResponseDtoPaymentTimingEnum[keyof typeof OrganizationServiceBookingPolicyResponseDtoPaymentTimingEnum];
export const OrganizationServiceBookingPolicyResponseDtoConfirmationPolicyEnum = {
    AutoConfirm: 'AUTO_CONFIRM',
    RequiresApproval: 'REQUIRES_APPROVAL'
} as const;

export type OrganizationServiceBookingPolicyResponseDtoConfirmationPolicyEnum = typeof OrganizationServiceBookingPolicyResponseDtoConfirmationPolicyEnum[keyof typeof OrganizationServiceBookingPolicyResponseDtoConfirmationPolicyEnum];

/**
 *
 * @export
 * @interface OrganizationStatisticsDto
 */
export interface OrganizationStatisticsDto {
    /**
     *
     * @type {string}
     * @memberof OrganizationStatisticsDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof OrganizationStatisticsDto
     */
    'calculatedAt': string;
    /**
     *
     * @type {string}
     * @memberof OrganizationStatisticsDto
     */
    'timezone': string;
    /**
     *
     * @type {StatisticsIntervalDto}
     * @memberof OrganizationStatisticsDto
     */
    'currentInterval': StatisticsIntervalDto;
    /**
     *
     * @type {StatisticsIntervalDto}
     * @memberof OrganizationStatisticsDto
     */
    'comparisonInterval'?: StatisticsIntervalDto | null;
    /**
     *
     * @type {StatisticsCountsDto}
     * @memberof OrganizationStatisticsDto
     */
    'current': StatisticsCountsDto;
    /**
     *
     * @type {StatisticsCountsDto}
     * @memberof OrganizationStatisticsDto
     */
    'comparison'?: StatisticsCountsDto | null;
    /**
     *
     * @type {Array<StatisticsStatusDto>}
     * @memberof OrganizationStatisticsDto
     */
    'statusCounts': Array<StatisticsStatusDto>;
    /**
     *
     * @type {number}
     * @memberof OrganizationStatisticsDto
     */
    'overdueOpenVisits': number;
    /**
     *
     * @type {Array<StatisticsPointDto>}
     * @memberof OrganizationStatisticsDto
     */
    'daily': Array<StatisticsPointDto>;
    /**
     *
     * @type {Array<StatisticsPointDto>}
     * @memberof OrganizationStatisticsDto
     */
    'weekly': Array<StatisticsPointDto>;
    /**
     *
     * @type {Array<StatisticsPointDto>}
     * @memberof OrganizationStatisticsDto
     */
    'monthly': Array<StatisticsPointDto>;
    /**
     *
     * @type {StatisticsPatientsDto}
     * @memberof OrganizationStatisticsDto
     */
    'patientComposition': StatisticsPatientsDto;
    /**
     *
     * @type {Array<StatisticsServiceDto>}
     * @memberof OrganizationStatisticsDto
     */
    'services': Array<StatisticsServiceDto>;
    /**
     *
     * @type {Array<StatisticsHeatmapCellDto>}
     * @memberof OrganizationStatisticsDto
     */
    'heatmap': Array<StatisticsHeatmapCellDto>;
    /**
     *
     * @type {Array<StatisticsSpecialistDto>}
     * @memberof OrganizationStatisticsDto
     */
    'specialists': Array<StatisticsSpecialistDto>;
    /**
     *
     * @type {StatisticsCountsDto}
     * @memberof OrganizationStatisticsDto
     */
    'specialistTotals': StatisticsCountsDto;
    /**
     *
     * @type {StatisticsDataQualityDto}
     * @memberof OrganizationStatisticsDto
     */
    'dataQuality': StatisticsDataQualityDto;
    /**
     *
     * @type {string}
     * @memberof OrganizationStatisticsDto
     */
    'periodStart': string;
    /**
     *
     * @type {string}
     * @memberof OrganizationStatisticsDto
     */
    'periodEnd': string;
    /**
     *
     * @type {number}
     * @memberof OrganizationStatisticsDto
     */
    'totalVisits': number;
    /**
     *
     * @type {number}
     * @memberof OrganizationStatisticsDto
     */
    'completedVisits': number;
    /**
     *
     * @type {number}
     * @memberof OrganizationStatisticsDto
     */
    'cancelledVisits': number;
    /**
     *
     * @type {number}
     * @memberof OrganizationStatisticsDto
     */
    'pendingApprovalVisits': number;
    /**
     *
     * @type {number}
     * @memberof OrganizationStatisticsDto
     */
    'completedToCancelledRatio': number;
    /**
     *
     * @type {number}
     * @memberof OrganizationStatisticsDto
     */
    'visitCompletionRate': number;
    /**
     *
     * @type {number}
     * @memberof OrganizationStatisticsDto
     */
    'averageRating'?: number | null;
    /**
     *
     * @type {Array<LegacyVisitTypeDto>}
     * @memberof OrganizationStatisticsDto
     */
    'visitTypeStats': Array<LegacyVisitTypeDto>;
    /**
     *
     * @type {Array<LegacyProfessionalDto>}
     * @memberof OrganizationStatisticsDto
     */
    'professionalStats': Array<LegacyProfessionalDto>;
    /**
     *
     * @type {Array<LegacyHourlyDto>}
     * @memberof OrganizationStatisticsDto
     */
    'peakHours': Array<LegacyHourlyDto>;
    /**
     *
     * @type {Array<LegacyDailyDto>}
     * @memberof OrganizationStatisticsDto
     */
    'visitsOverTime': Array<LegacyDailyDto>;
    /**
     *
     * @type {LegacyStatusDistributionDto}
     * @memberof OrganizationStatisticsDto
     */
    'statusDistribution': LegacyStatusDistributionDto;
    /**
     *
     * @type {LegacyPatientStatsDto}
     * @memberof OrganizationStatisticsDto
     */
    'patientStats': LegacyPatientStatsDto;
    /**
     *
     * @type {string}
     * @memberof OrganizationStatisticsDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof OrganizationStatisticsDto
     */
    'updatedAt': string;
}
/**
 *
 * @export
 * @interface OutreachAuditDto
 */
export interface OutreachAuditDto {
    /**
     *
     * @type {string}
     * @memberof OutreachAuditDto
     */
    'at': string;
    /**
     *
     * @type {string}
     * @memberof OutreachAuditDto
     */
    'actor': string;
    /**
     *
     * @type {string}
     * @memberof OutreachAuditDto
     */
    'action': string;
    /**
     *
     * @type {string}
     * @memberof OutreachAuditDto
     */
    'value': string;
    /**
     *
     * @type {string}
     * @memberof OutreachAuditDto
     */
    'reason': string;
}
/**
 *
 * @export
 * @interface OutreachCampaignActionDto
 */
export interface OutreachCampaignActionDto {
    /**
     *
     * @type {number}
     * @memberof OutreachCampaignActionDto
     */
    'version': number;
}
/**
 *
 * @export
 * @interface OutreachCampaignCreateDto
 */
export interface OutreachCampaignCreateDto {
    /**
     *
     * @type {string}
     * @memberof OutreachCampaignCreateDto
     */
    'name': string;
    /**
     *
     * @type {Array<string>}
     * @memberof OutreachCampaignCreateDto
     */
    'contactIds'?: Array<string>;
}
/**
 *
 * @export
 * @interface OutreachCampaignDto
 */
export interface OutreachCampaignDto {
    /**
     *
     * @type {string}
     * @memberof OutreachCampaignDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof OutreachCampaignDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof OutreachCampaignDto
     */
    'state': OutreachCampaignDtoStateEnum;
    /**
     *
     * @type {number}
     * @memberof OutreachCampaignDto
     */
    'version': number;
    /**
     *
     * @type {string}
     * @memberof OutreachCampaignDto
     */
    'mailboxId'?: string | null;
    /**
     *
     * @type {string}
     * @memberof OutreachCampaignDto
     */
    'sender': string;
    /**
     *
     * @type {string}
     * @memberof OutreachCampaignDto
     */
    'subject': string;
    /**
     *
     * @type {string}
     * @memberof OutreachCampaignDto
     */
    'text': string;
    /**
     *
     * @type {Array<OutreachRecipientDto>}
     * @memberof OutreachCampaignDto
     */
    'recipients': Array<OutreachRecipientDto>;
    /**
     *
     * @type {Array<string>}
     * @memberof OutreachCampaignDto
     */
    'warnings': Array<string>;
    /**
     *
     * @type {string}
     * @memberof OutreachCampaignDto
     */
    'createdAt': string;
    /**
     *
     * @type {number}
     * @memberof OutreachCampaignDto
     */
    'queued': number;
    /**
     *
     * @type {number}
     * @memberof OutreachCampaignDto
     */
    'accepted': number;
    /**
     *
     * @type {number}
     * @memberof OutreachCampaignDto
     */
    'replied': number;
    /**
     *
     * @type {number}
     * @memberof OutreachCampaignDto
     */
    'needsReview': number;
}

export const OutreachCampaignDtoStateEnum = {
    Draft: 'DRAFT',
    Sending: 'SENDING',
    Paused: 'PAUSED',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED'
} as const;

export type OutreachCampaignDtoStateEnum = typeof OutreachCampaignDtoStateEnum[keyof typeof OutreachCampaignDtoStateEnum];

/**
 *
 * @export
 * @interface OutreachCampaignPageDto
 */
export interface OutreachCampaignPageDto {
    /**
     *
     * @type {Array<OutreachCampaignDto>}
     * @memberof OutreachCampaignPageDto
     */
    'items': Array<OutreachCampaignDto>;
    /**
     *
     * @type {number}
     * @memberof OutreachCampaignPageDto
     */
    'total': number;
}
/**
 *
 * @export
 * @interface OutreachCampaignUpdateDto
 */
export interface OutreachCampaignUpdateDto {
    /**
     *
     * @type {number}
     * @memberof OutreachCampaignUpdateDto
     */
    'version': number;
    /**
     *
     * @type {string}
     * @memberof OutreachCampaignUpdateDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof OutreachCampaignUpdateDto
     */
    'mailboxId'?: string;
    /**
     *
     * @type {string}
     * @memberof OutreachCampaignUpdateDto
     */
    'sender': string;
    /**
     *
     * @type {string}
     * @memberof OutreachCampaignUpdateDto
     */
    'subject': string;
    /**
     *
     * @type {string}
     * @memberof OutreachCampaignUpdateDto
     */
    'text': string;
    /**
     *
     * @type {Array<OutreachRecipientInputDto>}
     * @memberof OutreachCampaignUpdateDto
     */
    'recipients': Array<OutreachRecipientInputDto>;
}
/**
 *
 * @export
 * @interface OutreachContactDto
 */
export interface OutreachContactDto {
    /**
     *
     * @type {string}
     * @memberof OutreachContactDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof OutreachContactDto
     */
    'email': string;
    /**
     *
     * @type {string}
     * @memberof OutreachContactDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof OutreachContactDto
     */
    'interest': OutreachContactDtoInterestEnum;
    /**
     *
     * @type {string}
     * @memberof OutreachContactDto
     */
    'eligibility': OutreachContactDtoEligibilityEnum;
    /**
     *
     * @type {string}
     * @memberof OutreachContactDto
     */
    'eligibilityBasis': string;
    /**
     *
     * @type {boolean}
     * @memberof OutreachContactDto
     */
    'doNotContact': boolean;
    /**
     *
     * @type {boolean}
     * @memberof OutreachContactDto
     */
    'blocked': boolean;
    /**
     *
     * @type {string}
     * @memberof OutreachContactDto
     */
    'notes': string;
    /**
     *
     * @type {Array<OutreachProspectDto>}
     * @memberof OutreachContactDto
     */
    'prospects': Array<OutreachProspectDto>;
    /**
     *
     * @type {Array<OutreachAuditDto>}
     * @memberof OutreachContactDto
     */
    'history': Array<OutreachAuditDto>;
    /**
     *
     * @type {boolean}
     * @memberof OutreachContactDto
     */
    'previouslyContacted': boolean;
}

export const OutreachContactDtoInterestEnum = {
    New: 'NEW',
    InDiscussion: 'IN_DISCUSSION',
    Interested: 'INTERESTED',
    NotInterested: 'NOT_INTERESTED'
} as const;

export type OutreachContactDtoInterestEnum = typeof OutreachContactDtoInterestEnum[keyof typeof OutreachContactDtoInterestEnum];
export const OutreachContactDtoEligibilityEnum = {
    Unknown: 'UNKNOWN',
    Eligible: 'ELIGIBLE'
} as const;

export type OutreachContactDtoEligibilityEnum = typeof OutreachContactDtoEligibilityEnum[keyof typeof OutreachContactDtoEligibilityEnum];

/**
 *
 * @export
 * @interface OutreachContactImportDto
 */
export interface OutreachContactImportDto {
    /**
     *
     * @type {string}
     * @memberof OutreachContactImportDto
     */
    'text': string;
    /**
     *
     * @type {string}
     * @memberof OutreachContactImportDto
     */
    'format': OutreachContactImportDtoFormatEnum;
}

export const OutreachContactImportDtoFormatEnum = {
    Paste: 'PASTE',
    Csv: 'CSV'
} as const;

export type OutreachContactImportDtoFormatEnum = typeof OutreachContactImportDtoFormatEnum[keyof typeof OutreachContactImportDtoFormatEnum];

/**
 *
 * @export
 * @interface OutreachContactImportResultDto
 */
export interface OutreachContactImportResultDto {
    /**
     *
     * @type {Array<OutreachContactDto>}
     * @memberof OutreachContactImportResultDto
     */
    'contacts': Array<OutreachContactDto>;
    /**
     *
     * @type {Array<string>}
     * @memberof OutreachContactImportResultDto
     */
    'invalid': Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof OutreachContactImportResultDto
     */
    'duplicates': Array<string>;
}
/**
 *
 * @export
 * @interface OutreachContactPageDto
 */
export interface OutreachContactPageDto {
    /**
     *
     * @type {Array<OutreachContactDto>}
     * @memberof OutreachContactPageDto
     */
    'items': Array<OutreachContactDto>;
    /**
     *
     * @type {number}
     * @memberof OutreachContactPageDto
     */
    'total': number;
}
/**
 *
 * @export
 * @interface OutreachContactResearchDto
 */
export interface OutreachContactResearchDto {
    /**
     *
     * @type {string}
     * @memberof OutreachContactResearchDto
     */
    'status': OutreachContactResearchDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof OutreachContactResearchDto
     */
    'checkedAt': string;
    /**
     *
     * @type {Array<OutreachEmailEvidenceDto>}
     * @memberof OutreachContactResearchDto
     */
    'evidence': Array<OutreachEmailEvidenceDto>;
}

export const OutreachContactResearchDtoStatusEnum = {
    Verified: 'verified',
    NoPublicEmail: 'no_public_email',
    Ambiguous: 'ambiguous',
    NoMatch: 'no_match',
    Blocked: 'blocked',
    TransientError: 'transient_error',
    QuotaDeferred: 'quota_deferred'
} as const;

export type OutreachContactResearchDtoStatusEnum = typeof OutreachContactResearchDtoStatusEnum[keyof typeof OutreachContactResearchDtoStatusEnum];

/**
 *
 * @export
 * @interface OutreachContactRestrictionDto
 */
export interface OutreachContactRestrictionDto {
    /**
     *
     * @type {boolean}
     * @memberof OutreachContactRestrictionDto
     */
    'doNotContact': boolean;
    /**
     *
     * @type {string}
     * @memberof OutreachContactRestrictionDto
     */
    'reason': string;
    /**
     *
     * @type {string}
     * @memberof OutreachContactRestrictionDto
     */
    'prospectId'?: string;
}
/**
 *
 * @export
 * @interface OutreachContactUpdateDto
 */
export interface OutreachContactUpdateDto {
    /**
     *
     * @type {string}
     * @memberof OutreachContactUpdateDto
     */
    'interest'?: OutreachContactUpdateDtoInterestEnum;
    /**
     *
     * @type {string}
     * @memberof OutreachContactUpdateDto
     */
    'notes'?: string;
    /**
     *
     * @type {string}
     * @memberof OutreachContactUpdateDto
     */
    'eligibility'?: OutreachContactUpdateDtoEligibilityEnum;
    /**
     *
     * @type {string}
     * @memberof OutreachContactUpdateDto
     */
    'eligibilityBasis'?: string;
}

export const OutreachContactUpdateDtoInterestEnum = {
    New: 'NEW',
    InDiscussion: 'IN_DISCUSSION',
    Interested: 'INTERESTED',
    NotInterested: 'NOT_INTERESTED'
} as const;

export type OutreachContactUpdateDtoInterestEnum = typeof OutreachContactUpdateDtoInterestEnum[keyof typeof OutreachContactUpdateDtoInterestEnum];
export const OutreachContactUpdateDtoEligibilityEnum = {
    Unknown: 'UNKNOWN',
    Eligible: 'ELIGIBLE'
} as const;

export type OutreachContactUpdateDtoEligibilityEnum = typeof OutreachContactUpdateDtoEligibilityEnum[keyof typeof OutreachContactUpdateDtoEligibilityEnum];

/**
 *
 * @export
 * @interface OutreachConversationDto
 */
export interface OutreachConversationDto {
    /**
     *
     * @type {Array<OutreachMessageDto>}
     * @memberof OutreachConversationDto
     */
    'messages': Array<OutreachMessageDto>;
    /**
     *
     * @type {OutreachContactDto}
     * @memberof OutreachConversationDto
     */
    'contact': OutreachContactDto;
    /**
     *
     * @type {OutreachProspectDto}
     * @memberof OutreachConversationDto
     */
    'prospect'?: OutreachProspectDto;
}
/**
 *
 * @export
 * @interface OutreachEmailEvidenceDto
 */
export interface OutreachEmailEvidenceDto {
    /**
     *
     * @type {string}
     * @memberof OutreachEmailEvidenceDto
     */
    'email': string;
    /**
     *
     * @type {string}
     * @memberof OutreachEmailEvidenceDto
     */
    'sourceUrl': string;
    /**
     *
     * @type {string}
     * @memberof OutreachEmailEvidenceDto
     */
    'fetchedAt': string;
    /**
     *
     * @type {string}
     * @memberof OutreachEmailEvidenceDto
     */
    'contentSha256': string;
    /**
     *
     * @type {Array<string>}
     * @memberof OutreachEmailEvidenceDto
     */
    'matchedFields': Array<string>;
    /**
     *
     * @type {string}
     * @memberof OutreachEmailEvidenceDto
     */
    'method': OutreachEmailEvidenceDtoMethodEnum;
}

export const OutreachEmailEvidenceDtoMethodEnum = {
    Mailto: 'mailto',
    Text: 'text'
} as const;

export type OutreachEmailEvidenceDtoMethodEnum = typeof OutreachEmailEvidenceDtoMethodEnum[keyof typeof OutreachEmailEvidenceDtoMethodEnum];

/**
 *
 * @export
 * @interface OutreachMailboxDto
 */
export interface OutreachMailboxDto {
    /**
     *
     * @type {string}
     * @memberof OutreachMailboxDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof OutreachMailboxDto
     */
    'email': string;
    /**
     *
     * @type {string}
     * @memberof OutreachMailboxDto
     */
    'state': OutreachMailboxDtoStateEnum;
    /**
     *
     * @type {Array<string>}
     * @memberof OutreachMailboxDto
     */
    'senders': Array<string>;
    /**
     *
     * @type {string}
     * @memberof OutreachMailboxDto
     */
    'lastSyncedAt'?: string | null;
    /**
     *
     * @type {string}
     * @memberof OutreachMailboxDto
     */
    'errorCode': string;
    /**
     *
     * @type {string}
     * @memberof OutreachMailboxDto
     */
    'mode': OutreachMailboxDtoModeEnum;
}

export const OutreachMailboxDtoStateEnum = {
    Connected: 'CONNECTED',
    Paused: 'PAUSED',
    Disconnected: 'DISCONNECTED'
} as const;

export type OutreachMailboxDtoStateEnum = typeof OutreachMailboxDtoStateEnum[keyof typeof OutreachMailboxDtoStateEnum];
export const OutreachMailboxDtoModeEnum = {
    Disabled: 'disabled',
    Fake: 'fake',
    Live: 'live'
} as const;

export type OutreachMailboxDtoModeEnum = typeof OutreachMailboxDtoModeEnum[keyof typeof OutreachMailboxDtoModeEnum];

/**
 *
 * @export
 * @interface OutreachMessageDto
 */
export interface OutreachMessageDto {
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'mailboxId': string;
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'conversationId': string;
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'campaignId'?: string | null;
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'contactId': string;
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'prospectId'?: string | null;
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'direction': OutreachMessageDtoDirectionEnum;
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'state': OutreachMessageDtoStateEnum;
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'from': string;
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'to': string;
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'subject': string;
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'text': string;
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'acceptedAt'?: string | null;
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'sentObservedAt'?: string | null;
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'bouncedAt'?: string | null;
    /**
     *
     * @type {boolean}
     * @memberof OutreachMessageDto
     */
    'automatic': boolean;
    /**
     *
     * @type {string}
     * @memberof OutreachMessageDto
     */
    'errorCode': string;
}

export const OutreachMessageDtoDirectionEnum = {
    Outbound: 'OUTBOUND',
    Inbound: 'INBOUND'
} as const;

export type OutreachMessageDtoDirectionEnum = typeof OutreachMessageDtoDirectionEnum[keyof typeof OutreachMessageDtoDirectionEnum];
export const OutreachMessageDtoStateEnum = {
    Queued: 'QUEUED',
    Sending: 'SENDING',
    Accepted: 'ACCEPTED',
    Failed: 'FAILED',
    Uncertain: 'UNCERTAIN',
    Suppressed: 'SUPPRESSED',
    Cancelled: 'CANCELLED',
    Received: 'RECEIVED'
} as const;

export type OutreachMessageDtoStateEnum = typeof OutreachMessageDtoStateEnum[keyof typeof OutreachMessageDtoStateEnum];

/**
 *
 * @export
 * @interface OutreachMessagePageDto
 */
export interface OutreachMessagePageDto {
    /**
     *
     * @type {Array<OutreachMessageDto>}
     * @memberof OutreachMessagePageDto
     */
    'items': Array<OutreachMessageDto>;
    /**
     *
     * @type {number}
     * @memberof OutreachMessagePageDto
     */
    'total': number;
}
/**
 *
 * @export
 * @interface OutreachOauthCompleteDto
 */
export interface OutreachOauthCompleteDto {
    /**
     *
     * @type {string}
     * @memberof OutreachOauthCompleteDto
     */
    'code': string;
    /**
     *
     * @type {string}
     * @memberof OutreachOauthCompleteDto
     */
    'state': string;
}
/**
 *
 * @export
 * @interface OutreachOauthStartDto
 */
export interface OutreachOauthStartDto {
    /**
     *
     * @type {string}
     * @memberof OutreachOauthStartDto
     */
    'authorizationUrl': string;
}
/**
 *
 * @export
 * @interface OutreachProspectDto
 */
export interface OutreachProspectDto {
    /**
     *
     * @type {string}
     * @memberof OutreachProspectDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof OutreachProspectDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof OutreachProspectDto
     */
    'address': string;
    /**
     *
     * @type {string}
     * @memberof OutreachProspectDto
     */
    'chamber': string;
    /**
     *
     * @type {string}
     * @memberof OutreachProspectDto
     */
    'registryNumber': string;
    /**
     *
     * @type {string}
     * @memberof OutreachProspectDto
     */
    'registrationDate'?: string | null;
    /**
     *
     * @type {string}
     * @memberof OutreachProspectDto
     */
    'sourceUrl': string;
    /**
     *
     * @type {Array<string>}
     * @memberof OutreachProspectDto
     */
    'emails': Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof OutreachProspectDto
     */
    'phones'?: Array<string>;
    /**
     *
     * @type {string}
     * @memberof OutreachProspectDto
     */
    'website'?: string;
    /**
     *
     * @type {OutreachContactResearchDto}
     * @memberof OutreachProspectDto
     */
    'contactResearch'?: OutreachContactResearchDto | null;
    /**
     *
     * @type {boolean}
     * @memberof OutreachProspectDto
     */
    'doNotContact': boolean;
}
/**
 *
 * @export
 * @interface OutreachRecipientDto
 */
export interface OutreachRecipientDto {
    /**
     *
     * @type {string}
     * @memberof OutreachRecipientDto
     */
    'key': string;
    /**
     *
     * @type {string}
     * @memberof OutreachRecipientDto
     */
    'prospectId'?: string | null;
    /**
     *
     * @type {string}
     * @memberof OutreachRecipientDto
     */
    'contactId'?: string | null;
    /**
     *
     * @type {string}
     * @memberof OutreachRecipientDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof OutreachRecipientDto
     */
    'email': string;
    /**
     *
     * @type {Array<string>}
     * @memberof OutreachRecipientDto
     */
    'emailOptions': Array<string>;
    /**
     *
     * @type {boolean}
     * @memberof OutreachRecipientDto
     */
    'selected': boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof OutreachRecipientDto
     */
    'issues': Array<string>;
    /**
     *
     * @type {boolean}
     * @memberof OutreachRecipientDto
     */
    'previouslyContacted': boolean;
    /**
     *
     * @type {boolean}
     * @memberof OutreachRecipientDto
     */
    'eligible': boolean;
    /**
     *
     * @type {boolean}
     * @memberof OutreachRecipientDto
     */
    'blocked': boolean;
}
/**
 *
 * @export
 * @interface OutreachRecipientInputDto
 */
export interface OutreachRecipientInputDto {
    /**
     *
     * @type {string}
     * @memberof OutreachRecipientInputDto
     */
    'key': string;
    /**
     *
     * @type {string}
     * @memberof OutreachRecipientInputDto
     */
    'prospectId'?: string;
    /**
     *
     * @type {string}
     * @memberof OutreachRecipientInputDto
     */
    'contactId'?: string;
    /**
     *
     * @type {string}
     * @memberof OutreachRecipientInputDto
     */
    'email'?: string;
    /**
     *
     * @type {boolean}
     * @memberof OutreachRecipientInputDto
     */
    'selected': boolean;
}
/**
 *
 * @export
 * @interface OutreachReplyDto
 */
export interface OutreachReplyDto {
    /**
     *
     * @type {string}
     * @memberof OutreachReplyDto
     */
    'text': string;
    /**
     *
     * @type {string}
     * @memberof OutreachReplyDto
     */
    'idempotencyKey': string;
}
/**
 *
 * @export
 * @interface OutreachUncertainResolutionDto
 */
export interface OutreachUncertainResolutionDto {
    /**
     *
     * @type {string}
     * @memberof OutreachUncertainResolutionDto
     */
    'action': OutreachUncertainResolutionDtoActionEnum;
    /**
     *
     * @type {string}
     * @memberof OutreachUncertainResolutionDto
     */
    'reason': string;
}

export const OutreachUncertainResolutionDtoActionEnum = {
    Retry: 'RETRY',
    Close: 'CLOSE'
} as const;

export type OutreachUncertainResolutionDtoActionEnum = typeof OutreachUncertainResolutionDtoActionEnum[keyof typeof OutreachUncertainResolutionDtoActionEnum];

/**
 *
 * @export
 * @interface PackagingDto
 */
export interface PackagingDto {
    /**
     * Raw packaging data
     * @type {string}
     * @memberof PackagingDto
     */
    'raw'?: string;
    /**
     * Structured packaging data
     * @type {Array<PackagingItemDto>}
     * @memberof PackagingDto
     */
    'structured'?: Array<PackagingItemDto>;
}
/**
 *
 * @export
 * @interface PackagingItemDto
 */
export interface PackagingItemDto {
    /**
     * Barcode number
     * @type {string}
     * @memberof PackagingItemDto
     */
    'barcode'?: string;
    /**
     * Prescription type
     * @type {string}
     * @memberof PackagingItemDto
     */
    'prescription_type'?: string;
    /**
     * Package code
     * @type {string}
     * @memberof PackagingItemDto
     */
    'code'?: string;
    /**
     * Package description
     * @type {string}
     * @memberof PackagingItemDto
     */
    'description'?: string;
}
/**
 *
 * @export
 * @interface PaginatedDocumentsResponseDto
 */
export interface PaginatedDocumentsResponseDto {
    /**
     * Documents for the requested page
     * @type {Array<DocumentFileResponseDto>}
     * @memberof PaginatedDocumentsResponseDto
     */
    'data': Array<DocumentFileResponseDto>;
    /**
     * Total number of documents across all pages
     * @type {number}
     * @memberof PaginatedDocumentsResponseDto
     */
    'total': number;
    /**
     * Current page (0-indexed)
     * @type {number}
     * @memberof PaginatedDocumentsResponseDto
     */
    'page': number;
    /**
     * Rows per page
     * @type {number}
     * @memberof PaginatedDocumentsResponseDto
     */
    'limit': number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof PaginatedDocumentsResponseDto
     */
    'totalPages': number;
}
/**
 *
 * @export
 * @interface PaginatedMedicationsResponseDto
 */
export interface PaginatedMedicationsResponseDto {
    /**
     * Medications for the requested page
     * @type {Array<GetProfileMedicationsDto>}
     * @memberof PaginatedMedicationsResponseDto
     */
    'data': Array<GetProfileMedicationsDto>;
    /**
     * Total number of medications across all pages
     * @type {number}
     * @memberof PaginatedMedicationsResponseDto
     */
    'total': number;
    /**
     * Current page (0-indexed)
     * @type {number}
     * @memberof PaginatedMedicationsResponseDto
     */
    'page': number;
    /**
     * Rows per page
     * @type {number}
     * @memberof PaginatedMedicationsResponseDto
     */
    'limit': number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof PaginatedMedicationsResponseDto
     */
    'totalPages': number;
}
/**
 *
 * @export
 * @interface PaginatedProfilesResponseDto
 */
export interface PaginatedProfilesResponseDto {
    /**
     * Array of profiles for the current page
     * @type {Array<GetOrganizationProfilesDto>}
     * @memberof PaginatedProfilesResponseDto
     */
    'data': Array<GetOrganizationProfilesDto>;
    /**
     * Total number of profiles across all pages
     * @type {number}
     * @memberof PaginatedProfilesResponseDto
     */
    'total': number;
    /**
     * Current page number (0-indexed)
     * @type {number}
     * @memberof PaginatedProfilesResponseDto
     */
    'page': number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof PaginatedProfilesResponseDto
     */
    'limit': number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof PaginatedProfilesResponseDto
     */
    'totalPages': number;
}
/**
 *
 * @export
 * @interface PaginatedRemindersResponseDto
 */
export interface PaginatedRemindersResponseDto {
    /**
     * Reminders for the requested page
     * @type {Array<GetReminderDto>}
     * @memberof PaginatedRemindersResponseDto
     */
    'data': Array<GetReminderDto>;
    /**
     * Total number of reminders across all pages
     * @type {number}
     * @memberof PaginatedRemindersResponseDto
     */
    'total': number;
    /**
     * Current page (0-indexed)
     * @type {number}
     * @memberof PaginatedRemindersResponseDto
     */
    'page': number;
    /**
     * Rows per page
     * @type {number}
     * @memberof PaginatedRemindersResponseDto
     */
    'limit': number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof PaginatedRemindersResponseDto
     */
    'totalPages': number;
}
/**
 *
 * @export
 * @interface PaginatedTreatmentsResponseDto
 */
export interface PaginatedTreatmentsResponseDto {
    /**
     * Treatments for the requested page
     * @type {Array<GetProfileTreatmentDto>}
     * @memberof PaginatedTreatmentsResponseDto
     */
    'data': Array<GetProfileTreatmentDto>;
    /**
     * Total number of treatments across all pages
     * @type {number}
     * @memberof PaginatedTreatmentsResponseDto
     */
    'total': number;
    /**
     * Current page (0-indexed)
     * @type {number}
     * @memberof PaginatedTreatmentsResponseDto
     */
    'page': number;
    /**
     * Rows per page
     * @type {number}
     * @memberof PaginatedTreatmentsResponseDto
     */
    'limit': number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof PaginatedTreatmentsResponseDto
     */
    'totalPages': number;
}
/**
 *
 * @export
 * @interface PaginatedVisitHistoryResponseDto
 */
export interface PaginatedVisitHistoryResponseDto {
    /**
     * Visits for the requested page
     * @type {Array<GetVisitById>}
     * @memberof PaginatedVisitHistoryResponseDto
     */
    'data': Array<GetVisitById>;
    /**
     * Total number of visits across all pages
     * @type {number}
     * @memberof PaginatedVisitHistoryResponseDto
     */
    'total': number;
    /**
     * Current page (0-indexed)
     * @type {number}
     * @memberof PaginatedVisitHistoryResponseDto
     */
    'page': number;
    /**
     * Rows per page
     * @type {number}
     * @memberof PaginatedVisitHistoryResponseDto
     */
    'limit': number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof PaginatedVisitHistoryResponseDto
     */
    'totalPages': number;
}
/**
 *
 * @export
 * @interface PaginatedVisitsResponseDto
 */
export interface PaginatedVisitsResponseDto {
    /**
     * Array of visits for the current page
     * @type {Array<GetVisitById>}
     * @memberof PaginatedVisitsResponseDto
     */
    'data': Array<GetVisitById>;
    /**
     * Total number of visits across all pages
     * @type {number}
     * @memberof PaginatedVisitsResponseDto
     */
    'total': number;
    /**
     * Current page number (0-indexed)
     * @type {number}
     * @memberof PaginatedVisitsResponseDto
     */
    'page': number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof PaginatedVisitsResponseDto
     */
    'limit': number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof PaginatedVisitsResponseDto
     */
    'totalPages': number;
}
/**
 *
 * @export
 * @interface PaginatedWarehouseDemandRequestsDto
 */
export interface PaginatedWarehouseDemandRequestsDto {
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseDemandRequestsDto
     */
    'total': number;
    /**
     * Page number (0-indexed)
     * @type {number}
     * @memberof PaginatedWarehouseDemandRequestsDto
     */
    'page': number;
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseDemandRequestsDto
     */
    'limit': number;
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseDemandRequestsDto
     */
    'totalPages': number;
    /**
     *
     * @type {Array<WarehouseDemandRequestResponseDto>}
     * @memberof PaginatedWarehouseDemandRequestsDto
     */
    'data': Array<WarehouseDemandRequestResponseDto>;
}
/**
 *
 * @export
 * @interface PaginatedWarehouseDocumentsDto
 */
export interface PaginatedWarehouseDocumentsDto {
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseDocumentsDto
     */
    'total': number;
    /**
     * Page number (0-indexed)
     * @type {number}
     * @memberof PaginatedWarehouseDocumentsDto
     */
    'page': number;
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseDocumentsDto
     */
    'limit': number;
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseDocumentsDto
     */
    'totalPages': number;
    /**
     *
     * @type {Array<WarehouseDocumentDto>}
     * @memberof PaginatedWarehouseDocumentsDto
     */
    'data': Array<WarehouseDocumentDto>;
}
/**
 *
 * @export
 * @interface PaginatedWarehouseMovementsDto
 */
export interface PaginatedWarehouseMovementsDto {
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseMovementsDto
     */
    'total': number;
    /**
     * Page number (0-indexed)
     * @type {number}
     * @memberof PaginatedWarehouseMovementsDto
     */
    'page': number;
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseMovementsDto
     */
    'limit': number;
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseMovementsDto
     */
    'totalPages': number;
    /**
     *
     * @type {Array<WarehouseMovementDto>}
     * @memberof PaginatedWarehouseMovementsDto
     */
    'data': Array<WarehouseMovementDto>;
}
/**
 *
 * @export
 * @interface PaginatedWarehouseProductsDto
 */
export interface PaginatedWarehouseProductsDto {
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseProductsDto
     */
    'total': number;
    /**
     * Page number (0-indexed)
     * @type {number}
     * @memberof PaginatedWarehouseProductsDto
     */
    'page': number;
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseProductsDto
     */
    'limit': number;
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseProductsDto
     */
    'totalPages': number;
    /**
     *
     * @type {Array<WarehouseProductDto>}
     * @memberof PaginatedWarehouseProductsDto
     */
    'data': Array<WarehouseProductDto>;
}
/**
 *
 * @export
 * @interface PaginatedWarehouseSaleLinesDto
 */
export interface PaginatedWarehouseSaleLinesDto {
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseSaleLinesDto
     */
    'total': number;
    /**
     * Page number (0-indexed)
     * @type {number}
     * @memberof PaginatedWarehouseSaleLinesDto
     */
    'page': number;
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseSaleLinesDto
     */
    'limit': number;
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseSaleLinesDto
     */
    'totalPages': number;
    /**
     *
     * @type {Array<WarehouseSaleLineDto>}
     * @memberof PaginatedWarehouseSaleLinesDto
     */
    'data': Array<WarehouseSaleLineDto>;
}
/**
 *
 * @export
 * @interface PaginatedWarehouseSuppliersDto
 */
export interface PaginatedWarehouseSuppliersDto {
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseSuppliersDto
     */
    'total': number;
    /**
     * Page number (0-indexed)
     * @type {number}
     * @memberof PaginatedWarehouseSuppliersDto
     */
    'page': number;
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseSuppliersDto
     */
    'limit': number;
    /**
     *
     * @type {number}
     * @memberof PaginatedWarehouseSuppliersDto
     */
    'totalPages': number;
    /**
     *
     * @type {Array<WarehouseSupplierDto>}
     * @memberof PaginatedWarehouseSuppliersDto
     */
    'data': Array<WarehouseSupplierDto>;
}
/**
 *
 * @export
 * @interface Payment
 */
export interface Payment {
    /**
     *
     * @type {string}
     * @memberof Payment
     */
    'status': PaymentStatusEnum;
    /**
     *
     * @type {string}
     * @memberof Payment
     */
    'paymentUrl': string;
    /**
     *
     * @type {number}
     * @memberof Payment
     */
    'amount': number;
}

export const PaymentStatusEnum = {
    Created: 'created',
    Verified: 'verified',
    Failed: 'failed',
    Refunded: 'refunded'
} as const;

export type PaymentStatusEnum = typeof PaymentStatusEnum[keyof typeof PaymentStatusEnum];

/**
 *
 * @export
 * @interface PetBreedDto
 */
export interface PetBreedDto {
    /**
     * Pet breed name in English
     * @type {string}
     * @memberof PetBreedDto
     */
    'nameEN': string;
    /**
     * Pet breed name in Polish
     * @type {string}
     * @memberof PetBreedDto
     */
    'namePL': string;
    /**
     * Pet category
     * @type {string}
     * @memberof PetBreedDto
     */
    'category': PetBreedDtoCategoryEnum;
}

export const PetBreedDtoCategoryEnum = {
    Dog: 'dog',
    Cat: 'cat',
    Other: 'other'
} as const;

export type PetBreedDtoCategoryEnum = typeof PetBreedDtoCategoryEnum[keyof typeof PetBreedDtoCategoryEnum];

/**
 *
 * @export
 * @interface PetConversationRequestDto
 */
export interface PetConversationRequestDto {
    /**
     * The ID of the profile for which to generate the pet conversation response
     * @type {string}
     * @memberof PetConversationRequestDto
     */
    'profileId': string;
    /**
     * The user input for the conversation
     * @type {string}
     * @memberof PetConversationRequestDto
     */
    'input': string;
    /**
     * Previous messages in the conversation
     * @type {Array<ConversationMessage>}
     * @memberof PetConversationRequestDto
     */
    'conversationHistory': Array<ConversationMessage>;
}
/**
 *
 * @export
 * @interface PetConversationResponseDto
 */
export interface PetConversationResponseDto {
    /**
     * Whether the input is valid
     * @type {boolean}
     * @memberof PetConversationResponseDto
     */
    'isValid': boolean;
    /**
     * The response message
     * @type {string}
     * @memberof PetConversationResponseDto
     */
    'response'?: string;
    /**
     * Whether the response is related to a medical concern
     * @type {boolean}
     * @memberof PetConversationResponseDto
     */
    'isMedicalRelated'?: boolean;
    /**
     * Whether the response is related to dietary needs
     * @type {boolean}
     * @memberof PetConversationResponseDto
     */
    'isDietaryRelated'?: boolean;
    /**
     * Whether the response is related to behavioral issues or training
     * @type {boolean}
     * @memberof PetConversationResponseDto
     */
    'isBehaviorRelated'?: boolean;
    /**
     * Reason for invalid input, if applicable
     * @type {string}
     * @memberof PetConversationResponseDto
     */
    'reason'?: string;
    /**
     * Whether the conversation is closing
     * @type {boolean}
     * @memberof PetConversationResponseDto
     */
    'isConversationClosing'?: boolean;
    /**
     * Document sources used to generate the response
     * @type {Array<PetConversationResponseDtoDocumentSourcesInner>}
     * @memberof PetConversationResponseDto
     */
    'documentSources'?: Array<PetConversationResponseDtoDocumentSourcesInner> | null;
}
/**
 *
 * @export
 * @interface PetConversationResponseDtoDocumentSourcesInner
 */
export interface PetConversationResponseDtoDocumentSourcesInner {
    /**
     *
     * @type {string}
     * @memberof PetConversationResponseDtoDocumentSourcesInner
     */
    'filename'?: string;
    /**
     *
     * @type {string}
     * @memberof PetConversationResponseDtoDocumentSourcesInner
     */
    'originalFilename'?: string;
    /**
     *
     * @type {string}
     * @memberof PetConversationResponseDtoDocumentSourcesInner
     */
    'fileUrl'?: string;
    /**
     *
     * @type {number}
     * @memberof PetConversationResponseDtoDocumentSourcesInner
     */
    'similarity'?: number;
}
/**
 *
 * @export
 * @interface PetDto
 */
export interface PetDto {
    /**
     *
     * @type {number}
     * @memberof PetDto
     */
    'id': number;
    /**
     *
     * @type {string}
     * @memberof PetDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof PetDto
     */
    'type': string;
    /**
     *
     * @type {string}
     * @memberof PetDto
     */
    'gender': string;
    /**
     *
     * @type {string}
     * @memberof PetDto
     */
    'birthDate': string;
    /**
     *
     * @type {string}
     * @memberof PetDto
     */
    'size': string;
    /**
     *
     * @type {string}
     * @memberof PetDto
     */
    'breed': string;
    /**
     *
     * @type {string}
     * @memberof PetDto
     */
    'about': string;
    /**
     *
     * @type {string}
     * @memberof PetDto
     */
    'medicationsDetails'?: string;
    /**
     *
     * @type {string}
     * @memberof PetDto
     */
    'avatarUrl'?: string;
}
/**
 *
 * @export
 * @interface PetFact
 */
export interface PetFact {
    /**
     * Title of the pet fact
     * @type {string}
     * @memberof PetFact
     */
    'title': string;
    /**
     * Content of the pet fact
     * @type {string}
     * @memberof PetFact
     */
    'content': string;
    /**
     * Full blog post content (around 250 words)
     * @type {string}
     * @memberof PetFact
     */
    'blogPost': string;
    /**
     * Category of the pet fact
     * @type {string}
     * @memberof PetFact
     */
    'category': PetFactCategoryEnum;
    /**
     * Type of the pet fact
     * @type {string}
     * @memberof PetFact
     */
    'type': PetFactTypeEnum;
    /**
     * When the fact was generated
     * @type {string}
     * @memberof PetFact
     */
    'generatedAt': string;
    /**
     * Pet category this fact applies to (e.g., dog, cat)
     * @type {string}
     * @memberof PetFact
     */
    'petCategory': string;
    /**
     * Practical tip or call-to-action for pet owners
     * @type {string}
     * @memberof PetFact
     */
    'tip': string;
}

export const PetFactCategoryEnum = {
    Health: 'health',
    Nutrition: 'nutrition',
    Behavior: 'behavior',
    General: 'general',
    Fun: 'fun'
} as const;

export type PetFactCategoryEnum = typeof PetFactCategoryEnum[keyof typeof PetFactCategoryEnum];
export const PetFactTypeEnum = {
    Medical: 'medical',
    Lifestyle: 'lifestyle',
    Behavioral: 'behavioral'
} as const;

export type PetFactTypeEnum = typeof PetFactTypeEnum[keyof typeof PetFactTypeEnum];

/**
 *
 * @export
 * @interface PetsitterDto
 */
export interface PetsitterDto {
    /**
     *
     * @type {number}
     * @memberof PetsitterDto
     */
    'id': number;
    /**
     *
     * @type {string}
     * @memberof PetsitterDto
     */
    'email': string;
    /**
     *
     * @type {string}
     * @memberof PetsitterDto
     */
    'firstName': string;
    /**
     *
     * @type {string}
     * @memberof PetsitterDto
     */
    'lastName': string;
    /**
     *
     * @type {string}
     * @memberof PetsitterDto
     */
    'avatarUrl': string;
    /**
     *
     * @type {string}
     * @memberof PetsitterDto
     */
    'phoneNumber'?: string;
}
/**
 *
 * @export
 * @interface PlaceVoiceDsrLegalHoldDto
 */
export interface PlaceVoiceDsrLegalHoldDto {
    /**
     *
     * @type {number}
     * @memberof PlaceVoiceDsrLegalHoldDto
     */
    'expectedRevision': number;
    /**
     *
     * @type {string}
     * @memberof PlaceVoiceDsrLegalHoldDto
     */
    'holdUntil': string;
}
/**
 *
 * @export
 * @interface PreviewUserDto
 */
export interface PreviewUserDto {
    /**
     *
     * @type {string}
     * @memberof PreviewUserDto
     */
    'firstName': string;
    /**
     *
     * @type {string}
     * @memberof PreviewUserDto
     */
    'middleName'?: string;
    /**
     *
     * @type {string}
     * @memberof PreviewUserDto
     */
    'lastName': string;
    /**
     *
     * @type {string}
     * @memberof PreviewUserDto
     */
    'avatar'?: string;
    /**
     *
     * @type {string}
     * @memberof PreviewUserDto
     */
    'email': string;
    /**
     *
     * @type {string}
     * @memberof PreviewUserDto
     */
    'phoneNumber': string;
    /**
     *
     * @type {string}
     * @memberof PreviewUserDto
     */
    'address'?: string;
    /**
     *
     * @type {string}
     * @memberof PreviewUserDto
     */
    'city': string;
    /**
     *
     * @type {string}
     * @memberof PreviewUserDto
     */
    'zip'?: string;
}
/**
 *
 * @export
 * @interface PreviewWebinarRecordingPublicationDto
 */
export interface PreviewWebinarRecordingPublicationDto {
    /**
     *
     * @type {string}
     * @memberof PreviewWebinarRecordingPublicationDto
     */
    'recordingUrl': string;
}
/**
 *
 * @export
 * @interface ProcessDocumentDto
 */
export interface ProcessDocumentDto {
    /**
     * Filename of the document
     * @type {string}
     * @memberof ProcessDocumentDto
     */
    'filename': string;
    /**
     * URL or path to the document file
     * @type {string}
     * @memberof ProcessDocumentDto
     */
    'fileUrl': string;
    /**
     * Profile ID associated with this document
     * @type {string}
     * @memberof ProcessDocumentDto
     */
    'profileId': string;
    /**
     * Visit ID if document is related to a specific visit
     * @type {string}
     * @memberof ProcessDocumentDto
     */
    'visitId'?: string;
    /**
     * Additional metadata for the document
     * @type {object}
     * @memberof ProcessDocumentDto
     */
    'metadata'?: object;
}
/**
 *
 * @export
 * @interface ProcessInvitationDto
 */
export interface ProcessInvitationDto {
    /**
     * The unique token for the invitation.
     * @type {string}
     * @memberof ProcessInvitationDto
     */
    'token': string;
}
/**
 *
 * @export
 * @interface ProductImageDto
 */
export interface ProductImageDto {
    /**
     * Image ID
     * @type {number}
     * @memberof ProductImageDto
     */
    'id': number;
    /**
     * Date created
     * @type {string}
     * @memberof ProductImageDto
     */
    'date_created': string;
    /**
     * Date modified
     * @type {string}
     * @memberof ProductImageDto
     */
    'date_modified': string;
    /**
     * Image source URL
     * @type {string}
     * @memberof ProductImageDto
     */
    'src': string;
    /**
     * Image name
     * @type {string}
     * @memberof ProductImageDto
     */
    'name': string;
    /**
     * Image alt text
     * @type {string}
     * @memberof ProductImageDto
     */
    'alt': string;
}
/**
 *
 * @export
 * @interface ProductResponseDto
 */
export interface ProductResponseDto {
    /**
     * Product ID
     * @type {number}
     * @memberof ProductResponseDto
     */
    'id': number;
    /**
     * Product name
     * @type {string}
     * @memberof ProductResponseDto
     */
    'name': string;
    /**
     * Product slug
     * @type {string}
     * @memberof ProductResponseDto
     */
    'slug': string;
    /**
     * Product permalink
     * @type {string}
     * @memberof ProductResponseDto
     */
    'permalink': string;
    /**
     * Date created
     * @type {string}
     * @memberof ProductResponseDto
     */
    'date_created': string;
    /**
     * Date modified
     * @type {string}
     * @memberof ProductResponseDto
     */
    'date_modified': string;
    /**
     * Product type
     * @type {string}
     * @memberof ProductResponseDto
     */
    'type': string;
    /**
     * Product status
     * @type {string}
     * @memberof ProductResponseDto
     */
    'status': string;
    /**
     * Featured status
     * @type {boolean}
     * @memberof ProductResponseDto
     */
    'featured': boolean;
    /**
     * Product catalog visibility
     * @type {string}
     * @memberof ProductResponseDto
     */
    'catalog_visibility': string;
    /**
     * Product description
     * @type {string}
     * @memberof ProductResponseDto
     */
    'description': string;
    /**
     * Short description
     * @type {string}
     * @memberof ProductResponseDto
     */
    'short_description': string;
    /**
     * SKU
     * @type {string}
     * @memberof ProductResponseDto
     */
    'sku': string;
    /**
     * Product price
     * @type {string}
     * @memberof ProductResponseDto
     */
    'price': string;
    /**
     * Regular price
     * @type {string}
     * @memberof ProductResponseDto
     */
    'regular_price': string;
    /**
     * Sale price
     * @type {string}
     * @memberof ProductResponseDto
     */
    'sale_price': string;
    /**
     * Product stock status
     * @type {string}
     * @memberof ProductResponseDto
     */
    'stock_status': string;
    /**
     * Product images
     * @type {Array<ProductImageDto>}
     * @memberof ProductResponseDto
     */
    'images': Array<ProductImageDto>;
    /**
     * Product categories
     * @type {Array<object>}
     * @memberof ProductResponseDto
     */
    'categories': Array<object>;
    /**
     * Product tags
     * @type {Array<object>}
     * @memberof ProductResponseDto
     */
    'tags': Array<object>;
}
/**
 *
 * @export
 * @interface ProductsListResponseDto
 */
export interface ProductsListResponseDto {
    /**
     * List of products
     * @type {Array<ProductResponseDto>}
     * @memberof ProductsListResponseDto
     */
    'products': Array<ProductResponseDto>;
    /**
     * Total number of products
     * @type {number}
     * @memberof ProductsListResponseDto
     */
    'totalCount': number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof ProductsListResponseDto
     */
    'totalPages': number;
}
/**
 *
 * @export
 * @interface Professional
 */
export interface Professional {
    /**
     *
     * @type {string}
     * @memberof Professional
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof Professional
     */
    'firstName': string;
    /**
     *
     * @type {string}
     * @memberof Professional
     */
    'middleName': string;
    /**
     *
     * @type {string}
     * @memberof Professional
     */
    'lastName': string;
    /**
     *
     * @type {string}
     * @memberof Professional
     */
    'avatar': string;
    /**
     *
     * @type {Array<string>}
     * @memberof Professional
     */
    'categories': Array<ProfessionalCategoriesEnum>;
}

export const ProfessionalCategoriesEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type ProfessionalCategoriesEnum = typeof ProfessionalCategoriesEnum[keyof typeof ProfessionalCategoriesEnum];

/**
 *
 * @export
 * @interface ProfessionalAssistantFollowupRequestDto
 */
export interface ProfessionalAssistantFollowupRequestDto {
    /**
     * The profile ID for the pet. Omit for guest visits (pass visitId only).
     * @type {string}
     * @memberof ProfessionalAssistantFollowupRequestDto
     */
    'profileId'?: string;
    /**
     * The visit ID. Required when profileId is omitted (guest-visit flow).
     * @type {string}
     * @memberof ProfessionalAssistantFollowupRequestDto
     */
    'visitId'?: string;
    /**
     * Current question from the professional
     * @type {string}
     * @memberof ProfessionalAssistantFollowupRequestDto
     */
    'currentQuestion': string;
    /**
     * Previous messages in the conversation with the assistant
     * @type {Array<ConversationMessageDto>}
     * @memberof ProfessionalAssistantFollowupRequestDto
     */
    'conversationHistory'?: Array<ConversationMessageDto>;
    /**
     * Current content of the Notatki dla pacjenta editor, sent so the assistant can transform it in place.
     * @type {string}
     * @memberof ProfessionalAssistantFollowupRequestDto
     */
    'patientNotesDraft'?: string;
    /**
     * Current content of the Notatki wewnętrzne (internal notes) editor, so the assistant can see what the professional is writing.
     * @type {string}
     * @memberof ProfessionalAssistantFollowupRequestDto
     */
    'internalNotesDraft'?: string;
    /**
     * Surface hint. \"patient_note\" enables the text-note tools (get_text_notes + fill_text_note) for the profile-scoped note modal.
     * @type {string}
     * @memberof ProfessionalAssistantFollowupRequestDto
     */
    'surface'?: string;
    /**
     * Current text-note editor content (HTML), for the patient-note modal.
     * @type {string}
     * @memberof ProfessionalAssistantFollowupRequestDto
     */
    'textNoteDraft'?: string;
}
/**
 *
 * @export
 * @interface ProfessionalAssistantInitialRequestDto
 */
export interface ProfessionalAssistantInitialRequestDto {
    /**
     * The profile ID for the pet
     * @type {string}
     * @memberof ProfessionalAssistantInitialRequestDto
     */
    'profileId': string;
    /**
     * The visit ID (optional, if related to a visit)
     * @type {string}
     * @memberof ProfessionalAssistantInitialRequestDto
     */
    'visitId'?: string;
}
/**
 *
 * @export
 * @interface ProfessionalAssistantResponseDto
 */
export interface ProfessionalAssistantResponseDto {
    /**
     * The assistant response
     * @type {string}
     * @memberof ProfessionalAssistantResponseDto
     */
    'response': string;
    /**
     * Timestamp when the summary was generated
     * @type {string}
     * @memberof ProfessionalAssistantResponseDto
     */
    'generatedAt'?: string;
    /**
     * Suggested diagnostic tests
     * @type {Array<string>}
     * @memberof ProfessionalAssistantResponseDto
     */
    'suggestedTests'?: Array<string> | null;
    /**
     * Potential differential diagnoses
     * @type {Array<string>}
     * @memberof ProfessionalAssistantResponseDto
     */
    'differentialDiagnoses'?: Array<string> | null;
    /**
     * Treatment recommendations
     * @type {Array<string>}
     * @memberof ProfessionalAssistantResponseDto
     */
    'treatmentRecommendations'?: Array<string> | null;
    /**
     * Important warnings or red flags
     * @type {Array<string>}
     * @memberof ProfessionalAssistantResponseDto
     */
    'warnings'?: Array<string> | null;
    /**
     * Document sources used to generate the response
     * @type {Array<PetConversationResponseDtoDocumentSourcesInner>}
     * @memberof ProfessionalAssistantResponseDto
     */
    'documentSources'?: Array<PetConversationResponseDtoDocumentSourcesInner> | null;
    /**
     *
     * @type {ProfessionalAssistantResponseDtoAction}
     * @memberof ProfessionalAssistantResponseDto
     */
    'action'?: ProfessionalAssistantResponseDtoAction | null;
}
/**
 * Optional action for the frontend to perform (e.g. prefill the patient notes). Null for normal chat answers.
 * @export
 * @interface ProfessionalAssistantResponseDtoAction
 */
export interface ProfessionalAssistantResponseDtoAction {
    /**
     * Action the frontend should perform.
     * @type {string}
     * @memberof ProfessionalAssistantResponseDtoAction
     */
    'type': ProfessionalAssistantResponseDtoActionTypeEnum;
    /**
     *
     * @type {AssistantActionPayloadDto}
     * @memberof ProfessionalAssistantResponseDtoAction
     */
    'payload': AssistantActionPayloadDto;
}

export const ProfessionalAssistantResponseDtoActionTypeEnum = {
    PatientNotes: 'fill_patient_notes',
    InternalNotes: 'fill_internal_notes',
    TextNote: 'fill_text_note'
} as const;

export type ProfessionalAssistantResponseDtoActionTypeEnum = typeof ProfessionalAssistantResponseDtoActionTypeEnum[keyof typeof ProfessionalAssistantResponseDtoActionTypeEnum];

/**
 *
 * @export
 * @interface ProfessionalCategoryDto
 */
export interface ProfessionalCategoryDto {
    /**
     * Category name
     * @type {string}
     * @memberof ProfessionalCategoryDto
     */
    'name': ProfessionalCategoryDtoNameEnum;
    /**
     * Price for this category
     * @type {number}
     * @memberof ProfessionalCategoryDto
     */
    'price': number;
}

export const ProfessionalCategoryDtoNameEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type ProfessionalCategoryDtoNameEnum = typeof ProfessionalCategoryDtoNameEnum[keyof typeof ProfessionalCategoryDtoNameEnum];

/**
 *
 * @export
 * @interface ProfessionalDetailsDto
 */
export interface ProfessionalDetailsDto {
    /**
     * Professional first name
     * @type {string}
     * @memberof ProfessionalDetailsDto
     */
    'firstName': string;
    /**
     * Professional last name
     * @type {string}
     * @memberof ProfessionalDetailsDto
     */
    'lastName': string;
    /**
     * Professional avatar URL
     * @type {string}
     * @memberof ProfessionalDetailsDto
     */
    'avatar'?: string;
    /**
     * Professional email address
     * @type {string}
     * @memberof ProfessionalDetailsDto
     */
    'email': string;
    /**
     * Professional phone number
     * @type {string}
     * @memberof ProfessionalDetailsDto
     */
    'phoneNumber'?: string;
    /**
     * Professional city
     * @type {string}
     * @memberof ProfessionalDetailsDto
     */
    'city'?: string;
    /**
     * Professional address
     * @type {string}
     * @memberof ProfessionalDetailsDto
     */
    'address'?: string;
    /**
     * Professional zip code
     * @type {string}
     * @memberof ProfessionalDetailsDto
     */
    'zip'?: string;
    /**
     * Professional PWZ number
     * @type {string}
     * @memberof ProfessionalDetailsDto
     */
    'pwzNumber'?: string;
    /**
     * Professional date of birth
     * @type {string}
     * @memberof ProfessionalDetailsDto
     */
    'dob'?: string;
    /**
     * Professional specializations
     * @type {Array<ProfessionalSpecializationDto>}
     * @memberof ProfessionalDetailsDto
     */
    'specializations'?: Array<ProfessionalSpecializationDto>;
    /**
     * Professional description
     * @type {string}
     * @memberof ProfessionalDetailsDto
     */
    'description'?: string;
}
/**
 *
 * @export
 * @interface ProfessionalRatingStatsDto
 */
export interface ProfessionalRatingStatsDto {
    /**
     * Professional ID
     * @type {string}
     * @memberof ProfessionalRatingStatsDto
     */
    'professionalId': string;
    /**
     * Average rating for the professional
     * @type {number}
     * @memberof ProfessionalRatingStatsDto
     */
    'averageRating': number;
    /**
     * Total number of ratings
     * @type {number}
     * @memberof ProfessionalRatingStatsDto
     */
    'totalRatings': number;
    /**
     * Distribution of ratings (1-5 stars)
     * @type {object}
     * @memberof ProfessionalRatingStatsDto
     */
    'ratingDistribution': object;
}
/**
 *
 * @export
 * @interface ProfessionalSlotsResponseDto
 */
export interface ProfessionalSlotsResponseDto {
    /**
     * ID of the professional
     * @type {string}
     * @memberof ProfessionalSlotsResponseDto
     */
    'professionalId': string;
    /**
     * Visit category
     * @type {string}
     * @memberof ProfessionalSlotsResponseDto
     */
    'category': ProfessionalSlotsResponseDtoCategoryEnum;
    /**
     * Maximum number of slots per day (if specified)
     * @type {number}
     * @memberof ProfessionalSlotsResponseDto
     */
    'slotsPerDay'?: number;
    /**
     * Total number of available slots found
     * @type {number}
     * @memberof ProfessionalSlotsResponseDto
     */
    'totalSlots': number;
    /**
     * Array of available slot dates and times
     * @type {Array<string>}
     * @memberof ProfessionalSlotsResponseDto
     */
    'slots': Array<string>;
}

export const ProfessionalSlotsResponseDtoCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type ProfessionalSlotsResponseDtoCategoryEnum = typeof ProfessionalSlotsResponseDtoCategoryEnum[keyof typeof ProfessionalSlotsResponseDtoCategoryEnum];

/**
 *
 * @export
 * @interface ProfessionalSpecializationDto
 */
export interface ProfessionalSpecializationDto {
    /**
     * Specialization ID
     * @type {string}
     * @memberof ProfessionalSpecializationDto
     */
    'id': string;
    /**
     * Specialization name
     * @type {string}
     * @memberof ProfessionalSpecializationDto
     */
    'name': string;
}
/**
 *
 * @export
 * @interface ProfessionalStatisticsDto
 */
export interface ProfessionalStatisticsDto {
    /**
     *
     * @type {string}
     * @memberof ProfessionalStatisticsDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof ProfessionalStatisticsDto
     */
    'calculatedAt': string;
    /**
     *
     * @type {string}
     * @memberof ProfessionalStatisticsDto
     */
    'timezone': string;
    /**
     *
     * @type {StatisticsIntervalDto}
     * @memberof ProfessionalStatisticsDto
     */
    'currentInterval': StatisticsIntervalDto;
    /**
     *
     * @type {StatisticsIntervalDto}
     * @memberof ProfessionalStatisticsDto
     */
    'comparisonInterval'?: StatisticsIntervalDto | null;
    /**
     *
     * @type {StatisticsCountsDto}
     * @memberof ProfessionalStatisticsDto
     */
    'current': StatisticsCountsDto;
    /**
     *
     * @type {StatisticsCountsDto}
     * @memberof ProfessionalStatisticsDto
     */
    'comparison'?: StatisticsCountsDto | null;
    /**
     *
     * @type {Array<StatisticsStatusDto>}
     * @memberof ProfessionalStatisticsDto
     */
    'statusCounts': Array<StatisticsStatusDto>;
    /**
     *
     * @type {number}
     * @memberof ProfessionalStatisticsDto
     */
    'overdueOpenVisits': number;
    /**
     *
     * @type {Array<StatisticsPointDto>}
     * @memberof ProfessionalStatisticsDto
     */
    'daily': Array<StatisticsPointDto>;
    /**
     *
     * @type {Array<StatisticsPointDto>}
     * @memberof ProfessionalStatisticsDto
     */
    'weekly': Array<StatisticsPointDto>;
    /**
     *
     * @type {Array<StatisticsPointDto>}
     * @memberof ProfessionalStatisticsDto
     */
    'monthly': Array<StatisticsPointDto>;
    /**
     *
     * @type {StatisticsPatientsDto}
     * @memberof ProfessionalStatisticsDto
     */
    'patientComposition': StatisticsPatientsDto;
    /**
     *
     * @type {Array<StatisticsServiceDto>}
     * @memberof ProfessionalStatisticsDto
     */
    'services': Array<StatisticsServiceDto>;
    /**
     *
     * @type {Array<StatisticsHeatmapCellDto>}
     * @memberof ProfessionalStatisticsDto
     */
    'heatmap': Array<StatisticsHeatmapCellDto>;
    /**
     *
     * @type {string}
     * @memberof ProfessionalStatisticsDto
     */
    'professionalId': string;
}
/**
 *
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     *
     * @type {string}
     * @memberof Profile
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof Profile
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof Profile
     */
    'avatar': string;
    /**
     *
     * @type {string}
     * @memberof Profile
     */
    'breed': string;
    /**
     *
     * @type {string}
     * @memberof Profile
     */
    'petCategory': ProfilePetCategoryEnum;
    /**
     *
     * @type {number}
     * @memberof Profile
     */
    'weight': number;
    /**
     *
     * @type {string}
     * @memberof Profile
     */
    'gender': string;
    /**
     *
     * @type {string}
     * @memberof Profile
     */
    'chipNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof Profile
     */
    'dob': string;
    /**
     * Pet medications
     * @type {Array<object>}
     * @memberof Profile
     */
    'medications': Array<object>;
}

export const ProfilePetCategoryEnum = {
    Dog: 'dog',
    Cat: 'cat',
    Other: 'other'
} as const;

export type ProfilePetCategoryEnum = typeof ProfilePetCategoryEnum[keyof typeof ProfilePetCategoryEnum];

/**
 *
 * @export
 * @interface PromoCode
 */
export interface PromoCode {
    /**
     *
     * @type {number}
     * @memberof PromoCode
     */
    'discountPercentage': number;
    /**
     *
     * @type {string}
     * @memberof PromoCode
     */
    'code': string;
}
/**
 *
 * @export
 * @interface ProposeReceptionIncidentActionDto
 */
export interface ProposeReceptionIncidentActionDto {
    /**
     *
     * @type {string}
     * @memberof ProposeReceptionIncidentActionDto
     */
    'reason': ProposeReceptionIncidentActionDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof ProposeReceptionIncidentActionDto
     */
    'note'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ProposeReceptionIncidentActionDto
     */
    'organizationId'?: string | null;
    /**
     *
     * @type {number}
     * @memberof ProposeReceptionIncidentActionDto
     */
    'expectedStateRevision': number;
}

export const ProposeReceptionIncidentActionDtoReasonEnum = {
    FirstActivation: 'FIRST_ACTIVATION',
    ProviderIncident: 'PROVIDER_INCIDENT',
    ProviderDrift: 'PROVIDER_DRIFT',
    PrivacyIncident: 'PRIVACY_INCIDENT',
    SafetyEvidenceInvalidated: 'SAFETY_EVIDENCE_INVALIDATED',
    EmergencyRouteCompromised: 'EMERGENCY_ROUTE_COMPROMISED',
    SpendProtection: 'SPEND_PROTECTION',
    AutomatedSecurityTrigger: 'AUTOMATED_SECURITY_TRIGGER',
    IncidentResolved: 'INCIDENT_RESOLVED'
} as const;

export type ProposeReceptionIncidentActionDtoReasonEnum = typeof ProposeReceptionIncidentActionDtoReasonEnum[keyof typeof ProposeReceptionIncidentActionDtoReasonEnum];

/**
 *
 * @export
 * @interface ProposeVoiceFallbackContentApprovalDto
 */
export interface ProposeVoiceFallbackContentApprovalDto {
    /**
     *
     * @type {VoiceFallbackBundleContentDto}
     * @memberof ProposeVoiceFallbackContentApprovalDto
     */
    'content': VoiceFallbackBundleContentDto;
    /**
     *
     * @type {string}
     * @memberof ProposeVoiceFallbackContentApprovalDto
     */
    'reason': string;
}
/**
 *
 * @export
 * @interface ProposeVoicePlatformCapabilityAssignmentDto
 */
export interface ProposeVoicePlatformCapabilityAssignmentDto {
    /**
     * Identyfikator użytkownika, który ma otrzymać uprawnienie
     * @type {string}
     * @memberof ProposeVoicePlatformCapabilityAssignmentDto
     */
    'subjectUserId': string;
    /**
     * Proponowane uprawnienie platformy głosowej
     * @type {string}
     * @memberof ProposeVoicePlatformCapabilityAssignmentDto
     */
    'capability': ProposeVoicePlatformCapabilityAssignmentDtoCapabilityEnum;
}

export const ProposeVoicePlatformCapabilityAssignmentDtoCapabilityEnum = {
    ProductPublisher: 'VOICE_PRODUCT_PUBLISHER',
    Operations: 'VOICE_OPERATIONS',
    PrivacyReviewer: 'VOICE_PRIVACY_REVIEWER',
    SafetyReviewer: 'VOICE_SAFETY_REVIEWER',
    IncidentCommander: 'VOICE_INCIDENT_COMMANDER'
} as const;

export type ProposeVoicePlatformCapabilityAssignmentDtoCapabilityEnum = typeof ProposeVoicePlatformCapabilityAssignmentDtoCapabilityEnum[keyof typeof ProposeVoicePlatformCapabilityAssignmentDtoCapabilityEnum];

/**
 *
 * @export
 * @interface ProposeVoiceSmsPrivacyQualificationDto
 */
export interface ProposeVoiceSmsPrivacyQualificationDto {
    /**
     *
     * @type {string}
     * @memberof ProposeVoiceSmsPrivacyQualificationDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof ProposeVoiceSmsPrivacyQualificationDto
     */
    'policyEvidenceSha256': string;
    /**
     *
     * @type {string}
     * @memberof ProposeVoiceSmsPrivacyQualificationDto
     */
    'testSenderE164': string;
    /**
     *
     * @type {string}
     * @memberof ProposeVoiceSmsPrivacyQualificationDto
     */
    'acknowledgement': ProposeVoiceSmsPrivacyQualificationDtoAcknowledgementEnum;
}

export const ProposeVoiceSmsPrivacyQualificationDtoAcknowledgementEnum = {
    ReviewedConsentedTestSmsPrivacyOnlyNoCallsNoRepliesV1: 'REVIEWED_CONSENTED_TEST_SMS_PRIVACY_ONLY_NO_CALLS_NO_REPLIES_V1'
} as const;

export type ProposeVoiceSmsPrivacyQualificationDtoAcknowledgementEnum = typeof ProposeVoiceSmsPrivacyQualificationDtoAcknowledgementEnum[keyof typeof ProposeVoiceSmsPrivacyQualificationDtoAcknowledgementEnum];

/**
 *
 * @export
 * @interface ProposeVoiceSpendReopenDto
 */
export interface ProposeVoiceSpendReopenDto {
    /**
     * Kontrolowany powód operacji na sterowaniu przyjęciem Voice
     * @type {string}
     * @memberof ProposeVoiceSpendReopenDto
     */
    'reason': string;
    /**
     * Opcjonalna notatka operacyjna bez danych osobowych
     * @type {string}
     * @memberof ProposeVoiceSpendReopenDto
     */
    'note'?: string;
    /**
     * Dzień kalendarzowy Europe/Warsaw objęty propozycją
     * @type {string}
     * @memberof ProposeVoiceSpendReopenDto
     */
    'warsawDay': string;
}
/**
 *
 * @export
 * @interface ProvisionVoiceAllowanceDto
 */
export interface ProvisionVoiceAllowanceDto {
    /**
     * Kontrolowany powód operacji na sterowaniu przyjęciem Voice
     * @type {string}
     * @memberof ProvisionVoiceAllowanceDto
     */
    'reason': string;
    /**
     * Opcjonalna notatka operacyjna bez danych osobowych
     * @type {string}
     * @memberof ProvisionVoiceAllowanceDto
     */
    'note'?: string;
}
/**
 *
 * @export
 * @interface PublishReceptionAssignmentDto
 */
export interface PublishReceptionAssignmentDto {
    /**
     *
     * @type {number}
     * @memberof PublishReceptionAssignmentDto
     */
    'expectedAssignmentFence': number;
    /**
     * Wybrany aktywny Professional
     * @type {string}
     * @memberof PublishReceptionAssignmentDto
     */
    'selectedEmergencyProfessionalUserId': string;
    /**
     *
     * @type {Array<string>}
     * @memberof PublishReceptionAssignmentDto
     */
    'callbackHandlerUserIds': Array<string>;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionAssignmentDto
     */
    'reason': PublishReceptionAssignmentDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionAssignmentDto
     */
    'note'?: string | null;
}

export const PublishReceptionAssignmentDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    EmergencyProfessionalUpdate: 'EMERGENCY_PROFESSIONAL_UPDATE',
    CallbackHandlersUpdate: 'CALLBACK_HANDLERS_UPDATE'
} as const;

export type PublishReceptionAssignmentDtoReasonEnum = typeof PublishReceptionAssignmentDtoReasonEnum[keyof typeof PublishReceptionAssignmentDtoReasonEnum];

/**
 *
 * @export
 * @interface PublishReceptionDestinationDto
 */
export interface PublishReceptionDestinationDto {
    /**
     *
     * @type {number}
     * @memberof PublishReceptionDestinationDto
     */
    'expectedRoutingRevision': number;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionDestinationDto
     */
    'canonicalE164': string;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionDestinationDto
     */
    'desiredState': PublishReceptionDestinationDtoDesiredStateEnum;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionDestinationDto
     */
    'validFrom': string;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionDestinationDto
     */
    'validUntil'?: string | null;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionDestinationDto
     */
    'reason': PublishReceptionDestinationDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionDestinationDto
     */
    'note'?: string | null;
}

export const PublishReceptionDestinationDtoDesiredStateEnum = {
    Active: 'ACTIVE',
    Revoked: 'REVOKED'
} as const;

export type PublishReceptionDestinationDtoDesiredStateEnum = typeof PublishReceptionDestinationDtoDesiredStateEnum[keyof typeof PublishReceptionDestinationDtoDesiredStateEnum];
export const PublishReceptionDestinationDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    DestinationUpdate: 'DESTINATION_UPDATE',
    ProviderReconciliation: 'PROVIDER_RECONCILIATION',
    Revocation: 'REVOCATION',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type PublishReceptionDestinationDtoReasonEnum = typeof PublishReceptionDestinationDtoReasonEnum[keyof typeof PublishReceptionDestinationDtoReasonEnum];

/**
 *
 * @export
 * @interface PublishReceptionFactDto
 */
export interface PublishReceptionFactDto {
    /**
     *
     * @type {string}
     * @memberof PublishReceptionFactDto
     */
    'factId': string;
    /**
     *
     * @type {number}
     * @memberof PublishReceptionFactDto
     */
    'expectedRevision': number;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionFactDto
     */
    'topic': string;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionFactDto
     */
    'statement': string;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionFactDto
     */
    'sourceKind': PublishReceptionFactDtoSourceKindEnum;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionFactDto
     */
    'sourceId': string;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionFactDto
     */
    'sourceRevision': string;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionFactDto
     */
    'validFrom': string;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionFactDto
     */
    'validUntil'?: string | null;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionFactDto
     */
    'reason': PublishReceptionFactDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionFactDto
     */
    'note'?: string | null;
}

export const PublishReceptionFactDtoSourceKindEnum = {
    CanonicalField: 'CANONICAL_FIELD',
    OrganizationDocument: 'ORGANIZATION_DOCUMENT'
} as const;

export type PublishReceptionFactDtoSourceKindEnum = typeof PublishReceptionFactDtoSourceKindEnum[keyof typeof PublishReceptionFactDtoSourceKindEnum];
export const PublishReceptionFactDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    FactsUpdate: 'FACTS_UPDATE',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type PublishReceptionFactDtoReasonEnum = typeof PublishReceptionFactDtoReasonEnum[keyof typeof PublishReceptionFactDtoReasonEnum];

/**
 *
 * @export
 * @interface PublishReceptionPolicyDraftDto
 */
export interface PublishReceptionPolicyDraftDto {
    /**
     *
     * @type {string}
     * @memberof PublishReceptionPolicyDraftDto
     */
    'note'?: string | null;
    /**
     *
     * @type {number}
     * @memberof PublishReceptionPolicyDraftDto
     */
    'expectedPublishedRevision': number;
    /**
     *
     * @type {string}
     * @memberof PublishReceptionPolicyDraftDto
     */
    'reason': PublishReceptionPolicyDraftDtoReasonEnum;
}

export const PublishReceptionPolicyDraftDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    PolicyUpdate: 'POLICY_UPDATE',
    FactsUpdate: 'FACTS_UPDATE',
    BookingPolicyUpdate: 'BOOKING_POLICY_UPDATE',
    ReceptionScheduleUpdate: 'RECEPTION_SCHEDULE_UPDATE',
    CallbackHandlerUpdate: 'CALLBACK_HANDLER_UPDATE',
    SafetyReferenceUpdate: 'SAFETY_REFERENCE_UPDATE',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type PublishReceptionPolicyDraftDtoReasonEnum = typeof PublishReceptionPolicyDraftDtoReasonEnum[keyof typeof PublishReceptionPolicyDraftDtoReasonEnum];

/**
 *
 * @export
 * @interface PublishServicePricePolicyDto
 */
export interface PublishServicePricePolicyDto {
    /**
     *
     * @type {string}
     * @memberof PublishServicePricePolicyDto
     */
    'serviceId': string;
    /**
     *
     * @type {number}
     * @memberof PublishServicePricePolicyDto
     */
    'expectedRevision': number;
    /**
     *
     * @type {string}
     * @memberof PublishServicePricePolicyDto
     */
    'kind': PublishServicePricePolicyDtoKindEnum;
    /**
     * Ignored; the spoken amount is always the Organization service price (ADR 0021).
     * @type {number}
     * @memberof PublishServicePricePolicyDto
     * @deprecated
     */
    'amountMinor'?: number | null;
    /**
     *
     * @type {string}
     * @memberof PublishServicePricePolicyDto
     */
    'currency': PublishServicePricePolicyDtoCurrencyEnum;
    /**
     *
     * @type {string}
     * @memberof PublishServicePricePolicyDto
     */
    'effectiveAt': string;
    /**
     *
     * @type {string}
     * @memberof PublishServicePricePolicyDto
     */
    'validUntil'?: string | null;
    /**
     *
     * @type {string}
     * @memberof PublishServicePricePolicyDto
     */
    'reason': PublishServicePricePolicyDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof PublishServicePricePolicyDto
     */
    'note'?: string | null;
}

export const PublishServicePricePolicyDtoKindEnum = {
    Exact: 'EXACT',
    From: 'FROM',
    DoNotQuote: 'DO_NOT_QUOTE'
} as const;

export type PublishServicePricePolicyDtoKindEnum = typeof PublishServicePricePolicyDtoKindEnum[keyof typeof PublishServicePricePolicyDtoKindEnum];
export const PublishServicePricePolicyDtoCurrencyEnum = {
    Pln: 'PLN'
} as const;

export type PublishServicePricePolicyDtoCurrencyEnum = typeof PublishServicePricePolicyDtoCurrencyEnum[keyof typeof PublishServicePricePolicyDtoCurrencyEnum];
export const PublishServicePricePolicyDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    FactsUpdate: 'FACTS_UPDATE',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type PublishServicePricePolicyDtoReasonEnum = typeof PublishServicePricePolicyDtoReasonEnum[keyof typeof PublishServicePricePolicyDtoReasonEnum];

/**
 *
 * @export
 * @interface PublishVoiceDevelopOperatorTrialDto
 */
export interface PublishVoiceDevelopOperatorTrialDto {
    /**
     *
     * @type {string}
     * @memberof PublishVoiceDevelopOperatorTrialDto
     */
    'bindingSha256': string;
    /**
     *
     * @type {Array<string>}
     * @memberof PublishVoiceDevelopOperatorTrialDto
     */
    'callerAllowlistHmac': Array<string>;
    /**
     *
     * @type {number}
     * @memberof PublishVoiceDevelopOperatorTrialDto
     */
    'acceptUnverifiedGoogleAndLegal': PublishVoiceDevelopOperatorTrialDtoAcceptUnverifiedGoogleAndLegalEnum;
}

export const PublishVoiceDevelopOperatorTrialDtoAcceptUnverifiedGoogleAndLegalEnum = {
    NUMBER_null: null
} as const;

export type PublishVoiceDevelopOperatorTrialDtoAcceptUnverifiedGoogleAndLegalEnum = typeof PublishVoiceDevelopOperatorTrialDtoAcceptUnverifiedGoogleAndLegalEnum[keyof typeof PublishVoiceDevelopOperatorTrialDtoAcceptUnverifiedGoogleAndLegalEnum];

/**
 *
 * @export
 * @interface PublishVoiceFallbackBundleDto
 */
export interface PublishVoiceFallbackBundleDto {
    /**
     *
     * @type {number}
     * @memberof PublishVoiceFallbackBundleDto
     */
    'expectedRevision': number;
    /**
     * Zatwierdzenie dokładnej treści fallback
     * @type {string}
     * @memberof PublishVoiceFallbackBundleDto
     */
    'approvalId': string;
    /**
     *
     * @type {number}
     * @memberof PublishVoiceFallbackBundleDto
     */
    'routingFence': number;
    /**
     *
     * @type {VoiceFallbackBundleContentDto}
     * @memberof PublishVoiceFallbackBundleDto
     */
    'content': VoiceFallbackBundleContentDto;
    /**
     * Kontrolowany powód publikacji bez danych osobowych
     * @type {string}
     * @memberof PublishVoiceFallbackBundleDto
     */
    'reason': string;
}
/**
 *
 * @export
 * @interface PublishVoiceMessagingDesiredDto
 */
export interface PublishVoiceMessagingDesiredDto {
    /**
     *
     * @type {string}
     * @memberof PublishVoiceMessagingDesiredDto
     */
    'accountSid': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceMessagingDesiredDto
     */
    'messagingServiceSid': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceMessagingDesiredDto
     */
    'senderE164': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceMessagingDesiredDto
     */
    'region': PublishVoiceMessagingDesiredDtoRegionEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceMessagingDesiredDto
     */
    'edge': PublishVoiceMessagingDesiredDtoEdgeEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceMessagingDesiredDto
     */
    'statusCallbackUrlTemplate': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceMessagingDesiredDto
     */
    'contentRetentionMode': PublishVoiceMessagingDesiredDtoContentRetentionModeEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceMessagingDesiredDto
     */
    'addressRetentionMode': PublishVoiceMessagingDesiredDtoAddressRetentionModeEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceMessagingDesiredDto
     */
    'providerErasureMode': PublishVoiceMessagingDesiredDtoProviderErasureModeEnum;
    /**
     *
     * @type {number}
     * @memberof PublishVoiceMessagingDesiredDto
     */
    'providerErasureDeadlineHours': number;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceMessagingDesiredDto
     */
    'requestId': string;
    /**
     *
     * @type {number}
     * @memberof PublishVoiceMessagingDesiredDto
     */
    'expectedRevision': number;
}

export const PublishVoiceMessagingDesiredDtoRegionEnum = {
    Ie1: 'ie1'
} as const;

export type PublishVoiceMessagingDesiredDtoRegionEnum = typeof PublishVoiceMessagingDesiredDtoRegionEnum[keyof typeof PublishVoiceMessagingDesiredDtoRegionEnum];
export const PublishVoiceMessagingDesiredDtoEdgeEnum = {
    Dublin: 'dublin'
} as const;

export type PublishVoiceMessagingDesiredDtoEdgeEnum = typeof PublishVoiceMessagingDesiredDtoEdgeEnum[keyof typeof PublishVoiceMessagingDesiredDtoEdgeEnum];
export const PublishVoiceMessagingDesiredDtoContentRetentionModeEnum = {
    DiscardBody: 'DISCARD_BODY'
} as const;

export type PublishVoiceMessagingDesiredDtoContentRetentionModeEnum = typeof PublishVoiceMessagingDesiredDtoContentRetentionModeEnum[keyof typeof PublishVoiceMessagingDesiredDtoContentRetentionModeEnum];
export const PublishVoiceMessagingDesiredDtoAddressRetentionModeEnum = {
    Obfuscate: 'OBFUSCATE'
} as const;

export type PublishVoiceMessagingDesiredDtoAddressRetentionModeEnum = typeof PublishVoiceMessagingDesiredDtoAddressRetentionModeEnum[keyof typeof PublishVoiceMessagingDesiredDtoAddressRetentionModeEnum];
export const PublishVoiceMessagingDesiredDtoProviderErasureModeEnum = {
    DeleteMessage: 'DELETE_MESSAGE'
} as const;

export type PublishVoiceMessagingDesiredDtoProviderErasureModeEnum = typeof PublishVoiceMessagingDesiredDtoProviderErasureModeEnum[keyof typeof PublishVoiceMessagingDesiredDtoProviderErasureModeEnum];

/**
 *
 * @export
 * @interface PublishVoicePilotEnvelopeDto
 */
export interface PublishVoicePilotEnvelopeDto {
    /**
     *
     * @type {number}
     * @memberof PublishVoicePilotEnvelopeDto
     */
    'expectedRevision': number;
    /**
     *
     * @type {string}
     * @memberof PublishVoicePilotEnvelopeDto
     */
    'state': PublishVoicePilotEnvelopeDtoStateEnum;
}

export const PublishVoicePilotEnvelopeDtoStateEnum = {
    Staged: 'STAGED',
    Active: 'ACTIVE',
    Suspended: 'SUSPENDED',
    Ended: 'ENDED'
} as const;

export type PublishVoicePilotEnvelopeDtoStateEnum = typeof PublishVoicePilotEnvelopeDtoStateEnum[keyof typeof PublishVoicePilotEnvelopeDtoStateEnum];

/**
 *
 * @export
 * @interface PublishVoiceProductionQualificationDto
 */
export interface PublishVoiceProductionQualificationDto {
    /**
     *
     * @type {number}
     * @memberof PublishVoiceProductionQualificationDto
     */
    'expectedRevision': number;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDto
     */
    'releaseId': string;
    /**
     *
     * @type {number}
     * @memberof PublishVoiceProductionQualificationDto
     */
    'releaseRevision': number;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDto
     */
    'category': PublishVoiceProductionQualificationDtoCategoryEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDto
     */
    'subjectRevision': string;
    /**
     *
     * @type {VoiceProductionQualificationSourceBindingDto}
     * @memberof PublishVoiceProductionQualificationDto
     */
    'source': VoiceProductionQualificationSourceBindingDto;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDto
     */
    'provenanceDigest': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDto
     */
    'observedAt': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDto
     */
    'expiresAt': string;
    /**
     *
     * @type {VoiceProductionVertexRuntimeDto}
     * @memberof PublishVoiceProductionQualificationDto
     */
    'vertexRuntime'?: VoiceProductionVertexRuntimeDto | null;
    /**
     *
     * @type {VoiceProductionReceptionAssetsDto}
     * @memberof PublishVoiceProductionQualificationDto
     */
    'receptionAssets'?: VoiceProductionReceptionAssetsDto | null;
    /**
     *
     * @type {PublishVoiceProductionQualificationDtoSmsRetentionReview}
     * @memberof PublishVoiceProductionQualificationDto
     */
    'smsRetentionReview'?: PublishVoiceProductionQualificationDtoSmsRetentionReview | null;
}

export const PublishVoiceProductionQualificationDtoCategoryEnum = {
    VertexRuntime: 'VERTEX_RUNTIME',
    VertexZeroRetention: 'VERTEX_ZERO_RETENTION',
    ReceptionAssets: 'RECEPTION_ASSETS',
    ProviderQualification: 'PROVIDER_QUALIFICATION',
    Phase1Safety: 'PHASE_1_SAFETY',
    RateCatalogue: 'RATE_CATALOGUE',
    BookingSafety: 'BOOKING_SAFETY',
    VoiceSmsProvider: 'VOICE_SMS_PROVIDER',
    VoiceSmsPrivacy: 'VOICE_SMS_PRIVACY',
    VoiceSmsContract: 'VOICE_SMS_CONTRACT',
    ContactCapability: 'CONTACT_CAPABILITY',
    VoiceSmsErasure: 'VOICE_SMS_ERASURE',
    PilotAccess: 'PILOT_ACCESS'
} as const;

export type PublishVoiceProductionQualificationDtoCategoryEnum = typeof PublishVoiceProductionQualificationDtoCategoryEnum[keyof typeof PublishVoiceProductionQualificationDtoCategoryEnum];

/**
 * Wymagany przegląd retencji dla VOICE_SMS_PRIVACY i VOICE_SMS_CONTRACT.
 * @export
 * @interface PublishVoiceProductionQualificationDtoSmsRetentionReview
 */
export interface PublishVoiceProductionQualificationDtoSmsRetentionReview {
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'modelVersion': PublishVoiceProductionQualificationDtoSmsRetentionReviewModelVersionEnum;
    /**
     *
     * @type {number}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'messagingDesiredRevision': number;
    /**
     *
     * @type {number}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'applicationSessionPiiMaxDays': PublishVoiceProductionQualificationDtoSmsRetentionReviewApplicationSessionPiiMaxDaysEnum;
    /**
     *
     * @type {number}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'providerMessageDeleteDeadlineHours': PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderMessageDeleteDeadlineHoursEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'contentRetention': PublishVoiceProductionQualificationDtoSmsRetentionReviewContentRetentionEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'optOutModel': PublishVoiceProductionQualificationDtoSmsRetentionReviewOptOutModelEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'providerBuiltInStopFiltering': PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderBuiltInStopFilteringEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'addressRetention': PublishVoiceProductionQualificationDtoSmsRetentionReviewAddressRetentionEnum;
    /**
     *
     * @type {number}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'providerProductionAccessMaxHours': PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderProductionAccessMaxHoursEnum;
    /**
     *
     * @type {number}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'providerBackupRetentionMaxDaysAfterDeletion': PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderBackupRetentionMaxDaysAfterDeletionEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'complianceData': PublishVoiceProductionQualificationDtoSmsRetentionReviewComplianceDataEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'compliancePurposes': PublishVoiceProductionQualificationDtoSmsRetentionReviewCompliancePurposesEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'ordinaryComplianceRetention': PublishVoiceProductionQualificationDtoSmsRetentionReviewOrdinaryComplianceRetentionEnum;
    /**
     *
     * @type {number}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'ordinaryComplianceRetentionMaxDays': number | null;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'legalHoldRetention': PublishVoiceProductionQualificationDtoSmsRetentionReviewLegalHoldRetentionEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'accessControls': PublishVoiceProductionQualificationDtoSmsRetentionReviewAccessControlsEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'dsarHandling': PublishVoiceProductionQualificationDtoSmsRetentionReviewDsarHandlingEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'optOutAndBillingRetention': PublishVoiceProductionQualificationDtoSmsRetentionReviewOptOutAndBillingRetentionEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'applicationSuppressionRetention': PublishVoiceProductionQualificationDtoSmsRetentionReviewApplicationSuppressionRetentionEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'privacyNoticeRevision': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'providerEvidenceDigest': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'retentionAssessmentDigest': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'reviewedAt': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'decision': PublishVoiceProductionQualificationDtoSmsRetentionReviewDecisionEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceProductionQualificationDtoSmsRetentionReview
     */
    'decisionEvidenceDigest': string;
}

export const PublishVoiceProductionQualificationDtoSmsRetentionReviewModelVersionEnum = {
    VoiceSmsRetentionReviewV2: 'voice-sms-retention-review.v2'
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewModelVersionEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewModelVersionEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewModelVersionEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewApplicationSessionPiiMaxDaysEnum = {
    NUMBER_30: 30
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewApplicationSessionPiiMaxDaysEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewApplicationSessionPiiMaxDaysEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewApplicationSessionPiiMaxDaysEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderMessageDeleteDeadlineHoursEnum = {
    NUMBER_23: 23
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderMessageDeleteDeadlineHoursEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderMessageDeleteDeadlineHoursEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderMessageDeleteDeadlineHoursEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewContentRetentionEnum = {
    Discard: 'discard'
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewContentRetentionEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewContentRetentionEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewContentRetentionEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewOptOutModelEnum = {
    ApplicationManagedV1: 'APPLICATION_MANAGED_V1'
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewOptOutModelEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewOptOutModelEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewOptOutModelEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderBuiltInStopFilteringEnum = {
    DisabledConfirmedByProvider: 'DISABLED_CONFIRMED_BY_PROVIDER'
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderBuiltInStopFilteringEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderBuiltInStopFilteringEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderBuiltInStopFilteringEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewAddressRetentionEnum = {
    Obfuscate: 'obfuscate'
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewAddressRetentionEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewAddressRetentionEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewAddressRetentionEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderProductionAccessMaxHoursEnum = {
    NUMBER_24: 24
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderProductionAccessMaxHoursEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderProductionAccessMaxHoursEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderProductionAccessMaxHoursEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderBackupRetentionMaxDaysAfterDeletionEnum = {
    NUMBER_30: 30
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderBackupRetentionMaxDaysAfterDeletionEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderBackupRetentionMaxDaysAfterDeletionEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewProviderBackupRetentionMaxDaysAfterDeletionEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewComplianceDataEnum = {
    MessageBodyPhoneNumbersAndMetadata: 'MESSAGE_BODY_PHONE_NUMBERS_AND_METADATA'
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewComplianceDataEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewComplianceDataEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewComplianceDataEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewCompliancePurposesEnum = {
    LegalAndRegulatory: 'LEGAL_AND_REGULATORY'
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewCompliancePurposesEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewCompliancePurposesEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewCompliancePurposesEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewOrdinaryComplianceRetentionEnum = {
    Bounded: 'BOUNDED',
    Unspecified: 'UNSPECIFIED'
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewOrdinaryComplianceRetentionEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewOrdinaryComplianceRetentionEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewOrdinaryComplianceRetentionEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewLegalHoldRetentionEnum = {
    MayExtendOrdinaryRetention: 'MAY_EXTEND_ORDINARY_RETENTION'
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewLegalHoldRetentionEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewLegalHoldRetentionEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewLegalHoldRetentionEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewAccessControlsEnum = {
    RestrictedProviderComplianceAccess: 'RESTRICTED_PROVIDER_COMPLIANCE_ACCESS'
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewAccessControlsEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewAccessControlsEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewAccessControlsEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewDsarHandlingEnum = {
    ProviderDpaProcessWithLegalExceptions: 'PROVIDER_DPA_PROCESS_WITH_LEGAL_EXCEPTIONS'
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewDsarHandlingEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewDsarHandlingEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewDsarHandlingEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewOptOutAndBillingRetentionEnum = {
    SeparatePurposeRetention: 'SEPARATE_PURPOSE_RETENTION'
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewOptOutAndBillingRetentionEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewOptOutAndBillingRetentionEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewOptOutAndBillingRetentionEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewApplicationSuppressionRetentionEnum = {
    UntilValidOptInOrReviewedRetirement: 'UNTIL_VALID_OPT_IN_OR_REVIEWED_RETIREMENT'
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewApplicationSuppressionRetentionEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewApplicationSuppressionRetentionEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewApplicationSuppressionRetentionEnum];
export const PublishVoiceProductionQualificationDtoSmsRetentionReviewDecisionEnum = {
    BoundedRetention: 'ACCEPT_BOUNDED_RETENTION',
    UnspecifiedRetentionException: 'ACCEPT_UNSPECIFIED_RETENTION_EXCEPTION'
} as const;

export type PublishVoiceProductionQualificationDtoSmsRetentionReviewDecisionEnum = typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewDecisionEnum[keyof typeof PublishVoiceProductionQualificationDtoSmsRetentionReviewDecisionEnum];

/**
 *
 * @export
 * @interface PublishVoiceQualifiedRatesDto
 */
export interface PublishVoiceQualifiedRatesDto {
    /**
     * Kontrolowany powód operacji na sterowaniu przyjęciem Voice
     * @type {string}
     * @memberof PublishVoiceQualifiedRatesDto
     */
    'reason': string;
    /**
     * Opcjonalna notatka operacyjna bez danych osobowych
     * @type {string}
     * @memberof PublishVoiceQualifiedRatesDto
     */
    'note'?: string;
    /**
     * Początek okresu ważności dowodu kwalifikacji
     * @type {string}
     * @memberof PublishVoiceQualifiedRatesDto
     */
    'qualifiedFrom': string;
    /**
     * Koniec okresu ważności dowodu kwalifikacji
     * @type {string}
     * @memberof PublishVoiceQualifiedRatesDto
     */
    'qualifiedUntil': string;
    /**
     * Wersja dowodu kwalifikacji stawek Phase 0
     * @type {string}
     * @memberof PublishVoiceQualifiedRatesDto
     */
    'qualificationEvidenceVersion': string;
    /**
     *
     * @type {Array<VoiceQualifiedCostComponentDto>}
     * @memberof PublishVoiceQualifiedRatesDto
     */
    'components': Array<VoiceQualifiedCostComponentDto>;
}
/**
 *
 * @export
 * @interface PublishVoiceQualifiedReleaseDto
 */
export interface PublishVoiceQualifiedReleaseDto {
    /**
     *
     * @type {number}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'expectedRevision': number;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'releaseId': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'qualifiedModelId': PublishVoiceQualifiedReleaseDtoQualifiedModelIdEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'vertexProjectId': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'vertexLocation': PublishVoiceQualifiedReleaseDtoVertexLocationEnum;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'voiceId': string;
    /**
     *
     * @type {number}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'voiceRevision': number;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'auditionAssetId': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'auditionAssetPublicUrl': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'auditionAssetSha256': string;
    /**
     *
     * @type {Array<VoiceQualifiedReleaseAssetEvidenceDto>}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'approvedAssets': Array<VoiceQualifiedReleaseAssetEvidenceDto>;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'rendererVersion': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'sdkVersion': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'qualificationEvidenceVersion': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'catalogueExpiresAt': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'evidenceExpiresAt': string;
    /**
     *
     * @type {string}
     * @memberof PublishVoiceQualifiedReleaseDto
     */
    'reason': PublishVoiceQualifiedReleaseDtoReasonEnum;
}

export const PublishVoiceQualifiedReleaseDtoQualifiedModelIdEnum = {
    GeminiLive25FlashNativeAudio: 'gemini-live-2.5-flash-native-audio'
} as const;

export type PublishVoiceQualifiedReleaseDtoQualifiedModelIdEnum = typeof PublishVoiceQualifiedReleaseDtoQualifiedModelIdEnum[keyof typeof PublishVoiceQualifiedReleaseDtoQualifiedModelIdEnum];
export const PublishVoiceQualifiedReleaseDtoVertexLocationEnum = {
    EuropeCentral2: 'europe-central2'
} as const;

export type PublishVoiceQualifiedReleaseDtoVertexLocationEnum = typeof PublishVoiceQualifiedReleaseDtoVertexLocationEnum[keyof typeof PublishVoiceQualifiedReleaseDtoVertexLocationEnum];
export const PublishVoiceQualifiedReleaseDtoReasonEnum = {
    QualificationRecorded: 'QUALIFICATION_RECORDED',
    EvidenceRefresh: 'EVIDENCE_REFRESH',
    ModelOrSdkChange: 'MODEL_OR_SDK_CHANGE',
    VoiceOrRendererChange: 'VOICE_OR_RENDERER_CHANGE',
    ForwardRollback: 'FORWARD_ROLLBACK',
    SyntheticHermeticTestOnly: 'SYNTHETIC_HERMETIC_TEST_ONLY'
} as const;

export type PublishVoiceQualifiedReleaseDtoReasonEnum = typeof PublishVoiceQualifiedReleaseDtoReasonEnum[keyof typeof PublishVoiceQualifiedReleaseDtoReasonEnum];

/**
 *
 * @export
 * @interface PublishWebinarRecordingDto
 */
export interface PublishWebinarRecordingDto {
    /**
     *
     * @type {string}
     * @memberof PublishWebinarRecordingDto
     */
    'recordingUrl': string;
    /**
     *
     * @type {string}
     * @memberof PublishWebinarRecordingDto
     */
    'audienceHash': string;
}
/**
 *
 * @export
 * @interface QualifiedVoiceReferenceDto
 */
export interface QualifiedVoiceReferenceDto {
    /**
     *
     * @type {string}
     * @memberof QualifiedVoiceReferenceDto
     */
    'voiceId': string;
    /**
     *
     * @type {number}
     * @memberof QualifiedVoiceReferenceDto
     */
    'revision': number;
}
/**
 *
 * @export
 * @interface RateByGuestDto
 */
export interface RateByGuestDto {
    /**
     *
     * @type {number}
     * @memberof RateByGuestDto
     */
    'professionalRating': number;
    /**
     *
     * @type {number}
     * @memberof RateByGuestDto
     */
    'organizationRating': number;
    /**
     *
     * @type {string}
     * @memberof RateByGuestDto
     */
    'review'?: string;
}
/**
 *
 * @export
 * @interface RateVisitDto
 */
export interface RateVisitDto {
    /**
     *
     * @type {string}
     * @memberof RateVisitDto
     */
    'review'?: string;
    /**
     *
     * @type {number}
     * @memberof RateVisitDto
     */
    'rate': number;
}
/**
 *
 * @export
 * @interface ReassignCallbackDto
 */
export interface ReassignCallbackDto {
    /**
     *
     * @type {number}
     * @memberof ReassignCallbackDto
     */
    'expectedClaimVersion': number;
    /**
     * Nowy, bieżący Callback Handler
     * @type {string}
     * @memberof ReassignCallbackDto
     */
    'newHandlerUserId': string;
}
/**
 *
 * @export
 * @interface ReassignVisitDto
 */
export interface ReassignVisitDto {
    /**
     * ID of the new professional to assign the visit to
     * @type {string}
     * @memberof ReassignVisitDto
     */
    'newProfessionalId': string;
}
/**
 *
 * @export
 * @interface ReceptionActivationEvidenceResponseDto
 */
export interface ReceptionActivationEvidenceResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionActivationEvidenceResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionActivationEvidenceResponseDto
     */
    'releaseId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionActivationEvidenceResponseDto
     */
    'capability': ReceptionActivationEvidenceResponseDtoCapabilityEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionActivationEvidenceResponseDto
     */
    'actorUserId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionActivationEvidenceResponseDto
     */
    'approvedAt': string;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionActivationEvidenceResponseDto
     */
    'current': boolean;
}

export const ReceptionActivationEvidenceResponseDtoCapabilityEnum = {
    Operations: 'VOICE_OPERATIONS',
    PrivacyReviewer: 'VOICE_PRIVACY_REVIEWER',
    SafetyReviewer: 'VOICE_SAFETY_REVIEWER'
} as const;

export type ReceptionActivationEvidenceResponseDtoCapabilityEnum = typeof ReceptionActivationEvidenceResponseDtoCapabilityEnum[keyof typeof ReceptionActivationEvidenceResponseDtoCapabilityEnum];

/**
 *
 * @export
 * @interface ReceptionActivationFinalizationResponseDto
 */
export interface ReceptionActivationFinalizationResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionActivationFinalizationResponseDto
     */
    'finalizationId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionActivationFinalizationResponseDto
     */
    'releaseId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionActivationFinalizationResponseDto
     */
    'finalizedAt': string;
}
/**
 *
 * @export
 * @interface ReceptionActivationHistoryResponseDto
 */
export interface ReceptionActivationHistoryResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionActivationHistoryResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionActivationHistoryResponseDto
     */
    'releaseId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionActivationHistoryResponseDto
     */
    'finalizedByUserId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionActivationHistoryResponseDto
     */
    'finalizedAt': string;
}
/**
 *
 * @export
 * @interface ReceptionActivationStatusResponseDto
 */
export interface ReceptionActivationStatusResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionActivationStatusResponseDto
     */
    'bookingConfirmationChannel'?: ReceptionActivationStatusResponseDtoBookingConfirmationChannelEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionActivationStatusResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionActivationStatusResponseDto
     */
    'releaseId': string;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionActivationStatusResponseDto
     */
    'receptionReady': boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof ReceptionActivationStatusResponseDto
     */
    'readinessReasons': Array<string>;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionActivationStatusResponseDto
     */
    'approvalsComplete': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionActivationStatusResponseDto
     */
    'finalized': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionActivationStatusResponseDto
     */
    'effectiveEnabled': boolean;
    /**
     *
     * @type {Array<ReceptionActivationEvidenceResponseDto>}
     * @memberof ReceptionActivationStatusResponseDto
     */
    'approvals': Array<ReceptionActivationEvidenceResponseDto>;
    /**
     *
     * @type {Array<ReceptionActivationHistoryResponseDto>}
     * @memberof ReceptionActivationStatusResponseDto
     */
    'finalizations': Array<ReceptionActivationHistoryResponseDto>;
}

export const ReceptionActivationStatusResponseDtoBookingConfirmationChannelEnum = {
    Email: 'EMAIL'
} as const;

export type ReceptionActivationStatusResponseDtoBookingConfirmationChannelEnum = typeof ReceptionActivationStatusResponseDtoBookingConfirmationChannelEnum[keyof typeof ReceptionActivationStatusResponseDtoBookingConfirmationChannelEnum];

/**
 *
 * @export
 * @interface ReceptionAssignmentCurrentResponseDto
 */
export interface ReceptionAssignmentCurrentResponseDto {
    /**
     *
     * @type {ReceptionAssignmentResponseDto}
     * @memberof ReceptionAssignmentCurrentResponseDto
     */
    'current': ReceptionAssignmentResponseDto | null;
}
/**
 *
 * @export
 * @interface ReceptionAssignmentHistoryResponseDto
 */
export interface ReceptionAssignmentHistoryResponseDto {
    /**
     *
     * @type {ReceptionAssignmentResponseDto}
     * @memberof ReceptionAssignmentHistoryResponseDto
     */
    'current'?: ReceptionAssignmentResponseDto | null;
    /**
     *
     * @type {Array<ReceptionAssignmentResponseDto>}
     * @memberof ReceptionAssignmentHistoryResponseDto
     */
    'published': Array<ReceptionAssignmentResponseDto>;
}
/**
 *
 * @export
 * @interface ReceptionAssignmentResponseDto
 */
export interface ReceptionAssignmentResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionAssignmentResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionAssignmentResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {number}
     * @memberof ReceptionAssignmentResponseDto
     */
    'assignmentFence': number;
    /**
     *
     * @type {string}
     * @memberof ReceptionAssignmentResponseDto
     */
    'selectedEmergencyProfessionalUserId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionAssignmentResponseDto
     */
    'professionalAssignmentId': string;
    /**
     *
     * @type {Array<ReceptionCallbackHandlerAssignmentResponseDto>}
     * @memberof ReceptionAssignmentResponseDto
     */
    'callbackHandlers': Array<ReceptionCallbackHandlerAssignmentResponseDto>;
    /**
     *
     * @type {Array<string>}
     * @memberof ReceptionAssignmentResponseDto
     */
    'callbackHandlerUserIds': Array<string>;
    /**
     *
     * @type {string}
     * @memberof ReceptionAssignmentResponseDto
     */
    'actorReferenceKind': ReceptionAssignmentResponseDtoActorReferenceKindEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionAssignmentResponseDto
     */
    'actorUserId'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionAssignmentResponseDto
     */
    'actorPseudonym'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionAssignmentResponseDto
     */
    'actorErasedAt'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionAssignmentResponseDto
     */
    'reason': ReceptionAssignmentResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionAssignmentResponseDto
     */
    'note'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionAssignmentResponseDto
     */
    'publishedAt': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionAssignmentResponseDto
     */
    'retainUntil'?: string | null;
}

export const ReceptionAssignmentResponseDtoActorReferenceKindEnum = {
    UserId: 'USER_ID',
    ErasedPseudonym: 'ERASED_PSEUDONYM'
} as const;

export type ReceptionAssignmentResponseDtoActorReferenceKindEnum = typeof ReceptionAssignmentResponseDtoActorReferenceKindEnum[keyof typeof ReceptionAssignmentResponseDtoActorReferenceKindEnum];
export const ReceptionAssignmentResponseDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    EmergencyProfessionalUpdate: 'EMERGENCY_PROFESSIONAL_UPDATE',
    CallbackHandlersUpdate: 'CALLBACK_HANDLERS_UPDATE'
} as const;

export type ReceptionAssignmentResponseDtoReasonEnum = typeof ReceptionAssignmentResponseDtoReasonEnum[keyof typeof ReceptionAssignmentResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface ReceptionCallbackHandlerAssignmentResponseDto
 */
export interface ReceptionCallbackHandlerAssignmentResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionCallbackHandlerAssignmentResponseDto
     */
    'assignmentId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionCallbackHandlerAssignmentResponseDto
     */
    'userId': string;
    /**
     *
     * @type {number}
     * @memberof ReceptionCallbackHandlerAssignmentResponseDto
     */
    'assignmentRevision': number;
}
/**
 *
 * @export
 * @interface ReceptionClosureEventResponseDto
 */
export interface ReceptionClosureEventResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionClosureEventResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionClosureEventResponseDto
     */
    'closureId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionClosureEventResponseDto
     */
    'eventType': ReceptionClosureEventResponseDtoEventTypeEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionClosureEventResponseDto
     */
    'startsAt': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionClosureEventResponseDto
     */
    'endsAt': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionClosureEventResponseDto
     */
    'reason': ReceptionClosureEventResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionClosureEventResponseDto
     */
    'actorReferenceKind': ReceptionClosureEventResponseDtoActorReferenceKindEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionClosureEventResponseDto
     */
    'actorUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionClosureEventResponseDto
     */
    'actorPseudonym': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionClosureEventResponseDto
     */
    'actorErasedAt': string | null;
    /**
     *
     * @type {number}
     * @memberof ReceptionClosureEventResponseDto
     */
    'policyRevision': number;
    /**
     *
     * @type {string}
     * @memberof ReceptionClosureEventResponseDto
     */
    'occurredAt': string;
}

export const ReceptionClosureEventResponseDtoEventTypeEnum = {
    Created: 'CREATED',
    Cancelled: 'CANCELLED'
} as const;

export type ReceptionClosureEventResponseDtoEventTypeEnum = typeof ReceptionClosureEventResponseDtoEventTypeEnum[keyof typeof ReceptionClosureEventResponseDtoEventTypeEnum];
export const ReceptionClosureEventResponseDtoReasonEnum = {
    ManualClosure: 'MANUAL_CLOSURE',
    StaffUnavailable: 'STAFF_UNAVAILABLE',
    FacilityEvent: 'FACILITY_EVENT'
} as const;

export type ReceptionClosureEventResponseDtoReasonEnum = typeof ReceptionClosureEventResponseDtoReasonEnum[keyof typeof ReceptionClosureEventResponseDtoReasonEnum];
export const ReceptionClosureEventResponseDtoActorReferenceKindEnum = {
    UserId: 'USER_ID',
    ErasedPseudonym: 'ERASED_PSEUDONYM'
} as const;

export type ReceptionClosureEventResponseDtoActorReferenceKindEnum = typeof ReceptionClosureEventResponseDtoActorReferenceKindEnum[keyof typeof ReceptionClosureEventResponseDtoActorReferenceKindEnum];

/**
 *
 * @export
 * @interface ReceptionClosureHistoryResponseDto
 */
export interface ReceptionClosureHistoryResponseDto {
    /**
     *
     * @type {number}
     * @memberof ReceptionClosureHistoryResponseDto
     */
    'currentPolicyRevision': number;
    /**
     *
     * @type {Array<ReceptionClosureEventResponseDto>}
     * @memberof ReceptionClosureHistoryResponseDto
     */
    'active': Array<ReceptionClosureEventResponseDto>;
    /**
     *
     * @type {Array<ReceptionClosureEventResponseDto>}
     * @memberof ReceptionClosureHistoryResponseDto
     */
    'history': Array<ReceptionClosureEventResponseDto>;
}
/**
 *
 * @export
 * @interface ReceptionClosureSnapshotDto
 */
export interface ReceptionClosureSnapshotDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionClosureSnapshotDto
     */
    'closureId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionClosureSnapshotDto
     */
    'startsAt': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionClosureSnapshotDto
     */
    'endsAt': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionClosureSnapshotDto
     */
    'reason': ReceptionClosureSnapshotDtoReasonEnum;
}

export const ReceptionClosureSnapshotDtoReasonEnum = {
    ManualClosure: 'MANUAL_CLOSURE',
    StaffUnavailable: 'STAFF_UNAVAILABLE',
    FacilityEvent: 'FACILITY_EVENT'
} as const;

export type ReceptionClosureSnapshotDtoReasonEnum = typeof ReceptionClosureSnapshotDtoReasonEnum[keyof typeof ReceptionClosureSnapshotDtoReasonEnum];

/**
 *
 * @export
 * @interface ReceptionControlResultResponseDto
 */
export interface ReceptionControlResultResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionControlResultResponseDto
     */
    'type': ReceptionControlResultResponseDtoTypeEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionControlResultResponseDto
     */
    'approvalId'?: string;
    /**
     *
     * @type {string}
     * @memberof ReceptionControlResultResponseDto
     */
    'incidentId'?: string;
    /**
     *
     * @type {string}
     * @memberof ReceptionControlResultResponseDto
     */
    'proposalId'?: string;
    /**
     *
     * @type {number}
     * @memberof ReceptionControlResultResponseDto
     */
    'revision'?: number;
    /**
     *
     * @type {number}
     * @memberof ReceptionControlResultResponseDto
     */
    'terminationRequested'?: number;
}

export const ReceptionControlResultResponseDtoTypeEnum = {
    ActivationApproved: 'ACTIVATION_APPROVED',
    IncidentApplied: 'INCIDENT_APPLIED',
    TerminationProposed: 'TERMINATION_PROPOSED',
    ReopenProposed: 'REOPEN_PROPOSED',
    ActiveSessionTerminationRequested: 'ACTIVE_SESSION_TERMINATION_REQUESTED',
    IncidentReopened: 'INCIDENT_REOPENED'
} as const;

export type ReceptionControlResultResponseDtoTypeEnum = typeof ReceptionControlResultResponseDtoTypeEnum[keyof typeof ReceptionControlResultResponseDtoTypeEnum];

/**
 *
 * @export
 * @interface ReceptionDesiredStateResponseDto
 */
export interface ReceptionDesiredStateResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionDesiredStateResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionDesiredStateResponseDto
     */
    'desiredEnabled': boolean;
    /**
     *
     * @type {number}
     * @memberof ReceptionDesiredStateResponseDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof ReceptionDesiredStateResponseDto
     */
    'updatedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionDesiredStateResponseDto
     */
    'updatedByUserId': string | null;
}
/**
 *
 * @export
 * @interface ReceptionDestinationCurrentResponseDto
 */
export interface ReceptionDestinationCurrentResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'destinationId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'kind': ReceptionDestinationCurrentResponseDtoKindEnum;
    /**
     *
     * @type {number}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'routingRevision': number;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'canonicalE164': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'desiredState': ReceptionDestinationCurrentResponseDtoDesiredStateEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'validFrom': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'validUntil': string | null;
    /**
     *
     * @type {ReceptionDestinationProviderReferenceResponseDto}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'desiredProviderReference': ReceptionDestinationProviderReferenceResponseDto;
    /**
     *
     * @type {ReceptionDestinationObservedProviderReferenceResponseDto}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'observedProviderReference': ReceptionDestinationObservedProviderReferenceResponseDto | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'fingerprint': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'publicationSource': ReceptionDestinationCurrentResponseDtoPublicationSourceEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'actorUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'internalServiceId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'internalRequestId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'reason': ReceptionDestinationCurrentResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'note': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'publishedAt': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'supersededAt': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'retainUntil': string | null;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'active': boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof ReceptionDestinationCurrentResponseDto
     */
    'safeFailureReasons': ReceptionDestinationCurrentResponseDtoSafeFailureReasonsEnum;
}

export const ReceptionDestinationCurrentResponseDtoKindEnum = {
    Ordinary: 'ORDINARY',
    Emergency: 'EMERGENCY'
} as const;

export type ReceptionDestinationCurrentResponseDtoKindEnum = typeof ReceptionDestinationCurrentResponseDtoKindEnum[keyof typeof ReceptionDestinationCurrentResponseDtoKindEnum];
export const ReceptionDestinationCurrentResponseDtoDesiredStateEnum = {
    Active: 'ACTIVE',
    Revoked: 'REVOKED'
} as const;

export type ReceptionDestinationCurrentResponseDtoDesiredStateEnum = typeof ReceptionDestinationCurrentResponseDtoDesiredStateEnum[keyof typeof ReceptionDestinationCurrentResponseDtoDesiredStateEnum];
export const ReceptionDestinationCurrentResponseDtoPublicationSourceEnum = {
    OrganizationMember: 'ORGANIZATION_MEMBER',
    AuthenticatedInternalService: 'AUTHENTICATED_INTERNAL_SERVICE'
} as const;

export type ReceptionDestinationCurrentResponseDtoPublicationSourceEnum = typeof ReceptionDestinationCurrentResponseDtoPublicationSourceEnum[keyof typeof ReceptionDestinationCurrentResponseDtoPublicationSourceEnum];
export const ReceptionDestinationCurrentResponseDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    DestinationUpdate: 'DESTINATION_UPDATE',
    ProviderReconciliation: 'PROVIDER_RECONCILIATION',
    Revocation: 'REVOCATION',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type ReceptionDestinationCurrentResponseDtoReasonEnum = typeof ReceptionDestinationCurrentResponseDtoReasonEnum[keyof typeof ReceptionDestinationCurrentResponseDtoReasonEnum];
export const ReceptionDestinationCurrentResponseDtoSafeFailureReasonsEnum = {
    DestinationRevoked: 'DESTINATION_REVOKED',
    DestinationNotYetValid: 'DESTINATION_NOT_YET_VALID',
    DestinationExpired: 'DESTINATION_EXPIRED',
    ProviderObservationMissing: 'PROVIDER_OBSERVATION_MISSING',
    ProviderObservationStale: 'PROVIDER_OBSERVATION_STALE',
    ProviderObservationMismatch: 'PROVIDER_OBSERVATION_MISMATCH'
} as const;

export type ReceptionDestinationCurrentResponseDtoSafeFailureReasonsEnum = typeof ReceptionDestinationCurrentResponseDtoSafeFailureReasonsEnum[keyof typeof ReceptionDestinationCurrentResponseDtoSafeFailureReasonsEnum];

/**
 *
 * @export
 * @interface ReceptionDestinationObservedProviderReferenceResponseDto
 */
export interface ReceptionDestinationObservedProviderReferenceResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationObservedProviderReferenceResponseDto
     */
    'provider': ReceptionDestinationObservedProviderReferenceResponseDtoProviderEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationObservedProviderReferenceResponseDto
     */
    'accountSid': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationObservedProviderReferenceResponseDto
     */
    'resourceSid': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationObservedProviderReferenceResponseDto
     */
    'region': ReceptionDestinationObservedProviderReferenceResponseDtoRegionEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationObservedProviderReferenceResponseDto
     */
    'configurationRevision': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationObservedProviderReferenceResponseDto
     */
    'observedAt': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationObservedProviderReferenceResponseDto
     */
    'evidenceExpiresAt': string;
}

export const ReceptionDestinationObservedProviderReferenceResponseDtoProviderEnum = {
    Twilio: 'TWILIO'
} as const;

export type ReceptionDestinationObservedProviderReferenceResponseDtoProviderEnum = typeof ReceptionDestinationObservedProviderReferenceResponseDtoProviderEnum[keyof typeof ReceptionDestinationObservedProviderReferenceResponseDtoProviderEnum];
export const ReceptionDestinationObservedProviderReferenceResponseDtoRegionEnum = {
    Ie1: 'IE1'
} as const;

export type ReceptionDestinationObservedProviderReferenceResponseDtoRegionEnum = typeof ReceptionDestinationObservedProviderReferenceResponseDtoRegionEnum[keyof typeof ReceptionDestinationObservedProviderReferenceResponseDtoRegionEnum];

/**
 *
 * @export
 * @interface ReceptionDestinationProviderReferenceResponseDto
 */
export interface ReceptionDestinationProviderReferenceResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationProviderReferenceResponseDto
     */
    'provider': ReceptionDestinationProviderReferenceResponseDtoProviderEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationProviderReferenceResponseDto
     */
    'accountSid': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationProviderReferenceResponseDto
     */
    'resourceSid': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationProviderReferenceResponseDto
     */
    'region': ReceptionDestinationProviderReferenceResponseDtoRegionEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationProviderReferenceResponseDto
     */
    'configurationRevision': string;
}

export const ReceptionDestinationProviderReferenceResponseDtoProviderEnum = {
    Twilio: 'TWILIO'
} as const;

export type ReceptionDestinationProviderReferenceResponseDtoProviderEnum = typeof ReceptionDestinationProviderReferenceResponseDtoProviderEnum[keyof typeof ReceptionDestinationProviderReferenceResponseDtoProviderEnum];
export const ReceptionDestinationProviderReferenceResponseDtoRegionEnum = {
    Ie1: 'IE1'
} as const;

export type ReceptionDestinationProviderReferenceResponseDtoRegionEnum = typeof ReceptionDestinationProviderReferenceResponseDtoRegionEnum[keyof typeof ReceptionDestinationProviderReferenceResponseDtoRegionEnum];

/**
 *
 * @export
 * @interface ReceptionDestinationRevisionResponseDto
 */
export interface ReceptionDestinationRevisionResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'destinationId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'kind': ReceptionDestinationRevisionResponseDtoKindEnum;
    /**
     *
     * @type {number}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'routingRevision': number;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'canonicalE164': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'desiredState': ReceptionDestinationRevisionResponseDtoDesiredStateEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'validFrom': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'validUntil': string | null;
    /**
     *
     * @type {ReceptionDestinationProviderReferenceResponseDto}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'desiredProviderReference': ReceptionDestinationProviderReferenceResponseDto;
    /**
     *
     * @type {ReceptionDestinationObservedProviderReferenceResponseDto}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'observedProviderReference': ReceptionDestinationObservedProviderReferenceResponseDto | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'fingerprint': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'publicationSource': ReceptionDestinationRevisionResponseDtoPublicationSourceEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'actorUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'internalServiceId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'internalRequestId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'reason': ReceptionDestinationRevisionResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'note': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'publishedAt': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'supersededAt': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionDestinationRevisionResponseDto
     */
    'retainUntil': string | null;
}

export const ReceptionDestinationRevisionResponseDtoKindEnum = {
    Ordinary: 'ORDINARY',
    Emergency: 'EMERGENCY'
} as const;

export type ReceptionDestinationRevisionResponseDtoKindEnum = typeof ReceptionDestinationRevisionResponseDtoKindEnum[keyof typeof ReceptionDestinationRevisionResponseDtoKindEnum];
export const ReceptionDestinationRevisionResponseDtoDesiredStateEnum = {
    Active: 'ACTIVE',
    Revoked: 'REVOKED'
} as const;

export type ReceptionDestinationRevisionResponseDtoDesiredStateEnum = typeof ReceptionDestinationRevisionResponseDtoDesiredStateEnum[keyof typeof ReceptionDestinationRevisionResponseDtoDesiredStateEnum];
export const ReceptionDestinationRevisionResponseDtoPublicationSourceEnum = {
    OrganizationMember: 'ORGANIZATION_MEMBER',
    AuthenticatedInternalService: 'AUTHENTICATED_INTERNAL_SERVICE'
} as const;

export type ReceptionDestinationRevisionResponseDtoPublicationSourceEnum = typeof ReceptionDestinationRevisionResponseDtoPublicationSourceEnum[keyof typeof ReceptionDestinationRevisionResponseDtoPublicationSourceEnum];
export const ReceptionDestinationRevisionResponseDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    DestinationUpdate: 'DESTINATION_UPDATE',
    ProviderReconciliation: 'PROVIDER_RECONCILIATION',
    Revocation: 'REVOCATION',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type ReceptionDestinationRevisionResponseDtoReasonEnum = typeof ReceptionDestinationRevisionResponseDtoReasonEnum[keyof typeof ReceptionDestinationRevisionResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface ReceptionFactGroundingSourceDto
 */
export interface ReceptionFactGroundingSourceDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionFactGroundingSourceDto
     */
    'kind': ReceptionFactGroundingSourceDtoKindEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactGroundingSourceDto
     */
    'referenceId': string;
    /**
     *
     * @type {number}
     * @memberof ReceptionFactGroundingSourceDto
     */
    'version': number;
}

export const ReceptionFactGroundingSourceDtoKindEnum = {
    CanonicalField: 'CANONICAL_FIELD',
    OrganizationDocument: 'ORGANIZATION_DOCUMENT'
} as const;

export type ReceptionFactGroundingSourceDtoKindEnum = typeof ReceptionFactGroundingSourceDtoKindEnum[keyof typeof ReceptionFactGroundingSourceDtoKindEnum];

/**
 *
 * @export
 * @interface ReceptionFactRevisionResponseDto
 */
export interface ReceptionFactRevisionResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'factId': string;
    /**
     *
     * @type {number}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'topic': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'statement': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'sourceKind': ReceptionFactRevisionResponseDtoSourceKindEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'sourceId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'sourceRevision': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'validFrom': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'validUntil'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'reason': ReceptionFactRevisionResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'note'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'actorUserId'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'actorPseudonym'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'actorPseudonymizedAt'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'publishedAt': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'supersededAt'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactRevisionResponseDto
     */
    'retainUntil'?: string | null;
}

export const ReceptionFactRevisionResponseDtoSourceKindEnum = {
    CanonicalField: 'CANONICAL_FIELD',
    OrganizationDocument: 'ORGANIZATION_DOCUMENT'
} as const;

export type ReceptionFactRevisionResponseDtoSourceKindEnum = typeof ReceptionFactRevisionResponseDtoSourceKindEnum[keyof typeof ReceptionFactRevisionResponseDtoSourceKindEnum];
export const ReceptionFactRevisionResponseDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    FactsUpdate: 'FACTS_UPDATE',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type ReceptionFactRevisionResponseDtoReasonEnum = typeof ReceptionFactRevisionResponseDtoReasonEnum[keyof typeof ReceptionFactRevisionResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface ReceptionFactSnapshotDto
 */
export interface ReceptionFactSnapshotDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionFactSnapshotDto
     */
    'factId': string;
    /**
     *
     * @type {number}
     * @memberof ReceptionFactSnapshotDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactSnapshotDto
     */
    'statement': string;
    /**
     *
     * @type {ReceptionFactGroundingSourceDto}
     * @memberof ReceptionFactSnapshotDto
     */
    'groundingSource': ReceptionFactGroundingSourceDto;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactSnapshotDto
     */
    'validFrom': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionFactSnapshotDto
     */
    'validUntil'?: string | null;
}
/**
 *
 * @export
 * @interface ReceptionHoursWindowDto
 */
export interface ReceptionHoursWindowDto {
    /**
     *
     * @type {number}
     * @memberof ReceptionHoursWindowDto
     */
    'dayOfWeek': number;
    /**
     *
     * @type {number}
     * @memberof ReceptionHoursWindowDto
     */
    'startMinute': number;
    /**
     *
     * @type {number}
     * @memberof ReceptionHoursWindowDto
     */
    'endMinute': number;
}
/**
 *
 * @export
 * @interface ReceptionIncidentHistoryEventResponseDto
 */
export interface ReceptionIncidentHistoryEventResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionIncidentHistoryEventResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionIncidentHistoryEventResponseDto
     */
    'proposalId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionIncidentHistoryEventResponseDto
     */
    'incidentId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionIncidentHistoryEventResponseDto
     */
    'organizationId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionIncidentHistoryEventResponseDto
     */
    'eventType': ReceptionIncidentHistoryEventResponseDtoEventTypeEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionIncidentHistoryEventResponseDto
     */
    'actorUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionIncidentHistoryEventResponseDto
     */
    'reason': ReceptionIncidentHistoryEventResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionIncidentHistoryEventResponseDto
     */
    'note': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionIncidentHistoryEventResponseDto
     */
    'createdAt': string;
}

export const ReceptionIncidentHistoryEventResponseDtoEventTypeEnum = {
    BlockApplied: 'BLOCK_APPLIED',
    SafetyOverrideApplied: 'SAFETY_OVERRIDE_APPLIED',
    TerminationProposed: 'TERMINATION_PROPOSED',
    TerminationApproved: 'TERMINATION_APPROVED',
    AutomatedTermination: 'AUTOMATED_TERMINATION',
    ReopenProposed: 'REOPEN_PROPOSED',
    ReopenApproved: 'REOPEN_APPROVED'
} as const;

export type ReceptionIncidentHistoryEventResponseDtoEventTypeEnum = typeof ReceptionIncidentHistoryEventResponseDtoEventTypeEnum[keyof typeof ReceptionIncidentHistoryEventResponseDtoEventTypeEnum];
export const ReceptionIncidentHistoryEventResponseDtoReasonEnum = {
    FirstActivation: 'FIRST_ACTIVATION',
    ProviderIncident: 'PROVIDER_INCIDENT',
    ProviderDrift: 'PROVIDER_DRIFT',
    PrivacyIncident: 'PRIVACY_INCIDENT',
    SafetyEvidenceInvalidated: 'SAFETY_EVIDENCE_INVALIDATED',
    EmergencyRouteCompromised: 'EMERGENCY_ROUTE_COMPROMISED',
    SpendProtection: 'SPEND_PROTECTION',
    AutomatedSecurityTrigger: 'AUTOMATED_SECURITY_TRIGGER',
    IncidentResolved: 'INCIDENT_RESOLVED'
} as const;

export type ReceptionIncidentHistoryEventResponseDtoReasonEnum = typeof ReceptionIncidentHistoryEventResponseDtoReasonEnum[keyof typeof ReceptionIncidentHistoryEventResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface ReceptionIncidentSafetyEffectsResponseDto
 */
export interface ReceptionIncidentSafetyEffectsResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionIncidentSafetyEffectsResponseDto
     */
    'organizationId': string | null;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionIncidentSafetyEffectsResponseDto
     */
    'admissionBlocked': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionIncidentSafetyEffectsResponseDto
     */
    'bookingDisabled': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionIncidentSafetyEffectsResponseDto
     */
    'routingRevoked': boolean;
    /**
     *
     * @type {number}
     * @memberof ReceptionIncidentSafetyEffectsResponseDto
     */
    'revision': number;
}
/**
 *
 * @export
 * @interface ReceptionIncidentStateResponseDto
 */
export interface ReceptionIncidentStateResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionIncidentStateResponseDto
     */
    'scopeKey': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionIncidentStateResponseDto
     */
    'organizationId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionIncidentStateResponseDto
     */
    'incidentId': string | null;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionIncidentStateResponseDto
     */
    'admissionBlocked': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionIncidentStateResponseDto
     */
    'bookingDisabled': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionIncidentStateResponseDto
     */
    'routingRevoked': boolean;
    /**
     *
     * @type {number}
     * @memberof ReceptionIncidentStateResponseDto
     */
    'revision': number;
    /**
     *
     * @type {Array<ReceptionIncidentHistoryEventResponseDto>}
     * @memberof ReceptionIncidentStateResponseDto
     */
    'pendingProposals': Array<ReceptionIncidentHistoryEventResponseDto>;
}
/**
 *
 * @export
 * @interface ReceptionOrganizationGovernanceActivationResponseDto
 */
export interface ReceptionOrganizationGovernanceActivationResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceActivationResponseDto
     */
    'releaseId': string;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionOrganizationGovernanceActivationResponseDto
     */
    'approvalsComplete': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionOrganizationGovernanceActivationResponseDto
     */
    'finalized': boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof ReceptionOrganizationGovernanceActivationResponseDto
     */
    'missingCapabilities': Array<string>;
}
/**
 *
 * @export
 * @interface ReceptionOrganizationGovernanceAllowanceResponseDto
 */
export interface ReceptionOrganizationGovernanceAllowanceResponseDto {
    /**
     *
     * @type {boolean}
     * @memberof ReceptionOrganizationGovernanceAllowanceResponseDto
     */
    'available': boolean;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceAllowanceResponseDto
     */
    'warsawMonth'?: string;
    /**
     *
     * @type {number}
     * @memberof ReceptionOrganizationGovernanceAllowanceResponseDto
     */
    'grantedMs'?: number;
    /**
     *
     * @type {number}
     * @memberof ReceptionOrganizationGovernanceAllowanceResponseDto
     */
    'usedMs'?: number;
    /**
     *
     * @type {number}
     * @memberof ReceptionOrganizationGovernanceAllowanceResponseDto
     */
    'reservedMs'?: number;
    /**
     *
     * @type {number}
     * @memberof ReceptionOrganizationGovernanceAllowanceResponseDto
     */
    'acceptedCallCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ReceptionOrganizationGovernanceAllowanceResponseDto
     */
    'nextMonthRecurringBaseGrantMs'?: number | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceAllowanceResponseDto
     */
    'safeReasonCode'?: string;
}
/**
 *
 * @export
 * @interface ReceptionOrganizationGovernanceBlockerResponseDto
 */
export interface ReceptionOrganizationGovernanceBlockerResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceBlockerResponseDto
     */
    'code': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceBlockerResponseDto
     */
    'category': ReceptionOrganizationGovernanceBlockerResponseDtoCategoryEnum;
}

export const ReceptionOrganizationGovernanceBlockerResponseDtoCategoryEnum = {
    Clinic: 'CLINIC',
    Vetsi: 'VETSI',
    Approval: 'APPROVAL',
    Temporary: 'TEMPORARY',
    Unknown: 'UNKNOWN'
} as const;

export type ReceptionOrganizationGovernanceBlockerResponseDtoCategoryEnum = typeof ReceptionOrganizationGovernanceBlockerResponseDtoCategoryEnum[keyof typeof ReceptionOrganizationGovernanceBlockerResponseDtoCategoryEnum];

/**
 *
 * @export
 * @interface ReceptionOrganizationGovernanceConcurrencyCounterResponseDto
 */
export interface ReceptionOrganizationGovernanceConcurrencyCounterResponseDto {
    /**
     *
     * @type {number}
     * @memberof ReceptionOrganizationGovernanceConcurrencyCounterResponseDto
     */
    'active': number;
    /**
     *
     * @type {number}
     * @memberof ReceptionOrganizationGovernanceConcurrencyCounterResponseDto
     */
    'limit': number;
}
/**
 *
 * @export
 * @interface ReceptionOrganizationGovernanceConcurrencyResponseDto
 */
export interface ReceptionOrganizationGovernanceConcurrencyResponseDto {
    /**
     *
     * @type {ReceptionOrganizationGovernanceConcurrencyCounterResponseDto}
     * @memberof ReceptionOrganizationGovernanceConcurrencyResponseDto
     */
    'organization': ReceptionOrganizationGovernanceConcurrencyCounterResponseDto;
    /**
     *
     * @type {ReceptionOrganizationGovernanceConcurrencyCounterResponseDto}
     * @memberof ReceptionOrganizationGovernanceConcurrencyResponseDto
     */
    'global': ReceptionOrganizationGovernanceConcurrencyCounterResponseDto;
}
/**
 *
 * @export
 * @interface ReceptionOrganizationGovernanceIncidentEffectsResponseDto
 */
export interface ReceptionOrganizationGovernanceIncidentEffectsResponseDto {
    /**
     *
     * @type {boolean}
     * @memberof ReceptionOrganizationGovernanceIncidentEffectsResponseDto
     */
    'admissionBlocked': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionOrganizationGovernanceIncidentEffectsResponseDto
     */
    'bookingDisabled': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionOrganizationGovernanceIncidentEffectsResponseDto
     */
    'routingRevoked': boolean;
    /**
     *
     * @type {number}
     * @memberof ReceptionOrganizationGovernanceIncidentEffectsResponseDto
     */
    'revision': number;
}
/**
 *
 * @export
 * @interface ReceptionOrganizationGovernanceIncidentsResponseDto
 */
export interface ReceptionOrganizationGovernanceIncidentsResponseDto {
    /**
     *
     * @type {ReceptionOrganizationGovernanceIncidentEffectsResponseDto}
     * @memberof ReceptionOrganizationGovernanceIncidentsResponseDto
     */
    'global': ReceptionOrganizationGovernanceIncidentEffectsResponseDto;
    /**
     *
     * @type {ReceptionOrganizationGovernanceIncidentEffectsResponseDto}
     * @memberof ReceptionOrganizationGovernanceIncidentsResponseDto
     */
    'organization': ReceptionOrganizationGovernanceIncidentEffectsResponseDto;
}
/**
 *
 * @export
 * @interface ReceptionOrganizationGovernanceLineResponseDto
 */
export interface ReceptionOrganizationGovernanceLineResponseDto {
    /**
     *
     * @type {boolean}
     * @memberof ReceptionOrganizationGovernanceLineResponseDto
     */
    'assigned': boolean;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceLineResponseDto
     */
    'assignedE164': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceLineResponseDto
     */
    'assignmentState': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceLineResponseDto
     */
    'desiredState': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceLineResponseDto
     */
    'observedState': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceLineResponseDto
     */
    'reconciliationStatus': string | null;
    /**
     *
     * @type {Array<string>}
     * @memberof ReceptionOrganizationGovernanceLineResponseDto
     */
    'reconciliationReasons': Array<string>;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceLineResponseDto
     */
    'reconciledAt': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceLineResponseDto
     */
    'ordinaryDestinationE164': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceLineResponseDto
     */
    'upstreamForwardingE164': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceLineResponseDto
     */
    'forwardingReadiness': ReceptionOrganizationGovernanceLineResponseDtoForwardingReadinessEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceLineResponseDto
     */
    'forwardingDetection': ReceptionOrganizationGovernanceLineResponseDtoForwardingDetectionEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceLineResponseDto
     */
    'forwardingObservedAt': string | null;
}

export const ReceptionOrganizationGovernanceLineResponseDtoForwardingReadinessEnum = {
    ConfigurationRequired: 'CONFIGURATION_REQUIRED',
    ReadyForTest: 'READY_FOR_TEST'
} as const;

export type ReceptionOrganizationGovernanceLineResponseDtoForwardingReadinessEnum = typeof ReceptionOrganizationGovernanceLineResponseDtoForwardingReadinessEnum[keyof typeof ReceptionOrganizationGovernanceLineResponseDtoForwardingReadinessEnum];
export const ReceptionOrganizationGovernanceLineResponseDtoForwardingDetectionEnum = {
    NotObserved: 'NOT_OBSERVED',
    Detected: 'DETECTED',
    NotDetected: 'NOT_DETECTED'
} as const;

export type ReceptionOrganizationGovernanceLineResponseDtoForwardingDetectionEnum = typeof ReceptionOrganizationGovernanceLineResponseDtoForwardingDetectionEnum[keyof typeof ReceptionOrganizationGovernanceLineResponseDtoForwardingDetectionEnum];

/**
 *
 * @export
 * @interface ReceptionOrganizationGovernanceReadinessItemResponseDto
 */
export interface ReceptionOrganizationGovernanceReadinessItemResponseDto {
    /**
     *
     * @type {boolean}
     * @memberof ReceptionOrganizationGovernanceReadinessItemResponseDto
     */
    'ready': boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof ReceptionOrganizationGovernanceReadinessItemResponseDto
     */
    'reasons': Array<string>;
}
/**
 *
 * @export
 * @interface ReceptionOrganizationGovernanceReadinessResponseDto
 */
export interface ReceptionOrganizationGovernanceReadinessResponseDto {
    /**
     *
     * @type {ReceptionOrganizationGovernanceReadinessItemResponseDto}
     * @memberof ReceptionOrganizationGovernanceReadinessResponseDto
     */
    'reception': ReceptionOrganizationGovernanceReadinessItemResponseDto;
    /**
     *
     * @type {ReceptionOrganizationGovernanceReadinessItemResponseDto}
     * @memberof ReceptionOrganizationGovernanceReadinessResponseDto
     */
    'booking': ReceptionOrganizationGovernanceReadinessItemResponseDto;
    /**
     *
     * @type {ReceptionOrganizationGovernanceReadinessItemResponseDto}
     * @memberof ReceptionOrganizationGovernanceReadinessResponseDto
     */
    'voiceSms': ReceptionOrganizationGovernanceReadinessItemResponseDto;
}
/**
 *
 * @export
 * @interface ReceptionOrganizationGovernanceResponseDto
 */
export interface ReceptionOrganizationGovernanceResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceResponseDto
     */
    'evaluatedAt': string;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionOrganizationGovernanceResponseDto
     */
    'desiredEnabled': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionOrganizationGovernanceResponseDto
     */
    'effectiveEnabled': boolean;
    /**
     *
     * @type {number}
     * @memberof ReceptionOrganizationGovernanceResponseDto
     */
    'sessionDurationLimitMs': number;
    /**
     *
     * @type {ReceptionOrganizationGovernanceReadinessResponseDto}
     * @memberof ReceptionOrganizationGovernanceResponseDto
     */
    'readiness': ReceptionOrganizationGovernanceReadinessResponseDto;
    /**
     *
     * @type {Array<ReceptionOrganizationGovernanceBlockerResponseDto>}
     * @memberof ReceptionOrganizationGovernanceResponseDto
     */
    'blockers': Array<ReceptionOrganizationGovernanceBlockerResponseDto>;
    /**
     *
     * @type {ReceptionOrganizationGovernanceActivationResponseDto}
     * @memberof ReceptionOrganizationGovernanceResponseDto
     */
    'activation': ReceptionOrganizationGovernanceActivationResponseDto;
    /**
     *
     * @type {ReceptionOrganizationGovernanceLineResponseDto}
     * @memberof ReceptionOrganizationGovernanceResponseDto
     */
    'line': ReceptionOrganizationGovernanceLineResponseDto;
    /**
     *
     * @type {ReceptionOrganizationGovernanceAllowanceResponseDto}
     * @memberof ReceptionOrganizationGovernanceResponseDto
     */
    'allowance': ReceptionOrganizationGovernanceAllowanceResponseDto;
    /**
     *
     * @type {ReceptionOrganizationGovernanceSpendProtectionResponseDto}
     * @memberof ReceptionOrganizationGovernanceResponseDto
     */
    'spendProtection': ReceptionOrganizationGovernanceSpendProtectionResponseDto;
    /**
     *
     * @type {ReceptionOrganizationGovernanceConcurrencyResponseDto}
     * @memberof ReceptionOrganizationGovernanceResponseDto
     */
    'concurrency': ReceptionOrganizationGovernanceConcurrencyResponseDto;
    /**
     *
     * @type {ReceptionOrganizationGovernanceIncidentsResponseDto}
     * @memberof ReceptionOrganizationGovernanceResponseDto
     */
    'incidents': ReceptionOrganizationGovernanceIncidentsResponseDto;
}
/**
 *
 * @export
 * @interface ReceptionOrganizationGovernanceSpendProtectionResponseDto
 */
export interface ReceptionOrganizationGovernanceSpendProtectionResponseDto {
    /**
     *
     * @type {boolean}
     * @memberof ReceptionOrganizationGovernanceSpendProtectionResponseDto
     */
    'available': boolean;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceSpendProtectionResponseDto
     */
    'warsawDay': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceSpendProtectionResponseDto
     */
    'state': ReceptionOrganizationGovernanceSpendProtectionResponseDtoStateEnum;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionOrganizationGovernanceSpendProtectionResponseDto
     */
    'admissionBlocked': boolean;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceSpendProtectionResponseDto
     */
    'updatedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionOrganizationGovernanceSpendProtectionResponseDto
     */
    'safeReasonCode': string | null;
    /**
     *
     * @type {number}
     * @memberof ReceptionOrganizationGovernanceSpendProtectionResponseDto
     */
    'usedMinorPln': number | null;
    /**
     *
     * @type {number}
     * @memberof ReceptionOrganizationGovernanceSpendProtectionResponseDto
     */
    'reservedMinorPln': number | null;
    /**
     *
     * @type {number}
     * @memberof ReceptionOrganizationGovernanceSpendProtectionResponseDto
     */
    'admissionThresholdMinorPln': number | null;
    /**
     *
     * @type {number}
     * @memberof ReceptionOrganizationGovernanceSpendProtectionResponseDto
     */
    'ceilingMinorPln': number | null;
}

export const ReceptionOrganizationGovernanceSpendProtectionResponseDtoStateEnum = {
    Open: 'OPEN',
    Tripped: 'TRIPPED'
} as const;

export type ReceptionOrganizationGovernanceSpendProtectionResponseDtoStateEnum = typeof ReceptionOrganizationGovernanceSpendProtectionResponseDtoStateEnum[keyof typeof ReceptionOrganizationGovernanceSpendProtectionResponseDtoStateEnum];

/**
 *
 * @export
 * @interface ReceptionPilotApprovalEvidenceResponseDto
 */
export interface ReceptionPilotApprovalEvidenceResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionPilotApprovalEvidenceResponseDto
     */
    'capability': ReceptionPilotApprovalEvidenceResponseDtoCapabilityEnum;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionPilotApprovalEvidenceResponseDto
     */
    'recorded': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionPilotApprovalEvidenceResponseDto
     */
    'current': boolean;
    /**
     *
     * @type {string}
     * @memberof ReceptionPilotApprovalEvidenceResponseDto
     */
    'evidenceId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPilotApprovalEvidenceResponseDto
     */
    'recordedAt': string | null;
}

export const ReceptionPilotApprovalEvidenceResponseDtoCapabilityEnum = {
    Operations: 'VOICE_OPERATIONS',
    PrivacyReviewer: 'VOICE_PRIVACY_REVIEWER',
    SafetyReviewer: 'VOICE_SAFETY_REVIEWER'
} as const;

export type ReceptionPilotApprovalEvidenceResponseDtoCapabilityEnum = typeof ReceptionPilotApprovalEvidenceResponseDtoCapabilityEnum[keyof typeof ReceptionPilotApprovalEvidenceResponseDtoCapabilityEnum];

/**
 *
 * @export
 * @interface ReceptionPilotFinalizationEvidenceResponseDto
 */
export interface ReceptionPilotFinalizationEvidenceResponseDto {
    /**
     *
     * @type {boolean}
     * @memberof ReceptionPilotFinalizationEvidenceResponseDto
     */
    'recorded': boolean;
    /**
     *
     * @type {string}
     * @memberof ReceptionPilotFinalizationEvidenceResponseDto
     */
    'evidenceId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPilotFinalizationEvidenceResponseDto
     */
    'recordedAt': string | null;
}
/**
 *
 * @export
 * @interface ReceptionPilotPhase6EvidenceResponseDto
 */
export interface ReceptionPilotPhase6EvidenceResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionPilotPhase6EvidenceResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionPilotPhase6EvidenceResponseDto
     */
    'releaseId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionPilotPhase6EvidenceResponseDto
     */
    'evaluatedAt': string;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionPilotPhase6EvidenceResponseDto
     */
    'receptionReady': boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof ReceptionPilotPhase6EvidenceResponseDto
     */
    'readinessReasons': Array<ReceptionPilotPhase6EvidenceResponseDtoReadinessReasonsEnum>;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionPilotPhase6EvidenceResponseDto
     */
    'approvalsComplete': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionPilotPhase6EvidenceResponseDto
     */
    'separationOfDutiesSatisfied': boolean;
    /**
     *
     * @type {Array<ReceptionPilotApprovalEvidenceResponseDto>}
     * @memberof ReceptionPilotPhase6EvidenceResponseDto
     */
    'approvals': Array<ReceptionPilotApprovalEvidenceResponseDto>;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionPilotPhase6EvidenceResponseDto
     */
    'activationFinalized': boolean;
    /**
     *
     * @type {ReceptionPilotFinalizationEvidenceResponseDto}
     * @memberof ReceptionPilotPhase6EvidenceResponseDto
     */
    'finalization': ReceptionPilotFinalizationEvidenceResponseDto;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionPilotPhase6EvidenceResponseDto
     */
    'effectiveEnabled': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionPilotPhase6EvidenceResponseDto
     */
    'phase6ExitSatisfied': boolean;
    /**
     * Faza 6 nie autoryzuje rozszerzenia pilota
     * @type {boolean}
     * @memberof ReceptionPilotPhase6EvidenceResponseDto
     */
    'pilotExpansionAuthorized': boolean;
}

export const ReceptionPilotPhase6EvidenceResponseDtoReadinessReasonsEnum = {
    PlatformPilotAccessMissing: 'PLATFORM_PILOT_ACCESS_MISSING',
    PlatformSuspended: 'PLATFORM_SUSPENDED',
    GlobalIncidentAdmissionBlocked: 'GLOBAL_INCIDENT_ADMISSION_BLOCKED',
    OrganizationIncidentAdmissionBlocked: 'ORGANIZATION_INCIDENT_ADMISSION_BLOCKED',
    OrganizationInactive: 'ORGANIZATION_INACTIVE',
    OrganizationDesiredDisabled: 'ORGANIZATION_DESIRED_DISABLED',
    ReceptionPolicyMissingOrInvalid: 'RECEPTION_POLICY_MISSING_OR_INVALID',
    VoiceLineMissing: 'VOICE_LINE_MISSING',
    VoiceLineProviderStateUnreconciled: 'VOICE_LINE_PROVIDER_STATE_UNRECONCILED',
    VoiceLineRegionNotIe1: 'VOICE_LINE_REGION_NOT_IE1',
    VoiceLineRegionalEndpointsUnreconciled: 'VOICE_LINE_REGIONAL_ENDPOINTS_UNRECONCILED',
    FallbackBundleUnreconciled: 'FALLBACK_BUNDLE_UNRECONCILED',
    QualifiedVoiceModelMissing: 'QUALIFIED_VOICE_MODEL_MISSING',
    QualifiedVoiceMissing: 'QUALIFIED_VOICE_MISSING',
    VertexZeroRetentionUnverified: 'VERTEX_ZERO_RETENTION_UNVERIFIED',
    DisclosureAssetInvalid: 'DISCLOSURE_ASSET_INVALID',
    GreetingAssetInvalid: 'GREETING_ASSET_INVALID',
    FallbackAssetsInvalid: 'FALLBACK_ASSETS_INVALID',
    RoutingDestinationsInvalid: 'ROUTING_DESTINATIONS_INVALID',
    ReceptionHoursInvalid: 'RECEPTION_HOURS_INVALID',
    EmergencyGuidanceMissingOrInvalid: 'EMERGENCY_GUIDANCE_MISSING_OR_INVALID',
    EmergencyGuidanceExpired: 'EMERGENCY_GUIDANCE_EXPIRED',
    EmergencyDestinationInvalidated: 'EMERGENCY_DESTINATION_INVALIDATED',
    EmergencyProfessionalApprovalInvalid: 'EMERGENCY_PROFESSIONAL_APPROVAL_INVALID',
    CallbackHandlerMissing: 'CALLBACK_HANDLER_MISSING',
    CallbackHandlerRevisionStale: 'CALLBACK_HANDLER_REVISION_STALE',
    Phase0ProviderQualificationMissing: 'PHASE_0_PROVIDER_QUALIFICATION_MISSING',
    Phase1SafetyFoundationsMissing: 'PHASE_1_SAFETY_FOUNDATIONS_MISSING',
    QualifiedCostEvidenceMissing: 'QUALIFIED_COST_EVIDENCE_MISSING'
} as const;

export type ReceptionPilotPhase6EvidenceResponseDtoReadinessReasonsEnum = typeof ReceptionPilotPhase6EvidenceResponseDtoReadinessReasonsEnum[keyof typeof ReceptionPilotPhase6EvidenceResponseDtoReadinessReasonsEnum];

/**
 *
 * @export
 * @interface ReceptionPolicyContentDto
 */
export interface ReceptionPolicyContentDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyContentDto
     */
    'spokenFacilityName': string;
    /**
     *
     * @type {FacilityGreetingSelectionDto}
     * @memberof ReceptionPolicyContentDto
     */
    'greeting': FacilityGreetingSelectionDto;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyContentDto
     */
    'tone': ReceptionPolicyContentDtoToneEnum;
    /**
     *
     * @type {QualifiedVoiceReferenceDto}
     * @memberof ReceptionPolicyContentDto
     */
    'qualifiedVoice': QualifiedVoiceReferenceDto;
    /**
     *
     * @type {Array<ReceptionFactSnapshotDto>}
     * @memberof ReceptionPolicyContentDto
     */
    'receptionFacts': Array<ReceptionFactSnapshotDto>;
    /**
     *
     * @type {Array<VoiceBookingPolicySnapshotDto>}
     * @memberof ReceptionPolicyContentDto
     */
    'bookingPolicies': Array<VoiceBookingPolicySnapshotDto>;
    /**
     *
     * @type {Array<ReceptionHoursWindowDto>}
     * @memberof ReceptionPolicyContentDto
     */
    'receptionHours': Array<ReceptionHoursWindowDto>;
    /**
     *
     * @type {Array<ReceptionClosureSnapshotDto>}
     * @memberof ReceptionPolicyContentDto
     */
    'receptionClosures': Array<ReceptionClosureSnapshotDto>;
    /**
     *
     * @type {Array<CallbackHandlerAssignmentSnapshotDto>}
     * @memberof ReceptionPolicyContentDto
     */
    'callbackHandlers': Array<CallbackHandlerAssignmentSnapshotDto>;
    /**
     *
     * @type {EmergencyGuidanceReferenceDto}
     * @memberof ReceptionPolicyContentDto
     */
    'emergencyGuidance': EmergencyGuidanceReferenceDto;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyContentDto
     */
    'ordinaryTransferDestinationId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyContentDto
     */
    'upstreamForwardingE164': string;
}

export const ReceptionPolicyContentDtoToneEnum = {
    WarmProfessional: 'WARM_PROFESSIONAL',
    CalmDirect: 'CALM_DIRECT',
    ConciseNeutral: 'CONCISE_NEUTRAL'
} as const;

export type ReceptionPolicyContentDtoToneEnum = typeof ReceptionPolicyContentDtoToneEnum[keyof typeof ReceptionPolicyContentDtoToneEnum];

/**
 *
 * @export
 * @interface ReceptionPolicyCurrentResponseDto
 */
export interface ReceptionPolicyCurrentResponseDto {
    /**
     *
     * @type {ReceptionPolicyRevisionResponseDto}
     * @memberof ReceptionPolicyCurrentResponseDto
     */
    'current': ReceptionPolicyRevisionResponseDto | null;
}
/**
 *
 * @export
 * @interface ReceptionPolicyDraftResponseDto
 */
export interface ReceptionPolicyDraftResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyDraftResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyDraftResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {number}
     * @memberof ReceptionPolicyDraftResponseDto
     */
    'expectedPublishedRevision': number;
    /**
     *
     * @type {ReceptionPolicyContentDto}
     * @memberof ReceptionPolicyDraftResponseDto
     */
    'content': ReceptionPolicyContentDto;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyDraftResponseDto
     */
    'actorReferenceKind': ReceptionPolicyDraftResponseDtoActorReferenceKindEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyDraftResponseDto
     */
    'actorUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyDraftResponseDto
     */
    'actorPseudonym': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyDraftResponseDto
     */
    'actorErasedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyDraftResponseDto
     */
    'reason': ReceptionPolicyDraftResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyDraftResponseDto
     */
    'note': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyDraftResponseDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyDraftResponseDto
     */
    'retainUntil': string;
}

export const ReceptionPolicyDraftResponseDtoActorReferenceKindEnum = {
    UserId: 'USER_ID',
    ErasedPseudonym: 'ERASED_PSEUDONYM'
} as const;

export type ReceptionPolicyDraftResponseDtoActorReferenceKindEnum = typeof ReceptionPolicyDraftResponseDtoActorReferenceKindEnum[keyof typeof ReceptionPolicyDraftResponseDtoActorReferenceKindEnum];
export const ReceptionPolicyDraftResponseDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    PolicyUpdate: 'POLICY_UPDATE',
    FactsUpdate: 'FACTS_UPDATE',
    BookingPolicyUpdate: 'BOOKING_POLICY_UPDATE',
    ReceptionScheduleUpdate: 'RECEPTION_SCHEDULE_UPDATE',
    CallbackHandlerUpdate: 'CALLBACK_HANDLER_UPDATE',
    SafetyReferenceUpdate: 'SAFETY_REFERENCE_UPDATE',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type ReceptionPolicyDraftResponseDtoReasonEnum = typeof ReceptionPolicyDraftResponseDtoReasonEnum[keyof typeof ReceptionPolicyDraftResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface ReceptionPolicyHistoryResponseDto
 */
export interface ReceptionPolicyHistoryResponseDto {
    /**
     *
     * @type {ReceptionPolicyRevisionResponseDto}
     * @memberof ReceptionPolicyHistoryResponseDto
     */
    'current': ReceptionPolicyRevisionResponseDto | null;
    /**
     *
     * @type {Array<ReceptionPolicyRevisionResponseDto>}
     * @memberof ReceptionPolicyHistoryResponseDto
     */
    'published': Array<ReceptionPolicyRevisionResponseDto>;
    /**
     *
     * @type {Array<ReceptionPolicyDraftResponseDto>}
     * @memberof ReceptionPolicyHistoryResponseDto
     */
    'drafts': Array<ReceptionPolicyDraftResponseDto>;
}
/**
 *
 * @export
 * @interface ReceptionPolicyPendingDraftItemResponseDto
 */
export interface ReceptionPolicyPendingDraftItemResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyPendingDraftItemResponseDto
     */
    'draftId': string;
    /**
     *
     * @type {number}
     * @memberof ReceptionPolicyPendingDraftItemResponseDto
     */
    'expectedPublishedRevision': number;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyPendingDraftItemResponseDto
     */
    'state': ReceptionPolicyPendingDraftItemResponseDtoStateEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyPendingDraftItemResponseDto
     */
    'actorReferenceKind': ReceptionPolicyPendingDraftItemResponseDtoActorReferenceKindEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyPendingDraftItemResponseDto
     */
    'actorUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyPendingDraftItemResponseDto
     */
    'actorPseudonym': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyPendingDraftItemResponseDto
     */
    'actorErasedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyPendingDraftItemResponseDto
     */
    'reason': ReceptionPolicyPendingDraftItemResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyPendingDraftItemResponseDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyPendingDraftItemResponseDto
     */
    'safeReasonCode': ReceptionPolicyPendingDraftItemResponseDtoSafeReasonCodeEnum;
}

export const ReceptionPolicyPendingDraftItemResponseDtoStateEnum = {
    Pending: 'PENDING',
    Stale: 'STALE'
} as const;

export type ReceptionPolicyPendingDraftItemResponseDtoStateEnum = typeof ReceptionPolicyPendingDraftItemResponseDtoStateEnum[keyof typeof ReceptionPolicyPendingDraftItemResponseDtoStateEnum];
export const ReceptionPolicyPendingDraftItemResponseDtoActorReferenceKindEnum = {
    UserId: 'USER_ID',
    ErasedPseudonym: 'ERASED_PSEUDONYM'
} as const;

export type ReceptionPolicyPendingDraftItemResponseDtoActorReferenceKindEnum = typeof ReceptionPolicyPendingDraftItemResponseDtoActorReferenceKindEnum[keyof typeof ReceptionPolicyPendingDraftItemResponseDtoActorReferenceKindEnum];
export const ReceptionPolicyPendingDraftItemResponseDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    PolicyUpdate: 'POLICY_UPDATE',
    FactsUpdate: 'FACTS_UPDATE',
    BookingPolicyUpdate: 'BOOKING_POLICY_UPDATE',
    ReceptionScheduleUpdate: 'RECEPTION_SCHEDULE_UPDATE',
    CallbackHandlerUpdate: 'CALLBACK_HANDLER_UPDATE',
    SafetyReferenceUpdate: 'SAFETY_REFERENCE_UPDATE',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type ReceptionPolicyPendingDraftItemResponseDtoReasonEnum = typeof ReceptionPolicyPendingDraftItemResponseDtoReasonEnum[keyof typeof ReceptionPolicyPendingDraftItemResponseDtoReasonEnum];
export const ReceptionPolicyPendingDraftItemResponseDtoSafeReasonCodeEnum = {
    ReceptionPolicyHeadChanged: 'RECEPTION_POLICY_HEAD_CHANGED'
} as const;

export type ReceptionPolicyPendingDraftItemResponseDtoSafeReasonCodeEnum = typeof ReceptionPolicyPendingDraftItemResponseDtoSafeReasonCodeEnum[keyof typeof ReceptionPolicyPendingDraftItemResponseDtoSafeReasonCodeEnum];

/**
 *
 * @export
 * @interface ReceptionPolicyPendingDraftsResponseDto
 */
export interface ReceptionPolicyPendingDraftsResponseDto {
    /**
     *
     * @type {number}
     * @memberof ReceptionPolicyPendingDraftsResponseDto
     */
    'currentPublishedRevision': number;
    /**
     *
     * @type {Array<ReceptionPolicyPendingDraftItemResponseDto>}
     * @memberof ReceptionPolicyPendingDraftsResponseDto
     */
    'items': Array<ReceptionPolicyPendingDraftItemResponseDto>;
}
/**
 *
 * @export
 * @interface ReceptionPolicyRevisionResponseDto
 */
export interface ReceptionPolicyRevisionResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {number}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'revision': number;
    /**
     *
     * @type {ReceptionPolicyContentDto}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'content': ReceptionPolicyContentDto;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'contentSha256': string;
    /**
     *
     * @type {Array<object>}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'renderedAssets': Array<object>;
    /**
     *
     * @type {number}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'callbackHandlerAssignmentFence': number;
    /**
     *
     * @type {number}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'acceptedConfigurationFence': number;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'acceptedConfigurationManifestId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'acceptedConfigurationManifestSha256': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'sourceDraftId': string | null;
    /**
     *
     * @type {number}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'rollbackOfRevision': number | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'actorReferenceKind': ReceptionPolicyRevisionResponseDtoActorReferenceKindEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'actorUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'actorPseudonym': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'actorErasedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'reason': ReceptionPolicyRevisionResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'note': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'publishedAt': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'supersededAt': string | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionPolicyRevisionResponseDto
     */
    'retainUntil': string | null;
}

export const ReceptionPolicyRevisionResponseDtoActorReferenceKindEnum = {
    UserId: 'USER_ID',
    ErasedPseudonym: 'ERASED_PSEUDONYM'
} as const;

export type ReceptionPolicyRevisionResponseDtoActorReferenceKindEnum = typeof ReceptionPolicyRevisionResponseDtoActorReferenceKindEnum[keyof typeof ReceptionPolicyRevisionResponseDtoActorReferenceKindEnum];
export const ReceptionPolicyRevisionResponseDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    PolicyUpdate: 'POLICY_UPDATE',
    FactsUpdate: 'FACTS_UPDATE',
    BookingPolicyUpdate: 'BOOKING_POLICY_UPDATE',
    ReceptionScheduleUpdate: 'RECEPTION_SCHEDULE_UPDATE',
    CallbackHandlerUpdate: 'CALLBACK_HANDLER_UPDATE',
    SafetyReferenceUpdate: 'SAFETY_REFERENCE_UPDATE',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type ReceptionPolicyRevisionResponseDtoReasonEnum = typeof ReceptionPolicyRevisionResponseDtoReasonEnum[keyof typeof ReceptionPolicyRevisionResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface ReceptionQualifiedVoiceCurrentResponseDto
 */
export interface ReceptionQualifiedVoiceCurrentResponseDto {
    /**
     *
     * @type {ReceptionQualifiedVoiceResponseDto}
     * @memberof ReceptionQualifiedVoiceCurrentResponseDto
     */
    'current': ReceptionQualifiedVoiceResponseDto | null;
}
/**
 *
 * @export
 * @interface ReceptionQualifiedVoiceResponseDto
 */
export interface ReceptionQualifiedVoiceResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionQualifiedVoiceResponseDto
     */
    'releaseId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionQualifiedVoiceResponseDto
     */
    'voiceId': string;
    /**
     *
     * @type {number}
     * @memberof ReceptionQualifiedVoiceResponseDto
     */
    'voiceRevision': number;
    /**
     *
     * @type {string}
     * @memberof ReceptionQualifiedVoiceResponseDto
     */
    'auditionAssetPublicUrl': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionQualifiedVoiceResponseDto
     */
    'auditionAssetSha256': string;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionQualifiedVoiceResponseDto
     */
    'effective': boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof ReceptionQualifiedVoiceResponseDto
     */
    'safeFailureReasons': Array<string>;
}
/**
 *
 * @export
 * @interface ReceptionReadinessResponseDto
 */
export interface ReceptionReadinessResponseDto {
    /**
     *
     * @type {object}
     * @memberof ReceptionReadinessResponseDto
     */
    'developOperatorTrial'?: object;
    /**
     *
     * @type {string}
     * @memberof ReceptionReadinessResponseDto
     */
    'bookingConfirmationChannel'?: ReceptionReadinessResponseDtoBookingConfirmationChannelEnum;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionReadinessResponseDto
     */
    'emailConfirmationReady'?: boolean;
    /**
     *
     * @type {string}
     * @memberof ReceptionReadinessResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionReadinessResponseDto
     */
    'evaluatedAt': string;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionReadinessResponseDto
     */
    'desiredEnabled': boolean;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionReadinessResponseDto
     */
    'effectiveEnabled': boolean;
    /**
     *
     * @type {ReceptionReadinessResponseDtoReception}
     * @memberof ReceptionReadinessResponseDto
     */
    'reception': ReceptionReadinessResponseDtoReception;
    /**
     *
     * @type {ReceptionReadinessResponseDtoBooking}
     * @memberof ReceptionReadinessResponseDto
     */
    'booking': ReceptionReadinessResponseDtoBooking;
    /**
     *
     * @type {ReceptionReadinessResponseDtoVoiceSms}
     * @memberof ReceptionReadinessResponseDto
     */
    'voiceSms': ReceptionReadinessResponseDtoVoiceSms;
    /**
     *
     * @type {ReceptionReadinessResponseDtoActivation}
     * @memberof ReceptionReadinessResponseDto
     */
    'activation': ReceptionReadinessResponseDtoActivation;
    /**
     *
     * @type {object}
     * @memberof ReceptionReadinessResponseDto
     */
    'actions': object;
}

export const ReceptionReadinessResponseDtoBookingConfirmationChannelEnum = {
    Email: 'EMAIL'
} as const;

export type ReceptionReadinessResponseDtoBookingConfirmationChannelEnum = typeof ReceptionReadinessResponseDtoBookingConfirmationChannelEnum[keyof typeof ReceptionReadinessResponseDtoBookingConfirmationChannelEnum];

/**
 *
 * @export
 * @interface ReceptionReadinessResponseDtoActivation
 */
export interface ReceptionReadinessResponseDtoActivation {
    /**
     *
     * @type {string}
     * @memberof ReceptionReadinessResponseDtoActivation
     */
    'releaseId'?: string;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionReadinessResponseDtoActivation
     */
    'approved'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionReadinessResponseDtoActivation
     */
    'finalized'?: boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof ReceptionReadinessResponseDtoActivation
     */
    'approvedCapabilities'?: Array<ReceptionReadinessResponseDtoActivationApprovedCapabilitiesEnum>;
    /**
     *
     * @type {Array<string>}
     * @memberof ReceptionReadinessResponseDtoActivation
     */
    'missingCapabilities'?: Array<ReceptionReadinessResponseDtoActivationMissingCapabilitiesEnum>;
    /**
     *
     * @type {boolean}
     * @memberof ReceptionReadinessResponseDtoActivation
     */
    'separationOfDutiesSatisfied'?: boolean;
}

export const ReceptionReadinessResponseDtoActivationApprovedCapabilitiesEnum = {
    Operations: 'VOICE_OPERATIONS',
    PrivacyReviewer: 'VOICE_PRIVACY_REVIEWER',
    SafetyReviewer: 'VOICE_SAFETY_REVIEWER'
} as const;

export type ReceptionReadinessResponseDtoActivationApprovedCapabilitiesEnum = typeof ReceptionReadinessResponseDtoActivationApprovedCapabilitiesEnum[keyof typeof ReceptionReadinessResponseDtoActivationApprovedCapabilitiesEnum];
export const ReceptionReadinessResponseDtoActivationMissingCapabilitiesEnum = {
    Operations: 'VOICE_OPERATIONS',
    PrivacyReviewer: 'VOICE_PRIVACY_REVIEWER',
    SafetyReviewer: 'VOICE_SAFETY_REVIEWER'
} as const;

export type ReceptionReadinessResponseDtoActivationMissingCapabilitiesEnum = typeof ReceptionReadinessResponseDtoActivationMissingCapabilitiesEnum[keyof typeof ReceptionReadinessResponseDtoActivationMissingCapabilitiesEnum];

/**
 *
 * @export
 * @interface ReceptionReadinessResponseDtoBooking
 */
export interface ReceptionReadinessResponseDtoBooking {
    /**
     *
     * @type {boolean}
     * @memberof ReceptionReadinessResponseDtoBooking
     */
    'ready'?: boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof ReceptionReadinessResponseDtoBooking
     */
    'reasons'?: Array<ReceptionReadinessResponseDtoBookingReasonsEnum>;
}

export const ReceptionReadinessResponseDtoBookingReasonsEnum = {
    EmailConfirmationUnavailable: 'EMAIL_CONFIRMATION_UNAVAILABLE',
    ConfirmationChannelInvalid: 'CONFIRMATION_CHANNEL_INVALID',
    VoiceSmsNotReady: 'VOICE_SMS_NOT_READY',
    BookingIncidentDisabled: 'BOOKING_INCIDENT_DISABLED',
    FacilityAddressInvalid: 'FACILITY_ADDRESS_INVALID',
    FacilityHoursInvalid: 'FACILITY_HOURS_INVALID',
    ServicePoliciesInvalid: 'SERVICE_POLICIES_INVALID',
    BookingAllowlistInvalid: 'BOOKING_ALLOWLIST_INVALID',
    ProfessionalAssignmentsInvalid: 'PROFESSIONAL_ASSIGNMENTS_INVALID',
    SlotConfigurationInvalid: 'SLOT_CONFIGURATION_INVALID',
    Phase1BookingSafetyMissing: 'PHASE_1_BOOKING_SAFETY_MISSING'
} as const;

export type ReceptionReadinessResponseDtoBookingReasonsEnum = typeof ReceptionReadinessResponseDtoBookingReasonsEnum[keyof typeof ReceptionReadinessResponseDtoBookingReasonsEnum];

/**
 *
 * @export
 * @interface ReceptionReadinessResponseDtoReception
 */
export interface ReceptionReadinessResponseDtoReception {
    /**
     *
     * @type {boolean}
     * @memberof ReceptionReadinessResponseDtoReception
     */
    'ready'?: boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof ReceptionReadinessResponseDtoReception
     */
    'reasons'?: Array<ReceptionReadinessResponseDtoReceptionReasonsEnum>;
}

export const ReceptionReadinessResponseDtoReceptionReasonsEnum = {
    PlatformPilotAccessMissing: 'PLATFORM_PILOT_ACCESS_MISSING',
    PlatformSuspended: 'PLATFORM_SUSPENDED',
    GlobalIncidentAdmissionBlocked: 'GLOBAL_INCIDENT_ADMISSION_BLOCKED',
    OrganizationIncidentAdmissionBlocked: 'ORGANIZATION_INCIDENT_ADMISSION_BLOCKED',
    OrganizationInactive: 'ORGANIZATION_INACTIVE',
    OrganizationDesiredDisabled: 'ORGANIZATION_DESIRED_DISABLED',
    ReceptionPolicyMissingOrInvalid: 'RECEPTION_POLICY_MISSING_OR_INVALID',
    VoiceLineMissing: 'VOICE_LINE_MISSING',
    VoiceLineProviderStateUnreconciled: 'VOICE_LINE_PROVIDER_STATE_UNRECONCILED',
    VoiceLineRegionNotIe1: 'VOICE_LINE_REGION_NOT_IE1',
    VoiceLineRegionalEndpointsUnreconciled: 'VOICE_LINE_REGIONAL_ENDPOINTS_UNRECONCILED',
    FallbackBundleUnreconciled: 'FALLBACK_BUNDLE_UNRECONCILED',
    QualifiedVoiceModelMissing: 'QUALIFIED_VOICE_MODEL_MISSING',
    QualifiedVoiceMissing: 'QUALIFIED_VOICE_MISSING',
    VertexZeroRetentionUnverified: 'VERTEX_ZERO_RETENTION_UNVERIFIED',
    DisclosureAssetInvalid: 'DISCLOSURE_ASSET_INVALID',
    GreetingAssetInvalid: 'GREETING_ASSET_INVALID',
    FallbackAssetsInvalid: 'FALLBACK_ASSETS_INVALID',
    RoutingDestinationsInvalid: 'ROUTING_DESTINATIONS_INVALID',
    ReceptionHoursInvalid: 'RECEPTION_HOURS_INVALID',
    EmergencyGuidanceMissingOrInvalid: 'EMERGENCY_GUIDANCE_MISSING_OR_INVALID',
    EmergencyGuidanceExpired: 'EMERGENCY_GUIDANCE_EXPIRED',
    EmergencyDestinationInvalidated: 'EMERGENCY_DESTINATION_INVALIDATED',
    EmergencyProfessionalApprovalInvalid: 'EMERGENCY_PROFESSIONAL_APPROVAL_INVALID',
    CallbackHandlerMissing: 'CALLBACK_HANDLER_MISSING',
    CallbackHandlerRevisionStale: 'CALLBACK_HANDLER_REVISION_STALE',
    Phase0ProviderQualificationMissing: 'PHASE_0_PROVIDER_QUALIFICATION_MISSING',
    Phase1SafetyFoundationsMissing: 'PHASE_1_SAFETY_FOUNDATIONS_MISSING',
    QualifiedCostEvidenceMissing: 'QUALIFIED_COST_EVIDENCE_MISSING'
} as const;

export type ReceptionReadinessResponseDtoReceptionReasonsEnum = typeof ReceptionReadinessResponseDtoReceptionReasonsEnum[keyof typeof ReceptionReadinessResponseDtoReceptionReasonsEnum];

/**
 *
 * @export
 * @interface ReceptionReadinessResponseDtoVoiceSms
 */
export interface ReceptionReadinessResponseDtoVoiceSms {
    /**
     *
     * @type {boolean}
     * @memberof ReceptionReadinessResponseDtoVoiceSms
     */
    'ready'?: boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof ReceptionReadinessResponseDtoVoiceSms
     */
    'reasons'?: Array<ReceptionReadinessResponseDtoVoiceSmsReasonsEnum>;
}

export const ReceptionReadinessResponseDtoVoiceSmsReasonsEnum = {
    VoiceSmsDisabledForEmailConfirmation: 'VOICE_SMS_DISABLED_FOR_EMAIL_CONFIRMATION',
    DedicatedIe1VoiceSenderUnreconciled: 'DEDICATED_IE1_VOICE_SENDER_UNRECONCILED',
    VoiceSmsRegionalPathsUnreconciled: 'VOICE_SMS_REGIONAL_PATHS_UNRECONCILED',
    VoiceSmsPrivacyControlsUnverified: 'VOICE_SMS_PRIVACY_CONTROLS_UNVERIFIED',
    VoiceSmsContractualEvidenceMissing: 'VOICE_SMS_CONTRACTUAL_EVIDENCE_MISSING',
    ContactCapabilityUnqualified: 'CONTACT_CAPABILITY_UNQUALIFIED',
    VoiceSmsCredentialsMissing: 'VOICE_SMS_CREDENTIALS_MISSING',
    VoiceSmsStatusCallbackUnverified: 'VOICE_SMS_STATUS_CALLBACK_UNVERIFIED',
    VoiceSmsProviderErasureUnverified: 'VOICE_SMS_PROVIDER_ERASURE_UNVERIFIED',
    VoiceSmsProviderReconciliationStale: 'VOICE_SMS_PROVIDER_RECONCILIATION_STALE',
    Phase0VoiceSmsQualificationMissing: 'PHASE_0_VOICE_SMS_QUALIFICATION_MISSING'
} as const;

export type ReceptionReadinessResponseDtoVoiceSmsReasonsEnum = typeof ReceptionReadinessResponseDtoVoiceSmsReasonsEnum[keyof typeof ReceptionReadinessResponseDtoVoiceSmsReasonsEnum];

/**
 *
 * @export
 * @interface ReceptionSessionAccessHistoryItemDto
 */
export interface ReceptionSessionAccessHistoryItemDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionAccessHistoryItemDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionAccessHistoryItemDto
     */
    'surface': ReceptionSessionAccessHistoryItemDtoSurfaceEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionAccessHistoryItemDto
     */
    'actorReference': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionAccessHistoryItemDto
     */
    'actorReferenceKind': ReceptionSessionAccessHistoryItemDtoActorReferenceKindEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionAccessHistoryItemDto
     */
    'targetReference': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionAccessHistoryItemDto
     */
    'targetReferenceKind': ReceptionSessionAccessHistoryItemDtoTargetReferenceKindEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionAccessHistoryItemDto
     */
    'action': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionAccessHistoryItemDto
     */
    'occurredAt': string;
}

export const ReceptionSessionAccessHistoryItemDtoSurfaceEnum = {
    ReceptionTranscript: 'RECEPTION_TRANSCRIPT',
    CallbackRequestPii: 'CALLBACK_REQUEST_PII'
} as const;

export type ReceptionSessionAccessHistoryItemDtoSurfaceEnum = typeof ReceptionSessionAccessHistoryItemDtoSurfaceEnum[keyof typeof ReceptionSessionAccessHistoryItemDtoSurfaceEnum];
export const ReceptionSessionAccessHistoryItemDtoActorReferenceKindEnum = {
    UserId: 'USER_ID',
    IrreversiblePseudonym: 'IRREVERSIBLE_PSEUDONYM',
    System: 'SYSTEM',
    Unavailable: 'UNAVAILABLE'
} as const;

export type ReceptionSessionAccessHistoryItemDtoActorReferenceKindEnum = typeof ReceptionSessionAccessHistoryItemDtoActorReferenceKindEnum[keyof typeof ReceptionSessionAccessHistoryItemDtoActorReferenceKindEnum];
export const ReceptionSessionAccessHistoryItemDtoTargetReferenceKindEnum = {
    SessionId: 'SESSION_ID',
    IrreversiblePseudonym: 'IRREVERSIBLE_PSEUDONYM',
    NotApplicable: 'NOT_APPLICABLE',
    Unavailable: 'UNAVAILABLE'
} as const;

export type ReceptionSessionAccessHistoryItemDtoTargetReferenceKindEnum = typeof ReceptionSessionAccessHistoryItemDtoTargetReferenceKindEnum[keyof typeof ReceptionSessionAccessHistoryItemDtoTargetReferenceKindEnum];

/**
 *
 * @export
 * @interface ReceptionSessionAccessHistoryResponseDto
 */
export interface ReceptionSessionAccessHistoryResponseDto {
    /**
     *
     * @type {Array<ReceptionSessionAccessHistoryItemDto>}
     * @memberof ReceptionSessionAccessHistoryResponseDto
     */
    'items': Array<ReceptionSessionAccessHistoryItemDto>;
    /**
     *
     * @type {number}
     * @memberof ReceptionSessionAccessHistoryResponseDto
     */
    'total': number;
    /**
     *
     * @type {number}
     * @memberof ReceptionSessionAccessHistoryResponseDto
     */
    'page': number;
    /**
     *
     * @type {number}
     * @memberof ReceptionSessionAccessHistoryResponseDto
     */
    'limit': number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ReceptionSessionEndReason = {
    CallerHangup: 'CALLER_HANGUP',
    TimeLimit: 'TIME_LIMIT',
    TransferStarted: 'TRANSFER_STARTED',
    TranscriptionRefused: 'TRANSCRIPTION_REFUSED',
    SilenceTimeout: 'SILENCE_TIMEOUT',
    ProviderFailure: 'PROVIDER_FAILURE',
    BridgeShutdown: 'BRIDGE_SHUTDOWN',
    Abuse: 'ABUSE',
    IncidentTermination: 'INCIDENT_TERMINATION',
    InternalFailure: 'INTERNAL_FAILURE'
} as const;

export type ReceptionSessionEndReason = typeof ReceptionSessionEndReason[keyof typeof ReceptionSessionEndReason];


/**
 *
 * @export
 * @interface ReceptionSessionListResponseDto
 */
export interface ReceptionSessionListResponseDto {
    /**
     *
     * @type {Array<ReceptionSessionMetadataResponseDto>}
     * @memberof ReceptionSessionListResponseDto
     */
    'items': Array<ReceptionSessionMetadataResponseDto>;
    /**
     *
     * @type {number}
     * @memberof ReceptionSessionListResponseDto
     */
    'total': number;
    /**
     *
     * @type {number}
     * @memberof ReceptionSessionListResponseDto
     */
    'page': number;
    /**
     *
     * @type {number}
     * @memberof ReceptionSessionListResponseDto
     */
    'limit': number;
}
/**
 *
 * @export
 * @interface ReceptionSessionMetadataResponseDto
 */
export interface ReceptionSessionMetadataResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionMetadataResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionMetadataResponseDto
     */
    'status': ReceptionSessionMetadataResponseDtoStatusEnum;
    /**
     *
     * @type {ReceptionSessionEndReason}
     * @memberof ReceptionSessionMetadataResponseDto
     */
    'endReason': ReceptionSessionEndReason | null;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionMetadataResponseDto
     */
    'acceptedAt': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionMetadataResponseDto
     */
    'endsAt': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionMetadataResponseDto
     */
    'endedAt': string | null;
    /**
     *
     * @type {number}
     * @memberof ReceptionSessionMetadataResponseDto
     */
    'durationMs': number;
}

export const ReceptionSessionMetadataResponseDtoStatusEnum = {
    Active: 'ACTIVE',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
} as const;

export type ReceptionSessionMetadataResponseDtoStatusEnum = typeof ReceptionSessionMetadataResponseDtoStatusEnum[keyof typeof ReceptionSessionMetadataResponseDtoStatusEnum];

/**
 *
 * @export
 * @interface ReceptionSessionReviewDto
 */
export interface ReceptionSessionReviewDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionReviewDto
     */
    'disclosure': ReceptionSessionReviewDtoDisclosureEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionReviewDto
     */
    'grounding': ReceptionSessionReviewDtoGroundingEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionReviewDto
     */
    'safety': ReceptionSessionReviewDtoSafetyEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionReviewDto
     */
    'taskOutcome': ReceptionSessionReviewDtoTaskOutcomeEnum;
}

export const ReceptionSessionReviewDtoDisclosureEnum = {
    Pass: 'PASS',
    Fail: 'FAIL',
    NotAssessed: 'NOT_ASSESSED'
} as const;

export type ReceptionSessionReviewDtoDisclosureEnum = typeof ReceptionSessionReviewDtoDisclosureEnum[keyof typeof ReceptionSessionReviewDtoDisclosureEnum];
export const ReceptionSessionReviewDtoGroundingEnum = {
    Pass: 'PASS',
    Fail: 'FAIL',
    NotAssessed: 'NOT_ASSESSED'
} as const;

export type ReceptionSessionReviewDtoGroundingEnum = typeof ReceptionSessionReviewDtoGroundingEnum[keyof typeof ReceptionSessionReviewDtoGroundingEnum];
export const ReceptionSessionReviewDtoSafetyEnum = {
    Pass: 'PASS',
    Fail: 'FAIL',
    NotAssessed: 'NOT_ASSESSED'
} as const;

export type ReceptionSessionReviewDtoSafetyEnum = typeof ReceptionSessionReviewDtoSafetyEnum[keyof typeof ReceptionSessionReviewDtoSafetyEnum];
export const ReceptionSessionReviewDtoTaskOutcomeEnum = {
    Resolved: 'RESOLVED',
    Handoff: 'HANDOFF',
    Unresolved: 'UNRESOLVED',
    NotAssessed: 'NOT_ASSESSED'
} as const;

export type ReceptionSessionReviewDtoTaskOutcomeEnum = typeof ReceptionSessionReviewDtoTaskOutcomeEnum[keyof typeof ReceptionSessionReviewDtoTaskOutcomeEnum];

/**
 *
 * @export
 * @interface ReceptionSessionReviewResponseDto
 */
export interface ReceptionSessionReviewResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionReviewResponseDto
     */
    'disclosure': ReceptionSessionReviewResponseDtoDisclosureEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionReviewResponseDto
     */
    'grounding': ReceptionSessionReviewResponseDtoGroundingEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionReviewResponseDto
     */
    'safety': ReceptionSessionReviewResponseDtoSafetyEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionReviewResponseDto
     */
    'taskOutcome': ReceptionSessionReviewResponseDtoTaskOutcomeEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionReviewResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionReviewResponseDto
     */
    'sessionId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionReviewResponseDto
     */
    'reviewedAt': string;
}

export const ReceptionSessionReviewResponseDtoDisclosureEnum = {
    Pass: 'PASS',
    Fail: 'FAIL',
    NotAssessed: 'NOT_ASSESSED'
} as const;

export type ReceptionSessionReviewResponseDtoDisclosureEnum = typeof ReceptionSessionReviewResponseDtoDisclosureEnum[keyof typeof ReceptionSessionReviewResponseDtoDisclosureEnum];
export const ReceptionSessionReviewResponseDtoGroundingEnum = {
    Pass: 'PASS',
    Fail: 'FAIL',
    NotAssessed: 'NOT_ASSESSED'
} as const;

export type ReceptionSessionReviewResponseDtoGroundingEnum = typeof ReceptionSessionReviewResponseDtoGroundingEnum[keyof typeof ReceptionSessionReviewResponseDtoGroundingEnum];
export const ReceptionSessionReviewResponseDtoSafetyEnum = {
    Pass: 'PASS',
    Fail: 'FAIL',
    NotAssessed: 'NOT_ASSESSED'
} as const;

export type ReceptionSessionReviewResponseDtoSafetyEnum = typeof ReceptionSessionReviewResponseDtoSafetyEnum[keyof typeof ReceptionSessionReviewResponseDtoSafetyEnum];
export const ReceptionSessionReviewResponseDtoTaskOutcomeEnum = {
    Resolved: 'RESOLVED',
    Handoff: 'HANDOFF',
    Unresolved: 'UNRESOLVED',
    NotAssessed: 'NOT_ASSESSED'
} as const;

export type ReceptionSessionReviewResponseDtoTaskOutcomeEnum = typeof ReceptionSessionReviewResponseDtoTaskOutcomeEnum[keyof typeof ReceptionSessionReviewResponseDtoTaskOutcomeEnum];

/**
 *
 * @export
 * @interface ReceptionSessionTranscriptResponseDto
 */
export interface ReceptionSessionTranscriptResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionTranscriptResponseDto
     */
    'sampleEvidenceDigest': string | null;
    /**
     *
     * @type {ReceptionSessionMetadataResponseDto}
     * @memberof ReceptionSessionTranscriptResponseDto
     */
    'session': ReceptionSessionMetadataResponseDto;
    /**
     *
     * @type {Array<ReceptionSessionTurnResponseDto>}
     * @memberof ReceptionSessionTranscriptResponseDto
     */
    'turns': Array<ReceptionSessionTurnResponseDto>;
}
/**
 *
 * @export
 * @interface ReceptionSessionTurnResponseDto
 */
export interface ReceptionSessionTurnResponseDto {
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionTurnResponseDto
     */
    'turnId': string;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionTurnResponseDto
     */
    'speaker': ReceptionSessionTurnResponseDtoSpeakerEnum;
    /**
     *
     * @type {string}
     * @memberof ReceptionSessionTurnResponseDto
     */
    'text': string;
    /**
     *
     * @type {number}
     * @memberof ReceptionSessionTurnResponseDto
     */
    'atMs': number;
    /**
     *
     * @type {Array<string>}
     * @memberof ReceptionSessionTurnResponseDto
     */
    'toolNames': Array<string>;
}

export const ReceptionSessionTurnResponseDtoSpeakerEnum = {
    Caller: 'CALLER',
    Receptionist: 'RECEPTIONIST'
} as const;

export type ReceptionSessionTurnResponseDtoSpeakerEnum = typeof ReceptionSessionTurnResponseDtoSpeakerEnum[keyof typeof ReceptionSessionTurnResponseDtoSpeakerEnum];

/**
 *
 * @export
 * @interface RecommendationBatchFailureDto
 */
export interface RecommendationBatchFailureDto {
    /**
     *
     * @type {string}
     * @memberof RecommendationBatchFailureDto
     */
    'category': string;
    /**
     *
     * @type {number}
     * @memberof RecommendationBatchFailureDto
     */
    'count': number;
}
/**
 *
 * @export
 * @interface RecommendationBatchResultDto
 */
export interface RecommendationBatchResultDto {
    /**
     *
     * @type {boolean}
     * @memberof RecommendationBatchResultDto
     */
    'complete': boolean;
    /**
     *
     * @type {string}
     * @memberof RecommendationBatchResultDto
     */
    'dateKey': string;
    /**
     *
     * @type {number}
     * @memberof RecommendationBatchResultDto
     */
    'totalActive': number;
    /**
     *
     * @type {number}
     * @memberof RecommendationBatchResultDto
     */
    'eligible': number;
    /**
     *
     * @type {number}
     * @memberof RecommendationBatchResultDto
     */
    'skippedIncomplete': number;
    /**
     *
     * @type {number}
     * @memberof RecommendationBatchResultDto
     */
    'generated': number;
    /**
     *
     * @type {number}
     * @memberof RecommendationBatchResultDto
     */
    'alreadyCurrent': number;
    /**
     *
     * @type {number}
     * @memberof RecommendationBatchResultDto
     */
    'skippedInvalidBreed': number;
    /**
     *
     * @type {number}
     * @memberof RecommendationBatchResultDto
     */
    'retryableFailures': number;
    /**
     *
     * @type {number}
     * @memberof RecommendationBatchResultDto
     */
    'terminalFailures': number;
    /**
     *
     * @type {number}
     * @memberof RecommendationBatchResultDto
     */
    'remaining': number;
    /**
     *
     * @type {number}
     * @memberof RecommendationBatchResultDto
     */
    'attempted': number;
    /**
     *
     * @type {number}
     * @memberof RecommendationBatchResultDto
     */
    'leasedElsewhere': number;
    /**
     *
     * @type {boolean}
     * @memberof RecommendationBatchResultDto
     */
    'circuitOpen': boolean;
    /**
     *
     * @type {boolean}
     * @memberof RecommendationBatchResultDto
     */
    'budgetExhausted': boolean;
    /**
     *
     * @type {number}
     * @memberof RecommendationBatchResultDto
     */
    'durationMs': number;
    /**
     *
     * @type {Array<RecommendationBatchFailureDto>}
     * @memberof RecommendationBatchResultDto
     */
    'failures': Array<RecommendationBatchFailureDto>;
}
/**
 *
 * @export
 * @interface RecommendationDto
 */
export interface RecommendationDto {
    /**
     * Title of the recommendation
     * @type {string}
     * @memberof RecommendationDto
     */
    'title': string;
    /**
     * Description of the recommendation
     * @type {string}
     * @memberof RecommendationDto
     */
    'description': string;
    /**
     * Category of the recommendation
     * @type {string}
     * @memberof RecommendationDto
     */
    'category': RecommendationDtoCategoryEnum;
    /**
     * Whether the recommendation is related to dietary needs
     * @type {boolean}
     * @memberof RecommendationDto
     */
    'isDietaryRelated'?: boolean;
}

export const RecommendationDtoCategoryEnum = {
    Nutrition: 'nutrition',
    Exercise: 'exercise',
    Health: 'health',
    Grooming: 'grooming',
    Behavior: 'behavior',
    Other: 'other'
} as const;

export type RecommendationDtoCategoryEnum = typeof RecommendationDtoCategoryEnum[keyof typeof RecommendationDtoCategoryEnum];

/**
 *
 * @export
 * @interface ReconcileVoiceLineDto
 */
export interface ReconcileVoiceLineDto {
    /**
     * Kontrolowany powód operacji na Voice Line
     * @type {string}
     * @memberof ReconcileVoiceLineDto
     */
    'reason': ReconcileVoiceLineDtoReasonEnum;
    /**
     * Opcjonalna notatka operacyjna bez danych osobowych (maks. 200 znaków)
     * @type {string}
     * @memberof ReconcileVoiceLineDto
     */
    'note'?: string;
}

export const ReconcileVoiceLineDtoReasonEnum = {
    PilotProvisioning: 'PILOT_PROVISIONING',
    OrganizationReassignment: 'ORGANIZATION_REASSIGNMENT',
    OrganizationDeprovisioning: 'ORGANIZATION_DEPROVISIONING',
    ProviderReconciliation: 'PROVIDER_RECONCILIATION',
    ProviderDriftRemediation: 'PROVIDER_DRIFT_REMEDIATION'
} as const;

export type ReconcileVoiceLineDtoReasonEnum = typeof ReconcileVoiceLineDtoReasonEnum[keyof typeof ReconcileVoiceLineDtoReasonEnum];

/**
 *
 * @export
 * @interface RecordAuthenticatedVoiceExactTextArtifactDto
 */
export interface RecordAuthenticatedVoiceExactTextArtifactDto {
    /**
     *
     * @type {string}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'purpose': RecordAuthenticatedVoiceExactTextArtifactDtoPurposeEnum;
    /**
     *
     * @type {string}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'sourceId': string;
    /**
     *
     * @type {number}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'expectedRevision': number;
    /**
     *
     * @type {string}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'sourceSha256': string;
    /**
     *
     * @type {string}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'spokenTextSha256': string;
    /**
     *
     * @type {string}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'qualifiedReleaseId': string;
    /**
     *
     * @type {number}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'qualifiedReleaseRevision': number;
    /**
     *
     * @type {string}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'voiceId': string;
    /**
     *
     * @type {number}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'voiceRevision': number;
    /**
     *
     * @type {string}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'rendererVersion': string;
    /**
     *
     * @type {string}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'assetId': string;
    /**
     *
     * @type {string}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'assetSha256': string;
    /**
     *
     * @type {number}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'durationMs': number;
    /**
     *
     * @type {string}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'observedAt': string;
    /**
     *
     * @type {string}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'expiresAt': string;
    /**
     *
     * @type {string}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'authenticatedServiceId': string;
    /**
     *
     * @type {string}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'authenticationRequestId': string;
    /**
     *
     * @type {string}
     * @memberof RecordAuthenticatedVoiceExactTextArtifactDto
     */
    'authenticationSignature': string;
}

export const RecordAuthenticatedVoiceExactTextArtifactDtoPurposeEnum = {
    FacilityGreeting: 'FACILITY_GREETING',
    EmergencyGuidance: 'EMERGENCY_GUIDANCE'
} as const;

export type RecordAuthenticatedVoiceExactTextArtifactDtoPurposeEnum = typeof RecordAuthenticatedVoiceExactTextArtifactDtoPurposeEnum[keyof typeof RecordAuthenticatedVoiceExactTextArtifactDtoPurposeEnum];

/**
 *
 * @export
 * @interface RecordCallbackAttemptDto
 */
export interface RecordCallbackAttemptDto {
    /**
     *
     * @type {number}
     * @memberof RecordCallbackAttemptDto
     */
    'expectedClaimVersion': number;
    /**
     *
     * @type {string}
     * @memberof RecordCallbackAttemptDto
     */
    'result': RecordCallbackAttemptDtoResultEnum;
}

export const RecordCallbackAttemptDtoResultEnum = {
    Contacted: 'CONTACTED',
    NoAnswer: 'NO_ANSWER',
    Busy: 'BUSY',
    Voicemail: 'VOICEMAIL',
    Failed: 'FAILED'
} as const;

export type RecordCallbackAttemptDtoResultEnum = typeof RecordCallbackAttemptDtoResultEnum[keyof typeof RecordCallbackAttemptDtoResultEnum];

/**
 *
 * @export
 * @interface RecordCardBalanceDto
 */
export interface RecordCardBalanceDto {
    /**
     * Signed milli-Units
     * @type {number}
     * @memberof RecordCardBalanceDto
     */
    'quantityMilli': number;
    /**
     * Pack size used to split this balance
     * @type {number}
     * @memberof RecordCardBalanceDto
     */
    'unitsPerPackage': number;
    /**
     * Whole packs of the magnitude of quantityMilli. The sign of quantityMilli applies to the whole quantity; only the leading non-zero part carries it (-12 000 at 10 per pack: packages -1, unitsMilli 2 000). Never add the parts.
     * @type {number}
     * @memberof RecordCardBalanceDto
     */
    'packages': number;
    /**
     * Milli-Units of the magnitude left after the whole packs. The sign of quantityMilli applies to the whole quantity; only the leading non-zero part carries it (-12 000 at 10 per pack: packages -1, unitsMilli 2 000). Never add the parts.
     * @type {number}
     * @memberof RecordCardBalanceDto
     */
    'unitsMilli': number;
}
/**
 *
 * @export
 * @interface RecordCardBatchBalanceDto
 */
export interface RecordCardBatchBalanceDto {
    /**
     * null = movements without a batch (seria nieznana)
     * @type {string}
     * @memberof RecordCardBatchBalanceDto
     */
    'batchId': string | null;
    /**
     *
     * @type {string}
     * @memberof RecordCardBatchBalanceDto
     */
    'batchNumber': string | null;
    /**
     *
     * @type {string}
     * @memberof RecordCardBatchBalanceDto
     */
    'expiryDate': string | null;
    /**
     *
     * @type {RecordCardBalanceDto}
     * @memberof RecordCardBatchBalanceDto
     */
    'opening': RecordCardBalanceDto;
    /**
     *
     * @type {RecordCardBalanceDto}
     * @memberof RecordCardBatchBalanceDto
     */
    'closing': RecordCardBalanceDto;
}
/**
 *
 * @export
 * @interface RecordCardClinicDto
 */
export interface RecordCardClinicDto {
    /**
     *
     * @type {string}
     * @memberof RecordCardClinicDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof RecordCardClinicDto
     */
    'address': string;
}
/**
 *
 * @export
 * @interface RecordCardDto
 */
export interface RecordCardDto {
    /**
     *
     * @type {RecordCardClinicDto}
     * @memberof RecordCardDto
     */
    'clinic': RecordCardClinicDto;
    /**
     *
     * @type {RecordCardProductDto}
     * @memberof RecordCardDto
     */
    'product': RecordCardProductDto;
    /**
     *
     * @type {string}
     * @memberof RecordCardDto
     */
    'from': string;
    /**
     *
     * @type {string}
     * @memberof RecordCardDto
     */
    'to': string;
    /**
     * ISO-8601 instant
     * @type {string}
     * @memberof RecordCardDto
     */
    'generatedAt': string;
    /**
     *
     * @type {RecordCardBalanceDto}
     * @memberof RecordCardDto
     */
    'opening': RecordCardBalanceDto;
    /**
     *
     * @type {RecordCardBalanceDto}
     * @memberof RecordCardDto
     */
    'closing': RecordCardBalanceDto;
    /**
     *
     * @type {Array<RecordCardBatchBalanceDto>}
     * @memberof RecordCardDto
     */
    'batches': Array<RecordCardBatchBalanceDto>;
    /**
     *
     * @type {Array<RecordCardRowDto>}
     * @memberof RecordCardDto
     */
    'rows': Array<RecordCardRowDto>;
    /**
     * Outgoing rows of the period without a batch that no reversal on this card resolves; a later correction never changes a reprint of an earlier period
     * @type {number}
     * @memberof RecordCardDto
     */
    'rowsWithoutBatchCount': number;
}
/**
 *
 * @export
 * @interface RecordCardProductDto
 */
export interface RecordCardProductDto {
    /**
     *
     * @type {string}
     * @memberof RecordCardProductDto
     */
    'id': string;
    /**
     * Snapshot of the first row in the period
     * @type {string}
     * @memberof RecordCardProductDto
     */
    'name': string;
    /**
     *
     * @type {boolean}
     * @memberof RecordCardProductDto
     */
    'isRx': boolean;
    /**
     *
     * @type {string}
     * @memberof RecordCardProductDto
     */
    'marketingAuthorisationNumber': string | null;
    /**
     * Podmiot odpowiedzialny (snapshot)
     * @type {string}
     * @memberof RecordCardProductDto
     */
    'marketingAuthorisationHolder': string | null;
    /**
     *
     * @type {string}
     * @memberof RecordCardProductDto
     */
    'form': string | null;
    /**
     *
     * @type {string}
     * @memberof RecordCardProductDto
     */
    'strength': string | null;
    /**
     *
     * @type {string}
     * @memberof RecordCardProductDto
     */
    'withdrawalPeriod': string | null;
    /**
     *
     * @type {WarehouseUnit}
     * @memberof RecordCardProductDto
     */
    'unit': WarehouseUnit;
    /**
     * Snapshot label of an OTHER unit
     * @type {string}
     * @memberof RecordCardProductDto
     */
    'unitCustom': string | null;
    /**
     * Pack content of the snapshot the header was taken from
     * @type {number}
     * @memberof RecordCardProductDto
     */
    'unitsPerPackage': number;
    /**
     * true only for a Product that has never moved: the header then comes from the catalogue
     * @type {boolean}
     * @memberof RecordCardProductDto
     */
    'headerFromCatalogue': boolean;
}


/**
 *
 * @export
 * @interface RecordCardRowDto
 */
export interface RecordCardRowDto {
    /**
     *
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'movementId': string;
    /**
     * 1-based chronological position (Lp.)
     * @type {number}
     * @memberof RecordCardRowDto
     */
    'lp': number;
    /**
     *
     * @type {WarehouseMovementType}
     * @memberof RecordCardRowDto
     */
    'type': WarehouseMovementType;
    /**
     *
     * @type {WarehouseMovementSourceKind}
     * @memberof RecordCardRowDto
     */
    'sourceKind': WarehouseMovementSourceKind;
    /**
     * Document, Medication or Performed Treatment id
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'sourceId': string;
    /**
     * Document line or Medication stock issue id
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'sourceLineId': string | null;
    /**
     * ISO-8601 issue instant (a reversal or repost keeps the original one)
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'occurredAt': string;
    /**
     * Warsaw card date = effectiveAt: the issue date of an original, the correction date for every part of a correction (R2-1)
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'date': string;
    /**
     * Warsaw issue date (occurredAt); printed on a repost
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'issueDate': string;
    /**
     * ISO-8601 instant
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'recordedAt': string;
    /**
     *
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'recordedByName': string | null;
    /**
     * Signed milli-Units: + in, - out
     * @type {number}
     * @memberof RecordCardRowDto
     */
    'quantityMilli': number;
    /**
     * Pack size snapshot of this movement
     * @type {number}
     * @memberof RecordCardRowDto
     */
    'unitsPerPackage': number;
    /**
     * Marketing-authorisation number snapshot of this movement; printed per row only when it differs from the header
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'marketingAuthorisationNumber': string | null;
    /**
     * Whole packs of the magnitude of quantityMilli. The sign of quantityMilli applies to the whole quantity; only the leading non-zero part carries it (-12 000 at 10 per pack: packages -1, unitsMilli 2 000). Never add the parts.
     * @type {number}
     * @memberof RecordCardRowDto
     */
    'packages': number;
    /**
     * Milli-Units of the magnitude left after the whole packs. The sign of quantityMilli applies to the whole quantity; only the leading non-zero part carries it (-12 000 at 10 per pack: packages -1, unitsMilli 2 000). Never add the parts.
     * @type {number}
     * @memberof RecordCardRowDto
     */
    'unitsMilli': number;
    /**
     * Product balance after this row, milli-Units
     * @type {number}
     * @memberof RecordCardRowDto
     */
    'balanceAfterMilli': number;
    /**
     *
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'batchId': string | null;
    /**
     *
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'batchNumber': string | null;
    /**
     *
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'expiryDate': string | null;
    /**
     *
     * @type {WarehouseDocumentType}
     * @memberof RecordCardRowDto
     */
    'documentType'?: WarehouseDocumentType;
    /**
     *
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'documentNumber': string | null;
    /**
     * Supplier snapshot of the approved document
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'supplierName': string | null;
    /**
     *
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'supplierAddress': string | null;
    /**
     *
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'supplierInvoiceNumber': string | null;
    /**
     * Receipt rows: quantity as entered on the document line
     * @type {number}
     * @memberof RecordCardRowDto
     */
    'receiptInputQuantity': number | null;
    /**
     *
     * @type {WarehouseQuantityMeasure}
     * @memberof RecordCardRowDto
     */
    'receiptInputMeasure'?: WarehouseQuantityMeasure;
    /**
     *
     * @type {WarehouseAdjustmentReason}
     * @memberof RecordCardRowDto
     */
    'adjustmentReason'?: WarehouseAdjustmentReason;
    /**
     *
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'visitId': string | null;
    /**
     *
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'visitDate': string | null;
    /**
     *
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'patientName': string | null;
    /**
     *
     * @type {WarehouseHandover}
     * @memberof RecordCardRowDto
     */
    'handover'?: WarehouseHandover;
    /**
     *
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'recipientName': string | null;
    /**
     * Handed-over drugs: the recipient address snapshot, printed with the recipient (Art. 103(3)(e) Reg. 2019/6); null on rows recorded before it was collected
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'recipientAddress': string | null;
    /**
     *
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'prescriberName': string | null;
    /**
     * Handed-over Rx issues: was a prescription issued
     * @type {boolean}
     * @memberof RecordCardRowDto
     */
    'prescriptionIssued': boolean | null;
    /**
     * Where the prescription was filled
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'prescriptionRealisedAt': string | null;
    /**
     * This row is a reversal (storno) of another movement
     * @type {boolean}
     * @memberof RecordCardRowDto
     */
    'isCorrection': boolean;
    /**
     * Written by a correction, dated by it, and shows issueDate: either a repost of a reversed movement (a corrected issue or a batch assignment), or a first stock issue that a later edit added to a past visit\'s entry (an entry added by an edit, issued on issueDate; nothing was reversed)
     * @type {boolean}
     * @memberof RecordCardRowDto
     */
    'isRepost': boolean;
    /**
     * This row is part of a batch assignment: its reversal or one of its reposts
     * @type {boolean}
     * @memberof RecordCardRowDto
     */
    'isBatchAssignment': boolean;
    /**
     *
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'correctsMovementId': string | null;
    /**
     * lp of the corrected row when it is on this card
     * @type {number}
     * @memberof RecordCardRowDto
     */
    'correctsLp': number | null;
    /**
     * Card date of the corrected row
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'correctsDate': string | null;
    /**
     *
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'reversedByMovementId': string | null;
    /**
     * Warsaw date the reversal was recorded
     * @type {string}
     * @memberof RecordCardRowDto
     */
    'reversedOn': string | null;
    /**
     * The reversal of this row assigned its batch
     * @type {boolean}
     * @memberof RecordCardRowDto
     */
    'reversedByBatchAssignment': boolean;
}


/**
 *
 * @export
 * @interface RecordReceptionDestinationProviderObservationDto
 */
export interface RecordReceptionDestinationProviderObservationDto {
    /**
     *
     * @type {string}
     * @memberof RecordReceptionDestinationProviderObservationDto
     */
    'destinationId': string;
    /**
     *
     * @type {number}
     * @memberof RecordReceptionDestinationProviderObservationDto
     */
    'expectedRoutingRevision': number;
    /**
     *
     * @type {string}
     * @memberof RecordReceptionDestinationProviderObservationDto
     */
    'internalRequestId': string;
}
/**
 *
 * @export
 * @interface RecordVoicePilotExpansionDecisionDto
 */
export interface RecordVoicePilotExpansionDecisionDto {
    /**
     *
     * @type {string}
     * @memberof RecordVoicePilotExpansionDecisionDto
     */
    'decision': RecordVoicePilotExpansionDecisionDtoDecisionEnum;
}

export const RecordVoicePilotExpansionDecisionDtoDecisionEnum = {
    Approve: 'APPROVE',
    Veto: 'VETO'
} as const;

export type RecordVoicePilotExpansionDecisionDtoDecisionEnum = typeof RecordVoicePilotExpansionDecisionDtoDecisionEnum[keyof typeof RecordVoicePilotExpansionDecisionDtoDecisionEnum];

/**
 *
 * @export
 * @interface RecordVoiceQualifiedReleaseApprovalDto
 */
export interface RecordVoiceQualifiedReleaseApprovalDto {
    /**
     *
     * @type {number}
     * @memberof RecordVoiceQualifiedReleaseApprovalDto
     */
    'expectedRevision': number;
    /**
     *
     * @type {string}
     * @memberof RecordVoiceQualifiedReleaseApprovalDto
     */
    'evidenceDigest': string;
}
/**
 *
 * @export
 * @interface RegisterManagedVoiceLineDto
 */
export interface RegisterManagedVoiceLineDto {
    /**
     * Kontrolowany powód operacji na Voice Line
     * @type {string}
     * @memberof RegisterManagedVoiceLineDto
     */
    'reason': RegisterManagedVoiceLineDtoReasonEnum;
    /**
     * Opcjonalna notatka operacyjna bez danych osobowych (maks. 200 znaków)
     * @type {string}
     * @memberof RegisterManagedVoiceLineDto
     */
    'note'?: string;
    /**
     * SID obecnego konta dostawcy Twilio
     * @type {string}
     * @memberof RegisterManagedVoiceLineDto
     */
    'providerAccountSid': string;
    /**
     * SID zarządzanego zasobu IncomingPhoneNumber
     * @type {string}
     * @memberof RegisterManagedVoiceLineDto
     */
    'incomingPhoneNumberSid': string;
    /**
     * Kanoniczny numer Voice Line w formacie E.164
     * @type {string}
     * @memberof RegisterManagedVoiceLineDto
     */
    'e164': string;
    /**
     * Docelowy regionalny adres głównego webhooka Voice
     * @type {string}
     * @memberof RegisterManagedVoiceLineDto
     */
    'desiredPrimaryWebhookUrl': string;
    /**
     * Docelowy regionalny adres niezależnego webhooka fallback
     * @type {string}
     * @memberof RegisterManagedVoiceLineDto
     */
    'desiredFallbackWebhookUrl': string;
    /**
     * Docelowy regionalny adres callbacka statusu połączenia
     * @type {string}
     * @memberof RegisterManagedVoiceLineDto
     */
    'desiredStatusCallbackUrl': string;
    /**
     * Docelowa opublikowana rewizja Fallback Bundle
     * @type {number}
     * @memberof RegisterManagedVoiceLineDto
     */
    'desiredFallbackBundleRevision': number;
    /**
     * Identyfikator docelowego regionalnego wdrożenia fallback
     * @type {string}
     * @memberof RegisterManagedVoiceLineDto
     */
    'desiredFallbackDeploymentId': string;
}

export const RegisterManagedVoiceLineDtoReasonEnum = {
    PilotProvisioning: 'PILOT_PROVISIONING',
    OrganizationReassignment: 'ORGANIZATION_REASSIGNMENT',
    OrganizationDeprovisioning: 'ORGANIZATION_DEPROVISIONING',
    ProviderReconciliation: 'PROVIDER_RECONCILIATION',
    ProviderDriftRemediation: 'PROVIDER_DRIFT_REMEDIATION'
} as const;

export type RegisterManagedVoiceLineDtoReasonEnum = typeof RegisterManagedVoiceLineDtoReasonEnum[keyof typeof RegisterManagedVoiceLineDtoReasonEnum];

/**
 *
 * @export
 * @interface RegisterProfessionalDto
 */
export interface RegisterProfessionalDto {
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'email': string;
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'password': string;
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'firstName': string;
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'middleName'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'lastName': string;
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'phoneNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'dob'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'avatar'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'address'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'companyName'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'companyAddress'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'companyCity'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'companyZip'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'vatNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'pwzNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'city'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterProfessionalDto
     */
    'zip'?: string;
    /**
     *
     * @type {boolean}
     * @memberof RegisterProfessionalDto
     */
    'marketing'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof RegisterProfessionalDto
     */
    'terms': boolean;
}
/**
 *
 * @export
 * @interface RegisterUserDto
 */
export interface RegisterUserDto {
    /**
     *
     * @type {string}
     * @memberof RegisterUserDto
     */
    'email': string;
    /**
     *
     * @type {string}
     * @memberof RegisterUserDto
     */
    'password': string;
    /**
     *
     * @type {string}
     * @memberof RegisterUserDto
     */
    'firstName': string;
    /**
     *
     * @type {string}
     * @memberof RegisterUserDto
     */
    'middleName'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterUserDto
     */
    'lastName': string;
    /**
     *
     * @type {string}
     * @memberof RegisterUserDto
     */
    'phoneNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterUserDto
     */
    'dob'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterUserDto
     */
    'avatar'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterUserDto
     */
    'address'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterUserDto
     */
    'city'?: string;
    /**
     *
     * @type {string}
     * @memberof RegisterUserDto
     */
    'zip'?: string;
    /**
     *
     * @type {boolean}
     * @memberof RegisterUserDto
     */
    'marketing'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof RegisterUserDto
     */
    'terms': boolean;
}
/**
 *
 * @export
 * @interface RejectByGuestDto
 */
export interface RejectByGuestDto {
    /**
     * Optional reason for rejecting the visit
     * @type {string}
     * @memberof RejectByGuestDto
     */
    'reason'?: string;
}
/**
 *
 * @export
 * @interface RejectVoiceDsrDto
 */
export interface RejectVoiceDsrDto {
    /**
     *
     * @type {number}
     * @memberof RejectVoiceDsrDto
     */
    'expectedRevision': number;
    /**
     *
     * @type {string}
     * @memberof RejectVoiceDsrDto
     */
    'reason': RejectVoiceDsrDtoReasonEnum;
}

export const RejectVoiceDsrDtoReasonEnum = {
    IdentityEvidenceInsufficient: 'IDENTITY_EVIDENCE_INSUFFICIENT',
    RequestScopeUnclear: 'REQUEST_SCOPE_UNCLEAR',
    LegalObligationRequiresRetention: 'LEGAL_OBLIGATION_REQUIRES_RETENTION',
    NoQualifiedFulfillmentChannel: 'NO_QUALIFIED_FULFILLMENT_CHANNEL',
    RightNotApplicable: 'RIGHT_NOT_APPLICABLE'
} as const;

export type RejectVoiceDsrDtoReasonEnum = typeof RejectVoiceDsrDtoReasonEnum[keyof typeof RejectVoiceDsrDtoReasonEnum];

/**
 *
 * @export
 * @interface RequestCallbackSupportGrantDto
 */
export interface RequestCallbackSupportGrantDto {
    /**
     *
     * @type {string}
     * @memberof RequestCallbackSupportGrantDto
     */
    'supportSessionId': string;
    /**
     *
     * @type {string}
     * @memberof RequestCallbackSupportGrantDto
     */
    'ticketReference': string;
    /**
     *
     * @type {string}
     * @memberof RequestCallbackSupportGrantDto
     */
    'reason': RequestCallbackSupportGrantDtoReasonEnum;
    /**
     *
     * @type {number}
     * @memberof RequestCallbackSupportGrantDto
     */
    'requestedMinutes': number;
}

export const RequestCallbackSupportGrantDtoReasonEnum = {
    CallbackQueueDiagnosis: 'CALLBACK_QUEUE_DIAGNOSIS',
    CallbackSlaIncidentInvestigation: 'CALLBACK_SLA_INCIDENT_INVESTIGATION',
    AccessControlVerification: 'ACCESS_CONTROL_VERIFICATION'
} as const;

export type RequestCallbackSupportGrantDtoReasonEnum = typeof RequestCallbackSupportGrantDtoReasonEnum[keyof typeof RequestCallbackSupportGrantDtoReasonEnum];

/**
 *
 * @export
 * @interface RequestTranscriptSupportGrantDto
 */
export interface RequestTranscriptSupportGrantDto {
    /**
     *
     * @type {string}
     * @memberof RequestTranscriptSupportGrantDto
     */
    'supportSessionId': string;
    /**
     *
     * @type {string}
     * @memberof RequestTranscriptSupportGrantDto
     */
    'ticketReference': string;
    /**
     *
     * @type {string}
     * @memberof RequestTranscriptSupportGrantDto
     */
    'reason': RequestTranscriptSupportGrantDtoReasonEnum;
    /**
     *
     * @type {number}
     * @memberof RequestTranscriptSupportGrantDto
     */
    'requestedMinutes': number;
}

export const RequestTranscriptSupportGrantDtoReasonEnum = {
    ReceptionBehaviorDiagnosis: 'RECEPTION_BEHAVIOR_DIAGNOSIS',
    PrivacyIncidentInvestigation: 'PRIVACY_INCIDENT_INVESTIGATION',
    AccessControlVerification: 'ACCESS_CONTROL_VERIFICATION'
} as const;

export type RequestTranscriptSupportGrantDtoReasonEnum = typeof RequestTranscriptSupportGrantDtoReasonEnum[keyof typeof RequestTranscriptSupportGrantDtoReasonEnum];

/**
 *
 * @export
 * @interface RequestVisitDto
 */
export interface RequestVisitDto {
    /**
     *
     * @type {OrderDto}
     * @memberof RequestVisitDto
     */
    'order': OrderDto;
    /**
     *
     * @type {PetsitterDto}
     * @memberof RequestVisitDto
     */
    'petsitter': PetsitterDto;
    /**
     *
     * @type {Array<PetDto>}
     * @memberof RequestVisitDto
     */
    'pet': Array<PetDto>;
}
/**
 *
 * @export
 * @interface RequestVoiceLineDetachDto
 */
export interface RequestVoiceLineDetachDto {
    /**
     * Kontrolowany powód operacji na Voice Line
     * @type {string}
     * @memberof RequestVoiceLineDetachDto
     */
    'reason': RequestVoiceLineDetachDtoReasonEnum;
    /**
     * Opcjonalna notatka operacyjna bez danych osobowych (maks. 200 znaków)
     * @type {string}
     * @memberof RequestVoiceLineDetachDto
     */
    'note'?: string;
    /**
     * Docelowy regionalny adres niezależnego webhooka dla odłączonej linii
     * @type {string}
     * @memberof RequestVoiceLineDetachDto
     */
    'desiredFallbackWebhookUrl': string;
    /**
     * Nowa, wyższa rewizja Fallback Bundle dla odłączonej linii
     * @type {number}
     * @memberof RequestVoiceLineDetachDto
     */
    'desiredFallbackBundleRevision': number;
    /**
     * Identyfikator nowego regionalnego wdrożenia fallback dla odłączonej linii
     * @type {string}
     * @memberof RequestVoiceLineDetachDto
     */
    'desiredFallbackDeploymentId': string;
}

export const RequestVoiceLineDetachDtoReasonEnum = {
    PilotProvisioning: 'PILOT_PROVISIONING',
    OrganizationReassignment: 'ORGANIZATION_REASSIGNMENT',
    OrganizationDeprovisioning: 'ORGANIZATION_DEPROVISIONING',
    ProviderReconciliation: 'PROVIDER_RECONCILIATION',
    ProviderDriftRemediation: 'PROVIDER_DRIFT_REMEDIATION'
} as const;

export type RequestVoiceLineDetachDtoReasonEnum = typeof RequestVoiceLineDetachDtoReasonEnum[keyof typeof RequestVoiceLineDetachDtoReasonEnum];

/**
 *
 * @export
 * @interface RequiredFormInfo
 */
export interface RequiredFormInfo {
    /**
     * Form ID
     * @type {string}
     * @memberof RequiredFormInfo
     */
    'formId': string;
    /**
     * Form name
     * @type {string}
     * @memberof RequiredFormInfo
     */
    'formName': string;
    /**
     * Submission status
     * @type {string}
     * @memberof RequiredFormInfo
     */
    'submissionStatus': RequiredFormInfoSubmissionStatusEnum;
}

export const RequiredFormInfoSubmissionStatusEnum = {
    NotStarted: 'not_started',
    Draft: 'draft',
    Submitted: 'submitted'
} as const;

export type RequiredFormInfoSubmissionStatusEnum = typeof RequiredFormInfoSubmissionStatusEnum[keyof typeof RequiredFormInfoSubmissionStatusEnum];

/**
 *
 * @export
 * @interface RescheduleByGuestDto
 */
export interface RescheduleByGuestDto {
    /**
     * New visit start time (ISO 8601)
     * @type {string}
     * @memberof RescheduleByGuestDto
     */
    'startTime': string;
    /**
     * Optional professional ID to reassign the visit to
     * @type {string}
     * @memberof RescheduleByGuestDto
     */
    'professionalId'?: string;
}
/**
 *
 * @export
 * @interface RescheduleStaffVisitDto
 */
export interface RescheduleStaffVisitDto {
    /**
     * New start time for the visit (ISO format)
     * @type {string}
     * @memberof RescheduleStaffVisitDto
     */
    'newStartTime': string;
    /**
     * ID of the new professional to assign the visit to (optional)
     * @type {string}
     * @memberof RescheduleStaffVisitDto
     */
    'newProfessionalId'?: string;
}
/**
 *
 * @export
 * @interface RescheduleVisitDto
 */
export interface RescheduleVisitDto {
    /**
     * Visit ID to reschedule
     * @type {string}
     * @memberof RescheduleVisitDto
     */
    'visitId': string;
    /**
     * New start time for the visit
     * @type {string}
     * @memberof RescheduleVisitDto
     */
    'newStartTime': string;
    /**
     * Optional professional ID to assign the visit to
     * @type {string}
     * @memberof RescheduleVisitDto
     */
    'professionalId'?: string;
}
/**
 *
 * @export
 * @interface RevokeVoiceSecurityTriggerReceiptDto
 */
export interface RevokeVoiceSecurityTriggerReceiptDto {
    /**
     *
     * @type {string}
     * @memberof RevokeVoiceSecurityTriggerReceiptDto
     */
    'receiptId': string;
    /**
     *
     * @type {string}
     * @memberof RevokeVoiceSecurityTriggerReceiptDto
     */
    'reason': string;
}
/**
 *
 * @export
 * @interface ScheduleVisitDto
 */
export interface ScheduleVisitDto {
    /**
     * When false, the visit is stored as a guest booking and no User/Profile is created. Guest-required fields (firstName, lastName, phoneNumber, profileName, terms=true) must be provided.
     * @type {boolean}
     * @memberof ScheduleVisitDto
     */
    'createAccount'?: boolean;
    /**
     * Start time of the visit in ISO 8601 format
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'startTime': string;
    /**
     * ID of the pet profile. Either profileId or profileName must be provided.
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'profileId'?: string;
    /**
     * Name of the pet profile. Either profileId or profileName must be provided.
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'profileName'?: string;
    /**
     * Category of the visit
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'category': ScheduleVisitDtoCategoryEnum;
    /**
     * Type of the visit
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'visitType'?: ScheduleVisitDtoVisitTypeEnum;
    /**
     * Description of the visit
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'description': string;
    /**
     * Array of document files related to the visit
     * @type {Array<DocumentFileDto>}
     * @memberof ScheduleVisitDto
     */
    'documents'?: Array<DocumentFileDto>;
    /**
     * Promotional code for the visit
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'promoCode'?: string;
    /**
     *
     * @type {ScheduleVisitDtoExternalId}
     * @memberof ScheduleVisitDto
     */
    'externalId'?: ScheduleVisitDtoExternalId;
    /**
     * First name of the pet owner
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'firstName'?: string;
    /**
     * Last name of the pet owner
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'lastName'?: string;
    /**
     * Phone number of the pet owner
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'phoneNumber'?: string;
    /**
     * Email address of the pet owner (used for guest bookings)
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'email'?: string;
    /**
     * Whether the user consents to marketing communications
     * @type {boolean}
     * @memberof ScheduleVisitDto
     */
    'marketing'?: boolean;
    /**
     * Whether the user accepts terms and conditions
     * @type {boolean}
     * @memberof ScheduleVisitDto
     */
    'terms'?: boolean;
    /**
     * Date of birth of the pet
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'dob'?: string;
    /**
     * Breed of the pet
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'breed'?: string;
    /**
     * Weight of the pet in kilograms
     * @type {number}
     * @memberof ScheduleVisitDto
     */
    'weight'?: number;
    /**
     * Gender of the pet
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'gender'?: string;
    /**
     * Category of the pet
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'petCategory'?: ScheduleVisitDtoPetCategoryEnum;
    /**
     * ID of the professional handling the visit
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'professionalId'?: string;
    /**
     * ID of the organization where the visit takes place
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'organizationId'?: string;
    /**
     * ID of the selected service for this visit
     * @type {string}
     * @memberof ScheduleVisitDto
     */
    'serviceId'?: string;
    /**
     *
     * @type {StaffScheduleVisitDtoVisitAddress}
     * @memberof ScheduleVisitDto
     */
    'visitAddress'?: StaffScheduleVisitDtoVisitAddress;
}

export const ScheduleVisitDtoCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type ScheduleVisitDtoCategoryEnum = typeof ScheduleVisitDtoCategoryEnum[keyof typeof ScheduleVisitDtoCategoryEnum];
export const ScheduleVisitDtoVisitTypeEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type ScheduleVisitDtoVisitTypeEnum = typeof ScheduleVisitDtoVisitTypeEnum[keyof typeof ScheduleVisitDtoVisitTypeEnum];
export const ScheduleVisitDtoPetCategoryEnum = {
    Dog: 'dog',
    Cat: 'cat',
    Other: 'other'
} as const;

export type ScheduleVisitDtoPetCategoryEnum = typeof ScheduleVisitDtoPetCategoryEnum[keyof typeof ScheduleVisitDtoPetCategoryEnum];

/**
 * External ID for integration with other systems
 * @export
 * @interface ScheduleVisitDtoExternalId
 */
export interface ScheduleVisitDtoExternalId {
    /**
     * Name of the external ID system
     * @type {string}
     * @memberof ScheduleVisitDtoExternalId
     */
    'name': string;
    /**
     * Value of the external ID
     * @type {string}
     * @memberof ScheduleVisitDtoExternalId
     */
    'value': string;
}
/**
 *
 * @export
 * @interface ScheduleVisitResponseDto
 */
export interface ScheduleVisitResponseDto {
    /**
     *
     * @type {string}
     * @memberof ScheduleVisitResponseDto
     */
    'redirectUrl'?: string;
    /**
     *
     * @type {string}
     * @memberof ScheduleVisitResponseDto
     */
    'id': string;
    /**
     *
     * @type {number}
     * @memberof ScheduleVisitResponseDto
     */
    'amount'?: number;
    /**
     *
     * @type {string}
     * @memberof ScheduleVisitResponseDto
     */
    'token': string;
}
/**
 *
 * @export
 * @interface ScheduleVoiceAllowanceReductionDto
 */
export interface ScheduleVoiceAllowanceReductionDto {
    /**
     * Kontrolowany powód operacji na sterowaniu przyjęciem Voice
     * @type {string}
     * @memberof ScheduleVoiceAllowanceReductionDto
     */
    'reason': string;
    /**
     * Opcjonalna notatka operacyjna bez danych osobowych
     * @type {string}
     * @memberof ScheduleVoiceAllowanceReductionDto
     */
    'note'?: string;
    /**
     * Niższy cykliczny przydział bazowy obowiązujący od następnego miesiąca warszawskiego
     * @type {number}
     * @memberof ScheduleVoiceAllowanceReductionDto
     */
    'nextMonthRecurringBaseGrantMs': number;
}
/**
 *
 * @export
 * @interface ScheduleVoiceDsrErasureDto
 */
export interface ScheduleVoiceDsrErasureDto {
    /**
     *
     * @type {number}
     * @memberof ScheduleVoiceDsrErasureDto
     */
    'expectedRevision': number;
    /**
     *
     * @type {string}
     * @memberof ScheduleVoiceDsrErasureDto
     */
    'visitDisposition'?: ScheduleVoiceDsrErasureDtoVisitDispositionEnum;
    /**
     *
     * @type {string}
     * @memberof ScheduleVoiceDsrErasureDto
     */
    'legalReviewEvidenceDigest'?: string;
}

export const ScheduleVoiceDsrErasureDtoVisitDispositionEnum = {
    AnonymizeNonClinicalVoiceVisit: 'ANONYMIZE_NON_CLINICAL_VOICE_VISIT'
} as const;

export type ScheduleVoiceDsrErasureDtoVisitDispositionEnum = typeof ScheduleVoiceDsrErasureDtoVisitDispositionEnum[keyof typeof ScheduleVoiceDsrErasureDtoVisitDispositionEnum];

/**
 *
 * @export
 * @interface SearchDocumentsDto
 */
export interface SearchDocumentsDto {
    /**
     * Search query
     * @type {string}
     * @memberof SearchDocumentsDto
     */
    'query': string;
    /**
     * Profile ID to search documents for
     * @type {string}
     * @memberof SearchDocumentsDto
     */
    'profileId': string;
    /**
     * Maximum number of results to return
     * @type {number}
     * @memberof SearchDocumentsDto
     */
    'maxResults'?: number;
    /**
     * Minimum similarity score (0-1) for results
     * @type {number}
     * @memberof SearchDocumentsDto
     */
    'minSimilarity'?: number;
}
/**
 *
 * @export
 * @interface SearchGlobalUsersDto
 */
export interface SearchGlobalUsersDto {
    /**
     * Email to search for
     * @type {string}
     * @memberof SearchGlobalUsersDto
     */
    'email'?: string;
    /**
     * Phone number to search for
     * @type {string}
     * @memberof SearchGlobalUsersDto
     */
    'phoneNumber'?: string;
    /**
     * User ID to search for
     * @type {string}
     * @memberof SearchGlobalUsersDto
     */
    'id'?: string;
}
/**
 *
 * @export
 * @interface SendChatMessageRequest
 */
export interface SendChatMessageRequest {
    /**
     *
     * @type {string}
     * @memberof SendChatMessageRequest
     */
    'conversationId': string;
    /**
     *
     * @type {string}
     * @memberof SendChatMessageRequest
     */
    'message': string;
}
/**
 *
 * @export
 * @interface SendChatMessageResponse
 */
export interface SendChatMessageResponse {
    /**
     *
     * @type {object}
     * @memberof SendChatMessageResponse
     */
    'message': object;
}
/**
 *
 * @export
 * @interface SendGuestVerifySmsDto
 */
export interface SendGuestVerifySmsDto {
    /**
     *
     * @type {string}
     * @memberof SendGuestVerifySmsDto
     */
    'phoneNumber': string;
    /**
     *
     * @type {string}
     * @memberof SendGuestVerifySmsDto
     */
    'code': string;
}
/**
 *
 * @export
 * @interface SendPasswordResetDto
 */
export interface SendPasswordResetDto {
    /**
     * Email address of the account requesting the reset
     * @type {string}
     * @memberof SendPasswordResetDto
     */
    'email': string;
}
/**
 *
 * @export
 * @interface SendPasswordResetResponseDto
 */
export interface SendPasswordResetResponseDto {
    /**
     * Always true. The endpoint returns the same response whether or not the email exists, to avoid account enumeration.
     * @type {boolean}
     * @memberof SendPasswordResetResponseDto
     */
    'success': boolean;
}
/**
 *
 * @export
 * @interface SendPhoneVerificationDto
 */
export interface SendPhoneVerificationDto {
    /**
     * Phone number with country code (e.g., +48606870846)
     * @type {string}
     * @memberof SendPhoneVerificationDto
     */
    'phoneNumber': string;
}
/**
 *
 * @export
 * @interface SendPhoneVerificationResponseDto
 */
export interface SendPhoneVerificationResponseDto {
    /**
     * Success message
     * @type {string}
     * @memberof SendPhoneVerificationResponseDto
     */
    'message': string;
}
/**
 *
 * @export
 * @interface SendVerificationQuestionDto
 */
export interface SendVerificationQuestionDto {
    /**
     * Organization ID
     * @type {string}
     * @memberof SendVerificationQuestionDto
     */
    'organizationId': string;
    /**
     * Question content
     * @type {string}
     * @memberof SendVerificationQuestionDto
     */
    'question': string;
}
/**
 *
 * @export
 * @interface SendWebinarStaffInvitationDto
 */
export interface SendWebinarStaffInvitationDto {
    /**
     *
     * @type {string}
     * @memberof SendWebinarStaffInvitationDto
     */
    'requestId': string;
}
/**
 *
 * @export
 * @interface ServiceConfigDto
 */
export interface ServiceConfigDto {
    /**
     * Service ID
     * @type {string}
     * @memberof ServiceConfigDto
     */
    'serviceId': string;
    /**
     * Service name
     * @type {string}
     * @memberof ServiceConfigDto
     */
    'serviceName': string;
    /**
     * Specialization ID this service is assigned to
     * @type {string}
     * @memberof ServiceConfigDto
     */
    'specializationId': string;
    /**
     * Service category
     * @type {string}
     * @memberof ServiceConfigDto
     */
    'category': ServiceConfigDtoCategoryEnum;
    /**
     * Visit type for this service
     * @type {string}
     * @memberof ServiceConfigDto
     */
    'visitType': ServiceConfigDtoVisitTypeEnum;
    /**
     * Service duration in minutes
     * @type {number}
     * @memberof ServiceConfigDto
     */
    'duration': number;
    /**
     * Default price for this service in PLN
     * @type {number}
     * @memberof ServiceConfigDto
     */
    'defaultPrice': number;
    /**
     * Notes about this service
     * @type {string}
     * @memberof ServiceConfigDto
     */
    'notes'?: string;
    /**
     * Reservation fee in PLN charged at booking. null = no fee.
     * @type {number}
     * @memberof ServiceConfigDto
     */
    'prepaidAmount'?: number;
}

export const ServiceConfigDtoCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type ServiceConfigDtoCategoryEnum = typeof ServiceConfigDtoCategoryEnum[keyof typeof ServiceConfigDtoCategoryEnum];
export const ServiceConfigDtoVisitTypeEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type ServiceConfigDtoVisitTypeEnum = typeof ServiceConfigDtoVisitTypeEnum[keyof typeof ServiceConfigDtoVisitTypeEnum];

/**
 *
 * @export
 * @interface ServiceDetails
 */
export interface ServiceDetails {
    /**
     * Service name
     * @type {string}
     * @memberof ServiceDetails
     */
    'name': string;
    /**
     * Service duration in minutes
     * @type {number}
     * @memberof ServiceDetails
     */
    'duration': number;
    /**
     * Service price
     * @type {number}
     * @memberof ServiceDetails
     */
    'price': number;
    /**
     * Service description
     * @type {string}
     * @memberof ServiceDetails
     */
    'description'?: string;
}
/**
 *
 * @export
 * @interface ServicePricePolicyRevisionResponseDto
 */
export interface ServicePricePolicyRevisionResponseDto {
    /**
     *
     * @type {string}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'serviceId': string;
    /**
     *
     * @type {number}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'kind': ServicePricePolicyRevisionResponseDtoKindEnum;
    /**
     *
     * @type {number}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'amountMinor'?: number | null;
    /**
     *
     * @type {string}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'currency': ServicePricePolicyRevisionResponseDtoCurrencyEnum;
    /**
     *
     * @type {string}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'effectiveAt': string;
    /**
     *
     * @type {string}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'validUntil'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'reason': ServicePricePolicyRevisionResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'note'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'actorUserId'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'actorPseudonym'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'actorPseudonymizedAt'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'publishedAt': string;
    /**
     *
     * @type {string}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'supersededAt'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ServicePricePolicyRevisionResponseDto
     */
    'retainUntil'?: string | null;
}

export const ServicePricePolicyRevisionResponseDtoKindEnum = {
    Exact: 'EXACT',
    From: 'FROM',
    DoNotQuote: 'DO_NOT_QUOTE'
} as const;

export type ServicePricePolicyRevisionResponseDtoKindEnum = typeof ServicePricePolicyRevisionResponseDtoKindEnum[keyof typeof ServicePricePolicyRevisionResponseDtoKindEnum];
export const ServicePricePolicyRevisionResponseDtoCurrencyEnum = {
    Pln: 'PLN'
} as const;

export type ServicePricePolicyRevisionResponseDtoCurrencyEnum = typeof ServicePricePolicyRevisionResponseDtoCurrencyEnum[keyof typeof ServicePricePolicyRevisionResponseDtoCurrencyEnum];
export const ServicePricePolicyRevisionResponseDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    FactsUpdate: 'FACTS_UPDATE',
    ForwardRollback: 'FORWARD_ROLLBACK'
} as const;

export type ServicePricePolicyRevisionResponseDtoReasonEnum = typeof ServicePricePolicyRevisionResponseDtoReasonEnum[keyof typeof ServicePricePolicyRevisionResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface SetOrganizationAvailabilityDto
 */
export interface SetOrganizationAvailabilityDto {
    /**
     * Array of availability slots
     * @type {Array<OrganizationAvailabilitySlotDto>}
     * @memberof SetOrganizationAvailabilityDto
     */
    'availabilitySlots': Array<OrganizationAvailabilitySlotDto>;
    /**
     * When true, only computes conflicting visits without persisting the change (preview for the confirm modal).
     * @type {boolean}
     * @memberof SetOrganizationAvailabilityDto
     */
    'dryRun'?: boolean;
}
/**
 *
 * @export
 * @interface SetOrganizationAvailabilityResponseDto
 */
export interface SetOrganizationAvailabilityResponseDto {
    /**
     * Professional ID
     * @type {string}
     * @memberof SetOrganizationAvailabilityResponseDto
     */
    'professionalId': string;
    /**
     * Organization ID
     * @type {string}
     * @memberof SetOrganizationAvailabilityResponseDto
     */
    'organizationId': string;
    /**
     * Array of availability slots
     * @type {Array<SetOrganizationAvailabilityResponseDtoAvailabilitySlotsInner>}
     * @memberof SetOrganizationAvailabilityResponseDto
     */
    'availabilitySlots'?: Array<SetOrganizationAvailabilityResponseDtoAvailabilitySlotsInner>;
    /**
     * Array of time off periods
     * @type {Array<SetOrganizationAvailabilityResponseDtoTimeOffInner>}
     * @memberof SetOrganizationAvailabilityResponseDto
     */
    'timeOff'?: Array<SetOrganizationAvailabilityResponseDtoTimeOffInner>;
    /**
     * Whether the availability is active
     * @type {boolean}
     * @memberof SetOrganizationAvailabilityResponseDto
     */
    'isActive': boolean;
    /**
     * Creation date
     * @type {string}
     * @memberof SetOrganizationAvailabilityResponseDto
     */
    'createdAt'?: string;
    /**
     * Last update date
     * @type {string}
     * @memberof SetOrganizationAvailabilityResponseDto
     */
    'updatedAt'?: string;
    /**
     * Wizyty kolidujące z nowym harmonogramem specjalisty (może być pusta tablica)
     * @type {Array<ConflictingVisitDto>}
     * @memberof SetOrganizationAvailabilityResponseDto
     */
    'conflictingVisits': Array<ConflictingVisitDto>;
}
/**
 *
 * @export
 * @interface SetOrganizationAvailabilityResponseDtoAvailabilitySlotsInner
 */
export interface SetOrganizationAvailabilityResponseDtoAvailabilitySlotsInner {
    /**
     *
     * @type {number}
     * @memberof SetOrganizationAvailabilityResponseDtoAvailabilitySlotsInner
     */
    'weekday'?: number;
    /**
     *
     * @type {string}
     * @memberof SetOrganizationAvailabilityResponseDtoAvailabilitySlotsInner
     */
    'start'?: string;
    /**
     *
     * @type {string}
     * @memberof SetOrganizationAvailabilityResponseDtoAvailabilitySlotsInner
     */
    'end'?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof SetOrganizationAvailabilityResponseDtoAvailabilitySlotsInner
     */
    'visitTypes'?: Array<string>;
}
/**
 *
 * @export
 * @interface SetOrganizationAvailabilityResponseDtoTimeOffInner
 */
export interface SetOrganizationAvailabilityResponseDtoTimeOffInner {
    /**
     *
     * @type {string}
     * @memberof SetOrganizationAvailabilityResponseDtoTimeOffInner
     */
    'startDate'?: string;
    /**
     *
     * @type {string}
     * @memberof SetOrganizationAvailabilityResponseDtoTimeOffInner
     */
    'endDate'?: string;
    /**
     *
     * @type {string}
     * @memberof SetOrganizationAvailabilityResponseDtoTimeOffInner
     */
    'id'?: string;
}
/**
 *
 * @export
 * @interface SetOrganizationPublishedDto
 */
export interface SetOrganizationPublishedDto {
    /**
     * Whether the organization should be published (visible in search)
     * @type {boolean}
     * @memberof SetOrganizationPublishedDto
     */
    'isPublished': boolean;
}
/**
 *
 * @export
 * @interface SetOrganizationServiceBookingPolicyDto
 */
export interface SetOrganizationServiceBookingPolicyDto {
    /**
     * Derived from visit type and prepayment. Legacy input is accepted for compatibility but cannot override the derived policy.
     * @type {string}
     * @memberof SetOrganizationServiceBookingPolicyDto
     */
    'paymentTiming': SetOrganizationServiceBookingPolicyDtoPaymentTimingEnum;
    /**
     * Organization approval is always AUTO_CONFIRM. Legacy input cannot override it.
     * @type {string}
     * @memberof SetOrganizationServiceBookingPolicyDto
     */
    'confirmationPolicy': SetOrganizationServiceBookingPolicyDtoConfirmationPolicyEnum;
}

export const SetOrganizationServiceBookingPolicyDtoPaymentTimingEnum = {
    AtFacility: 'AT_FACILITY',
    OnlineRequired: 'ONLINE_REQUIRED'
} as const;

export type SetOrganizationServiceBookingPolicyDtoPaymentTimingEnum = typeof SetOrganizationServiceBookingPolicyDtoPaymentTimingEnum[keyof typeof SetOrganizationServiceBookingPolicyDtoPaymentTimingEnum];
export const SetOrganizationServiceBookingPolicyDtoConfirmationPolicyEnum = {
    AutoConfirm: 'AUTO_CONFIRM',
    RequiresApproval: 'REQUIRES_APPROVAL'
} as const;

export type SetOrganizationServiceBookingPolicyDtoConfirmationPolicyEnum = typeof SetOrganizationServiceBookingPolicyDtoConfirmationPolicyEnum[keyof typeof SetOrganizationServiceBookingPolicyDtoConfirmationPolicyEnum];

/**
 *
 * @export
 * @interface SetOrganizationTimeOffDto
 */
export interface SetOrganizationTimeOffDto {
    /**
     * Array of time off periods for the professional in this organization
     * @type {Array<TimeOffDto>}
     * @memberof SetOrganizationTimeOffDto
     */
    'timeOff': Array<TimeOffDto>;
    /**
     * When true, only computes conflicting visits without persisting the time-off (preview for the confirm modal).
     * @type {boolean}
     * @memberof SetOrganizationTimeOffDto
     */
    'dryRun'?: boolean;
}
/**
 *
 * @export
 * @interface SetProfessionalConfigDto
 */
export interface SetProfessionalConfigDto {
    /**
     * Visit types enabled for this professional in this organization
     * @type {Array<string>}
     * @memberof SetProfessionalConfigDto
     */
    'enabledVisitTypes': Array<SetProfessionalConfigDtoEnabledVisitTypesEnum>;
    /**
     * Categories enabled for this professional in this organization
     * @type {Array<string>}
     * @memberof SetProfessionalConfigDto
     */
    'enabledCategories'?: Array<SetProfessionalConfigDtoEnabledCategoriesEnum>;
    /**
     * Visit type and category configurations
     * @type {Array<VisitTypeCategoryConfigDto>}
     * @memberof SetProfessionalConfigDto
     */
    'visitTypeCategoryConfigs'?: Array<VisitTypeCategoryConfigDto>;
    /**
     * Service configurations for this professional
     * @type {Array<ServiceConfigDto>}
     * @memberof SetProfessionalConfigDto
     */
    'serviceConfigs': Array<ServiceConfigDto>;
    /**
     * Professional description for this organization
     * @type {string}
     * @memberof SetProfessionalConfigDto
     */
    'description'?: string;
    /**
     * Array of specialization IDs
     * @type {Array<string>}
     * @memberof SetProfessionalConfigDto
     */
    'specializations'?: Array<string>;
}

export const SetProfessionalConfigDtoEnabledVisitTypesEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type SetProfessionalConfigDtoEnabledVisitTypesEnum = typeof SetProfessionalConfigDtoEnabledVisitTypesEnum[keyof typeof SetProfessionalConfigDtoEnabledVisitTypesEnum];
export const SetProfessionalConfigDtoEnabledCategoriesEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type SetProfessionalConfigDtoEnabledCategoriesEnum = typeof SetProfessionalConfigDtoEnabledCategoriesEnum[keyof typeof SetProfessionalConfigDtoEnabledCategoriesEnum];

/**
 *
 * @export
 * @interface SetReceptionDesiredStateDto
 */
export interface SetReceptionDesiredStateDto {
    /**
     *
     * @type {string}
     * @memberof SetReceptionDesiredStateDto
     */
    'note'?: string | null;
    /**
     *
     * @type {boolean}
     * @memberof SetReceptionDesiredStateDto
     */
    'desiredEnabled': boolean;
    /**
     *
     * @type {number}
     * @memberof SetReceptionDesiredStateDto
     */
    'expectedRevision': number;
}
/**
 *
 * @export
 * @interface SetVoiceBookingServicePolicyDto
 */
export interface SetVoiceBookingServicePolicyDto {
    /**
     *
     * @type {number}
     * @memberof SetVoiceBookingServicePolicyDto
     */
    'expectedPolicyFence': number;
    /**
     *
     * @type {string}
     * @memberof SetVoiceBookingServicePolicyDto
     */
    'reason': SetVoiceBookingServicePolicyDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof SetVoiceBookingServicePolicyDto
     */
    'note'?: string | null;
    /**
     *
     * @type {VoiceBookingServicePolicyDto}
     * @memberof SetVoiceBookingServicePolicyDto
     */
    'policy': VoiceBookingServicePolicyDto;
}

export const SetVoiceBookingServicePolicyDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    ServicePolicyUpdate: 'SERVICE_POLICY_UPDATE'
} as const;

export type SetVoiceBookingServicePolicyDtoReasonEnum = typeof SetVoiceBookingServicePolicyDtoReasonEnum[keyof typeof SetVoiceBookingServicePolicyDtoReasonEnum];

/**
 *
 * @export
 * @interface SetWarehouseActivationDto
 */
export interface SetWarehouseActivationDto {
    /**
     *
     * @type {boolean}
     * @memberof SetWarehouseActivationDto
     */
    'enabled': boolean;
}
/**
 *
 * @export
 * @interface SignedVoiceSecurityTriggerReceiptDto
 */
export interface SignedVoiceSecurityTriggerReceiptDto {
    /**
     *
     * @type {string}
     * @memberof SignedVoiceSecurityTriggerReceiptDto
     */
    'schemaVersion': SignedVoiceSecurityTriggerReceiptDtoSchemaVersionEnum;
    /**
     *
     * @type {string}
     * @memberof SignedVoiceSecurityTriggerReceiptDto
     */
    'receiptId': string;
    /**
     *
     * @type {string}
     * @memberof SignedVoiceSecurityTriggerReceiptDto
     */
    'sourceKind': SignedVoiceSecurityTriggerReceiptDtoSourceKindEnum;
    /**
     *
     * @type {string}
     * @memberof SignedVoiceSecurityTriggerReceiptDto
     */
    'scopeKind': SignedVoiceSecurityTriggerReceiptDtoScopeKindEnum;
    /**
     *
     * @type {string}
     * @memberof SignedVoiceSecurityTriggerReceiptDto
     */
    'organizationId': string | null;
    /**
     *
     * @type {boolean}
     * @memberof SignedVoiceSecurityTriggerReceiptDto
     */
    'emergencyRouteCompromised': boolean;
    /**
     *
     * @type {string}
     * @memberof SignedVoiceSecurityTriggerReceiptDto
     */
    'issuedAt': string;
    /**
     *
     * @type {string}
     * @memberof SignedVoiceSecurityTriggerReceiptDto
     */
    'expiresAt': string;
    /**
     *
     * @type {string}
     * @memberof SignedVoiceSecurityTriggerReceiptDto
     */
    'keyVersion': string;
    /**
     *
     * @type {string}
     * @memberof SignedVoiceSecurityTriggerReceiptDto
     */
    'signature': string;
}

export const SignedVoiceSecurityTriggerReceiptDtoSchemaVersionEnum = {
    VoiceSecurityTriggerReceiptV1: 'voice-security-trigger-receipt.v1'
} as const;

export type SignedVoiceSecurityTriggerReceiptDtoSchemaVersionEnum = typeof SignedVoiceSecurityTriggerReceiptDtoSchemaVersionEnum[keyof typeof SignedVoiceSecurityTriggerReceiptDtoSchemaVersionEnum];
export const SignedVoiceSecurityTriggerReceiptDtoSourceKindEnum = {
    AbuseMonitor: 'ABUSE_MONITOR',
    ProviderSecurityMonitor: 'PROVIDER_SECURITY_MONITOR',
    PlatformSecurityMonitor: 'PLATFORM_SECURITY_MONITOR'
} as const;

export type SignedVoiceSecurityTriggerReceiptDtoSourceKindEnum = typeof SignedVoiceSecurityTriggerReceiptDtoSourceKindEnum[keyof typeof SignedVoiceSecurityTriggerReceiptDtoSourceKindEnum];
export const SignedVoiceSecurityTriggerReceiptDtoScopeKindEnum = {
    Global: 'GLOBAL',
    Organization: 'ORGANIZATION'
} as const;

export type SignedVoiceSecurityTriggerReceiptDtoScopeKindEnum = typeof SignedVoiceSecurityTriggerReceiptDtoScopeKindEnum[keyof typeof SignedVoiceSecurityTriggerReceiptDtoScopeKindEnum];

/**
 *
 * @export
 * @interface SpecializationControllerUpdateServiceFormsRequest
 */
export interface SpecializationControllerUpdateServiceFormsRequest {
    /**
     * Array of form IDs to associate with the service
     * @type {Array<string>}
     * @memberof SpecializationControllerUpdateServiceFormsRequest
     */
    'formIds': Array<string>;
}
/**
 *
 * @export
 * @interface SpecializationDto
 */
export interface SpecializationDto {
    /**
     * Specialization ID
     * @type {string}
     * @memberof SpecializationDto
     */
    'id': string;
    /**
     * Specialization name
     * @type {string}
     * @memberof SpecializationDto
     */
    'name': string;
}
/**
 *
 * @export
 * @interface StaffScheduleVisitDto
 */
export interface StaffScheduleVisitDto {
    /**
     * Whether staff has already confirmed the booking with the owner. False requests owner approval; organization approval is always automatic.
     * @type {boolean}
     * @memberof StaffScheduleVisitDto
     */
    'autoAccept'?: boolean;
    /**
     * When false, the visit is stored as a guest booking and no User/Profile is created. userId/profileId must not be set and the guest fields (firstName, lastName, breed, name) are required.
     * @type {boolean}
     * @memberof StaffScheduleVisitDto
     */
    'createAccount'?: boolean;
    /**
     * Pet owner\'s first name
     * @type {string}
     * @memberof StaffScheduleVisitDto
     */
    'firstName': string;
    /**
     * Pet owner\'s last name
     * @type {string}
     * @memberof StaffScheduleVisitDto
     */
    'lastName': string;
    /**
     * Pet owner\'s email address
     * @type {string}
     * @memberof StaffScheduleVisitDto
     */
    'email'?: string;
    /**
     * Pet owner\'s phone number
     * @type {string}
     * @memberof StaffScheduleVisitDto
     */
    'phoneNumber'?: string;
    /**
     * Pet\'s breed
     * @type {string}
     * @memberof StaffScheduleVisitDto
     */
    'breed'?: string;
    /**
     * Pet\'s category
     * @type {string}
     * @memberof StaffScheduleVisitDto
     */
    'petCategory'?: StaffScheduleVisitDtoPetCategoryEnum;
    /**
     * Pet\'s name
     * @type {string}
     * @memberof StaffScheduleVisitDto
     */
    'name'?: string;
    /**
     * Description of the problem/condition
     * @type {string}
     * @memberof StaffScheduleVisitDto
     */
    'description': string;
    /**
     * Optional list of document URLs/IDs
     * @type {Array<DocumentFileDto>}
     * @memberof StaffScheduleVisitDto
     */
    'documents'?: Array<DocumentFileDto>;
    /**
     * Start time of the visit in ISO 8601 format
     * @type {string}
     * @memberof StaffScheduleVisitDto
     */
    'startTime': string;
    /**
     * Category of the visit
     * @type {string}
     * @memberof StaffScheduleVisitDto
     */
    'category': StaffScheduleVisitDtoCategoryEnum;
    /**
     * Type of the visit
     * @type {string}
     * @memberof StaffScheduleVisitDto
     */
    'visitType'?: StaffScheduleVisitDtoVisitTypeEnum;
    /**
     * ID of the professional handling the visit
     * @type {string}
     * @memberof StaffScheduleVisitDto
     */
    'professionalId'?: string;
    /**
     * ID of existing user/pet owner
     * @type {string}
     * @memberof StaffScheduleVisitDto
     */
    'userId'?: string;
    /**
     * ID of existing profile/pet to schedule visit for
     * @type {string}
     * @memberof StaffScheduleVisitDto
     */
    'profileId'?: string;
    /**
     * ID of the selected service for this visit
     * @type {string}
     * @memberof StaffScheduleVisitDto
     */
    'serviceId'?: string;
    /**
     *
     * @type {StaffScheduleVisitDtoVisitAddress}
     * @memberof StaffScheduleVisitDto
     */
    'visitAddress'?: StaffScheduleVisitDtoVisitAddress;
}

export const StaffScheduleVisitDtoPetCategoryEnum = {
    Dog: 'dog',
    Cat: 'cat',
    Other: 'other'
} as const;

export type StaffScheduleVisitDtoPetCategoryEnum = typeof StaffScheduleVisitDtoPetCategoryEnum[keyof typeof StaffScheduleVisitDtoPetCategoryEnum];
export const StaffScheduleVisitDtoCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type StaffScheduleVisitDtoCategoryEnum = typeof StaffScheduleVisitDtoCategoryEnum[keyof typeof StaffScheduleVisitDtoCategoryEnum];
export const StaffScheduleVisitDtoVisitTypeEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type StaffScheduleVisitDtoVisitTypeEnum = typeof StaffScheduleVisitDtoVisitTypeEnum[keyof typeof StaffScheduleVisitDtoVisitTypeEnum];

/**
 * Address for mobile visits
 * @export
 * @interface StaffScheduleVisitDtoVisitAddress
 */
export interface StaffScheduleVisitDtoVisitAddress {
    /**
     * Street address for the mobile visit
     * @type {string}
     * @memberof StaffScheduleVisitDtoVisitAddress
     */
    'street': string;
    /**
     * City for the mobile visit
     * @type {string}
     * @memberof StaffScheduleVisitDtoVisitAddress
     */
    'city': string;
    /**
     * Zip code for the mobile visit
     * @type {string}
     * @memberof StaffScheduleVisitDtoVisitAddress
     */
    'zipCode': string;
}
/**
 *
 * @export
 * @interface StaffScheduleVisitResponseDto
 */
export interface StaffScheduleVisitResponseDto {
    /**
     * ID of the created visit
     * @type {string}
     * @memberof StaffScheduleVisitResponseDto
     */
    'visitId': string;
    /**
     * Whether a new user account was created
     * @type {boolean}
     * @memberof StaffScheduleVisitResponseDto
     */
    'newUserCreated': boolean;
    /**
     * Payment URL for user to complete payment before approving visit
     * @type {string}
     * @memberof StaffScheduleVisitResponseDto
     */
    'paymentUrl'?: string;
    /**
     * Whether the visit requires payment before approval
     * @type {boolean}
     * @memberof StaffScheduleVisitResponseDto
     */
    'requiresPayment': boolean;
}
/**
 *
 * @export
 * @interface StartDictationResponseDto
 */
export interface StartDictationResponseDto {
    /**
     *
     * @type {string}
     * @memberof StartDictationResponseDto
     */
    'sessionId': string;
    /**
     *
     * @type {string}
     * @memberof StartDictationResponseDto
     */
    'socketUrl': string;
    /**
     *
     * @type {string}
     * @memberof StartDictationResponseDto
     */
    'token': string;
    /**
     *
     * @type {string}
     * @memberof StartDictationResponseDto
     */
    'expiresAt': string;
}
/**
 *
 * @export
 * @interface StartVisitTranscriptionDto
 */
export interface StartVisitTranscriptionDto {
    /**
     *
     * @type {boolean}
     * @memberof StartVisitTranscriptionDto
     */
    'consentConfirmed': boolean;
}
/**
 *
 * @export
 * @interface StartVisitTranscriptionResponseDto
 */
export interface StartVisitTranscriptionResponseDto {
    /**
     *
     * @type {string}
     * @memberof StartVisitTranscriptionResponseDto
     */
    'sessionId': string;
    /**
     *
     * @type {string}
     * @memberof StartVisitTranscriptionResponseDto
     */
    'socketUrl': string;
    /**
     *
     * @type {string}
     * @memberof StartVisitTranscriptionResponseDto
     */
    'token': string;
    /**
     *
     * @type {string}
     * @memberof StartVisitTranscriptionResponseDto
     */
    'tokenExpiresAt': string;
    /**
     *
     * @type {VisitTranscriptionDto}
     * @memberof StartVisitTranscriptionResponseDto
     */
    'transcription': VisitTranscriptionDto;
}
/**
 *
 * @export
 * @interface StatisticsCountsDto
 */
export interface StatisticsCountsDto {
    /**
     *
     * @type {number}
     * @memberof StatisticsCountsDto
     */
    'total': number;
    /**
     *
     * @type {number}
     * @memberof StatisticsCountsDto
     */
    'completed': number;
    /**
     *
     * @type {number}
     * @memberof StatisticsCountsDto
     */
    'cancelled': number;
    /**
     *
     * @type {number}
     * @memberof StatisticsCountsDto
     */
    'other': number;
}
/**
 *
 * @export
 * @interface StatisticsDataQualityDto
 */
export interface StatisticsDataQualityDto {
    /**
     *
     * @type {number}
     * @memberof StatisticsDataQualityDto
     */
    'unknownStatusVisits': number;
    /**
     *
     * @type {number}
     * @memberof StatisticsDataQualityDto
     */
    'missingServiceVisits': number;
    /**
     *
     * @type {number}
     * @memberof StatisticsDataQualityDto
     */
    'missingSpecialistVisits': number;
}
/**
 *
 * @export
 * @interface StatisticsHeatmapCellDto
 */
export interface StatisticsHeatmapCellDto {
    /**
     *
     * @type {number}
     * @memberof StatisticsHeatmapCellDto
     */
    'weekday': number;
    /**
     *
     * @type {number}
     * @memberof StatisticsHeatmapCellDto
     */
    'hour': number;
    /**
     *
     * @type {number}
     * @memberof StatisticsHeatmapCellDto
     */
    'count': number;
}
/**
 *
 * @export
 * @interface StatisticsIntervalDto
 */
export interface StatisticsIntervalDto {
    /**
     *
     * @type {string}
     * @memberof StatisticsIntervalDto
     */
    'start': string;
    /**
     *
     * @type {string}
     * @memberof StatisticsIntervalDto
     */
    'end': string;
    /**
     *
     * @type {string}
     * @memberof StatisticsIntervalDto
     */
    'localStartDate': string;
    /**
     *
     * @type {string}
     * @memberof StatisticsIntervalDto
     */
    'localEndDate': string;
    /**
     *
     * @type {boolean}
     * @memberof StatisticsIntervalDto
     */
    'isPartial': boolean;
}
/**
 *
 * @export
 * @interface StatisticsPatientsDto
 */
export interface StatisticsPatientsDto {
    /**
     *
     * @type {number}
     * @memberof StatisticsPatientsDto
     */
    'identified': number;
    /**
     *
     * @type {number}
     * @memberof StatisticsPatientsDto
     */
    'new': number;
    /**
     *
     * @type {number}
     * @memberof StatisticsPatientsDto
     */
    'returning': number;
    /**
     *
     * @type {number}
     * @memberof StatisticsPatientsDto
     */
    'unlinkedCompletedVisits': number;
}
/**
 *
 * @export
 * @interface StatisticsPointDto
 */
export interface StatisticsPointDto {
    /**
     *
     * @type {string}
     * @memberof StatisticsPointDto
     */
    'startDate': string;
    /**
     *
     * @type {string}
     * @memberof StatisticsPointDto
     */
    'endDate': string;
    /**
     *
     * @type {number}
     * @memberof StatisticsPointDto
     */
    'count': number;
    /**
     *
     * @type {boolean}
     * @memberof StatisticsPointDto
     */
    'isPartial': boolean;
}
/**
 *
 * @export
 * @interface StatisticsServiceDto
 */
export interface StatisticsServiceDto {
    /**
     *
     * @type {string}
     * @memberof StatisticsServiceDto
     */
    'serviceId'?: string | null;
    /**
     *
     * @type {string}
     * @memberof StatisticsServiceDto
     */
    'name': string;
    /**
     *
     * @type {number}
     * @memberof StatisticsServiceDto
     */
    'count': number;
    /**
     *
     * @type {boolean}
     * @memberof StatisticsServiceDto
     */
    'missingReference': boolean;
}
/**
 *
 * @export
 * @interface StatisticsSpecialistDto
 */
export interface StatisticsSpecialistDto {
    /**
     *
     * @type {number}
     * @memberof StatisticsSpecialistDto
     */
    'total': number;
    /**
     *
     * @type {number}
     * @memberof StatisticsSpecialistDto
     */
    'completed': number;
    /**
     *
     * @type {number}
     * @memberof StatisticsSpecialistDto
     */
    'cancelled': number;
    /**
     *
     * @type {number}
     * @memberof StatisticsSpecialistDto
     */
    'other': number;
    /**
     *
     * @type {string}
     * @memberof StatisticsSpecialistDto
     */
    'professionalId'?: string | null;
    /**
     *
     * @type {string}
     * @memberof StatisticsSpecialistDto
     */
    'name': string;
    /**
     *
     * @type {boolean}
     * @memberof StatisticsSpecialistDto
     */
    'missingReference': boolean;
    /**
     * Profile photo URL of the specialist
     * @type {string}
     * @memberof StatisticsSpecialistDto
     */
    'avatar'?: string;
}
/**
 *
 * @export
 * @interface StatisticsStatusDto
 */
export interface StatisticsStatusDto {
    /**
     *
     * @type {string}
     * @memberof StatisticsStatusDto
     */
    'status': string;
    /**
     *
     * @type {number}
     * @memberof StatisticsStatusDto
     */
    'count': number;
}
/**
 *
 * @export
 * @interface StockWarningDto
 */
export interface StockWarningDto {
    /**
     *
     * @type {string}
     * @memberof StockWarningDto
     */
    'productId': string;
    /**
     *
     * @type {string}
     * @memberof StockWarningDto
     */
    'productName': string;
    /**
     * Thousandths of a Unit that were not on stock
     * @type {number}
     * @memberof StockWarningDto
     */
    'shortfallMilli': number;
}
/**
 *
 * @export
 * @interface StopVisitTranscriptionDto
 */
export interface StopVisitTranscriptionDto {
    /**
     *
     * @type {string}
     * @memberof StopVisitTranscriptionDto
     */
    'sessionId': string;
    /**
     *
     * @type {string}
     * @memberof StopVisitTranscriptionDto
     */
    'errorMessage'?: string;
}
/**
 *
 * @export
 * @interface SubmitVoicePilotFacilityQaReviewDto
 */
export interface SubmitVoicePilotFacilityQaReviewDto {
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotFacilityQaReviewDto
     */
    'sampleEvidenceDigest': string;
    /**
     *
     * @type {number}
     * @memberof SubmitVoicePilotFacilityQaReviewDto
     */
    'rubricVersion': SubmitVoicePilotFacilityQaReviewDtoRubricVersionEnum;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotFacilityQaReviewDto
     */
    'disclosure': SubmitVoicePilotFacilityQaReviewDtoDisclosureEnum;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotFacilityQaReviewDto
     */
    'grounding': SubmitVoicePilotFacilityQaReviewDtoGroundingEnum;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotFacilityQaReviewDto
     */
    'safety': SubmitVoicePilotFacilityQaReviewDtoSafetyEnum;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotFacilityQaReviewDto
     */
    'taskOutcome': SubmitVoicePilotFacilityQaReviewDtoTaskOutcomeEnum;
}

export const SubmitVoicePilotFacilityQaReviewDtoRubricVersionEnum = {
    NUMBER_1: 1
} as const;

export type SubmitVoicePilotFacilityQaReviewDtoRubricVersionEnum = typeof SubmitVoicePilotFacilityQaReviewDtoRubricVersionEnum[keyof typeof SubmitVoicePilotFacilityQaReviewDtoRubricVersionEnum];
export const SubmitVoicePilotFacilityQaReviewDtoDisclosureEnum = {
    Pass: 'PASS',
    Fail: 'FAIL',
    NotAssessed: 'NOT_ASSESSED'
} as const;

export type SubmitVoicePilotFacilityQaReviewDtoDisclosureEnum = typeof SubmitVoicePilotFacilityQaReviewDtoDisclosureEnum[keyof typeof SubmitVoicePilotFacilityQaReviewDtoDisclosureEnum];
export const SubmitVoicePilotFacilityQaReviewDtoGroundingEnum = {
    Pass: 'PASS',
    Fail: 'FAIL',
    NotAssessed: 'NOT_ASSESSED'
} as const;

export type SubmitVoicePilotFacilityQaReviewDtoGroundingEnum = typeof SubmitVoicePilotFacilityQaReviewDtoGroundingEnum[keyof typeof SubmitVoicePilotFacilityQaReviewDtoGroundingEnum];
export const SubmitVoicePilotFacilityQaReviewDtoSafetyEnum = {
    Pass: 'PASS',
    Fail: 'FAIL',
    NotAssessed: 'NOT_ASSESSED'
} as const;

export type SubmitVoicePilotFacilityQaReviewDtoSafetyEnum = typeof SubmitVoicePilotFacilityQaReviewDtoSafetyEnum[keyof typeof SubmitVoicePilotFacilityQaReviewDtoSafetyEnum];
export const SubmitVoicePilotFacilityQaReviewDtoTaskOutcomeEnum = {
    Resolved: 'RESOLVED',
    Handoff: 'HANDOFF',
    Unresolved: 'UNRESOLVED',
    NotAssessed: 'NOT_ASSESSED'
} as const;

export type SubmitVoicePilotFacilityQaReviewDtoTaskOutcomeEnum = typeof SubmitVoicePilotFacilityQaReviewDtoTaskOutcomeEnum[keyof typeof SubmitVoicePilotFacilityQaReviewDtoTaskOutcomeEnum];

/**
 *
 * @export
 * @interface SubmitVoicePilotProductionOperationsPartDto
 */
export interface SubmitVoicePilotProductionOperationsPartDto {
    /**
     *
     * @type {number}
     * @memberof SubmitVoicePilotProductionOperationsPartDto
     */
    'schemaVersion': SubmitVoicePilotProductionOperationsPartDtoSchemaVersionEnum;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotProductionOperationsPartDto
     */
    'sourceExecutionReference': string;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotProductionOperationsPartDto
     */
    'sourceBundleDigest': string;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotProductionOperationsPartDto
     */
    'windowStartedAt': string;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotProductionOperationsPartDto
     */
    'windowEndedAt': string;
    /**
     *
     * @type {boolean}
     * @memberof SubmitVoicePilotProductionOperationsPartDto
     */
    'complete': boolean;
    /**
     *
     * @type {Array<VoicePilotProductionSessionClassificationDto>}
     * @memberof SubmitVoicePilotProductionOperationsPartDto
     */
    'sessionClassifications': Array<VoicePilotProductionSessionClassificationDto>;
    /**
     *
     * @type {VoicePilotProductionProviderCostDto}
     * @memberof SubmitVoicePilotProductionOperationsPartDto
     */
    'providerCost': VoicePilotProductionProviderCostDto;
}

export const SubmitVoicePilotProductionOperationsPartDtoSchemaVersionEnum = {
    NUMBER_1: 1
} as const;

export type SubmitVoicePilotProductionOperationsPartDtoSchemaVersionEnum = typeof SubmitVoicePilotProductionOperationsPartDtoSchemaVersionEnum[keyof typeof SubmitVoicePilotProductionOperationsPartDtoSchemaVersionEnum];

/**
 *
 * @export
 * @interface SubmitVoicePilotProductionPrivacyPartDto
 */
export interface SubmitVoicePilotProductionPrivacyPartDto {
    /**
     *
     * @type {number}
     * @memberof SubmitVoicePilotProductionPrivacyPartDto
     */
    'schemaVersion': SubmitVoicePilotProductionPrivacyPartDtoSchemaVersionEnum;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotProductionPrivacyPartDto
     */
    'sourceExecutionReference': string;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotProductionPrivacyPartDto
     */
    'sourceBundleDigest': string;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotProductionPrivacyPartDto
     */
    'windowStartedAt': string;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotProductionPrivacyPartDto
     */
    'windowEndedAt': string;
    /**
     *
     * @type {boolean}
     * @memberof SubmitVoicePilotProductionPrivacyPartDto
     */
    'completeCoverage': boolean;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotProductionPrivacyPartDto
     */
    'proofBundleDigest': string;
    /**
     *
     * @type {number}
     * @memberof SubmitVoicePilotProductionPrivacyPartDto
     */
    'crossOrganizationData': number;
    /**
     *
     * @type {number}
     * @memberof SubmitVoicePilotProductionPrivacyPartDto
     */
    'retainedCallAudio': number;
    /**
     *
     * @type {number}
     * @memberof SubmitVoicePilotProductionPrivacyPartDto
     */
    'piiInLogs': number;
    /**
     *
     * @type {Array<VoicePilotProductionPrivacyProofSourceDto>}
     * @memberof SubmitVoicePilotProductionPrivacyPartDto
     */
    'proofSources': Array<VoicePilotProductionPrivacyProofSourceDto>;
}

export const SubmitVoicePilotProductionPrivacyPartDtoSchemaVersionEnum = {
    NUMBER_1: 1
} as const;

export type SubmitVoicePilotProductionPrivacyPartDtoSchemaVersionEnum = typeof SubmitVoicePilotProductionPrivacyPartDtoSchemaVersionEnum[keyof typeof SubmitVoicePilotProductionPrivacyPartDtoSchemaVersionEnum];

/**
 *
 * @export
 * @interface SubmitVoicePilotProductionSafetyPartDto
 */
export interface SubmitVoicePilotProductionSafetyPartDto {
    /**
     *
     * @type {number}
     * @memberof SubmitVoicePilotProductionSafetyPartDto
     */
    'schemaVersion': SubmitVoicePilotProductionSafetyPartDtoSchemaVersionEnum;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotProductionSafetyPartDto
     */
    'sourceExecutionReference': string;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotProductionSafetyPartDto
     */
    'sourceBundleDigest': string;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotProductionSafetyPartDto
     */
    'windowStartedAt': string;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotProductionSafetyPartDto
     */
    'windowEndedAt': string;
    /**
     *
     * @type {boolean}
     * @memberof SubmitVoicePilotProductionSafetyPartDto
     */
    'completeCoverage': boolean;
    /**
     *
     * @type {string}
     * @memberof SubmitVoicePilotProductionSafetyPartDto
     */
    'proofBundleDigest': string;
    /**
     *
     * @type {number}
     * @memberof SubmitVoicePilotProductionSafetyPartDto
     */
    'missingDisclosure': number;
    /**
     *
     * @type {number}
     * @memberof SubmitVoicePilotProductionSafetyPartDto
     */
    'unauthorizedVisitAction': number;
    /**
     *
     * @type {number}
     * @memberof SubmitVoicePilotProductionSafetyPartDto
     */
    'falseConfirmation': number;
    /**
     *
     * @type {number}
     * @memberof SubmitVoicePilotProductionSafetyPartDto
     */
    'ordinaryWorkAfterEmergencyLatch': number;
    /**
     *
     * @type {Array<VoicePilotProductionSafetyProofSourceDto>}
     * @memberof SubmitVoicePilotProductionSafetyPartDto
     */
    'proofSources': Array<VoicePilotProductionSafetyProofSourceDto>;
}

export const SubmitVoicePilotProductionSafetyPartDtoSchemaVersionEnum = {
    NUMBER_1: 1
} as const;

export type SubmitVoicePilotProductionSafetyPartDtoSchemaVersionEnum = typeof SubmitVoicePilotProductionSafetyPartDtoSchemaVersionEnum[keyof typeof SubmitVoicePilotProductionSafetyPartDtoSchemaVersionEnum];

/**
 *
 * @export
 * @interface SuggestionContentDto
 */
export interface SuggestionContentDto {
    /**
     * List of action items
     * @type {Array<ActionItemDto>}
     * @memberof SuggestionContentDto
     */
    'actionItems': Array<ActionItemDto>;
    /**
     * List of recommendations
     * @type {Array<RecommendationDto>}
     * @memberof SuggestionContentDto
     */
    'recommendations': Array<RecommendationDto>;
}
/**
 *
 * @export
 * @interface TimeOffDto
 */
export interface TimeOffDto {
    /**
     * ISO date string for the start date of time off
     * @type {string}
     * @memberof TimeOffDto
     */
    'startDate': string;
    /**
     * ISO date string for the end date of time off
     * @type {string}
     * @memberof TimeOffDto
     */
    'endDate': string;
    /**
     * Optional start time in HH:MM format for time-specific unavailability
     * @type {string}
     * @memberof TimeOffDto
     */
    'startTime'?: string;
    /**
     * Optional end time in HH:MM format for time-specific unavailability
     * @type {string}
     * @memberof TimeOffDto
     */
    'endTime'?: string;
}
/**
 *
 * @export
 * @interface TopUpVoiceAllowanceDto
 */
export interface TopUpVoiceAllowanceDto {
    /**
     * Kontrolowany powód operacji na sterowaniu przyjęciem Voice
     * @type {string}
     * @memberof TopUpVoiceAllowanceDto
     */
    'reason': string;
    /**
     * Opcjonalna notatka operacyjna bez danych osobowych
     * @type {string}
     * @memberof TopUpVoiceAllowanceDto
     */
    'note'?: string;
    /**
     * Dodatkowy przydział bieżącego miesiąca w milisekundach
     * @type {number}
     * @memberof TopUpVoiceAllowanceDto
     */
    'amountMs': number;
}
/**
 *
 * @export
 * @interface TranscriptSupportGrantQueueItemResponseDto
 */
export interface TranscriptSupportGrantQueueItemResponseDto {
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantQueueItemResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantQueueItemResponseDto
     */
    'status': TranscriptSupportGrantQueueItemResponseDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantQueueItemResponseDto
     */
    'reason': TranscriptSupportGrantQueueItemResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantQueueItemResponseDto
     */
    'requestedAt': string;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantQueueItemResponseDto
     */
    'activeUntil': string | null;
}

export const TranscriptSupportGrantQueueItemResponseDtoStatusEnum = {
    Requested: 'REQUESTED',
    Active: 'ACTIVE',
    Denied: 'DENIED',
    Revoked: 'REVOKED',
    Consumed: 'CONSUMED',
    Expired: 'EXPIRED'
} as const;

export type TranscriptSupportGrantQueueItemResponseDtoStatusEnum = typeof TranscriptSupportGrantQueueItemResponseDtoStatusEnum[keyof typeof TranscriptSupportGrantQueueItemResponseDtoStatusEnum];
export const TranscriptSupportGrantQueueItemResponseDtoReasonEnum = {
    ReceptionBehaviorDiagnosis: 'RECEPTION_BEHAVIOR_DIAGNOSIS',
    PrivacyIncidentInvestigation: 'PRIVACY_INCIDENT_INVESTIGATION',
    AccessControlVerification: 'ACCESS_CONTROL_VERIFICATION'
} as const;

export type TranscriptSupportGrantQueueItemResponseDtoReasonEnum = typeof TranscriptSupportGrantQueueItemResponseDtoReasonEnum[keyof typeof TranscriptSupportGrantQueueItemResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface TranscriptSupportGrantResponseDto
 */
export interface TranscriptSupportGrantResponseDto {
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'subjectUserId': string;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'surface': TranscriptSupportGrantResponseDtoSurfaceEnum;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'status': TranscriptSupportGrantResponseDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'supportSessionId': string;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'ticketReference': string;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'reason': TranscriptSupportGrantResponseDtoReasonEnum;
    /**
     *
     * @type {number}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'requestedMinutes': number;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'requestedAt': string;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'requestExpiresAt': string;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'approvedByUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'approvedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'activeUntil': string | null;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'deniedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'revokedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof TranscriptSupportGrantResponseDto
     */
    'consumedAt': string | null;
}

export const TranscriptSupportGrantResponseDtoSurfaceEnum = {
    ReceptionTranscript: 'RECEPTION_TRANSCRIPT'
} as const;

export type TranscriptSupportGrantResponseDtoSurfaceEnum = typeof TranscriptSupportGrantResponseDtoSurfaceEnum[keyof typeof TranscriptSupportGrantResponseDtoSurfaceEnum];
export const TranscriptSupportGrantResponseDtoStatusEnum = {
    Requested: 'REQUESTED',
    Active: 'ACTIVE',
    Denied: 'DENIED',
    Revoked: 'REVOKED',
    Consumed: 'CONSUMED',
    Expired: 'EXPIRED'
} as const;

export type TranscriptSupportGrantResponseDtoStatusEnum = typeof TranscriptSupportGrantResponseDtoStatusEnum[keyof typeof TranscriptSupportGrantResponseDtoStatusEnum];
export const TranscriptSupportGrantResponseDtoReasonEnum = {
    ReceptionBehaviorDiagnosis: 'RECEPTION_BEHAVIOR_DIAGNOSIS',
    PrivacyIncidentInvestigation: 'PRIVACY_INCIDENT_INVESTIGATION',
    AccessControlVerification: 'ACCESS_CONTROL_VERIFICATION'
} as const;

export type TranscriptSupportGrantResponseDtoReasonEnum = typeof TranscriptSupportGrantResponseDtoReasonEnum[keyof typeof TranscriptSupportGrantResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface TreatmentMaterialInputDto
 */
export interface TreatmentMaterialInputDto {
    /**
     * Existing line id when editing a Performed Treatment; omit for a new line. Ids must not repeat.
     * @type {string}
     * @memberof TreatmentMaterialInputDto
     */
    'id'?: string;
    /**
     * Warehouse Product (NON_DRUG) id
     * @type {string}
     * @memberof TreatmentMaterialInputDto
     */
    'productId': string;
    /**
     *
     * @type {number}
     * @memberof TreatmentMaterialInputDto
     */
    'quantity': number;
    /**
     *
     * @type {WarehouseQuantityMeasure}
     * @memberof TreatmentMaterialInputDto
     */
    'measure': WarehouseQuantityMeasure;
}


/**
 *
 * @export
 * @interface UpdateAdUrlDto
 */
export interface UpdateAdUrlDto {
    /**
     * Nowy URL docelowy reklamy
     * @type {string}
     * @memberof UpdateAdUrlDto
     */
    'url': string;
}
/**
 *
 * @export
 * @interface UpdateAvailabilityDto
 */
export interface UpdateAvailabilityDto {
    /**
     * Array of availability slots
     * @type {Array<AvailabilitySlotDto>}
     * @memberof UpdateAvailabilityDto
     */
    'availabilitySlots': Array<AvailabilitySlotDto>;
}
/**
 *
 * @export
 * @interface UpdateCampaignBudgetDto
 */
export interface UpdateCampaignBudgetDto {
    /**
     * Daily budget in PLN (zł)
     * @type {number}
     * @memberof UpdateCampaignBudgetDto
     */
    'dailyBudget': number;
    /**
     * Campaign start date
     * @type {string}
     * @memberof UpdateCampaignBudgetDto
     */
    'startDate': string;
    /**
     * Campaign end date
     * @type {string}
     * @memberof UpdateCampaignBudgetDto
     */
    'endDate': string;
}
/**
 *
 * @export
 * @interface UpdateCampaignDto
 */
export interface UpdateCampaignDto {
    /**
     * Campaign name
     * @type {string}
     * @memberof UpdateCampaignDto
     */
    'name'?: string;
    /**
     * Campaign description
     * @type {string}
     * @memberof UpdateCampaignDto
     */
    'description'?: string;
    /**
     * Campaign keywords
     * @type {Array<string>}
     * @memberof UpdateCampaignDto
     */
    'keywords'?: Array<string>;
    /**
     * Target locations
     * @type {Array<string>}
     * @memberof UpdateCampaignDto
     */
    'targetLocations'?: Array<string>;
    /**
     * Bidding strategy
     * @type {string}
     * @memberof UpdateCampaignDto
     */
    'biddingStrategy'?: UpdateCampaignDtoBiddingStrategyEnum;
}

export const UpdateCampaignDtoBiddingStrategyEnum = {
    TargetSpend: 'TARGET_SPEND',
    MaximizeConversions: 'MAXIMIZE_CONVERSIONS',
    ManualCpc: 'MANUAL_CPC',
    TargetCpa: 'TARGET_CPA',
    TargetRoas: 'TARGET_ROAS'
} as const;

export type UpdateCampaignDtoBiddingStrategyEnum = typeof UpdateCampaignDtoBiddingStrategyEnum[keyof typeof UpdateCampaignDtoBiddingStrategyEnum];

/**
 *
 * @export
 * @interface UpdateEnabledCategoriesDto
 */
export interface UpdateEnabledCategoriesDto {
    /**
     * Array of categories enabled for professionals in this organization
     * @type {Array<string>}
     * @memberof UpdateEnabledCategoriesDto
     */
    'enabledCategories': Array<UpdateEnabledCategoriesDtoEnabledCategoriesEnum>;
}

export const UpdateEnabledCategoriesDtoEnabledCategoriesEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type UpdateEnabledCategoriesDtoEnabledCategoriesEnum = typeof UpdateEnabledCategoriesDtoEnabledCategoriesEnum[keyof typeof UpdateEnabledCategoriesDtoEnabledCategoriesEnum];

/**
 *
 * @export
 * @interface UpdateEnabledVisitTypesDto
 */
export interface UpdateEnabledVisitTypesDto {
    /**
     * Array of visit types enabled for professionals in this organization
     * @type {Array<string>}
     * @memberof UpdateEnabledVisitTypesDto
     */
    'enabledVisitTypes': Array<UpdateEnabledVisitTypesDtoEnabledVisitTypesEnum>;
}

export const UpdateEnabledVisitTypesDtoEnabledVisitTypesEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type UpdateEnabledVisitTypesDtoEnabledVisitTypesEnum = typeof UpdateEnabledVisitTypesDtoEnabledVisitTypesEnum[keyof typeof UpdateEnabledVisitTypesDtoEnabledVisitTypesEnum];

/**
 *
 * @export
 * @interface UpdateFacilityMedicationDto
 */
export interface UpdateFacilityMedicationDto {
    /**
     * Strength value
     * @type {number}
     * @memberof UpdateFacilityMedicationDto
     */
    'strengthValue'?: number;
    /**
     *
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'strengthUnit'?: UpdateFacilityMedicationDtoStrengthUnitEnum;
    /**
     * Required when strengthUnit is OTHER
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'strengthUnitCustom'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'form'?: UpdateFacilityMedicationDtoFormEnum;
    /**
     * Required when form is OTHER
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'formCustom'?: string;
    /**
     * Amount given per administration, e.g. half a tablet
     * @type {number}
     * @memberof UpdateFacilityMedicationDto
     */
    'quantityValue'?: number;
    /**
     *
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'quantityCustom'?: string;
    /**
     * Recorded before the dose is known, e.g. pending a weigh-in
     * @type {boolean}
     * @memberof UpdateFacilityMedicationDto
     */
    'dosagePending'?: boolean;
    /**
     *
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'frequencyType'?: UpdateFacilityMedicationDtoFrequencyTypeEnum;
    /**
     *
     * @type {number}
     * @memberof UpdateFacilityMedicationDto
     */
    'frequencyValue'?: number;
    /**
     * Required when frequencyType is OTHER
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'frequencyCustom'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'durationType'?: UpdateFacilityMedicationDtoDurationTypeEnum;
    /**
     *
     * @type {number}
     * @memberof UpdateFacilityMedicationDto
     */
    'durationValue'?: number;
    /**
     * Required when durationType is OTHER
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'durationCustom'?: string;
    /**
     * Dosing that changes over the course, e.g. a steroid taper
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'dosageSchedule'?: string;
    /**
     * What the medication is for
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'indication'?: string;
    /**
     *
     * @type {boolean}
     * @memberof UpdateFacilityMedicationDto
     */
    'adverseReaction'?: boolean;
    /**
     *
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'adverseReactionNote'?: string;
    /**
     * When the patient started taking it
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'startedAt'?: string;
    /**
     * Medicine product ID from the medicine database
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'medicineProductId'?: string;
    /**
     * Name of the medication (required if medicineProductId not provided)
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'name'?: string;
    /**
     * Preparation type
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'preparationType'?: string;
    /**
     * Dosage amount (deprecated — use quantityValue)
     * @type {number}
     * @memberof UpdateFacilityMedicationDto
     */
    'dosage'?: number;
    /**
     * Dosage interval (deprecated — use frequencyType)
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'dosageInterval'?: UpdateFacilityMedicationDtoDosageIntervalEnum;
    /**
     * Additional notes about the medication
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'notes'?: string;
    /**
     *
     * @type {boolean}
     * @memberof UpdateFacilityMedicationDto
     */
    'reminderEnabled'?: boolean;
    /**
     *
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'reminderDescription'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'reminderScheduledAt'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'reminderRecurrenceType'?: UpdateFacilityMedicationDtoReminderRecurrenceTypeEnum;
    /**
     *
     * @type {CustomRecurrenceDto}
     * @memberof UpdateFacilityMedicationDto
     */
    'reminderCustomRecurrence'?: CustomRecurrenceDto;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateFacilityMedicationDto
     */
    'reminderNotificationChannels'?: Array<UpdateFacilityMedicationDtoReminderNotificationChannelsEnum>;
    /**
     *
     * @type {UpdateFacilityMedicationDtoStock}
     * @memberof UpdateFacilityMedicationDto
     */
    'stock'?: UpdateFacilityMedicationDtoStock | null;
    /**
     * Client UUID v4, one per submit series (R3-4); a resend with the same key and body replays
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'operationKey'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateFacilityMedicationDto
     */
    'visitId'?: string;
}

export const UpdateFacilityMedicationDtoStrengthUnitEnum = {
    Mg: 'MG',
    G: 'G',
    Mcg: 'MCG',
    Ml: 'ML',
    Iu: 'IU',
    Percent: 'PERCENT',
    None: 'NONE',
    Other: 'OTHER'
} as const;

export type UpdateFacilityMedicationDtoStrengthUnitEnum = typeof UpdateFacilityMedicationDtoStrengthUnitEnum[keyof typeof UpdateFacilityMedicationDtoStrengthUnitEnum];
export const UpdateFacilityMedicationDtoFormEnum = {
    Tablet: 'TABLET',
    Capsule: 'CAPSULE',
    Sachet: 'SACHET',
    Suspension: 'SUSPENSION',
    Solution: 'SOLUTION',
    Drops: 'DROPS',
    Injection: 'INJECTION',
    Ointment: 'OINTMENT',
    SpotOn: 'SPOT_ON',
    Spray: 'SPRAY',
    Powder: 'POWDER',
    Paste: 'PASTE',
    Other: 'OTHER'
} as const;

export type UpdateFacilityMedicationDtoFormEnum = typeof UpdateFacilityMedicationDtoFormEnum[keyof typeof UpdateFacilityMedicationDtoFormEnum];
export const UpdateFacilityMedicationDtoFrequencyTypeEnum = {
    TimesPerDay: 'TIMES_PER_DAY',
    EveryNHours: 'EVERY_N_HOURS',
    EveryNDays: 'EVERY_N_DAYS',
    TimesPerWeek: 'TIMES_PER_WEEK',
    TimesPerMonth: 'TIMES_PER_MONTH',
    AsNeeded: 'AS_NEEDED',
    Other: 'OTHER'
} as const;

export type UpdateFacilityMedicationDtoFrequencyTypeEnum = typeof UpdateFacilityMedicationDtoFrequencyTypeEnum[keyof typeof UpdateFacilityMedicationDtoFrequencyTypeEnum];
export const UpdateFacilityMedicationDtoDurationTypeEnum = {
    UntilFurtherNotice: 'UNTIL_FURTHER_NOTICE',
    Days: 'DAYS',
    Weeks: 'WEEKS',
    UntilFollowUp: 'UNTIL_FOLLOW_UP',
    SingleDose: 'SINGLE_DOSE',
    Other: 'OTHER'
} as const;

export type UpdateFacilityMedicationDtoDurationTypeEnum = typeof UpdateFacilityMedicationDtoDurationTypeEnum[keyof typeof UpdateFacilityMedicationDtoDurationTypeEnum];
export const UpdateFacilityMedicationDtoDosageIntervalEnum = {
    Day: 'Day',
    Week: 'Week',
    Month: 'Month'
} as const;

export type UpdateFacilityMedicationDtoDosageIntervalEnum = typeof UpdateFacilityMedicationDtoDosageIntervalEnum[keyof typeof UpdateFacilityMedicationDtoDosageIntervalEnum];
export const UpdateFacilityMedicationDtoReminderRecurrenceTypeEnum = {
    Single: 'SINGLE',
    Daily: 'DAILY',
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
    Custom: 'CUSTOM'
} as const;

export type UpdateFacilityMedicationDtoReminderRecurrenceTypeEnum = typeof UpdateFacilityMedicationDtoReminderRecurrenceTypeEnum[keyof typeof UpdateFacilityMedicationDtoReminderRecurrenceTypeEnum];
export const UpdateFacilityMedicationDtoReminderNotificationChannelsEnum = {
    Email: 'EMAIL',
    Sms: 'SMS'
} as const;

export type UpdateFacilityMedicationDtoReminderNotificationChannelsEnum = typeof UpdateFacilityMedicationDtoReminderNotificationChannelsEnum[keyof typeof UpdateFacilityMedicationDtoReminderNotificationChannelsEnum];

/**
 * The clinic’s MANUAL issue: omitted leaves it as it is; null returns it to the Warehouse
 * @export
 * @interface UpdateFacilityMedicationDtoStock
 */
export interface UpdateFacilityMedicationDtoStock {
    /**
     * Warehouse Product (DRUG) id
     * @type {string}
     * @memberof UpdateFacilityMedicationDtoStock
     */
    'productId': string;
    /**
     * Quantity in the given measure, at most 3 decimals
     * @type {number}
     * @memberof UpdateFacilityMedicationDtoStock
     */
    'quantity': number;
    /**
     *
     * @type {WarehouseQuantityMeasure}
     * @memberof UpdateFacilityMedicationDtoStock
     */
    'measure': WarehouseQuantityMeasure;
    /**
     *
     * @type {WarehouseHandover}
     * @memberof UpdateFacilityMedicationDtoStock
     */
    'handover': WarehouseHandover;
    /**
     * Pinned Batch; omitted means FEFO
     * @type {string}
     * @memberof UpdateFacilityMedicationDtoStock
     */
    'batchId'?: string | null;
    /**
     * Handed-over Rx only: whether a prescription was issued (filled at the Facility)
     * @type {boolean}
     * @memberof UpdateFacilityMedicationDtoStock
     */
    'prescriptionIssued'?: boolean;
    /**
     * Handed-over only: who received the drug. Omitted or blank records the registered owner or the guest contact; with neither the write is 422 RECIPIENT_REQUIRED
     * @type {string}
     * @memberof UpdateFacilityMedicationDtoStock
     */
    'recipientName'?: string;
    /**
     * Handed-over only: the recipient\'s address. Omitted or blank records the registered owner\'s profile address when the owner received the drug; a handed-over Rx drug with no address is 422 RECIPIENT_ADDRESS_REQUIRED
     * @type {string}
     * @memberof UpdateFacilityMedicationDtoStock
     */
    'recipientAddress'?: string;
}


/**
 *
 * @export
 * @interface UpdateFactPreferencesDto
 */
export interface UpdateFactPreferencesDto {
    /**
     * User preferences for fact types
     * @type {Array<string>}
     * @memberof UpdateFactPreferencesDto
     */
    'preferences': Array<string>;
}
/**
 *
 * @export
 * @interface UpdateFormDto
 */
export interface UpdateFormDto {
    /**
     * Form name
     * @type {string}
     * @memberof UpdateFormDto
     */
    'name'?: string;
    /**
     * Form description
     * @type {string}
     * @memberof UpdateFormDto
     */
    'description'?: string;
    /**
     * Form fields
     * @type {Array<FormFieldDto>}
     * @memberof UpdateFormDto
     */
    'fields'?: Array<FormFieldDto>;
}
/**
 *
 * @export
 * @interface UpdateFormSubmissionDto
 */
export interface UpdateFormSubmissionDto {
    /**
     * Field responses
     * @type {Array<FieldResponseDto>}
     * @memberof UpdateFormSubmissionDto
     */
    'responses'?: Array<FieldResponseDto>;
    /**
     * Submission status
     * @type {string}
     * @memberof UpdateFormSubmissionDto
     */
    'status'?: UpdateFormSubmissionDtoStatusEnum;
}

export const UpdateFormSubmissionDtoStatusEnum = {
    Draft: 'draft',
    Submitted: 'submitted'
} as const;

export type UpdateFormSubmissionDtoStatusEnum = typeof UpdateFormSubmissionDtoStatusEnum[keyof typeof UpdateFormSubmissionDtoStatusEnum];

/**
 *
 * @export
 * @interface UpdateOrganizationDto
 */
export interface UpdateOrganizationDto {
    /**
     *
     * @type {Array<InitializeOrganizationServiceBookingPolicyDto>}
     * @memberof UpdateOrganizationDto
     */
    'bookingPolicies'?: Array<InitializeOrganizationServiceBookingPolicyDto>;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    'street'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    'zip'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    'city'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    'website'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    'description'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    'phoneNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    'email'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    'nip'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    'rating'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    'logoUrl'?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateOrganizationDto
     */
    'images'?: Array<string>;
    /**
     *
     * @type {boolean}
     * @memberof UpdateOrganizationDto
     */
    'isActive'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof UpdateOrganizationDto
     */
    'isPublished'?: boolean;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    'type'?: UpdateOrganizationDtoTypeEnum;
    /**
     *
     * @type {Array<AvailabilitySlotDto>}
     * @memberof UpdateOrganizationDto
     */
    'workingHours'?: Array<AvailabilitySlotDto>;
    /**
     *
     * @type {Array<TimeOffDto>}
     * @memberof UpdateOrganizationDto
     */
    'timeOff'?: Array<TimeOffDto>;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateOrganizationDto
     */
    'specializations'?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateOrganizationDto
     */
    'enabledServices'?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateOrganizationDto
     */
    'socialMedia'?: Array<string>;
}

export const UpdateOrganizationDtoTypeEnum = {
    VeterinaryFacility: 'VETERINARY_FACILITY'
} as const;

export type UpdateOrganizationDtoTypeEnum = typeof UpdateOrganizationDtoTypeEnum[keyof typeof UpdateOrganizationDtoTypeEnum];

/**
 *
 * @export
 * @interface UpdateOrganizationProfileDuringVisitDto
 */
export interface UpdateOrganizationProfileDuringVisitDto {
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationProfileDuringVisitDto
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationProfileDuringVisitDto
     */
    'dob'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationProfileDuringVisitDto
     */
    'breed'?: string;
    /**
     *
     * @type {number}
     * @memberof UpdateOrganizationProfileDuringVisitDto
     */
    'weight'?: number;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationProfileDuringVisitDto
     */
    'chipNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationProfileDuringVisitDto
     */
    'gender'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganizationProfileDuringVisitDto
     */
    'petCategory'?: UpdateOrganizationProfileDuringVisitDtoPetCategoryEnum;
}

export const UpdateOrganizationProfileDuringVisitDtoPetCategoryEnum = {
    Dog: 'dog',
    Cat: 'cat',
    Other: 'other'
} as const;

export type UpdateOrganizationProfileDuringVisitDtoPetCategoryEnum = typeof UpdateOrganizationProfileDuringVisitDtoPetCategoryEnum[keyof typeof UpdateOrganizationProfileDuringVisitDtoPetCategoryEnum];

/**
 *
 * @export
 * @interface UpdateProfessionalConfigDto
 */
export interface UpdateProfessionalConfigDto {
    /**
     * Visit types enabled for this professional in this organization
     * @type {Array<string>}
     * @memberof UpdateProfessionalConfigDto
     */
    'enabledVisitTypes'?: Array<UpdateProfessionalConfigDtoEnabledVisitTypesEnum>;
    /**
     * Categories enabled for this professional in this organization
     * @type {Array<string>}
     * @memberof UpdateProfessionalConfigDto
     */
    'enabledCategories'?: Array<UpdateProfessionalConfigDtoEnabledCategoriesEnum>;
}

export const UpdateProfessionalConfigDtoEnabledVisitTypesEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type UpdateProfessionalConfigDtoEnabledVisitTypesEnum = typeof UpdateProfessionalConfigDtoEnabledVisitTypesEnum[keyof typeof UpdateProfessionalConfigDtoEnabledVisitTypesEnum];
export const UpdateProfessionalConfigDtoEnabledCategoriesEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type UpdateProfessionalConfigDtoEnabledCategoriesEnum = typeof UpdateProfessionalConfigDtoEnabledCategoriesEnum[keyof typeof UpdateProfessionalConfigDtoEnabledCategoriesEnum];

/**
 *
 * @export
 * @interface UpdateProfileDto
 */
export interface UpdateProfileDto {
    /**
     *
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'avatar'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'background'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'dob'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'breed'?: string;
    /**
     *
     * @type {number}
     * @memberof UpdateProfileDto
     */
    'weight'?: number;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'chipNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'gender'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'petCategory'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'description'?: string;
    /**
     *
     * @type {Array<object>}
     * @memberof UpdateProfileDto
     */
    'medications'?: Array<object>;
}
/**
 *
 * @export
 * @interface UpdateProfileMedicationDto
 */
export interface UpdateProfileMedicationDto {
    /**
     * Strength value
     * @type {number}
     * @memberof UpdateProfileMedicationDto
     */
    'strengthValue'?: number;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'strengthUnit'?: UpdateProfileMedicationDtoStrengthUnitEnum;
    /**
     * Required when strengthUnit is OTHER
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'strengthUnitCustom'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'form'?: UpdateProfileMedicationDtoFormEnum;
    /**
     * Required when form is OTHER
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'formCustom'?: string;
    /**
     * Amount given per administration, e.g. half a tablet
     * @type {number}
     * @memberof UpdateProfileMedicationDto
     */
    'quantityValue'?: number;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'quantityCustom'?: string;
    /**
     * Recorded before the dose is known, e.g. pending a weigh-in
     * @type {boolean}
     * @memberof UpdateProfileMedicationDto
     */
    'dosagePending'?: boolean;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'frequencyType'?: UpdateProfileMedicationDtoFrequencyTypeEnum;
    /**
     *
     * @type {number}
     * @memberof UpdateProfileMedicationDto
     */
    'frequencyValue'?: number;
    /**
     * Required when frequencyType is OTHER
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'frequencyCustom'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'durationType'?: UpdateProfileMedicationDtoDurationTypeEnum;
    /**
     *
     * @type {number}
     * @memberof UpdateProfileMedicationDto
     */
    'durationValue'?: number;
    /**
     * Required when durationType is OTHER
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'durationCustom'?: string;
    /**
     * Dosing that changes over the course, e.g. a steroid taper
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'dosageSchedule'?: string;
    /**
     * What the medication is for
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'indication'?: string;
    /**
     *
     * @type {boolean}
     * @memberof UpdateProfileMedicationDto
     */
    'adverseReaction'?: boolean;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'adverseReactionNote'?: string;
    /**
     * When the patient started taking it
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'startedAt'?: string;
    /**
     * Medicine product ID from the medicine database
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'medicineProductId'?: string;
    /**
     * Name of the medication (required if medicineProductId not provided)
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'name'?: string;
    /**
     * Preparation type
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'preparationType'?: string;
    /**
     * Dosage amount (deprecated — use quantityValue)
     * @type {number}
     * @memberof UpdateProfileMedicationDto
     */
    'dosage'?: number;
    /**
     * Dosage interval (deprecated — use frequencyType)
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'dosageInterval'?: UpdateProfileMedicationDtoDosageIntervalEnum;
    /**
     * Additional notes about the medication
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'notes'?: string;
    /**
     *
     * @type {boolean}
     * @memberof UpdateProfileMedicationDto
     */
    'reminderEnabled'?: boolean;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'reminderDescription'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'reminderScheduledAt'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'reminderRecurrenceType'?: UpdateProfileMedicationDtoReminderRecurrenceTypeEnum;
    /**
     *
     * @type {CustomRecurrenceDto}
     * @memberof UpdateProfileMedicationDto
     */
    'reminderCustomRecurrence'?: CustomRecurrenceDto;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateProfileMedicationDto
     */
    'reminderNotificationChannels'?: Array<UpdateProfileMedicationDtoReminderNotificationChannelsEnum>;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileMedicationDto
     */
    'visitId'?: string;
}

export const UpdateProfileMedicationDtoStrengthUnitEnum = {
    Mg: 'MG',
    G: 'G',
    Mcg: 'MCG',
    Ml: 'ML',
    Iu: 'IU',
    Percent: 'PERCENT',
    None: 'NONE',
    Other: 'OTHER'
} as const;

export type UpdateProfileMedicationDtoStrengthUnitEnum = typeof UpdateProfileMedicationDtoStrengthUnitEnum[keyof typeof UpdateProfileMedicationDtoStrengthUnitEnum];
export const UpdateProfileMedicationDtoFormEnum = {
    Tablet: 'TABLET',
    Capsule: 'CAPSULE',
    Sachet: 'SACHET',
    Suspension: 'SUSPENSION',
    Solution: 'SOLUTION',
    Drops: 'DROPS',
    Injection: 'INJECTION',
    Ointment: 'OINTMENT',
    SpotOn: 'SPOT_ON',
    Spray: 'SPRAY',
    Powder: 'POWDER',
    Paste: 'PASTE',
    Other: 'OTHER'
} as const;

export type UpdateProfileMedicationDtoFormEnum = typeof UpdateProfileMedicationDtoFormEnum[keyof typeof UpdateProfileMedicationDtoFormEnum];
export const UpdateProfileMedicationDtoFrequencyTypeEnum = {
    TimesPerDay: 'TIMES_PER_DAY',
    EveryNHours: 'EVERY_N_HOURS',
    EveryNDays: 'EVERY_N_DAYS',
    TimesPerWeek: 'TIMES_PER_WEEK',
    TimesPerMonth: 'TIMES_PER_MONTH',
    AsNeeded: 'AS_NEEDED',
    Other: 'OTHER'
} as const;

export type UpdateProfileMedicationDtoFrequencyTypeEnum = typeof UpdateProfileMedicationDtoFrequencyTypeEnum[keyof typeof UpdateProfileMedicationDtoFrequencyTypeEnum];
export const UpdateProfileMedicationDtoDurationTypeEnum = {
    UntilFurtherNotice: 'UNTIL_FURTHER_NOTICE',
    Days: 'DAYS',
    Weeks: 'WEEKS',
    UntilFollowUp: 'UNTIL_FOLLOW_UP',
    SingleDose: 'SINGLE_DOSE',
    Other: 'OTHER'
} as const;

export type UpdateProfileMedicationDtoDurationTypeEnum = typeof UpdateProfileMedicationDtoDurationTypeEnum[keyof typeof UpdateProfileMedicationDtoDurationTypeEnum];
export const UpdateProfileMedicationDtoDosageIntervalEnum = {
    Day: 'Day',
    Week: 'Week',
    Month: 'Month'
} as const;

export type UpdateProfileMedicationDtoDosageIntervalEnum = typeof UpdateProfileMedicationDtoDosageIntervalEnum[keyof typeof UpdateProfileMedicationDtoDosageIntervalEnum];
export const UpdateProfileMedicationDtoReminderRecurrenceTypeEnum = {
    Single: 'SINGLE',
    Daily: 'DAILY',
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
    Custom: 'CUSTOM'
} as const;

export type UpdateProfileMedicationDtoReminderRecurrenceTypeEnum = typeof UpdateProfileMedicationDtoReminderRecurrenceTypeEnum[keyof typeof UpdateProfileMedicationDtoReminderRecurrenceTypeEnum];
export const UpdateProfileMedicationDtoReminderNotificationChannelsEnum = {
    Email: 'EMAIL',
    Sms: 'SMS'
} as const;

export type UpdateProfileMedicationDtoReminderNotificationChannelsEnum = typeof UpdateProfileMedicationDtoReminderNotificationChannelsEnum[keyof typeof UpdateProfileMedicationDtoReminderNotificationChannelsEnum];

/**
 *
 * @export
 * @interface UpdateProfileTreatmentDto
 */
export interface UpdateProfileTreatmentDto {
    /**
     * Treatment name
     * @type {string}
     * @memberof UpdateProfileTreatmentDto
     */
    'name'?: string;
    /**
     * Treatment description
     * @type {string}
     * @memberof UpdateProfileTreatmentDto
     */
    'description'?: string;
    /**
     * Date and time of the treatment
     * @type {string}
     * @memberof UpdateProfileTreatmentDto
     */
    'treatmentDate'?: string;
    /**
     * Net price
     * @type {number}
     * @memberof UpdateProfileTreatmentDto
     */
    'priceNetto'?: number;
    /**
     * Gross price
     * @type {number}
     * @memberof UpdateProfileTreatmentDto
     */
    'priceBrutto'?: number;
    /**
     * VAT rate percentage
     * @type {number}
     * @memberof UpdateProfileTreatmentDto
     */
    'vatRate'?: number;
    /**
     * Medicines associated with this treatment
     * @type {Array<AssociatedMedicineDto>}
     * @memberof UpdateProfileTreatmentDto
     */
    'associatedMedicines'?: Array<AssociatedMedicineDto>;
    /**
     * Non-drug materials used (clinic context only; omitted leaves them as they are)
     * @type {Array<TreatmentMaterialInputDto>}
     * @memberof UpdateProfileTreatmentDto
     */
    'materials'?: Array<TreatmentMaterialInputDto>;
    /**
     * Visit ID
     * @type {string}
     * @memberof UpdateProfileTreatmentDto
     */
    'visitId'?: string;
    /**
     * Whether to keep/create a reminder
     * @type {boolean}
     * @memberof UpdateProfileTreatmentDto
     */
    'reminderEnabled'?: boolean;
    /**
     * Reminder description
     * @type {string}
     * @memberof UpdateProfileTreatmentDto
     */
    'reminderDescription'?: string;
    /**
     * Reminder scheduled date
     * @type {string}
     * @memberof UpdateProfileTreatmentDto
     */
    'reminderScheduledAt'?: string;
    /**
     * Reminder recurrence type
     * @type {string}
     * @memberof UpdateProfileTreatmentDto
     */
    'reminderRecurrenceType'?: UpdateProfileTreatmentDtoReminderRecurrenceTypeEnum;
    /**
     *
     * @type {UpdateReminderDtoCustomRecurrence}
     * @memberof UpdateProfileTreatmentDto
     */
    'reminderCustomRecurrence'?: UpdateReminderDtoCustomRecurrence;
    /**
     * Reminder notification channels
     * @type {Array<string>}
     * @memberof UpdateProfileTreatmentDto
     */
    'reminderNotificationChannels'?: Array<UpdateProfileTreatmentDtoReminderNotificationChannelsEnum>;
    /**
     * Client UUID v4, one per submit series; required on a create when a clinic sends stock fields, claimed whenever a clinic sends it (R3-4)
     * @type {string}
     * @memberof UpdateProfileTreatmentDto
     */
    'operationKey'?: string;
}

export const UpdateProfileTreatmentDtoReminderRecurrenceTypeEnum = {
    Single: 'SINGLE',
    Daily: 'DAILY',
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
    Custom: 'CUSTOM'
} as const;

export type UpdateProfileTreatmentDtoReminderRecurrenceTypeEnum = typeof UpdateProfileTreatmentDtoReminderRecurrenceTypeEnum[keyof typeof UpdateProfileTreatmentDtoReminderRecurrenceTypeEnum];
export const UpdateProfileTreatmentDtoReminderNotificationChannelsEnum = {
    Email: 'EMAIL',
    Sms: 'SMS'
} as const;

export type UpdateProfileTreatmentDtoReminderNotificationChannelsEnum = typeof UpdateProfileTreatmentDtoReminderNotificationChannelsEnum[keyof typeof UpdateProfileTreatmentDtoReminderNotificationChannelsEnum];

/**
 *
 * @export
 * @interface UpdateRatingDto
 */
export interface UpdateRatingDto {
    /**
     * Updated rating for the professional (1-5 stars)
     * @type {number}
     * @memberof UpdateRatingDto
     */
    'professionalRating'?: number;
    /**
     * Updated rating for the organization (1-5 stars)
     * @type {number}
     * @memberof UpdateRatingDto
     */
    'organizationRating'?: number;
    /**
     * Updated review text
     * @type {string}
     * @memberof UpdateRatingDto
     */
    'review'?: string;
}
/**
 *
 * @export
 * @interface UpdateReminderByGuestDto
 */
export interface UpdateReminderByGuestDto {
    /**
     *
     * @type {string}
     * @memberof UpdateReminderByGuestDto
     */
    'description'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateReminderByGuestDto
     */
    'scheduledAt'?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateReminderByGuestDto
     */
    'notificationChannels'?: Array<UpdateReminderByGuestDtoNotificationChannelsEnum>;
}

export const UpdateReminderByGuestDtoNotificationChannelsEnum = {
    Email: 'EMAIL',
    Sms: 'SMS'
} as const;

export type UpdateReminderByGuestDtoNotificationChannelsEnum = typeof UpdateReminderByGuestDtoNotificationChannelsEnum[keyof typeof UpdateReminderByGuestDtoNotificationChannelsEnum];

/**
 *
 * @export
 * @interface UpdateReminderDto
 */
export interface UpdateReminderDto {
    /**
     * Reminder description (max 250 characters)
     * @type {string}
     * @memberof UpdateReminderDto
     */
    'description'?: string;
    /**
     * Date and time of the first (or only) notification
     * @type {string}
     * @memberof UpdateReminderDto
     */
    'scheduledAt'?: string;
    /**
     * Recurrence type
     * @type {string}
     * @memberof UpdateReminderDto
     */
    'recurrenceType'?: UpdateReminderDtoRecurrenceTypeEnum;
    /**
     *
     * @type {UpdateReminderDtoCustomRecurrence}
     * @memberof UpdateReminderDto
     */
    'customRecurrence'?: UpdateReminderDtoCustomRecurrence;
    /**
     * Notification channels (at least one required)
     * @type {Array<string>}
     * @memberof UpdateReminderDto
     */
    'notificationChannels'?: Array<UpdateReminderDtoNotificationChannelsEnum>;
    /**
     * Whether the reminder is active
     * @type {boolean}
     * @memberof UpdateReminderDto
     */
    'isActive'?: boolean;
    /**
     * Medication ID this reminder is linked to
     * @type {string}
     * @memberof UpdateReminderDto
     */
    'medicationId'?: string;
    /**
     * Treatment ID this reminder is linked to
     * @type {string}
     * @memberof UpdateReminderDto
     */
    'treatmentId'?: string;
    /**
     * Visit ID this reminder is associated with
     * @type {string}
     * @memberof UpdateReminderDto
     */
    'visitId'?: string;
}

export const UpdateReminderDtoRecurrenceTypeEnum = {
    Single: 'SINGLE',
    Daily: 'DAILY',
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
    Custom: 'CUSTOM'
} as const;

export type UpdateReminderDtoRecurrenceTypeEnum = typeof UpdateReminderDtoRecurrenceTypeEnum[keyof typeof UpdateReminderDtoRecurrenceTypeEnum];
export const UpdateReminderDtoNotificationChannelsEnum = {
    Email: 'EMAIL',
    Sms: 'SMS'
} as const;

export type UpdateReminderDtoNotificationChannelsEnum = typeof UpdateReminderDtoNotificationChannelsEnum[keyof typeof UpdateReminderDtoNotificationChannelsEnum];

/**
 * Custom recurrence config
 * @export
 * @interface UpdateReminderDtoCustomRecurrence
 */
export interface UpdateReminderDtoCustomRecurrence {
    /**
     * Interval value
     * @type {number}
     * @memberof UpdateReminderDtoCustomRecurrence
     */
    'every': number;
    /**
     * Interval unit
     * @type {string}
     * @memberof UpdateReminderDtoCustomRecurrence
     */
    'unit': UpdateReminderDtoCustomRecurrenceUnitEnum;
    /**
     * Day of week (0=Sun, 1=Mon, ..., 6=Sat)
     * @type {number}
     * @memberof UpdateReminderDtoCustomRecurrence
     */
    'dayOfWeek'?: number;
    /**
     * Week of month for monthly recurrence
     * @type {string}
     * @memberof UpdateReminderDtoCustomRecurrence
     */
    'weekOfMonth'?: UpdateReminderDtoCustomRecurrenceWeekOfMonthEnum;
}

export const UpdateReminderDtoCustomRecurrenceUnitEnum = {
    Hour: 'hour',
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const;

export type UpdateReminderDtoCustomRecurrenceUnitEnum = typeof UpdateReminderDtoCustomRecurrenceUnitEnum[keyof typeof UpdateReminderDtoCustomRecurrenceUnitEnum];
export const UpdateReminderDtoCustomRecurrenceWeekOfMonthEnum = {
    First: 'first',
    Second: 'second',
    Third: 'third',
    Fourth: 'fourth',
    Last: 'last'
} as const;

export type UpdateReminderDtoCustomRecurrenceWeekOfMonthEnum = typeof UpdateReminderDtoCustomRecurrenceWeekOfMonthEnum[keyof typeof UpdateReminderDtoCustomRecurrenceWeekOfMonthEnum];

/**
 *
 * @export
 * @interface UpdateScheduleResponseDto
 */
export interface UpdateScheduleResponseDto {
    /**
     *
     * @type {string}
     * @memberof UpdateScheduleResponseDto
     */
    '_id': string;
    /**
     *
     * @type {string}
     * @memberof UpdateScheduleResponseDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof UpdateScheduleResponseDto
     */
    'street': string;
    /**
     *
     * @type {string}
     * @memberof UpdateScheduleResponseDto
     */
    'zip': string;
    /**
     *
     * @type {string}
     * @memberof UpdateScheduleResponseDto
     */
    'city': string;
    /**
     *
     * @type {string}
     * @memberof UpdateScheduleResponseDto
     */
    'website': string;
    /**
     *
     * @type {string}
     * @memberof UpdateScheduleResponseDto
     */
    'description': string;
    /**
     *
     * @type {string}
     * @memberof UpdateScheduleResponseDto
     */
    'phoneNumber': string;
    /**
     *
     * @type {string}
     * @memberof UpdateScheduleResponseDto
     */
    'email': string;
    /**
     *
     * @type {string}
     * @memberof UpdateScheduleResponseDto
     */
    'nip': string;
    /**
     *
     * @type {string}
     * @memberof UpdateScheduleResponseDto
     */
    'rating': string;
    /**
     *
     * @type {string}
     * @memberof UpdateScheduleResponseDto
     */
    'logoUrl': string;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateScheduleResponseDto
     */
    'images': Array<string>;
    /**
     *
     * @type {boolean}
     * @memberof UpdateScheduleResponseDto
     */
    'isActive': boolean;
    /**
     *
     * @type {boolean}
     * @memberof UpdateScheduleResponseDto
     */
    'isPublished': boolean;
    /**
     *
     * @type {boolean}
     * @memberof UpdateScheduleResponseDto
     */
    'isVerified': boolean;
    /**
     *
     * @type {string}
     * @memberof UpdateScheduleResponseDto
     */
    'type': UpdateScheduleResponseDtoTypeEnum;
    /**
     *
     * @type {Array<object>}
     * @memberof UpdateScheduleResponseDto
     */
    'workingHours': Array<object>;
    /**
     *
     * @type {Array<object>}
     * @memberof UpdateScheduleResponseDto
     */
    'timeOff': Array<object>;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateScheduleResponseDto
     */
    'specializations': Array<string>;
    /**
     *
     * @type {string}
     * @memberof UpdateScheduleResponseDto
     */
    'slug'?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateScheduleResponseDto
     */
    'enabledServices': Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateScheduleResponseDto
     */
    'enabledVisitTypes': Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateScheduleResponseDto
     */
    'enabledCategories': Array<string>;
    /**
     *
     * @type {Array<GetOrganizationDtoVisitTypeCategoryConfigsInner>}
     * @memberof UpdateScheduleResponseDto
     */
    'visitTypeCategoryConfigs'?: Array<GetOrganizationDtoVisitTypeCategoryConfigsInner>;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateScheduleResponseDto
     */
    'socialMedia': Array<string>;
    /**
     *
     * @type {string}
     * @memberof UpdateScheduleResponseDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof UpdateScheduleResponseDto
     */
    'updatedAt': string;
    /**
     * Wizyty kolidujące z nowym harmonogramem (może być pusta tablica)
     * @type {Array<ConflictingVisitDto>}
     * @memberof UpdateScheduleResponseDto
     */
    'conflictingVisits': Array<ConflictingVisitDto>;
}

export const UpdateScheduleResponseDtoTypeEnum = {
    VeterinaryFacility: 'VETERINARY_FACILITY'
} as const;

export type UpdateScheduleResponseDtoTypeEnum = typeof UpdateScheduleResponseDtoTypeEnum[keyof typeof UpdateScheduleResponseDtoTypeEnum];

/**
 *
 * @export
 * @interface UpdateSpecializationDto
 */
export interface UpdateSpecializationDto {
    /**
     * Custom duration in minutes for this specialization
     * @type {number}
     * @memberof UpdateSpecializationDto
     */
    'customDuration'?: number;
    /**
     * Additional notes about this specialization
     * @type {string}
     * @memberof UpdateSpecializationDto
     */
    'notes'?: string;
    /**
     * Whether this specialization is actively offered
     * @type {boolean}
     * @memberof UpdateSpecializationDto
     */
    'isActive'?: boolean;
}
/**
 *
 * @export
 * @interface UpdateSpecializationServiceDto
 */
export interface UpdateSpecializationServiceDto {
    /**
     * Name of the service
     * @type {string}
     * @memberof UpdateSpecializationServiceDto
     */
    'name'?: string;
    /**
     * Description of the service
     * @type {string}
     * @memberof UpdateSpecializationServiceDto
     */
    'description'?: string;
    /**
     * Specialization ID this service belongs to
     * @type {string}
     * @memberof UpdateSpecializationServiceDto
     */
    'specializationId'?: string;
    /**
     * Category of the service
     * @type {string}
     * @memberof UpdateSpecializationServiceDto
     */
    'category'?: UpdateSpecializationServiceDtoCategoryEnum;
    /**
     * Visit type this service is for
     * @type {string}
     * @memberof UpdateSpecializationServiceDto
     */
    'visitType'?: UpdateSpecializationServiceDtoVisitTypeEnum;
    /**
     * Default price for this service in PLN
     * @type {number}
     * @memberof UpdateSpecializationServiceDto
     */
    'defaultPrice'?: number;
    /**
     * Default duration for this service in minutes
     * @type {number}
     * @memberof UpdateSpecializationServiceDto
     */
    'defaultDuration'?: number;
    /**
     * Reservation fee in PLN charged online at booking. Onsite/mobile only; 0..defaultPrice. Omit/null for no fee.
     * @type {number}
     * @memberof UpdateSpecializationServiceDto
     */
    'prepaidAmount'?: number;
}

export const UpdateSpecializationServiceDtoCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type UpdateSpecializationServiceDtoCategoryEnum = typeof UpdateSpecializationServiceDtoCategoryEnum[keyof typeof UpdateSpecializationServiceDtoCategoryEnum];
export const UpdateSpecializationServiceDtoVisitTypeEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type UpdateSpecializationServiceDtoVisitTypeEnum = typeof UpdateSpecializationServiceDtoVisitTypeEnum[keyof typeof UpdateSpecializationServiceDtoVisitTypeEnum];

/**
 *
 * @export
 * @interface UpdateTemplateDto
 */
export interface UpdateTemplateDto {
    /**
     * Template name
     * @type {string}
     * @memberof UpdateTemplateDto
     */
    'name'?: string;
    /**
     * Template description
     * @type {string}
     * @memberof UpdateTemplateDto
     */
    'description'?: string;
    /**
     * Template category - can be predefined (veterinarian, dietitian, behaviorist, physiotherapist) or custom
     * @type {string}
     * @memberof UpdateTemplateDto
     */
    'category'?: string;
    /**
     * Template type
     * @type {string}
     * @memberof UpdateTemplateDto
     */
    'templateType'?: UpdateTemplateDtoTemplateTypeEnum;
    /**
     * Template content in markdown format
     * @type {string}
     * @memberof UpdateTemplateDto
     */
    'content'?: string;
    /**
     * Whether the template is shared with other professionals
     * @type {boolean}
     * @memberof UpdateTemplateDto
     */
    'isShared'?: boolean;
}

export const UpdateTemplateDtoTemplateTypeEnum = {
    InitialAssessment: 'initial_assessment',
    FollowUp: 'follow_up',
    General: 'general',
    Surgery: 'surgery',
    Vaccination: 'vaccination',
    Emergency: 'emergency',
    Diagnostic: 'diagnostic',
    Prescription: 'prescription',
    Discharge: 'discharge',
    Checkup: 'checkup'
} as const;

export type UpdateTemplateDtoTemplateTypeEnum = typeof UpdateTemplateDtoTemplateTypeEnum[keyof typeof UpdateTemplateDtoTemplateTypeEnum];

/**
 *
 * @export
 * @interface UpdateTextNoteDto
 */
export interface UpdateTextNoteDto {
    /**
     * Updated text note body (HTML from the editor).
     * @type {string}
     * @memberof UpdateTextNoteDto
     */
    'content': string;
}
/**
 *
 * @export
 * @interface UpdateTimeOffDto
 */
export interface UpdateTimeOffDto {
    /**
     * Array of time off periods for the organization
     * @type {Array<TimeOffDto>}
     * @memberof UpdateTimeOffDto
     */
    'timeOff': Array<TimeOffDto>;
    /**
     * When true, only computes conflicting visits without persisting the change (preview for the confirm modal).
     * @type {boolean}
     * @memberof UpdateTimeOffDto
     */
    'dryRun'?: boolean;
}
/**
 *
 * @export
 * @interface UpdateTreatmentDto
 */
export interface UpdateTreatmentDto {
    /**
     * Treatment name
     * @type {string}
     * @memberof UpdateTreatmentDto
     */
    'name'?: string;
    /**
     * Treatment description
     * @type {string}
     * @memberof UpdateTreatmentDto
     */
    'description'?: string;
    /**
     * Net price (without VAT)
     * @type {number}
     * @memberof UpdateTreatmentDto
     */
    'priceNetto'?: number;
    /**
     * Gross price (with VAT)
     * @type {number}
     * @memberof UpdateTreatmentDto
     */
    'priceBrutto'?: number;
    /**
     * VAT rate percentage
     * @type {number}
     * @memberof UpdateTreatmentDto
     */
    'vatRate'?: number;
    /**
     * Whether the treatment is active
     * @type {boolean}
     * @memberof UpdateTreatmentDto
     */
    'isActive'?: boolean;
    /**
     * Medicines associated with this treatment
     * @type {Array<AssociatedMedicineDto>}
     * @memberof UpdateTreatmentDto
     */
    'associatedMedicines'?: Array<AssociatedMedicineDto>;
    /**
     * Default non-drug materials used by this treatment
     * @type {Array<TreatmentMaterialInputDto>}
     * @memberof UpdateTreatmentDto
     */
    'defaultMaterials'?: Array<TreatmentMaterialInputDto>;
}
/**
 *
 * @export
 * @interface UpdateUserDto
 */
export interface UpdateUserDto {
    /**
     *
     * @type {string}
     * @memberof UpdateUserDto
     */
    'firstName'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateUserDto
     */
    'email'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateUserDto
     */
    'lastName'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateUserDto
     */
    'middleName'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateUserDto
     */
    'phoneNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateUserDto
     */
    'avatar'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateUserDto
     */
    'dob'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateUserDto
     */
    'address'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateUserDto
     */
    'pwzNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateUserDto
     */
    'city'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateUserDto
     */
    'zip'?: string;
    /**
     *
     * @type {Array<object>}
     * @memberof UpdateUserDto
     */
    'availabilitySlots'?: Array<object>;
    /**
     *
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    'marketing'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    'terms'?: boolean;
    /**
     *
     * @type {string}
     * @memberof UpdateUserDto
     */
    'description'?: string;
}
/**
 *
 * @export
 * @interface UpdateVisitDetailsDto
 */
export interface UpdateVisitDetailsDto {
    /**
     *
     * @type {string}
     * @memberof UpdateVisitDetailsDto
     */
    'description'?: string;
    /**
     *
     * @type {Array<DocumentFileEntryDto>}
     * @memberof UpdateVisitDetailsDto
     */
    'documentsToAdd'?: Array<DocumentFileEntryDto>;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateVisitDetailsDto
     */
    'documentIdsToRemove'?: Array<string>;
}
/**
 *
 * @export
 * @interface UpdateVisitProfileDataDto
 */
export interface UpdateVisitProfileDataDto {
    /**
     *
     * @type {string}
     * @memberof UpdateVisitProfileDataDto
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateVisitProfileDataDto
     */
    'breed'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateVisitProfileDataDto
     */
    'petCategory'?: UpdateVisitProfileDataDtoPetCategoryEnum;
    /**
     *
     * @type {number}
     * @memberof UpdateVisitProfileDataDto
     */
    'weight'?: number;
    /**
     *
     * @type {string}
     * @memberof UpdateVisitProfileDataDto
     */
    'gender'?: string;
    /**
     * ISO-8601 date
     * @type {string}
     * @memberof UpdateVisitProfileDataDto
     */
    'dob'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateVisitProfileDataDto
     */
    'chipNumber'?: string;
}

export const UpdateVisitProfileDataDtoPetCategoryEnum = {
    Dog: 'dog',
    Cat: 'cat',
    Other: 'other'
} as const;

export type UpdateVisitProfileDataDtoPetCategoryEnum = typeof UpdateVisitProfileDataDtoPetCategoryEnum[keyof typeof UpdateVisitProfileDataDtoPetCategoryEnum];

/**
 *
 * @export
 * @interface UpdateVisitSettingsDto
 */
export interface UpdateVisitSettingsDto {
    /**
     * Array of visit types enabled for professionals in this organization
     * @type {Array<string>}
     * @memberof UpdateVisitSettingsDto
     */
    'enabledVisitTypes'?: Array<UpdateVisitSettingsDtoEnabledVisitTypesEnum>;
    /**
     * Array of categories enabled for professionals in this organization
     * @type {Array<string>}
     * @memberof UpdateVisitSettingsDto
     */
    'enabledCategories'?: Array<UpdateVisitSettingsDtoEnabledCategoriesEnum>;
    /**
     * Visit type and category configurations
     * @type {Array<VisitTypeCategoryConfigDto>}
     * @memberof UpdateVisitSettingsDto
     */
    'visitTypeCategoryConfigs'?: Array<VisitTypeCategoryConfigDto>;
}

export const UpdateVisitSettingsDtoEnabledVisitTypesEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type UpdateVisitSettingsDtoEnabledVisitTypesEnum = typeof UpdateVisitSettingsDtoEnabledVisitTypesEnum[keyof typeof UpdateVisitSettingsDtoEnabledVisitTypesEnum];
export const UpdateVisitSettingsDtoEnabledCategoriesEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type UpdateVisitSettingsDtoEnabledCategoriesEnum = typeof UpdateVisitSettingsDtoEnabledCategoriesEnum[keyof typeof UpdateVisitSettingsDtoEnabledCategoriesEnum];

/**
 *
 * @export
 * @interface UpdateVisitTranscriptionSegmentDto
 */
export interface UpdateVisitTranscriptionSegmentDto {
    /**
     *
     * @type {string}
     * @memberof UpdateVisitTranscriptionSegmentDto
     */
    'segmentId': string;
    /**
     *
     * @type {string}
     * @memberof UpdateVisitTranscriptionSegmentDto
     */
    'speaker': UpdateVisitTranscriptionSegmentDtoSpeakerEnum;
    /**
     *
     * @type {string}
     * @memberof UpdateVisitTranscriptionSegmentDto
     */
    'text': string;
}

export const UpdateVisitTranscriptionSegmentDtoSpeakerEnum = {
    Professional: 'professional',
    Caregiver: 'caregiver',
    Unknown: 'unknown'
} as const;

export type UpdateVisitTranscriptionSegmentDtoSpeakerEnum = typeof UpdateVisitTranscriptionSegmentDtoSpeakerEnum[keyof typeof UpdateVisitTranscriptionSegmentDtoSpeakerEnum];

/**
 *
 * @export
 * @interface UpdateVisitUserDataDto
 */
export interface UpdateVisitUserDataDto {
    /**
     *
     * @type {string}
     * @memberof UpdateVisitUserDataDto
     */
    'firstName'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateVisitUserDataDto
     */
    'lastName'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateVisitUserDataDto
     */
    'email'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateVisitUserDataDto
     */
    'phoneNumber'?: string;
}
/**
 *
 * @export
 * @interface UpdateWarehouseProductDto
 */
export interface UpdateWarehouseProductDto {
    /**
     *
     * @type {string}
     * @memberof UpdateWarehouseProductDto
     */
    'name': string;
    /**
     * Medicine.productId from the RPL registry
     * @type {string}
     * @memberof UpdateWarehouseProductDto
     */
    'medicineProductId'?: string;
    /**
     *
     * @type {boolean}
     * @memberof UpdateWarehouseProductDto
     */
    'isRx'?: boolean;
    /**
     *
     * @type {WarehouseControlledCategory}
     * @memberof UpdateWarehouseProductDto
     */
    'controlledCategory'?: WarehouseControlledCategory;
    /**
     *
     * @type {WarehouseUnit}
     * @memberof UpdateWarehouseProductDto
     */
    'unit': WarehouseUnit;
    /**
     * Required when unit is OTHER
     * @type {string}
     * @memberof UpdateWarehouseProductDto
     */
    'unitCustom'?: string;
    /**
     *
     * @type {number}
     * @memberof UpdateWarehouseProductDto
     */
    'unitsPerPackage': number;
    /**
     *
     * @type {WarehouseDispenseMode}
     * @memberof UpdateWarehouseProductDto
     */
    'dispenseMode'?: WarehouseDispenseMode;
    /**
     * Gross sale price of one package, grosze
     * @type {number}
     * @memberof UpdateWarehouseProductDto
     */
    'packagePriceGrossMinor': number;
    /**
     * Gross sale price of one Unit; derived from the package price when absent
     * @type {number}
     * @memberof UpdateWarehouseProductDto
     */
    'unitPriceGrossMinor'?: number;
    /**
     *
     * @type {WarehouseVatRate}
     * @memberof UpdateWarehouseProductDto
     */
    'vatRate': WarehouseVatRate;
    /**
     * Minimum stock in minStockMeasure (≤3 decimals)
     * @type {number}
     * @memberof UpdateWarehouseProductDto
     */
    'minStockQuantity'?: number;
    /**
     *
     * @type {WarehouseQuantityMeasure}
     * @memberof UpdateWarehouseProductDto
     */
    'minStockMeasure'?: WarehouseQuantityMeasure;
    /**
     * Required for Rx drugs (MA_HOLDER_REQUIRED)
     * @type {string}
     * @memberof UpdateWarehouseProductDto
     */
    'marketingAuthorisationNumber'?: string;
    /**
     * Podmiot odpowiedzialny; required for Rx drugs (MA_HOLDER_REQUIRED)
     * @type {string}
     * @memberof UpdateWarehouseProductDto
     */
    'marketingAuthorisationHolder'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateWarehouseProductDto
     */
    'withdrawalPeriod'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateWarehouseProductDto
     */
    'form'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateWarehouseProductDto
     */
    'strength'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateWarehouseProductDto
     */
    'gtin'?: string;
}


/**
 *
 * @export
 * @interface UpdateWarehouseReceiptDto
 */
export interface UpdateWarehouseReceiptDto {
    /**
     * Business date, YYYY-MM-DD
     * @type {string}
     * @memberof UpdateWarehouseReceiptDto
     */
    'documentDate': string;
    /**
     * Required to approve a PZ; ignored on a BO
     * @type {string}
     * @memberof UpdateWarehouseReceiptDto
     */
    'supplierId'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateWarehouseReceiptDto
     */
    'supplierInvoiceNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateWarehouseReceiptDto
     */
    'note'?: string;
    /**
     *
     * @type {Array<WarehouseReceiptLineInputDto>}
     * @memberof UpdateWarehouseReceiptDto
     */
    'lines': Array<WarehouseReceiptLineInputDto>;
}
/**
 *
 * @export
 * @interface UpdateWarehouseSupplierDto
 */
export interface UpdateWarehouseSupplierDto {
    /**
     *
     * @type {string}
     * @memberof UpdateWarehouseSupplierDto
     */
    'name': string;
    /**
     * 10 digits; spaces and dashes are ignored
     * @type {string}
     * @memberof UpdateWarehouseSupplierDto
     */
    'nip'?: string;
    /**
     *
     * @type {CreateWarehouseSupplierDtoAddress}
     * @memberof UpdateWarehouseSupplierDto
     */
    'address'?: CreateWarehouseSupplierDtoAddress;
}
/**
 *
 * @export
 * @interface UpdateWebinarDto
 */
export interface UpdateWebinarDto {
    /**
     *
     * @type {string}
     * @memberof UpdateWebinarDto
     */
    'title'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateWebinarDto
     */
    'description'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateWebinarDto
     */
    'slug'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateWebinarDto
     */
    'startsAt'?: string;
    /**
     *
     * @type {number}
     * @memberof UpdateWebinarDto
     */
    'durationMinutes'?: number;
    /**
     * Liczba miejsc dla uczestników, bez prowadzących i rejestratora.
     * @type {number}
     * @memberof UpdateWebinarDto
     */
    'capacity'?: number;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateWebinarDto
     */
    'presenterIds'?: Array<string>;
    /**
     * Główny prowadzący uprawniony do zarządzania nagrywaniem. Musi należeć do listy prowadzących.
     * @type {string}
     * @memberof UpdateWebinarDto
     */
    'mainPresenterId'?: string | null;
    /**
     * Moderatorzy zatwierdzają wiadomości czatu publicznego. Nie mają kamery, mikrofonu ani udostępniania ekranu.
     * @type {Array<string>}
     * @memberof UpdateWebinarDto
     */
    'moderatorIds'?: Array<string>;
}
/**
 *
 * @export
 * @interface UpdateWorkingHoursDto
 */
export interface UpdateWorkingHoursDto {
    /**
     * Array of working hour slots for the organization
     * @type {Array<AvailabilitySlotDto>}
     * @memberof UpdateWorkingHoursDto
     */
    'workingHours': Array<AvailabilitySlotDto>;
    /**
     * When true, only computes conflicting visits without persisting the change (preview for the confirm modal).
     * @type {boolean}
     * @memberof UpdateWorkingHoursDto
     */
    'dryRun'?: boolean;
}
/**
 *
 * @export
 * @interface UploadFileResponseDto
 */
export interface UploadFileResponseDto {
    /**
     * Proof returned by the upload endpoint for attaching a new file
     * @type {string}
     * @memberof UploadFileResponseDto
     */
    'uploadToken'?: string;
    /**
     * The unique filename of the uploaded file
     * @type {string}
     * @memberof UploadFileResponseDto
     */
    'filename': string;
    /**
     * The URL or filename to access the file (public URL for public uploads, filename for private uploads)
     * @type {string}
     * @memberof UploadFileResponseDto
     */
    'url': string;
}
/**
 *
 * @export
 * @interface User
 */
export interface User {
    /**
     *
     * @type {string}
     * @memberof User
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof User
     */
    'firstName': string;
    /**
     *
     * @type {string}
     * @memberof User
     */
    'middleName': string;
    /**
     *
     * @type {string}
     * @memberof User
     */
    'lastName': string;
    /**
     *
     * @type {string}
     * @memberof User
     */
    'avatar': string;
    /**
     *
     * @type {string}
     * @memberof User
     */
    'email'?: string | null;
    /**
     *
     * @type {string}
     * @memberof User
     */
    'phoneNumber'?: string | null;
}
/**
 *
 * @export
 * @interface ValidatePetDto
 */
export interface ValidatePetDto {
    /**
     * Category of the pet
     * @type {string}
     * @memberof ValidatePetDto
     */
    'petCategory': ValidatePetDtoPetCategoryEnum;
    /**
     * Breed of the pet
     * @type {string}
     * @memberof ValidatePetDto
     */
    'breed': string;
}

export const ValidatePetDtoPetCategoryEnum = {
    Dog: 'dog',
    Cat: 'cat',
    Other: 'other'
} as const;

export type ValidatePetDtoPetCategoryEnum = typeof ValidatePetDtoPetCategoryEnum[keyof typeof ValidatePetDtoPetCategoryEnum];

/**
 *
 * @export
 * @interface ValidatePetResponseDto
 */
export interface ValidatePetResponseDto {
    /**
     * Whether the pet breed and category combination is valid
     * @type {boolean}
     * @memberof ValidatePetResponseDto
     */
    'isValid': boolean;
    /**
     * Message about the validation result
     * @type {string}
     * @memberof ValidatePetResponseDto
     */
    'message': string;
}
/**
 *
 * @export
 * @interface ValidatePromoCodeDto
 */
export interface ValidatePromoCodeDto {
    /**
     * Promo code to validate
     * @type {string}
     * @memberof ValidatePromoCodeDto
     */
    'code': string;
    /**
     * Category for which the promo code is being validated (required for visit type)
     * @type {string}
     * @memberof ValidatePromoCodeDto
     */
    'category'?: ValidatePromoCodeDtoCategoryEnum;
    /**
     * Promo code type
     * @type {string}
     * @memberof ValidatePromoCodeDto
     */
    'type'?: ValidatePromoCodeDtoTypeEnum;
}

export const ValidatePromoCodeDtoCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type ValidatePromoCodeDtoCategoryEnum = typeof ValidatePromoCodeDtoCategoryEnum[keyof typeof ValidatePromoCodeDtoCategoryEnum];
export const ValidatePromoCodeDtoTypeEnum = {
    Visit: 'visit',
    Campaign: 'campaign'
} as const;

export type ValidatePromoCodeDtoTypeEnum = typeof ValidatePromoCodeDtoTypeEnum[keyof typeof ValidatePromoCodeDtoTypeEnum];

/**
 *
 * @export
 * @interface ValidatePromoCodeResponseDto
 */
export interface ValidatePromoCodeResponseDto {
    /**
     * Discount percentage
     * @type {number}
     * @memberof ValidatePromoCodeResponseDto
     */
    'discountPercentage': number;
    /**
     * Discounted price (if applicable)
     * @type {number}
     * @memberof ValidatePromoCodeResponseDto
     */
    'discountedPrice'?: number;
}
/**
 *
 * @export
 * @interface VerifyPhoneCodeDto
 */
export interface VerifyPhoneCodeDto {
    /**
     * Phone number with country code
     * @type {string}
     * @memberof VerifyPhoneCodeDto
     */
    'phoneNumber': string;
    /**
     * 6-digit verification code
     * @type {string}
     * @memberof VerifyPhoneCodeDto
     */
    'verificationCode': string;
}
/**
 *
 * @export
 * @interface VerifyPhoneCodeResponseDto
 */
export interface VerifyPhoneCodeResponseDto {
    /**
     * Whether verification was successful
     * @type {boolean}
     * @memberof VerifyPhoneCodeResponseDto
     */
    'success': boolean;
    /**
     * Response message
     * @type {string}
     * @memberof VerifyPhoneCodeResponseDto
     */
    'message': string;
    /**
     * Firebase custom token for authentication
     * @type {string}
     * @memberof VerifyPhoneCodeResponseDto
     */
    'customToken'?: string;
}
/**
 *
 * @export
 * @interface VisitActivityResponseDto
 */
export interface VisitActivityResponseDto {
    /**
     *
     * @type {string}
     * @memberof VisitActivityResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof VisitActivityResponseDto
     */
    'type': VisitActivityResponseDtoTypeEnum;
    /**
     *
     * @type {string}
     * @memberof VisitActivityResponseDto
     */
    'action': VisitActivityResponseDtoActionEnum;
    /**
     *
     * @type {string}
     * @memberof VisitActivityResponseDto
     */
    'referenceId': string;
    /**
     *
     * @type {string}
     * @memberof VisitActivityResponseDto
     */
    'name': string;
    /**
     *
     * @type {object}
     * @memberof VisitActivityResponseDto
     */
    'metadata'?: object;
    /**
     *
     * @type {string}
     * @memberof VisitActivityResponseDto
     */
    'createdAt': string;
}

export const VisitActivityResponseDtoTypeEnum = {
    Medication: 'MEDICATION',
    Treatment: 'TREATMENT',
    Reminder: 'REMINDER',
    Document: 'DOCUMENT',
    Transcription: 'TRANSCRIPTION'
} as const;

export type VisitActivityResponseDtoTypeEnum = typeof VisitActivityResponseDtoTypeEnum[keyof typeof VisitActivityResponseDtoTypeEnum];
export const VisitActivityResponseDtoActionEnum = {
    Added: 'ADDED',
    Updated: 'UPDATED',
    Removed: 'REMOVED',
    Started: 'STARTED',
    Stopped: 'STOPPED',
    Paused: 'PAUSED',
    Resumed: 'RESUMED'
} as const;

export type VisitActivityResponseDtoActionEnum = typeof VisitActivityResponseDtoActionEnum[keyof typeof VisitActivityResponseDtoActionEnum];

/**
 *
 * @export
 * @interface VisitAddressDto
 */
export interface VisitAddressDto {
    /**
     * Street address for the mobile visit
     * @type {string}
     * @memberof VisitAddressDto
     */
    'street': string;
    /**
     * City for the mobile visit
     * @type {string}
     * @memberof VisitAddressDto
     */
    'city': string;
    /**
     * Zip code for the mobile visit
     * @type {string}
     * @memberof VisitAddressDto
     */
    'zipCode': string;
}
/**
 *
 * @export
 * @interface VisitAddressResponse
 */
export interface VisitAddressResponse {
    /**
     * Street address for the mobile visit
     * @type {string}
     * @memberof VisitAddressResponse
     */
    'street': string;
    /**
     * City for the mobile visit
     * @type {string}
     * @memberof VisitAddressResponse
     */
    'city': string;
    /**
     * Zip code for the mobile visit
     * @type {string}
     * @memberof VisitAddressResponse
     */
    'zipCode': string;
}
/**
 *
 * @export
 * @interface VisitApprovalDto
 */
export interface VisitApprovalDto {
    /**
     * The new status of the appointment
     * @type {string}
     * @memberof VisitApprovalDto
     */
    'status': VisitApprovalDtoStatusEnum;
    /**
     * Reason for rejection (required only if status is REJECTED)
     * @type {string}
     * @memberof VisitApprovalDto
     */
    'rejectionReason'?: string;
}

export const VisitApprovalDtoStatusEnum = {
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED'
} as const;

export type VisitApprovalDtoStatusEnum = typeof VisitApprovalDtoStatusEnum[keyof typeof VisitApprovalDtoStatusEnum];

/**
 *
 * @export
 * @interface VisitControllerAttachVisitSummary200Response
 */
export interface VisitControllerAttachVisitSummary200Response {
    /**
     *
     * @type {string}
     * @memberof VisitControllerAttachVisitSummary200Response
     */
    'documentUrl'?: string;
}
/**
 *
 * @export
 * @interface VisitControllerAttachVisitSummaryRequest
 */
export interface VisitControllerAttachVisitSummaryRequest {
    /**
     * PDF file in base64 format
     * @type {string}
     * @memberof VisitControllerAttachVisitSummaryRequest
     */
    'pdfBase64'?: string;
}
/**
 *
 * @export
 * @interface VisitControllerCheckUserByEmail200Response
 */
export interface VisitControllerCheckUserByEmail200Response {
    /**
     *
     * @type {boolean}
     * @memberof VisitControllerCheckUserByEmail200Response
     */
    'exists'?: boolean;
    /**
     *
     * @type {VisitControllerCheckUserByEmail200ResponseUser}
     * @memberof VisitControllerCheckUserByEmail200Response
     */
    'user'?: VisitControllerCheckUserByEmail200ResponseUser | null;
}
/**
 *
 * @export
 * @interface VisitControllerCheckUserByEmail200ResponseUser
 */
export interface VisitControllerCheckUserByEmail200ResponseUser {
    /**
     *
     * @type {string}
     * @memberof VisitControllerCheckUserByEmail200ResponseUser
     */
    'id'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitControllerCheckUserByEmail200ResponseUser
     */
    'firstName'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitControllerCheckUserByEmail200ResponseUser
     */
    'lastName'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitControllerCheckUserByEmail200ResponseUser
     */
    'email'?: string;
}
/**
 *
 * @export
 * @interface VisitControllerGetUserProfiles200ResponseInner
 */
export interface VisitControllerGetUserProfiles200ResponseInner {
    /**
     *
     * @type {string}
     * @memberof VisitControllerGetUserProfiles200ResponseInner
     */
    'id'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitControllerGetUserProfiles200ResponseInner
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitControllerGetUserProfiles200ResponseInner
     */
    'breed'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitControllerGetUserProfiles200ResponseInner
     */
    'dob'?: string;
    /**
     *
     * @type {number}
     * @memberof VisitControllerGetUserProfiles200ResponseInner
     */
    'weight'?: number;
    /**
     *
     * @type {string}
     * @memberof VisitControllerGetUserProfiles200ResponseInner
     */
    'gender'?: string;
}
/**
 *
 * @export
 * @interface VisitControllerGetVisitFileSignedUrl200Response
 */
export interface VisitControllerGetVisitFileSignedUrl200Response {
    /**
     *
     * @type {string}
     * @memberof VisitControllerGetVisitFileSignedUrl200Response
     */
    'url'?: string;
}
/**
 *
 * @export
 * @interface VisitStats
 */
export interface VisitStats {
    /**
     *
     * @type {VisitStatsDetail}
     * @memberof VisitStats
     */
    'COMPLETED'?: VisitStatsDetail;
    /**
     *
     * @type {VisitStatsDetail}
     * @memberof VisitStats
     */
    'CREATED'?: VisitStatsDetail;
    /**
     *
     * @type {VisitStatsDetail}
     * @memberof VisitStats
     */
    'PENDING'?: VisitStatsDetail;
}
/**
 *
 * @export
 * @interface VisitStatsDetail
 */
export interface VisitStatsDetail {
    /**
     *
     * @type {number}
     * @memberof VisitStatsDetail
     */
    'totalSaleAmount': number;
    /**
     *
     * @type {number}
     * @memberof VisitStatsDetail
     */
    'count': number;
}
/**
 *
 * @export
 * @interface VisitSummaryDataDto
 */
export interface VisitSummaryDataDto {
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'visitId': string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'visitDate': string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'visitType': string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'category': string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'serviceName'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'petName': string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'petBreed'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'petAge'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'petGender'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'ownerName': string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'ownerEmail'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'ownerPhone'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'organizationName': string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'organizationAddress'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'organizationCity'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'organizationZip'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'organizationPhone'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'organizationEmail'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'organizationLogoUrl'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'organizationNip'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'professionalName': string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'professionalTitle'?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof VisitSummaryDataDto
     */
    'professionalSpecializations'?: Array<string>;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'professionalPwzNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'description'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'notes'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'internalNotes'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'aiNote'?: string;
    /**
     *
     * @type {Array<object>}
     * @memberof VisitSummaryDataDto
     */
    'medications'?: Array<object>;
    /**
     *
     * @type {Array<object>}
     * @memberof VisitSummaryDataDto
     */
    'treatments'?: Array<object>;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'generatedBy': string;
    /**
     *
     * @type {string}
     * @memberof VisitSummaryDataDto
     */
    'generatedAt': string;
}
/**
 *
 * @export
 * @interface VisitTranscriptionDto
 */
export interface VisitTranscriptionDto {
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionDto
     */
    'status': VisitTranscriptionDtoStatusEnum;
    /**
     *
     * @type {Array<VisitTranscriptionSessionDto>}
     * @memberof VisitTranscriptionDto
     */
    'sessions': Array<VisitTranscriptionSessionDto>;
    /**
     *
     * @type {Array<VisitTranscriptionSegmentDto>}
     * @memberof VisitTranscriptionDto
     */
    'segments': Array<VisitTranscriptionSegmentDto>;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionDto
     */
    'plainText': string;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionDto
     */
    'consentConfirmedAt'?: string | null;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionDto
     */
    'consentConfirmedBy'?: string | null;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionDto
     */
    'updatedAt'?: string | null;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionDto
     */
    'errorMessage'?: string | null;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionDto
     */
    'transcriptSummary'?: string | null;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionDto
     */
    'transcriptSummaryStatus'?: VisitTranscriptionDtoTranscriptSummaryStatusEnum;
}

export const VisitTranscriptionDtoStatusEnum = {
    Idle: 'idle',
    Recording: 'recording',
    Finalizing: 'finalizing',
    Completed: 'completed',
    Failed: 'failed'
} as const;

export type VisitTranscriptionDtoStatusEnum = typeof VisitTranscriptionDtoStatusEnum[keyof typeof VisitTranscriptionDtoStatusEnum];
export const VisitTranscriptionDtoTranscriptSummaryStatusEnum = {
    Pending: 'pending',
    Success: 'success',
    Failed: 'failed'
} as const;

export type VisitTranscriptionDtoTranscriptSummaryStatusEnum = typeof VisitTranscriptionDtoTranscriptSummaryStatusEnum[keyof typeof VisitTranscriptionDtoTranscriptSummaryStatusEnum];

/**
 *
 * @export
 * @interface VisitTranscriptionSegmentDto
 */
export interface VisitTranscriptionSegmentDto {
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSegmentDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSegmentDto
     */
    'sessionId': string;
    /**
     * Acoustic speaker label; scoped to the visit for google-gemini and gemini-transcribe-flash, otherwise to sessionId. Not a verified personal identity.
     * @type {string}
     * @memberof VisitTranscriptionSegmentDto
     */
    'speakerId'?: string | null;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSegmentDto
     */
    'speaker': VisitTranscriptionSegmentDtoSpeakerEnum;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSegmentDto
     */
    'originalSpeaker': VisitTranscriptionSegmentDtoOriginalSpeakerEnum;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSegmentDto
     */
    'text': string;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSegmentDto
     */
    'originalText': string;
    /**
     *
     * @type {number}
     * @memberof VisitTranscriptionSegmentDto
     */
    'startMs'?: number | null;
    /**
     *
     * @type {number}
     * @memberof VisitTranscriptionSegmentDto
     */
    'endMs'?: number | null;
    /**
     *
     * @type {number}
     * @memberof VisitTranscriptionSegmentDto
     */
    'confidence'?: number | null;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSegmentDto
     */
    'source': string;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSegmentDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSegmentDto
     */
    'editedAt'?: string | null;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSegmentDto
     */
    'editedBy'?: string | null;
}

export const VisitTranscriptionSegmentDtoSpeakerEnum = {
    Professional: 'professional',
    Caregiver: 'caregiver',
    Unknown: 'unknown'
} as const;

export type VisitTranscriptionSegmentDtoSpeakerEnum = typeof VisitTranscriptionSegmentDtoSpeakerEnum[keyof typeof VisitTranscriptionSegmentDtoSpeakerEnum];
export const VisitTranscriptionSegmentDtoOriginalSpeakerEnum = {
    Professional: 'professional',
    Caregiver: 'caregiver',
    Unknown: 'unknown'
} as const;

export type VisitTranscriptionSegmentDtoOriginalSpeakerEnum = typeof VisitTranscriptionSegmentDtoOriginalSpeakerEnum[keyof typeof VisitTranscriptionSegmentDtoOriginalSpeakerEnum];

/**
 *
 * @export
 * @interface VisitTranscriptionSessionDto
 */
export interface VisitTranscriptionSessionDto {
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSessionDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSessionDto
     */
    'provider'?: VisitTranscriptionSessionDtoProviderEnum;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSessionDto
     */
    'status': VisitTranscriptionSessionDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSessionDto
     */
    'startedBy': string;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSessionDto
     */
    'startedAt': string;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSessionDto
     */
    'stoppedAt'?: string | null;
    /**
     *
     * @type {string}
     * @memberof VisitTranscriptionSessionDto
     */
    'errorMessage'?: string | null;
}

export const VisitTranscriptionSessionDtoProviderEnum = {
    Google: 'google',
    LivekitSpeechmatics: 'livekit-speechmatics',
    GoogleLivekitSpeechmatics: 'google-livekit-speechmatics',
    GoogleGemini: 'google-gemini',
    GeminiTranscribeFlash: 'gemini-transcribe-flash'
} as const;

export type VisitTranscriptionSessionDtoProviderEnum = typeof VisitTranscriptionSessionDtoProviderEnum[keyof typeof VisitTranscriptionSessionDtoProviderEnum];
export const VisitTranscriptionSessionDtoStatusEnum = {
    Recording: 'recording',
    Finalizing: 'finalizing',
    Completed: 'completed',
    Failed: 'failed'
} as const;

export type VisitTranscriptionSessionDtoStatusEnum = typeof VisitTranscriptionSessionDtoStatusEnum[keyof typeof VisitTranscriptionSessionDtoStatusEnum];

/**
 *
 * @export
 * @interface VisitTypeCategoryConfigDto
 */
export interface VisitTypeCategoryConfigDto {
    /**
     *
     * @type {string}
     * @memberof VisitTypeCategoryConfigDto
     */
    'visitType': VisitTypeCategoryConfigDtoVisitTypeEnum;
    /**
     *
     * @type {string}
     * @memberof VisitTypeCategoryConfigDto
     */
    'category': VisitTypeCategoryConfigDtoCategoryEnum;
}

export const VisitTypeCategoryConfigDtoVisitTypeEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type VisitTypeCategoryConfigDtoVisitTypeEnum = typeof VisitTypeCategoryConfigDtoVisitTypeEnum[keyof typeof VisitTypeCategoryConfigDtoVisitTypeEnum];
export const VisitTypeCategoryConfigDtoCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type VisitTypeCategoryConfigDtoCategoryEnum = typeof VisitTypeCategoryConfigDtoCategoryEnum[keyof typeof VisitTypeCategoryConfigDtoCategoryEnum];

/**
 *
 * @export
 * @interface VoiceAllowanceMonthResponseDto
 */
export interface VoiceAllowanceMonthResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceAllowanceMonthResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceAllowanceMonthResponseDto
     */
    'warsawMonth': string;
    /**
     *
     * @type {number}
     * @memberof VoiceAllowanceMonthResponseDto
     */
    'recurringBaseGrantMs': number;
    /**
     *
     * @type {number}
     * @memberof VoiceAllowanceMonthResponseDto
     */
    'topUpMs': number;
    /**
     *
     * @type {number}
     * @memberof VoiceAllowanceMonthResponseDto
     */
    'grantedMs': number;
    /**
     *
     * @type {number}
     * @memberof VoiceAllowanceMonthResponseDto
     */
    'usedMs': number;
    /**
     *
     * @type {number}
     * @memberof VoiceAllowanceMonthResponseDto
     */
    'reservedMs': number;
    /**
     *
     * @type {number}
     * @memberof VoiceAllowanceMonthResponseDto
     */
    'acceptedCallCount': number;
    /**
     *
     * @type {number}
     * @memberof VoiceAllowanceMonthResponseDto
     */
    'nextMonthRecurringBaseGrantMs': number | null;
    /**
     *
     * @type {string}
     * @memberof VoiceAllowanceMonthResponseDto
     */
    'provisionedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceAllowanceMonthResponseDto
     */
    'updatedAt': string;
}
/**
 *
 * @export
 * @interface VoiceBookingPolicyCurrentResponseDto
 */
export interface VoiceBookingPolicyCurrentResponseDto {
    /**
     *
     * @type {VoiceBookingPolicySnapshotResponseDto}
     * @memberof VoiceBookingPolicyCurrentResponseDto
     */
    'current': VoiceBookingPolicySnapshotResponseDto | null;
}
/**
 *
 * @export
 * @interface VoiceBookingPolicyHistoryResponseDto
 */
export interface VoiceBookingPolicyHistoryResponseDto {
    /**
     *
     * @type {VoiceBookingPolicySnapshotResponseDto}
     * @memberof VoiceBookingPolicyHistoryResponseDto
     */
    'current': VoiceBookingPolicySnapshotResponseDto | null;
    /**
     *
     * @type {number}
     * @memberof VoiceBookingPolicyHistoryResponseDto
     */
    'currentPolicyFence': number;
    /**
     *
     * @type {Array<VoiceBookingPolicySnapshotResponseDto>}
     * @memberof VoiceBookingPolicyHistoryResponseDto
     */
    'published': Array<VoiceBookingPolicySnapshotResponseDto>;
}
/**
 *
 * @export
 * @interface VoiceBookingPolicySnapshotDto
 */
export interface VoiceBookingPolicySnapshotDto {
    /**
     *
     * @type {string}
     * @memberof VoiceBookingPolicySnapshotDto
     */
    'serviceId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceBookingPolicySnapshotDto
     */
    'serviceRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceBookingPolicySnapshotDto
     */
    'priceCommunicationPolicy': VoiceBookingPolicySnapshotDtoPriceCommunicationPolicyEnum;
}

export const VoiceBookingPolicySnapshotDtoPriceCommunicationPolicyEnum = {
    Exact: 'EXACT',
    From: 'FROM',
    DoNotQuote: 'DO_NOT_QUOTE'
} as const;

export type VoiceBookingPolicySnapshotDtoPriceCommunicationPolicyEnum = typeof VoiceBookingPolicySnapshotDtoPriceCommunicationPolicyEnum[keyof typeof VoiceBookingPolicySnapshotDtoPriceCommunicationPolicyEnum];

/**
 *
 * @export
 * @interface VoiceBookingPolicySnapshotResponseDto
 */
export interface VoiceBookingPolicySnapshotResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceBookingPolicySnapshotResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceBookingPolicySnapshotResponseDto
     */
    'revision': number;
    /**
     *
     * @type {number}
     * @memberof VoiceBookingPolicySnapshotResponseDto
     */
    'policyFence': number;
    /**
     *
     * @type {number}
     * @memberof VoiceBookingPolicySnapshotResponseDto
     */
    'publishedPolicyFence': number;
    /**
     *
     * @type {Array<VoiceBookingServicePolicyDto>}
     * @memberof VoiceBookingPolicySnapshotResponseDto
     */
    'services': Array<VoiceBookingServicePolicyDto>;
    /**
     *
     * @type {string}
     * @memberof VoiceBookingPolicySnapshotResponseDto
     */
    'changedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceBookingPolicySnapshotResponseDto
     */
    'actorReferenceKind': VoiceBookingPolicySnapshotResponseDtoActorReferenceKindEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceBookingPolicySnapshotResponseDto
     */
    'actorUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceBookingPolicySnapshotResponseDto
     */
    'actorPseudonym': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceBookingPolicySnapshotResponseDto
     */
    'actorErasedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceBookingPolicySnapshotResponseDto
     */
    'reason': VoiceBookingPolicySnapshotResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceBookingPolicySnapshotResponseDto
     */
    'note': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceBookingPolicySnapshotResponseDto
     */
    'supersededAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceBookingPolicySnapshotResponseDto
     */
    'retainUntil': string | null;
}

export const VoiceBookingPolicySnapshotResponseDtoActorReferenceKindEnum = {
    UserId: 'USER_ID',
    ErasedPseudonym: 'ERASED_PSEUDONYM'
} as const;

export type VoiceBookingPolicySnapshotResponseDtoActorReferenceKindEnum = typeof VoiceBookingPolicySnapshotResponseDtoActorReferenceKindEnum[keyof typeof VoiceBookingPolicySnapshotResponseDtoActorReferenceKindEnum];
export const VoiceBookingPolicySnapshotResponseDtoReasonEnum = {
    InitialConfiguration: 'INITIAL_CONFIGURATION',
    ServicePolicyUpdate: 'SERVICE_POLICY_UPDATE'
} as const;

export type VoiceBookingPolicySnapshotResponseDtoReasonEnum = typeof VoiceBookingPolicySnapshotResponseDtoReasonEnum[keyof typeof VoiceBookingPolicySnapshotResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface VoiceBookingPriceEvidenceDto
 */
export interface VoiceBookingPriceEvidenceDto {
    /**
     *
     * @type {string}
     * @memberof VoiceBookingPriceEvidenceDto
     */
    'referenceId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceBookingPriceEvidenceDto
     */
    'revision': number;
}
/**
 *
 * @export
 * @interface VoiceBookingQualificationAuthorityDto
 */
export interface VoiceBookingQualificationAuthorityDto {
    /**
     *
     * @type {string}
     * @memberof VoiceBookingQualificationAuthorityDto
     */
    'authorityId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceBookingQualificationAuthorityDto
     */
    'authorityRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceBookingQualificationAuthorityDto
     */
    'subjectRevision': string;
}
/**
 *
 * @export
 * @interface VoiceBookingQualificationAuthorityResponseDto
 */
export interface VoiceBookingQualificationAuthorityResponseDto {
    /**
     *
     * @type {VoiceBookingQualificationAuthorityDto}
     * @memberof VoiceBookingQualificationAuthorityResponseDto
     */
    'authority': VoiceBookingQualificationAuthorityDto | null;
}
/**
 *
 * @export
 * @interface VoiceBookingServicePolicyDto
 */
export interface VoiceBookingServicePolicyDto {
    /**
     *
     * @type {string}
     * @memberof VoiceBookingServicePolicyDto
     */
    'serviceId': string;
    /**
     *
     * @type {boolean}
     * @memberof VoiceBookingServicePolicyDto
     */
    'enabled': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceBookingServicePolicyDto
     */
    'allowlisted': boolean;
    /**
     *
     * @type {string}
     * @memberof VoiceBookingServicePolicyDto
     */
    'visitType': VoiceBookingServicePolicyDtoVisitTypeEnum;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceBookingServicePolicyDto
     */
    'canonicalNames': Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceBookingServicePolicyDto
     */
    'aliases': Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceBookingServicePolicyDto
     */
    'nonClinicalRoutingText': Array<string>;
    /**
     *
     * @type {string}
     * @memberof VoiceBookingServicePolicyDto
     */
    'priceCommunicationPolicy': VoiceBookingServicePolicyDtoPriceCommunicationPolicyEnum;
    /**
     *
     * @type {VoiceBookingPriceEvidenceDto}
     * @memberof VoiceBookingServicePolicyDto
     */
    'priceEvidence': VoiceBookingPriceEvidenceDto;
}

export const VoiceBookingServicePolicyDtoVisitTypeEnum = {
    Onsite: 'ONSITE'
} as const;

export type VoiceBookingServicePolicyDtoVisitTypeEnum = typeof VoiceBookingServicePolicyDtoVisitTypeEnum[keyof typeof VoiceBookingServicePolicyDtoVisitTypeEnum];
export const VoiceBookingServicePolicyDtoPriceCommunicationPolicyEnum = {
    Exact: 'EXACT',
    From: 'FROM',
    DoNotQuote: 'DO_NOT_QUOTE'
} as const;

export type VoiceBookingServicePolicyDtoPriceCommunicationPolicyEnum = typeof VoiceBookingServicePolicyDtoPriceCommunicationPolicyEnum[keyof typeof VoiceBookingServicePolicyDtoPriceCommunicationPolicyEnum];

/**
 *
 * @export
 * @interface VoiceCostReconciliationComponentEvidenceDto
 */
export interface VoiceCostReconciliationComponentEvidenceDto {
    /**
     *
     * @type {string}
     * @memberof VoiceCostReconciliationComponentEvidenceDto
     */
    'component': VoiceCostReconciliationComponentEvidenceDtoComponentEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceCostReconciliationComponentEvidenceDto
     */
    'actualQuantity': number;
    /**
     *
     * @type {string}
     * @memberof VoiceCostReconciliationComponentEvidenceDto
     */
    'evidenceReference': string;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceCostReconciliationComponentEvidenceDto
     */
    'occurredAt': Array<string>;
}

export const VoiceCostReconciliationComponentEvidenceDtoComponentEnum = {
    Vertex: 'VERTEX',
    TwilioInboundVoice: 'TWILIO_INBOUND_VOICE',
    MediaStreams: 'MEDIA_STREAMS',
    BoundedTransfer: 'BOUNDED_TRANSFER',
    VoiceSms: 'VOICE_SMS',
    ContactCapabilityLookup: 'CONTACT_CAPABILITY_LOOKUP',
    FallbackSpeech: 'FALLBACK_SPEECH'
} as const;

export type VoiceCostReconciliationComponentEvidenceDtoComponentEnum = typeof VoiceCostReconciliationComponentEvidenceDtoComponentEnum[keyof typeof VoiceCostReconciliationComponentEvidenceDtoComponentEnum];

/**
 *
 * @export
 * @interface VoiceCostReconciliationReceiptResponseDto
 */
export interface VoiceCostReconciliationReceiptResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceCostReconciliationReceiptResponseDto
     */
    'receiptId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceCostReconciliationReceiptResponseDto
     */
    'leaseId': string;
    /**
     *
     * @type {boolean}
     * @memberof VoiceCostReconciliationReceiptResponseDto
     */
    'replayed': boolean;
    /**
     *
     * @type {number}
     * @memberof VoiceCostReconciliationReceiptResponseDto
     */
    'estimatedCostMicrosPln': number;
    /**
     *
     * @type {number}
     * @memberof VoiceCostReconciliationReceiptResponseDto
     */
    'actualCostMicrosPln': number;
    /**
     *
     * @type {boolean}
     * @memberof VoiceCostReconciliationReceiptResponseDto
     */
    'estimateExceeded': boolean;
}
/**
 *
 * @export
 * @interface VoiceDevelopOperatorTrialCommandDto
 */
export interface VoiceDevelopOperatorTrialCommandDto {
    /**
     *
     * @type {string}
     * @memberof VoiceDevelopOperatorTrialCommandDto
     */
    'bindingSha256': string;
}
/**
 *
 * @export
 * @interface VoiceDevelopOperatorTrialCurrentDto
 */
export interface VoiceDevelopOperatorTrialCurrentDto {
    /**
     *
     * @type {object}
     * @memberof VoiceDevelopOperatorTrialCurrentDto
     */
    'developOperatorTrial': object | null;
}
/**
 *
 * @export
 * @interface VoiceDsrGovernanceResponseDto
 */
export interface VoiceDsrGovernanceResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceDsrGovernanceResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrGovernanceResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrGovernanceResponseDto
     */
    'right': VoiceDsrGovernanceResponseDtoRightEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrGovernanceResponseDto
     */
    'status': VoiceDsrGovernanceResponseDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrGovernanceResponseDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrGovernanceResponseDto
     */
    'verifiedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrGovernanceResponseDto
     */
    'temporaryHoldUntil'?: string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrGovernanceResponseDto
     */
    'completedAt'?: string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrGovernanceResponseDto
     */
    'safeReasonCode'?: string | null;
    /**
     *
     * @type {number}
     * @memberof VoiceDsrGovernanceResponseDto
     */
    'targetCount': number;
    /**
     *
     * @type {VoiceDsrTargetCountsResponseDto}
     * @memberof VoiceDsrGovernanceResponseDto
     */
    'targetCounts': VoiceDsrTargetCountsResponseDto;
    /**
     *
     * @type {boolean}
     * @memberof VoiceDsrGovernanceResponseDto
     */
    'targetBindingEvidenceRecorded': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceDsrGovernanceResponseDto
     */
    'fulfillmentEvidenceRecorded': boolean;
    /**
     *
     * @type {number}
     * @memberof VoiceDsrGovernanceResponseDto
     */
    'revision': number;
}

export const VoiceDsrGovernanceResponseDtoRightEnum = {
    Access: 'ACCESS',
    Correction: 'CORRECTION',
    Restriction: 'RESTRICTION',
    Erasure: 'ERASURE'
} as const;

export type VoiceDsrGovernanceResponseDtoRightEnum = typeof VoiceDsrGovernanceResponseDtoRightEnum[keyof typeof VoiceDsrGovernanceResponseDtoRightEnum];
export const VoiceDsrGovernanceResponseDtoStatusEnum = {
    PendingHumanReview: 'PENDING_HUMAN_REVIEW',
    InReview: 'IN_REVIEW',
    Restricted: 'RESTRICTED',
    DeferredByLegalHold: 'DEFERRED_BY_LEGAL_HOLD',
    Completed: 'COMPLETED',
    Rejected: 'REJECTED'
} as const;

export type VoiceDsrGovernanceResponseDtoStatusEnum = typeof VoiceDsrGovernanceResponseDtoStatusEnum[keyof typeof VoiceDsrGovernanceResponseDtoStatusEnum];

/**
 *
 * @export
 * @interface VoiceDsrRevisionCommandDto
 */
export interface VoiceDsrRevisionCommandDto {
    /**
     *
     * @type {number}
     * @memberof VoiceDsrRevisionCommandDto
     */
    'expectedRevision': number;
}
/**
 *
 * @export
 * @interface VoiceDsrTargetCountsResponseDto
 */
export interface VoiceDsrTargetCountsResponseDto {
    /**
     *
     * @type {number}
     * @memberof VoiceDsrTargetCountsResponseDto
     */
    'sessions': number;
    /**
     *
     * @type {number}
     * @memberof VoiceDsrTargetCountsResponseDto
     */
    'callbacks': number;
    /**
     *
     * @type {number}
     * @memberof VoiceDsrTargetCountsResponseDto
     */
    'visits': number;
}
/**
 *
 * @export
 * @interface VoiceExactTextArtifactProvenanceResponseDto
 */
export interface VoiceExactTextArtifactProvenanceResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactProvenanceResponseDto
     */
    'kind': VoiceExactTextArtifactProvenanceResponseDtoKindEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactProvenanceResponseDto
     */
    'serviceId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactProvenanceResponseDto
     */
    'requestId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactProvenanceResponseDto
     */
    'authenticationReceiptSha256': string;
}

export const VoiceExactTextArtifactProvenanceResponseDtoKindEnum = {
    AuthenticatedInternalService: 'AUTHENTICATED_INTERNAL_SERVICE'
} as const;

export type VoiceExactTextArtifactProvenanceResponseDtoKindEnum = typeof VoiceExactTextArtifactProvenanceResponseDtoKindEnum[keyof typeof VoiceExactTextArtifactProvenanceResponseDtoKindEnum];

/**
 *
 * @export
 * @interface VoiceExactTextArtifactResponseDto
 */
export interface VoiceExactTextArtifactResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'purpose': VoiceExactTextArtifactResponseDtoPurposeEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'sourceId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'sourceSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'spokenTextSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'qualifiedReleaseId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'qualifiedReleaseRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'voiceId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'voiceRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'rendererVersion': string;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'assetId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'assetSha256': string;
    /**
     *
     * @type {number}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'durationMs': number;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'observedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'expiresAt': string;
    /**
     *
     * @type {VoiceExactTextArtifactProvenanceResponseDto}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'provenance': VoiceExactTextArtifactProvenanceResponseDto;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'receiptFingerprint': string;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'recordedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'supersededAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceExactTextArtifactResponseDto
     */
    'retainUntil': string | null;
}

export const VoiceExactTextArtifactResponseDtoPurposeEnum = {
    FacilityGreeting: 'FACILITY_GREETING',
    EmergencyGuidance: 'EMERGENCY_GUIDANCE'
} as const;

export type VoiceExactTextArtifactResponseDtoPurposeEnum = typeof VoiceExactTextArtifactResponseDtoPurposeEnum[keyof typeof VoiceExactTextArtifactResponseDtoPurposeEnum];

/**
 *
 * @export
 * @interface VoiceFallbackAssetFactsDto
 */
export interface VoiceFallbackAssetFactsDto {
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackAssetFactsDto
     */
    'purpose': VoiceFallbackAssetFactsDtoPurposeEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackAssetFactsDto
     */
    'assetId': string;
    /**
     * Publiczny adres dokładnego zasobu fallback
     * @type {string}
     * @memberof VoiceFallbackAssetFactsDto
     */
    'publicUrl': string;
    /**
     * Dokładny skrót SHA-256 zasobu
     * @type {string}
     * @memberof VoiceFallbackAssetFactsDto
     */
    'sha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackAssetFactsDto
     */
    'rendererVersion': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackAssetFactsDto
     */
    'buildId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackAssetFactsDto
     */
    'deploymentId': string;
}

export const VoiceFallbackAssetFactsDtoPurposeEnum = {
    TechnicalUnavailable: 'TECHNICAL_UNAVAILABLE',
    TransferFailedClose: 'TRANSFER_FAILED_CLOSE'
} as const;

export type VoiceFallbackAssetFactsDtoPurposeEnum = typeof VoiceFallbackAssetFactsDtoPurposeEnum[keyof typeof VoiceFallbackAssetFactsDtoPurposeEnum];

/**
 *
 * @export
 * @interface VoiceFallbackBundleBindingResponseDto
 */
export interface VoiceFallbackBundleBindingResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleBindingResponseDto
     */
    'lineId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceFallbackBundleBindingResponseDto
     */
    'bundleRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoiceFallbackBundleBindingResponseDto
     */
    'routingFence': number;
    /**
     *
     * @type {VoiceFallbackBundleContentDto}
     * @memberof VoiceFallbackBundleBindingResponseDto
     */
    'content': VoiceFallbackBundleContentDto;
    /**
     *
     * @type {boolean}
     * @memberof VoiceFallbackBundleBindingResponseDto
     */
    'reconciled': boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceFallbackBundleBindingResponseDto
     */
    'reasons': Array<VoiceFallbackBundleBindingResponseDtoReasonsEnum>;
    /**
     *
     * @type {number}
     * @memberof VoiceFallbackBundleBindingResponseDto
     */
    'reconciliationGeneration': number;
    /**
     *
     * @type {VoiceFallbackBundleProviderObservationResponseDto}
     * @memberof VoiceFallbackBundleBindingResponseDto
     */
    'observed': VoiceFallbackBundleProviderObservationResponseDto | null;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleBindingResponseDto
     */
    'observedAt': string | null;
}

export const VoiceFallbackBundleBindingResponseDtoReasonsEnum = {
    NeverReconciled: 'NEVER_RECONCILED',
    ProviderObservationFailed: 'PROVIDER_OBSERVATION_FAILED',
    RegionDrift: 'REGION_DRIFT',
    PrimaryRoutingDrift: 'PRIMARY_ROUTING_DRIFT',
    FallbackRoutingDrift: 'FALLBACK_ROUTING_DRIFT',
    StatusRoutingDrift: 'STATUS_ROUTING_DRIFT',
    StreamRoutingDrift: 'STREAM_ROUTING_DRIFT',
    FallbackDeploymentDrift: 'FALLBACK_DEPLOYMENT_DRIFT',
    FallbackAssetDrift: 'FALLBACK_ASSET_DRIFT',
    ProviderIdentityDrift: 'PROVIDER_IDENTITY_DRIFT',
    LineBindingDrift: 'LINE_BINDING_DRIFT',
    RoutingValidationDrift: 'ROUTING_VALIDATION_DRIFT',
    OrdinaryTwimlDrift: 'ORDINARY_TWIML_DRIFT',
    ProviderEvidenceDrift: 'PROVIDER_EVIDENCE_DRIFT'
} as const;

export type VoiceFallbackBundleBindingResponseDtoReasonsEnum = typeof VoiceFallbackBundleBindingResponseDtoReasonsEnum[keyof typeof VoiceFallbackBundleBindingResponseDtoReasonsEnum];

/**
 *
 * @export
 * @interface VoiceFallbackBundleContentDto
 */
export interface VoiceFallbackBundleContentDto {
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleContentDto
     */
    'region': VoiceFallbackBundleContentDtoRegionEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleContentDto
     */
    'providerAccountSid': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleContentDto
     */
    'incomingPhoneNumberSid': string;
    /**
     *
     * @type {VoiceFallbackLineBindingFactsDto}
     * @memberof VoiceFallbackBundleContentDto
     */
    'lineBinding': VoiceFallbackLineBindingFactsDto;
    /**
     *
     * @type {VoiceFallbackRoutingValidationFactsDto}
     * @memberof VoiceFallbackBundleContentDto
     */
    'routingValidation': VoiceFallbackRoutingValidationFactsDto;
    /**
     *
     * @type {VoiceFallbackBundleEndpointsDto}
     * @memberof VoiceFallbackBundleContentDto
     */
    'endpoints': VoiceFallbackBundleEndpointsDto;
    /**
     *
     * @type {VoiceFallbackDeploymentFactsDto}
     * @memberof VoiceFallbackBundleContentDto
     */
    'fallbackDeployment': VoiceFallbackDeploymentFactsDto;
    /**
     *
     * @type {Array<VoiceFallbackAssetFactsDto>}
     * @memberof VoiceFallbackBundleContentDto
     */
    'assets': Array<VoiceFallbackAssetFactsDto>;
    /**
     *
     * @type {VoiceFallbackOrdinaryTwimlFactsDto}
     * @memberof VoiceFallbackBundleContentDto
     */
    'ordinaryTwiml': VoiceFallbackOrdinaryTwimlFactsDto;
}

export const VoiceFallbackBundleContentDtoRegionEnum = {
    Ie1: 'IE1'
} as const;

export type VoiceFallbackBundleContentDtoRegionEnum = typeof VoiceFallbackBundleContentDtoRegionEnum[keyof typeof VoiceFallbackBundleContentDtoRegionEnum];

/**
 *
 * @export
 * @interface VoiceFallbackBundleEndpointsDto
 */
export interface VoiceFallbackBundleEndpointsDto {
    /**
     *
     * @type {VoiceFallbackWebhookEndpointDto}
     * @memberof VoiceFallbackBundleEndpointsDto
     */
    'primary': VoiceFallbackWebhookEndpointDto;
    /**
     *
     * @type {VoiceFallbackWebhookEndpointDto}
     * @memberof VoiceFallbackBundleEndpointsDto
     */
    'fallback': VoiceFallbackWebhookEndpointDto;
    /**
     *
     * @type {VoiceFallbackWebhookEndpointDto}
     * @memberof VoiceFallbackBundleEndpointsDto
     */
    'status': VoiceFallbackWebhookEndpointDto;
    /**
     * Regionalny adres WSS dla minimalnego handoffu Stream
     * @type {string}
     * @memberof VoiceFallbackBundleEndpointsDto
     */
    'streamUrl': string;
}
/**
 *
 * @export
 * @interface VoiceFallbackBundleProviderObservationResponseDto
 */
export interface VoiceFallbackBundleProviderObservationResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleProviderObservationResponseDto
     */
    'region': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleProviderObservationResponseDto
     */
    'providerAccountSid': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleProviderObservationResponseDto
     */
    'incomingPhoneNumberSid': string;
    /**
     *
     * @type {VoiceFallbackObservedEndpointsResponseDto}
     * @memberof VoiceFallbackBundleProviderObservationResponseDto
     */
    'endpoints': VoiceFallbackObservedEndpointsResponseDto;
    /**
     *
     * @type {VoiceFallbackObservedDeploymentFactsResponseDto}
     * @memberof VoiceFallbackBundleProviderObservationResponseDto
     */
    'fallbackDeployment': VoiceFallbackObservedDeploymentFactsResponseDto;
    /**
     *
     * @type {Array<VoiceFallbackObservedAssetFactsResponseDto>}
     * @memberof VoiceFallbackBundleProviderObservationResponseDto
     */
    'assets': Array<VoiceFallbackObservedAssetFactsResponseDto>;
    /**
     *
     * @type {VoiceFallbackObservedOrdinaryTwimlFactsResponseDto}
     * @memberof VoiceFallbackBundleProviderObservationResponseDto
     */
    'ordinaryTwiml': VoiceFallbackObservedOrdinaryTwimlFactsResponseDto;
    /**
     *
     * @type {VoiceFallbackObservedVerificationFactsResponseDto}
     * @memberof VoiceFallbackBundleProviderObservationResponseDto
     */
    'verification': VoiceFallbackObservedVerificationFactsResponseDto;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleProviderObservationResponseDto
     */
    'observedAt': string;
}
/**
 *
 * @export
 * @interface VoiceFallbackBundleRevisionResponseDto
 */
export interface VoiceFallbackBundleRevisionResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleRevisionResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleRevisionResponseDto
     */
    'lineId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceFallbackBundleRevisionResponseDto
     */
    'revision': number;
    /**
     *
     * @type {number}
     * @memberof VoiceFallbackBundleRevisionResponseDto
     */
    'routingFence': number;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleRevisionResponseDto
     */
    'approvalId': string;
    /**
     *
     * @type {VoiceFallbackBundleContentDto}
     * @memberof VoiceFallbackBundleRevisionResponseDto
     */
    'content': VoiceFallbackBundleContentDto;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleRevisionResponseDto
     */
    'actorUserId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleRevisionResponseDto
     */
    'reason': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleRevisionResponseDto
     */
    'publishedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleRevisionResponseDto
     */
    'supersededAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackBundleRevisionResponseDto
     */
    'retainUntil': string | null;
}
/**
 *
 * @export
 * @interface VoiceFallbackContentApprovalHistoryResponseDto
 */
export interface VoiceFallbackContentApprovalHistoryResponseDto {
    /**
     *
     * @type {VoiceFallbackContentProposalResponseDto}
     * @memberof VoiceFallbackContentApprovalHistoryResponseDto
     */
    'proposal': VoiceFallbackContentProposalResponseDto;
    /**
     *
     * @type {VoiceFallbackContentApprovalResponseDto}
     * @memberof VoiceFallbackContentApprovalHistoryResponseDto
     */
    'approval': VoiceFallbackContentApprovalResponseDto | null;
}
/**
 *
 * @export
 * @interface VoiceFallbackContentApprovalResponseDto
 */
export interface VoiceFallbackContentApprovalResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackContentApprovalResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackContentApprovalResponseDto
     */
    'proposalId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackContentApprovalResponseDto
     */
    'lineId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackContentApprovalResponseDto
     */
    'ordinaryContentSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackContentApprovalResponseDto
     */
    'proposedByUserId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackContentApprovalResponseDto
     */
    'approvedByUserId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackContentApprovalResponseDto
     */
    'reason': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackContentApprovalResponseDto
     */
    'approvedAt': string;
}
/**
 *
 * @export
 * @interface VoiceFallbackContentProposalResponseDto
 */
export interface VoiceFallbackContentProposalResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackContentProposalResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackContentProposalResponseDto
     */
    'lineId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackContentProposalResponseDto
     */
    'ordinaryContentSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackContentProposalResponseDto
     */
    'proposedByUserId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackContentProposalResponseDto
     */
    'reason': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackContentProposalResponseDto
     */
    'proposedAt': string;
}
/**
 *
 * @export
 * @interface VoiceFallbackDeploymentFactsDto
 */
export interface VoiceFallbackDeploymentFactsDto {
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackDeploymentFactsDto
     */
    'region': VoiceFallbackDeploymentFactsDtoRegionEnum;
    /**
     * Niezależny origin HTTPS wdrożenia fallback
     * @type {string}
     * @memberof VoiceFallbackDeploymentFactsDto
     */
    'origin': string;
    /**
     * Dokładny regionalny webhook fallback HTTPS
     * @type {string}
     * @memberof VoiceFallbackDeploymentFactsDto
     */
    'fallbackWebhookUrl': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackDeploymentFactsDto
     */
    'fallbackWebhookMethod': VoiceFallbackDeploymentFactsDtoFallbackWebhookMethodEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackDeploymentFactsDto
     */
    'serviceId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackDeploymentFactsDto
     */
    'buildId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackDeploymentFactsDto
     */
    'deploymentId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackDeploymentFactsDto
     */
    'rendererVersion': string;
    /**
     * Skrót manifestu niezmiennego wdrożenia
     * @type {string}
     * @memberof VoiceFallbackDeploymentFactsDto
     */
    'artifactManifestSha256': string;
}

export const VoiceFallbackDeploymentFactsDtoRegionEnum = {
    Ie1: 'IE1'
} as const;

export type VoiceFallbackDeploymentFactsDtoRegionEnum = typeof VoiceFallbackDeploymentFactsDtoRegionEnum[keyof typeof VoiceFallbackDeploymentFactsDtoRegionEnum];
export const VoiceFallbackDeploymentFactsDtoFallbackWebhookMethodEnum = {
    Post: 'POST'
} as const;

export type VoiceFallbackDeploymentFactsDtoFallbackWebhookMethodEnum = typeof VoiceFallbackDeploymentFactsDtoFallbackWebhookMethodEnum[keyof typeof VoiceFallbackDeploymentFactsDtoFallbackWebhookMethodEnum];

/**
 *
 * @export
 * @interface VoiceFallbackLineBindingFactsDto
 */
export interface VoiceFallbackLineBindingFactsDto {
    /**
     *
     * @type {number}
     * @memberof VoiceFallbackLineBindingFactsDto
     */
    'voiceLineAssignmentRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoiceFallbackLineBindingFactsDto
     */
    'routingFence': number;
    /**
     * Kanoniczny numer E.164 Voice Line
     * @type {string}
     * @memberof VoiceFallbackLineBindingFactsDto
     */
    'voiceLineE164': string;
    /**
     * Kanoniczny zwykły cel przekierowania E.164
     * @type {string}
     * @memberof VoiceFallbackLineBindingFactsDto
     */
    'ordinaryDestinationE164': string;
    /**
     * Znany źródłowy numer przekierowania E.164
     * @type {string}
     * @memberof VoiceFallbackLineBindingFactsDto
     */
    'upstreamForwardingE164': string;
}
/**
 *
 * @export
 * @interface VoiceFallbackObservedAssetFactsResponseDto
 */
export interface VoiceFallbackObservedAssetFactsResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedAssetFactsResponseDto
     */
    'purpose': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedAssetFactsResponseDto
     */
    'assetId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedAssetFactsResponseDto
     */
    'publicUrl': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedAssetFactsResponseDto
     */
    'sha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedAssetFactsResponseDto
     */
    'rendererVersion': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedAssetFactsResponseDto
     */
    'buildId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedAssetFactsResponseDto
     */
    'deploymentId': string;
}
/**
 *
 * @export
 * @interface VoiceFallbackObservedDeploymentFactsResponseDto
 */
export interface VoiceFallbackObservedDeploymentFactsResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedDeploymentFactsResponseDto
     */
    'region': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedDeploymentFactsResponseDto
     */
    'origin': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedDeploymentFactsResponseDto
     */
    'fallbackWebhookUrl': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedDeploymentFactsResponseDto
     */
    'fallbackWebhookMethod': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedDeploymentFactsResponseDto
     */
    'serviceId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedDeploymentFactsResponseDto
     */
    'buildId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedDeploymentFactsResponseDto
     */
    'deploymentId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedDeploymentFactsResponseDto
     */
    'rendererVersion': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedDeploymentFactsResponseDto
     */
    'artifactManifestSha256': string;
}
/**
 *
 * @export
 * @interface VoiceFallbackObservedEndpointsResponseDto
 */
export interface VoiceFallbackObservedEndpointsResponseDto {
    /**
     *
     * @type {VoiceFallbackObservedWebhookEndpointResponseDto}
     * @memberof VoiceFallbackObservedEndpointsResponseDto
     */
    'primary': VoiceFallbackObservedWebhookEndpointResponseDto;
    /**
     *
     * @type {VoiceFallbackObservedWebhookEndpointResponseDto}
     * @memberof VoiceFallbackObservedEndpointsResponseDto
     */
    'fallback': VoiceFallbackObservedWebhookEndpointResponseDto;
    /**
     *
     * @type {VoiceFallbackObservedWebhookEndpointResponseDto}
     * @memberof VoiceFallbackObservedEndpointsResponseDto
     */
    'status': VoiceFallbackObservedWebhookEndpointResponseDto;
}
/**
 *
 * @export
 * @interface VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
 */
export interface VoiceFallbackObservedOrdinaryTwimlFactsResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
     */
    'formatVersion': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
     */
    'artifactId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
     */
    'publicUrl': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
     */
    'sha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
     */
    'mediaType': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
     */
    'rendererVersion': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
     */
    'buildId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
     */
    'deploymentId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
     */
    'technicalUnavailableAssetSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
     */
    'transferFailedAssetSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
     */
    'ordinaryDestinationE164': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
     */
    'dialActionUrl': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
     */
    'dialMethod': string;
    /**
     *
     * @type {number}
     * @memberof VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
     */
    'dialTimeoutSeconds': number;
    /**
     *
     * @type {number}
     * @memberof VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
     */
    'dialTimeLimitSeconds': number;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedOrdinaryTwimlFactsResponseDto
     */
    'record': string;
}
/**
 *
 * @export
 * @interface VoiceFallbackObservedVerificationFactsResponseDto
 */
export interface VoiceFallbackObservedVerificationFactsResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedVerificationFactsResponseDto
     */
    'version': VoiceFallbackObservedVerificationFactsResponseDtoVersionEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedVerificationFactsResponseDto
     */
    'providerConfigurationSource': VoiceFallbackObservedVerificationFactsResponseDtoProviderConfigurationSourceEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedVerificationFactsResponseDto
     */
    'serverlessDeploymentSource': VoiceFallbackObservedVerificationFactsResponseDtoServerlessDeploymentSourceEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedVerificationFactsResponseDto
     */
    'artifactContentSource': VoiceFallbackObservedVerificationFactsResponseDtoArtifactContentSourceEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedVerificationFactsResponseDto
     */
    'environmentId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedVerificationFactsResponseDto
     */
    'manifestAssetUrl': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedVerificationFactsResponseDto
     */
    'buildResourcesSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedVerificationFactsResponseDto
     */
    'fallbackFunctionSourceSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedVerificationFactsResponseDto
     */
    'dialResultFunctionSourceSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedVerificationFactsResponseDto
     */
    'evidenceSha256': string;
}

export const VoiceFallbackObservedVerificationFactsResponseDtoVersionEnum = {
    TwilioFallbackObservationV2: 'TWILIO_FALLBACK_OBSERVATION_V2'
} as const;

export type VoiceFallbackObservedVerificationFactsResponseDtoVersionEnum = typeof VoiceFallbackObservedVerificationFactsResponseDtoVersionEnum[keyof typeof VoiceFallbackObservedVerificationFactsResponseDtoVersionEnum];
export const VoiceFallbackObservedVerificationFactsResponseDtoProviderConfigurationSourceEnum = {
    TwilioNumberAndRoutesApi: 'TWILIO_NUMBER_AND_ROUTES_API'
} as const;

export type VoiceFallbackObservedVerificationFactsResponseDtoProviderConfigurationSourceEnum = typeof VoiceFallbackObservedVerificationFactsResponseDtoProviderConfigurationSourceEnum[keyof typeof VoiceFallbackObservedVerificationFactsResponseDtoProviderConfigurationSourceEnum];
export const VoiceFallbackObservedVerificationFactsResponseDtoServerlessDeploymentSourceEnum = {
    TwilioServerlessApi: 'TWILIO_SERVERLESS_API'
} as const;

export type VoiceFallbackObservedVerificationFactsResponseDtoServerlessDeploymentSourceEnum = typeof VoiceFallbackObservedVerificationFactsResponseDtoServerlessDeploymentSourceEnum[keyof typeof VoiceFallbackObservedVerificationFactsResponseDtoServerlessDeploymentSourceEnum];
export const VoiceFallbackObservedVerificationFactsResponseDtoArtifactContentSourceEnum = {
    TwilioDeployedProtectedBytes: 'TWILIO_DEPLOYED_PROTECTED_BYTES'
} as const;

export type VoiceFallbackObservedVerificationFactsResponseDtoArtifactContentSourceEnum = typeof VoiceFallbackObservedVerificationFactsResponseDtoArtifactContentSourceEnum[keyof typeof VoiceFallbackObservedVerificationFactsResponseDtoArtifactContentSourceEnum];

/**
 *
 * @export
 * @interface VoiceFallbackObservedWebhookEndpointResponseDto
 */
export interface VoiceFallbackObservedWebhookEndpointResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedWebhookEndpointResponseDto
     */
    'url': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackObservedWebhookEndpointResponseDto
     */
    'method': string;
}
/**
 *
 * @export
 * @interface VoiceFallbackOrdinaryTwimlFactsDto
 */
export interface VoiceFallbackOrdinaryTwimlFactsDto {
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackOrdinaryTwimlFactsDto
     */
    'formatVersion': VoiceFallbackOrdinaryTwimlFactsDtoFormatVersionEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackOrdinaryTwimlFactsDto
     */
    'artifactId': string;
    /**
     * Publiczny niezmienny artefakt TwiML
     * @type {string}
     * @memberof VoiceFallbackOrdinaryTwimlFactsDto
     */
    'publicUrl': string;
    /**
     * Skrót deterministycznego artefaktu TwiML
     * @type {string}
     * @memberof VoiceFallbackOrdinaryTwimlFactsDto
     */
    'sha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackOrdinaryTwimlFactsDto
     */
    'mediaType': VoiceFallbackOrdinaryTwimlFactsDtoMediaTypeEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackOrdinaryTwimlFactsDto
     */
    'rendererVersion': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackOrdinaryTwimlFactsDto
     */
    'buildId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackOrdinaryTwimlFactsDto
     */
    'deploymentId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackOrdinaryTwimlFactsDto
     */
    'technicalUnavailableAssetSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackOrdinaryTwimlFactsDto
     */
    'transferFailedAssetSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackOrdinaryTwimlFactsDto
     */
    'ordinaryDestinationE164': string;
    /**
     * Niezależny regionalny Dial action HTTPS
     * @type {string}
     * @memberof VoiceFallbackOrdinaryTwimlFactsDto
     */
    'dialActionUrl': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackOrdinaryTwimlFactsDto
     */
    'dialMethod': VoiceFallbackOrdinaryTwimlFactsDtoDialMethodEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceFallbackOrdinaryTwimlFactsDto
     */
    'dialTimeoutSeconds': VoiceFallbackOrdinaryTwimlFactsDtoDialTimeoutSecondsEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceFallbackOrdinaryTwimlFactsDto
     */
    'dialTimeLimitSeconds': VoiceFallbackOrdinaryTwimlFactsDtoDialTimeLimitSecondsEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackOrdinaryTwimlFactsDto
     */
    'record': VoiceFallbackOrdinaryTwimlFactsDtoRecordEnum;
}

export const VoiceFallbackOrdinaryTwimlFactsDtoFormatVersionEnum = {
    Twiml1: 'TWIML_1'
} as const;

export type VoiceFallbackOrdinaryTwimlFactsDtoFormatVersionEnum = typeof VoiceFallbackOrdinaryTwimlFactsDtoFormatVersionEnum[keyof typeof VoiceFallbackOrdinaryTwimlFactsDtoFormatVersionEnum];
export const VoiceFallbackOrdinaryTwimlFactsDtoMediaTypeEnum = {
    ApplicationXml: 'application/xml'
} as const;

export type VoiceFallbackOrdinaryTwimlFactsDtoMediaTypeEnum = typeof VoiceFallbackOrdinaryTwimlFactsDtoMediaTypeEnum[keyof typeof VoiceFallbackOrdinaryTwimlFactsDtoMediaTypeEnum];
export const VoiceFallbackOrdinaryTwimlFactsDtoDialMethodEnum = {
    Post: 'POST'
} as const;

export type VoiceFallbackOrdinaryTwimlFactsDtoDialMethodEnum = typeof VoiceFallbackOrdinaryTwimlFactsDtoDialMethodEnum[keyof typeof VoiceFallbackOrdinaryTwimlFactsDtoDialMethodEnum];
export const VoiceFallbackOrdinaryTwimlFactsDtoDialTimeoutSecondsEnum = {
    NUMBER_20: 20
} as const;

export type VoiceFallbackOrdinaryTwimlFactsDtoDialTimeoutSecondsEnum = typeof VoiceFallbackOrdinaryTwimlFactsDtoDialTimeoutSecondsEnum[keyof typeof VoiceFallbackOrdinaryTwimlFactsDtoDialTimeoutSecondsEnum];
export const VoiceFallbackOrdinaryTwimlFactsDtoDialTimeLimitSecondsEnum = {
    NUMBER_900: 900
} as const;

export type VoiceFallbackOrdinaryTwimlFactsDtoDialTimeLimitSecondsEnum = typeof VoiceFallbackOrdinaryTwimlFactsDtoDialTimeLimitSecondsEnum[keyof typeof VoiceFallbackOrdinaryTwimlFactsDtoDialTimeLimitSecondsEnum];
export const VoiceFallbackOrdinaryTwimlFactsDtoRecordEnum = {
    DoNotRecord: 'do-not-record'
} as const;

export type VoiceFallbackOrdinaryTwimlFactsDtoRecordEnum = typeof VoiceFallbackOrdinaryTwimlFactsDtoRecordEnum[keyof typeof VoiceFallbackOrdinaryTwimlFactsDtoRecordEnum];

/**
 *
 * @export
 * @interface VoiceFallbackRoutingValidationFactsDto
 */
export interface VoiceFallbackRoutingValidationFactsDto {
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackRoutingValidationFactsDto
     */
    'version': VoiceFallbackRoutingValidationFactsDtoVersionEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceFallbackRoutingValidationFactsDto
     */
    'voiceLineAssignmentRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoiceFallbackRoutingValidationFactsDto
     */
    'routingFence': number;
    /**
     *
     * @type {number}
     * @memberof VoiceFallbackRoutingValidationFactsDto
     */
    'validationFence': number;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackRoutingValidationFactsDto
     */
    'result': VoiceFallbackRoutingValidationFactsDtoResultEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackRoutingValidationFactsDto
     */
    'validationReceiptId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackRoutingValidationFactsDto
     */
    'validatedAt': string;
    /**
     * Skrót dowodu walidacji pętli
     * @type {string}
     * @memberof VoiceFallbackRoutingValidationFactsDto
     */
    'evidenceSha256': string;
}

export const VoiceFallbackRoutingValidationFactsDtoVersionEnum = {
    VoiceRoutingLoopCheckV1: 'VOICE_ROUTING_LOOP_CHECK_V1'
} as const;

export type VoiceFallbackRoutingValidationFactsDtoVersionEnum = typeof VoiceFallbackRoutingValidationFactsDtoVersionEnum[keyof typeof VoiceFallbackRoutingValidationFactsDtoVersionEnum];
export const VoiceFallbackRoutingValidationFactsDtoResultEnum = {
    NonLooping: 'NON_LOOPING'
} as const;

export type VoiceFallbackRoutingValidationFactsDtoResultEnum = typeof VoiceFallbackRoutingValidationFactsDtoResultEnum[keyof typeof VoiceFallbackRoutingValidationFactsDtoResultEnum];

/**
 *
 * @export
 * @interface VoiceFallbackWebhookEndpointDto
 */
export interface VoiceFallbackWebhookEndpointDto {
    /**
     * Regionalny adres webhooka HTTPS
     * @type {string}
     * @memberof VoiceFallbackWebhookEndpointDto
     */
    'url': string;
    /**
     *
     * @type {string}
     * @memberof VoiceFallbackWebhookEndpointDto
     */
    'method': VoiceFallbackWebhookEndpointDtoMethodEnum;
}

export const VoiceFallbackWebhookEndpointDtoMethodEnum = {
    Post: 'POST'
} as const;

export type VoiceFallbackWebhookEndpointDtoMethodEnum = typeof VoiceFallbackWebhookEndpointDtoMethodEnum[keyof typeof VoiceFallbackWebhookEndpointDtoMethodEnum];

/**
 *
 * @export
 * @interface VoiceLineAssignmentEventResponseDto
 */
export interface VoiceLineAssignmentEventResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentEventResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentEventResponseDto
     */
    'assignmentId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentEventResponseDto
     */
    'voiceLineId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentEventResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceLineAssignmentEventResponseDto
     */
    'sequence': number;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentEventResponseDto
     */
    'eventType': VoiceLineAssignmentEventResponseDtoEventTypeEnum;
    /**
     *
     * @type {VoiceLineAssignmentState}
     * @memberof VoiceLineAssignmentEventResponseDto
     */
    'fromState': VoiceLineAssignmentState | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentEventResponseDto
     */
    'toState': VoiceLineAssignmentEventResponseDtoToStateEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceLineAssignmentEventResponseDto
     */
    'lineAssignmentRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoiceLineAssignmentEventResponseDto
     */
    'organizationAssignmentRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentEventResponseDto
     */
    'actorUserId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentEventResponseDto
     */
    'reason': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentEventResponseDto
     */
    'note': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentEventResponseDto
     */
    'occurredAt': string;
}

export const VoiceLineAssignmentEventResponseDtoEventTypeEnum = {
    Assigned: 'ASSIGNED',
    DrainRequested: 'DRAIN_REQUESTED',
    Quarantined: 'QUARANTINED'
} as const;

export type VoiceLineAssignmentEventResponseDtoEventTypeEnum = typeof VoiceLineAssignmentEventResponseDtoEventTypeEnum[keyof typeof VoiceLineAssignmentEventResponseDtoEventTypeEnum];
export const VoiceLineAssignmentEventResponseDtoToStateEnum = {
    Active: 'ACTIVE',
    Draining: 'DRAINING',
    Quarantined: 'QUARANTINED'
} as const;

export type VoiceLineAssignmentEventResponseDtoToStateEnum = typeof VoiceLineAssignmentEventResponseDtoToStateEnum[keyof typeof VoiceLineAssignmentEventResponseDtoToStateEnum];

/**
 *
 * @export
 * @interface VoiceLineAssignmentHistoryResponseDto
 */
export interface VoiceLineAssignmentHistoryResponseDto {
    /**
     *
     * @type {VoiceLineAssignmentResponseDto}
     * @memberof VoiceLineAssignmentHistoryResponseDto
     */
    'assignment': VoiceLineAssignmentResponseDto;
    /**
     *
     * @type {Array<VoiceLineAssignmentEventResponseDto>}
     * @memberof VoiceLineAssignmentHistoryResponseDto
     */
    'events': Array<VoiceLineAssignmentEventResponseDto>;
}
/**
 *
 * @export
 * @interface VoiceLineAssignmentResponseDto
 */
export interface VoiceLineAssignmentResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'voiceLineId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'lineAssignmentRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'organizationAssignmentRevision': number;
    /**
     *
     * @type {VoiceLineAssignmentState}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'state': VoiceLineAssignmentState;
    /**
     *
     * @type {boolean}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'occupiesAssignmentSlot': boolean;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'assignedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'assignedByUserId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'providerAccountSid': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'incomingPhoneNumberSid': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'e164': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'desiredVoiceRegion': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'desiredPrimaryWebhookUrl': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'desiredFallbackWebhookUrl': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'desiredStatusCallbackUrl': string;
    /**
     *
     * @type {number}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'activeFallbackBundleRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'activeFallbackDeploymentId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'observedVoiceRegionAtAssignment': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'observedPrimaryWebhookUrlAtAssignment': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'observedFallbackWebhookUrlAtAssignment': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'observedStatusCallbackUrlAtAssignment': string | null;
    /**
     *
     * @type {number}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'observedFallbackBundleRevisionAtAssignment': number | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'observedFallbackDeploymentIdAtAssignment': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'providerObservedAtAssignment': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'drainRequestedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'drainRequestedByUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'quarantinedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'quarantineUntil': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineAssignmentResponseDto
     */
    'updatedAt': string;
}


/**
 *
 * @export
 * @enum {string}
 */

export const VoiceLineAssignmentState = {
    Active: 'ACTIVE',
    Draining: 'DRAINING',
    Quarantined: 'QUARANTINED'
} as const;

export type VoiceLineAssignmentState = typeof VoiceLineAssignmentState[keyof typeof VoiceLineAssignmentState];


/**
 *
 * @export
 * @interface VoiceLineDesiredRoutingResponseDto
 */
export interface VoiceLineDesiredRoutingResponseDto {
    /**
     *
     * @type {VoiceLineDesiredState}
     * @memberof VoiceLineDesiredRoutingResponseDto
     */
    'state': VoiceLineDesiredState;
    /**
     *
     * @type {string}
     * @memberof VoiceLineDesiredRoutingResponseDto
     */
    'voiceRegion': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineDesiredRoutingResponseDto
     */
    'primaryWebhookUrl': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineDesiredRoutingResponseDto
     */
    'fallbackWebhookUrl': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineDesiredRoutingResponseDto
     */
    'statusCallbackUrl': string;
    /**
     *
     * @type {number}
     * @memberof VoiceLineDesiredRoutingResponseDto
     */
    'fallbackBundleRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceLineDesiredRoutingResponseDto
     */
    'fallbackDeploymentId': string;
}


/**
 *
 * @export
 * @enum {string}
 */

export const VoiceLineDesiredState = {
    Managed: 'MANAGED',
    Detached: 'DETACHED'
} as const;

export type VoiceLineDesiredState = typeof VoiceLineDesiredState[keyof typeof VoiceLineDesiredState];


/**
 *
 * @export
 * @interface VoiceLineObservedRoutingResponseDto
 */
export interface VoiceLineObservedRoutingResponseDto {
    /**
     *
     * @type {VoiceLineDesiredState}
     * @memberof VoiceLineObservedRoutingResponseDto
     */
    'state': VoiceLineDesiredState | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineObservedRoutingResponseDto
     */
    'voiceRegion': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineObservedRoutingResponseDto
     */
    'primaryWebhookUrl': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineObservedRoutingResponseDto
     */
    'fallbackWebhookUrl': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineObservedRoutingResponseDto
     */
    'statusCallbackUrl': string | null;
    /**
     *
     * @type {number}
     * @memberof VoiceLineObservedRoutingResponseDto
     */
    'fallbackBundleRevision': number | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineObservedRoutingResponseDto
     */
    'fallbackDeploymentId': string | null;
}


/**
 *
 * @export
 * @interface VoiceLineProviderPrivacyRecoveryBaselineResponseDto
 */
export interface VoiceLineProviderPrivacyRecoveryBaselineResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryBaselineResponseDto
     */
    'lineDesiredState': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryBaselineResponseDto
     */
    'lineDesiredRoutingSha256': string;
    /**
     *
     * @type {VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto}
     * @memberof VoiceLineProviderPrivacyRecoveryBaselineResponseDto
     */
    'fallback': VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto | null;
    /**
     *
     * @type {VoiceLineProviderPrivacyRecoveryEnvelopeSnapshotResponseDto}
     * @memberof VoiceLineProviderPrivacyRecoveryBaselineResponseDto
     */
    'envelope': VoiceLineProviderPrivacyRecoveryEnvelopeSnapshotResponseDto | null;
    /**
     *
     * @type {VoiceLineProviderPrivacyRecoveryDestinationSnapshotResponseDto}
     * @memberof VoiceLineProviderPrivacyRecoveryBaselineResponseDto
     */
    'ordinaryDestination': VoiceLineProviderPrivacyRecoveryDestinationSnapshotResponseDto | null;
    /**
     *
     * @type {VoiceLineProviderPrivacyRecoveryDestinationSnapshotResponseDto}
     * @memberof VoiceLineProviderPrivacyRecoveryBaselineResponseDto
     */
    'emergencyDestination': VoiceLineProviderPrivacyRecoveryDestinationSnapshotResponseDto | null;
    /**
     *
     * @type {VoiceLineProviderPrivacyRecoveryHeadSnapshotResponseDto}
     * @memberof VoiceLineProviderPrivacyRecoveryBaselineResponseDto
     */
    'receptionPolicy': VoiceLineProviderPrivacyRecoveryHeadSnapshotResponseDto | null;
    /**
     *
     * @type {VoiceLineProviderPrivacyRecoveryHeadSnapshotResponseDto}
     * @memberof VoiceLineProviderPrivacyRecoveryBaselineResponseDto
     */
    'emergencyGuidance': VoiceLineProviderPrivacyRecoveryHeadSnapshotResponseDto | null;
    /**
     *
     * @type {number}
     * @memberof VoiceLineProviderPrivacyRecoveryBaselineResponseDto
     */
    'productionQualificationRevision': number | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const VoiceLineProviderPrivacyRecoveryCheckpoint = {
    LineReconciled: 'LINE_RECONCILED',
    RoutingEvidenceRecorded: 'ROUTING_EVIDENCE_RECORDED',
    EnvelopeRestored: 'ENVELOPE_RESTORED',
    DestinationsRestored: 'DESTINATIONS_RESTORED',
    GovernanceRepublished: 'GOVERNANCE_REPUBLISHED',
    QualificationRefreshed: 'QUALIFICATION_REFRESHED',
    Complete: 'COMPLETE'
} as const;

export type VoiceLineProviderPrivacyRecoveryCheckpoint = typeof VoiceLineProviderPrivacyRecoveryCheckpoint[keyof typeof VoiceLineProviderPrivacyRecoveryCheckpoint];


/**
 *
 * @export
 * @interface VoiceLineProviderPrivacyRecoveryDestinationSnapshotResponseDto
 */
export interface VoiceLineProviderPrivacyRecoveryDestinationSnapshotResponseDto {
    /**
     *
     * @type {number}
     * @memberof VoiceLineProviderPrivacyRecoveryDestinationSnapshotResponseDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryDestinationSnapshotResponseDto
     */
    'revisionId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryDestinationSnapshotResponseDto
     */
    'destinationId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryDestinationSnapshotResponseDto
     */
    'configurationSha256': string;
}
/**
 *
 * @export
 * @interface VoiceLineProviderPrivacyRecoveryEnvelopeSnapshotResponseDto
 */
export interface VoiceLineProviderPrivacyRecoveryEnvelopeSnapshotResponseDto {
    /**
     *
     * @type {number}
     * @memberof VoiceLineProviderPrivacyRecoveryEnvelopeSnapshotResponseDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryEnvelopeSnapshotResponseDto
     */
    'revisionId': string;
    /**
     *
     * @type {VoicePilotEnvelopeRecoveryState}
     * @memberof VoiceLineProviderPrivacyRecoveryEnvelopeSnapshotResponseDto
     */
    'state': VoicePilotEnvelopeRecoveryState;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryEnvelopeSnapshotResponseDto
     */
    'configurationSha256': string;
}


/**
 *
 * @export
 * @interface VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto
 */
export interface VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto {
    /**
     *
     * @type {number}
     * @memberof VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto
     */
    'revisionId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto
     */
    'assignmentFence': number;
    /**
     *
     * @type {number}
     * @memberof VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto
     */
    'routingFence': number;
    /**
     *
     * @type {number}
     * @memberof VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto
     */
    'reconciliationGeneration': number;
    /**
     *
     * @type {boolean}
     * @memberof VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto
     */
    'reconciled': boolean;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto
     */
    'ordinaryContentSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto
     */
    'fallbackRuntimeSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto
     */
    'routingTupleSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto
     */
    'fallbackHeadObservationSha256': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto
     */
    'validationReceiptSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto
     */
    'routingApprovalId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto
     */
    'validatedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto
     */
    'validationEvidenceSha256': string;
}
/**
 *
 * @export
 * @interface VoiceLineProviderPrivacyRecoveryHeadSnapshotResponseDto
 */
export interface VoiceLineProviderPrivacyRecoveryHeadSnapshotResponseDto {
    /**
     *
     * @type {number}
     * @memberof VoiceLineProviderPrivacyRecoveryHeadSnapshotResponseDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryHeadSnapshotResponseDto
     */
    'revisionId': string;
}
/**
 *
 * @export
 * @interface VoiceLineProviderPrivacyRecoveryResponseDto
 */
export interface VoiceLineProviderPrivacyRecoveryResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDto
     */
    'recoveryId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDto
     */
    'recoveryRevision': number;
    /**
     *
     * @type {VoiceLineProviderPrivacyRecoveryStatus}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDto
     */
    'status': VoiceLineProviderPrivacyRecoveryStatus;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDto
     */
    'lineId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDto
     */
    'organizationId': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDto
     */
    'assignmentId': string | null;
    /**
     *
     * @type {number}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDto
     */
    'assignmentFence': number;
    /**
     *
     * @type {number}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDto
     */
    'preReopenRoutingFence': number;
    /**
     *
     * @type {number}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDto
     */
    'routingFence': number;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDto
     */
    'reopenedAt': string;
    /**
     *
     * @type {VoiceLineProviderPrivacyRecoveryResponseDtoBaseline}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDto
     */
    'baseline': VoiceLineProviderPrivacyRecoveryResponseDtoBaseline;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDto
     */
    'completedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDto
     */
    'abortedAt': string | null;
}


/**
 * Niezmienny bazowy stan odzyskiwania ograniczony do metadanych; nie zawiera identyfikatorów dostawcy ani numerów telefonu.
 * @export
 * @interface VoiceLineProviderPrivacyRecoveryResponseDtoBaseline
 */
export interface VoiceLineProviderPrivacyRecoveryResponseDtoBaseline {
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDtoBaseline
     */
    'lineDesiredState': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDtoBaseline
     */
    'lineDesiredRoutingSha256': string;
    /**
     *
     * @type {VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDtoBaseline
     */
    'fallback': VoiceLineProviderPrivacyRecoveryFallbackSnapshotResponseDto | null;
    /**
     *
     * @type {VoiceLineProviderPrivacyRecoveryEnvelopeSnapshotResponseDto}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDtoBaseline
     */
    'envelope': VoiceLineProviderPrivacyRecoveryEnvelopeSnapshotResponseDto | null;
    /**
     *
     * @type {VoiceLineProviderPrivacyRecoveryDestinationSnapshotResponseDto}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDtoBaseline
     */
    'ordinaryDestination': VoiceLineProviderPrivacyRecoveryDestinationSnapshotResponseDto | null;
    /**
     *
     * @type {VoiceLineProviderPrivacyRecoveryDestinationSnapshotResponseDto}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDtoBaseline
     */
    'emergencyDestination': VoiceLineProviderPrivacyRecoveryDestinationSnapshotResponseDto | null;
    /**
     *
     * @type {VoiceLineProviderPrivacyRecoveryHeadSnapshotResponseDto}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDtoBaseline
     */
    'receptionPolicy': VoiceLineProviderPrivacyRecoveryHeadSnapshotResponseDto | null;
    /**
     *
     * @type {VoiceLineProviderPrivacyRecoveryHeadSnapshotResponseDto}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDtoBaseline
     */
    'emergencyGuidance': VoiceLineProviderPrivacyRecoveryHeadSnapshotResponseDto | null;
    /**
     *
     * @type {number}
     * @memberof VoiceLineProviderPrivacyRecoveryResponseDtoBaseline
     */
    'productionQualificationRevision': number | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const VoiceLineProviderPrivacyRecoveryStatus = {
    LineReconciliationRequired: 'LINE_RECONCILIATION_REQUIRED',
    RoutingEvidenceRequired: 'ROUTING_EVIDENCE_REQUIRED',
    EnvelopeRestoreRequired: 'ENVELOPE_RESTORE_REQUIRED',
    DestinationRestoreRequired: 'DESTINATION_RESTORE_REQUIRED',
    GovernanceRequired: 'GOVERNANCE_REQUIRED',
    QualificationRequired: 'QUALIFICATION_REQUIRED',
    CompletionRequired: 'COMPLETION_REQUIRED',
    Completed: 'COMPLETED',
    Aborted: 'ABORTED'
} as const;

export type VoiceLineProviderPrivacyRecoveryStatus = typeof VoiceLineProviderPrivacyRecoveryStatus[keyof typeof VoiceLineProviderPrivacyRecoveryStatus];


/**
 *
 * @export
 * @enum {string}
 */

export const VoiceLineReconciliationReason = {
    Phase0ProviderQualificationMissing: 'PHASE_0_PROVIDER_QUALIFICATION_MISSING',
    ProviderReconciliationRequired: 'PROVIDER_RECONCILIATION_REQUIRED',
    DeprovisionReconciliationRequired: 'DEPROVISION_RECONCILIATION_REQUIRED',
    ProviderE164Drift: 'PROVIDER_E164_DRIFT',
    ProviderLifecycleDrift: 'PROVIDER_LIFECYCLE_DRIFT',
    VoiceRegionDrift: 'VOICE_REGION_DRIFT',
    PrimaryWebhookDrift: 'PRIMARY_WEBHOOK_DRIFT',
    FallbackWebhookDrift: 'FALLBACK_WEBHOOK_DRIFT',
    StatusCallbackDrift: 'STATUS_CALLBACK_DRIFT',
    FallbackBundleDeploymentUnreconciled: 'FALLBACK_BUNDLE_DEPLOYMENT_UNRECONCILED',
    ActiveCallsDraining: 'ACTIVE_CALLS_DRAINING',
    DetachDesiredStateNotPublished: 'DETACH_DESIRED_STATE_NOT_PUBLISHED',
    DetachFallbackBundleNotPublished: 'DETACH_FALLBACK_BUNDLE_NOT_PUBLISHED',
    ProviderPrivacySuspended: 'PROVIDER_PRIVACY_SUSPENDED'
} as const;

export type VoiceLineReconciliationReason = typeof VoiceLineReconciliationReason[keyof typeof VoiceLineReconciliationReason];


/**
 *
 * @export
 * @interface VoiceLineReconciliationResponseDto
 */
export interface VoiceLineReconciliationResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceLineReconciliationResponseDto
     */
    'status': VoiceLineReconciliationResponseDtoStatusEnum;
    /**
     *
     * @type {Array<VoiceLineReconciliationReason>}
     * @memberof VoiceLineReconciliationResponseDto
     */
    'reasons': Array<VoiceLineReconciliationReason>;
    /**
     *
     * @type {string}
     * @memberof VoiceLineReconciliationResponseDto
     */
    'attemptedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineReconciliationResponseDto
     */
    'reconciledAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineReconciliationResponseDto
     */
    'providerObservedAt': string | null;
}

export const VoiceLineReconciliationResponseDtoStatusEnum = {
    Pending: 'PENDING',
    Reconciled: 'RECONCILED',
    Drifted: 'DRIFTED',
    Failed: 'FAILED'
} as const;

export type VoiceLineReconciliationResponseDtoStatusEnum = typeof VoiceLineReconciliationResponseDtoStatusEnum[keyof typeof VoiceLineReconciliationResponseDtoStatusEnum];

/**
 *
 * @export
 * @interface VoiceLineResponseDto
 */
export interface VoiceLineResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceLineResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineResponseDto
     */
    'providerAccountSid': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineResponseDto
     */
    'incomingPhoneNumberSid': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineResponseDto
     */
    'e164': string;
    /**
     *
     * @type {VoiceLineDesiredRoutingResponseDto}
     * @memberof VoiceLineResponseDto
     */
    'desired': VoiceLineDesiredRoutingResponseDto;
    /**
     *
     * @type {VoiceLineObservedRoutingResponseDto}
     * @memberof VoiceLineResponseDto
     */
    'observed': VoiceLineObservedRoutingResponseDto | null;
    /**
     *
     * @type {VoiceLineReconciliationResponseDto}
     * @memberof VoiceLineResponseDto
     */
    'reconciliation': VoiceLineReconciliationResponseDto;
    /**
     *
     * @type {number}
     * @memberof VoiceLineResponseDto
     */
    'assignmentFence': number;
    /**
     *
     * @type {number}
     * @memberof VoiceLineResponseDto
     */
    'routingFence': number;
    /**
     *
     * @type {VoiceLineAssignmentResponseDto}
     * @memberof VoiceLineResponseDto
     */
    'currentAssignment': VoiceLineAssignmentResponseDto | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineResponseDto
     */
    'quarantineUntil': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceLineResponseDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceLineResponseDto
     */
    'updatedAt': string;
}
/**
 *
 * @export
 * @interface VoiceMessagingControlCurrentResponseDto
 */
export interface VoiceMessagingControlCurrentResponseDto {
    /**
     *
     * @type {number}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'readinessRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'healthRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'desiredRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'qualificationAuthorityId': VoiceMessagingControlCurrentResponseDtoQualificationAuthorityIdEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'qualificationSubjectRevision': string;
    /**
     *
     * @type {number}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'observedDesiredRevision': number | null;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'qualifiedOrganizationIds': Array<string>;
    /**
     *
     * @type {VoiceMessagingProviderBindingResponseDto}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'desired': VoiceMessagingProviderBindingResponseDto;
    /**
     *
     * @type {VoiceMessagingProviderObservationBindingResponseDto}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'observed': VoiceMessagingProviderObservationBindingResponseDto | null;
    /**
     *
     * @type {number}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'observedSenderPoolSize': number | null;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'reconciliationStatus': VoiceMessagingControlCurrentResponseDtoReconciliationStatusEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'providerObservedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'reconciledAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'providerScanCompletedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'submissionWorkerLastSucceededAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'reconciliationWorkerLastSucceededAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlCurrentResponseDto
     */
    'erasureWorkerLastSucceededAt': string | null;
}

export const VoiceMessagingControlCurrentResponseDtoQualificationAuthorityIdEnum = {
    VoiceMessagingConfig: 'VOICE_MESSAGING_CONFIG'
} as const;

export type VoiceMessagingControlCurrentResponseDtoQualificationAuthorityIdEnum = typeof VoiceMessagingControlCurrentResponseDtoQualificationAuthorityIdEnum[keyof typeof VoiceMessagingControlCurrentResponseDtoQualificationAuthorityIdEnum];
export const VoiceMessagingControlCurrentResponseDtoReconciliationStatusEnum = {
    Pending: 'PENDING',
    Reconciled: 'RECONCILED',
    Drifted: 'DRIFTED'
} as const;

export type VoiceMessagingControlCurrentResponseDtoReconciliationStatusEnum = typeof VoiceMessagingControlCurrentResponseDtoReconciliationStatusEnum[keyof typeof VoiceMessagingControlCurrentResponseDtoReconciliationStatusEnum];

/**
 *
 * @export
 * @interface VoiceMessagingControlDiagnosticsResponseDto
 */
export interface VoiceMessagingControlDiagnosticsResponseDto {
    /**
     *
     * @type {VoiceMessagingControlCurrentResponseDto}
     * @memberof VoiceMessagingControlDiagnosticsResponseDto
     */
    'current': VoiceMessagingControlCurrentResponseDto | null;
    /**
     *
     * @type {boolean}
     * @memberof VoiceMessagingControlDiagnosticsResponseDto
     */
    'betaOrganizationQualified': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceMessagingControlDiagnosticsResponseDto
     */
    'desiredFenceCurrent': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceMessagingControlDiagnosticsResponseDto
     */
    'providerBindingReconciled': boolean;
}
/**
 *
 * @export
 * @interface VoiceMessagingControlHistoryEntryResponseDto
 */
export interface VoiceMessagingControlHistoryEntryResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlHistoryEntryResponseDto
     */
    'requestId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlHistoryEntryResponseDto
     */
    'action': VoiceMessagingControlHistoryEntryResponseDtoActionEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceMessagingControlHistoryEntryResponseDto
     */
    'readinessRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoiceMessagingControlHistoryEntryResponseDto
     */
    'desiredRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlHistoryEntryResponseDto
     */
    'reconciliationStatus': VoiceMessagingControlHistoryEntryResponseDtoReconciliationStatusEnum;
    /**
     *
     * @type {boolean}
     * @memberof VoiceMessagingControlHistoryEntryResponseDto
     */
    'replayed': boolean;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlHistoryEntryResponseDto
     */
    'actorKind': VoiceMessagingControlHistoryEntryResponseDtoActorKindEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlHistoryEntryResponseDto
     */
    'actorId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlHistoryEntryResponseDto
     */
    'organizationId': string | null;
    /**
     *
     * @type {VoiceMessagingProviderBindingResponseDto}
     * @memberof VoiceMessagingControlHistoryEntryResponseDto
     */
    'desired': VoiceMessagingProviderBindingResponseDto | null;
    /**
     *
     * @type {VoiceMessagingProviderObservationBindingResponseDto}
     * @memberof VoiceMessagingControlHistoryEntryResponseDto
     */
    'observed': VoiceMessagingProviderObservationBindingResponseDto | null;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlHistoryEntryResponseDto
     */
    'providerObservedAt': string | null;
    /**
     *
     * @type {number}
     * @memberof VoiceMessagingControlHistoryEntryResponseDto
     */
    'observedSenderPoolSize': number | null;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlHistoryEntryResponseDto
     */
    'recordedAt': string;
}

export const VoiceMessagingControlHistoryEntryResponseDtoActionEnum = {
    DesiredPublished: 'DESIRED_PUBLISHED',
    OrganizationGranted: 'ORGANIZATION_GRANTED',
    OrganizationRevoked: 'ORGANIZATION_REVOKED',
    ProviderReconciled: 'PROVIDER_RECONCILED'
} as const;

export type VoiceMessagingControlHistoryEntryResponseDtoActionEnum = typeof VoiceMessagingControlHistoryEntryResponseDtoActionEnum[keyof typeof VoiceMessagingControlHistoryEntryResponseDtoActionEnum];
export const VoiceMessagingControlHistoryEntryResponseDtoReconciliationStatusEnum = {
    Pending: 'PENDING',
    Reconciled: 'RECONCILED',
    Drifted: 'DRIFTED'
} as const;

export type VoiceMessagingControlHistoryEntryResponseDtoReconciliationStatusEnum = typeof VoiceMessagingControlHistoryEntryResponseDtoReconciliationStatusEnum[keyof typeof VoiceMessagingControlHistoryEntryResponseDtoReconciliationStatusEnum];
export const VoiceMessagingControlHistoryEntryResponseDtoActorKindEnum = {
    User: 'USER',
    InternalService: 'INTERNAL_SERVICE'
} as const;

export type VoiceMessagingControlHistoryEntryResponseDtoActorKindEnum = typeof VoiceMessagingControlHistoryEntryResponseDtoActorKindEnum[keyof typeof VoiceMessagingControlHistoryEntryResponseDtoActorKindEnum];

/**
 *
 * @export
 * @interface VoiceMessagingControlReceiptResponseDto
 */
export interface VoiceMessagingControlReceiptResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlReceiptResponseDto
     */
    'requestId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlReceiptResponseDto
     */
    'action': VoiceMessagingControlReceiptResponseDtoActionEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceMessagingControlReceiptResponseDto
     */
    'readinessRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoiceMessagingControlReceiptResponseDto
     */
    'desiredRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingControlReceiptResponseDto
     */
    'reconciliationStatus': VoiceMessagingControlReceiptResponseDtoReconciliationStatusEnum;
    /**
     *
     * @type {boolean}
     * @memberof VoiceMessagingControlReceiptResponseDto
     */
    'replayed': boolean;
}

export const VoiceMessagingControlReceiptResponseDtoActionEnum = {
    DesiredPublished: 'DESIRED_PUBLISHED',
    OrganizationGranted: 'ORGANIZATION_GRANTED',
    OrganizationRevoked: 'ORGANIZATION_REVOKED',
    ProviderReconciled: 'PROVIDER_RECONCILED'
} as const;

export type VoiceMessagingControlReceiptResponseDtoActionEnum = typeof VoiceMessagingControlReceiptResponseDtoActionEnum[keyof typeof VoiceMessagingControlReceiptResponseDtoActionEnum];
export const VoiceMessagingControlReceiptResponseDtoReconciliationStatusEnum = {
    Pending: 'PENDING',
    Reconciled: 'RECONCILED',
    Drifted: 'DRIFTED'
} as const;

export type VoiceMessagingControlReceiptResponseDtoReconciliationStatusEnum = typeof VoiceMessagingControlReceiptResponseDtoReconciliationStatusEnum[keyof typeof VoiceMessagingControlReceiptResponseDtoReconciliationStatusEnum];

/**
 *
 * @export
 * @interface VoiceMessagingProviderBindingResponseDto
 */
export interface VoiceMessagingProviderBindingResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderBindingResponseDto
     */
    'accountSid': string;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderBindingResponseDto
     */
    'messagingServiceSid': string;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderBindingResponseDto
     */
    'senderE164': string;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderBindingResponseDto
     */
    'region': VoiceMessagingProviderBindingResponseDtoRegionEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderBindingResponseDto
     */
    'edge': VoiceMessagingProviderBindingResponseDtoEdgeEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderBindingResponseDto
     */
    'statusCallbackUrlTemplate': string;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderBindingResponseDto
     */
    'contentRetentionMode': VoiceMessagingProviderBindingResponseDtoContentRetentionModeEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderBindingResponseDto
     */
    'addressRetentionMode': VoiceMessagingProviderBindingResponseDtoAddressRetentionModeEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderBindingResponseDto
     */
    'providerErasureMode': VoiceMessagingProviderBindingResponseDtoProviderErasureModeEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceMessagingProviderBindingResponseDto
     */
    'providerErasureDeadlineHours': number;
}

export const VoiceMessagingProviderBindingResponseDtoRegionEnum = {
    Ie1: 'ie1'
} as const;

export type VoiceMessagingProviderBindingResponseDtoRegionEnum = typeof VoiceMessagingProviderBindingResponseDtoRegionEnum[keyof typeof VoiceMessagingProviderBindingResponseDtoRegionEnum];
export const VoiceMessagingProviderBindingResponseDtoEdgeEnum = {
    Dublin: 'dublin'
} as const;

export type VoiceMessagingProviderBindingResponseDtoEdgeEnum = typeof VoiceMessagingProviderBindingResponseDtoEdgeEnum[keyof typeof VoiceMessagingProviderBindingResponseDtoEdgeEnum];
export const VoiceMessagingProviderBindingResponseDtoContentRetentionModeEnum = {
    DiscardBody: 'DISCARD_BODY'
} as const;

export type VoiceMessagingProviderBindingResponseDtoContentRetentionModeEnum = typeof VoiceMessagingProviderBindingResponseDtoContentRetentionModeEnum[keyof typeof VoiceMessagingProviderBindingResponseDtoContentRetentionModeEnum];
export const VoiceMessagingProviderBindingResponseDtoAddressRetentionModeEnum = {
    Obfuscate: 'OBFUSCATE'
} as const;

export type VoiceMessagingProviderBindingResponseDtoAddressRetentionModeEnum = typeof VoiceMessagingProviderBindingResponseDtoAddressRetentionModeEnum[keyof typeof VoiceMessagingProviderBindingResponseDtoAddressRetentionModeEnum];
export const VoiceMessagingProviderBindingResponseDtoProviderErasureModeEnum = {
    DeleteMessage: 'DELETE_MESSAGE'
} as const;

export type VoiceMessagingProviderBindingResponseDtoProviderErasureModeEnum = typeof VoiceMessagingProviderBindingResponseDtoProviderErasureModeEnum[keyof typeof VoiceMessagingProviderBindingResponseDtoProviderErasureModeEnum];

/**
 *
 * @export
 * @interface VoiceMessagingProviderObservationBindingResponseDto
 */
export interface VoiceMessagingProviderObservationBindingResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderObservationBindingResponseDto
     */
    'accountSid': string;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderObservationBindingResponseDto
     */
    'messagingServiceSid': string;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderObservationBindingResponseDto
     */
    'senderE164': string;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderObservationBindingResponseDto
     */
    'region': VoiceMessagingProviderObservationBindingResponseDtoRegionEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderObservationBindingResponseDto
     */
    'edge': VoiceMessagingProviderObservationBindingResponseDtoEdgeEnum;
    /**
     * True only when the static Messaging Service status callback is unset; concrete opaque-handle callbacks are supplied per Message.
     * @type {boolean}
     * @memberof VoiceMessagingProviderObservationBindingResponseDto
     */
    'serviceStatusCallbackDisabled': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceMessagingProviderObservationBindingResponseDto
     */
    'applicationOptOutWebhookConfigured': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceMessagingProviderObservationBindingResponseDto
     */
    'stickySenderEnabled': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceMessagingProviderObservationBindingResponseDto
     */
    'fallbackToLongCodeEnabled': boolean;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderObservationBindingResponseDto
     */
    'contentRetentionMode': VoiceMessagingProviderObservationBindingResponseDtoContentRetentionModeEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderObservationBindingResponseDto
     */
    'addressRetentionMode': VoiceMessagingProviderObservationBindingResponseDtoAddressRetentionModeEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceMessagingProviderObservationBindingResponseDto
     */
    'providerErasureMode': VoiceMessagingProviderObservationBindingResponseDtoProviderErasureModeEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceMessagingProviderObservationBindingResponseDto
     */
    'providerErasureDeadlineHours': number | null;
}

export const VoiceMessagingProviderObservationBindingResponseDtoRegionEnum = {
    Ie1: 'ie1'
} as const;

export type VoiceMessagingProviderObservationBindingResponseDtoRegionEnum = typeof VoiceMessagingProviderObservationBindingResponseDtoRegionEnum[keyof typeof VoiceMessagingProviderObservationBindingResponseDtoRegionEnum];
export const VoiceMessagingProviderObservationBindingResponseDtoEdgeEnum = {
    Dublin: 'dublin'
} as const;

export type VoiceMessagingProviderObservationBindingResponseDtoEdgeEnum = typeof VoiceMessagingProviderObservationBindingResponseDtoEdgeEnum[keyof typeof VoiceMessagingProviderObservationBindingResponseDtoEdgeEnum];
export const VoiceMessagingProviderObservationBindingResponseDtoContentRetentionModeEnum = {
    DiscardBody: 'DISCARD_BODY'
} as const;

export type VoiceMessagingProviderObservationBindingResponseDtoContentRetentionModeEnum = typeof VoiceMessagingProviderObservationBindingResponseDtoContentRetentionModeEnum[keyof typeof VoiceMessagingProviderObservationBindingResponseDtoContentRetentionModeEnum];
export const VoiceMessagingProviderObservationBindingResponseDtoAddressRetentionModeEnum = {
    Obfuscate: 'OBFUSCATE'
} as const;

export type VoiceMessagingProviderObservationBindingResponseDtoAddressRetentionModeEnum = typeof VoiceMessagingProviderObservationBindingResponseDtoAddressRetentionModeEnum[keyof typeof VoiceMessagingProviderObservationBindingResponseDtoAddressRetentionModeEnum];
export const VoiceMessagingProviderObservationBindingResponseDtoProviderErasureModeEnum = {
    DeleteMessage: 'DELETE_MESSAGE'
} as const;

export type VoiceMessagingProviderObservationBindingResponseDtoProviderErasureModeEnum = typeof VoiceMessagingProviderObservationBindingResponseDtoProviderErasureModeEnum[keyof typeof VoiceMessagingProviderObservationBindingResponseDtoProviderErasureModeEnum];

/**
 *
 * @export
 * @interface VoicePilotAssessmentMetricsResponseDto
 */
export interface VoicePilotAssessmentMetricsResponseDto {
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'inboundCallsObserved': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'policyRejections': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'eligibleInboundCalls': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'receptionSessionsStarted': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'providerRejections': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'technicalStartFailures': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'technicalToolAttempts': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'technicalToolSuccesses': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'elapsedPilotMilliseconds': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'genuineReceptionSessions': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'incidentFreeMilliseconds': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'eligibleStartBps': number | null;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'technicalToolSuccessBps': number | null;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'conversationalResponseP95Ms': number | null;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'providerCostVarianceBps': number | null;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'recurringBaseAllowanceMs': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'auditedTopUpGrantedMs': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'totalGrantedMs': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'allowanceConsumedMs': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'allowanceReservedMs': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'spendCeilingMicrosPln': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'spendObservedMicrosPln': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'facilityConcurrencyLimit': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'peakFacilityConcurrency': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'globalConcurrencyLimit': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'peakGlobalConcurrency': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'consecutivePassingScriptedRuns': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'sampledGenuineSessions': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'ownerAdminReviewsSubmitted': number;
    /**
     *
     * @type {VoicePilotNoContentQaResponseDto}
     * @memberof VoicePilotAssessmentMetricsResponseDto
     */
    'facilityQa': VoicePilotNoContentQaResponseDto;
}
/**
 *
 * @export
 * @interface VoicePilotAssessmentResponseDto
 */
export interface VoicePilotAssessmentResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoicePilotAssessmentResponseDto
     */
    'pilotReference': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotAssessmentResponseDto
     */
    'assessmentDigest': string;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentResponseDto
     */
    'assessmentRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoicePilotAssessmentResponseDto
     */
    'releaseReference': string;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentResponseDto
     */
    'envelopeRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotAssessmentResponseDto
     */
    'incidentGeneration': number;
    /**
     *
     * @type {string}
     * @memberof VoicePilotAssessmentResponseDto
     */
    'evidenceDigest': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotAssessmentResponseDto
     */
    'assessedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotAssessmentResponseDto
     */
    'evidenceExpiresAt': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotAssessmentResponseDto
     */
    'provenance': VoicePilotAssessmentResponseDtoProvenanceEnum;
    /**
     *
     * @type {boolean}
     * @memberof VoicePilotAssessmentResponseDto
     */
    'thresholdCriteriaSatisfied': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoicePilotAssessmentResponseDto
     */
    'machineCriteriaSatisfied': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoicePilotAssessmentResponseDto
     */
    'productionEvidenceReadyForReview': boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof VoicePilotAssessmentResponseDto
     */
    'unmetCriteria': Array<VoicePilotAssessmentResponseDtoUnmetCriteriaEnum>;
    /**
     *
     * @type {VoicePilotAssessmentMetricsResponseDto}
     * @memberof VoicePilotAssessmentResponseDto
     */
    'metrics': VoicePilotAssessmentMetricsResponseDto;
}

export const VoicePilotAssessmentResponseDtoProvenanceEnum = {
    Production: 'PRODUCTION',
    HermeticSynthetic: 'HERMETIC_SYNTHETIC'
} as const;

export type VoicePilotAssessmentResponseDtoProvenanceEnum = typeof VoicePilotAssessmentResponseDtoProvenanceEnum[keyof typeof VoicePilotAssessmentResponseDtoProvenanceEnum];
export const VoicePilotAssessmentResponseDtoUnmetCriteriaEnum = {
    EvidencePartial: 'EVIDENCE_PARTIAL',
    EvidenceStale: 'EVIDENCE_STALE',
    EvidenceWindowInvalid: 'EVIDENCE_WINDOW_INVALID',
    ProductionEvidenceRequired: 'PRODUCTION_EVIDENCE_REQUIRED',
    ReleaseMismatch: 'RELEASE_MISMATCH',
    EnvelopeMismatch: 'ENVELOPE_MISMATCH',
    IncidentGenerationMismatch: 'INCIDENT_GENERATION_MISMATCH',
    AnonymousCountConservationInvalid: 'ANONYMOUS_COUNT_CONSERVATION_INVALID',
    PilotDurationBelow14ElapsedDays: 'PILOT_DURATION_BELOW_14_ELAPSED_DAYS',
    GenuineReceptionSessionsBelow100: 'GENUINE_RECEPTION_SESSIONS_BELOW_100',
    IncidentFreeStreakBelow7ElapsedDays: 'INCIDENT_FREE_STREAK_BELOW_7_ELAPSED_DAYS',
    EligibleInboundStartReliabilityBelow95Percent: 'ELIGIBLE_INBOUND_START_RELIABILITY_BELOW_95_PERCENT',
    TechnicalToolSuccessBelow95Percent: 'TECHNICAL_TOOL_SUCCESS_BELOW_95_PERCENT',
    ConversationalResponseP95NotBelow2500Ms: 'CONVERSATIONAL_RESPONSE_P95_NOT_BELOW_2500_MS',
    ProviderCostVarianceAbove10Percent: 'PROVIDER_COST_VARIANCE_ABOVE_10_PERCENT',
    HardSafetyZeroCoverageIncomplete: 'HARD_SAFETY_ZERO_COVERAGE_INCOMPLETE',
    HardSafetyZeroViolated: 'HARD_SAFETY_ZERO_VIOLATED',
    ThreeConsecutiveScriptedRunsMissing: 'THREE_CONSECUTIVE_SCRIPTED_RUNS_MISSING',
    FacilityNoContentQaIncomplete: 'FACILITY_NO_CONTENT_QA_INCOMPLETE',
    PilotOperationalEnvelopeInvalid: 'PILOT_OPERATIONAL_ENVELOPE_INVALID'
} as const;

export type VoicePilotAssessmentResponseDtoUnmetCriteriaEnum = typeof VoicePilotAssessmentResponseDtoUnmetCriteriaEnum[keyof typeof VoicePilotAssessmentResponseDtoUnmetCriteriaEnum];

/**
 *
 * @export
 * @interface VoicePilotDecisionResponseDto
 */
export interface VoicePilotDecisionResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoicePilotDecisionResponseDto
     */
    'pilotReference': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotDecisionResponseDto
     */
    'assessmentDigest': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotDecisionResponseDto
     */
    'capability': VoicePilotDecisionResponseDtoCapabilityEnum;
    /**
     *
     * @type {string}
     * @memberof VoicePilotDecisionResponseDto
     */
    'decision': VoicePilotDecisionResponseDtoDecisionEnum;
    /**
     *
     * @type {string}
     * @memberof VoicePilotDecisionResponseDto
     */
    'reason': VoicePilotDecisionResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof VoicePilotDecisionResponseDto
     */
    'decidedAt': string;
}

export const VoicePilotDecisionResponseDtoCapabilityEnum = {
    ProductPublisher: 'VOICE_PRODUCT_PUBLISHER',
    SafetyReviewer: 'VOICE_SAFETY_REVIEWER',
    PrivacyReviewer: 'VOICE_PRIVACY_REVIEWER'
} as const;

export type VoicePilotDecisionResponseDtoCapabilityEnum = typeof VoicePilotDecisionResponseDtoCapabilityEnum[keyof typeof VoicePilotDecisionResponseDtoCapabilityEnum];
export const VoicePilotDecisionResponseDtoDecisionEnum = {
    Approve: 'APPROVE',
    Veto: 'VETO'
} as const;

export type VoicePilotDecisionResponseDtoDecisionEnum = typeof VoicePilotDecisionResponseDtoDecisionEnum[keyof typeof VoicePilotDecisionResponseDtoDecisionEnum];
export const VoicePilotDecisionResponseDtoReasonEnum = {
    EvidenceAccepted: 'EVIDENCE_ACCEPTED',
    ProductVeto: 'PRODUCT_VETO',
    SafetyVeto: 'SAFETY_VETO',
    PrivacyVeto: 'PRIVACY_VETO'
} as const;

export type VoicePilotDecisionResponseDtoReasonEnum = typeof VoicePilotDecisionResponseDtoReasonEnum[keyof typeof VoicePilotDecisionResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface VoicePilotDecisionSummaryResponseDto
 */
export interface VoicePilotDecisionSummaryResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoicePilotDecisionSummaryResponseDto
     */
    'pilotReference': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotDecisionSummaryResponseDto
     */
    'assessmentDigest': string;
    /**
     *
     * @type {boolean}
     * @memberof VoicePilotDecisionSummaryResponseDto
     */
    'approvalsComplete': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoicePilotDecisionSummaryResponseDto
     */
    'vetoed': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoicePilotDecisionSummaryResponseDto
     */
    'expansionAuthorized': boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof VoicePilotDecisionSummaryResponseDto
     */
    'missingCapabilities': Array<VoicePilotDecisionSummaryResponseDtoMissingCapabilitiesEnum>;
    /**
     *
     * @type {Array<VoicePilotDecisionResponseDto>}
     * @memberof VoicePilotDecisionSummaryResponseDto
     */
    'decisions': Array<VoicePilotDecisionResponseDto>;
}

export const VoicePilotDecisionSummaryResponseDtoMissingCapabilitiesEnum = {
    ProductPublisher: 'VOICE_PRODUCT_PUBLISHER',
    SafetyReviewer: 'VOICE_SAFETY_REVIEWER',
    PrivacyReviewer: 'VOICE_PRIVACY_REVIEWER'
} as const;

export type VoicePilotDecisionSummaryResponseDtoMissingCapabilitiesEnum = typeof VoicePilotDecisionSummaryResponseDtoMissingCapabilitiesEnum[keyof typeof VoicePilotDecisionSummaryResponseDtoMissingCapabilitiesEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const VoicePilotEnvelopeRecoveryState = {
    Staged: 'STAGED',
    Active: 'ACTIVE',
    Suspended: 'SUSPENDED',
    Ended: 'ENDED'
} as const;

export type VoicePilotEnvelopeRecoveryState = typeof VoicePilotEnvelopeRecoveryState[keyof typeof VoicePilotEnvelopeRecoveryState];


/**
 *
 * @export
 * @interface VoicePilotEnvelopeResponseDto
 */
export interface VoicePilotEnvelopeResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoicePilotEnvelopeResponseDto
     */
    'pilotReference': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotEnvelopeResponseDto
     */
    'envelopeDigest': string;
    /**
     *
     * @type {number}
     * @memberof VoicePilotEnvelopeResponseDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof VoicePilotEnvelopeResponseDto
     */
    'state': VoicePilotEnvelopeResponseDtoStateEnum;
    /**
     *
     * @type {string}
     * @memberof VoicePilotEnvelopeResponseDto
     */
    'provenance': VoicePilotEnvelopeResponseDtoProvenanceEnum;
    /**
     *
     * @type {string}
     * @memberof VoicePilotEnvelopeResponseDto
     */
    'releaseReference': string;
    /**
     *
     * @type {number}
     * @memberof VoicePilotEnvelopeResponseDto
     */
    'releaseRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoicePilotEnvelopeResponseDto
     */
    'recordedAt': string;
}

export const VoicePilotEnvelopeResponseDtoStateEnum = {
    Staged: 'STAGED',
    Active: 'ACTIVE',
    Suspended: 'SUSPENDED',
    Ended: 'ENDED'
} as const;

export type VoicePilotEnvelopeResponseDtoStateEnum = typeof VoicePilotEnvelopeResponseDtoStateEnum[keyof typeof VoicePilotEnvelopeResponseDtoStateEnum];
export const VoicePilotEnvelopeResponseDtoProvenanceEnum = {
    Production: 'PRODUCTION',
    HermeticSynthetic: 'HERMETIC_SYNTHETIC'
} as const;

export type VoicePilotEnvelopeResponseDtoProvenanceEnum = typeof VoicePilotEnvelopeResponseDtoProvenanceEnum[keyof typeof VoicePilotEnvelopeResponseDtoProvenanceEnum];

/**
 *
 * @export
 * @interface VoicePilotEvidenceExportAssessmentDto
 */
export interface VoicePilotEvidenceExportAssessmentDto {
    /**
     *
     * @type {string}
     * @memberof VoicePilotEvidenceExportAssessmentDto
     */
    'pilotReferenceDigest': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotEvidenceExportAssessmentDto
     */
    'releaseReferenceDigest': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotEvidenceExportAssessmentDto
     */
    'assessmentDigest': string;
    /**
     *
     * @type {number}
     * @memberof VoicePilotEvidenceExportAssessmentDto
     */
    'assessmentRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotEvidenceExportAssessmentDto
     */
    'envelopeRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotEvidenceExportAssessmentDto
     */
    'incidentGeneration': number;
    /**
     *
     * @type {string}
     * @memberof VoicePilotEvidenceExportAssessmentDto
     */
    'evidenceDigest': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotEvidenceExportAssessmentDto
     */
    'assessedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotEvidenceExportAssessmentDto
     */
    'evidenceExpiresAt': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotEvidenceExportAssessmentDto
     */
    'provenance': VoicePilotEvidenceExportAssessmentDtoProvenanceEnum;
    /**
     *
     * @type {boolean}
     * @memberof VoicePilotEvidenceExportAssessmentDto
     */
    'thresholdCriteriaSatisfied': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoicePilotEvidenceExportAssessmentDto
     */
    'machineCriteriaSatisfied': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoicePilotEvidenceExportAssessmentDto
     */
    'productionEvidenceReadyForReview': boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof VoicePilotEvidenceExportAssessmentDto
     */
    'unmetCriteria': Array<VoicePilotEvidenceExportAssessmentDtoUnmetCriteriaEnum>;
    /**
     *
     * @type {VoicePilotAssessmentMetricsResponseDto}
     * @memberof VoicePilotEvidenceExportAssessmentDto
     */
    'metrics': VoicePilotAssessmentMetricsResponseDto;
}

export const VoicePilotEvidenceExportAssessmentDtoProvenanceEnum = {
    Production: 'PRODUCTION',
    HermeticSynthetic: 'HERMETIC_SYNTHETIC'
} as const;

export type VoicePilotEvidenceExportAssessmentDtoProvenanceEnum = typeof VoicePilotEvidenceExportAssessmentDtoProvenanceEnum[keyof typeof VoicePilotEvidenceExportAssessmentDtoProvenanceEnum];
export const VoicePilotEvidenceExportAssessmentDtoUnmetCriteriaEnum = {
    EvidencePartial: 'EVIDENCE_PARTIAL',
    EvidenceStale: 'EVIDENCE_STALE',
    EvidenceWindowInvalid: 'EVIDENCE_WINDOW_INVALID',
    ProductionEvidenceRequired: 'PRODUCTION_EVIDENCE_REQUIRED',
    ReleaseMismatch: 'RELEASE_MISMATCH',
    EnvelopeMismatch: 'ENVELOPE_MISMATCH',
    IncidentGenerationMismatch: 'INCIDENT_GENERATION_MISMATCH',
    AnonymousCountConservationInvalid: 'ANONYMOUS_COUNT_CONSERVATION_INVALID',
    PilotDurationBelow14ElapsedDays: 'PILOT_DURATION_BELOW_14_ELAPSED_DAYS',
    GenuineReceptionSessionsBelow100: 'GENUINE_RECEPTION_SESSIONS_BELOW_100',
    IncidentFreeStreakBelow7ElapsedDays: 'INCIDENT_FREE_STREAK_BELOW_7_ELAPSED_DAYS',
    EligibleInboundStartReliabilityBelow95Percent: 'ELIGIBLE_INBOUND_START_RELIABILITY_BELOW_95_PERCENT',
    TechnicalToolSuccessBelow95Percent: 'TECHNICAL_TOOL_SUCCESS_BELOW_95_PERCENT',
    ConversationalResponseP95NotBelow2500Ms: 'CONVERSATIONAL_RESPONSE_P95_NOT_BELOW_2500_MS',
    ProviderCostVarianceAbove10Percent: 'PROVIDER_COST_VARIANCE_ABOVE_10_PERCENT',
    HardSafetyZeroCoverageIncomplete: 'HARD_SAFETY_ZERO_COVERAGE_INCOMPLETE',
    HardSafetyZeroViolated: 'HARD_SAFETY_ZERO_VIOLATED',
    ThreeConsecutiveScriptedRunsMissing: 'THREE_CONSECUTIVE_SCRIPTED_RUNS_MISSING',
    FacilityNoContentQaIncomplete: 'FACILITY_NO_CONTENT_QA_INCOMPLETE',
    PilotOperationalEnvelopeInvalid: 'PILOT_OPERATIONAL_ENVELOPE_INVALID'
} as const;

export type VoicePilotEvidenceExportAssessmentDtoUnmetCriteriaEnum = typeof VoicePilotEvidenceExportAssessmentDtoUnmetCriteriaEnum[keyof typeof VoicePilotEvidenceExportAssessmentDtoUnmetCriteriaEnum];

/**
 *
 * @export
 * @interface VoicePilotEvidenceExportDecisionDto
 */
export interface VoicePilotEvidenceExportDecisionDto {
    /**
     *
     * @type {string}
     * @memberof VoicePilotEvidenceExportDecisionDto
     */
    'assessmentDigest': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotEvidenceExportDecisionDto
     */
    'capability': VoicePilotEvidenceExportDecisionDtoCapabilityEnum;
    /**
     *
     * @type {string}
     * @memberof VoicePilotEvidenceExportDecisionDto
     */
    'decision': VoicePilotEvidenceExportDecisionDtoDecisionEnum;
    /**
     *
     * @type {string}
     * @memberof VoicePilotEvidenceExportDecisionDto
     */
    'reason': VoicePilotEvidenceExportDecisionDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof VoicePilotEvidenceExportDecisionDto
     */
    'decidedAt': string;
}

export const VoicePilotEvidenceExportDecisionDtoCapabilityEnum = {
    ProductPublisher: 'VOICE_PRODUCT_PUBLISHER',
    SafetyReviewer: 'VOICE_SAFETY_REVIEWER',
    PrivacyReviewer: 'VOICE_PRIVACY_REVIEWER'
} as const;

export type VoicePilotEvidenceExportDecisionDtoCapabilityEnum = typeof VoicePilotEvidenceExportDecisionDtoCapabilityEnum[keyof typeof VoicePilotEvidenceExportDecisionDtoCapabilityEnum];
export const VoicePilotEvidenceExportDecisionDtoDecisionEnum = {
    Approve: 'APPROVE',
    Veto: 'VETO'
} as const;

export type VoicePilotEvidenceExportDecisionDtoDecisionEnum = typeof VoicePilotEvidenceExportDecisionDtoDecisionEnum[keyof typeof VoicePilotEvidenceExportDecisionDtoDecisionEnum];
export const VoicePilotEvidenceExportDecisionDtoReasonEnum = {
    EvidenceAccepted: 'EVIDENCE_ACCEPTED',
    ProductVeto: 'PRODUCT_VETO',
    SafetyVeto: 'SAFETY_VETO',
    PrivacyVeto: 'PRIVACY_VETO'
} as const;

export type VoicePilotEvidenceExportDecisionDtoReasonEnum = typeof VoicePilotEvidenceExportDecisionDtoReasonEnum[keyof typeof VoicePilotEvidenceExportDecisionDtoReasonEnum];

/**
 *
 * @export
 * @interface VoicePilotEvidenceExportDecisionSummaryDto
 */
export interface VoicePilotEvidenceExportDecisionSummaryDto {
    /**
     *
     * @type {string}
     * @memberof VoicePilotEvidenceExportDecisionSummaryDto
     */
    'assessmentDigest': string;
    /**
     *
     * @type {boolean}
     * @memberof VoicePilotEvidenceExportDecisionSummaryDto
     */
    'approvalsComplete': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoicePilotEvidenceExportDecisionSummaryDto
     */
    'vetoed': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoicePilotEvidenceExportDecisionSummaryDto
     */
    'expansionAuthorized': boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof VoicePilotEvidenceExportDecisionSummaryDto
     */
    'missingCapabilities': Array<VoicePilotEvidenceExportDecisionSummaryDtoMissingCapabilitiesEnum>;
    /**
     *
     * @type {Array<VoicePilotEvidenceExportDecisionDto>}
     * @memberof VoicePilotEvidenceExportDecisionSummaryDto
     */
    'decisions': Array<VoicePilotEvidenceExportDecisionDto>;
}

export const VoicePilotEvidenceExportDecisionSummaryDtoMissingCapabilitiesEnum = {
    ProductPublisher: 'VOICE_PRODUCT_PUBLISHER',
    SafetyReviewer: 'VOICE_SAFETY_REVIEWER',
    PrivacyReviewer: 'VOICE_PRIVACY_REVIEWER'
} as const;

export type VoicePilotEvidenceExportDecisionSummaryDtoMissingCapabilitiesEnum = typeof VoicePilotEvidenceExportDecisionSummaryDtoMissingCapabilitiesEnum[keyof typeof VoicePilotEvidenceExportDecisionSummaryDtoMissingCapabilitiesEnum];

/**
 *
 * @export
 * @interface VoicePilotEvidenceExportResponseDto
 */
export interface VoicePilotEvidenceExportResponseDto {
    /**
     *
     * @type {number}
     * @memberof VoicePilotEvidenceExportResponseDto
     */
    'schemaVersion': VoicePilotEvidenceExportResponseDtoSchemaVersionEnum;
    /**
     *
     * @type {string}
     * @memberof VoicePilotEvidenceExportResponseDto
     */
    'artifactKind': VoicePilotEvidenceExportResponseDtoArtifactKindEnum;
    /**
     *
     * @type {VoicePilotEvidenceExportAssessmentDto}
     * @memberof VoicePilotEvidenceExportResponseDto
     */
    'assessment': VoicePilotEvidenceExportAssessmentDto;
    /**
     *
     * @type {VoicePilotEvidenceExportDecisionSummaryDto}
     * @memberof VoicePilotEvidenceExportResponseDto
     */
    'decisionSummary': VoicePilotEvidenceExportDecisionSummaryDto;
}

export const VoicePilotEvidenceExportResponseDtoSchemaVersionEnum = {
    NUMBER_1: 1
} as const;

export type VoicePilotEvidenceExportResponseDtoSchemaVersionEnum = typeof VoicePilotEvidenceExportResponseDtoSchemaVersionEnum[keyof typeof VoicePilotEvidenceExportResponseDtoSchemaVersionEnum];
export const VoicePilotEvidenceExportResponseDtoArtifactKindEnum = {
    VoicePilotAnonymousNoContent: 'VOICE_PILOT_ANONYMOUS_NO_CONTENT'
} as const;

export type VoicePilotEvidenceExportResponseDtoArtifactKindEnum = typeof VoicePilotEvidenceExportResponseDtoArtifactKindEnum[keyof typeof VoicePilotEvidenceExportResponseDtoArtifactKindEnum];

/**
 *
 * @export
 * @interface VoicePilotFacilityQaAggregateResponseDto
 */
export interface VoicePilotFacilityQaAggregateResponseDto {
    /**
     *
     * @type {number}
     * @memberof VoicePilotFacilityQaAggregateResponseDto
     */
    'complete': VoicePilotFacilityQaAggregateResponseDtoCompleteEnum;
    /**
     *
     * @type {number}
     * @memberof VoicePilotFacilityQaAggregateResponseDto
     */
    'rubricVersion': VoicePilotFacilityQaAggregateResponseDtoRubricVersionEnum;
    /**
     *
     * @type {number}
     * @memberof VoicePilotFacilityQaAggregateResponseDto
     */
    'sampledGenuineSessions': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotFacilityQaAggregateResponseDto
     */
    'ownerAdminReviewsSubmitted': number;
    /**
     *
     * @type {VoicePilotFacilityQaFindingCountsResponseDto}
     * @memberof VoicePilotFacilityQaAggregateResponseDto
     */
    'disclosure': VoicePilotFacilityQaFindingCountsResponseDto;
    /**
     *
     * @type {VoicePilotFacilityQaFindingCountsResponseDto}
     * @memberof VoicePilotFacilityQaAggregateResponseDto
     */
    'grounding': VoicePilotFacilityQaFindingCountsResponseDto;
    /**
     *
     * @type {VoicePilotFacilityQaFindingCountsResponseDto}
     * @memberof VoicePilotFacilityQaAggregateResponseDto
     */
    'safety': VoicePilotFacilityQaFindingCountsResponseDto;
    /**
     *
     * @type {VoicePilotFacilityQaTaskOutcomeCountsResponseDto}
     * @memberof VoicePilotFacilityQaAggregateResponseDto
     */
    'taskOutcome': VoicePilotFacilityQaTaskOutcomeCountsResponseDto;
}

export const VoicePilotFacilityQaAggregateResponseDtoCompleteEnum = {
    NUMBER_null: null
} as const;

export type VoicePilotFacilityQaAggregateResponseDtoCompleteEnum = typeof VoicePilotFacilityQaAggregateResponseDtoCompleteEnum[keyof typeof VoicePilotFacilityQaAggregateResponseDtoCompleteEnum];
export const VoicePilotFacilityQaAggregateResponseDtoRubricVersionEnum = {
    NUMBER_1: 1
} as const;

export type VoicePilotFacilityQaAggregateResponseDtoRubricVersionEnum = typeof VoicePilotFacilityQaAggregateResponseDtoRubricVersionEnum[keyof typeof VoicePilotFacilityQaAggregateResponseDtoRubricVersionEnum];

/**
 *
 * @export
 * @interface VoicePilotFacilityQaFindingCountsResponseDto
 */
export interface VoicePilotFacilityQaFindingCountsResponseDto {
    /**
     *
     * @type {number}
     * @memberof VoicePilotFacilityQaFindingCountsResponseDto
     */
    'pass': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotFacilityQaFindingCountsResponseDto
     */
    'fail': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotFacilityQaFindingCountsResponseDto
     */
    'notAssessed': number;
}
/**
 *
 * @export
 * @interface VoicePilotFacilityQaReceiptResponseDto
 */
export interface VoicePilotFacilityQaReceiptResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoicePilotFacilityQaReceiptResponseDto
     */
    'reviewId': string;
    /**
     *
     * @type {number}
     * @memberof VoicePilotFacilityQaReceiptResponseDto
     */
    'reviewVersion': VoicePilotFacilityQaReceiptResponseDtoReviewVersionEnum;
    /**
     *
     * @type {number}
     * @memberof VoicePilotFacilityQaReceiptResponseDto
     */
    'rubricVersion': VoicePilotFacilityQaReceiptResponseDtoRubricVersionEnum;
    /**
     *
     * @type {boolean}
     * @memberof VoicePilotFacilityQaReceiptResponseDto
     */
    'replayed': boolean;
}

export const VoicePilotFacilityQaReceiptResponseDtoReviewVersionEnum = {
    NUMBER_1: 1
} as const;

export type VoicePilotFacilityQaReceiptResponseDtoReviewVersionEnum = typeof VoicePilotFacilityQaReceiptResponseDtoReviewVersionEnum[keyof typeof VoicePilotFacilityQaReceiptResponseDtoReviewVersionEnum];
export const VoicePilotFacilityQaReceiptResponseDtoRubricVersionEnum = {
    NUMBER_1: 1
} as const;

export type VoicePilotFacilityQaReceiptResponseDtoRubricVersionEnum = typeof VoicePilotFacilityQaReceiptResponseDtoRubricVersionEnum[keyof typeof VoicePilotFacilityQaReceiptResponseDtoRubricVersionEnum];

/**
 *
 * @export
 * @interface VoicePilotFacilityQaTaskOutcomeCountsResponseDto
 */
export interface VoicePilotFacilityQaTaskOutcomeCountsResponseDto {
    /**
     *
     * @type {number}
     * @memberof VoicePilotFacilityQaTaskOutcomeCountsResponseDto
     */
    'resolved': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotFacilityQaTaskOutcomeCountsResponseDto
     */
    'handoff': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotFacilityQaTaskOutcomeCountsResponseDto
     */
    'unresolved': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotFacilityQaTaskOutcomeCountsResponseDto
     */
    'notAssessed': number;
}
/**
 *
 * @export
 * @interface VoicePilotNoContentQaResponseDto
 */
export interface VoicePilotNoContentQaResponseDto {
    /**
     *
     * @type {boolean}
     * @memberof VoicePilotNoContentQaResponseDto
     */
    'complete': boolean;
    /**
     *
     * @type {number}
     * @memberof VoicePilotNoContentQaResponseDto
     */
    'rubricVersion': VoicePilotNoContentQaResponseDtoRubricVersionEnum;
    /**
     *
     * @type {number}
     * @memberof VoicePilotNoContentQaResponseDto
     */
    'sampledGenuineSessions': number;
    /**
     *
     * @type {number}
     * @memberof VoicePilotNoContentQaResponseDto
     */
    'ownerAdminReviewsSubmitted': number;
    /**
     *
     * @type {VoicePilotFacilityQaFindingCountsResponseDto}
     * @memberof VoicePilotNoContentQaResponseDto
     */
    'disclosure': VoicePilotFacilityQaFindingCountsResponseDto;
    /**
     *
     * @type {VoicePilotFacilityQaFindingCountsResponseDto}
     * @memberof VoicePilotNoContentQaResponseDto
     */
    'grounding': VoicePilotFacilityQaFindingCountsResponseDto;
    /**
     *
     * @type {VoicePilotFacilityQaFindingCountsResponseDto}
     * @memberof VoicePilotNoContentQaResponseDto
     */
    'safety': VoicePilotFacilityQaFindingCountsResponseDto;
    /**
     *
     * @type {VoicePilotFacilityQaTaskOutcomeCountsResponseDto}
     * @memberof VoicePilotNoContentQaResponseDto
     */
    'taskOutcome': VoicePilotFacilityQaTaskOutcomeCountsResponseDto;
}

export const VoicePilotNoContentQaResponseDtoRubricVersionEnum = {
    NUMBER_1: 1
} as const;

export type VoicePilotNoContentQaResponseDtoRubricVersionEnum = typeof VoicePilotNoContentQaResponseDtoRubricVersionEnum[keyof typeof VoicePilotNoContentQaResponseDtoRubricVersionEnum];

/**
 *
 * @export
 * @interface VoicePilotProductionEvidencePartReceiptDto
 */
export interface VoicePilotProductionEvidencePartReceiptDto {
    /**
     *
     * @type {string}
     * @memberof VoicePilotProductionEvidencePartReceiptDto
     */
    'partKind': VoicePilotProductionEvidencePartReceiptDtoPartKindEnum;
    /**
     *
     * @type {string}
     * @memberof VoicePilotProductionEvidencePartReceiptDto
     */
    'partDigest': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotProductionEvidencePartReceiptDto
     */
    'windowStartedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotProductionEvidencePartReceiptDto
     */
    'windowEndedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotProductionEvidencePartReceiptDto
     */
    'recordedAt': string;
}

export const VoicePilotProductionEvidencePartReceiptDtoPartKindEnum = {
    Operations: 'OPERATIONS',
    Safety: 'SAFETY',
    Privacy: 'PRIVACY'
} as const;

export type VoicePilotProductionEvidencePartReceiptDtoPartKindEnum = typeof VoicePilotProductionEvidencePartReceiptDtoPartKindEnum[keyof typeof VoicePilotProductionEvidencePartReceiptDtoPartKindEnum];

/**
 *
 * @export
 * @interface VoicePilotProductionPrivacyProofSourceDto
 */
export interface VoicePilotProductionPrivacyProofSourceDto {
    /**
     *
     * @type {string}
     * @memberof VoicePilotProductionPrivacyProofSourceDto
     */
    'kind': VoicePilotProductionPrivacyProofSourceDtoKindEnum;
    /**
     *
     * @type {string}
     * @memberof VoicePilotProductionPrivacyProofSourceDto
     */
    'scannerVersion': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotProductionPrivacyProofSourceDto
     */
    'evidenceDigest': string;
}

export const VoicePilotProductionPrivacyProofSourceDtoKindEnum = {
    TenantIsolationAudit: 'TENANT_ISOLATION_AUDIT',
    ProviderErasureAudit: 'PROVIDER_ERASURE_AUDIT',
    OperationalLogPiiAudit: 'OPERATIONAL_LOG_PII_AUDIT'
} as const;

export type VoicePilotProductionPrivacyProofSourceDtoKindEnum = typeof VoicePilotProductionPrivacyProofSourceDtoKindEnum[keyof typeof VoicePilotProductionPrivacyProofSourceDtoKindEnum];

/**
 *
 * @export
 * @interface VoicePilotProductionProviderCostDto
 */
export interface VoicePilotProductionProviderCostDto {
    /**
     *
     * @type {boolean}
     * @memberof VoicePilotProductionProviderCostDto
     */
    'complete': boolean;
    /**
     *
     * @type {number}
     * @memberof VoicePilotProductionProviderCostDto
     */
    'providerLedgerMicrosPln': number;
    /**
     *
     * @type {string}
     * @memberof VoicePilotProductionProviderCostDto
     */
    'sourceStatementDigest': string;
}
/**
 *
 * @export
 * @interface VoicePilotProductionSafetyProofSourceDto
 */
export interface VoicePilotProductionSafetyProofSourceDto {
    /**
     *
     * @type {string}
     * @memberof VoicePilotProductionSafetyProofSourceDto
     */
    'kind': VoicePilotProductionSafetyProofSourceDtoKindEnum;
    /**
     *
     * @type {string}
     * @memberof VoicePilotProductionSafetyProofSourceDto
     */
    'scannerVersion': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotProductionSafetyProofSourceDto
     */
    'evidenceDigest': string;
}

export const VoicePilotProductionSafetyProofSourceDtoKindEnum = {
    DisclosureAudit: 'DISCLOSURE_AUDIT',
    VisitAuthorizationAudit: 'VISIT_AUTHORIZATION_AUDIT',
    BookingCommitAudit: 'BOOKING_COMMIT_AUDIT',
    EmergencyLatchAudit: 'EMERGENCY_LATCH_AUDIT'
} as const;

export type VoicePilotProductionSafetyProofSourceDtoKindEnum = typeof VoicePilotProductionSafetyProofSourceDtoKindEnum[keyof typeof VoicePilotProductionSafetyProofSourceDtoKindEnum];

/**
 *
 * @export
 * @interface VoicePilotProductionSessionClassificationDto
 */
export interface VoicePilotProductionSessionClassificationDto {
    /**
     *
     * @type {string}
     * @memberof VoicePilotProductionSessionClassificationDto
     */
    'sampleEvidenceDigest': string;
    /**
     *
     * @type {string}
     * @memberof VoicePilotProductionSessionClassificationDto
     */
    'classification': VoicePilotProductionSessionClassificationDtoClassificationEnum;
}

export const VoicePilotProductionSessionClassificationDtoClassificationEnum = {
    Genuine: 'GENUINE',
    Staff: 'STAFF',
    Scripted: 'SCRIPTED',
    Synthetic: 'SYNTHETIC'
} as const;

export type VoicePilotProductionSessionClassificationDtoClassificationEnum = typeof VoicePilotProductionSessionClassificationDtoClassificationEnum[keyof typeof VoicePilotProductionSessionClassificationDtoClassificationEnum];

/**
 *
 * @export
 * @interface VoicePlatformCapabilityAssignmentResponseDto
 */
export interface VoicePlatformCapabilityAssignmentResponseDto {
    /**
     * Identyfikator przypisania uprawnienia
     * @type {string}
     * @memberof VoicePlatformCapabilityAssignmentResponseDto
     */
    'id': string;
    /**
     * Identyfikator użytkownika z uprawnieniem
     * @type {string}
     * @memberof VoicePlatformCapabilityAssignmentResponseDto
     */
    'subjectUserId': string;
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCapabilityAssignmentResponseDto
     */
    'capability': VoicePlatformCapabilityAssignmentResponseDtoCapabilityEnum;
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCapabilityAssignmentResponseDto
     */
    'status': VoicePlatformCapabilityAssignmentResponseDtoStatusEnum;
    /**
     * Administrator, który zgłosił przypisanie
     * @type {string}
     * @memberof VoicePlatformCapabilityAssignmentResponseDto
     */
    'proposedByUserId': string;
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCapabilityAssignmentResponseDto
     */
    'proposedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCapabilityAssignmentResponseDto
     */
    'approvedByUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCapabilityAssignmentResponseDto
     */
    'approvedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCapabilityAssignmentResponseDto
     */
    'revokedByUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCapabilityAssignmentResponseDto
     */
    'revokedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCapabilityAssignmentResponseDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCapabilityAssignmentResponseDto
     */
    'updatedAt': string;
}

export const VoicePlatformCapabilityAssignmentResponseDtoCapabilityEnum = {
    ProductPublisher: 'VOICE_PRODUCT_PUBLISHER',
    Operations: 'VOICE_OPERATIONS',
    PrivacyReviewer: 'VOICE_PRIVACY_REVIEWER',
    SafetyReviewer: 'VOICE_SAFETY_REVIEWER',
    IncidentCommander: 'VOICE_INCIDENT_COMMANDER'
} as const;

export type VoicePlatformCapabilityAssignmentResponseDtoCapabilityEnum = typeof VoicePlatformCapabilityAssignmentResponseDtoCapabilityEnum[keyof typeof VoicePlatformCapabilityAssignmentResponseDtoCapabilityEnum];
export const VoicePlatformCapabilityAssignmentResponseDtoStatusEnum = {
    Pending: 'PENDING',
    Active: 'ACTIVE',
    Revoked: 'REVOKED'
} as const;

export type VoicePlatformCapabilityAssignmentResponseDtoStatusEnum = typeof VoicePlatformCapabilityAssignmentResponseDtoStatusEnum[keyof typeof VoicePlatformCapabilityAssignmentResponseDtoStatusEnum];

/**
 *
 * @export
 * @interface VoicePlatformCapabilityAuthorizationResponseDto
 */
export interface VoicePlatformCapabilityAuthorizationResponseDto {
    /**
     *
     * @type {boolean}
     * @memberof VoicePlatformCapabilityAuthorizationResponseDto
     */
    'authorized': boolean;
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCapabilityAuthorizationResponseDto
     */
    'capability': VoicePlatformCapabilityAuthorizationResponseDtoCapabilityEnum;
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCapabilityAuthorizationResponseDto
     */
    'action': VoicePlatformCapabilityAuthorizationResponseDtoActionEnum;
}

export const VoicePlatformCapabilityAuthorizationResponseDtoCapabilityEnum = {
    ProductPublisher: 'VOICE_PRODUCT_PUBLISHER',
    Operations: 'VOICE_OPERATIONS',
    PrivacyReviewer: 'VOICE_PRIVACY_REVIEWER',
    SafetyReviewer: 'VOICE_SAFETY_REVIEWER',
    IncidentCommander: 'VOICE_INCIDENT_COMMANDER'
} as const;

export type VoicePlatformCapabilityAuthorizationResponseDtoCapabilityEnum = typeof VoicePlatformCapabilityAuthorizationResponseDtoCapabilityEnum[keyof typeof VoicePlatformCapabilityAuthorizationResponseDtoCapabilityEnum];
export const VoicePlatformCapabilityAuthorizationResponseDtoActionEnum = {
    DevelopOperatorTrialPublish: 'VOICE_DEVELOP_OPERATOR_TRIAL_PUBLISH',
    DevelopOperatorTrialMonitor: 'VOICE_DEVELOP_OPERATOR_TRIAL_MONITOR',
    DevelopOperatorTrialRevoke: 'VOICE_DEVELOP_OPERATOR_TRIAL_REVOKE',
    PlatformCapabilityList: 'VOICE_PLATFORM_CAPABILITY_LIST',
    PlatformCapabilityPropose: 'VOICE_PLATFORM_CAPABILITY_PROPOSE',
    PlatformCapabilityApprove: 'VOICE_PLATFORM_CAPABILITY_APPROVE',
    PlatformCapabilityRevoke: 'VOICE_PLATFORM_CAPABILITY_REVOKE',
    PlatformCapabilityUse: 'VOICE_PLATFORM_CAPABILITY_USE',
    SmsPrivacyQualificationRead: 'VOICE_SMS_PRIVACY_QUALIFICATION_READ',
    SmsPrivacyQualificationPropose: 'VOICE_SMS_PRIVACY_QUALIFICATION_PROPOSE',
    SmsPrivacyQualificationApprove: 'VOICE_SMS_PRIVACY_QUALIFICATION_APPROVE',
    SmsPrivacyQualificationRevoke: 'VOICE_SMS_PRIVACY_QUALIFICATION_REVOKE',
    SmsPrivacyQualificationCleanup: 'VOICE_SMS_PRIVACY_QUALIFICATION_CLEANUP',
    AllowanceRead: 'VOICE_ALLOWANCE_READ',
    AllowanceProvision: 'VOICE_ALLOWANCE_PROVISION',
    AllowanceReconcile: 'VOICE_ALLOWANCE_RECONCILE',
    AllowanceTopUp: 'VOICE_ALLOWANCE_TOP_UP',
    AllowanceReduction: 'VOICE_ALLOWANCE_REDUCTION',
    QualifiedRatePublication: 'VOICE_QUALIFIED_RATE_PUBLICATION',
    QualifiedReleaseRead: 'VOICE_QUALIFIED_RELEASE_READ',
    QualifiedReleasePublish: 'VOICE_QUALIFIED_RELEASE_PUBLISH',
    QualifiedReleaseApproveOperations: 'VOICE_QUALIFIED_RELEASE_APPROVE_OPERATIONS',
    QualifiedReleaseApprovePrivacy: 'VOICE_QUALIFIED_RELEASE_APPROVE_PRIVACY',
    QualifiedReleaseApproveSafety: 'VOICE_QUALIFIED_RELEASE_APPROVE_SAFETY',
    ProductionQualificationRead: 'VOICE_PRODUCTION_QUALIFICATION_READ',
    ProductionQualificationPublishOperations: 'VOICE_PRODUCTION_QUALIFICATION_PUBLISH_OPERATIONS',
    ProductionQualificationPublishPrivacy: 'VOICE_PRODUCTION_QUALIFICATION_PUBLISH_PRIVACY',
    ProductionQualificationPublishSafety: 'VOICE_PRODUCTION_QUALIFICATION_PUBLISH_SAFETY',
    ProductionQualificationInvalidateOperations: 'VOICE_PRODUCTION_QUALIFICATION_INVALIDATE_OPERATIONS',
    ProductionQualificationInvalidatePrivacy: 'VOICE_PRODUCTION_QUALIFICATION_INVALIDATE_PRIVACY',
    ProductionQualificationInvalidateSafety: 'VOICE_PRODUCTION_QUALIFICATION_INVALIDATE_SAFETY',
    ProductionQualificationRenewalAcknowledge: 'VOICE_PRODUCTION_QUALIFICATION_RENEWAL_ACKNOWLEDGE',
    MessagingDesiredPublish: 'VOICE_MESSAGING_DESIRED_PUBLISH',
    MessagingBetaGrant: 'VOICE_MESSAGING_BETA_GRANT',
    MessagingBetaRevoke: 'VOICE_MESSAGING_BETA_REVOKE',
    MessagingRead: 'VOICE_MESSAGING_READ',
    ProviderErasureRemediationPropose: 'VOICE_PROVIDER_ERASURE_REMEDIATION_PROPOSE',
    ProviderErasureRemediationApprove: 'VOICE_PROVIDER_ERASURE_REMEDIATION_APPROVE',
    ProviderErasureIncidentRead: 'VOICE_PROVIDER_ERASURE_INCIDENT_READ',
    ProviderErasureIncidentReopen: 'VOICE_PROVIDER_ERASURE_INCIDENT_REOPEN',
    ProviderCallScanReconcileExactIncidents: 'VOICE_PROVIDER_CALL_SCAN_RECONCILE_EXACT_INCIDENTS',
    ProviderCallScanSchedulePropose: 'VOICE_PROVIDER_CALL_SCAN_SCHEDULE_PROPOSE',
    ProviderCallScanScheduleApprove: 'VOICE_PROVIDER_CALL_SCAN_SCHEDULE_APPROVE',
    ProviderCallScanScheduleActivate: 'VOICE_PROVIDER_CALL_SCAN_SCHEDULE_ACTIVATE',
    ProviderCallScanScheduleRevoke: 'VOICE_PROVIDER_CALL_SCAN_SCHEDULE_REVOKE',
    ProviderCallScanScheduleRead: 'VOICE_PROVIDER_CALL_SCAN_SCHEDULE_READ',
    SpendRead: 'VOICE_SPEND_READ',
    SpendReopenPropose: 'VOICE_SPEND_REOPEN_PROPOSE',
    SpendReopenApprove: 'VOICE_SPEND_REOPEN_APPROVE',
    ReceptionActivationApproveOperations: 'VOICE_RECEPTION_ACTIVATION_APPROVE_OPERATIONS',
    ReceptionActivationApprovePrivacy: 'VOICE_RECEPTION_ACTIVATION_APPROVE_PRIVACY',
    ReceptionActivationApproveSafety: 'VOICE_RECEPTION_ACTIVATION_APPROVE_SAFETY',
    ReceptionActivationRead: 'VOICE_RECEPTION_ACTIVATION_READ',
    ReceptionActivationPrivacyRead: 'VOICE_RECEPTION_ACTIVATION_PRIVACY_READ',
    ReceptionActivationSafetyRead: 'VOICE_RECEPTION_ACTIVATION_SAFETY_READ',
    ReceptionActivationFinalize: 'VOICE_RECEPTION_ACTIVATION_FINALIZE',
    ReceptionIncidentBlock: 'VOICE_RECEPTION_INCIDENT_BLOCK',
    ReceptionSafetyOverride: 'VOICE_RECEPTION_SAFETY_OVERRIDE',
    ReceptionTerminationPropose: 'VOICE_RECEPTION_TERMINATION_PROPOSE',
    ReceptionTerminationApprove: 'VOICE_RECEPTION_TERMINATION_APPROVE',
    ReceptionIncidentReopenPropose: 'VOICE_RECEPTION_INCIDENT_REOPEN_PROPOSE',
    ReceptionIncidentReopenApprove: 'VOICE_RECEPTION_INCIDENT_REOPEN_APPROVE',
    ReceptionIncidentHistory: 'VOICE_RECEPTION_INCIDENT_HISTORY',
    ReceptionIncidentStateRead: 'VOICE_RECEPTION_INCIDENT_STATE_READ',
    ReceptionIncidentSafetyEffectsRead: 'VOICE_RECEPTION_INCIDENT_SAFETY_EFFECTS_READ',
    ReceptionControlRevalidation: 'VOICE_RECEPTION_CONTROL_REVALIDATION',
    PilotEvidencePhase6Read: 'VOICE_PILOT_EVIDENCE_PHASE_6_READ',
    PilotEnvelopePublish: 'VOICE_PILOT_ENVELOPE_PUBLISH',
    PilotEnvelopeRead: 'VOICE_PILOT_ENVELOPE_READ',
    PilotEvidenceCapture: 'VOICE_PILOT_EVIDENCE_CAPTURE',
    PilotAssessmentRead: 'VOICE_PILOT_ASSESSMENT_READ',
    PilotEvidenceExport: 'VOICE_PILOT_EVIDENCE_EXPORT',
    PilotDecisionProduct: 'VOICE_PILOT_DECISION_PRODUCT',
    PilotDecisionSafety: 'VOICE_PILOT_DECISION_SAFETY',
    PilotDecisionPrivacy: 'VOICE_PILOT_DECISION_PRIVACY',
    PilotDecisionRead: 'VOICE_PILOT_DECISION_READ',
    FallbackBundleRead: 'VOICE_FALLBACK_BUNDLE_READ',
    FallbackContentPropose: 'VOICE_FALLBACK_CONTENT_PROPOSE',
    FallbackContentApprove: 'VOICE_FALLBACK_CONTENT_APPROVE',
    FallbackContentApprovalRead: 'VOICE_FALLBACK_CONTENT_APPROVAL_READ',
    FallbackContentPublicationRevalidate: 'VOICE_FALLBACK_CONTENT_PUBLICATION_REVALIDATE',
    FallbackBundlePublish: 'VOICE_FALLBACK_BUNDLE_PUBLISH',
    FallbackBundleReconcile: 'VOICE_FALLBACK_BUNDLE_RECONCILE'
} as const;

export type VoicePlatformCapabilityAuthorizationResponseDtoActionEnum = typeof VoicePlatformCapabilityAuthorizationResponseDtoActionEnum[keyof typeof VoicePlatformCapabilityAuthorizationResponseDtoActionEnum];

/**
 *
 * @export
 * @interface VoiceProductionQualificationCurrentResponseDto
 */
export interface VoiceProductionQualificationCurrentResponseDto {
    /**
     *
     * @type {object}
     * @memberof VoiceProductionQualificationCurrentResponseDto
     */
    'developOperatorTrial'?: object;
    /**
     *
     * @type {number}
     * @memberof VoiceProductionQualificationCurrentResponseDto
     */
    'headRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationCurrentResponseDto
     */
    'bookingConfirmationChannel'?: VoiceProductionQualificationCurrentResponseDtoBookingConfirmationChannelEnum;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceProductionQualificationCurrentResponseDto
     */
    'requiredCategories'?: Array<VoiceProductionQualificationCurrentResponseDtoRequiredCategoriesEnum>;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceProductionQualificationCurrentResponseDto
     */
    'missingRequiredCategories'?: Array<VoiceProductionQualificationCurrentResponseDtoMissingRequiredCategoriesEnum>;
    /**
     *
     * @type {boolean}
     * @memberof VoiceProductionQualificationCurrentResponseDto
     */
    'capabilityProfileEffective'?: boolean;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationCurrentResponseDto
     */
    'releaseId': string | null;
    /**
     *
     * @type {number}
     * @memberof VoiceProductionQualificationCurrentResponseDto
     */
    'releaseRevision': number | null;
    /**
     *
     * @type {boolean}
     * @memberof VoiceProductionQualificationCurrentResponseDto
     */
    'releaseEffective': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceProductionQualificationCurrentResponseDto
     */
    'effective': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceProductionQualificationCurrentResponseDto
     */
    'receptionRuntimeEffective': boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceProductionQualificationCurrentResponseDto
     */
    'missingReceptionRuntimeCategories': VoiceProductionQualificationCurrentResponseDtoMissingReceptionRuntimeCategoriesEnum;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceProductionQualificationCurrentResponseDto
     */
    'missingCategories': VoiceProductionQualificationCurrentResponseDtoMissingCategoriesEnum;
    /**
     *
     * @type {Array<VoiceProductionQualificationEvidenceResponseDto>}
     * @memberof VoiceProductionQualificationCurrentResponseDto
     */
    'evidence': Array<VoiceProductionQualificationEvidenceResponseDto>;
    /**
     *
     * @type {VoiceProductionQualificationReleaseProjectionDto}
     * @memberof VoiceProductionQualificationCurrentResponseDto
     */
    'qualifiedRelease': VoiceProductionQualificationReleaseProjectionDto | null;
}

export const VoiceProductionQualificationCurrentResponseDtoBookingConfirmationChannelEnum = {
    Email: 'EMAIL'
} as const;

export type VoiceProductionQualificationCurrentResponseDtoBookingConfirmationChannelEnum = typeof VoiceProductionQualificationCurrentResponseDtoBookingConfirmationChannelEnum[keyof typeof VoiceProductionQualificationCurrentResponseDtoBookingConfirmationChannelEnum];
export const VoiceProductionQualificationCurrentResponseDtoRequiredCategoriesEnum = {
    VertexRuntime: 'VERTEX_RUNTIME',
    VertexZeroRetention: 'VERTEX_ZERO_RETENTION',
    ReceptionAssets: 'RECEPTION_ASSETS',
    ProviderQualification: 'PROVIDER_QUALIFICATION',
    Phase1Safety: 'PHASE_1_SAFETY',
    RateCatalogue: 'RATE_CATALOGUE',
    BookingSafety: 'BOOKING_SAFETY',
    VoiceSmsProvider: 'VOICE_SMS_PROVIDER',
    VoiceSmsPrivacy: 'VOICE_SMS_PRIVACY',
    VoiceSmsContract: 'VOICE_SMS_CONTRACT',
    ContactCapability: 'CONTACT_CAPABILITY',
    VoiceSmsErasure: 'VOICE_SMS_ERASURE',
    PilotAccess: 'PILOT_ACCESS'
} as const;

export type VoiceProductionQualificationCurrentResponseDtoRequiredCategoriesEnum = typeof VoiceProductionQualificationCurrentResponseDtoRequiredCategoriesEnum[keyof typeof VoiceProductionQualificationCurrentResponseDtoRequiredCategoriesEnum];
export const VoiceProductionQualificationCurrentResponseDtoMissingRequiredCategoriesEnum = {
    VertexRuntime: 'VERTEX_RUNTIME',
    VertexZeroRetention: 'VERTEX_ZERO_RETENTION',
    ReceptionAssets: 'RECEPTION_ASSETS',
    ProviderQualification: 'PROVIDER_QUALIFICATION',
    Phase1Safety: 'PHASE_1_SAFETY',
    RateCatalogue: 'RATE_CATALOGUE',
    BookingSafety: 'BOOKING_SAFETY',
    VoiceSmsProvider: 'VOICE_SMS_PROVIDER',
    VoiceSmsPrivacy: 'VOICE_SMS_PRIVACY',
    VoiceSmsContract: 'VOICE_SMS_CONTRACT',
    ContactCapability: 'CONTACT_CAPABILITY',
    VoiceSmsErasure: 'VOICE_SMS_ERASURE',
    PilotAccess: 'PILOT_ACCESS'
} as const;

export type VoiceProductionQualificationCurrentResponseDtoMissingRequiredCategoriesEnum = typeof VoiceProductionQualificationCurrentResponseDtoMissingRequiredCategoriesEnum[keyof typeof VoiceProductionQualificationCurrentResponseDtoMissingRequiredCategoriesEnum];
export const VoiceProductionQualificationCurrentResponseDtoMissingReceptionRuntimeCategoriesEnum = {
    VertexRuntime: 'VERTEX_RUNTIME',
    VertexZeroRetention: 'VERTEX_ZERO_RETENTION',
    ReceptionAssets: 'RECEPTION_ASSETS',
    ProviderQualification: 'PROVIDER_QUALIFICATION',
    Phase1Safety: 'PHASE_1_SAFETY',
    RateCatalogue: 'RATE_CATALOGUE',
    PilotAccess: 'PILOT_ACCESS'
} as const;

export type VoiceProductionQualificationCurrentResponseDtoMissingReceptionRuntimeCategoriesEnum = typeof VoiceProductionQualificationCurrentResponseDtoMissingReceptionRuntimeCategoriesEnum[keyof typeof VoiceProductionQualificationCurrentResponseDtoMissingReceptionRuntimeCategoriesEnum];
export const VoiceProductionQualificationCurrentResponseDtoMissingCategoriesEnum = {
    VertexRuntime: 'VERTEX_RUNTIME',
    VertexZeroRetention: 'VERTEX_ZERO_RETENTION',
    ReceptionAssets: 'RECEPTION_ASSETS',
    ProviderQualification: 'PROVIDER_QUALIFICATION',
    Phase1Safety: 'PHASE_1_SAFETY',
    RateCatalogue: 'RATE_CATALOGUE',
    BookingSafety: 'BOOKING_SAFETY',
    VoiceSmsProvider: 'VOICE_SMS_PROVIDER',
    VoiceSmsPrivacy: 'VOICE_SMS_PRIVACY',
    VoiceSmsContract: 'VOICE_SMS_CONTRACT',
    ContactCapability: 'CONTACT_CAPABILITY',
    VoiceSmsErasure: 'VOICE_SMS_ERASURE',
    PilotAccess: 'PILOT_ACCESS'
} as const;

export type VoiceProductionQualificationCurrentResponseDtoMissingCategoriesEnum = typeof VoiceProductionQualificationCurrentResponseDtoMissingCategoriesEnum[keyof typeof VoiceProductionQualificationCurrentResponseDtoMissingCategoriesEnum];

/**
 *
 * @export
 * @interface VoiceProductionQualificationEvidenceResponseDto
 */
export interface VoiceProductionQualificationEvidenceResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'id': string;
    /**
     *
     * @type {number}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'ledgerRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'releaseId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'releaseRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'category': VoiceProductionQualificationEvidenceResponseDtoCategoryEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'capability': VoiceProductionQualificationEvidenceResponseDtoCapabilityEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'subjectRevision': string;
    /**
     *
     * @type {VoiceProductionQualificationSourceBindingDto}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'source': VoiceProductionQualificationSourceBindingDto;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'provenanceDigest': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'observedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'expiresAt': string;
    /**
     *
     * @type {VoiceProductionVertexRuntimeDto}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'vertexRuntime': VoiceProductionVertexRuntimeDto | null;
    /**
     *
     * @type {VoiceProductionReceptionAssetsDto}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'receptionAssets': VoiceProductionReceptionAssetsDto | null;
    /**
     *
     * @type {VoiceSmsRetentionReviewDto}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'smsRetentionReview'?: VoiceSmsRetentionReviewDto | null;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'recordedByUserId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'recordedAt': string;
    /**
     *
     * @type {boolean}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'effective': boolean;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'invalidatedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationEvidenceResponseDto
     */
    'invalidationReason': VoiceProductionQualificationEvidenceResponseDtoInvalidationReasonEnum;
}

export const VoiceProductionQualificationEvidenceResponseDtoCategoryEnum = {
    VertexRuntime: 'VERTEX_RUNTIME',
    VertexZeroRetention: 'VERTEX_ZERO_RETENTION',
    ReceptionAssets: 'RECEPTION_ASSETS',
    ProviderQualification: 'PROVIDER_QUALIFICATION',
    Phase1Safety: 'PHASE_1_SAFETY',
    RateCatalogue: 'RATE_CATALOGUE',
    BookingSafety: 'BOOKING_SAFETY',
    VoiceSmsProvider: 'VOICE_SMS_PROVIDER',
    VoiceSmsPrivacy: 'VOICE_SMS_PRIVACY',
    VoiceSmsContract: 'VOICE_SMS_CONTRACT',
    ContactCapability: 'CONTACT_CAPABILITY',
    VoiceSmsErasure: 'VOICE_SMS_ERASURE',
    PilotAccess: 'PILOT_ACCESS'
} as const;

export type VoiceProductionQualificationEvidenceResponseDtoCategoryEnum = typeof VoiceProductionQualificationEvidenceResponseDtoCategoryEnum[keyof typeof VoiceProductionQualificationEvidenceResponseDtoCategoryEnum];
export const VoiceProductionQualificationEvidenceResponseDtoCapabilityEnum = {
    Operations: 'VOICE_OPERATIONS',
    PrivacyReviewer: 'VOICE_PRIVACY_REVIEWER',
    SafetyReviewer: 'VOICE_SAFETY_REVIEWER'
} as const;

export type VoiceProductionQualificationEvidenceResponseDtoCapabilityEnum = typeof VoiceProductionQualificationEvidenceResponseDtoCapabilityEnum[keyof typeof VoiceProductionQualificationEvidenceResponseDtoCapabilityEnum];
export const VoiceProductionQualificationEvidenceResponseDtoInvalidationReasonEnum = {
    ProviderDrift: 'PROVIDER_DRIFT',
    EvidenceRevoked: 'EVIDENCE_REVOKED',
    SourceCorrection: 'SOURCE_CORRECTION',
    SecurityIncident: 'SECURITY_INCIDENT'
} as const;

export type VoiceProductionQualificationEvidenceResponseDtoInvalidationReasonEnum = typeof VoiceProductionQualificationEvidenceResponseDtoInvalidationReasonEnum[keyof typeof VoiceProductionQualificationEvidenceResponseDtoInvalidationReasonEnum];

/**
 *
 * @export
 * @interface VoiceProductionQualificationHistoryEntryResponseDto
 */
export interface VoiceProductionQualificationHistoryEntryResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationHistoryEntryResponseDto
     */
    'eventType': VoiceProductionQualificationHistoryEntryResponseDtoEventTypeEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceProductionQualificationHistoryEntryResponseDto
     */
    'ledgerRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationHistoryEntryResponseDto
     */
    'releaseId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceProductionQualificationHistoryEntryResponseDto
     */
    'releaseRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationHistoryEntryResponseDto
     */
    'category': VoiceProductionQualificationHistoryEntryResponseDtoCategoryEnum;
    /**
     *
     * @type {VoiceProductionQualificationEvidenceResponseDto}
     * @memberof VoiceProductionQualificationHistoryEntryResponseDto
     */
    'evidence': VoiceProductionQualificationEvidenceResponseDto | null;
    /**
     *
     * @type {VoiceProductionQualificationInvalidationResponseDto}
     * @memberof VoiceProductionQualificationHistoryEntryResponseDto
     */
    'invalidation': VoiceProductionQualificationInvalidationResponseDto | null;
}

export const VoiceProductionQualificationHistoryEntryResponseDtoEventTypeEnum = {
    Published: 'PUBLISHED',
    Invalidated: 'INVALIDATED'
} as const;

export type VoiceProductionQualificationHistoryEntryResponseDtoEventTypeEnum = typeof VoiceProductionQualificationHistoryEntryResponseDtoEventTypeEnum[keyof typeof VoiceProductionQualificationHistoryEntryResponseDtoEventTypeEnum];
export const VoiceProductionQualificationHistoryEntryResponseDtoCategoryEnum = {
    VertexRuntime: 'VERTEX_RUNTIME',
    VertexZeroRetention: 'VERTEX_ZERO_RETENTION',
    ReceptionAssets: 'RECEPTION_ASSETS',
    ProviderQualification: 'PROVIDER_QUALIFICATION',
    Phase1Safety: 'PHASE_1_SAFETY',
    RateCatalogue: 'RATE_CATALOGUE',
    BookingSafety: 'BOOKING_SAFETY',
    VoiceSmsProvider: 'VOICE_SMS_PROVIDER',
    VoiceSmsPrivacy: 'VOICE_SMS_PRIVACY',
    VoiceSmsContract: 'VOICE_SMS_CONTRACT',
    ContactCapability: 'CONTACT_CAPABILITY',
    VoiceSmsErasure: 'VOICE_SMS_ERASURE',
    PilotAccess: 'PILOT_ACCESS'
} as const;

export type VoiceProductionQualificationHistoryEntryResponseDtoCategoryEnum = typeof VoiceProductionQualificationHistoryEntryResponseDtoCategoryEnum[keyof typeof VoiceProductionQualificationHistoryEntryResponseDtoCategoryEnum];

/**
 *
 * @export
 * @interface VoiceProductionQualificationInvalidationResponseDto
 */
export interface VoiceProductionQualificationInvalidationResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationInvalidationResponseDto
     */
    'id': string;
    /**
     *
     * @type {number}
     * @memberof VoiceProductionQualificationInvalidationResponseDto
     */
    'ledgerRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationInvalidationResponseDto
     */
    'evidenceId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationInvalidationResponseDto
     */
    'releaseId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceProductionQualificationInvalidationResponseDto
     */
    'releaseRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationInvalidationResponseDto
     */
    'category': VoiceProductionQualificationInvalidationResponseDtoCategoryEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationInvalidationResponseDto
     */
    'capability': VoiceProductionQualificationInvalidationResponseDtoCapabilityEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationInvalidationResponseDto
     */
    'provenanceDigest': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationInvalidationResponseDto
     */
    'reason': VoiceProductionQualificationInvalidationResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationInvalidationResponseDto
     */
    'invalidatedByUserId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationInvalidationResponseDto
     */
    'invalidatedAt': string;
}

export const VoiceProductionQualificationInvalidationResponseDtoCategoryEnum = {
    VertexRuntime: 'VERTEX_RUNTIME',
    VertexZeroRetention: 'VERTEX_ZERO_RETENTION',
    ReceptionAssets: 'RECEPTION_ASSETS',
    ProviderQualification: 'PROVIDER_QUALIFICATION',
    Phase1Safety: 'PHASE_1_SAFETY',
    RateCatalogue: 'RATE_CATALOGUE',
    BookingSafety: 'BOOKING_SAFETY',
    VoiceSmsProvider: 'VOICE_SMS_PROVIDER',
    VoiceSmsPrivacy: 'VOICE_SMS_PRIVACY',
    VoiceSmsContract: 'VOICE_SMS_CONTRACT',
    ContactCapability: 'CONTACT_CAPABILITY',
    VoiceSmsErasure: 'VOICE_SMS_ERASURE',
    PilotAccess: 'PILOT_ACCESS'
} as const;

export type VoiceProductionQualificationInvalidationResponseDtoCategoryEnum = typeof VoiceProductionQualificationInvalidationResponseDtoCategoryEnum[keyof typeof VoiceProductionQualificationInvalidationResponseDtoCategoryEnum];
export const VoiceProductionQualificationInvalidationResponseDtoCapabilityEnum = {
    Operations: 'VOICE_OPERATIONS',
    PrivacyReviewer: 'VOICE_PRIVACY_REVIEWER',
    SafetyReviewer: 'VOICE_SAFETY_REVIEWER'
} as const;

export type VoiceProductionQualificationInvalidationResponseDtoCapabilityEnum = typeof VoiceProductionQualificationInvalidationResponseDtoCapabilityEnum[keyof typeof VoiceProductionQualificationInvalidationResponseDtoCapabilityEnum];
export const VoiceProductionQualificationInvalidationResponseDtoReasonEnum = {
    ProviderDrift: 'PROVIDER_DRIFT',
    EvidenceRevoked: 'EVIDENCE_REVOKED',
    SourceCorrection: 'SOURCE_CORRECTION',
    SecurityIncident: 'SECURITY_INCIDENT'
} as const;

export type VoiceProductionQualificationInvalidationResponseDtoReasonEnum = typeof VoiceProductionQualificationInvalidationResponseDtoReasonEnum[keyof typeof VoiceProductionQualificationInvalidationResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface VoiceProductionQualificationReleaseAssetDto
 */
export interface VoiceProductionQualificationReleaseAssetDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationReleaseAssetDto
     */
    'purpose': VoiceProductionQualificationReleaseAssetDtoPurposeEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationReleaseAssetDto
     */
    'assetId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationReleaseAssetDto
     */
    'sha256': string;
}

export const VoiceProductionQualificationReleaseAssetDtoPurposeEnum = {
    CallDisclosure: 'CALL_DISCLOSURE',
    OrdinaryUnavailable: 'ORDINARY_UNAVAILABLE',
    OrdinaryTransferFailed: 'ORDINARY_TRANSFER_FAILED',
    SafetyFallback: 'SAFETY_FALLBACK',
    HumanDanger112: 'HUMAN_DANGER_112',
    EmergencyRoutingNotice: 'EMERGENCY_ROUTING_NOTICE',
    EmergencyDeclineClose: 'EMERGENCY_DECLINE_CLOSE',
    CallbackReview: 'CALLBACK_REVIEW',
    PhonePlus: 'PHONE_PLUS',
    PhoneDigit0: 'PHONE_DIGIT_0',
    PhoneDigit1: 'PHONE_DIGIT_1',
    PhoneDigit2: 'PHONE_DIGIT_2',
    PhoneDigit3: 'PHONE_DIGIT_3',
    PhoneDigit4: 'PHONE_DIGIT_4',
    PhoneDigit5: 'PHONE_DIGIT_5',
    PhoneDigit6: 'PHONE_DIGIT_6',
    PhoneDigit7: 'PHONE_DIGIT_7',
    PhoneDigit8: 'PHONE_DIGIT_8',
    PhoneDigit9: 'PHONE_DIGIT_9',
    SilenceNudge1: 'SILENCE_NUDGE_1',
    SilenceNudge2: 'SILENCE_NUDGE_2',
    TimeLimitClosing: 'TIME_LIMIT_CLOSING'
} as const;

export type VoiceProductionQualificationReleaseAssetDtoPurposeEnum = typeof VoiceProductionQualificationReleaseAssetDtoPurposeEnum[keyof typeof VoiceProductionQualificationReleaseAssetDtoPurposeEnum];

/**
 *
 * @export
 * @interface VoiceProductionQualificationReleaseProjectionDto
 */
export interface VoiceProductionQualificationReleaseProjectionDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationReleaseProjectionDto
     */
    'qualifiedModelId': VoiceProductionQualificationReleaseProjectionDtoQualifiedModelIdEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationReleaseProjectionDto
     */
    'vertexProjectId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationReleaseProjectionDto
     */
    'vertexLocation': VoiceProductionQualificationReleaseProjectionDtoVertexLocationEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationReleaseProjectionDto
     */
    'voiceId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceProductionQualificationReleaseProjectionDto
     */
    'voiceRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationReleaseProjectionDto
     */
    'rendererVersion': string;
    /**
     *
     * @type {Array<VoiceProductionQualificationReleaseAssetDto>}
     * @memberof VoiceProductionQualificationReleaseProjectionDto
     */
    'approvedAssets': Array<VoiceProductionQualificationReleaseAssetDto>;
}

export const VoiceProductionQualificationReleaseProjectionDtoQualifiedModelIdEnum = {
    GeminiLive25FlashNativeAudio: 'gemini-live-2.5-flash-native-audio'
} as const;

export type VoiceProductionQualificationReleaseProjectionDtoQualifiedModelIdEnum = typeof VoiceProductionQualificationReleaseProjectionDtoQualifiedModelIdEnum[keyof typeof VoiceProductionQualificationReleaseProjectionDtoQualifiedModelIdEnum];
export const VoiceProductionQualificationReleaseProjectionDtoVertexLocationEnum = {
    EuropeCentral2: 'europe-central2'
} as const;

export type VoiceProductionQualificationReleaseProjectionDtoVertexLocationEnum = typeof VoiceProductionQualificationReleaseProjectionDtoVertexLocationEnum[keyof typeof VoiceProductionQualificationReleaseProjectionDtoVertexLocationEnum];

/**
 *
 * @export
 * @interface VoiceProductionQualificationRenewalResponseDto
 */
export interface VoiceProductionQualificationRenewalResponseDto {
    /**
     *
     * @type {number}
     * @memberof VoiceProductionQualificationRenewalResponseDto
     */
    'trackingRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationRenewalResponseDto
     */
    'status': VoiceProductionQualificationRenewalResponseDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationRenewalResponseDto
     */
    'cycleId': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationRenewalResponseDto
     */
    'requirementKind': string | null;
    /**
     *
     * @type {number}
     * @memberof VoiceProductionQualificationRenewalResponseDto
     */
    'qualificationHeadRevision': number | null;
    /**
     *
     * @type {number}
     * @memberof VoiceProductionQualificationRenewalResponseDto
     */
    'releaseRevision': number | null;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceProductionQualificationRenewalResponseDto
     */
    'requiredCategories': Array<VoiceProductionQualificationRenewalResponseDtoRequiredCategoriesEnum>;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationRenewalResponseDto
     */
    'openedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationRenewalResponseDto
     */
    'acknowledgementDueAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationRenewalResponseDto
     */
    'renewalDueAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationRenewalResponseDto
     */
    'acknowledgedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationRenewalResponseDto
     */
    'unacknowledgedEscalatedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationRenewalResponseDto
     */
    'overdueEscalatedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationRenewalResponseDto
     */
    'lastAssessedAt': string | null;
}

export const VoiceProductionQualificationRenewalResponseDtoStatusEnum = {
    Unassessed: 'UNASSESSED',
    Clear: 'CLEAR',
    AwaitingAcknowledgement: 'AWAITING_ACKNOWLEDGEMENT',
    Acknowledged: 'ACKNOWLEDGED',
    UnacknowledgedEscalated: 'UNACKNOWLEDGED_ESCALATED',
    Overdue: 'OVERDUE'
} as const;

export type VoiceProductionQualificationRenewalResponseDtoStatusEnum = typeof VoiceProductionQualificationRenewalResponseDtoStatusEnum[keyof typeof VoiceProductionQualificationRenewalResponseDtoStatusEnum];
export const VoiceProductionQualificationRenewalResponseDtoRequiredCategoriesEnum = {
    VertexRuntime: 'VERTEX_RUNTIME',
    VertexZeroRetention: 'VERTEX_ZERO_RETENTION',
    ReceptionAssets: 'RECEPTION_ASSETS',
    ProviderQualification: 'PROVIDER_QUALIFICATION',
    Phase1Safety: 'PHASE_1_SAFETY',
    RateCatalogue: 'RATE_CATALOGUE',
    BookingSafety: 'BOOKING_SAFETY',
    VoiceSmsProvider: 'VOICE_SMS_PROVIDER',
    VoiceSmsPrivacy: 'VOICE_SMS_PRIVACY',
    VoiceSmsContract: 'VOICE_SMS_CONTRACT',
    ContactCapability: 'CONTACT_CAPABILITY',
    VoiceSmsErasure: 'VOICE_SMS_ERASURE',
    PilotAccess: 'PILOT_ACCESS'
} as const;

export type VoiceProductionQualificationRenewalResponseDtoRequiredCategoriesEnum = typeof VoiceProductionQualificationRenewalResponseDtoRequiredCategoriesEnum[keyof typeof VoiceProductionQualificationRenewalResponseDtoRequiredCategoriesEnum];

/**
 *
 * @export
 * @interface VoiceProductionQualificationSourceBindingDto
 */
export interface VoiceProductionQualificationSourceBindingDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationSourceBindingDto
     */
    'kind': VoiceProductionQualificationSourceBindingDtoKindEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationSourceBindingDto
     */
    'authorityId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceProductionQualificationSourceBindingDto
     */
    'authorityRevision': number;
}

export const VoiceProductionQualificationSourceBindingDtoKindEnum = {
    QualifiedReleaseVertexRuntime: 'QUALIFIED_RELEASE_VERTEX_RUNTIME',
    VertexZeroRetentionApproval: 'VERTEX_ZERO_RETENTION_APPROVAL',
    QualifiedReleaseReceptionAssets: 'QUALIFIED_RELEASE_RECEPTION_ASSETS',
    VoiceProviderObservation: 'VOICE_PROVIDER_OBSERVATION',
    Phase1SafetyApproval: 'PHASE_1_SAFETY_APPROVAL',
    RateCataloguePublication: 'RATE_CATALOGUE_PUBLICATION',
    VoiceBookingConfiguration: 'VOICE_BOOKING_CONFIGURATION',
    VoiceSmsProviderObservation: 'VOICE_SMS_PROVIDER_OBSERVATION',
    VoiceSmsPrivacyApproval: 'VOICE_SMS_PRIVACY_APPROVAL',
    VoiceSmsContract: 'VOICE_SMS_CONTRACT',
    VoiceSmsContactCapability: 'VOICE_SMS_CONTACT_CAPABILITY',
    VoiceSmsErasureObservation: 'VOICE_SMS_ERASURE_OBSERVATION',
    VoicePilotEnvelope: 'VOICE_PILOT_ENVELOPE'
} as const;

export type VoiceProductionQualificationSourceBindingDtoKindEnum = typeof VoiceProductionQualificationSourceBindingDtoKindEnum[keyof typeof VoiceProductionQualificationSourceBindingDtoKindEnum];

/**
 *
 * @export
 * @interface VoiceProductionQualificationSourceCandidateResponseDto
 */
export interface VoiceProductionQualificationSourceCandidateResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationSourceCandidateResponseDto
     */
    'category': VoiceProductionQualificationSourceCandidateResponseDtoCategoryEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationSourceCandidateResponseDto
     */
    'inputMode': VoiceProductionQualificationSourceCandidateResponseDtoInputModeEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationSourceCandidateResponseDto
     */
    'sourceKind': VoiceProductionQualificationSourceCandidateResponseDtoSourceKindEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationSourceCandidateResponseDto
     */
    'authorityId': string | null;
    /**
     *
     * @type {number}
     * @memberof VoiceProductionQualificationSourceCandidateResponseDto
     */
    'authorityRevision': number | null;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationSourceCandidateResponseDto
     */
    'subjectRevision': string | null;
    /**
     *
     * @type {VoiceProductionVertexRuntimeDto}
     * @memberof VoiceProductionQualificationSourceCandidateResponseDto
     */
    'vertexRuntime': VoiceProductionVertexRuntimeDto | null;
    /**
     *
     * @type {VoiceProductionReceptionAssetsDto}
     * @memberof VoiceProductionQualificationSourceCandidateResponseDto
     */
    'receptionAssets': VoiceProductionReceptionAssetsDto | null;
}

export const VoiceProductionQualificationSourceCandidateResponseDtoCategoryEnum = {
    VertexRuntime: 'VERTEX_RUNTIME',
    VertexZeroRetention: 'VERTEX_ZERO_RETENTION',
    ReceptionAssets: 'RECEPTION_ASSETS',
    ProviderQualification: 'PROVIDER_QUALIFICATION',
    Phase1Safety: 'PHASE_1_SAFETY',
    RateCatalogue: 'RATE_CATALOGUE',
    BookingSafety: 'BOOKING_SAFETY',
    VoiceSmsProvider: 'VOICE_SMS_PROVIDER',
    VoiceSmsPrivacy: 'VOICE_SMS_PRIVACY',
    VoiceSmsContract: 'VOICE_SMS_CONTRACT',
    ContactCapability: 'CONTACT_CAPABILITY',
    VoiceSmsErasure: 'VOICE_SMS_ERASURE',
    PilotAccess: 'PILOT_ACCESS'
} as const;

export type VoiceProductionQualificationSourceCandidateResponseDtoCategoryEnum = typeof VoiceProductionQualificationSourceCandidateResponseDtoCategoryEnum[keyof typeof VoiceProductionQualificationSourceCandidateResponseDtoCategoryEnum];
export const VoiceProductionQualificationSourceCandidateResponseDtoInputModeEnum = {
    CanonicalCurrent: 'CANONICAL_CURRENT',
    ExternalAttestation: 'EXTERNAL_ATTESTATION',
    Unavailable: 'UNAVAILABLE'
} as const;

export type VoiceProductionQualificationSourceCandidateResponseDtoInputModeEnum = typeof VoiceProductionQualificationSourceCandidateResponseDtoInputModeEnum[keyof typeof VoiceProductionQualificationSourceCandidateResponseDtoInputModeEnum];
export const VoiceProductionQualificationSourceCandidateResponseDtoSourceKindEnum = {
    QualifiedReleaseVertexRuntime: 'QUALIFIED_RELEASE_VERTEX_RUNTIME',
    VertexZeroRetentionApproval: 'VERTEX_ZERO_RETENTION_APPROVAL',
    QualifiedReleaseReceptionAssets: 'QUALIFIED_RELEASE_RECEPTION_ASSETS',
    VoiceProviderObservation: 'VOICE_PROVIDER_OBSERVATION',
    Phase1SafetyApproval: 'PHASE_1_SAFETY_APPROVAL',
    RateCataloguePublication: 'RATE_CATALOGUE_PUBLICATION',
    VoiceBookingConfiguration: 'VOICE_BOOKING_CONFIGURATION',
    VoiceSmsProviderObservation: 'VOICE_SMS_PROVIDER_OBSERVATION',
    VoiceSmsPrivacyApproval: 'VOICE_SMS_PRIVACY_APPROVAL',
    VoiceSmsContract: 'VOICE_SMS_CONTRACT',
    VoiceSmsContactCapability: 'VOICE_SMS_CONTACT_CAPABILITY',
    VoiceSmsErasureObservation: 'VOICE_SMS_ERASURE_OBSERVATION',
    VoicePilotEnvelope: 'VOICE_PILOT_ENVELOPE'
} as const;

export type VoiceProductionQualificationSourceCandidateResponseDtoSourceKindEnum = typeof VoiceProductionQualificationSourceCandidateResponseDtoSourceKindEnum[keyof typeof VoiceProductionQualificationSourceCandidateResponseDtoSourceKindEnum];

/**
 *
 * @export
 * @interface VoiceProductionQualificationSourceCandidatesResponseDto
 */
export interface VoiceProductionQualificationSourceCandidatesResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualificationSourceCandidatesResponseDto
     */
    'releaseId': string | null;
    /**
     *
     * @type {number}
     * @memberof VoiceProductionQualificationSourceCandidatesResponseDto
     */
    'releaseRevision': number | null;
    /**
     *
     * @type {Array<VoiceProductionQualificationSourceCandidateResponseDto>}
     * @memberof VoiceProductionQualificationSourceCandidatesResponseDto
     */
    'candidates': Array<VoiceProductionQualificationSourceCandidateResponseDto>;
}
/**
 *
 * @export
 * @interface VoiceProductionQualifiedAudioAssetDto
 */
export interface VoiceProductionQualifiedAudioAssetDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualifiedAudioAssetDto
     */
    'assetId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualifiedAudioAssetDto
     */
    'sha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionQualifiedAudioAssetDto
     */
    'rendererVersion': string;
}
/**
 *
 * @export
 * @interface VoiceProductionReceptionAssetsDto
 */
export interface VoiceProductionReceptionAssetsDto {
    /**
     *
     * @type {VoiceProductionQualifiedAudioAssetDto}
     * @memberof VoiceProductionReceptionAssetsDto
     */
    'silenceNudge1': VoiceProductionQualifiedAudioAssetDto;
    /**
     *
     * @type {VoiceProductionQualifiedAudioAssetDto}
     * @memberof VoiceProductionReceptionAssetsDto
     */
    'silenceNudge2': VoiceProductionQualifiedAudioAssetDto;
    /**
     *
     * @type {VoiceProductionQualifiedAudioAssetDto}
     * @memberof VoiceProductionReceptionAssetsDto
     */
    'timeLimitClosing': VoiceProductionQualifiedAudioAssetDto;
}
/**
 *
 * @export
 * @interface VoiceProductionVertexRuntimeDto
 */
export interface VoiceProductionVertexRuntimeDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProductionVertexRuntimeDto
     */
    'projectId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionVertexRuntimeDto
     */
    'location': VoiceProductionVertexRuntimeDtoLocationEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProductionVertexRuntimeDto
     */
    'model': VoiceProductionVertexRuntimeDtoModelEnum;
}

export const VoiceProductionVertexRuntimeDtoLocationEnum = {
    EuropeCentral2: 'europe-central2'
} as const;

export type VoiceProductionVertexRuntimeDtoLocationEnum = typeof VoiceProductionVertexRuntimeDtoLocationEnum[keyof typeof VoiceProductionVertexRuntimeDtoLocationEnum];
export const VoiceProductionVertexRuntimeDtoModelEnum = {
    GeminiLive25FlashNativeAudio: 'gemini-live-2.5-flash-native-audio'
} as const;

export type VoiceProductionVertexRuntimeDtoModelEnum = typeof VoiceProductionVertexRuntimeDtoModelEnum[keyof typeof VoiceProductionVertexRuntimeDtoModelEnum];

/**
 *
 * @export
 * @interface VoiceProviderCallScanCommandDto
 */
export interface VoiceProviderCallScanCommandDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanCommandDto
     */
    'acknowledgement': VoiceProviderCallScanCommandDtoAcknowledgementEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanCommandDto
     */
    'reason': VoiceProviderCallScanCommandDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanCommandDto
     */
    'operationId': string;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceProviderCallScanCommandDto
     */
    'incidentKeys': Array<string>;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanCommandDto
     */
    'approvalReference': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanCommandDto
     */
    'authorizedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanCommandDto
     */
    'authorizationExpiresAt': string;
}

export const VoiceProviderCallScanCommandDtoAcknowledgementEnum = {
    HumanAuthorizedExactProviderPrivacyIncidentScanAndDelete: 'HUMAN_AUTHORIZED_EXACT_PROVIDER_PRIVACY_INCIDENT_SCAN_AND_DELETE'
} as const;

export type VoiceProviderCallScanCommandDtoAcknowledgementEnum = typeof VoiceProviderCallScanCommandDtoAcknowledgementEnum[keyof typeof VoiceProviderCallScanCommandDtoAcknowledgementEnum];
export const VoiceProviderCallScanCommandDtoReasonEnum = {
    PrivacyIncidentRecovery: 'PROVIDER_PRIVACY_INCIDENT_RECOVERY',
    RetentionReconciliation: 'PROVIDER_RETENTION_RECONCILIATION'
} as const;

export type VoiceProviderCallScanCommandDtoReasonEnum = typeof VoiceProviderCallScanCommandDtoReasonEnum[keyof typeof VoiceProviderCallScanCommandDtoReasonEnum];

/**
 *
 * @export
 * @interface VoiceProviderCallScanResponseDto
 */
export interface VoiceProviderCallScanResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanResponseDto
     */
    'operationId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanResponseDto
     */
    'status': VoiceProviderCallScanResponseDtoStatusEnum;
    /**
     *
     * @type {Array<VoiceProviderCallScanTargetResponseDto>}
     * @memberof VoiceProviderCallScanResponseDto
     */
    'targets': Array<VoiceProviderCallScanTargetResponseDto>;
}

export const VoiceProviderCallScanResponseDtoStatusEnum = {
    Completed: 'COMPLETED',
    Partial: 'PARTIAL',
    Failed: 'FAILED',
    Busy: 'BUSY'
} as const;

export type VoiceProviderCallScanResponseDtoStatusEnum = typeof VoiceProviderCallScanResponseDtoStatusEnum[keyof typeof VoiceProviderCallScanResponseDtoStatusEnum];

/**
 *
 * @export
 * @interface VoiceProviderCallScanScheduleAuthorityCandidateResponseDto
 */
export interface VoiceProviderCallScanScheduleAuthorityCandidateResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityCandidateResponseDto
     */
    'deployGithubSha': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityCandidateResponseDto
     */
    'cloudRunRevision': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityCandidateResponseDto
     */
    'scopeDigest': string;
    /**
     *
     * @type {Array<VoiceProviderCallScanScheduleScopeResponseDto>}
     * @memberof VoiceProviderCallScanScheduleAuthorityCandidateResponseDto
     */
    'scopes': Array<VoiceProviderCallScanScheduleScopeResponseDto>;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityCandidateResponseDto
     */
    'expiresAt': string;
}
/**
 *
 * @export
 * @interface VoiceProviderCallScanScheduleAuthorityProposalDto
 */
export interface VoiceProviderCallScanScheduleAuthorityProposalDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityProposalDto
     */
    'governanceReference': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityProposalDto
     */
    'expiresAt': string;
}
/**
 *
 * @export
 * @interface VoiceProviderCallScanScheduleAuthorityReadResponseDto
 */
export interface VoiceProviderCallScanScheduleAuthorityReadResponseDto {
    /**
     *
     * @type {VoiceProviderCallScanScheduleAuthorityResponseDto}
     * @memberof VoiceProviderCallScanScheduleAuthorityReadResponseDto
     */
    'authority': VoiceProviderCallScanScheduleAuthorityResponseDto | null;
}
/**
 *
 * @export
 * @interface VoiceProviderCallScanScheduleAuthorityResponseDto
 */
export interface VoiceProviderCallScanScheduleAuthorityResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityResponseDto
     */
    'authorityId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityResponseDto
     */
    'status': VoiceProviderCallScanScheduleAuthorityResponseDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityResponseDto
     */
    'deployGithubSha': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityResponseDto
     */
    'cloudRunRevision': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityResponseDto
     */
    'governanceReference': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityResponseDto
     */
    'scopeDigest': string;
    /**
     *
     * @type {Array<VoiceProviderCallScanScheduleScopeResponseDto>}
     * @memberof VoiceProviderCallScanScheduleAuthorityResponseDto
     */
    'scopes': Array<VoiceProviderCallScanScheduleScopeResponseDto>;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityResponseDto
     */
    'proposedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityResponseDto
     */
    'approvedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityResponseDto
     */
    'activatedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityResponseDto
     */
    'expiresAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleAuthorityResponseDto
     */
    'revokedAt': string | null;
}

export const VoiceProviderCallScanScheduleAuthorityResponseDtoStatusEnum = {
    Proposed: 'PROPOSED',
    Approved: 'APPROVED',
    Active: 'ACTIVE',
    Revoked: 'REVOKED'
} as const;

export type VoiceProviderCallScanScheduleAuthorityResponseDtoStatusEnum = typeof VoiceProviderCallScanScheduleAuthorityResponseDtoStatusEnum[keyof typeof VoiceProviderCallScanScheduleAuthorityResponseDtoStatusEnum];

/**
 *
 * @export
 * @interface VoiceProviderCallScanScheduleScopeResponseDto
 */
export interface VoiceProviderCallScanScheduleScopeResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleScopeResponseDto
     */
    'voiceLineId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceProviderCallScanScheduleScopeResponseDto
     */
    'assignmentFence': number;
    /**
     *
     * @type {number}
     * @memberof VoiceProviderCallScanScheduleScopeResponseDto
     */
    'routingFence': number;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceProviderCallScanScheduleScopeResponseDto
     */
    'incidentKeys': Array<string>;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleScopeResponseDto
     */
    'coverageWindowStart': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanScheduleScopeResponseDto
     */
    'coverageWindowEnd': string;
}
/**
 *
 * @export
 * @interface VoiceProviderCallScanTargetResponseDto
 */
export interface VoiceProviderCallScanTargetResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanTargetResponseDto
     */
    'incidentKey': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanTargetResponseDto
     */
    'status': VoiceProviderCallScanTargetResponseDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderCallScanTargetResponseDto
     */
    'failureCode': VoiceProviderCallScanTargetResponseDtoFailureCodeEnum;
}

export const VoiceProviderCallScanTargetResponseDtoStatusEnum = {
    Completed: 'COMPLETED',
    Partial: 'PARTIAL',
    Failed: 'FAILED',
    Busy: 'BUSY'
} as const;

export type VoiceProviderCallScanTargetResponseDtoStatusEnum = typeof VoiceProviderCallScanTargetResponseDtoStatusEnum[keyof typeof VoiceProviderCallScanTargetResponseDtoStatusEnum];
export const VoiceProviderCallScanTargetResponseDtoFailureCodeEnum = {
    TargetNotFound: 'TARGET_NOT_FOUND',
    TargetNotRemediationAuthorized: 'TARGET_NOT_REMEDIATION_AUTHORIZED',
    TargetAuthorityNotCurrent: 'TARGET_AUTHORITY_NOT_CURRENT',
    TargetCoverageWindowUnavailable: 'TARGET_COVERAGE_WINDOW_UNAVAILABLE',
    TargetSetInvalid: 'TARGET_SET_INVALID',
    ProviderScanPartial: 'PROVIDER_SCAN_PARTIAL',
    ProviderScanCoveragePersistenceUncertain: 'PROVIDER_SCAN_COVERAGE_PERSISTENCE_UNCERTAIN',
    ProviderScanFailed: 'PROVIDER_SCAN_FAILED',
    ProviderScanBusy: 'PROVIDER_SCAN_BUSY',
    RemediationTransitionFailed: 'REMEDIATION_TRANSITION_FAILED',
    AuthorizationWindowExpired: 'AUTHORIZATION_WINDOW_EXPIRED',
    ExecutorCapabilityNotCurrent: 'EXECUTOR_CAPABILITY_NOT_CURRENT',
    ScheduleAuthorityScopeNotCurrent: 'SCHEDULE_AUTHORITY_SCOPE_NOT_CURRENT'
} as const;

export type VoiceProviderCallScanTargetResponseDtoFailureCodeEnum = typeof VoiceProviderCallScanTargetResponseDtoFailureCodeEnum[keyof typeof VoiceProviderCallScanTargetResponseDtoFailureCodeEnum];

/**
 *
 * @export
 * @interface VoiceProviderPrivacyIncidentCurrentResponseDto
 */
export interface VoiceProviderPrivacyIncidentCurrentResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProviderPrivacyIncidentCurrentResponseDto
     */
    'incidentKey': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderPrivacyIncidentCurrentResponseDto
     */
    'reason': VoiceProviderPrivacyIncidentCurrentResponseDtoReasonEnum;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceProviderPrivacyIncidentCurrentResponseDto
     */
    'resourceKinds': Array<VoiceProviderPrivacyIncidentCurrentResponseDtoResourceKindsEnum>;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderPrivacyIncidentCurrentResponseDto
     */
    'status': VoiceProviderPrivacyIncidentCurrentResponseDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderPrivacyIncidentCurrentResponseDto
     */
    'openedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderPrivacyIncidentCurrentResponseDto
     */
    'authorizedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderPrivacyIncidentCurrentResponseDto
     */
    'remediatedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderPrivacyIncidentCurrentResponseDto
     */
    'reopenAuthorizedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderPrivacyIncidentCurrentResponseDto
     */
    'reopenedAt': string | null;
    /**
     *
     * @type {VoiceProviderRemediationCurrentAuthorityResponseDto}
     * @memberof VoiceProviderPrivacyIncidentCurrentResponseDto
     */
    'currentAuthority': VoiceProviderRemediationCurrentAuthorityResponseDto | null;
}

export const VoiceProviderPrivacyIncidentCurrentResponseDtoReasonEnum = {
    Day30ProviderErasureUnverified: 'DAY_30_PROVIDER_ERASURE_UNVERIFIED',
    ProviderArtifactDrift: 'PROVIDER_ARTIFACT_DRIFT',
    ProviderScanCoverageGap: 'PROVIDER_SCAN_COVERAGE_GAP'
} as const;

export type VoiceProviderPrivacyIncidentCurrentResponseDtoReasonEnum = typeof VoiceProviderPrivacyIncidentCurrentResponseDtoReasonEnum[keyof typeof VoiceProviderPrivacyIncidentCurrentResponseDtoReasonEnum];
export const VoiceProviderPrivacyIncidentCurrentResponseDtoResourceKindsEnum = {
    Recording: 'RECORDING',
    Transcription: 'TRANSCRIPTION'
} as const;

export type VoiceProviderPrivacyIncidentCurrentResponseDtoResourceKindsEnum = typeof VoiceProviderPrivacyIncidentCurrentResponseDtoResourceKindsEnum[keyof typeof VoiceProviderPrivacyIncidentCurrentResponseDtoResourceKindsEnum];
export const VoiceProviderPrivacyIncidentCurrentResponseDtoStatusEnum = {
    SuspendedPendingAuthorization: 'SUSPENDED_PENDING_AUTHORIZATION',
    RemediationAuthorized: 'REMEDIATION_AUTHORIZED',
    RemediatedPendingReopen: 'REMEDIATED_PENDING_REOPEN',
    Reopened: 'REOPENED'
} as const;

export type VoiceProviderPrivacyIncidentCurrentResponseDtoStatusEnum = typeof VoiceProviderPrivacyIncidentCurrentResponseDtoStatusEnum[keyof typeof VoiceProviderPrivacyIncidentCurrentResponseDtoStatusEnum];

/**
 *
 * @export
 * @interface VoiceProviderPrivacyIncidentReopenResponseDto
 */
export interface VoiceProviderPrivacyIncidentReopenResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProviderPrivacyIncidentReopenResponseDto
     */
    'incidentKey': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderPrivacyIncidentReopenResponseDto
     */
    'status': VoiceProviderPrivacyIncidentReopenResponseDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderPrivacyIncidentReopenResponseDto
     */
    'reopenedAt': string;
}

export const VoiceProviderPrivacyIncidentReopenResponseDtoStatusEnum = {
    Reopened: 'REOPENED'
} as const;

export type VoiceProviderPrivacyIncidentReopenResponseDtoStatusEnum = typeof VoiceProviderPrivacyIncidentReopenResponseDtoStatusEnum[keyof typeof VoiceProviderPrivacyIncidentReopenResponseDtoStatusEnum];

/**
 *
 * @export
 * @interface VoiceProviderRemediationApprovalResponseDto
 */
export interface VoiceProviderRemediationApprovalResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProviderRemediationApprovalResponseDto
     */
    'incidentKey': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderRemediationApprovalResponseDto
     */
    'proposalId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderRemediationApprovalResponseDto
     */
    'approvedAt': string;
}
/**
 *
 * @export
 * @interface VoiceProviderRemediationCurrentAuthorityResponseDto
 */
export interface VoiceProviderRemediationCurrentAuthorityResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProviderRemediationCurrentAuthorityResponseDto
     */
    'proposalId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderRemediationCurrentAuthorityResponseDto
     */
    'status': VoiceProviderRemediationCurrentAuthorityResponseDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderRemediationCurrentAuthorityResponseDto
     */
    'expiresAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderRemediationCurrentAuthorityResponseDto
     */
    'approvedAt': string | null;
}

export const VoiceProviderRemediationCurrentAuthorityResponseDtoStatusEnum = {
    Proposed: 'PROPOSED',
    Approved: 'APPROVED',
    Consumed: 'CONSUMED',
    Expired: 'EXPIRED'
} as const;

export type VoiceProviderRemediationCurrentAuthorityResponseDtoStatusEnum = typeof VoiceProviderRemediationCurrentAuthorityResponseDtoStatusEnum[keyof typeof VoiceProviderRemediationCurrentAuthorityResponseDtoStatusEnum];

/**
 *
 * @export
 * @interface VoiceProviderRemediationProposalResponseDto
 */
export interface VoiceProviderRemediationProposalResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceProviderRemediationProposalResponseDto
     */
    'incidentKey': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderRemediationProposalResponseDto
     */
    'proposalId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceProviderRemediationProposalResponseDto
     */
    'expiresAt': string;
}
/**
 *
 * @export
 * @interface VoiceQualifiedCostComponentDto
 */
export interface VoiceQualifiedCostComponentDto {
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedCostComponentDto
     */
    'component': VoiceQualifiedCostComponentDtoComponentEnum;
    /**
     * Zakwalifikowany koszt jednostkowy w mikro-PLN
     * @type {number}
     * @memberof VoiceQualifiedCostComponentDto
     */
    'costMicrosPlnPerUnit': number;
    /**
     * Całkowita liczba jednostek ilości przypadająca na stawkę
     * @type {number}
     * @memberof VoiceQualifiedCostComponentDto
     */
    'quantityScale': number;
    /**
     * Największa zakwalifikowana ilość rezerwowana dla jednego przyjętego połączenia
     * @type {number}
     * @memberof VoiceQualifiedCostComponentDto
     */
    'worstCaseQuantity': number;
    /**
     * Zakwalifikowane przesunięcie początku okna rezerwacji kosztu od przyjęcia połączenia
     * @type {number}
     * @memberof VoiceQualifiedCostComponentDto
     */
    'reservationWindowOffsetMs': number;
    /**
     * Zakwalifikowany maksymalny czas trwania okna rezerwacji kosztu
     * @type {number}
     * @memberof VoiceQualifiedCostComponentDto
     */
    'reservationWindowDurationMs': number;
}

export const VoiceQualifiedCostComponentDtoComponentEnum = {
    Vertex: 'VERTEX',
    TwilioInboundVoice: 'TWILIO_INBOUND_VOICE',
    MediaStreams: 'MEDIA_STREAMS',
    BoundedTransfer: 'BOUNDED_TRANSFER',
    VoiceSms: 'VOICE_SMS',
    ContactCapabilityLookup: 'CONTACT_CAPABILITY_LOOKUP',
    FallbackSpeech: 'FALLBACK_SPEECH'
} as const;

export type VoiceQualifiedCostComponentDtoComponentEnum = typeof VoiceQualifiedCostComponentDtoComponentEnum[keyof typeof VoiceQualifiedCostComponentDtoComponentEnum];

/**
 *
 * @export
 * @interface VoiceQualifiedRatePublicationResponseDto
 */
export interface VoiceQualifiedRatePublicationResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedRatePublicationResponseDto
     */
    'id': string;
    /**
     *
     * @type {number}
     * @memberof VoiceQualifiedRatePublicationResponseDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedRatePublicationResponseDto
     */
    'qualifiedFrom': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedRatePublicationResponseDto
     */
    'qualifiedUntil': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedRatePublicationResponseDto
     */
    'qualificationEvidenceVersion': string;
    /**
     *
     * @type {Array<VoiceQualifiedCostComponentDto>}
     * @memberof VoiceQualifiedRatePublicationResponseDto
     */
    'components': Array<VoiceQualifiedCostComponentDto>;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedRatePublicationResponseDto
     */
    'publishedByUserId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedRatePublicationResponseDto
     */
    'reason': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedRatePublicationResponseDto
     */
    'publishedAt': string;
}
/**
 *
 * @export
 * @interface VoiceQualifiedReleaseApprovalResponseDto
 */
export interface VoiceQualifiedReleaseApprovalResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseApprovalResponseDto
     */
    'capability': VoiceQualifiedReleaseApprovalResponseDtoCapabilityEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseApprovalResponseDto
     */
    'approvedByUserId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseApprovalResponseDto
     */
    'evidenceDigest': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseApprovalResponseDto
     */
    'approvedAssetManifestSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseApprovalResponseDto
     */
    'approvedAt': string;
}

export const VoiceQualifiedReleaseApprovalResponseDtoCapabilityEnum = {
    Operations: 'VOICE_OPERATIONS',
    PrivacyReviewer: 'VOICE_PRIVACY_REVIEWER',
    SafetyReviewer: 'VOICE_SAFETY_REVIEWER'
} as const;

export type VoiceQualifiedReleaseApprovalResponseDtoCapabilityEnum = typeof VoiceQualifiedReleaseApprovalResponseDtoCapabilityEnum[keyof typeof VoiceQualifiedReleaseApprovalResponseDtoCapabilityEnum];

/**
 *
 * @export
 * @interface VoiceQualifiedReleaseAssetEvidenceDto
 */
export interface VoiceQualifiedReleaseAssetEvidenceDto {
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseAssetEvidenceDto
     */
    'purpose': VoiceQualifiedReleaseAssetEvidenceDtoPurposeEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseAssetEvidenceDto
     */
    'assetId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseAssetEvidenceDto
     */
    'sha256': string;
}

export const VoiceQualifiedReleaseAssetEvidenceDtoPurposeEnum = {
    CallDisclosure: 'CALL_DISCLOSURE',
    OrdinaryUnavailable: 'ORDINARY_UNAVAILABLE',
    OrdinaryTransferFailed: 'ORDINARY_TRANSFER_FAILED',
    SafetyFallback: 'SAFETY_FALLBACK',
    HumanDanger112: 'HUMAN_DANGER_112',
    EmergencyRoutingNotice: 'EMERGENCY_ROUTING_NOTICE',
    EmergencyDeclineClose: 'EMERGENCY_DECLINE_CLOSE',
    CallbackReview: 'CALLBACK_REVIEW',
    PhonePlus: 'PHONE_PLUS',
    PhoneDigit0: 'PHONE_DIGIT_0',
    PhoneDigit1: 'PHONE_DIGIT_1',
    PhoneDigit2: 'PHONE_DIGIT_2',
    PhoneDigit3: 'PHONE_DIGIT_3',
    PhoneDigit4: 'PHONE_DIGIT_4',
    PhoneDigit5: 'PHONE_DIGIT_5',
    PhoneDigit6: 'PHONE_DIGIT_6',
    PhoneDigit7: 'PHONE_DIGIT_7',
    PhoneDigit8: 'PHONE_DIGIT_8',
    PhoneDigit9: 'PHONE_DIGIT_9',
    SilenceNudge1: 'SILENCE_NUDGE_1',
    SilenceNudge2: 'SILENCE_NUDGE_2',
    TimeLimitClosing: 'TIME_LIMIT_CLOSING'
} as const;

export type VoiceQualifiedReleaseAssetEvidenceDtoPurposeEnum = typeof VoiceQualifiedReleaseAssetEvidenceDtoPurposeEnum[keyof typeof VoiceQualifiedReleaseAssetEvidenceDtoPurposeEnum];

/**
 *
 * @export
 * @interface VoiceQualifiedReleaseCurrentResponseDto
 */
export interface VoiceQualifiedReleaseCurrentResponseDto {
    /**
     *
     * @type {VoiceQualifiedReleaseResponseDto}
     * @memberof VoiceQualifiedReleaseCurrentResponseDto
     */
    'current': VoiceQualifiedReleaseResponseDto | null;
}
/**
 *
 * @export
 * @interface VoiceQualifiedReleaseResponseDto
 */
export interface VoiceQualifiedReleaseResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'id': string;
    /**
     *
     * @type {number}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'releaseId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'qualifiedModelId': VoiceQualifiedReleaseResponseDtoQualifiedModelIdEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'vertexProjectId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'vertexLocation': VoiceQualifiedReleaseResponseDtoVertexLocationEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'voiceId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'voiceRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'auditionAssetId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'auditionAssetPublicUrl': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'auditionAssetSha256': string;
    /**
     *
     * @type {Array<VoiceQualifiedReleaseAssetEvidenceDto>}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'approvedAssets': Array<VoiceQualifiedReleaseAssetEvidenceDto>;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'rendererVersion': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'sdkVersion': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'qualificationEvidenceVersion': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'catalogueExpiresAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'evidenceExpiresAt': string;
    /**
     *
     * @type {boolean}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'effective': boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'safeFailureReasons': Array<string>;
    /**
     *
     * @type {Array<VoiceQualifiedReleaseApprovalResponseDto>}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'approvals': Array<VoiceQualifiedReleaseApprovalResponseDto>;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'publishedByUserId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'reason': VoiceQualifiedReleaseResponseDtoReasonEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceQualifiedReleaseResponseDto
     */
    'publishedAt': string;
}

export const VoiceQualifiedReleaseResponseDtoQualifiedModelIdEnum = {
    GeminiLive25FlashNativeAudio: 'gemini-live-2.5-flash-native-audio'
} as const;

export type VoiceQualifiedReleaseResponseDtoQualifiedModelIdEnum = typeof VoiceQualifiedReleaseResponseDtoQualifiedModelIdEnum[keyof typeof VoiceQualifiedReleaseResponseDtoQualifiedModelIdEnum];
export const VoiceQualifiedReleaseResponseDtoVertexLocationEnum = {
    EuropeCentral2: 'europe-central2'
} as const;

export type VoiceQualifiedReleaseResponseDtoVertexLocationEnum = typeof VoiceQualifiedReleaseResponseDtoVertexLocationEnum[keyof typeof VoiceQualifiedReleaseResponseDtoVertexLocationEnum];
export const VoiceQualifiedReleaseResponseDtoReasonEnum = {
    QualificationRecorded: 'QUALIFICATION_RECORDED',
    EvidenceRefresh: 'EVIDENCE_REFRESH',
    ModelOrSdkChange: 'MODEL_OR_SDK_CHANGE',
    VoiceOrRendererChange: 'VOICE_OR_RENDERER_CHANGE',
    ForwardRollback: 'FORWARD_ROLLBACK',
    SyntheticHermeticTestOnly: 'SYNTHETIC_HERMETIC_TEST_ONLY'
} as const;

export type VoiceQualifiedReleaseResponseDtoReasonEnum = typeof VoiceQualifiedReleaseResponseDtoReasonEnum[keyof typeof VoiceQualifiedReleaseResponseDtoReasonEnum];

/**
 *
 * @export
 * @interface VoiceReadinessAuditApplicationSnapshotResponseDto
 */
export interface VoiceReadinessAuditApplicationSnapshotResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditApplicationSnapshotResponseDto
     */
    'schemaVersion': VoiceReadinessAuditApplicationSnapshotResponseDtoSchemaVersionEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditApplicationSnapshotResponseDto
     */
    'observedAt': string;
    /**
     *
     * @type {VoiceReadinessAuditDoubleSnapshotResponseDto}
     * @memberof VoiceReadinessAuditApplicationSnapshotResponseDto
     */
    'readiness': VoiceReadinessAuditDoubleSnapshotResponseDto;
    /**
     *
     * @type {VoiceReadinessAuditProviderSnapshotResponseDto}
     * @memberof VoiceReadinessAuditApplicationSnapshotResponseDto
     */
    'provider': VoiceReadinessAuditProviderSnapshotResponseDto;
    /**
     *
     * @type {VoiceReadinessAuditQualifiedAssetsResponseDto}
     * @memberof VoiceReadinessAuditApplicationSnapshotResponseDto
     */
    'qualifiedAssets': VoiceReadinessAuditQualifiedAssetsResponseDto;
}

export const VoiceReadinessAuditApplicationSnapshotResponseDtoSchemaVersionEnum = {
    V1: 'voice-zero-traffic-application-evidence.v1',
    V2: 'voice-zero-traffic-application-evidence.v2'
} as const;

export type VoiceReadinessAuditApplicationSnapshotResponseDtoSchemaVersionEnum = typeof VoiceReadinessAuditApplicationSnapshotResponseDtoSchemaVersionEnum[keyof typeof VoiceReadinessAuditApplicationSnapshotResponseDtoSchemaVersionEnum];

/**
 *
 * @export
 * @interface VoiceReadinessAuditDoubleSnapshotResponseDto
 */
export interface VoiceReadinessAuditDoubleSnapshotResponseDto {
    /**
     *
     * @type {VoiceReadinessAuditSnapshotResponseDto}
     * @memberof VoiceReadinessAuditDoubleSnapshotResponseDto
     */
    'before': VoiceReadinessAuditSnapshotResponseDto;
    /**
     *
     * @type {VoiceReadinessAuditSnapshotResponseDto}
     * @memberof VoiceReadinessAuditDoubleSnapshotResponseDto
     */
    'after': VoiceReadinessAuditSnapshotResponseDto;
}
/**
 *
 * @export
 * @interface VoiceReadinessAuditProviderSnapshotResponseDto
 */
export interface VoiceReadinessAuditProviderSnapshotResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'bookingConfirmationChannel'?: VoiceReadinessAuditProviderSnapshotResponseDtoBookingConfirmationChannelEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'reconciledAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'status': VoiceReadinessAuditProviderSnapshotResponseDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'voiceRegion': VoiceReadinessAuditProviderSnapshotResponseDtoVoiceRegionEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'voiceEdge': VoiceReadinessAuditProviderSnapshotResponseDtoVoiceEdgeEnum;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'driftReasons': Array<string>;
    /**
     *
     * @type {boolean}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'callbacksVerified': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'fallbackVerified': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'smsVerified': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'providerErasureVerified': boolean;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'accountSidDigest': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'voiceLineId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'lineAssignmentRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'routingRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'messagingDesiredRevision': number | null;
    /**
     *
     * @type {number}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'messagingReadinessRevision': number | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditProviderSnapshotResponseDto
     */
    'evidenceDigest': string;
}

export const VoiceReadinessAuditProviderSnapshotResponseDtoBookingConfirmationChannelEnum = {
    Email: 'EMAIL'
} as const;

export type VoiceReadinessAuditProviderSnapshotResponseDtoBookingConfirmationChannelEnum = typeof VoiceReadinessAuditProviderSnapshotResponseDtoBookingConfirmationChannelEnum[keyof typeof VoiceReadinessAuditProviderSnapshotResponseDtoBookingConfirmationChannelEnum];
export const VoiceReadinessAuditProviderSnapshotResponseDtoStatusEnum = {
    Reconciled: 'RECONCILED',
    Drifted: 'DRIFTED'
} as const;

export type VoiceReadinessAuditProviderSnapshotResponseDtoStatusEnum = typeof VoiceReadinessAuditProviderSnapshotResponseDtoStatusEnum[keyof typeof VoiceReadinessAuditProviderSnapshotResponseDtoStatusEnum];
export const VoiceReadinessAuditProviderSnapshotResponseDtoVoiceRegionEnum = {
    Ie1: 'ie1'
} as const;

export type VoiceReadinessAuditProviderSnapshotResponseDtoVoiceRegionEnum = typeof VoiceReadinessAuditProviderSnapshotResponseDtoVoiceRegionEnum[keyof typeof VoiceReadinessAuditProviderSnapshotResponseDtoVoiceRegionEnum];
export const VoiceReadinessAuditProviderSnapshotResponseDtoVoiceEdgeEnum = {
    Dublin: 'dublin'
} as const;

export type VoiceReadinessAuditProviderSnapshotResponseDtoVoiceEdgeEnum = typeof VoiceReadinessAuditProviderSnapshotResponseDtoVoiceEdgeEnum[keyof typeof VoiceReadinessAuditProviderSnapshotResponseDtoVoiceEdgeEnum];

/**
 *
 * @export
 * @interface VoiceReadinessAuditQualifiedAssetsResponseDto
 */
export interface VoiceReadinessAuditQualifiedAssetsResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditQualifiedAssetsResponseDto
     */
    'releaseId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceReadinessAuditQualifiedAssetsResponseDto
     */
    'releaseRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditQualifiedAssetsResponseDto
     */
    'evidenceExpiresAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditQualifiedAssetsResponseDto
     */
    'manifestSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditQualifiedAssetsResponseDto
     */
    'humanDanger112AssetId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditQualifiedAssetsResponseDto
     */
    'humanDanger112AssetSha256': string;
}
/**
 *
 * @export
 * @interface VoiceReadinessAuditSnapshotResponseDto
 */
export interface VoiceReadinessAuditSnapshotResponseDto {
    /**
     *
     * @type {object}
     * @memberof VoiceReadinessAuditSnapshotResponseDto
     */
    'developOperatorTrial'?: object;
    /**
     *
     * @type {number}
     * @memberof VoiceReadinessAuditSnapshotResponseDto
     */
    'normalQualificationEffective'?: VoiceReadinessAuditSnapshotResponseDtoNormalQualificationEffectiveEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditSnapshotResponseDto
     */
    'bookingConfirmationChannel'?: VoiceReadinessAuditSnapshotResponseDtoBookingConfirmationChannelEnum;
    /**
     *
     * @type {boolean}
     * @memberof VoiceReadinessAuditSnapshotResponseDto
     */
    'emailConfirmationReady'?: boolean;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditSnapshotResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditSnapshotResponseDto
     */
    'releaseId': string;
    /**
     *
     * @type {number}
     * @memberof VoiceReadinessAuditSnapshotResponseDto
     */
    'releaseRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoiceReadinessAuditSnapshotResponseDto
     */
    'qualificationHeadRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditSnapshotResponseDto
     */
    'evaluatedAt': string;
    /**
     *
     * @type {boolean}
     * @memberof VoiceReadinessAuditSnapshotResponseDto
     */
    'receptionReady': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceReadinessAuditSnapshotResponseDto
     */
    'bookingReady': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceReadinessAuditSnapshotResponseDto
     */
    'voiceSmsReady': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceReadinessAuditSnapshotResponseDto
     */
    'activationApproved': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceReadinessAuditSnapshotResponseDto
     */
    'activationFinalized': boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceReadinessAuditSnapshotResponseDto
     */
    'reasons': Array<string>;
    /**
     *
     * @type {string}
     * @memberof VoiceReadinessAuditSnapshotResponseDto
     */
    'evidenceDigest': string;
}

export const VoiceReadinessAuditSnapshotResponseDtoNormalQualificationEffectiveEnum = {
    NUMBER_null: null
} as const;

export type VoiceReadinessAuditSnapshotResponseDtoNormalQualificationEffectiveEnum = typeof VoiceReadinessAuditSnapshotResponseDtoNormalQualificationEffectiveEnum[keyof typeof VoiceReadinessAuditSnapshotResponseDtoNormalQualificationEffectiveEnum];
export const VoiceReadinessAuditSnapshotResponseDtoBookingConfirmationChannelEnum = {
    Email: 'EMAIL'
} as const;

export type VoiceReadinessAuditSnapshotResponseDtoBookingConfirmationChannelEnum = typeof VoiceReadinessAuditSnapshotResponseDtoBookingConfirmationChannelEnum[keyof typeof VoiceReadinessAuditSnapshotResponseDtoBookingConfirmationChannelEnum];

/**
 *
 * @export
 * @interface VoiceReceptionistCallDetailResponseDto
 */
export interface VoiceReceptionistCallDetailResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallDetailResponseDto
     */
    'callRef': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallDetailResponseDto
     */
    'state': VoiceReceptionistCallDetailResponseDtoStateEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallDetailResponseDto
     */
    'openedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallDetailResponseDto
     */
    'finishedAt': string | null;
    /**
     *
     * @type {number}
     * @memberof VoiceReceptionistCallDetailResponseDto
     */
    'durationSeconds': number | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallDetailResponseDto
     */
    'finishOutcome': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallDetailResponseDto
     */
    'selectedServiceName': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallDetailResponseDto
     */
    'bookingStatus': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallDetailResponseDto
     */
    'visitId': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallDetailResponseDto
     */
    'transferOutcome': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallDetailResponseDto
     */
    'callbackStatus': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallDetailResponseDto
     */
    'callbackOutcome': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallDetailResponseDto
     */
    'maskedCallerNumber': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallDetailResponseDto
     */
    'transcriptState': VoiceReceptionistCallDetailResponseDtoTranscriptStateEnum;
    /**
     *
     * @type {Array<VoiceReceptionistCallTimelineEventResponseDto>}
     * @memberof VoiceReceptionistCallDetailResponseDto
     */
    'timeline': Array<VoiceReceptionistCallTimelineEventResponseDto>;
}

export const VoiceReceptionistCallDetailResponseDtoStateEnum = {
    Active: 'ACTIVE',
    Finished: 'FINISHED'
} as const;

export type VoiceReceptionistCallDetailResponseDtoStateEnum = typeof VoiceReceptionistCallDetailResponseDtoStateEnum[keyof typeof VoiceReceptionistCallDetailResponseDtoStateEnum];
export const VoiceReceptionistCallDetailResponseDtoTranscriptStateEnum = {
    Empty: 'EMPTY',
    Available: 'AVAILABLE',
    Expired: 'EXPIRED',
    Refused: 'REFUSED'
} as const;

export type VoiceReceptionistCallDetailResponseDtoTranscriptStateEnum = typeof VoiceReceptionistCallDetailResponseDtoTranscriptStateEnum[keyof typeof VoiceReceptionistCallDetailResponseDtoTranscriptStateEnum];

/**
 *
 * @export
 * @interface VoiceReceptionistCallListItemResponseDto
 */
export interface VoiceReceptionistCallListItemResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallListItemResponseDto
     */
    'callRef': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallListItemResponseDto
     */
    'state': VoiceReceptionistCallListItemResponseDtoStateEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallListItemResponseDto
     */
    'openedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallListItemResponseDto
     */
    'finishedAt': string | null;
    /**
     *
     * @type {number}
     * @memberof VoiceReceptionistCallListItemResponseDto
     */
    'durationSeconds': number | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallListItemResponseDto
     */
    'finishOutcome': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallListItemResponseDto
     */
    'selectedServiceName': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallListItemResponseDto
     */
    'bookingStatus': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallListItemResponseDto
     */
    'visitId': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallListItemResponseDto
     */
    'transferOutcome': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallListItemResponseDto
     */
    'callbackStatus': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallListItemResponseDto
     */
    'callbackOutcome': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallListItemResponseDto
     */
    'maskedCallerNumber': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallListItemResponseDto
     */
    'transcriptState': VoiceReceptionistCallListItemResponseDtoTranscriptStateEnum;
}

export const VoiceReceptionistCallListItemResponseDtoStateEnum = {
    Active: 'ACTIVE',
    Finished: 'FINISHED'
} as const;

export type VoiceReceptionistCallListItemResponseDtoStateEnum = typeof VoiceReceptionistCallListItemResponseDtoStateEnum[keyof typeof VoiceReceptionistCallListItemResponseDtoStateEnum];
export const VoiceReceptionistCallListItemResponseDtoTranscriptStateEnum = {
    Empty: 'EMPTY',
    Available: 'AVAILABLE',
    Expired: 'EXPIRED',
    Refused: 'REFUSED'
} as const;

export type VoiceReceptionistCallListItemResponseDtoTranscriptStateEnum = typeof VoiceReceptionistCallListItemResponseDtoTranscriptStateEnum[keyof typeof VoiceReceptionistCallListItemResponseDtoTranscriptStateEnum];

/**
 *
 * @export
 * @interface VoiceReceptionistCallListResponseDto
 */
export interface VoiceReceptionistCallListResponseDto {
    /**
     *
     * @type {Array<VoiceReceptionistCallListItemResponseDto>}
     * @memberof VoiceReceptionistCallListResponseDto
     */
    'items': Array<VoiceReceptionistCallListItemResponseDto>;
    /**
     *
     * @type {number}
     * @memberof VoiceReceptionistCallListResponseDto
     */
    'total': number;
    /**
     *
     * @type {number}
     * @memberof VoiceReceptionistCallListResponseDto
     */
    'page': number;
    /**
     *
     * @type {number}
     * @memberof VoiceReceptionistCallListResponseDto
     */
    'limit': number;
}
/**
 *
 * @export
 * @interface VoiceReceptionistCallTimelineEventResponseDto
 */
export interface VoiceReceptionistCallTimelineEventResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallTimelineEventResponseDto
     */
    'kind': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallTimelineEventResponseDto
     */
    'occurredAt': string;
}
/**
 *
 * @export
 * @interface VoiceReceptionistCallTranscriptResponseDto
 */
export interface VoiceReceptionistCallTranscriptResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallTranscriptResponseDto
     */
    'callRef': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallTranscriptResponseDto
     */
    'state': VoiceReceptionistCallTranscriptResponseDtoStateEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistCallTranscriptResponseDto
     */
    'expiresAt': string | null;
    /**
     *
     * @type {Array<VoiceReceptionistTranscriptTurnResponseDto>}
     * @memberof VoiceReceptionistCallTranscriptResponseDto
     */
    'turns': Array<VoiceReceptionistTranscriptTurnResponseDto>;
}

export const VoiceReceptionistCallTranscriptResponseDtoStateEnum = {
    Empty: 'EMPTY',
    Available: 'AVAILABLE',
    Expired: 'EXPIRED',
    Refused: 'REFUSED'
} as const;

export type VoiceReceptionistCallTranscriptResponseDtoStateEnum = typeof VoiceReceptionistCallTranscriptResponseDtoStateEnum[keyof typeof VoiceReceptionistCallTranscriptResponseDtoStateEnum];

/**
 *
 * @export
 * @interface VoiceReceptionistConfigurationResponseDto
 */
export interface VoiceReceptionistConfigurationResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistConfigurationResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistConfigurationResponseDto
     */
    'state': VoiceReceptionistConfigurationResponseDtoStateEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistConfigurationResponseDto
     */
    'readiness': VoiceReceptionistConfigurationResponseDtoReadinessEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceReceptionistConfigurationResponseDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistConfigurationResponseDto
     */
    'welcomeMessage': string;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceReceptionistConfigurationResponseDto
     */
    'selectedServiceIds': Array<string>;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistConfigurationResponseDto
     */
    'operationRef': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistConfigurationResponseDto
     */
    'failureCode': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistConfigurationResponseDto
     */
    'updatedAt': string;
}

export const VoiceReceptionistConfigurationResponseDtoStateEnum = {
    Disabled: 'DISABLED',
    Transferring: 'TRANSFERRING',
    Transferred: 'TRANSFERRED',
    Disabling: 'DISABLING',
    Provisioning: 'PROVISIONING',
    Active: 'ACTIVE',
    Failed: 'FAILED'
} as const;

export type VoiceReceptionistConfigurationResponseDtoStateEnum = typeof VoiceReceptionistConfigurationResponseDtoStateEnum[keyof typeof VoiceReceptionistConfigurationResponseDtoStateEnum];
export const VoiceReceptionistConfigurationResponseDtoReadinessEnum = {
    Unavailable: 'UNAVAILABLE',
    HumanFallback: 'HUMAN_FALLBACK',
    Ready: 'READY'
} as const;

export type VoiceReceptionistConfigurationResponseDtoReadinessEnum = typeof VoiceReceptionistConfigurationResponseDtoReadinessEnum[keyof typeof VoiceReceptionistConfigurationResponseDtoReadinessEnum];

/**
 *
 * @export
 * @interface VoiceReceptionistManagedConfigurationResponseDto
 */
export interface VoiceReceptionistManagedConfigurationResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistManagedConfigurationResponseDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistManagedConfigurationResponseDto
     */
    'state': VoiceReceptionistManagedConfigurationResponseDtoStateEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistManagedConfigurationResponseDto
     */
    'readiness': VoiceReceptionistManagedConfigurationResponseDtoReadinessEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceReceptionistManagedConfigurationResponseDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistManagedConfigurationResponseDto
     */
    'welcomeMessage': string;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceReceptionistManagedConfigurationResponseDto
     */
    'selectedServiceIds': Array<string>;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistManagedConfigurationResponseDto
     */
    'operationRef': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistManagedConfigurationResponseDto
     */
    'failureCode': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistManagedConfigurationResponseDto
     */
    'updatedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistManagedConfigurationResponseDto
     */
    'assignedNumber': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistManagedConfigurationResponseDto
     */
    'humanFallbackNumber': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistManagedConfigurationResponseDto
     */
    'currentOperationKind': VoiceReceptionistManagedConfigurationResponseDtoCurrentOperationKindEnum;
}

export const VoiceReceptionistManagedConfigurationResponseDtoStateEnum = {
    Disabled: 'DISABLED',
    Transferring: 'TRANSFERRING',
    Transferred: 'TRANSFERRED',
    Disabling: 'DISABLING',
    Provisioning: 'PROVISIONING',
    Active: 'ACTIVE',
    Failed: 'FAILED'
} as const;

export type VoiceReceptionistManagedConfigurationResponseDtoStateEnum = typeof VoiceReceptionistManagedConfigurationResponseDtoStateEnum[keyof typeof VoiceReceptionistManagedConfigurationResponseDtoStateEnum];
export const VoiceReceptionistManagedConfigurationResponseDtoReadinessEnum = {
    Unavailable: 'UNAVAILABLE',
    HumanFallback: 'HUMAN_FALLBACK',
    Ready: 'READY'
} as const;

export type VoiceReceptionistManagedConfigurationResponseDtoReadinessEnum = typeof VoiceReceptionistManagedConfigurationResponseDtoReadinessEnum[keyof typeof VoiceReceptionistManagedConfigurationResponseDtoReadinessEnum];
export const VoiceReceptionistManagedConfigurationResponseDtoCurrentOperationKindEnum = {
    Provision: 'PROVISION',
    Transfer: 'TRANSFER',
    Disable: 'DISABLE'
} as const;

export type VoiceReceptionistManagedConfigurationResponseDtoCurrentOperationKindEnum = typeof VoiceReceptionistManagedConfigurationResponseDtoCurrentOperationKindEnum[keyof typeof VoiceReceptionistManagedConfigurationResponseDtoCurrentOperationKindEnum];

/**
 *
 * @export
 * @interface VoiceReceptionistProvisionDto
 */
export interface VoiceReceptionistProvisionDto {
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistProvisionDto
     */
    'receptionistNumber': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistProvisionDto
     */
    'humanFallbackNumber': string;
}
/**
 *
 * @export
 * @interface VoiceReceptionistProvisioningOperationResponseDto
 */
export interface VoiceReceptionistProvisioningOperationResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistProvisioningOperationResponseDto
     */
    'operationRef': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistProvisioningOperationResponseDto
     */
    'state': VoiceReceptionistProvisioningOperationResponseDtoStateEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistProvisioningOperationResponseDto
     */
    'failureCode': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistProvisioningOperationResponseDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistProvisioningOperationResponseDto
     */
    'updatedAt': string;
}

export const VoiceReceptionistProvisioningOperationResponseDtoStateEnum = {
    Pending: 'PENDING',
    Running: 'RUNNING',
    Succeeded: 'SUCCEEDED',
    Failed: 'FAILED'
} as const;

export type VoiceReceptionistProvisioningOperationResponseDtoStateEnum = typeof VoiceReceptionistProvisioningOperationResponseDtoStateEnum[keyof typeof VoiceReceptionistProvisioningOperationResponseDtoStateEnum];

/**
 *
 * @export
 * @interface VoiceReceptionistProvisioningResponseDto
 */
export interface VoiceReceptionistProvisioningResponseDto {
    /**
     *
     * @type {boolean}
     * @memberof VoiceReceptionistProvisioningResponseDto
     */
    'replayed': boolean;
    /**
     *
     * @type {VoiceReceptionistProvisioningOperationResponseDto}
     * @memberof VoiceReceptionistProvisioningResponseDto
     */
    'operation': VoiceReceptionistProvisioningOperationResponseDto;
    /**
     *
     * @type {VoiceReceptionistConfigurationResponseDto}
     * @memberof VoiceReceptionistProvisioningResponseDto
     */
    'configuration': VoiceReceptionistConfigurationResponseDto;
}
/**
 *
 * @export
 * @interface VoiceReceptionistReplaceNumberDto
 */
export interface VoiceReceptionistReplaceNumberDto {
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistReplaceNumberDto
     */
    'receptionistNumber': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistReplaceNumberDto
     */
    'humanFallbackNumber': string;
}
/**
 *
 * @export
 * @interface VoiceReceptionistSelectableServiceResponseDto
 */
export interface VoiceReceptionistSelectableServiceResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistSelectableServiceResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistSelectableServiceResponseDto
     */
    'name': string;
}
/**
 *
 * @export
 * @interface VoiceReceptionistSelectableServicesResponseDto
 */
export interface VoiceReceptionistSelectableServicesResponseDto {
    /**
     *
     * @type {Array<VoiceReceptionistSelectableServiceResponseDto>}
     * @memberof VoiceReceptionistSelectableServicesResponseDto
     */
    'items': Array<VoiceReceptionistSelectableServiceResponseDto>;
}
/**
 *
 * @export
 * @interface VoiceReceptionistTranscriptTurnResponseDto
 */
export interface VoiceReceptionistTranscriptTurnResponseDto {
    /**
     *
     * @type {number}
     * @memberof VoiceReceptionistTranscriptTurnResponseDto
     */
    'sequence': number;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistTranscriptTurnResponseDto
     */
    'speaker': VoiceReceptionistTranscriptTurnResponseDtoSpeakerEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistTranscriptTurnResponseDto
     */
    'text': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistTranscriptTurnResponseDto
     */
    'occurredAt': string;
}

export const VoiceReceptionistTranscriptTurnResponseDtoSpeakerEnum = {
    Caller: 'CALLER',
    Receptionist: 'RECEPTIONIST'
} as const;

export type VoiceReceptionistTranscriptTurnResponseDtoSpeakerEnum = typeof VoiceReceptionistTranscriptTurnResponseDtoSpeakerEnum[keyof typeof VoiceReceptionistTranscriptTurnResponseDtoSpeakerEnum];

/**
 *
 * @export
 * @interface VoiceReceptionistTransferDto
 */
export interface VoiceReceptionistTransferDto {
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistTransferDto
     */
    'receptionistNumber': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistTransferDto
     */
    'humanFallbackNumber': string;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistTransferDto
     */
    'sourceOrganizationId': string;
}
/**
 *
 * @export
 * @interface VoiceReceptionistUpdateEscalationDto
 */
export interface VoiceReceptionistUpdateEscalationDto {
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistUpdateEscalationDto
     */
    'humanFallbackNumber': string;
}
/**
 *
 * @export
 * @interface VoiceReceptionistUpdateSettingsDto
 */
export interface VoiceReceptionistUpdateSettingsDto {
    /**
     *
     * @type {number}
     * @memberof VoiceReceptionistUpdateSettingsDto
     */
    'expectedRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceReceptionistUpdateSettingsDto
     */
    'welcomeMessage'?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceReceptionistUpdateSettingsDto
     */
    'selectedServiceIds': Array<string>;
}
/**
 *
 * @export
 * @interface VoiceSecurityTriggerRevocationResponseDto
 */
export interface VoiceSecurityTriggerRevocationResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceSecurityTriggerRevocationResponseDto
     */
    'type': VoiceSecurityTriggerRevocationResponseDtoTypeEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSecurityTriggerRevocationResponseDto
     */
    'receiptId': string;
}

export const VoiceSecurityTriggerRevocationResponseDtoTypeEnum = {
    VoiceSecurityTriggerReceiptRevoked: 'VOICE_SECURITY_TRIGGER_RECEIPT_REVOKED'
} as const;

export type VoiceSecurityTriggerRevocationResponseDtoTypeEnum = typeof VoiceSecurityTriggerRevocationResponseDtoTypeEnum[keyof typeof VoiceSecurityTriggerRevocationResponseDtoTypeEnum];

/**
 *
 * @export
 * @interface VoiceSecurityTriggerTerminationResponseDto
 */
export interface VoiceSecurityTriggerTerminationResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceSecurityTriggerTerminationResponseDto
     */
    'type': VoiceSecurityTriggerTerminationResponseDtoTypeEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceSecurityTriggerTerminationResponseDto
     */
    'terminationRequested': number;
}

export const VoiceSecurityTriggerTerminationResponseDtoTypeEnum = {
    ActiveSessionTerminationRequested: 'ACTIVE_SESSION_TERMINATION_REQUESTED'
} as const;

export type VoiceSecurityTriggerTerminationResponseDtoTypeEnum = typeof VoiceSecurityTriggerTerminationResponseDtoTypeEnum[keyof typeof VoiceSecurityTriggerTerminationResponseDtoTypeEnum];

/**
 *
 * @export
 * @interface VoiceSmsPrivacyAuthorityReferenceDto
 */
export interface VoiceSmsPrivacyAuthorityReferenceDto {
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyAuthorityReferenceDto
     */
    'id': string;
    /**
     *
     * @type {number}
     * @memberof VoiceSmsPrivacyAuthorityReferenceDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyAuthorityReferenceDto
     */
    'scopeSha256': string;
}
/**
 *
 * @export
 * @interface VoiceSmsPrivacyAuthorityResponseDto
 */
export interface VoiceSmsPrivacyAuthorityResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyAuthorityResponseDto
     */
    'id': string;
    /**
     *
     * @type {number}
     * @memberof VoiceSmsPrivacyAuthorityResponseDto
     */
    'revision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyAuthorityResponseDto
     */
    'scopeSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyAuthorityResponseDto
     */
    'schema': VoiceSmsPrivacyAuthorityResponseDtoSchemaEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyAuthorityResponseDto
     */
    'status': VoiceSmsPrivacyAuthorityResponseDtoStatusEnum;
    /**
     *
     * @type {VoiceSmsPrivacyScopeDto}
     * @memberof VoiceSmsPrivacyAuthorityResponseDto
     */
    'scope': VoiceSmsPrivacyScopeDto;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyAuthorityResponseDto
     */
    'issuedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyAuthorityResponseDto
     */
    'expiresAt': string;
    /**
     *
     * @type {VoiceSmsPrivacyGovernanceDto}
     * @memberof VoiceSmsPrivacyAuthorityResponseDto
     */
    'governance': VoiceSmsPrivacyGovernanceDto;
    /**
     *
     * @type {VoiceSmsPrivacyCountersDto}
     * @memberof VoiceSmsPrivacyAuthorityResponseDto
     */
    'counters': VoiceSmsPrivacyCountersDto;
    /**
     *
     * @type {boolean}
     * @memberof VoiceSmsPrivacyAuthorityResponseDto
     */
    'current': boolean;
}

export const VoiceSmsPrivacyAuthorityResponseDtoSchemaEnum = {
    VoiceSmsPrivacyQualificationAuthorityV1: 'voice-sms-privacy-qualification-authority.v1'
} as const;

export type VoiceSmsPrivacyAuthorityResponseDtoSchemaEnum = typeof VoiceSmsPrivacyAuthorityResponseDtoSchemaEnum[keyof typeof VoiceSmsPrivacyAuthorityResponseDtoSchemaEnum];
export const VoiceSmsPrivacyAuthorityResponseDtoStatusEnum = {
    Proposed: 'PROPOSED',
    Active: 'ACTIVE',
    Revoked: 'REVOKED',
    Closed: 'CLOSED'
} as const;

export type VoiceSmsPrivacyAuthorityResponseDtoStatusEnum = typeof VoiceSmsPrivacyAuthorityResponseDtoStatusEnum[keyof typeof VoiceSmsPrivacyAuthorityResponseDtoStatusEnum];

/**
 *
 * @export
 * @interface VoiceSmsPrivacyCountersDto
 */
export interface VoiceSmsPrivacyCountersDto {
    /**
     *
     * @type {number}
     * @memberof VoiceSmsPrivacyCountersDto
     */
    'acceptedInboundEvents': number;
    /**
     *
     * @type {number}
     * @memberof VoiceSmsPrivacyCountersDto
     */
    'providerOperations': number;
    /**
     *
     * @type {boolean}
     * @memberof VoiceSmsPrivacyCountersDto
     */
    'operationInFlight': boolean;
    /**
     *
     * @type {boolean}
     * @memberof VoiceSmsPrivacyCountersDto
     */
    'incident': boolean;
}
/**
 *
 * @export
 * @interface VoiceSmsPrivacyGovernanceDto
 */
export interface VoiceSmsPrivacyGovernanceDto {
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyGovernanceDto
     */
    'proposedByActorSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyGovernanceDto
     */
    'approvedByActorSha256': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyGovernanceDto
     */
    'approvedAt': string | null;
    /**
     *
     * @type {boolean}
     * @memberof VoiceSmsPrivacyGovernanceDto
     */
    'distinctActors': boolean;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyGovernanceDto
     */
    'approvalEvidenceSha256': string | null;
}
/**
 *
 * @export
 * @interface VoiceSmsPrivacyOpenResponseDto
 */
export interface VoiceSmsPrivacyOpenResponseDto {
    /**
     *
     * @type {VoiceSmsPrivacyAuthorityResponseDto}
     * @memberof VoiceSmsPrivacyOpenResponseDto
     */
    'authority': VoiceSmsPrivacyAuthorityResponseDto | null;
}
/**
 *
 * @export
 * @interface VoiceSmsPrivacyScopeDto
 */
export interface VoiceSmsPrivacyScopeDto {
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyScopeDto
     */
    'environment': VoiceSmsPrivacyScopeDtoEnvironmentEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyScopeDto
     */
    'projectId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyScopeDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyScopeDto
     */
    'backendRevision': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyScopeDto
     */
    'backendGithubSha': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyScopeDto
     */
    'publicVoiceOrigin': string;
    /**
     *
     * @type {number}
     * @memberof VoiceSmsPrivacyScopeDto
     */
    'messagingDesiredRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoiceSmsPrivacyScopeDto
     */
    'receptionPolicyRevision': number;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyScopeDto
     */
    'providerScopeSha256': string;
    /**
     *
     * @type {number}
     * @memberof VoiceSmsPrivacyScopeDto
     */
    'optOutKeyVersion': number;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyScopeDto
     */
    'policyEvidenceSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsPrivacyScopeDto
     */
    'testSenderDigest': string;
    /**
     *
     * @type {number}
     * @memberof VoiceSmsPrivacyScopeDto
     */
    'maximumInboundEvents': VoiceSmsPrivacyScopeDtoMaximumInboundEventsEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceSmsPrivacyScopeDto
     */
    'maximumProviderOperations': VoiceSmsPrivacyScopeDtoMaximumProviderOperationsEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceSmsPrivacyScopeDto
     */
    'maximumConcurrentOperations': VoiceSmsPrivacyScopeDtoMaximumConcurrentOperationsEnum;
}

export const VoiceSmsPrivacyScopeDtoEnvironmentEnum = {
    Develop: 'develop',
    Production: 'production'
} as const;

export type VoiceSmsPrivacyScopeDtoEnvironmentEnum = typeof VoiceSmsPrivacyScopeDtoEnvironmentEnum[keyof typeof VoiceSmsPrivacyScopeDtoEnvironmentEnum];
export const VoiceSmsPrivacyScopeDtoMaximumInboundEventsEnum = {
    NUMBER_10: 10
} as const;

export type VoiceSmsPrivacyScopeDtoMaximumInboundEventsEnum = typeof VoiceSmsPrivacyScopeDtoMaximumInboundEventsEnum[keyof typeof VoiceSmsPrivacyScopeDtoMaximumInboundEventsEnum];
export const VoiceSmsPrivacyScopeDtoMaximumProviderOperationsEnum = {
    NUMBER_40: 40
} as const;

export type VoiceSmsPrivacyScopeDtoMaximumProviderOperationsEnum = typeof VoiceSmsPrivacyScopeDtoMaximumProviderOperationsEnum[keyof typeof VoiceSmsPrivacyScopeDtoMaximumProviderOperationsEnum];
export const VoiceSmsPrivacyScopeDtoMaximumConcurrentOperationsEnum = {
    NUMBER_1: 1
} as const;

export type VoiceSmsPrivacyScopeDtoMaximumConcurrentOperationsEnum = typeof VoiceSmsPrivacyScopeDtoMaximumConcurrentOperationsEnum[keyof typeof VoiceSmsPrivacyScopeDtoMaximumConcurrentOperationsEnum];

/**
 *
 * @export
 * @interface VoiceSmsRetentionReviewDto
 */
export interface VoiceSmsRetentionReviewDto {
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'modelVersion': VoiceSmsRetentionReviewDtoModelVersionEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'messagingDesiredRevision': number;
    /**
     *
     * @type {number}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'applicationSessionPiiMaxDays': VoiceSmsRetentionReviewDtoApplicationSessionPiiMaxDaysEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'providerMessageDeleteDeadlineHours': VoiceSmsRetentionReviewDtoProviderMessageDeleteDeadlineHoursEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'contentRetention': VoiceSmsRetentionReviewDtoContentRetentionEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'optOutModel': VoiceSmsRetentionReviewDtoOptOutModelEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'providerBuiltInStopFiltering': VoiceSmsRetentionReviewDtoProviderBuiltInStopFilteringEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'addressRetention': VoiceSmsRetentionReviewDtoAddressRetentionEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'providerProductionAccessMaxHours': VoiceSmsRetentionReviewDtoProviderProductionAccessMaxHoursEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'providerBackupRetentionMaxDaysAfterDeletion': VoiceSmsRetentionReviewDtoProviderBackupRetentionMaxDaysAfterDeletionEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'complianceData': VoiceSmsRetentionReviewDtoComplianceDataEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'compliancePurposes': VoiceSmsRetentionReviewDtoCompliancePurposesEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'ordinaryComplianceRetention': VoiceSmsRetentionReviewDtoOrdinaryComplianceRetentionEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'ordinaryComplianceRetentionMaxDays': number | null;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'legalHoldRetention': VoiceSmsRetentionReviewDtoLegalHoldRetentionEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'accessControls': VoiceSmsRetentionReviewDtoAccessControlsEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'dsarHandling': VoiceSmsRetentionReviewDtoDsarHandlingEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'optOutAndBillingRetention': VoiceSmsRetentionReviewDtoOptOutAndBillingRetentionEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'applicationSuppressionRetention': VoiceSmsRetentionReviewDtoApplicationSuppressionRetentionEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'privacyNoticeRevision': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'providerEvidenceDigest': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'retentionAssessmentDigest': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'reviewedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'decision': VoiceSmsRetentionReviewDtoDecisionEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSmsRetentionReviewDto
     */
    'decisionEvidenceDigest': string;
}

export const VoiceSmsRetentionReviewDtoModelVersionEnum = {
    VoiceSmsRetentionReviewV2: 'voice-sms-retention-review.v2'
} as const;

export type VoiceSmsRetentionReviewDtoModelVersionEnum = typeof VoiceSmsRetentionReviewDtoModelVersionEnum[keyof typeof VoiceSmsRetentionReviewDtoModelVersionEnum];
export const VoiceSmsRetentionReviewDtoApplicationSessionPiiMaxDaysEnum = {
    NUMBER_30: 30
} as const;

export type VoiceSmsRetentionReviewDtoApplicationSessionPiiMaxDaysEnum = typeof VoiceSmsRetentionReviewDtoApplicationSessionPiiMaxDaysEnum[keyof typeof VoiceSmsRetentionReviewDtoApplicationSessionPiiMaxDaysEnum];
export const VoiceSmsRetentionReviewDtoProviderMessageDeleteDeadlineHoursEnum = {
    NUMBER_23: 23
} as const;

export type VoiceSmsRetentionReviewDtoProviderMessageDeleteDeadlineHoursEnum = typeof VoiceSmsRetentionReviewDtoProviderMessageDeleteDeadlineHoursEnum[keyof typeof VoiceSmsRetentionReviewDtoProviderMessageDeleteDeadlineHoursEnum];
export const VoiceSmsRetentionReviewDtoContentRetentionEnum = {
    Discard: 'discard'
} as const;

export type VoiceSmsRetentionReviewDtoContentRetentionEnum = typeof VoiceSmsRetentionReviewDtoContentRetentionEnum[keyof typeof VoiceSmsRetentionReviewDtoContentRetentionEnum];
export const VoiceSmsRetentionReviewDtoOptOutModelEnum = {
    ApplicationManagedV1: 'APPLICATION_MANAGED_V1'
} as const;

export type VoiceSmsRetentionReviewDtoOptOutModelEnum = typeof VoiceSmsRetentionReviewDtoOptOutModelEnum[keyof typeof VoiceSmsRetentionReviewDtoOptOutModelEnum];
export const VoiceSmsRetentionReviewDtoProviderBuiltInStopFilteringEnum = {
    DisabledConfirmedByProvider: 'DISABLED_CONFIRMED_BY_PROVIDER'
} as const;

export type VoiceSmsRetentionReviewDtoProviderBuiltInStopFilteringEnum = typeof VoiceSmsRetentionReviewDtoProviderBuiltInStopFilteringEnum[keyof typeof VoiceSmsRetentionReviewDtoProviderBuiltInStopFilteringEnum];
export const VoiceSmsRetentionReviewDtoAddressRetentionEnum = {
    Obfuscate: 'obfuscate'
} as const;

export type VoiceSmsRetentionReviewDtoAddressRetentionEnum = typeof VoiceSmsRetentionReviewDtoAddressRetentionEnum[keyof typeof VoiceSmsRetentionReviewDtoAddressRetentionEnum];
export const VoiceSmsRetentionReviewDtoProviderProductionAccessMaxHoursEnum = {
    NUMBER_24: 24
} as const;

export type VoiceSmsRetentionReviewDtoProviderProductionAccessMaxHoursEnum = typeof VoiceSmsRetentionReviewDtoProviderProductionAccessMaxHoursEnum[keyof typeof VoiceSmsRetentionReviewDtoProviderProductionAccessMaxHoursEnum];
export const VoiceSmsRetentionReviewDtoProviderBackupRetentionMaxDaysAfterDeletionEnum = {
    NUMBER_30: 30
} as const;

export type VoiceSmsRetentionReviewDtoProviderBackupRetentionMaxDaysAfterDeletionEnum = typeof VoiceSmsRetentionReviewDtoProviderBackupRetentionMaxDaysAfterDeletionEnum[keyof typeof VoiceSmsRetentionReviewDtoProviderBackupRetentionMaxDaysAfterDeletionEnum];
export const VoiceSmsRetentionReviewDtoComplianceDataEnum = {
    MessageBodyPhoneNumbersAndMetadata: 'MESSAGE_BODY_PHONE_NUMBERS_AND_METADATA'
} as const;

export type VoiceSmsRetentionReviewDtoComplianceDataEnum = typeof VoiceSmsRetentionReviewDtoComplianceDataEnum[keyof typeof VoiceSmsRetentionReviewDtoComplianceDataEnum];
export const VoiceSmsRetentionReviewDtoCompliancePurposesEnum = {
    LegalAndRegulatory: 'LEGAL_AND_REGULATORY'
} as const;

export type VoiceSmsRetentionReviewDtoCompliancePurposesEnum = typeof VoiceSmsRetentionReviewDtoCompliancePurposesEnum[keyof typeof VoiceSmsRetentionReviewDtoCompliancePurposesEnum];
export const VoiceSmsRetentionReviewDtoOrdinaryComplianceRetentionEnum = {
    Bounded: 'BOUNDED',
    Unspecified: 'UNSPECIFIED'
} as const;

export type VoiceSmsRetentionReviewDtoOrdinaryComplianceRetentionEnum = typeof VoiceSmsRetentionReviewDtoOrdinaryComplianceRetentionEnum[keyof typeof VoiceSmsRetentionReviewDtoOrdinaryComplianceRetentionEnum];
export const VoiceSmsRetentionReviewDtoLegalHoldRetentionEnum = {
    MayExtendOrdinaryRetention: 'MAY_EXTEND_ORDINARY_RETENTION'
} as const;

export type VoiceSmsRetentionReviewDtoLegalHoldRetentionEnum = typeof VoiceSmsRetentionReviewDtoLegalHoldRetentionEnum[keyof typeof VoiceSmsRetentionReviewDtoLegalHoldRetentionEnum];
export const VoiceSmsRetentionReviewDtoAccessControlsEnum = {
    RestrictedProviderComplianceAccess: 'RESTRICTED_PROVIDER_COMPLIANCE_ACCESS'
} as const;

export type VoiceSmsRetentionReviewDtoAccessControlsEnum = typeof VoiceSmsRetentionReviewDtoAccessControlsEnum[keyof typeof VoiceSmsRetentionReviewDtoAccessControlsEnum];
export const VoiceSmsRetentionReviewDtoDsarHandlingEnum = {
    ProviderDpaProcessWithLegalExceptions: 'PROVIDER_DPA_PROCESS_WITH_LEGAL_EXCEPTIONS'
} as const;

export type VoiceSmsRetentionReviewDtoDsarHandlingEnum = typeof VoiceSmsRetentionReviewDtoDsarHandlingEnum[keyof typeof VoiceSmsRetentionReviewDtoDsarHandlingEnum];
export const VoiceSmsRetentionReviewDtoOptOutAndBillingRetentionEnum = {
    SeparatePurposeRetention: 'SEPARATE_PURPOSE_RETENTION'
} as const;

export type VoiceSmsRetentionReviewDtoOptOutAndBillingRetentionEnum = typeof VoiceSmsRetentionReviewDtoOptOutAndBillingRetentionEnum[keyof typeof VoiceSmsRetentionReviewDtoOptOutAndBillingRetentionEnum];
export const VoiceSmsRetentionReviewDtoApplicationSuppressionRetentionEnum = {
    UntilValidOptInOrReviewedRetirement: 'UNTIL_VALID_OPT_IN_OR_REVIEWED_RETIREMENT'
} as const;

export type VoiceSmsRetentionReviewDtoApplicationSuppressionRetentionEnum = typeof VoiceSmsRetentionReviewDtoApplicationSuppressionRetentionEnum[keyof typeof VoiceSmsRetentionReviewDtoApplicationSuppressionRetentionEnum];
export const VoiceSmsRetentionReviewDtoDecisionEnum = {
    BoundedRetention: 'ACCEPT_BOUNDED_RETENTION',
    UnspecifiedRetentionException: 'ACCEPT_UNSPECIFIED_RETENTION_EXCEPTION'
} as const;

export type VoiceSmsRetentionReviewDtoDecisionEnum = typeof VoiceSmsRetentionReviewDtoDecisionEnum[keyof typeof VoiceSmsRetentionReviewDtoDecisionEnum];

/**
 *
 * @export
 * @interface VoiceSpendControlResponseDto
 */
export interface VoiceSpendControlResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceSpendControlResponseDto
     */
    'warsawDay': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSpendControlResponseDto
     */
    'state': VoiceSpendControlResponseDtoStateEnum;
    /**
     *
     * @type {number}
     * @memberof VoiceSpendControlResponseDto
     */
    'ceilingMicrosPln': number;
    /**
     *
     * @type {number}
     * @memberof VoiceSpendControlResponseDto
     */
    'admissionThresholdMicrosPln': number;
    /**
     *
     * @type {number}
     * @memberof VoiceSpendControlResponseDto
     */
    'estimatedUsedMicrosPln': number;
    /**
     *
     * @type {number}
     * @memberof VoiceSpendControlResponseDto
     */
    'reconciledUsedMicrosPln': number;
    /**
     *
     * @type {number}
     * @memberof VoiceSpendControlResponseDto
     */
    'reservedWorstCaseMicrosPln': number;
    /**
     *
     * @type {string}
     * @memberof VoiceSpendControlResponseDto
     */
    'qualifiedRatePublicationId': string | null;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceSpendControlResponseDto
     */
    'reasons': Array<string>;
    /**
     *
     * @type {string}
     * @memberof VoiceSpendControlResponseDto
     */
    'trippedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceSpendControlResponseDto
     */
    'reopenedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceSpendControlResponseDto
     */
    'updatedAt': string;
}

export const VoiceSpendControlResponseDtoStateEnum = {
    Open: 'OPEN',
    Tripped: 'TRIPPED'
} as const;

export type VoiceSpendControlResponseDtoStateEnum = typeof VoiceSpendControlResponseDtoStateEnum[keyof typeof VoiceSpendControlResponseDtoStateEnum];

/**
 *
 * @export
 * @interface VoiceSpendReopenProposalResponseDto
 */
export interface VoiceSpendReopenProposalResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceSpendReopenProposalResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSpendReopenProposalResponseDto
     */
    'warsawDay': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSpendReopenProposalResponseDto
     */
    'status': VoiceSpendReopenProposalResponseDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceSpendReopenProposalResponseDto
     */
    'proposedByUserId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSpendReopenProposalResponseDto
     */
    'proposedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceSpendReopenProposalResponseDto
     */
    'approvedByUserId': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceSpendReopenProposalResponseDto
     */
    'approvedAt': string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceSpendReopenProposalResponseDto
     */
    'reason': string;
}

export const VoiceSpendReopenProposalResponseDtoStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Expired: 'EXPIRED'
} as const;

export type VoiceSpendReopenProposalResponseDtoStatusEnum = typeof VoiceSpendReopenProposalResponseDtoStatusEnum[keyof typeof VoiceSpendReopenProposalResponseDtoStatusEnum];

/**
 *
 * @export
 * @interface WalkInVisitDto
 */
export interface WalkInVisitDto {
    /**
     * When false, the visit is stored as a guest booking and no User/Profile is created. userId/profileId must not be set and the guest fields (firstName, lastName, breed, name) are required.
     * @type {boolean}
     * @memberof WalkInVisitDto
     */
    'createAccount'?: boolean;
    /**
     * Pet owner\'s first name
     * @type {string}
     * @memberof WalkInVisitDto
     */
    'firstName': string;
    /**
     * Pet owner\'s last name
     * @type {string}
     * @memberof WalkInVisitDto
     */
    'lastName': string;
    /**
     * Pet owner\'s email address
     * @type {string}
     * @memberof WalkInVisitDto
     */
    'email'?: string;
    /**
     * Pet owner\'s phone number
     * @type {string}
     * @memberof WalkInVisitDto
     */
    'phoneNumber'?: string;
    /**
     * Pet\'s breed
     * @type {string}
     * @memberof WalkInVisitDto
     */
    'breed'?: string;
    /**
     * Pet\'s category
     * @type {string}
     * @memberof WalkInVisitDto
     */
    'petCategory'?: WalkInVisitDtoPetCategoryEnum;
    /**
     * Pet\'s name
     * @type {string}
     * @memberof WalkInVisitDto
     */
    'name'?: string;
    /**
     * Description of the problem/condition
     * @type {string}
     * @memberof WalkInVisitDto
     */
    'description': string;
    /**
     * Optional list of document URLs/IDs
     * @type {Array<DocumentFileDto>}
     * @memberof WalkInVisitDto
     */
    'documents'?: Array<DocumentFileDto>;
    /**
     * Category of the visit
     * @type {string}
     * @memberof WalkInVisitDto
     */
    'category': WalkInVisitDtoCategoryEnum;
    /**
     * ID of existing user/pet owner
     * @type {string}
     * @memberof WalkInVisitDto
     */
    'userId'?: string;
    /**
     * ID of existing profile/pet to schedule visit for
     * @type {string}
     * @memberof WalkInVisitDto
     */
    'profileId'?: string;
    /**
     * ID of the selected service for this visit
     * @type {string}
     * @memberof WalkInVisitDto
     */
    'serviceId'?: string;
}

export const WalkInVisitDtoPetCategoryEnum = {
    Dog: 'dog',
    Cat: 'cat',
    Other: 'other'
} as const;

export type WalkInVisitDtoPetCategoryEnum = typeof WalkInVisitDtoPetCategoryEnum[keyof typeof WalkInVisitDtoPetCategoryEnum];
export const WalkInVisitDtoCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type WalkInVisitDtoCategoryEnum = typeof WalkInVisitDtoCategoryEnum[keyof typeof WalkInVisitDtoCategoryEnum];

/**
 *
 * @export
 * @interface WalkInVisitResponseDto
 */
export interface WalkInVisitResponseDto {
    /**
     * The visit that was created and started
     * @type {string}
     * @memberof WalkInVisitResponseDto
     */
    'visitId': string;
    /**
     * Whether a new owner account was created for this visit
     * @type {boolean}
     * @memberof WalkInVisitResponseDto
     */
    'newUserCreated': boolean;
}
/**
 *
 * @export
 * @interface WarehouseActivationDto
 */
export interface WarehouseActivationDto {
    /**
     * Stock writes are allowed
     * @type {boolean}
     * @memberof WarehouseActivationDto
     */
    'enabled': boolean;
    /**
     * The organization already has warehouse data (read-only when disabled)
     * @type {boolean}
     * @memberof WarehouseActivationDto
     */
    'hasHistory': boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export const WarehouseAdjustmentDirection = {
    Increase: 'INCREASE',
    Decrease: 'DECREASE'
} as const;

export type WarehouseAdjustmentDirection = typeof WarehouseAdjustmentDirection[keyof typeof WarehouseAdjustmentDirection];


/**
 *
 * @export
 * @enum {string}
 */

export const WarehouseAdjustmentReason = {
    Damaged: 'DAMAGED',
    Expired: 'EXPIRED',
    StockCount: 'STOCK_COUNT',
    InternalUse: 'INTERNAL_USE',
    Other: 'OTHER'
} as const;

export type WarehouseAdjustmentReason = typeof WarehouseAdjustmentReason[keyof typeof WarehouseAdjustmentReason];


/**
 *
 * @export
 * @interface WarehouseAttachmentUrlDto
 */
export interface WarehouseAttachmentUrlDto {
    /**
     *
     * @type {string}
     * @memberof WarehouseAttachmentUrlDto
     */
    'url': string;
    /**
     *
     * @type {number}
     * @memberof WarehouseAttachmentUrlDto
     */
    'expiresInMinutes': number;
}
/**
 *
 * @export
 * @interface WarehouseBatchAssignmentResponseDto
 */
export interface WarehouseBatchAssignmentResponseDto {
    /**
     *
     * @type {WarehouseBatchAssignmentResponseDtoMovement}
     * @memberof WarehouseBatchAssignmentResponseDto
     */
    'movement': WarehouseBatchAssignmentResponseDtoMovement;
}
/**
 * The movement now carrying the Batch
 * @export
 * @interface WarehouseBatchAssignmentResponseDtoMovement
 */
export interface WarehouseBatchAssignmentResponseDtoMovement {
    /**
     *
     * @type {string}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'id': string;
    /**
     *
     * @type {WarehouseMovementType}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'type': WarehouseMovementType;
    /**
     *
     * @type {number}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'quantityMilli': number;
    /**
     * Product name when the movement was posted (snapshot)
     * @type {string}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'productName': string;
    /**
     * Units per package when the movement was posted (snapshot)
     * @type {number}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'unitsPerPackage': number;
    /**
     * Custom unit name when the movement was posted (snapshot)
     * @type {string}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'unitCustom'?: string;
    /**
     * The batch-less movement this one replaced (batch assignment)
     * @type {string}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'assignmentOf'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'occurredAt': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'recordedAt': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'recordedById': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'visitId'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'profileId'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'recordedByName'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'batchId'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'batchNumber'?: string;
    /**
     *
     * @type {WarehouseMovementSourceKind}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'sourceKind': WarehouseMovementSourceKind;
    /**
     *
     * @type {string}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'sourceId': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'documentNumber'?: string;
    /**
     *
     * @type {WarehouseDocumentType}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'documentType'?: WarehouseDocumentType;
    /**
     *
     * @type {WarehouseAdjustmentReason}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'documentReason'?: WarehouseAdjustmentReason;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'isReversal': boolean;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'isReversed': boolean;
    /**
     *
     * @type {WarehouseHandover}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'handover'?: WarehouseHandover;
    /**
     *
     * @type {string}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'recipientName'?: string;
    /**
     * Handed-over rows: the recipient\'s address as recorded at the posting
     * @type {string}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'recipientAddress'?: string;
    /**
     * Owner/admin only
     * @type {number}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'unitCostNetMinor'?: number;
    /**
     *
     * @type {number}
     * @memberof WarehouseBatchAssignmentResponseDtoMovement
     */
    'unitPriceGrossMinor'?: number;
}


/**
 *
 * @export
 * @interface WarehouseBatchDto
 */
export interface WarehouseBatchDto {
    /**
     *
     * @type {string}
     * @memberof WarehouseBatchDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseBatchDto
     */
    'productId': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseBatchDto
     */
    'batchNumber': string;
    /**
     * YYYY-MM-DD
     * @type {string}
     * @memberof WarehouseBatchDto
     */
    'expiryDate': string;
    /**
     *
     * @type {number}
     * @memberof WarehouseBatchDto
     */
    'onHandMilli': number;
    /**
     *
     * @type {string}
     * @memberof WarehouseBatchDto
     */
    'firstReceivedAt': string;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseBatchDto
     */
    'isExpired': boolean;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseBatchDto
     */
    'isExpiringSoon': boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export const WarehouseControlledCategory = {
    IN: 'I-N',
    IiN: 'II-N',
    IiP: 'II-P',
    IiiP: 'III-P',
    IvP: 'IV-P'
} as const;

export type WarehouseControlledCategory = typeof WarehouseControlledCategory[keyof typeof WarehouseControlledCategory];


/**
 *
 * @export
 * @interface WarehouseDemandRequestBatchResponseDto
 */
export interface WarehouseDemandRequestBatchResponseDto {
    /**
     * Zapotrzebowania w kolejności pozycji.
     * @type {Array<WarehouseDemandRequestResponseDto>}
     * @memberof WarehouseDemandRequestBatchResponseDto
     */
    'data': Array<WarehouseDemandRequestResponseDto>;
}
/**
 *
 * @export
 * @interface WarehouseDemandRequestResponseDto
 */
export interface WarehouseDemandRequestResponseDto {
    /**
     *
     * @type {string}
     * @memberof WarehouseDemandRequestResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDemandRequestResponseDto
     */
    'productId'?: string;
    /**
     * Nazwa produktu z magazynu albo wpisana nazwa.
     * @type {string}
     * @memberof WarehouseDemandRequestResponseDto
     */
    'productName': string;
    /**
     * Nazwa wpisana przy zgłoszeniu spoza magazynu. Zostaje po połączeniu z produktem z katalogu.
     * @type {string}
     * @memberof WarehouseDemandRequestResponseDto
     */
    'requestedName'?: string;
    /**
     * false dla produktu spoza magazynu.
     * @type {boolean}
     * @memberof WarehouseDemandRequestResponseDto
     */
    'isCatalogueProduct': boolean;
    /**
     *
     * @type {number}
     * @memberof WarehouseDemandRequestResponseDto
     */
    'quantityMilli'?: number;
    /**
     * Np. \"3 op. + 2 tabl.\".
     * @type {string}
     * @memberof WarehouseDemandRequestResponseDto
     */
    'quantityLabel'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDemandRequestResponseDto
     */
    'note'?: string;
    /**
     *
     * @type {WarehouseDemandRequestStatus}
     * @memberof WarehouseDemandRequestResponseDto
     */
    'status': WarehouseDemandRequestStatus;
    /**
     *
     * @type {string}
     * @memberof WarehouseDemandRequestResponseDto
     */
    'createdBy': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDemandRequestResponseDto
     */
    'createdByName': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDemandRequestResponseDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDemandRequestResponseDto
     */
    'statusChangedAt'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDemandRequestResponseDto
     */
    'statusChangedByName'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDemandRequestResponseDto
     */
    'closedByDocumentId'?: string;
    /**
     * Numer PZ, który zamknął zapotrzebowanie.
     * @type {string}
     * @memberof WarehouseDemandRequestResponseDto
     */
    'closedByDocumentNumber'?: string;
}


/**
 *
 * @export
 * @enum {string}
 */

export const WarehouseDemandRequestStatus = {
    Open: 'OPEN',
    Ordered: 'ORDERED',
    Closed: 'CLOSED'
} as const;

export type WarehouseDemandRequestStatus = typeof WarehouseDemandRequestStatus[keyof typeof WarehouseDemandRequestStatus];


/**
 *
 * @export
 * @enum {string}
 */

export const WarehouseDemandRequestTargetStatus = {
    Ordered: 'ORDERED',
    Closed: 'CLOSED'
} as const;

export type WarehouseDemandRequestTargetStatus = typeof WarehouseDemandRequestTargetStatus[keyof typeof WarehouseDemandRequestTargetStatus];


/**
 *
 * @export
 * @enum {string}
 */

export const WarehouseDispenseMode = {
    Packages: 'PACKAGES',
    Units: 'UNITS'
} as const;

export type WarehouseDispenseMode = typeof WarehouseDispenseMode[keyof typeof WarehouseDispenseMode];


/**
 *
 * @export
 * @interface WarehouseDocumentAttachmentDto
 */
export interface WarehouseDocumentAttachmentDto {
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentAttachmentDto
     */
    'fileName': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentAttachmentDto
     */
    'contentType': string;
    /**
     *
     * @type {number}
     * @memberof WarehouseDocumentAttachmentDto
     */
    'size': number;
}
/**
 *
 * @export
 * @interface WarehouseDocumentDto
 */
export interface WarehouseDocumentDto {
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentDto
     */
    'id': string;
    /**
     *
     * @type {WarehouseDocumentType}
     * @memberof WarehouseDocumentDto
     */
    'type': WarehouseDocumentType;
    /**
     *
     * @type {WarehouseDocumentStatus}
     * @memberof WarehouseDocumentDto
     */
    'status': WarehouseDocumentStatus;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentDto
     */
    'number'?: string;
    /**
     * YYYY-MM-DD
     * @type {string}
     * @memberof WarehouseDocumentDto
     */
    'documentDate': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentDto
     */
    'supplierId'?: string;
    /**
     * The snapshot name once approved, else the live Supplier name
     * @type {string}
     * @memberof WarehouseDocumentDto
     */
    'supplierName'?: string;
    /**
     *
     * @type {WarehouseDocumentDtoSupplierSnapshot}
     * @memberof WarehouseDocumentDto
     */
    'supplierSnapshot'?: WarehouseDocumentDtoSupplierSnapshot;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentDto
     */
    'supplierInvoiceNumber'?: string;
    /**
     *
     * @type {WarehouseDocumentAttachmentDto}
     * @memberof WarehouseDocumentDto
     */
    'attachment'?: WarehouseDocumentAttachmentDto;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentDto
     */
    'buyerName'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentDto
     */
    'visitId'?: string;
    /**
     * Start of the linked visit (ISO-8601, date and time)
     * @type {string}
     * @memberof WarehouseDocumentDto
     */
    'visitStartAt'?: string;
    /**
     *
     * @type {WarehouseAdjustmentReason}
     * @memberof WarehouseDocumentDto
     */
    'reason'?: WarehouseAdjustmentReason;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentDto
     */
    'note'?: string;
    /**
     *
     * @type {Array<WarehouseDocumentLineDto>}
     * @memberof WarehouseDocumentDto
     */
    'lines': Array<WarehouseDocumentLineDto>;
    /**
     * Owner/admin only
     * @type {number}
     * @memberof WarehouseDocumentDto
     */
    'totalNetMinor'?: number;
    /**
     * Owner/admin only
     * @type {number}
     * @memberof WarehouseDocumentDto
     */
    'totalGrossMinor'?: number;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentDto
     */
    'createdById': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentDto
     */
    'approvedAt'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentDto
     */
    'cancelledAt'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentDto
     */
    'cancelReason'?: string;
}


/**
 * Supplier data frozen at PZ approval
 * @export
 * @interface WarehouseDocumentDtoSupplierSnapshot
 */
export interface WarehouseDocumentDtoSupplierSnapshot {
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentDtoSupplierSnapshot
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentDtoSupplierSnapshot
     */
    'nip'?: string;
    /**
     *
     * @type {WarehouseSupplierAddressDto}
     * @memberof WarehouseDocumentDtoSupplierSnapshot
     */
    'address': WarehouseSupplierAddressDto;
}
/**
 *
 * @export
 * @interface WarehouseDocumentLineDto
 */
export interface WarehouseDocumentLineDto {
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentLineDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentLineDto
     */
    'productId': string;
    /**
     * Snapshot at approval/creation
     * @type {string}
     * @memberof WarehouseDocumentLineDto
     */
    'productName': string;
    /**
     *
     * @type {WarehouseProductKind}
     * @memberof WarehouseDocumentLineDto
     */
    'productKind': WarehouseProductKind;
    /**
     * Snapshot
     * @type {boolean}
     * @memberof WarehouseDocumentLineDto
     */
    'isRx': boolean;
    /**
     *
     * @type {WarehouseUnit}
     * @memberof WarehouseDocumentLineDto
     */
    'unit': WarehouseUnit;
    /**
     * Custom unit name (snapshot)
     * @type {string}
     * @memberof WarehouseDocumentLineDto
     */
    'unitCustom'?: string;
    /**
     * Units per package in force when the line was approved (snapshot)
     * @type {number}
     * @memberof WarehouseDocumentLineDto
     */
    'unitsPerPackage': number;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentLineDto
     */
    'form'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentLineDto
     */
    'strength'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentLineDto
     */
    'marketingAuthorisationNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentLineDto
     */
    'marketingAuthorisationHolder'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentLineDto
     */
    'withdrawalPeriod'?: string;
    /**
     * Thousandths of a Unit; negative on a decreasing KOR
     * @type {number}
     * @memberof WarehouseDocumentLineDto
     */
    'quantityMilli': number;
    /**
     *
     * @type {number}
     * @memberof WarehouseDocumentLineDto
     */
    'inputQuantity': number;
    /**
     *
     * @type {WarehouseQuantityMeasure}
     * @memberof WarehouseDocumentLineDto
     */
    'inputMeasure': WarehouseQuantityMeasure;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentLineDto
     */
    'batchNumber'?: string;
    /**
     * YYYY-MM-DD
     * @type {string}
     * @memberof WarehouseDocumentLineDto
     */
    'expiryDate'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseDocumentLineDto
     */
    'batchId'?: string;
    /**
     *
     * @type {WarehouseVatRate}
     * @memberof WarehouseDocumentLineDto
     */
    'vatRate': WarehouseVatRate;
    /**
     * Owner/admin only
     * @type {number}
     * @memberof WarehouseDocumentLineDto
     */
    'inputCostNetMinor'?: number;
    /**
     * Owner/admin only
     * @type {number}
     * @memberof WarehouseDocumentLineDto
     */
    'unitCostNetMinor'?: number;
    /**
     *
     * @type {number}
     * @memberof WarehouseDocumentLineDto
     */
    'unitPriceGrossMinor'?: number;
    /**
     * Owner/admin only
     * @type {number}
     * @memberof WarehouseDocumentLineDto
     */
    'lineNetMinor'?: number;
    /**
     * Owner/admin only
     * @type {number}
     * @memberof WarehouseDocumentLineDto
     */
    'lineGrossMinor'?: number;
}


/**
 *
 * @export
 * @interface WarehouseDocumentMutationResponseDto
 */
export interface WarehouseDocumentMutationResponseDto {
    /**
     *
     * @type {WarehouseDocumentDto}
     * @memberof WarehouseDocumentMutationResponseDto
     */
    'document': WarehouseDocumentDto;
    /**
     *
     * @type {Array<StockWarningDto>}
     * @memberof WarehouseDocumentMutationResponseDto
     */
    'stockWarnings': Array<StockWarningDto>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const WarehouseDocumentStatus = {
    Draft: 'DRAFT',
    Approved: 'APPROVED',
    Cancelled: 'CANCELLED'
} as const;

export type WarehouseDocumentStatus = typeof WarehouseDocumentStatus[keyof typeof WarehouseDocumentStatus];


/**
 *
 * @export
 * @enum {string}
 */

export const WarehouseDocumentType = {
    Pz: 'PZ',
    Bo: 'BO',
    Wz: 'WZ',
    Kor: 'KOR'
} as const;

export type WarehouseDocumentType = typeof WarehouseDocumentType[keyof typeof WarehouseDocumentType];


/**
 *
 * @export
 * @enum {string}
 */

export const WarehouseHandover = {
    Administered: 'ADMINISTERED',
    HandedOver: 'HANDED_OVER'
} as const;

export type WarehouseHandover = typeof WarehouseHandover[keyof typeof WarehouseHandover];


/**
 *
 * @export
 * @interface WarehouseMedicineOptionDto
 */
export interface WarehouseMedicineOptionDto {
    /**
     *
     * @type {WarehouseMedicineProductDto}
     * @memberof WarehouseMedicineOptionDto
     */
    'product': WarehouseMedicineProductDto;
    /**
     * YYYY-MM-DD: the earliest expiry of a Batch holding stock and not expired on the Europe/Warsaw date; null without one
     * @type {string}
     * @memberof WarehouseMedicineOptionDto
     */
    'nextExpiryDate': string | null;
    /**
     *
     * @type {WarehouseMedicineOptionDtoMedicine}
     * @memberof WarehouseMedicineOptionDto
     */
    'medicine': WarehouseMedicineOptionDtoMedicine | null;
}
/**
 * The registry medicine the Product links to; null for a manual Product or one missing from the registry
 * @export
 * @interface WarehouseMedicineOptionDtoMedicine
 */
export interface WarehouseMedicineOptionDtoMedicine {
    /**
     * Medicine ID
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'id': string;
    /**
     * Product ID
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'productId': string;
    /**
     * Product name
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'productName': string;
    /**
     * Common name
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'commonName'?: string;
    /**
     * Preparation type
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'preparationType'?: string;
    /**
     * Animal usage ban
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'animalUsageBan'?: string;
    /**
     * Previous name
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'previousName'?: string;
    /**
     * Administration route
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'administrationRoute'?: string;
    /**
     * Strength
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'strength'?: string;
    /**
     * Pharmaceutical form
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'pharmaceuticalForm'?: string;
    /**
     * Procedure type
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'procedureType'?: string;
    /**
     * License number
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'licenseNumber'?: string;
    /**
     * License validity
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'licenseValidity'?: string;
    /**
     * ATC code
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'atcCode'?: string;
    /**
     * Responsible entity
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'responsibleEntity'?: string;
    /**
     *
     * @type {GetMedicineDtoPackaging}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'packaging'?: GetMedicineDtoPackaging;
    /**
     * Active substance
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'activeSubstance'?: string;
    /**
     * Manufacturer name
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'manufacturerName'?: string;
    /**
     * Manufacturer country
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'manufacturerCountry'?: string;
    /**
     * Importer name
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'importerName'?: string;
    /**
     * Importer country
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'importerCountry'?: string;
    /**
     * Manufacturer/Importer name
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'manufacturerImporterName'?: string;
    /**
     * Manufacturer/Importer country
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'manufacturerImporterCountry'?: string;
    /**
     * Responsible entity export
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'responsibleEntityExport'?: string;
    /**
     * Export country
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'exportCountry'?: string;
    /**
     * Legal basis
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'legalBasis'?: string;
    /**
     * Leaflet URL
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'leafletUrl'?: string;
    /**
     * Characteristic URL
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'characteristicUrl'?: string;
    /**
     * Label leaflet URL
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'labelLeafletUrl'?: string;
    /**
     * Parallel import leaflet URL
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'parallelImportLeafletUrl'?: string;
    /**
     * Parallel import label leaflet URL
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'parallelImportLabelLeafletUrl'?: string;
    /**
     * Parallel import packaging marking URL
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'parallelImportPackagingMarkingUrl'?: string;
    /**
     * Educational medical tools URL
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'educationalMedicalToolsUrl'?: string;
    /**
     * Educational patient tools URL
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'educationalPatientToolsUrl'?: string;
    /**
     * Import date
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'importDate'?: string;
    /**
     * Source file
     * @type {string}
     * @memberof WarehouseMedicineOptionDtoMedicine
     */
    'sourceFile'?: string;
}
/**
 *
 * @export
 * @interface WarehouseMedicineProductDto
 */
export interface WarehouseMedicineProductDto {
    /**
     *
     * @type {string}
     * @memberof WarehouseMedicineProductDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseMedicineProductDto
     */
    'name': string;
    /**
     * Medicine.productId from the RPL registry
     * @type {string}
     * @memberof WarehouseMedicineProductDto
     */
    'medicineProductId'?: string;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseMedicineProductDto
     */
    'isRx': boolean;
    /**
     *
     * @type {WarehouseControlledCategory}
     * @memberof WarehouseMedicineProductDto
     */
    'controlledCategory'?: WarehouseControlledCategory;
    /**
     *
     * @type {WarehouseUnit}
     * @memberof WarehouseMedicineProductDto
     */
    'unit': WarehouseUnit;
    /**
     *
     * @type {string}
     * @memberof WarehouseMedicineProductDto
     */
    'unitCustom'?: string;
    /**
     *
     * @type {number}
     * @memberof WarehouseMedicineProductDto
     */
    'unitsPerPackage': number;
    /**
     *
     * @type {WarehouseDispenseMode}
     * @memberof WarehouseMedicineProductDto
     */
    'dispenseMode'?: WarehouseDispenseMode;
    /**
     * Minimum stock, thousandths of a Unit
     * @type {number}
     * @memberof WarehouseMedicineProductDto
     */
    'minStockMilli'?: number;
    /**
     *
     * @type {string}
     * @memberof WarehouseMedicineProductDto
     */
    'form'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseMedicineProductDto
     */
    'strength'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseMedicineProductDto
     */
    'gtin'?: string;
    /**
     * Stock Level, thousandths of a Unit (may be negative)
     * @type {number}
     * @memberof WarehouseMedicineProductDto
     */
    'onHandMilli': number;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseMedicineProductDto
     */
    'isNegative': boolean;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseMedicineProductDto
     */
    'isBelowMinimum': boolean;
}


/**
 *
 * @export
 * @interface WarehouseMedicineSearchDto
 */
export interface WarehouseMedicineSearchDto {
    /**
     * The organization\'s drug Products, in stock first, then by name (at most 10)
     * @type {Array<WarehouseMedicineOptionDto>}
     * @memberof WarehouseMedicineSearchDto
     */
    'warehouse': Array<WarehouseMedicineOptionDto>;
    /**
     * Registry medicines none of the returned Products links to
     * @type {Array<GetMedicineDto>}
     * @memberof WarehouseMedicineSearchDto
     */
    'registry': Array<GetMedicineDto>;
}
/**
 *
 * @export
 * @interface WarehouseMovementDto
 */
export interface WarehouseMovementDto {
    /**
     *
     * @type {string}
     * @memberof WarehouseMovementDto
     */
    'id': string;
    /**
     *
     * @type {WarehouseMovementType}
     * @memberof WarehouseMovementDto
     */
    'type': WarehouseMovementType;
    /**
     *
     * @type {number}
     * @memberof WarehouseMovementDto
     */
    'quantityMilli': number;
    /**
     * Product name when the movement was posted (snapshot)
     * @type {string}
     * @memberof WarehouseMovementDto
     */
    'productName': string;
    /**
     * Units per package when the movement was posted (snapshot)
     * @type {number}
     * @memberof WarehouseMovementDto
     */
    'unitsPerPackage': number;
    /**
     * Custom unit name when the movement was posted (snapshot)
     * @type {string}
     * @memberof WarehouseMovementDto
     */
    'unitCustom'?: string;
    /**
     * The batch-less movement this one replaced (batch assignment)
     * @type {string}
     * @memberof WarehouseMovementDto
     */
    'assignmentOf'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseMovementDto
     */
    'occurredAt': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseMovementDto
     */
    'recordedAt': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseMovementDto
     */
    'recordedById': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseMovementDto
     */
    'visitId'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseMovementDto
     */
    'profileId'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseMovementDto
     */
    'recordedByName'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseMovementDto
     */
    'batchId'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseMovementDto
     */
    'batchNumber'?: string;
    /**
     *
     * @type {WarehouseMovementSourceKind}
     * @memberof WarehouseMovementDto
     */
    'sourceKind': WarehouseMovementSourceKind;
    /**
     *
     * @type {string}
     * @memberof WarehouseMovementDto
     */
    'sourceId': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseMovementDto
     */
    'documentNumber'?: string;
    /**
     *
     * @type {WarehouseDocumentType}
     * @memberof WarehouseMovementDto
     */
    'documentType'?: WarehouseDocumentType;
    /**
     *
     * @type {WarehouseAdjustmentReason}
     * @memberof WarehouseMovementDto
     */
    'documentReason'?: WarehouseAdjustmentReason;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseMovementDto
     */
    'isReversal': boolean;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseMovementDto
     */
    'isReversed': boolean;
    /**
     *
     * @type {WarehouseHandover}
     * @memberof WarehouseMovementDto
     */
    'handover'?: WarehouseHandover;
    /**
     *
     * @type {string}
     * @memberof WarehouseMovementDto
     */
    'recipientName'?: string;
    /**
     * Handed-over rows: the recipient\'s address as recorded at the posting
     * @type {string}
     * @memberof WarehouseMovementDto
     */
    'recipientAddress'?: string;
    /**
     * Owner/admin only
     * @type {number}
     * @memberof WarehouseMovementDto
     */
    'unitCostNetMinor'?: number;
    /**
     *
     * @type {number}
     * @memberof WarehouseMovementDto
     */
    'unitPriceGrossMinor'?: number;
}


/**
 *
 * @export
 * @enum {string}
 */

export const WarehouseMovementSourceKind = {
    Document: 'DOCUMENT',
    Medication: 'MEDICATION',
    PerformedTreatment: 'PERFORMED_TREATMENT'
} as const;

export type WarehouseMovementSourceKind = typeof WarehouseMovementSourceKind[keyof typeof WarehouseMovementSourceKind];


/**
 *
 * @export
 * @enum {string}
 */

export const WarehouseMovementType = {
    Opening: 'OPENING',
    Receipt: 'RECEIPT',
    Usage: 'USAGE',
    Sale: 'SALE',
    Adjustment: 'ADJUSTMENT'
} as const;

export type WarehouseMovementType = typeof WarehouseMovementType[keyof typeof WarehouseMovementType];


/**
 *
 * @export
 * @interface WarehouseProductDetailDto
 */
export interface WarehouseProductDetailDto {
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDetailDto
     */
    'id': string;
    /**
     *
     * @type {WarehouseProductKind}
     * @memberof WarehouseProductDetailDto
     */
    'kind': WarehouseProductKind;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDetailDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDetailDto
     */
    'medicineProductId'?: string;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseProductDetailDto
     */
    'isRx': boolean;
    /**
     *
     * @type {WarehouseControlledCategory}
     * @memberof WarehouseProductDetailDto
     */
    'controlledCategory'?: WarehouseControlledCategory;
    /**
     *
     * @type {WarehouseUnit}
     * @memberof WarehouseProductDetailDto
     */
    'unit': WarehouseUnit;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDetailDto
     */
    'unitCustom'?: string;
    /**
     *
     * @type {number}
     * @memberof WarehouseProductDetailDto
     */
    'unitsPerPackage': number;
    /**
     *
     * @type {WarehouseDispenseMode}
     * @memberof WarehouseProductDetailDto
     */
    'dispenseMode'?: WarehouseDispenseMode;
    /**
     *
     * @type {number}
     * @memberof WarehouseProductDetailDto
     */
    'packagePriceNetMinor': number;
    /**
     *
     * @type {number}
     * @memberof WarehouseProductDetailDto
     */
    'packagePriceGrossMinor': number;
    /**
     *
     * @type {number}
     * @memberof WarehouseProductDetailDto
     */
    'unitPriceNetMinor': number;
    /**
     *
     * @type {number}
     * @memberof WarehouseProductDetailDto
     */
    'unitPriceGrossMinor': number;
    /**
     *
     * @type {WarehouseVatRate}
     * @memberof WarehouseProductDetailDto
     */
    'vatRate': WarehouseVatRate;
    /**
     *
     * @type {number}
     * @memberof WarehouseProductDetailDto
     */
    'minStockMilli'?: number;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDetailDto
     */
    'marketingAuthorisationNumber'?: string;
    /**
     * Podmiot odpowiedzialny
     * @type {string}
     * @memberof WarehouseProductDetailDto
     */
    'marketingAuthorisationHolder'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDetailDto
     */
    'withdrawalPeriod'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDetailDto
     */
    'form'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDetailDto
     */
    'strength'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDetailDto
     */
    'gtin'?: string;
    /**
     * Stock Level, thousandths of a Unit (may be negative)
     * @type {number}
     * @memberof WarehouseProductDetailDto
     */
    'onHandMilli': number;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseProductDetailDto
     */
    'isNegative': boolean;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseProductDetailDto
     */
    'isBelowMinimum': boolean;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseProductDetailDto
     */
    'hasExpiringBatch': boolean;
    /**
     * Unassigned issues: outgoing drug movements without a batch, net of reversals (all time)
     * @type {number}
     * @memberof WarehouseProductDetailDto
     */
    'unbatchedIssueCount': number;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDetailDto
     */
    'archivedAt'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDetailDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDetailDto
     */
    'updatedAt': string;
    /**
     *
     * @type {Array<WarehouseBatchDto>}
     * @memberof WarehouseProductDetailDto
     */
    'batches': Array<WarehouseBatchDto>;
    /**
     * Owner/admin only: last net purchase cost per Unit
     * @type {number}
     * @memberof WarehouseProductDetailDto
     */
    'lastUnitCostNetMinor'?: number;
    /**
     * The Unit can no longer change: the product has movements or document lines (UNIT_LOCKED)
     * @type {boolean}
     * @memberof WarehouseProductDetailDto
     */
    'unitLocked': boolean;
}


/**
 *
 * @export
 * @interface WarehouseProductDto
 */
export interface WarehouseProductDto {
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDto
     */
    'id': string;
    /**
     *
     * @type {WarehouseProductKind}
     * @memberof WarehouseProductDto
     */
    'kind': WarehouseProductKind;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDto
     */
    'medicineProductId'?: string;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseProductDto
     */
    'isRx': boolean;
    /**
     *
     * @type {WarehouseControlledCategory}
     * @memberof WarehouseProductDto
     */
    'controlledCategory'?: WarehouseControlledCategory;
    /**
     *
     * @type {WarehouseUnit}
     * @memberof WarehouseProductDto
     */
    'unit': WarehouseUnit;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDto
     */
    'unitCustom'?: string;
    /**
     *
     * @type {number}
     * @memberof WarehouseProductDto
     */
    'unitsPerPackage': number;
    /**
     *
     * @type {WarehouseDispenseMode}
     * @memberof WarehouseProductDto
     */
    'dispenseMode'?: WarehouseDispenseMode;
    /**
     *
     * @type {number}
     * @memberof WarehouseProductDto
     */
    'packagePriceNetMinor': number;
    /**
     *
     * @type {number}
     * @memberof WarehouseProductDto
     */
    'packagePriceGrossMinor': number;
    /**
     *
     * @type {number}
     * @memberof WarehouseProductDto
     */
    'unitPriceNetMinor': number;
    /**
     *
     * @type {number}
     * @memberof WarehouseProductDto
     */
    'unitPriceGrossMinor': number;
    /**
     *
     * @type {WarehouseVatRate}
     * @memberof WarehouseProductDto
     */
    'vatRate': WarehouseVatRate;
    /**
     *
     * @type {number}
     * @memberof WarehouseProductDto
     */
    'minStockMilli'?: number;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDto
     */
    'marketingAuthorisationNumber'?: string;
    /**
     * Podmiot odpowiedzialny
     * @type {string}
     * @memberof WarehouseProductDto
     */
    'marketingAuthorisationHolder'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDto
     */
    'withdrawalPeriod'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDto
     */
    'form'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDto
     */
    'strength'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDto
     */
    'gtin'?: string;
    /**
     * Stock Level, thousandths of a Unit (may be negative)
     * @type {number}
     * @memberof WarehouseProductDto
     */
    'onHandMilli': number;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseProductDto
     */
    'isNegative': boolean;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseProductDto
     */
    'isBelowMinimum': boolean;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseProductDto
     */
    'hasExpiringBatch': boolean;
    /**
     * Unassigned issues: outgoing drug movements without a batch, net of reversals (all time)
     * @type {number}
     * @memberof WarehouseProductDto
     */
    'unbatchedIssueCount': number;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDto
     */
    'archivedAt'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductDto
     */
    'updatedAt': string;
}


/**
 *
 * @export
 * @enum {string}
 */

export const WarehouseProductKind = {
    Drug: 'DRUG',
    NonDrug: 'NON_DRUG'
} as const;

export type WarehouseProductKind = typeof WarehouseProductKind[keyof typeof WarehouseProductKind];


/**
 *
 * @export
 * @interface WarehouseProductPrefillDto
 */
export interface WarehouseProductPrefillDto {
    /**
     *
     * @type {WarehouseProductKind}
     * @memberof WarehouseProductPrefillDto
     */
    'kind': WarehouseProductKind;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductPrefillDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductPrefillDto
     */
    'medicineProductId': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductPrefillDto
     */
    'form'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductPrefillDto
     */
    'strength'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductPrefillDto
     */
    'marketingAuthorisationNumber'?: string;
    /**
     * Registry responsibleEntity (podmiot odpowiedzialny)
     * @type {string}
     * @memberof WarehouseProductPrefillDto
     */
    'marketingAuthorisationHolder'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductPrefillDto
     */
    'withdrawalPeriod'?: string;
    /**
     *
     * @type {boolean}
     * @memberof WarehouseProductPrefillDto
     */
    'isRx': boolean;
    /**
     * Registry says Rpw: suggest a controlled category (hint only)
     * @type {boolean}
     * @memberof WarehouseProductPrefillDto
     */
    'suggestControlled': boolean;
    /**
     *
     * @type {string}
     * @memberof WarehouseProductPrefillDto
     */
    'gtin'?: string;
    /**
     * Registry package descriptions to pick unit/unitsPerPackage from
     * @type {Array<string>}
     * @memberof WarehouseProductPrefillDto
     */
    'packagingOptions': Array<string>;
}


/**
 *
 * @export
 * @enum {string}
 */

export const WarehouseQuantityMeasure = {
    Package: 'PACKAGE',
    Unit: 'UNIT'
} as const;

export type WarehouseQuantityMeasure = typeof WarehouseQuantityMeasure[keyof typeof WarehouseQuantityMeasure];


/**
 *
 * @export
 * @interface WarehouseReceiptLineInputDto
 */
export interface WarehouseReceiptLineInputDto {
    /**
     *
     * @type {string}
     * @memberof WarehouseReceiptLineInputDto
     */
    'productId': string;
    /**
     * Quantity in the chosen measure, at most 3 decimals
     * @type {number}
     * @memberof WarehouseReceiptLineInputDto
     */
    'quantity': number;
    /**
     *
     * @type {WarehouseQuantityMeasure}
     * @memberof WarehouseReceiptLineInputDto
     */
    'measure': WarehouseQuantityMeasure;
    /**
     * Net purchase price of one package or one Unit (matching measure), grosze
     * @type {number}
     * @memberof WarehouseReceiptLineInputDto
     */
    'costNetMinor'?: number;
    /**
     *
     * @type {WarehouseVatRate}
     * @memberof WarehouseReceiptLineInputDto
     */
    'vatRate': WarehouseVatRate;
    /**
     * Required for drugs at approval
     * @type {string}
     * @memberof WarehouseReceiptLineInputDto
     */
    'batchNumber'?: string;
    /**
     * YYYY-MM-DD; required for drugs at approval
     * @type {string}
     * @memberof WarehouseReceiptLineInputDto
     */
    'expiryDate'?: string;
}


/**
 *
 * @export
 * @interface WarehouseSaleLineDto
 */
export interface WarehouseSaleLineDto {
    /**
     *
     * @type {string}
     * @memberof WarehouseSaleLineDto
     */
    'documentId': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseSaleLineDto
     */
    'documentNumber'?: string;
    /**
     * YYYY-MM-DD
     * @type {string}
     * @memberof WarehouseSaleLineDto
     */
    'documentDate': string;
    /**
     *
     * @type {WarehouseDocumentStatus}
     * @memberof WarehouseSaleLineDto
     */
    'status': WarehouseDocumentStatus;
    /**
     *
     * @type {string}
     * @memberof WarehouseSaleLineDto
     */
    'buyerName'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseSaleLineDto
     */
    'visitId'?: string;
    /**
     *
     * @type {string}
     * @memberof WarehouseSaleLineDto
     */
    'lineId': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseSaleLineDto
     */
    'productId': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseSaleLineDto
     */
    'productName': string;
    /**
     *
     * @type {WarehouseUnit}
     * @memberof WarehouseSaleLineDto
     */
    'unit': WarehouseUnit;
    /**
     *
     * @type {string}
     * @memberof WarehouseSaleLineDto
     */
    'unitCustom'?: string;
    /**
     *
     * @type {number}
     * @memberof WarehouseSaleLineDto
     */
    'unitsPerPackage': number;
    /**
     *
     * @type {number}
     * @memberof WarehouseSaleLineDto
     */
    'quantityMilli': number;
    /**
     *
     * @type {number}
     * @memberof WarehouseSaleLineDto
     */
    'inputQuantity': number;
    /**
     *
     * @type {WarehouseQuantityMeasure}
     * @memberof WarehouseSaleLineDto
     */
    'inputMeasure': WarehouseQuantityMeasure;
    /**
     *
     * @type {WarehouseVatRate}
     * @memberof WarehouseSaleLineDto
     */
    'vatRate': WarehouseVatRate;
    /**
     *
     * @type {number}
     * @memberof WarehouseSaleLineDto
     */
    'unitPriceGrossMinor'?: number;
    /**
     *
     * @type {number}
     * @memberof WarehouseSaleLineDto
     */
    'lineGrossMinor'?: number;
    /**
     *
     * @type {string}
     * @memberof WarehouseSaleLineDto
     */
    'batchNumber'?: string;
    /**
     * The whole Sale\'s gross value, over all its lines
     * @type {number}
     * @memberof WarehouseSaleLineDto
     */
    'documentTotalGrossMinor'?: number;
}


/**
 *
 * @export
 * @enum {string}
 */

export const WarehouseStockIssueOrigin = {
    Manual: 'MANUAL',
    Treatment: 'TREATMENT'
} as const;

export type WarehouseStockIssueOrigin = typeof WarehouseStockIssueOrigin[keyof typeof WarehouseStockIssueOrigin];


/**
 *
 * @export
 * @interface WarehouseSupplierAddressDto
 */
export interface WarehouseSupplierAddressDto {
    /**
     *
     * @type {string}
     * @memberof WarehouseSupplierAddressDto
     */
    'street': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseSupplierAddressDto
     */
    'postalCode': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseSupplierAddressDto
     */
    'city': string;
}
/**
 *
 * @export
 * @interface WarehouseSupplierDto
 */
export interface WarehouseSupplierDto {
    /**
     *
     * @type {string}
     * @memberof WarehouseSupplierDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseSupplierDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseSupplierDto
     */
    'nip'?: string;
    /**
     *
     * @type {WarehouseSupplierAddressDto}
     * @memberof WarehouseSupplierDto
     */
    'address'?: WarehouseSupplierAddressDto;
    /**
     *
     * @type {string}
     * @memberof WarehouseSupplierDto
     */
    'createdAt': string;
}
/**
 *
 * @export
 * @interface WarehouseSupplierSnapshotDto
 */
export interface WarehouseSupplierSnapshotDto {
    /**
     *
     * @type {string}
     * @memberof WarehouseSupplierSnapshotDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof WarehouseSupplierSnapshotDto
     */
    'nip'?: string;
    /**
     *
     * @type {WarehouseSupplierAddressDto}
     * @memberof WarehouseSupplierSnapshotDto
     */
    'address': WarehouseSupplierAddressDto;
}
/**
 *
 * @export
 * @enum {string}
 */

export const WarehouseUnit = {
    Tablet: 'TABLET',
    Capsule: 'CAPSULE',
    Blister: 'BLISTER',
    Ml: 'ML',
    G: 'G',
    Piece: 'PIECE',
    Sachet: 'SACHET',
    Ampoule: 'AMPOULE',
    Vial: 'VIAL',
    Pipette: 'PIPETTE',
    Dose: 'DOSE',
    Other: 'OTHER'
} as const;

export type WarehouseUnit = typeof WarehouseUnit[keyof typeof WarehouseUnit];


/**
 *
 * @export
 * @enum {string}
 */

export const WarehouseVatRate = {
    _23: '23',
    _8: '8',
    _5: '5',
    _0: '0',
    Zw: 'ZW'
} as const;

export type WarehouseVatRate = typeof WarehouseVatRate[keyof typeof WarehouseVatRate];


/**
 *
 * @export
 * @interface WebinarAdmissionDto
 */
export interface WebinarAdmissionDto {
    /**
     *
     * @type {string}
     * @memberof WebinarAdmissionDto
     */
    'status': WebinarAdmissionDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarAdmissionDto
     */
    'clientUrl'?: string;
    /**
     * Krótkotrwały token do uruchomienia natywnego klienta. Nie zapisuj go ani nie loguj.
     * @type {string}
     * @memberof WebinarAdmissionDto
     */
    'token'?: string;
}

export const WebinarAdmissionDtoStatusEnum = {
    Waiting: 'waiting',
    Ready: 'ready'
} as const;

export type WebinarAdmissionDtoStatusEnum = typeof WebinarAdmissionDtoStatusEnum[keyof typeof WebinarAdmissionDtoStatusEnum];

/**
 *
 * @export
 * @interface WebinarAttributionDto
 */
export interface WebinarAttributionDto {
    /**
     * utm_source
     * @type {string}
     * @memberof WebinarAttributionDto
     */
    'source': string;
    /**
     * utm_medium
     * @type {string}
     * @memberof WebinarAttributionDto
     */
    'medium'?: string;
    /**
     * utm_campaign
     * @type {string}
     * @memberof WebinarAttributionDto
     */
    'campaign'?: string;
    /**
     * utm_content
     * @type {string}
     * @memberof WebinarAttributionDto
     */
    'content'?: string;
    /**
     * utm_term
     * @type {string}
     * @memberof WebinarAttributionDto
     */
    'term'?: string;
}
/**
 *
 * @export
 * @interface WebinarConfirmationEmailDto
 */
export interface WebinarConfirmationEmailDto {
    /**
     * ACCEPTED oznacza przyjęcie przez serwer SMTP, nie dostarczenie do skrzynki.
     * @type {string}
     * @memberof WebinarConfirmationEmailDto
     */
    'status': WebinarConfirmationEmailDtoStatusEnum;
    /**
     *
     * @type {number}
     * @memberof WebinarConfirmationEmailDto
     */
    'attempts': number;
    /**
     *
     * @type {string}
     * @memberof WebinarConfirmationEmailDto
     */
    'lastAttemptAt'?: string;
    /**
     *
     * @type {string}
     * @memberof WebinarConfirmationEmailDto
     */
    'completedAt'?: string;
    /**
     *
     * @type {boolean}
     * @memberof WebinarConfirmationEmailDto
     */
    'canResend': boolean;
    /**
     *
     * @type {string}
     * @memberof WebinarConfirmationEmailDto
     */
    'resendAvailableAt'?: string;
}

export const WebinarConfirmationEmailDtoStatusEnum = {
    NotQueued: 'NOT_QUEUED',
    Queued: 'QUEUED',
    Sending: 'SENDING',
    Accepted: 'ACCEPTED',
    Uncertain: 'UNCERTAIN',
    Failed: 'FAILED',
    Suppressed: 'SUPPRESSED'
} as const;

export type WebinarConfirmationEmailDtoStatusEnum = typeof WebinarConfirmationEmailDtoStatusEnum[keyof typeof WebinarConfirmationEmailDtoStatusEnum];

/**
 *
 * @export
 * @interface WebinarCurrentSessionDto
 */
export interface WebinarCurrentSessionDto {
    /**
     *
     * @type {boolean}
     * @memberof WebinarCurrentSessionDto
     */
    'rehearsal': boolean;
    /**
     *
     * @type {string}
     * @memberof WebinarCurrentSessionDto
     */
    'audiencePhase'?: WebinarCurrentSessionDtoAudiencePhaseEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarCurrentSessionDto
     */
    'audienceTransitionTo'?: WebinarCurrentSessionDtoAudienceTransitionToEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarCurrentSessionDto
     */
    'firstAudienceOpenedAt'?: string | null;
    /**
     * Wynik zamykania zapisany przy pierwszej próbie. Ponowienie zachowuje go niezależnie od polecenia.
     * @type {string}
     * @memberof WebinarCurrentSessionDto
     */
    'closeDisposition'?: WebinarCurrentSessionDtoCloseDispositionEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarCurrentSessionDto
     */
    'status': WebinarCurrentSessionDtoStatusEnum;
}

export const WebinarCurrentSessionDtoAudiencePhaseEnum = {
    Crew: 'crew',
    Public: 'public'
} as const;

export type WebinarCurrentSessionDtoAudiencePhaseEnum = typeof WebinarCurrentSessionDtoAudiencePhaseEnum[keyof typeof WebinarCurrentSessionDtoAudiencePhaseEnum];
export const WebinarCurrentSessionDtoAudienceTransitionToEnum = {
    Crew: 'crew',
    Public: 'public'
} as const;

export type WebinarCurrentSessionDtoAudienceTransitionToEnum = typeof WebinarCurrentSessionDtoAudienceTransitionToEnum[keyof typeof WebinarCurrentSessionDtoAudienceTransitionToEnum];
export const WebinarCurrentSessionDtoCloseDispositionEnum = {
    Published: 'PUBLISHED',
    Ended: 'ENDED'
} as const;

export type WebinarCurrentSessionDtoCloseDispositionEnum = typeof WebinarCurrentSessionDtoCloseDispositionEnum[keyof typeof WebinarCurrentSessionDtoCloseDispositionEnum];
export const WebinarCurrentSessionDtoStatusEnum = {
    Provisioning: 'PROVISIONING',
    Active: 'ACTIVE',
    Ending: 'ENDING',
    Ended: 'ENDED'
} as const;

export type WebinarCurrentSessionDtoStatusEnum = typeof WebinarCurrentSessionDtoStatusEnum[keyof typeof WebinarCurrentSessionDtoStatusEnum];

/**
 *
 * @export
 * @interface WebinarDownloadDto
 */
export interface WebinarDownloadDto {
    /**
     *
     * @type {string}
     * @memberof WebinarDownloadDto
     */
    'url': string;
    /**
     *
     * @type {string}
     * @memberof WebinarDownloadDto
     */
    'expiresAt': string;
}
/**
 *
 * @export
 * @interface WebinarEventDto
 */
export interface WebinarEventDto {
    /**
     *
     * @type {string}
     * @memberof WebinarEventDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof WebinarEventDto
     */
    'slug': string;
    /**
     *
     * @type {string}
     * @memberof WebinarEventDto
     */
    'title': string;
    /**
     *
     * @type {string}
     * @memberof WebinarEventDto
     */
    'description': string;
    /**
     *
     * @type {string}
     * @memberof WebinarEventDto
     */
    'startsAt': string;
    /**
     * Najwcześniejszy termin ręcznego otwarcia pokoju na żywo. Dołączenie wymaga otwartego pokoju.
     * @type {string}
     * @memberof WebinarEventDto
     */
    'joinOpensAt'?: string;
    /**
     *
     * @type {number}
     * @memberof WebinarEventDto
     */
    'durationMinutes': number;
    /**
     *
     * @type {number}
     * @memberof WebinarEventDto
     */
    'capacity': number;
    /**
     *
     * @type {number}
     * @memberof WebinarEventDto
     */
    'remainingSeats': number;
    /**
     *
     * @type {string}
     * @memberof WebinarEventDto
     */
    'status': WebinarEventDtoStatusEnum;
    /**
     *
     * @type {boolean}
     * @memberof WebinarEventDto
     */
    'registrationOpen': boolean;
    /**
     *
     * @type {number}
     * @memberof WebinarEventDto
     */
    'recordingOnlyRegistrations': number;
    /**
     *
     * @type {boolean}
     * @memberof WebinarEventDto
     */
    'recordingRegistrationOpen': boolean;
    /**
     *
     * @type {string}
     * @memberof WebinarEventDto
     */
    'recordingNotice': string;
    /**
     *
     * @type {string}
     * @memberof WebinarEventDto
     */
    'crewOpensAt'?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof WebinarEventDto
     */
    'presenterIds': Array<string>;
    /**
     *
     * @type {string}
     * @memberof WebinarEventDto
     */
    'mainPresenterId'?: string;
    /**
     *
     * @type {string}
     * @memberof WebinarEventDto
     */
    'mainPresenterInvitationId'?: string;
    /**
     *
     * @type {Array<WebinarPresenterDto>}
     * @memberof WebinarEventDto
     */
    'presenters': Array<WebinarPresenterDto>;
    /**
     *
     * @type {Array<string>}
     * @memberof WebinarEventDto
     */
    'moderatorIds': Array<string>;
    /**
     *
     * @type {Array<WebinarPresenterDto>}
     * @memberof WebinarEventDto
     */
    'moderators': Array<WebinarPresenterDto>;
    /**
     *
     * @type {number}
     * @memberof WebinarEventDto
     */
    'revision': number;
    /**
     *
     * @type {number}
     * @memberof WebinarEventDto
     */
    'registrationCount': number;
    /**
     *
     * @type {string}
     * @memberof WebinarEventDto
     */
    'currentSessionId'?: string;
    /**
     *
     * @type {WebinarCurrentSessionDto}
     * @memberof WebinarEventDto
     */
    'currentSession'?: WebinarCurrentSessionDto;
}

export const WebinarEventDtoStatusEnum = {
    Draft: 'DRAFT',
    Published: 'PUBLISHED',
    Open: 'OPEN',
    Ended: 'ENDED',
    Cancelled: 'CANCELLED'
} as const;

export type WebinarEventDtoStatusEnum = typeof WebinarEventDtoStatusEnum[keyof typeof WebinarEventDtoStatusEnum];

/**
 *
 * @export
 * @interface WebinarPresenterDto
 */
export interface WebinarPresenterDto {
    /**
     *
     * @type {string}
     * @memberof WebinarPresenterDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof WebinarPresenterDto
     */
    'email': string;
    /**
     *
     * @type {string}
     * @memberof WebinarPresenterDto
     */
    'name': string;
}
/**
 *
 * @export
 * @interface WebinarReadinessDto
 */
export interface WebinarReadinessDto {
    /**
     *
     * @type {boolean}
     * @memberof WebinarReadinessDto
     */
    'safeToStop': boolean;
    /**
     *
     * @type {boolean}
     * @memberof WebinarReadinessDto
     */
    'activeSession': boolean;
    /**
     *
     * @type {number}
     * @memberof WebinarReadinessDto
     */
    'pendingRecordings': number;
    /**
     *
     * @type {number}
     * @memberof WebinarReadinessDto
     */
    'unresolvedNotifications': number;
    /**
     *
     * @type {Array<string>}
     * @memberof WebinarReadinessDto
     */
    'blockers': Array<string>;
}
/**
 *
 * @export
 * @interface WebinarRecordingDto
 */
export interface WebinarRecordingDto {
    /**
     *
     * @type {boolean}
     * @memberof WebinarRecordingDto
     */
    'preparation'?: boolean | null;
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingDto
     */
    'sessionId': string;
    /**
     *
     * @type {boolean}
     * @memberof WebinarRecordingDto
     */
    'rehearsal': boolean | null;
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingDto
     */
    'recordingId': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingDto
     */
    'roomId': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingDto
     */
    'status': WebinarRecordingDtoStatusEnum;
    /**
     *
     * @type {number}
     * @memberof WebinarRecordingDto
     */
    'sizeBytes'?: number;
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingDto
     */
    'uploadedAt'?: string;
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingDto
     */
    'failureReason'?: WebinarRecordingDtoFailureReasonEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingDto
     */
    'failedAt'?: string;
}

export const WebinarRecordingDtoStatusEnum = {
    Pending: 'PENDING',
    Available: 'AVAILABLE',
    Deleting: 'DELETING',
    Deleted: 'DELETED',
    Failed: 'FAILED'
} as const;

export type WebinarRecordingDtoStatusEnum = typeof WebinarRecordingDtoStatusEnum[keyof typeof WebinarRecordingDtoStatusEnum];
export const WebinarRecordingDtoFailureReasonEnum = {
    RecordingOutputMissing: 'RECORDING_OUTPUT_MISSING'
} as const;

export type WebinarRecordingDtoFailureReasonEnum = typeof WebinarRecordingDtoFailureReasonEnum[keyof typeof WebinarRecordingDtoFailureReasonEnum];

/**
 *
 * @export
 * @interface WebinarRecordingPublicationDto
 */
export interface WebinarRecordingPublicationDto {
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingPublicationDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingPublicationDto
     */
    'recordingUrl': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingPublicationDto
     */
    'publishedAt': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingPublicationDto
     */
    'cancelledAt'?: string;
    /**
     *
     * @type {number}
     * @memberof WebinarRecordingPublicationDto
     */
    'recipientCount': number;
    /**
     *
     * @type {boolean}
     * @memberof WebinarRecordingPublicationDto
     */
    'enrollmentComplete': boolean;
    /**
     *
     * @type {number}
     * @memberof WebinarRecordingPublicationDto
     */
    'queued': number;
    /**
     *
     * @type {number}
     * @memberof WebinarRecordingPublicationDto
     */
    'accepted': number;
    /**
     *
     * @type {number}
     * @memberof WebinarRecordingPublicationDto
     */
    'failed': number;
    /**
     *
     * @type {number}
     * @memberof WebinarRecordingPublicationDto
     */
    'suppressed': number;
}
/**
 *
 * @export
 * @interface WebinarRecordingPublicationPreviewDto
 */
export interface WebinarRecordingPublicationPreviewDto {
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingPublicationPreviewDto
     */
    'recordingUrl': string;
    /**
     *
     * @type {number}
     * @memberof WebinarRecordingPublicationPreviewDto
     */
    'recipientCount': number;
    /**
     *
     * @type {number}
     * @memberof WebinarRecordingPublicationPreviewDto
     */
    'registrationCount': number;
    /**
     *
     * @type {number}
     * @memberof WebinarRecordingPublicationPreviewDto
     */
    'staffCount': number;
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingPublicationPreviewDto
     */
    'audienceHash': string;
    /**
     *
     * @type {Array<WebinarRecordingRecipientDto>}
     * @memberof WebinarRecordingPublicationPreviewDto
     */
    'recipients': Array<WebinarRecordingRecipientDto>;
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingPublicationPreviewDto
     */
    'emailSubject': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingPublicationPreviewDto
     */
    'emailHtml': string;
}
/**
 *
 * @export
 * @interface WebinarRecordingPublicationReviewDto
 */
export interface WebinarRecordingPublicationReviewDto {
    /**
     *
     * @type {WebinarRecordingPublicationDto}
     * @memberof WebinarRecordingPublicationReviewDto
     */
    'publication'?: WebinarRecordingPublicationDto;
}
/**
 *
 * @export
 * @interface WebinarRecordingRecipientDto
 */
export interface WebinarRecordingRecipientDto {
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingRecipientDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRecordingRecipientDto
     */
    'email': string;
    /**
     *
     * @type {boolean}
     * @memberof WebinarRecordingRecipientDto
     */
    'registered': boolean;
    /**
     *
     * @type {boolean}
     * @memberof WebinarRecordingRecipientDto
     */
    'staff': boolean;
}
/**
 *
 * @export
 * @interface WebinarRegistrationAdminDto
 */
export interface WebinarRegistrationAdminDto {
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationAdminDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationAdminDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationAdminDto
     */
    'email': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationAdminDto
     */
    'profession'?: string;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationAdminDto
     */
    'clinic'?: string;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationAdminDto
     */
    'mode': WebinarRegistrationAdminDtoModeEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationAdminDto
     */
    'requestedMode': WebinarRegistrationAdminDtoRequestedModeEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationAdminDto
     */
    'status': WebinarRegistrationAdminDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationAdminDto
     */
    'confirmedAt'?: string;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationAdminDto
     */
    'verificationExpiresAt'?: string;
    /**
     *
     * @type {WebinarConfirmationEmailDto}
     * @memberof WebinarRegistrationAdminDto
     */
    'verificationEmail': WebinarConfirmationEmailDto;
    /**
     *
     * @type {boolean}
     * @memberof WebinarRegistrationAdminDto
     */
    'marketingConsent': boolean;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationAdminDto
     */
    'marketingConsentAt'?: string;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationAdminDto
     */
    'marketingConsentVersion'?: string;
    /**
     *
     * @type {WebinarAttributionDto}
     * @memberof WebinarRegistrationAdminDto
     */
    'attribution'?: WebinarAttributionDto;
    /**
     *
     * @type {WebinarConfirmationEmailDto}
     * @memberof WebinarRegistrationAdminDto
     */
    'confirmationEmail': WebinarConfirmationEmailDto;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationAdminDto
     */
    'createdAt': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationAdminDto
     */
    'revokedAt'?: string;
}

export const WebinarRegistrationAdminDtoModeEnum = {
    Live: 'live',
    Recording: 'recording'
} as const;

export type WebinarRegistrationAdminDtoModeEnum = typeof WebinarRegistrationAdminDtoModeEnum[keyof typeof WebinarRegistrationAdminDtoModeEnum];
export const WebinarRegistrationAdminDtoRequestedModeEnum = {
    Live: 'live',
    Recording: 'recording'
} as const;

export type WebinarRegistrationAdminDtoRequestedModeEnum = typeof WebinarRegistrationAdminDtoRequestedModeEnum[keyof typeof WebinarRegistrationAdminDtoRequestedModeEnum];
export const WebinarRegistrationAdminDtoStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED'
} as const;

export type WebinarRegistrationAdminDtoStatusEnum = typeof WebinarRegistrationAdminDtoStatusEnum[keyof typeof WebinarRegistrationAdminDtoStatusEnum];

/**
 *
 * @export
 * @interface WebinarRehearsalInvitationDto
 */
export interface WebinarRehearsalInvitationDto {
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalInvitationDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalInvitationDto
     */
    'sessionId': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalInvitationDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalInvitationDto
     */
    'role': WebinarRehearsalInvitationDtoRoleEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalInvitationDto
     */
    'expiresAt': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalInvitationDto
     */
    'revokedAt'?: string;
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalInvitationDto
     */
    'url': string;
}

export const WebinarRehearsalInvitationDtoRoleEnum = {
    Host: 'host',
    Guest: 'guest',
    Moderator: 'moderator',
    Attendee: 'attendee'
} as const;

export type WebinarRehearsalInvitationDtoRoleEnum = typeof WebinarRehearsalInvitationDtoRoleEnum[keyof typeof WebinarRehearsalInvitationDtoRoleEnum];

/**
 *
 * @export
 * @interface WebinarStaffEmailPreviewDto
 */
export interface WebinarStaffEmailPreviewDto {
    /**
     *
     * @type {string}
     * @memberof WebinarStaffEmailPreviewDto
     */
    'subject': string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffEmailPreviewDto
     */
    'html': string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffEmailPreviewDto
     */
    'text': string;
}
/**
 *
 * @export
 * @interface WebinarStaffInvitationDto
 */
export interface WebinarStaffInvitationDto {
    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationDto
     */
    'eventId': string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationDto
     */
    'email': string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationDto
     */
    'role': WebinarStaffInvitationDtoRoleEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationDto
     */
    'url': string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationDto
     */
    'expiresAt': string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationDto
     */
    'revokedAt'?: string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationDto
     */
    'recordingConsentAt'?: string;
    /**
     *
     * @type {WebinarStaffMailStatusDto}
     * @memberof WebinarStaffInvitationDto
     */
    'manualEmail': WebinarStaffMailStatusDto;
    /**
     *
     * @type {WebinarStaffMailStatusDto}
     * @memberof WebinarStaffInvitationDto
     */
    'scheduledEmail': WebinarStaffMailStatusDto;
}

export const WebinarStaffInvitationDtoRoleEnum = {
    Host: 'host',
    Guest: 'guest',
    Moderator: 'moderator'
} as const;

export type WebinarStaffInvitationDtoRoleEnum = typeof WebinarStaffInvitationDtoRoleEnum[keyof typeof WebinarStaffInvitationDtoRoleEnum];

/**
 *
 * @export
 * @interface WebinarStaffMailStatusDto
 */
export interface WebinarStaffMailStatusDto {
    /**
     *
     * @type {string}
     * @memberof WebinarStaffMailStatusDto
     */
    'status': WebinarStaffMailStatusDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffMailStatusDto
     */
    'jobId'?: string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffMailStatusDto
     */
    'dueAt'?: string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffMailStatusDto
     */
    'completedAt'?: string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffMailStatusDto
     */
    'lastAttemptAt'?: string;
    /**
     *
     * @type {number}
     * @memberof WebinarStaffMailStatusDto
     */
    'attempts': number;
}

export const WebinarStaffMailStatusDtoStatusEnum = {
    NotQueued: 'NOT_QUEUED',
    Queued: 'QUEUED',
    Sending: 'SENDING',
    Accepted: 'ACCEPTED',
    Uncertain: 'UNCERTAIN',
    Failed: 'FAILED',
    Suppressed: 'SUPPRESSED'
} as const;

export type WebinarStaffMailStatusDtoStatusEnum = typeof WebinarStaffMailStatusDtoStatusEnum[keyof typeof WebinarStaffMailStatusDtoStatusEnum];


/**
 * AcquisitionApi - axios parameter creator
 * @export
 */
export const AcquisitionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {7 | 28 | 90} days Complete days ending yesterday in the GA4 property reporting time zone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acquisitionControllerReport: async (days: 7 | 28 | 90, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'days' is not null or undefined
            assertParamExists('acquisitionControllerReport', 'days', days)
            const localVarPath = `/api/acquisition/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AcquisitionApi - functional programming interface
 * @export
 */
export const AcquisitionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AcquisitionApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {7 | 28 | 90} days Complete days ending yesterday in the GA4 property reporting time zone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acquisitionControllerReport(days: 7 | 28 | 90, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AcquisitionReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acquisitionControllerReport(days, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AcquisitionApi - factory interface
 * @export
 */
export const AcquisitionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AcquisitionApiFp(configuration)
    return {
        /**
         *
         * @param {AcquisitionApiAcquisitionControllerReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acquisitionControllerReport(requestParameters: AcquisitionApiAcquisitionControllerReportRequest, options?: AxiosRequestConfig): AxiosPromise<AcquisitionReportDto> {
            return localVarFp.acquisitionControllerReport(requestParameters.days, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for acquisitionControllerReport operation in AcquisitionApi.
 * @export
 * @interface AcquisitionApiAcquisitionControllerReportRequest
 */
export interface AcquisitionApiAcquisitionControllerReportRequest {
    /**
     * Complete days ending yesterday in the GA4 property reporting time zone.
     * @type {7 | 28 | 90}
     * @memberof AcquisitionApiAcquisitionControllerReport
     */
    readonly days: 7 | 28 | 90
}

/**
 * AcquisitionApi - object-oriented interface
 * @export
 * @class AcquisitionApi
 * @extends {BaseAPI}
 */
export class AcquisitionApi extends BaseAPI {
    /**
     *
     * @param {AcquisitionApiAcquisitionControllerReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AcquisitionApi
     */
    public acquisitionControllerReport(requestParameters: AcquisitionApiAcquisitionControllerReportRequest, options?: AxiosRequestConfig) {
        return AcquisitionApiFp(this.configuration).acquisitionControllerReport(requestParameters.days, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Send a Vetsi-branded password reset email. Replaces the Firebase hosted template.
         * @param {SendPasswordResetDto} sendPasswordResetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendPasswordReset: async (sendPasswordResetDto: SendPasswordResetDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendPasswordResetDto' is not null or undefined
            assertParamExists('authControllerSendPasswordReset', 'sendPasswordResetDto', sendPasswordResetDto)
            const localVarPath = `/api/auth/password-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendPasswordResetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Send phone verification code via SMS
         * @param {SendPhoneVerificationDto} sendPhoneVerificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendPhoneVerificationCode: async (sendPhoneVerificationDto: SendPhoneVerificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendPhoneVerificationDto' is not null or undefined
            assertParamExists('authControllerSendPhoneVerificationCode', 'sendPhoneVerificationDto', sendPhoneVerificationDto)
            const localVarPath = `/api/auth/phone/send-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendPhoneVerificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Verify phone number with SMS code
         * @param {VerifyPhoneCodeDto} verifyPhoneCodeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerVerifyPhoneCode: async (verifyPhoneCodeDto: VerifyPhoneCodeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyPhoneCodeDto' is not null or undefined
            assertParamExists('authControllerVerifyPhoneCode', 'verifyPhoneCodeDto', verifyPhoneCodeDto)
            const localVarPath = `/api/auth/phone/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyPhoneCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Send a Vetsi-branded password reset email. Replaces the Firebase hosted template.
         * @param {SendPasswordResetDto} sendPasswordResetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSendPasswordReset(sendPasswordResetDto: SendPasswordResetDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendPasswordResetResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSendPasswordReset(sendPasswordResetDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Send phone verification code via SMS
         * @param {SendPhoneVerificationDto} sendPhoneVerificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSendPhoneVerificationCode(sendPhoneVerificationDto: SendPhoneVerificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendPhoneVerificationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSendPhoneVerificationCode(sendPhoneVerificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Verify phone number with SMS code
         * @param {VerifyPhoneCodeDto} verifyPhoneCodeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerVerifyPhoneCode(verifyPhoneCodeDto: VerifyPhoneCodeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyPhoneCodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerVerifyPhoneCode(verifyPhoneCodeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         *
         * @summary Send a Vetsi-branded password reset email. Replaces the Firebase hosted template.
         * @param {AuthApiAuthControllerSendPasswordResetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendPasswordReset(requestParameters: AuthApiAuthControllerSendPasswordResetRequest, options?: AxiosRequestConfig): AxiosPromise<SendPasswordResetResponseDto> {
            return localVarFp.authControllerSendPasswordReset(requestParameters.sendPasswordResetDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Send phone verification code via SMS
         * @param {AuthApiAuthControllerSendPhoneVerificationCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendPhoneVerificationCode(requestParameters: AuthApiAuthControllerSendPhoneVerificationCodeRequest, options?: AxiosRequestConfig): AxiosPromise<SendPhoneVerificationResponseDto> {
            return localVarFp.authControllerSendPhoneVerificationCode(requestParameters.sendPhoneVerificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify phone number with SMS code
         * @param {AuthApiAuthControllerVerifyPhoneCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerVerifyPhoneCode(requestParameters: AuthApiAuthControllerVerifyPhoneCodeRequest, options?: AxiosRequestConfig): AxiosPromise<VerifyPhoneCodeResponseDto> {
            return localVarFp.authControllerVerifyPhoneCode(requestParameters.verifyPhoneCodeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for authControllerSendPasswordReset operation in AuthApi.
 * @export
 * @interface AuthApiAuthControllerSendPasswordResetRequest
 */
export interface AuthApiAuthControllerSendPasswordResetRequest {
    /**
     *
     * @type {SendPasswordResetDto}
     * @memberof AuthApiAuthControllerSendPasswordReset
     */
    readonly sendPasswordResetDto: SendPasswordResetDto
}

/**
 * Request parameters for authControllerSendPhoneVerificationCode operation in AuthApi.
 * @export
 * @interface AuthApiAuthControllerSendPhoneVerificationCodeRequest
 */
export interface AuthApiAuthControllerSendPhoneVerificationCodeRequest {
    /**
     *
     * @type {SendPhoneVerificationDto}
     * @memberof AuthApiAuthControllerSendPhoneVerificationCode
     */
    readonly sendPhoneVerificationDto: SendPhoneVerificationDto
}

/**
 * Request parameters for authControllerVerifyPhoneCode operation in AuthApi.
 * @export
 * @interface AuthApiAuthControllerVerifyPhoneCodeRequest
 */
export interface AuthApiAuthControllerVerifyPhoneCodeRequest {
    /**
     *
     * @type {VerifyPhoneCodeDto}
     * @memberof AuthApiAuthControllerVerifyPhoneCode
     */
    readonly verifyPhoneCodeDto: VerifyPhoneCodeDto
}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     *
     * @summary Send a Vetsi-branded password reset email. Replaces the Firebase hosted template.
     * @param {AuthApiAuthControllerSendPasswordResetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerSendPasswordReset(requestParameters: AuthApiAuthControllerSendPasswordResetRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerSendPasswordReset(requestParameters.sendPasswordResetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Send phone verification code via SMS
     * @param {AuthApiAuthControllerSendPhoneVerificationCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerSendPhoneVerificationCode(requestParameters: AuthApiAuthControllerSendPhoneVerificationCodeRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerSendPhoneVerificationCode(requestParameters.sendPhoneVerificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Verify phone number with SMS code
     * @param {AuthApiAuthControllerVerifyPhoneCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerVerifyPhoneCode(requestParameters: AuthApiAuthControllerVerifyPhoneCodeRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerVerifyPhoneCode(requestParameters.verifyPhoneCodeDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AutopayPublicApi - axios parameter creator
 * @export
 */
export const AutopayPublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autopayPublicControllerHandleITN: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/autopay/public/payment/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AutopayPublicApi - functional programming interface
 * @export
 */
export const AutopayPublicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AutopayPublicApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autopayPublicControllerHandleITN(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autopayPublicControllerHandleITN(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AutopayPublicApi - factory interface
 * @export
 */
export const AutopayPublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AutopayPublicApiFp(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autopayPublicControllerHandleITN(options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.autopayPublicControllerHandleITN(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AutopayPublicApi - object-oriented interface
 * @export
 * @class AutopayPublicApi
 * @extends {BaseAPI}
 */
export class AutopayPublicApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutopayPublicApi
     */
    public autopayPublicControllerHandleITN(options?: AxiosRequestConfig) {
        return AutopayPublicApiFp(this.configuration).autopayPublicControllerHandleITN(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CallbackRequestAccessApi - axios parameter creator
 * @export
 */
export const CallbackRequestAccessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Pobierz bieżący dostęp do Callback Request
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackAccessControllerGet: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('callbackAccessControllerGet', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/callback-access`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallbackRequestAccessApi - functional programming interface
 * @export
 */
export const CallbackRequestAccessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallbackRequestAccessApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Pobierz bieżący dostęp do Callback Request
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackAccessControllerGet(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackAccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackAccessControllerGet(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CallbackRequestAccessApi - factory interface
 * @export
 */
export const CallbackRequestAccessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallbackRequestAccessApiFp(configuration)
    return {
        /**
         *
         * @summary Pobierz bieżący dostęp do Callback Request
         * @param {CallbackRequestAccessApiCallbackAccessControllerGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackAccessControllerGet(requestParameters: CallbackRequestAccessApiCallbackAccessControllerGetRequest, options?: AxiosRequestConfig): AxiosPromise<CallbackAccessResponseDto> {
            return localVarFp.callbackAccessControllerGet(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for callbackAccessControllerGet operation in CallbackRequestAccessApi.
 * @export
 * @interface CallbackRequestAccessApiCallbackAccessControllerGetRequest
 */
export interface CallbackRequestAccessApiCallbackAccessControllerGetRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof CallbackRequestAccessApiCallbackAccessControllerGet
     */
    readonly organizationId: string
}

/**
 * CallbackRequestAccessApi - object-oriented interface
 * @export
 * @class CallbackRequestAccessApi
 * @extends {BaseAPI}
 */
export class CallbackRequestAccessApi extends BaseAPI {
    /**
     *
     * @summary Pobierz bieżący dostęp do Callback Request
     * @param {CallbackRequestAccessApiCallbackAccessControllerGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbackRequestAccessApi
     */
    public callbackAccessControllerGet(requestParameters: CallbackRequestAccessApiCallbackAccessControllerGetRequest, options?: AxiosRequestConfig) {
        return CallbackRequestAccessApiFp(this.configuration).callbackAccessControllerGet(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CallbackRequestHandlerApi - axios parameter creator
 * @export
 */
export const CallbackRequestHandlerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Zapisz próbę kontaktu Callback Request
         * @param {string} organizationId Identyfikator Organization
         * @param {string} callbackId Identyfikator Callback Request
         * @param {RecordCallbackAttemptDto} recordCallbackAttemptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackHandlerControllerAttempt: async (organizationId: string, callbackId: string, recordCallbackAttemptDto: RecordCallbackAttemptDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('callbackHandlerControllerAttempt', 'organizationId', organizationId)
            // verify required parameter 'callbackId' is not null or undefined
            assertParamExists('callbackHandlerControllerAttempt', 'callbackId', callbackId)
            // verify required parameter 'recordCallbackAttemptDto' is not null or undefined
            assertParamExists('callbackHandlerControllerAttempt', 'recordCallbackAttemptDto', recordCallbackAttemptDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/callbacks/{callbackId}/attempts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"callbackId"}}`, encodeURIComponent(String(callbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordCallbackAttemptDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Przejmij Callback Request wyłącznie
         * @param {string} organizationId Identyfikator Organization
         * @param {string} callbackId Identyfikator Callback Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackHandlerControllerClaim: async (organizationId: string, callbackId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('callbackHandlerControllerClaim', 'organizationId', organizationId)
            // verify required parameter 'callbackId' is not null or undefined
            assertParamExists('callbackHandlerControllerClaim', 'callbackId', callbackId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/callbacks/{callbackId}/claim`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"callbackId"}}`, encodeURIComponent(String(callbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz Callback Request
         * @param {string} organizationId Identyfikator Organization
         * @param {string} callbackId Identyfikator Callback Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackHandlerControllerDetail: async (organizationId: string, callbackId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('callbackHandlerControllerDetail', 'organizationId', organizationId)
            // verify required parameter 'callbackId' is not null or undefined
            assertParamExists('callbackHandlerControllerDetail', 'callbackId', callbackId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/callbacks/{callbackId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"callbackId"}}`, encodeURIComponent(String(callbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zakończ Callback Request po kontakcie
         * @param {string} organizationId Identyfikator Organization
         * @param {string} callbackId Identyfikator Callback Request
         * @param {CallbackClaimVersionDto} callbackClaimVersionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackHandlerControllerFinish: async (organizationId: string, callbackId: string, callbackClaimVersionDto: CallbackClaimVersionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('callbackHandlerControllerFinish', 'organizationId', organizationId)
            // verify required parameter 'callbackId' is not null or undefined
            assertParamExists('callbackHandlerControllerFinish', 'callbackId', callbackId)
            // verify required parameter 'callbackClaimVersionDto' is not null or undefined
            assertParamExists('callbackHandlerControllerFinish', 'callbackClaimVersionDto', callbackClaimVersionDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/callbacks/{callbackId}/finish`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"callbackId"}}`, encodeURIComponent(String(callbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callbackClaimVersionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz kolejkę Callback Request
         * @param {string} organizationId Identyfikator Organization
         * @param {number} [page]
         * @param {number} [limit]
         * @param {'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackHandlerControllerList: async (organizationId: string, page?: number, limit?: number, status?: 'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('callbackHandlerControllerList', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/callbacks`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zwolnij własne przejęcie Callback Request
         * @param {string} organizationId Identyfikator Organization
         * @param {string} callbackId Identyfikator Callback Request
         * @param {CallbackClaimVersionDto} callbackClaimVersionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackHandlerControllerRelease: async (organizationId: string, callbackId: string, callbackClaimVersionDto: CallbackClaimVersionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('callbackHandlerControllerRelease', 'organizationId', organizationId)
            // verify required parameter 'callbackId' is not null or undefined
            assertParamExists('callbackHandlerControllerRelease', 'callbackId', callbackId)
            // verify required parameter 'callbackClaimVersionDto' is not null or undefined
            assertParamExists('callbackHandlerControllerRelease', 'callbackClaimVersionDto', callbackClaimVersionDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/callbacks/{callbackId}/release`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"callbackId"}}`, encodeURIComponent(String(callbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callbackClaimVersionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallbackRequestHandlerApi - functional programming interface
 * @export
 */
export const CallbackRequestHandlerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallbackRequestHandlerApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Zapisz próbę kontaktu Callback Request
         * @param {string} organizationId Identyfikator Organization
         * @param {string} callbackId Identyfikator Callback Request
         * @param {RecordCallbackAttemptDto} recordCallbackAttemptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackHandlerControllerAttempt(organizationId: string, callbackId: string, recordCallbackAttemptDto: RecordCallbackAttemptDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackHandlerControllerAttempt(organizationId, callbackId, recordCallbackAttemptDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Przejmij Callback Request wyłącznie
         * @param {string} organizationId Identyfikator Organization
         * @param {string} callbackId Identyfikator Callback Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackHandlerControllerClaim(organizationId: string, callbackId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackHandlerControllerClaim(organizationId, callbackId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz Callback Request
         * @param {string} organizationId Identyfikator Organization
         * @param {string} callbackId Identyfikator Callback Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackHandlerControllerDetail(organizationId: string, callbackId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackHandlerControllerDetail(organizationId, callbackId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zakończ Callback Request po kontakcie
         * @param {string} organizationId Identyfikator Organization
         * @param {string} callbackId Identyfikator Callback Request
         * @param {CallbackClaimVersionDto} callbackClaimVersionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackHandlerControllerFinish(organizationId: string, callbackId: string, callbackClaimVersionDto: CallbackClaimVersionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackHandlerControllerFinish(organizationId, callbackId, callbackClaimVersionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz kolejkę Callback Request
         * @param {string} organizationId Identyfikator Organization
         * @param {number} [page]
         * @param {number} [limit]
         * @param {'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackHandlerControllerList(organizationId: string, page?: number, limit?: number, status?: 'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackRequestListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackHandlerControllerList(organizationId, page, limit, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zwolnij własne przejęcie Callback Request
         * @param {string} organizationId Identyfikator Organization
         * @param {string} callbackId Identyfikator Callback Request
         * @param {CallbackClaimVersionDto} callbackClaimVersionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackHandlerControllerRelease(organizationId: string, callbackId: string, callbackClaimVersionDto: CallbackClaimVersionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackHandlerControllerRelease(organizationId, callbackId, callbackClaimVersionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CallbackRequestHandlerApi - factory interface
 * @export
 */
export const CallbackRequestHandlerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallbackRequestHandlerApiFp(configuration)
    return {
        /**
         *
         * @summary Zapisz próbę kontaktu Callback Request
         * @param {CallbackRequestHandlerApiCallbackHandlerControllerAttemptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackHandlerControllerAttempt(requestParameters: CallbackRequestHandlerApiCallbackHandlerControllerAttemptRequest, options?: AxiosRequestConfig): AxiosPromise<CallbackRequestResponseDto> {
            return localVarFp.callbackHandlerControllerAttempt(requestParameters.organizationId, requestParameters.callbackId, requestParameters.recordCallbackAttemptDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Przejmij Callback Request wyłącznie
         * @param {CallbackRequestHandlerApiCallbackHandlerControllerClaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackHandlerControllerClaim(requestParameters: CallbackRequestHandlerApiCallbackHandlerControllerClaimRequest, options?: AxiosRequestConfig): AxiosPromise<CallbackRequestResponseDto> {
            return localVarFp.callbackHandlerControllerClaim(requestParameters.organizationId, requestParameters.callbackId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz Callback Request
         * @param {CallbackRequestHandlerApiCallbackHandlerControllerDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackHandlerControllerDetail(requestParameters: CallbackRequestHandlerApiCallbackHandlerControllerDetailRequest, options?: AxiosRequestConfig): AxiosPromise<CallbackRequestResponseDto> {
            return localVarFp.callbackHandlerControllerDetail(requestParameters.organizationId, requestParameters.callbackId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zakończ Callback Request po kontakcie
         * @param {CallbackRequestHandlerApiCallbackHandlerControllerFinishRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackHandlerControllerFinish(requestParameters: CallbackRequestHandlerApiCallbackHandlerControllerFinishRequest, options?: AxiosRequestConfig): AxiosPromise<CallbackRequestResponseDto> {
            return localVarFp.callbackHandlerControllerFinish(requestParameters.organizationId, requestParameters.callbackId, requestParameters.callbackClaimVersionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz kolejkę Callback Request
         * @param {CallbackRequestHandlerApiCallbackHandlerControllerListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackHandlerControllerList(requestParameters: CallbackRequestHandlerApiCallbackHandlerControllerListRequest, options?: AxiosRequestConfig): AxiosPromise<CallbackRequestListResponseDto> {
            return localVarFp.callbackHandlerControllerList(requestParameters.organizationId, requestParameters.page, requestParameters.limit, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zwolnij własne przejęcie Callback Request
         * @param {CallbackRequestHandlerApiCallbackHandlerControllerReleaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackHandlerControllerRelease(requestParameters: CallbackRequestHandlerApiCallbackHandlerControllerReleaseRequest, options?: AxiosRequestConfig): AxiosPromise<CallbackRequestResponseDto> {
            return localVarFp.callbackHandlerControllerRelease(requestParameters.organizationId, requestParameters.callbackId, requestParameters.callbackClaimVersionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for callbackHandlerControllerAttempt operation in CallbackRequestHandlerApi.
 * @export
 * @interface CallbackRequestHandlerApiCallbackHandlerControllerAttemptRequest
 */
export interface CallbackRequestHandlerApiCallbackHandlerControllerAttemptRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerAttempt
     */
    readonly organizationId: string

    /**
     * Identyfikator Callback Request
     * @type {string}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerAttempt
     */
    readonly callbackId: string

    /**
     *
     * @type {RecordCallbackAttemptDto}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerAttempt
     */
    readonly recordCallbackAttemptDto: RecordCallbackAttemptDto
}

/**
 * Request parameters for callbackHandlerControllerClaim operation in CallbackRequestHandlerApi.
 * @export
 * @interface CallbackRequestHandlerApiCallbackHandlerControllerClaimRequest
 */
export interface CallbackRequestHandlerApiCallbackHandlerControllerClaimRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerClaim
     */
    readonly organizationId: string

    /**
     * Identyfikator Callback Request
     * @type {string}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerClaim
     */
    readonly callbackId: string
}

/**
 * Request parameters for callbackHandlerControllerDetail operation in CallbackRequestHandlerApi.
 * @export
 * @interface CallbackRequestHandlerApiCallbackHandlerControllerDetailRequest
 */
export interface CallbackRequestHandlerApiCallbackHandlerControllerDetailRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerDetail
     */
    readonly organizationId: string

    /**
     * Identyfikator Callback Request
     * @type {string}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerDetail
     */
    readonly callbackId: string
}

/**
 * Request parameters for callbackHandlerControllerFinish operation in CallbackRequestHandlerApi.
 * @export
 * @interface CallbackRequestHandlerApiCallbackHandlerControllerFinishRequest
 */
export interface CallbackRequestHandlerApiCallbackHandlerControllerFinishRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerFinish
     */
    readonly organizationId: string

    /**
     * Identyfikator Callback Request
     * @type {string}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerFinish
     */
    readonly callbackId: string

    /**
     *
     * @type {CallbackClaimVersionDto}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerFinish
     */
    readonly callbackClaimVersionDto: CallbackClaimVersionDto
}

/**
 * Request parameters for callbackHandlerControllerList operation in CallbackRequestHandlerApi.
 * @export
 * @interface CallbackRequestHandlerApiCallbackHandlerControllerListRequest
 */
export interface CallbackRequestHandlerApiCallbackHandlerControllerListRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerList
     */
    readonly organizationId: string

    /**
     *
     * @type {number}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerList
     */
    readonly page?: number

    /**
     *
     * @type {number}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerList
     */
    readonly limit?: number

    /**
     *
     * @type {'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED'}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerList
     */
    readonly status?: 'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED'
}

/**
 * Request parameters for callbackHandlerControllerRelease operation in CallbackRequestHandlerApi.
 * @export
 * @interface CallbackRequestHandlerApiCallbackHandlerControllerReleaseRequest
 */
export interface CallbackRequestHandlerApiCallbackHandlerControllerReleaseRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerRelease
     */
    readonly organizationId: string

    /**
     * Identyfikator Callback Request
     * @type {string}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerRelease
     */
    readonly callbackId: string

    /**
     *
     * @type {CallbackClaimVersionDto}
     * @memberof CallbackRequestHandlerApiCallbackHandlerControllerRelease
     */
    readonly callbackClaimVersionDto: CallbackClaimVersionDto
}

/**
 * CallbackRequestHandlerApi - object-oriented interface
 * @export
 * @class CallbackRequestHandlerApi
 * @extends {BaseAPI}
 */
export class CallbackRequestHandlerApi extends BaseAPI {
    /**
     *
     * @summary Zapisz próbę kontaktu Callback Request
     * @param {CallbackRequestHandlerApiCallbackHandlerControllerAttemptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbackRequestHandlerApi
     */
    public callbackHandlerControllerAttempt(requestParameters: CallbackRequestHandlerApiCallbackHandlerControllerAttemptRequest, options?: AxiosRequestConfig) {
        return CallbackRequestHandlerApiFp(this.configuration).callbackHandlerControllerAttempt(requestParameters.organizationId, requestParameters.callbackId, requestParameters.recordCallbackAttemptDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Przejmij Callback Request wyłącznie
     * @param {CallbackRequestHandlerApiCallbackHandlerControllerClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbackRequestHandlerApi
     */
    public callbackHandlerControllerClaim(requestParameters: CallbackRequestHandlerApiCallbackHandlerControllerClaimRequest, options?: AxiosRequestConfig) {
        return CallbackRequestHandlerApiFp(this.configuration).callbackHandlerControllerClaim(requestParameters.organizationId, requestParameters.callbackId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz Callback Request
     * @param {CallbackRequestHandlerApiCallbackHandlerControllerDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbackRequestHandlerApi
     */
    public callbackHandlerControllerDetail(requestParameters: CallbackRequestHandlerApiCallbackHandlerControllerDetailRequest, options?: AxiosRequestConfig) {
        return CallbackRequestHandlerApiFp(this.configuration).callbackHandlerControllerDetail(requestParameters.organizationId, requestParameters.callbackId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zakończ Callback Request po kontakcie
     * @param {CallbackRequestHandlerApiCallbackHandlerControllerFinishRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbackRequestHandlerApi
     */
    public callbackHandlerControllerFinish(requestParameters: CallbackRequestHandlerApiCallbackHandlerControllerFinishRequest, options?: AxiosRequestConfig) {
        return CallbackRequestHandlerApiFp(this.configuration).callbackHandlerControllerFinish(requestParameters.organizationId, requestParameters.callbackId, requestParameters.callbackClaimVersionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz kolejkę Callback Request
     * @param {CallbackRequestHandlerApiCallbackHandlerControllerListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbackRequestHandlerApi
     */
    public callbackHandlerControllerList(requestParameters: CallbackRequestHandlerApiCallbackHandlerControllerListRequest, options?: AxiosRequestConfig) {
        return CallbackRequestHandlerApiFp(this.configuration).callbackHandlerControllerList(requestParameters.organizationId, requestParameters.page, requestParameters.limit, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zwolnij własne przejęcie Callback Request
     * @param {CallbackRequestHandlerApiCallbackHandlerControllerReleaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbackRequestHandlerApi
     */
    public callbackHandlerControllerRelease(requestParameters: CallbackRequestHandlerApiCallbackHandlerControllerReleaseRequest, options?: AxiosRequestConfig) {
        return CallbackRequestHandlerApiFp(this.configuration).callbackHandlerControllerRelease(requestParameters.organizationId, requestParameters.callbackId, requestParameters.callbackClaimVersionDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CallbackRequestOwnerAdminApi - axios parameter creator
 * @export
 */
export const CallbackRequestOwnerAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Anuluj Callback Request administracyjnie
         * @param {string} organizationId Identyfikator Organization
         * @param {string} callbackId Identyfikator Callback Request
         * @param {CallbackAggregateVersionDto} callbackAggregateVersionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackOwnerAdminControllerCancel: async (organizationId: string, callbackId: string, callbackAggregateVersionDto: CallbackAggregateVersionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('callbackOwnerAdminControllerCancel', 'organizationId', organizationId)
            // verify required parameter 'callbackId' is not null or undefined
            assertParamExists('callbackOwnerAdminControllerCancel', 'callbackId', callbackId)
            // verify required parameter 'callbackAggregateVersionDto' is not null or undefined
            assertParamExists('callbackOwnerAdminControllerCancel', 'callbackAggregateVersionDto', callbackAggregateVersionDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/callbacks/{callbackId}/cancel`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"callbackId"}}`, encodeURIComponent(String(callbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callbackAggregateVersionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Przypisz Callback Request innemu Handlerowi
         * @param {string} organizationId Identyfikator Organization
         * @param {string} callbackId Identyfikator Callback Request
         * @param {ReassignCallbackDto} reassignCallbackDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackOwnerAdminControllerReassign: async (organizationId: string, callbackId: string, reassignCallbackDto: ReassignCallbackDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('callbackOwnerAdminControllerReassign', 'organizationId', organizationId)
            // verify required parameter 'callbackId' is not null or undefined
            assertParamExists('callbackOwnerAdminControllerReassign', 'callbackId', callbackId)
            // verify required parameter 'reassignCallbackDto' is not null or undefined
            assertParamExists('callbackOwnerAdminControllerReassign', 'reassignCallbackDto', reassignCallbackDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/callbacks/{callbackId}/reassign`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"callbackId"}}`, encodeURIComponent(String(callbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reassignCallbackDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallbackRequestOwnerAdminApi - functional programming interface
 * @export
 */
export const CallbackRequestOwnerAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallbackRequestOwnerAdminApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Anuluj Callback Request administracyjnie
         * @param {string} organizationId Identyfikator Organization
         * @param {string} callbackId Identyfikator Callback Request
         * @param {CallbackAggregateVersionDto} callbackAggregateVersionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackOwnerAdminControllerCancel(organizationId: string, callbackId: string, callbackAggregateVersionDto: CallbackAggregateVersionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackOwnerAdminControllerCancel(organizationId, callbackId, callbackAggregateVersionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Przypisz Callback Request innemu Handlerowi
         * @param {string} organizationId Identyfikator Organization
         * @param {string} callbackId Identyfikator Callback Request
         * @param {ReassignCallbackDto} reassignCallbackDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackOwnerAdminControllerReassign(organizationId: string, callbackId: string, reassignCallbackDto: ReassignCallbackDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackOwnerAdminControllerReassign(organizationId, callbackId, reassignCallbackDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CallbackRequestOwnerAdminApi - factory interface
 * @export
 */
export const CallbackRequestOwnerAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallbackRequestOwnerAdminApiFp(configuration)
    return {
        /**
         *
         * @summary Anuluj Callback Request administracyjnie
         * @param {CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerCancelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackOwnerAdminControllerCancel(requestParameters: CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerCancelRequest, options?: AxiosRequestConfig): AxiosPromise<CallbackRequestResponseDto> {
            return localVarFp.callbackOwnerAdminControllerCancel(requestParameters.organizationId, requestParameters.callbackId, requestParameters.callbackAggregateVersionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Przypisz Callback Request innemu Handlerowi
         * @param {CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerReassignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackOwnerAdminControllerReassign(requestParameters: CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerReassignRequest, options?: AxiosRequestConfig): AxiosPromise<CallbackRequestResponseDto> {
            return localVarFp.callbackOwnerAdminControllerReassign(requestParameters.organizationId, requestParameters.callbackId, requestParameters.reassignCallbackDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for callbackOwnerAdminControllerCancel operation in CallbackRequestOwnerAdminApi.
 * @export
 * @interface CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerCancelRequest
 */
export interface CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerCancelRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerCancel
     */
    readonly organizationId: string

    /**
     * Identyfikator Callback Request
     * @type {string}
     * @memberof CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerCancel
     */
    readonly callbackId: string

    /**
     *
     * @type {CallbackAggregateVersionDto}
     * @memberof CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerCancel
     */
    readonly callbackAggregateVersionDto: CallbackAggregateVersionDto
}

/**
 * Request parameters for callbackOwnerAdminControllerReassign operation in CallbackRequestOwnerAdminApi.
 * @export
 * @interface CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerReassignRequest
 */
export interface CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerReassignRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerReassign
     */
    readonly organizationId: string

    /**
     * Identyfikator Callback Request
     * @type {string}
     * @memberof CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerReassign
     */
    readonly callbackId: string

    /**
     *
     * @type {ReassignCallbackDto}
     * @memberof CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerReassign
     */
    readonly reassignCallbackDto: ReassignCallbackDto
}

/**
 * CallbackRequestOwnerAdminApi - object-oriented interface
 * @export
 * @class CallbackRequestOwnerAdminApi
 * @extends {BaseAPI}
 */
export class CallbackRequestOwnerAdminApi extends BaseAPI {
    /**
     *
     * @summary Anuluj Callback Request administracyjnie
     * @param {CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerCancelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbackRequestOwnerAdminApi
     */
    public callbackOwnerAdminControllerCancel(requestParameters: CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerCancelRequest, options?: AxiosRequestConfig) {
        return CallbackRequestOwnerAdminApiFp(this.configuration).callbackOwnerAdminControllerCancel(requestParameters.organizationId, requestParameters.callbackId, requestParameters.callbackAggregateVersionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Przypisz Callback Request innemu Handlerowi
     * @param {CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerReassignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbackRequestOwnerAdminApi
     */
    public callbackOwnerAdminControllerReassign(requestParameters: CallbackRequestOwnerAdminApiCallbackOwnerAdminControllerReassignRequest, options?: AxiosRequestConfig) {
        return CallbackRequestOwnerAdminApiFp(this.configuration).callbackOwnerAdminControllerReassign(requestParameters.organizationId, requestParameters.callbackId, requestParameters.reassignCallbackDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CampaignsApi - axios parameter creator
 * @export
 */
export const CampaignsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Activate campaign after payment
         * @param {string} campaignId Campaign ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerActivate: async (campaignId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('campaignControllerActivate', 'campaignId', campaignId)
            const localVarPath = `/api/campaigns/{campaignId}/activate`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Cancel an active or paused campaign
         * @param {string} campaignId Campaign ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerCancel: async (campaignId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('campaignControllerCancel', 'campaignId', campaignId)
            const localVarPath = `/api/campaigns/{campaignId}/cancel`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a new campaign draft
         * @param {string} organizationId Organization ID
         * @param {CreateCampaignDto} createCampaignDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerCreate: async (organizationId: string, createCampaignDto: CreateCampaignDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('campaignControllerCreate', 'organizationId', organizationId)
            // verify required parameter 'createCampaignDto' is not null or undefined
            assertParamExists('campaignControllerCreate', 'createCampaignDto', createCampaignDto)
            const localVarPath = `/api/campaigns/organization/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCampaignDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a draft or cancelled campaign
         * @param {string} campaignId Campaign ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerDelete: async (campaignId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('campaignControllerDelete', 'campaignId', campaignId)
            const localVarPath = `/api/campaigns/{campaignId}`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a campaign by ID
         * @param {string} campaignId Campaign ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerFindById: async (campaignId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('campaignControllerFindById', 'campaignId', campaignId)
            const localVarPath = `/api/campaigns/{campaignId}`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all campaigns for an organization
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerFindByOrganization: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('campaignControllerFindByOrganization', 'organizationId', organizationId)
            const localVarPath = `/api/campaigns/organization/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate keywords using AI
         * @param {string} campaignId Campaign ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerGenerateKeywords: async (campaignId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('campaignControllerGenerateKeywords', 'campaignId', campaignId)
            const localVarPath = `/api/campaigns/{campaignId}/generate-keywords`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate keywords for organization using AI
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerGenerateKeywordsForOrganization: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('campaignControllerGenerateKeywordsForOrganization', 'organizationId', organizationId)
            const localVarPath = `/api/campaigns/organization/{organizationId}/generate-keywords`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Initialize payment for campaign
         * @param {string} campaignId Campaign ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerInitiatePayment: async (campaignId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('campaignControllerInitiatePayment', 'campaignId', campaignId)
            const localVarPath = `/api/campaigns/{campaignId}/pay`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pause an active campaign
         * @param {string} campaignId Campaign ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerPause: async (campaignId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('campaignControllerPause', 'campaignId', campaignId)
            const localVarPath = `/api/campaigns/{campaignId}/pause`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Resume a paused campaign
         * @param {string} campaignId Campaign ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerResume: async (campaignId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('campaignControllerResume', 'campaignId', campaignId)
            const localVarPath = `/api/campaigns/{campaignId}/resume`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update campaign basic info
         * @param {string} campaignId Campaign ID
         * @param {UpdateCampaignDto} updateCampaignDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerUpdate: async (campaignId: string, updateCampaignDto: UpdateCampaignDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('campaignControllerUpdate', 'campaignId', campaignId)
            // verify required parameter 'updateCampaignDto' is not null or undefined
            assertParamExists('campaignControllerUpdate', 'updateCampaignDto', updateCampaignDto)
            const localVarPath = `/api/campaigns/{campaignId}`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCampaignDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update ad final URL for a campaign
         * @param {string} campaignId Campaign ID
         * @param {UpdateAdUrlDto} updateAdUrlDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerUpdateAdUrl: async (campaignId: string, updateAdUrlDto: UpdateAdUrlDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('campaignControllerUpdateAdUrl', 'campaignId', campaignId)
            // verify required parameter 'updateAdUrlDto' is not null or undefined
            assertParamExists('campaignControllerUpdateAdUrl', 'updateAdUrlDto', updateAdUrlDto)
            const localVarPath = `/api/campaigns/{campaignId}/ad-url`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAdUrlDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update campaign budget and schedule
         * @param {string} campaignId Campaign ID
         * @param {UpdateCampaignBudgetDto} updateCampaignBudgetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerUpdateBudget: async (campaignId: string, updateCampaignBudgetDto: UpdateCampaignBudgetDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('campaignControllerUpdateBudget', 'campaignId', campaignId)
            // verify required parameter 'updateCampaignBudgetDto' is not null or undefined
            assertParamExists('campaignControllerUpdateBudget', 'updateCampaignBudgetDto', updateCampaignBudgetDto)
            const localVarPath = `/api/campaigns/{campaignId}/budget`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCampaignBudgetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CampaignsApi - functional programming interface
 * @export
 */
export const CampaignsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CampaignsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Activate campaign after payment
         * @param {string} campaignId Campaign ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerActivate(campaignId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerActivate(campaignId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Cancel an active or paused campaign
         * @param {string} campaignId Campaign ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerCancel(campaignId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerCancel(campaignId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Create a new campaign draft
         * @param {string} organizationId Organization ID
         * @param {CreateCampaignDto} createCampaignDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerCreate(organizationId: string, createCampaignDto: CreateCampaignDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerCreate(organizationId, createCampaignDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a draft or cancelled campaign
         * @param {string} campaignId Campaign ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerDelete(campaignId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerDelete(campaignId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a campaign by ID
         * @param {string} campaignId Campaign ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerFindById(campaignId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerFindById(campaignId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all campaigns for an organization
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerFindByOrganization(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCampaignDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerFindByOrganization(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Generate keywords using AI
         * @param {string} campaignId Campaign ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerGenerateKeywords(campaignId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateKeywordsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerGenerateKeywords(campaignId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Generate keywords for organization using AI
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerGenerateKeywordsForOrganization(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateKeywordsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerGenerateKeywordsForOrganization(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Initialize payment for campaign
         * @param {string} campaignId Campaign ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerInitiatePayment(campaignId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignPaymentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerInitiatePayment(campaignId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pause an active campaign
         * @param {string} campaignId Campaign ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerPause(campaignId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerPause(campaignId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Resume a paused campaign
         * @param {string} campaignId Campaign ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerResume(campaignId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerResume(campaignId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update campaign basic info
         * @param {string} campaignId Campaign ID
         * @param {UpdateCampaignDto} updateCampaignDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerUpdate(campaignId: string, updateCampaignDto: UpdateCampaignDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerUpdate(campaignId, updateCampaignDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update ad final URL for a campaign
         * @param {string} campaignId Campaign ID
         * @param {UpdateAdUrlDto} updateAdUrlDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerUpdateAdUrl(campaignId: string, updateAdUrlDto: UpdateAdUrlDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerUpdateAdUrl(campaignId, updateAdUrlDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update campaign budget and schedule
         * @param {string} campaignId Campaign ID
         * @param {UpdateCampaignBudgetDto} updateCampaignBudgetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerUpdateBudget(campaignId: string, updateCampaignBudgetDto: UpdateCampaignBudgetDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerUpdateBudget(campaignId, updateCampaignBudgetDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CampaignsApi - factory interface
 * @export
 */
export const CampaignsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CampaignsApiFp(configuration)
    return {
        /**
         *
         * @summary Activate campaign after payment
         * @param {CampaignsApiCampaignControllerActivateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerActivate(requestParameters: CampaignsApiCampaignControllerActivateRequest, options?: AxiosRequestConfig): AxiosPromise<GetCampaignDto> {
            return localVarFp.campaignControllerActivate(requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cancel an active or paused campaign
         * @param {CampaignsApiCampaignControllerCancelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerCancel(requestParameters: CampaignsApiCampaignControllerCancelRequest, options?: AxiosRequestConfig): AxiosPromise<GetCampaignDto> {
            return localVarFp.campaignControllerCancel(requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new campaign draft
         * @param {CampaignsApiCampaignControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerCreate(requestParameters: CampaignsApiCampaignControllerCreateRequest, options?: AxiosRequestConfig): AxiosPromise<GetCampaignDto> {
            return localVarFp.campaignControllerCreate(requestParameters.organizationId, requestParameters.createCampaignDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a draft or cancelled campaign
         * @param {CampaignsApiCampaignControllerDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerDelete(requestParameters: CampaignsApiCampaignControllerDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.campaignControllerDelete(requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a campaign by ID
         * @param {CampaignsApiCampaignControllerFindByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerFindById(requestParameters: CampaignsApiCampaignControllerFindByIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetCampaignDto> {
            return localVarFp.campaignControllerFindById(requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all campaigns for an organization
         * @param {CampaignsApiCampaignControllerFindByOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerFindByOrganization(requestParameters: CampaignsApiCampaignControllerFindByOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetCampaignDto>> {
            return localVarFp.campaignControllerFindByOrganization(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Generate keywords using AI
         * @param {CampaignsApiCampaignControllerGenerateKeywordsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerGenerateKeywords(requestParameters: CampaignsApiCampaignControllerGenerateKeywordsRequest, options?: AxiosRequestConfig): AxiosPromise<GenerateKeywordsResponseDto> {
            return localVarFp.campaignControllerGenerateKeywords(requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Generate keywords for organization using AI
         * @param {CampaignsApiCampaignControllerGenerateKeywordsForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerGenerateKeywordsForOrganization(requestParameters: CampaignsApiCampaignControllerGenerateKeywordsForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<GenerateKeywordsResponseDto> {
            return localVarFp.campaignControllerGenerateKeywordsForOrganization(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Initialize payment for campaign
         * @param {CampaignsApiCampaignControllerInitiatePaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerInitiatePayment(requestParameters: CampaignsApiCampaignControllerInitiatePaymentRequest, options?: AxiosRequestConfig): AxiosPromise<CampaignPaymentResponseDto> {
            return localVarFp.campaignControllerInitiatePayment(requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pause an active campaign
         * @param {CampaignsApiCampaignControllerPauseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerPause(requestParameters: CampaignsApiCampaignControllerPauseRequest, options?: AxiosRequestConfig): AxiosPromise<GetCampaignDto> {
            return localVarFp.campaignControllerPause(requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Resume a paused campaign
         * @param {CampaignsApiCampaignControllerResumeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerResume(requestParameters: CampaignsApiCampaignControllerResumeRequest, options?: AxiosRequestConfig): AxiosPromise<GetCampaignDto> {
            return localVarFp.campaignControllerResume(requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update campaign basic info
         * @param {CampaignsApiCampaignControllerUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerUpdate(requestParameters: CampaignsApiCampaignControllerUpdateRequest, options?: AxiosRequestConfig): AxiosPromise<GetCampaignDto> {
            return localVarFp.campaignControllerUpdate(requestParameters.campaignId, requestParameters.updateCampaignDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update ad final URL for a campaign
         * @param {CampaignsApiCampaignControllerUpdateAdUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerUpdateAdUrl(requestParameters: CampaignsApiCampaignControllerUpdateAdUrlRequest, options?: AxiosRequestConfig): AxiosPromise<GetCampaignDto> {
            return localVarFp.campaignControllerUpdateAdUrl(requestParameters.campaignId, requestParameters.updateAdUrlDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update campaign budget and schedule
         * @param {CampaignsApiCampaignControllerUpdateBudgetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerUpdateBudget(requestParameters: CampaignsApiCampaignControllerUpdateBudgetRequest, options?: AxiosRequestConfig): AxiosPromise<GetCampaignDto> {
            return localVarFp.campaignControllerUpdateBudget(requestParameters.campaignId, requestParameters.updateCampaignBudgetDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for campaignControllerActivate operation in CampaignsApi.
 * @export
 * @interface CampaignsApiCampaignControllerActivateRequest
 */
export interface CampaignsApiCampaignControllerActivateRequest {
    /**
     * Campaign ID
     * @type {string}
     * @memberof CampaignsApiCampaignControllerActivate
     */
    readonly campaignId: string
}

/**
 * Request parameters for campaignControllerCancel operation in CampaignsApi.
 * @export
 * @interface CampaignsApiCampaignControllerCancelRequest
 */
export interface CampaignsApiCampaignControllerCancelRequest {
    /**
     * Campaign ID
     * @type {string}
     * @memberof CampaignsApiCampaignControllerCancel
     */
    readonly campaignId: string
}

/**
 * Request parameters for campaignControllerCreate operation in CampaignsApi.
 * @export
 * @interface CampaignsApiCampaignControllerCreateRequest
 */
export interface CampaignsApiCampaignControllerCreateRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof CampaignsApiCampaignControllerCreate
     */
    readonly organizationId: string

    /**
     *
     * @type {CreateCampaignDto}
     * @memberof CampaignsApiCampaignControllerCreate
     */
    readonly createCampaignDto: CreateCampaignDto
}

/**
 * Request parameters for campaignControllerDelete operation in CampaignsApi.
 * @export
 * @interface CampaignsApiCampaignControllerDeleteRequest
 */
export interface CampaignsApiCampaignControllerDeleteRequest {
    /**
     * Campaign ID
     * @type {string}
     * @memberof CampaignsApiCampaignControllerDelete
     */
    readonly campaignId: string
}

/**
 * Request parameters for campaignControllerFindById operation in CampaignsApi.
 * @export
 * @interface CampaignsApiCampaignControllerFindByIdRequest
 */
export interface CampaignsApiCampaignControllerFindByIdRequest {
    /**
     * Campaign ID
     * @type {string}
     * @memberof CampaignsApiCampaignControllerFindById
     */
    readonly campaignId: string
}

/**
 * Request parameters for campaignControllerFindByOrganization operation in CampaignsApi.
 * @export
 * @interface CampaignsApiCampaignControllerFindByOrganizationRequest
 */
export interface CampaignsApiCampaignControllerFindByOrganizationRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof CampaignsApiCampaignControllerFindByOrganization
     */
    readonly organizationId: string
}

/**
 * Request parameters for campaignControllerGenerateKeywords operation in CampaignsApi.
 * @export
 * @interface CampaignsApiCampaignControllerGenerateKeywordsRequest
 */
export interface CampaignsApiCampaignControllerGenerateKeywordsRequest {
    /**
     * Campaign ID
     * @type {string}
     * @memberof CampaignsApiCampaignControllerGenerateKeywords
     */
    readonly campaignId: string
}

/**
 * Request parameters for campaignControllerGenerateKeywordsForOrganization operation in CampaignsApi.
 * @export
 * @interface CampaignsApiCampaignControllerGenerateKeywordsForOrganizationRequest
 */
export interface CampaignsApiCampaignControllerGenerateKeywordsForOrganizationRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof CampaignsApiCampaignControllerGenerateKeywordsForOrganization
     */
    readonly organizationId: string
}

/**
 * Request parameters for campaignControllerInitiatePayment operation in CampaignsApi.
 * @export
 * @interface CampaignsApiCampaignControllerInitiatePaymentRequest
 */
export interface CampaignsApiCampaignControllerInitiatePaymentRequest {
    /**
     * Campaign ID
     * @type {string}
     * @memberof CampaignsApiCampaignControllerInitiatePayment
     */
    readonly campaignId: string
}

/**
 * Request parameters for campaignControllerPause operation in CampaignsApi.
 * @export
 * @interface CampaignsApiCampaignControllerPauseRequest
 */
export interface CampaignsApiCampaignControllerPauseRequest {
    /**
     * Campaign ID
     * @type {string}
     * @memberof CampaignsApiCampaignControllerPause
     */
    readonly campaignId: string
}

/**
 * Request parameters for campaignControllerResume operation in CampaignsApi.
 * @export
 * @interface CampaignsApiCampaignControllerResumeRequest
 */
export interface CampaignsApiCampaignControllerResumeRequest {
    /**
     * Campaign ID
     * @type {string}
     * @memberof CampaignsApiCampaignControllerResume
     */
    readonly campaignId: string
}

/**
 * Request parameters for campaignControllerUpdate operation in CampaignsApi.
 * @export
 * @interface CampaignsApiCampaignControllerUpdateRequest
 */
export interface CampaignsApiCampaignControllerUpdateRequest {
    /**
     * Campaign ID
     * @type {string}
     * @memberof CampaignsApiCampaignControllerUpdate
     */
    readonly campaignId: string

    /**
     *
     * @type {UpdateCampaignDto}
     * @memberof CampaignsApiCampaignControllerUpdate
     */
    readonly updateCampaignDto: UpdateCampaignDto
}

/**
 * Request parameters for campaignControllerUpdateAdUrl operation in CampaignsApi.
 * @export
 * @interface CampaignsApiCampaignControllerUpdateAdUrlRequest
 */
export interface CampaignsApiCampaignControllerUpdateAdUrlRequest {
    /**
     * Campaign ID
     * @type {string}
     * @memberof CampaignsApiCampaignControllerUpdateAdUrl
     */
    readonly campaignId: string

    /**
     *
     * @type {UpdateAdUrlDto}
     * @memberof CampaignsApiCampaignControllerUpdateAdUrl
     */
    readonly updateAdUrlDto: UpdateAdUrlDto
}

/**
 * Request parameters for campaignControllerUpdateBudget operation in CampaignsApi.
 * @export
 * @interface CampaignsApiCampaignControllerUpdateBudgetRequest
 */
export interface CampaignsApiCampaignControllerUpdateBudgetRequest {
    /**
     * Campaign ID
     * @type {string}
     * @memberof CampaignsApiCampaignControllerUpdateBudget
     */
    readonly campaignId: string

    /**
     *
     * @type {UpdateCampaignBudgetDto}
     * @memberof CampaignsApiCampaignControllerUpdateBudget
     */
    readonly updateCampaignBudgetDto: UpdateCampaignBudgetDto
}

/**
 * CampaignsApi - object-oriented interface
 * @export
 * @class CampaignsApi
 * @extends {BaseAPI}
 */
export class CampaignsApi extends BaseAPI {
    /**
     *
     * @summary Activate campaign after payment
     * @param {CampaignsApiCampaignControllerActivateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignControllerActivate(requestParameters: CampaignsApiCampaignControllerActivateRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignControllerActivate(requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Cancel an active or paused campaign
     * @param {CampaignsApiCampaignControllerCancelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignControllerCancel(requestParameters: CampaignsApiCampaignControllerCancelRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignControllerCancel(requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create a new campaign draft
     * @param {CampaignsApiCampaignControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignControllerCreate(requestParameters: CampaignsApiCampaignControllerCreateRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignControllerCreate(requestParameters.organizationId, requestParameters.createCampaignDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete a draft or cancelled campaign
     * @param {CampaignsApiCampaignControllerDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignControllerDelete(requestParameters: CampaignsApiCampaignControllerDeleteRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignControllerDelete(requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get a campaign by ID
     * @param {CampaignsApiCampaignControllerFindByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignControllerFindById(requestParameters: CampaignsApiCampaignControllerFindByIdRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignControllerFindById(requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all campaigns for an organization
     * @param {CampaignsApiCampaignControllerFindByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignControllerFindByOrganization(requestParameters: CampaignsApiCampaignControllerFindByOrganizationRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignControllerFindByOrganization(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Generate keywords using AI
     * @param {CampaignsApiCampaignControllerGenerateKeywordsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignControllerGenerateKeywords(requestParameters: CampaignsApiCampaignControllerGenerateKeywordsRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignControllerGenerateKeywords(requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Generate keywords for organization using AI
     * @param {CampaignsApiCampaignControllerGenerateKeywordsForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignControllerGenerateKeywordsForOrganization(requestParameters: CampaignsApiCampaignControllerGenerateKeywordsForOrganizationRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignControllerGenerateKeywordsForOrganization(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Initialize payment for campaign
     * @param {CampaignsApiCampaignControllerInitiatePaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignControllerInitiatePayment(requestParameters: CampaignsApiCampaignControllerInitiatePaymentRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignControllerInitiatePayment(requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pause an active campaign
     * @param {CampaignsApiCampaignControllerPauseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignControllerPause(requestParameters: CampaignsApiCampaignControllerPauseRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignControllerPause(requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Resume a paused campaign
     * @param {CampaignsApiCampaignControllerResumeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignControllerResume(requestParameters: CampaignsApiCampaignControllerResumeRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignControllerResume(requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update campaign basic info
     * @param {CampaignsApiCampaignControllerUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignControllerUpdate(requestParameters: CampaignsApiCampaignControllerUpdateRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignControllerUpdate(requestParameters.campaignId, requestParameters.updateCampaignDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update ad final URL for a campaign
     * @param {CampaignsApiCampaignControllerUpdateAdUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignControllerUpdateAdUrl(requestParameters: CampaignsApiCampaignControllerUpdateAdUrlRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignControllerUpdateAdUrl(requestParameters.campaignId, requestParameters.updateAdUrlDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update campaign budget and schedule
     * @param {CampaignsApiCampaignControllerUpdateBudgetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignControllerUpdateBudget(requestParameters: CampaignsApiCampaignControllerUpdateBudgetRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignControllerUpdateBudget(requestParameters.campaignId, requestParameters.updateCampaignBudgetDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConversationApi - axios parameter creator
 * @export
 */
export const ConversationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Cancel a pending conversation. Professional only.
         * @param {ConversationCancelDto} conversationCancelDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerCancel: async (conversationCancelDto: ConversationCancelDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationCancelDto' is not null or undefined
            assertParamExists('conversationControllerCancel', 'conversationCancelDto', conversationCancelDto)
            const localVarPath = `/api/conversation/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationCancelDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Complete a pending conversation. Professional only.
         * @param {ConversationCompleteDto} conversationCompleteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerEnd: async (conversationCompleteDto: ConversationCompleteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationCompleteDto' is not null or undefined
            assertParamExists('conversationControllerEnd', 'conversationCompleteDto', conversationCompleteDto)
            const localVarPath = `/api/conversation/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationCompleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all conversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerGetAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/conversation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get messages from chat conversation
         * @param {string} conversationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerGetChatMessages: async (conversationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('conversationControllerGetChatMessages', 'conversationId', conversationId)
            const localVarPath = `/api/conversation/chat/messages/{conversationId}`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get chat access token for conversation
         * @param {ChatTokenRequest} chatTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerGetChatToken: async (chatTokenRequest: ChatTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatTokenRequest' is not null or undefined
            assertParamExists('conversationControllerGetChatToken', 'chatTokenRequest', chatTokenRequest)
            const localVarPath = `/api/conversation/chat/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get conversation by id
         * @param {string} conversationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerGetConversationById: async (conversationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('conversationControllerGetConversationById', 'conversationId', conversationId)
            const localVarPath = `/api/conversation/{conversationId}`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Join started conversation
         * @param {ConversationJointDto} conversationJointDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerJoin: async (conversationJointDto: ConversationJointDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationJointDto' is not null or undefined
            assertParamExists('conversationControllerJoin', 'conversationJointDto', conversationJointDto)
            const localVarPath = `/api/conversation/join`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationJointDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Send message to chat conversation
         * @param {SendChatMessageRequest} sendChatMessageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerSendChatMessage: async (sendChatMessageRequest: SendChatMessageRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendChatMessageRequest' is not null or undefined
            assertParamExists('conversationControllerSendChatMessage', 'sendChatMessageRequest', sendChatMessageRequest)
            const localVarPath = `/api/conversation/chat/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendChatMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Start created conversation. Professional only.
         * @param {ConversationStartDto} conversationStartDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerStart: async (conversationStartDto: ConversationStartDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationStartDto' is not null or undefined
            assertParamExists('conversationControllerStart', 'conversationStartDto', conversationStartDto)
            const localVarPath = `/api/conversation/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationStartDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConversationApi - functional programming interface
 * @export
 */
export const ConversationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConversationApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Cancel a pending conversation. Professional only.
         * @param {ConversationCancelDto} conversationCancelDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async conversationControllerCancel(conversationCancelDto: ConversationCancelDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.conversationControllerCancel(conversationCancelDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Complete a pending conversation. Professional only.
         * @param {ConversationCompleteDto} conversationCompleteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async conversationControllerEnd(conversationCompleteDto: ConversationCompleteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.conversationControllerEnd(conversationCompleteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all conversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async conversationControllerGetAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.conversationControllerGetAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get messages from chat conversation
         * @param {string} conversationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async conversationControllerGetChatMessages(conversationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.conversationControllerGetChatMessages(conversationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get chat access token for conversation
         * @param {ChatTokenRequest} chatTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async conversationControllerGetChatToken(chatTokenRequest: ChatTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.conversationControllerGetChatToken(chatTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get conversation by id
         * @param {string} conversationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async conversationControllerGetConversationById(conversationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.conversationControllerGetConversationById(conversationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Join started conversation
         * @param {ConversationJointDto} conversationJointDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async conversationControllerJoin(conversationJointDto: ConversationJointDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.conversationControllerJoin(conversationJointDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Send message to chat conversation
         * @param {SendChatMessageRequest} sendChatMessageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async conversationControllerSendChatMessage(sendChatMessageRequest: SendChatMessageRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendChatMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.conversationControllerSendChatMessage(sendChatMessageRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Start created conversation. Professional only.
         * @param {ConversationStartDto} conversationStartDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async conversationControllerStart(conversationStartDto: ConversationStartDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.conversationControllerStart(conversationStartDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConversationApi - factory interface
 * @export
 */
export const ConversationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConversationApiFp(configuration)
    return {
        /**
         *
         * @summary Cancel a pending conversation. Professional only.
         * @param {ConversationApiConversationControllerCancelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerCancel(requestParameters: ConversationApiConversationControllerCancelRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.conversationControllerCancel(requestParameters.conversationCancelDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Complete a pending conversation. Professional only.
         * @param {ConversationApiConversationControllerEndRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerEnd(requestParameters: ConversationApiConversationControllerEndRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.conversationControllerEnd(requestParameters.conversationCompleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all conversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerGetAll(options?: AxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.conversationControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get messages from chat conversation
         * @param {ConversationApiConversationControllerGetChatMessagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerGetChatMessages(requestParameters: ConversationApiConversationControllerGetChatMessagesRequest, options?: AxiosRequestConfig): AxiosPromise<ChatMessagesResponse> {
            return localVarFp.conversationControllerGetChatMessages(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get chat access token for conversation
         * @param {ConversationApiConversationControllerGetChatTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerGetChatToken(requestParameters: ConversationApiConversationControllerGetChatTokenRequest, options?: AxiosRequestConfig): AxiosPromise<ChatTokenResponse> {
            return localVarFp.conversationControllerGetChatToken(requestParameters.chatTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get conversation by id
         * @param {ConversationApiConversationControllerGetConversationByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerGetConversationById(requestParameters: ConversationApiConversationControllerGetConversationByIdRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.conversationControllerGetConversationById(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Join started conversation
         * @param {ConversationApiConversationControllerJoinRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerJoin(requestParameters: ConversationApiConversationControllerJoinRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.conversationControllerJoin(requestParameters.conversationJointDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Send message to chat conversation
         * @param {ConversationApiConversationControllerSendChatMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerSendChatMessage(requestParameters: ConversationApiConversationControllerSendChatMessageRequest, options?: AxiosRequestConfig): AxiosPromise<SendChatMessageResponse> {
            return localVarFp.conversationControllerSendChatMessage(requestParameters.sendChatMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Start created conversation. Professional only.
         * @param {ConversationApiConversationControllerStartRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationControllerStart(requestParameters: ConversationApiConversationControllerStartRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.conversationControllerStart(requestParameters.conversationStartDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for conversationControllerCancel operation in ConversationApi.
 * @export
 * @interface ConversationApiConversationControllerCancelRequest
 */
export interface ConversationApiConversationControllerCancelRequest {
    /**
     *
     * @type {ConversationCancelDto}
     * @memberof ConversationApiConversationControllerCancel
     */
    readonly conversationCancelDto: ConversationCancelDto
}

/**
 * Request parameters for conversationControllerEnd operation in ConversationApi.
 * @export
 * @interface ConversationApiConversationControllerEndRequest
 */
export interface ConversationApiConversationControllerEndRequest {
    /**
     *
     * @type {ConversationCompleteDto}
     * @memberof ConversationApiConversationControllerEnd
     */
    readonly conversationCompleteDto: ConversationCompleteDto
}

/**
 * Request parameters for conversationControllerGetChatMessages operation in ConversationApi.
 * @export
 * @interface ConversationApiConversationControllerGetChatMessagesRequest
 */
export interface ConversationApiConversationControllerGetChatMessagesRequest {
    /**
     *
     * @type {string}
     * @memberof ConversationApiConversationControllerGetChatMessages
     */
    readonly conversationId: string
}

/**
 * Request parameters for conversationControllerGetChatToken operation in ConversationApi.
 * @export
 * @interface ConversationApiConversationControllerGetChatTokenRequest
 */
export interface ConversationApiConversationControllerGetChatTokenRequest {
    /**
     *
     * @type {ChatTokenRequest}
     * @memberof ConversationApiConversationControllerGetChatToken
     */
    readonly chatTokenRequest: ChatTokenRequest
}

/**
 * Request parameters for conversationControllerGetConversationById operation in ConversationApi.
 * @export
 * @interface ConversationApiConversationControllerGetConversationByIdRequest
 */
export interface ConversationApiConversationControllerGetConversationByIdRequest {
    /**
     *
     * @type {string}
     * @memberof ConversationApiConversationControllerGetConversationById
     */
    readonly conversationId: string
}

/**
 * Request parameters for conversationControllerJoin operation in ConversationApi.
 * @export
 * @interface ConversationApiConversationControllerJoinRequest
 */
export interface ConversationApiConversationControllerJoinRequest {
    /**
     *
     * @type {ConversationJointDto}
     * @memberof ConversationApiConversationControllerJoin
     */
    readonly conversationJointDto: ConversationJointDto
}

/**
 * Request parameters for conversationControllerSendChatMessage operation in ConversationApi.
 * @export
 * @interface ConversationApiConversationControllerSendChatMessageRequest
 */
export interface ConversationApiConversationControllerSendChatMessageRequest {
    /**
     *
     * @type {SendChatMessageRequest}
     * @memberof ConversationApiConversationControllerSendChatMessage
     */
    readonly sendChatMessageRequest: SendChatMessageRequest
}

/**
 * Request parameters for conversationControllerStart operation in ConversationApi.
 * @export
 * @interface ConversationApiConversationControllerStartRequest
 */
export interface ConversationApiConversationControllerStartRequest {
    /**
     *
     * @type {ConversationStartDto}
     * @memberof ConversationApiConversationControllerStart
     */
    readonly conversationStartDto: ConversationStartDto
}

/**
 * ConversationApi - object-oriented interface
 * @export
 * @class ConversationApi
 * @extends {BaseAPI}
 */
export class ConversationApi extends BaseAPI {
    /**
     *
     * @summary Cancel a pending conversation. Professional only.
     * @param {ConversationApiConversationControllerCancelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public conversationControllerCancel(requestParameters: ConversationApiConversationControllerCancelRequest, options?: AxiosRequestConfig) {
        return ConversationApiFp(this.configuration).conversationControllerCancel(requestParameters.conversationCancelDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Complete a pending conversation. Professional only.
     * @param {ConversationApiConversationControllerEndRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public conversationControllerEnd(requestParameters: ConversationApiConversationControllerEndRequest, options?: AxiosRequestConfig) {
        return ConversationApiFp(this.configuration).conversationControllerEnd(requestParameters.conversationCompleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all conversations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public conversationControllerGetAll(options?: AxiosRequestConfig) {
        return ConversationApiFp(this.configuration).conversationControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get messages from chat conversation
     * @param {ConversationApiConversationControllerGetChatMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public conversationControllerGetChatMessages(requestParameters: ConversationApiConversationControllerGetChatMessagesRequest, options?: AxiosRequestConfig) {
        return ConversationApiFp(this.configuration).conversationControllerGetChatMessages(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get chat access token for conversation
     * @param {ConversationApiConversationControllerGetChatTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public conversationControllerGetChatToken(requestParameters: ConversationApiConversationControllerGetChatTokenRequest, options?: AxiosRequestConfig) {
        return ConversationApiFp(this.configuration).conversationControllerGetChatToken(requestParameters.chatTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get conversation by id
     * @param {ConversationApiConversationControllerGetConversationByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public conversationControllerGetConversationById(requestParameters: ConversationApiConversationControllerGetConversationByIdRequest, options?: AxiosRequestConfig) {
        return ConversationApiFp(this.configuration).conversationControllerGetConversationById(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Join started conversation
     * @param {ConversationApiConversationControllerJoinRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public conversationControllerJoin(requestParameters: ConversationApiConversationControllerJoinRequest, options?: AxiosRequestConfig) {
        return ConversationApiFp(this.configuration).conversationControllerJoin(requestParameters.conversationJointDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Send message to chat conversation
     * @param {ConversationApiConversationControllerSendChatMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public conversationControllerSendChatMessage(requestParameters: ConversationApiConversationControllerSendChatMessageRequest, options?: AxiosRequestConfig) {
        return ConversationApiFp(this.configuration).conversationControllerSendChatMessage(requestParameters.sendChatMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Start created conversation. Professional only.
     * @param {ConversationApiConversationControllerStartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public conversationControllerStart(requestParameters: ConversationApiConversationControllerStartRequest, options?: AxiosRequestConfig) {
        return ConversationApiFp(this.configuration).conversationControllerStart(requestParameters.conversationStartDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CouponsApi - axios parameter creator
 * @export
 */
export const CouponsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get all valid coupons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponsControllerGetAllCoupons: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/coupons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouponsApi - functional programming interface
 * @export
 */
export const CouponsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouponsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get all valid coupons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async couponsControllerGetAllCoupons(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCouponsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.couponsControllerGetAllCoupons(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CouponsApi - factory interface
 * @export
 */
export const CouponsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouponsApiFp(configuration)
    return {
        /**
         *
         * @summary Get all valid coupons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponsControllerGetAllCoupons(options?: AxiosRequestConfig): AxiosPromise<Array<GetCouponsDto>> {
            return localVarFp.couponsControllerGetAllCoupons(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CouponsApi - object-oriented interface
 * @export
 * @class CouponsApi
 * @extends {BaseAPI}
 */
export class CouponsApi extends BaseAPI {
    /**
     *
     * @summary Get all valid coupons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public couponsControllerGetAllCoupons(options?: AxiosRequestConfig) {
        return CouponsApiFp(this.configuration).couponsControllerGetAllCoupons(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productionCandidateHealthControllerHealth: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/internal/production-candidate/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productionCandidateHealthControllerHealth(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productionCandidateHealthControllerHealth(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productionCandidateHealthControllerHealth(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productionCandidateHealthControllerHealth(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public productionCandidateHealthControllerHealth(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).productionCandidateHealthControllerHealth(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DictationApi - axios parameter creator
 * @export
 */
export const DictationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create a voice dictation session for note editing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictationControllerCreateSession: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dictation/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DictationApi - functional programming interface
 * @export
 */
export const DictationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DictationApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create a voice dictation session for note editing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictationControllerCreateSession(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartDictationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictationControllerCreateSession(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DictationApi - factory interface
 * @export
 */
export const DictationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DictationApiFp(configuration)
    return {
        /**
         *
         * @summary Create a voice dictation session for note editing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictationControllerCreateSession(options?: AxiosRequestConfig): AxiosPromise<StartDictationResponseDto> {
            return localVarFp.dictationControllerCreateSession(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DictationApi - object-oriented interface
 * @export
 * @class DictationApi
 * @extends {BaseAPI}
 */
export class DictationApi extends BaseAPI {
    /**
     *
     * @summary Create a voice dictation session for note editing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictationApi
     */
    public dictationControllerCreateSession(options?: AxiosRequestConfig) {
        return DictationApiFp(this.configuration).dictationControllerCreateSession(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Add documents to user profile
         * @param {string} profileId
         * @param {Array<DocumentFileDto>} documentFileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerAddProfileDocuments: async (profileId: string, documentFileDto: Array<DocumentFileDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('documentControllerAddProfileDocuments', 'profileId', profileId)
            // verify required parameter 'documentFileDto' is not null or undefined
            assertParamExists('documentControllerAddProfileDocuments', 'documentFileDto', documentFileDto)
            const localVarPath = `/api/profile/{profileId}/documents`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Add documents to profile within organization context
         * @param {string} profileId
         * @param {Array<DocumentFileDto>} documentFileDto
         * @param {string} [visitId] Optional visit ID to track document additions as visit activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerAddProfileDocumentsInOrganization: async (profileId: string, documentFileDto: Array<DocumentFileDto>, visitId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('documentControllerAddProfileDocumentsInOrganization', 'profileId', profileId)
            // verify required parameter 'documentFileDto' is not null or undefined
            assertParamExists('documentControllerAddProfileDocumentsInOrganization', 'documentFileDto', documentFileDto)
            const localVarPath = `/api/organization-profile/profile/{profileId}/documents`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (visitId !== undefined) {
                localVarQueryParameter['visitId'] = visitId;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a text note on the owner\'s own profile
         * @param {string} profileId
         * @param {CreateTextNoteDto} createTextNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerCreateProfileTextNoteForOwner: async (profileId: string, createTextNoteDto: CreateTextNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('documentControllerCreateProfileTextNoteForOwner', 'profileId', profileId)
            // verify required parameter 'createTextNoteDto' is not null or undefined
            assertParamExists('documentControllerCreateProfileTextNoteForOwner', 'createTextNoteDto', createTextNoteDto)
            const localVarPath = `/api/profile/{profileId}/text-notes`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTextNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a text note for a profile within organization context
         * @param {string} profileId
         * @param {CreateTextNoteDto} createTextNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerCreateProfileTextNoteInOrganization: async (profileId: string, createTextNoteDto: CreateTextNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('documentControllerCreateProfileTextNoteInOrganization', 'profileId', profileId)
            // verify required parameter 'createTextNoteDto' is not null or undefined
            assertParamExists('documentControllerCreateProfileTextNoteInOrganization', 'createTextNoteDto', createTextNoteDto)
            const localVarPath = `/api/organization-profile/profile/{profileId}/text-notes`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTextNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete document from user profile
         * @param {string} profileId
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerDeleteProfileDocument: async (profileId: string, filename: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('documentControllerDeleteProfileDocument', 'profileId', profileId)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('documentControllerDeleteProfileDocument', 'filename', filename)
            const localVarPath = `/api/profile/{profileId}/documents/{filename}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Professionals and org admins can only delete documents uploaded via visits that took place in their organization
         * @summary Delete a profile document within organization context
         * @param {string} profileId
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerDeleteProfileDocumentInOrganization: async (profileId: string, filename: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('documentControllerDeleteProfileDocumentInOrganization', 'profileId', profileId)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('documentControllerDeleteProfileDocumentInOrganization', 'filename', filename)
            const localVarPath = `/api/organization-profile/profile/{profileId}/documents/{filename}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a signed URL for a Document file (org-gated)
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerGetDocumentSignedUrl: async (documentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('documentControllerGetDocumentSignedUrl', 'documentId', documentId)
            const localVarPath = `/api/document/{documentId}/signed-url`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get user profile documents
         * @param {string} profileId
         * @param {number} [page] Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
         * @param {number} [limit] Rows per page. Omit together with &#x60;page&#x60; to get every row.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerGetProfileDocuments: async (profileId: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('documentControllerGetProfileDocuments', 'profileId', profileId)
            const localVarPath = `/api/profile/{profileId}/documents`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get profile documents within organization context
         * @param {string} profileId
         * @param {number} [page] Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
         * @param {number} [limit] Rows per page. Omit together with &#x60;page&#x60; to get every row.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerGetProfileDocumentsInOrganization: async (profileId: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('documentControllerGetProfileDocumentsInOrganization', 'profileId', profileId)
            const localVarPath = `/api/organization-profile/profile/{profileId}/documents`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get user profile documents. Professional only.
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerGetProfileDocumentsPreview: async (profileId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('documentControllerGetProfileDocumentsPreview', 'profileId', profileId)
            const localVarPath = `/api/profile/{profileId}/documents/preview`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a text note on the owner\'s own profile
         * @param {string} profileId
         * @param {string} filename
         * @param {UpdateTextNoteDto} updateTextNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerUpdateProfileTextNoteForOwner: async (profileId: string, filename: string, updateTextNoteDto: UpdateTextNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('documentControllerUpdateProfileTextNoteForOwner', 'profileId', profileId)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('documentControllerUpdateProfileTextNoteForOwner', 'filename', filename)
            // verify required parameter 'updateTextNoteDto' is not null or undefined
            assertParamExists('documentControllerUpdateProfileTextNoteForOwner', 'updateTextNoteDto', updateTextNoteDto)
            const localVarPath = `/api/profile/{profileId}/text-notes/{filename}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTextNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a text note for a profile within organization context
         * @param {string} profileId
         * @param {string} filename
         * @param {UpdateTextNoteDto} updateTextNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerUpdateProfileTextNoteInOrganization: async (profileId: string, filename: string, updateTextNoteDto: UpdateTextNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('documentControllerUpdateProfileTextNoteInOrganization', 'profileId', profileId)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('documentControllerUpdateProfileTextNoteInOrganization', 'filename', filename)
            // verify required parameter 'updateTextNoteDto' is not null or undefined
            assertParamExists('documentControllerUpdateProfileTextNoteInOrganization', 'updateTextNoteDto', updateTextNoteDto)
            const localVarPath = `/api/organization-profile/profile/{profileId}/text-notes/{filename}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTextNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Add documents to user profile
         * @param {string} profileId
         * @param {Array<DocumentFileDto>} documentFileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentControllerAddProfileDocuments(profileId: string, documentFileDto: Array<DocumentFileDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentFileResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentControllerAddProfileDocuments(profileId, documentFileDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Add documents to profile within organization context
         * @param {string} profileId
         * @param {Array<DocumentFileDto>} documentFileDto
         * @param {string} [visitId] Optional visit ID to track document additions as visit activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentControllerAddProfileDocumentsInOrganization(profileId: string, documentFileDto: Array<DocumentFileDto>, visitId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentFileResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentControllerAddProfileDocumentsInOrganization(profileId, documentFileDto, visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Create a text note on the owner\'s own profile
         * @param {string} profileId
         * @param {CreateTextNoteDto} createTextNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentControllerCreateProfileTextNoteForOwner(profileId: string, createTextNoteDto: CreateTextNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentFileResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentControllerCreateProfileTextNoteForOwner(profileId, createTextNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Create a text note for a profile within organization context
         * @param {string} profileId
         * @param {CreateTextNoteDto} createTextNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentControllerCreateProfileTextNoteInOrganization(profileId: string, createTextNoteDto: CreateTextNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentFileResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentControllerCreateProfileTextNoteInOrganization(profileId, createTextNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete document from user profile
         * @param {string} profileId
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentControllerDeleteProfileDocument(profileId: string, filename: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentFileResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentControllerDeleteProfileDocument(profileId, filename, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Professionals and org admins can only delete documents uploaded via visits that took place in their organization
         * @summary Delete a profile document within organization context
         * @param {string} profileId
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentControllerDeleteProfileDocumentInOrganization(profileId: string, filename: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentFileResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentControllerDeleteProfileDocumentInOrganization(profileId, filename, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a signed URL for a Document file (org-gated)
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentControllerGetDocumentSignedUrl(documentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisitControllerGetVisitFileSignedUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentControllerGetDocumentSignedUrl(documentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get user profile documents
         * @param {string} profileId
         * @param {number} [page] Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
         * @param {number} [limit] Rows per page. Omit together with &#x60;page&#x60; to get every row.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentControllerGetProfileDocuments(profileId: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedDocumentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentControllerGetProfileDocuments(profileId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get profile documents within organization context
         * @param {string} profileId
         * @param {number} [page] Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
         * @param {number} [limit] Rows per page. Omit together with &#x60;page&#x60; to get every row.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentControllerGetProfileDocumentsInOrganization(profileId: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedDocumentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentControllerGetProfileDocumentsInOrganization(profileId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get user profile documents. Professional only.
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentControllerGetProfileDocumentsPreview(profileId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentFileResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentControllerGetProfileDocumentsPreview(profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update a text note on the owner\'s own profile
         * @param {string} profileId
         * @param {string} filename
         * @param {UpdateTextNoteDto} updateTextNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentControllerUpdateProfileTextNoteForOwner(profileId: string, filename: string, updateTextNoteDto: UpdateTextNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentFileResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentControllerUpdateProfileTextNoteForOwner(profileId, filename, updateTextNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update a text note for a profile within organization context
         * @param {string} profileId
         * @param {string} filename
         * @param {UpdateTextNoteDto} updateTextNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentControllerUpdateProfileTextNoteInOrganization(profileId: string, filename: string, updateTextNoteDto: UpdateTextNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentFileResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentControllerUpdateProfileTextNoteInOrganization(profileId, filename, updateTextNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentApiFp(configuration)
    return {
        /**
         *
         * @summary Add documents to user profile
         * @param {DocumentApiDocumentControllerAddProfileDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerAddProfileDocuments(requestParameters: DocumentApiDocumentControllerAddProfileDocumentsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<DocumentFileResponseDto>> {
            return localVarFp.documentControllerAddProfileDocuments(requestParameters.profileId, requestParameters.documentFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add documents to profile within organization context
         * @param {DocumentApiDocumentControllerAddProfileDocumentsInOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerAddProfileDocumentsInOrganization(requestParameters: DocumentApiDocumentControllerAddProfileDocumentsInOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<DocumentFileResponseDto>> {
            return localVarFp.documentControllerAddProfileDocumentsInOrganization(requestParameters.profileId, requestParameters.documentFileDto, requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a text note on the owner\'s own profile
         * @param {DocumentApiDocumentControllerCreateProfileTextNoteForOwnerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerCreateProfileTextNoteForOwner(requestParameters: DocumentApiDocumentControllerCreateProfileTextNoteForOwnerRequest, options?: AxiosRequestConfig): AxiosPromise<Array<DocumentFileResponseDto>> {
            return localVarFp.documentControllerCreateProfileTextNoteForOwner(requestParameters.profileId, requestParameters.createTextNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a text note for a profile within organization context
         * @param {DocumentApiDocumentControllerCreateProfileTextNoteInOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerCreateProfileTextNoteInOrganization(requestParameters: DocumentApiDocumentControllerCreateProfileTextNoteInOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<DocumentFileResponseDto>> {
            return localVarFp.documentControllerCreateProfileTextNoteInOrganization(requestParameters.profileId, requestParameters.createTextNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete document from user profile
         * @param {DocumentApiDocumentControllerDeleteProfileDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerDeleteProfileDocument(requestParameters: DocumentApiDocumentControllerDeleteProfileDocumentRequest, options?: AxiosRequestConfig): AxiosPromise<Array<DocumentFileResponseDto>> {
            return localVarFp.documentControllerDeleteProfileDocument(requestParameters.profileId, requestParameters.filename, options).then((request) => request(axios, basePath));
        },
        /**
         * Professionals and org admins can only delete documents uploaded via visits that took place in their organization
         * @summary Delete a profile document within organization context
         * @param {DocumentApiDocumentControllerDeleteProfileDocumentInOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerDeleteProfileDocumentInOrganization(requestParameters: DocumentApiDocumentControllerDeleteProfileDocumentInOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<DocumentFileResponseDto>> {
            return localVarFp.documentControllerDeleteProfileDocumentInOrganization(requestParameters.profileId, requestParameters.filename, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a signed URL for a Document file (org-gated)
         * @param {DocumentApiDocumentControllerGetDocumentSignedUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerGetDocumentSignedUrl(requestParameters: DocumentApiDocumentControllerGetDocumentSignedUrlRequest, options?: AxiosRequestConfig): AxiosPromise<VisitControllerGetVisitFileSignedUrl200Response> {
            return localVarFp.documentControllerGetDocumentSignedUrl(requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get user profile documents
         * @param {DocumentApiDocumentControllerGetProfileDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerGetProfileDocuments(requestParameters: DocumentApiDocumentControllerGetProfileDocumentsRequest, options?: AxiosRequestConfig): AxiosPromise<PaginatedDocumentsResponseDto> {
            return localVarFp.documentControllerGetProfileDocuments(requestParameters.profileId, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get profile documents within organization context
         * @param {DocumentApiDocumentControllerGetProfileDocumentsInOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerGetProfileDocumentsInOrganization(requestParameters: DocumentApiDocumentControllerGetProfileDocumentsInOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<PaginatedDocumentsResponseDto> {
            return localVarFp.documentControllerGetProfileDocumentsInOrganization(requestParameters.profileId, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get user profile documents. Professional only.
         * @param {DocumentApiDocumentControllerGetProfileDocumentsPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerGetProfileDocumentsPreview(requestParameters: DocumentApiDocumentControllerGetProfileDocumentsPreviewRequest, options?: AxiosRequestConfig): AxiosPromise<Array<DocumentFileResponseDto>> {
            return localVarFp.documentControllerGetProfileDocumentsPreview(requestParameters.profileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a text note on the owner\'s own profile
         * @param {DocumentApiDocumentControllerUpdateProfileTextNoteForOwnerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerUpdateProfileTextNoteForOwner(requestParameters: DocumentApiDocumentControllerUpdateProfileTextNoteForOwnerRequest, options?: AxiosRequestConfig): AxiosPromise<Array<DocumentFileResponseDto>> {
            return localVarFp.documentControllerUpdateProfileTextNoteForOwner(requestParameters.profileId, requestParameters.filename, requestParameters.updateTextNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a text note for a profile within organization context
         * @param {DocumentApiDocumentControllerUpdateProfileTextNoteInOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentControllerUpdateProfileTextNoteInOrganization(requestParameters: DocumentApiDocumentControllerUpdateProfileTextNoteInOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<DocumentFileResponseDto>> {
            return localVarFp.documentControllerUpdateProfileTextNoteInOrganization(requestParameters.profileId, requestParameters.filename, requestParameters.updateTextNoteDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for documentControllerAddProfileDocuments operation in DocumentApi.
 * @export
 * @interface DocumentApiDocumentControllerAddProfileDocumentsRequest
 */
export interface DocumentApiDocumentControllerAddProfileDocumentsRequest {
    /**
     *
     * @type {string}
     * @memberof DocumentApiDocumentControllerAddProfileDocuments
     */
    readonly profileId: string

    /**
     *
     * @type {Array<DocumentFileDto>}
     * @memberof DocumentApiDocumentControllerAddProfileDocuments
     */
    readonly documentFileDto: Array<DocumentFileDto>
}

/**
 * Request parameters for documentControllerAddProfileDocumentsInOrganization operation in DocumentApi.
 * @export
 * @interface DocumentApiDocumentControllerAddProfileDocumentsInOrganizationRequest
 */
export interface DocumentApiDocumentControllerAddProfileDocumentsInOrganizationRequest {
    /**
     *
     * @type {string}
     * @memberof DocumentApiDocumentControllerAddProfileDocumentsInOrganization
     */
    readonly profileId: string

    /**
     *
     * @type {Array<DocumentFileDto>}
     * @memberof DocumentApiDocumentControllerAddProfileDocumentsInOrganization
     */
    readonly documentFileDto: Array<DocumentFileDto>

    /**
     * Optional visit ID to track document additions as visit activity
     * @type {string}
     * @memberof DocumentApiDocumentControllerAddProfileDocumentsInOrganization
     */
    readonly visitId?: string
}

/**
 * Request parameters for documentControllerCreateProfileTextNoteForOwner operation in DocumentApi.
 * @export
 * @interface DocumentApiDocumentControllerCreateProfileTextNoteForOwnerRequest
 */
export interface DocumentApiDocumentControllerCreateProfileTextNoteForOwnerRequest {
    /**
     *
     * @type {string}
     * @memberof DocumentApiDocumentControllerCreateProfileTextNoteForOwner
     */
    readonly profileId: string

    /**
     *
     * @type {CreateTextNoteDto}
     * @memberof DocumentApiDocumentControllerCreateProfileTextNoteForOwner
     */
    readonly createTextNoteDto: CreateTextNoteDto
}

/**
 * Request parameters for documentControllerCreateProfileTextNoteInOrganization operation in DocumentApi.
 * @export
 * @interface DocumentApiDocumentControllerCreateProfileTextNoteInOrganizationRequest
 */
export interface DocumentApiDocumentControllerCreateProfileTextNoteInOrganizationRequest {
    /**
     *
     * @type {string}
     * @memberof DocumentApiDocumentControllerCreateProfileTextNoteInOrganization
     */
    readonly profileId: string

    /**
     *
     * @type {CreateTextNoteDto}
     * @memberof DocumentApiDocumentControllerCreateProfileTextNoteInOrganization
     */
    readonly createTextNoteDto: CreateTextNoteDto
}

/**
 * Request parameters for documentControllerDeleteProfileDocument operation in DocumentApi.
 * @export
 * @interface DocumentApiDocumentControllerDeleteProfileDocumentRequest
 */
export interface DocumentApiDocumentControllerDeleteProfileDocumentRequest {
    /**
     *
     * @type {string}
     * @memberof DocumentApiDocumentControllerDeleteProfileDocument
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof DocumentApiDocumentControllerDeleteProfileDocument
     */
    readonly filename: string
}

/**
 * Request parameters for documentControllerDeleteProfileDocumentInOrganization operation in DocumentApi.
 * @export
 * @interface DocumentApiDocumentControllerDeleteProfileDocumentInOrganizationRequest
 */
export interface DocumentApiDocumentControllerDeleteProfileDocumentInOrganizationRequest {
    /**
     *
     * @type {string}
     * @memberof DocumentApiDocumentControllerDeleteProfileDocumentInOrganization
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof DocumentApiDocumentControllerDeleteProfileDocumentInOrganization
     */
    readonly filename: string
}

/**
 * Request parameters for documentControllerGetDocumentSignedUrl operation in DocumentApi.
 * @export
 * @interface DocumentApiDocumentControllerGetDocumentSignedUrlRequest
 */
export interface DocumentApiDocumentControllerGetDocumentSignedUrlRequest {
    /**
     *
     * @type {string}
     * @memberof DocumentApiDocumentControllerGetDocumentSignedUrl
     */
    readonly documentId: string
}

/**
 * Request parameters for documentControllerGetProfileDocuments operation in DocumentApi.
 * @export
 * @interface DocumentApiDocumentControllerGetProfileDocumentsRequest
 */
export interface DocumentApiDocumentControllerGetProfileDocumentsRequest {
    /**
     *
     * @type {string}
     * @memberof DocumentApiDocumentControllerGetProfileDocuments
     */
    readonly profileId: string

    /**
     * Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
     * @type {number}
     * @memberof DocumentApiDocumentControllerGetProfileDocuments
     */
    readonly page?: number

    /**
     * Rows per page. Omit together with &#x60;page&#x60; to get every row.
     * @type {number}
     * @memberof DocumentApiDocumentControllerGetProfileDocuments
     */
    readonly limit?: number
}

/**
 * Request parameters for documentControllerGetProfileDocumentsInOrganization operation in DocumentApi.
 * @export
 * @interface DocumentApiDocumentControllerGetProfileDocumentsInOrganizationRequest
 */
export interface DocumentApiDocumentControllerGetProfileDocumentsInOrganizationRequest {
    /**
     *
     * @type {string}
     * @memberof DocumentApiDocumentControllerGetProfileDocumentsInOrganization
     */
    readonly profileId: string

    /**
     * Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
     * @type {number}
     * @memberof DocumentApiDocumentControllerGetProfileDocumentsInOrganization
     */
    readonly page?: number

    /**
     * Rows per page. Omit together with &#x60;page&#x60; to get every row.
     * @type {number}
     * @memberof DocumentApiDocumentControllerGetProfileDocumentsInOrganization
     */
    readonly limit?: number
}

/**
 * Request parameters for documentControllerGetProfileDocumentsPreview operation in DocumentApi.
 * @export
 * @interface DocumentApiDocumentControllerGetProfileDocumentsPreviewRequest
 */
export interface DocumentApiDocumentControllerGetProfileDocumentsPreviewRequest {
    /**
     *
     * @type {string}
     * @memberof DocumentApiDocumentControllerGetProfileDocumentsPreview
     */
    readonly profileId: string
}

/**
 * Request parameters for documentControllerUpdateProfileTextNoteForOwner operation in DocumentApi.
 * @export
 * @interface DocumentApiDocumentControllerUpdateProfileTextNoteForOwnerRequest
 */
export interface DocumentApiDocumentControllerUpdateProfileTextNoteForOwnerRequest {
    /**
     *
     * @type {string}
     * @memberof DocumentApiDocumentControllerUpdateProfileTextNoteForOwner
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof DocumentApiDocumentControllerUpdateProfileTextNoteForOwner
     */
    readonly filename: string

    /**
     *
     * @type {UpdateTextNoteDto}
     * @memberof DocumentApiDocumentControllerUpdateProfileTextNoteForOwner
     */
    readonly updateTextNoteDto: UpdateTextNoteDto
}

/**
 * Request parameters for documentControllerUpdateProfileTextNoteInOrganization operation in DocumentApi.
 * @export
 * @interface DocumentApiDocumentControllerUpdateProfileTextNoteInOrganizationRequest
 */
export interface DocumentApiDocumentControllerUpdateProfileTextNoteInOrganizationRequest {
    /**
     *
     * @type {string}
     * @memberof DocumentApiDocumentControllerUpdateProfileTextNoteInOrganization
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof DocumentApiDocumentControllerUpdateProfileTextNoteInOrganization
     */
    readonly filename: string

    /**
     *
     * @type {UpdateTextNoteDto}
     * @memberof DocumentApiDocumentControllerUpdateProfileTextNoteInOrganization
     */
    readonly updateTextNoteDto: UpdateTextNoteDto
}

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
    /**
     *
     * @summary Add documents to user profile
     * @param {DocumentApiDocumentControllerAddProfileDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentControllerAddProfileDocuments(requestParameters: DocumentApiDocumentControllerAddProfileDocumentsRequest, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).documentControllerAddProfileDocuments(requestParameters.profileId, requestParameters.documentFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Add documents to profile within organization context
     * @param {DocumentApiDocumentControllerAddProfileDocumentsInOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentControllerAddProfileDocumentsInOrganization(requestParameters: DocumentApiDocumentControllerAddProfileDocumentsInOrganizationRequest, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).documentControllerAddProfileDocumentsInOrganization(requestParameters.profileId, requestParameters.documentFileDto, requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create a text note on the owner\'s own profile
     * @param {DocumentApiDocumentControllerCreateProfileTextNoteForOwnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentControllerCreateProfileTextNoteForOwner(requestParameters: DocumentApiDocumentControllerCreateProfileTextNoteForOwnerRequest, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).documentControllerCreateProfileTextNoteForOwner(requestParameters.profileId, requestParameters.createTextNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create a text note for a profile within organization context
     * @param {DocumentApiDocumentControllerCreateProfileTextNoteInOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentControllerCreateProfileTextNoteInOrganization(requestParameters: DocumentApiDocumentControllerCreateProfileTextNoteInOrganizationRequest, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).documentControllerCreateProfileTextNoteInOrganization(requestParameters.profileId, requestParameters.createTextNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete document from user profile
     * @param {DocumentApiDocumentControllerDeleteProfileDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentControllerDeleteProfileDocument(requestParameters: DocumentApiDocumentControllerDeleteProfileDocumentRequest, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).documentControllerDeleteProfileDocument(requestParameters.profileId, requestParameters.filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Professionals and org admins can only delete documents uploaded via visits that took place in their organization
     * @summary Delete a profile document within organization context
     * @param {DocumentApiDocumentControllerDeleteProfileDocumentInOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentControllerDeleteProfileDocumentInOrganization(requestParameters: DocumentApiDocumentControllerDeleteProfileDocumentInOrganizationRequest, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).documentControllerDeleteProfileDocumentInOrganization(requestParameters.profileId, requestParameters.filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get a signed URL for a Document file (org-gated)
     * @param {DocumentApiDocumentControllerGetDocumentSignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentControllerGetDocumentSignedUrl(requestParameters: DocumentApiDocumentControllerGetDocumentSignedUrlRequest, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).documentControllerGetDocumentSignedUrl(requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get user profile documents
     * @param {DocumentApiDocumentControllerGetProfileDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentControllerGetProfileDocuments(requestParameters: DocumentApiDocumentControllerGetProfileDocumentsRequest, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).documentControllerGetProfileDocuments(requestParameters.profileId, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get profile documents within organization context
     * @param {DocumentApiDocumentControllerGetProfileDocumentsInOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentControllerGetProfileDocumentsInOrganization(requestParameters: DocumentApiDocumentControllerGetProfileDocumentsInOrganizationRequest, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).documentControllerGetProfileDocumentsInOrganization(requestParameters.profileId, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get user profile documents. Professional only.
     * @param {DocumentApiDocumentControllerGetProfileDocumentsPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentControllerGetProfileDocumentsPreview(requestParameters: DocumentApiDocumentControllerGetProfileDocumentsPreviewRequest, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).documentControllerGetProfileDocumentsPreview(requestParameters.profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update a text note on the owner\'s own profile
     * @param {DocumentApiDocumentControllerUpdateProfileTextNoteForOwnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentControllerUpdateProfileTextNoteForOwner(requestParameters: DocumentApiDocumentControllerUpdateProfileTextNoteForOwnerRequest, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).documentControllerUpdateProfileTextNoteForOwner(requestParameters.profileId, requestParameters.filename, requestParameters.updateTextNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update a text note for a profile within organization context
     * @param {DocumentApiDocumentControllerUpdateProfileTextNoteInOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentControllerUpdateProfileTextNoteInOrganization(requestParameters: DocumentApiDocumentControllerUpdateProfileTextNoteInOrganizationRequest, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).documentControllerUpdateProfileTextNoteInOrganization(requestParameters.profileId, requestParameters.filename, requestParameters.updateTextNoteDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DowodyGotowociRecepcjiGosowejApi - axios parameter creator
 * @export
 */
export const DowodyGotowociRecepcjiGosowejApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Pobierz zminimalizowane dowody wyjścia z Fazy 6
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPilotEvidenceControllerGetPhase6Exit: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionPilotEvidenceControllerGetPhase6Exit', 'organizationId', organizationId)
            const localVarPath = `/api/voice-platform/pilot-evidence/organizations/{organizationId}/phase-6-exit`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DowodyGotowociRecepcjiGosowejApi - functional programming interface
 * @export
 */
export const DowodyGotowociRecepcjiGosowejApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DowodyGotowociRecepcjiGosowejApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Pobierz zminimalizowane dowody wyjścia z Fazy 6
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPilotEvidenceControllerGetPhase6Exit(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionPilotPhase6EvidenceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPilotEvidenceControllerGetPhase6Exit(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DowodyGotowociRecepcjiGosowejApi - factory interface
 * @export
 */
export const DowodyGotowociRecepcjiGosowejApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DowodyGotowociRecepcjiGosowejApiFp(configuration)
    return {
        /**
         *
         * @summary Pobierz zminimalizowane dowody wyjścia z Fazy 6
         * @param {DowodyGotowociRecepcjiGosowejApiReceptionPilotEvidenceControllerGetPhase6ExitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPilotEvidenceControllerGetPhase6Exit(requestParameters: DowodyGotowociRecepcjiGosowejApiReceptionPilotEvidenceControllerGetPhase6ExitRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionPilotPhase6EvidenceResponseDto> {
            return localVarFp.receptionPilotEvidenceControllerGetPhase6Exit(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for receptionPilotEvidenceControllerGetPhase6Exit operation in DowodyGotowociRecepcjiGosowejApi.
 * @export
 * @interface DowodyGotowociRecepcjiGosowejApiReceptionPilotEvidenceControllerGetPhase6ExitRequest
 */
export interface DowodyGotowociRecepcjiGosowejApiReceptionPilotEvidenceControllerGetPhase6ExitRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof DowodyGotowociRecepcjiGosowejApiReceptionPilotEvidenceControllerGetPhase6Exit
     */
    readonly organizationId: string
}

/**
 * DowodyGotowociRecepcjiGosowejApi - object-oriented interface
 * @export
 * @class DowodyGotowociRecepcjiGosowejApi
 * @extends {BaseAPI}
 */
export class DowodyGotowociRecepcjiGosowejApi extends BaseAPI {
    /**
     *
     * @summary Pobierz zminimalizowane dowody wyjścia z Fazy 6
     * @param {DowodyGotowociRecepcjiGosowejApiReceptionPilotEvidenceControllerGetPhase6ExitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DowodyGotowociRecepcjiGosowejApi
     */
    public receptionPilotEvidenceControllerGetPhase6Exit(requestParameters: DowodyGotowociRecepcjiGosowejApiReceptionPilotEvidenceControllerGetPhase6ExitRequest, options?: AxiosRequestConfig) {
        return DowodyGotowociRecepcjiGosowejApiFp(this.configuration).receptionPilotEvidenceControllerGetPhase6Exit(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DowodyProdukcyjnePilotauRecepcjiGosowejApi - axios parameter creator
 * @export
 */
export const DowodyProdukcyjnePilotauRecepcjiGosowejApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Zapisz anonimową część dowodu operacyjnego
         * @param {string} pilotReference
         * @param {SubmitVoicePilotProductionOperationsPartDto} submitVoicePilotProductionOperationsPartDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotProductionEvidencePartsControllerSubmitOperations: async (pilotReference: string, submitVoicePilotProductionOperationsPartDto: SubmitVoicePilotProductionOperationsPartDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pilotReference' is not null or undefined
            assertParamExists('voicePilotProductionEvidencePartsControllerSubmitOperations', 'pilotReference', pilotReference)
            // verify required parameter 'submitVoicePilotProductionOperationsPartDto' is not null or undefined
            assertParamExists('voicePilotProductionEvidencePartsControllerSubmitOperations', 'submitVoicePilotProductionOperationsPartDto', submitVoicePilotProductionOperationsPartDto)
            const localVarPath = `/api/voice-platform/pilots/{pilotReference}/evidence/production-parts/operations`
                .replace(`{${"pilotReference"}}`, encodeURIComponent(String(pilotReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitVoicePilotProductionOperationsPartDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zapisz anonimową część dowodu prywatności
         * @param {string} pilotReference
         * @param {SubmitVoicePilotProductionPrivacyPartDto} submitVoicePilotProductionPrivacyPartDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotProductionEvidencePartsControllerSubmitPrivacy: async (pilotReference: string, submitVoicePilotProductionPrivacyPartDto: SubmitVoicePilotProductionPrivacyPartDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pilotReference' is not null or undefined
            assertParamExists('voicePilotProductionEvidencePartsControllerSubmitPrivacy', 'pilotReference', pilotReference)
            // verify required parameter 'submitVoicePilotProductionPrivacyPartDto' is not null or undefined
            assertParamExists('voicePilotProductionEvidencePartsControllerSubmitPrivacy', 'submitVoicePilotProductionPrivacyPartDto', submitVoicePilotProductionPrivacyPartDto)
            const localVarPath = `/api/voice-platform/pilots/{pilotReference}/evidence/production-parts/privacy`
                .replace(`{${"pilotReference"}}`, encodeURIComponent(String(pilotReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitVoicePilotProductionPrivacyPartDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zapisz anonimową część dowodu bezpieczeństwa
         * @param {string} pilotReference
         * @param {SubmitVoicePilotProductionSafetyPartDto} submitVoicePilotProductionSafetyPartDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotProductionEvidencePartsControllerSubmitSafety: async (pilotReference: string, submitVoicePilotProductionSafetyPartDto: SubmitVoicePilotProductionSafetyPartDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pilotReference' is not null or undefined
            assertParamExists('voicePilotProductionEvidencePartsControllerSubmitSafety', 'pilotReference', pilotReference)
            // verify required parameter 'submitVoicePilotProductionSafetyPartDto' is not null or undefined
            assertParamExists('voicePilotProductionEvidencePartsControllerSubmitSafety', 'submitVoicePilotProductionSafetyPartDto', submitVoicePilotProductionSafetyPartDto)
            const localVarPath = `/api/voice-platform/pilots/{pilotReference}/evidence/production-parts/safety`
                .replace(`{${"pilotReference"}}`, encodeURIComponent(String(pilotReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitVoicePilotProductionSafetyPartDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DowodyProdukcyjnePilotauRecepcjiGosowejApi - functional programming interface
 * @export
 */
export const DowodyProdukcyjnePilotauRecepcjiGosowejApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DowodyProdukcyjnePilotauRecepcjiGosowejApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Zapisz anonimową część dowodu operacyjnego
         * @param {string} pilotReference
         * @param {SubmitVoicePilotProductionOperationsPartDto} submitVoicePilotProductionOperationsPartDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePilotProductionEvidencePartsControllerSubmitOperations(pilotReference: string, submitVoicePilotProductionOperationsPartDto: SubmitVoicePilotProductionOperationsPartDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePilotProductionEvidencePartReceiptDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePilotProductionEvidencePartsControllerSubmitOperations(pilotReference, submitVoicePilotProductionOperationsPartDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zapisz anonimową część dowodu prywatności
         * @param {string} pilotReference
         * @param {SubmitVoicePilotProductionPrivacyPartDto} submitVoicePilotProductionPrivacyPartDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePilotProductionEvidencePartsControllerSubmitPrivacy(pilotReference: string, submitVoicePilotProductionPrivacyPartDto: SubmitVoicePilotProductionPrivacyPartDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePilotProductionEvidencePartReceiptDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePilotProductionEvidencePartsControllerSubmitPrivacy(pilotReference, submitVoicePilotProductionPrivacyPartDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zapisz anonimową część dowodu bezpieczeństwa
         * @param {string} pilotReference
         * @param {SubmitVoicePilotProductionSafetyPartDto} submitVoicePilotProductionSafetyPartDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePilotProductionEvidencePartsControllerSubmitSafety(pilotReference: string, submitVoicePilotProductionSafetyPartDto: SubmitVoicePilotProductionSafetyPartDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePilotProductionEvidencePartReceiptDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePilotProductionEvidencePartsControllerSubmitSafety(pilotReference, submitVoicePilotProductionSafetyPartDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DowodyProdukcyjnePilotauRecepcjiGosowejApi - factory interface
 * @export
 */
export const DowodyProdukcyjnePilotauRecepcjiGosowejApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DowodyProdukcyjnePilotauRecepcjiGosowejApiFp(configuration)
    return {
        /**
         *
         * @summary Zapisz anonimową część dowodu operacyjnego
         * @param {DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitOperationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotProductionEvidencePartsControllerSubmitOperations(requestParameters: DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitOperationsRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePilotProductionEvidencePartReceiptDto> {
            return localVarFp.voicePilotProductionEvidencePartsControllerSubmitOperations(requestParameters.pilotReference, requestParameters.submitVoicePilotProductionOperationsPartDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zapisz anonimową część dowodu prywatności
         * @param {DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitPrivacyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotProductionEvidencePartsControllerSubmitPrivacy(requestParameters: DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitPrivacyRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePilotProductionEvidencePartReceiptDto> {
            return localVarFp.voicePilotProductionEvidencePartsControllerSubmitPrivacy(requestParameters.pilotReference, requestParameters.submitVoicePilotProductionPrivacyPartDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zapisz anonimową część dowodu bezpieczeństwa
         * @param {DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitSafetyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotProductionEvidencePartsControllerSubmitSafety(requestParameters: DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitSafetyRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePilotProductionEvidencePartReceiptDto> {
            return localVarFp.voicePilotProductionEvidencePartsControllerSubmitSafety(requestParameters.pilotReference, requestParameters.submitVoicePilotProductionSafetyPartDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voicePilotProductionEvidencePartsControllerSubmitOperations operation in DowodyProdukcyjnePilotauRecepcjiGosowejApi.
 * @export
 * @interface DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitOperationsRequest
 */
export interface DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitOperationsRequest {
    /**
     *
     * @type {string}
     * @memberof DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitOperations
     */
    readonly pilotReference: string

    /**
     *
     * @type {SubmitVoicePilotProductionOperationsPartDto}
     * @memberof DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitOperations
     */
    readonly submitVoicePilotProductionOperationsPartDto: SubmitVoicePilotProductionOperationsPartDto
}

/**
 * Request parameters for voicePilotProductionEvidencePartsControllerSubmitPrivacy operation in DowodyProdukcyjnePilotauRecepcjiGosowejApi.
 * @export
 * @interface DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitPrivacyRequest
 */
export interface DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitPrivacyRequest {
    /**
     *
     * @type {string}
     * @memberof DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitPrivacy
     */
    readonly pilotReference: string

    /**
     *
     * @type {SubmitVoicePilotProductionPrivacyPartDto}
     * @memberof DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitPrivacy
     */
    readonly submitVoicePilotProductionPrivacyPartDto: SubmitVoicePilotProductionPrivacyPartDto
}

/**
 * Request parameters for voicePilotProductionEvidencePartsControllerSubmitSafety operation in DowodyProdukcyjnePilotauRecepcjiGosowejApi.
 * @export
 * @interface DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitSafetyRequest
 */
export interface DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitSafetyRequest {
    /**
     *
     * @type {string}
     * @memberof DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitSafety
     */
    readonly pilotReference: string

    /**
     *
     * @type {SubmitVoicePilotProductionSafetyPartDto}
     * @memberof DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitSafety
     */
    readonly submitVoicePilotProductionSafetyPartDto: SubmitVoicePilotProductionSafetyPartDto
}

/**
 * DowodyProdukcyjnePilotauRecepcjiGosowejApi - object-oriented interface
 * @export
 * @class DowodyProdukcyjnePilotauRecepcjiGosowejApi
 * @extends {BaseAPI}
 */
export class DowodyProdukcyjnePilotauRecepcjiGosowejApi extends BaseAPI {
    /**
     *
     * @summary Zapisz anonimową część dowodu operacyjnego
     * @param {DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitOperationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DowodyProdukcyjnePilotauRecepcjiGosowejApi
     */
    public voicePilotProductionEvidencePartsControllerSubmitOperations(requestParameters: DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitOperationsRequest, options?: AxiosRequestConfig) {
        return DowodyProdukcyjnePilotauRecepcjiGosowejApiFp(this.configuration).voicePilotProductionEvidencePartsControllerSubmitOperations(requestParameters.pilotReference, requestParameters.submitVoicePilotProductionOperationsPartDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zapisz anonimową część dowodu prywatności
     * @param {DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitPrivacyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DowodyProdukcyjnePilotauRecepcjiGosowejApi
     */
    public voicePilotProductionEvidencePartsControllerSubmitPrivacy(requestParameters: DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitPrivacyRequest, options?: AxiosRequestConfig) {
        return DowodyProdukcyjnePilotauRecepcjiGosowejApiFp(this.configuration).voicePilotProductionEvidencePartsControllerSubmitPrivacy(requestParameters.pilotReference, requestParameters.submitVoicePilotProductionPrivacyPartDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zapisz anonimową część dowodu bezpieczeństwa
     * @param {DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitSafetyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DowodyProdukcyjnePilotauRecepcjiGosowejApi
     */
    public voicePilotProductionEvidencePartsControllerSubmitSafety(requestParameters: DowodyProdukcyjnePilotauRecepcjiGosowejApiVoicePilotProductionEvidencePartsControllerSubmitSafetyRequest, options?: AxiosRequestConfig) {
        return DowodyProdukcyjnePilotauRecepcjiGosowejApiFp(this.configuration).voicePilotProductionEvidencePartsControllerSubmitSafety(requestParameters.pilotReference, requestParameters.submitVoicePilotProductionSafetyPartDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EmbeddingsApi - axios parameter creator
 * @export
 */
export const EmbeddingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Delete embeddings for a specific file
         * @param {string} profileId
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        embeddingsControllerDeleteDocumentEmbeddings: async (profileId: string, filename: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('embeddingsControllerDeleteDocumentEmbeddings', 'profileId', profileId)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('embeddingsControllerDeleteDocumentEmbeddings', 'filename', filename)
            const localVarPath = `/api/embeddings/{profileId}/{filename}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Enrich a prompt with relevant document context
         * @param {EnrichPromptDto} enrichPromptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        embeddingsControllerEnrichPrompt: async (enrichPromptDto: EnrichPromptDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enrichPromptDto' is not null or undefined
            assertParamExists('embeddingsControllerEnrichPrompt', 'enrichPromptDto', enrichPromptDto)
            const localVarPath = `/api/embeddings/enrich-prompt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enrichPromptDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get summary of available documents for a profile
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        embeddingsControllerGetDocumentsSummary: async (profileId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('embeddingsControllerGetDocumentsSummary', 'profileId', profileId)
            const localVarPath = `/api/embeddings/summary/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Process a document and generate embeddings
         * @param {ProcessDocumentDto} processDocumentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        embeddingsControllerProcessDocument: async (processDocumentDto: ProcessDocumentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processDocumentDto' is not null or undefined
            assertParamExists('embeddingsControllerProcessDocument', 'processDocumentDto', processDocumentDto)
            const localVarPath = `/api/embeddings/process`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search for relevant information in documents
         * @param {SearchDocumentsDto} searchDocumentsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        embeddingsControllerSearchDocuments: async (searchDocumentsDto: SearchDocumentsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchDocumentsDto' is not null or undefined
            assertParamExists('embeddingsControllerSearchDocuments', 'searchDocumentsDto', searchDocumentsDto)
            const localVarPath = `/api/embeddings/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchDocumentsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmbeddingsApi - functional programming interface
 * @export
 */
export const EmbeddingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmbeddingsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Delete embeddings for a specific file
         * @param {string} profileId
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async embeddingsControllerDeleteDocumentEmbeddings(profileId: string, filename: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.embeddingsControllerDeleteDocumentEmbeddings(profileId, filename, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Enrich a prompt with relevant document context
         * @param {EnrichPromptDto} enrichPromptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async embeddingsControllerEnrichPrompt(enrichPromptDto: EnrichPromptDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.embeddingsControllerEnrichPrompt(enrichPromptDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get summary of available documents for a profile
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async embeddingsControllerGetDocumentsSummary(profileId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.embeddingsControllerGetDocumentsSummary(profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Process a document and generate embeddings
         * @param {ProcessDocumentDto} processDocumentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async embeddingsControllerProcessDocument(processDocumentDto: ProcessDocumentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.embeddingsControllerProcessDocument(processDocumentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Search for relevant information in documents
         * @param {SearchDocumentsDto} searchDocumentsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async embeddingsControllerSearchDocuments(searchDocumentsDto: SearchDocumentsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.embeddingsControllerSearchDocuments(searchDocumentsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmbeddingsApi - factory interface
 * @export
 */
export const EmbeddingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmbeddingsApiFp(configuration)
    return {
        /**
         *
         * @summary Delete embeddings for a specific file
         * @param {EmbeddingsApiEmbeddingsControllerDeleteDocumentEmbeddingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        embeddingsControllerDeleteDocumentEmbeddings(requestParameters: EmbeddingsApiEmbeddingsControllerDeleteDocumentEmbeddingsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.embeddingsControllerDeleteDocumentEmbeddings(requestParameters.profileId, requestParameters.filename, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Enrich a prompt with relevant document context
         * @param {EmbeddingsApiEmbeddingsControllerEnrichPromptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        embeddingsControllerEnrichPrompt(requestParameters: EmbeddingsApiEmbeddingsControllerEnrichPromptRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.embeddingsControllerEnrichPrompt(requestParameters.enrichPromptDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get summary of available documents for a profile
         * @param {EmbeddingsApiEmbeddingsControllerGetDocumentsSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        embeddingsControllerGetDocumentsSummary(requestParameters: EmbeddingsApiEmbeddingsControllerGetDocumentsSummaryRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.embeddingsControllerGetDocumentsSummary(requestParameters.profileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Process a document and generate embeddings
         * @param {EmbeddingsApiEmbeddingsControllerProcessDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        embeddingsControllerProcessDocument(requestParameters: EmbeddingsApiEmbeddingsControllerProcessDocumentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.embeddingsControllerProcessDocument(requestParameters.processDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search for relevant information in documents
         * @param {EmbeddingsApiEmbeddingsControllerSearchDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        embeddingsControllerSearchDocuments(requestParameters: EmbeddingsApiEmbeddingsControllerSearchDocumentsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.embeddingsControllerSearchDocuments(requestParameters.searchDocumentsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for embeddingsControllerDeleteDocumentEmbeddings operation in EmbeddingsApi.
 * @export
 * @interface EmbeddingsApiEmbeddingsControllerDeleteDocumentEmbeddingsRequest
 */
export interface EmbeddingsApiEmbeddingsControllerDeleteDocumentEmbeddingsRequest {
    /**
     *
     * @type {string}
     * @memberof EmbeddingsApiEmbeddingsControllerDeleteDocumentEmbeddings
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof EmbeddingsApiEmbeddingsControllerDeleteDocumentEmbeddings
     */
    readonly filename: string
}

/**
 * Request parameters for embeddingsControllerEnrichPrompt operation in EmbeddingsApi.
 * @export
 * @interface EmbeddingsApiEmbeddingsControllerEnrichPromptRequest
 */
export interface EmbeddingsApiEmbeddingsControllerEnrichPromptRequest {
    /**
     *
     * @type {EnrichPromptDto}
     * @memberof EmbeddingsApiEmbeddingsControllerEnrichPrompt
     */
    readonly enrichPromptDto: EnrichPromptDto
}

/**
 * Request parameters for embeddingsControllerGetDocumentsSummary operation in EmbeddingsApi.
 * @export
 * @interface EmbeddingsApiEmbeddingsControllerGetDocumentsSummaryRequest
 */
export interface EmbeddingsApiEmbeddingsControllerGetDocumentsSummaryRequest {
    /**
     *
     * @type {string}
     * @memberof EmbeddingsApiEmbeddingsControllerGetDocumentsSummary
     */
    readonly profileId: string
}

/**
 * Request parameters for embeddingsControllerProcessDocument operation in EmbeddingsApi.
 * @export
 * @interface EmbeddingsApiEmbeddingsControllerProcessDocumentRequest
 */
export interface EmbeddingsApiEmbeddingsControllerProcessDocumentRequest {
    /**
     *
     * @type {ProcessDocumentDto}
     * @memberof EmbeddingsApiEmbeddingsControllerProcessDocument
     */
    readonly processDocumentDto: ProcessDocumentDto
}

/**
 * Request parameters for embeddingsControllerSearchDocuments operation in EmbeddingsApi.
 * @export
 * @interface EmbeddingsApiEmbeddingsControllerSearchDocumentsRequest
 */
export interface EmbeddingsApiEmbeddingsControllerSearchDocumentsRequest {
    /**
     *
     * @type {SearchDocumentsDto}
     * @memberof EmbeddingsApiEmbeddingsControllerSearchDocuments
     */
    readonly searchDocumentsDto: SearchDocumentsDto
}

/**
 * EmbeddingsApi - object-oriented interface
 * @export
 * @class EmbeddingsApi
 * @extends {BaseAPI}
 */
export class EmbeddingsApi extends BaseAPI {
    /**
     *
     * @summary Delete embeddings for a specific file
     * @param {EmbeddingsApiEmbeddingsControllerDeleteDocumentEmbeddingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddingsApi
     */
    public embeddingsControllerDeleteDocumentEmbeddings(requestParameters: EmbeddingsApiEmbeddingsControllerDeleteDocumentEmbeddingsRequest, options?: AxiosRequestConfig) {
        return EmbeddingsApiFp(this.configuration).embeddingsControllerDeleteDocumentEmbeddings(requestParameters.profileId, requestParameters.filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Enrich a prompt with relevant document context
     * @param {EmbeddingsApiEmbeddingsControllerEnrichPromptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddingsApi
     */
    public embeddingsControllerEnrichPrompt(requestParameters: EmbeddingsApiEmbeddingsControllerEnrichPromptRequest, options?: AxiosRequestConfig) {
        return EmbeddingsApiFp(this.configuration).embeddingsControllerEnrichPrompt(requestParameters.enrichPromptDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get summary of available documents for a profile
     * @param {EmbeddingsApiEmbeddingsControllerGetDocumentsSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddingsApi
     */
    public embeddingsControllerGetDocumentsSummary(requestParameters: EmbeddingsApiEmbeddingsControllerGetDocumentsSummaryRequest, options?: AxiosRequestConfig) {
        return EmbeddingsApiFp(this.configuration).embeddingsControllerGetDocumentsSummary(requestParameters.profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Process a document and generate embeddings
     * @param {EmbeddingsApiEmbeddingsControllerProcessDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddingsApi
     */
    public embeddingsControllerProcessDocument(requestParameters: EmbeddingsApiEmbeddingsControllerProcessDocumentRequest, options?: AxiosRequestConfig) {
        return EmbeddingsApiFp(this.configuration).embeddingsControllerProcessDocument(requestParameters.processDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Search for relevant information in documents
     * @param {EmbeddingsApiEmbeddingsControllerSearchDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddingsApi
     */
    public embeddingsControllerSearchDocuments(requestParameters: EmbeddingsApiEmbeddingsControllerSearchDocumentsRequest, options?: AxiosRequestConfig) {
        return EmbeddingsApiFp(this.configuration).embeddingsControllerSearchDocuments(requestParameters.searchDocumentsDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FeedbackApi - axios parameter creator
 * @export
 */
export const FeedbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get feedback statistics for a suggestion
         * @param {string} suggestionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackControllerGetFeedbackStats: async (suggestionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suggestionId' is not null or undefined
            assertParamExists('feedbackControllerGetFeedbackStats', 'suggestionId', suggestionId)
            const localVarPath = `/api/feedback/stats/{suggestionId}`
                .replace(`{${"suggestionId"}}`, encodeURIComponent(String(suggestionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Check if user has given feedback for a suggestion
         * @param {string} suggestionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackControllerHasGivenFeedback: async (suggestionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suggestionId' is not null or undefined
            assertParamExists('feedbackControllerHasGivenFeedback', 'suggestionId', suggestionId)
            const localVarPath = `/api/feedback/has-given/{suggestionId}`
                .replace(`{${"suggestionId"}}`, encodeURIComponent(String(suggestionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Submit feedback for a suggestion
         * @param {CreateFeedbackDto} createFeedbackDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackControllerSubmitFeedback: async (createFeedbackDto: CreateFeedbackDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFeedbackDto' is not null or undefined
            assertParamExists('feedbackControllerSubmitFeedback', 'createFeedbackDto', createFeedbackDto)
            const localVarPath = `/api/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFeedbackDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeedbackApi - functional programming interface
 * @export
 */
export const FeedbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeedbackApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get feedback statistics for a suggestion
         * @param {string} suggestionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feedbackControllerGetFeedbackStats(suggestionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.feedbackControllerGetFeedbackStats(suggestionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Check if user has given feedback for a suggestion
         * @param {string} suggestionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feedbackControllerHasGivenFeedback(suggestionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.feedbackControllerHasGivenFeedback(suggestionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Submit feedback for a suggestion
         * @param {CreateFeedbackDto} createFeedbackDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feedbackControllerSubmitFeedback(createFeedbackDto: CreateFeedbackDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.feedbackControllerSubmitFeedback(createFeedbackDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FeedbackApi - factory interface
 * @export
 */
export const FeedbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeedbackApiFp(configuration)
    return {
        /**
         *
         * @summary Get feedback statistics for a suggestion
         * @param {FeedbackApiFeedbackControllerGetFeedbackStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackControllerGetFeedbackStats(requestParameters: FeedbackApiFeedbackControllerGetFeedbackStatsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.feedbackControllerGetFeedbackStats(requestParameters.suggestionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check if user has given feedback for a suggestion
         * @param {FeedbackApiFeedbackControllerHasGivenFeedbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackControllerHasGivenFeedback(requestParameters: FeedbackApiFeedbackControllerHasGivenFeedbackRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.feedbackControllerHasGivenFeedback(requestParameters.suggestionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Submit feedback for a suggestion
         * @param {FeedbackApiFeedbackControllerSubmitFeedbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackControllerSubmitFeedback(requestParameters: FeedbackApiFeedbackControllerSubmitFeedbackRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.feedbackControllerSubmitFeedback(requestParameters.createFeedbackDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for feedbackControllerGetFeedbackStats operation in FeedbackApi.
 * @export
 * @interface FeedbackApiFeedbackControllerGetFeedbackStatsRequest
 */
export interface FeedbackApiFeedbackControllerGetFeedbackStatsRequest {
    /**
     *
     * @type {string}
     * @memberof FeedbackApiFeedbackControllerGetFeedbackStats
     */
    readonly suggestionId: string
}

/**
 * Request parameters for feedbackControllerHasGivenFeedback operation in FeedbackApi.
 * @export
 * @interface FeedbackApiFeedbackControllerHasGivenFeedbackRequest
 */
export interface FeedbackApiFeedbackControllerHasGivenFeedbackRequest {
    /**
     *
     * @type {string}
     * @memberof FeedbackApiFeedbackControllerHasGivenFeedback
     */
    readonly suggestionId: string
}

/**
 * Request parameters for feedbackControllerSubmitFeedback operation in FeedbackApi.
 * @export
 * @interface FeedbackApiFeedbackControllerSubmitFeedbackRequest
 */
export interface FeedbackApiFeedbackControllerSubmitFeedbackRequest {
    /**
     *
     * @type {CreateFeedbackDto}
     * @memberof FeedbackApiFeedbackControllerSubmitFeedback
     */
    readonly createFeedbackDto: CreateFeedbackDto
}

/**
 * FeedbackApi - object-oriented interface
 * @export
 * @class FeedbackApi
 * @extends {BaseAPI}
 */
export class FeedbackApi extends BaseAPI {
    /**
     *
     * @summary Get feedback statistics for a suggestion
     * @param {FeedbackApiFeedbackControllerGetFeedbackStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedbackApi
     */
    public feedbackControllerGetFeedbackStats(requestParameters: FeedbackApiFeedbackControllerGetFeedbackStatsRequest, options?: AxiosRequestConfig) {
        return FeedbackApiFp(this.configuration).feedbackControllerGetFeedbackStats(requestParameters.suggestionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Check if user has given feedback for a suggestion
     * @param {FeedbackApiFeedbackControllerHasGivenFeedbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedbackApi
     */
    public feedbackControllerHasGivenFeedback(requestParameters: FeedbackApiFeedbackControllerHasGivenFeedbackRequest, options?: AxiosRequestConfig) {
        return FeedbackApiFp(this.configuration).feedbackControllerHasGivenFeedback(requestParameters.suggestionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Submit feedback for a suggestion
     * @param {FeedbackApiFeedbackControllerSubmitFeedbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedbackApi
     */
    public feedbackControllerSubmitFeedback(requestParameters: FeedbackApiFeedbackControllerSubmitFeedbackRequest, options?: AxiosRequestConfig) {
        return FeedbackApiFp(this.configuration).feedbackControllerSubmitFeedback(requestParameters.createFeedbackDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FormsApi - axios parameter creator
 * @export
 */
export const FormsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create a new form
         * @param {CreateFormDto} createFormDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerCreateForm: async (createFormDto: CreateFormDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFormDto' is not null or undefined
            assertParamExists('formControllerCreateForm', 'createFormDto', createFormDto)
            const localVarPath = `/api/forms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFormDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a form (soft delete)
         * @param {string} formId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerDeleteForm: async (formId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formControllerDeleteForm', 'formId', formId)
            const localVarPath = `/api/forms/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a form by ID
         * @param {string} formId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerGetFormById: async (formId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formControllerGetFormById', 'formId', formId)
            const localVarPath = `/api/forms/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all forms for an organization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerGetFormsByOrganization: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('formControllerGetFormsByOrganization', 'organizationId', organizationId)
            const localVarPath = `/api/forms/organization/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a submission by ID
         * @param {string} submissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerGetSubmissionById: async (submissionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('formControllerGetSubmissionById', 'submissionId', submissionId)
            const localVarPath = `/api/forms/submissions/{submissionId}`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all submissions for a visit
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerGetSubmissionsByVisit: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('formControllerGetSubmissionsByVisit', 'visitId', visitId)
            const localVarPath = `/api/forms/submissions/visit/{visitId}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a form
         * @param {string} formId
         * @param {UpdateFormDto} updateFormDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerUpdateForm: async (formId: string, updateFormDto: UpdateFormDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formControllerUpdateForm', 'formId', formId)
            // verify required parameter 'updateFormDto' is not null or undefined
            assertParamExists('formControllerUpdateForm', 'updateFormDto', updateFormDto)
            const localVarPath = `/api/forms/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFormDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a form submission
         * @param {string} submissionId
         * @param {UpdateFormSubmissionDto} updateFormSubmissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerUpdateSubmission: async (submissionId: string, updateFormSubmissionDto: UpdateFormSubmissionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('formControllerUpdateSubmission', 'submissionId', submissionId)
            // verify required parameter 'updateFormSubmissionDto' is not null or undefined
            assertParamExists('formControllerUpdateSubmission', 'updateFormSubmissionDto', updateFormSubmissionDto)
            const localVarPath = `/api/forms/submissions/{submissionId}`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFormSubmissionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create or update a form submission (upsert)
         * @param {CreateFormSubmissionDto} createFormSubmissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerUpsertSubmission: async (createFormSubmissionDto: CreateFormSubmissionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFormSubmissionDto' is not null or undefined
            assertParamExists('formControllerUpsertSubmission', 'createFormSubmissionDto', createFormSubmissionDto)
            const localVarPath = `/api/forms/submissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFormSubmissionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormsApi - functional programming interface
 * @export
 */
export const FormsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create a new form
         * @param {CreateFormDto} createFormDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formControllerCreateForm(createFormDto: CreateFormDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFormDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formControllerCreateForm(createFormDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a form (soft delete)
         * @param {string} formId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formControllerDeleteForm(formId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formControllerDeleteForm(formId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a form by ID
         * @param {string} formId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formControllerGetFormById(formId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFormDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formControllerGetFormById(formId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all forms for an organization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formControllerGetFormsByOrganization(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFormDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formControllerGetFormsByOrganization(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a submission by ID
         * @param {string} submissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formControllerGetSubmissionById(submissionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFormSubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formControllerGetSubmissionById(submissionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all submissions for a visit
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formControllerGetSubmissionsByVisit(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFormSubmissionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formControllerGetSubmissionsByVisit(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update a form
         * @param {string} formId
         * @param {UpdateFormDto} updateFormDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formControllerUpdateForm(formId: string, updateFormDto: UpdateFormDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFormDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formControllerUpdateForm(formId, updateFormDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update a form submission
         * @param {string} submissionId
         * @param {UpdateFormSubmissionDto} updateFormSubmissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formControllerUpdateSubmission(submissionId: string, updateFormSubmissionDto: UpdateFormSubmissionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFormSubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formControllerUpdateSubmission(submissionId, updateFormSubmissionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Create or update a form submission (upsert)
         * @param {CreateFormSubmissionDto} createFormSubmissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formControllerUpsertSubmission(createFormSubmissionDto: CreateFormSubmissionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFormSubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formControllerUpsertSubmission(createFormSubmissionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FormsApi - factory interface
 * @export
 */
export const FormsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormsApiFp(configuration)
    return {
        /**
         *
         * @summary Create a new form
         * @param {FormsApiFormControllerCreateFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerCreateForm(requestParameters: FormsApiFormControllerCreateFormRequest, options?: AxiosRequestConfig): AxiosPromise<GetFormDto> {
            return localVarFp.formControllerCreateForm(requestParameters.createFormDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a form (soft delete)
         * @param {FormsApiFormControllerDeleteFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerDeleteForm(requestParameters: FormsApiFormControllerDeleteFormRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formControllerDeleteForm(requestParameters.formId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a form by ID
         * @param {FormsApiFormControllerGetFormByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerGetFormById(requestParameters: FormsApiFormControllerGetFormByIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetFormDto> {
            return localVarFp.formControllerGetFormById(requestParameters.formId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all forms for an organization
         * @param {FormsApiFormControllerGetFormsByOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerGetFormsByOrganization(requestParameters: FormsApiFormControllerGetFormsByOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFormDto>> {
            return localVarFp.formControllerGetFormsByOrganization(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a submission by ID
         * @param {FormsApiFormControllerGetSubmissionByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerGetSubmissionById(requestParameters: FormsApiFormControllerGetSubmissionByIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetFormSubmissionDto> {
            return localVarFp.formControllerGetSubmissionById(requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all submissions for a visit
         * @param {FormsApiFormControllerGetSubmissionsByVisitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerGetSubmissionsByVisit(requestParameters: FormsApiFormControllerGetSubmissionsByVisitRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFormSubmissionDto>> {
            return localVarFp.formControllerGetSubmissionsByVisit(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a form
         * @param {FormsApiFormControllerUpdateFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerUpdateForm(requestParameters: FormsApiFormControllerUpdateFormRequest, options?: AxiosRequestConfig): AxiosPromise<GetFormDto> {
            return localVarFp.formControllerUpdateForm(requestParameters.formId, requestParameters.updateFormDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a form submission
         * @param {FormsApiFormControllerUpdateSubmissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerUpdateSubmission(requestParameters: FormsApiFormControllerUpdateSubmissionRequest, options?: AxiosRequestConfig): AxiosPromise<GetFormSubmissionDto> {
            return localVarFp.formControllerUpdateSubmission(requestParameters.submissionId, requestParameters.updateFormSubmissionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create or update a form submission (upsert)
         * @param {FormsApiFormControllerUpsertSubmissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formControllerUpsertSubmission(requestParameters: FormsApiFormControllerUpsertSubmissionRequest, options?: AxiosRequestConfig): AxiosPromise<GetFormSubmissionDto> {
            return localVarFp.formControllerUpsertSubmission(requestParameters.createFormSubmissionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for formControllerCreateForm operation in FormsApi.
 * @export
 * @interface FormsApiFormControllerCreateFormRequest
 */
export interface FormsApiFormControllerCreateFormRequest {
    /**
     *
     * @type {CreateFormDto}
     * @memberof FormsApiFormControllerCreateForm
     */
    readonly createFormDto: CreateFormDto
}

/**
 * Request parameters for formControllerDeleteForm operation in FormsApi.
 * @export
 * @interface FormsApiFormControllerDeleteFormRequest
 */
export interface FormsApiFormControllerDeleteFormRequest {
    /**
     *
     * @type {string}
     * @memberof FormsApiFormControllerDeleteForm
     */
    readonly formId: string
}

/**
 * Request parameters for formControllerGetFormById operation in FormsApi.
 * @export
 * @interface FormsApiFormControllerGetFormByIdRequest
 */
export interface FormsApiFormControllerGetFormByIdRequest {
    /**
     *
     * @type {string}
     * @memberof FormsApiFormControllerGetFormById
     */
    readonly formId: string
}

/**
 * Request parameters for formControllerGetFormsByOrganization operation in FormsApi.
 * @export
 * @interface FormsApiFormControllerGetFormsByOrganizationRequest
 */
export interface FormsApiFormControllerGetFormsByOrganizationRequest {
    /**
     *
     * @type {string}
     * @memberof FormsApiFormControllerGetFormsByOrganization
     */
    readonly organizationId: string
}

/**
 * Request parameters for formControllerGetSubmissionById operation in FormsApi.
 * @export
 * @interface FormsApiFormControllerGetSubmissionByIdRequest
 */
export interface FormsApiFormControllerGetSubmissionByIdRequest {
    /**
     *
     * @type {string}
     * @memberof FormsApiFormControllerGetSubmissionById
     */
    readonly submissionId: string
}

/**
 * Request parameters for formControllerGetSubmissionsByVisit operation in FormsApi.
 * @export
 * @interface FormsApiFormControllerGetSubmissionsByVisitRequest
 */
export interface FormsApiFormControllerGetSubmissionsByVisitRequest {
    /**
     *
     * @type {string}
     * @memberof FormsApiFormControllerGetSubmissionsByVisit
     */
    readonly visitId: string
}

/**
 * Request parameters for formControllerUpdateForm operation in FormsApi.
 * @export
 * @interface FormsApiFormControllerUpdateFormRequest
 */
export interface FormsApiFormControllerUpdateFormRequest {
    /**
     *
     * @type {string}
     * @memberof FormsApiFormControllerUpdateForm
     */
    readonly formId: string

    /**
     *
     * @type {UpdateFormDto}
     * @memberof FormsApiFormControllerUpdateForm
     */
    readonly updateFormDto: UpdateFormDto
}

/**
 * Request parameters for formControllerUpdateSubmission operation in FormsApi.
 * @export
 * @interface FormsApiFormControllerUpdateSubmissionRequest
 */
export interface FormsApiFormControllerUpdateSubmissionRequest {
    /**
     *
     * @type {string}
     * @memberof FormsApiFormControllerUpdateSubmission
     */
    readonly submissionId: string

    /**
     *
     * @type {UpdateFormSubmissionDto}
     * @memberof FormsApiFormControllerUpdateSubmission
     */
    readonly updateFormSubmissionDto: UpdateFormSubmissionDto
}

/**
 * Request parameters for formControllerUpsertSubmission operation in FormsApi.
 * @export
 * @interface FormsApiFormControllerUpsertSubmissionRequest
 */
export interface FormsApiFormControllerUpsertSubmissionRequest {
    /**
     *
     * @type {CreateFormSubmissionDto}
     * @memberof FormsApiFormControllerUpsertSubmission
     */
    readonly createFormSubmissionDto: CreateFormSubmissionDto
}

/**
 * FormsApi - object-oriented interface
 * @export
 * @class FormsApi
 * @extends {BaseAPI}
 */
export class FormsApi extends BaseAPI {
    /**
     *
     * @summary Create a new form
     * @param {FormsApiFormControllerCreateFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formControllerCreateForm(requestParameters: FormsApiFormControllerCreateFormRequest, options?: AxiosRequestConfig) {
        return FormsApiFp(this.configuration).formControllerCreateForm(requestParameters.createFormDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete a form (soft delete)
     * @param {FormsApiFormControllerDeleteFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formControllerDeleteForm(requestParameters: FormsApiFormControllerDeleteFormRequest, options?: AxiosRequestConfig) {
        return FormsApiFp(this.configuration).formControllerDeleteForm(requestParameters.formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get a form by ID
     * @param {FormsApiFormControllerGetFormByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formControllerGetFormById(requestParameters: FormsApiFormControllerGetFormByIdRequest, options?: AxiosRequestConfig) {
        return FormsApiFp(this.configuration).formControllerGetFormById(requestParameters.formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all forms for an organization
     * @param {FormsApiFormControllerGetFormsByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formControllerGetFormsByOrganization(requestParameters: FormsApiFormControllerGetFormsByOrganizationRequest, options?: AxiosRequestConfig) {
        return FormsApiFp(this.configuration).formControllerGetFormsByOrganization(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get a submission by ID
     * @param {FormsApiFormControllerGetSubmissionByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formControllerGetSubmissionById(requestParameters: FormsApiFormControllerGetSubmissionByIdRequest, options?: AxiosRequestConfig) {
        return FormsApiFp(this.configuration).formControllerGetSubmissionById(requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all submissions for a visit
     * @param {FormsApiFormControllerGetSubmissionsByVisitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formControllerGetSubmissionsByVisit(requestParameters: FormsApiFormControllerGetSubmissionsByVisitRequest, options?: AxiosRequestConfig) {
        return FormsApiFp(this.configuration).formControllerGetSubmissionsByVisit(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update a form
     * @param {FormsApiFormControllerUpdateFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formControllerUpdateForm(requestParameters: FormsApiFormControllerUpdateFormRequest, options?: AxiosRequestConfig) {
        return FormsApiFp(this.configuration).formControllerUpdateForm(requestParameters.formId, requestParameters.updateFormDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update a form submission
     * @param {FormsApiFormControllerUpdateSubmissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formControllerUpdateSubmission(requestParameters: FormsApiFormControllerUpdateSubmissionRequest, options?: AxiosRequestConfig) {
        return FormsApiFp(this.configuration).formControllerUpdateSubmission(requestParameters.submissionId, requestParameters.updateFormSubmissionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create or update a form submission (upsert)
     * @param {FormsApiFormControllerUpsertSubmissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formControllerUpsertSubmission(requestParameters: FormsApiFormControllerUpsertSubmissionRequest, options?: AxiosRequestConfig) {
        return FormsApiFp(this.configuration).formControllerUpsertSubmission(requestParameters.createFormSubmissionDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GroundedVoiceReceptionApi - axios parameter creator
 * @export
 */
export const GroundedVoiceReceptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Pobierz opublikowane Reception Facts
         * @param {string} organizationId
         * @param {'true' | 'false'} [includeHistory]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groundedReceptionOrganizationControllerListFacts: async (organizationId: string, includeHistory?: 'true' | 'false', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('groundedReceptionOrganizationControllerListFacts', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/facts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeHistory !== undefined) {
                localVarQueryParameter['includeHistory'] = includeHistory;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz polityki języka cen usług
         * @param {string} organizationId
         * @param {'true' | 'false'} [includeHistory]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groundedReceptionOrganizationControllerListPricePolicies: async (organizationId: string, includeHistory?: 'true' | 'false', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('groundedReceptionOrganizationControllerListPricePolicies', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/service-price-policies`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeHistory !== undefined) {
                localVarQueryParameter['includeHistory'] = includeHistory;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz aktywne informacyjne usługi bez rezerwacji głosowej
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groundedReceptionOrganizationControllerListServices: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('groundedReceptionOrganizationControllerListServices', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/services`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Opublikuj następną rewizję Reception Fact
         * @param {string} organizationId
         * @param {PublishReceptionFactDto} publishReceptionFactDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groundedReceptionOrganizationControllerPublishFact: async (organizationId: string, publishReceptionFactDto: PublishReceptionFactDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('groundedReceptionOrganizationControllerPublishFact', 'organizationId', organizationId)
            // verify required parameter 'publishReceptionFactDto' is not null or undefined
            assertParamExists('groundedReceptionOrganizationControllerPublishFact', 'publishReceptionFactDto', publishReceptionFactDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/facts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishReceptionFactDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Opublikuj następną politykę języka ceny
         * @param {string} organizationId
         * @param {PublishServicePricePolicyDto} publishServicePricePolicyDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groundedReceptionOrganizationControllerPublishPricePolicy: async (organizationId: string, publishServicePricePolicyDto: PublishServicePricePolicyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('groundedReceptionOrganizationControllerPublishPricePolicy', 'organizationId', organizationId)
            // verify required parameter 'publishServicePricePolicyDto' is not null or undefined
            assertParamExists('groundedReceptionOrganizationControllerPublishPricePolicy', 'publishServicePricePolicyDto', publishServicePricePolicyDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/service-price-policies`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishServicePricePolicyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroundedVoiceReceptionApi - functional programming interface
 * @export
 */
export const GroundedVoiceReceptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroundedVoiceReceptionApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Pobierz opublikowane Reception Facts
         * @param {string} organizationId
         * @param {'true' | 'false'} [includeHistory]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groundedReceptionOrganizationControllerListFacts(organizationId: string, includeHistory?: 'true' | 'false', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReceptionFactRevisionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groundedReceptionOrganizationControllerListFacts(organizationId, includeHistory, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz polityki języka cen usług
         * @param {string} organizationId
         * @param {'true' | 'false'} [includeHistory]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groundedReceptionOrganizationControllerListPricePolicies(organizationId: string, includeHistory?: 'true' | 'false', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServicePricePolicyRevisionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groundedReceptionOrganizationControllerListPricePolicies(organizationId, includeHistory, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz aktywne informacyjne usługi bez rezerwacji głosowej
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groundedReceptionOrganizationControllerListServices(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActiveInformationalServiceResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groundedReceptionOrganizationControllerListServices(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Opublikuj następną rewizję Reception Fact
         * @param {string} organizationId
         * @param {PublishReceptionFactDto} publishReceptionFactDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groundedReceptionOrganizationControllerPublishFact(organizationId: string, publishReceptionFactDto: PublishReceptionFactDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionFactRevisionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groundedReceptionOrganizationControllerPublishFact(organizationId, publishReceptionFactDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Opublikuj następną politykę języka ceny
         * @param {string} organizationId
         * @param {PublishServicePricePolicyDto} publishServicePricePolicyDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groundedReceptionOrganizationControllerPublishPricePolicy(organizationId: string, publishServicePricePolicyDto: PublishServicePricePolicyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePricePolicyRevisionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groundedReceptionOrganizationControllerPublishPricePolicy(organizationId, publishServicePricePolicyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GroundedVoiceReceptionApi - factory interface
 * @export
 */
export const GroundedVoiceReceptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroundedVoiceReceptionApiFp(configuration)
    return {
        /**
         *
         * @summary Pobierz opublikowane Reception Facts
         * @param {GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListFactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groundedReceptionOrganizationControllerListFacts(requestParameters: GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListFactsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<ReceptionFactRevisionResponseDto>> {
            return localVarFp.groundedReceptionOrganizationControllerListFacts(requestParameters.organizationId, requestParameters.includeHistory, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz polityki języka cen usług
         * @param {GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListPricePoliciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groundedReceptionOrganizationControllerListPricePolicies(requestParameters: GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListPricePoliciesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<ServicePricePolicyRevisionResponseDto>> {
            return localVarFp.groundedReceptionOrganizationControllerListPricePolicies(requestParameters.organizationId, requestParameters.includeHistory, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz aktywne informacyjne usługi bez rezerwacji głosowej
         * @param {GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListServicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groundedReceptionOrganizationControllerListServices(requestParameters: GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListServicesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<ActiveInformationalServiceResponseDto>> {
            return localVarFp.groundedReceptionOrganizationControllerListServices(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opublikuj następną rewizję Reception Fact
         * @param {GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerPublishFactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groundedReceptionOrganizationControllerPublishFact(requestParameters: GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerPublishFactRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionFactRevisionResponseDto> {
            return localVarFp.groundedReceptionOrganizationControllerPublishFact(requestParameters.organizationId, requestParameters.publishReceptionFactDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opublikuj następną politykę języka ceny
         * @param {GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerPublishPricePolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groundedReceptionOrganizationControllerPublishPricePolicy(requestParameters: GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerPublishPricePolicyRequest, options?: AxiosRequestConfig): AxiosPromise<ServicePricePolicyRevisionResponseDto> {
            return localVarFp.groundedReceptionOrganizationControllerPublishPricePolicy(requestParameters.organizationId, requestParameters.publishServicePricePolicyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for groundedReceptionOrganizationControllerListFacts operation in GroundedVoiceReceptionApi.
 * @export
 * @interface GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListFactsRequest
 */
export interface GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListFactsRequest {
    /**
     *
     * @type {string}
     * @memberof GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListFacts
     */
    readonly organizationId: string

    /**
     *
     * @type {'true' | 'false'}
     * @memberof GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListFacts
     */
    readonly includeHistory?: 'true' | 'false'
}

/**
 * Request parameters for groundedReceptionOrganizationControllerListPricePolicies operation in GroundedVoiceReceptionApi.
 * @export
 * @interface GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListPricePoliciesRequest
 */
export interface GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListPricePoliciesRequest {
    /**
     *
     * @type {string}
     * @memberof GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListPricePolicies
     */
    readonly organizationId: string

    /**
     *
     * @type {'true' | 'false'}
     * @memberof GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListPricePolicies
     */
    readonly includeHistory?: 'true' | 'false'
}

/**
 * Request parameters for groundedReceptionOrganizationControllerListServices operation in GroundedVoiceReceptionApi.
 * @export
 * @interface GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListServicesRequest
 */
export interface GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListServicesRequest {
    /**
     *
     * @type {string}
     * @memberof GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListServices
     */
    readonly organizationId: string
}

/**
 * Request parameters for groundedReceptionOrganizationControllerPublishFact operation in GroundedVoiceReceptionApi.
 * @export
 * @interface GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerPublishFactRequest
 */
export interface GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerPublishFactRequest {
    /**
     *
     * @type {string}
     * @memberof GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerPublishFact
     */
    readonly organizationId: string

    /**
     *
     * @type {PublishReceptionFactDto}
     * @memberof GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerPublishFact
     */
    readonly publishReceptionFactDto: PublishReceptionFactDto
}

/**
 * Request parameters for groundedReceptionOrganizationControllerPublishPricePolicy operation in GroundedVoiceReceptionApi.
 * @export
 * @interface GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerPublishPricePolicyRequest
 */
export interface GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerPublishPricePolicyRequest {
    /**
     *
     * @type {string}
     * @memberof GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerPublishPricePolicy
     */
    readonly organizationId: string

    /**
     *
     * @type {PublishServicePricePolicyDto}
     * @memberof GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerPublishPricePolicy
     */
    readonly publishServicePricePolicyDto: PublishServicePricePolicyDto
}

/**
 * GroundedVoiceReceptionApi - object-oriented interface
 * @export
 * @class GroundedVoiceReceptionApi
 * @extends {BaseAPI}
 */
export class GroundedVoiceReceptionApi extends BaseAPI {
    /**
     *
     * @summary Pobierz opublikowane Reception Facts
     * @param {GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListFactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroundedVoiceReceptionApi
     */
    public groundedReceptionOrganizationControllerListFacts(requestParameters: GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListFactsRequest, options?: AxiosRequestConfig) {
        return GroundedVoiceReceptionApiFp(this.configuration).groundedReceptionOrganizationControllerListFacts(requestParameters.organizationId, requestParameters.includeHistory, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz polityki języka cen usług
     * @param {GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListPricePoliciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroundedVoiceReceptionApi
     */
    public groundedReceptionOrganizationControllerListPricePolicies(requestParameters: GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListPricePoliciesRequest, options?: AxiosRequestConfig) {
        return GroundedVoiceReceptionApiFp(this.configuration).groundedReceptionOrganizationControllerListPricePolicies(requestParameters.organizationId, requestParameters.includeHistory, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz aktywne informacyjne usługi bez rezerwacji głosowej
     * @param {GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroundedVoiceReceptionApi
     */
    public groundedReceptionOrganizationControllerListServices(requestParameters: GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerListServicesRequest, options?: AxiosRequestConfig) {
        return GroundedVoiceReceptionApiFp(this.configuration).groundedReceptionOrganizationControllerListServices(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Opublikuj następną rewizję Reception Fact
     * @param {GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerPublishFactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroundedVoiceReceptionApi
     */
    public groundedReceptionOrganizationControllerPublishFact(requestParameters: GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerPublishFactRequest, options?: AxiosRequestConfig) {
        return GroundedVoiceReceptionApiFp(this.configuration).groundedReceptionOrganizationControllerPublishFact(requestParameters.organizationId, requestParameters.publishReceptionFactDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Opublikuj następną politykę języka ceny
     * @param {GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerPublishPricePolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroundedVoiceReceptionApi
     */
    public groundedReceptionOrganizationControllerPublishPricePolicy(requestParameters: GroundedVoiceReceptionApiGroundedReceptionOrganizationControllerPublishPricePolicyRequest, options?: AxiosRequestConfig) {
        return GroundedVoiceReceptionApiFp(this.configuration).groundedReceptionOrganizationControllerPublishPricePolicy(requestParameters.organizationId, requestParameters.publishServicePricePolicyDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IncydentyPrywatnociDostawcyVoiceApi - axios parameter creator
 * @export
 */
export const IncydentyPrywatnociDostawcyVoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Aktywuj zatwierdzone upoważnienie dla dokładnej rewizji wdrożenia
         * @param {string} authorityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerActivateProviderCallScanScheduleAuthority: async (authorityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorityId' is not null or undefined
            assertParamExists('voiceProviderPrivacyIncidentControllerActivateProviderCallScanScheduleAuthority', 'authorityId', authorityId)
            const localVarPath = `/api/voice-platform/provider-privacy-incidents/provider-call-scan/schedule-authorities/{authorityId}/activation`
                .replace(`{${"authorityId"}}`, encodeURIComponent(String(authorityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zatwierdź usunięcie artefaktów jako druga osoba
         * @param {string} incidentKey
         * @param {string} proposalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerApprove: async (incidentKey: string, proposalId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'incidentKey' is not null or undefined
            assertParamExists('voiceProviderPrivacyIncidentControllerApprove', 'incidentKey', incidentKey)
            // verify required parameter 'proposalId' is not null or undefined
            assertParamExists('voiceProviderPrivacyIncidentControllerApprove', 'proposalId', proposalId)
            const localVarPath = `/api/voice-platform/provider-privacy-incidents/{incidentKey}/remediation-proposals/{proposalId}/approval`
                .replace(`{${"incidentKey"}}`, encodeURIComponent(String(incidentKey)))
                .replace(`{${"proposalId"}}`, encodeURIComponent(String(proposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zatwierdź upoważnienie harmonogramu jako druga osoba
         * @param {string} authorityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerApproveProviderCallScanScheduleAuthority: async (authorityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorityId' is not null or undefined
            assertParamExists('voiceProviderPrivacyIncidentControllerApproveProviderCallScanScheduleAuthority', 'authorityId', authorityId)
            const localVarPath = `/api/voice-platform/provider-privacy-incidents/provider-call-scan/schedule-authorities/{authorityId}/approval`
                .replace(`{${"authorityId"}}`, encodeURIComponent(String(authorityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz dokładne bieżące upoważnienie harmonogramu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerGetCurrentProviderCallScanScheduleAuthority: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/provider-privacy-incidents/provider-call-scan/schedule-authorities/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Odzyskaj nieodwołane nieprzezroczyste upoważnienie harmonogramu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerGetOpenProviderCallScanScheduleAuthority: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/provider-privacy-incidents/provider-call-scan/schedule-authorities/open`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz wyprowadzony przez serwer zakres upoważnienia harmonogramu
         * @param {string} expiresAt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerGetProviderCallScanScheduleAuthorityCandidate: async (expiresAt: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'expiresAt' is not null or undefined
            assertParamExists('voiceProviderPrivacyIncidentControllerGetProviderCallScanScheduleAuthorityCandidate', 'expiresAt', expiresAt)
            const localVarPath = `/api/voice-platform/provider-privacy-incidents/provider-call-scan/schedule-authorities/candidate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (expiresAt !== undefined) {
                localVarQueryParameter['expiresAt'] = (expiresAt as any instanceof Date) ?
                    (expiresAt as any).toISOString() :
                    expiresAt;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz bezpieczną kolejkę incydentów prywatności dostawcy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/provider-privacy-incidents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zaproponuj usunięcie dokładnego zestawu artefaktów dostawcy
         * @param {string} incidentKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerPropose: async (incidentKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'incidentKey' is not null or undefined
            assertParamExists('voiceProviderPrivacyIncidentControllerPropose', 'incidentKey', incidentKey)
            const localVarPath = `/api/voice-platform/provider-privacy-incidents/{incidentKey}/remediation-proposals`
                .replace(`{${"incidentKey"}}`, encodeURIComponent(String(incidentKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zaproponuj ograniczone upoważnienie harmonogramu skanowania dostawcy
         * @param {VoiceProviderCallScanScheduleAuthorityProposalDto} voiceProviderCallScanScheduleAuthorityProposalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerProposeProviderCallScanScheduleAuthority: async (voiceProviderCallScanScheduleAuthorityProposalDto: VoiceProviderCallScanScheduleAuthorityProposalDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceProviderCallScanScheduleAuthorityProposalDto' is not null or undefined
            assertParamExists('voiceProviderPrivacyIncidentControllerProposeProviderCallScanScheduleAuthority', 'voiceProviderCallScanScheduleAuthorityProposalDto', voiceProviderCallScanScheduleAuthorityProposalDto)
            const localVarPath = `/api/voice-platform/provider-privacy-incidents/provider-call-scan/schedule-authorities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceProviderCallScanScheduleAuthorityProposalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Uruchom ograniczone uzgadnianie i usuwanie zakończonych połączeń dostawcy
         * @param {VoiceProviderCallScanCommandDto} voiceProviderCallScanCommandDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerReconcileProviderCalls: async (voiceProviderCallScanCommandDto: VoiceProviderCallScanCommandDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceProviderCallScanCommandDto' is not null or undefined
            assertParamExists('voiceProviderPrivacyIncidentControllerReconcileProviderCalls', 'voiceProviderCallScanCommandDto', voiceProviderCallScanCommandDto)
            const localVarPath = `/api/voice-platform/provider-privacy-incidents/provider-call-scan/reconciliation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceProviderCallScanCommandDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Otwórz linię po zweryfikowanej remediacji dostawcy
         * @param {string} incidentKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerReopen: async (incidentKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'incidentKey' is not null or undefined
            assertParamExists('voiceProviderPrivacyIncidentControllerReopen', 'incidentKey', incidentKey)
            const localVarPath = `/api/voice-platform/provider-privacy-incidents/{incidentKey}/reopen`
                .replace(`{${"incidentKey"}}`, encodeURIComponent(String(incidentKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Odwołaj upoważnienie harmonogramu skanowania
         * @param {string} authorityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerRevokeProviderCallScanScheduleAuthority: async (authorityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorityId' is not null or undefined
            assertParamExists('voiceProviderPrivacyIncidentControllerRevokeProviderCallScanScheduleAuthority', 'authorityId', authorityId)
            const localVarPath = `/api/voice-platform/provider-privacy-incidents/provider-call-scan/schedule-authorities/{authorityId}/revocation`
                .replace(`{${"authorityId"}}`, encodeURIComponent(String(authorityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IncydentyPrywatnociDostawcyVoiceApi - functional programming interface
 * @export
 */
export const IncydentyPrywatnociDostawcyVoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IncydentyPrywatnociDostawcyVoiceApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Aktywuj zatwierdzone upoważnienie dla dokładnej rewizji wdrożenia
         * @param {string} authorityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProviderPrivacyIncidentControllerActivateProviderCallScanScheduleAuthority(authorityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProviderCallScanScheduleAuthorityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProviderPrivacyIncidentControllerActivateProviderCallScanScheduleAuthority(authorityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zatwierdź usunięcie artefaktów jako druga osoba
         * @param {string} incidentKey
         * @param {string} proposalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProviderPrivacyIncidentControllerApprove(incidentKey: string, proposalId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProviderRemediationApprovalResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProviderPrivacyIncidentControllerApprove(incidentKey, proposalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zatwierdź upoważnienie harmonogramu jako druga osoba
         * @param {string} authorityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProviderPrivacyIncidentControllerApproveProviderCallScanScheduleAuthority(authorityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProviderCallScanScheduleAuthorityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProviderPrivacyIncidentControllerApproveProviderCallScanScheduleAuthority(authorityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz dokładne bieżące upoważnienie harmonogramu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProviderPrivacyIncidentControllerGetCurrentProviderCallScanScheduleAuthority(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProviderCallScanScheduleAuthorityReadResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProviderPrivacyIncidentControllerGetCurrentProviderCallScanScheduleAuthority(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Odzyskaj nieodwołane nieprzezroczyste upoważnienie harmonogramu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProviderPrivacyIncidentControllerGetOpenProviderCallScanScheduleAuthority(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProviderCallScanScheduleAuthorityReadResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProviderPrivacyIncidentControllerGetOpenProviderCallScanScheduleAuthority(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz wyprowadzony przez serwer zakres upoważnienia harmonogramu
         * @param {string} expiresAt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProviderPrivacyIncidentControllerGetProviderCallScanScheduleAuthorityCandidate(expiresAt: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProviderCallScanScheduleAuthorityCandidateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProviderPrivacyIncidentControllerGetProviderCallScanScheduleAuthorityCandidate(expiresAt, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz bezpieczną kolejkę incydentów prywatności dostawcy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProviderPrivacyIncidentControllerList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoiceProviderPrivacyIncidentCurrentResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProviderPrivacyIncidentControllerList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zaproponuj usunięcie dokładnego zestawu artefaktów dostawcy
         * @param {string} incidentKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProviderPrivacyIncidentControllerPropose(incidentKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProviderRemediationProposalResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProviderPrivacyIncidentControllerPropose(incidentKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zaproponuj ograniczone upoważnienie harmonogramu skanowania dostawcy
         * @param {VoiceProviderCallScanScheduleAuthorityProposalDto} voiceProviderCallScanScheduleAuthorityProposalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProviderPrivacyIncidentControllerProposeProviderCallScanScheduleAuthority(voiceProviderCallScanScheduleAuthorityProposalDto: VoiceProviderCallScanScheduleAuthorityProposalDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProviderCallScanScheduleAuthorityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProviderPrivacyIncidentControllerProposeProviderCallScanScheduleAuthority(voiceProviderCallScanScheduleAuthorityProposalDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Uruchom ograniczone uzgadnianie i usuwanie zakończonych połączeń dostawcy
         * @param {VoiceProviderCallScanCommandDto} voiceProviderCallScanCommandDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProviderPrivacyIncidentControllerReconcileProviderCalls(voiceProviderCallScanCommandDto: VoiceProviderCallScanCommandDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProviderCallScanResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProviderPrivacyIncidentControllerReconcileProviderCalls(voiceProviderCallScanCommandDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Otwórz linię po zweryfikowanej remediacji dostawcy
         * @param {string} incidentKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProviderPrivacyIncidentControllerReopen(incidentKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProviderPrivacyIncidentReopenResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProviderPrivacyIncidentControllerReopen(incidentKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Odwołaj upoważnienie harmonogramu skanowania
         * @param {string} authorityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProviderPrivacyIncidentControllerRevokeProviderCallScanScheduleAuthority(authorityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProviderCallScanScheduleAuthorityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProviderPrivacyIncidentControllerRevokeProviderCallScanScheduleAuthority(authorityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IncydentyPrywatnociDostawcyVoiceApi - factory interface
 * @export
 */
export const IncydentyPrywatnociDostawcyVoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IncydentyPrywatnociDostawcyVoiceApiFp(configuration)
    return {
        /**
         *
         * @summary Aktywuj zatwierdzone upoważnienie dla dokładnej rewizji wdrożenia
         * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerActivateProviderCallScanScheduleAuthorityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerActivateProviderCallScanScheduleAuthority(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerActivateProviderCallScanScheduleAuthorityRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceProviderCallScanScheduleAuthorityResponseDto> {
            return localVarFp.voiceProviderPrivacyIncidentControllerActivateProviderCallScanScheduleAuthority(requestParameters.authorityId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zatwierdź usunięcie artefaktów jako druga osoba
         * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerApproveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerApprove(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerApproveRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceProviderRemediationApprovalResponseDto> {
            return localVarFp.voiceProviderPrivacyIncidentControllerApprove(requestParameters.incidentKey, requestParameters.proposalId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zatwierdź upoważnienie harmonogramu jako druga osoba
         * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerApproveProviderCallScanScheduleAuthorityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerApproveProviderCallScanScheduleAuthority(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerApproveProviderCallScanScheduleAuthorityRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceProviderCallScanScheduleAuthorityResponseDto> {
            return localVarFp.voiceProviderPrivacyIncidentControllerApproveProviderCallScanScheduleAuthority(requestParameters.authorityId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz dokładne bieżące upoważnienie harmonogramu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerGetCurrentProviderCallScanScheduleAuthority(options?: AxiosRequestConfig): AxiosPromise<VoiceProviderCallScanScheduleAuthorityReadResponseDto> {
            return localVarFp.voiceProviderPrivacyIncidentControllerGetCurrentProviderCallScanScheduleAuthority(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Odzyskaj nieodwołane nieprzezroczyste upoważnienie harmonogramu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerGetOpenProviderCallScanScheduleAuthority(options?: AxiosRequestConfig): AxiosPromise<VoiceProviderCallScanScheduleAuthorityReadResponseDto> {
            return localVarFp.voiceProviderPrivacyIncidentControllerGetOpenProviderCallScanScheduleAuthority(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz wyprowadzony przez serwer zakres upoważnienia harmonogramu
         * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerGetProviderCallScanScheduleAuthorityCandidateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerGetProviderCallScanScheduleAuthorityCandidate(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerGetProviderCallScanScheduleAuthorityCandidateRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceProviderCallScanScheduleAuthorityCandidateResponseDto> {
            return localVarFp.voiceProviderPrivacyIncidentControllerGetProviderCallScanScheduleAuthorityCandidate(requestParameters.expiresAt, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz bezpieczną kolejkę incydentów prywatności dostawcy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerList(options?: AxiosRequestConfig): AxiosPromise<Array<VoiceProviderPrivacyIncidentCurrentResponseDto>> {
            return localVarFp.voiceProviderPrivacyIncidentControllerList(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zaproponuj usunięcie dokładnego zestawu artefaktów dostawcy
         * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerProposeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerPropose(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerProposeRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceProviderRemediationProposalResponseDto> {
            return localVarFp.voiceProviderPrivacyIncidentControllerPropose(requestParameters.incidentKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zaproponuj ograniczone upoważnienie harmonogramu skanowania dostawcy
         * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerProposeProviderCallScanScheduleAuthorityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerProposeProviderCallScanScheduleAuthority(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerProposeProviderCallScanScheduleAuthorityRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceProviderCallScanScheduleAuthorityResponseDto> {
            return localVarFp.voiceProviderPrivacyIncidentControllerProposeProviderCallScanScheduleAuthority(requestParameters.voiceProviderCallScanScheduleAuthorityProposalDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Uruchom ograniczone uzgadnianie i usuwanie zakończonych połączeń dostawcy
         * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerReconcileProviderCallsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerReconcileProviderCalls(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerReconcileProviderCallsRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceProviderCallScanResponseDto> {
            return localVarFp.voiceProviderPrivacyIncidentControllerReconcileProviderCalls(requestParameters.voiceProviderCallScanCommandDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Otwórz linię po zweryfikowanej remediacji dostawcy
         * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerReopenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerReopen(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerReopenRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceProviderPrivacyIncidentReopenResponseDto> {
            return localVarFp.voiceProviderPrivacyIncidentControllerReopen(requestParameters.incidentKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Odwołaj upoważnienie harmonogramu skanowania
         * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerRevokeProviderCallScanScheduleAuthorityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProviderPrivacyIncidentControllerRevokeProviderCallScanScheduleAuthority(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerRevokeProviderCallScanScheduleAuthorityRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceProviderCallScanScheduleAuthorityResponseDto> {
            return localVarFp.voiceProviderPrivacyIncidentControllerRevokeProviderCallScanScheduleAuthority(requestParameters.authorityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceProviderPrivacyIncidentControllerActivateProviderCallScanScheduleAuthority operation in IncydentyPrywatnociDostawcyVoiceApi.
 * @export
 * @interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerActivateProviderCallScanScheduleAuthorityRequest
 */
export interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerActivateProviderCallScanScheduleAuthorityRequest {
    /**
     *
     * @type {string}
     * @memberof IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerActivateProviderCallScanScheduleAuthority
     */
    readonly authorityId: string
}

/**
 * Request parameters for voiceProviderPrivacyIncidentControllerApprove operation in IncydentyPrywatnociDostawcyVoiceApi.
 * @export
 * @interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerApproveRequest
 */
export interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerApproveRequest {
    /**
     *
     * @type {string}
     * @memberof IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerApprove
     */
    readonly incidentKey: string

    /**
     *
     * @type {string}
     * @memberof IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerApprove
     */
    readonly proposalId: string
}

/**
 * Request parameters for voiceProviderPrivacyIncidentControllerApproveProviderCallScanScheduleAuthority operation in IncydentyPrywatnociDostawcyVoiceApi.
 * @export
 * @interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerApproveProviderCallScanScheduleAuthorityRequest
 */
export interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerApproveProviderCallScanScheduleAuthorityRequest {
    /**
     *
     * @type {string}
     * @memberof IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerApproveProviderCallScanScheduleAuthority
     */
    readonly authorityId: string
}

/**
 * Request parameters for voiceProviderPrivacyIncidentControllerGetProviderCallScanScheduleAuthorityCandidate operation in IncydentyPrywatnociDostawcyVoiceApi.
 * @export
 * @interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerGetProviderCallScanScheduleAuthorityCandidateRequest
 */
export interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerGetProviderCallScanScheduleAuthorityCandidateRequest {
    /**
     *
     * @type {string}
     * @memberof IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerGetProviderCallScanScheduleAuthorityCandidate
     */
    readonly expiresAt: string
}

/**
 * Request parameters for voiceProviderPrivacyIncidentControllerPropose operation in IncydentyPrywatnociDostawcyVoiceApi.
 * @export
 * @interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerProposeRequest
 */
export interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerProposeRequest {
    /**
     *
     * @type {string}
     * @memberof IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerPropose
     */
    readonly incidentKey: string
}

/**
 * Request parameters for voiceProviderPrivacyIncidentControllerProposeProviderCallScanScheduleAuthority operation in IncydentyPrywatnociDostawcyVoiceApi.
 * @export
 * @interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerProposeProviderCallScanScheduleAuthorityRequest
 */
export interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerProposeProviderCallScanScheduleAuthorityRequest {
    /**
     *
     * @type {VoiceProviderCallScanScheduleAuthorityProposalDto}
     * @memberof IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerProposeProviderCallScanScheduleAuthority
     */
    readonly voiceProviderCallScanScheduleAuthorityProposalDto: VoiceProviderCallScanScheduleAuthorityProposalDto
}

/**
 * Request parameters for voiceProviderPrivacyIncidentControllerReconcileProviderCalls operation in IncydentyPrywatnociDostawcyVoiceApi.
 * @export
 * @interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerReconcileProviderCallsRequest
 */
export interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerReconcileProviderCallsRequest {
    /**
     *
     * @type {VoiceProviderCallScanCommandDto}
     * @memberof IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerReconcileProviderCalls
     */
    readonly voiceProviderCallScanCommandDto: VoiceProviderCallScanCommandDto
}

/**
 * Request parameters for voiceProviderPrivacyIncidentControllerReopen operation in IncydentyPrywatnociDostawcyVoiceApi.
 * @export
 * @interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerReopenRequest
 */
export interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerReopenRequest {
    /**
     *
     * @type {string}
     * @memberof IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerReopen
     */
    readonly incidentKey: string
}

/**
 * Request parameters for voiceProviderPrivacyIncidentControllerRevokeProviderCallScanScheduleAuthority operation in IncydentyPrywatnociDostawcyVoiceApi.
 * @export
 * @interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerRevokeProviderCallScanScheduleAuthorityRequest
 */
export interface IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerRevokeProviderCallScanScheduleAuthorityRequest {
    /**
     *
     * @type {string}
     * @memberof IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerRevokeProviderCallScanScheduleAuthority
     */
    readonly authorityId: string
}

/**
 * IncydentyPrywatnociDostawcyVoiceApi - object-oriented interface
 * @export
 * @class IncydentyPrywatnociDostawcyVoiceApi
 * @extends {BaseAPI}
 */
export class IncydentyPrywatnociDostawcyVoiceApi extends BaseAPI {
    /**
     *
     * @summary Aktywuj zatwierdzone upoważnienie dla dokładnej rewizji wdrożenia
     * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerActivateProviderCallScanScheduleAuthorityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncydentyPrywatnociDostawcyVoiceApi
     */
    public voiceProviderPrivacyIncidentControllerActivateProviderCallScanScheduleAuthority(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerActivateProviderCallScanScheduleAuthorityRequest, options?: AxiosRequestConfig) {
        return IncydentyPrywatnociDostawcyVoiceApiFp(this.configuration).voiceProviderPrivacyIncidentControllerActivateProviderCallScanScheduleAuthority(requestParameters.authorityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zatwierdź usunięcie artefaktów jako druga osoba
     * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerApproveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncydentyPrywatnociDostawcyVoiceApi
     */
    public voiceProviderPrivacyIncidentControllerApprove(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerApproveRequest, options?: AxiosRequestConfig) {
        return IncydentyPrywatnociDostawcyVoiceApiFp(this.configuration).voiceProviderPrivacyIncidentControllerApprove(requestParameters.incidentKey, requestParameters.proposalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zatwierdź upoważnienie harmonogramu jako druga osoba
     * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerApproveProviderCallScanScheduleAuthorityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncydentyPrywatnociDostawcyVoiceApi
     */
    public voiceProviderPrivacyIncidentControllerApproveProviderCallScanScheduleAuthority(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerApproveProviderCallScanScheduleAuthorityRequest, options?: AxiosRequestConfig) {
        return IncydentyPrywatnociDostawcyVoiceApiFp(this.configuration).voiceProviderPrivacyIncidentControllerApproveProviderCallScanScheduleAuthority(requestParameters.authorityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz dokładne bieżące upoważnienie harmonogramu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncydentyPrywatnociDostawcyVoiceApi
     */
    public voiceProviderPrivacyIncidentControllerGetCurrentProviderCallScanScheduleAuthority(options?: AxiosRequestConfig) {
        return IncydentyPrywatnociDostawcyVoiceApiFp(this.configuration).voiceProviderPrivacyIncidentControllerGetCurrentProviderCallScanScheduleAuthority(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Odzyskaj nieodwołane nieprzezroczyste upoważnienie harmonogramu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncydentyPrywatnociDostawcyVoiceApi
     */
    public voiceProviderPrivacyIncidentControllerGetOpenProviderCallScanScheduleAuthority(options?: AxiosRequestConfig) {
        return IncydentyPrywatnociDostawcyVoiceApiFp(this.configuration).voiceProviderPrivacyIncidentControllerGetOpenProviderCallScanScheduleAuthority(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz wyprowadzony przez serwer zakres upoważnienia harmonogramu
     * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerGetProviderCallScanScheduleAuthorityCandidateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncydentyPrywatnociDostawcyVoiceApi
     */
    public voiceProviderPrivacyIncidentControllerGetProviderCallScanScheduleAuthorityCandidate(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerGetProviderCallScanScheduleAuthorityCandidateRequest, options?: AxiosRequestConfig) {
        return IncydentyPrywatnociDostawcyVoiceApiFp(this.configuration).voiceProviderPrivacyIncidentControllerGetProviderCallScanScheduleAuthorityCandidate(requestParameters.expiresAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz bezpieczną kolejkę incydentów prywatności dostawcy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncydentyPrywatnociDostawcyVoiceApi
     */
    public voiceProviderPrivacyIncidentControllerList(options?: AxiosRequestConfig) {
        return IncydentyPrywatnociDostawcyVoiceApiFp(this.configuration).voiceProviderPrivacyIncidentControllerList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zaproponuj usunięcie dokładnego zestawu artefaktów dostawcy
     * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerProposeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncydentyPrywatnociDostawcyVoiceApi
     */
    public voiceProviderPrivacyIncidentControllerPropose(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerProposeRequest, options?: AxiosRequestConfig) {
        return IncydentyPrywatnociDostawcyVoiceApiFp(this.configuration).voiceProviderPrivacyIncidentControllerPropose(requestParameters.incidentKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zaproponuj ograniczone upoważnienie harmonogramu skanowania dostawcy
     * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerProposeProviderCallScanScheduleAuthorityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncydentyPrywatnociDostawcyVoiceApi
     */
    public voiceProviderPrivacyIncidentControllerProposeProviderCallScanScheduleAuthority(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerProposeProviderCallScanScheduleAuthorityRequest, options?: AxiosRequestConfig) {
        return IncydentyPrywatnociDostawcyVoiceApiFp(this.configuration).voiceProviderPrivacyIncidentControllerProposeProviderCallScanScheduleAuthority(requestParameters.voiceProviderCallScanScheduleAuthorityProposalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Uruchom ograniczone uzgadnianie i usuwanie zakończonych połączeń dostawcy
     * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerReconcileProviderCallsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncydentyPrywatnociDostawcyVoiceApi
     */
    public voiceProviderPrivacyIncidentControllerReconcileProviderCalls(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerReconcileProviderCallsRequest, options?: AxiosRequestConfig) {
        return IncydentyPrywatnociDostawcyVoiceApiFp(this.configuration).voiceProviderPrivacyIncidentControllerReconcileProviderCalls(requestParameters.voiceProviderCallScanCommandDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Otwórz linię po zweryfikowanej remediacji dostawcy
     * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerReopenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncydentyPrywatnociDostawcyVoiceApi
     */
    public voiceProviderPrivacyIncidentControllerReopen(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerReopenRequest, options?: AxiosRequestConfig) {
        return IncydentyPrywatnociDostawcyVoiceApiFp(this.configuration).voiceProviderPrivacyIncidentControllerReopen(requestParameters.incidentKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Odwołaj upoważnienie harmonogramu skanowania
     * @param {IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerRevokeProviderCallScanScheduleAuthorityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncydentyPrywatnociDostawcyVoiceApi
     */
    public voiceProviderPrivacyIncidentControllerRevokeProviderCallScanScheduleAuthority(requestParameters: IncydentyPrywatnociDostawcyVoiceApiVoiceProviderPrivacyIncidentControllerRevokeProviderCallScanScheduleAuthorityRequest, options?: AxiosRequestConfig) {
        return IncydentyPrywatnociDostawcyVoiceApiFp(this.configuration).voiceProviderPrivacyIncidentControllerRevokeProviderCallScanScheduleAuthority(requestParameters.authorityId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InternalApi - axios parameter creator
 * @export
 */
export const InternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Send the guest-verify SMS (6-digit code). Called by the public backend after it mints a verify challenge; protected by X-Internal-Token.
         * @param {SendGuestVerifySmsDto} sendGuestVerifySmsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsInternalControllerSendGuestVerify: async (sendGuestVerifySmsDto: SendGuestVerifySmsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendGuestVerifySmsDto' is not null or undefined
            assertParamExists('smsInternalControllerSendGuestVerify', 'sendGuestVerifySmsDto', sendGuestVerifySmsDto)
            const localVarPath = `/api/internal/sms/guest-verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendGuestVerifySmsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Approve a PENDING_APPROVAL guest visit (flips status to CREATED). 409 if not pending.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerApprove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('visitGuestManagementControllerApprove', 'id', id)
            const localVarPath = `/api/internal/visit/{id}/approve-by-guest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Cancel a guest visit on behalf of the visit owner (called by the public backend after GuestSessionGuard verified the session).
         * @param {string} id
         * @param {CancelByGuestDto} cancelByGuestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerCancel: async (id: string, cancelByGuestDto: CancelByGuestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('visitGuestManagementControllerCancel', 'id', id)
            // verify required parameter 'cancelByGuestDto' is not null or undefined
            assertParamExists('visitGuestManagementControllerCancel', 'cancelByGuestDto', cancelByGuestDto)
            const localVarPath = `/api/internal/visit/{id}/cancel-by-guest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelByGuestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a reminder bound to the guest visit. 404 if the reminder is not bound to this visit.
         * @param {string} id
         * @param {string} reminderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerDeleteReminderByGuest: async (id: string, reminderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('visitGuestManagementControllerDeleteReminderByGuest', 'id', id)
            // verify required parameter 'reminderId' is not null or undefined
            assertParamExists('visitGuestManagementControllerDeleteReminderByGuest', 'reminderId', reminderId)
            const localVarPath = `/api/internal/visit/{id}/reminders-by-guest/{reminderId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"reminderId"}}`, encodeURIComponent(String(reminderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retry a failed guest payment (session-gated mirror). 400 if not a guest visit or payment not in FAILED state.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerPaymentRetryByGuest: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('visitGuestManagementControllerPaymentRetryByGuest', 'id', id)
            const localVarPath = `/api/internal/visit/{id}/payment-retry-by-guest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Submit a rating for the guest visit. 400 if not a guest or not completed; 409 if already rated.
         * @param {string} id
         * @param {RateByGuestDto} rateByGuestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerRateByGuest: async (id: string, rateByGuestDto: RateByGuestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('visitGuestManagementControllerRateByGuest', 'id', id)
            // verify required parameter 'rateByGuestDto' is not null or undefined
            assertParamExists('visitGuestManagementControllerRateByGuest', 'rateByGuestDto', rateByGuestDto)
            const localVarPath = `/api/internal/visit/{id}/rate-by-guest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rateByGuestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reject a PENDING_APPROVAL guest visit (flips status to REJECTED). Sessions are revoked (terminal status). 409 if not pending.
         * @param {string} id
         * @param {RejectByGuestDto} rejectByGuestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerReject: async (id: string, rejectByGuestDto: RejectByGuestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('visitGuestManagementControllerReject', 'id', id)
            // verify required parameter 'rejectByGuestDto' is not null or undefined
            assertParamExists('visitGuestManagementControllerReject', 'rejectByGuestDto', rejectByGuestDto)
            const localVarPath = `/api/internal/visit/{id}/reject-by-guest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectByGuestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reschedule a guest visit. Sessions are NOT revoked (same visit, new time).
         * @param {string} id
         * @param {RescheduleByGuestDto} rescheduleByGuestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerReschedule: async (id: string, rescheduleByGuestDto: RescheduleByGuestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('visitGuestManagementControllerReschedule', 'id', id)
            // verify required parameter 'rescheduleByGuestDto' is not null or undefined
            assertParamExists('visitGuestManagementControllerReschedule', 'rescheduleByGuestDto', rescheduleByGuestDto)
            const localVarPath = `/api/internal/visit/{id}/reschedule-by-guest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescheduleByGuestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch the visit description and attached documents on a guest visit. Rejects if the visit is account-backed.
         * @param {string} id
         * @param {UpdateVisitDetailsDto} updateVisitDetailsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerUpdateDetailsByGuest: async (id: string, updateVisitDetailsDto: UpdateVisitDetailsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('visitGuestManagementControllerUpdateDetailsByGuest', 'id', id)
            // verify required parameter 'updateVisitDetailsDto' is not null or undefined
            assertParamExists('visitGuestManagementControllerUpdateDetailsByGuest', 'updateVisitDetailsDto', updateVisitDetailsDto)
            const localVarPath = `/api/internal/visit/{id}/details-by-guest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVisitDetailsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch the visit-embedded pet profileData on a guest visit. Rejects if the visit is linked to a Profile.
         * @param {string} id
         * @param {UpdateVisitProfileDataDto} updateVisitProfileDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerUpdateProfileDataByGuest: async (id: string, updateVisitProfileDataDto: UpdateVisitProfileDataDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('visitGuestManagementControllerUpdateProfileDataByGuest', 'id', id)
            // verify required parameter 'updateVisitProfileDataDto' is not null or undefined
            assertParamExists('visitGuestManagementControllerUpdateProfileDataByGuest', 'updateVisitProfileDataDto', updateVisitProfileDataDto)
            const localVarPath = `/api/internal/visit/{id}/profile-data-by-guest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVisitProfileDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a reminder bound to the guest visit. 404 if the reminder is not bound to this visit.
         * @param {string} id
         * @param {string} reminderId
         * @param {UpdateReminderByGuestDto} updateReminderByGuestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerUpdateReminderByGuest: async (id: string, reminderId: string, updateReminderByGuestDto: UpdateReminderByGuestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('visitGuestManagementControllerUpdateReminderByGuest', 'id', id)
            // verify required parameter 'reminderId' is not null or undefined
            assertParamExists('visitGuestManagementControllerUpdateReminderByGuest', 'reminderId', reminderId)
            // verify required parameter 'updateReminderByGuestDto' is not null or undefined
            assertParamExists('visitGuestManagementControllerUpdateReminderByGuest', 'updateReminderByGuestDto', updateReminderByGuestDto)
            const localVarPath = `/api/internal/visit/{id}/reminders-by-guest/{reminderId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"reminderId"}}`, encodeURIComponent(String(reminderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReminderByGuestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch the visit-embedded owner userData on a guest visit. Rejects if the visit is account-backed (has userId).
         * @param {string} id
         * @param {UpdateVisitUserDataDto} updateVisitUserDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerUpdateUserDataByGuest: async (id: string, updateVisitUserDataDto: UpdateVisitUserDataDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('visitGuestManagementControllerUpdateUserDataByGuest', 'id', id)
            // verify required parameter 'updateVisitUserDataDto' is not null or undefined
            assertParamExists('visitGuestManagementControllerUpdateUserDataByGuest', 'updateVisitUserDataDto', updateVisitUserDataDto)
            const localVarPath = `/api/internal/visit/{id}/user-data-by-guest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVisitUserDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Twilio video token for the guest visit. 404 if the professional has not started the room yet.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerVideoTokenByGuest: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('visitGuestManagementControllerVideoTokenByGuest', 'id', id)
            const localVarPath = `/api/internal/visit/{id}/video-token-by-guest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Schedule a visit on behalf of an unauthenticated guest or a freshly created account. Called by the public backend; protected by X-Internal-Token.
         * @param {string} xBookingIdempotencyKey
         * @param {string} xBookingPayloadHash
         * @param {string} xGuestConfirmedContactChannel
         * @param {string} xGuestConfirmedContactHash
         * @param {InternalScheduleVisitDto} internalScheduleVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitInternalControllerSchedule: async (xBookingIdempotencyKey: string, xBookingPayloadHash: string, xGuestConfirmedContactChannel: string, xGuestConfirmedContactHash: string, internalScheduleVisitDto: InternalScheduleVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xBookingIdempotencyKey' is not null or undefined
            assertParamExists('visitInternalControllerSchedule', 'xBookingIdempotencyKey', xBookingIdempotencyKey)
            // verify required parameter 'xBookingPayloadHash' is not null or undefined
            assertParamExists('visitInternalControllerSchedule', 'xBookingPayloadHash', xBookingPayloadHash)
            // verify required parameter 'xGuestConfirmedContactChannel' is not null or undefined
            assertParamExists('visitInternalControllerSchedule', 'xGuestConfirmedContactChannel', xGuestConfirmedContactChannel)
            // verify required parameter 'xGuestConfirmedContactHash' is not null or undefined
            assertParamExists('visitInternalControllerSchedule', 'xGuestConfirmedContactHash', xGuestConfirmedContactHash)
            // verify required parameter 'internalScheduleVisitDto' is not null or undefined
            assertParamExists('visitInternalControllerSchedule', 'internalScheduleVisitDto', internalScheduleVisitDto)
            const localVarPath = `/api/internal/visit/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xBookingIdempotencyKey != null) {
                localVarHeaderParameter['x-booking-idempotency-key'] = String(xBookingIdempotencyKey);
            }

            if (xBookingPayloadHash != null) {
                localVarHeaderParameter['x-booking-payload-hash'] = String(xBookingPayloadHash);
            }

            if (xGuestConfirmedContactChannel != null) {
                localVarHeaderParameter['x-guest-confirmed-contact-channel'] = String(xGuestConfirmedContactChannel);
            }

            if (xGuestConfirmedContactHash != null) {
                localVarHeaderParameter['x-guest-confirmed-contact-hash'] = String(xGuestConfirmedContactHash);
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(internalScheduleVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalApi - functional programming interface
 * @export
 */
export const InternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Send the guest-verify SMS (6-digit code). Called by the public backend after it mints a verify challenge; protected by X-Internal-Token.
         * @param {SendGuestVerifySmsDto} sendGuestVerifySmsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async smsInternalControllerSendGuestVerify(sendGuestVerifySmsDto: SendGuestVerifySmsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.smsInternalControllerSendGuestVerify(sendGuestVerifySmsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Approve a PENDING_APPROVAL guest visit (flips status to CREATED). 409 if not pending.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementControllerApprove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementControllerApprove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Cancel a guest visit on behalf of the visit owner (called by the public backend after GuestSessionGuard verified the session).
         * @param {string} id
         * @param {CancelByGuestDto} cancelByGuestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementControllerCancel(id: string, cancelByGuestDto: CancelByGuestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementControllerCancel(id, cancelByGuestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a reminder bound to the guest visit. 404 if the reminder is not bound to this visit.
         * @param {string} id
         * @param {string} reminderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementControllerDeleteReminderByGuest(id: string, reminderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementControllerDeleteReminderByGuest(id, reminderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Retry a failed guest payment (session-gated mirror). 400 if not a guest visit or payment not in FAILED state.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementControllerPaymentRetryByGuest(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementControllerPaymentRetryByGuest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Submit a rating for the guest visit. 400 if not a guest or not completed; 409 if already rated.
         * @param {string} id
         * @param {RateByGuestDto} rateByGuestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementControllerRateByGuest(id: string, rateByGuestDto: RateByGuestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementControllerRateByGuest(id, rateByGuestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Reject a PENDING_APPROVAL guest visit (flips status to REJECTED). Sessions are revoked (terminal status). 409 if not pending.
         * @param {string} id
         * @param {RejectByGuestDto} rejectByGuestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementControllerReject(id: string, rejectByGuestDto: RejectByGuestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementControllerReject(id, rejectByGuestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Reschedule a guest visit. Sessions are NOT revoked (same visit, new time).
         * @param {string} id
         * @param {RescheduleByGuestDto} rescheduleByGuestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementControllerReschedule(id: string, rescheduleByGuestDto: RescheduleByGuestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementControllerReschedule(id, rescheduleByGuestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch the visit description and attached documents on a guest visit. Rejects if the visit is account-backed.
         * @param {string} id
         * @param {UpdateVisitDetailsDto} updateVisitDetailsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementControllerUpdateDetailsByGuest(id: string, updateVisitDetailsDto: UpdateVisitDetailsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementControllerUpdateDetailsByGuest(id, updateVisitDetailsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch the visit-embedded pet profileData on a guest visit. Rejects if the visit is linked to a Profile.
         * @param {string} id
         * @param {UpdateVisitProfileDataDto} updateVisitProfileDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementControllerUpdateProfileDataByGuest(id: string, updateVisitProfileDataDto: UpdateVisitProfileDataDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementControllerUpdateProfileDataByGuest(id, updateVisitProfileDataDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update a reminder bound to the guest visit. 404 if the reminder is not bound to this visit.
         * @param {string} id
         * @param {string} reminderId
         * @param {UpdateReminderByGuestDto} updateReminderByGuestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementControllerUpdateReminderByGuest(id: string, reminderId: string, updateReminderByGuestDto: UpdateReminderByGuestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementControllerUpdateReminderByGuest(id, reminderId, updateReminderByGuestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch the visit-embedded owner userData on a guest visit. Rejects if the visit is account-backed (has userId).
         * @param {string} id
         * @param {UpdateVisitUserDataDto} updateVisitUserDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementControllerUpdateUserDataByGuest(id: string, updateVisitUserDataDto: UpdateVisitUserDataDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementControllerUpdateUserDataByGuest(id, updateVisitUserDataDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Twilio video token for the guest visit. 404 if the professional has not started the room yet.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementControllerVideoTokenByGuest(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementControllerVideoTokenByGuest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Schedule a visit on behalf of an unauthenticated guest or a freshly created account. Called by the public backend; protected by X-Internal-Token.
         * @param {string} xBookingIdempotencyKey
         * @param {string} xBookingPayloadHash
         * @param {string} xGuestConfirmedContactChannel
         * @param {string} xGuestConfirmedContactHash
         * @param {InternalScheduleVisitDto} internalScheduleVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitInternalControllerSchedule(xBookingIdempotencyKey: string, xBookingPayloadHash: string, xGuestConfirmedContactChannel: string, xGuestConfirmedContactHash: string, internalScheduleVisitDto: InternalScheduleVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalScheduleVisitResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitInternalControllerSchedule(xBookingIdempotencyKey, xBookingPayloadHash, xGuestConfirmedContactChannel, xGuestConfirmedContactHash, internalScheduleVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InternalApi - factory interface
 * @export
 */
export const InternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalApiFp(configuration)
    return {
        /**
         *
         * @summary Send the guest-verify SMS (6-digit code). Called by the public backend after it mints a verify challenge; protected by X-Internal-Token.
         * @param {InternalApiSmsInternalControllerSendGuestVerifyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsInternalControllerSendGuestVerify(requestParameters: InternalApiSmsInternalControllerSendGuestVerifyRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.smsInternalControllerSendGuestVerify(requestParameters.sendGuestVerifySmsDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Approve a PENDING_APPROVAL guest visit (flips status to CREATED). 409 if not pending.
         * @param {InternalApiVisitGuestManagementControllerApproveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerApprove(requestParameters: InternalApiVisitGuestManagementControllerApproveRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementControllerApprove(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cancel a guest visit on behalf of the visit owner (called by the public backend after GuestSessionGuard verified the session).
         * @param {InternalApiVisitGuestManagementControllerCancelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerCancel(requestParameters: InternalApiVisitGuestManagementControllerCancelRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementControllerCancel(requestParameters.id, requestParameters.cancelByGuestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a reminder bound to the guest visit. 404 if the reminder is not bound to this visit.
         * @param {InternalApiVisitGuestManagementControllerDeleteReminderByGuestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerDeleteReminderByGuest(requestParameters: InternalApiVisitGuestManagementControllerDeleteReminderByGuestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementControllerDeleteReminderByGuest(requestParameters.id, requestParameters.reminderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retry a failed guest payment (session-gated mirror). 400 if not a guest visit or payment not in FAILED state.
         * @param {InternalApiVisitGuestManagementControllerPaymentRetryByGuestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerPaymentRetryByGuest(requestParameters: InternalApiVisitGuestManagementControllerPaymentRetryByGuestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementControllerPaymentRetryByGuest(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Submit a rating for the guest visit. 400 if not a guest or not completed; 409 if already rated.
         * @param {InternalApiVisitGuestManagementControllerRateByGuestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerRateByGuest(requestParameters: InternalApiVisitGuestManagementControllerRateByGuestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementControllerRateByGuest(requestParameters.id, requestParameters.rateByGuestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reject a PENDING_APPROVAL guest visit (flips status to REJECTED). Sessions are revoked (terminal status). 409 if not pending.
         * @param {InternalApiVisitGuestManagementControllerRejectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerReject(requestParameters: InternalApiVisitGuestManagementControllerRejectRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementControllerReject(requestParameters.id, requestParameters.rejectByGuestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reschedule a guest visit. Sessions are NOT revoked (same visit, new time).
         * @param {InternalApiVisitGuestManagementControllerRescheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerReschedule(requestParameters: InternalApiVisitGuestManagementControllerRescheduleRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementControllerReschedule(requestParameters.id, requestParameters.rescheduleByGuestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch the visit description and attached documents on a guest visit. Rejects if the visit is account-backed.
         * @param {InternalApiVisitGuestManagementControllerUpdateDetailsByGuestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerUpdateDetailsByGuest(requestParameters: InternalApiVisitGuestManagementControllerUpdateDetailsByGuestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementControllerUpdateDetailsByGuest(requestParameters.id, requestParameters.updateVisitDetailsDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch the visit-embedded pet profileData on a guest visit. Rejects if the visit is linked to a Profile.
         * @param {InternalApiVisitGuestManagementControllerUpdateProfileDataByGuestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerUpdateProfileDataByGuest(requestParameters: InternalApiVisitGuestManagementControllerUpdateProfileDataByGuestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementControllerUpdateProfileDataByGuest(requestParameters.id, requestParameters.updateVisitProfileDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a reminder bound to the guest visit. 404 if the reminder is not bound to this visit.
         * @param {InternalApiVisitGuestManagementControllerUpdateReminderByGuestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerUpdateReminderByGuest(requestParameters: InternalApiVisitGuestManagementControllerUpdateReminderByGuestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementControllerUpdateReminderByGuest(requestParameters.id, requestParameters.reminderId, requestParameters.updateReminderByGuestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch the visit-embedded owner userData on a guest visit. Rejects if the visit is account-backed (has userId).
         * @param {InternalApiVisitGuestManagementControllerUpdateUserDataByGuestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerUpdateUserDataByGuest(requestParameters: InternalApiVisitGuestManagementControllerUpdateUserDataByGuestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementControllerUpdateUserDataByGuest(requestParameters.id, requestParameters.updateVisitUserDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Twilio video token for the guest visit. 404 if the professional has not started the room yet.
         * @param {InternalApiVisitGuestManagementControllerVideoTokenByGuestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementControllerVideoTokenByGuest(requestParameters: InternalApiVisitGuestManagementControllerVideoTokenByGuestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementControllerVideoTokenByGuest(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Schedule a visit on behalf of an unauthenticated guest or a freshly created account. Called by the public backend; protected by X-Internal-Token.
         * @param {InternalApiVisitInternalControllerScheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitInternalControllerSchedule(requestParameters: InternalApiVisitInternalControllerScheduleRequest, options?: AxiosRequestConfig): AxiosPromise<InternalScheduleVisitResponseDto> {
            return localVarFp.visitInternalControllerSchedule(requestParameters.xBookingIdempotencyKey, requestParameters.xBookingPayloadHash, requestParameters.xGuestConfirmedContactChannel, requestParameters.xGuestConfirmedContactHash, requestParameters.internalScheduleVisitDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for smsInternalControllerSendGuestVerify operation in InternalApi.
 * @export
 * @interface InternalApiSmsInternalControllerSendGuestVerifyRequest
 */
export interface InternalApiSmsInternalControllerSendGuestVerifyRequest {
    /**
     *
     * @type {SendGuestVerifySmsDto}
     * @memberof InternalApiSmsInternalControllerSendGuestVerify
     */
    readonly sendGuestVerifySmsDto: SendGuestVerifySmsDto
}

/**
 * Request parameters for visitGuestManagementControllerApprove operation in InternalApi.
 * @export
 * @interface InternalApiVisitGuestManagementControllerApproveRequest
 */
export interface InternalApiVisitGuestManagementControllerApproveRequest {
    /**
     *
     * @type {string}
     * @memberof InternalApiVisitGuestManagementControllerApprove
     */
    readonly id: string
}

/**
 * Request parameters for visitGuestManagementControllerCancel operation in InternalApi.
 * @export
 * @interface InternalApiVisitGuestManagementControllerCancelRequest
 */
export interface InternalApiVisitGuestManagementControllerCancelRequest {
    /**
     *
     * @type {string}
     * @memberof InternalApiVisitGuestManagementControllerCancel
     */
    readonly id: string

    /**
     *
     * @type {CancelByGuestDto}
     * @memberof InternalApiVisitGuestManagementControllerCancel
     */
    readonly cancelByGuestDto: CancelByGuestDto
}

/**
 * Request parameters for visitGuestManagementControllerDeleteReminderByGuest operation in InternalApi.
 * @export
 * @interface InternalApiVisitGuestManagementControllerDeleteReminderByGuestRequest
 */
export interface InternalApiVisitGuestManagementControllerDeleteReminderByGuestRequest {
    /**
     *
     * @type {string}
     * @memberof InternalApiVisitGuestManagementControllerDeleteReminderByGuest
     */
    readonly id: string

    /**
     *
     * @type {string}
     * @memberof InternalApiVisitGuestManagementControllerDeleteReminderByGuest
     */
    readonly reminderId: string
}

/**
 * Request parameters for visitGuestManagementControllerPaymentRetryByGuest operation in InternalApi.
 * @export
 * @interface InternalApiVisitGuestManagementControllerPaymentRetryByGuestRequest
 */
export interface InternalApiVisitGuestManagementControllerPaymentRetryByGuestRequest {
    /**
     *
     * @type {string}
     * @memberof InternalApiVisitGuestManagementControllerPaymentRetryByGuest
     */
    readonly id: string
}

/**
 * Request parameters for visitGuestManagementControllerRateByGuest operation in InternalApi.
 * @export
 * @interface InternalApiVisitGuestManagementControllerRateByGuestRequest
 */
export interface InternalApiVisitGuestManagementControllerRateByGuestRequest {
    /**
     *
     * @type {string}
     * @memberof InternalApiVisitGuestManagementControllerRateByGuest
     */
    readonly id: string

    /**
     *
     * @type {RateByGuestDto}
     * @memberof InternalApiVisitGuestManagementControllerRateByGuest
     */
    readonly rateByGuestDto: RateByGuestDto
}

/**
 * Request parameters for visitGuestManagementControllerReject operation in InternalApi.
 * @export
 * @interface InternalApiVisitGuestManagementControllerRejectRequest
 */
export interface InternalApiVisitGuestManagementControllerRejectRequest {
    /**
     *
     * @type {string}
     * @memberof InternalApiVisitGuestManagementControllerReject
     */
    readonly id: string

    /**
     *
     * @type {RejectByGuestDto}
     * @memberof InternalApiVisitGuestManagementControllerReject
     */
    readonly rejectByGuestDto: RejectByGuestDto
}

/**
 * Request parameters for visitGuestManagementControllerReschedule operation in InternalApi.
 * @export
 * @interface InternalApiVisitGuestManagementControllerRescheduleRequest
 */
export interface InternalApiVisitGuestManagementControllerRescheduleRequest {
    /**
     *
     * @type {string}
     * @memberof InternalApiVisitGuestManagementControllerReschedule
     */
    readonly id: string

    /**
     *
     * @type {RescheduleByGuestDto}
     * @memberof InternalApiVisitGuestManagementControllerReschedule
     */
    readonly rescheduleByGuestDto: RescheduleByGuestDto
}

/**
 * Request parameters for visitGuestManagementControllerUpdateDetailsByGuest operation in InternalApi.
 * @export
 * @interface InternalApiVisitGuestManagementControllerUpdateDetailsByGuestRequest
 */
export interface InternalApiVisitGuestManagementControllerUpdateDetailsByGuestRequest {
    /**
     *
     * @type {string}
     * @memberof InternalApiVisitGuestManagementControllerUpdateDetailsByGuest
     */
    readonly id: string

    /**
     *
     * @type {UpdateVisitDetailsDto}
     * @memberof InternalApiVisitGuestManagementControllerUpdateDetailsByGuest
     */
    readonly updateVisitDetailsDto: UpdateVisitDetailsDto
}

/**
 * Request parameters for visitGuestManagementControllerUpdateProfileDataByGuest operation in InternalApi.
 * @export
 * @interface InternalApiVisitGuestManagementControllerUpdateProfileDataByGuestRequest
 */
export interface InternalApiVisitGuestManagementControllerUpdateProfileDataByGuestRequest {
    /**
     *
     * @type {string}
     * @memberof InternalApiVisitGuestManagementControllerUpdateProfileDataByGuest
     */
    readonly id: string

    /**
     *
     * @type {UpdateVisitProfileDataDto}
     * @memberof InternalApiVisitGuestManagementControllerUpdateProfileDataByGuest
     */
    readonly updateVisitProfileDataDto: UpdateVisitProfileDataDto
}

/**
 * Request parameters for visitGuestManagementControllerUpdateReminderByGuest operation in InternalApi.
 * @export
 * @interface InternalApiVisitGuestManagementControllerUpdateReminderByGuestRequest
 */
export interface InternalApiVisitGuestManagementControllerUpdateReminderByGuestRequest {
    /**
     *
     * @type {string}
     * @memberof InternalApiVisitGuestManagementControllerUpdateReminderByGuest
     */
    readonly id: string

    /**
     *
     * @type {string}
     * @memberof InternalApiVisitGuestManagementControllerUpdateReminderByGuest
     */
    readonly reminderId: string

    /**
     *
     * @type {UpdateReminderByGuestDto}
     * @memberof InternalApiVisitGuestManagementControllerUpdateReminderByGuest
     */
    readonly updateReminderByGuestDto: UpdateReminderByGuestDto
}

/**
 * Request parameters for visitGuestManagementControllerUpdateUserDataByGuest operation in InternalApi.
 * @export
 * @interface InternalApiVisitGuestManagementControllerUpdateUserDataByGuestRequest
 */
export interface InternalApiVisitGuestManagementControllerUpdateUserDataByGuestRequest {
    /**
     *
     * @type {string}
     * @memberof InternalApiVisitGuestManagementControllerUpdateUserDataByGuest
     */
    readonly id: string

    /**
     *
     * @type {UpdateVisitUserDataDto}
     * @memberof InternalApiVisitGuestManagementControllerUpdateUserDataByGuest
     */
    readonly updateVisitUserDataDto: UpdateVisitUserDataDto
}

/**
 * Request parameters for visitGuestManagementControllerVideoTokenByGuest operation in InternalApi.
 * @export
 * @interface InternalApiVisitGuestManagementControllerVideoTokenByGuestRequest
 */
export interface InternalApiVisitGuestManagementControllerVideoTokenByGuestRequest {
    /**
     *
     * @type {string}
     * @memberof InternalApiVisitGuestManagementControllerVideoTokenByGuest
     */
    readonly id: string
}

/**
 * Request parameters for visitInternalControllerSchedule operation in InternalApi.
 * @export
 * @interface InternalApiVisitInternalControllerScheduleRequest
 */
export interface InternalApiVisitInternalControllerScheduleRequest {
    /**
     *
     * @type {string}
     * @memberof InternalApiVisitInternalControllerSchedule
     */
    readonly xBookingIdempotencyKey: string

    /**
     *
     * @type {string}
     * @memberof InternalApiVisitInternalControllerSchedule
     */
    readonly xBookingPayloadHash: string

    /**
     *
     * @type {string}
     * @memberof InternalApiVisitInternalControllerSchedule
     */
    readonly xGuestConfirmedContactChannel: string

    /**
     *
     * @type {string}
     * @memberof InternalApiVisitInternalControllerSchedule
     */
    readonly xGuestConfirmedContactHash: string

    /**
     *
     * @type {InternalScheduleVisitDto}
     * @memberof InternalApiVisitInternalControllerSchedule
     */
    readonly internalScheduleVisitDto: InternalScheduleVisitDto
}

/**
 * InternalApi - object-oriented interface
 * @export
 * @class InternalApi
 * @extends {BaseAPI}
 */
export class InternalApi extends BaseAPI {
    /**
     *
     * @summary Send the guest-verify SMS (6-digit code). Called by the public backend after it mints a verify challenge; protected by X-Internal-Token.
     * @param {InternalApiSmsInternalControllerSendGuestVerifyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public smsInternalControllerSendGuestVerify(requestParameters: InternalApiSmsInternalControllerSendGuestVerifyRequest, options?: AxiosRequestConfig) {
        return InternalApiFp(this.configuration).smsInternalControllerSendGuestVerify(requestParameters.sendGuestVerifySmsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Approve a PENDING_APPROVAL guest visit (flips status to CREATED). 409 if not pending.
     * @param {InternalApiVisitGuestManagementControllerApproveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public visitGuestManagementControllerApprove(requestParameters: InternalApiVisitGuestManagementControllerApproveRequest, options?: AxiosRequestConfig) {
        return InternalApiFp(this.configuration).visitGuestManagementControllerApprove(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Cancel a guest visit on behalf of the visit owner (called by the public backend after GuestSessionGuard verified the session).
     * @param {InternalApiVisitGuestManagementControllerCancelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public visitGuestManagementControllerCancel(requestParameters: InternalApiVisitGuestManagementControllerCancelRequest, options?: AxiosRequestConfig) {
        return InternalApiFp(this.configuration).visitGuestManagementControllerCancel(requestParameters.id, requestParameters.cancelByGuestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete a reminder bound to the guest visit. 404 if the reminder is not bound to this visit.
     * @param {InternalApiVisitGuestManagementControllerDeleteReminderByGuestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public visitGuestManagementControllerDeleteReminderByGuest(requestParameters: InternalApiVisitGuestManagementControllerDeleteReminderByGuestRequest, options?: AxiosRequestConfig) {
        return InternalApiFp(this.configuration).visitGuestManagementControllerDeleteReminderByGuest(requestParameters.id, requestParameters.reminderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Retry a failed guest payment (session-gated mirror). 400 if not a guest visit or payment not in FAILED state.
     * @param {InternalApiVisitGuestManagementControllerPaymentRetryByGuestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public visitGuestManagementControllerPaymentRetryByGuest(requestParameters: InternalApiVisitGuestManagementControllerPaymentRetryByGuestRequest, options?: AxiosRequestConfig) {
        return InternalApiFp(this.configuration).visitGuestManagementControllerPaymentRetryByGuest(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Submit a rating for the guest visit. 400 if not a guest or not completed; 409 if already rated.
     * @param {InternalApiVisitGuestManagementControllerRateByGuestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public visitGuestManagementControllerRateByGuest(requestParameters: InternalApiVisitGuestManagementControllerRateByGuestRequest, options?: AxiosRequestConfig) {
        return InternalApiFp(this.configuration).visitGuestManagementControllerRateByGuest(requestParameters.id, requestParameters.rateByGuestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Reject a PENDING_APPROVAL guest visit (flips status to REJECTED). Sessions are revoked (terminal status). 409 if not pending.
     * @param {InternalApiVisitGuestManagementControllerRejectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public visitGuestManagementControllerReject(requestParameters: InternalApiVisitGuestManagementControllerRejectRequest, options?: AxiosRequestConfig) {
        return InternalApiFp(this.configuration).visitGuestManagementControllerReject(requestParameters.id, requestParameters.rejectByGuestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Reschedule a guest visit. Sessions are NOT revoked (same visit, new time).
     * @param {InternalApiVisitGuestManagementControllerRescheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public visitGuestManagementControllerReschedule(requestParameters: InternalApiVisitGuestManagementControllerRescheduleRequest, options?: AxiosRequestConfig) {
        return InternalApiFp(this.configuration).visitGuestManagementControllerReschedule(requestParameters.id, requestParameters.rescheduleByGuestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Patch the visit description and attached documents on a guest visit. Rejects if the visit is account-backed.
     * @param {InternalApiVisitGuestManagementControllerUpdateDetailsByGuestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public visitGuestManagementControllerUpdateDetailsByGuest(requestParameters: InternalApiVisitGuestManagementControllerUpdateDetailsByGuestRequest, options?: AxiosRequestConfig) {
        return InternalApiFp(this.configuration).visitGuestManagementControllerUpdateDetailsByGuest(requestParameters.id, requestParameters.updateVisitDetailsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Patch the visit-embedded pet profileData on a guest visit. Rejects if the visit is linked to a Profile.
     * @param {InternalApiVisitGuestManagementControllerUpdateProfileDataByGuestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public visitGuestManagementControllerUpdateProfileDataByGuest(requestParameters: InternalApiVisitGuestManagementControllerUpdateProfileDataByGuestRequest, options?: AxiosRequestConfig) {
        return InternalApiFp(this.configuration).visitGuestManagementControllerUpdateProfileDataByGuest(requestParameters.id, requestParameters.updateVisitProfileDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update a reminder bound to the guest visit. 404 if the reminder is not bound to this visit.
     * @param {InternalApiVisitGuestManagementControllerUpdateReminderByGuestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public visitGuestManagementControllerUpdateReminderByGuest(requestParameters: InternalApiVisitGuestManagementControllerUpdateReminderByGuestRequest, options?: AxiosRequestConfig) {
        return InternalApiFp(this.configuration).visitGuestManagementControllerUpdateReminderByGuest(requestParameters.id, requestParameters.reminderId, requestParameters.updateReminderByGuestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Patch the visit-embedded owner userData on a guest visit. Rejects if the visit is account-backed (has userId).
     * @param {InternalApiVisitGuestManagementControllerUpdateUserDataByGuestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public visitGuestManagementControllerUpdateUserDataByGuest(requestParameters: InternalApiVisitGuestManagementControllerUpdateUserDataByGuestRequest, options?: AxiosRequestConfig) {
        return InternalApiFp(this.configuration).visitGuestManagementControllerUpdateUserDataByGuest(requestParameters.id, requestParameters.updateVisitUserDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get a Twilio video token for the guest visit. 404 if the professional has not started the room yet.
     * @param {InternalApiVisitGuestManagementControllerVideoTokenByGuestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public visitGuestManagementControllerVideoTokenByGuest(requestParameters: InternalApiVisitGuestManagementControllerVideoTokenByGuestRequest, options?: AxiosRequestConfig) {
        return InternalApiFp(this.configuration).visitGuestManagementControllerVideoTokenByGuest(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Schedule a visit on behalf of an unauthenticated guest or a freshly created account. Called by the public backend; protected by X-Internal-Token.
     * @param {InternalApiVisitInternalControllerScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public visitInternalControllerSchedule(requestParameters: InternalApiVisitInternalControllerScheduleRequest, options?: AxiosRequestConfig) {
        return InternalApiFp(this.configuration).visitInternalControllerSchedule(requestParameters.xBookingIdempotencyKey, requestParameters.xBookingPayloadHash, requestParameters.xGuestConfirmedContactChannel, requestParameters.xGuestConfirmedContactHash, requestParameters.internalScheduleVisitDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InternalVoiceSecurityTriggersApi - axios parameter creator
 * @export
 */
export const InternalVoiceSecurityTriggersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Revoke a security-trigger receipt durably
         * @param {string} xVoiceInternalToken
         * @param {RevokeVoiceSecurityTriggerReceiptDto} revokeVoiceSecurityTriggerReceiptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceSecurityTriggerInternalControllerRevoke: async (xVoiceInternalToken: string, revokeVoiceSecurityTriggerReceiptDto: RevokeVoiceSecurityTriggerReceiptDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xVoiceInternalToken' is not null or undefined
            assertParamExists('voiceSecurityTriggerInternalControllerRevoke', 'xVoiceInternalToken', xVoiceInternalToken)
            // verify required parameter 'revokeVoiceSecurityTriggerReceiptDto' is not null or undefined
            assertParamExists('voiceSecurityTriggerInternalControllerRevoke', 'revokeVoiceSecurityTriggerReceiptDto', revokeVoiceSecurityTriggerReceiptDto)
            const localVarPath = `/api/internal/voice/security/receipt-revocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xVoiceInternalToken != null) {
                localVarHeaderParameter['x-voice-internal-token'] = String(xVoiceInternalToken);
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(revokeVoiceSecurityTriggerReceiptDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Terminate sessions using a signed trigger
         * @param {string} xVoiceInternalToken
         * @param {SignedVoiceSecurityTriggerReceiptDto} signedVoiceSecurityTriggerReceiptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceSecurityTriggerInternalControllerTerminate: async (xVoiceInternalToken: string, signedVoiceSecurityTriggerReceiptDto: SignedVoiceSecurityTriggerReceiptDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xVoiceInternalToken' is not null or undefined
            assertParamExists('voiceSecurityTriggerInternalControllerTerminate', 'xVoiceInternalToken', xVoiceInternalToken)
            // verify required parameter 'signedVoiceSecurityTriggerReceiptDto' is not null or undefined
            assertParamExists('voiceSecurityTriggerInternalControllerTerminate', 'signedVoiceSecurityTriggerReceiptDto', signedVoiceSecurityTriggerReceiptDto)
            const localVarPath = `/api/internal/voice/security/terminate-active-sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xVoiceInternalToken != null) {
                localVarHeaderParameter['x-voice-internal-token'] = String(xVoiceInternalToken);
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signedVoiceSecurityTriggerReceiptDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalVoiceSecurityTriggersApi - functional programming interface
 * @export
 */
export const InternalVoiceSecurityTriggersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalVoiceSecurityTriggersApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Revoke a security-trigger receipt durably
         * @param {string} xVoiceInternalToken
         * @param {RevokeVoiceSecurityTriggerReceiptDto} revokeVoiceSecurityTriggerReceiptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceSecurityTriggerInternalControllerRevoke(xVoiceInternalToken: string, revokeVoiceSecurityTriggerReceiptDto: RevokeVoiceSecurityTriggerReceiptDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceSecurityTriggerRevocationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceSecurityTriggerInternalControllerRevoke(xVoiceInternalToken, revokeVoiceSecurityTriggerReceiptDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Terminate sessions using a signed trigger
         * @param {string} xVoiceInternalToken
         * @param {SignedVoiceSecurityTriggerReceiptDto} signedVoiceSecurityTriggerReceiptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceSecurityTriggerInternalControllerTerminate(xVoiceInternalToken: string, signedVoiceSecurityTriggerReceiptDto: SignedVoiceSecurityTriggerReceiptDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceSecurityTriggerTerminationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceSecurityTriggerInternalControllerTerminate(xVoiceInternalToken, signedVoiceSecurityTriggerReceiptDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InternalVoiceSecurityTriggersApi - factory interface
 * @export
 */
export const InternalVoiceSecurityTriggersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalVoiceSecurityTriggersApiFp(configuration)
    return {
        /**
         *
         * @summary Revoke a security-trigger receipt durably
         * @param {InternalVoiceSecurityTriggersApiVoiceSecurityTriggerInternalControllerRevokeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceSecurityTriggerInternalControllerRevoke(requestParameters: InternalVoiceSecurityTriggersApiVoiceSecurityTriggerInternalControllerRevokeRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceSecurityTriggerRevocationResponseDto> {
            return localVarFp.voiceSecurityTriggerInternalControllerRevoke(requestParameters.xVoiceInternalToken, requestParameters.revokeVoiceSecurityTriggerReceiptDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Terminate sessions using a signed trigger
         * @param {InternalVoiceSecurityTriggersApiVoiceSecurityTriggerInternalControllerTerminateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceSecurityTriggerInternalControllerTerminate(requestParameters: InternalVoiceSecurityTriggersApiVoiceSecurityTriggerInternalControllerTerminateRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceSecurityTriggerTerminationResponseDto> {
            return localVarFp.voiceSecurityTriggerInternalControllerTerminate(requestParameters.xVoiceInternalToken, requestParameters.signedVoiceSecurityTriggerReceiptDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceSecurityTriggerInternalControllerRevoke operation in InternalVoiceSecurityTriggersApi.
 * @export
 * @interface InternalVoiceSecurityTriggersApiVoiceSecurityTriggerInternalControllerRevokeRequest
 */
export interface InternalVoiceSecurityTriggersApiVoiceSecurityTriggerInternalControllerRevokeRequest {
    /**
     *
     * @type {string}
     * @memberof InternalVoiceSecurityTriggersApiVoiceSecurityTriggerInternalControllerRevoke
     */
    readonly xVoiceInternalToken: string

    /**
     *
     * @type {RevokeVoiceSecurityTriggerReceiptDto}
     * @memberof InternalVoiceSecurityTriggersApiVoiceSecurityTriggerInternalControllerRevoke
     */
    readonly revokeVoiceSecurityTriggerReceiptDto: RevokeVoiceSecurityTriggerReceiptDto
}

/**
 * Request parameters for voiceSecurityTriggerInternalControllerTerminate operation in InternalVoiceSecurityTriggersApi.
 * @export
 * @interface InternalVoiceSecurityTriggersApiVoiceSecurityTriggerInternalControllerTerminateRequest
 */
export interface InternalVoiceSecurityTriggersApiVoiceSecurityTriggerInternalControllerTerminateRequest {
    /**
     *
     * @type {string}
     * @memberof InternalVoiceSecurityTriggersApiVoiceSecurityTriggerInternalControllerTerminate
     */
    readonly xVoiceInternalToken: string

    /**
     *
     * @type {SignedVoiceSecurityTriggerReceiptDto}
     * @memberof InternalVoiceSecurityTriggersApiVoiceSecurityTriggerInternalControllerTerminate
     */
    readonly signedVoiceSecurityTriggerReceiptDto: SignedVoiceSecurityTriggerReceiptDto
}

/**
 * InternalVoiceSecurityTriggersApi - object-oriented interface
 * @export
 * @class InternalVoiceSecurityTriggersApi
 * @extends {BaseAPI}
 */
export class InternalVoiceSecurityTriggersApi extends BaseAPI {
    /**
     *
     * @summary Revoke a security-trigger receipt durably
     * @param {InternalVoiceSecurityTriggersApiVoiceSecurityTriggerInternalControllerRevokeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalVoiceSecurityTriggersApi
     */
    public voiceSecurityTriggerInternalControllerRevoke(requestParameters: InternalVoiceSecurityTriggersApiVoiceSecurityTriggerInternalControllerRevokeRequest, options?: AxiosRequestConfig) {
        return InternalVoiceSecurityTriggersApiFp(this.configuration).voiceSecurityTriggerInternalControllerRevoke(requestParameters.xVoiceInternalToken, requestParameters.revokeVoiceSecurityTriggerReceiptDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Terminate sessions using a signed trigger
     * @param {InternalVoiceSecurityTriggersApiVoiceSecurityTriggerInternalControllerTerminateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalVoiceSecurityTriggersApi
     */
    public voiceSecurityTriggerInternalControllerTerminate(requestParameters: InternalVoiceSecurityTriggersApiVoiceSecurityTriggerInternalControllerTerminateRequest, options?: AxiosRequestConfig) {
        return InternalVoiceSecurityTriggersApiFp(this.configuration).voiceSecurityTriggerInternalControllerTerminate(requestParameters.xVoiceInternalToken, requestParameters.signedVoiceSecurityTriggerReceiptDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InvitationApi - axios parameter creator
 * @export
 */
export const InvitationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Accept an invitation
         * @param {ProcessInvitationDto} processInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerAcceptInvitation: async (processInvitationDto: ProcessInvitationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processInvitationDto' is not null or undefined
            assertParamExists('invitationControllerAcceptInvitation', 'processInvitationDto', processInvitationDto)
            const localVarPath = `/api/invitation/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processInvitationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a new invitation
         * @param {CreateInvitationDto} createInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerCreateInvitation: async (createInvitationDto: CreateInvitationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createInvitationDto' is not null or undefined
            assertParamExists('invitationControllerCreateInvitation', 'createInvitationDto', createInvitationDto)
            const localVarPath = `/api/invitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvitationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Decline invitation
         * @param {ProcessInvitationDto} processInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerDeclineInvitation: async (processInvitationDto: ProcessInvitationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processInvitationDto' is not null or undefined
            assertParamExists('invitationControllerDeclineInvitation', 'processInvitationDto', processInvitationDto)
            const localVarPath = `/api/invitation/decline`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processInvitationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all invitations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerGetAllInvitations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/invitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get invitation by token
         * @param {string} token Invitation token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerGetInvitationByToken: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('invitationControllerGetInvitationByToken', 'token', token)
            const localVarPath = `/api/invitation/token/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get invitations by organization
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerGetInvitationsByOrganization: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('invitationControllerGetInvitationsByOrganization', 'organizationId', organizationId)
            const localVarPath = `/api/invitation/organization/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get invitations for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerGetInvitationsByUserId: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/invitation/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Resend an invitation
         * @param {string} invitationId Invitation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerResendInvitation: async (invitationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('invitationControllerResendInvitation', 'invitationId', invitationId)
            const localVarPath = `/api/invitation/{invitationId}/resend`
                .replace(`{${"invitationId"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvitationApi - functional programming interface
 * @export
 */
export const InvitationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvitationApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Accept an invitation
         * @param {ProcessInvitationDto} processInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationControllerAcceptInvitation(processInvitationDto: ProcessInvitationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationControllerAcceptInvitation(processInvitationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Create a new invitation
         * @param {CreateInvitationDto} createInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationControllerCreateInvitation(createInvitationDto: CreateInvitationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationControllerCreateInvitation(createInvitationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Decline invitation
         * @param {ProcessInvitationDto} processInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationControllerDeclineInvitation(processInvitationDto: ProcessInvitationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationControllerDeclineInvitation(processInvitationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all invitations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationControllerGetAllInvitations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvitationSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationControllerGetAllInvitations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get invitation by token
         * @param {string} token Invitation token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationControllerGetInvitationByToken(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationControllerGetInvitationByToken(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get invitations by organization
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationControllerGetInvitationsByOrganization(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvitationSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationControllerGetInvitationsByOrganization(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get invitations for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationControllerGetInvitationsByUserId(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvitationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationControllerGetInvitationsByUserId(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Resend an invitation
         * @param {string} invitationId Invitation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationControllerResendInvitation(invitationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationControllerResendInvitation(invitationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InvitationApi - factory interface
 * @export
 */
export const InvitationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvitationApiFp(configuration)
    return {
        /**
         *
         * @summary Accept an invitation
         * @param {InvitationApiInvitationControllerAcceptInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerAcceptInvitation(requestParameters: InvitationApiInvitationControllerAcceptInvitationRequest, options?: AxiosRequestConfig): AxiosPromise<InvitationDto> {
            return localVarFp.invitationControllerAcceptInvitation(requestParameters.processInvitationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new invitation
         * @param {InvitationApiInvitationControllerCreateInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerCreateInvitation(requestParameters: InvitationApiInvitationControllerCreateInvitationRequest, options?: AxiosRequestConfig): AxiosPromise<InvitationDto> {
            return localVarFp.invitationControllerCreateInvitation(requestParameters.createInvitationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Decline invitation
         * @param {InvitationApiInvitationControllerDeclineInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerDeclineInvitation(requestParameters: InvitationApiInvitationControllerDeclineInvitationRequest, options?: AxiosRequestConfig): AxiosPromise<InvitationDto> {
            return localVarFp.invitationControllerDeclineInvitation(requestParameters.processInvitationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all invitations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerGetAllInvitations(options?: AxiosRequestConfig): AxiosPromise<Array<InvitationSummaryDto>> {
            return localVarFp.invitationControllerGetAllInvitations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get invitation by token
         * @param {InvitationApiInvitationControllerGetInvitationByTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerGetInvitationByToken(requestParameters: InvitationApiInvitationControllerGetInvitationByTokenRequest, options?: AxiosRequestConfig): AxiosPromise<InvitationDto> {
            return localVarFp.invitationControllerGetInvitationByToken(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get invitations by organization
         * @param {InvitationApiInvitationControllerGetInvitationsByOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerGetInvitationsByOrganization(requestParameters: InvitationApiInvitationControllerGetInvitationsByOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<InvitationSummaryDto>> {
            return localVarFp.invitationControllerGetInvitationsByOrganization(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get invitations for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerGetInvitationsByUserId(options?: AxiosRequestConfig): AxiosPromise<Array<InvitationDto>> {
            return localVarFp.invitationControllerGetInvitationsByUserId(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Resend an invitation
         * @param {InvitationApiInvitationControllerResendInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerResendInvitation(requestParameters: InvitationApiInvitationControllerResendInvitationRequest, options?: AxiosRequestConfig): AxiosPromise<InvitationDto> {
            return localVarFp.invitationControllerResendInvitation(requestParameters.invitationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for invitationControllerAcceptInvitation operation in InvitationApi.
 * @export
 * @interface InvitationApiInvitationControllerAcceptInvitationRequest
 */
export interface InvitationApiInvitationControllerAcceptInvitationRequest {
    /**
     *
     * @type {ProcessInvitationDto}
     * @memberof InvitationApiInvitationControllerAcceptInvitation
     */
    readonly processInvitationDto: ProcessInvitationDto
}

/**
 * Request parameters for invitationControllerCreateInvitation operation in InvitationApi.
 * @export
 * @interface InvitationApiInvitationControllerCreateInvitationRequest
 */
export interface InvitationApiInvitationControllerCreateInvitationRequest {
    /**
     *
     * @type {CreateInvitationDto}
     * @memberof InvitationApiInvitationControllerCreateInvitation
     */
    readonly createInvitationDto: CreateInvitationDto
}

/**
 * Request parameters for invitationControllerDeclineInvitation operation in InvitationApi.
 * @export
 * @interface InvitationApiInvitationControllerDeclineInvitationRequest
 */
export interface InvitationApiInvitationControllerDeclineInvitationRequest {
    /**
     *
     * @type {ProcessInvitationDto}
     * @memberof InvitationApiInvitationControllerDeclineInvitation
     */
    readonly processInvitationDto: ProcessInvitationDto
}

/**
 * Request parameters for invitationControllerGetInvitationByToken operation in InvitationApi.
 * @export
 * @interface InvitationApiInvitationControllerGetInvitationByTokenRequest
 */
export interface InvitationApiInvitationControllerGetInvitationByTokenRequest {
    /**
     * Invitation token
     * @type {string}
     * @memberof InvitationApiInvitationControllerGetInvitationByToken
     */
    readonly token: string
}

/**
 * Request parameters for invitationControllerGetInvitationsByOrganization operation in InvitationApi.
 * @export
 * @interface InvitationApiInvitationControllerGetInvitationsByOrganizationRequest
 */
export interface InvitationApiInvitationControllerGetInvitationsByOrganizationRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof InvitationApiInvitationControllerGetInvitationsByOrganization
     */
    readonly organizationId: string
}

/**
 * Request parameters for invitationControllerResendInvitation operation in InvitationApi.
 * @export
 * @interface InvitationApiInvitationControllerResendInvitationRequest
 */
export interface InvitationApiInvitationControllerResendInvitationRequest {
    /**
     * Invitation ID
     * @type {string}
     * @memberof InvitationApiInvitationControllerResendInvitation
     */
    readonly invitationId: string
}

/**
 * InvitationApi - object-oriented interface
 * @export
 * @class InvitationApi
 * @extends {BaseAPI}
 */
export class InvitationApi extends BaseAPI {
    /**
     *
     * @summary Accept an invitation
     * @param {InvitationApiInvitationControllerAcceptInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public invitationControllerAcceptInvitation(requestParameters: InvitationApiInvitationControllerAcceptInvitationRequest, options?: AxiosRequestConfig) {
        return InvitationApiFp(this.configuration).invitationControllerAcceptInvitation(requestParameters.processInvitationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create a new invitation
     * @param {InvitationApiInvitationControllerCreateInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public invitationControllerCreateInvitation(requestParameters: InvitationApiInvitationControllerCreateInvitationRequest, options?: AxiosRequestConfig) {
        return InvitationApiFp(this.configuration).invitationControllerCreateInvitation(requestParameters.createInvitationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Decline invitation
     * @param {InvitationApiInvitationControllerDeclineInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public invitationControllerDeclineInvitation(requestParameters: InvitationApiInvitationControllerDeclineInvitationRequest, options?: AxiosRequestConfig) {
        return InvitationApiFp(this.configuration).invitationControllerDeclineInvitation(requestParameters.processInvitationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all invitations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public invitationControllerGetAllInvitations(options?: AxiosRequestConfig) {
        return InvitationApiFp(this.configuration).invitationControllerGetAllInvitations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get invitation by token
     * @param {InvitationApiInvitationControllerGetInvitationByTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public invitationControllerGetInvitationByToken(requestParameters: InvitationApiInvitationControllerGetInvitationByTokenRequest, options?: AxiosRequestConfig) {
        return InvitationApiFp(this.configuration).invitationControllerGetInvitationByToken(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get invitations by organization
     * @param {InvitationApiInvitationControllerGetInvitationsByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public invitationControllerGetInvitationsByOrganization(requestParameters: InvitationApiInvitationControllerGetInvitationsByOrganizationRequest, options?: AxiosRequestConfig) {
        return InvitationApiFp(this.configuration).invitationControllerGetInvitationsByOrganization(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get invitations for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public invitationControllerGetInvitationsByUserId(options?: AxiosRequestConfig) {
        return InvitationApiFp(this.configuration).invitationControllerGetInvitationsByUserId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Resend an invitation
     * @param {InvitationApiInvitationControllerResendInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public invitationControllerResendInvitation(requestParameters: InvitationApiInvitationControllerResendInvitationRequest, options?: AxiosRequestConfig) {
        return InvitationApiFp(this.configuration).invitationControllerResendInvitation(requestParameters.invitationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * KatalogKwalifikowanychWydaVoiceApi - axios parameter creator
 * @export
 */
export const KatalogKwalifikowanychWydaVoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Zapisz zatwierdzenie dowodów przez Voice Operations
         * @param {string} releaseId
         * @param {RecordVoiceQualifiedReleaseApprovalDto} recordVoiceQualifiedReleaseApprovalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceQualifiedReleaseControllerApproveOperations: async (releaseId: string, recordVoiceQualifiedReleaseApprovalDto: RecordVoiceQualifiedReleaseApprovalDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'releaseId' is not null or undefined
            assertParamExists('voiceQualifiedReleaseControllerApproveOperations', 'releaseId', releaseId)
            // verify required parameter 'recordVoiceQualifiedReleaseApprovalDto' is not null or undefined
            assertParamExists('voiceQualifiedReleaseControllerApproveOperations', 'recordVoiceQualifiedReleaseApprovalDto', recordVoiceQualifiedReleaseApprovalDto)
            const localVarPath = `/api/voice-platform/qualified-releases/{releaseId}/approvals/operations`
                .replace(`{${"releaseId"}}`, encodeURIComponent(String(releaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordVoiceQualifiedReleaseApprovalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zapisz zatwierdzenie dowodów prywatności Voice
         * @param {string} releaseId
         * @param {RecordVoiceQualifiedReleaseApprovalDto} recordVoiceQualifiedReleaseApprovalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceQualifiedReleaseControllerApprovePrivacy: async (releaseId: string, recordVoiceQualifiedReleaseApprovalDto: RecordVoiceQualifiedReleaseApprovalDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'releaseId' is not null or undefined
            assertParamExists('voiceQualifiedReleaseControllerApprovePrivacy', 'releaseId', releaseId)
            // verify required parameter 'recordVoiceQualifiedReleaseApprovalDto' is not null or undefined
            assertParamExists('voiceQualifiedReleaseControllerApprovePrivacy', 'recordVoiceQualifiedReleaseApprovalDto', recordVoiceQualifiedReleaseApprovalDto)
            const localVarPath = `/api/voice-platform/qualified-releases/{releaseId}/approvals/privacy`
                .replace(`{${"releaseId"}}`, encodeURIComponent(String(releaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordVoiceQualifiedReleaseApprovalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zapisz zatwierdzenie dowodów bezpieczeństwa Voice
         * @param {string} releaseId
         * @param {RecordVoiceQualifiedReleaseApprovalDto} recordVoiceQualifiedReleaseApprovalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceQualifiedReleaseControllerApproveSafety: async (releaseId: string, recordVoiceQualifiedReleaseApprovalDto: RecordVoiceQualifiedReleaseApprovalDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'releaseId' is not null or undefined
            assertParamExists('voiceQualifiedReleaseControllerApproveSafety', 'releaseId', releaseId)
            // verify required parameter 'recordVoiceQualifiedReleaseApprovalDto' is not null or undefined
            assertParamExists('voiceQualifiedReleaseControllerApproveSafety', 'recordVoiceQualifiedReleaseApprovalDto', recordVoiceQualifiedReleaseApprovalDto)
            const localVarPath = `/api/voice-platform/qualified-releases/{releaseId}/approvals/safety`
                .replace(`{${"releaseId"}}`, encodeURIComponent(String(releaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordVoiceQualifiedReleaseApprovalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz bieżące zakwalifikowane wydanie Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceQualifiedReleaseControllerCurrent: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/qualified-releases/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz niezmienną historię wydań Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceQualifiedReleaseControllerHistory: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/qualified-releases/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Opublikuj atomowe zakwalifikowane wydanie Voice
         * @param {PublishVoiceQualifiedReleaseDto} publishVoiceQualifiedReleaseDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceQualifiedReleaseControllerPublish: async (publishVoiceQualifiedReleaseDto: PublishVoiceQualifiedReleaseDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publishVoiceQualifiedReleaseDto' is not null or undefined
            assertParamExists('voiceQualifiedReleaseControllerPublish', 'publishVoiceQualifiedReleaseDto', publishVoiceQualifiedReleaseDto)
            const localVarPath = `/api/voice-platform/qualified-releases/publications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishVoiceQualifiedReleaseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KatalogKwalifikowanychWydaVoiceApi - functional programming interface
 * @export
 */
export const KatalogKwalifikowanychWydaVoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KatalogKwalifikowanychWydaVoiceApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Zapisz zatwierdzenie dowodów przez Voice Operations
         * @param {string} releaseId
         * @param {RecordVoiceQualifiedReleaseApprovalDto} recordVoiceQualifiedReleaseApprovalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceQualifiedReleaseControllerApproveOperations(releaseId: string, recordVoiceQualifiedReleaseApprovalDto: RecordVoiceQualifiedReleaseApprovalDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceQualifiedReleaseResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceQualifiedReleaseControllerApproveOperations(releaseId, recordVoiceQualifiedReleaseApprovalDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zapisz zatwierdzenie dowodów prywatności Voice
         * @param {string} releaseId
         * @param {RecordVoiceQualifiedReleaseApprovalDto} recordVoiceQualifiedReleaseApprovalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceQualifiedReleaseControllerApprovePrivacy(releaseId: string, recordVoiceQualifiedReleaseApprovalDto: RecordVoiceQualifiedReleaseApprovalDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceQualifiedReleaseResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceQualifiedReleaseControllerApprovePrivacy(releaseId, recordVoiceQualifiedReleaseApprovalDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zapisz zatwierdzenie dowodów bezpieczeństwa Voice
         * @param {string} releaseId
         * @param {RecordVoiceQualifiedReleaseApprovalDto} recordVoiceQualifiedReleaseApprovalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceQualifiedReleaseControllerApproveSafety(releaseId: string, recordVoiceQualifiedReleaseApprovalDto: RecordVoiceQualifiedReleaseApprovalDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceQualifiedReleaseResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceQualifiedReleaseControllerApproveSafety(releaseId, recordVoiceQualifiedReleaseApprovalDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz bieżące zakwalifikowane wydanie Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceQualifiedReleaseControllerCurrent(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceQualifiedReleaseCurrentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceQualifiedReleaseControllerCurrent(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz niezmienną historię wydań Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceQualifiedReleaseControllerHistory(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoiceQualifiedReleaseResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceQualifiedReleaseControllerHistory(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Opublikuj atomowe zakwalifikowane wydanie Voice
         * @param {PublishVoiceQualifiedReleaseDto} publishVoiceQualifiedReleaseDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceQualifiedReleaseControllerPublish(publishVoiceQualifiedReleaseDto: PublishVoiceQualifiedReleaseDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceQualifiedReleaseResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceQualifiedReleaseControllerPublish(publishVoiceQualifiedReleaseDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KatalogKwalifikowanychWydaVoiceApi - factory interface
 * @export
 */
export const KatalogKwalifikowanychWydaVoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KatalogKwalifikowanychWydaVoiceApiFp(configuration)
    return {
        /**
         *
         * @summary Zapisz zatwierdzenie dowodów przez Voice Operations
         * @param {KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApproveOperationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceQualifiedReleaseControllerApproveOperations(requestParameters: KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApproveOperationsRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceQualifiedReleaseResponseDto> {
            return localVarFp.voiceQualifiedReleaseControllerApproveOperations(requestParameters.releaseId, requestParameters.recordVoiceQualifiedReleaseApprovalDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zapisz zatwierdzenie dowodów prywatności Voice
         * @param {KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApprovePrivacyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceQualifiedReleaseControllerApprovePrivacy(requestParameters: KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApprovePrivacyRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceQualifiedReleaseResponseDto> {
            return localVarFp.voiceQualifiedReleaseControllerApprovePrivacy(requestParameters.releaseId, requestParameters.recordVoiceQualifiedReleaseApprovalDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zapisz zatwierdzenie dowodów bezpieczeństwa Voice
         * @param {KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApproveSafetyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceQualifiedReleaseControllerApproveSafety(requestParameters: KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApproveSafetyRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceQualifiedReleaseResponseDto> {
            return localVarFp.voiceQualifiedReleaseControllerApproveSafety(requestParameters.releaseId, requestParameters.recordVoiceQualifiedReleaseApprovalDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz bieżące zakwalifikowane wydanie Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceQualifiedReleaseControllerCurrent(options?: AxiosRequestConfig): AxiosPromise<VoiceQualifiedReleaseCurrentResponseDto> {
            return localVarFp.voiceQualifiedReleaseControllerCurrent(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz niezmienną historię wydań Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceQualifiedReleaseControllerHistory(options?: AxiosRequestConfig): AxiosPromise<Array<VoiceQualifiedReleaseResponseDto>> {
            return localVarFp.voiceQualifiedReleaseControllerHistory(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opublikuj atomowe zakwalifikowane wydanie Voice
         * @param {KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerPublishRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceQualifiedReleaseControllerPublish(requestParameters: KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerPublishRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceQualifiedReleaseResponseDto> {
            return localVarFp.voiceQualifiedReleaseControllerPublish(requestParameters.publishVoiceQualifiedReleaseDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceQualifiedReleaseControllerApproveOperations operation in KatalogKwalifikowanychWydaVoiceApi.
 * @export
 * @interface KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApproveOperationsRequest
 */
export interface KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApproveOperationsRequest {
    /**
     *
     * @type {string}
     * @memberof KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApproveOperations
     */
    readonly releaseId: string

    /**
     *
     * @type {RecordVoiceQualifiedReleaseApprovalDto}
     * @memberof KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApproveOperations
     */
    readonly recordVoiceQualifiedReleaseApprovalDto: RecordVoiceQualifiedReleaseApprovalDto
}

/**
 * Request parameters for voiceQualifiedReleaseControllerApprovePrivacy operation in KatalogKwalifikowanychWydaVoiceApi.
 * @export
 * @interface KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApprovePrivacyRequest
 */
export interface KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApprovePrivacyRequest {
    /**
     *
     * @type {string}
     * @memberof KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApprovePrivacy
     */
    readonly releaseId: string

    /**
     *
     * @type {RecordVoiceQualifiedReleaseApprovalDto}
     * @memberof KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApprovePrivacy
     */
    readonly recordVoiceQualifiedReleaseApprovalDto: RecordVoiceQualifiedReleaseApprovalDto
}

/**
 * Request parameters for voiceQualifiedReleaseControllerApproveSafety operation in KatalogKwalifikowanychWydaVoiceApi.
 * @export
 * @interface KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApproveSafetyRequest
 */
export interface KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApproveSafetyRequest {
    /**
     *
     * @type {string}
     * @memberof KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApproveSafety
     */
    readonly releaseId: string

    /**
     *
     * @type {RecordVoiceQualifiedReleaseApprovalDto}
     * @memberof KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApproveSafety
     */
    readonly recordVoiceQualifiedReleaseApprovalDto: RecordVoiceQualifiedReleaseApprovalDto
}

/**
 * Request parameters for voiceQualifiedReleaseControllerPublish operation in KatalogKwalifikowanychWydaVoiceApi.
 * @export
 * @interface KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerPublishRequest
 */
export interface KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerPublishRequest {
    /**
     *
     * @type {PublishVoiceQualifiedReleaseDto}
     * @memberof KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerPublish
     */
    readonly publishVoiceQualifiedReleaseDto: PublishVoiceQualifiedReleaseDto
}

/**
 * KatalogKwalifikowanychWydaVoiceApi - object-oriented interface
 * @export
 * @class KatalogKwalifikowanychWydaVoiceApi
 * @extends {BaseAPI}
 */
export class KatalogKwalifikowanychWydaVoiceApi extends BaseAPI {
    /**
     *
     * @summary Zapisz zatwierdzenie dowodów przez Voice Operations
     * @param {KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApproveOperationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KatalogKwalifikowanychWydaVoiceApi
     */
    public voiceQualifiedReleaseControllerApproveOperations(requestParameters: KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApproveOperationsRequest, options?: AxiosRequestConfig) {
        return KatalogKwalifikowanychWydaVoiceApiFp(this.configuration).voiceQualifiedReleaseControllerApproveOperations(requestParameters.releaseId, requestParameters.recordVoiceQualifiedReleaseApprovalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zapisz zatwierdzenie dowodów prywatności Voice
     * @param {KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApprovePrivacyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KatalogKwalifikowanychWydaVoiceApi
     */
    public voiceQualifiedReleaseControllerApprovePrivacy(requestParameters: KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApprovePrivacyRequest, options?: AxiosRequestConfig) {
        return KatalogKwalifikowanychWydaVoiceApiFp(this.configuration).voiceQualifiedReleaseControllerApprovePrivacy(requestParameters.releaseId, requestParameters.recordVoiceQualifiedReleaseApprovalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zapisz zatwierdzenie dowodów bezpieczeństwa Voice
     * @param {KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApproveSafetyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KatalogKwalifikowanychWydaVoiceApi
     */
    public voiceQualifiedReleaseControllerApproveSafety(requestParameters: KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerApproveSafetyRequest, options?: AxiosRequestConfig) {
        return KatalogKwalifikowanychWydaVoiceApiFp(this.configuration).voiceQualifiedReleaseControllerApproveSafety(requestParameters.releaseId, requestParameters.recordVoiceQualifiedReleaseApprovalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz bieżące zakwalifikowane wydanie Voice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KatalogKwalifikowanychWydaVoiceApi
     */
    public voiceQualifiedReleaseControllerCurrent(options?: AxiosRequestConfig) {
        return KatalogKwalifikowanychWydaVoiceApiFp(this.configuration).voiceQualifiedReleaseControllerCurrent(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz niezmienną historię wydań Voice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KatalogKwalifikowanychWydaVoiceApi
     */
    public voiceQualifiedReleaseControllerHistory(options?: AxiosRequestConfig) {
        return KatalogKwalifikowanychWydaVoiceApiFp(this.configuration).voiceQualifiedReleaseControllerHistory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Opublikuj atomowe zakwalifikowane wydanie Voice
     * @param {KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerPublishRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KatalogKwalifikowanychWydaVoiceApi
     */
    public voiceQualifiedReleaseControllerPublish(requestParameters: KatalogKwalifikowanychWydaVoiceApiVoiceQualifiedReleaseControllerPublishRequest, options?: AxiosRequestConfig) {
        return KatalogKwalifikowanychWydaVoiceApiFp(this.configuration).voiceQualifiedReleaseControllerPublish(requestParameters.publishVoiceQualifiedReleaseDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * KierunkiRecepcjiGosowejOrganizationApi - axios parameter creator
 * @export
 */
export const KierunkiRecepcjiGosowejOrganizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Pobierz bieżący kierunek recepcji głosowej
         * @param {string} organizationId
         * @param {'ORDINARY' | 'EMERGENCY'} kind
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionDestinationControllerCurrent: async (organizationId: string, kind: 'ORDINARY' | 'EMERGENCY', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionDestinationControllerCurrent', 'organizationId', organizationId)
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('receptionDestinationControllerCurrent', 'kind', kind)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/destinations/{kind}/current`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"kind"}}`, encodeURIComponent(String(kind)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz niezmienną historię kierunku recepcji
         * @param {string} organizationId
         * @param {'ORDINARY' | 'EMERGENCY'} kind
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionDestinationControllerHistory: async (organizationId: string, kind: 'ORDINARY' | 'EMERGENCY', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionDestinationControllerHistory', 'organizationId', organizationId)
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('receptionDestinationControllerHistory', 'kind', kind)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/destinations/{kind}/history`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"kind"}}`, encodeURIComponent(String(kind)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Opublikuj audytowaną rewizję kierunku bez mutacji dostawcy
         * @param {string} organizationId
         * @param {'ORDINARY' | 'EMERGENCY'} kind
         * @param {PublishReceptionDestinationDto} publishReceptionDestinationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionDestinationControllerPublish: async (organizationId: string, kind: 'ORDINARY' | 'EMERGENCY', publishReceptionDestinationDto: PublishReceptionDestinationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionDestinationControllerPublish', 'organizationId', organizationId)
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('receptionDestinationControllerPublish', 'kind', kind)
            // verify required parameter 'publishReceptionDestinationDto' is not null or undefined
            assertParamExists('receptionDestinationControllerPublish', 'publishReceptionDestinationDto', publishReceptionDestinationDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/destinations/{kind}/revisions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"kind"}}`, encodeURIComponent(String(kind)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishReceptionDestinationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KierunkiRecepcjiGosowejOrganizationApi - functional programming interface
 * @export
 */
export const KierunkiRecepcjiGosowejOrganizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KierunkiRecepcjiGosowejOrganizationApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Pobierz bieżący kierunek recepcji głosowej
         * @param {string} organizationId
         * @param {'ORDINARY' | 'EMERGENCY'} kind
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionDestinationControllerCurrent(organizationId: string, kind: 'ORDINARY' | 'EMERGENCY', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionDestinationCurrentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionDestinationControllerCurrent(organizationId, kind, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz niezmienną historię kierunku recepcji
         * @param {string} organizationId
         * @param {'ORDINARY' | 'EMERGENCY'} kind
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionDestinationControllerHistory(organizationId: string, kind: 'ORDINARY' | 'EMERGENCY', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReceptionDestinationRevisionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionDestinationControllerHistory(organizationId, kind, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Opublikuj audytowaną rewizję kierunku bez mutacji dostawcy
         * @param {string} organizationId
         * @param {'ORDINARY' | 'EMERGENCY'} kind
         * @param {PublishReceptionDestinationDto} publishReceptionDestinationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionDestinationControllerPublish(organizationId: string, kind: 'ORDINARY' | 'EMERGENCY', publishReceptionDestinationDto: PublishReceptionDestinationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionDestinationRevisionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionDestinationControllerPublish(organizationId, kind, publishReceptionDestinationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KierunkiRecepcjiGosowejOrganizationApi - factory interface
 * @export
 */
export const KierunkiRecepcjiGosowejOrganizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KierunkiRecepcjiGosowejOrganizationApiFp(configuration)
    return {
        /**
         *
         * @summary Pobierz bieżący kierunek recepcji głosowej
         * @param {KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerCurrentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionDestinationControllerCurrent(requestParameters: KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerCurrentRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionDestinationCurrentResponseDto> {
            return localVarFp.receptionDestinationControllerCurrent(requestParameters.organizationId, requestParameters.kind, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz niezmienną historię kierunku recepcji
         * @param {KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionDestinationControllerHistory(requestParameters: KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerHistoryRequest, options?: AxiosRequestConfig): AxiosPromise<Array<ReceptionDestinationRevisionResponseDto>> {
            return localVarFp.receptionDestinationControllerHistory(requestParameters.organizationId, requestParameters.kind, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opublikuj audytowaną rewizję kierunku bez mutacji dostawcy
         * @param {KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerPublishRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionDestinationControllerPublish(requestParameters: KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerPublishRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionDestinationRevisionResponseDto> {
            return localVarFp.receptionDestinationControllerPublish(requestParameters.organizationId, requestParameters.kind, requestParameters.publishReceptionDestinationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for receptionDestinationControllerCurrent operation in KierunkiRecepcjiGosowejOrganizationApi.
 * @export
 * @interface KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerCurrentRequest
 */
export interface KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerCurrentRequest {
    /**
     *
     * @type {string}
     * @memberof KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerCurrent
     */
    readonly organizationId: string

    /**
     *
     * @type {'ORDINARY' | 'EMERGENCY'}
     * @memberof KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerCurrent
     */
    readonly kind: 'ORDINARY' | 'EMERGENCY'
}

/**
 * Request parameters for receptionDestinationControllerHistory operation in KierunkiRecepcjiGosowejOrganizationApi.
 * @export
 * @interface KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerHistoryRequest
 */
export interface KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerHistoryRequest {
    /**
     *
     * @type {string}
     * @memberof KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerHistory
     */
    readonly organizationId: string

    /**
     *
     * @type {'ORDINARY' | 'EMERGENCY'}
     * @memberof KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerHistory
     */
    readonly kind: 'ORDINARY' | 'EMERGENCY'
}

/**
 * Request parameters for receptionDestinationControllerPublish operation in KierunkiRecepcjiGosowejOrganizationApi.
 * @export
 * @interface KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerPublishRequest
 */
export interface KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerPublishRequest {
    /**
     *
     * @type {string}
     * @memberof KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerPublish
     */
    readonly organizationId: string

    /**
     *
     * @type {'ORDINARY' | 'EMERGENCY'}
     * @memberof KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerPublish
     */
    readonly kind: 'ORDINARY' | 'EMERGENCY'

    /**
     *
     * @type {PublishReceptionDestinationDto}
     * @memberof KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerPublish
     */
    readonly publishReceptionDestinationDto: PublishReceptionDestinationDto
}

/**
 * KierunkiRecepcjiGosowejOrganizationApi - object-oriented interface
 * @export
 * @class KierunkiRecepcjiGosowejOrganizationApi
 * @extends {BaseAPI}
 */
export class KierunkiRecepcjiGosowejOrganizationApi extends BaseAPI {
    /**
     *
     * @summary Pobierz bieżący kierunek recepcji głosowej
     * @param {KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerCurrentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KierunkiRecepcjiGosowejOrganizationApi
     */
    public receptionDestinationControllerCurrent(requestParameters: KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerCurrentRequest, options?: AxiosRequestConfig) {
        return KierunkiRecepcjiGosowejOrganizationApiFp(this.configuration).receptionDestinationControllerCurrent(requestParameters.organizationId, requestParameters.kind, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz niezmienną historię kierunku recepcji
     * @param {KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KierunkiRecepcjiGosowejOrganizationApi
     */
    public receptionDestinationControllerHistory(requestParameters: KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerHistoryRequest, options?: AxiosRequestConfig) {
        return KierunkiRecepcjiGosowejOrganizationApiFp(this.configuration).receptionDestinationControllerHistory(requestParameters.organizationId, requestParameters.kind, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Opublikuj audytowaną rewizję kierunku bez mutacji dostawcy
     * @param {KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerPublishRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KierunkiRecepcjiGosowejOrganizationApi
     */
    public receptionDestinationControllerPublish(requestParameters: KierunkiRecepcjiGosowejOrganizationApiReceptionDestinationControllerPublishRequest, options?: AxiosRequestConfig) {
        return KierunkiRecepcjiGosowejOrganizationApiFp(this.configuration).receptionDestinationControllerPublish(requestParameters.organizationId, requestParameters.kind, requestParameters.publishReceptionDestinationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * KwalifikacjaProdukcyjnaVoiceApi - axios parameter creator
 * @export
 */
export const KwalifikacjaProdukcyjnaVoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Pobierz bieżącą kwalifikację produkcyjną Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerCurrent: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/production-qualifications/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz niezmienną historię kwalifikacji Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerHistory: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/production-qualifications/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Unieważnij dowód kwalifikacji Operations
         * @param {string} evidenceId
         * @param {InvalidateVoiceProductionQualificationDto} invalidateVoiceProductionQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerInvalidateOperations: async (evidenceId: string, invalidateVoiceProductionQualificationDto: InvalidateVoiceProductionQualificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('voiceProductionQualificationControllerInvalidateOperations', 'evidenceId', evidenceId)
            // verify required parameter 'invalidateVoiceProductionQualificationDto' is not null or undefined
            assertParamExists('voiceProductionQualificationControllerInvalidateOperations', 'invalidateVoiceProductionQualificationDto', invalidateVoiceProductionQualificationDto)
            const localVarPath = `/api/voice-platform/production-qualifications/evidence/{evidenceId}/invalidations/operations`
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invalidateVoiceProductionQualificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Unieważnij dowód kwalifikacji Privacy
         * @param {string} evidenceId
         * @param {InvalidateVoiceProductionQualificationDto} invalidateVoiceProductionQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerInvalidatePrivacy: async (evidenceId: string, invalidateVoiceProductionQualificationDto: InvalidateVoiceProductionQualificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('voiceProductionQualificationControllerInvalidatePrivacy', 'evidenceId', evidenceId)
            // verify required parameter 'invalidateVoiceProductionQualificationDto' is not null or undefined
            assertParamExists('voiceProductionQualificationControllerInvalidatePrivacy', 'invalidateVoiceProductionQualificationDto', invalidateVoiceProductionQualificationDto)
            const localVarPath = `/api/voice-platform/production-qualifications/evidence/{evidenceId}/invalidations/privacy`
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invalidateVoiceProductionQualificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Unieważnij dowód kwalifikacji Safety
         * @param {string} evidenceId
         * @param {InvalidateVoiceProductionQualificationDto} invalidateVoiceProductionQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerInvalidateSafety: async (evidenceId: string, invalidateVoiceProductionQualificationDto: InvalidateVoiceProductionQualificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('voiceProductionQualificationControllerInvalidateSafety', 'evidenceId', evidenceId)
            // verify required parameter 'invalidateVoiceProductionQualificationDto' is not null or undefined
            assertParamExists('voiceProductionQualificationControllerInvalidateSafety', 'invalidateVoiceProductionQualificationDto', invalidateVoiceProductionQualificationDto)
            const localVarPath = `/api/voice-platform/production-qualifications/evidence/{evidenceId}/invalidations/safety`
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invalidateVoiceProductionQualificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Opublikuj dowód kwalifikacji Operations
         * @param {PublishVoiceProductionQualificationDto} publishVoiceProductionQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerPublishOperations: async (publishVoiceProductionQualificationDto: PublishVoiceProductionQualificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publishVoiceProductionQualificationDto' is not null or undefined
            assertParamExists('voiceProductionQualificationControllerPublishOperations', 'publishVoiceProductionQualificationDto', publishVoiceProductionQualificationDto)
            const localVarPath = `/api/voice-platform/production-qualifications/evidence/operations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishVoiceProductionQualificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Opublikuj dowód kwalifikacji Privacy
         * @param {PublishVoiceProductionQualificationDto} publishVoiceProductionQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerPublishPrivacy: async (publishVoiceProductionQualificationDto: PublishVoiceProductionQualificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publishVoiceProductionQualificationDto' is not null or undefined
            assertParamExists('voiceProductionQualificationControllerPublishPrivacy', 'publishVoiceProductionQualificationDto', publishVoiceProductionQualificationDto)
            const localVarPath = `/api/voice-platform/production-qualifications/evidence/privacy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishVoiceProductionQualificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Opublikuj dowód kwalifikacji Safety
         * @param {PublishVoiceProductionQualificationDto} publishVoiceProductionQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerPublishSafety: async (publishVoiceProductionQualificationDto: PublishVoiceProductionQualificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publishVoiceProductionQualificationDto' is not null or undefined
            assertParamExists('voiceProductionQualificationControllerPublishSafety', 'publishVoiceProductionQualificationDto', publishVoiceProductionQualificationDto)
            const localVarPath = `/api/voice-platform/production-qualifications/evidence/safety`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishVoiceProductionQualificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz bieżące kontrolowane źródła kwalifikacji Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerSourceCandidates: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/production-qualifications/source-candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KwalifikacjaProdukcyjnaVoiceApi - functional programming interface
 * @export
 */
export const KwalifikacjaProdukcyjnaVoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KwalifikacjaProdukcyjnaVoiceApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Pobierz bieżącą kwalifikację produkcyjną Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProductionQualificationControllerCurrent(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProductionQualificationCurrentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProductionQualificationControllerCurrent(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz niezmienną historię kwalifikacji Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProductionQualificationControllerHistory(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoiceProductionQualificationHistoryEntryResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProductionQualificationControllerHistory(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Unieważnij dowód kwalifikacji Operations
         * @param {string} evidenceId
         * @param {InvalidateVoiceProductionQualificationDto} invalidateVoiceProductionQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProductionQualificationControllerInvalidateOperations(evidenceId: string, invalidateVoiceProductionQualificationDto: InvalidateVoiceProductionQualificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProductionQualificationInvalidationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProductionQualificationControllerInvalidateOperations(evidenceId, invalidateVoiceProductionQualificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Unieważnij dowód kwalifikacji Privacy
         * @param {string} evidenceId
         * @param {InvalidateVoiceProductionQualificationDto} invalidateVoiceProductionQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProductionQualificationControllerInvalidatePrivacy(evidenceId: string, invalidateVoiceProductionQualificationDto: InvalidateVoiceProductionQualificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProductionQualificationInvalidationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProductionQualificationControllerInvalidatePrivacy(evidenceId, invalidateVoiceProductionQualificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Unieważnij dowód kwalifikacji Safety
         * @param {string} evidenceId
         * @param {InvalidateVoiceProductionQualificationDto} invalidateVoiceProductionQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProductionQualificationControllerInvalidateSafety(evidenceId: string, invalidateVoiceProductionQualificationDto: InvalidateVoiceProductionQualificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProductionQualificationInvalidationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProductionQualificationControllerInvalidateSafety(evidenceId, invalidateVoiceProductionQualificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Opublikuj dowód kwalifikacji Operations
         * @param {PublishVoiceProductionQualificationDto} publishVoiceProductionQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProductionQualificationControllerPublishOperations(publishVoiceProductionQualificationDto: PublishVoiceProductionQualificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProductionQualificationEvidenceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProductionQualificationControllerPublishOperations(publishVoiceProductionQualificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Opublikuj dowód kwalifikacji Privacy
         * @param {PublishVoiceProductionQualificationDto} publishVoiceProductionQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProductionQualificationControllerPublishPrivacy(publishVoiceProductionQualificationDto: PublishVoiceProductionQualificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProductionQualificationEvidenceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProductionQualificationControllerPublishPrivacy(publishVoiceProductionQualificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Opublikuj dowód kwalifikacji Safety
         * @param {PublishVoiceProductionQualificationDto} publishVoiceProductionQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProductionQualificationControllerPublishSafety(publishVoiceProductionQualificationDto: PublishVoiceProductionQualificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProductionQualificationEvidenceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProductionQualificationControllerPublishSafety(publishVoiceProductionQualificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz bieżące kontrolowane źródła kwalifikacji Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProductionQualificationControllerSourceCandidates(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProductionQualificationSourceCandidatesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProductionQualificationControllerSourceCandidates(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KwalifikacjaProdukcyjnaVoiceApi - factory interface
 * @export
 */
export const KwalifikacjaProdukcyjnaVoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KwalifikacjaProdukcyjnaVoiceApiFp(configuration)
    return {
        /**
         *
         * @summary Pobierz bieżącą kwalifikację produkcyjną Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerCurrent(options?: AxiosRequestConfig): AxiosPromise<VoiceProductionQualificationCurrentResponseDto> {
            return localVarFp.voiceProductionQualificationControllerCurrent(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz niezmienną historię kwalifikacji Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerHistory(options?: AxiosRequestConfig): AxiosPromise<Array<VoiceProductionQualificationHistoryEntryResponseDto>> {
            return localVarFp.voiceProductionQualificationControllerHistory(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Unieważnij dowód kwalifikacji Operations
         * @param {KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidateOperationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerInvalidateOperations(requestParameters: KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidateOperationsRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceProductionQualificationInvalidationResponseDto> {
            return localVarFp.voiceProductionQualificationControllerInvalidateOperations(requestParameters.evidenceId, requestParameters.invalidateVoiceProductionQualificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Unieważnij dowód kwalifikacji Privacy
         * @param {KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidatePrivacyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerInvalidatePrivacy(requestParameters: KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidatePrivacyRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceProductionQualificationInvalidationResponseDto> {
            return localVarFp.voiceProductionQualificationControllerInvalidatePrivacy(requestParameters.evidenceId, requestParameters.invalidateVoiceProductionQualificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Unieważnij dowód kwalifikacji Safety
         * @param {KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidateSafetyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerInvalidateSafety(requestParameters: KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidateSafetyRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceProductionQualificationInvalidationResponseDto> {
            return localVarFp.voiceProductionQualificationControllerInvalidateSafety(requestParameters.evidenceId, requestParameters.invalidateVoiceProductionQualificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opublikuj dowód kwalifikacji Operations
         * @param {KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishOperationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerPublishOperations(requestParameters: KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishOperationsRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceProductionQualificationEvidenceResponseDto> {
            return localVarFp.voiceProductionQualificationControllerPublishOperations(requestParameters.publishVoiceProductionQualificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opublikuj dowód kwalifikacji Privacy
         * @param {KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishPrivacyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerPublishPrivacy(requestParameters: KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishPrivacyRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceProductionQualificationEvidenceResponseDto> {
            return localVarFp.voiceProductionQualificationControllerPublishPrivacy(requestParameters.publishVoiceProductionQualificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opublikuj dowód kwalifikacji Safety
         * @param {KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishSafetyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerPublishSafety(requestParameters: KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishSafetyRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceProductionQualificationEvidenceResponseDto> {
            return localVarFp.voiceProductionQualificationControllerPublishSafety(requestParameters.publishVoiceProductionQualificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz bieżące kontrolowane źródła kwalifikacji Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationControllerSourceCandidates(options?: AxiosRequestConfig): AxiosPromise<VoiceProductionQualificationSourceCandidatesResponseDto> {
            return localVarFp.voiceProductionQualificationControllerSourceCandidates(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceProductionQualificationControllerInvalidateOperations operation in KwalifikacjaProdukcyjnaVoiceApi.
 * @export
 * @interface KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidateOperationsRequest
 */
export interface KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidateOperationsRequest {
    /**
     *
     * @type {string}
     * @memberof KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidateOperations
     */
    readonly evidenceId: string

    /**
     *
     * @type {InvalidateVoiceProductionQualificationDto}
     * @memberof KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidateOperations
     */
    readonly invalidateVoiceProductionQualificationDto: InvalidateVoiceProductionQualificationDto
}

/**
 * Request parameters for voiceProductionQualificationControllerInvalidatePrivacy operation in KwalifikacjaProdukcyjnaVoiceApi.
 * @export
 * @interface KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidatePrivacyRequest
 */
export interface KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidatePrivacyRequest {
    /**
     *
     * @type {string}
     * @memberof KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidatePrivacy
     */
    readonly evidenceId: string

    /**
     *
     * @type {InvalidateVoiceProductionQualificationDto}
     * @memberof KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidatePrivacy
     */
    readonly invalidateVoiceProductionQualificationDto: InvalidateVoiceProductionQualificationDto
}

/**
 * Request parameters for voiceProductionQualificationControllerInvalidateSafety operation in KwalifikacjaProdukcyjnaVoiceApi.
 * @export
 * @interface KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidateSafetyRequest
 */
export interface KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidateSafetyRequest {
    /**
     *
     * @type {string}
     * @memberof KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidateSafety
     */
    readonly evidenceId: string

    /**
     *
     * @type {InvalidateVoiceProductionQualificationDto}
     * @memberof KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidateSafety
     */
    readonly invalidateVoiceProductionQualificationDto: InvalidateVoiceProductionQualificationDto
}

/**
 * Request parameters for voiceProductionQualificationControllerPublishOperations operation in KwalifikacjaProdukcyjnaVoiceApi.
 * @export
 * @interface KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishOperationsRequest
 */
export interface KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishOperationsRequest {
    /**
     *
     * @type {PublishVoiceProductionQualificationDto}
     * @memberof KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishOperations
     */
    readonly publishVoiceProductionQualificationDto: PublishVoiceProductionQualificationDto
}

/**
 * Request parameters for voiceProductionQualificationControllerPublishPrivacy operation in KwalifikacjaProdukcyjnaVoiceApi.
 * @export
 * @interface KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishPrivacyRequest
 */
export interface KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishPrivacyRequest {
    /**
     *
     * @type {PublishVoiceProductionQualificationDto}
     * @memberof KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishPrivacy
     */
    readonly publishVoiceProductionQualificationDto: PublishVoiceProductionQualificationDto
}

/**
 * Request parameters for voiceProductionQualificationControllerPublishSafety operation in KwalifikacjaProdukcyjnaVoiceApi.
 * @export
 * @interface KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishSafetyRequest
 */
export interface KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishSafetyRequest {
    /**
     *
     * @type {PublishVoiceProductionQualificationDto}
     * @memberof KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishSafety
     */
    readonly publishVoiceProductionQualificationDto: PublishVoiceProductionQualificationDto
}

/**
 * KwalifikacjaProdukcyjnaVoiceApi - object-oriented interface
 * @export
 * @class KwalifikacjaProdukcyjnaVoiceApi
 * @extends {BaseAPI}
 */
export class KwalifikacjaProdukcyjnaVoiceApi extends BaseAPI {
    /**
     *
     * @summary Pobierz bieżącą kwalifikację produkcyjną Voice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KwalifikacjaProdukcyjnaVoiceApi
     */
    public voiceProductionQualificationControllerCurrent(options?: AxiosRequestConfig) {
        return KwalifikacjaProdukcyjnaVoiceApiFp(this.configuration).voiceProductionQualificationControllerCurrent(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz niezmienną historię kwalifikacji Voice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KwalifikacjaProdukcyjnaVoiceApi
     */
    public voiceProductionQualificationControllerHistory(options?: AxiosRequestConfig) {
        return KwalifikacjaProdukcyjnaVoiceApiFp(this.configuration).voiceProductionQualificationControllerHistory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Unieważnij dowód kwalifikacji Operations
     * @param {KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidateOperationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KwalifikacjaProdukcyjnaVoiceApi
     */
    public voiceProductionQualificationControllerInvalidateOperations(requestParameters: KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidateOperationsRequest, options?: AxiosRequestConfig) {
        return KwalifikacjaProdukcyjnaVoiceApiFp(this.configuration).voiceProductionQualificationControllerInvalidateOperations(requestParameters.evidenceId, requestParameters.invalidateVoiceProductionQualificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Unieważnij dowód kwalifikacji Privacy
     * @param {KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidatePrivacyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KwalifikacjaProdukcyjnaVoiceApi
     */
    public voiceProductionQualificationControllerInvalidatePrivacy(requestParameters: KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidatePrivacyRequest, options?: AxiosRequestConfig) {
        return KwalifikacjaProdukcyjnaVoiceApiFp(this.configuration).voiceProductionQualificationControllerInvalidatePrivacy(requestParameters.evidenceId, requestParameters.invalidateVoiceProductionQualificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Unieważnij dowód kwalifikacji Safety
     * @param {KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidateSafetyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KwalifikacjaProdukcyjnaVoiceApi
     */
    public voiceProductionQualificationControllerInvalidateSafety(requestParameters: KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerInvalidateSafetyRequest, options?: AxiosRequestConfig) {
        return KwalifikacjaProdukcyjnaVoiceApiFp(this.configuration).voiceProductionQualificationControllerInvalidateSafety(requestParameters.evidenceId, requestParameters.invalidateVoiceProductionQualificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Opublikuj dowód kwalifikacji Operations
     * @param {KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishOperationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KwalifikacjaProdukcyjnaVoiceApi
     */
    public voiceProductionQualificationControllerPublishOperations(requestParameters: KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishOperationsRequest, options?: AxiosRequestConfig) {
        return KwalifikacjaProdukcyjnaVoiceApiFp(this.configuration).voiceProductionQualificationControllerPublishOperations(requestParameters.publishVoiceProductionQualificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Opublikuj dowód kwalifikacji Privacy
     * @param {KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishPrivacyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KwalifikacjaProdukcyjnaVoiceApi
     */
    public voiceProductionQualificationControllerPublishPrivacy(requestParameters: KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishPrivacyRequest, options?: AxiosRequestConfig) {
        return KwalifikacjaProdukcyjnaVoiceApiFp(this.configuration).voiceProductionQualificationControllerPublishPrivacy(requestParameters.publishVoiceProductionQualificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Opublikuj dowód kwalifikacji Safety
     * @param {KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishSafetyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KwalifikacjaProdukcyjnaVoiceApi
     */
    public voiceProductionQualificationControllerPublishSafety(requestParameters: KwalifikacjaProdukcyjnaVoiceApiVoiceProductionQualificationControllerPublishSafetyRequest, options?: AxiosRequestConfig) {
        return KwalifikacjaProdukcyjnaVoiceApiFp(this.configuration).voiceProductionQualificationControllerPublishSafety(requestParameters.publishVoiceProductionQualificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz bieżące kontrolowane źródła kwalifikacji Voice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KwalifikacjaProdukcyjnaVoiceApi
     */
    public voiceProductionQualificationControllerSourceCandidates(options?: AxiosRequestConfig) {
        return KwalifikacjaProdukcyjnaVoiceApiFp(this.configuration).voiceProductionQualificationControllerSourceCandidates(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * KwalifikacjaPrywatnociSMSVoiceApi - axios parameter creator
 * @export
 */
export const KwalifikacjaPrywatnociSMSVoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Zatwierdź dokładny zakres kwalifikacji SMS
         * @param {ApproveVoiceSmsPrivacyQualificationDto} approveVoiceSmsPrivacyQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceSmsPrivacyQualificationControllerApprove: async (approveVoiceSmsPrivacyQualificationDto: ApproveVoiceSmsPrivacyQualificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'approveVoiceSmsPrivacyQualificationDto' is not null or undefined
            assertParamExists('voiceSmsPrivacyQualificationControllerApprove', 'approveVoiceSmsPrivacyQualificationDto', approveVoiceSmsPrivacyQualificationDto)
            const localVarPath = `/api/voice-platform/sms/privacy-qualification/approvals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveVoiceSmsPrivacyQualificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zamknij kwalifikację po weryfikacji dokładnie zapisanych zdarzeń
         * @param {CleanupVoiceSmsPrivacyQualificationDto} cleanupVoiceSmsPrivacyQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceSmsPrivacyQualificationControllerCleanup: async (cleanupVoiceSmsPrivacyQualificationDto: CleanupVoiceSmsPrivacyQualificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cleanupVoiceSmsPrivacyQualificationDto' is not null or undefined
            assertParamExists('voiceSmsPrivacyQualificationControllerCleanup', 'cleanupVoiceSmsPrivacyQualificationDto', cleanupVoiceSmsPrivacyQualificationDto)
            const localVarPath = `/api/voice-platform/sms/privacy-qualification/cleanup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cleanupVoiceSmsPrivacyQualificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Odczytaj bieżący zakres kwalifikacji prywatności SMS
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceSmsPrivacyQualificationControllerCurrent: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('voiceSmsPrivacyQualificationControllerCurrent', 'id', id)
            const localVarPath = `/api/voice-platform/sms/privacy-qualification/authorities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Odczytaj otwartą kwalifikację po przerwanym żądaniu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceSmsPrivacyQualificationControllerOpen: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/sms/privacy-qualification/authorities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zaproponuj ograniczoną kwalifikację po przeglądzie prywatności
         * @param {ProposeVoiceSmsPrivacyQualificationDto} proposeVoiceSmsPrivacyQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceSmsPrivacyQualificationControllerPropose: async (proposeVoiceSmsPrivacyQualificationDto: ProposeVoiceSmsPrivacyQualificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proposeVoiceSmsPrivacyQualificationDto' is not null or undefined
            assertParamExists('voiceSmsPrivacyQualificationControllerPropose', 'proposeVoiceSmsPrivacyQualificationDto', proposeVoiceSmsPrivacyQualificationDto)
            const localVarPath = `/api/voice-platform/sms/privacy-qualification/proposals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proposeVoiceSmsPrivacyQualificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zamknij przyjmowanie wiadomości w kwalifikacji SMS
         * @param {VoiceSmsPrivacyAuthorityReferenceDto} voiceSmsPrivacyAuthorityReferenceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceSmsPrivacyQualificationControllerRevoke: async (voiceSmsPrivacyAuthorityReferenceDto: VoiceSmsPrivacyAuthorityReferenceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceSmsPrivacyAuthorityReferenceDto' is not null or undefined
            assertParamExists('voiceSmsPrivacyQualificationControllerRevoke', 'voiceSmsPrivacyAuthorityReferenceDto', voiceSmsPrivacyAuthorityReferenceDto)
            const localVarPath = `/api/voice-platform/sms/privacy-qualification/revocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceSmsPrivacyAuthorityReferenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KwalifikacjaPrywatnociSMSVoiceApi - functional programming interface
 * @export
 */
export const KwalifikacjaPrywatnociSMSVoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KwalifikacjaPrywatnociSMSVoiceApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Zatwierdź dokładny zakres kwalifikacji SMS
         * @param {ApproveVoiceSmsPrivacyQualificationDto} approveVoiceSmsPrivacyQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceSmsPrivacyQualificationControllerApprove(approveVoiceSmsPrivacyQualificationDto: ApproveVoiceSmsPrivacyQualificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceSmsPrivacyAuthorityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceSmsPrivacyQualificationControllerApprove(approveVoiceSmsPrivacyQualificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zamknij kwalifikację po weryfikacji dokładnie zapisanych zdarzeń
         * @param {CleanupVoiceSmsPrivacyQualificationDto} cleanupVoiceSmsPrivacyQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceSmsPrivacyQualificationControllerCleanup(cleanupVoiceSmsPrivacyQualificationDto: CleanupVoiceSmsPrivacyQualificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceSmsPrivacyAuthorityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceSmsPrivacyQualificationControllerCleanup(cleanupVoiceSmsPrivacyQualificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Odczytaj bieżący zakres kwalifikacji prywatności SMS
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceSmsPrivacyQualificationControllerCurrent(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceSmsPrivacyAuthorityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceSmsPrivacyQualificationControllerCurrent(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Odczytaj otwartą kwalifikację po przerwanym żądaniu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceSmsPrivacyQualificationControllerOpen(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceSmsPrivacyOpenResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceSmsPrivacyQualificationControllerOpen(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zaproponuj ograniczoną kwalifikację po przeglądzie prywatności
         * @param {ProposeVoiceSmsPrivacyQualificationDto} proposeVoiceSmsPrivacyQualificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceSmsPrivacyQualificationControllerPropose(proposeVoiceSmsPrivacyQualificationDto: ProposeVoiceSmsPrivacyQualificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceSmsPrivacyAuthorityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceSmsPrivacyQualificationControllerPropose(proposeVoiceSmsPrivacyQualificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zamknij przyjmowanie wiadomości w kwalifikacji SMS
         * @param {VoiceSmsPrivacyAuthorityReferenceDto} voiceSmsPrivacyAuthorityReferenceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceSmsPrivacyQualificationControllerRevoke(voiceSmsPrivacyAuthorityReferenceDto: VoiceSmsPrivacyAuthorityReferenceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceSmsPrivacyAuthorityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceSmsPrivacyQualificationControllerRevoke(voiceSmsPrivacyAuthorityReferenceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KwalifikacjaPrywatnociSMSVoiceApi - factory interface
 * @export
 */
export const KwalifikacjaPrywatnociSMSVoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KwalifikacjaPrywatnociSMSVoiceApiFp(configuration)
    return {
        /**
         *
         * @summary Zatwierdź dokładny zakres kwalifikacji SMS
         * @param {KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerApproveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceSmsPrivacyQualificationControllerApprove(requestParameters: KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerApproveRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceSmsPrivacyAuthorityResponseDto> {
            return localVarFp.voiceSmsPrivacyQualificationControllerApprove(requestParameters.approveVoiceSmsPrivacyQualificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zamknij kwalifikację po weryfikacji dokładnie zapisanych zdarzeń
         * @param {KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerCleanupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceSmsPrivacyQualificationControllerCleanup(requestParameters: KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerCleanupRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceSmsPrivacyAuthorityResponseDto> {
            return localVarFp.voiceSmsPrivacyQualificationControllerCleanup(requestParameters.cleanupVoiceSmsPrivacyQualificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Odczytaj bieżący zakres kwalifikacji prywatności SMS
         * @param {KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerCurrentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceSmsPrivacyQualificationControllerCurrent(requestParameters: KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerCurrentRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceSmsPrivacyAuthorityResponseDto> {
            return localVarFp.voiceSmsPrivacyQualificationControllerCurrent(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Odczytaj otwartą kwalifikację po przerwanym żądaniu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceSmsPrivacyQualificationControllerOpen(options?: AxiosRequestConfig): AxiosPromise<VoiceSmsPrivacyOpenResponseDto> {
            return localVarFp.voiceSmsPrivacyQualificationControllerOpen(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zaproponuj ograniczoną kwalifikację po przeglądzie prywatności
         * @param {KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerProposeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceSmsPrivacyQualificationControllerPropose(requestParameters: KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerProposeRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceSmsPrivacyAuthorityResponseDto> {
            return localVarFp.voiceSmsPrivacyQualificationControllerPropose(requestParameters.proposeVoiceSmsPrivacyQualificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zamknij przyjmowanie wiadomości w kwalifikacji SMS
         * @param {KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerRevokeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceSmsPrivacyQualificationControllerRevoke(requestParameters: KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerRevokeRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceSmsPrivacyAuthorityResponseDto> {
            return localVarFp.voiceSmsPrivacyQualificationControllerRevoke(requestParameters.voiceSmsPrivacyAuthorityReferenceDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceSmsPrivacyQualificationControllerApprove operation in KwalifikacjaPrywatnociSMSVoiceApi.
 * @export
 * @interface KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerApproveRequest
 */
export interface KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerApproveRequest {
    /**
     *
     * @type {ApproveVoiceSmsPrivacyQualificationDto}
     * @memberof KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerApprove
     */
    readonly approveVoiceSmsPrivacyQualificationDto: ApproveVoiceSmsPrivacyQualificationDto
}

/**
 * Request parameters for voiceSmsPrivacyQualificationControllerCleanup operation in KwalifikacjaPrywatnociSMSVoiceApi.
 * @export
 * @interface KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerCleanupRequest
 */
export interface KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerCleanupRequest {
    /**
     *
     * @type {CleanupVoiceSmsPrivacyQualificationDto}
     * @memberof KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerCleanup
     */
    readonly cleanupVoiceSmsPrivacyQualificationDto: CleanupVoiceSmsPrivacyQualificationDto
}

/**
 * Request parameters for voiceSmsPrivacyQualificationControllerCurrent operation in KwalifikacjaPrywatnociSMSVoiceApi.
 * @export
 * @interface KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerCurrentRequest
 */
export interface KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerCurrentRequest {
    /**
     *
     * @type {string}
     * @memberof KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerCurrent
     */
    readonly id: string
}

/**
 * Request parameters for voiceSmsPrivacyQualificationControllerPropose operation in KwalifikacjaPrywatnociSMSVoiceApi.
 * @export
 * @interface KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerProposeRequest
 */
export interface KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerProposeRequest {
    /**
     *
     * @type {ProposeVoiceSmsPrivacyQualificationDto}
     * @memberof KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerPropose
     */
    readonly proposeVoiceSmsPrivacyQualificationDto: ProposeVoiceSmsPrivacyQualificationDto
}

/**
 * Request parameters for voiceSmsPrivacyQualificationControllerRevoke operation in KwalifikacjaPrywatnociSMSVoiceApi.
 * @export
 * @interface KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerRevokeRequest
 */
export interface KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerRevokeRequest {
    /**
     *
     * @type {VoiceSmsPrivacyAuthorityReferenceDto}
     * @memberof KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerRevoke
     */
    readonly voiceSmsPrivacyAuthorityReferenceDto: VoiceSmsPrivacyAuthorityReferenceDto
}

/**
 * KwalifikacjaPrywatnociSMSVoiceApi - object-oriented interface
 * @export
 * @class KwalifikacjaPrywatnociSMSVoiceApi
 * @extends {BaseAPI}
 */
export class KwalifikacjaPrywatnociSMSVoiceApi extends BaseAPI {
    /**
     *
     * @summary Zatwierdź dokładny zakres kwalifikacji SMS
     * @param {KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerApproveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KwalifikacjaPrywatnociSMSVoiceApi
     */
    public voiceSmsPrivacyQualificationControllerApprove(requestParameters: KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerApproveRequest, options?: AxiosRequestConfig) {
        return KwalifikacjaPrywatnociSMSVoiceApiFp(this.configuration).voiceSmsPrivacyQualificationControllerApprove(requestParameters.approveVoiceSmsPrivacyQualificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zamknij kwalifikację po weryfikacji dokładnie zapisanych zdarzeń
     * @param {KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerCleanupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KwalifikacjaPrywatnociSMSVoiceApi
     */
    public voiceSmsPrivacyQualificationControllerCleanup(requestParameters: KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerCleanupRequest, options?: AxiosRequestConfig) {
        return KwalifikacjaPrywatnociSMSVoiceApiFp(this.configuration).voiceSmsPrivacyQualificationControllerCleanup(requestParameters.cleanupVoiceSmsPrivacyQualificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Odczytaj bieżący zakres kwalifikacji prywatności SMS
     * @param {KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerCurrentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KwalifikacjaPrywatnociSMSVoiceApi
     */
    public voiceSmsPrivacyQualificationControllerCurrent(requestParameters: KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerCurrentRequest, options?: AxiosRequestConfig) {
        return KwalifikacjaPrywatnociSMSVoiceApiFp(this.configuration).voiceSmsPrivacyQualificationControllerCurrent(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Odczytaj otwartą kwalifikację po przerwanym żądaniu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KwalifikacjaPrywatnociSMSVoiceApi
     */
    public voiceSmsPrivacyQualificationControllerOpen(options?: AxiosRequestConfig) {
        return KwalifikacjaPrywatnociSMSVoiceApiFp(this.configuration).voiceSmsPrivacyQualificationControllerOpen(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zaproponuj ograniczoną kwalifikację po przeglądzie prywatności
     * @param {KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerProposeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KwalifikacjaPrywatnociSMSVoiceApi
     */
    public voiceSmsPrivacyQualificationControllerPropose(requestParameters: KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerProposeRequest, options?: AxiosRequestConfig) {
        return KwalifikacjaPrywatnociSMSVoiceApiFp(this.configuration).voiceSmsPrivacyQualificationControllerPropose(requestParameters.proposeVoiceSmsPrivacyQualificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zamknij przyjmowanie wiadomości w kwalifikacji SMS
     * @param {KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerRevokeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KwalifikacjaPrywatnociSMSVoiceApi
     */
    public voiceSmsPrivacyQualificationControllerRevoke(requestParameters: KwalifikacjaPrywatnociSMSVoiceApiVoiceSmsPrivacyQualificationControllerRevokeRequest, options?: AxiosRequestConfig) {
        return KwalifikacjaPrywatnociSMSVoiceApiFp(this.configuration).voiceSmsPrivacyQualificationControllerRevoke(requestParameters.voiceSmsPrivacyAuthorityReferenceDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MailCronApi - axios parameter creator
 * @export
 */
export const MailCronApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Send engagement reminders to inactive users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailCronControllerSendEngagementReminders: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mail/cron/engagement-reminders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MailCronApi - functional programming interface
 * @export
 */
export const MailCronApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MailCronApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Send engagement reminders to inactive users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailCronControllerSendEngagementReminders(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailCronControllerSendEngagementReminders(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MailCronApi - factory interface
 * @export
 */
export const MailCronApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MailCronApiFp(configuration)
    return {
        /**
         *
         * @summary Send engagement reminders to inactive users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailCronControllerSendEngagementReminders(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.mailCronControllerSendEngagementReminders(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MailCronApi - object-oriented interface
 * @export
 * @class MailCronApi
 * @extends {BaseAPI}
 */
export class MailCronApi extends BaseAPI {
    /**
     *
     * @summary Send engagement reminders to inactive users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailCronApi
     */
    public mailCronControllerSendEngagementReminders(options?: AxiosRequestConfig) {
        return MailCronApiFp(this.configuration).mailCronControllerSendEngagementReminders(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MarketingAnalyticsApi - axios parameter creator
 * @export
 */
export const MarketingAnalyticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {MarketingReportRequestDto} marketingReportRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingAnalyticsControllerAnalyze: async (marketingReportRequestDto: MarketingReportRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'marketingReportRequestDto' is not null or undefined
            assertParamExists('marketingAnalyticsControllerAnalyze', 'marketingReportRequestDto', marketingReportRequestDto)
            const localVarPath = `/api/marketing-analytics/analysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(marketingReportRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {MarketingReportRequestDto} marketingReportRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingAnalyticsControllerReport: async (marketingReportRequestDto: MarketingReportRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'marketingReportRequestDto' is not null or undefined
            assertParamExists('marketingAnalyticsControllerReport', 'marketingReportRequestDto', marketingReportRequestDto)
            const localVarPath = `/api/marketing-analytics/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(marketingReportRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketingAnalyticsApi - functional programming interface
 * @export
 */
export const MarketingAnalyticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketingAnalyticsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {MarketingReportRequestDto} marketingReportRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketingAnalyticsControllerAnalyze(marketingReportRequestDto: MarketingReportRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingAnalysisDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketingAnalyticsControllerAnalyze(marketingReportRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {MarketingReportRequestDto} marketingReportRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketingAnalyticsControllerReport(marketingReportRequestDto: MarketingReportRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketingAnalyticsControllerReport(marketingReportRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MarketingAnalyticsApi - factory interface
 * @export
 */
export const MarketingAnalyticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketingAnalyticsApiFp(configuration)
    return {
        /**
         *
         * @param {MarketingAnalyticsApiMarketingAnalyticsControllerAnalyzeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingAnalyticsControllerAnalyze(requestParameters: MarketingAnalyticsApiMarketingAnalyticsControllerAnalyzeRequest, options?: AxiosRequestConfig): AxiosPromise<MarketingAnalysisDto> {
            return localVarFp.marketingAnalyticsControllerAnalyze(requestParameters.marketingReportRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MarketingAnalyticsApiMarketingAnalyticsControllerReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingAnalyticsControllerReport(requestParameters: MarketingAnalyticsApiMarketingAnalyticsControllerReportRequest, options?: AxiosRequestConfig): AxiosPromise<MarketingReportDto> {
            return localVarFp.marketingAnalyticsControllerReport(requestParameters.marketingReportRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for marketingAnalyticsControllerAnalyze operation in MarketingAnalyticsApi.
 * @export
 * @interface MarketingAnalyticsApiMarketingAnalyticsControllerAnalyzeRequest
 */
export interface MarketingAnalyticsApiMarketingAnalyticsControllerAnalyzeRequest {
    /**
     *
     * @type {MarketingReportRequestDto}
     * @memberof MarketingAnalyticsApiMarketingAnalyticsControllerAnalyze
     */
    readonly marketingReportRequestDto: MarketingReportRequestDto
}

/**
 * Request parameters for marketingAnalyticsControllerReport operation in MarketingAnalyticsApi.
 * @export
 * @interface MarketingAnalyticsApiMarketingAnalyticsControllerReportRequest
 */
export interface MarketingAnalyticsApiMarketingAnalyticsControllerReportRequest {
    /**
     *
     * @type {MarketingReportRequestDto}
     * @memberof MarketingAnalyticsApiMarketingAnalyticsControllerReport
     */
    readonly marketingReportRequestDto: MarketingReportRequestDto
}

/**
 * MarketingAnalyticsApi - object-oriented interface
 * @export
 * @class MarketingAnalyticsApi
 * @extends {BaseAPI}
 */
export class MarketingAnalyticsApi extends BaseAPI {
    /**
     *
     * @param {MarketingAnalyticsApiMarketingAnalyticsControllerAnalyzeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingAnalyticsApi
     */
    public marketingAnalyticsControllerAnalyze(requestParameters: MarketingAnalyticsApiMarketingAnalyticsControllerAnalyzeRequest, options?: AxiosRequestConfig) {
        return MarketingAnalyticsApiFp(this.configuration).marketingAnalyticsControllerAnalyze(requestParameters.marketingReportRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {MarketingAnalyticsApiMarketingAnalyticsControllerReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingAnalyticsApi
     */
    public marketingAnalyticsControllerReport(requestParameters: MarketingAnalyticsApiMarketingAnalyticsControllerReportRequest, options?: AxiosRequestConfig) {
        return MarketingAnalyticsApiFp(this.configuration).marketingAnalyticsControllerReport(requestParameters.marketingReportRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MedicationApi - axios parameter creator
 * @export
 */
export const MedicationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Add medication to user profile
         * @param {string} profileId
         * @param {AddProfileMedicationDto} addProfileMedicationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerAddProfileMedication: async (profileId: string, addProfileMedicationDto: AddProfileMedicationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('medicationControllerAddProfileMedication', 'profileId', profileId)
            // verify required parameter 'addProfileMedicationDto' is not null or undefined
            assertParamExists('medicationControllerAddProfileMedication', 'addProfileMedicationDto', addProfileMedicationDto)
            const localVarPath = `/api/profile/{profileId}/medications`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addProfileMedicationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Add medication to profile within organization context
         * @param {string} profileId
         * @param {AddFacilityMedicationDto} addFacilityMedicationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerAddProfileMedicationInOrganization: async (profileId: string, addFacilityMedicationDto: AddFacilityMedicationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('medicationControllerAddProfileMedicationInOrganization', 'profileId', profileId)
            // verify required parameter 'addFacilityMedicationDto' is not null or undefined
            assertParamExists('medicationControllerAddProfileMedicationInOrganization', 'addFacilityMedicationDto', addFacilityMedicationDto)
            const localVarPath = `/api/organization-profile/profile/{profileId}/medications`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addFacilityMedicationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Add a medication prescribed during a visit.
         * @param {string} visitId
         * @param {AddFacilityMedicationDto} addFacilityMedicationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerAddVisitMedication: async (visitId: string, addFacilityMedicationDto: AddFacilityMedicationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('medicationControllerAddVisitMedication', 'visitId', visitId)
            // verify required parameter 'addFacilityMedicationDto' is not null or undefined
            assertParamExists('medicationControllerAddVisitMedication', 'addFacilityMedicationDto', addFacilityMedicationDto)
            const localVarPath = `/api/organization-profile/visit/{visitId}/medication`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addFacilityMedicationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Stop, pause or restart a medication on a user profile
         * @param {string} profileId
         * @param {string} medicationId
         * @param {ChangeMedicationStatusDto} changeMedicationStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerChangeProfileMedicationStatus: async (profileId: string, medicationId: string, changeMedicationStatusDto: ChangeMedicationStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('medicationControllerChangeProfileMedicationStatus', 'profileId', profileId)
            // verify required parameter 'medicationId' is not null or undefined
            assertParamExists('medicationControllerChangeProfileMedicationStatus', 'medicationId', medicationId)
            // verify required parameter 'changeMedicationStatusDto' is not null or undefined
            assertParamExists('medicationControllerChangeProfileMedicationStatus', 'changeMedicationStatusDto', changeMedicationStatusDto)
            const localVarPath = `/api/profile/{profileId}/medications/{medicationId}/status`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"medicationId"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeMedicationStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Stop, pause or restart a medication on a patient
         * @param {string} profileId
         * @param {string} medicationId
         * @param {ChangeMedicationStatusDto} changeMedicationStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerChangeProfileMedicationStatusInOrganization: async (profileId: string, medicationId: string, changeMedicationStatusDto: ChangeMedicationStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('medicationControllerChangeProfileMedicationStatusInOrganization', 'profileId', profileId)
            // verify required parameter 'medicationId' is not null or undefined
            assertParamExists('medicationControllerChangeProfileMedicationStatusInOrganization', 'medicationId', medicationId)
            // verify required parameter 'changeMedicationStatusDto' is not null or undefined
            assertParamExists('medicationControllerChangeProfileMedicationStatusInOrganization', 'changeMedicationStatusDto', changeMedicationStatusDto)
            const localVarPath = `/api/organization-profile/profile/{profileId}/medications/{medicationId}/status`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"medicationId"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeMedicationStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Stop, pause or restart a medication during a visit.
         * @param {string} visitId
         * @param {string} medicationId
         * @param {ChangeMedicationStatusDto} changeMedicationStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerChangeVisitMedicationStatus: async (visitId: string, medicationId: string, changeMedicationStatusDto: ChangeMedicationStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('medicationControllerChangeVisitMedicationStatus', 'visitId', visitId)
            // verify required parameter 'medicationId' is not null or undefined
            assertParamExists('medicationControllerChangeVisitMedicationStatus', 'medicationId', medicationId)
            // verify required parameter 'changeMedicationStatusDto' is not null or undefined
            assertParamExists('medicationControllerChangeVisitMedicationStatus', 'changeMedicationStatusDto', changeMedicationStatusDto)
            const localVarPath = `/api/organization-profile/visit/{visitId}/medication/{medicationId}/status`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)))
                .replace(`{${"medicationId"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeMedicationStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete medication from user profile
         * @param {string} profileId
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerDeleteProfileMedication: async (profileId: string, medicationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('medicationControllerDeleteProfileMedication', 'profileId', profileId)
            // verify required parameter 'medicationId' is not null or undefined
            assertParamExists('medicationControllerDeleteProfileMedication', 'medicationId', medicationId)
            const localVarPath = `/api/profile/{profileId}/medications/{medicationId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"medicationId"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete medication from profile within organization context
         * @param {string} profileId
         * @param {string} medicationId
         * @param {string} [visitId] Optional visit ID to track deletion as a visit activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerDeleteProfileMedicationInOrganization: async (profileId: string, medicationId: string, visitId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('medicationControllerDeleteProfileMedicationInOrganization', 'profileId', profileId)
            // verify required parameter 'medicationId' is not null or undefined
            assertParamExists('medicationControllerDeleteProfileMedicationInOrganization', 'medicationId', medicationId)
            const localVarPath = `/api/organization-profile/profile/{profileId}/medications/{medicationId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"medicationId"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (visitId !== undefined) {
                localVarQueryParameter['visitId'] = visitId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Read the history of a medication
         * @param {string} profileId
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerGetProfileMedicationHistory: async (profileId: string, medicationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('medicationControllerGetProfileMedicationHistory', 'profileId', profileId)
            // verify required parameter 'medicationId' is not null or undefined
            assertParamExists('medicationControllerGetProfileMedicationHistory', 'medicationId', medicationId)
            const localVarPath = `/api/profile/{profileId}/medications/{medicationId}/history`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"medicationId"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Read the history of a patient medication
         * @param {string} profileId
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerGetProfileMedicationHistoryInOrganization: async (profileId: string, medicationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('medicationControllerGetProfileMedicationHistoryInOrganization', 'profileId', profileId)
            // verify required parameter 'medicationId' is not null or undefined
            assertParamExists('medicationControllerGetProfileMedicationHistoryInOrganization', 'medicationId', medicationId)
            const localVarPath = `/api/organization-profile/profile/{profileId}/medications/{medicationId}/history`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"medicationId"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get user profile medications
         * @param {string} profileId
         * @param {number} [page] Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
         * @param {number} [limit] Rows per page. Omit together with &#x60;page&#x60; to get every row.
         * @param {'active' | 'stopped' | 'all'} [status] Defaults to &#x60;all&#x60;
         * @param {Array<'SCHEDULED' | 'ACTIVE' | 'PAUSED' | 'STOPPED'>} [statuses] Repeat the parameter or pass it comma-separated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerGetProfileMedications: async (profileId: string, page?: number, limit?: number, status?: 'active' | 'stopped' | 'all', statuses?: Array<'SCHEDULED' | 'ACTIVE' | 'PAUSED' | 'STOPPED'>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('medicationControllerGetProfileMedications', 'profileId', profileId)
            const localVarPath = `/api/profile/{profileId}/medications`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get profile medications within organization context
         * @param {string} profileId
         * @param {number} [page] Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
         * @param {number} [limit] Rows per page. Omit together with &#x60;page&#x60; to get every row.
         * @param {'active' | 'stopped' | 'all'} [status] Defaults to &#x60;all&#x60;
         * @param {Array<'SCHEDULED' | 'ACTIVE' | 'PAUSED' | 'STOPPED'>} [statuses] Repeat the parameter or pass it comma-separated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerGetProfileMedicationsInOrganization: async (profileId: string, page?: number, limit?: number, status?: 'active' | 'stopped' | 'all', statuses?: Array<'SCHEDULED' | 'ACTIVE' | 'PAUSED' | 'STOPPED'>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('medicationControllerGetProfileMedicationsInOrganization', 'profileId', profileId)
            const localVarPath = `/api/organization-profile/profile/{profileId}/medications`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List medications attached to a visit.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerListVisitMedications: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('medicationControllerListVisitMedications', 'visitId', visitId)
            const localVarPath = `/api/organization-profile/visit/{visitId}/medications`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Remove a medication from a visit.
         * @param {string} visitId
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerRemoveVisitMedication: async (visitId: string, medicationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('medicationControllerRemoveVisitMedication', 'visitId', visitId)
            // verify required parameter 'medicationId' is not null or undefined
            assertParamExists('medicationControllerRemoveVisitMedication', 'medicationId', medicationId)
            const localVarPath = `/api/organization-profile/visit/{visitId}/medication/{medicationId}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)))
                .replace(`{${"medicationId"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update medication in user profile
         * @param {string} profileId
         * @param {string} medicationId
         * @param {UpdateProfileMedicationDto} updateProfileMedicationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerUpdateProfileMedication: async (profileId: string, medicationId: string, updateProfileMedicationDto: UpdateProfileMedicationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('medicationControllerUpdateProfileMedication', 'profileId', profileId)
            // verify required parameter 'medicationId' is not null or undefined
            assertParamExists('medicationControllerUpdateProfileMedication', 'medicationId', medicationId)
            // verify required parameter 'updateProfileMedicationDto' is not null or undefined
            assertParamExists('medicationControllerUpdateProfileMedication', 'updateProfileMedicationDto', updateProfileMedicationDto)
            const localVarPath = `/api/profile/{profileId}/medications/{medicationId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"medicationId"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileMedicationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update medication in profile within organization context
         * @param {string} profileId
         * @param {string} medicationId
         * @param {UpdateFacilityMedicationDto} updateFacilityMedicationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerUpdateProfileMedicationInOrganization: async (profileId: string, medicationId: string, updateFacilityMedicationDto: UpdateFacilityMedicationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('medicationControllerUpdateProfileMedicationInOrganization', 'profileId', profileId)
            // verify required parameter 'medicationId' is not null or undefined
            assertParamExists('medicationControllerUpdateProfileMedicationInOrganization', 'medicationId', medicationId)
            // verify required parameter 'updateFacilityMedicationDto' is not null or undefined
            assertParamExists('medicationControllerUpdateProfileMedicationInOrganization', 'updateFacilityMedicationDto', updateFacilityMedicationDto)
            const localVarPath = `/api/organization-profile/profile/{profileId}/medications/{medicationId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"medicationId"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFacilityMedicationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a medication on a visit.
         * @param {string} visitId
         * @param {string} medicationId
         * @param {UpdateFacilityMedicationDto} updateFacilityMedicationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerUpdateVisitMedication: async (visitId: string, medicationId: string, updateFacilityMedicationDto: UpdateFacilityMedicationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('medicationControllerUpdateVisitMedication', 'visitId', visitId)
            // verify required parameter 'medicationId' is not null or undefined
            assertParamExists('medicationControllerUpdateVisitMedication', 'medicationId', medicationId)
            // verify required parameter 'updateFacilityMedicationDto' is not null or undefined
            assertParamExists('medicationControllerUpdateVisitMedication', 'updateFacilityMedicationDto', updateFacilityMedicationDto)
            const localVarPath = `/api/organization-profile/visit/{visitId}/medication/{medicationId}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)))
                .replace(`{${"medicationId"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFacilityMedicationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary How the organization last dosed the picked drug, preferring a patient of the same species (the medication form\'s dosage autofill)
         * @param {string} profileId The patient the drug is being prescribed for
         * @param {string} [medicineProductId] Registry medicine id of the picked drug; matched before the name
         * @param {string} [name] Name of the picked drug, matched whole and case-insensitively when it has no registry id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationDosingSuggestionControllerSuggest: async (profileId: string, medicineProductId?: string, name?: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('medicationDosingSuggestionControllerSuggest', 'profileId', profileId)
            const localVarPath = `/api/organization-profile/medication-dosing-suggestion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }

            if (medicineProductId !== undefined) {
                localVarQueryParameter['medicineProductId'] = medicineProductId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MedicationApi - functional programming interface
 * @export
 */
export const MedicationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MedicationApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Add medication to user profile
         * @param {string} profileId
         * @param {AddProfileMedicationDto} addProfileMedicationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerAddProfileMedication(profileId: string, addProfileMedicationDto: AddProfileMedicationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProfileMedicationsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerAddProfileMedication(profileId, addProfileMedicationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Add medication to profile within organization context
         * @param {string} profileId
         * @param {AddFacilityMedicationDto} addFacilityMedicationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerAddProfileMedicationInOrganization(profileId: string, addFacilityMedicationDto: AddFacilityMedicationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProfileMedicationsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerAddProfileMedicationInOrganization(profileId, addFacilityMedicationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Add a medication prescribed during a visit.
         * @param {string} visitId
         * @param {AddFacilityMedicationDto} addFacilityMedicationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerAddVisitMedication(visitId: string, addFacilityMedicationDto: AddFacilityMedicationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerAddVisitMedication(visitId, addFacilityMedicationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Stop, pause or restart a medication on a user profile
         * @param {string} profileId
         * @param {string} medicationId
         * @param {ChangeMedicationStatusDto} changeMedicationStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerChangeProfileMedicationStatus(profileId: string, medicationId: string, changeMedicationStatusDto: ChangeMedicationStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProfileMedicationsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerChangeProfileMedicationStatus(profileId, medicationId, changeMedicationStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Stop, pause or restart a medication on a patient
         * @param {string} profileId
         * @param {string} medicationId
         * @param {ChangeMedicationStatusDto} changeMedicationStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerChangeProfileMedicationStatusInOrganization(profileId: string, medicationId: string, changeMedicationStatusDto: ChangeMedicationStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProfileMedicationsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerChangeProfileMedicationStatusInOrganization(profileId, medicationId, changeMedicationStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Stop, pause or restart a medication during a visit.
         * @param {string} visitId
         * @param {string} medicationId
         * @param {ChangeMedicationStatusDto} changeMedicationStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerChangeVisitMedicationStatus(visitId: string, medicationId: string, changeMedicationStatusDto: ChangeMedicationStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProfileMedicationsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerChangeVisitMedicationStatus(visitId, medicationId, changeMedicationStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete medication from user profile
         * @param {string} profileId
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerDeleteProfileMedication(profileId: string, medicationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProfileMedicationsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerDeleteProfileMedication(profileId, medicationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete medication from profile within organization context
         * @param {string} profileId
         * @param {string} medicationId
         * @param {string} [visitId] Optional visit ID to track deletion as a visit activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerDeleteProfileMedicationInOrganization(profileId: string, medicationId: string, visitId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProfileMedicationsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerDeleteProfileMedicationInOrganization(profileId, medicationId, visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Read the history of a medication
         * @param {string} profileId
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerGetProfileMedicationHistory(profileId: string, medicationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMedicationHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerGetProfileMedicationHistory(profileId, medicationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Read the history of a patient medication
         * @param {string} profileId
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerGetProfileMedicationHistoryInOrganization(profileId: string, medicationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMedicationHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerGetProfileMedicationHistoryInOrganization(profileId, medicationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get user profile medications
         * @param {string} profileId
         * @param {number} [page] Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
         * @param {number} [limit] Rows per page. Omit together with &#x60;page&#x60; to get every row.
         * @param {'active' | 'stopped' | 'all'} [status] Defaults to &#x60;all&#x60;
         * @param {Array<'SCHEDULED' | 'ACTIVE' | 'PAUSED' | 'STOPPED'>} [statuses] Repeat the parameter or pass it comma-separated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerGetProfileMedications(profileId: string, page?: number, limit?: number, status?: 'active' | 'stopped' | 'all', statuses?: Array<'SCHEDULED' | 'ACTIVE' | 'PAUSED' | 'STOPPED'>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMedicationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerGetProfileMedications(profileId, page, limit, status, statuses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get profile medications within organization context
         * @param {string} profileId
         * @param {number} [page] Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
         * @param {number} [limit] Rows per page. Omit together with &#x60;page&#x60; to get every row.
         * @param {'active' | 'stopped' | 'all'} [status] Defaults to &#x60;all&#x60;
         * @param {Array<'SCHEDULED' | 'ACTIVE' | 'PAUSED' | 'STOPPED'>} [statuses] Repeat the parameter or pass it comma-separated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerGetProfileMedicationsInOrganization(profileId: string, page?: number, limit?: number, status?: 'active' | 'stopped' | 'all', statuses?: Array<'SCHEDULED' | 'ACTIVE' | 'PAUSED' | 'STOPPED'>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMedicationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerGetProfileMedicationsInOrganization(profileId, page, limit, status, statuses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List medications attached to a visit.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerListVisitMedications(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProfileMedicationsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerListVisitMedications(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Remove a medication from a visit.
         * @param {string} visitId
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerRemoveVisitMedication(visitId: string, medicationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerRemoveVisitMedication(visitId, medicationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update medication in user profile
         * @param {string} profileId
         * @param {string} medicationId
         * @param {UpdateProfileMedicationDto} updateProfileMedicationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerUpdateProfileMedication(profileId: string, medicationId: string, updateProfileMedicationDto: UpdateProfileMedicationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProfileMedicationsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerUpdateProfileMedication(profileId, medicationId, updateProfileMedicationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update medication in profile within organization context
         * @param {string} profileId
         * @param {string} medicationId
         * @param {UpdateFacilityMedicationDto} updateFacilityMedicationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerUpdateProfileMedicationInOrganization(profileId: string, medicationId: string, updateFacilityMedicationDto: UpdateFacilityMedicationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProfileMedicationsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerUpdateProfileMedicationInOrganization(profileId, medicationId, updateFacilityMedicationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update a medication on a visit.
         * @param {string} visitId
         * @param {string} medicationId
         * @param {UpdateFacilityMedicationDto} updateFacilityMedicationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationControllerUpdateVisitMedication(visitId: string, medicationId: string, updateFacilityMedicationDto: UpdateFacilityMedicationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerUpdateVisitMedication(visitId, medicationId, updateFacilityMedicationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary How the organization last dosed the picked drug, preferring a patient of the same species (the medication form\'s dosage autofill)
         * @param {string} profileId The patient the drug is being prescribed for
         * @param {string} [medicineProductId] Registry medicine id of the picked drug; matched before the name
         * @param {string} [name] Name of the picked drug, matched whole and case-insensitively when it has no registry id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicationDosingSuggestionControllerSuggest(profileId: string, medicineProductId?: string, name?: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MedicationDosingSuggestionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicationDosingSuggestionControllerSuggest(profileId, medicineProductId, name, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MedicationApi - factory interface
 * @export
 */
export const MedicationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MedicationApiFp(configuration)
    return {
        /**
         *
         * @summary Add medication to user profile
         * @param {MedicationApiMedicationControllerAddProfileMedicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerAddProfileMedication(requestParameters: MedicationApiMedicationControllerAddProfileMedicationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetProfileMedicationsDto>> {
            return localVarFp.medicationControllerAddProfileMedication(requestParameters.profileId, requestParameters.addProfileMedicationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add medication to profile within organization context
         * @param {MedicationApiMedicationControllerAddProfileMedicationInOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerAddProfileMedicationInOrganization(requestParameters: MedicationApiMedicationControllerAddProfileMedicationInOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetProfileMedicationsDto>> {
            return localVarFp.medicationControllerAddProfileMedicationInOrganization(requestParameters.profileId, requestParameters.addFacilityMedicationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add a medication prescribed during a visit.
         * @param {MedicationApiMedicationControllerAddVisitMedicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerAddVisitMedication(requestParameters: MedicationApiMedicationControllerAddVisitMedicationRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.medicationControllerAddVisitMedication(requestParameters.visitId, requestParameters.addFacilityMedicationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Stop, pause or restart a medication on a user profile
         * @param {MedicationApiMedicationControllerChangeProfileMedicationStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerChangeProfileMedicationStatus(requestParameters: MedicationApiMedicationControllerChangeProfileMedicationStatusRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetProfileMedicationsDto>> {
            return localVarFp.medicationControllerChangeProfileMedicationStatus(requestParameters.profileId, requestParameters.medicationId, requestParameters.changeMedicationStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Stop, pause or restart a medication on a patient
         * @param {MedicationApiMedicationControllerChangeProfileMedicationStatusInOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerChangeProfileMedicationStatusInOrganization(requestParameters: MedicationApiMedicationControllerChangeProfileMedicationStatusInOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetProfileMedicationsDto>> {
            return localVarFp.medicationControllerChangeProfileMedicationStatusInOrganization(requestParameters.profileId, requestParameters.medicationId, requestParameters.changeMedicationStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Stop, pause or restart a medication during a visit.
         * @param {MedicationApiMedicationControllerChangeVisitMedicationStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerChangeVisitMedicationStatus(requestParameters: MedicationApiMedicationControllerChangeVisitMedicationStatusRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetProfileMedicationsDto>> {
            return localVarFp.medicationControllerChangeVisitMedicationStatus(requestParameters.visitId, requestParameters.medicationId, requestParameters.changeMedicationStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete medication from user profile
         * @param {MedicationApiMedicationControllerDeleteProfileMedicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerDeleteProfileMedication(requestParameters: MedicationApiMedicationControllerDeleteProfileMedicationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetProfileMedicationsDto>> {
            return localVarFp.medicationControllerDeleteProfileMedication(requestParameters.profileId, requestParameters.medicationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete medication from profile within organization context
         * @param {MedicationApiMedicationControllerDeleteProfileMedicationInOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerDeleteProfileMedicationInOrganization(requestParameters: MedicationApiMedicationControllerDeleteProfileMedicationInOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetProfileMedicationsDto>> {
            return localVarFp.medicationControllerDeleteProfileMedicationInOrganization(requestParameters.profileId, requestParameters.medicationId, requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Read the history of a medication
         * @param {MedicationApiMedicationControllerGetProfileMedicationHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerGetProfileMedicationHistory(requestParameters: MedicationApiMedicationControllerGetProfileMedicationHistoryRequest, options?: AxiosRequestConfig): AxiosPromise<GetMedicationHistoryDto> {
            return localVarFp.medicationControllerGetProfileMedicationHistory(requestParameters.profileId, requestParameters.medicationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Read the history of a patient medication
         * @param {MedicationApiMedicationControllerGetProfileMedicationHistoryInOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerGetProfileMedicationHistoryInOrganization(requestParameters: MedicationApiMedicationControllerGetProfileMedicationHistoryInOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<GetMedicationHistoryDto> {
            return localVarFp.medicationControllerGetProfileMedicationHistoryInOrganization(requestParameters.profileId, requestParameters.medicationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get user profile medications
         * @param {MedicationApiMedicationControllerGetProfileMedicationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerGetProfileMedications(requestParameters: MedicationApiMedicationControllerGetProfileMedicationsRequest, options?: AxiosRequestConfig): AxiosPromise<PaginatedMedicationsResponseDto> {
            return localVarFp.medicationControllerGetProfileMedications(requestParameters.profileId, requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.statuses, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get profile medications within organization context
         * @param {MedicationApiMedicationControllerGetProfileMedicationsInOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerGetProfileMedicationsInOrganization(requestParameters: MedicationApiMedicationControllerGetProfileMedicationsInOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<PaginatedMedicationsResponseDto> {
            return localVarFp.medicationControllerGetProfileMedicationsInOrganization(requestParameters.profileId, requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.statuses, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List medications attached to a visit.
         * @param {MedicationApiMedicationControllerListVisitMedicationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerListVisitMedications(requestParameters: MedicationApiMedicationControllerListVisitMedicationsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetProfileMedicationsDto>> {
            return localVarFp.medicationControllerListVisitMedications(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove a medication from a visit.
         * @param {MedicationApiMedicationControllerRemoveVisitMedicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerRemoveVisitMedication(requestParameters: MedicationApiMedicationControllerRemoveVisitMedicationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.medicationControllerRemoveVisitMedication(requestParameters.visitId, requestParameters.medicationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update medication in user profile
         * @param {MedicationApiMedicationControllerUpdateProfileMedicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerUpdateProfileMedication(requestParameters: MedicationApiMedicationControllerUpdateProfileMedicationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetProfileMedicationsDto>> {
            return localVarFp.medicationControllerUpdateProfileMedication(requestParameters.profileId, requestParameters.medicationId, requestParameters.updateProfileMedicationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update medication in profile within organization context
         * @param {MedicationApiMedicationControllerUpdateProfileMedicationInOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerUpdateProfileMedicationInOrganization(requestParameters: MedicationApiMedicationControllerUpdateProfileMedicationInOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetProfileMedicationsDto>> {
            return localVarFp.medicationControllerUpdateProfileMedicationInOrganization(requestParameters.profileId, requestParameters.medicationId, requestParameters.updateFacilityMedicationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a medication on a visit.
         * @param {MedicationApiMedicationControllerUpdateVisitMedicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerUpdateVisitMedication(requestParameters: MedicationApiMedicationControllerUpdateVisitMedicationRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.medicationControllerUpdateVisitMedication(requestParameters.visitId, requestParameters.medicationId, requestParameters.updateFacilityMedicationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary How the organization last dosed the picked drug, preferring a patient of the same species (the medication form\'s dosage autofill)
         * @param {MedicationApiMedicationDosingSuggestionControllerSuggestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationDosingSuggestionControllerSuggest(requestParameters: MedicationApiMedicationDosingSuggestionControllerSuggestRequest, options?: AxiosRequestConfig): AxiosPromise<MedicationDosingSuggestionDto> {
            return localVarFp.medicationDosingSuggestionControllerSuggest(requestParameters.profileId, requestParameters.medicineProductId, requestParameters.name, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for medicationControllerAddProfileMedication operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerAddProfileMedicationRequest
 */
export interface MedicationApiMedicationControllerAddProfileMedicationRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerAddProfileMedication
     */
    readonly profileId: string

    /**
     *
     * @type {AddProfileMedicationDto}
     * @memberof MedicationApiMedicationControllerAddProfileMedication
     */
    readonly addProfileMedicationDto: AddProfileMedicationDto
}

/**
 * Request parameters for medicationControllerAddProfileMedicationInOrganization operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerAddProfileMedicationInOrganizationRequest
 */
export interface MedicationApiMedicationControllerAddProfileMedicationInOrganizationRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerAddProfileMedicationInOrganization
     */
    readonly profileId: string

    /**
     *
     * @type {AddFacilityMedicationDto}
     * @memberof MedicationApiMedicationControllerAddProfileMedicationInOrganization
     */
    readonly addFacilityMedicationDto: AddFacilityMedicationDto
}

/**
 * Request parameters for medicationControllerAddVisitMedication operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerAddVisitMedicationRequest
 */
export interface MedicationApiMedicationControllerAddVisitMedicationRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerAddVisitMedication
     */
    readonly visitId: string

    /**
     *
     * @type {AddFacilityMedicationDto}
     * @memberof MedicationApiMedicationControllerAddVisitMedication
     */
    readonly addFacilityMedicationDto: AddFacilityMedicationDto
}

/**
 * Request parameters for medicationControllerChangeProfileMedicationStatus operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerChangeProfileMedicationStatusRequest
 */
export interface MedicationApiMedicationControllerChangeProfileMedicationStatusRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerChangeProfileMedicationStatus
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerChangeProfileMedicationStatus
     */
    readonly medicationId: string

    /**
     *
     * @type {ChangeMedicationStatusDto}
     * @memberof MedicationApiMedicationControllerChangeProfileMedicationStatus
     */
    readonly changeMedicationStatusDto: ChangeMedicationStatusDto
}

/**
 * Request parameters for medicationControllerChangeProfileMedicationStatusInOrganization operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerChangeProfileMedicationStatusInOrganizationRequest
 */
export interface MedicationApiMedicationControllerChangeProfileMedicationStatusInOrganizationRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerChangeProfileMedicationStatusInOrganization
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerChangeProfileMedicationStatusInOrganization
     */
    readonly medicationId: string

    /**
     *
     * @type {ChangeMedicationStatusDto}
     * @memberof MedicationApiMedicationControllerChangeProfileMedicationStatusInOrganization
     */
    readonly changeMedicationStatusDto: ChangeMedicationStatusDto
}

/**
 * Request parameters for medicationControllerChangeVisitMedicationStatus operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerChangeVisitMedicationStatusRequest
 */
export interface MedicationApiMedicationControllerChangeVisitMedicationStatusRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerChangeVisitMedicationStatus
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerChangeVisitMedicationStatus
     */
    readonly medicationId: string

    /**
     *
     * @type {ChangeMedicationStatusDto}
     * @memberof MedicationApiMedicationControllerChangeVisitMedicationStatus
     */
    readonly changeMedicationStatusDto: ChangeMedicationStatusDto
}

/**
 * Request parameters for medicationControllerDeleteProfileMedication operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerDeleteProfileMedicationRequest
 */
export interface MedicationApiMedicationControllerDeleteProfileMedicationRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerDeleteProfileMedication
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerDeleteProfileMedication
     */
    readonly medicationId: string
}

/**
 * Request parameters for medicationControllerDeleteProfileMedicationInOrganization operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerDeleteProfileMedicationInOrganizationRequest
 */
export interface MedicationApiMedicationControllerDeleteProfileMedicationInOrganizationRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerDeleteProfileMedicationInOrganization
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerDeleteProfileMedicationInOrganization
     */
    readonly medicationId: string

    /**
     * Optional visit ID to track deletion as a visit activity
     * @type {string}
     * @memberof MedicationApiMedicationControllerDeleteProfileMedicationInOrganization
     */
    readonly visitId?: string
}

/**
 * Request parameters for medicationControllerGetProfileMedicationHistory operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerGetProfileMedicationHistoryRequest
 */
export interface MedicationApiMedicationControllerGetProfileMedicationHistoryRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerGetProfileMedicationHistory
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerGetProfileMedicationHistory
     */
    readonly medicationId: string
}

/**
 * Request parameters for medicationControllerGetProfileMedicationHistoryInOrganization operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerGetProfileMedicationHistoryInOrganizationRequest
 */
export interface MedicationApiMedicationControllerGetProfileMedicationHistoryInOrganizationRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerGetProfileMedicationHistoryInOrganization
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerGetProfileMedicationHistoryInOrganization
     */
    readonly medicationId: string
}

/**
 * Request parameters for medicationControllerGetProfileMedications operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerGetProfileMedicationsRequest
 */
export interface MedicationApiMedicationControllerGetProfileMedicationsRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerGetProfileMedications
     */
    readonly profileId: string

    /**
     * Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
     * @type {number}
     * @memberof MedicationApiMedicationControllerGetProfileMedications
     */
    readonly page?: number

    /**
     * Rows per page. Omit together with &#x60;page&#x60; to get every row.
     * @type {number}
     * @memberof MedicationApiMedicationControllerGetProfileMedications
     */
    readonly limit?: number

    /**
     * Defaults to &#x60;all&#x60;
     * @type {'active' | 'stopped' | 'all'}
     * @memberof MedicationApiMedicationControllerGetProfileMedications
     */
    readonly status?: 'active' | 'stopped' | 'all'

    /**
     * Repeat the parameter or pass it comma-separated
     * @type {Array<'SCHEDULED' | 'ACTIVE' | 'PAUSED' | 'STOPPED'>}
     * @memberof MedicationApiMedicationControllerGetProfileMedications
     */
    readonly statuses?: Array<'SCHEDULED' | 'ACTIVE' | 'PAUSED' | 'STOPPED'>
}

/**
 * Request parameters for medicationControllerGetProfileMedicationsInOrganization operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerGetProfileMedicationsInOrganizationRequest
 */
export interface MedicationApiMedicationControllerGetProfileMedicationsInOrganizationRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerGetProfileMedicationsInOrganization
     */
    readonly profileId: string

    /**
     * Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
     * @type {number}
     * @memberof MedicationApiMedicationControllerGetProfileMedicationsInOrganization
     */
    readonly page?: number

    /**
     * Rows per page. Omit together with &#x60;page&#x60; to get every row.
     * @type {number}
     * @memberof MedicationApiMedicationControllerGetProfileMedicationsInOrganization
     */
    readonly limit?: number

    /**
     * Defaults to &#x60;all&#x60;
     * @type {'active' | 'stopped' | 'all'}
     * @memberof MedicationApiMedicationControllerGetProfileMedicationsInOrganization
     */
    readonly status?: 'active' | 'stopped' | 'all'

    /**
     * Repeat the parameter or pass it comma-separated
     * @type {Array<'SCHEDULED' | 'ACTIVE' | 'PAUSED' | 'STOPPED'>}
     * @memberof MedicationApiMedicationControllerGetProfileMedicationsInOrganization
     */
    readonly statuses?: Array<'SCHEDULED' | 'ACTIVE' | 'PAUSED' | 'STOPPED'>
}

/**
 * Request parameters for medicationControllerListVisitMedications operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerListVisitMedicationsRequest
 */
export interface MedicationApiMedicationControllerListVisitMedicationsRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerListVisitMedications
     */
    readonly visitId: string
}

/**
 * Request parameters for medicationControllerRemoveVisitMedication operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerRemoveVisitMedicationRequest
 */
export interface MedicationApiMedicationControllerRemoveVisitMedicationRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerRemoveVisitMedication
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerRemoveVisitMedication
     */
    readonly medicationId: string
}

/**
 * Request parameters for medicationControllerUpdateProfileMedication operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerUpdateProfileMedicationRequest
 */
export interface MedicationApiMedicationControllerUpdateProfileMedicationRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerUpdateProfileMedication
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerUpdateProfileMedication
     */
    readonly medicationId: string

    /**
     *
     * @type {UpdateProfileMedicationDto}
     * @memberof MedicationApiMedicationControllerUpdateProfileMedication
     */
    readonly updateProfileMedicationDto: UpdateProfileMedicationDto
}

/**
 * Request parameters for medicationControllerUpdateProfileMedicationInOrganization operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerUpdateProfileMedicationInOrganizationRequest
 */
export interface MedicationApiMedicationControllerUpdateProfileMedicationInOrganizationRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerUpdateProfileMedicationInOrganization
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerUpdateProfileMedicationInOrganization
     */
    readonly medicationId: string

    /**
     *
     * @type {UpdateFacilityMedicationDto}
     * @memberof MedicationApiMedicationControllerUpdateProfileMedicationInOrganization
     */
    readonly updateFacilityMedicationDto: UpdateFacilityMedicationDto
}

/**
 * Request parameters for medicationControllerUpdateVisitMedication operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationControllerUpdateVisitMedicationRequest
 */
export interface MedicationApiMedicationControllerUpdateVisitMedicationRequest {
    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerUpdateVisitMedication
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof MedicationApiMedicationControllerUpdateVisitMedication
     */
    readonly medicationId: string

    /**
     *
     * @type {UpdateFacilityMedicationDto}
     * @memberof MedicationApiMedicationControllerUpdateVisitMedication
     */
    readonly updateFacilityMedicationDto: UpdateFacilityMedicationDto
}

/**
 * Request parameters for medicationDosingSuggestionControllerSuggest operation in MedicationApi.
 * @export
 * @interface MedicationApiMedicationDosingSuggestionControllerSuggestRequest
 */
export interface MedicationApiMedicationDosingSuggestionControllerSuggestRequest {
    /**
     * The patient the drug is being prescribed for
     * @type {string}
     * @memberof MedicationApiMedicationDosingSuggestionControllerSuggest
     */
    readonly profileId: string

    /**
     * Registry medicine id of the picked drug; matched before the name
     * @type {string}
     * @memberof MedicationApiMedicationDosingSuggestionControllerSuggest
     */
    readonly medicineProductId?: string

    /**
     * Name of the picked drug, matched whole and case-insensitively when it has no registry id
     * @type {string}
     * @memberof MedicationApiMedicationDosingSuggestionControllerSuggest
     */
    readonly name?: string

    /**
     *
     * @type {object}
     * @memberof MedicationApiMedicationDosingSuggestionControllerSuggest
     */
    readonly body?: object
}

/**
 * MedicationApi - object-oriented interface
 * @export
 * @class MedicationApi
 * @extends {BaseAPI}
 */
export class MedicationApi extends BaseAPI {
    /**
     *
     * @summary Add medication to user profile
     * @param {MedicationApiMedicationControllerAddProfileMedicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerAddProfileMedication(requestParameters: MedicationApiMedicationControllerAddProfileMedicationRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerAddProfileMedication(requestParameters.profileId, requestParameters.addProfileMedicationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Add medication to profile within organization context
     * @param {MedicationApiMedicationControllerAddProfileMedicationInOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerAddProfileMedicationInOrganization(requestParameters: MedicationApiMedicationControllerAddProfileMedicationInOrganizationRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerAddProfileMedicationInOrganization(requestParameters.profileId, requestParameters.addFacilityMedicationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Add a medication prescribed during a visit.
     * @param {MedicationApiMedicationControllerAddVisitMedicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerAddVisitMedication(requestParameters: MedicationApiMedicationControllerAddVisitMedicationRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerAddVisitMedication(requestParameters.visitId, requestParameters.addFacilityMedicationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Stop, pause or restart a medication on a user profile
     * @param {MedicationApiMedicationControllerChangeProfileMedicationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerChangeProfileMedicationStatus(requestParameters: MedicationApiMedicationControllerChangeProfileMedicationStatusRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerChangeProfileMedicationStatus(requestParameters.profileId, requestParameters.medicationId, requestParameters.changeMedicationStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Stop, pause or restart a medication on a patient
     * @param {MedicationApiMedicationControllerChangeProfileMedicationStatusInOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerChangeProfileMedicationStatusInOrganization(requestParameters: MedicationApiMedicationControllerChangeProfileMedicationStatusInOrganizationRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerChangeProfileMedicationStatusInOrganization(requestParameters.profileId, requestParameters.medicationId, requestParameters.changeMedicationStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Stop, pause or restart a medication during a visit.
     * @param {MedicationApiMedicationControllerChangeVisitMedicationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerChangeVisitMedicationStatus(requestParameters: MedicationApiMedicationControllerChangeVisitMedicationStatusRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerChangeVisitMedicationStatus(requestParameters.visitId, requestParameters.medicationId, requestParameters.changeMedicationStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete medication from user profile
     * @param {MedicationApiMedicationControllerDeleteProfileMedicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerDeleteProfileMedication(requestParameters: MedicationApiMedicationControllerDeleteProfileMedicationRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerDeleteProfileMedication(requestParameters.profileId, requestParameters.medicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete medication from profile within organization context
     * @param {MedicationApiMedicationControllerDeleteProfileMedicationInOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerDeleteProfileMedicationInOrganization(requestParameters: MedicationApiMedicationControllerDeleteProfileMedicationInOrganizationRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerDeleteProfileMedicationInOrganization(requestParameters.profileId, requestParameters.medicationId, requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Read the history of a medication
     * @param {MedicationApiMedicationControllerGetProfileMedicationHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerGetProfileMedicationHistory(requestParameters: MedicationApiMedicationControllerGetProfileMedicationHistoryRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerGetProfileMedicationHistory(requestParameters.profileId, requestParameters.medicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Read the history of a patient medication
     * @param {MedicationApiMedicationControllerGetProfileMedicationHistoryInOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerGetProfileMedicationHistoryInOrganization(requestParameters: MedicationApiMedicationControllerGetProfileMedicationHistoryInOrganizationRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerGetProfileMedicationHistoryInOrganization(requestParameters.profileId, requestParameters.medicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get user profile medications
     * @param {MedicationApiMedicationControllerGetProfileMedicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerGetProfileMedications(requestParameters: MedicationApiMedicationControllerGetProfileMedicationsRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerGetProfileMedications(requestParameters.profileId, requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.statuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get profile medications within organization context
     * @param {MedicationApiMedicationControllerGetProfileMedicationsInOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerGetProfileMedicationsInOrganization(requestParameters: MedicationApiMedicationControllerGetProfileMedicationsInOrganizationRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerGetProfileMedicationsInOrganization(requestParameters.profileId, requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.statuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List medications attached to a visit.
     * @param {MedicationApiMedicationControllerListVisitMedicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerListVisitMedications(requestParameters: MedicationApiMedicationControllerListVisitMedicationsRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerListVisitMedications(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Remove a medication from a visit.
     * @param {MedicationApiMedicationControllerRemoveVisitMedicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerRemoveVisitMedication(requestParameters: MedicationApiMedicationControllerRemoveVisitMedicationRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerRemoveVisitMedication(requestParameters.visitId, requestParameters.medicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update medication in user profile
     * @param {MedicationApiMedicationControllerUpdateProfileMedicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerUpdateProfileMedication(requestParameters: MedicationApiMedicationControllerUpdateProfileMedicationRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerUpdateProfileMedication(requestParameters.profileId, requestParameters.medicationId, requestParameters.updateProfileMedicationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update medication in profile within organization context
     * @param {MedicationApiMedicationControllerUpdateProfileMedicationInOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerUpdateProfileMedicationInOrganization(requestParameters: MedicationApiMedicationControllerUpdateProfileMedicationInOrganizationRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerUpdateProfileMedicationInOrganization(requestParameters.profileId, requestParameters.medicationId, requestParameters.updateFacilityMedicationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update a medication on a visit.
     * @param {MedicationApiMedicationControllerUpdateVisitMedicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationControllerUpdateVisitMedication(requestParameters: MedicationApiMedicationControllerUpdateVisitMedicationRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationControllerUpdateVisitMedication(requestParameters.visitId, requestParameters.medicationId, requestParameters.updateFacilityMedicationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary How the organization last dosed the picked drug, preferring a patient of the same species (the medication form\'s dosage autofill)
     * @param {MedicationApiMedicationDosingSuggestionControllerSuggestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationApi
     */
    public medicationDosingSuggestionControllerSuggest(requestParameters: MedicationApiMedicationDosingSuggestionControllerSuggestRequest, options?: AxiosRequestConfig) {
        return MedicationApiFp(this.configuration).medicationDosingSuggestionControllerSuggest(requestParameters.profileId, requestParameters.medicineProductId, requestParameters.name, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MedicineApi - axios parameter creator
 * @export
 */
export const MedicineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get medicine by ID
         * @param {string} id The medicine ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicineControllerGetMedicineById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('medicineControllerGetMedicineById', 'id', id)
            const localVarPath = `/api/medicine/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get medicine by exact product name
         * @param {string} productName The exact product name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicineControllerGetMedicineByName: async (productName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productName' is not null or undefined
            assertParamExists('medicineControllerGetMedicineByName', 'productName', productName)
            const localVarPath = `/api/medicine/name/{productName}`
                .replace(`{${"productName"}}`, encodeURIComponent(String(productName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get medicine by product ID
         * @param {string} productId The product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicineControllerGetMedicineByProductId: async (productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('medicineControllerGetMedicineByProductId', 'productId', productId)
            const localVarPath = `/api/medicine/product/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get medicines by ATC code
         * @param {string} atcCode The ATC code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicineControllerGetMedicinesByAtcCode: async (atcCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'atcCode' is not null or undefined
            assertParamExists('medicineControllerGetMedicinesByAtcCode', 'atcCode', atcCode)
            const localVarPath = `/api/medicine/atc/{atcCode}`
                .replace(`{${"atcCode"}}`, encodeURIComponent(String(atcCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Performs efficient full-text search on product names and common names using MongoDB text index
         * @summary Search medicines by name
         * @param {string} [query] Search query for medicine name
         * @param {number} [limit] Maximum number of results to return
         * @param {number} [skip] Number of results to skip (for pagination)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicineControllerSearchMedicines: async (query?: string, limit?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/medicine/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MedicineApi - functional programming interface
 * @export
 */
export const MedicineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MedicineApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get medicine by ID
         * @param {string} id The medicine ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicineControllerGetMedicineById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMedicineDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicineControllerGetMedicineById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get medicine by exact product name
         * @param {string} productName The exact product name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicineControllerGetMedicineByName(productName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMedicineDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicineControllerGetMedicineByName(productName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get medicine by product ID
         * @param {string} productId The product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicineControllerGetMedicineByProductId(productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMedicineDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicineControllerGetMedicineByProductId(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get medicines by ATC code
         * @param {string} atcCode The ATC code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicineControllerGetMedicinesByAtcCode(atcCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetMedicineDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicineControllerGetMedicinesByAtcCode(atcCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Performs efficient full-text search on product names and common names using MongoDB text index
         * @summary Search medicines by name
         * @param {string} [query] Search query for medicine name
         * @param {number} [limit] Maximum number of results to return
         * @param {number} [skip] Number of results to skip (for pagination)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medicineControllerSearchMedicines(query?: string, limit?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MedicineControllerSearchMedicines200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medicineControllerSearchMedicines(query, limit, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MedicineApi - factory interface
 * @export
 */
export const MedicineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MedicineApiFp(configuration)
    return {
        /**
         *
         * @summary Get medicine by ID
         * @param {MedicineApiMedicineControllerGetMedicineByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicineControllerGetMedicineById(requestParameters: MedicineApiMedicineControllerGetMedicineByIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetMedicineDto> {
            return localVarFp.medicineControllerGetMedicineById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get medicine by exact product name
         * @param {MedicineApiMedicineControllerGetMedicineByNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicineControllerGetMedicineByName(requestParameters: MedicineApiMedicineControllerGetMedicineByNameRequest, options?: AxiosRequestConfig): AxiosPromise<GetMedicineDto> {
            return localVarFp.medicineControllerGetMedicineByName(requestParameters.productName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get medicine by product ID
         * @param {MedicineApiMedicineControllerGetMedicineByProductIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicineControllerGetMedicineByProductId(requestParameters: MedicineApiMedicineControllerGetMedicineByProductIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetMedicineDto> {
            return localVarFp.medicineControllerGetMedicineByProductId(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get medicines by ATC code
         * @param {MedicineApiMedicineControllerGetMedicinesByAtcCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicineControllerGetMedicinesByAtcCode(requestParameters: MedicineApiMedicineControllerGetMedicinesByAtcCodeRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetMedicineDto>> {
            return localVarFp.medicineControllerGetMedicinesByAtcCode(requestParameters.atcCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Performs efficient full-text search on product names and common names using MongoDB text index
         * @summary Search medicines by name
         * @param {MedicineApiMedicineControllerSearchMedicinesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicineControllerSearchMedicines(requestParameters: MedicineApiMedicineControllerSearchMedicinesRequest = {}, options?: AxiosRequestConfig): AxiosPromise<MedicineControllerSearchMedicines200Response> {
            return localVarFp.medicineControllerSearchMedicines(requestParameters.query, requestParameters.limit, requestParameters.skip, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for medicineControllerGetMedicineById operation in MedicineApi.
 * @export
 * @interface MedicineApiMedicineControllerGetMedicineByIdRequest
 */
export interface MedicineApiMedicineControllerGetMedicineByIdRequest {
    /**
     * The medicine ID
     * @type {string}
     * @memberof MedicineApiMedicineControllerGetMedicineById
     */
    readonly id: string
}

/**
 * Request parameters for medicineControllerGetMedicineByName operation in MedicineApi.
 * @export
 * @interface MedicineApiMedicineControllerGetMedicineByNameRequest
 */
export interface MedicineApiMedicineControllerGetMedicineByNameRequest {
    /**
     * The exact product name
     * @type {string}
     * @memberof MedicineApiMedicineControllerGetMedicineByName
     */
    readonly productName: string
}

/**
 * Request parameters for medicineControllerGetMedicineByProductId operation in MedicineApi.
 * @export
 * @interface MedicineApiMedicineControllerGetMedicineByProductIdRequest
 */
export interface MedicineApiMedicineControllerGetMedicineByProductIdRequest {
    /**
     * The product ID
     * @type {string}
     * @memberof MedicineApiMedicineControllerGetMedicineByProductId
     */
    readonly productId: string
}

/**
 * Request parameters for medicineControllerGetMedicinesByAtcCode operation in MedicineApi.
 * @export
 * @interface MedicineApiMedicineControllerGetMedicinesByAtcCodeRequest
 */
export interface MedicineApiMedicineControllerGetMedicinesByAtcCodeRequest {
    /**
     * The ATC code
     * @type {string}
     * @memberof MedicineApiMedicineControllerGetMedicinesByAtcCode
     */
    readonly atcCode: string
}

/**
 * Request parameters for medicineControllerSearchMedicines operation in MedicineApi.
 * @export
 * @interface MedicineApiMedicineControllerSearchMedicinesRequest
 */
export interface MedicineApiMedicineControllerSearchMedicinesRequest {
    /**
     * Search query for medicine name
     * @type {string}
     * @memberof MedicineApiMedicineControllerSearchMedicines
     */
    readonly query?: string

    /**
     * Maximum number of results to return
     * @type {number}
     * @memberof MedicineApiMedicineControllerSearchMedicines
     */
    readonly limit?: number

    /**
     * Number of results to skip (for pagination)
     * @type {number}
     * @memberof MedicineApiMedicineControllerSearchMedicines
     */
    readonly skip?: number
}

/**
 * MedicineApi - object-oriented interface
 * @export
 * @class MedicineApi
 * @extends {BaseAPI}
 */
export class MedicineApi extends BaseAPI {
    /**
     *
     * @summary Get medicine by ID
     * @param {MedicineApiMedicineControllerGetMedicineByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicineApi
     */
    public medicineControllerGetMedicineById(requestParameters: MedicineApiMedicineControllerGetMedicineByIdRequest, options?: AxiosRequestConfig) {
        return MedicineApiFp(this.configuration).medicineControllerGetMedicineById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get medicine by exact product name
     * @param {MedicineApiMedicineControllerGetMedicineByNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicineApi
     */
    public medicineControllerGetMedicineByName(requestParameters: MedicineApiMedicineControllerGetMedicineByNameRequest, options?: AxiosRequestConfig) {
        return MedicineApiFp(this.configuration).medicineControllerGetMedicineByName(requestParameters.productName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get medicine by product ID
     * @param {MedicineApiMedicineControllerGetMedicineByProductIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicineApi
     */
    public medicineControllerGetMedicineByProductId(requestParameters: MedicineApiMedicineControllerGetMedicineByProductIdRequest, options?: AxiosRequestConfig) {
        return MedicineApiFp(this.configuration).medicineControllerGetMedicineByProductId(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get medicines by ATC code
     * @param {MedicineApiMedicineControllerGetMedicinesByAtcCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicineApi
     */
    public medicineControllerGetMedicinesByAtcCode(requestParameters: MedicineApiMedicineControllerGetMedicinesByAtcCodeRequest, options?: AxiosRequestConfig) {
        return MedicineApiFp(this.configuration).medicineControllerGetMedicinesByAtcCode(requestParameters.atcCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Performs efficient full-text search on product names and common names using MongoDB text index
     * @summary Search medicines by name
     * @param {MedicineApiMedicineControllerSearchMedicinesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicineApi
     */
    public medicineControllerSearchMedicines(requestParameters: MedicineApiMedicineControllerSearchMedicinesRequest = {}, options?: AxiosRequestConfig) {
        return MedicineApiFp(this.configuration).medicineControllerSearchMedicines(requestParameters.query, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NadzorowanaPrbaRozwojowaRecepcjiApi - axios parameter creator
 * @export
 */
export const NadzorowanaPrbaRozwojowaRecepcjiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} organizationId
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDevelopOperatorTrialControllerCurrent: async (organizationId: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceDevelopOperatorTrialControllerCurrent', 'organizationId', organizationId)
            const localVarPath = `/api/voice-platform/develop-operator-trials/{organizationId}/current`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} organizationId
         * @param {VoiceDevelopOperatorTrialCommandDto} voiceDevelopOperatorTrialCommandDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDevelopOperatorTrialControllerMonitor: async (organizationId: string, voiceDevelopOperatorTrialCommandDto: VoiceDevelopOperatorTrialCommandDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceDevelopOperatorTrialControllerMonitor', 'organizationId', organizationId)
            // verify required parameter 'voiceDevelopOperatorTrialCommandDto' is not null or undefined
            assertParamExists('voiceDevelopOperatorTrialControllerMonitor', 'voiceDevelopOperatorTrialCommandDto', voiceDevelopOperatorTrialCommandDto)
            const localVarPath = `/api/voice-platform/develop-operator-trials/{organizationId}/monitor`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceDevelopOperatorTrialCommandDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} organizationId
         * @param {PublishVoiceDevelopOperatorTrialDto} publishVoiceDevelopOperatorTrialDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDevelopOperatorTrialControllerPublish: async (organizationId: string, publishVoiceDevelopOperatorTrialDto: PublishVoiceDevelopOperatorTrialDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceDevelopOperatorTrialControllerPublish', 'organizationId', organizationId)
            // verify required parameter 'publishVoiceDevelopOperatorTrialDto' is not null or undefined
            assertParamExists('voiceDevelopOperatorTrialControllerPublish', 'publishVoiceDevelopOperatorTrialDto', publishVoiceDevelopOperatorTrialDto)
            const localVarPath = `/api/voice-platform/develop-operator-trials/{organizationId}/publications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishVoiceDevelopOperatorTrialDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} organizationId
         * @param {VoiceDevelopOperatorTrialCommandDto} voiceDevelopOperatorTrialCommandDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDevelopOperatorTrialControllerRevoke: async (organizationId: string, voiceDevelopOperatorTrialCommandDto: VoiceDevelopOperatorTrialCommandDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceDevelopOperatorTrialControllerRevoke', 'organizationId', organizationId)
            // verify required parameter 'voiceDevelopOperatorTrialCommandDto' is not null or undefined
            assertParamExists('voiceDevelopOperatorTrialControllerRevoke', 'voiceDevelopOperatorTrialCommandDto', voiceDevelopOperatorTrialCommandDto)
            const localVarPath = `/api/voice-platform/develop-operator-trials/{organizationId}/revoke`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceDevelopOperatorTrialCommandDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NadzorowanaPrbaRozwojowaRecepcjiApi - functional programming interface
 * @export
 */
export const NadzorowanaPrbaRozwojowaRecepcjiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NadzorowanaPrbaRozwojowaRecepcjiApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {string} organizationId
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceDevelopOperatorTrialControllerCurrent(organizationId: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceDevelopOperatorTrialCurrentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceDevelopOperatorTrialControllerCurrent(organizationId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} organizationId
         * @param {VoiceDevelopOperatorTrialCommandDto} voiceDevelopOperatorTrialCommandDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceDevelopOperatorTrialControllerMonitor(organizationId: string, voiceDevelopOperatorTrialCommandDto: VoiceDevelopOperatorTrialCommandDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceDevelopOperatorTrialCurrentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceDevelopOperatorTrialControllerMonitor(organizationId, voiceDevelopOperatorTrialCommandDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} organizationId
         * @param {PublishVoiceDevelopOperatorTrialDto} publishVoiceDevelopOperatorTrialDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceDevelopOperatorTrialControllerPublish(organizationId: string, publishVoiceDevelopOperatorTrialDto: PublishVoiceDevelopOperatorTrialDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceDevelopOperatorTrialCurrentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceDevelopOperatorTrialControllerPublish(organizationId, publishVoiceDevelopOperatorTrialDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} organizationId
         * @param {VoiceDevelopOperatorTrialCommandDto} voiceDevelopOperatorTrialCommandDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceDevelopOperatorTrialControllerRevoke(organizationId: string, voiceDevelopOperatorTrialCommandDto: VoiceDevelopOperatorTrialCommandDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceDevelopOperatorTrialCurrentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceDevelopOperatorTrialControllerRevoke(organizationId, voiceDevelopOperatorTrialCommandDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NadzorowanaPrbaRozwojowaRecepcjiApi - factory interface
 * @export
 */
export const NadzorowanaPrbaRozwojowaRecepcjiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NadzorowanaPrbaRozwojowaRecepcjiApiFp(configuration)
    return {
        /**
         *
         * @param {NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerCurrentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDevelopOperatorTrialControllerCurrent(requestParameters: NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerCurrentRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceDevelopOperatorTrialCurrentDto> {
            return localVarFp.voiceDevelopOperatorTrialControllerCurrent(requestParameters.organizationId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerMonitorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDevelopOperatorTrialControllerMonitor(requestParameters: NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerMonitorRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceDevelopOperatorTrialCurrentDto> {
            return localVarFp.voiceDevelopOperatorTrialControllerMonitor(requestParameters.organizationId, requestParameters.voiceDevelopOperatorTrialCommandDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerPublishRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDevelopOperatorTrialControllerPublish(requestParameters: NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerPublishRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceDevelopOperatorTrialCurrentDto> {
            return localVarFp.voiceDevelopOperatorTrialControllerPublish(requestParameters.organizationId, requestParameters.publishVoiceDevelopOperatorTrialDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerRevokeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDevelopOperatorTrialControllerRevoke(requestParameters: NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerRevokeRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceDevelopOperatorTrialCurrentDto> {
            return localVarFp.voiceDevelopOperatorTrialControllerRevoke(requestParameters.organizationId, requestParameters.voiceDevelopOperatorTrialCommandDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceDevelopOperatorTrialControllerCurrent operation in NadzorowanaPrbaRozwojowaRecepcjiApi.
 * @export
 * @interface NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerCurrentRequest
 */
export interface NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerCurrentRequest {
    /**
     *
     * @type {string}
     * @memberof NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerCurrent
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerCurrent
     */
    readonly body?: string
}

/**
 * Request parameters for voiceDevelopOperatorTrialControllerMonitor operation in NadzorowanaPrbaRozwojowaRecepcjiApi.
 * @export
 * @interface NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerMonitorRequest
 */
export interface NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerMonitorRequest {
    /**
     *
     * @type {string}
     * @memberof NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerMonitor
     */
    readonly organizationId: string

    /**
     *
     * @type {VoiceDevelopOperatorTrialCommandDto}
     * @memberof NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerMonitor
     */
    readonly voiceDevelopOperatorTrialCommandDto: VoiceDevelopOperatorTrialCommandDto
}

/**
 * Request parameters for voiceDevelopOperatorTrialControllerPublish operation in NadzorowanaPrbaRozwojowaRecepcjiApi.
 * @export
 * @interface NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerPublishRequest
 */
export interface NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerPublishRequest {
    /**
     *
     * @type {string}
     * @memberof NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerPublish
     */
    readonly organizationId: string

    /**
     *
     * @type {PublishVoiceDevelopOperatorTrialDto}
     * @memberof NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerPublish
     */
    readonly publishVoiceDevelopOperatorTrialDto: PublishVoiceDevelopOperatorTrialDto
}

/**
 * Request parameters for voiceDevelopOperatorTrialControllerRevoke operation in NadzorowanaPrbaRozwojowaRecepcjiApi.
 * @export
 * @interface NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerRevokeRequest
 */
export interface NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerRevokeRequest {
    /**
     *
     * @type {string}
     * @memberof NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerRevoke
     */
    readonly organizationId: string

    /**
     *
     * @type {VoiceDevelopOperatorTrialCommandDto}
     * @memberof NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerRevoke
     */
    readonly voiceDevelopOperatorTrialCommandDto: VoiceDevelopOperatorTrialCommandDto
}

/**
 * NadzorowanaPrbaRozwojowaRecepcjiApi - object-oriented interface
 * @export
 * @class NadzorowanaPrbaRozwojowaRecepcjiApi
 * @extends {BaseAPI}
 */
export class NadzorowanaPrbaRozwojowaRecepcjiApi extends BaseAPI {
    /**
     *
     * @param {NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerCurrentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NadzorowanaPrbaRozwojowaRecepcjiApi
     */
    public voiceDevelopOperatorTrialControllerCurrent(requestParameters: NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerCurrentRequest, options?: AxiosRequestConfig) {
        return NadzorowanaPrbaRozwojowaRecepcjiApiFp(this.configuration).voiceDevelopOperatorTrialControllerCurrent(requestParameters.organizationId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerMonitorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NadzorowanaPrbaRozwojowaRecepcjiApi
     */
    public voiceDevelopOperatorTrialControllerMonitor(requestParameters: NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerMonitorRequest, options?: AxiosRequestConfig) {
        return NadzorowanaPrbaRozwojowaRecepcjiApiFp(this.configuration).voiceDevelopOperatorTrialControllerMonitor(requestParameters.organizationId, requestParameters.voiceDevelopOperatorTrialCommandDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerPublishRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NadzorowanaPrbaRozwojowaRecepcjiApi
     */
    public voiceDevelopOperatorTrialControllerPublish(requestParameters: NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerPublishRequest, options?: AxiosRequestConfig) {
        return NadzorowanaPrbaRozwojowaRecepcjiApiFp(this.configuration).voiceDevelopOperatorTrialControllerPublish(requestParameters.organizationId, requestParameters.publishVoiceDevelopOperatorTrialDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerRevokeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NadzorowanaPrbaRozwojowaRecepcjiApi
     */
    public voiceDevelopOperatorTrialControllerRevoke(requestParameters: NadzorowanaPrbaRozwojowaRecepcjiApiVoiceDevelopOperatorTrialControllerRevokeRequest, options?: AxiosRequestConfig) {
        return NadzorowanaPrbaRozwojowaRecepcjiApiFp(this.configuration).voiceDevelopOperatorTrialControllerRevoke(requestParameters.organizationId, requestParameters.voiceDevelopOperatorTrialCommandDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OcenaJakociPilotauRecepcjiGosowejApi - axios parameter creator
 * @export
 */
export const OcenaJakociPilotauRecepcjiGosowejApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Pobierz zbiorczą ocenę jakości bez treści rozmów
         * @param {string} organizationId
         * @param {string} pilotReference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotFacilityQaControllerAggregate: async (organizationId: string, pilotReference: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voicePilotFacilityQaControllerAggregate', 'organizationId', organizationId)
            // verify required parameter 'pilotReference' is not null or undefined
            assertParamExists('voicePilotFacilityQaControllerAggregate', 'pilotReference', pilotReference)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/pilots/{pilotReference}/qa-reviews/aggregate`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"pilotReference"}}`, encodeURIComponent(String(pilotReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zapisz ocenę próbki według rubryki pilotażu
         * @param {string} organizationId
         * @param {string} pilotReference
         * @param {SubmitVoicePilotFacilityQaReviewDto} submitVoicePilotFacilityQaReviewDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotFacilityQaControllerSubmit: async (organizationId: string, pilotReference: string, submitVoicePilotFacilityQaReviewDto: SubmitVoicePilotFacilityQaReviewDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voicePilotFacilityQaControllerSubmit', 'organizationId', organizationId)
            // verify required parameter 'pilotReference' is not null or undefined
            assertParamExists('voicePilotFacilityQaControllerSubmit', 'pilotReference', pilotReference)
            // verify required parameter 'submitVoicePilotFacilityQaReviewDto' is not null or undefined
            assertParamExists('voicePilotFacilityQaControllerSubmit', 'submitVoicePilotFacilityQaReviewDto', submitVoicePilotFacilityQaReviewDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/pilots/{pilotReference}/qa-reviews`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"pilotReference"}}`, encodeURIComponent(String(pilotReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitVoicePilotFacilityQaReviewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OcenaJakociPilotauRecepcjiGosowejApi - functional programming interface
 * @export
 */
export const OcenaJakociPilotauRecepcjiGosowejApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OcenaJakociPilotauRecepcjiGosowejApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Pobierz zbiorczą ocenę jakości bez treści rozmów
         * @param {string} organizationId
         * @param {string} pilotReference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePilotFacilityQaControllerAggregate(organizationId: string, pilotReference: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePilotFacilityQaAggregateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePilotFacilityQaControllerAggregate(organizationId, pilotReference, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zapisz ocenę próbki według rubryki pilotażu
         * @param {string} organizationId
         * @param {string} pilotReference
         * @param {SubmitVoicePilotFacilityQaReviewDto} submitVoicePilotFacilityQaReviewDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePilotFacilityQaControllerSubmit(organizationId: string, pilotReference: string, submitVoicePilotFacilityQaReviewDto: SubmitVoicePilotFacilityQaReviewDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePilotFacilityQaReceiptResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePilotFacilityQaControllerSubmit(organizationId, pilotReference, submitVoicePilotFacilityQaReviewDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OcenaJakociPilotauRecepcjiGosowejApi - factory interface
 * @export
 */
export const OcenaJakociPilotauRecepcjiGosowejApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OcenaJakociPilotauRecepcjiGosowejApiFp(configuration)
    return {
        /**
         *
         * @summary Pobierz zbiorczą ocenę jakości bez treści rozmów
         * @param {OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerAggregateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotFacilityQaControllerAggregate(requestParameters: OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerAggregateRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePilotFacilityQaAggregateResponseDto> {
            return localVarFp.voicePilotFacilityQaControllerAggregate(requestParameters.organizationId, requestParameters.pilotReference, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zapisz ocenę próbki według rubryki pilotażu
         * @param {OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerSubmitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotFacilityQaControllerSubmit(requestParameters: OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerSubmitRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePilotFacilityQaReceiptResponseDto> {
            return localVarFp.voicePilotFacilityQaControllerSubmit(requestParameters.organizationId, requestParameters.pilotReference, requestParameters.submitVoicePilotFacilityQaReviewDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voicePilotFacilityQaControllerAggregate operation in OcenaJakociPilotauRecepcjiGosowejApi.
 * @export
 * @interface OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerAggregateRequest
 */
export interface OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerAggregateRequest {
    /**
     *
     * @type {string}
     * @memberof OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerAggregate
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerAggregate
     */
    readonly pilotReference: string
}

/**
 * Request parameters for voicePilotFacilityQaControllerSubmit operation in OcenaJakociPilotauRecepcjiGosowejApi.
 * @export
 * @interface OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerSubmitRequest
 */
export interface OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerSubmitRequest {
    /**
     *
     * @type {string}
     * @memberof OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerSubmit
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerSubmit
     */
    readonly pilotReference: string

    /**
     *
     * @type {SubmitVoicePilotFacilityQaReviewDto}
     * @memberof OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerSubmit
     */
    readonly submitVoicePilotFacilityQaReviewDto: SubmitVoicePilotFacilityQaReviewDto
}

/**
 * OcenaJakociPilotauRecepcjiGosowejApi - object-oriented interface
 * @export
 * @class OcenaJakociPilotauRecepcjiGosowejApi
 * @extends {BaseAPI}
 */
export class OcenaJakociPilotauRecepcjiGosowejApi extends BaseAPI {
    /**
     *
     * @summary Pobierz zbiorczą ocenę jakości bez treści rozmów
     * @param {OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerAggregateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OcenaJakociPilotauRecepcjiGosowejApi
     */
    public voicePilotFacilityQaControllerAggregate(requestParameters: OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerAggregateRequest, options?: AxiosRequestConfig) {
        return OcenaJakociPilotauRecepcjiGosowejApiFp(this.configuration).voicePilotFacilityQaControllerAggregate(requestParameters.organizationId, requestParameters.pilotReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zapisz ocenę próbki według rubryki pilotażu
     * @param {OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerSubmitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OcenaJakociPilotauRecepcjiGosowejApi
     */
    public voicePilotFacilityQaControllerSubmit(requestParameters: OcenaJakociPilotauRecepcjiGosowejApiVoicePilotFacilityQaControllerSubmitRequest, options?: AxiosRequestConfig) {
        return OcenaJakociPilotauRecepcjiGosowejApiFp(this.configuration).voicePilotFacilityQaControllerSubmit(requestParameters.organizationId, requestParameters.pilotReference, requestParameters.submitVoicePilotFacilityQaReviewDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OdnowienieKwalifikacjiProdukcyjnejVoiceApi - axios parameter creator
 * @export
 */
export const OdnowienieKwalifikacjiProdukcyjnejVoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Potwierdź przyjęcie terminu odnowienia kwalifikacji Voice
         * @param {string} cycleId
         * @param {AcknowledgeVoiceProductionQualificationRenewalDto} acknowledgeVoiceProductionQualificationRenewalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationRenewalControllerAcknowledge: async (cycleId: string, acknowledgeVoiceProductionQualificationRenewalDto: AcknowledgeVoiceProductionQualificationRenewalDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cycleId' is not null or undefined
            assertParamExists('voiceProductionQualificationRenewalControllerAcknowledge', 'cycleId', cycleId)
            // verify required parameter 'acknowledgeVoiceProductionQualificationRenewalDto' is not null or undefined
            assertParamExists('voiceProductionQualificationRenewalControllerAcknowledge', 'acknowledgeVoiceProductionQualificationRenewalDto', acknowledgeVoiceProductionQualificationRenewalDto)
            const localVarPath = `/api/voice-platform/production-qualifications/renewal/cycles/{cycleId}/acknowledgements`
                .replace(`{${"cycleId"}}`, encodeURIComponent(String(cycleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acknowledgeVoiceProductionQualificationRenewalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz stan odnowienia kwalifikacji Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationRenewalControllerCurrent: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/production-qualifications/renewal/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OdnowienieKwalifikacjiProdukcyjnejVoiceApi - functional programming interface
 * @export
 */
export const OdnowienieKwalifikacjiProdukcyjnejVoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OdnowienieKwalifikacjiProdukcyjnejVoiceApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Potwierdź przyjęcie terminu odnowienia kwalifikacji Voice
         * @param {string} cycleId
         * @param {AcknowledgeVoiceProductionQualificationRenewalDto} acknowledgeVoiceProductionQualificationRenewalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProductionQualificationRenewalControllerAcknowledge(cycleId: string, acknowledgeVoiceProductionQualificationRenewalDto: AcknowledgeVoiceProductionQualificationRenewalDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProductionQualificationRenewalResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProductionQualificationRenewalControllerAcknowledge(cycleId, acknowledgeVoiceProductionQualificationRenewalDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz stan odnowienia kwalifikacji Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceProductionQualificationRenewalControllerCurrent(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProductionQualificationRenewalResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceProductionQualificationRenewalControllerCurrent(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OdnowienieKwalifikacjiProdukcyjnejVoiceApi - factory interface
 * @export
 */
export const OdnowienieKwalifikacjiProdukcyjnejVoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OdnowienieKwalifikacjiProdukcyjnejVoiceApiFp(configuration)
    return {
        /**
         *
         * @summary Potwierdź przyjęcie terminu odnowienia kwalifikacji Voice
         * @param {OdnowienieKwalifikacjiProdukcyjnejVoiceApiVoiceProductionQualificationRenewalControllerAcknowledgeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationRenewalControllerAcknowledge(requestParameters: OdnowienieKwalifikacjiProdukcyjnejVoiceApiVoiceProductionQualificationRenewalControllerAcknowledgeRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceProductionQualificationRenewalResponseDto> {
            return localVarFp.voiceProductionQualificationRenewalControllerAcknowledge(requestParameters.cycleId, requestParameters.acknowledgeVoiceProductionQualificationRenewalDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz stan odnowienia kwalifikacji Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceProductionQualificationRenewalControllerCurrent(options?: AxiosRequestConfig): AxiosPromise<VoiceProductionQualificationRenewalResponseDto> {
            return localVarFp.voiceProductionQualificationRenewalControllerCurrent(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceProductionQualificationRenewalControllerAcknowledge operation in OdnowienieKwalifikacjiProdukcyjnejVoiceApi.
 * @export
 * @interface OdnowienieKwalifikacjiProdukcyjnejVoiceApiVoiceProductionQualificationRenewalControllerAcknowledgeRequest
 */
export interface OdnowienieKwalifikacjiProdukcyjnejVoiceApiVoiceProductionQualificationRenewalControllerAcknowledgeRequest {
    /**
     *
     * @type {string}
     * @memberof OdnowienieKwalifikacjiProdukcyjnejVoiceApiVoiceProductionQualificationRenewalControllerAcknowledge
     */
    readonly cycleId: string

    /**
     *
     * @type {AcknowledgeVoiceProductionQualificationRenewalDto}
     * @memberof OdnowienieKwalifikacjiProdukcyjnejVoiceApiVoiceProductionQualificationRenewalControllerAcknowledge
     */
    readonly acknowledgeVoiceProductionQualificationRenewalDto: AcknowledgeVoiceProductionQualificationRenewalDto
}

/**
 * OdnowienieKwalifikacjiProdukcyjnejVoiceApi - object-oriented interface
 * @export
 * @class OdnowienieKwalifikacjiProdukcyjnejVoiceApi
 * @extends {BaseAPI}
 */
export class OdnowienieKwalifikacjiProdukcyjnejVoiceApi extends BaseAPI {
    /**
     *
     * @summary Potwierdź przyjęcie terminu odnowienia kwalifikacji Voice
     * @param {OdnowienieKwalifikacjiProdukcyjnejVoiceApiVoiceProductionQualificationRenewalControllerAcknowledgeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OdnowienieKwalifikacjiProdukcyjnejVoiceApi
     */
    public voiceProductionQualificationRenewalControllerAcknowledge(requestParameters: OdnowienieKwalifikacjiProdukcyjnejVoiceApiVoiceProductionQualificationRenewalControllerAcknowledgeRequest, options?: AxiosRequestConfig) {
        return OdnowienieKwalifikacjiProdukcyjnejVoiceApiFp(this.configuration).voiceProductionQualificationRenewalControllerAcknowledge(requestParameters.cycleId, requestParameters.acknowledgeVoiceProductionQualificationRenewalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz stan odnowienia kwalifikacji Voice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OdnowienieKwalifikacjiProdukcyjnejVoiceApi
     */
    public voiceProductionQualificationRenewalControllerCurrent(options?: AxiosRequestConfig) {
        return OdnowienieKwalifikacjiProdukcyjnejVoiceApiFp(this.configuration).voiceProductionQualificationRenewalControllerCurrent(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationApi - axios parameter creator
 * @export
 */
export const OrganizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Add organization.
         * @param {AddOrganizationDto} addOrganizationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerAddOrganization: async (addOrganizationDto: AddOrganizationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addOrganizationDto' is not null or undefined
            assertParamExists('organizationControllerAddOrganization', 'addOrganizationDto', addOrganizationDto)
            const localVarPath = `/api/organization/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrganizationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns information about professionals who have the services configured
         * @summary Check if removing services will affect professional configurations
         * @param {string} id Organization ID
         * @param {CheckServiceUsageDto} checkServiceUsageDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerCheckOrganizationServiceUsage: async (id: string, checkServiceUsageDto: CheckServiceUsageDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerCheckOrganizationServiceUsage', 'id', id)
            // verify required parameter 'checkServiceUsageDto' is not null or undefined
            assertParamExists('organizationControllerCheckOrganizationServiceUsage', 'checkServiceUsageDto', checkServiceUsageDto)
            const localVarPath = `/api/organization/{id}/check-service-usage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkServiceUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns information about professionals and services that will be affected
         * @summary Check if removing specializations will affect service assignments across the organization
         * @param {string} id Organization ID
         * @param {CheckSpecializationServicesDto} checkSpecializationServicesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerCheckOrganizationSpecializationServices: async (id: string, checkSpecializationServicesDto: CheckSpecializationServicesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerCheckOrganizationSpecializationServices', 'id', id)
            // verify required parameter 'checkSpecializationServicesDto' is not null or undefined
            assertParamExists('organizationControllerCheckOrganizationSpecializationServices', 'checkSpecializationServicesDto', checkSpecializationServicesDto)
            const localVarPath = `/api/organization/{id}/check-specialization-services`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkSpecializationServicesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all organizations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetAllOrganizations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organization/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all unique cities from organizations (authenticated users)
         * @param {string} [visitType] Optional visit type filter. If not provided, returns all cities.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetCities: async (visitType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organization/cities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (visitType !== undefined) {
                localVarQueryParameter['visitType'] = visitType;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get last booked visit for an organization.
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetLastBookedVisit: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerGetLastBookedVisit', 'id', id)
            const localVarPath = `/api/organization/{id}/last-booked-visit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get organization by ID.
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerGetOrganizationById', 'id', id)
            const localVarPath = `/api/organization/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search this organization\'s customers (users with a visit here). Optional ?query= filters by name/email/phone.
         * @param {string} id Organization ID
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationCustomers: async (id: string, query?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerGetOrganizationCustomers', 'id', id)
            const localVarPath = `/api/organization/{id}/customers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get organization by ID for booking
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationForBooking: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerGetOrganizationForBooking', 'id', id)
            const localVarPath = `/api/organization/booking/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all professionals for an organization.
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationProfessionals: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerGetOrganizationProfessionals', 'id', id)
            const localVarPath = `/api/organization/{id}/professionals`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get professionals for organization booking
         * @param {string} id Organization ID or slug
         * @param {string} [visitType] Optional visit type filter. If not provided, returns all professionals.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationProfessionalsForBooking: async (id: string, visitType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerGetOrganizationProfessionalsForBooking', 'id', id)
            const localVarPath = `/api/organization/booking/{id}/professionals`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (visitType !== undefined) {
                localVarQueryParameter['visitType'] = visitType;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all profiles for an organization.
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationProfiles: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerGetOrganizationProfiles', 'id', id)
            const localVarPath = `/api/organization/{id}/profiles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get paginated profiles for an organization.
         * @param {string} id Organization ID
         * @param {number} [page] Page number (0-indexed)
         * @param {number} [limit] Number of items per page
         * @param {string} [ownerName] Filter by owner name (first or last name)
         * @param {string} [profileName] Filter by profile name (pet name)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationProfilesPaginated: async (id: string, page?: number, limit?: number, ownerName?: string, profileName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerGetOrganizationProfilesPaginated', 'id', id)
            const localVarPath = `/api/organization/{id}/profiles/paginated`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (ownerName !== undefined) {
                localVarQueryParameter['ownerName'] = ownerName;
            }

            if (profileName !== undefined) {
                localVarQueryParameter['profileName'] = profileName;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all users for an organization.
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationUsers: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerGetOrganizationUsers', 'id', id)
            const localVarPath = `/api/organization/{id}/users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all organizations for a user.
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationsByUserId: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('organizationControllerGetOrganizationsByUserId', 'userId', userId)
            const localVarPath = `/api/organization/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get organization from the most recent visit across all user profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetRecentVisitOrganization: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organization/search/recent-visit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Remove organization.
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerRemoveOrganization: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerRemoveOrganization', 'id', id)
            const localVarPath = `/api/organization/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search organizations with optional filters (authenticated users)
         * @param {string} [name] Filter by organization name
         * @param {string} [city] Filter by city name
         * @param {string} [specialization] Filter by specialization ID
         * @param {'video' | 'chat' | 'onsite'} [visitType] Filter by visit type
         * @param {string} [category] Filter by visit category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerSearchOrganizations: async (name?: string, city?: string, specialization?: string, visitType?: 'video' | 'chat' | 'onsite', category?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organization/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (specialization !== undefined) {
                localVarQueryParameter['specialization'] = specialization;
            }

            if (visitType !== undefined) {
                localVarQueryParameter['visitType'] = visitType;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Send a question while waiting for organization verification.
         * @param {SendVerificationQuestionDto} sendVerificationQuestionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerSendVerificationQuestion: async (sendVerificationQuestionDto: SendVerificationQuestionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendVerificationQuestionDto' is not null or undefined
            assertParamExists('organizationControllerSendVerificationQuestion', 'sendVerificationQuestionDto', sendVerificationQuestionDto)
            const localVarPath = `/api/organization/verification-question`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendVerificationQuestionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set organization published state (visible in search).
         * @param {string} id Organization ID
         * @param {SetOrganizationPublishedDto} setOrganizationPublishedDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerSetOrganizationPublished: async (id: string, setOrganizationPublishedDto: SetOrganizationPublishedDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerSetOrganizationPublished', 'id', id)
            // verify required parameter 'setOrganizationPublishedDto' is not null or undefined
            assertParamExists('organizationControllerSetOrganizationPublished', 'setOrganizationPublishedDto', setOrganizationPublishedDto)
            const localVarPath = `/api/organization/{id}/publish`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setOrganizationPublishedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update organization.
         * @param {string} id Organization ID
         * @param {UpdateOrganizationDto} updateOrganizationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerUpdateOrganization: async (id: string, updateOrganizationDto: UpdateOrganizationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerUpdateOrganization', 'id', id)
            // verify required parameter 'updateOrganizationDto' is not null or undefined
            assertParamExists('organizationControllerUpdateOrganization', 'updateOrganizationDto', updateOrganizationDto)
            const localVarPath = `/api/organization/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganizationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update organization enabled categories.
         * @param {string} id Organization ID
         * @param {UpdateEnabledCategoriesDto} updateEnabledCategoriesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerUpdateOrganizationCategories: async (id: string, updateEnabledCategoriesDto: UpdateEnabledCategoriesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerUpdateOrganizationCategories', 'id', id)
            // verify required parameter 'updateEnabledCategoriesDto' is not null or undefined
            assertParamExists('organizationControllerUpdateOrganizationCategories', 'updateEnabledCategoriesDto', updateEnabledCategoriesDto)
            const localVarPath = `/api/organization/{id}/categories`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEnabledCategoriesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update organization time off periods.
         * @param {string} id Organization ID
         * @param {UpdateTimeOffDto} updateTimeOffDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerUpdateOrganizationTimeOff: async (id: string, updateTimeOffDto: UpdateTimeOffDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerUpdateOrganizationTimeOff', 'id', id)
            // verify required parameter 'updateTimeOffDto' is not null or undefined
            assertParamExists('organizationControllerUpdateOrganizationTimeOff', 'updateTimeOffDto', updateTimeOffDto)
            const localVarPath = `/api/organization/{id}/time-off`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTimeOffDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update organization visit settings (types and categories).
         * @param {string} id Organization ID
         * @param {UpdateVisitSettingsDto} updateVisitSettingsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerUpdateOrganizationVisitSettings: async (id: string, updateVisitSettingsDto: UpdateVisitSettingsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerUpdateOrganizationVisitSettings', 'id', id)
            // verify required parameter 'updateVisitSettingsDto' is not null or undefined
            assertParamExists('organizationControllerUpdateOrganizationVisitSettings', 'updateVisitSettingsDto', updateVisitSettingsDto)
            const localVarPath = `/api/organization/{id}/visit-settings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVisitSettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update organization enabled visit types.
         * @param {string} id Organization ID
         * @param {UpdateEnabledVisitTypesDto} updateEnabledVisitTypesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerUpdateOrganizationVisitTypes: async (id: string, updateEnabledVisitTypesDto: UpdateEnabledVisitTypesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerUpdateOrganizationVisitTypes', 'id', id)
            // verify required parameter 'updateEnabledVisitTypesDto' is not null or undefined
            assertParamExists('organizationControllerUpdateOrganizationVisitTypes', 'updateEnabledVisitTypesDto', updateEnabledVisitTypesDto)
            const localVarPath = `/api/organization/{id}/visit-types`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEnabledVisitTypesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update organization working hours.
         * @param {string} id Organization ID
         * @param {UpdateWorkingHoursDto} updateWorkingHoursDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerUpdateOrganizationWorkingHours: async (id: string, updateWorkingHoursDto: UpdateWorkingHoursDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationControllerUpdateOrganizationWorkingHours', 'id', id)
            // verify required parameter 'updateWorkingHoursDto' is not null or undefined
            assertParamExists('organizationControllerUpdateOrganizationWorkingHours', 'updateWorkingHoursDto', updateWorkingHoursDto)
            const localVarPath = `/api/organization/{id}/working-hours`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkingHoursDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationApi - functional programming interface
 * @export
 */
export const OrganizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Add organization.
         * @param {AddOrganizationDto} addOrganizationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerAddOrganization(addOrganizationDto: AddOrganizationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerAddOrganization(addOrganizationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns information about professionals who have the services configured
         * @summary Check if removing services will affect professional configurations
         * @param {string} id Organization ID
         * @param {CheckServiceUsageDto} checkServiceUsageDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerCheckOrganizationServiceUsage(id: string, checkServiceUsageDto: CheckServiceUsageDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckOrganizationServiceUsageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerCheckOrganizationServiceUsage(id, checkServiceUsageDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns information about professionals and services that will be affected
         * @summary Check if removing specializations will affect service assignments across the organization
         * @param {string} id Organization ID
         * @param {CheckSpecializationServicesDto} checkSpecializationServicesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerCheckOrganizationSpecializationServices(id: string, checkSpecializationServicesDto: CheckSpecializationServicesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckOrganizationSpecializationServicesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerCheckOrganizationSpecializationServices(id, checkSpecializationServicesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all organizations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerGetAllOrganizations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerGetAllOrganizations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all unique cities from organizations (authenticated users)
         * @param {string} [visitType] Optional visit type filter. If not provided, returns all cities.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerGetCities(visitType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerGetCities(visitType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get last booked visit for an organization.
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerGetLastBookedVisit(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLastBookedVisitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerGetLastBookedVisit(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get organization by ID.
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerGetOrganizationById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerGetOrganizationById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Search this organization\'s customers (users with a visit here). Optional ?query= filters by name/email/phone.
         * @param {string} id Organization ID
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerGetOrganizationCustomers(id: string, query?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationCustomersDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerGetOrganizationCustomers(id, query, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get organization by ID for booking
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerGetOrganizationForBooking(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationSearchDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerGetOrganizationForBooking(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all professionals for an organization.
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerGetOrganizationProfessionals(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationProfessionalsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerGetOrganizationProfessionals(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get professionals for organization booking
         * @param {string} id Organization ID or slug
         * @param {string} [visitType] Optional visit type filter. If not provided, returns all professionals.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerGetOrganizationProfessionalsForBooking(id: string, visitType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationProfessionalBookingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerGetOrganizationProfessionalsForBooking(id, visitType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all profiles for an organization.
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerGetOrganizationProfiles(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationProfilesDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerGetOrganizationProfiles(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get paginated profiles for an organization.
         * @param {string} id Organization ID
         * @param {number} [page] Page number (0-indexed)
         * @param {number} [limit] Number of items per page
         * @param {string} [ownerName] Filter by owner name (first or last name)
         * @param {string} [profileName] Filter by profile name (pet name)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerGetOrganizationProfilesPaginated(id: string, page?: number, limit?: number, ownerName?: string, profileName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedProfilesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerGetOrganizationProfilesPaginated(id, page, limit, ownerName, profileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all users for an organization.
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerGetOrganizationUsers(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationUsersDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerGetOrganizationUsers(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all organizations for a user.
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerGetOrganizationsByUserId(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserOrganizationsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerGetOrganizationsByUserId(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get organization from the most recent visit across all user profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerGetRecentVisitOrganization(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationSearchDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerGetRecentVisitOrganization(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Remove organization.
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerRemoveOrganization(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerRemoveOrganization(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Search organizations with optional filters (authenticated users)
         * @param {string} [name] Filter by organization name
         * @param {string} [city] Filter by city name
         * @param {string} [specialization] Filter by specialization ID
         * @param {'video' | 'chat' | 'onsite'} [visitType] Filter by visit type
         * @param {string} [category] Filter by visit category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerSearchOrganizations(name?: string, city?: string, specialization?: string, visitType?: 'video' | 'chat' | 'onsite', category?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationSearchDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerSearchOrganizations(name, city, specialization, visitType, category, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Send a question while waiting for organization verification.
         * @param {SendVerificationQuestionDto} sendVerificationQuestionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerSendVerificationQuestion(sendVerificationQuestionDto: SendVerificationQuestionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerSendVerificationQuestion(sendVerificationQuestionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Set organization published state (visible in search).
         * @param {string} id Organization ID
         * @param {SetOrganizationPublishedDto} setOrganizationPublishedDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerSetOrganizationPublished(id: string, setOrganizationPublishedDto: SetOrganizationPublishedDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerSetOrganizationPublished(id, setOrganizationPublishedDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update organization.
         * @param {string} id Organization ID
         * @param {UpdateOrganizationDto} updateOrganizationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerUpdateOrganization(id: string, updateOrganizationDto: UpdateOrganizationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerUpdateOrganization(id, updateOrganizationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update organization enabled categories.
         * @param {string} id Organization ID
         * @param {UpdateEnabledCategoriesDto} updateEnabledCategoriesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerUpdateOrganizationCategories(id: string, updateEnabledCategoriesDto: UpdateEnabledCategoriesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerUpdateOrganizationCategories(id, updateEnabledCategoriesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update organization time off periods.
         * @param {string} id Organization ID
         * @param {UpdateTimeOffDto} updateTimeOffDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerUpdateOrganizationTimeOff(id: string, updateTimeOffDto: UpdateTimeOffDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateScheduleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerUpdateOrganizationTimeOff(id, updateTimeOffDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update organization visit settings (types and categories).
         * @param {string} id Organization ID
         * @param {UpdateVisitSettingsDto} updateVisitSettingsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerUpdateOrganizationVisitSettings(id: string, updateVisitSettingsDto: UpdateVisitSettingsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerUpdateOrganizationVisitSettings(id, updateVisitSettingsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update organization enabled visit types.
         * @param {string} id Organization ID
         * @param {UpdateEnabledVisitTypesDto} updateEnabledVisitTypesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerUpdateOrganizationVisitTypes(id: string, updateEnabledVisitTypesDto: UpdateEnabledVisitTypesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerUpdateOrganizationVisitTypes(id, updateEnabledVisitTypesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update organization working hours.
         * @param {string} id Organization ID
         * @param {UpdateWorkingHoursDto} updateWorkingHoursDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationControllerUpdateOrganizationWorkingHours(id: string, updateWorkingHoursDto: UpdateWorkingHoursDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateScheduleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationControllerUpdateOrganizationWorkingHours(id, updateWorkingHoursDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationApi - factory interface
 * @export
 */
export const OrganizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationApiFp(configuration)
    return {
        /**
         *
         * @summary Add organization.
         * @param {OrganizationApiOrganizationControllerAddOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerAddOrganization(requestParameters: OrganizationApiOrganizationControllerAddOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.organizationControllerAddOrganization(requestParameters.addOrganizationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns information about professionals who have the services configured
         * @summary Check if removing services will affect professional configurations
         * @param {OrganizationApiOrganizationControllerCheckOrganizationServiceUsageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerCheckOrganizationServiceUsage(requestParameters: OrganizationApiOrganizationControllerCheckOrganizationServiceUsageRequest, options?: AxiosRequestConfig): AxiosPromise<CheckOrganizationServiceUsageResponseDto> {
            return localVarFp.organizationControllerCheckOrganizationServiceUsage(requestParameters.id, requestParameters.checkServiceUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns information about professionals and services that will be affected
         * @summary Check if removing specializations will affect service assignments across the organization
         * @param {OrganizationApiOrganizationControllerCheckOrganizationSpecializationServicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerCheckOrganizationSpecializationServices(requestParameters: OrganizationApiOrganizationControllerCheckOrganizationSpecializationServicesRequest, options?: AxiosRequestConfig): AxiosPromise<CheckOrganizationSpecializationServicesResponseDto> {
            return localVarFp.organizationControllerCheckOrganizationSpecializationServices(requestParameters.id, requestParameters.checkSpecializationServicesDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all organizations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetAllOrganizations(options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationsDto>> {
            return localVarFp.organizationControllerGetAllOrganizations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all unique cities from organizations (authenticated users)
         * @param {OrganizationApiOrganizationControllerGetCitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetCities(requestParameters: OrganizationApiOrganizationControllerGetCitiesRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<GetCityDto>> {
            return localVarFp.organizationControllerGetCities(requestParameters.visitType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get last booked visit for an organization.
         * @param {OrganizationApiOrganizationControllerGetLastBookedVisitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetLastBookedVisit(requestParameters: OrganizationApiOrganizationControllerGetLastBookedVisitRequest, options?: AxiosRequestConfig): AxiosPromise<GetLastBookedVisitDto> {
            return localVarFp.organizationControllerGetLastBookedVisit(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get organization by ID.
         * @param {OrganizationApiOrganizationControllerGetOrganizationByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationById(requestParameters: OrganizationApiOrganizationControllerGetOrganizationByIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetOrganizationDto> {
            return localVarFp.organizationControllerGetOrganizationById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search this organization\'s customers (users with a visit here). Optional ?query= filters by name/email/phone.
         * @param {OrganizationApiOrganizationControllerGetOrganizationCustomersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationCustomers(requestParameters: OrganizationApiOrganizationControllerGetOrganizationCustomersRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationCustomersDto>> {
            return localVarFp.organizationControllerGetOrganizationCustomers(requestParameters.id, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get organization by ID for booking
         * @param {OrganizationApiOrganizationControllerGetOrganizationForBookingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationForBooking(requestParameters: OrganizationApiOrganizationControllerGetOrganizationForBookingRequest, options?: AxiosRequestConfig): AxiosPromise<GetOrganizationSearchDto> {
            return localVarFp.organizationControllerGetOrganizationForBooking(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all professionals for an organization.
         * @param {OrganizationApiOrganizationControllerGetOrganizationProfessionalsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationProfessionals(requestParameters: OrganizationApiOrganizationControllerGetOrganizationProfessionalsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationProfessionalsDto>> {
            return localVarFp.organizationControllerGetOrganizationProfessionals(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get professionals for organization booking
         * @param {OrganizationApiOrganizationControllerGetOrganizationProfessionalsForBookingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationProfessionalsForBooking(requestParameters: OrganizationApiOrganizationControllerGetOrganizationProfessionalsForBookingRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationProfessionalBookingDto>> {
            return localVarFp.organizationControllerGetOrganizationProfessionalsForBooking(requestParameters.id, requestParameters.visitType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all profiles for an organization.
         * @param {OrganizationApiOrganizationControllerGetOrganizationProfilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationProfiles(requestParameters: OrganizationApiOrganizationControllerGetOrganizationProfilesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationProfilesDto>> {
            return localVarFp.organizationControllerGetOrganizationProfiles(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get paginated profiles for an organization.
         * @param {OrganizationApiOrganizationControllerGetOrganizationProfilesPaginatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationProfilesPaginated(requestParameters: OrganizationApiOrganizationControllerGetOrganizationProfilesPaginatedRequest, options?: AxiosRequestConfig): AxiosPromise<PaginatedProfilesResponseDto> {
            return localVarFp.organizationControllerGetOrganizationProfilesPaginated(requestParameters.id, requestParameters.page, requestParameters.limit, requestParameters.ownerName, requestParameters.profileName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all users for an organization.
         * @param {OrganizationApiOrganizationControllerGetOrganizationUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationUsers(requestParameters: OrganizationApiOrganizationControllerGetOrganizationUsersRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationUsersDto>> {
            return localVarFp.organizationControllerGetOrganizationUsers(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all organizations for a user.
         * @param {OrganizationApiOrganizationControllerGetOrganizationsByUserIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetOrganizationsByUserId(requestParameters: OrganizationApiOrganizationControllerGetOrganizationsByUserIdRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserOrganizationsDto>> {
            return localVarFp.organizationControllerGetOrganizationsByUserId(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get organization from the most recent visit across all user profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerGetRecentVisitOrganization(options?: AxiosRequestConfig): AxiosPromise<GetOrganizationSearchDto> {
            return localVarFp.organizationControllerGetRecentVisitOrganization(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove organization.
         * @param {OrganizationApiOrganizationControllerRemoveOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerRemoveOrganization(requestParameters: OrganizationApiOrganizationControllerRemoveOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.organizationControllerRemoveOrganization(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search organizations with optional filters (authenticated users)
         * @param {OrganizationApiOrganizationControllerSearchOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerSearchOrganizations(requestParameters: OrganizationApiOrganizationControllerSearchOrganizationsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationSearchDto>> {
            return localVarFp.organizationControllerSearchOrganizations(requestParameters.name, requestParameters.city, requestParameters.specialization, requestParameters.visitType, requestParameters.category, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Send a question while waiting for organization verification.
         * @param {OrganizationApiOrganizationControllerSendVerificationQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerSendVerificationQuestion(requestParameters: OrganizationApiOrganizationControllerSendVerificationQuestionRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.organizationControllerSendVerificationQuestion(requestParameters.sendVerificationQuestionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set organization published state (visible in search).
         * @param {OrganizationApiOrganizationControllerSetOrganizationPublishedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerSetOrganizationPublished(requestParameters: OrganizationApiOrganizationControllerSetOrganizationPublishedRequest, options?: AxiosRequestConfig): AxiosPromise<GetOrganizationDto> {
            return localVarFp.organizationControllerSetOrganizationPublished(requestParameters.id, requestParameters.setOrganizationPublishedDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update organization.
         * @param {OrganizationApiOrganizationControllerUpdateOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerUpdateOrganization(requestParameters: OrganizationApiOrganizationControllerUpdateOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.organizationControllerUpdateOrganization(requestParameters.id, requestParameters.updateOrganizationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update organization enabled categories.
         * @param {OrganizationApiOrganizationControllerUpdateOrganizationCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerUpdateOrganizationCategories(requestParameters: OrganizationApiOrganizationControllerUpdateOrganizationCategoriesRequest, options?: AxiosRequestConfig): AxiosPromise<GetOrganizationDto> {
            return localVarFp.organizationControllerUpdateOrganizationCategories(requestParameters.id, requestParameters.updateEnabledCategoriesDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update organization time off periods.
         * @param {OrganizationApiOrganizationControllerUpdateOrganizationTimeOffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerUpdateOrganizationTimeOff(requestParameters: OrganizationApiOrganizationControllerUpdateOrganizationTimeOffRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateScheduleResponseDto> {
            return localVarFp.organizationControllerUpdateOrganizationTimeOff(requestParameters.id, requestParameters.updateTimeOffDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update organization visit settings (types and categories).
         * @param {OrganizationApiOrganizationControllerUpdateOrganizationVisitSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerUpdateOrganizationVisitSettings(requestParameters: OrganizationApiOrganizationControllerUpdateOrganizationVisitSettingsRequest, options?: AxiosRequestConfig): AxiosPromise<GetOrganizationDto> {
            return localVarFp.organizationControllerUpdateOrganizationVisitSettings(requestParameters.id, requestParameters.updateVisitSettingsDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update organization enabled visit types.
         * @param {OrganizationApiOrganizationControllerUpdateOrganizationVisitTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerUpdateOrganizationVisitTypes(requestParameters: OrganizationApiOrganizationControllerUpdateOrganizationVisitTypesRequest, options?: AxiosRequestConfig): AxiosPromise<GetOrganizationDto> {
            return localVarFp.organizationControllerUpdateOrganizationVisitTypes(requestParameters.id, requestParameters.updateEnabledVisitTypesDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update organization working hours.
         * @param {OrganizationApiOrganizationControllerUpdateOrganizationWorkingHoursRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationControllerUpdateOrganizationWorkingHours(requestParameters: OrganizationApiOrganizationControllerUpdateOrganizationWorkingHoursRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateScheduleResponseDto> {
            return localVarFp.organizationControllerUpdateOrganizationWorkingHours(requestParameters.id, requestParameters.updateWorkingHoursDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for organizationControllerAddOrganization operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerAddOrganizationRequest
 */
export interface OrganizationApiOrganizationControllerAddOrganizationRequest {
    /**
     *
     * @type {AddOrganizationDto}
     * @memberof OrganizationApiOrganizationControllerAddOrganization
     */
    readonly addOrganizationDto: AddOrganizationDto
}

/**
 * Request parameters for organizationControllerCheckOrganizationServiceUsage operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerCheckOrganizationServiceUsageRequest
 */
export interface OrganizationApiOrganizationControllerCheckOrganizationServiceUsageRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerCheckOrganizationServiceUsage
     */
    readonly id: string

    /**
     *
     * @type {CheckServiceUsageDto}
     * @memberof OrganizationApiOrganizationControllerCheckOrganizationServiceUsage
     */
    readonly checkServiceUsageDto: CheckServiceUsageDto
}

/**
 * Request parameters for organizationControllerCheckOrganizationSpecializationServices operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerCheckOrganizationSpecializationServicesRequest
 */
export interface OrganizationApiOrganizationControllerCheckOrganizationSpecializationServicesRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerCheckOrganizationSpecializationServices
     */
    readonly id: string

    /**
     *
     * @type {CheckSpecializationServicesDto}
     * @memberof OrganizationApiOrganizationControllerCheckOrganizationSpecializationServices
     */
    readonly checkSpecializationServicesDto: CheckSpecializationServicesDto
}

/**
 * Request parameters for organizationControllerGetCities operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerGetCitiesRequest
 */
export interface OrganizationApiOrganizationControllerGetCitiesRequest {
    /**
     * Optional visit type filter. If not provided, returns all cities.
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerGetCities
     */
    readonly visitType?: string
}

/**
 * Request parameters for organizationControllerGetLastBookedVisit operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerGetLastBookedVisitRequest
 */
export interface OrganizationApiOrganizationControllerGetLastBookedVisitRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerGetLastBookedVisit
     */
    readonly id: string
}

/**
 * Request parameters for organizationControllerGetOrganizationById operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerGetOrganizationByIdRequest
 */
export interface OrganizationApiOrganizationControllerGetOrganizationByIdRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerGetOrganizationById
     */
    readonly id: string
}

/**
 * Request parameters for organizationControllerGetOrganizationCustomers operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerGetOrganizationCustomersRequest
 */
export interface OrganizationApiOrganizationControllerGetOrganizationCustomersRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerGetOrganizationCustomers
     */
    readonly id: string

    /**
     *
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerGetOrganizationCustomers
     */
    readonly query?: string
}

/**
 * Request parameters for organizationControllerGetOrganizationForBooking operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerGetOrganizationForBookingRequest
 */
export interface OrganizationApiOrganizationControllerGetOrganizationForBookingRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerGetOrganizationForBooking
     */
    readonly id: string
}

/**
 * Request parameters for organizationControllerGetOrganizationProfessionals operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerGetOrganizationProfessionalsRequest
 */
export interface OrganizationApiOrganizationControllerGetOrganizationProfessionalsRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerGetOrganizationProfessionals
     */
    readonly id: string
}

/**
 * Request parameters for organizationControllerGetOrganizationProfessionalsForBooking operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerGetOrganizationProfessionalsForBookingRequest
 */
export interface OrganizationApiOrganizationControllerGetOrganizationProfessionalsForBookingRequest {
    /**
     * Organization ID or slug
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerGetOrganizationProfessionalsForBooking
     */
    readonly id: string

    /**
     * Optional visit type filter. If not provided, returns all professionals.
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerGetOrganizationProfessionalsForBooking
     */
    readonly visitType?: string
}

/**
 * Request parameters for organizationControllerGetOrganizationProfiles operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerGetOrganizationProfilesRequest
 */
export interface OrganizationApiOrganizationControllerGetOrganizationProfilesRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerGetOrganizationProfiles
     */
    readonly id: string
}

/**
 * Request parameters for organizationControllerGetOrganizationProfilesPaginated operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerGetOrganizationProfilesPaginatedRequest
 */
export interface OrganizationApiOrganizationControllerGetOrganizationProfilesPaginatedRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerGetOrganizationProfilesPaginated
     */
    readonly id: string

    /**
     * Page number (0-indexed)
     * @type {number}
     * @memberof OrganizationApiOrganizationControllerGetOrganizationProfilesPaginated
     */
    readonly page?: number

    /**
     * Number of items per page
     * @type {number}
     * @memberof OrganizationApiOrganizationControllerGetOrganizationProfilesPaginated
     */
    readonly limit?: number

    /**
     * Filter by owner name (first or last name)
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerGetOrganizationProfilesPaginated
     */
    readonly ownerName?: string

    /**
     * Filter by profile name (pet name)
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerGetOrganizationProfilesPaginated
     */
    readonly profileName?: string
}

/**
 * Request parameters for organizationControllerGetOrganizationUsers operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerGetOrganizationUsersRequest
 */
export interface OrganizationApiOrganizationControllerGetOrganizationUsersRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerGetOrganizationUsers
     */
    readonly id: string
}

/**
 * Request parameters for organizationControllerGetOrganizationsByUserId operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerGetOrganizationsByUserIdRequest
 */
export interface OrganizationApiOrganizationControllerGetOrganizationsByUserIdRequest {
    /**
     * User ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerGetOrganizationsByUserId
     */
    readonly userId: string
}

/**
 * Request parameters for organizationControllerRemoveOrganization operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerRemoveOrganizationRequest
 */
export interface OrganizationApiOrganizationControllerRemoveOrganizationRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerRemoveOrganization
     */
    readonly id: string
}

/**
 * Request parameters for organizationControllerSearchOrganizations operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerSearchOrganizationsRequest
 */
export interface OrganizationApiOrganizationControllerSearchOrganizationsRequest {
    /**
     * Filter by organization name
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerSearchOrganizations
     */
    readonly name?: string

    /**
     * Filter by city name
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerSearchOrganizations
     */
    readonly city?: string

    /**
     * Filter by specialization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerSearchOrganizations
     */
    readonly specialization?: string

    /**
     * Filter by visit type
     * @type {'video' | 'chat' | 'onsite'}
     * @memberof OrganizationApiOrganizationControllerSearchOrganizations
     */
    readonly visitType?: 'video' | 'chat' | 'onsite'

    /**
     * Filter by visit category ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerSearchOrganizations
     */
    readonly category?: string
}

/**
 * Request parameters for organizationControllerSendVerificationQuestion operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerSendVerificationQuestionRequest
 */
export interface OrganizationApiOrganizationControllerSendVerificationQuestionRequest {
    /**
     *
     * @type {SendVerificationQuestionDto}
     * @memberof OrganizationApiOrganizationControllerSendVerificationQuestion
     */
    readonly sendVerificationQuestionDto: SendVerificationQuestionDto
}

/**
 * Request parameters for organizationControllerSetOrganizationPublished operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerSetOrganizationPublishedRequest
 */
export interface OrganizationApiOrganizationControllerSetOrganizationPublishedRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerSetOrganizationPublished
     */
    readonly id: string

    /**
     *
     * @type {SetOrganizationPublishedDto}
     * @memberof OrganizationApiOrganizationControllerSetOrganizationPublished
     */
    readonly setOrganizationPublishedDto: SetOrganizationPublishedDto
}

/**
 * Request parameters for organizationControllerUpdateOrganization operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerUpdateOrganizationRequest
 */
export interface OrganizationApiOrganizationControllerUpdateOrganizationRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerUpdateOrganization
     */
    readonly id: string

    /**
     *
     * @type {UpdateOrganizationDto}
     * @memberof OrganizationApiOrganizationControllerUpdateOrganization
     */
    readonly updateOrganizationDto: UpdateOrganizationDto
}

/**
 * Request parameters for organizationControllerUpdateOrganizationCategories operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerUpdateOrganizationCategoriesRequest
 */
export interface OrganizationApiOrganizationControllerUpdateOrganizationCategoriesRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerUpdateOrganizationCategories
     */
    readonly id: string

    /**
     *
     * @type {UpdateEnabledCategoriesDto}
     * @memberof OrganizationApiOrganizationControllerUpdateOrganizationCategories
     */
    readonly updateEnabledCategoriesDto: UpdateEnabledCategoriesDto
}

/**
 * Request parameters for organizationControllerUpdateOrganizationTimeOff operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerUpdateOrganizationTimeOffRequest
 */
export interface OrganizationApiOrganizationControllerUpdateOrganizationTimeOffRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerUpdateOrganizationTimeOff
     */
    readonly id: string

    /**
     *
     * @type {UpdateTimeOffDto}
     * @memberof OrganizationApiOrganizationControllerUpdateOrganizationTimeOff
     */
    readonly updateTimeOffDto: UpdateTimeOffDto
}

/**
 * Request parameters for organizationControllerUpdateOrganizationVisitSettings operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerUpdateOrganizationVisitSettingsRequest
 */
export interface OrganizationApiOrganizationControllerUpdateOrganizationVisitSettingsRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerUpdateOrganizationVisitSettings
     */
    readonly id: string

    /**
     *
     * @type {UpdateVisitSettingsDto}
     * @memberof OrganizationApiOrganizationControllerUpdateOrganizationVisitSettings
     */
    readonly updateVisitSettingsDto: UpdateVisitSettingsDto
}

/**
 * Request parameters for organizationControllerUpdateOrganizationVisitTypes operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerUpdateOrganizationVisitTypesRequest
 */
export interface OrganizationApiOrganizationControllerUpdateOrganizationVisitTypesRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerUpdateOrganizationVisitTypes
     */
    readonly id: string

    /**
     *
     * @type {UpdateEnabledVisitTypesDto}
     * @memberof OrganizationApiOrganizationControllerUpdateOrganizationVisitTypes
     */
    readonly updateEnabledVisitTypesDto: UpdateEnabledVisitTypesDto
}

/**
 * Request parameters for organizationControllerUpdateOrganizationWorkingHours operation in OrganizationApi.
 * @export
 * @interface OrganizationApiOrganizationControllerUpdateOrganizationWorkingHoursRequest
 */
export interface OrganizationApiOrganizationControllerUpdateOrganizationWorkingHoursRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationApiOrganizationControllerUpdateOrganizationWorkingHours
     */
    readonly id: string

    /**
     *
     * @type {UpdateWorkingHoursDto}
     * @memberof OrganizationApiOrganizationControllerUpdateOrganizationWorkingHours
     */
    readonly updateWorkingHoursDto: UpdateWorkingHoursDto
}

/**
 * OrganizationApi - object-oriented interface
 * @export
 * @class OrganizationApi
 * @extends {BaseAPI}
 */
export class OrganizationApi extends BaseAPI {
    /**
     *
     * @summary Add organization.
     * @param {OrganizationApiOrganizationControllerAddOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerAddOrganization(requestParameters: OrganizationApiOrganizationControllerAddOrganizationRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerAddOrganization(requestParameters.addOrganizationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns information about professionals who have the services configured
     * @summary Check if removing services will affect professional configurations
     * @param {OrganizationApiOrganizationControllerCheckOrganizationServiceUsageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerCheckOrganizationServiceUsage(requestParameters: OrganizationApiOrganizationControllerCheckOrganizationServiceUsageRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerCheckOrganizationServiceUsage(requestParameters.id, requestParameters.checkServiceUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns information about professionals and services that will be affected
     * @summary Check if removing specializations will affect service assignments across the organization
     * @param {OrganizationApiOrganizationControllerCheckOrganizationSpecializationServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerCheckOrganizationSpecializationServices(requestParameters: OrganizationApiOrganizationControllerCheckOrganizationSpecializationServicesRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerCheckOrganizationSpecializationServices(requestParameters.id, requestParameters.checkSpecializationServicesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all organizations.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerGetAllOrganizations(options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerGetAllOrganizations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all unique cities from organizations (authenticated users)
     * @param {OrganizationApiOrganizationControllerGetCitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerGetCities(requestParameters: OrganizationApiOrganizationControllerGetCitiesRequest = {}, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerGetCities(requestParameters.visitType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get last booked visit for an organization.
     * @param {OrganizationApiOrganizationControllerGetLastBookedVisitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerGetLastBookedVisit(requestParameters: OrganizationApiOrganizationControllerGetLastBookedVisitRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerGetLastBookedVisit(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get organization by ID.
     * @param {OrganizationApiOrganizationControllerGetOrganizationByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerGetOrganizationById(requestParameters: OrganizationApiOrganizationControllerGetOrganizationByIdRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerGetOrganizationById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Search this organization\'s customers (users with a visit here). Optional ?query= filters by name/email/phone.
     * @param {OrganizationApiOrganizationControllerGetOrganizationCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerGetOrganizationCustomers(requestParameters: OrganizationApiOrganizationControllerGetOrganizationCustomersRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerGetOrganizationCustomers(requestParameters.id, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get organization by ID for booking
     * @param {OrganizationApiOrganizationControllerGetOrganizationForBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerGetOrganizationForBooking(requestParameters: OrganizationApiOrganizationControllerGetOrganizationForBookingRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerGetOrganizationForBooking(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all professionals for an organization.
     * @param {OrganizationApiOrganizationControllerGetOrganizationProfessionalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerGetOrganizationProfessionals(requestParameters: OrganizationApiOrganizationControllerGetOrganizationProfessionalsRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerGetOrganizationProfessionals(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get professionals for organization booking
     * @param {OrganizationApiOrganizationControllerGetOrganizationProfessionalsForBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerGetOrganizationProfessionalsForBooking(requestParameters: OrganizationApiOrganizationControllerGetOrganizationProfessionalsForBookingRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerGetOrganizationProfessionalsForBooking(requestParameters.id, requestParameters.visitType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all profiles for an organization.
     * @param {OrganizationApiOrganizationControllerGetOrganizationProfilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerGetOrganizationProfiles(requestParameters: OrganizationApiOrganizationControllerGetOrganizationProfilesRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerGetOrganizationProfiles(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get paginated profiles for an organization.
     * @param {OrganizationApiOrganizationControllerGetOrganizationProfilesPaginatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerGetOrganizationProfilesPaginated(requestParameters: OrganizationApiOrganizationControllerGetOrganizationProfilesPaginatedRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerGetOrganizationProfilesPaginated(requestParameters.id, requestParameters.page, requestParameters.limit, requestParameters.ownerName, requestParameters.profileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all users for an organization.
     * @param {OrganizationApiOrganizationControllerGetOrganizationUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerGetOrganizationUsers(requestParameters: OrganizationApiOrganizationControllerGetOrganizationUsersRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerGetOrganizationUsers(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all organizations for a user.
     * @param {OrganizationApiOrganizationControllerGetOrganizationsByUserIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerGetOrganizationsByUserId(requestParameters: OrganizationApiOrganizationControllerGetOrganizationsByUserIdRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerGetOrganizationsByUserId(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get organization from the most recent visit across all user profiles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerGetRecentVisitOrganization(options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerGetRecentVisitOrganization(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Remove organization.
     * @param {OrganizationApiOrganizationControllerRemoveOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerRemoveOrganization(requestParameters: OrganizationApiOrganizationControllerRemoveOrganizationRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerRemoveOrganization(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Search organizations with optional filters (authenticated users)
     * @param {OrganizationApiOrganizationControllerSearchOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerSearchOrganizations(requestParameters: OrganizationApiOrganizationControllerSearchOrganizationsRequest = {}, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerSearchOrganizations(requestParameters.name, requestParameters.city, requestParameters.specialization, requestParameters.visitType, requestParameters.category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Send a question while waiting for organization verification.
     * @param {OrganizationApiOrganizationControllerSendVerificationQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerSendVerificationQuestion(requestParameters: OrganizationApiOrganizationControllerSendVerificationQuestionRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerSendVerificationQuestion(requestParameters.sendVerificationQuestionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Set organization published state (visible in search).
     * @param {OrganizationApiOrganizationControllerSetOrganizationPublishedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerSetOrganizationPublished(requestParameters: OrganizationApiOrganizationControllerSetOrganizationPublishedRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerSetOrganizationPublished(requestParameters.id, requestParameters.setOrganizationPublishedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update organization.
     * @param {OrganizationApiOrganizationControllerUpdateOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerUpdateOrganization(requestParameters: OrganizationApiOrganizationControllerUpdateOrganizationRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerUpdateOrganization(requestParameters.id, requestParameters.updateOrganizationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update organization enabled categories.
     * @param {OrganizationApiOrganizationControllerUpdateOrganizationCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerUpdateOrganizationCategories(requestParameters: OrganizationApiOrganizationControllerUpdateOrganizationCategoriesRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerUpdateOrganizationCategories(requestParameters.id, requestParameters.updateEnabledCategoriesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update organization time off periods.
     * @param {OrganizationApiOrganizationControllerUpdateOrganizationTimeOffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerUpdateOrganizationTimeOff(requestParameters: OrganizationApiOrganizationControllerUpdateOrganizationTimeOffRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerUpdateOrganizationTimeOff(requestParameters.id, requestParameters.updateTimeOffDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update organization visit settings (types and categories).
     * @param {OrganizationApiOrganizationControllerUpdateOrganizationVisitSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerUpdateOrganizationVisitSettings(requestParameters: OrganizationApiOrganizationControllerUpdateOrganizationVisitSettingsRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerUpdateOrganizationVisitSettings(requestParameters.id, requestParameters.updateVisitSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update organization enabled visit types.
     * @param {OrganizationApiOrganizationControllerUpdateOrganizationVisitTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerUpdateOrganizationVisitTypes(requestParameters: OrganizationApiOrganizationControllerUpdateOrganizationVisitTypesRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerUpdateOrganizationVisitTypes(requestParameters.id, requestParameters.updateEnabledVisitTypesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update organization working hours.
     * @param {OrganizationApiOrganizationControllerUpdateOrganizationWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationControllerUpdateOrganizationWorkingHours(requestParameters: OrganizationApiOrganizationControllerUpdateOrganizationWorkingHoursRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationControllerUpdateOrganizationWorkingHours(requestParameters.id, requestParameters.updateWorkingHoursDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationAvailabilityApi - axios parameter creator
 * @export
 */
export const OrganizationAvailabilityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Add time off to existing professional availability in organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional ID
         * @param {AddOrganizationTimeOffDto} addOrganizationTimeOffDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerAddOrganizationTimeOff: async (organizationId: string, professionalId: string, addOrganizationTimeOffDto: AddOrganizationTimeOffDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationAvailabilityControllerAddOrganizationTimeOff', 'organizationId', organizationId)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('organizationAvailabilityControllerAddOrganizationTimeOff', 'professionalId', professionalId)
            // verify required parameter 'addOrganizationTimeOffDto' is not null or undefined
            assertParamExists('organizationAvailabilityControllerAddOrganizationTimeOff', 'addOrganizationTimeOffDto', addOrganizationTimeOffDto)
            const localVarPath = `/api/organization-availability/{organizationId}/professional/{professionalId}/time-off/add`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrganizationTimeOffDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete availability for a professional in a specific organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerDeleteOrganizationAvailability: async (organizationId: string, professionalId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationAvailabilityControllerDeleteOrganizationAvailability', 'organizationId', organizationId)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('organizationAvailabilityControllerDeleteOrganizationAvailability', 'professionalId', professionalId)
            const localVarPath = `/api/organization-availability/{organizationId}/professional/{professionalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get time off for all professionals in an organization
         * @param {string} organizationId Organization ID
         * @param {string} [professionalId] Filter by professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerGetOrganizationAllTimeOff: async (organizationId: string, professionalId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationAvailabilityControllerGetOrganizationAllTimeOff', 'organizationId', organizationId)
            const localVarPath = `/api/organization-availability/{organizationId}/time-off`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (professionalId !== undefined) {
                localVarQueryParameter['professionalId'] = professionalId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get availability for a professional in a specific organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerGetOrganizationAvailability: async (organizationId: string, professionalId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationAvailabilityControllerGetOrganizationAvailability', 'organizationId', organizationId)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('organizationAvailabilityControllerGetOrganizationAvailability', 'professionalId', professionalId)
            const localVarPath = `/api/organization-availability/{organizationId}/professional/{professionalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get available visit slots for organization with enhanced filtering
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerGetOrganizationAvailableSlots: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationAvailabilityControllerGetOrganizationAvailableSlots', 'organizationId', organizationId)
            const localVarPath = `/api/organization-availability/slots/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get time off for a professional in a specific organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerGetOrganizationTimeOff: async (organizationId: string, professionalId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationAvailabilityControllerGetOrganizationTimeOff', 'organizationId', organizationId)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('organizationAvailabilityControllerGetOrganizationTimeOff', 'professionalId', professionalId)
            const localVarPath = `/api/organization-availability/{organizationId}/professional/{professionalId}/time-off`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all organization availabilities for a professional
         * @param {string} professionalId Professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerGetProfessionalOrganizationAvailabilities: async (professionalId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('organizationAvailabilityControllerGetProfessionalOrganizationAvailabilities', 'professionalId', professionalId)
            const localVarPath = `/api/organization-availability/professional/{professionalId}`
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set availability for a professional using organization context from header
         * @param {string} professionalId Professional ID
         * @param {SetOrganizationAvailabilityDto} setOrganizationAvailabilityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerSetAvailabilityWithOrganizationContext: async (professionalId: string, setOrganizationAvailabilityDto: SetOrganizationAvailabilityDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('organizationAvailabilityControllerSetAvailabilityWithOrganizationContext', 'professionalId', professionalId)
            // verify required parameter 'setOrganizationAvailabilityDto' is not null or undefined
            assertParamExists('organizationAvailabilityControllerSetAvailabilityWithOrganizationContext', 'setOrganizationAvailabilityDto', setOrganizationAvailabilityDto)
            const localVarPath = `/api/organization-availability/professional/{professionalId}`
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setOrganizationAvailabilityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set availability for a professional in a specific organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional ID
         * @param {SetOrganizationAvailabilityDto} setOrganizationAvailabilityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerSetOrganizationAvailability: async (organizationId: string, professionalId: string, setOrganizationAvailabilityDto: SetOrganizationAvailabilityDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationAvailabilityControllerSetOrganizationAvailability', 'organizationId', organizationId)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('organizationAvailabilityControllerSetOrganizationAvailability', 'professionalId', professionalId)
            // verify required parameter 'setOrganizationAvailabilityDto' is not null or undefined
            assertParamExists('organizationAvailabilityControllerSetOrganizationAvailability', 'setOrganizationAvailabilityDto', setOrganizationAvailabilityDto)
            const localVarPath = `/api/organization-availability/{organizationId}/professional/{professionalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setOrganizationAvailabilityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set time off for a professional in a specific organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional ID
         * @param {SetOrganizationTimeOffDto} setOrganizationTimeOffDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerSetOrganizationTimeOff: async (organizationId: string, professionalId: string, setOrganizationTimeOffDto: SetOrganizationTimeOffDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationAvailabilityControllerSetOrganizationTimeOff', 'organizationId', organizationId)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('organizationAvailabilityControllerSetOrganizationTimeOff', 'professionalId', professionalId)
            // verify required parameter 'setOrganizationTimeOffDto' is not null or undefined
            assertParamExists('organizationAvailabilityControllerSetOrganizationTimeOff', 'setOrganizationTimeOffDto', setOrganizationTimeOffDto)
            const localVarPath = `/api/organization-availability/{organizationId}/professional/{professionalId}/time-off`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setOrganizationTimeOffDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationAvailabilityApi - functional programming interface
 * @export
 */
export const OrganizationAvailabilityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationAvailabilityApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Add time off to existing professional availability in organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional ID
         * @param {AddOrganizationTimeOffDto} addOrganizationTimeOffDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationAvailabilityControllerAddOrganizationTimeOff(organizationId: string, professionalId: string, addOrganizationTimeOffDto: AddOrganizationTimeOffDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationAvailabilityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationAvailabilityControllerAddOrganizationTimeOff(organizationId, professionalId, addOrganizationTimeOffDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete availability for a professional in a specific organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationAvailabilityControllerDeleteOrganizationAvailability(organizationId: string, professionalId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteOrganizationAvailabilityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationAvailabilityControllerDeleteOrganizationAvailability(organizationId, professionalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get time off for all professionals in an organization
         * @param {string} organizationId Organization ID
         * @param {string} [professionalId] Filter by professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationAvailabilityControllerGetOrganizationAllTimeOff(organizationId: string, professionalId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationTimeOffResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationAvailabilityControllerGetOrganizationAllTimeOff(organizationId, professionalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get availability for a professional in a specific organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationAvailabilityControllerGetOrganizationAvailability(organizationId: string, professionalId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationAvailabilityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationAvailabilityControllerGetOrganizationAvailability(organizationId, professionalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get available visit slots for organization with enhanced filtering
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationAvailabilityControllerGetOrganizationAvailableSlots(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationAvailabilityControllerGetOrganizationAvailableSlots(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get time off for a professional in a specific organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationAvailabilityControllerGetOrganizationTimeOff(organizationId: string, professionalId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationAvailabilityControllerGetOrganizationTimeOff(organizationId, professionalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all organization availabilities for a professional
         * @param {string} professionalId Professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationAvailabilityControllerGetProfessionalOrganizationAvailabilities(professionalId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfessionalOrganizationAvailabilitiesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationAvailabilityControllerGetProfessionalOrganizationAvailabilities(professionalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Set availability for a professional using organization context from header
         * @param {string} professionalId Professional ID
         * @param {SetOrganizationAvailabilityDto} setOrganizationAvailabilityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationAvailabilityControllerSetAvailabilityWithOrganizationContext(professionalId: string, setOrganizationAvailabilityDto: SetOrganizationAvailabilityDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetOrganizationAvailabilityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationAvailabilityControllerSetAvailabilityWithOrganizationContext(professionalId, setOrganizationAvailabilityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Set availability for a professional in a specific organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional ID
         * @param {SetOrganizationAvailabilityDto} setOrganizationAvailabilityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationAvailabilityControllerSetOrganizationAvailability(organizationId: string, professionalId: string, setOrganizationAvailabilityDto: SetOrganizationAvailabilityDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetOrganizationAvailabilityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationAvailabilityControllerSetOrganizationAvailability(organizationId, professionalId, setOrganizationAvailabilityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Set time off for a professional in a specific organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional ID
         * @param {SetOrganizationTimeOffDto} setOrganizationTimeOffDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationAvailabilityControllerSetOrganizationTimeOff(organizationId: string, professionalId: string, setOrganizationTimeOffDto: SetOrganizationTimeOffDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetOrganizationAvailabilityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationAvailabilityControllerSetOrganizationTimeOff(organizationId, professionalId, setOrganizationTimeOffDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationAvailabilityApi - factory interface
 * @export
 */
export const OrganizationAvailabilityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationAvailabilityApiFp(configuration)
    return {
        /**
         *
         * @summary Add time off to existing professional availability in organization
         * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerAddOrganizationTimeOffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerAddOrganizationTimeOff(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerAddOrganizationTimeOffRequest, options?: AxiosRequestConfig): AxiosPromise<GetOrganizationAvailabilityDto> {
            return localVarFp.organizationAvailabilityControllerAddOrganizationTimeOff(requestParameters.organizationId, requestParameters.professionalId, requestParameters.addOrganizationTimeOffDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete availability for a professional in a specific organization
         * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerDeleteOrganizationAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerDeleteOrganizationAvailability(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerDeleteOrganizationAvailabilityRequest, options?: AxiosRequestConfig): AxiosPromise<DeleteOrganizationAvailabilityDto> {
            return localVarFp.organizationAvailabilityControllerDeleteOrganizationAvailability(requestParameters.organizationId, requestParameters.professionalId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get time off for all professionals in an organization
         * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAllTimeOffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerGetOrganizationAllTimeOff(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAllTimeOffRequest, options?: AxiosRequestConfig): AxiosPromise<GetOrganizationTimeOffResponseDto> {
            return localVarFp.organizationAvailabilityControllerGetOrganizationAllTimeOff(requestParameters.organizationId, requestParameters.professionalId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get availability for a professional in a specific organization
         * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerGetOrganizationAvailability(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAvailabilityRequest, options?: AxiosRequestConfig): AxiosPromise<GetOrganizationAvailabilityDto> {
            return localVarFp.organizationAvailabilityControllerGetOrganizationAvailability(requestParameters.organizationId, requestParameters.professionalId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get available visit slots for organization with enhanced filtering
         * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAvailableSlotsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerGetOrganizationAvailableSlots(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAvailableSlotsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.organizationAvailabilityControllerGetOrganizationAvailableSlots(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get time off for a professional in a specific organization
         * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationTimeOffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerGetOrganizationTimeOff(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationTimeOffRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.organizationAvailabilityControllerGetOrganizationTimeOff(requestParameters.organizationId, requestParameters.professionalId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all organization availabilities for a professional
         * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerGetProfessionalOrganizationAvailabilitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerGetProfessionalOrganizationAvailabilities(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerGetProfessionalOrganizationAvailabilitiesRequest, options?: AxiosRequestConfig): AxiosPromise<GetProfessionalOrganizationAvailabilitiesDto> {
            return localVarFp.organizationAvailabilityControllerGetProfessionalOrganizationAvailabilities(requestParameters.professionalId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set availability for a professional using organization context from header
         * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerSetAvailabilityWithOrganizationContextRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerSetAvailabilityWithOrganizationContext(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerSetAvailabilityWithOrganizationContextRequest, options?: AxiosRequestConfig): AxiosPromise<SetOrganizationAvailabilityResponseDto> {
            return localVarFp.organizationAvailabilityControllerSetAvailabilityWithOrganizationContext(requestParameters.professionalId, requestParameters.setOrganizationAvailabilityDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set availability for a professional in a specific organization
         * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerSetOrganizationAvailability(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationAvailabilityRequest, options?: AxiosRequestConfig): AxiosPromise<SetOrganizationAvailabilityResponseDto> {
            return localVarFp.organizationAvailabilityControllerSetOrganizationAvailability(requestParameters.organizationId, requestParameters.professionalId, requestParameters.setOrganizationAvailabilityDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set time off for a professional in a specific organization
         * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationTimeOffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAvailabilityControllerSetOrganizationTimeOff(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationTimeOffRequest, options?: AxiosRequestConfig): AxiosPromise<SetOrganizationAvailabilityResponseDto> {
            return localVarFp.organizationAvailabilityControllerSetOrganizationTimeOff(requestParameters.organizationId, requestParameters.professionalId, requestParameters.setOrganizationTimeOffDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for organizationAvailabilityControllerAddOrganizationTimeOff operation in OrganizationAvailabilityApi.
 * @export
 * @interface OrganizationAvailabilityApiOrganizationAvailabilityControllerAddOrganizationTimeOffRequest
 */
export interface OrganizationAvailabilityApiOrganizationAvailabilityControllerAddOrganizationTimeOffRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerAddOrganizationTimeOff
     */
    readonly organizationId: string

    /**
     * Professional ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerAddOrganizationTimeOff
     */
    readonly professionalId: string

    /**
     *
     * @type {AddOrganizationTimeOffDto}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerAddOrganizationTimeOff
     */
    readonly addOrganizationTimeOffDto: AddOrganizationTimeOffDto
}

/**
 * Request parameters for organizationAvailabilityControllerDeleteOrganizationAvailability operation in OrganizationAvailabilityApi.
 * @export
 * @interface OrganizationAvailabilityApiOrganizationAvailabilityControllerDeleteOrganizationAvailabilityRequest
 */
export interface OrganizationAvailabilityApiOrganizationAvailabilityControllerDeleteOrganizationAvailabilityRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerDeleteOrganizationAvailability
     */
    readonly organizationId: string

    /**
     * Professional ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerDeleteOrganizationAvailability
     */
    readonly professionalId: string
}

/**
 * Request parameters for organizationAvailabilityControllerGetOrganizationAllTimeOff operation in OrganizationAvailabilityApi.
 * @export
 * @interface OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAllTimeOffRequest
 */
export interface OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAllTimeOffRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAllTimeOff
     */
    readonly organizationId: string

    /**
     * Filter by professional ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAllTimeOff
     */
    readonly professionalId?: string
}

/**
 * Request parameters for organizationAvailabilityControllerGetOrganizationAvailability operation in OrganizationAvailabilityApi.
 * @export
 * @interface OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAvailabilityRequest
 */
export interface OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAvailabilityRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAvailability
     */
    readonly organizationId: string

    /**
     * Professional ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAvailability
     */
    readonly professionalId: string
}

/**
 * Request parameters for organizationAvailabilityControllerGetOrganizationAvailableSlots operation in OrganizationAvailabilityApi.
 * @export
 * @interface OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAvailableSlotsRequest
 */
export interface OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAvailableSlotsRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAvailableSlots
     */
    readonly organizationId: string
}

/**
 * Request parameters for organizationAvailabilityControllerGetOrganizationTimeOff operation in OrganizationAvailabilityApi.
 * @export
 * @interface OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationTimeOffRequest
 */
export interface OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationTimeOffRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationTimeOff
     */
    readonly organizationId: string

    /**
     * Professional ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationTimeOff
     */
    readonly professionalId: string
}

/**
 * Request parameters for organizationAvailabilityControllerGetProfessionalOrganizationAvailabilities operation in OrganizationAvailabilityApi.
 * @export
 * @interface OrganizationAvailabilityApiOrganizationAvailabilityControllerGetProfessionalOrganizationAvailabilitiesRequest
 */
export interface OrganizationAvailabilityApiOrganizationAvailabilityControllerGetProfessionalOrganizationAvailabilitiesRequest {
    /**
     * Professional ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerGetProfessionalOrganizationAvailabilities
     */
    readonly professionalId: string
}

/**
 * Request parameters for organizationAvailabilityControllerSetAvailabilityWithOrganizationContext operation in OrganizationAvailabilityApi.
 * @export
 * @interface OrganizationAvailabilityApiOrganizationAvailabilityControllerSetAvailabilityWithOrganizationContextRequest
 */
export interface OrganizationAvailabilityApiOrganizationAvailabilityControllerSetAvailabilityWithOrganizationContextRequest {
    /**
     * Professional ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerSetAvailabilityWithOrganizationContext
     */
    readonly professionalId: string

    /**
     *
     * @type {SetOrganizationAvailabilityDto}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerSetAvailabilityWithOrganizationContext
     */
    readonly setOrganizationAvailabilityDto: SetOrganizationAvailabilityDto
}

/**
 * Request parameters for organizationAvailabilityControllerSetOrganizationAvailability operation in OrganizationAvailabilityApi.
 * @export
 * @interface OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationAvailabilityRequest
 */
export interface OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationAvailabilityRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationAvailability
     */
    readonly organizationId: string

    /**
     * Professional ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationAvailability
     */
    readonly professionalId: string

    /**
     *
     * @type {SetOrganizationAvailabilityDto}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationAvailability
     */
    readonly setOrganizationAvailabilityDto: SetOrganizationAvailabilityDto
}

/**
 * Request parameters for organizationAvailabilityControllerSetOrganizationTimeOff operation in OrganizationAvailabilityApi.
 * @export
 * @interface OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationTimeOffRequest
 */
export interface OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationTimeOffRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationTimeOff
     */
    readonly organizationId: string

    /**
     * Professional ID
     * @type {string}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationTimeOff
     */
    readonly professionalId: string

    /**
     *
     * @type {SetOrganizationTimeOffDto}
     * @memberof OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationTimeOff
     */
    readonly setOrganizationTimeOffDto: SetOrganizationTimeOffDto
}

/**
 * OrganizationAvailabilityApi - object-oriented interface
 * @export
 * @class OrganizationAvailabilityApi
 * @extends {BaseAPI}
 */
export class OrganizationAvailabilityApi extends BaseAPI {
    /**
     *
     * @summary Add time off to existing professional availability in organization
     * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerAddOrganizationTimeOffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAvailabilityApi
     */
    public organizationAvailabilityControllerAddOrganizationTimeOff(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerAddOrganizationTimeOffRequest, options?: AxiosRequestConfig) {
        return OrganizationAvailabilityApiFp(this.configuration).organizationAvailabilityControllerAddOrganizationTimeOff(requestParameters.organizationId, requestParameters.professionalId, requestParameters.addOrganizationTimeOffDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete availability for a professional in a specific organization
     * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerDeleteOrganizationAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAvailabilityApi
     */
    public organizationAvailabilityControllerDeleteOrganizationAvailability(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerDeleteOrganizationAvailabilityRequest, options?: AxiosRequestConfig) {
        return OrganizationAvailabilityApiFp(this.configuration).organizationAvailabilityControllerDeleteOrganizationAvailability(requestParameters.organizationId, requestParameters.professionalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get time off for all professionals in an organization
     * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAllTimeOffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAvailabilityApi
     */
    public organizationAvailabilityControllerGetOrganizationAllTimeOff(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAllTimeOffRequest, options?: AxiosRequestConfig) {
        return OrganizationAvailabilityApiFp(this.configuration).organizationAvailabilityControllerGetOrganizationAllTimeOff(requestParameters.organizationId, requestParameters.professionalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get availability for a professional in a specific organization
     * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAvailabilityApi
     */
    public organizationAvailabilityControllerGetOrganizationAvailability(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAvailabilityRequest, options?: AxiosRequestConfig) {
        return OrganizationAvailabilityApiFp(this.configuration).organizationAvailabilityControllerGetOrganizationAvailability(requestParameters.organizationId, requestParameters.professionalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get available visit slots for organization with enhanced filtering
     * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAvailableSlotsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAvailabilityApi
     */
    public organizationAvailabilityControllerGetOrganizationAvailableSlots(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationAvailableSlotsRequest, options?: AxiosRequestConfig) {
        return OrganizationAvailabilityApiFp(this.configuration).organizationAvailabilityControllerGetOrganizationAvailableSlots(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get time off for a professional in a specific organization
     * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationTimeOffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAvailabilityApi
     */
    public organizationAvailabilityControllerGetOrganizationTimeOff(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerGetOrganizationTimeOffRequest, options?: AxiosRequestConfig) {
        return OrganizationAvailabilityApiFp(this.configuration).organizationAvailabilityControllerGetOrganizationTimeOff(requestParameters.organizationId, requestParameters.professionalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all organization availabilities for a professional
     * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerGetProfessionalOrganizationAvailabilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAvailabilityApi
     */
    public organizationAvailabilityControllerGetProfessionalOrganizationAvailabilities(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerGetProfessionalOrganizationAvailabilitiesRequest, options?: AxiosRequestConfig) {
        return OrganizationAvailabilityApiFp(this.configuration).organizationAvailabilityControllerGetProfessionalOrganizationAvailabilities(requestParameters.professionalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Set availability for a professional using organization context from header
     * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerSetAvailabilityWithOrganizationContextRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAvailabilityApi
     */
    public organizationAvailabilityControllerSetAvailabilityWithOrganizationContext(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerSetAvailabilityWithOrganizationContextRequest, options?: AxiosRequestConfig) {
        return OrganizationAvailabilityApiFp(this.configuration).organizationAvailabilityControllerSetAvailabilityWithOrganizationContext(requestParameters.professionalId, requestParameters.setOrganizationAvailabilityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Set availability for a professional in a specific organization
     * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAvailabilityApi
     */
    public organizationAvailabilityControllerSetOrganizationAvailability(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationAvailabilityRequest, options?: AxiosRequestConfig) {
        return OrganizationAvailabilityApiFp(this.configuration).organizationAvailabilityControllerSetOrganizationAvailability(requestParameters.organizationId, requestParameters.professionalId, requestParameters.setOrganizationAvailabilityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Set time off for a professional in a specific organization
     * @param {OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationTimeOffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAvailabilityApi
     */
    public organizationAvailabilityControllerSetOrganizationTimeOff(requestParameters: OrganizationAvailabilityApiOrganizationAvailabilityControllerSetOrganizationTimeOffRequest, options?: AxiosRequestConfig) {
        return OrganizationAvailabilityApiFp(this.configuration).organizationAvailabilityControllerSetOrganizationTimeOff(requestParameters.organizationId, requestParameters.professionalId, requestParameters.setOrganizationTimeOffDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationBookingPolicyApi - axios parameter creator
 * @export
 */
export const OrganizationBookingPolicyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get the explicit Organization-service booking policy.
         * @param {string} organizationId
         * @param {string} serviceId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationServiceBookingPolicyControllerGet: async (organizationId: string, serviceId: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationServiceBookingPolicyControllerGet', 'organizationId', organizationId)
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('organizationServiceBookingPolicyControllerGet', 'serviceId', serviceId)
            const localVarPath = `/api/organization/{organizationId}/services/{serviceId}/booking-policy`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set the explicit Organization-service booking policy.
         * @param {string} organizationId
         * @param {string} serviceId
         * @param {SetOrganizationServiceBookingPolicyDto} setOrganizationServiceBookingPolicyDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationServiceBookingPolicyControllerSet: async (organizationId: string, serviceId: string, setOrganizationServiceBookingPolicyDto: SetOrganizationServiceBookingPolicyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationServiceBookingPolicyControllerSet', 'organizationId', organizationId)
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('organizationServiceBookingPolicyControllerSet', 'serviceId', serviceId)
            // verify required parameter 'setOrganizationServiceBookingPolicyDto' is not null or undefined
            assertParamExists('organizationServiceBookingPolicyControllerSet', 'setOrganizationServiceBookingPolicyDto', setOrganizationServiceBookingPolicyDto)
            const localVarPath = `/api/organization/{organizationId}/services/{serviceId}/booking-policy`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setOrganizationServiceBookingPolicyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationBookingPolicyApi - functional programming interface
 * @export
 */
export const OrganizationBookingPolicyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationBookingPolicyApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get the explicit Organization-service booking policy.
         * @param {string} organizationId
         * @param {string} serviceId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationServiceBookingPolicyControllerGet(organizationId: string, serviceId: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationServiceBookingPolicyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationServiceBookingPolicyControllerGet(organizationId, serviceId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Set the explicit Organization-service booking policy.
         * @param {string} organizationId
         * @param {string} serviceId
         * @param {SetOrganizationServiceBookingPolicyDto} setOrganizationServiceBookingPolicyDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationServiceBookingPolicyControllerSet(organizationId: string, serviceId: string, setOrganizationServiceBookingPolicyDto: SetOrganizationServiceBookingPolicyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationServiceBookingPolicyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationServiceBookingPolicyControllerSet(organizationId, serviceId, setOrganizationServiceBookingPolicyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationBookingPolicyApi - factory interface
 * @export
 */
export const OrganizationBookingPolicyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationBookingPolicyApiFp(configuration)
    return {
        /**
         *
         * @summary Get the explicit Organization-service booking policy.
         * @param {OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationServiceBookingPolicyControllerGet(requestParameters: OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerGetRequest, options?: AxiosRequestConfig): AxiosPromise<OrganizationServiceBookingPolicyResponseDto> {
            return localVarFp.organizationServiceBookingPolicyControllerGet(requestParameters.organizationId, requestParameters.serviceId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set the explicit Organization-service booking policy.
         * @param {OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerSetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationServiceBookingPolicyControllerSet(requestParameters: OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerSetRequest, options?: AxiosRequestConfig): AxiosPromise<OrganizationServiceBookingPolicyResponseDto> {
            return localVarFp.organizationServiceBookingPolicyControllerSet(requestParameters.organizationId, requestParameters.serviceId, requestParameters.setOrganizationServiceBookingPolicyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for organizationServiceBookingPolicyControllerGet operation in OrganizationBookingPolicyApi.
 * @export
 * @interface OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerGetRequest
 */
export interface OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerGetRequest {
    /**
     *
     * @type {string}
     * @memberof OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerGet
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerGet
     */
    readonly serviceId: string

    /**
     *
     * @type {object}
     * @memberof OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerGet
     */
    readonly body?: object
}

/**
 * Request parameters for organizationServiceBookingPolicyControllerSet operation in OrganizationBookingPolicyApi.
 * @export
 * @interface OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerSetRequest
 */
export interface OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerSetRequest {
    /**
     *
     * @type {string}
     * @memberof OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerSet
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerSet
     */
    readonly serviceId: string

    /**
     *
     * @type {SetOrganizationServiceBookingPolicyDto}
     * @memberof OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerSet
     */
    readonly setOrganizationServiceBookingPolicyDto: SetOrganizationServiceBookingPolicyDto
}

/**
 * OrganizationBookingPolicyApi - object-oriented interface
 * @export
 * @class OrganizationBookingPolicyApi
 * @extends {BaseAPI}
 */
export class OrganizationBookingPolicyApi extends BaseAPI {
    /**
     *
     * @summary Get the explicit Organization-service booking policy.
     * @param {OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBookingPolicyApi
     */
    public organizationServiceBookingPolicyControllerGet(requestParameters: OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerGetRequest, options?: AxiosRequestConfig) {
        return OrganizationBookingPolicyApiFp(this.configuration).organizationServiceBookingPolicyControllerGet(requestParameters.organizationId, requestParameters.serviceId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Set the explicit Organization-service booking policy.
     * @param {OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerSetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBookingPolicyApi
     */
    public organizationServiceBookingPolicyControllerSet(requestParameters: OrganizationBookingPolicyApiOrganizationServiceBookingPolicyControllerSetRequest, options?: AxiosRequestConfig) {
        return OrganizationBookingPolicyApiFp(this.configuration).organizationServiceBookingPolicyControllerSet(requestParameters.organizationId, requestParameters.serviceId, requestParameters.setOrganizationServiceBookingPolicyDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationProfessionalConfigurationApi - axios parameter creator
 * @export
 */
export const OrganizationProfessionalConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new specialization to the professional configuration
         * @summary Add specialization to professional configuration
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional user ID
         * @param {AddSpecializationDto} addSpecializationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfessionalConfigControllerAddSpecialization: async (organizationId: string, professionalId: string, addSpecializationDto: AddSpecializationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerAddSpecialization', 'organizationId', organizationId)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerAddSpecialization', 'professionalId', professionalId)
            // verify required parameter 'addSpecializationDto' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerAddSpecialization', 'addSpecializationDto', addSpecializationDto)
            const localVarPath = `/api/organizations/{organizationId}/professionals/{professionalId}/config/specializations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSpecializationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Check if removing specializations will affect service assignments
         * @param {string} organizationId
         * @param {string} professionalId
         * @param {CheckSpecializationServicesDto} checkSpecializationServicesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfessionalConfigControllerCheckSpecializationServices: async (organizationId: string, professionalId: string, checkSpecializationServicesDto: CheckSpecializationServicesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerCheckSpecializationServices', 'organizationId', organizationId)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerCheckSpecializationServices', 'professionalId', professionalId)
            // verify required parameter 'checkSpecializationServicesDto' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerCheckSpecializationServices', 'checkSpecializationServicesDto', checkSpecializationServicesDto)
            const localVarPath = `/api/organizations/{organizationId}/professionals/{professionalId}/config/check-specialization-services`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkSpecializationServicesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the configuration for a professional in a specific organization. If no config exists, returns user-level settings as defaults to populate the UI.
         * @summary Get professional configuration in organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfessionalConfigControllerGetConfig: async (organizationId: string, professionalId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerGetConfig', 'organizationId', organizationId)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerGetConfig', 'professionalId', professionalId)
            const localVarPath = `/api/organizations/{organizationId}/professionals/{professionalId}/config`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a specialization from the professional configuration
         * @summary Remove specialization from professional configuration
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional user ID
         * @param {string} specializationId Specialization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfessionalConfigControllerRemoveSpecialization: async (organizationId: string, professionalId: string, specializationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerRemoveSpecialization', 'organizationId', organizationId)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerRemoveSpecialization', 'professionalId', professionalId)
            // verify required parameter 'specializationId' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerRemoveSpecialization', 'specializationId', specializationId)
            const localVarPath = `/api/organizations/{organizationId}/professionals/{professionalId}/config/specializations/{specializationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)))
                .replace(`{${"specializationId"}}`, encodeURIComponent(String(specializationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set or replace the complete configuration for a professional in an organization
         * @summary Set complete professional configuration
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional user ID
         * @param {SetProfessionalConfigDto} setProfessionalConfigDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfessionalConfigControllerSetConfig: async (organizationId: string, professionalId: string, setProfessionalConfigDto: SetProfessionalConfigDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerSetConfig', 'organizationId', organizationId)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerSetConfig', 'professionalId', professionalId)
            // verify required parameter 'setProfessionalConfigDto' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerSetConfig', 'setProfessionalConfigDto', setProfessionalConfigDto)
            const localVarPath = `/api/organizations/{organizationId}/professionals/{professionalId}/config`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setProfessionalConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Partially update the configuration for a professional in an organization
         * @summary Update professional configuration
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional user ID
         * @param {UpdateProfessionalConfigDto} updateProfessionalConfigDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfessionalConfigControllerUpdateConfig: async (organizationId: string, professionalId: string, updateProfessionalConfigDto: UpdateProfessionalConfigDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerUpdateConfig', 'organizationId', organizationId)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerUpdateConfig', 'professionalId', professionalId)
            // verify required parameter 'updateProfessionalConfigDto' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerUpdateConfig', 'updateProfessionalConfigDto', updateProfessionalConfigDto)
            const localVarPath = `/api/organizations/{organizationId}/professionals/{professionalId}/config`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfessionalConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing specialization configuration
         * @summary Update specialization in professional configuration
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional user ID
         * @param {string} specializationId Specialization ID
         * @param {UpdateSpecializationDto} updateSpecializationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfessionalConfigControllerUpdateSpecialization: async (organizationId: string, professionalId: string, specializationId: string, updateSpecializationDto: UpdateSpecializationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerUpdateSpecialization', 'organizationId', organizationId)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerUpdateSpecialization', 'professionalId', professionalId)
            // verify required parameter 'specializationId' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerUpdateSpecialization', 'specializationId', specializationId)
            // verify required parameter 'updateSpecializationDto' is not null or undefined
            assertParamExists('organizationProfessionalConfigControllerUpdateSpecialization', 'updateSpecializationDto', updateSpecializationDto)
            const localVarPath = `/api/organizations/{organizationId}/professionals/{professionalId}/config/specializations/{specializationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)))
                .replace(`{${"specializationId"}}`, encodeURIComponent(String(specializationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSpecializationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationProfessionalConfigurationApi - functional programming interface
 * @export
 */
export const OrganizationProfessionalConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationProfessionalConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new specialization to the professional configuration
         * @summary Add specialization to professional configuration
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional user ID
         * @param {AddSpecializationDto} addSpecializationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfessionalConfigControllerAddSpecialization(organizationId: string, professionalId: string, addSpecializationDto: AddSpecializationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfessionalConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfessionalConfigControllerAddSpecialization(organizationId, professionalId, addSpecializationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Check if removing specializations will affect service assignments
         * @param {string} organizationId
         * @param {string} professionalId
         * @param {CheckSpecializationServicesDto} checkSpecializationServicesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfessionalConfigControllerCheckSpecializationServices(organizationId: string, professionalId: string, checkSpecializationServicesDto: CheckSpecializationServicesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProfessionalSpecializationServicesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfessionalConfigControllerCheckSpecializationServices(organizationId, professionalId, checkSpecializationServicesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the configuration for a professional in a specific organization. If no config exists, returns user-level settings as defaults to populate the UI.
         * @summary Get professional configuration in organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfessionalConfigControllerGetConfig(organizationId: string, professionalId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfessionalConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfessionalConfigControllerGetConfig(organizationId, professionalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Remove a specialization from the professional configuration
         * @summary Remove specialization from professional configuration
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional user ID
         * @param {string} specializationId Specialization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfessionalConfigControllerRemoveSpecialization(organizationId: string, professionalId: string, specializationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfessionalConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfessionalConfigControllerRemoveSpecialization(organizationId, professionalId, specializationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set or replace the complete configuration for a professional in an organization
         * @summary Set complete professional configuration
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional user ID
         * @param {SetProfessionalConfigDto} setProfessionalConfigDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfessionalConfigControllerSetConfig(organizationId: string, professionalId: string, setProfessionalConfigDto: SetProfessionalConfigDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfessionalConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfessionalConfigControllerSetConfig(organizationId, professionalId, setProfessionalConfigDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Partially update the configuration for a professional in an organization
         * @summary Update professional configuration
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional user ID
         * @param {UpdateProfessionalConfigDto} updateProfessionalConfigDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfessionalConfigControllerUpdateConfig(organizationId: string, professionalId: string, updateProfessionalConfigDto: UpdateProfessionalConfigDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfessionalConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfessionalConfigControllerUpdateConfig(organizationId, professionalId, updateProfessionalConfigDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update an existing specialization configuration
         * @summary Update specialization in professional configuration
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional user ID
         * @param {string} specializationId Specialization ID
         * @param {UpdateSpecializationDto} updateSpecializationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfessionalConfigControllerUpdateSpecialization(organizationId: string, professionalId: string, specializationId: string, updateSpecializationDto: UpdateSpecializationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfessionalConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfessionalConfigControllerUpdateSpecialization(organizationId, professionalId, specializationId, updateSpecializationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationProfessionalConfigurationApi - factory interface
 * @export
 */
export const OrganizationProfessionalConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationProfessionalConfigurationApiFp(configuration)
    return {
        /**
         * Add a new specialization to the professional configuration
         * @summary Add specialization to professional configuration
         * @param {OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerAddSpecializationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfessionalConfigControllerAddSpecialization(requestParameters: OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerAddSpecializationRequest, options?: AxiosRequestConfig): AxiosPromise<GetProfessionalConfigDto> {
            return localVarFp.organizationProfessionalConfigControllerAddSpecialization(requestParameters.organizationId, requestParameters.professionalId, requestParameters.addSpecializationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check if removing specializations will affect service assignments
         * @param {OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerCheckSpecializationServicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfessionalConfigControllerCheckSpecializationServices(requestParameters: OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerCheckSpecializationServicesRequest, options?: AxiosRequestConfig): AxiosPromise<CheckProfessionalSpecializationServicesResponseDto> {
            return localVarFp.organizationProfessionalConfigControllerCheckSpecializationServices(requestParameters.organizationId, requestParameters.professionalId, requestParameters.checkSpecializationServicesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the configuration for a professional in a specific organization. If no config exists, returns user-level settings as defaults to populate the UI.
         * @summary Get professional configuration in organization
         * @param {OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerGetConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfessionalConfigControllerGetConfig(requestParameters: OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerGetConfigRequest, options?: AxiosRequestConfig): AxiosPromise<GetProfessionalConfigDto> {
            return localVarFp.organizationProfessionalConfigControllerGetConfig(requestParameters.organizationId, requestParameters.professionalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a specialization from the professional configuration
         * @summary Remove specialization from professional configuration
         * @param {OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerRemoveSpecializationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfessionalConfigControllerRemoveSpecialization(requestParameters: OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerRemoveSpecializationRequest, options?: AxiosRequestConfig): AxiosPromise<GetProfessionalConfigDto> {
            return localVarFp.organizationProfessionalConfigControllerRemoveSpecialization(requestParameters.organizationId, requestParameters.professionalId, requestParameters.specializationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Set or replace the complete configuration for a professional in an organization
         * @summary Set complete professional configuration
         * @param {OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerSetConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfessionalConfigControllerSetConfig(requestParameters: OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerSetConfigRequest, options?: AxiosRequestConfig): AxiosPromise<GetProfessionalConfigDto> {
            return localVarFp.organizationProfessionalConfigControllerSetConfig(requestParameters.organizationId, requestParameters.professionalId, requestParameters.setProfessionalConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Partially update the configuration for a professional in an organization
         * @summary Update professional configuration
         * @param {OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfessionalConfigControllerUpdateConfig(requestParameters: OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateConfigRequest, options?: AxiosRequestConfig): AxiosPromise<GetProfessionalConfigDto> {
            return localVarFp.organizationProfessionalConfigControllerUpdateConfig(requestParameters.organizationId, requestParameters.professionalId, requestParameters.updateProfessionalConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing specialization configuration
         * @summary Update specialization in professional configuration
         * @param {OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateSpecializationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfessionalConfigControllerUpdateSpecialization(requestParameters: OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateSpecializationRequest, options?: AxiosRequestConfig): AxiosPromise<GetProfessionalConfigDto> {
            return localVarFp.organizationProfessionalConfigControllerUpdateSpecialization(requestParameters.organizationId, requestParameters.professionalId, requestParameters.specializationId, requestParameters.updateSpecializationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for organizationProfessionalConfigControllerAddSpecialization operation in OrganizationProfessionalConfigurationApi.
 * @export
 * @interface OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerAddSpecializationRequest
 */
export interface OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerAddSpecializationRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerAddSpecialization
     */
    readonly organizationId: string

    /**
     * Professional user ID
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerAddSpecialization
     */
    readonly professionalId: string

    /**
     *
     * @type {AddSpecializationDto}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerAddSpecialization
     */
    readonly addSpecializationDto: AddSpecializationDto
}

/**
 * Request parameters for organizationProfessionalConfigControllerCheckSpecializationServices operation in OrganizationProfessionalConfigurationApi.
 * @export
 * @interface OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerCheckSpecializationServicesRequest
 */
export interface OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerCheckSpecializationServicesRequest {
    /**
     *
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerCheckSpecializationServices
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerCheckSpecializationServices
     */
    readonly professionalId: string

    /**
     *
     * @type {CheckSpecializationServicesDto}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerCheckSpecializationServices
     */
    readonly checkSpecializationServicesDto: CheckSpecializationServicesDto
}

/**
 * Request parameters for organizationProfessionalConfigControllerGetConfig operation in OrganizationProfessionalConfigurationApi.
 * @export
 * @interface OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerGetConfigRequest
 */
export interface OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerGetConfigRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerGetConfig
     */
    readonly organizationId: string

    /**
     * Professional user ID
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerGetConfig
     */
    readonly professionalId: string
}

/**
 * Request parameters for organizationProfessionalConfigControllerRemoveSpecialization operation in OrganizationProfessionalConfigurationApi.
 * @export
 * @interface OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerRemoveSpecializationRequest
 */
export interface OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerRemoveSpecializationRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerRemoveSpecialization
     */
    readonly organizationId: string

    /**
     * Professional user ID
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerRemoveSpecialization
     */
    readonly professionalId: string

    /**
     * Specialization ID
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerRemoveSpecialization
     */
    readonly specializationId: string
}

/**
 * Request parameters for organizationProfessionalConfigControllerSetConfig operation in OrganizationProfessionalConfigurationApi.
 * @export
 * @interface OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerSetConfigRequest
 */
export interface OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerSetConfigRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerSetConfig
     */
    readonly organizationId: string

    /**
     * Professional user ID
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerSetConfig
     */
    readonly professionalId: string

    /**
     *
     * @type {SetProfessionalConfigDto}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerSetConfig
     */
    readonly setProfessionalConfigDto: SetProfessionalConfigDto
}

/**
 * Request parameters for organizationProfessionalConfigControllerUpdateConfig operation in OrganizationProfessionalConfigurationApi.
 * @export
 * @interface OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateConfigRequest
 */
export interface OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateConfigRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateConfig
     */
    readonly organizationId: string

    /**
     * Professional user ID
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateConfig
     */
    readonly professionalId: string

    /**
     *
     * @type {UpdateProfessionalConfigDto}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateConfig
     */
    readonly updateProfessionalConfigDto: UpdateProfessionalConfigDto
}

/**
 * Request parameters for organizationProfessionalConfigControllerUpdateSpecialization operation in OrganizationProfessionalConfigurationApi.
 * @export
 * @interface OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateSpecializationRequest
 */
export interface OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateSpecializationRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateSpecialization
     */
    readonly organizationId: string

    /**
     * Professional user ID
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateSpecialization
     */
    readonly professionalId: string

    /**
     * Specialization ID
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateSpecialization
     */
    readonly specializationId: string

    /**
     *
     * @type {UpdateSpecializationDto}
     * @memberof OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateSpecialization
     */
    readonly updateSpecializationDto: UpdateSpecializationDto
}

/**
 * OrganizationProfessionalConfigurationApi - object-oriented interface
 * @export
 * @class OrganizationProfessionalConfigurationApi
 * @extends {BaseAPI}
 */
export class OrganizationProfessionalConfigurationApi extends BaseAPI {
    /**
     * Add a new specialization to the professional configuration
     * @summary Add specialization to professional configuration
     * @param {OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerAddSpecializationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfessionalConfigurationApi
     */
    public organizationProfessionalConfigControllerAddSpecialization(requestParameters: OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerAddSpecializationRequest, options?: AxiosRequestConfig) {
        return OrganizationProfessionalConfigurationApiFp(this.configuration).organizationProfessionalConfigControllerAddSpecialization(requestParameters.organizationId, requestParameters.professionalId, requestParameters.addSpecializationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Check if removing specializations will affect service assignments
     * @param {OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerCheckSpecializationServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfessionalConfigurationApi
     */
    public organizationProfessionalConfigControllerCheckSpecializationServices(requestParameters: OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerCheckSpecializationServicesRequest, options?: AxiosRequestConfig) {
        return OrganizationProfessionalConfigurationApiFp(this.configuration).organizationProfessionalConfigControllerCheckSpecializationServices(requestParameters.organizationId, requestParameters.professionalId, requestParameters.checkSpecializationServicesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the configuration for a professional in a specific organization. If no config exists, returns user-level settings as defaults to populate the UI.
     * @summary Get professional configuration in organization
     * @param {OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerGetConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfessionalConfigurationApi
     */
    public organizationProfessionalConfigControllerGetConfig(requestParameters: OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerGetConfigRequest, options?: AxiosRequestConfig) {
        return OrganizationProfessionalConfigurationApiFp(this.configuration).organizationProfessionalConfigControllerGetConfig(requestParameters.organizationId, requestParameters.professionalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a specialization from the professional configuration
     * @summary Remove specialization from professional configuration
     * @param {OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerRemoveSpecializationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfessionalConfigurationApi
     */
    public organizationProfessionalConfigControllerRemoveSpecialization(requestParameters: OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerRemoveSpecializationRequest, options?: AxiosRequestConfig) {
        return OrganizationProfessionalConfigurationApiFp(this.configuration).organizationProfessionalConfigControllerRemoveSpecialization(requestParameters.organizationId, requestParameters.professionalId, requestParameters.specializationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set or replace the complete configuration for a professional in an organization
     * @summary Set complete professional configuration
     * @param {OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerSetConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfessionalConfigurationApi
     */
    public organizationProfessionalConfigControllerSetConfig(requestParameters: OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerSetConfigRequest, options?: AxiosRequestConfig) {
        return OrganizationProfessionalConfigurationApiFp(this.configuration).organizationProfessionalConfigControllerSetConfig(requestParameters.organizationId, requestParameters.professionalId, requestParameters.setProfessionalConfigDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Partially update the configuration for a professional in an organization
     * @summary Update professional configuration
     * @param {OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfessionalConfigurationApi
     */
    public organizationProfessionalConfigControllerUpdateConfig(requestParameters: OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateConfigRequest, options?: AxiosRequestConfig) {
        return OrganizationProfessionalConfigurationApiFp(this.configuration).organizationProfessionalConfigControllerUpdateConfig(requestParameters.organizationId, requestParameters.professionalId, requestParameters.updateProfessionalConfigDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing specialization configuration
     * @summary Update specialization in professional configuration
     * @param {OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateSpecializationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfessionalConfigurationApi
     */
    public organizationProfessionalConfigControllerUpdateSpecialization(requestParameters: OrganizationProfessionalConfigurationApiOrganizationProfessionalConfigControllerUpdateSpecializationRequest, options?: AxiosRequestConfig) {
        return OrganizationProfessionalConfigurationApiFp(this.configuration).organizationProfessionalConfigControllerUpdateSpecialization(requestParameters.organizationId, requestParameters.professionalId, requestParameters.specializationId, requestParameters.updateSpecializationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationProfessionalConfigurationsApi - axios parameter creator
 * @export
 */
export const OrganizationProfessionalConfigurationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve all professional configurations for an organization (admin only)
         * @summary Get all professional configurations in organization
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfessionalConfigsControllerGetAllProfessionalsConfigs: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationProfessionalConfigsControllerGetAllProfessionalsConfigs', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/professionals-config`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationProfessionalConfigurationsApi - functional programming interface
 * @export
 */
export const OrganizationProfessionalConfigurationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationProfessionalConfigurationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve all professional configurations for an organization (admin only)
         * @summary Get all professional configurations in organization
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfessionalConfigsControllerGetAllProfessionalsConfigs(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProfessionalConfigDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfessionalConfigsControllerGetAllProfessionalsConfigs(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationProfessionalConfigurationsApi - factory interface
 * @export
 */
export const OrganizationProfessionalConfigurationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationProfessionalConfigurationsApiFp(configuration)
    return {
        /**
         * Retrieve all professional configurations for an organization (admin only)
         * @summary Get all professional configurations in organization
         * @param {OrganizationProfessionalConfigurationsApiOrganizationProfessionalConfigsControllerGetAllProfessionalsConfigsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfessionalConfigsControllerGetAllProfessionalsConfigs(requestParameters: OrganizationProfessionalConfigurationsApiOrganizationProfessionalConfigsControllerGetAllProfessionalsConfigsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetProfessionalConfigDto>> {
            return localVarFp.organizationProfessionalConfigsControllerGetAllProfessionalsConfigs(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for organizationProfessionalConfigsControllerGetAllProfessionalsConfigs operation in OrganizationProfessionalConfigurationsApi.
 * @export
 * @interface OrganizationProfessionalConfigurationsApiOrganizationProfessionalConfigsControllerGetAllProfessionalsConfigsRequest
 */
export interface OrganizationProfessionalConfigurationsApiOrganizationProfessionalConfigsControllerGetAllProfessionalsConfigsRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationProfessionalConfigurationsApiOrganizationProfessionalConfigsControllerGetAllProfessionalsConfigs
     */
    readonly organizationId: string
}

/**
 * OrganizationProfessionalConfigurationsApi - object-oriented interface
 * @export
 * @class OrganizationProfessionalConfigurationsApi
 * @extends {BaseAPI}
 */
export class OrganizationProfessionalConfigurationsApi extends BaseAPI {
    /**
     * Retrieve all professional configurations for an organization (admin only)
     * @summary Get all professional configurations in organization
     * @param {OrganizationProfessionalConfigurationsApiOrganizationProfessionalConfigsControllerGetAllProfessionalsConfigsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfessionalConfigurationsApi
     */
    public organizationProfessionalConfigsControllerGetAllProfessionalsConfigs(requestParameters: OrganizationProfessionalConfigurationsApiOrganizationProfessionalConfigsControllerGetAllProfessionalsConfigsRequest, options?: AxiosRequestConfig) {
        return OrganizationProfessionalConfigurationsApiFp(this.configuration).organizationProfessionalConfigsControllerGetAllProfessionalsConfigs(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationProfileApi - axios parameter creator
 * @export
 */
export const OrganizationProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create a reminder from a visit.
         * @param {string} visitId
         * @param {CreateReminderDto} createReminderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerAddVisitReminder: async (visitId: string, createReminderDto: CreateReminderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('organizationProfileControllerAddVisitReminder', 'visitId', visitId)
            // verify required parameter 'createReminderDto' is not null or undefined
            assertParamExists('organizationProfileControllerAddVisitReminder', 'createReminderDto', createReminderDto)
            const localVarPath = `/api/organization-profile/visit/{visitId}/reminder`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReminderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all profiles assigned to a user by userId within the organization context
         * @param {string} userId User ID to find profiles for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerGetOrganizationProfilesForScheduleByUserId: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('organizationProfileControllerGetOrganizationProfilesForScheduleByUserId', 'userId', userId)
            const localVarPath = `/api/organization-profile/profiles/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the latest AI summary for a profile, optionally filtered by visit
         * @param {string} profileId
         * @param {string} [visitId] Optional visit ID to get summary specific to this visit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerGetProfileAiSummary: async (profileId: string, visitId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('organizationProfileControllerGetProfileAiSummary', 'profileId', profileId)
            const localVarPath = `/api/organization-profile/profile/{profileId}/ai-summary`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (visitId !== undefined) {
                localVarQueryParameter['visitId'] = visitId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get activity log for a visit
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerGetVisitActivity: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('organizationProfileControllerGetVisitActivity', 'visitId', visitId)
            const localVarPath = `/api/organization-profile/visit/{visitId}/activity`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the visit-scoped AI summary (cache + dirty-check regen)
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerGetVisitAiSummary: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('organizationProfileControllerGetVisitAiSummary', 'visitId', visitId)
            const localVarPath = `/api/organization-profile/visit/{visitId}/ai-summary`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List reminders attached to a visit.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerListVisitReminders: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('organizationProfileControllerListVisitReminders', 'visitId', visitId)
            const localVarPath = `/api/organization-profile/visit/{visitId}/reminders`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Secure endpoint for professionals to access profiles within their organization
         * @summary Preview profile by id within organization context
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerPreviewProfileInOrganization: async (profileId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('organizationProfileControllerPreviewProfileInOrganization', 'profileId', profileId)
            const localVarPath = `/api/organization-profile/profile/{profileId}/preview`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only allowed when visit is in PENDING state
         * @summary Remove an activity from a visit and cascade delete the associated item
         * @param {string} visitId
         * @param {string} activityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerRemoveVisitActivity: async (visitId: string, activityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('organizationProfileControllerRemoveVisitActivity', 'visitId', visitId)
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('organizationProfileControllerRemoveVisitActivity', 'activityId', activityId)
            const localVarPath = `/api/organization-profile/visit/{visitId}/activity/{activityId}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)))
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a reminder attached to a visit.
         * @param {string} visitId
         * @param {string} reminderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerRemoveVisitReminder: async (visitId: string, reminderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('organizationProfileControllerRemoveVisitReminder', 'visitId', visitId)
            // verify required parameter 'reminderId' is not null or undefined
            assertParamExists('organizationProfileControllerRemoveVisitReminder', 'reminderId', reminderId)
            const localVarPath = `/api/organization-profile/visit/{visitId}/reminder/{reminderId}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)))
                .replace(`{${"reminderId"}}`, encodeURIComponent(String(reminderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Secure endpoint for professionals to update patient profile information during an active (PENDING) visit. Validates that the visit belongs to the organization and is currently in progress.
         * @summary Update profile during a live visit within organization context
         * @param {string} profileId
         * @param {string} visitId
         * @param {UpdateOrganizationProfileDuringVisitDto} updateOrganizationProfileDuringVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerUpdateProfileDuringVisitInOrganization: async (profileId: string, visitId: string, updateOrganizationProfileDuringVisitDto: UpdateOrganizationProfileDuringVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('organizationProfileControllerUpdateProfileDuringVisitInOrganization', 'profileId', profileId)
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('organizationProfileControllerUpdateProfileDuringVisitInOrganization', 'visitId', visitId)
            // verify required parameter 'updateOrganizationProfileDuringVisitDto' is not null or undefined
            assertParamExists('organizationProfileControllerUpdateProfileDuringVisitInOrganization', 'updateOrganizationProfileDuringVisitDto', updateOrganizationProfileDuringVisitDto)
            const localVarPath = `/api/organization-profile/profile/{profileId}/visit/{visitId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganizationProfileDuringVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a reminder attached to a visit.
         * @param {string} visitId
         * @param {string} reminderId
         * @param {UpdateReminderDto} updateReminderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerUpdateVisitReminder: async (visitId: string, reminderId: string, updateReminderDto: UpdateReminderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('organizationProfileControllerUpdateVisitReminder', 'visitId', visitId)
            // verify required parameter 'reminderId' is not null or undefined
            assertParamExists('organizationProfileControllerUpdateVisitReminder', 'reminderId', reminderId)
            // verify required parameter 'updateReminderDto' is not null or undefined
            assertParamExists('organizationProfileControllerUpdateVisitReminder', 'updateReminderDto', updateReminderDto)
            const localVarPath = `/api/organization-profile/visit/{visitId}/reminder/{reminderId}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)))
                .replace(`{${"reminderId"}}`, encodeURIComponent(String(reminderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReminderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationProfileApi - functional programming interface
 * @export
 */
export const OrganizationProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationProfileApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create a reminder from a visit.
         * @param {string} visitId
         * @param {CreateReminderDto} createReminderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfileControllerAddVisitReminder(visitId: string, createReminderDto: CreateReminderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReminderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfileControllerAddVisitReminder(visitId, createReminderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all profiles assigned to a user by userId within the organization context
         * @param {string} userId User ID to find profiles for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfileControllerGetOrganizationProfilesForScheduleByUserId(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationProfilesForScheduleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfileControllerGetOrganizationProfilesForScheduleByUserId(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get the latest AI summary for a profile, optionally filtered by visit
         * @param {string} profileId
         * @param {string} [visitId] Optional visit ID to get summary specific to this visit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfileControllerGetProfileAiSummary(profileId: string, visitId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfileControllerGetProfileAiSummary(profileId, visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get activity log for a visit
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfileControllerGetVisitActivity(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VisitActivityResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfileControllerGetVisitActivity(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get the visit-scoped AI summary (cache + dirty-check regen)
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfileControllerGetVisitAiSummary(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfileControllerGetVisitAiSummary(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List reminders attached to a visit.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfileControllerListVisitReminders(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetReminderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfileControllerListVisitReminders(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Secure endpoint for professionals to access profiles within their organization
         * @summary Preview profile by id within organization context
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfileControllerPreviewProfileInOrganization(profileId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfessionalProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfileControllerPreviewProfileInOrganization(profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Only allowed when visit is in PENDING state
         * @summary Remove an activity from a visit and cascade delete the associated item
         * @param {string} visitId
         * @param {string} activityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfileControllerRemoveVisitActivity(visitId: string, activityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VisitActivityResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfileControllerRemoveVisitActivity(visitId, activityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a reminder attached to a visit.
         * @param {string} visitId
         * @param {string} reminderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfileControllerRemoveVisitReminder(visitId: string, reminderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfileControllerRemoveVisitReminder(visitId, reminderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Secure endpoint for professionals to update patient profile information during an active (PENDING) visit. Validates that the visit belongs to the organization and is currently in progress.
         * @summary Update profile during a live visit within organization context
         * @param {string} profileId
         * @param {string} visitId
         * @param {UpdateOrganizationProfileDuringVisitDto} updateOrganizationProfileDuringVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfileControllerUpdateProfileDuringVisitInOrganization(profileId: string, visitId: string, updateOrganizationProfileDuringVisitDto: UpdateOrganizationProfileDuringVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfessionalProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfileControllerUpdateProfileDuringVisitInOrganization(profileId, visitId, updateOrganizationProfileDuringVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update a reminder attached to a visit.
         * @param {string} visitId
         * @param {string} reminderId
         * @param {UpdateReminderDto} updateReminderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationProfileControllerUpdateVisitReminder(visitId: string, reminderId: string, updateReminderDto: UpdateReminderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReminderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationProfileControllerUpdateVisitReminder(visitId, reminderId, updateReminderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationProfileApi - factory interface
 * @export
 */
export const OrganizationProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationProfileApiFp(configuration)
    return {
        /**
         *
         * @summary Create a reminder from a visit.
         * @param {OrganizationProfileApiOrganizationProfileControllerAddVisitReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerAddVisitReminder(requestParameters: OrganizationProfileApiOrganizationProfileControllerAddVisitReminderRequest, options?: AxiosRequestConfig): AxiosPromise<GetReminderDto> {
            return localVarFp.organizationProfileControllerAddVisitReminder(requestParameters.visitId, requestParameters.createReminderDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all profiles assigned to a user by userId within the organization context
         * @param {OrganizationProfileApiOrganizationProfileControllerGetOrganizationProfilesForScheduleByUserIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerGetOrganizationProfilesForScheduleByUserId(requestParameters: OrganizationProfileApiOrganizationProfileControllerGetOrganizationProfilesForScheduleByUserIdRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationProfilesForScheduleDto>> {
            return localVarFp.organizationProfileControllerGetOrganizationProfilesForScheduleByUserId(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the latest AI summary for a profile, optionally filtered by visit
         * @param {OrganizationProfileApiOrganizationProfileControllerGetProfileAiSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerGetProfileAiSummary(requestParameters: OrganizationProfileApiOrganizationProfileControllerGetProfileAiSummaryRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.organizationProfileControllerGetProfileAiSummary(requestParameters.profileId, requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get activity log for a visit
         * @param {OrganizationProfileApiOrganizationProfileControllerGetVisitActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerGetVisitActivity(requestParameters: OrganizationProfileApiOrganizationProfileControllerGetVisitActivityRequest, options?: AxiosRequestConfig): AxiosPromise<Array<VisitActivityResponseDto>> {
            return localVarFp.organizationProfileControllerGetVisitActivity(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the visit-scoped AI summary (cache + dirty-check regen)
         * @param {OrganizationProfileApiOrganizationProfileControllerGetVisitAiSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerGetVisitAiSummary(requestParameters: OrganizationProfileApiOrganizationProfileControllerGetVisitAiSummaryRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.organizationProfileControllerGetVisitAiSummary(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List reminders attached to a visit.
         * @param {OrganizationProfileApiOrganizationProfileControllerListVisitRemindersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerListVisitReminders(requestParameters: OrganizationProfileApiOrganizationProfileControllerListVisitRemindersRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetReminderDto>> {
            return localVarFp.organizationProfileControllerListVisitReminders(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         * Secure endpoint for professionals to access profiles within their organization
         * @summary Preview profile by id within organization context
         * @param {OrganizationProfileApiOrganizationProfileControllerPreviewProfileInOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerPreviewProfileInOrganization(requestParameters: OrganizationProfileApiOrganizationProfileControllerPreviewProfileInOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<GetProfessionalProfileDto> {
            return localVarFp.organizationProfileControllerPreviewProfileInOrganization(requestParameters.profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Only allowed when visit is in PENDING state
         * @summary Remove an activity from a visit and cascade delete the associated item
         * @param {OrganizationProfileApiOrganizationProfileControllerRemoveVisitActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerRemoveVisitActivity(requestParameters: OrganizationProfileApiOrganizationProfileControllerRemoveVisitActivityRequest, options?: AxiosRequestConfig): AxiosPromise<Array<VisitActivityResponseDto>> {
            return localVarFp.organizationProfileControllerRemoveVisitActivity(requestParameters.visitId, requestParameters.activityId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a reminder attached to a visit.
         * @param {OrganizationProfileApiOrganizationProfileControllerRemoveVisitReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerRemoveVisitReminder(requestParameters: OrganizationProfileApiOrganizationProfileControllerRemoveVisitReminderRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.organizationProfileControllerRemoveVisitReminder(requestParameters.visitId, requestParameters.reminderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Secure endpoint for professionals to update patient profile information during an active (PENDING) visit. Validates that the visit belongs to the organization and is currently in progress.
         * @summary Update profile during a live visit within organization context
         * @param {OrganizationProfileApiOrganizationProfileControllerUpdateProfileDuringVisitInOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerUpdateProfileDuringVisitInOrganization(requestParameters: OrganizationProfileApiOrganizationProfileControllerUpdateProfileDuringVisitInOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<GetProfessionalProfileDto> {
            return localVarFp.organizationProfileControllerUpdateProfileDuringVisitInOrganization(requestParameters.profileId, requestParameters.visitId, requestParameters.updateOrganizationProfileDuringVisitDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a reminder attached to a visit.
         * @param {OrganizationProfileApiOrganizationProfileControllerUpdateVisitReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationProfileControllerUpdateVisitReminder(requestParameters: OrganizationProfileApiOrganizationProfileControllerUpdateVisitReminderRequest, options?: AxiosRequestConfig): AxiosPromise<GetReminderDto> {
            return localVarFp.organizationProfileControllerUpdateVisitReminder(requestParameters.visitId, requestParameters.reminderId, requestParameters.updateReminderDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for organizationProfileControllerAddVisitReminder operation in OrganizationProfileApi.
 * @export
 * @interface OrganizationProfileApiOrganizationProfileControllerAddVisitReminderRequest
 */
export interface OrganizationProfileApiOrganizationProfileControllerAddVisitReminderRequest {
    /**
     *
     * @type {string}
     * @memberof OrganizationProfileApiOrganizationProfileControllerAddVisitReminder
     */
    readonly visitId: string

    /**
     *
     * @type {CreateReminderDto}
     * @memberof OrganizationProfileApiOrganizationProfileControllerAddVisitReminder
     */
    readonly createReminderDto: CreateReminderDto
}

/**
 * Request parameters for organizationProfileControllerGetOrganizationProfilesForScheduleByUserId operation in OrganizationProfileApi.
 * @export
 * @interface OrganizationProfileApiOrganizationProfileControllerGetOrganizationProfilesForScheduleByUserIdRequest
 */
export interface OrganizationProfileApiOrganizationProfileControllerGetOrganizationProfilesForScheduleByUserIdRequest {
    /**
     * User ID to find profiles for
     * @type {string}
     * @memberof OrganizationProfileApiOrganizationProfileControllerGetOrganizationProfilesForScheduleByUserId
     */
    readonly userId: string
}

/**
 * Request parameters for organizationProfileControllerGetProfileAiSummary operation in OrganizationProfileApi.
 * @export
 * @interface OrganizationProfileApiOrganizationProfileControllerGetProfileAiSummaryRequest
 */
export interface OrganizationProfileApiOrganizationProfileControllerGetProfileAiSummaryRequest {
    /**
     *
     * @type {string}
     * @memberof OrganizationProfileApiOrganizationProfileControllerGetProfileAiSummary
     */
    readonly profileId: string

    /**
     * Optional visit ID to get summary specific to this visit
     * @type {string}
     * @memberof OrganizationProfileApiOrganizationProfileControllerGetProfileAiSummary
     */
    readonly visitId?: string
}

/**
 * Request parameters for organizationProfileControllerGetVisitActivity operation in OrganizationProfileApi.
 * @export
 * @interface OrganizationProfileApiOrganizationProfileControllerGetVisitActivityRequest
 */
export interface OrganizationProfileApiOrganizationProfileControllerGetVisitActivityRequest {
    /**
     *
     * @type {string}
     * @memberof OrganizationProfileApiOrganizationProfileControllerGetVisitActivity
     */
    readonly visitId: string
}

/**
 * Request parameters for organizationProfileControllerGetVisitAiSummary operation in OrganizationProfileApi.
 * @export
 * @interface OrganizationProfileApiOrganizationProfileControllerGetVisitAiSummaryRequest
 */
export interface OrganizationProfileApiOrganizationProfileControllerGetVisitAiSummaryRequest {
    /**
     *
     * @type {string}
     * @memberof OrganizationProfileApiOrganizationProfileControllerGetVisitAiSummary
     */
    readonly visitId: string
}

/**
 * Request parameters for organizationProfileControllerListVisitReminders operation in OrganizationProfileApi.
 * @export
 * @interface OrganizationProfileApiOrganizationProfileControllerListVisitRemindersRequest
 */
export interface OrganizationProfileApiOrganizationProfileControllerListVisitRemindersRequest {
    /**
     *
     * @type {string}
     * @memberof OrganizationProfileApiOrganizationProfileControllerListVisitReminders
     */
    readonly visitId: string
}

/**
 * Request parameters for organizationProfileControllerPreviewProfileInOrganization operation in OrganizationProfileApi.
 * @export
 * @interface OrganizationProfileApiOrganizationProfileControllerPreviewProfileInOrganizationRequest
 */
export interface OrganizationProfileApiOrganizationProfileControllerPreviewProfileInOrganizationRequest {
    /**
     *
     * @type {string}
     * @memberof OrganizationProfileApiOrganizationProfileControllerPreviewProfileInOrganization
     */
    readonly profileId: string
}

/**
 * Request parameters for organizationProfileControllerRemoveVisitActivity operation in OrganizationProfileApi.
 * @export
 * @interface OrganizationProfileApiOrganizationProfileControllerRemoveVisitActivityRequest
 */
export interface OrganizationProfileApiOrganizationProfileControllerRemoveVisitActivityRequest {
    /**
     *
     * @type {string}
     * @memberof OrganizationProfileApiOrganizationProfileControllerRemoveVisitActivity
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof OrganizationProfileApiOrganizationProfileControllerRemoveVisitActivity
     */
    readonly activityId: string
}

/**
 * Request parameters for organizationProfileControllerRemoveVisitReminder operation in OrganizationProfileApi.
 * @export
 * @interface OrganizationProfileApiOrganizationProfileControllerRemoveVisitReminderRequest
 */
export interface OrganizationProfileApiOrganizationProfileControllerRemoveVisitReminderRequest {
    /**
     *
     * @type {string}
     * @memberof OrganizationProfileApiOrganizationProfileControllerRemoveVisitReminder
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof OrganizationProfileApiOrganizationProfileControllerRemoveVisitReminder
     */
    readonly reminderId: string
}

/**
 * Request parameters for organizationProfileControllerUpdateProfileDuringVisitInOrganization operation in OrganizationProfileApi.
 * @export
 * @interface OrganizationProfileApiOrganizationProfileControllerUpdateProfileDuringVisitInOrganizationRequest
 */
export interface OrganizationProfileApiOrganizationProfileControllerUpdateProfileDuringVisitInOrganizationRequest {
    /**
     *
     * @type {string}
     * @memberof OrganizationProfileApiOrganizationProfileControllerUpdateProfileDuringVisitInOrganization
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof OrganizationProfileApiOrganizationProfileControllerUpdateProfileDuringVisitInOrganization
     */
    readonly visitId: string

    /**
     *
     * @type {UpdateOrganizationProfileDuringVisitDto}
     * @memberof OrganizationProfileApiOrganizationProfileControllerUpdateProfileDuringVisitInOrganization
     */
    readonly updateOrganizationProfileDuringVisitDto: UpdateOrganizationProfileDuringVisitDto
}

/**
 * Request parameters for organizationProfileControllerUpdateVisitReminder operation in OrganizationProfileApi.
 * @export
 * @interface OrganizationProfileApiOrganizationProfileControllerUpdateVisitReminderRequest
 */
export interface OrganizationProfileApiOrganizationProfileControllerUpdateVisitReminderRequest {
    /**
     *
     * @type {string}
     * @memberof OrganizationProfileApiOrganizationProfileControllerUpdateVisitReminder
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof OrganizationProfileApiOrganizationProfileControllerUpdateVisitReminder
     */
    readonly reminderId: string

    /**
     *
     * @type {UpdateReminderDto}
     * @memberof OrganizationProfileApiOrganizationProfileControllerUpdateVisitReminder
     */
    readonly updateReminderDto: UpdateReminderDto
}

/**
 * OrganizationProfileApi - object-oriented interface
 * @export
 * @class OrganizationProfileApi
 * @extends {BaseAPI}
 */
export class OrganizationProfileApi extends BaseAPI {
    /**
     *
     * @summary Create a reminder from a visit.
     * @param {OrganizationProfileApiOrganizationProfileControllerAddVisitReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfileApi
     */
    public organizationProfileControllerAddVisitReminder(requestParameters: OrganizationProfileApiOrganizationProfileControllerAddVisitReminderRequest, options?: AxiosRequestConfig) {
        return OrganizationProfileApiFp(this.configuration).organizationProfileControllerAddVisitReminder(requestParameters.visitId, requestParameters.createReminderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all profiles assigned to a user by userId within the organization context
     * @param {OrganizationProfileApiOrganizationProfileControllerGetOrganizationProfilesForScheduleByUserIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfileApi
     */
    public organizationProfileControllerGetOrganizationProfilesForScheduleByUserId(requestParameters: OrganizationProfileApiOrganizationProfileControllerGetOrganizationProfilesForScheduleByUserIdRequest, options?: AxiosRequestConfig) {
        return OrganizationProfileApiFp(this.configuration).organizationProfileControllerGetOrganizationProfilesForScheduleByUserId(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get the latest AI summary for a profile, optionally filtered by visit
     * @param {OrganizationProfileApiOrganizationProfileControllerGetProfileAiSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfileApi
     */
    public organizationProfileControllerGetProfileAiSummary(requestParameters: OrganizationProfileApiOrganizationProfileControllerGetProfileAiSummaryRequest, options?: AxiosRequestConfig) {
        return OrganizationProfileApiFp(this.configuration).organizationProfileControllerGetProfileAiSummary(requestParameters.profileId, requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get activity log for a visit
     * @param {OrganizationProfileApiOrganizationProfileControllerGetVisitActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfileApi
     */
    public organizationProfileControllerGetVisitActivity(requestParameters: OrganizationProfileApiOrganizationProfileControllerGetVisitActivityRequest, options?: AxiosRequestConfig) {
        return OrganizationProfileApiFp(this.configuration).organizationProfileControllerGetVisitActivity(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get the visit-scoped AI summary (cache + dirty-check regen)
     * @param {OrganizationProfileApiOrganizationProfileControllerGetVisitAiSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfileApi
     */
    public organizationProfileControllerGetVisitAiSummary(requestParameters: OrganizationProfileApiOrganizationProfileControllerGetVisitAiSummaryRequest, options?: AxiosRequestConfig) {
        return OrganizationProfileApiFp(this.configuration).organizationProfileControllerGetVisitAiSummary(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List reminders attached to a visit.
     * @param {OrganizationProfileApiOrganizationProfileControllerListVisitRemindersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfileApi
     */
    public organizationProfileControllerListVisitReminders(requestParameters: OrganizationProfileApiOrganizationProfileControllerListVisitRemindersRequest, options?: AxiosRequestConfig) {
        return OrganizationProfileApiFp(this.configuration).organizationProfileControllerListVisitReminders(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Secure endpoint for professionals to access profiles within their organization
     * @summary Preview profile by id within organization context
     * @param {OrganizationProfileApiOrganizationProfileControllerPreviewProfileInOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfileApi
     */
    public organizationProfileControllerPreviewProfileInOrganization(requestParameters: OrganizationProfileApiOrganizationProfileControllerPreviewProfileInOrganizationRequest, options?: AxiosRequestConfig) {
        return OrganizationProfileApiFp(this.configuration).organizationProfileControllerPreviewProfileInOrganization(requestParameters.profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only allowed when visit is in PENDING state
     * @summary Remove an activity from a visit and cascade delete the associated item
     * @param {OrganizationProfileApiOrganizationProfileControllerRemoveVisitActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfileApi
     */
    public organizationProfileControllerRemoveVisitActivity(requestParameters: OrganizationProfileApiOrganizationProfileControllerRemoveVisitActivityRequest, options?: AxiosRequestConfig) {
        return OrganizationProfileApiFp(this.configuration).organizationProfileControllerRemoveVisitActivity(requestParameters.visitId, requestParameters.activityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete a reminder attached to a visit.
     * @param {OrganizationProfileApiOrganizationProfileControllerRemoveVisitReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfileApi
     */
    public organizationProfileControllerRemoveVisitReminder(requestParameters: OrganizationProfileApiOrganizationProfileControllerRemoveVisitReminderRequest, options?: AxiosRequestConfig) {
        return OrganizationProfileApiFp(this.configuration).organizationProfileControllerRemoveVisitReminder(requestParameters.visitId, requestParameters.reminderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Secure endpoint for professionals to update patient profile information during an active (PENDING) visit. Validates that the visit belongs to the organization and is currently in progress.
     * @summary Update profile during a live visit within organization context
     * @param {OrganizationProfileApiOrganizationProfileControllerUpdateProfileDuringVisitInOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfileApi
     */
    public organizationProfileControllerUpdateProfileDuringVisitInOrganization(requestParameters: OrganizationProfileApiOrganizationProfileControllerUpdateProfileDuringVisitInOrganizationRequest, options?: AxiosRequestConfig) {
        return OrganizationProfileApiFp(this.configuration).organizationProfileControllerUpdateProfileDuringVisitInOrganization(requestParameters.profileId, requestParameters.visitId, requestParameters.updateOrganizationProfileDuringVisitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update a reminder attached to a visit.
     * @param {OrganizationProfileApiOrganizationProfileControllerUpdateVisitReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationProfileApi
     */
    public organizationProfileControllerUpdateVisitReminder(requestParameters: OrganizationProfileApiOrganizationProfileControllerUpdateVisitReminderRequest, options?: AxiosRequestConfig) {
        return OrganizationProfileApiFp(this.configuration).organizationProfileControllerUpdateVisitReminder(requestParameters.visitId, requestParameters.reminderId, requestParameters.updateReminderDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationStatisticsApi - axios parameter creator
 * @export
 */
export const OrganizationStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Deprecated: return fresh statistics without persisting a snapshot
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationStatisticsControllerGenerateStatistics: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationStatisticsControllerGenerateStatistics', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/statistics/generate`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get current organization statistics
         * @param {string} organizationId Organization ID
         * @param {'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_90_DAYS' | 'LAST_365_DAYS' | 'CURRENT_MONTH' | 'LAST_MONTH' | 'ALL_TIME'} [period]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationStatisticsControllerGetStatistics: async (organizationId: string, period?: 'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_90_DAYS' | 'LAST_365_DAYS' | 'CURRENT_MONTH' | 'LAST_MONTH' | 'ALL_TIME', startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationStatisticsControllerGetStatistics', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/statistics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationStatisticsApi - functional programming interface
 * @export
 */
export const OrganizationStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Deprecated: return fresh statistics without persisting a snapshot
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationStatisticsControllerGenerateStatistics(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationStatisticsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationStatisticsControllerGenerateStatistics(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get current organization statistics
         * @param {string} organizationId Organization ID
         * @param {'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_90_DAYS' | 'LAST_365_DAYS' | 'CURRENT_MONTH' | 'LAST_MONTH' | 'ALL_TIME'} [period]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationStatisticsControllerGetStatistics(organizationId: string, period?: 'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_90_DAYS' | 'LAST_365_DAYS' | 'CURRENT_MONTH' | 'LAST_MONTH' | 'ALL_TIME', startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationStatisticsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationStatisticsControllerGetStatistics(organizationId, period, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationStatisticsApi - factory interface
 * @export
 */
export const OrganizationStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationStatisticsApiFp(configuration)
    return {
        /**
         *
         * @summary Deprecated: return fresh statistics without persisting a snapshot
         * @param {OrganizationStatisticsApiOrganizationStatisticsControllerGenerateStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationStatisticsControllerGenerateStatistics(requestParameters: OrganizationStatisticsApiOrganizationStatisticsControllerGenerateStatisticsRequest, options?: AxiosRequestConfig): AxiosPromise<OrganizationStatisticsDto> {
            return localVarFp.organizationStatisticsControllerGenerateStatistics(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get current organization statistics
         * @param {OrganizationStatisticsApiOrganizationStatisticsControllerGetStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationStatisticsControllerGetStatistics(requestParameters: OrganizationStatisticsApiOrganizationStatisticsControllerGetStatisticsRequest, options?: AxiosRequestConfig): AxiosPromise<OrganizationStatisticsDto> {
            return localVarFp.organizationStatisticsControllerGetStatistics(requestParameters.organizationId, requestParameters.period, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for organizationStatisticsControllerGenerateStatistics operation in OrganizationStatisticsApi.
 * @export
 * @interface OrganizationStatisticsApiOrganizationStatisticsControllerGenerateStatisticsRequest
 */
export interface OrganizationStatisticsApiOrganizationStatisticsControllerGenerateStatisticsRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationStatisticsApiOrganizationStatisticsControllerGenerateStatistics
     */
    readonly organizationId: string
}

/**
 * Request parameters for organizationStatisticsControllerGetStatistics operation in OrganizationStatisticsApi.
 * @export
 * @interface OrganizationStatisticsApiOrganizationStatisticsControllerGetStatisticsRequest
 */
export interface OrganizationStatisticsApiOrganizationStatisticsControllerGetStatisticsRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationStatisticsApiOrganizationStatisticsControllerGetStatistics
     */
    readonly organizationId: string

    /**
     *
     * @type {'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_90_DAYS' | 'LAST_365_DAYS' | 'CURRENT_MONTH' | 'LAST_MONTH' | 'ALL_TIME'}
     * @memberof OrganizationStatisticsApiOrganizationStatisticsControllerGetStatistics
     */
    readonly period?: 'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_90_DAYS' | 'LAST_365_DAYS' | 'CURRENT_MONTH' | 'LAST_MONTH' | 'ALL_TIME'

    /**
     *
     * @type {string}
     * @memberof OrganizationStatisticsApiOrganizationStatisticsControllerGetStatistics
     */
    readonly startDate?: string

    /**
     *
     * @type {string}
     * @memberof OrganizationStatisticsApiOrganizationStatisticsControllerGetStatistics
     */
    readonly endDate?: string
}

/**
 * OrganizationStatisticsApi - object-oriented interface
 * @export
 * @class OrganizationStatisticsApi
 * @extends {BaseAPI}
 */
export class OrganizationStatisticsApi extends BaseAPI {
    /**
     *
     * @summary Deprecated: return fresh statistics without persisting a snapshot
     * @param {OrganizationStatisticsApiOrganizationStatisticsControllerGenerateStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStatisticsApi
     */
    public organizationStatisticsControllerGenerateStatistics(requestParameters: OrganizationStatisticsApiOrganizationStatisticsControllerGenerateStatisticsRequest, options?: AxiosRequestConfig) {
        return OrganizationStatisticsApiFp(this.configuration).organizationStatisticsControllerGenerateStatistics(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get current organization statistics
     * @param {OrganizationStatisticsApiOrganizationStatisticsControllerGetStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStatisticsApi
     */
    public organizationStatisticsControllerGetStatistics(requestParameters: OrganizationStatisticsApiOrganizationStatisticsControllerGetStatisticsRequest, options?: AxiosRequestConfig) {
        return OrganizationStatisticsApiFp(this.configuration).organizationStatisticsControllerGetStatistics(requestParameters.organizationId, requestParameters.period, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationStatisticsCronApi - axios parameter creator
 * @export
 */
export const OrganizationStatisticsCronApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Retired statistics scheduler acknowledgement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationStatisticsCronControllerGenerateAllStatistics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization-statistics/cron`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationStatisticsCronApi - functional programming interface
 * @export
 */
export const OrganizationStatisticsCronApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationStatisticsCronApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Retired statistics scheduler acknowledgement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationStatisticsCronControllerGenerateAllStatistics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationStatisticsCronControllerGenerateAllStatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationStatisticsCronApi - factory interface
 * @export
 */
export const OrganizationStatisticsCronApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationStatisticsCronApiFp(configuration)
    return {
        /**
         *
         * @summary Retired statistics scheduler acknowledgement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationStatisticsCronControllerGenerateAllStatistics(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.organizationStatisticsCronControllerGenerateAllStatistics(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationStatisticsCronApi - object-oriented interface
 * @export
 * @class OrganizationStatisticsCronApi
 * @extends {BaseAPI}
 */
export class OrganizationStatisticsCronApi extends BaseAPI {
    /**
     *
     * @summary Retired statistics scheduler acknowledgement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStatisticsCronApi
     */
    public organizationStatisticsCronControllerGenerateAllStatistics(options?: AxiosRequestConfig) {
        return OrganizationStatisticsCronApiFp(this.configuration).organizationStatisticsCronControllerGenerateAllStatistics(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OutreachApi - axios parameter creator
 * @export
 */
export const OutreachApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachCampaignActionDto} outreachCampaignActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachCancelCampaign: async (id: string, outreachCampaignActionDto: OutreachCampaignActionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('outreachCancelCampaign', 'id', id)
            // verify required parameter 'outreachCampaignActionDto' is not null or undefined
            assertParamExists('outreachCancelCampaign', 'outreachCampaignActionDto', outreachCampaignActionDto)
            const localVarPath = `/api/outreach/campaigns/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outreachCampaignActionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {OutreachOauthCompleteDto} outreachOauthCompleteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachCompleteGoogle: async (outreachOauthCompleteDto: OutreachOauthCompleteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outreachOauthCompleteDto' is not null or undefined
            assertParamExists('outreachCompleteGoogle', 'outreachOauthCompleteDto', outreachOauthCompleteDto)
            const localVarPath = `/api/outreach/mailboxes/google/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outreachOauthCompleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {OutreachCampaignCreateDto} outreachCampaignCreateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachCreateCampaign: async (outreachCampaignCreateDto: OutreachCampaignCreateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outreachCampaignCreateDto' is not null or undefined
            assertParamExists('outreachCreateCampaign', 'outreachCampaignCreateDto', outreachCampaignCreateDto)
            const localVarPath = `/api/outreach/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outreachCampaignCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachDisconnectMailbox: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('outreachDisconnectMailbox', 'id', id)
            const localVarPath = `/api/outreach/mailboxes/{id}/disconnect`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachGetCampaign: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('outreachGetCampaign', 'id', id)
            const localVarPath = `/api/outreach/campaigns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachGetContact: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('outreachGetContact', 'id', id)
            const localVarPath = `/api/outreach/contacts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachGetConversation: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('outreachGetConversation', 'id', id)
            const localVarPath = `/api/outreach/messages/{id}/conversation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {OutreachContactImportDto} outreachContactImportDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachImportContacts: async (outreachContactImportDto: OutreachContactImportDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outreachContactImportDto' is not null or undefined
            assertParamExists('outreachImportContacts', 'outreachContactImportDto', outreachContactImportDto)
            const localVarPath = `/api/outreach/contacts/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outreachContactImportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [search]
         * @param {string} [state]
         * @param {string} [campaignId]
         * @param {string} [contactId]
         * @param {string} [mailboxId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachListCampaigns: async (page?: number, limit?: number, search?: string, state?: string, campaignId?: string, contactId?: string, mailboxId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/outreach/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }

            if (contactId !== undefined) {
                localVarQueryParameter['contactId'] = contactId;
            }

            if (mailboxId !== undefined) {
                localVarQueryParameter['mailboxId'] = mailboxId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [search]
         * @param {string} [state]
         * @param {string} [campaignId]
         * @param {string} [contactId]
         * @param {string} [mailboxId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachListContacts: async (page?: number, limit?: number, search?: string, state?: string, campaignId?: string, contactId?: string, mailboxId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/outreach/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }

            if (contactId !== undefined) {
                localVarQueryParameter['contactId'] = contactId;
            }

            if (mailboxId !== undefined) {
                localVarQueryParameter['mailboxId'] = mailboxId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachListMailboxes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/outreach/mailboxes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [search]
         * @param {string} [state]
         * @param {string} [campaignId]
         * @param {string} [contactId]
         * @param {string} [mailboxId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachListMessages: async (page?: number, limit?: number, search?: string, state?: string, campaignId?: string, contactId?: string, mailboxId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/outreach/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }

            if (contactId !== undefined) {
                localVarQueryParameter['contactId'] = contactId;
            }

            if (mailboxId !== undefined) {
                localVarQueryParameter['mailboxId'] = mailboxId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachCampaignActionDto} outreachCampaignActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachPauseCampaign: async (id: string, outreachCampaignActionDto: OutreachCampaignActionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('outreachPauseCampaign', 'id', id)
            // verify required parameter 'outreachCampaignActionDto' is not null or undefined
            assertParamExists('outreachPauseCampaign', 'outreachCampaignActionDto', outreachCampaignActionDto)
            const localVarPath = `/api/outreach/campaigns/{id}/pause`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outreachCampaignActionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachReplyDto} outreachReplyDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachReply: async (id: string, outreachReplyDto: OutreachReplyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('outreachReply', 'id', id)
            // verify required parameter 'outreachReplyDto' is not null or undefined
            assertParamExists('outreachReply', 'outreachReplyDto', outreachReplyDto)
            const localVarPath = `/api/outreach/messages/{id}/reply`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outreachReplyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachUncertainResolutionDto} outreachUncertainResolutionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachResolveMessage: async (id: string, outreachUncertainResolutionDto: OutreachUncertainResolutionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('outreachResolveMessage', 'id', id)
            // verify required parameter 'outreachUncertainResolutionDto' is not null or undefined
            assertParamExists('outreachResolveMessage', 'outreachUncertainResolutionDto', outreachUncertainResolutionDto)
            const localVarPath = `/api/outreach/messages/{id}/resolve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outreachUncertainResolutionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachCampaignActionDto} outreachCampaignActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachResumeCampaign: async (id: string, outreachCampaignActionDto: OutreachCampaignActionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('outreachResumeCampaign', 'id', id)
            // verify required parameter 'outreachCampaignActionDto' is not null or undefined
            assertParamExists('outreachResumeCampaign', 'outreachCampaignActionDto', outreachCampaignActionDto)
            const localVarPath = `/api/outreach/campaigns/{id}/resume`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outreachCampaignActionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachContactRestrictionDto} outreachContactRestrictionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachSetRestriction: async (id: string, outreachContactRestrictionDto: OutreachContactRestrictionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('outreachSetRestriction', 'id', id)
            // verify required parameter 'outreachContactRestrictionDto' is not null or undefined
            assertParamExists('outreachSetRestriction', 'outreachContactRestrictionDto', outreachContactRestrictionDto)
            const localVarPath = `/api/outreach/contacts/{id}/restriction`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outreachContactRestrictionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachCampaignActionDto} outreachCampaignActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachStartCampaign: async (id: string, outreachCampaignActionDto: OutreachCampaignActionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('outreachStartCampaign', 'id', id)
            // verify required parameter 'outreachCampaignActionDto' is not null or undefined
            assertParamExists('outreachStartCampaign', 'outreachCampaignActionDto', outreachCampaignActionDto)
            const localVarPath = `/api/outreach/campaigns/{id}/start`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outreachCampaignActionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachStartGoogle: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/outreach/mailboxes/google/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachSyncMailbox: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('outreachSyncMailbox', 'id', id)
            const localVarPath = `/api/outreach/mailboxes/{id}/sync`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachCampaignUpdateDto} outreachCampaignUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachUpdateCampaign: async (id: string, outreachCampaignUpdateDto: OutreachCampaignUpdateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('outreachUpdateCampaign', 'id', id)
            // verify required parameter 'outreachCampaignUpdateDto' is not null or undefined
            assertParamExists('outreachUpdateCampaign', 'outreachCampaignUpdateDto', outreachCampaignUpdateDto)
            const localVarPath = `/api/outreach/campaigns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outreachCampaignUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachContactUpdateDto} outreachContactUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachUpdateContact: async (id: string, outreachContactUpdateDto: OutreachContactUpdateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('outreachUpdateContact', 'id', id)
            // verify required parameter 'outreachContactUpdateDto' is not null or undefined
            assertParamExists('outreachUpdateContact', 'outreachContactUpdateDto', outreachContactUpdateDto)
            const localVarPath = `/api/outreach/contacts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outreachContactUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OutreachApi - functional programming interface
 * @export
 */
export const OutreachApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OutreachApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachCampaignActionDto} outreachCampaignActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachCancelCampaign(id: string, outreachCampaignActionDto: OutreachCampaignActionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachCancelCampaign(id, outreachCampaignActionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {OutreachOauthCompleteDto} outreachOauthCompleteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachCompleteGoogle(outreachOauthCompleteDto: OutreachOauthCompleteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachMailboxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachCompleteGoogle(outreachOauthCompleteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {OutreachCampaignCreateDto} outreachCampaignCreateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachCreateCampaign(outreachCampaignCreateDto: OutreachCampaignCreateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachCreateCampaign(outreachCampaignCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachDisconnectMailbox(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachMailboxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachDisconnectMailbox(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachGetCampaign(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachGetCampaign(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachGetContact(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachContactDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachGetContact(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachGetConversation(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachConversationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachGetConversation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {OutreachContactImportDto} outreachContactImportDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachImportContacts(outreachContactImportDto: OutreachContactImportDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachContactImportResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachImportContacts(outreachContactImportDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [search]
         * @param {string} [state]
         * @param {string} [campaignId]
         * @param {string} [contactId]
         * @param {string} [mailboxId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachListCampaigns(page?: number, limit?: number, search?: string, state?: string, campaignId?: string, contactId?: string, mailboxId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachCampaignPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachListCampaigns(page, limit, search, state, campaignId, contactId, mailboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [search]
         * @param {string} [state]
         * @param {string} [campaignId]
         * @param {string} [contactId]
         * @param {string} [mailboxId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachListContacts(page?: number, limit?: number, search?: string, state?: string, campaignId?: string, contactId?: string, mailboxId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachContactPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachListContacts(page, limit, search, state, campaignId, contactId, mailboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachListMailboxes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OutreachMailboxDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachListMailboxes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [search]
         * @param {string} [state]
         * @param {string} [campaignId]
         * @param {string} [contactId]
         * @param {string} [mailboxId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachListMessages(page?: number, limit?: number, search?: string, state?: string, campaignId?: string, contactId?: string, mailboxId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachMessagePageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachListMessages(page, limit, search, state, campaignId, contactId, mailboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachCampaignActionDto} outreachCampaignActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachPauseCampaign(id: string, outreachCampaignActionDto: OutreachCampaignActionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachPauseCampaign(id, outreachCampaignActionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachReplyDto} outreachReplyDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachReply(id: string, outreachReplyDto: OutreachReplyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachReply(id, outreachReplyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachUncertainResolutionDto} outreachUncertainResolutionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachResolveMessage(id: string, outreachUncertainResolutionDto: OutreachUncertainResolutionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachResolveMessage(id, outreachUncertainResolutionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachCampaignActionDto} outreachCampaignActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachResumeCampaign(id: string, outreachCampaignActionDto: OutreachCampaignActionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachResumeCampaign(id, outreachCampaignActionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachContactRestrictionDto} outreachContactRestrictionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachSetRestriction(id: string, outreachContactRestrictionDto: OutreachContactRestrictionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachContactDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachSetRestriction(id, outreachContactRestrictionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachCampaignActionDto} outreachCampaignActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachStartCampaign(id: string, outreachCampaignActionDto: OutreachCampaignActionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachStartCampaign(id, outreachCampaignActionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachStartGoogle(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachOauthStartDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachStartGoogle(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachSyncMailbox(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachMailboxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachSyncMailbox(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachCampaignUpdateDto} outreachCampaignUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachUpdateCampaign(id: string, outreachCampaignUpdateDto: OutreachCampaignUpdateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachUpdateCampaign(id, outreachCampaignUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary
         * @param {string} id
         * @param {OutreachContactUpdateDto} outreachContactUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachUpdateContact(id: string, outreachContactUpdateDto: OutreachContactUpdateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutreachContactDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachUpdateContact(id, outreachContactUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OutreachApi - factory interface
 * @export
 */
export const OutreachApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OutreachApiFp(configuration)
    return {
        /**
         *
         * @summary
         * @param {OutreachApiOutreachCancelCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachCancelCampaign(requestParameters: OutreachApiOutreachCancelCampaignRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachCampaignDto> {
            return localVarFp.outreachCancelCampaign(requestParameters.id, requestParameters.outreachCampaignActionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachCompleteGoogleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachCompleteGoogle(requestParameters: OutreachApiOutreachCompleteGoogleRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachMailboxDto> {
            return localVarFp.outreachCompleteGoogle(requestParameters.outreachOauthCompleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachCreateCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachCreateCampaign(requestParameters: OutreachApiOutreachCreateCampaignRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachCampaignDto> {
            return localVarFp.outreachCreateCampaign(requestParameters.outreachCampaignCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachDisconnectMailboxRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachDisconnectMailbox(requestParameters: OutreachApiOutreachDisconnectMailboxRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachMailboxDto> {
            return localVarFp.outreachDisconnectMailbox(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachGetCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachGetCampaign(requestParameters: OutreachApiOutreachGetCampaignRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachCampaignDto> {
            return localVarFp.outreachGetCampaign(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachGetContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachGetContact(requestParameters: OutreachApiOutreachGetContactRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachContactDto> {
            return localVarFp.outreachGetContact(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachGetConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachGetConversation(requestParameters: OutreachApiOutreachGetConversationRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachConversationDto> {
            return localVarFp.outreachGetConversation(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachImportContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachImportContacts(requestParameters: OutreachApiOutreachImportContactsRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachContactImportResultDto> {
            return localVarFp.outreachImportContacts(requestParameters.outreachContactImportDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachListCampaignsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachListCampaigns(requestParameters: OutreachApiOutreachListCampaignsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<OutreachCampaignPageDto> {
            return localVarFp.outreachListCampaigns(requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.state, requestParameters.campaignId, requestParameters.contactId, requestParameters.mailboxId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachListContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachListContacts(requestParameters: OutreachApiOutreachListContactsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<OutreachContactPageDto> {
            return localVarFp.outreachListContacts(requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.state, requestParameters.campaignId, requestParameters.contactId, requestParameters.mailboxId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachListMailboxes(options?: AxiosRequestConfig): AxiosPromise<Array<OutreachMailboxDto>> {
            return localVarFp.outreachListMailboxes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachListMessagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachListMessages(requestParameters: OutreachApiOutreachListMessagesRequest = {}, options?: AxiosRequestConfig): AxiosPromise<OutreachMessagePageDto> {
            return localVarFp.outreachListMessages(requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.state, requestParameters.campaignId, requestParameters.contactId, requestParameters.mailboxId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachPauseCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachPauseCampaign(requestParameters: OutreachApiOutreachPauseCampaignRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachCampaignDto> {
            return localVarFp.outreachPauseCampaign(requestParameters.id, requestParameters.outreachCampaignActionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachReplyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachReply(requestParameters: OutreachApiOutreachReplyRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachMessageDto> {
            return localVarFp.outreachReply(requestParameters.id, requestParameters.outreachReplyDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachResolveMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachResolveMessage(requestParameters: OutreachApiOutreachResolveMessageRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachMessageDto> {
            return localVarFp.outreachResolveMessage(requestParameters.id, requestParameters.outreachUncertainResolutionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachResumeCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachResumeCampaign(requestParameters: OutreachApiOutreachResumeCampaignRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachCampaignDto> {
            return localVarFp.outreachResumeCampaign(requestParameters.id, requestParameters.outreachCampaignActionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachSetRestrictionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachSetRestriction(requestParameters: OutreachApiOutreachSetRestrictionRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachContactDto> {
            return localVarFp.outreachSetRestriction(requestParameters.id, requestParameters.outreachContactRestrictionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachStartCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachStartCampaign(requestParameters: OutreachApiOutreachStartCampaignRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachCampaignDto> {
            return localVarFp.outreachStartCampaign(requestParameters.id, requestParameters.outreachCampaignActionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachStartGoogle(options?: AxiosRequestConfig): AxiosPromise<OutreachOauthStartDto> {
            return localVarFp.outreachStartGoogle(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachSyncMailboxRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachSyncMailbox(requestParameters: OutreachApiOutreachSyncMailboxRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachMailboxDto> {
            return localVarFp.outreachSyncMailbox(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachUpdateCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachUpdateCampaign(requestParameters: OutreachApiOutreachUpdateCampaignRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachCampaignDto> {
            return localVarFp.outreachUpdateCampaign(requestParameters.id, requestParameters.outreachCampaignUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {OutreachApiOutreachUpdateContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachUpdateContact(requestParameters: OutreachApiOutreachUpdateContactRequest, options?: AxiosRequestConfig): AxiosPromise<OutreachContactDto> {
            return localVarFp.outreachUpdateContact(requestParameters.id, requestParameters.outreachContactUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for outreachCancelCampaign operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachCancelCampaignRequest
 */
export interface OutreachApiOutreachCancelCampaignRequest {
    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachCancelCampaign
     */
    readonly id: string

    /**
     *
     * @type {OutreachCampaignActionDto}
     * @memberof OutreachApiOutreachCancelCampaign
     */
    readonly outreachCampaignActionDto: OutreachCampaignActionDto
}

/**
 * Request parameters for outreachCompleteGoogle operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachCompleteGoogleRequest
 */
export interface OutreachApiOutreachCompleteGoogleRequest {
    /**
     *
     * @type {OutreachOauthCompleteDto}
     * @memberof OutreachApiOutreachCompleteGoogle
     */
    readonly outreachOauthCompleteDto: OutreachOauthCompleteDto
}

/**
 * Request parameters for outreachCreateCampaign operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachCreateCampaignRequest
 */
export interface OutreachApiOutreachCreateCampaignRequest {
    /**
     *
     * @type {OutreachCampaignCreateDto}
     * @memberof OutreachApiOutreachCreateCampaign
     */
    readonly outreachCampaignCreateDto: OutreachCampaignCreateDto
}

/**
 * Request parameters for outreachDisconnectMailbox operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachDisconnectMailboxRequest
 */
export interface OutreachApiOutreachDisconnectMailboxRequest {
    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachDisconnectMailbox
     */
    readonly id: string
}

/**
 * Request parameters for outreachGetCampaign operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachGetCampaignRequest
 */
export interface OutreachApiOutreachGetCampaignRequest {
    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachGetCampaign
     */
    readonly id: string
}

/**
 * Request parameters for outreachGetContact operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachGetContactRequest
 */
export interface OutreachApiOutreachGetContactRequest {
    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachGetContact
     */
    readonly id: string
}

/**
 * Request parameters for outreachGetConversation operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachGetConversationRequest
 */
export interface OutreachApiOutreachGetConversationRequest {
    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachGetConversation
     */
    readonly id: string
}

/**
 * Request parameters for outreachImportContacts operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachImportContactsRequest
 */
export interface OutreachApiOutreachImportContactsRequest {
    /**
     *
     * @type {OutreachContactImportDto}
     * @memberof OutreachApiOutreachImportContacts
     */
    readonly outreachContactImportDto: OutreachContactImportDto
}

/**
 * Request parameters for outreachListCampaigns operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachListCampaignsRequest
 */
export interface OutreachApiOutreachListCampaignsRequest {
    /**
     *
     * @type {number}
     * @memberof OutreachApiOutreachListCampaigns
     */
    readonly page?: number

    /**
     *
     * @type {number}
     * @memberof OutreachApiOutreachListCampaigns
     */
    readonly limit?: number

    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachListCampaigns
     */
    readonly search?: string

    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachListCampaigns
     */
    readonly state?: string

    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachListCampaigns
     */
    readonly campaignId?: string

    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachListCampaigns
     */
    readonly contactId?: string

    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachListCampaigns
     */
    readonly mailboxId?: string
}

/**
 * Request parameters for outreachListContacts operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachListContactsRequest
 */
export interface OutreachApiOutreachListContactsRequest {
    /**
     *
     * @type {number}
     * @memberof OutreachApiOutreachListContacts
     */
    readonly page?: number

    /**
     *
     * @type {number}
     * @memberof OutreachApiOutreachListContacts
     */
    readonly limit?: number

    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachListContacts
     */
    readonly search?: string

    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachListContacts
     */
    readonly state?: string

    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachListContacts
     */
    readonly campaignId?: string

    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachListContacts
     */
    readonly contactId?: string

    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachListContacts
     */
    readonly mailboxId?: string
}

/**
 * Request parameters for outreachListMessages operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachListMessagesRequest
 */
export interface OutreachApiOutreachListMessagesRequest {
    /**
     *
     * @type {number}
     * @memberof OutreachApiOutreachListMessages
     */
    readonly page?: number

    /**
     *
     * @type {number}
     * @memberof OutreachApiOutreachListMessages
     */
    readonly limit?: number

    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachListMessages
     */
    readonly search?: string

    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachListMessages
     */
    readonly state?: string

    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachListMessages
     */
    readonly campaignId?: string

    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachListMessages
     */
    readonly contactId?: string

    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachListMessages
     */
    readonly mailboxId?: string
}

/**
 * Request parameters for outreachPauseCampaign operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachPauseCampaignRequest
 */
export interface OutreachApiOutreachPauseCampaignRequest {
    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachPauseCampaign
     */
    readonly id: string

    /**
     *
     * @type {OutreachCampaignActionDto}
     * @memberof OutreachApiOutreachPauseCampaign
     */
    readonly outreachCampaignActionDto: OutreachCampaignActionDto
}

/**
 * Request parameters for outreachReply operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachReplyRequest
 */
export interface OutreachApiOutreachReplyRequest {
    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachReply
     */
    readonly id: string

    /**
     *
     * @type {OutreachReplyDto}
     * @memberof OutreachApiOutreachReply
     */
    readonly outreachReplyDto: OutreachReplyDto
}

/**
 * Request parameters for outreachResolveMessage operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachResolveMessageRequest
 */
export interface OutreachApiOutreachResolveMessageRequest {
    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachResolveMessage
     */
    readonly id: string

    /**
     *
     * @type {OutreachUncertainResolutionDto}
     * @memberof OutreachApiOutreachResolveMessage
     */
    readonly outreachUncertainResolutionDto: OutreachUncertainResolutionDto
}

/**
 * Request parameters for outreachResumeCampaign operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachResumeCampaignRequest
 */
export interface OutreachApiOutreachResumeCampaignRequest {
    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachResumeCampaign
     */
    readonly id: string

    /**
     *
     * @type {OutreachCampaignActionDto}
     * @memberof OutreachApiOutreachResumeCampaign
     */
    readonly outreachCampaignActionDto: OutreachCampaignActionDto
}

/**
 * Request parameters for outreachSetRestriction operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachSetRestrictionRequest
 */
export interface OutreachApiOutreachSetRestrictionRequest {
    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachSetRestriction
     */
    readonly id: string

    /**
     *
     * @type {OutreachContactRestrictionDto}
     * @memberof OutreachApiOutreachSetRestriction
     */
    readonly outreachContactRestrictionDto: OutreachContactRestrictionDto
}

/**
 * Request parameters for outreachStartCampaign operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachStartCampaignRequest
 */
export interface OutreachApiOutreachStartCampaignRequest {
    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachStartCampaign
     */
    readonly id: string

    /**
     *
     * @type {OutreachCampaignActionDto}
     * @memberof OutreachApiOutreachStartCampaign
     */
    readonly outreachCampaignActionDto: OutreachCampaignActionDto
}

/**
 * Request parameters for outreachSyncMailbox operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachSyncMailboxRequest
 */
export interface OutreachApiOutreachSyncMailboxRequest {
    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachSyncMailbox
     */
    readonly id: string
}

/**
 * Request parameters for outreachUpdateCampaign operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachUpdateCampaignRequest
 */
export interface OutreachApiOutreachUpdateCampaignRequest {
    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachUpdateCampaign
     */
    readonly id: string

    /**
     *
     * @type {OutreachCampaignUpdateDto}
     * @memberof OutreachApiOutreachUpdateCampaign
     */
    readonly outreachCampaignUpdateDto: OutreachCampaignUpdateDto
}

/**
 * Request parameters for outreachUpdateContact operation in OutreachApi.
 * @export
 * @interface OutreachApiOutreachUpdateContactRequest
 */
export interface OutreachApiOutreachUpdateContactRequest {
    /**
     *
     * @type {string}
     * @memberof OutreachApiOutreachUpdateContact
     */
    readonly id: string

    /**
     *
     * @type {OutreachContactUpdateDto}
     * @memberof OutreachApiOutreachUpdateContact
     */
    readonly outreachContactUpdateDto: OutreachContactUpdateDto
}

/**
 * OutreachApi - object-oriented interface
 * @export
 * @class OutreachApi
 * @extends {BaseAPI}
 */
export class OutreachApi extends BaseAPI {
    /**
     *
     * @summary
     * @param {OutreachApiOutreachCancelCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachCancelCampaign(requestParameters: OutreachApiOutreachCancelCampaignRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachCancelCampaign(requestParameters.id, requestParameters.outreachCampaignActionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachCompleteGoogleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachCompleteGoogle(requestParameters: OutreachApiOutreachCompleteGoogleRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachCompleteGoogle(requestParameters.outreachOauthCompleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachCreateCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachCreateCampaign(requestParameters: OutreachApiOutreachCreateCampaignRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachCreateCampaign(requestParameters.outreachCampaignCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachDisconnectMailboxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachDisconnectMailbox(requestParameters: OutreachApiOutreachDisconnectMailboxRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachDisconnectMailbox(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachGetCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachGetCampaign(requestParameters: OutreachApiOutreachGetCampaignRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachGetCampaign(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachGetContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachGetContact(requestParameters: OutreachApiOutreachGetContactRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachGetContact(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachGetConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachGetConversation(requestParameters: OutreachApiOutreachGetConversationRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachGetConversation(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachImportContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachImportContacts(requestParameters: OutreachApiOutreachImportContactsRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachImportContacts(requestParameters.outreachContactImportDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachListCampaignsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachListCampaigns(requestParameters: OutreachApiOutreachListCampaignsRequest = {}, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachListCampaigns(requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.state, requestParameters.campaignId, requestParameters.contactId, requestParameters.mailboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachListContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachListContacts(requestParameters: OutreachApiOutreachListContactsRequest = {}, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachListContacts(requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.state, requestParameters.campaignId, requestParameters.contactId, requestParameters.mailboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachListMailboxes(options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachListMailboxes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachListMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachListMessages(requestParameters: OutreachApiOutreachListMessagesRequest = {}, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachListMessages(requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.state, requestParameters.campaignId, requestParameters.contactId, requestParameters.mailboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachPauseCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachPauseCampaign(requestParameters: OutreachApiOutreachPauseCampaignRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachPauseCampaign(requestParameters.id, requestParameters.outreachCampaignActionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachReplyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachReply(requestParameters: OutreachApiOutreachReplyRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachReply(requestParameters.id, requestParameters.outreachReplyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachResolveMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachResolveMessage(requestParameters: OutreachApiOutreachResolveMessageRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachResolveMessage(requestParameters.id, requestParameters.outreachUncertainResolutionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachResumeCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachResumeCampaign(requestParameters: OutreachApiOutreachResumeCampaignRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachResumeCampaign(requestParameters.id, requestParameters.outreachCampaignActionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachSetRestrictionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachSetRestriction(requestParameters: OutreachApiOutreachSetRestrictionRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachSetRestriction(requestParameters.id, requestParameters.outreachContactRestrictionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachStartCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachStartCampaign(requestParameters: OutreachApiOutreachStartCampaignRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachStartCampaign(requestParameters.id, requestParameters.outreachCampaignActionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachStartGoogle(options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachStartGoogle(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachSyncMailboxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachSyncMailbox(requestParameters: OutreachApiOutreachSyncMailboxRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachSyncMailbox(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachUpdateCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachUpdateCampaign(requestParameters: OutreachApiOutreachUpdateCampaignRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachUpdateCampaign(requestParameters.id, requestParameters.outreachCampaignUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary
     * @param {OutreachApiOutreachUpdateContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutreachApi
     */
    public outreachUpdateContact(requestParameters: OutreachApiOutreachUpdateContactRequest, options?: AxiosRequestConfig) {
        return OutreachApiFp(this.configuration).outreachUpdateContact(requestParameters.id, requestParameters.outreachContactUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PaymentCronApi - axios parameter creator
 * @export
 */
export const PaymentCronApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Run Payment Cron Job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCronControllerRun: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payment/cron`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentCronApi - functional programming interface
 * @export
 */
export const PaymentCronApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentCronApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Run Payment Cron Job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentCronControllerRun(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentCronControllerRun(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PaymentCronApi - factory interface
 * @export
 */
export const PaymentCronApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentCronApiFp(configuration)
    return {
        /**
         *
         * @summary Run Payment Cron Job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCronControllerRun(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.paymentCronControllerRun(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentCronApi - object-oriented interface
 * @export
 * @class PaymentCronApi
 * @extends {BaseAPI}
 */
export class PaymentCronApi extends BaseAPI {
    /**
     *
     * @summary Run Payment Cron Job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentCronApi
     */
    public paymentCronControllerRun(options?: AxiosRequestConfig) {
        return PaymentCronApiFp(this.configuration).paymentCronControllerRun(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PetCategoryApi - axios parameter creator
 * @export
 */
export const PetCategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get cat breeds list
         * @param {string} [search] Search query term
         * @param {number} [limit] Limit number of returned items
         * @param {number} [offset] Offset number of items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        petBreedControllerGetCats: async (search?: string, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pet-breeds/cats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get dog breeds list
         * @param {string} [search] Search query term
         * @param {number} [limit] Limit number of returned items
         * @param {number} [offset] Offset number of items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        petBreedControllerGetDogs: async (search?: string, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pet-breeds/dogs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PetCategoryApi - functional programming interface
 * @export
 */
export const PetCategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PetCategoryApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get cat breeds list
         * @param {string} [search] Search query term
         * @param {number} [limit] Limit number of returned items
         * @param {number} [offset] Offset number of items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async petBreedControllerGetCats(search?: string, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PetBreedDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.petBreedControllerGetCats(search, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get dog breeds list
         * @param {string} [search] Search query term
         * @param {number} [limit] Limit number of returned items
         * @param {number} [offset] Offset number of items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async petBreedControllerGetDogs(search?: string, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PetBreedDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.petBreedControllerGetDogs(search, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PetCategoryApi - factory interface
 * @export
 */
export const PetCategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PetCategoryApiFp(configuration)
    return {
        /**
         *
         * @summary Get cat breeds list
         * @param {PetCategoryApiPetBreedControllerGetCatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        petBreedControllerGetCats(requestParameters: PetCategoryApiPetBreedControllerGetCatsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<PetBreedDto>> {
            return localVarFp.petBreedControllerGetCats(requestParameters.search, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get dog breeds list
         * @param {PetCategoryApiPetBreedControllerGetDogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        petBreedControllerGetDogs(requestParameters: PetCategoryApiPetBreedControllerGetDogsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<PetBreedDto>> {
            return localVarFp.petBreedControllerGetDogs(requestParameters.search, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for petBreedControllerGetCats operation in PetCategoryApi.
 * @export
 * @interface PetCategoryApiPetBreedControllerGetCatsRequest
 */
export interface PetCategoryApiPetBreedControllerGetCatsRequest {
    /**
     * Search query term
     * @type {string}
     * @memberof PetCategoryApiPetBreedControllerGetCats
     */
    readonly search?: string

    /**
     * Limit number of returned items
     * @type {number}
     * @memberof PetCategoryApiPetBreedControllerGetCats
     */
    readonly limit?: number

    /**
     * Offset number of items
     * @type {number}
     * @memberof PetCategoryApiPetBreedControllerGetCats
     */
    readonly offset?: number
}

/**
 * Request parameters for petBreedControllerGetDogs operation in PetCategoryApi.
 * @export
 * @interface PetCategoryApiPetBreedControllerGetDogsRequest
 */
export interface PetCategoryApiPetBreedControllerGetDogsRequest {
    /**
     * Search query term
     * @type {string}
     * @memberof PetCategoryApiPetBreedControllerGetDogs
     */
    readonly search?: string

    /**
     * Limit number of returned items
     * @type {number}
     * @memberof PetCategoryApiPetBreedControllerGetDogs
     */
    readonly limit?: number

    /**
     * Offset number of items
     * @type {number}
     * @memberof PetCategoryApiPetBreedControllerGetDogs
     */
    readonly offset?: number
}

/**
 * PetCategoryApi - object-oriented interface
 * @export
 * @class PetCategoryApi
 * @extends {BaseAPI}
 */
export class PetCategoryApi extends BaseAPI {
    /**
     *
     * @summary Get cat breeds list
     * @param {PetCategoryApiPetBreedControllerGetCatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PetCategoryApi
     */
    public petBreedControllerGetCats(requestParameters: PetCategoryApiPetBreedControllerGetCatsRequest = {}, options?: AxiosRequestConfig) {
        return PetCategoryApiFp(this.configuration).petBreedControllerGetCats(requestParameters.search, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get dog breeds list
     * @param {PetCategoryApiPetBreedControllerGetDogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PetCategoryApi
     */
    public petBreedControllerGetDogs(requestParameters: PetCategoryApiPetBreedControllerGetDogsRequest = {}, options?: AxiosRequestConfig) {
        return PetCategoryApiFp(this.configuration).petBreedControllerGetDogs(requestParameters.search, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PetsyApi - axios parameter creator
 * @export
 */
export const PetsyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary [Petsy] Request new visit
         * @param {string} xApiKey api key
         * @param {RequestVisitDto} requestVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        petsyControllerRequestNewVisit: async (xApiKey: string, requestVisitDto: RequestVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xApiKey' is not null or undefined
            assertParamExists('petsyControllerRequestNewVisit', 'xApiKey', xApiKey)
            // verify required parameter 'requestVisitDto' is not null or undefined
            assertParamExists('petsyControllerRequestNewVisit', 'requestVisitDto', requestVisitDto)
            const localVarPath = `/petsy/request-new-visit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xApiKey != null) {
                localVarHeaderParameter['x-api-key'] = String(xApiKey);
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PetsyApi - functional programming interface
 * @export
 */
export const PetsyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PetsyApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary [Petsy] Request new visit
         * @param {string} xApiKey api key
         * @param {RequestVisitDto} requestVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async petsyControllerRequestNewVisit(xApiKey: string, requestVisitDto: RequestVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.petsyControllerRequestNewVisit(xApiKey, requestVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PetsyApi - factory interface
 * @export
 */
export const PetsyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PetsyApiFp(configuration)
    return {
        /**
         *
         * @summary [Petsy] Request new visit
         * @param {PetsyApiPetsyControllerRequestNewVisitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        petsyControllerRequestNewVisit(requestParameters: PetsyApiPetsyControllerRequestNewVisitRequest, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.petsyControllerRequestNewVisit(requestParameters.xApiKey, requestParameters.requestVisitDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for petsyControllerRequestNewVisit operation in PetsyApi.
 * @export
 * @interface PetsyApiPetsyControllerRequestNewVisitRequest
 */
export interface PetsyApiPetsyControllerRequestNewVisitRequest {
    /**
     * api key
     * @type {string}
     * @memberof PetsyApiPetsyControllerRequestNewVisit
     */
    readonly xApiKey: string

    /**
     *
     * @type {RequestVisitDto}
     * @memberof PetsyApiPetsyControllerRequestNewVisit
     */
    readonly requestVisitDto: RequestVisitDto
}

/**
 * PetsyApi - object-oriented interface
 * @export
 * @class PetsyApi
 * @extends {BaseAPI}
 */
export class PetsyApi extends BaseAPI {
    /**
     *
     * @summary [Petsy] Request new visit
     * @param {PetsyApiPetsyControllerRequestNewVisitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PetsyApi
     */
    public petsyControllerRequestNewVisit(requestParameters: PetsyApiPetsyControllerRequestNewVisitRequest, options?: AxiosRequestConfig) {
        return PetsyApiFp(this.configuration).petsyControllerRequestNewVisit(requestParameters.xApiKey, requestParameters.requestVisitDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PilotaRecepcjiGosowejApi - axios parameter creator
 * @export
 */
export const PilotaRecepcjiGosowejApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Oceń zapisany, zapieczętowany dowód pilotażu
         * @param {string} pilotReference
         * @param {AssessRecordedVoicePilotEvidenceDto} assessRecordedVoicePilotEvidenceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerAssessRecordedEvidence: async (pilotReference: string, assessRecordedVoicePilotEvidenceDto: AssessRecordedVoicePilotEvidenceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pilotReference' is not null or undefined
            assertParamExists('voicePilotPhase7ControllerAssessRecordedEvidence', 'pilotReference', pilotReference)
            // verify required parameter 'assessRecordedVoicePilotEvidenceDto' is not null or undefined
            assertParamExists('voicePilotPhase7ControllerAssessRecordedEvidence', 'assessRecordedVoicePilotEvidenceDto', assessRecordedVoicePilotEvidenceDto)
            const localVarPath = `/api/voice-platform/pilots/{pilotReference}/evidence/assessments`
                .replace(`{${"pilotReference"}}`, encodeURIComponent(String(pilotReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assessRecordedVoicePilotEvidenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zarejestruj i oceń zaufane dowody pilotażu
         * @param {string} pilotReference
         * @param {CaptureVoicePilotEvidenceDto} captureVoicePilotEvidenceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerCaptureAndAssess: async (pilotReference: string, captureVoicePilotEvidenceDto: CaptureVoicePilotEvidenceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pilotReference' is not null or undefined
            assertParamExists('voicePilotPhase7ControllerCaptureAndAssess', 'pilotReference', pilotReference)
            // verify required parameter 'captureVoicePilotEvidenceDto' is not null or undefined
            assertParamExists('voicePilotPhase7ControllerCaptureAndAssess', 'captureVoicePilotEvidenceDto', captureVoicePilotEvidenceDto)
            const localVarPath = `/api/voice-platform/pilots/{pilotReference}/evidence/captures`
                .replace(`{${"pilotReference"}}`, encodeURIComponent(String(pilotReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(captureVoicePilotEvidenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Eksportuj anonimowe dowody bez treści rozmów
         * @param {string} pilotReference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerExportCurrentAssessment: async (pilotReference: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pilotReference' is not null or undefined
            assertParamExists('voicePilotPhase7ControllerExportCurrentAssessment', 'pilotReference', pilotReference)
            const localVarPath = `/api/voice-platform/pilots/{pilotReference}/assessments/current/export`
                .replace(`{${"pilotReference"}}`, encodeURIComponent(String(pilotReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Opublikuj wersję obwiedni pilotażu
         * @param {string} pilotReference
         * @param {PublishVoicePilotEnvelopeDto} publishVoicePilotEnvelopeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerPublishEnvelope: async (pilotReference: string, publishVoicePilotEnvelopeDto: PublishVoicePilotEnvelopeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pilotReference' is not null or undefined
            assertParamExists('voicePilotPhase7ControllerPublishEnvelope', 'pilotReference', pilotReference)
            // verify required parameter 'publishVoicePilotEnvelopeDto' is not null or undefined
            assertParamExists('voicePilotPhase7ControllerPublishEnvelope', 'publishVoicePilotEnvelopeDto', publishVoicePilotEnvelopeDto)
            const localVarPath = `/api/voice-platform/pilots/{pilotReference}/envelope/publications`
                .replace(`{${"pilotReference"}}`, encodeURIComponent(String(pilotReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishVoicePilotEnvelopeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz bieżącą ocenę dowodów pilotażu
         * @param {string} pilotReference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerReadCurrentAssessment: async (pilotReference: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pilotReference' is not null or undefined
            assertParamExists('voicePilotPhase7ControllerReadCurrentAssessment', 'pilotReference', pilotReference)
            const localVarPath = `/api/voice-platform/pilots/{pilotReference}/assessments/current`
                .replace(`{${"pilotReference"}}`, encodeURIComponent(String(pilotReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz bieżące niezależne decyzje o rozszerzeniu
         * @param {string} pilotReference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerReadDecisionSummary: async (pilotReference: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pilotReference' is not null or undefined
            assertParamExists('voicePilotPhase7ControllerReadDecisionSummary', 'pilotReference', pilotReference)
            const localVarPath = `/api/voice-platform/pilots/{pilotReference}/decisions/current`
                .replace(`{${"pilotReference"}}`, encodeURIComponent(String(pilotReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz bieżącą obwiednię pilotażu
         * @param {string} pilotReference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerReadEnvelope: async (pilotReference: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pilotReference' is not null or undefined
            assertParamExists('voicePilotPhase7ControllerReadEnvelope', 'pilotReference', pilotReference)
            const localVarPath = `/api/voice-platform/pilots/{pilotReference}/envelope/current`
                .replace(`{${"pilotReference"}}`, encodeURIComponent(String(pilotReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zapisz decyzję recenzenta prywatności
         * @param {string} pilotReference
         * @param {RecordVoicePilotExpansionDecisionDto} recordVoicePilotExpansionDecisionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerRecordPrivacyDecision: async (pilotReference: string, recordVoicePilotExpansionDecisionDto: RecordVoicePilotExpansionDecisionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pilotReference' is not null or undefined
            assertParamExists('voicePilotPhase7ControllerRecordPrivacyDecision', 'pilotReference', pilotReference)
            // verify required parameter 'recordVoicePilotExpansionDecisionDto' is not null or undefined
            assertParamExists('voicePilotPhase7ControllerRecordPrivacyDecision', 'recordVoicePilotExpansionDecisionDto', recordVoicePilotExpansionDecisionDto)
            const localVarPath = `/api/voice-platform/pilots/{pilotReference}/decisions/privacy`
                .replace(`{${"pilotReference"}}`, encodeURIComponent(String(pilotReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordVoicePilotExpansionDecisionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zapisz decyzję wydawcy produktu głosowego
         * @param {string} pilotReference
         * @param {RecordVoicePilotExpansionDecisionDto} recordVoicePilotExpansionDecisionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerRecordProductDecision: async (pilotReference: string, recordVoicePilotExpansionDecisionDto: RecordVoicePilotExpansionDecisionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pilotReference' is not null or undefined
            assertParamExists('voicePilotPhase7ControllerRecordProductDecision', 'pilotReference', pilotReference)
            // verify required parameter 'recordVoicePilotExpansionDecisionDto' is not null or undefined
            assertParamExists('voicePilotPhase7ControllerRecordProductDecision', 'recordVoicePilotExpansionDecisionDto', recordVoicePilotExpansionDecisionDto)
            const localVarPath = `/api/voice-platform/pilots/{pilotReference}/decisions/product`
                .replace(`{${"pilotReference"}}`, encodeURIComponent(String(pilotReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordVoicePilotExpansionDecisionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zapisz decyzję recenzenta bezpieczeństwa
         * @param {string} pilotReference
         * @param {RecordVoicePilotExpansionDecisionDto} recordVoicePilotExpansionDecisionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerRecordSafetyDecision: async (pilotReference: string, recordVoicePilotExpansionDecisionDto: RecordVoicePilotExpansionDecisionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pilotReference' is not null or undefined
            assertParamExists('voicePilotPhase7ControllerRecordSafetyDecision', 'pilotReference', pilotReference)
            // verify required parameter 'recordVoicePilotExpansionDecisionDto' is not null or undefined
            assertParamExists('voicePilotPhase7ControllerRecordSafetyDecision', 'recordVoicePilotExpansionDecisionDto', recordVoicePilotExpansionDecisionDto)
            const localVarPath = `/api/voice-platform/pilots/{pilotReference}/decisions/safety`
                .replace(`{${"pilotReference"}}`, encodeURIComponent(String(pilotReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordVoicePilotExpansionDecisionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PilotaRecepcjiGosowejApi - functional programming interface
 * @export
 */
export const PilotaRecepcjiGosowejApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PilotaRecepcjiGosowejApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Oceń zapisany, zapieczętowany dowód pilotażu
         * @param {string} pilotReference
         * @param {AssessRecordedVoicePilotEvidenceDto} assessRecordedVoicePilotEvidenceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePilotPhase7ControllerAssessRecordedEvidence(pilotReference: string, assessRecordedVoicePilotEvidenceDto: AssessRecordedVoicePilotEvidenceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePilotAssessmentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePilotPhase7ControllerAssessRecordedEvidence(pilotReference, assessRecordedVoicePilotEvidenceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zarejestruj i oceń zaufane dowody pilotażu
         * @param {string} pilotReference
         * @param {CaptureVoicePilotEvidenceDto} captureVoicePilotEvidenceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePilotPhase7ControllerCaptureAndAssess(pilotReference: string, captureVoicePilotEvidenceDto: CaptureVoicePilotEvidenceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePilotAssessmentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePilotPhase7ControllerCaptureAndAssess(pilotReference, captureVoicePilotEvidenceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Eksportuj anonimowe dowody bez treści rozmów
         * @param {string} pilotReference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePilotPhase7ControllerExportCurrentAssessment(pilotReference: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePilotEvidenceExportResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePilotPhase7ControllerExportCurrentAssessment(pilotReference, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Opublikuj wersję obwiedni pilotażu
         * @param {string} pilotReference
         * @param {PublishVoicePilotEnvelopeDto} publishVoicePilotEnvelopeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePilotPhase7ControllerPublishEnvelope(pilotReference: string, publishVoicePilotEnvelopeDto: PublishVoicePilotEnvelopeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePilotEnvelopeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePilotPhase7ControllerPublishEnvelope(pilotReference, publishVoicePilotEnvelopeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz bieżącą ocenę dowodów pilotażu
         * @param {string} pilotReference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePilotPhase7ControllerReadCurrentAssessment(pilotReference: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePilotAssessmentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePilotPhase7ControllerReadCurrentAssessment(pilotReference, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz bieżące niezależne decyzje o rozszerzeniu
         * @param {string} pilotReference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePilotPhase7ControllerReadDecisionSummary(pilotReference: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePilotDecisionSummaryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePilotPhase7ControllerReadDecisionSummary(pilotReference, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz bieżącą obwiednię pilotażu
         * @param {string} pilotReference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePilotPhase7ControllerReadEnvelope(pilotReference: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePilotEnvelopeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePilotPhase7ControllerReadEnvelope(pilotReference, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zapisz decyzję recenzenta prywatności
         * @param {string} pilotReference
         * @param {RecordVoicePilotExpansionDecisionDto} recordVoicePilotExpansionDecisionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePilotPhase7ControllerRecordPrivacyDecision(pilotReference: string, recordVoicePilotExpansionDecisionDto: RecordVoicePilotExpansionDecisionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePilotDecisionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePilotPhase7ControllerRecordPrivacyDecision(pilotReference, recordVoicePilotExpansionDecisionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zapisz decyzję wydawcy produktu głosowego
         * @param {string} pilotReference
         * @param {RecordVoicePilotExpansionDecisionDto} recordVoicePilotExpansionDecisionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePilotPhase7ControllerRecordProductDecision(pilotReference: string, recordVoicePilotExpansionDecisionDto: RecordVoicePilotExpansionDecisionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePilotDecisionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePilotPhase7ControllerRecordProductDecision(pilotReference, recordVoicePilotExpansionDecisionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zapisz decyzję recenzenta bezpieczeństwa
         * @param {string} pilotReference
         * @param {RecordVoicePilotExpansionDecisionDto} recordVoicePilotExpansionDecisionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePilotPhase7ControllerRecordSafetyDecision(pilotReference: string, recordVoicePilotExpansionDecisionDto: RecordVoicePilotExpansionDecisionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePilotDecisionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePilotPhase7ControllerRecordSafetyDecision(pilotReference, recordVoicePilotExpansionDecisionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PilotaRecepcjiGosowejApi - factory interface
 * @export
 */
export const PilotaRecepcjiGosowejApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PilotaRecepcjiGosowejApiFp(configuration)
    return {
        /**
         *
         * @summary Oceń zapisany, zapieczętowany dowód pilotażu
         * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerAssessRecordedEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerAssessRecordedEvidence(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerAssessRecordedEvidenceRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePilotAssessmentResponseDto> {
            return localVarFp.voicePilotPhase7ControllerAssessRecordedEvidence(requestParameters.pilotReference, requestParameters.assessRecordedVoicePilotEvidenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zarejestruj i oceń zaufane dowody pilotażu
         * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerCaptureAndAssessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerCaptureAndAssess(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerCaptureAndAssessRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePilotAssessmentResponseDto> {
            return localVarFp.voicePilotPhase7ControllerCaptureAndAssess(requestParameters.pilotReference, requestParameters.captureVoicePilotEvidenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Eksportuj anonimowe dowody bez treści rozmów
         * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerExportCurrentAssessmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerExportCurrentAssessment(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerExportCurrentAssessmentRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePilotEvidenceExportResponseDto> {
            return localVarFp.voicePilotPhase7ControllerExportCurrentAssessment(requestParameters.pilotReference, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opublikuj wersję obwiedni pilotażu
         * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerPublishEnvelopeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerPublishEnvelope(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerPublishEnvelopeRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePilotEnvelopeResponseDto> {
            return localVarFp.voicePilotPhase7ControllerPublishEnvelope(requestParameters.pilotReference, requestParameters.publishVoicePilotEnvelopeDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz bieżącą ocenę dowodów pilotażu
         * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadCurrentAssessmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerReadCurrentAssessment(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadCurrentAssessmentRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePilotAssessmentResponseDto> {
            return localVarFp.voicePilotPhase7ControllerReadCurrentAssessment(requestParameters.pilotReference, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz bieżące niezależne decyzje o rozszerzeniu
         * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadDecisionSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerReadDecisionSummary(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadDecisionSummaryRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePilotDecisionSummaryResponseDto> {
            return localVarFp.voicePilotPhase7ControllerReadDecisionSummary(requestParameters.pilotReference, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz bieżącą obwiednię pilotażu
         * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadEnvelopeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerReadEnvelope(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadEnvelopeRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePilotEnvelopeResponseDto> {
            return localVarFp.voicePilotPhase7ControllerReadEnvelope(requestParameters.pilotReference, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zapisz decyzję recenzenta prywatności
         * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordPrivacyDecisionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerRecordPrivacyDecision(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordPrivacyDecisionRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePilotDecisionResponseDto> {
            return localVarFp.voicePilotPhase7ControllerRecordPrivacyDecision(requestParameters.pilotReference, requestParameters.recordVoicePilotExpansionDecisionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zapisz decyzję wydawcy produktu głosowego
         * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordProductDecisionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerRecordProductDecision(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordProductDecisionRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePilotDecisionResponseDto> {
            return localVarFp.voicePilotPhase7ControllerRecordProductDecision(requestParameters.pilotReference, requestParameters.recordVoicePilotExpansionDecisionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zapisz decyzję recenzenta bezpieczeństwa
         * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordSafetyDecisionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePilotPhase7ControllerRecordSafetyDecision(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordSafetyDecisionRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePilotDecisionResponseDto> {
            return localVarFp.voicePilotPhase7ControllerRecordSafetyDecision(requestParameters.pilotReference, requestParameters.recordVoicePilotExpansionDecisionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voicePilotPhase7ControllerAssessRecordedEvidence operation in PilotaRecepcjiGosowejApi.
 * @export
 * @interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerAssessRecordedEvidenceRequest
 */
export interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerAssessRecordedEvidenceRequest {
    /**
     *
     * @type {string}
     * @memberof PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerAssessRecordedEvidence
     */
    readonly pilotReference: string

    /**
     *
     * @type {AssessRecordedVoicePilotEvidenceDto}
     * @memberof PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerAssessRecordedEvidence
     */
    readonly assessRecordedVoicePilotEvidenceDto: AssessRecordedVoicePilotEvidenceDto
}

/**
 * Request parameters for voicePilotPhase7ControllerCaptureAndAssess operation in PilotaRecepcjiGosowejApi.
 * @export
 * @interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerCaptureAndAssessRequest
 */
export interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerCaptureAndAssessRequest {
    /**
     *
     * @type {string}
     * @memberof PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerCaptureAndAssess
     */
    readonly pilotReference: string

    /**
     *
     * @type {CaptureVoicePilotEvidenceDto}
     * @memberof PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerCaptureAndAssess
     */
    readonly captureVoicePilotEvidenceDto: CaptureVoicePilotEvidenceDto
}

/**
 * Request parameters for voicePilotPhase7ControllerExportCurrentAssessment operation in PilotaRecepcjiGosowejApi.
 * @export
 * @interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerExportCurrentAssessmentRequest
 */
export interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerExportCurrentAssessmentRequest {
    /**
     *
     * @type {string}
     * @memberof PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerExportCurrentAssessment
     */
    readonly pilotReference: string
}

/**
 * Request parameters for voicePilotPhase7ControllerPublishEnvelope operation in PilotaRecepcjiGosowejApi.
 * @export
 * @interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerPublishEnvelopeRequest
 */
export interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerPublishEnvelopeRequest {
    /**
     *
     * @type {string}
     * @memberof PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerPublishEnvelope
     */
    readonly pilotReference: string

    /**
     *
     * @type {PublishVoicePilotEnvelopeDto}
     * @memberof PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerPublishEnvelope
     */
    readonly publishVoicePilotEnvelopeDto: PublishVoicePilotEnvelopeDto
}

/**
 * Request parameters for voicePilotPhase7ControllerReadCurrentAssessment operation in PilotaRecepcjiGosowejApi.
 * @export
 * @interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadCurrentAssessmentRequest
 */
export interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadCurrentAssessmentRequest {
    /**
     *
     * @type {string}
     * @memberof PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadCurrentAssessment
     */
    readonly pilotReference: string
}

/**
 * Request parameters for voicePilotPhase7ControllerReadDecisionSummary operation in PilotaRecepcjiGosowejApi.
 * @export
 * @interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadDecisionSummaryRequest
 */
export interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadDecisionSummaryRequest {
    /**
     *
     * @type {string}
     * @memberof PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadDecisionSummary
     */
    readonly pilotReference: string
}

/**
 * Request parameters for voicePilotPhase7ControllerReadEnvelope operation in PilotaRecepcjiGosowejApi.
 * @export
 * @interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadEnvelopeRequest
 */
export interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadEnvelopeRequest {
    /**
     *
     * @type {string}
     * @memberof PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadEnvelope
     */
    readonly pilotReference: string
}

/**
 * Request parameters for voicePilotPhase7ControllerRecordPrivacyDecision operation in PilotaRecepcjiGosowejApi.
 * @export
 * @interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordPrivacyDecisionRequest
 */
export interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordPrivacyDecisionRequest {
    /**
     *
     * @type {string}
     * @memberof PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordPrivacyDecision
     */
    readonly pilotReference: string

    /**
     *
     * @type {RecordVoicePilotExpansionDecisionDto}
     * @memberof PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordPrivacyDecision
     */
    readonly recordVoicePilotExpansionDecisionDto: RecordVoicePilotExpansionDecisionDto
}

/**
 * Request parameters for voicePilotPhase7ControllerRecordProductDecision operation in PilotaRecepcjiGosowejApi.
 * @export
 * @interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordProductDecisionRequest
 */
export interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordProductDecisionRequest {
    /**
     *
     * @type {string}
     * @memberof PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordProductDecision
     */
    readonly pilotReference: string

    /**
     *
     * @type {RecordVoicePilotExpansionDecisionDto}
     * @memberof PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordProductDecision
     */
    readonly recordVoicePilotExpansionDecisionDto: RecordVoicePilotExpansionDecisionDto
}

/**
 * Request parameters for voicePilotPhase7ControllerRecordSafetyDecision operation in PilotaRecepcjiGosowejApi.
 * @export
 * @interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordSafetyDecisionRequest
 */
export interface PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordSafetyDecisionRequest {
    /**
     *
     * @type {string}
     * @memberof PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordSafetyDecision
     */
    readonly pilotReference: string

    /**
     *
     * @type {RecordVoicePilotExpansionDecisionDto}
     * @memberof PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordSafetyDecision
     */
    readonly recordVoicePilotExpansionDecisionDto: RecordVoicePilotExpansionDecisionDto
}

/**
 * PilotaRecepcjiGosowejApi - object-oriented interface
 * @export
 * @class PilotaRecepcjiGosowejApi
 * @extends {BaseAPI}
 */
export class PilotaRecepcjiGosowejApi extends BaseAPI {
    /**
     *
     * @summary Oceń zapisany, zapieczętowany dowód pilotażu
     * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerAssessRecordedEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PilotaRecepcjiGosowejApi
     */
    public voicePilotPhase7ControllerAssessRecordedEvidence(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerAssessRecordedEvidenceRequest, options?: AxiosRequestConfig) {
        return PilotaRecepcjiGosowejApiFp(this.configuration).voicePilotPhase7ControllerAssessRecordedEvidence(requestParameters.pilotReference, requestParameters.assessRecordedVoicePilotEvidenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zarejestruj i oceń zaufane dowody pilotażu
     * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerCaptureAndAssessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PilotaRecepcjiGosowejApi
     */
    public voicePilotPhase7ControllerCaptureAndAssess(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerCaptureAndAssessRequest, options?: AxiosRequestConfig) {
        return PilotaRecepcjiGosowejApiFp(this.configuration).voicePilotPhase7ControllerCaptureAndAssess(requestParameters.pilotReference, requestParameters.captureVoicePilotEvidenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Eksportuj anonimowe dowody bez treści rozmów
     * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerExportCurrentAssessmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PilotaRecepcjiGosowejApi
     */
    public voicePilotPhase7ControllerExportCurrentAssessment(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerExportCurrentAssessmentRequest, options?: AxiosRequestConfig) {
        return PilotaRecepcjiGosowejApiFp(this.configuration).voicePilotPhase7ControllerExportCurrentAssessment(requestParameters.pilotReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Opublikuj wersję obwiedni pilotażu
     * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerPublishEnvelopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PilotaRecepcjiGosowejApi
     */
    public voicePilotPhase7ControllerPublishEnvelope(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerPublishEnvelopeRequest, options?: AxiosRequestConfig) {
        return PilotaRecepcjiGosowejApiFp(this.configuration).voicePilotPhase7ControllerPublishEnvelope(requestParameters.pilotReference, requestParameters.publishVoicePilotEnvelopeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz bieżącą ocenę dowodów pilotażu
     * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadCurrentAssessmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PilotaRecepcjiGosowejApi
     */
    public voicePilotPhase7ControllerReadCurrentAssessment(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadCurrentAssessmentRequest, options?: AxiosRequestConfig) {
        return PilotaRecepcjiGosowejApiFp(this.configuration).voicePilotPhase7ControllerReadCurrentAssessment(requestParameters.pilotReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz bieżące niezależne decyzje o rozszerzeniu
     * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadDecisionSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PilotaRecepcjiGosowejApi
     */
    public voicePilotPhase7ControllerReadDecisionSummary(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadDecisionSummaryRequest, options?: AxiosRequestConfig) {
        return PilotaRecepcjiGosowejApiFp(this.configuration).voicePilotPhase7ControllerReadDecisionSummary(requestParameters.pilotReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz bieżącą obwiednię pilotażu
     * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadEnvelopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PilotaRecepcjiGosowejApi
     */
    public voicePilotPhase7ControllerReadEnvelope(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerReadEnvelopeRequest, options?: AxiosRequestConfig) {
        return PilotaRecepcjiGosowejApiFp(this.configuration).voicePilotPhase7ControllerReadEnvelope(requestParameters.pilotReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zapisz decyzję recenzenta prywatności
     * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordPrivacyDecisionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PilotaRecepcjiGosowejApi
     */
    public voicePilotPhase7ControllerRecordPrivacyDecision(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordPrivacyDecisionRequest, options?: AxiosRequestConfig) {
        return PilotaRecepcjiGosowejApiFp(this.configuration).voicePilotPhase7ControllerRecordPrivacyDecision(requestParameters.pilotReference, requestParameters.recordVoicePilotExpansionDecisionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zapisz decyzję wydawcy produktu głosowego
     * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordProductDecisionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PilotaRecepcjiGosowejApi
     */
    public voicePilotPhase7ControllerRecordProductDecision(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordProductDecisionRequest, options?: AxiosRequestConfig) {
        return PilotaRecepcjiGosowejApiFp(this.configuration).voicePilotPhase7ControllerRecordProductDecision(requestParameters.pilotReference, requestParameters.recordVoicePilotExpansionDecisionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zapisz decyzję recenzenta bezpieczeństwa
     * @param {PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordSafetyDecisionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PilotaRecepcjiGosowejApi
     */
    public voicePilotPhase7ControllerRecordSafetyDecision(requestParameters: PilotaRecepcjiGosowejApiVoicePilotPhase7ControllerRecordSafetyDecisionRequest, options?: AxiosRequestConfig) {
        return PilotaRecepcjiGosowejApiFp(this.configuration).voicePilotPhase7ControllerRecordSafetyDecision(requestParameters.pilotReference, requestParameters.recordVoicePilotExpansionDecisionDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PlatformoweSterowanieRecepcjGosowApi - axios parameter creator
 * @export
 */
export const PlatformoweSterowanieRecepcjGosowApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Zastosuj globalną lub organizacyjną blokadę incydentową
         * @param {ApplyReceptionIncidentBlockDto} applyReceptionIncidentBlockDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerApplyIncidentBlock: async (applyReceptionIncidentBlockDto: ApplyReceptionIncidentBlockDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applyReceptionIncidentBlockDto' is not null or undefined
            assertParamExists('receptionPlatformControllerApplyIncidentBlock', 'applyReceptionIncidentBlockDto', applyReceptionIncidentBlockDto)
            const localVarPath = `/api/voice-platform/reception/incidents/blocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyReceptionIncidentBlockDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zastosuj fail-closed nadpisanie bezpieczeństwa
         * @param {ApplyReceptionSafetyOverrideDto} applyReceptionSafetyOverrideDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerApplySafetyOverride: async (applyReceptionSafetyOverrideDto: ApplyReceptionSafetyOverrideDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applyReceptionSafetyOverrideDto' is not null or undefined
            assertParamExists('receptionPlatformControllerApplySafetyOverride', 'applyReceptionSafetyOverrideDto', applyReceptionSafetyOverrideDto)
            const localVarPath = `/api/voice-platform/reception/incidents/safety-overrides`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyReceptionSafetyOverrideDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zatwierdź pierwszą aktywację jako Voice Operations
         * @param {string} organizationId Identyfikator Organization
         * @param {ApproveReceptionActivationDto} approveReceptionActivationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerApproveOperationsActivation: async (organizationId: string, approveReceptionActivationDto: ApproveReceptionActivationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionPlatformControllerApproveOperationsActivation', 'organizationId', organizationId)
            // verify required parameter 'approveReceptionActivationDto' is not null or undefined
            assertParamExists('receptionPlatformControllerApproveOperationsActivation', 'approveReceptionActivationDto', approveReceptionActivationDto)
            const localVarPath = `/api/voice-platform/reception/activations/organizations/{organizationId}/operations-approvals`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveReceptionActivationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zatwierdź pierwszą aktywację jako Privacy Reviewer
         * @param {string} organizationId Identyfikator Organization
         * @param {ApproveReceptionActivationDto} approveReceptionActivationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerApprovePrivacyActivation: async (organizationId: string, approveReceptionActivationDto: ApproveReceptionActivationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionPlatformControllerApprovePrivacyActivation', 'organizationId', organizationId)
            // verify required parameter 'approveReceptionActivationDto' is not null or undefined
            assertParamExists('receptionPlatformControllerApprovePrivacyActivation', 'approveReceptionActivationDto', approveReceptionActivationDto)
            const localVarPath = `/api/voice-platform/reception/activations/organizations/{organizationId}/privacy-approvals`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveReceptionActivationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zatwierdź ponowne otwarcie jako druga osoba
         * @param {string} proposalId
         * @param {ApproveReceptionReopenDto} approveReceptionReopenDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerApproveReopen: async (proposalId: string, approveReceptionReopenDto: ApproveReceptionReopenDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proposalId' is not null or undefined
            assertParamExists('receptionPlatformControllerApproveReopen', 'proposalId', proposalId)
            // verify required parameter 'approveReceptionReopenDto' is not null or undefined
            assertParamExists('receptionPlatformControllerApproveReopen', 'approveReceptionReopenDto', approveReceptionReopenDto)
            const localVarPath = `/api/voice-platform/reception/incidents/reopen-proposals/{proposalId}/approval`
                .replace(`{${"proposalId"}}`, encodeURIComponent(String(proposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveReceptionReopenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zatwierdź pierwszą aktywację jako Safety Reviewer
         * @param {string} organizationId Identyfikator Organization
         * @param {ApproveReceptionActivationDto} approveReceptionActivationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerApproveSafetyActivation: async (organizationId: string, approveReceptionActivationDto: ApproveReceptionActivationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionPlatformControllerApproveSafetyActivation', 'organizationId', organizationId)
            // verify required parameter 'approveReceptionActivationDto' is not null or undefined
            assertParamExists('receptionPlatformControllerApproveSafetyActivation', 'approveReceptionActivationDto', approveReceptionActivationDto)
            const localVarPath = `/api/voice-platform/reception/activations/organizations/{organizationId}/safety-approvals`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveReceptionActivationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zatwierdź zakończenie sesji jako druga osoba
         * @param {string} proposalId
         * @param {ApproveReceptionTerminationDto} approveReceptionTerminationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerApproveTermination: async (proposalId: string, approveReceptionTerminationDto: ApproveReceptionTerminationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proposalId' is not null or undefined
            assertParamExists('receptionPlatformControllerApproveTermination', 'proposalId', proposalId)
            // verify required parameter 'approveReceptionTerminationDto' is not null or undefined
            assertParamExists('receptionPlatformControllerApproveTermination', 'approveReceptionTerminationDto', approveReceptionTerminationDto)
            const localVarPath = `/api/voice-platform/reception/incidents/termination-proposals/{proposalId}/approval`
                .replace(`{${"proposalId"}}`, encodeURIComponent(String(proposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveReceptionTerminationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Sfinalizuj aktywację po ponownej ocenie gotowości
         * @param {string} organizationId Identyfikator Organization
         * @param {FinalizeReceptionActivationDto} finalizeReceptionActivationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerFinalizeActivation: async (organizationId: string, finalizeReceptionActivationDto: FinalizeReceptionActivationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionPlatformControllerFinalizeActivation', 'organizationId', organizationId)
            // verify required parameter 'finalizeReceptionActivationDto' is not null or undefined
            assertParamExists('receptionPlatformControllerFinalizeActivation', 'finalizeReceptionActivationDto', finalizeReceptionActivationDto)
            const localVarPath = `/api/voice-platform/reception/activations/organizations/{organizationId}/finalize`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(finalizeReceptionActivationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz stan i historię aktywacji Facility
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerGetActivationStatus: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionPlatformControllerGetActivationStatus', 'organizationId', organizationId)
            const localVarPath = `/api/voice-platform/reception/activations/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz niezmienną historię sterowania incydentami
         * @param {string} [organizationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerGetIncidentHistory: async (organizationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/reception/incidents/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz bieżący stan i oczekujące decyzje incydentu
         * @param {string} [organizationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerGetIncidentState: async (organizationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/reception/incidents/state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz dowody aktywacji do przeglądu prywatności
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerGetPrivacyActivationEvidence: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionPlatformControllerGetPrivacyActivationEvidence', 'organizationId', organizationId)
            const localVarPath = `/api/voice-platform/reception/activations/organizations/{organizationId}/privacy-evidence`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz dowody aktywacji do przeglądu bezpieczeństwa
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerGetSafetyActivationEvidence: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionPlatformControllerGetSafetyActivationEvidence', 'organizationId', organizationId)
            const localVarPath = `/api/voice-platform/reception/activations/organizations/{organizationId}/safety-evidence`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz bezpieczne skutki bieżącego incydentu
         * @param {string} [organizationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerGetSafetyIncidentEffects: async (organizationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/reception/incidents/safety-effects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zaproponuj kontrolowane ponowne otwarcie incydentu
         * @param {ProposeReceptionIncidentActionDto} proposeReceptionIncidentActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerProposeReopen: async (proposeReceptionIncidentActionDto: ProposeReceptionIncidentActionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proposeReceptionIncidentActionDto' is not null or undefined
            assertParamExists('receptionPlatformControllerProposeReopen', 'proposeReceptionIncidentActionDto', proposeReceptionIncidentActionDto)
            const localVarPath = `/api/voice-platform/reception/incidents/reopen-proposals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proposeReceptionIncidentActionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zaproponuj zakończenie aktywnych sesji
         * @param {ProposeReceptionIncidentActionDto} proposeReceptionIncidentActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerProposeTermination: async (proposeReceptionIncidentActionDto: ProposeReceptionIncidentActionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proposeReceptionIncidentActionDto' is not null or undefined
            assertParamExists('receptionPlatformControllerProposeTermination', 'proposeReceptionIncidentActionDto', proposeReceptionIncidentActionDto)
            const localVarPath = `/api/voice-platform/reception/incidents/termination-proposals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proposeReceptionIncidentActionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlatformoweSterowanieRecepcjGosowApi - functional programming interface
 * @export
 */
export const PlatformoweSterowanieRecepcjGosowApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlatformoweSterowanieRecepcjGosowApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Zastosuj globalną lub organizacyjną blokadę incydentową
         * @param {ApplyReceptionIncidentBlockDto} applyReceptionIncidentBlockDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPlatformControllerApplyIncidentBlock(applyReceptionIncidentBlockDto: ApplyReceptionIncidentBlockDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionControlResultResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPlatformControllerApplyIncidentBlock(applyReceptionIncidentBlockDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zastosuj fail-closed nadpisanie bezpieczeństwa
         * @param {ApplyReceptionSafetyOverrideDto} applyReceptionSafetyOverrideDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPlatformControllerApplySafetyOverride(applyReceptionSafetyOverrideDto: ApplyReceptionSafetyOverrideDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionControlResultResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPlatformControllerApplySafetyOverride(applyReceptionSafetyOverrideDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zatwierdź pierwszą aktywację jako Voice Operations
         * @param {string} organizationId Identyfikator Organization
         * @param {ApproveReceptionActivationDto} approveReceptionActivationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPlatformControllerApproveOperationsActivation(organizationId: string, approveReceptionActivationDto: ApproveReceptionActivationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionControlResultResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPlatformControllerApproveOperationsActivation(organizationId, approveReceptionActivationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zatwierdź pierwszą aktywację jako Privacy Reviewer
         * @param {string} organizationId Identyfikator Organization
         * @param {ApproveReceptionActivationDto} approveReceptionActivationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPlatformControllerApprovePrivacyActivation(organizationId: string, approveReceptionActivationDto: ApproveReceptionActivationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionControlResultResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPlatformControllerApprovePrivacyActivation(organizationId, approveReceptionActivationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zatwierdź ponowne otwarcie jako druga osoba
         * @param {string} proposalId
         * @param {ApproveReceptionReopenDto} approveReceptionReopenDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPlatformControllerApproveReopen(proposalId: string, approveReceptionReopenDto: ApproveReceptionReopenDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionControlResultResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPlatformControllerApproveReopen(proposalId, approveReceptionReopenDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zatwierdź pierwszą aktywację jako Safety Reviewer
         * @param {string} organizationId Identyfikator Organization
         * @param {ApproveReceptionActivationDto} approveReceptionActivationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPlatformControllerApproveSafetyActivation(organizationId: string, approveReceptionActivationDto: ApproveReceptionActivationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionControlResultResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPlatformControllerApproveSafetyActivation(organizationId, approveReceptionActivationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zatwierdź zakończenie sesji jako druga osoba
         * @param {string} proposalId
         * @param {ApproveReceptionTerminationDto} approveReceptionTerminationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPlatformControllerApproveTermination(proposalId: string, approveReceptionTerminationDto: ApproveReceptionTerminationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionControlResultResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPlatformControllerApproveTermination(proposalId, approveReceptionTerminationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Sfinalizuj aktywację po ponownej ocenie gotowości
         * @param {string} organizationId Identyfikator Organization
         * @param {FinalizeReceptionActivationDto} finalizeReceptionActivationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPlatformControllerFinalizeActivation(organizationId: string, finalizeReceptionActivationDto: FinalizeReceptionActivationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionActivationFinalizationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPlatformControllerFinalizeActivation(organizationId, finalizeReceptionActivationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz stan i historię aktywacji Facility
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPlatformControllerGetActivationStatus(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionActivationStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPlatformControllerGetActivationStatus(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz niezmienną historię sterowania incydentami
         * @param {string} [organizationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPlatformControllerGetIncidentHistory(organizationId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReceptionIncidentHistoryEventResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPlatformControllerGetIncidentHistory(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz bieżący stan i oczekujące decyzje incydentu
         * @param {string} [organizationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPlatformControllerGetIncidentState(organizationId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionIncidentStateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPlatformControllerGetIncidentState(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz dowody aktywacji do przeglądu prywatności
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPlatformControllerGetPrivacyActivationEvidence(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionActivationStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPlatformControllerGetPrivacyActivationEvidence(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz dowody aktywacji do przeglądu bezpieczeństwa
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPlatformControllerGetSafetyActivationEvidence(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionActivationStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPlatformControllerGetSafetyActivationEvidence(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz bezpieczne skutki bieżącego incydentu
         * @param {string} [organizationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPlatformControllerGetSafetyIncidentEffects(organizationId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionIncidentSafetyEffectsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPlatformControllerGetSafetyIncidentEffects(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zaproponuj kontrolowane ponowne otwarcie incydentu
         * @param {ProposeReceptionIncidentActionDto} proposeReceptionIncidentActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPlatformControllerProposeReopen(proposeReceptionIncidentActionDto: ProposeReceptionIncidentActionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionControlResultResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPlatformControllerProposeReopen(proposeReceptionIncidentActionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zaproponuj zakończenie aktywnych sesji
         * @param {ProposeReceptionIncidentActionDto} proposeReceptionIncidentActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionPlatformControllerProposeTermination(proposeReceptionIncidentActionDto: ProposeReceptionIncidentActionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionControlResultResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionPlatformControllerProposeTermination(proposeReceptionIncidentActionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlatformoweSterowanieRecepcjGosowApi - factory interface
 * @export
 */
export const PlatformoweSterowanieRecepcjGosowApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlatformoweSterowanieRecepcjGosowApiFp(configuration)
    return {
        /**
         *
         * @summary Zastosuj globalną lub organizacyjną blokadę incydentową
         * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApplyIncidentBlockRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerApplyIncidentBlock(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApplyIncidentBlockRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionControlResultResponseDto> {
            return localVarFp.receptionPlatformControllerApplyIncidentBlock(requestParameters.applyReceptionIncidentBlockDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zastosuj fail-closed nadpisanie bezpieczeństwa
         * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApplySafetyOverrideRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerApplySafetyOverride(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApplySafetyOverrideRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionControlResultResponseDto> {
            return localVarFp.receptionPlatformControllerApplySafetyOverride(requestParameters.applyReceptionSafetyOverrideDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zatwierdź pierwszą aktywację jako Voice Operations
         * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveOperationsActivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerApproveOperationsActivation(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveOperationsActivationRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionControlResultResponseDto> {
            return localVarFp.receptionPlatformControllerApproveOperationsActivation(requestParameters.organizationId, requestParameters.approveReceptionActivationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zatwierdź pierwszą aktywację jako Privacy Reviewer
         * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApprovePrivacyActivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerApprovePrivacyActivation(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApprovePrivacyActivationRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionControlResultResponseDto> {
            return localVarFp.receptionPlatformControllerApprovePrivacyActivation(requestParameters.organizationId, requestParameters.approveReceptionActivationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zatwierdź ponowne otwarcie jako druga osoba
         * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveReopenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerApproveReopen(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveReopenRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionControlResultResponseDto> {
            return localVarFp.receptionPlatformControllerApproveReopen(requestParameters.proposalId, requestParameters.approveReceptionReopenDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zatwierdź pierwszą aktywację jako Safety Reviewer
         * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveSafetyActivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerApproveSafetyActivation(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveSafetyActivationRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionControlResultResponseDto> {
            return localVarFp.receptionPlatformControllerApproveSafetyActivation(requestParameters.organizationId, requestParameters.approveReceptionActivationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zatwierdź zakończenie sesji jako druga osoba
         * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveTerminationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerApproveTermination(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveTerminationRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionControlResultResponseDto> {
            return localVarFp.receptionPlatformControllerApproveTermination(requestParameters.proposalId, requestParameters.approveReceptionTerminationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sfinalizuj aktywację po ponownej ocenie gotowości
         * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerFinalizeActivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerFinalizeActivation(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerFinalizeActivationRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionActivationFinalizationResponseDto> {
            return localVarFp.receptionPlatformControllerFinalizeActivation(requestParameters.organizationId, requestParameters.finalizeReceptionActivationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz stan i historię aktywacji Facility
         * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetActivationStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerGetActivationStatus(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetActivationStatusRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionActivationStatusResponseDto> {
            return localVarFp.receptionPlatformControllerGetActivationStatus(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz niezmienną historię sterowania incydentami
         * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetIncidentHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerGetIncidentHistory(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetIncidentHistoryRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ReceptionIncidentHistoryEventResponseDto>> {
            return localVarFp.receptionPlatformControllerGetIncidentHistory(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz bieżący stan i oczekujące decyzje incydentu
         * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetIncidentStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerGetIncidentState(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetIncidentStateRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ReceptionIncidentStateResponseDto> {
            return localVarFp.receptionPlatformControllerGetIncidentState(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz dowody aktywacji do przeglądu prywatności
         * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetPrivacyActivationEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerGetPrivacyActivationEvidence(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetPrivacyActivationEvidenceRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionActivationStatusResponseDto> {
            return localVarFp.receptionPlatformControllerGetPrivacyActivationEvidence(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz dowody aktywacji do przeglądu bezpieczeństwa
         * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetSafetyActivationEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerGetSafetyActivationEvidence(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetSafetyActivationEvidenceRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionActivationStatusResponseDto> {
            return localVarFp.receptionPlatformControllerGetSafetyActivationEvidence(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz bezpieczne skutki bieżącego incydentu
         * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetSafetyIncidentEffectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerGetSafetyIncidentEffects(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetSafetyIncidentEffectsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ReceptionIncidentSafetyEffectsResponseDto> {
            return localVarFp.receptionPlatformControllerGetSafetyIncidentEffects(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zaproponuj kontrolowane ponowne otwarcie incydentu
         * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerProposeReopenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerProposeReopen(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerProposeReopenRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionControlResultResponseDto> {
            return localVarFp.receptionPlatformControllerProposeReopen(requestParameters.proposeReceptionIncidentActionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zaproponuj zakończenie aktywnych sesji
         * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerProposeTerminationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionPlatformControllerProposeTermination(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerProposeTerminationRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionControlResultResponseDto> {
            return localVarFp.receptionPlatformControllerProposeTermination(requestParameters.proposeReceptionIncidentActionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for receptionPlatformControllerApplyIncidentBlock operation in PlatformoweSterowanieRecepcjGosowApi.
 * @export
 * @interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApplyIncidentBlockRequest
 */
export interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApplyIncidentBlockRequest {
    /**
     *
     * @type {ApplyReceptionIncidentBlockDto}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApplyIncidentBlock
     */
    readonly applyReceptionIncidentBlockDto: ApplyReceptionIncidentBlockDto
}

/**
 * Request parameters for receptionPlatformControllerApplySafetyOverride operation in PlatformoweSterowanieRecepcjGosowApi.
 * @export
 * @interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApplySafetyOverrideRequest
 */
export interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApplySafetyOverrideRequest {
    /**
     *
     * @type {ApplyReceptionSafetyOverrideDto}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApplySafetyOverride
     */
    readonly applyReceptionSafetyOverrideDto: ApplyReceptionSafetyOverrideDto
}

/**
 * Request parameters for receptionPlatformControllerApproveOperationsActivation operation in PlatformoweSterowanieRecepcjGosowApi.
 * @export
 * @interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveOperationsActivationRequest
 */
export interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveOperationsActivationRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveOperationsActivation
     */
    readonly organizationId: string

    /**
     *
     * @type {ApproveReceptionActivationDto}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveOperationsActivation
     */
    readonly approveReceptionActivationDto: ApproveReceptionActivationDto
}

/**
 * Request parameters for receptionPlatformControllerApprovePrivacyActivation operation in PlatformoweSterowanieRecepcjGosowApi.
 * @export
 * @interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApprovePrivacyActivationRequest
 */
export interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApprovePrivacyActivationRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApprovePrivacyActivation
     */
    readonly organizationId: string

    /**
     *
     * @type {ApproveReceptionActivationDto}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApprovePrivacyActivation
     */
    readonly approveReceptionActivationDto: ApproveReceptionActivationDto
}

/**
 * Request parameters for receptionPlatformControllerApproveReopen operation in PlatformoweSterowanieRecepcjGosowApi.
 * @export
 * @interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveReopenRequest
 */
export interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveReopenRequest {
    /**
     *
     * @type {string}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveReopen
     */
    readonly proposalId: string

    /**
     *
     * @type {ApproveReceptionReopenDto}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveReopen
     */
    readonly approveReceptionReopenDto: ApproveReceptionReopenDto
}

/**
 * Request parameters for receptionPlatformControllerApproveSafetyActivation operation in PlatformoweSterowanieRecepcjGosowApi.
 * @export
 * @interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveSafetyActivationRequest
 */
export interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveSafetyActivationRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveSafetyActivation
     */
    readonly organizationId: string

    /**
     *
     * @type {ApproveReceptionActivationDto}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveSafetyActivation
     */
    readonly approveReceptionActivationDto: ApproveReceptionActivationDto
}

/**
 * Request parameters for receptionPlatformControllerApproveTermination operation in PlatformoweSterowanieRecepcjGosowApi.
 * @export
 * @interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveTerminationRequest
 */
export interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveTerminationRequest {
    /**
     *
     * @type {string}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveTermination
     */
    readonly proposalId: string

    /**
     *
     * @type {ApproveReceptionTerminationDto}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveTermination
     */
    readonly approveReceptionTerminationDto: ApproveReceptionTerminationDto
}

/**
 * Request parameters for receptionPlatformControllerFinalizeActivation operation in PlatformoweSterowanieRecepcjGosowApi.
 * @export
 * @interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerFinalizeActivationRequest
 */
export interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerFinalizeActivationRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerFinalizeActivation
     */
    readonly organizationId: string

    /**
     *
     * @type {FinalizeReceptionActivationDto}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerFinalizeActivation
     */
    readonly finalizeReceptionActivationDto: FinalizeReceptionActivationDto
}

/**
 * Request parameters for receptionPlatformControllerGetActivationStatus operation in PlatformoweSterowanieRecepcjGosowApi.
 * @export
 * @interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetActivationStatusRequest
 */
export interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetActivationStatusRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetActivationStatus
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionPlatformControllerGetIncidentHistory operation in PlatformoweSterowanieRecepcjGosowApi.
 * @export
 * @interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetIncidentHistoryRequest
 */
export interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetIncidentHistoryRequest {
    /**
     *
     * @type {string}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetIncidentHistory
     */
    readonly organizationId?: string
}

/**
 * Request parameters for receptionPlatformControllerGetIncidentState operation in PlatformoweSterowanieRecepcjGosowApi.
 * @export
 * @interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetIncidentStateRequest
 */
export interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetIncidentStateRequest {
    /**
     *
     * @type {string}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetIncidentState
     */
    readonly organizationId?: string
}

/**
 * Request parameters for receptionPlatformControllerGetPrivacyActivationEvidence operation in PlatformoweSterowanieRecepcjGosowApi.
 * @export
 * @interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetPrivacyActivationEvidenceRequest
 */
export interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetPrivacyActivationEvidenceRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetPrivacyActivationEvidence
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionPlatformControllerGetSafetyActivationEvidence operation in PlatformoweSterowanieRecepcjGosowApi.
 * @export
 * @interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetSafetyActivationEvidenceRequest
 */
export interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetSafetyActivationEvidenceRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetSafetyActivationEvidence
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionPlatformControllerGetSafetyIncidentEffects operation in PlatformoweSterowanieRecepcjGosowApi.
 * @export
 * @interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetSafetyIncidentEffectsRequest
 */
export interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetSafetyIncidentEffectsRequest {
    /**
     *
     * @type {string}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetSafetyIncidentEffects
     */
    readonly organizationId?: string
}

/**
 * Request parameters for receptionPlatformControllerProposeReopen operation in PlatformoweSterowanieRecepcjGosowApi.
 * @export
 * @interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerProposeReopenRequest
 */
export interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerProposeReopenRequest {
    /**
     *
     * @type {ProposeReceptionIncidentActionDto}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerProposeReopen
     */
    readonly proposeReceptionIncidentActionDto: ProposeReceptionIncidentActionDto
}

/**
 * Request parameters for receptionPlatformControllerProposeTermination operation in PlatformoweSterowanieRecepcjGosowApi.
 * @export
 * @interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerProposeTerminationRequest
 */
export interface PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerProposeTerminationRequest {
    /**
     *
     * @type {ProposeReceptionIncidentActionDto}
     * @memberof PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerProposeTermination
     */
    readonly proposeReceptionIncidentActionDto: ProposeReceptionIncidentActionDto
}

/**
 * PlatformoweSterowanieRecepcjGosowApi - object-oriented interface
 * @export
 * @class PlatformoweSterowanieRecepcjGosowApi
 * @extends {BaseAPI}
 */
export class PlatformoweSterowanieRecepcjGosowApi extends BaseAPI {
    /**
     *
     * @summary Zastosuj globalną lub organizacyjną blokadę incydentową
     * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApplyIncidentBlockRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformoweSterowanieRecepcjGosowApi
     */
    public receptionPlatformControllerApplyIncidentBlock(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApplyIncidentBlockRequest, options?: AxiosRequestConfig) {
        return PlatformoweSterowanieRecepcjGosowApiFp(this.configuration).receptionPlatformControllerApplyIncidentBlock(requestParameters.applyReceptionIncidentBlockDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zastosuj fail-closed nadpisanie bezpieczeństwa
     * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApplySafetyOverrideRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformoweSterowanieRecepcjGosowApi
     */
    public receptionPlatformControllerApplySafetyOverride(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApplySafetyOverrideRequest, options?: AxiosRequestConfig) {
        return PlatformoweSterowanieRecepcjGosowApiFp(this.configuration).receptionPlatformControllerApplySafetyOverride(requestParameters.applyReceptionSafetyOverrideDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zatwierdź pierwszą aktywację jako Voice Operations
     * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveOperationsActivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformoweSterowanieRecepcjGosowApi
     */
    public receptionPlatformControllerApproveOperationsActivation(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveOperationsActivationRequest, options?: AxiosRequestConfig) {
        return PlatformoweSterowanieRecepcjGosowApiFp(this.configuration).receptionPlatformControllerApproveOperationsActivation(requestParameters.organizationId, requestParameters.approveReceptionActivationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zatwierdź pierwszą aktywację jako Privacy Reviewer
     * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApprovePrivacyActivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformoweSterowanieRecepcjGosowApi
     */
    public receptionPlatformControllerApprovePrivacyActivation(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApprovePrivacyActivationRequest, options?: AxiosRequestConfig) {
        return PlatformoweSterowanieRecepcjGosowApiFp(this.configuration).receptionPlatformControllerApprovePrivacyActivation(requestParameters.organizationId, requestParameters.approveReceptionActivationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zatwierdź ponowne otwarcie jako druga osoba
     * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveReopenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformoweSterowanieRecepcjGosowApi
     */
    public receptionPlatformControllerApproveReopen(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveReopenRequest, options?: AxiosRequestConfig) {
        return PlatformoweSterowanieRecepcjGosowApiFp(this.configuration).receptionPlatformControllerApproveReopen(requestParameters.proposalId, requestParameters.approveReceptionReopenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zatwierdź pierwszą aktywację jako Safety Reviewer
     * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveSafetyActivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformoweSterowanieRecepcjGosowApi
     */
    public receptionPlatformControllerApproveSafetyActivation(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveSafetyActivationRequest, options?: AxiosRequestConfig) {
        return PlatformoweSterowanieRecepcjGosowApiFp(this.configuration).receptionPlatformControllerApproveSafetyActivation(requestParameters.organizationId, requestParameters.approveReceptionActivationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zatwierdź zakończenie sesji jako druga osoba
     * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveTerminationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformoweSterowanieRecepcjGosowApi
     */
    public receptionPlatformControllerApproveTermination(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerApproveTerminationRequest, options?: AxiosRequestConfig) {
        return PlatformoweSterowanieRecepcjGosowApiFp(this.configuration).receptionPlatformControllerApproveTermination(requestParameters.proposalId, requestParameters.approveReceptionTerminationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Sfinalizuj aktywację po ponownej ocenie gotowości
     * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerFinalizeActivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformoweSterowanieRecepcjGosowApi
     */
    public receptionPlatformControllerFinalizeActivation(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerFinalizeActivationRequest, options?: AxiosRequestConfig) {
        return PlatformoweSterowanieRecepcjGosowApiFp(this.configuration).receptionPlatformControllerFinalizeActivation(requestParameters.organizationId, requestParameters.finalizeReceptionActivationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz stan i historię aktywacji Facility
     * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetActivationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformoweSterowanieRecepcjGosowApi
     */
    public receptionPlatformControllerGetActivationStatus(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetActivationStatusRequest, options?: AxiosRequestConfig) {
        return PlatformoweSterowanieRecepcjGosowApiFp(this.configuration).receptionPlatformControllerGetActivationStatus(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz niezmienną historię sterowania incydentami
     * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetIncidentHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformoweSterowanieRecepcjGosowApi
     */
    public receptionPlatformControllerGetIncidentHistory(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetIncidentHistoryRequest = {}, options?: AxiosRequestConfig) {
        return PlatformoweSterowanieRecepcjGosowApiFp(this.configuration).receptionPlatformControllerGetIncidentHistory(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz bieżący stan i oczekujące decyzje incydentu
     * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetIncidentStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformoweSterowanieRecepcjGosowApi
     */
    public receptionPlatformControllerGetIncidentState(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetIncidentStateRequest = {}, options?: AxiosRequestConfig) {
        return PlatformoweSterowanieRecepcjGosowApiFp(this.configuration).receptionPlatformControllerGetIncidentState(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz dowody aktywacji do przeglądu prywatności
     * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetPrivacyActivationEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformoweSterowanieRecepcjGosowApi
     */
    public receptionPlatformControllerGetPrivacyActivationEvidence(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetPrivacyActivationEvidenceRequest, options?: AxiosRequestConfig) {
        return PlatformoweSterowanieRecepcjGosowApiFp(this.configuration).receptionPlatformControllerGetPrivacyActivationEvidence(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz dowody aktywacji do przeglądu bezpieczeństwa
     * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetSafetyActivationEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformoweSterowanieRecepcjGosowApi
     */
    public receptionPlatformControllerGetSafetyActivationEvidence(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetSafetyActivationEvidenceRequest, options?: AxiosRequestConfig) {
        return PlatformoweSterowanieRecepcjGosowApiFp(this.configuration).receptionPlatformControllerGetSafetyActivationEvidence(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz bezpieczne skutki bieżącego incydentu
     * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetSafetyIncidentEffectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformoweSterowanieRecepcjGosowApi
     */
    public receptionPlatformControllerGetSafetyIncidentEffects(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerGetSafetyIncidentEffectsRequest = {}, options?: AxiosRequestConfig) {
        return PlatformoweSterowanieRecepcjGosowApiFp(this.configuration).receptionPlatformControllerGetSafetyIncidentEffects(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zaproponuj kontrolowane ponowne otwarcie incydentu
     * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerProposeReopenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformoweSterowanieRecepcjGosowApi
     */
    public receptionPlatformControllerProposeReopen(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerProposeReopenRequest, options?: AxiosRequestConfig) {
        return PlatformoweSterowanieRecepcjGosowApiFp(this.configuration).receptionPlatformControllerProposeReopen(requestParameters.proposeReceptionIncidentActionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zaproponuj zakończenie aktywnych sesji
     * @param {PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerProposeTerminationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformoweSterowanieRecepcjGosowApi
     */
    public receptionPlatformControllerProposeTermination(requestParameters: PlatformoweSterowanieRecepcjGosowApiReceptionPlatformControllerProposeTerminationRequest, options?: AxiosRequestConfig) {
        return PlatformoweSterowanieRecepcjGosowApiFp(this.configuration).receptionPlatformControllerProposeTermination(requestParameters.proposeReceptionIncidentActionDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProfessionalPreviewApi - axios parameter creator
 * @export
 */
export const ProfessionalPreviewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Preview professional details for booking purposes
         * @param {string} professionalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        professionalPreviewControllerPreviewProfessional: async (professionalId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('professionalPreviewControllerPreviewProfessional', 'professionalId', professionalId)
            const localVarPath = `/professional-preview/{professionalId}`
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfessionalPreviewApi - functional programming interface
 * @export
 */
export const ProfessionalPreviewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfessionalPreviewApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Preview professional details for booking purposes
         * @param {string} professionalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async professionalPreviewControllerPreviewProfessional(professionalId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.professionalPreviewControllerPreviewProfessional(professionalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProfessionalPreviewApi - factory interface
 * @export
 */
export const ProfessionalPreviewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfessionalPreviewApiFp(configuration)
    return {
        /**
         *
         * @summary Preview professional details for booking purposes
         * @param {ProfessionalPreviewApiProfessionalPreviewControllerPreviewProfessionalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        professionalPreviewControllerPreviewProfessional(requestParameters: ProfessionalPreviewApiProfessionalPreviewControllerPreviewProfessionalRequest, options?: AxiosRequestConfig): AxiosPromise<PreviewUserDto> {
            return localVarFp.professionalPreviewControllerPreviewProfessional(requestParameters.professionalId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for professionalPreviewControllerPreviewProfessional operation in ProfessionalPreviewApi.
 * @export
 * @interface ProfessionalPreviewApiProfessionalPreviewControllerPreviewProfessionalRequest
 */
export interface ProfessionalPreviewApiProfessionalPreviewControllerPreviewProfessionalRequest {
    /**
     *
     * @type {string}
     * @memberof ProfessionalPreviewApiProfessionalPreviewControllerPreviewProfessional
     */
    readonly professionalId: string
}

/**
 * ProfessionalPreviewApi - object-oriented interface
 * @export
 * @class ProfessionalPreviewApi
 * @extends {BaseAPI}
 */
export class ProfessionalPreviewApi extends BaseAPI {
    /**
     *
     * @summary Preview professional details for booking purposes
     * @param {ProfessionalPreviewApiProfessionalPreviewControllerPreviewProfessionalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalPreviewApi
     */
    public professionalPreviewControllerPreviewProfessional(requestParameters: ProfessionalPreviewApiProfessionalPreviewControllerPreviewProfessionalRequest, options?: AxiosRequestConfig) {
        return ProfessionalPreviewApiFp(this.configuration).professionalPreviewControllerPreviewProfessional(requestParameters.professionalId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProfessionalStatisticsApi - axios parameter creator
 * @export
 */
export const ProfessionalStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get own professional statistics in one organization
         * @param {string} organizationId Organization ID
         * @param {'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_90_DAYS' | 'LAST_365_DAYS' | 'CURRENT_MONTH' | 'LAST_MONTH' | 'ALL_TIME'} [period]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        professionalStatisticsControllerGetMyStatistics: async (organizationId: string, period?: 'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_90_DAYS' | 'LAST_365_DAYS' | 'CURRENT_MONTH' | 'LAST_MONTH' | 'ALL_TIME', startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('professionalStatisticsControllerGetMyStatistics', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/statistics/me`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfessionalStatisticsApi - functional programming interface
 * @export
 */
export const ProfessionalStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfessionalStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get own professional statistics in one organization
         * @param {string} organizationId Organization ID
         * @param {'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_90_DAYS' | 'LAST_365_DAYS' | 'CURRENT_MONTH' | 'LAST_MONTH' | 'ALL_TIME'} [period]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async professionalStatisticsControllerGetMyStatistics(organizationId: string, period?: 'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_90_DAYS' | 'LAST_365_DAYS' | 'CURRENT_MONTH' | 'LAST_MONTH' | 'ALL_TIME', startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalStatisticsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.professionalStatisticsControllerGetMyStatistics(organizationId, period, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProfessionalStatisticsApi - factory interface
 * @export
 */
export const ProfessionalStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfessionalStatisticsApiFp(configuration)
    return {
        /**
         *
         * @summary Get own professional statistics in one organization
         * @param {ProfessionalStatisticsApiProfessionalStatisticsControllerGetMyStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        professionalStatisticsControllerGetMyStatistics(requestParameters: ProfessionalStatisticsApiProfessionalStatisticsControllerGetMyStatisticsRequest, options?: AxiosRequestConfig): AxiosPromise<ProfessionalStatisticsDto> {
            return localVarFp.professionalStatisticsControllerGetMyStatistics(requestParameters.organizationId, requestParameters.period, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for professionalStatisticsControllerGetMyStatistics operation in ProfessionalStatisticsApi.
 * @export
 * @interface ProfessionalStatisticsApiProfessionalStatisticsControllerGetMyStatisticsRequest
 */
export interface ProfessionalStatisticsApiProfessionalStatisticsControllerGetMyStatisticsRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof ProfessionalStatisticsApiProfessionalStatisticsControllerGetMyStatistics
     */
    readonly organizationId: string

    /**
     *
     * @type {'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_90_DAYS' | 'LAST_365_DAYS' | 'CURRENT_MONTH' | 'LAST_MONTH' | 'ALL_TIME'}
     * @memberof ProfessionalStatisticsApiProfessionalStatisticsControllerGetMyStatistics
     */
    readonly period?: 'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_90_DAYS' | 'LAST_365_DAYS' | 'CURRENT_MONTH' | 'LAST_MONTH' | 'ALL_TIME'

    /**
     *
     * @type {string}
     * @memberof ProfessionalStatisticsApiProfessionalStatisticsControllerGetMyStatistics
     */
    readonly startDate?: string

    /**
     *
     * @type {string}
     * @memberof ProfessionalStatisticsApiProfessionalStatisticsControllerGetMyStatistics
     */
    readonly endDate?: string
}

/**
 * ProfessionalStatisticsApi - object-oriented interface
 * @export
 * @class ProfessionalStatisticsApi
 * @extends {BaseAPI}
 */
export class ProfessionalStatisticsApi extends BaseAPI {
    /**
     *
     * @summary Get own professional statistics in one organization
     * @param {ProfessionalStatisticsApiProfessionalStatisticsControllerGetMyStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalStatisticsApi
     */
    public professionalStatisticsControllerGetMyStatistics(requestParameters: ProfessionalStatisticsApiProfessionalStatisticsControllerGetMyStatisticsRequest, options?: AxiosRequestConfig) {
        return ProfessionalStatisticsApiFp(this.configuration).professionalStatisticsControllerGetMyStatistics(requestParameters.organizationId, requestParameters.period, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProfileApi - axios parameter creator
 * @export
 */
export const ProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create a new profile
         * @param {CreateProfileDto} createProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileControllerCreateProfile: async (createProfileDto: CreateProfileDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProfileDto' is not null or undefined
            assertParamExists('profileControllerCreateProfile', 'createProfileDto', createProfileDto)
            const localVarPath = `/api/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProfileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete (inactivate) logged in user profile by id
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileControllerDeleteUser: async (profileId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('profileControllerDeleteUser', 'profileId', profileId)
            const localVarPath = `/api/profile/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all user profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileControllerGetAllUserProfiles: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Signed URL for a file in the documents collection scoped to a profile
         * @param {string} profileId
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileControllerGetProfileFileSignedUrl: async (profileId: string, filename: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('profileControllerGetProfileFileSignedUrl', 'profileId', profileId)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('profileControllerGetProfileFileSignedUrl', 'filename', filename)
            const localVarPath = `/api/profile/{profileId}/document-files/{filename}/signed-url`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get profile by id
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileControllerGetUserProfile: async (profileId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('profileControllerGetUserProfile', 'profileId', profileId)
            const localVarPath = `/api/profile/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Preview profile by id. Available for professional only.
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileControllerPreviewProfileId: async (profileId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('profileControllerPreviewProfileId', 'profileId', profileId)
            const localVarPath = `/api/profile/{profileId}/preview`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update logged in user profile by id
         * @param {string} profileId
         * @param {UpdateProfileDto} updateProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileControllerUpdateUser: async (profileId: string, updateProfileDto: UpdateProfileDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('profileControllerUpdateUser', 'profileId', profileId)
            // verify required parameter 'updateProfileDto' is not null or undefined
            assertParamExists('profileControllerUpdateUser', 'updateProfileDto', updateProfileDto)
            const localVarPath = `/api/profile/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create a new profile
         * @param {CreateProfileDto} createProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileControllerCreateProfile(createProfileDto: CreateProfileDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileControllerCreateProfile(createProfileDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete (inactivate) logged in user profile by id
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileControllerDeleteUser(profileId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileControllerDeleteUser(profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all user profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileControllerGetAllUserProfiles(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProfileDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileControllerGetAllUserProfiles(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Signed URL for a file in the documents collection scoped to a profile
         * @param {string} profileId
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileControllerGetProfileFileSignedUrl(profileId: string, filename: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisitControllerGetVisitFileSignedUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileControllerGetProfileFileSignedUrl(profileId, filename, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get profile by id
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileControllerGetUserProfile(profileId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileControllerGetUserProfile(profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Preview profile by id. Available for professional only.
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileControllerPreviewProfileId(profileId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileControllerPreviewProfileId(profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update logged in user profile by id
         * @param {string} profileId
         * @param {UpdateProfileDto} updateProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileControllerUpdateUser(profileId: string, updateProfileDto: UpdateProfileDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileControllerUpdateUser(profileId, updateProfileDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileApiFp(configuration)
    return {
        /**
         *
         * @summary Create a new profile
         * @param {ProfileApiProfileControllerCreateProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileControllerCreateProfile(requestParameters: ProfileApiProfileControllerCreateProfileRequest, options?: AxiosRequestConfig): AxiosPromise<GetProfileDto> {
            return localVarFp.profileControllerCreateProfile(requestParameters.createProfileDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete (inactivate) logged in user profile by id
         * @param {ProfileApiProfileControllerDeleteUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileControllerDeleteUser(requestParameters: ProfileApiProfileControllerDeleteUserRequest, options?: AxiosRequestConfig): AxiosPromise<GetProfileDto> {
            return localVarFp.profileControllerDeleteUser(requestParameters.profileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all user profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileControllerGetAllUserProfiles(options?: AxiosRequestConfig): AxiosPromise<Array<GetProfileDto>> {
            return localVarFp.profileControllerGetAllUserProfiles(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Signed URL for a file in the documents collection scoped to a profile
         * @param {ProfileApiProfileControllerGetProfileFileSignedUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileControllerGetProfileFileSignedUrl(requestParameters: ProfileApiProfileControllerGetProfileFileSignedUrlRequest, options?: AxiosRequestConfig): AxiosPromise<VisitControllerGetVisitFileSignedUrl200Response> {
            return localVarFp.profileControllerGetProfileFileSignedUrl(requestParameters.profileId, requestParameters.filename, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get profile by id
         * @param {ProfileApiProfileControllerGetUserProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileControllerGetUserProfile(requestParameters: ProfileApiProfileControllerGetUserProfileRequest, options?: AxiosRequestConfig): AxiosPromise<GetProfileDto> {
            return localVarFp.profileControllerGetUserProfile(requestParameters.profileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Preview profile by id. Available for professional only.
         * @param {ProfileApiProfileControllerPreviewProfileIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileControllerPreviewProfileId(requestParameters: ProfileApiProfileControllerPreviewProfileIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetProfileDto> {
            return localVarFp.profileControllerPreviewProfileId(requestParameters.profileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update logged in user profile by id
         * @param {ProfileApiProfileControllerUpdateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileControllerUpdateUser(requestParameters: ProfileApiProfileControllerUpdateUserRequest, options?: AxiosRequestConfig): AxiosPromise<GetProfileDto> {
            return localVarFp.profileControllerUpdateUser(requestParameters.profileId, requestParameters.updateProfileDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for profileControllerCreateProfile operation in ProfileApi.
 * @export
 * @interface ProfileApiProfileControllerCreateProfileRequest
 */
export interface ProfileApiProfileControllerCreateProfileRequest {
    /**
     *
     * @type {CreateProfileDto}
     * @memberof ProfileApiProfileControllerCreateProfile
     */
    readonly createProfileDto: CreateProfileDto
}

/**
 * Request parameters for profileControllerDeleteUser operation in ProfileApi.
 * @export
 * @interface ProfileApiProfileControllerDeleteUserRequest
 */
export interface ProfileApiProfileControllerDeleteUserRequest {
    /**
     *
     * @type {string}
     * @memberof ProfileApiProfileControllerDeleteUser
     */
    readonly profileId: string
}

/**
 * Request parameters for profileControllerGetProfileFileSignedUrl operation in ProfileApi.
 * @export
 * @interface ProfileApiProfileControllerGetProfileFileSignedUrlRequest
 */
export interface ProfileApiProfileControllerGetProfileFileSignedUrlRequest {
    /**
     *
     * @type {string}
     * @memberof ProfileApiProfileControllerGetProfileFileSignedUrl
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof ProfileApiProfileControllerGetProfileFileSignedUrl
     */
    readonly filename: string
}

/**
 * Request parameters for profileControllerGetUserProfile operation in ProfileApi.
 * @export
 * @interface ProfileApiProfileControllerGetUserProfileRequest
 */
export interface ProfileApiProfileControllerGetUserProfileRequest {
    /**
     *
     * @type {string}
     * @memberof ProfileApiProfileControllerGetUserProfile
     */
    readonly profileId: string
}

/**
 * Request parameters for profileControllerPreviewProfileId operation in ProfileApi.
 * @export
 * @interface ProfileApiProfileControllerPreviewProfileIdRequest
 */
export interface ProfileApiProfileControllerPreviewProfileIdRequest {
    /**
     *
     * @type {string}
     * @memberof ProfileApiProfileControllerPreviewProfileId
     */
    readonly profileId: string
}

/**
 * Request parameters for profileControllerUpdateUser operation in ProfileApi.
 * @export
 * @interface ProfileApiProfileControllerUpdateUserRequest
 */
export interface ProfileApiProfileControllerUpdateUserRequest {
    /**
     *
     * @type {string}
     * @memberof ProfileApiProfileControllerUpdateUser
     */
    readonly profileId: string

    /**
     *
     * @type {UpdateProfileDto}
     * @memberof ProfileApiProfileControllerUpdateUser
     */
    readonly updateProfileDto: UpdateProfileDto
}

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI {
    /**
     *
     * @summary Create a new profile
     * @param {ProfileApiProfileControllerCreateProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public profileControllerCreateProfile(requestParameters: ProfileApiProfileControllerCreateProfileRequest, options?: AxiosRequestConfig) {
        return ProfileApiFp(this.configuration).profileControllerCreateProfile(requestParameters.createProfileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete (inactivate) logged in user profile by id
     * @param {ProfileApiProfileControllerDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public profileControllerDeleteUser(requestParameters: ProfileApiProfileControllerDeleteUserRequest, options?: AxiosRequestConfig) {
        return ProfileApiFp(this.configuration).profileControllerDeleteUser(requestParameters.profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all user profiles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public profileControllerGetAllUserProfiles(options?: AxiosRequestConfig) {
        return ProfileApiFp(this.configuration).profileControllerGetAllUserProfiles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Signed URL for a file in the documents collection scoped to a profile
     * @param {ProfileApiProfileControllerGetProfileFileSignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public profileControllerGetProfileFileSignedUrl(requestParameters: ProfileApiProfileControllerGetProfileFileSignedUrlRequest, options?: AxiosRequestConfig) {
        return ProfileApiFp(this.configuration).profileControllerGetProfileFileSignedUrl(requestParameters.profileId, requestParameters.filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get profile by id
     * @param {ProfileApiProfileControllerGetUserProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public profileControllerGetUserProfile(requestParameters: ProfileApiProfileControllerGetUserProfileRequest, options?: AxiosRequestConfig) {
        return ProfileApiFp(this.configuration).profileControllerGetUserProfile(requestParameters.profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Preview profile by id. Available for professional only.
     * @param {ProfileApiProfileControllerPreviewProfileIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public profileControllerPreviewProfileId(requestParameters: ProfileApiProfileControllerPreviewProfileIdRequest, options?: AxiosRequestConfig) {
        return ProfileApiFp(this.configuration).profileControllerPreviewProfileId(requestParameters.profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update logged in user profile by id
     * @param {ProfileApiProfileControllerUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public profileControllerUpdateUser(requestParameters: ProfileApiProfileControllerUpdateUserRequest, options?: AxiosRequestConfig) {
        return ProfileApiFp(this.configuration).profileControllerUpdateUser(requestParameters.profileId, requestParameters.updateProfileDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PromoCodeApi - axios parameter creator
 * @export
 */
export const PromoCodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Validate promo code
         * @param {ValidatePromoCodeDto} validatePromoCodeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodeControllerVerifyUser: async (validatePromoCodeDto: ValidatePromoCodeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validatePromoCodeDto' is not null or undefined
            assertParamExists('promoCodeControllerVerifyUser', 'validatePromoCodeDto', validatePromoCodeDto)
            const localVarPath = `/api/promocode/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validatePromoCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromoCodeApi - functional programming interface
 * @export
 */
export const PromoCodeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromoCodeApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Validate promo code
         * @param {ValidatePromoCodeDto} validatePromoCodeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promoCodeControllerVerifyUser(validatePromoCodeDto: ValidatePromoCodeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidatePromoCodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promoCodeControllerVerifyUser(validatePromoCodeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PromoCodeApi - factory interface
 * @export
 */
export const PromoCodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromoCodeApiFp(configuration)
    return {
        /**
         *
         * @summary Validate promo code
         * @param {PromoCodeApiPromoCodeControllerVerifyUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodeControllerVerifyUser(requestParameters: PromoCodeApiPromoCodeControllerVerifyUserRequest, options?: AxiosRequestConfig): AxiosPromise<ValidatePromoCodeResponseDto> {
            return localVarFp.promoCodeControllerVerifyUser(requestParameters.validatePromoCodeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for promoCodeControllerVerifyUser operation in PromoCodeApi.
 * @export
 * @interface PromoCodeApiPromoCodeControllerVerifyUserRequest
 */
export interface PromoCodeApiPromoCodeControllerVerifyUserRequest {
    /**
     *
     * @type {ValidatePromoCodeDto}
     * @memberof PromoCodeApiPromoCodeControllerVerifyUser
     */
    readonly validatePromoCodeDto: ValidatePromoCodeDto
}

/**
 * PromoCodeApi - object-oriented interface
 * @export
 * @class PromoCodeApi
 * @extends {BaseAPI}
 */
export class PromoCodeApi extends BaseAPI {
    /**
     *
     * @summary Validate promo code
     * @param {PromoCodeApiPromoCodeControllerVerifyUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeApi
     */
    public promoCodeControllerVerifyUser(requestParameters: PromoCodeApiPromoCodeControllerVerifyUserRequest, options?: AxiosRequestConfig) {
        return PromoCodeApiFp(this.configuration).promoCodeControllerVerifyUser(requestParameters.validatePromoCodeDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * Przelewy24Api - axios parameter creator
 * @export
 */
export const Przelewy24ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        przelewy24ControllerGetAllUserTransactions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/przelewy24`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        przelewy24PublicControllerVerifyTransaction: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/przelewy24/public/payment/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Przelewy24Api - functional programming interface
 * @export
 */
export const Przelewy24ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = Przelewy24ApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async przelewy24ControllerGetAllUserTransactions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.przelewy24ControllerGetAllUserTransactions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async przelewy24PublicControllerVerifyTransaction(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.przelewy24PublicControllerVerifyTransaction(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * Przelewy24Api - factory interface
 * @export
 */
export const Przelewy24ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = Przelewy24ApiFp(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        przelewy24ControllerGetAllUserTransactions(options?: AxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.przelewy24ControllerGetAllUserTransactions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        przelewy24PublicControllerVerifyTransaction(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.przelewy24PublicControllerVerifyTransaction(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Przelewy24Api - object-oriented interface
 * @export
 * @class Przelewy24Api
 * @extends {BaseAPI}
 */
export class Przelewy24Api extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Przelewy24Api
     */
    public przelewy24ControllerGetAllUserTransactions(options?: AxiosRequestConfig) {
        return Przelewy24ApiFp(this.configuration).przelewy24ControllerGetAllUserTransactions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Przelewy24Api
     */
    public przelewy24PublicControllerVerifyTransaction(options?: AxiosRequestConfig) {
        return Przelewy24ApiFp(this.configuration).przelewy24PublicControllerVerifyTransaction(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PrzypisaniaRecepcjiGosowejOrganizationApi - axios parameter creator
 * @export
 */
export const PrzypisaniaRecepcjiGosowejOrganizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Pobierz bieżące przypisania recepcji głosowej
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionAssignmentControllerGetCurrent: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionAssignmentControllerGetCurrent', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/assignments/current`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz historię przypisań recepcji głosowej
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionAssignmentControllerGetHistory: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionAssignmentControllerGetHistory', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/assignments/history`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Opublikuj niezmienną rewizję przypisań recepcji głosowej
         * @param {string} organizationId Identyfikator Organization
         * @param {PublishReceptionAssignmentDto} publishReceptionAssignmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionAssignmentControllerPublish: async (organizationId: string, publishReceptionAssignmentDto: PublishReceptionAssignmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionAssignmentControllerPublish', 'organizationId', organizationId)
            // verify required parameter 'publishReceptionAssignmentDto' is not null or undefined
            assertParamExists('receptionAssignmentControllerPublish', 'publishReceptionAssignmentDto', publishReceptionAssignmentDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/assignments/publish`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishReceptionAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrzypisaniaRecepcjiGosowejOrganizationApi - functional programming interface
 * @export
 */
export const PrzypisaniaRecepcjiGosowejOrganizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrzypisaniaRecepcjiGosowejOrganizationApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Pobierz bieżące przypisania recepcji głosowej
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionAssignmentControllerGetCurrent(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionAssignmentCurrentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionAssignmentControllerGetCurrent(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz historię przypisań recepcji głosowej
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionAssignmentControllerGetHistory(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionAssignmentHistoryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionAssignmentControllerGetHistory(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Opublikuj niezmienną rewizję przypisań recepcji głosowej
         * @param {string} organizationId Identyfikator Organization
         * @param {PublishReceptionAssignmentDto} publishReceptionAssignmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionAssignmentControllerPublish(organizationId: string, publishReceptionAssignmentDto: PublishReceptionAssignmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionAssignmentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionAssignmentControllerPublish(organizationId, publishReceptionAssignmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PrzypisaniaRecepcjiGosowejOrganizationApi - factory interface
 * @export
 */
export const PrzypisaniaRecepcjiGosowejOrganizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrzypisaniaRecepcjiGosowejOrganizationApiFp(configuration)
    return {
        /**
         *
         * @summary Pobierz bieżące przypisania recepcji głosowej
         * @param {PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerGetCurrentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionAssignmentControllerGetCurrent(requestParameters: PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerGetCurrentRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionAssignmentCurrentResponseDto> {
            return localVarFp.receptionAssignmentControllerGetCurrent(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz historię przypisań recepcji głosowej
         * @param {PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerGetHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionAssignmentControllerGetHistory(requestParameters: PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerGetHistoryRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionAssignmentHistoryResponseDto> {
            return localVarFp.receptionAssignmentControllerGetHistory(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opublikuj niezmienną rewizję przypisań recepcji głosowej
         * @param {PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerPublishRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionAssignmentControllerPublish(requestParameters: PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerPublishRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionAssignmentResponseDto> {
            return localVarFp.receptionAssignmentControllerPublish(requestParameters.organizationId, requestParameters.publishReceptionAssignmentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for receptionAssignmentControllerGetCurrent operation in PrzypisaniaRecepcjiGosowejOrganizationApi.
 * @export
 * @interface PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerGetCurrentRequest
 */
export interface PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerGetCurrentRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerGetCurrent
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionAssignmentControllerGetHistory operation in PrzypisaniaRecepcjiGosowejOrganizationApi.
 * @export
 * @interface PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerGetHistoryRequest
 */
export interface PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerGetHistoryRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerGetHistory
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionAssignmentControllerPublish operation in PrzypisaniaRecepcjiGosowejOrganizationApi.
 * @export
 * @interface PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerPublishRequest
 */
export interface PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerPublishRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerPublish
     */
    readonly organizationId: string

    /**
     *
     * @type {PublishReceptionAssignmentDto}
     * @memberof PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerPublish
     */
    readonly publishReceptionAssignmentDto: PublishReceptionAssignmentDto
}

/**
 * PrzypisaniaRecepcjiGosowejOrganizationApi - object-oriented interface
 * @export
 * @class PrzypisaniaRecepcjiGosowejOrganizationApi
 * @extends {BaseAPI}
 */
export class PrzypisaniaRecepcjiGosowejOrganizationApi extends BaseAPI {
    /**
     *
     * @summary Pobierz bieżące przypisania recepcji głosowej
     * @param {PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerGetCurrentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrzypisaniaRecepcjiGosowejOrganizationApi
     */
    public receptionAssignmentControllerGetCurrent(requestParameters: PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerGetCurrentRequest, options?: AxiosRequestConfig) {
        return PrzypisaniaRecepcjiGosowejOrganizationApiFp(this.configuration).receptionAssignmentControllerGetCurrent(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz historię przypisań recepcji głosowej
     * @param {PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerGetHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrzypisaniaRecepcjiGosowejOrganizationApi
     */
    public receptionAssignmentControllerGetHistory(requestParameters: PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerGetHistoryRequest, options?: AxiosRequestConfig) {
        return PrzypisaniaRecepcjiGosowejOrganizationApiFp(this.configuration).receptionAssignmentControllerGetHistory(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Opublikuj niezmienną rewizję przypisań recepcji głosowej
     * @param {PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerPublishRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrzypisaniaRecepcjiGosowejOrganizationApi
     */
    public receptionAssignmentControllerPublish(requestParameters: PrzypisaniaRecepcjiGosowejOrganizationApiReceptionAssignmentControllerPublishRequest, options?: AxiosRequestConfig) {
        return PrzypisaniaRecepcjiGosowejOrganizationApiFp(this.configuration).receptionAssignmentControllerPublish(requestParameters.organizationId, requestParameters.publishReceptionAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RatingApi - axios parameter creator
 * @export
 */
export const RatingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create a new rating for a visit
         * @param {CreateRatingDto} createRatingDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratingControllerCreateRating: async (createRatingDto: CreateRatingDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRatingDto' is not null or undefined
            assertParamExists('ratingControllerCreateRating', 'createRatingDto', createRatingDto)
            const localVarPath = `/api/rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRatingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get rating statistics for an organization
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratingControllerGetOrganizationRatingStats: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('ratingControllerGetOrganizationRatingStats', 'organizationId', organizationId)
            const localVarPath = `/api/rating/organization/{organizationId}/stats`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all ratings for an organization
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratingControllerGetOrganizationRatings: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('ratingControllerGetOrganizationRatings', 'organizationId', organizationId)
            const localVarPath = `/api/rating/organization/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get rating statistics for a professional
         * @param {string} professionalId Professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratingControllerGetProfessionalRatingStats: async (professionalId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('ratingControllerGetProfessionalRatingStats', 'professionalId', professionalId)
            const localVarPath = `/api/rating/professional/{professionalId}/stats`
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all ratings for a professional
         * @param {string} professionalId Professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratingControllerGetProfessionalRatings: async (professionalId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('ratingControllerGetProfessionalRatings', 'professionalId', professionalId)
            const localVarPath = `/api/rating/professional/{professionalId}`
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get rating by ID
         * @param {string} id Rating ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratingControllerGetRatingById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('ratingControllerGetRatingById', 'id', id)
            const localVarPath = `/api/rating/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get rating by visit ID
         * @param {string} visitId Visit ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratingControllerGetRatingByVisitId: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('ratingControllerGetRatingByVisitId', 'visitId', visitId)
            const localVarPath = `/api/rating/visit/{visitId}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an existing rating
         * @param {string} id Rating ID
         * @param {UpdateRatingDto} updateRatingDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratingControllerUpdateRating: async (id: string, updateRatingDto: UpdateRatingDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('ratingControllerUpdateRating', 'id', id)
            // verify required parameter 'updateRatingDto' is not null or undefined
            assertParamExists('ratingControllerUpdateRating', 'updateRatingDto', updateRatingDto)
            const localVarPath = `/api/rating/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRatingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RatingApi - functional programming interface
 * @export
 */
export const RatingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RatingApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create a new rating for a visit
         * @param {CreateRatingDto} createRatingDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ratingControllerCreateRating(createRatingDto: CreateRatingDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRatingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ratingControllerCreateRating(createRatingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get rating statistics for an organization
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ratingControllerGetOrganizationRatingStats(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRatingStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ratingControllerGetOrganizationRatingStats(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all ratings for an organization
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ratingControllerGetOrganizationRatings(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRatingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ratingControllerGetOrganizationRatings(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get rating statistics for a professional
         * @param {string} professionalId Professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ratingControllerGetProfessionalRatingStats(professionalId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalRatingStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ratingControllerGetProfessionalRatingStats(professionalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all ratings for a professional
         * @param {string} professionalId Professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ratingControllerGetProfessionalRatings(professionalId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRatingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ratingControllerGetProfessionalRatings(professionalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get rating by ID
         * @param {string} id Rating ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ratingControllerGetRatingById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRatingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ratingControllerGetRatingById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get rating by visit ID
         * @param {string} visitId Visit ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ratingControllerGetRatingByVisitId(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRatingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ratingControllerGetRatingByVisitId(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update an existing rating
         * @param {string} id Rating ID
         * @param {UpdateRatingDto} updateRatingDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ratingControllerUpdateRating(id: string, updateRatingDto: UpdateRatingDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRatingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ratingControllerUpdateRating(id, updateRatingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RatingApi - factory interface
 * @export
 */
export const RatingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RatingApiFp(configuration)
    return {
        /**
         *
         * @summary Create a new rating for a visit
         * @param {RatingApiRatingControllerCreateRatingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratingControllerCreateRating(requestParameters: RatingApiRatingControllerCreateRatingRequest, options?: AxiosRequestConfig): AxiosPromise<GetRatingDto> {
            return localVarFp.ratingControllerCreateRating(requestParameters.createRatingDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get rating statistics for an organization
         * @param {RatingApiRatingControllerGetOrganizationRatingStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratingControllerGetOrganizationRatingStats(requestParameters: RatingApiRatingControllerGetOrganizationRatingStatsRequest, options?: AxiosRequestConfig): AxiosPromise<OrganizationRatingStatsDto> {
            return localVarFp.ratingControllerGetOrganizationRatingStats(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all ratings for an organization
         * @param {RatingApiRatingControllerGetOrganizationRatingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratingControllerGetOrganizationRatings(requestParameters: RatingApiRatingControllerGetOrganizationRatingsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetRatingDto>> {
            return localVarFp.ratingControllerGetOrganizationRatings(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get rating statistics for a professional
         * @param {RatingApiRatingControllerGetProfessionalRatingStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratingControllerGetProfessionalRatingStats(requestParameters: RatingApiRatingControllerGetProfessionalRatingStatsRequest, options?: AxiosRequestConfig): AxiosPromise<ProfessionalRatingStatsDto> {
            return localVarFp.ratingControllerGetProfessionalRatingStats(requestParameters.professionalId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all ratings for a professional
         * @param {RatingApiRatingControllerGetProfessionalRatingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratingControllerGetProfessionalRatings(requestParameters: RatingApiRatingControllerGetProfessionalRatingsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetRatingDto>> {
            return localVarFp.ratingControllerGetProfessionalRatings(requestParameters.professionalId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get rating by ID
         * @param {RatingApiRatingControllerGetRatingByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratingControllerGetRatingById(requestParameters: RatingApiRatingControllerGetRatingByIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetRatingDto> {
            return localVarFp.ratingControllerGetRatingById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get rating by visit ID
         * @param {RatingApiRatingControllerGetRatingByVisitIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratingControllerGetRatingByVisitId(requestParameters: RatingApiRatingControllerGetRatingByVisitIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetRatingDto> {
            return localVarFp.ratingControllerGetRatingByVisitId(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing rating
         * @param {RatingApiRatingControllerUpdateRatingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratingControllerUpdateRating(requestParameters: RatingApiRatingControllerUpdateRatingRequest, options?: AxiosRequestConfig): AxiosPromise<GetRatingDto> {
            return localVarFp.ratingControllerUpdateRating(requestParameters.id, requestParameters.updateRatingDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for ratingControllerCreateRating operation in RatingApi.
 * @export
 * @interface RatingApiRatingControllerCreateRatingRequest
 */
export interface RatingApiRatingControllerCreateRatingRequest {
    /**
     *
     * @type {CreateRatingDto}
     * @memberof RatingApiRatingControllerCreateRating
     */
    readonly createRatingDto: CreateRatingDto
}

/**
 * Request parameters for ratingControllerGetOrganizationRatingStats operation in RatingApi.
 * @export
 * @interface RatingApiRatingControllerGetOrganizationRatingStatsRequest
 */
export interface RatingApiRatingControllerGetOrganizationRatingStatsRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof RatingApiRatingControllerGetOrganizationRatingStats
     */
    readonly organizationId: string
}

/**
 * Request parameters for ratingControllerGetOrganizationRatings operation in RatingApi.
 * @export
 * @interface RatingApiRatingControllerGetOrganizationRatingsRequest
 */
export interface RatingApiRatingControllerGetOrganizationRatingsRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof RatingApiRatingControllerGetOrganizationRatings
     */
    readonly organizationId: string
}

/**
 * Request parameters for ratingControllerGetProfessionalRatingStats operation in RatingApi.
 * @export
 * @interface RatingApiRatingControllerGetProfessionalRatingStatsRequest
 */
export interface RatingApiRatingControllerGetProfessionalRatingStatsRequest {
    /**
     * Professional ID
     * @type {string}
     * @memberof RatingApiRatingControllerGetProfessionalRatingStats
     */
    readonly professionalId: string
}

/**
 * Request parameters for ratingControllerGetProfessionalRatings operation in RatingApi.
 * @export
 * @interface RatingApiRatingControllerGetProfessionalRatingsRequest
 */
export interface RatingApiRatingControllerGetProfessionalRatingsRequest {
    /**
     * Professional ID
     * @type {string}
     * @memberof RatingApiRatingControllerGetProfessionalRatings
     */
    readonly professionalId: string
}

/**
 * Request parameters for ratingControllerGetRatingById operation in RatingApi.
 * @export
 * @interface RatingApiRatingControllerGetRatingByIdRequest
 */
export interface RatingApiRatingControllerGetRatingByIdRequest {
    /**
     * Rating ID
     * @type {string}
     * @memberof RatingApiRatingControllerGetRatingById
     */
    readonly id: string
}

/**
 * Request parameters for ratingControllerGetRatingByVisitId operation in RatingApi.
 * @export
 * @interface RatingApiRatingControllerGetRatingByVisitIdRequest
 */
export interface RatingApiRatingControllerGetRatingByVisitIdRequest {
    /**
     * Visit ID
     * @type {string}
     * @memberof RatingApiRatingControllerGetRatingByVisitId
     */
    readonly visitId: string
}

/**
 * Request parameters for ratingControllerUpdateRating operation in RatingApi.
 * @export
 * @interface RatingApiRatingControllerUpdateRatingRequest
 */
export interface RatingApiRatingControllerUpdateRatingRequest {
    /**
     * Rating ID
     * @type {string}
     * @memberof RatingApiRatingControllerUpdateRating
     */
    readonly id: string

    /**
     *
     * @type {UpdateRatingDto}
     * @memberof RatingApiRatingControllerUpdateRating
     */
    readonly updateRatingDto: UpdateRatingDto
}

/**
 * RatingApi - object-oriented interface
 * @export
 * @class RatingApi
 * @extends {BaseAPI}
 */
export class RatingApi extends BaseAPI {
    /**
     *
     * @summary Create a new rating for a visit
     * @param {RatingApiRatingControllerCreateRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    public ratingControllerCreateRating(requestParameters: RatingApiRatingControllerCreateRatingRequest, options?: AxiosRequestConfig) {
        return RatingApiFp(this.configuration).ratingControllerCreateRating(requestParameters.createRatingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get rating statistics for an organization
     * @param {RatingApiRatingControllerGetOrganizationRatingStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    public ratingControllerGetOrganizationRatingStats(requestParameters: RatingApiRatingControllerGetOrganizationRatingStatsRequest, options?: AxiosRequestConfig) {
        return RatingApiFp(this.configuration).ratingControllerGetOrganizationRatingStats(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all ratings for an organization
     * @param {RatingApiRatingControllerGetOrganizationRatingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    public ratingControllerGetOrganizationRatings(requestParameters: RatingApiRatingControllerGetOrganizationRatingsRequest, options?: AxiosRequestConfig) {
        return RatingApiFp(this.configuration).ratingControllerGetOrganizationRatings(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get rating statistics for a professional
     * @param {RatingApiRatingControllerGetProfessionalRatingStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    public ratingControllerGetProfessionalRatingStats(requestParameters: RatingApiRatingControllerGetProfessionalRatingStatsRequest, options?: AxiosRequestConfig) {
        return RatingApiFp(this.configuration).ratingControllerGetProfessionalRatingStats(requestParameters.professionalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all ratings for a professional
     * @param {RatingApiRatingControllerGetProfessionalRatingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    public ratingControllerGetProfessionalRatings(requestParameters: RatingApiRatingControllerGetProfessionalRatingsRequest, options?: AxiosRequestConfig) {
        return RatingApiFp(this.configuration).ratingControllerGetProfessionalRatings(requestParameters.professionalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get rating by ID
     * @param {RatingApiRatingControllerGetRatingByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    public ratingControllerGetRatingById(requestParameters: RatingApiRatingControllerGetRatingByIdRequest, options?: AxiosRequestConfig) {
        return RatingApiFp(this.configuration).ratingControllerGetRatingById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get rating by visit ID
     * @param {RatingApiRatingControllerGetRatingByVisitIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    public ratingControllerGetRatingByVisitId(requestParameters: RatingApiRatingControllerGetRatingByVisitIdRequest, options?: AxiosRequestConfig) {
        return RatingApiFp(this.configuration).ratingControllerGetRatingByVisitId(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update an existing rating
     * @param {RatingApiRatingControllerUpdateRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    public ratingControllerUpdateRating(requestParameters: RatingApiRatingControllerUpdateRatingRequest, options?: AxiosRequestConfig) {
        return RatingApiFp(this.configuration).ratingControllerUpdateRating(requestParameters.id, requestParameters.updateRatingDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RecepcjaGosowaOrganizationApi - axios parameter creator
 * @export
 */
export const RecepcjaGosowaOrganizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Zatwierdź wskazówki jako wybrany aktywny Professional
         * @param {string} organizationId Identyfikator Organization
         * @param {string} draftId Identyfikator niezmiennego szkicu
         * @param {ApproveEmergencyGuidanceDraftDto} approveEmergencyGuidanceDraftDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerApproveEmergencyDraft: async (organizationId: string, draftId: string, approveEmergencyGuidanceDraftDto: ApproveEmergencyGuidanceDraftDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerApproveEmergencyDraft', 'organizationId', organizationId)
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('receptionOrganizationControllerApproveEmergencyDraft', 'draftId', draftId)
            // verify required parameter 'approveEmergencyGuidanceDraftDto' is not null or undefined
            assertParamExists('receptionOrganizationControllerApproveEmergencyDraft', 'approveEmergencyGuidanceDraftDto', approveEmergencyGuidanceDraftDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/emergency/drafts/{draftId}/professional-approval`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"draftId"}}`, encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveEmergencyGuidanceDraftDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zatwierdź wskazówki jako Owner lub Admin
         * @param {string} organizationId Identyfikator Organization
         * @param {string} draftId Identyfikator niezmiennego szkicu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerApproveEmergencyManagement: async (organizationId: string, draftId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerApproveEmergencyManagement', 'organizationId', organizationId)
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('receptionOrganizationControllerApproveEmergencyManagement', 'draftId', draftId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/emergency-revisions/{draftId}/management-approval`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"draftId"}}`, encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zatwierdź rewizję jako wybrany aktywny Professional
         * @param {string} organizationId Identyfikator Organization
         * @param {string} draftId Identyfikator niezmiennego szkicu
         * @param {ApproveEmergencyGuidanceDraftDto} approveEmergencyGuidanceDraftDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerApproveEmergencyRevision: async (organizationId: string, draftId: string, approveEmergencyGuidanceDraftDto: ApproveEmergencyGuidanceDraftDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerApproveEmergencyRevision', 'organizationId', organizationId)
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('receptionOrganizationControllerApproveEmergencyRevision', 'draftId', draftId)
            // verify required parameter 'approveEmergencyGuidanceDraftDto' is not null or undefined
            assertParamExists('receptionOrganizationControllerApproveEmergencyRevision', 'approveEmergencyGuidanceDraftDto', approveEmergencyGuidanceDraftDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/emergency-revisions/{draftId}/professional-approval`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"draftId"}}`, encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveEmergencyGuidanceDraftDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Anuluj aktywne zamknięcie recepcji
         * @param {string} organizationId Identyfikator Organization
         * @param {string} closureId
         * @param {CancelReceptionClosureDto} cancelReceptionClosureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerCancelReceptionClosure: async (organizationId: string, closureId: string, cancelReceptionClosureDto: CancelReceptionClosureDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerCancelReceptionClosure', 'organizationId', organizationId)
            // verify required parameter 'closureId' is not null or undefined
            assertParamExists('receptionOrganizationControllerCancelReceptionClosure', 'closureId', closureId)
            // verify required parameter 'cancelReceptionClosureDto' is not null or undefined
            assertParamExists('receptionOrganizationControllerCancelReceptionClosure', 'cancelReceptionClosureDto', cancelReceptionClosureDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/reception-closures/{closureId}/cancel`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"closureId"}}`, encodeURIComponent(String(closureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelReceptionClosureDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zapisz szkic wskazówek awaryjnych
         * @param {string} organizationId Identyfikator Organization
         * @param {CreateEmergencyGuidanceDraftDto} createEmergencyGuidanceDraftDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerCreateEmergencyDraft: async (organizationId: string, createEmergencyGuidanceDraftDto: CreateEmergencyGuidanceDraftDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerCreateEmergencyDraft', 'organizationId', organizationId)
            // verify required parameter 'createEmergencyGuidanceDraftDto' is not null or undefined
            assertParamExists('receptionOrganizationControllerCreateEmergencyDraft', 'createEmergencyGuidanceDraftDto', createEmergencyGuidanceDraftDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/emergency/drafts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmergencyGuidanceDraftDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zapisz niezmienny szkic polityki recepcji
         * @param {string} organizationId Identyfikator Organization
         * @param {CreateReceptionPolicyDraftDto} createReceptionPolicyDraftDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerCreatePolicyDraft: async (organizationId: string, createReceptionPolicyDraftDto: CreateReceptionPolicyDraftDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerCreatePolicyDraft', 'organizationId', organizationId)
            // verify required parameter 'createReceptionPolicyDraftDto' is not null or undefined
            assertParamExists('receptionOrganizationControllerCreatePolicyDraft', 'createReceptionPolicyDraftDto', createReceptionPolicyDraftDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/policy/drafts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReceptionPolicyDraftDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Opublikuj audytowane zamknięcie recepcji
         * @param {string} organizationId Identyfikator Organization
         * @param {CreateReceptionClosureDto} createReceptionClosureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerCreateReceptionClosure: async (organizationId: string, createReceptionClosureDto: CreateReceptionClosureDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerCreateReceptionClosure', 'organizationId', organizationId)
            // verify required parameter 'createReceptionClosureDto' is not null or undefined
            assertParamExists('receptionOrganizationControllerCreateReceptionClosure', 'createReceptionClosureDto', createReceptionClosureDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/reception-closures`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReceptionClosureDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Utwórz szkic cofnięcia wskazówek do dawnej rewizji
         * @param {string} organizationId Identyfikator Organization
         * @param {ForwardRollbackEmergencyGuidanceDto} forwardRollbackEmergencyGuidanceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerForwardRollbackEmergency: async (organizationId: string, forwardRollbackEmergencyGuidanceDto: ForwardRollbackEmergencyGuidanceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerForwardRollbackEmergency', 'organizationId', organizationId)
            // verify required parameter 'forwardRollbackEmergencyGuidanceDto' is not null or undefined
            assertParamExists('receptionOrganizationControllerForwardRollbackEmergency', 'forwardRollbackEmergencyGuidanceDto', forwardRollbackEmergencyGuidanceDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/emergency/forward-rollbacks`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forwardRollbackEmergencyGuidanceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Opublikuj dawną treść jako nową rewizję
         * @param {string} organizationId Identyfikator Organization
         * @param {ForwardRollbackReceptionPolicyDto} forwardRollbackReceptionPolicyDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerForwardRollbackPolicy: async (organizationId: string, forwardRollbackReceptionPolicyDto: ForwardRollbackReceptionPolicyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerForwardRollbackPolicy', 'organizationId', organizationId)
            // verify required parameter 'forwardRollbackReceptionPolicyDto' is not null or undefined
            assertParamExists('receptionOrganizationControllerForwardRollbackPolicy', 'forwardRollbackReceptionPolicyDto', forwardRollbackReceptionPolicyDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/policy/forward-rollbacks`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forwardRollbackReceptionPolicyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Sprawdź oczekujące wskazówki do przeglądu
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetCurrentEmergencyReview: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetCurrentEmergencyReview', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/emergency-reviews/current`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz bieżącą opublikowaną politykę recepcji
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetCurrentPolicy: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetCurrentPolicy', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/policy/current`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz bezpieczny bieżący głos dostępny dla Organization
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetCurrentQualifiedVoice: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetCurrentQualifiedVoice', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/qualified-voice/current`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz żądany stan recepcji głosowej
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetDesiredState: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetDesiredState', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/desired-state`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz historię wskazówek awaryjnych
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetEmergencyHistory: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetEmergencyHistory', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/emergency/history`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz wskazówki jako wybrany aktywny Professional
         * @param {string} organizationId Identyfikator Organization
         * @param {string} draftId Identyfikator niezmiennego szkicu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetEmergencyReview: async (organizationId: string, draftId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetEmergencyReview', 'organizationId', organizationId)
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetEmergencyReview', 'draftId', draftId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/emergency-reviews/{draftId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"draftId"}}`, encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz bieżący status wskazówek awaryjnych
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetEmergencyStatus: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetEmergencyStatus', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/emergency/status`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz bezpieczne podsumowanie zarządzania recepcją głosową
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetGovernanceSummary: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetGovernanceSummary', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/governance-summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz oczekujące szkice wskazówek awaryjnych
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetPendingEmergencyDrafts: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetPendingEmergencyDrafts', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/emergency/drafts/pending`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz oczekujące i nieaktualne szkice polityki
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetPendingPolicyDrafts: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetPendingPolicyDrafts', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/policy/drafts/pending`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz historię polityki recepcji
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetPolicyHistory: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetPolicyHistory', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/policy/history`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz obliczoną gotowość i przyczyny fail-closed
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetReadiness: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetReadiness', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/readiness`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz niezmienną historię zamknięć recepcji
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetReceptionClosures: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetReceptionClosures', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/reception-closures`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz bieżącą politykę aliasów i rezerwacji Voice
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetVoiceBookingPolicy: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetVoiceBookingPolicy', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/booking-policy/current`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz niezmienną historię polityki rezerwacji Voice
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetVoiceBookingPolicyHistory: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetVoiceBookingPolicyHistory', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/booking-policy/history`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz dokładną wersję konfiguracji dla kwalifikacji bezpieczeństwa rezerwacji Voice
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetVoiceBookingQualificationAuthority: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerGetVoiceBookingQualificationAuthority', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/booking-policy/qualification-authority`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Opublikuj szkic polityki jako jedną rewizję
         * @param {string} organizationId Identyfikator Organization
         * @param {string} draftId Identyfikator niezmiennego szkicu
         * @param {PublishReceptionPolicyDraftDto} publishReceptionPolicyDraftDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerPublishPolicyDraft: async (organizationId: string, draftId: string, publishReceptionPolicyDraftDto: PublishReceptionPolicyDraftDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerPublishPolicyDraft', 'organizationId', organizationId)
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('receptionOrganizationControllerPublishPolicyDraft', 'draftId', draftId)
            // verify required parameter 'publishReceptionPolicyDraftDto' is not null or undefined
            assertParamExists('receptionOrganizationControllerPublishPolicyDraft', 'publishReceptionPolicyDraftDto', publishReceptionPolicyDraftDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/policy/drafts/{draftId}/publish`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"draftId"}}`, encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishReceptionPolicyDraftDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zmień żądany stan recepcji głosowej
         * @param {string} organizationId Identyfikator Organization
         * @param {SetReceptionDesiredStateDto} setReceptionDesiredStateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerSetDesiredState: async (organizationId: string, setReceptionDesiredStateDto: SetReceptionDesiredStateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerSetDesiredState', 'organizationId', organizationId)
            // verify required parameter 'setReceptionDesiredStateDto' is not null or undefined
            assertParamExists('receptionOrganizationControllerSetDesiredState', 'setReceptionDesiredStateDto', setReceptionDesiredStateDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/desired-state`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setReceptionDesiredStateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Opublikuj rewizję aliasów i reguł rezerwacji Voice
         * @param {string} organizationId Identyfikator Organization
         * @param {SetVoiceBookingServicePolicyDto} setVoiceBookingServicePolicyDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerSetVoiceBookingServicePolicy: async (organizationId: string, setVoiceBookingServicePolicyDto: SetVoiceBookingServicePolicyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionOrganizationControllerSetVoiceBookingServicePolicy', 'organizationId', organizationId)
            // verify required parameter 'setVoiceBookingServicePolicyDto' is not null or undefined
            assertParamExists('receptionOrganizationControllerSetVoiceBookingServicePolicy', 'setVoiceBookingServicePolicyDto', setVoiceBookingServicePolicyDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-reception/booking-policy/services`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setVoiceBookingServicePolicyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecepcjaGosowaOrganizationApi - functional programming interface
 * @export
 */
export const RecepcjaGosowaOrganizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecepcjaGosowaOrganizationApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Zatwierdź wskazówki jako wybrany aktywny Professional
         * @param {string} organizationId Identyfikator Organization
         * @param {string} draftId Identyfikator niezmiennego szkicu
         * @param {ApproveEmergencyGuidanceDraftDto} approveEmergencyGuidanceDraftDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerApproveEmergencyDraft(organizationId: string, draftId: string, approveEmergencyGuidanceDraftDto: ApproveEmergencyGuidanceDraftDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyGuidanceRevisionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerApproveEmergencyDraft(organizationId, draftId, approveEmergencyGuidanceDraftDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zatwierdź wskazówki jako Owner lub Admin
         * @param {string} organizationId Identyfikator Organization
         * @param {string} draftId Identyfikator niezmiennego szkicu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerApproveEmergencyManagement(organizationId: string, draftId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyGuidanceManagementApprovalResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerApproveEmergencyManagement(organizationId, draftId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zatwierdź rewizję jako wybrany aktywny Professional
         * @param {string} organizationId Identyfikator Organization
         * @param {string} draftId Identyfikator niezmiennego szkicu
         * @param {ApproveEmergencyGuidanceDraftDto} approveEmergencyGuidanceDraftDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerApproveEmergencyRevision(organizationId: string, draftId: string, approveEmergencyGuidanceDraftDto: ApproveEmergencyGuidanceDraftDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyGuidanceRevisionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerApproveEmergencyRevision(organizationId, draftId, approveEmergencyGuidanceDraftDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Anuluj aktywne zamknięcie recepcji
         * @param {string} organizationId Identyfikator Organization
         * @param {string} closureId
         * @param {CancelReceptionClosureDto} cancelReceptionClosureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerCancelReceptionClosure(organizationId: string, closureId: string, cancelReceptionClosureDto: CancelReceptionClosureDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionClosureHistoryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerCancelReceptionClosure(organizationId, closureId, cancelReceptionClosureDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zapisz szkic wskazówek awaryjnych
         * @param {string} organizationId Identyfikator Organization
         * @param {CreateEmergencyGuidanceDraftDto} createEmergencyGuidanceDraftDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerCreateEmergencyDraft(organizationId: string, createEmergencyGuidanceDraftDto: CreateEmergencyGuidanceDraftDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyGuidanceDraftResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerCreateEmergencyDraft(organizationId, createEmergencyGuidanceDraftDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zapisz niezmienny szkic polityki recepcji
         * @param {string} organizationId Identyfikator Organization
         * @param {CreateReceptionPolicyDraftDto} createReceptionPolicyDraftDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerCreatePolicyDraft(organizationId: string, createReceptionPolicyDraftDto: CreateReceptionPolicyDraftDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionPolicyDraftResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerCreatePolicyDraft(organizationId, createReceptionPolicyDraftDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Opublikuj audytowane zamknięcie recepcji
         * @param {string} organizationId Identyfikator Organization
         * @param {CreateReceptionClosureDto} createReceptionClosureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerCreateReceptionClosure(organizationId: string, createReceptionClosureDto: CreateReceptionClosureDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionClosureHistoryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerCreateReceptionClosure(organizationId, createReceptionClosureDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Utwórz szkic cofnięcia wskazówek do dawnej rewizji
         * @param {string} organizationId Identyfikator Organization
         * @param {ForwardRollbackEmergencyGuidanceDto} forwardRollbackEmergencyGuidanceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerForwardRollbackEmergency(organizationId: string, forwardRollbackEmergencyGuidanceDto: ForwardRollbackEmergencyGuidanceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyGuidanceDraftResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerForwardRollbackEmergency(organizationId, forwardRollbackEmergencyGuidanceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Opublikuj dawną treść jako nową rewizję
         * @param {string} organizationId Identyfikator Organization
         * @param {ForwardRollbackReceptionPolicyDto} forwardRollbackReceptionPolicyDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerForwardRollbackPolicy(organizationId: string, forwardRollbackReceptionPolicyDto: ForwardRollbackReceptionPolicyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionPolicyRevisionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerForwardRollbackPolicy(organizationId, forwardRollbackReceptionPolicyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Sprawdź oczekujące wskazówki do przeglądu
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerGetCurrentEmergencyReview(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyGuidanceCurrentProfessionalReviewResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerGetCurrentEmergencyReview(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz bieżącą opublikowaną politykę recepcji
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerGetCurrentPolicy(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionPolicyCurrentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerGetCurrentPolicy(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz bezpieczny bieżący głos dostępny dla Organization
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerGetCurrentQualifiedVoice(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionQualifiedVoiceCurrentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerGetCurrentQualifiedVoice(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz żądany stan recepcji głosowej
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerGetDesiredState(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionDesiredStateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerGetDesiredState(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz historię wskazówek awaryjnych
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerGetEmergencyHistory(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyGuidanceHistoryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerGetEmergencyHistory(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz wskazówki jako wybrany aktywny Professional
         * @param {string} organizationId Identyfikator Organization
         * @param {string} draftId Identyfikator niezmiennego szkicu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerGetEmergencyReview(organizationId: string, draftId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyGuidanceProfessionalReviewResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerGetEmergencyReview(organizationId, draftId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz bieżący status wskazówek awaryjnych
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerGetEmergencyStatus(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyGuidanceCurrentStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerGetEmergencyStatus(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz bezpieczne podsumowanie zarządzania recepcją głosową
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerGetGovernanceSummary(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionOrganizationGovernanceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerGetGovernanceSummary(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz oczekujące szkice wskazówek awaryjnych
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerGetPendingEmergencyDrafts(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyGuidancePendingDraftsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerGetPendingEmergencyDrafts(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz oczekujące i nieaktualne szkice polityki
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerGetPendingPolicyDrafts(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionPolicyPendingDraftsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerGetPendingPolicyDrafts(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz historię polityki recepcji
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerGetPolicyHistory(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionPolicyHistoryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerGetPolicyHistory(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz obliczoną gotowość i przyczyny fail-closed
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerGetReadiness(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionReadinessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerGetReadiness(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz niezmienną historię zamknięć recepcji
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerGetReceptionClosures(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionClosureHistoryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerGetReceptionClosures(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz bieżącą politykę aliasów i rezerwacji Voice
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerGetVoiceBookingPolicy(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceBookingPolicyCurrentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerGetVoiceBookingPolicy(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz niezmienną historię polityki rezerwacji Voice
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerGetVoiceBookingPolicyHistory(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceBookingPolicyHistoryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerGetVoiceBookingPolicyHistory(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz dokładną wersję konfiguracji dla kwalifikacji bezpieczeństwa rezerwacji Voice
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerGetVoiceBookingQualificationAuthority(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceBookingQualificationAuthorityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerGetVoiceBookingQualificationAuthority(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Opublikuj szkic polityki jako jedną rewizję
         * @param {string} organizationId Identyfikator Organization
         * @param {string} draftId Identyfikator niezmiennego szkicu
         * @param {PublishReceptionPolicyDraftDto} publishReceptionPolicyDraftDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerPublishPolicyDraft(organizationId: string, draftId: string, publishReceptionPolicyDraftDto: PublishReceptionPolicyDraftDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionPolicyRevisionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerPublishPolicyDraft(organizationId, draftId, publishReceptionPolicyDraftDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zmień żądany stan recepcji głosowej
         * @param {string} organizationId Identyfikator Organization
         * @param {SetReceptionDesiredStateDto} setReceptionDesiredStateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerSetDesiredState(organizationId: string, setReceptionDesiredStateDto: SetReceptionDesiredStateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionDesiredStateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerSetDesiredState(organizationId, setReceptionDesiredStateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Opublikuj rewizję aliasów i reguł rezerwacji Voice
         * @param {string} organizationId Identyfikator Organization
         * @param {SetVoiceBookingServicePolicyDto} setVoiceBookingServicePolicyDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionOrganizationControllerSetVoiceBookingServicePolicy(organizationId: string, setVoiceBookingServicePolicyDto: SetVoiceBookingServicePolicyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceBookingPolicySnapshotResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionOrganizationControllerSetVoiceBookingServicePolicy(organizationId, setVoiceBookingServicePolicyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RecepcjaGosowaOrganizationApi - factory interface
 * @export
 */
export const RecepcjaGosowaOrganizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecepcjaGosowaOrganizationApiFp(configuration)
    return {
        /**
         *
         * @summary Zatwierdź wskazówki jako wybrany aktywny Professional
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyDraftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerApproveEmergencyDraft(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyDraftRequest, options?: AxiosRequestConfig): AxiosPromise<EmergencyGuidanceRevisionResponseDto> {
            return localVarFp.receptionOrganizationControllerApproveEmergencyDraft(requestParameters.organizationId, requestParameters.draftId, requestParameters.approveEmergencyGuidanceDraftDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zatwierdź wskazówki jako Owner lub Admin
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyManagementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerApproveEmergencyManagement(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyManagementRequest, options?: AxiosRequestConfig): AxiosPromise<EmergencyGuidanceManagementApprovalResponseDto> {
            return localVarFp.receptionOrganizationControllerApproveEmergencyManagement(requestParameters.organizationId, requestParameters.draftId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zatwierdź rewizję jako wybrany aktywny Professional
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyRevisionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerApproveEmergencyRevision(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyRevisionRequest, options?: AxiosRequestConfig): AxiosPromise<EmergencyGuidanceRevisionResponseDto> {
            return localVarFp.receptionOrganizationControllerApproveEmergencyRevision(requestParameters.organizationId, requestParameters.draftId, requestParameters.approveEmergencyGuidanceDraftDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Anuluj aktywne zamknięcie recepcji
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCancelReceptionClosureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerCancelReceptionClosure(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCancelReceptionClosureRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionClosureHistoryResponseDto> {
            return localVarFp.receptionOrganizationControllerCancelReceptionClosure(requestParameters.organizationId, requestParameters.closureId, requestParameters.cancelReceptionClosureDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zapisz szkic wskazówek awaryjnych
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreateEmergencyDraftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerCreateEmergencyDraft(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreateEmergencyDraftRequest, options?: AxiosRequestConfig): AxiosPromise<EmergencyGuidanceDraftResponseDto> {
            return localVarFp.receptionOrganizationControllerCreateEmergencyDraft(requestParameters.organizationId, requestParameters.createEmergencyGuidanceDraftDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zapisz niezmienny szkic polityki recepcji
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreatePolicyDraftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerCreatePolicyDraft(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreatePolicyDraftRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionPolicyDraftResponseDto> {
            return localVarFp.receptionOrganizationControllerCreatePolicyDraft(requestParameters.organizationId, requestParameters.createReceptionPolicyDraftDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opublikuj audytowane zamknięcie recepcji
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreateReceptionClosureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerCreateReceptionClosure(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreateReceptionClosureRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionClosureHistoryResponseDto> {
            return localVarFp.receptionOrganizationControllerCreateReceptionClosure(requestParameters.organizationId, requestParameters.createReceptionClosureDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Utwórz szkic cofnięcia wskazówek do dawnej rewizji
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerForwardRollbackEmergencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerForwardRollbackEmergency(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerForwardRollbackEmergencyRequest, options?: AxiosRequestConfig): AxiosPromise<EmergencyGuidanceDraftResponseDto> {
            return localVarFp.receptionOrganizationControllerForwardRollbackEmergency(requestParameters.organizationId, requestParameters.forwardRollbackEmergencyGuidanceDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opublikuj dawną treść jako nową rewizję
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerForwardRollbackPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerForwardRollbackPolicy(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerForwardRollbackPolicyRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionPolicyRevisionResponseDto> {
            return localVarFp.receptionOrganizationControllerForwardRollbackPolicy(requestParameters.organizationId, requestParameters.forwardRollbackReceptionPolicyDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sprawdź oczekujące wskazówki do przeglądu
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentEmergencyReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetCurrentEmergencyReview(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentEmergencyReviewRequest, options?: AxiosRequestConfig): AxiosPromise<EmergencyGuidanceCurrentProfessionalReviewResponseDto> {
            return localVarFp.receptionOrganizationControllerGetCurrentEmergencyReview(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz bieżącą opublikowaną politykę recepcji
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetCurrentPolicy(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentPolicyRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionPolicyCurrentResponseDto> {
            return localVarFp.receptionOrganizationControllerGetCurrentPolicy(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz bezpieczny bieżący głos dostępny dla Organization
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentQualifiedVoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetCurrentQualifiedVoice(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentQualifiedVoiceRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionQualifiedVoiceCurrentResponseDto> {
            return localVarFp.receptionOrganizationControllerGetCurrentQualifiedVoice(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz żądany stan recepcji głosowej
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetDesiredStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetDesiredState(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetDesiredStateRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionDesiredStateResponseDto> {
            return localVarFp.receptionOrganizationControllerGetDesiredState(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz historię wskazówek awaryjnych
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetEmergencyHistory(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyHistoryRequest, options?: AxiosRequestConfig): AxiosPromise<EmergencyGuidanceHistoryResponseDto> {
            return localVarFp.receptionOrganizationControllerGetEmergencyHistory(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz wskazówki jako wybrany aktywny Professional
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetEmergencyReview(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyReviewRequest, options?: AxiosRequestConfig): AxiosPromise<EmergencyGuidanceProfessionalReviewResponseDto> {
            return localVarFp.receptionOrganizationControllerGetEmergencyReview(requestParameters.organizationId, requestParameters.draftId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz bieżący status wskazówek awaryjnych
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetEmergencyStatus(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyStatusRequest, options?: AxiosRequestConfig): AxiosPromise<EmergencyGuidanceCurrentStatusResponseDto> {
            return localVarFp.receptionOrganizationControllerGetEmergencyStatus(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz bezpieczne podsumowanie zarządzania recepcją głosową
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetGovernanceSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetGovernanceSummary(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetGovernanceSummaryRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionOrganizationGovernanceResponseDto> {
            return localVarFp.receptionOrganizationControllerGetGovernanceSummary(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz oczekujące szkice wskazówek awaryjnych
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPendingEmergencyDraftsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetPendingEmergencyDrafts(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPendingEmergencyDraftsRequest, options?: AxiosRequestConfig): AxiosPromise<EmergencyGuidancePendingDraftsResponseDto> {
            return localVarFp.receptionOrganizationControllerGetPendingEmergencyDrafts(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz oczekujące i nieaktualne szkice polityki
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPendingPolicyDraftsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetPendingPolicyDrafts(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPendingPolicyDraftsRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionPolicyPendingDraftsResponseDto> {
            return localVarFp.receptionOrganizationControllerGetPendingPolicyDrafts(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz historię polityki recepcji
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPolicyHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetPolicyHistory(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPolicyHistoryRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionPolicyHistoryResponseDto> {
            return localVarFp.receptionOrganizationControllerGetPolicyHistory(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz obliczoną gotowość i przyczyny fail-closed
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetReadinessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetReadiness(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetReadinessRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionReadinessResponseDto> {
            return localVarFp.receptionOrganizationControllerGetReadiness(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz niezmienną historię zamknięć recepcji
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetReceptionClosuresRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetReceptionClosures(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetReceptionClosuresRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionClosureHistoryResponseDto> {
            return localVarFp.receptionOrganizationControllerGetReceptionClosures(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz bieżącą politykę aliasów i rezerwacji Voice
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetVoiceBookingPolicy(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingPolicyRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceBookingPolicyCurrentResponseDto> {
            return localVarFp.receptionOrganizationControllerGetVoiceBookingPolicy(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz niezmienną historię polityki rezerwacji Voice
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingPolicyHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetVoiceBookingPolicyHistory(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingPolicyHistoryRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceBookingPolicyHistoryResponseDto> {
            return localVarFp.receptionOrganizationControllerGetVoiceBookingPolicyHistory(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz dokładną wersję konfiguracji dla kwalifikacji bezpieczeństwa rezerwacji Voice
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingQualificationAuthorityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerGetVoiceBookingQualificationAuthority(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingQualificationAuthorityRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceBookingQualificationAuthorityResponseDto> {
            return localVarFp.receptionOrganizationControllerGetVoiceBookingQualificationAuthority(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opublikuj szkic polityki jako jedną rewizję
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerPublishPolicyDraftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerPublishPolicyDraft(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerPublishPolicyDraftRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionPolicyRevisionResponseDto> {
            return localVarFp.receptionOrganizationControllerPublishPolicyDraft(requestParameters.organizationId, requestParameters.draftId, requestParameters.publishReceptionPolicyDraftDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zmień żądany stan recepcji głosowej
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerSetDesiredStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerSetDesiredState(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerSetDesiredStateRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionDesiredStateResponseDto> {
            return localVarFp.receptionOrganizationControllerSetDesiredState(requestParameters.organizationId, requestParameters.setReceptionDesiredStateDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opublikuj rewizję aliasów i reguł rezerwacji Voice
         * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerSetVoiceBookingServicePolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionOrganizationControllerSetVoiceBookingServicePolicy(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerSetVoiceBookingServicePolicyRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceBookingPolicySnapshotResponseDto> {
            return localVarFp.receptionOrganizationControllerSetVoiceBookingServicePolicy(requestParameters.organizationId, requestParameters.setVoiceBookingServicePolicyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for receptionOrganizationControllerApproveEmergencyDraft operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyDraftRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyDraftRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyDraft
     */
    readonly organizationId: string

    /**
     * Identyfikator niezmiennego szkicu
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyDraft
     */
    readonly draftId: string

    /**
     *
     * @type {ApproveEmergencyGuidanceDraftDto}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyDraft
     */
    readonly approveEmergencyGuidanceDraftDto: ApproveEmergencyGuidanceDraftDto
}

/**
 * Request parameters for receptionOrganizationControllerApproveEmergencyManagement operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyManagementRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyManagementRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyManagement
     */
    readonly organizationId: string

    /**
     * Identyfikator niezmiennego szkicu
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyManagement
     */
    readonly draftId: string
}

/**
 * Request parameters for receptionOrganizationControllerApproveEmergencyRevision operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyRevisionRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyRevisionRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyRevision
     */
    readonly organizationId: string

    /**
     * Identyfikator niezmiennego szkicu
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyRevision
     */
    readonly draftId: string

    /**
     *
     * @type {ApproveEmergencyGuidanceDraftDto}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyRevision
     */
    readonly approveEmergencyGuidanceDraftDto: ApproveEmergencyGuidanceDraftDto
}

/**
 * Request parameters for receptionOrganizationControllerCancelReceptionClosure operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCancelReceptionClosureRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCancelReceptionClosureRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCancelReceptionClosure
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCancelReceptionClosure
     */
    readonly closureId: string

    /**
     *
     * @type {CancelReceptionClosureDto}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCancelReceptionClosure
     */
    readonly cancelReceptionClosureDto: CancelReceptionClosureDto
}

/**
 * Request parameters for receptionOrganizationControllerCreateEmergencyDraft operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreateEmergencyDraftRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreateEmergencyDraftRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreateEmergencyDraft
     */
    readonly organizationId: string

    /**
     *
     * @type {CreateEmergencyGuidanceDraftDto}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreateEmergencyDraft
     */
    readonly createEmergencyGuidanceDraftDto: CreateEmergencyGuidanceDraftDto
}

/**
 * Request parameters for receptionOrganizationControllerCreatePolicyDraft operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreatePolicyDraftRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreatePolicyDraftRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreatePolicyDraft
     */
    readonly organizationId: string

    /**
     *
     * @type {CreateReceptionPolicyDraftDto}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreatePolicyDraft
     */
    readonly createReceptionPolicyDraftDto: CreateReceptionPolicyDraftDto
}

/**
 * Request parameters for receptionOrganizationControllerCreateReceptionClosure operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreateReceptionClosureRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreateReceptionClosureRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreateReceptionClosure
     */
    readonly organizationId: string

    /**
     *
     * @type {CreateReceptionClosureDto}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreateReceptionClosure
     */
    readonly createReceptionClosureDto: CreateReceptionClosureDto
}

/**
 * Request parameters for receptionOrganizationControllerForwardRollbackEmergency operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerForwardRollbackEmergencyRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerForwardRollbackEmergencyRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerForwardRollbackEmergency
     */
    readonly organizationId: string

    /**
     *
     * @type {ForwardRollbackEmergencyGuidanceDto}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerForwardRollbackEmergency
     */
    readonly forwardRollbackEmergencyGuidanceDto: ForwardRollbackEmergencyGuidanceDto
}

/**
 * Request parameters for receptionOrganizationControllerForwardRollbackPolicy operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerForwardRollbackPolicyRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerForwardRollbackPolicyRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerForwardRollbackPolicy
     */
    readonly organizationId: string

    /**
     *
     * @type {ForwardRollbackReceptionPolicyDto}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerForwardRollbackPolicy
     */
    readonly forwardRollbackReceptionPolicyDto: ForwardRollbackReceptionPolicyDto
}

/**
 * Request parameters for receptionOrganizationControllerGetCurrentEmergencyReview operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentEmergencyReviewRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentEmergencyReviewRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentEmergencyReview
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionOrganizationControllerGetCurrentPolicy operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentPolicyRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentPolicyRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentPolicy
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionOrganizationControllerGetCurrentQualifiedVoice operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentQualifiedVoiceRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentQualifiedVoiceRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentQualifiedVoice
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionOrganizationControllerGetDesiredState operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetDesiredStateRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetDesiredStateRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetDesiredState
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionOrganizationControllerGetEmergencyHistory operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyHistoryRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyHistoryRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyHistory
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionOrganizationControllerGetEmergencyReview operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyReviewRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyReviewRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyReview
     */
    readonly organizationId: string

    /**
     * Identyfikator niezmiennego szkicu
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyReview
     */
    readonly draftId: string
}

/**
 * Request parameters for receptionOrganizationControllerGetEmergencyStatus operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyStatusRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyStatusRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyStatus
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionOrganizationControllerGetGovernanceSummary operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetGovernanceSummaryRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetGovernanceSummaryRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetGovernanceSummary
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionOrganizationControllerGetPendingEmergencyDrafts operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPendingEmergencyDraftsRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPendingEmergencyDraftsRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPendingEmergencyDrafts
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionOrganizationControllerGetPendingPolicyDrafts operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPendingPolicyDraftsRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPendingPolicyDraftsRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPendingPolicyDrafts
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionOrganizationControllerGetPolicyHistory operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPolicyHistoryRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPolicyHistoryRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPolicyHistory
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionOrganizationControllerGetReadiness operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetReadinessRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetReadinessRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetReadiness
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionOrganizationControllerGetReceptionClosures operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetReceptionClosuresRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetReceptionClosuresRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetReceptionClosures
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionOrganizationControllerGetVoiceBookingPolicy operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingPolicyRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingPolicyRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingPolicy
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionOrganizationControllerGetVoiceBookingPolicyHistory operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingPolicyHistoryRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingPolicyHistoryRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingPolicyHistory
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionOrganizationControllerGetVoiceBookingQualificationAuthority operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingQualificationAuthorityRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingQualificationAuthorityRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingQualificationAuthority
     */
    readonly organizationId: string
}

/**
 * Request parameters for receptionOrganizationControllerPublishPolicyDraft operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerPublishPolicyDraftRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerPublishPolicyDraftRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerPublishPolicyDraft
     */
    readonly organizationId: string

    /**
     * Identyfikator niezmiennego szkicu
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerPublishPolicyDraft
     */
    readonly draftId: string

    /**
     *
     * @type {PublishReceptionPolicyDraftDto}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerPublishPolicyDraft
     */
    readonly publishReceptionPolicyDraftDto: PublishReceptionPolicyDraftDto
}

/**
 * Request parameters for receptionOrganizationControllerSetDesiredState operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerSetDesiredStateRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerSetDesiredStateRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerSetDesiredState
     */
    readonly organizationId: string

    /**
     *
     * @type {SetReceptionDesiredStateDto}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerSetDesiredState
     */
    readonly setReceptionDesiredStateDto: SetReceptionDesiredStateDto
}

/**
 * Request parameters for receptionOrganizationControllerSetVoiceBookingServicePolicy operation in RecepcjaGosowaOrganizationApi.
 * @export
 * @interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerSetVoiceBookingServicePolicyRequest
 */
export interface RecepcjaGosowaOrganizationApiReceptionOrganizationControllerSetVoiceBookingServicePolicyRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerSetVoiceBookingServicePolicy
     */
    readonly organizationId: string

    /**
     *
     * @type {SetVoiceBookingServicePolicyDto}
     * @memberof RecepcjaGosowaOrganizationApiReceptionOrganizationControllerSetVoiceBookingServicePolicy
     */
    readonly setVoiceBookingServicePolicyDto: SetVoiceBookingServicePolicyDto
}

/**
 * RecepcjaGosowaOrganizationApi - object-oriented interface
 * @export
 * @class RecepcjaGosowaOrganizationApi
 * @extends {BaseAPI}
 */
export class RecepcjaGosowaOrganizationApi extends BaseAPI {
    /**
     *
     * @summary Zatwierdź wskazówki jako wybrany aktywny Professional
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerApproveEmergencyDraft(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyDraftRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerApproveEmergencyDraft(requestParameters.organizationId, requestParameters.draftId, requestParameters.approveEmergencyGuidanceDraftDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zatwierdź wskazówki jako Owner lub Admin
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyManagementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerApproveEmergencyManagement(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyManagementRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerApproveEmergencyManagement(requestParameters.organizationId, requestParameters.draftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zatwierdź rewizję jako wybrany aktywny Professional
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyRevisionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerApproveEmergencyRevision(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerApproveEmergencyRevisionRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerApproveEmergencyRevision(requestParameters.organizationId, requestParameters.draftId, requestParameters.approveEmergencyGuidanceDraftDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Anuluj aktywne zamknięcie recepcji
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCancelReceptionClosureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerCancelReceptionClosure(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCancelReceptionClosureRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerCancelReceptionClosure(requestParameters.organizationId, requestParameters.closureId, requestParameters.cancelReceptionClosureDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zapisz szkic wskazówek awaryjnych
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreateEmergencyDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerCreateEmergencyDraft(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreateEmergencyDraftRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerCreateEmergencyDraft(requestParameters.organizationId, requestParameters.createEmergencyGuidanceDraftDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zapisz niezmienny szkic polityki recepcji
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreatePolicyDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerCreatePolicyDraft(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreatePolicyDraftRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerCreatePolicyDraft(requestParameters.organizationId, requestParameters.createReceptionPolicyDraftDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Opublikuj audytowane zamknięcie recepcji
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreateReceptionClosureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerCreateReceptionClosure(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerCreateReceptionClosureRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerCreateReceptionClosure(requestParameters.organizationId, requestParameters.createReceptionClosureDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Utwórz szkic cofnięcia wskazówek do dawnej rewizji
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerForwardRollbackEmergencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerForwardRollbackEmergency(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerForwardRollbackEmergencyRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerForwardRollbackEmergency(requestParameters.organizationId, requestParameters.forwardRollbackEmergencyGuidanceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Opublikuj dawną treść jako nową rewizję
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerForwardRollbackPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerForwardRollbackPolicy(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerForwardRollbackPolicyRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerForwardRollbackPolicy(requestParameters.organizationId, requestParameters.forwardRollbackReceptionPolicyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Sprawdź oczekujące wskazówki do przeglądu
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentEmergencyReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerGetCurrentEmergencyReview(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentEmergencyReviewRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerGetCurrentEmergencyReview(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz bieżącą opublikowaną politykę recepcji
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerGetCurrentPolicy(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentPolicyRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerGetCurrentPolicy(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz bezpieczny bieżący głos dostępny dla Organization
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentQualifiedVoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerGetCurrentQualifiedVoice(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetCurrentQualifiedVoiceRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerGetCurrentQualifiedVoice(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz żądany stan recepcji głosowej
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetDesiredStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerGetDesiredState(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetDesiredStateRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerGetDesiredState(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz historię wskazówek awaryjnych
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerGetEmergencyHistory(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyHistoryRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerGetEmergencyHistory(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz wskazówki jako wybrany aktywny Professional
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerGetEmergencyReview(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyReviewRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerGetEmergencyReview(requestParameters.organizationId, requestParameters.draftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz bieżący status wskazówek awaryjnych
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerGetEmergencyStatus(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetEmergencyStatusRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerGetEmergencyStatus(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz bezpieczne podsumowanie zarządzania recepcją głosową
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetGovernanceSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerGetGovernanceSummary(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetGovernanceSummaryRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerGetGovernanceSummary(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz oczekujące szkice wskazówek awaryjnych
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPendingEmergencyDraftsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerGetPendingEmergencyDrafts(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPendingEmergencyDraftsRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerGetPendingEmergencyDrafts(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz oczekujące i nieaktualne szkice polityki
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPendingPolicyDraftsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerGetPendingPolicyDrafts(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPendingPolicyDraftsRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerGetPendingPolicyDrafts(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz historię polityki recepcji
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPolicyHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerGetPolicyHistory(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetPolicyHistoryRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerGetPolicyHistory(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz obliczoną gotowość i przyczyny fail-closed
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetReadinessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerGetReadiness(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetReadinessRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerGetReadiness(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz niezmienną historię zamknięć recepcji
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetReceptionClosuresRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerGetReceptionClosures(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetReceptionClosuresRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerGetReceptionClosures(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz bieżącą politykę aliasów i rezerwacji Voice
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerGetVoiceBookingPolicy(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingPolicyRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerGetVoiceBookingPolicy(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz niezmienną historię polityki rezerwacji Voice
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingPolicyHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerGetVoiceBookingPolicyHistory(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingPolicyHistoryRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerGetVoiceBookingPolicyHistory(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz dokładną wersję konfiguracji dla kwalifikacji bezpieczeństwa rezerwacji Voice
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingQualificationAuthorityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerGetVoiceBookingQualificationAuthority(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerGetVoiceBookingQualificationAuthorityRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerGetVoiceBookingQualificationAuthority(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Opublikuj szkic polityki jako jedną rewizję
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerPublishPolicyDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerPublishPolicyDraft(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerPublishPolicyDraftRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerPublishPolicyDraft(requestParameters.organizationId, requestParameters.draftId, requestParameters.publishReceptionPolicyDraftDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zmień żądany stan recepcji głosowej
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerSetDesiredStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerSetDesiredState(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerSetDesiredStateRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerSetDesiredState(requestParameters.organizationId, requestParameters.setReceptionDesiredStateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Opublikuj rewizję aliasów i reguł rezerwacji Voice
     * @param {RecepcjaGosowaOrganizationApiReceptionOrganizationControllerSetVoiceBookingServicePolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecepcjaGosowaOrganizationApi
     */
    public receptionOrganizationControllerSetVoiceBookingServicePolicy(requestParameters: RecepcjaGosowaOrganizationApiReceptionOrganizationControllerSetVoiceBookingServicePolicyRequest, options?: AxiosRequestConfig) {
        return RecepcjaGosowaOrganizationApiFp(this.configuration).receptionOrganizationControllerSetVoiceBookingServicePolicy(requestParameters.organizationId, requestParameters.setVoiceBookingServicePolicyDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReceptionSessionOrganizationApi - axios parameter creator
 * @export
 */
export const ReceptionSessionOrganizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Pobierz historię dostępu do transkrypcji
         * @param {string} id Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionSessionOrganizationControllerAccessHistory: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('receptionSessionOrganizationControllerAccessHistory', 'id', id)
            const localVarPath = `/api/organizations/{id}/voice-reception/sessions/access-history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz tylko do odczytu transkrypcję sesji
         * @param {string} id Identyfikator Organization
         * @param {string} sessionId Identyfikator Reception Session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionSessionOrganizationControllerGetTranscript: async (id: string, sessionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('receptionSessionOrganizationControllerGetTranscript', 'id', id)
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('receptionSessionOrganizationControllerGetTranscript', 'sessionId', sessionId)
            const localVarPath = `/api/organizations/{id}/voice-reception/sessions/{sessionId}/transcript`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz metadane sesji recepcji głosowej
         * @param {string} id Identyfikator Organization
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionSessionOrganizationControllerListSessions: async (id: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('receptionSessionOrganizationControllerListSessions', 'id', id)
            const localVarPath = `/api/organizations/{id}/voice-reception/sessions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zapisz stałą ocenę jakości bez wolnego tekstu
         * @param {string} id Identyfikator Organization
         * @param {string} sessionId Identyfikator Reception Session
         * @param {ReceptionSessionReviewDto} receptionSessionReviewDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionSessionOrganizationControllerReview: async (id: string, sessionId: string, receptionSessionReviewDto: ReceptionSessionReviewDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('receptionSessionOrganizationControllerReview', 'id', id)
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('receptionSessionOrganizationControllerReview', 'sessionId', sessionId)
            // verify required parameter 'receptionSessionReviewDto' is not null or undefined
            assertParamExists('receptionSessionOrganizationControllerReview', 'receptionSessionReviewDto', receptionSessionReviewDto)
            const localVarPath = `/api/organizations/{id}/voice-reception/sessions/{sessionId}/review`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(receptionSessionReviewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReceptionSessionOrganizationApi - functional programming interface
 * @export
 */
export const ReceptionSessionOrganizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReceptionSessionOrganizationApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Pobierz historię dostępu do transkrypcji
         * @param {string} id Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionSessionOrganizationControllerAccessHistory(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionSessionAccessHistoryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionSessionOrganizationControllerAccessHistory(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz tylko do odczytu transkrypcję sesji
         * @param {string} id Identyfikator Organization
         * @param {string} sessionId Identyfikator Reception Session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionSessionOrganizationControllerGetTranscript(id: string, sessionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionSessionTranscriptResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionSessionOrganizationControllerGetTranscript(id, sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz metadane sesji recepcji głosowej
         * @param {string} id Identyfikator Organization
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionSessionOrganizationControllerListSessions(id: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionSessionListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionSessionOrganizationControllerListSessions(id, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zapisz stałą ocenę jakości bez wolnego tekstu
         * @param {string} id Identyfikator Organization
         * @param {string} sessionId Identyfikator Reception Session
         * @param {ReceptionSessionReviewDto} receptionSessionReviewDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionSessionOrganizationControllerReview(id: string, sessionId: string, receptionSessionReviewDto: ReceptionSessionReviewDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionSessionReviewResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionSessionOrganizationControllerReview(id, sessionId, receptionSessionReviewDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReceptionSessionOrganizationApi - factory interface
 * @export
 */
export const ReceptionSessionOrganizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReceptionSessionOrganizationApiFp(configuration)
    return {
        /**
         *
         * @summary Pobierz historię dostępu do transkrypcji
         * @param {ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerAccessHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionSessionOrganizationControllerAccessHistory(requestParameters: ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerAccessHistoryRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionSessionAccessHistoryResponseDto> {
            return localVarFp.receptionSessionOrganizationControllerAccessHistory(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz tylko do odczytu transkrypcję sesji
         * @param {ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerGetTranscriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionSessionOrganizationControllerGetTranscript(requestParameters: ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerGetTranscriptRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionSessionTranscriptResponseDto> {
            return localVarFp.receptionSessionOrganizationControllerGetTranscript(requestParameters.id, requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz metadane sesji recepcji głosowej
         * @param {ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerListSessionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionSessionOrganizationControllerListSessions(requestParameters: ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerListSessionsRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionSessionListResponseDto> {
            return localVarFp.receptionSessionOrganizationControllerListSessions(requestParameters.id, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zapisz stałą ocenę jakości bez wolnego tekstu
         * @param {ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionSessionOrganizationControllerReview(requestParameters: ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerReviewRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionSessionReviewResponseDto> {
            return localVarFp.receptionSessionOrganizationControllerReview(requestParameters.id, requestParameters.sessionId, requestParameters.receptionSessionReviewDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for receptionSessionOrganizationControllerAccessHistory operation in ReceptionSessionOrganizationApi.
 * @export
 * @interface ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerAccessHistoryRequest
 */
export interface ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerAccessHistoryRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerAccessHistory
     */
    readonly id: string
}

/**
 * Request parameters for receptionSessionOrganizationControllerGetTranscript operation in ReceptionSessionOrganizationApi.
 * @export
 * @interface ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerGetTranscriptRequest
 */
export interface ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerGetTranscriptRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerGetTranscript
     */
    readonly id: string

    /**
     * Identyfikator Reception Session
     * @type {string}
     * @memberof ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerGetTranscript
     */
    readonly sessionId: string
}

/**
 * Request parameters for receptionSessionOrganizationControllerListSessions operation in ReceptionSessionOrganizationApi.
 * @export
 * @interface ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerListSessionsRequest
 */
export interface ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerListSessionsRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerListSessions
     */
    readonly id: string

    /**
     *
     * @type {number}
     * @memberof ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerListSessions
     */
    readonly page?: number

    /**
     *
     * @type {number}
     * @memberof ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerListSessions
     */
    readonly limit?: number
}

/**
 * Request parameters for receptionSessionOrganizationControllerReview operation in ReceptionSessionOrganizationApi.
 * @export
 * @interface ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerReviewRequest
 */
export interface ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerReviewRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerReview
     */
    readonly id: string

    /**
     * Identyfikator Reception Session
     * @type {string}
     * @memberof ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerReview
     */
    readonly sessionId: string

    /**
     *
     * @type {ReceptionSessionReviewDto}
     * @memberof ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerReview
     */
    readonly receptionSessionReviewDto: ReceptionSessionReviewDto
}

/**
 * ReceptionSessionOrganizationApi - object-oriented interface
 * @export
 * @class ReceptionSessionOrganizationApi
 * @extends {BaseAPI}
 */
export class ReceptionSessionOrganizationApi extends BaseAPI {
    /**
     *
     * @summary Pobierz historię dostępu do transkrypcji
     * @param {ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerAccessHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceptionSessionOrganizationApi
     */
    public receptionSessionOrganizationControllerAccessHistory(requestParameters: ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerAccessHistoryRequest, options?: AxiosRequestConfig) {
        return ReceptionSessionOrganizationApiFp(this.configuration).receptionSessionOrganizationControllerAccessHistory(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz tylko do odczytu transkrypcję sesji
     * @param {ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerGetTranscriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceptionSessionOrganizationApi
     */
    public receptionSessionOrganizationControllerGetTranscript(requestParameters: ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerGetTranscriptRequest, options?: AxiosRequestConfig) {
        return ReceptionSessionOrganizationApiFp(this.configuration).receptionSessionOrganizationControllerGetTranscript(requestParameters.id, requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz metadane sesji recepcji głosowej
     * @param {ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerListSessionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceptionSessionOrganizationApi
     */
    public receptionSessionOrganizationControllerListSessions(requestParameters: ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerListSessionsRequest, options?: AxiosRequestConfig) {
        return ReceptionSessionOrganizationApiFp(this.configuration).receptionSessionOrganizationControllerListSessions(requestParameters.id, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zapisz stałą ocenę jakości bez wolnego tekstu
     * @param {ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceptionSessionOrganizationApi
     */
    public receptionSessionOrganizationControllerReview(requestParameters: ReceptionSessionOrganizationApiReceptionSessionOrganizationControllerReviewRequest, options?: AxiosRequestConfig) {
        return ReceptionSessionOrganizationApiFp(this.configuration).receptionSessionOrganizationControllerReview(requestParameters.id, requestParameters.sessionId, requestParameters.receptionSessionReviewDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RegionalnyFallbackBundleVoiceApi - axios parameter creator
 * @export
 */
export const RegionalnyFallbackBundleVoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Zatwierdź dokładną treść zwykłego fallback
         * @param {string} lineId Identyfikator Voice Line
         * @param {string} proposalId Identyfikator propozycji
         * @param {ApproveVoiceFallbackContentDto} approveVoiceFallbackContentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceFallbackBundleControllerApproveContent: async (lineId: string, proposalId: string, approveVoiceFallbackContentDto: ApproveVoiceFallbackContentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('voiceFallbackBundleControllerApproveContent', 'lineId', lineId)
            // verify required parameter 'proposalId' is not null or undefined
            assertParamExists('voiceFallbackBundleControllerApproveContent', 'proposalId', proposalId)
            // verify required parameter 'approveVoiceFallbackContentDto' is not null or undefined
            assertParamExists('voiceFallbackBundleControllerApproveContent', 'approveVoiceFallbackContentDto', approveVoiceFallbackContentDto)
            const localVarPath = `/api/voice-platform/lines/{lineId}/fallback-bundle/content-approvals/proposals/{proposalId}/approval`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)))
                .replace(`{${"proposalId"}}`, encodeURIComponent(String(proposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveVoiceFallbackContentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz historię zatwierdzeń treści fallback
         * @param {string} lineId Identyfikator Voice Line
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceFallbackBundleControllerGetContentApprovalHistory: async (lineId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('voiceFallbackBundleControllerGetContentApprovalHistory', 'lineId', lineId)
            const localVarPath = `/api/voice-platform/lines/{lineId}/fallback-bundle/content-approvals/history`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz bieżące wiązanie Fallback Bundle
         * @param {string} lineId Identyfikator Voice Line
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceFallbackBundleControllerGetCurrent: async (lineId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('voiceFallbackBundleControllerGetCurrent', 'lineId', lineId)
            const localVarPath = `/api/voice-platform/lines/{lineId}/fallback-bundle/current`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz zachowaną historię Fallback Bundle
         * @param {string} lineId Identyfikator Voice Line
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceFallbackBundleControllerGetHistory: async (lineId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('voiceFallbackBundleControllerGetHistory', 'lineId', lineId)
            const localVarPath = `/api/voice-platform/lines/{lineId}/fallback-bundle/history`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zaproponuj dokładną treść zwykłego fallback
         * @param {string} lineId Identyfikator Voice Line
         * @param {ProposeVoiceFallbackContentApprovalDto} proposeVoiceFallbackContentApprovalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceFallbackBundleControllerProposeContent: async (lineId: string, proposeVoiceFallbackContentApprovalDto: ProposeVoiceFallbackContentApprovalDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('voiceFallbackBundleControllerProposeContent', 'lineId', lineId)
            // verify required parameter 'proposeVoiceFallbackContentApprovalDto' is not null or undefined
            assertParamExists('voiceFallbackBundleControllerProposeContent', 'proposeVoiceFallbackContentApprovalDto', proposeVoiceFallbackContentApprovalDto)
            const localVarPath = `/api/voice-platform/lines/{lineId}/fallback-bundle/content-approvals/proposals`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proposeVoiceFallbackContentApprovalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Opublikuj atomową rewizję Fallback Bundle
         * @param {string} lineId Identyfikator Voice Line
         * @param {PublishVoiceFallbackBundleDto} publishVoiceFallbackBundleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceFallbackBundleControllerPublish: async (lineId: string, publishVoiceFallbackBundleDto: PublishVoiceFallbackBundleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('voiceFallbackBundleControllerPublish', 'lineId', lineId)
            // verify required parameter 'publishVoiceFallbackBundleDto' is not null or undefined
            assertParamExists('voiceFallbackBundleControllerPublish', 'publishVoiceFallbackBundleDto', publishVoiceFallbackBundleDto)
            const localVarPath = `/api/voice-platform/lines/{lineId}/fallback-bundle/publications`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishVoiceFallbackBundleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Odczytaj i uzgodnij Fallback Bundle ze stanem dostawcy
         * @param {string} lineId Identyfikator Voice Line
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceFallbackBundleControllerReconcile: async (lineId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('voiceFallbackBundleControllerReconcile', 'lineId', lineId)
            const localVarPath = `/api/voice-platform/lines/{lineId}/fallback-bundle/reconcile`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegionalnyFallbackBundleVoiceApi - functional programming interface
 * @export
 */
export const RegionalnyFallbackBundleVoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegionalnyFallbackBundleVoiceApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Zatwierdź dokładną treść zwykłego fallback
         * @param {string} lineId Identyfikator Voice Line
         * @param {string} proposalId Identyfikator propozycji
         * @param {ApproveVoiceFallbackContentDto} approveVoiceFallbackContentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceFallbackBundleControllerApproveContent(lineId: string, proposalId: string, approveVoiceFallbackContentDto: ApproveVoiceFallbackContentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceFallbackContentApprovalResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceFallbackBundleControllerApproveContent(lineId, proposalId, approveVoiceFallbackContentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz historię zatwierdzeń treści fallback
         * @param {string} lineId Identyfikator Voice Line
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceFallbackBundleControllerGetContentApprovalHistory(lineId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoiceFallbackContentApprovalHistoryResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceFallbackBundleControllerGetContentApprovalHistory(lineId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz bieżące wiązanie Fallback Bundle
         * @param {string} lineId Identyfikator Voice Line
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceFallbackBundleControllerGetCurrent(lineId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceFallbackBundleBindingResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceFallbackBundleControllerGetCurrent(lineId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz zachowaną historię Fallback Bundle
         * @param {string} lineId Identyfikator Voice Line
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceFallbackBundleControllerGetHistory(lineId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoiceFallbackBundleRevisionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceFallbackBundleControllerGetHistory(lineId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zaproponuj dokładną treść zwykłego fallback
         * @param {string} lineId Identyfikator Voice Line
         * @param {ProposeVoiceFallbackContentApprovalDto} proposeVoiceFallbackContentApprovalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceFallbackBundleControllerProposeContent(lineId: string, proposeVoiceFallbackContentApprovalDto: ProposeVoiceFallbackContentApprovalDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceFallbackContentProposalResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceFallbackBundleControllerProposeContent(lineId, proposeVoiceFallbackContentApprovalDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Opublikuj atomową rewizję Fallback Bundle
         * @param {string} lineId Identyfikator Voice Line
         * @param {PublishVoiceFallbackBundleDto} publishVoiceFallbackBundleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceFallbackBundleControllerPublish(lineId: string, publishVoiceFallbackBundleDto: PublishVoiceFallbackBundleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceFallbackBundleRevisionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceFallbackBundleControllerPublish(lineId, publishVoiceFallbackBundleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Odczytaj i uzgodnij Fallback Bundle ze stanem dostawcy
         * @param {string} lineId Identyfikator Voice Line
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceFallbackBundleControllerReconcile(lineId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceFallbackBundleBindingResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceFallbackBundleControllerReconcile(lineId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegionalnyFallbackBundleVoiceApi - factory interface
 * @export
 */
export const RegionalnyFallbackBundleVoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegionalnyFallbackBundleVoiceApiFp(configuration)
    return {
        /**
         *
         * @summary Zatwierdź dokładną treść zwykłego fallback
         * @param {RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerApproveContentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceFallbackBundleControllerApproveContent(requestParameters: RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerApproveContentRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceFallbackContentApprovalResponseDto> {
            return localVarFp.voiceFallbackBundleControllerApproveContent(requestParameters.lineId, requestParameters.proposalId, requestParameters.approveVoiceFallbackContentDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz historię zatwierdzeń treści fallback
         * @param {RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetContentApprovalHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceFallbackBundleControllerGetContentApprovalHistory(requestParameters: RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetContentApprovalHistoryRequest, options?: AxiosRequestConfig): AxiosPromise<Array<VoiceFallbackContentApprovalHistoryResponseDto>> {
            return localVarFp.voiceFallbackBundleControllerGetContentApprovalHistory(requestParameters.lineId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz bieżące wiązanie Fallback Bundle
         * @param {RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetCurrentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceFallbackBundleControllerGetCurrent(requestParameters: RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetCurrentRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceFallbackBundleBindingResponseDto> {
            return localVarFp.voiceFallbackBundleControllerGetCurrent(requestParameters.lineId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz zachowaną historię Fallback Bundle
         * @param {RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceFallbackBundleControllerGetHistory(requestParameters: RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetHistoryRequest, options?: AxiosRequestConfig): AxiosPromise<Array<VoiceFallbackBundleRevisionResponseDto>> {
            return localVarFp.voiceFallbackBundleControllerGetHistory(requestParameters.lineId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zaproponuj dokładną treść zwykłego fallback
         * @param {RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerProposeContentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceFallbackBundleControllerProposeContent(requestParameters: RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerProposeContentRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceFallbackContentProposalResponseDto> {
            return localVarFp.voiceFallbackBundleControllerProposeContent(requestParameters.lineId, requestParameters.proposeVoiceFallbackContentApprovalDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opublikuj atomową rewizję Fallback Bundle
         * @param {RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerPublishRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceFallbackBundleControllerPublish(requestParameters: RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerPublishRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceFallbackBundleRevisionResponseDto> {
            return localVarFp.voiceFallbackBundleControllerPublish(requestParameters.lineId, requestParameters.publishVoiceFallbackBundleDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Odczytaj i uzgodnij Fallback Bundle ze stanem dostawcy
         * @param {RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerReconcileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceFallbackBundleControllerReconcile(requestParameters: RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerReconcileRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceFallbackBundleBindingResponseDto> {
            return localVarFp.voiceFallbackBundleControllerReconcile(requestParameters.lineId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceFallbackBundleControllerApproveContent operation in RegionalnyFallbackBundleVoiceApi.
 * @export
 * @interface RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerApproveContentRequest
 */
export interface RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerApproveContentRequest {
    /**
     * Identyfikator Voice Line
     * @type {string}
     * @memberof RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerApproveContent
     */
    readonly lineId: string

    /**
     * Identyfikator propozycji
     * @type {string}
     * @memberof RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerApproveContent
     */
    readonly proposalId: string

    /**
     *
     * @type {ApproveVoiceFallbackContentDto}
     * @memberof RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerApproveContent
     */
    readonly approveVoiceFallbackContentDto: ApproveVoiceFallbackContentDto
}

/**
 * Request parameters for voiceFallbackBundleControllerGetContentApprovalHistory operation in RegionalnyFallbackBundleVoiceApi.
 * @export
 * @interface RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetContentApprovalHistoryRequest
 */
export interface RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetContentApprovalHistoryRequest {
    /**
     * Identyfikator Voice Line
     * @type {string}
     * @memberof RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetContentApprovalHistory
     */
    readonly lineId: string
}

/**
 * Request parameters for voiceFallbackBundleControllerGetCurrent operation in RegionalnyFallbackBundleVoiceApi.
 * @export
 * @interface RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetCurrentRequest
 */
export interface RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetCurrentRequest {
    /**
     * Identyfikator Voice Line
     * @type {string}
     * @memberof RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetCurrent
     */
    readonly lineId: string
}

/**
 * Request parameters for voiceFallbackBundleControllerGetHistory operation in RegionalnyFallbackBundleVoiceApi.
 * @export
 * @interface RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetHistoryRequest
 */
export interface RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetHistoryRequest {
    /**
     * Identyfikator Voice Line
     * @type {string}
     * @memberof RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetHistory
     */
    readonly lineId: string
}

/**
 * Request parameters for voiceFallbackBundleControllerProposeContent operation in RegionalnyFallbackBundleVoiceApi.
 * @export
 * @interface RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerProposeContentRequest
 */
export interface RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerProposeContentRequest {
    /**
     * Identyfikator Voice Line
     * @type {string}
     * @memberof RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerProposeContent
     */
    readonly lineId: string

    /**
     *
     * @type {ProposeVoiceFallbackContentApprovalDto}
     * @memberof RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerProposeContent
     */
    readonly proposeVoiceFallbackContentApprovalDto: ProposeVoiceFallbackContentApprovalDto
}

/**
 * Request parameters for voiceFallbackBundleControllerPublish operation in RegionalnyFallbackBundleVoiceApi.
 * @export
 * @interface RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerPublishRequest
 */
export interface RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerPublishRequest {
    /**
     * Identyfikator Voice Line
     * @type {string}
     * @memberof RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerPublish
     */
    readonly lineId: string

    /**
     *
     * @type {PublishVoiceFallbackBundleDto}
     * @memberof RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerPublish
     */
    readonly publishVoiceFallbackBundleDto: PublishVoiceFallbackBundleDto
}

/**
 * Request parameters for voiceFallbackBundleControllerReconcile operation in RegionalnyFallbackBundleVoiceApi.
 * @export
 * @interface RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerReconcileRequest
 */
export interface RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerReconcileRequest {
    /**
     * Identyfikator Voice Line
     * @type {string}
     * @memberof RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerReconcile
     */
    readonly lineId: string
}

/**
 * RegionalnyFallbackBundleVoiceApi - object-oriented interface
 * @export
 * @class RegionalnyFallbackBundleVoiceApi
 * @extends {BaseAPI}
 */
export class RegionalnyFallbackBundleVoiceApi extends BaseAPI {
    /**
     *
     * @summary Zatwierdź dokładną treść zwykłego fallback
     * @param {RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerApproveContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegionalnyFallbackBundleVoiceApi
     */
    public voiceFallbackBundleControllerApproveContent(requestParameters: RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerApproveContentRequest, options?: AxiosRequestConfig) {
        return RegionalnyFallbackBundleVoiceApiFp(this.configuration).voiceFallbackBundleControllerApproveContent(requestParameters.lineId, requestParameters.proposalId, requestParameters.approveVoiceFallbackContentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz historię zatwierdzeń treści fallback
     * @param {RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetContentApprovalHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegionalnyFallbackBundleVoiceApi
     */
    public voiceFallbackBundleControllerGetContentApprovalHistory(requestParameters: RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetContentApprovalHistoryRequest, options?: AxiosRequestConfig) {
        return RegionalnyFallbackBundleVoiceApiFp(this.configuration).voiceFallbackBundleControllerGetContentApprovalHistory(requestParameters.lineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz bieżące wiązanie Fallback Bundle
     * @param {RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetCurrentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegionalnyFallbackBundleVoiceApi
     */
    public voiceFallbackBundleControllerGetCurrent(requestParameters: RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetCurrentRequest, options?: AxiosRequestConfig) {
        return RegionalnyFallbackBundleVoiceApiFp(this.configuration).voiceFallbackBundleControllerGetCurrent(requestParameters.lineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz zachowaną historię Fallback Bundle
     * @param {RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegionalnyFallbackBundleVoiceApi
     */
    public voiceFallbackBundleControllerGetHistory(requestParameters: RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerGetHistoryRequest, options?: AxiosRequestConfig) {
        return RegionalnyFallbackBundleVoiceApiFp(this.configuration).voiceFallbackBundleControllerGetHistory(requestParameters.lineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zaproponuj dokładną treść zwykłego fallback
     * @param {RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerProposeContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegionalnyFallbackBundleVoiceApi
     */
    public voiceFallbackBundleControllerProposeContent(requestParameters: RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerProposeContentRequest, options?: AxiosRequestConfig) {
        return RegionalnyFallbackBundleVoiceApiFp(this.configuration).voiceFallbackBundleControllerProposeContent(requestParameters.lineId, requestParameters.proposeVoiceFallbackContentApprovalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Opublikuj atomową rewizję Fallback Bundle
     * @param {RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerPublishRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegionalnyFallbackBundleVoiceApi
     */
    public voiceFallbackBundleControllerPublish(requestParameters: RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerPublishRequest, options?: AxiosRequestConfig) {
        return RegionalnyFallbackBundleVoiceApiFp(this.configuration).voiceFallbackBundleControllerPublish(requestParameters.lineId, requestParameters.publishVoiceFallbackBundleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Odczytaj i uzgodnij Fallback Bundle ze stanem dostawcy
     * @param {RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerReconcileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegionalnyFallbackBundleVoiceApi
     */
    public voiceFallbackBundleControllerReconcile(requestParameters: RegionalnyFallbackBundleVoiceApiVoiceFallbackBundleControllerReconcileRequest, options?: AxiosRequestConfig) {
        return RegionalnyFallbackBundleVoiceApiFp(this.configuration).voiceFallbackBundleControllerReconcile(requestParameters.lineId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RegisterApi - axios parameter creator
 * @export
 */
export const RegisterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Register professional user with email and password
         * @param {RegisterProfessionalDto} registerProfessionalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerControllerRegisterProfessionalUser: async (registerProfessionalDto: RegisterProfessionalDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerProfessionalDto' is not null or undefined
            assertParamExists('registerControllerRegisterProfessionalUser', 'registerProfessionalDto', registerProfessionalDto)
            const localVarPath = `/register/professional`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerProfessionalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Register user with email and password
         * @param {RegisterUserDto} registerUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerControllerRegisterUser: async (registerUserDto: RegisterUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerUserDto' is not null or undefined
            assertParamExists('registerControllerRegisterUser', 'registerUserDto', registerUserDto)
            const localVarPath = `/register/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegisterApi - functional programming interface
 * @export
 */
export const RegisterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegisterApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Register professional user with email and password
         * @param {RegisterProfessionalDto} registerProfessionalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerControllerRegisterProfessionalUser(registerProfessionalDto: RegisterProfessionalDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerControllerRegisterProfessionalUser(registerProfessionalDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Register user with email and password
         * @param {RegisterUserDto} registerUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerControllerRegisterUser(registerUserDto: RegisterUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerControllerRegisterUser(registerUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegisterApi - factory interface
 * @export
 */
export const RegisterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegisterApiFp(configuration)
    return {
        /**
         *
         * @summary Register professional user with email and password
         * @param {RegisterApiRegisterControllerRegisterProfessionalUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerControllerRegisterProfessionalUser(requestParameters: RegisterApiRegisterControllerRegisterProfessionalUserRequest, options?: AxiosRequestConfig): AxiosPromise<GetUserDto> {
            return localVarFp.registerControllerRegisterProfessionalUser(requestParameters.registerProfessionalDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Register user with email and password
         * @param {RegisterApiRegisterControllerRegisterUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerControllerRegisterUser(requestParameters: RegisterApiRegisterControllerRegisterUserRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.registerControllerRegisterUser(requestParameters.registerUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for registerControllerRegisterProfessionalUser operation in RegisterApi.
 * @export
 * @interface RegisterApiRegisterControllerRegisterProfessionalUserRequest
 */
export interface RegisterApiRegisterControllerRegisterProfessionalUserRequest {
    /**
     *
     * @type {RegisterProfessionalDto}
     * @memberof RegisterApiRegisterControllerRegisterProfessionalUser
     */
    readonly registerProfessionalDto: RegisterProfessionalDto
}

/**
 * Request parameters for registerControllerRegisterUser operation in RegisterApi.
 * @export
 * @interface RegisterApiRegisterControllerRegisterUserRequest
 */
export interface RegisterApiRegisterControllerRegisterUserRequest {
    /**
     *
     * @type {RegisterUserDto}
     * @memberof RegisterApiRegisterControllerRegisterUser
     */
    readonly registerUserDto: RegisterUserDto
}

/**
 * RegisterApi - object-oriented interface
 * @export
 * @class RegisterApi
 * @extends {BaseAPI}
 */
export class RegisterApi extends BaseAPI {
    /**
     *
     * @summary Register professional user with email and password
     * @param {RegisterApiRegisterControllerRegisterProfessionalUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegisterApi
     */
    public registerControllerRegisterProfessionalUser(requestParameters: RegisterApiRegisterControllerRegisterProfessionalUserRequest, options?: AxiosRequestConfig) {
        return RegisterApiFp(this.configuration).registerControllerRegisterProfessionalUser(requestParameters.registerProfessionalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Register user with email and password
     * @param {RegisterApiRegisterControllerRegisterUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegisterApi
     */
    public registerControllerRegisterUser(requestParameters: RegisterApiRegisterControllerRegisterUserRequest, options?: AxiosRequestConfig) {
        return RegisterApiFp(this.configuration).registerControllerRegisterUser(requestParameters.registerUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RejestrVoiceLineApi - axios parameter creator
 * @export
 */
export const RejestrVoiceLineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Potwierdź zweryfikowany checkpoint odzyskiwania po prywatności
         * @param {string} lineId Identyfikator Voice Line
         * @param {AdvanceVoiceLineProviderPrivacyRecoveryDto} advanceVoiceLineProviderPrivacyRecoveryDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerAdvanceProviderPrivacyRecovery: async (lineId: string, advanceVoiceLineProviderPrivacyRecoveryDto: AdvanceVoiceLineProviderPrivacyRecoveryDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('voiceLineRegistryControllerAdvanceProviderPrivacyRecovery', 'lineId', lineId)
            // verify required parameter 'advanceVoiceLineProviderPrivacyRecoveryDto' is not null or undefined
            assertParamExists('voiceLineRegistryControllerAdvanceProviderPrivacyRecovery', 'advanceVoiceLineProviderPrivacyRecoveryDto', advanceVoiceLineProviderPrivacyRecoveryDto)
            const localVarPath = `/api/voice-platform/lines/{lineId}/provider-privacy-recovery/checkpoints`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(advanceVoiceLineProviderPrivacyRecoveryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Przypisz Voice Line do Organization
         * @param {string} lineId Identyfikator Voice Line
         * @param {AssignVoiceLineDto} assignVoiceLineDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerAssignLine: async (lineId: string, assignVoiceLineDto: AssignVoiceLineDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('voiceLineRegistryControllerAssignLine', 'lineId', lineId)
            // verify required parameter 'assignVoiceLineDto' is not null or undefined
            assertParamExists('voiceLineRegistryControllerAssignLine', 'assignVoiceLineDto', assignVoiceLineDto)
            const localVarPath = `/api/voice-platform/lines/{lineId}/assignments`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignVoiceLineDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz trwały stan odzyskiwania po incydencie prywatności
         * @param {string} lineId Identyfikator Voice Line
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerGetProviderPrivacyRecovery: async (lineId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('voiceLineRegistryControllerGetProviderPrivacyRecovery', 'lineId', lineId)
            const localVarPath = `/api/voice-platform/lines/{lineId}/provider-privacy-recovery`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz historyczny stan odzyskiwania po jego identyfikatorze
         * @param {string} lineId Identyfikator Voice Line
         * @param {string} recoveryId Identyfikator odzyskiwania
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerGetProviderPrivacyRecoveryById: async (lineId: string, recoveryId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('voiceLineRegistryControllerGetProviderPrivacyRecoveryById', 'lineId', lineId)
            // verify required parameter 'recoveryId' is not null or undefined
            assertParamExists('voiceLineRegistryControllerGetProviderPrivacyRecoveryById', 'recoveryId', recoveryId)
            const localVarPath = `/api/voice-platform/lines/{lineId}/provider-privacy-recoveries/{recoveryId}`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)))
                .replace(`{${"recoveryId"}}`, encodeURIComponent(String(recoveryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz niezmienną historię przypisań Voice Line
         * @param {string} lineId Identyfikator Voice Line
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerListAssignmentHistory: async (lineId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('voiceLineRegistryControllerListAssignmentHistory', 'lineId', lineId)
            const localVarPath = `/api/voice-platform/lines/{lineId}/assignments`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz zarządzany rejestr Voice Line
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerListLines: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/lines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Uzgodnij Voice Line ze stanem dostawcy
         * @param {string} lineId Identyfikator Voice Line
         * @param {ReconcileVoiceLineDto} reconcileVoiceLineDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerReconcileLine: async (lineId: string, reconcileVoiceLineDto: ReconcileVoiceLineDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('voiceLineRegistryControllerReconcileLine', 'lineId', lineId)
            // verify required parameter 'reconcileVoiceLineDto' is not null or undefined
            assertParamExists('voiceLineRegistryControllerReconcileLine', 'reconcileVoiceLineDto', reconcileVoiceLineDto)
            const localVarPath = `/api/voice-platform/lines/{lineId}/reconcile`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reconcileVoiceLineDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zarejestruj zakupiony wcześniej Voice Line
         * @param {RegisterManagedVoiceLineDto} registerManagedVoiceLineDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerRegisterManagedLine: async (registerManagedVoiceLineDto: RegisterManagedVoiceLineDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerManagedVoiceLineDto' is not null or undefined
            assertParamExists('voiceLineRegistryControllerRegisterManagedLine', 'registerManagedVoiceLineDto', registerManagedVoiceLineDto)
            const localVarPath = `/api/voice-platform/lines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerManagedVoiceLineDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Rozpocznij drain przed odłączeniem Voice Line
         * @param {string} lineId Identyfikator Voice Line
         * @param {string} assignmentId Identyfikator aktywnego Voice Line Assignment
         * @param {RequestVoiceLineDetachDto} requestVoiceLineDetachDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerRequestDetach: async (lineId: string, assignmentId: string, requestVoiceLineDetachDto: RequestVoiceLineDetachDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('voiceLineRegistryControllerRequestDetach', 'lineId', lineId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('voiceLineRegistryControllerRequestDetach', 'assignmentId', assignmentId)
            // verify required parameter 'requestVoiceLineDetachDto' is not null or undefined
            assertParamExists('voiceLineRegistryControllerRequestDetach', 'requestVoiceLineDetachDto', requestVoiceLineDetachDto)
            const localVarPath = `/api/voice-platform/lines/{lineId}/assignments/{assignmentId}/detach`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestVoiceLineDetachDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RejestrVoiceLineApi - functional programming interface
 * @export
 */
export const RejestrVoiceLineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RejestrVoiceLineApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Potwierdź zweryfikowany checkpoint odzyskiwania po prywatności
         * @param {string} lineId Identyfikator Voice Line
         * @param {AdvanceVoiceLineProviderPrivacyRecoveryDto} advanceVoiceLineProviderPrivacyRecoveryDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceLineRegistryControllerAdvanceProviderPrivacyRecovery(lineId: string, advanceVoiceLineProviderPrivacyRecoveryDto: AdvanceVoiceLineProviderPrivacyRecoveryDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceLineProviderPrivacyRecoveryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceLineRegistryControllerAdvanceProviderPrivacyRecovery(lineId, advanceVoiceLineProviderPrivacyRecoveryDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Przypisz Voice Line do Organization
         * @param {string} lineId Identyfikator Voice Line
         * @param {AssignVoiceLineDto} assignVoiceLineDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceLineRegistryControllerAssignLine(lineId: string, assignVoiceLineDto: AssignVoiceLineDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceLineResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceLineRegistryControllerAssignLine(lineId, assignVoiceLineDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz trwały stan odzyskiwania po incydencie prywatności
         * @param {string} lineId Identyfikator Voice Line
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceLineRegistryControllerGetProviderPrivacyRecovery(lineId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceLineProviderPrivacyRecoveryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceLineRegistryControllerGetProviderPrivacyRecovery(lineId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz historyczny stan odzyskiwania po jego identyfikatorze
         * @param {string} lineId Identyfikator Voice Line
         * @param {string} recoveryId Identyfikator odzyskiwania
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceLineRegistryControllerGetProviderPrivacyRecoveryById(lineId: string, recoveryId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceLineProviderPrivacyRecoveryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceLineRegistryControllerGetProviderPrivacyRecoveryById(lineId, recoveryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz niezmienną historię przypisań Voice Line
         * @param {string} lineId Identyfikator Voice Line
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceLineRegistryControllerListAssignmentHistory(lineId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoiceLineAssignmentHistoryResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceLineRegistryControllerListAssignmentHistory(lineId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz zarządzany rejestr Voice Line
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceLineRegistryControllerListLines(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoiceLineResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceLineRegistryControllerListLines(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Uzgodnij Voice Line ze stanem dostawcy
         * @param {string} lineId Identyfikator Voice Line
         * @param {ReconcileVoiceLineDto} reconcileVoiceLineDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceLineRegistryControllerReconcileLine(lineId: string, reconcileVoiceLineDto: ReconcileVoiceLineDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceLineResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceLineRegistryControllerReconcileLine(lineId, reconcileVoiceLineDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zarejestruj zakupiony wcześniej Voice Line
         * @param {RegisterManagedVoiceLineDto} registerManagedVoiceLineDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceLineRegistryControllerRegisterManagedLine(registerManagedVoiceLineDto: RegisterManagedVoiceLineDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceLineResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceLineRegistryControllerRegisterManagedLine(registerManagedVoiceLineDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Rozpocznij drain przed odłączeniem Voice Line
         * @param {string} lineId Identyfikator Voice Line
         * @param {string} assignmentId Identyfikator aktywnego Voice Line Assignment
         * @param {RequestVoiceLineDetachDto} requestVoiceLineDetachDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceLineRegistryControllerRequestDetach(lineId: string, assignmentId: string, requestVoiceLineDetachDto: RequestVoiceLineDetachDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceLineResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceLineRegistryControllerRequestDetach(lineId, assignmentId, requestVoiceLineDetachDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RejestrVoiceLineApi - factory interface
 * @export
 */
export const RejestrVoiceLineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RejestrVoiceLineApiFp(configuration)
    return {
        /**
         *
         * @summary Potwierdź zweryfikowany checkpoint odzyskiwania po prywatności
         * @param {RejestrVoiceLineApiVoiceLineRegistryControllerAdvanceProviderPrivacyRecoveryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerAdvanceProviderPrivacyRecovery(requestParameters: RejestrVoiceLineApiVoiceLineRegistryControllerAdvanceProviderPrivacyRecoveryRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceLineProviderPrivacyRecoveryResponseDto> {
            return localVarFp.voiceLineRegistryControllerAdvanceProviderPrivacyRecovery(requestParameters.lineId, requestParameters.advanceVoiceLineProviderPrivacyRecoveryDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Przypisz Voice Line do Organization
         * @param {RejestrVoiceLineApiVoiceLineRegistryControllerAssignLineRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerAssignLine(requestParameters: RejestrVoiceLineApiVoiceLineRegistryControllerAssignLineRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceLineResponseDto> {
            return localVarFp.voiceLineRegistryControllerAssignLine(requestParameters.lineId, requestParameters.assignVoiceLineDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz trwały stan odzyskiwania po incydencie prywatności
         * @param {RejestrVoiceLineApiVoiceLineRegistryControllerGetProviderPrivacyRecoveryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerGetProviderPrivacyRecovery(requestParameters: RejestrVoiceLineApiVoiceLineRegistryControllerGetProviderPrivacyRecoveryRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceLineProviderPrivacyRecoveryResponseDto> {
            return localVarFp.voiceLineRegistryControllerGetProviderPrivacyRecovery(requestParameters.lineId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz historyczny stan odzyskiwania po jego identyfikatorze
         * @param {RejestrVoiceLineApiVoiceLineRegistryControllerGetProviderPrivacyRecoveryByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerGetProviderPrivacyRecoveryById(requestParameters: RejestrVoiceLineApiVoiceLineRegistryControllerGetProviderPrivacyRecoveryByIdRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceLineProviderPrivacyRecoveryResponseDto> {
            return localVarFp.voiceLineRegistryControllerGetProviderPrivacyRecoveryById(requestParameters.lineId, requestParameters.recoveryId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz niezmienną historię przypisań Voice Line
         * @param {RejestrVoiceLineApiVoiceLineRegistryControllerListAssignmentHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerListAssignmentHistory(requestParameters: RejestrVoiceLineApiVoiceLineRegistryControllerListAssignmentHistoryRequest, options?: AxiosRequestConfig): AxiosPromise<Array<VoiceLineAssignmentHistoryResponseDto>> {
            return localVarFp.voiceLineRegistryControllerListAssignmentHistory(requestParameters.lineId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz zarządzany rejestr Voice Line
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerListLines(options?: AxiosRequestConfig): AxiosPromise<Array<VoiceLineResponseDto>> {
            return localVarFp.voiceLineRegistryControllerListLines(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Uzgodnij Voice Line ze stanem dostawcy
         * @param {RejestrVoiceLineApiVoiceLineRegistryControllerReconcileLineRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerReconcileLine(requestParameters: RejestrVoiceLineApiVoiceLineRegistryControllerReconcileLineRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceLineResponseDto> {
            return localVarFp.voiceLineRegistryControllerReconcileLine(requestParameters.lineId, requestParameters.reconcileVoiceLineDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zarejestruj zakupiony wcześniej Voice Line
         * @param {RejestrVoiceLineApiVoiceLineRegistryControllerRegisterManagedLineRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerRegisterManagedLine(requestParameters: RejestrVoiceLineApiVoiceLineRegistryControllerRegisterManagedLineRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceLineResponseDto> {
            return localVarFp.voiceLineRegistryControllerRegisterManagedLine(requestParameters.registerManagedVoiceLineDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Rozpocznij drain przed odłączeniem Voice Line
         * @param {RejestrVoiceLineApiVoiceLineRegistryControllerRequestDetachRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceLineRegistryControllerRequestDetach(requestParameters: RejestrVoiceLineApiVoiceLineRegistryControllerRequestDetachRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceLineResponseDto> {
            return localVarFp.voiceLineRegistryControllerRequestDetach(requestParameters.lineId, requestParameters.assignmentId, requestParameters.requestVoiceLineDetachDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceLineRegistryControllerAdvanceProviderPrivacyRecovery operation in RejestrVoiceLineApi.
 * @export
 * @interface RejestrVoiceLineApiVoiceLineRegistryControllerAdvanceProviderPrivacyRecoveryRequest
 */
export interface RejestrVoiceLineApiVoiceLineRegistryControllerAdvanceProviderPrivacyRecoveryRequest {
    /**
     * Identyfikator Voice Line
     * @type {string}
     * @memberof RejestrVoiceLineApiVoiceLineRegistryControllerAdvanceProviderPrivacyRecovery
     */
    readonly lineId: string

    /**
     *
     * @type {AdvanceVoiceLineProviderPrivacyRecoveryDto}
     * @memberof RejestrVoiceLineApiVoiceLineRegistryControllerAdvanceProviderPrivacyRecovery
     */
    readonly advanceVoiceLineProviderPrivacyRecoveryDto: AdvanceVoiceLineProviderPrivacyRecoveryDto
}

/**
 * Request parameters for voiceLineRegistryControllerAssignLine operation in RejestrVoiceLineApi.
 * @export
 * @interface RejestrVoiceLineApiVoiceLineRegistryControllerAssignLineRequest
 */
export interface RejestrVoiceLineApiVoiceLineRegistryControllerAssignLineRequest {
    /**
     * Identyfikator Voice Line
     * @type {string}
     * @memberof RejestrVoiceLineApiVoiceLineRegistryControllerAssignLine
     */
    readonly lineId: string

    /**
     *
     * @type {AssignVoiceLineDto}
     * @memberof RejestrVoiceLineApiVoiceLineRegistryControllerAssignLine
     */
    readonly assignVoiceLineDto: AssignVoiceLineDto
}

/**
 * Request parameters for voiceLineRegistryControllerGetProviderPrivacyRecovery operation in RejestrVoiceLineApi.
 * @export
 * @interface RejestrVoiceLineApiVoiceLineRegistryControllerGetProviderPrivacyRecoveryRequest
 */
export interface RejestrVoiceLineApiVoiceLineRegistryControllerGetProviderPrivacyRecoveryRequest {
    /**
     * Identyfikator Voice Line
     * @type {string}
     * @memberof RejestrVoiceLineApiVoiceLineRegistryControllerGetProviderPrivacyRecovery
     */
    readonly lineId: string
}

/**
 * Request parameters for voiceLineRegistryControllerGetProviderPrivacyRecoveryById operation in RejestrVoiceLineApi.
 * @export
 * @interface RejestrVoiceLineApiVoiceLineRegistryControllerGetProviderPrivacyRecoveryByIdRequest
 */
export interface RejestrVoiceLineApiVoiceLineRegistryControllerGetProviderPrivacyRecoveryByIdRequest {
    /**
     * Identyfikator Voice Line
     * @type {string}
     * @memberof RejestrVoiceLineApiVoiceLineRegistryControllerGetProviderPrivacyRecoveryById
     */
    readonly lineId: string

    /**
     * Identyfikator odzyskiwania
     * @type {string}
     * @memberof RejestrVoiceLineApiVoiceLineRegistryControllerGetProviderPrivacyRecoveryById
     */
    readonly recoveryId: string
}

/**
 * Request parameters for voiceLineRegistryControllerListAssignmentHistory operation in RejestrVoiceLineApi.
 * @export
 * @interface RejestrVoiceLineApiVoiceLineRegistryControllerListAssignmentHistoryRequest
 */
export interface RejestrVoiceLineApiVoiceLineRegistryControllerListAssignmentHistoryRequest {
    /**
     * Identyfikator Voice Line
     * @type {string}
     * @memberof RejestrVoiceLineApiVoiceLineRegistryControllerListAssignmentHistory
     */
    readonly lineId: string
}

/**
 * Request parameters for voiceLineRegistryControllerReconcileLine operation in RejestrVoiceLineApi.
 * @export
 * @interface RejestrVoiceLineApiVoiceLineRegistryControllerReconcileLineRequest
 */
export interface RejestrVoiceLineApiVoiceLineRegistryControllerReconcileLineRequest {
    /**
     * Identyfikator Voice Line
     * @type {string}
     * @memberof RejestrVoiceLineApiVoiceLineRegistryControllerReconcileLine
     */
    readonly lineId: string

    /**
     *
     * @type {ReconcileVoiceLineDto}
     * @memberof RejestrVoiceLineApiVoiceLineRegistryControllerReconcileLine
     */
    readonly reconcileVoiceLineDto: ReconcileVoiceLineDto
}

/**
 * Request parameters for voiceLineRegistryControllerRegisterManagedLine operation in RejestrVoiceLineApi.
 * @export
 * @interface RejestrVoiceLineApiVoiceLineRegistryControllerRegisterManagedLineRequest
 */
export interface RejestrVoiceLineApiVoiceLineRegistryControllerRegisterManagedLineRequest {
    /**
     *
     * @type {RegisterManagedVoiceLineDto}
     * @memberof RejestrVoiceLineApiVoiceLineRegistryControllerRegisterManagedLine
     */
    readonly registerManagedVoiceLineDto: RegisterManagedVoiceLineDto
}

/**
 * Request parameters for voiceLineRegistryControllerRequestDetach operation in RejestrVoiceLineApi.
 * @export
 * @interface RejestrVoiceLineApiVoiceLineRegistryControllerRequestDetachRequest
 */
export interface RejestrVoiceLineApiVoiceLineRegistryControllerRequestDetachRequest {
    /**
     * Identyfikator Voice Line
     * @type {string}
     * @memberof RejestrVoiceLineApiVoiceLineRegistryControllerRequestDetach
     */
    readonly lineId: string

    /**
     * Identyfikator aktywnego Voice Line Assignment
     * @type {string}
     * @memberof RejestrVoiceLineApiVoiceLineRegistryControllerRequestDetach
     */
    readonly assignmentId: string

    /**
     *
     * @type {RequestVoiceLineDetachDto}
     * @memberof RejestrVoiceLineApiVoiceLineRegistryControllerRequestDetach
     */
    readonly requestVoiceLineDetachDto: RequestVoiceLineDetachDto
}

/**
 * RejestrVoiceLineApi - object-oriented interface
 * @export
 * @class RejestrVoiceLineApi
 * @extends {BaseAPI}
 */
export class RejestrVoiceLineApi extends BaseAPI {
    /**
     *
     * @summary Potwierdź zweryfikowany checkpoint odzyskiwania po prywatności
     * @param {RejestrVoiceLineApiVoiceLineRegistryControllerAdvanceProviderPrivacyRecoveryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RejestrVoiceLineApi
     */
    public voiceLineRegistryControllerAdvanceProviderPrivacyRecovery(requestParameters: RejestrVoiceLineApiVoiceLineRegistryControllerAdvanceProviderPrivacyRecoveryRequest, options?: AxiosRequestConfig) {
        return RejestrVoiceLineApiFp(this.configuration).voiceLineRegistryControllerAdvanceProviderPrivacyRecovery(requestParameters.lineId, requestParameters.advanceVoiceLineProviderPrivacyRecoveryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Przypisz Voice Line do Organization
     * @param {RejestrVoiceLineApiVoiceLineRegistryControllerAssignLineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RejestrVoiceLineApi
     */
    public voiceLineRegistryControllerAssignLine(requestParameters: RejestrVoiceLineApiVoiceLineRegistryControllerAssignLineRequest, options?: AxiosRequestConfig) {
        return RejestrVoiceLineApiFp(this.configuration).voiceLineRegistryControllerAssignLine(requestParameters.lineId, requestParameters.assignVoiceLineDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz trwały stan odzyskiwania po incydencie prywatności
     * @param {RejestrVoiceLineApiVoiceLineRegistryControllerGetProviderPrivacyRecoveryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RejestrVoiceLineApi
     */
    public voiceLineRegistryControllerGetProviderPrivacyRecovery(requestParameters: RejestrVoiceLineApiVoiceLineRegistryControllerGetProviderPrivacyRecoveryRequest, options?: AxiosRequestConfig) {
        return RejestrVoiceLineApiFp(this.configuration).voiceLineRegistryControllerGetProviderPrivacyRecovery(requestParameters.lineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz historyczny stan odzyskiwania po jego identyfikatorze
     * @param {RejestrVoiceLineApiVoiceLineRegistryControllerGetProviderPrivacyRecoveryByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RejestrVoiceLineApi
     */
    public voiceLineRegistryControllerGetProviderPrivacyRecoveryById(requestParameters: RejestrVoiceLineApiVoiceLineRegistryControllerGetProviderPrivacyRecoveryByIdRequest, options?: AxiosRequestConfig) {
        return RejestrVoiceLineApiFp(this.configuration).voiceLineRegistryControllerGetProviderPrivacyRecoveryById(requestParameters.lineId, requestParameters.recoveryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz niezmienną historię przypisań Voice Line
     * @param {RejestrVoiceLineApiVoiceLineRegistryControllerListAssignmentHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RejestrVoiceLineApi
     */
    public voiceLineRegistryControllerListAssignmentHistory(requestParameters: RejestrVoiceLineApiVoiceLineRegistryControllerListAssignmentHistoryRequest, options?: AxiosRequestConfig) {
        return RejestrVoiceLineApiFp(this.configuration).voiceLineRegistryControllerListAssignmentHistory(requestParameters.lineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz zarządzany rejestr Voice Line
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RejestrVoiceLineApi
     */
    public voiceLineRegistryControllerListLines(options?: AxiosRequestConfig) {
        return RejestrVoiceLineApiFp(this.configuration).voiceLineRegistryControllerListLines(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Uzgodnij Voice Line ze stanem dostawcy
     * @param {RejestrVoiceLineApiVoiceLineRegistryControllerReconcileLineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RejestrVoiceLineApi
     */
    public voiceLineRegistryControllerReconcileLine(requestParameters: RejestrVoiceLineApiVoiceLineRegistryControllerReconcileLineRequest, options?: AxiosRequestConfig) {
        return RejestrVoiceLineApiFp(this.configuration).voiceLineRegistryControllerReconcileLine(requestParameters.lineId, requestParameters.reconcileVoiceLineDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zarejestruj zakupiony wcześniej Voice Line
     * @param {RejestrVoiceLineApiVoiceLineRegistryControllerRegisterManagedLineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RejestrVoiceLineApi
     */
    public voiceLineRegistryControllerRegisterManagedLine(requestParameters: RejestrVoiceLineApiVoiceLineRegistryControllerRegisterManagedLineRequest, options?: AxiosRequestConfig) {
        return RejestrVoiceLineApiFp(this.configuration).voiceLineRegistryControllerRegisterManagedLine(requestParameters.registerManagedVoiceLineDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Rozpocznij drain przed odłączeniem Voice Line
     * @param {RejestrVoiceLineApiVoiceLineRegistryControllerRequestDetachRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RejestrVoiceLineApi
     */
    public voiceLineRegistryControllerRequestDetach(requestParameters: RejestrVoiceLineApiVoiceLineRegistryControllerRequestDetachRequest, options?: AxiosRequestConfig) {
        return RejestrVoiceLineApiFp(this.configuration).voiceLineRegistryControllerRequestDetach(requestParameters.lineId, requestParameters.assignmentId, requestParameters.requestVoiceLineDetachDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReminderApi - axios parameter creator
 * @export
 */
export const ReminderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create a new reminder for a profile
         * @param {CreateReminderDto} createReminderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderControllerCreateReminder: async (createReminderDto: CreateReminderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createReminderDto' is not null or undefined
            assertParamExists('reminderControllerCreateReminder', 'createReminderDto', createReminderDto)
            const localVarPath = `/api/reminder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReminderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a reminder
         * @param {string} reminderId
         * @param {string} [visitId] Optional visit ID to track deletion as visit activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderControllerDeleteReminder: async (reminderId: string, visitId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reminderId' is not null or undefined
            assertParamExists('reminderControllerDeleteReminder', 'reminderId', reminderId)
            const localVarPath = `/api/reminder/{reminderId}`
                .replace(`{${"reminderId"}}`, encodeURIComponent(String(reminderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (visitId !== undefined) {
                localVarQueryParameter['visitId'] = visitId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all reminders for a profile
         * @param {string} profileId
         * @param {number} [page] Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
         * @param {number} [limit] Rows per page. Omit together with &#x60;page&#x60; to get every row.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderControllerGetProfileReminders: async (profileId: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('reminderControllerGetProfileReminders', 'profileId', profileId)
            const localVarPath = `/api/reminder/profile/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get reminder linked to a specific medication
         * @param {string} profileId
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderControllerGetReminderByMedicationId: async (profileId: string, medicationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('reminderControllerGetReminderByMedicationId', 'profileId', profileId)
            // verify required parameter 'medicationId' is not null or undefined
            assertParamExists('reminderControllerGetReminderByMedicationId', 'medicationId', medicationId)
            const localVarPath = `/api/reminder/profile/{profileId}/medication/{medicationId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"medicationId"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get reminders bound to a specific visit (auth-user-owned OR same-org guest). Returns [] for unauthorised callers — the FE silently hides the Przypomnienia tab when empty.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderControllerGetVisitReminders: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('reminderControllerGetVisitReminders', 'visitId', visitId)
            const localVarPath = `/api/reminder/visit/{visitId}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a reminder
         * @param {string} reminderId
         * @param {UpdateReminderDto} updateReminderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderControllerUpdateReminder: async (reminderId: string, updateReminderDto: UpdateReminderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reminderId' is not null or undefined
            assertParamExists('reminderControllerUpdateReminder', 'reminderId', reminderId)
            // verify required parameter 'updateReminderDto' is not null or undefined
            assertParamExists('reminderControllerUpdateReminder', 'updateReminderDto', updateReminderDto)
            const localVarPath = `/api/reminder/{reminderId}`
                .replace(`{${"reminderId"}}`, encodeURIComponent(String(reminderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReminderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReminderApi - functional programming interface
 * @export
 */
export const ReminderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReminderApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create a new reminder for a profile
         * @param {CreateReminderDto} createReminderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reminderControllerCreateReminder(createReminderDto: CreateReminderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReminderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reminderControllerCreateReminder(createReminderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a reminder
         * @param {string} reminderId
         * @param {string} [visitId] Optional visit ID to track deletion as visit activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reminderControllerDeleteReminder(reminderId: string, visitId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reminderControllerDeleteReminder(reminderId, visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all reminders for a profile
         * @param {string} profileId
         * @param {number} [page] Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
         * @param {number} [limit] Rows per page. Omit together with &#x60;page&#x60; to get every row.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reminderControllerGetProfileReminders(profileId: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRemindersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reminderControllerGetProfileReminders(profileId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get reminder linked to a specific medication
         * @param {string} profileId
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reminderControllerGetReminderByMedicationId(profileId: string, medicationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReminderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reminderControllerGetReminderByMedicationId(profileId, medicationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get reminders bound to a specific visit (auth-user-owned OR same-org guest). Returns [] for unauthorised callers — the FE silently hides the Przypomnienia tab when empty.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reminderControllerGetVisitReminders(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetReminderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reminderControllerGetVisitReminders(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update a reminder
         * @param {string} reminderId
         * @param {UpdateReminderDto} updateReminderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reminderControllerUpdateReminder(reminderId: string, updateReminderDto: UpdateReminderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReminderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reminderControllerUpdateReminder(reminderId, updateReminderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReminderApi - factory interface
 * @export
 */
export const ReminderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReminderApiFp(configuration)
    return {
        /**
         *
         * @summary Create a new reminder for a profile
         * @param {ReminderApiReminderControllerCreateReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderControllerCreateReminder(requestParameters: ReminderApiReminderControllerCreateReminderRequest, options?: AxiosRequestConfig): AxiosPromise<GetReminderDto> {
            return localVarFp.reminderControllerCreateReminder(requestParameters.createReminderDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a reminder
         * @param {ReminderApiReminderControllerDeleteReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderControllerDeleteReminder(requestParameters: ReminderApiReminderControllerDeleteReminderRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reminderControllerDeleteReminder(requestParameters.reminderId, requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all reminders for a profile
         * @param {ReminderApiReminderControllerGetProfileRemindersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderControllerGetProfileReminders(requestParameters: ReminderApiReminderControllerGetProfileRemindersRequest, options?: AxiosRequestConfig): AxiosPromise<PaginatedRemindersResponseDto> {
            return localVarFp.reminderControllerGetProfileReminders(requestParameters.profileId, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get reminder linked to a specific medication
         * @param {ReminderApiReminderControllerGetReminderByMedicationIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderControllerGetReminderByMedicationId(requestParameters: ReminderApiReminderControllerGetReminderByMedicationIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetReminderDto> {
            return localVarFp.reminderControllerGetReminderByMedicationId(requestParameters.profileId, requestParameters.medicationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get reminders bound to a specific visit (auth-user-owned OR same-org guest). Returns [] for unauthorised callers — the FE silently hides the Przypomnienia tab when empty.
         * @param {ReminderApiReminderControllerGetVisitRemindersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderControllerGetVisitReminders(requestParameters: ReminderApiReminderControllerGetVisitRemindersRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetReminderDto>> {
            return localVarFp.reminderControllerGetVisitReminders(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a reminder
         * @param {ReminderApiReminderControllerUpdateReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderControllerUpdateReminder(requestParameters: ReminderApiReminderControllerUpdateReminderRequest, options?: AxiosRequestConfig): AxiosPromise<GetReminderDto> {
            return localVarFp.reminderControllerUpdateReminder(requestParameters.reminderId, requestParameters.updateReminderDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for reminderControllerCreateReminder operation in ReminderApi.
 * @export
 * @interface ReminderApiReminderControllerCreateReminderRequest
 */
export interface ReminderApiReminderControllerCreateReminderRequest {
    /**
     *
     * @type {CreateReminderDto}
     * @memberof ReminderApiReminderControllerCreateReminder
     */
    readonly createReminderDto: CreateReminderDto
}

/**
 * Request parameters for reminderControllerDeleteReminder operation in ReminderApi.
 * @export
 * @interface ReminderApiReminderControllerDeleteReminderRequest
 */
export interface ReminderApiReminderControllerDeleteReminderRequest {
    /**
     *
     * @type {string}
     * @memberof ReminderApiReminderControllerDeleteReminder
     */
    readonly reminderId: string

    /**
     * Optional visit ID to track deletion as visit activity
     * @type {string}
     * @memberof ReminderApiReminderControllerDeleteReminder
     */
    readonly visitId?: string
}

/**
 * Request parameters for reminderControllerGetProfileReminders operation in ReminderApi.
 * @export
 * @interface ReminderApiReminderControllerGetProfileRemindersRequest
 */
export interface ReminderApiReminderControllerGetProfileRemindersRequest {
    /**
     *
     * @type {string}
     * @memberof ReminderApiReminderControllerGetProfileReminders
     */
    readonly profileId: string

    /**
     * Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
     * @type {number}
     * @memberof ReminderApiReminderControllerGetProfileReminders
     */
    readonly page?: number

    /**
     * Rows per page. Omit together with &#x60;page&#x60; to get every row.
     * @type {number}
     * @memberof ReminderApiReminderControllerGetProfileReminders
     */
    readonly limit?: number
}

/**
 * Request parameters for reminderControllerGetReminderByMedicationId operation in ReminderApi.
 * @export
 * @interface ReminderApiReminderControllerGetReminderByMedicationIdRequest
 */
export interface ReminderApiReminderControllerGetReminderByMedicationIdRequest {
    /**
     *
     * @type {string}
     * @memberof ReminderApiReminderControllerGetReminderByMedicationId
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof ReminderApiReminderControllerGetReminderByMedicationId
     */
    readonly medicationId: string
}

/**
 * Request parameters for reminderControllerGetVisitReminders operation in ReminderApi.
 * @export
 * @interface ReminderApiReminderControllerGetVisitRemindersRequest
 */
export interface ReminderApiReminderControllerGetVisitRemindersRequest {
    /**
     *
     * @type {string}
     * @memberof ReminderApiReminderControllerGetVisitReminders
     */
    readonly visitId: string
}

/**
 * Request parameters for reminderControllerUpdateReminder operation in ReminderApi.
 * @export
 * @interface ReminderApiReminderControllerUpdateReminderRequest
 */
export interface ReminderApiReminderControllerUpdateReminderRequest {
    /**
     *
     * @type {string}
     * @memberof ReminderApiReminderControllerUpdateReminder
     */
    readonly reminderId: string

    /**
     *
     * @type {UpdateReminderDto}
     * @memberof ReminderApiReminderControllerUpdateReminder
     */
    readonly updateReminderDto: UpdateReminderDto
}

/**
 * ReminderApi - object-oriented interface
 * @export
 * @class ReminderApi
 * @extends {BaseAPI}
 */
export class ReminderApi extends BaseAPI {
    /**
     *
     * @summary Create a new reminder for a profile
     * @param {ReminderApiReminderControllerCreateReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReminderApi
     */
    public reminderControllerCreateReminder(requestParameters: ReminderApiReminderControllerCreateReminderRequest, options?: AxiosRequestConfig) {
        return ReminderApiFp(this.configuration).reminderControllerCreateReminder(requestParameters.createReminderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete a reminder
     * @param {ReminderApiReminderControllerDeleteReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReminderApi
     */
    public reminderControllerDeleteReminder(requestParameters: ReminderApiReminderControllerDeleteReminderRequest, options?: AxiosRequestConfig) {
        return ReminderApiFp(this.configuration).reminderControllerDeleteReminder(requestParameters.reminderId, requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all reminders for a profile
     * @param {ReminderApiReminderControllerGetProfileRemindersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReminderApi
     */
    public reminderControllerGetProfileReminders(requestParameters: ReminderApiReminderControllerGetProfileRemindersRequest, options?: AxiosRequestConfig) {
        return ReminderApiFp(this.configuration).reminderControllerGetProfileReminders(requestParameters.profileId, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get reminder linked to a specific medication
     * @param {ReminderApiReminderControllerGetReminderByMedicationIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReminderApi
     */
    public reminderControllerGetReminderByMedicationId(requestParameters: ReminderApiReminderControllerGetReminderByMedicationIdRequest, options?: AxiosRequestConfig) {
        return ReminderApiFp(this.configuration).reminderControllerGetReminderByMedicationId(requestParameters.profileId, requestParameters.medicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get reminders bound to a specific visit (auth-user-owned OR same-org guest). Returns [] for unauthorised callers — the FE silently hides the Przypomnienia tab when empty.
     * @param {ReminderApiReminderControllerGetVisitRemindersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReminderApi
     */
    public reminderControllerGetVisitReminders(requestParameters: ReminderApiReminderControllerGetVisitRemindersRequest, options?: AxiosRequestConfig) {
        return ReminderApiFp(this.configuration).reminderControllerGetVisitReminders(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update a reminder
     * @param {ReminderApiReminderControllerUpdateReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReminderApi
     */
    public reminderControllerUpdateReminder(requestParameters: ReminderApiReminderControllerUpdateReminderRequest, options?: AxiosRequestConfig) {
        return ReminderApiFp(this.configuration).reminderControllerUpdateReminder(requestParameters.reminderId, requestParameters.updateReminderDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReminderCronApi - axios parameter creator
 * @export
 */
export const ReminderCronApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Process and send due reminders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderCronControllerProcessReminders: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mail/cron/reminders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReminderCronApi - functional programming interface
 * @export
 */
export const ReminderCronApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReminderCronApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Process and send due reminders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reminderCronControllerProcessReminders(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reminderCronControllerProcessReminders(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReminderCronApi - factory interface
 * @export
 */
export const ReminderCronApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReminderCronApiFp(configuration)
    return {
        /**
         *
         * @summary Process and send due reminders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderCronControllerProcessReminders(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reminderCronControllerProcessReminders(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReminderCronApi - object-oriented interface
 * @export
 * @class ReminderCronApi
 * @extends {BaseAPI}
 */
export class ReminderCronApi extends BaseAPI {
    /**
     *
     * @summary Process and send due reminders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReminderCronApi
     */
    public reminderCronControllerProcessReminders(options?: AxiosRequestConfig) {
        return ReminderCronApiFp(this.configuration).reminderCronControllerProcessReminders(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SpecializationApi - axios parameter creator
 * @export
 */
export const SpecializationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Organization admins can create custom services with name, duration, and price
         * @summary Create a custom service for an organization
         * @param {string} organizationId The organization ID
         * @param {CreateSpecializationServiceDto} createSpecializationServiceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerCreateOrganizationService: async (organizationId: string, createSpecializationServiceDto: CreateSpecializationServiceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('specializationControllerCreateOrganizationService', 'organizationId', organizationId)
            // verify required parameter 'createSpecializationServiceDto' is not null or undefined
            assertParamExists('specializationControllerCreateOrganizationService', 'createSpecializationServiceDto', createSpecializationServiceDto)
            const localVarPath = `/api/specialization/organization/{organizationId}/service`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSpecializationServiceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all specialization services for organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerGetAllServices: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/specialization/services/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all specializations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerGetAllSpecializations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/specialization/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns services that are enabled for the organization and match the professional\'s specializations
         * @summary Get services filtered by organization and professional specializations
         * @param {string} organizationId The organization ID
         * @param {string} professionalId The professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerGetFilteredServicesForProfessional: async (organizationId: string, professionalId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('specializationControllerGetFilteredServicesForProfessional', 'organizationId', organizationId)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('specializationControllerGetFilteredServicesForProfessional', 'professionalId', professionalId)
            const localVarPath = `/api/specialization/organization/{organizationId}/professional/{professionalId}/services`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the form IDs associated with a service
         * @summary Get form IDs for a service
         * @param {string} serviceId The service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerGetServiceForms: async (serviceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('specializationControllerGetServiceForms', 'serviceId', serviceId)
            const localVarPath = `/api/specialization/service/{serviceId}/forms`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get specializations by visit category ID.
         * @param {string} visitCategoryId The visit category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerGetSpecializationsByVisitCategory: async (visitCategoryId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitCategoryId' is not null or undefined
            assertParamExists('specializationControllerGetSpecializationsByVisitCategory', 'visitCategoryId', visitCategoryId)
            const localVarPath = `/api/specialization/category/{visitCategoryId}`
                .replace(`{${"visitCategoryId"}}`, encodeURIComponent(String(visitCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Organization admins can update service details
         * @summary Update a service for an organization
         * @param {string} organizationId The organization ID
         * @param {string} serviceId The service ID to update
         * @param {UpdateSpecializationServiceDto} updateSpecializationServiceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerUpdateOrganizationService: async (organizationId: string, serviceId: string, updateSpecializationServiceDto: UpdateSpecializationServiceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('specializationControllerUpdateOrganizationService', 'organizationId', organizationId)
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('specializationControllerUpdateOrganizationService', 'serviceId', serviceId)
            // verify required parameter 'updateSpecializationServiceDto' is not null or undefined
            assertParamExists('specializationControllerUpdateOrganizationService', 'updateSpecializationServiceDto', updateSpecializationServiceDto)
            const localVarPath = `/api/specialization/organization/{organizationId}/service/{serviceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSpecializationServiceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Associates forms with a specialization service
         * @summary Set form IDs for a service
         * @param {string} serviceId The service ID
         * @param {SpecializationControllerUpdateServiceFormsRequest} specializationControllerUpdateServiceFormsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerUpdateServiceForms: async (serviceId: string, specializationControllerUpdateServiceFormsRequest: SpecializationControllerUpdateServiceFormsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('specializationControllerUpdateServiceForms', 'serviceId', serviceId)
            // verify required parameter 'specializationControllerUpdateServiceFormsRequest' is not null or undefined
            assertParamExists('specializationControllerUpdateServiceForms', 'specializationControllerUpdateServiceFormsRequest', specializationControllerUpdateServiceFormsRequest)
            const localVarPath = `/api/specialization/service/{serviceId}/forms`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(specializationControllerUpdateServiceFormsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SpecializationApi - functional programming interface
 * @export
 */
export const SpecializationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SpecializationApiAxiosParamCreator(configuration)
    return {
        /**
         * Organization admins can create custom services with name, duration, and price
         * @summary Create a custom service for an organization
         * @param {string} organizationId The organization ID
         * @param {CreateSpecializationServiceDto} createSpecializationServiceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specializationControllerCreateOrganizationService(organizationId: string, createSpecializationServiceDto: CreateSpecializationServiceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specializationControllerCreateOrganizationService(organizationId, createSpecializationServiceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all specialization services for organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specializationControllerGetAllServices(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specializationControllerGetAllServices(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all specializations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specializationControllerGetAllSpecializations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSpecializationsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specializationControllerGetAllSpecializations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns services that are enabled for the organization and match the professional\'s specializations
         * @summary Get services filtered by organization and professional specializations
         * @param {string} organizationId The organization ID
         * @param {string} professionalId The professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specializationControllerGetFilteredServicesForProfessional(organizationId: string, professionalId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specializationControllerGetFilteredServicesForProfessional(organizationId, professionalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the form IDs associated with a service
         * @summary Get form IDs for a service
         * @param {string} serviceId The service ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specializationControllerGetServiceForms(serviceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specializationControllerGetServiceForms(serviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get specializations by visit category ID.
         * @param {string} visitCategoryId The visit category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specializationControllerGetSpecializationsByVisitCategory(visitCategoryId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSpecializationsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specializationControllerGetSpecializationsByVisitCategory(visitCategoryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Organization admins can update service details
         * @summary Update a service for an organization
         * @param {string} organizationId The organization ID
         * @param {string} serviceId The service ID to update
         * @param {UpdateSpecializationServiceDto} updateSpecializationServiceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specializationControllerUpdateOrganizationService(organizationId: string, serviceId: string, updateSpecializationServiceDto: UpdateSpecializationServiceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specializationControllerUpdateOrganizationService(organizationId, serviceId, updateSpecializationServiceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Associates forms with a specialization service
         * @summary Set form IDs for a service
         * @param {string} serviceId The service ID
         * @param {SpecializationControllerUpdateServiceFormsRequest} specializationControllerUpdateServiceFormsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specializationControllerUpdateServiceForms(serviceId: string, specializationControllerUpdateServiceFormsRequest: SpecializationControllerUpdateServiceFormsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specializationControllerUpdateServiceForms(serviceId, specializationControllerUpdateServiceFormsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SpecializationApi - factory interface
 * @export
 */
export const SpecializationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SpecializationApiFp(configuration)
    return {
        /**
         * Organization admins can create custom services with name, duration, and price
         * @summary Create a custom service for an organization
         * @param {SpecializationApiSpecializationControllerCreateOrganizationServiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerCreateOrganizationService(requestParameters: SpecializationApiSpecializationControllerCreateOrganizationServiceRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.specializationControllerCreateOrganizationService(requestParameters.organizationId, requestParameters.createSpecializationServiceDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all specialization services for organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerGetAllServices(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.specializationControllerGetAllServices(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all specializations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerGetAllSpecializations(options?: AxiosRequestConfig): AxiosPromise<Array<GetSpecializationsDto>> {
            return localVarFp.specializationControllerGetAllSpecializations(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns services that are enabled for the organization and match the professional\'s specializations
         * @summary Get services filtered by organization and professional specializations
         * @param {SpecializationApiSpecializationControllerGetFilteredServicesForProfessionalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerGetFilteredServicesForProfessional(requestParameters: SpecializationApiSpecializationControllerGetFilteredServicesForProfessionalRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.specializationControllerGetFilteredServicesForProfessional(requestParameters.organizationId, requestParameters.professionalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the form IDs associated with a service
         * @summary Get form IDs for a service
         * @param {SpecializationApiSpecializationControllerGetServiceFormsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerGetServiceForms(requestParameters: SpecializationApiSpecializationControllerGetServiceFormsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.specializationControllerGetServiceForms(requestParameters.serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get specializations by visit category ID.
         * @param {SpecializationApiSpecializationControllerGetSpecializationsByVisitCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerGetSpecializationsByVisitCategory(requestParameters: SpecializationApiSpecializationControllerGetSpecializationsByVisitCategoryRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetSpecializationsDto>> {
            return localVarFp.specializationControllerGetSpecializationsByVisitCategory(requestParameters.visitCategoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Organization admins can update service details
         * @summary Update a service for an organization
         * @param {SpecializationApiSpecializationControllerUpdateOrganizationServiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerUpdateOrganizationService(requestParameters: SpecializationApiSpecializationControllerUpdateOrganizationServiceRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.specializationControllerUpdateOrganizationService(requestParameters.organizationId, requestParameters.serviceId, requestParameters.updateSpecializationServiceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Associates forms with a specialization service
         * @summary Set form IDs for a service
         * @param {SpecializationApiSpecializationControllerUpdateServiceFormsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerUpdateServiceForms(requestParameters: SpecializationApiSpecializationControllerUpdateServiceFormsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.specializationControllerUpdateServiceForms(requestParameters.serviceId, requestParameters.specializationControllerUpdateServiceFormsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for specializationControllerCreateOrganizationService operation in SpecializationApi.
 * @export
 * @interface SpecializationApiSpecializationControllerCreateOrganizationServiceRequest
 */
export interface SpecializationApiSpecializationControllerCreateOrganizationServiceRequest {
    /**
     * The organization ID
     * @type {string}
     * @memberof SpecializationApiSpecializationControllerCreateOrganizationService
     */
    readonly organizationId: string

    /**
     *
     * @type {CreateSpecializationServiceDto}
     * @memberof SpecializationApiSpecializationControllerCreateOrganizationService
     */
    readonly createSpecializationServiceDto: CreateSpecializationServiceDto
}

/**
 * Request parameters for specializationControllerGetFilteredServicesForProfessional operation in SpecializationApi.
 * @export
 * @interface SpecializationApiSpecializationControllerGetFilteredServicesForProfessionalRequest
 */
export interface SpecializationApiSpecializationControllerGetFilteredServicesForProfessionalRequest {
    /**
     * The organization ID
     * @type {string}
     * @memberof SpecializationApiSpecializationControllerGetFilteredServicesForProfessional
     */
    readonly organizationId: string

    /**
     * The professional ID
     * @type {string}
     * @memberof SpecializationApiSpecializationControllerGetFilteredServicesForProfessional
     */
    readonly professionalId: string
}

/**
 * Request parameters for specializationControllerGetServiceForms operation in SpecializationApi.
 * @export
 * @interface SpecializationApiSpecializationControllerGetServiceFormsRequest
 */
export interface SpecializationApiSpecializationControllerGetServiceFormsRequest {
    /**
     * The service ID
     * @type {string}
     * @memberof SpecializationApiSpecializationControllerGetServiceForms
     */
    readonly serviceId: string
}

/**
 * Request parameters for specializationControllerGetSpecializationsByVisitCategory operation in SpecializationApi.
 * @export
 * @interface SpecializationApiSpecializationControllerGetSpecializationsByVisitCategoryRequest
 */
export interface SpecializationApiSpecializationControllerGetSpecializationsByVisitCategoryRequest {
    /**
     * The visit category ID
     * @type {string}
     * @memberof SpecializationApiSpecializationControllerGetSpecializationsByVisitCategory
     */
    readonly visitCategoryId: string
}

/**
 * Request parameters for specializationControllerUpdateOrganizationService operation in SpecializationApi.
 * @export
 * @interface SpecializationApiSpecializationControllerUpdateOrganizationServiceRequest
 */
export interface SpecializationApiSpecializationControllerUpdateOrganizationServiceRequest {
    /**
     * The organization ID
     * @type {string}
     * @memberof SpecializationApiSpecializationControllerUpdateOrganizationService
     */
    readonly organizationId: string

    /**
     * The service ID to update
     * @type {string}
     * @memberof SpecializationApiSpecializationControllerUpdateOrganizationService
     */
    readonly serviceId: string

    /**
     *
     * @type {UpdateSpecializationServiceDto}
     * @memberof SpecializationApiSpecializationControllerUpdateOrganizationService
     */
    readonly updateSpecializationServiceDto: UpdateSpecializationServiceDto
}

/**
 * Request parameters for specializationControllerUpdateServiceForms operation in SpecializationApi.
 * @export
 * @interface SpecializationApiSpecializationControllerUpdateServiceFormsRequest
 */
export interface SpecializationApiSpecializationControllerUpdateServiceFormsRequest {
    /**
     * The service ID
     * @type {string}
     * @memberof SpecializationApiSpecializationControllerUpdateServiceForms
     */
    readonly serviceId: string

    /**
     *
     * @type {SpecializationControllerUpdateServiceFormsRequest}
     * @memberof SpecializationApiSpecializationControllerUpdateServiceForms
     */
    readonly specializationControllerUpdateServiceFormsRequest: SpecializationControllerUpdateServiceFormsRequest
}

/**
 * SpecializationApi - object-oriented interface
 * @export
 * @class SpecializationApi
 * @extends {BaseAPI}
 */
export class SpecializationApi extends BaseAPI {
    /**
     * Organization admins can create custom services with name, duration, and price
     * @summary Create a custom service for an organization
     * @param {SpecializationApiSpecializationControllerCreateOrganizationServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecializationApi
     */
    public specializationControllerCreateOrganizationService(requestParameters: SpecializationApiSpecializationControllerCreateOrganizationServiceRequest, options?: AxiosRequestConfig) {
        return SpecializationApiFp(this.configuration).specializationControllerCreateOrganizationService(requestParameters.organizationId, requestParameters.createSpecializationServiceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all specialization services for organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecializationApi
     */
    public specializationControllerGetAllServices(options?: AxiosRequestConfig) {
        return SpecializationApiFp(this.configuration).specializationControllerGetAllServices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all specializations.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecializationApi
     */
    public specializationControllerGetAllSpecializations(options?: AxiosRequestConfig) {
        return SpecializationApiFp(this.configuration).specializationControllerGetAllSpecializations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns services that are enabled for the organization and match the professional\'s specializations
     * @summary Get services filtered by organization and professional specializations
     * @param {SpecializationApiSpecializationControllerGetFilteredServicesForProfessionalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecializationApi
     */
    public specializationControllerGetFilteredServicesForProfessional(requestParameters: SpecializationApiSpecializationControllerGetFilteredServicesForProfessionalRequest, options?: AxiosRequestConfig) {
        return SpecializationApiFp(this.configuration).specializationControllerGetFilteredServicesForProfessional(requestParameters.organizationId, requestParameters.professionalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the form IDs associated with a service
     * @summary Get form IDs for a service
     * @param {SpecializationApiSpecializationControllerGetServiceFormsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecializationApi
     */
    public specializationControllerGetServiceForms(requestParameters: SpecializationApiSpecializationControllerGetServiceFormsRequest, options?: AxiosRequestConfig) {
        return SpecializationApiFp(this.configuration).specializationControllerGetServiceForms(requestParameters.serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get specializations by visit category ID.
     * @param {SpecializationApiSpecializationControllerGetSpecializationsByVisitCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecializationApi
     */
    public specializationControllerGetSpecializationsByVisitCategory(requestParameters: SpecializationApiSpecializationControllerGetSpecializationsByVisitCategoryRequest, options?: AxiosRequestConfig) {
        return SpecializationApiFp(this.configuration).specializationControllerGetSpecializationsByVisitCategory(requestParameters.visitCategoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Organization admins can update service details
     * @summary Update a service for an organization
     * @param {SpecializationApiSpecializationControllerUpdateOrganizationServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecializationApi
     */
    public specializationControllerUpdateOrganizationService(requestParameters: SpecializationApiSpecializationControllerUpdateOrganizationServiceRequest, options?: AxiosRequestConfig) {
        return SpecializationApiFp(this.configuration).specializationControllerUpdateOrganizationService(requestParameters.organizationId, requestParameters.serviceId, requestParameters.updateSpecializationServiceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Associates forms with a specialization service
     * @summary Set form IDs for a service
     * @param {SpecializationApiSpecializationControllerUpdateServiceFormsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecializationApi
     */
    public specializationControllerUpdateServiceForms(requestParameters: SpecializationApiSpecializationControllerUpdateServiceFormsRequest, options?: AxiosRequestConfig) {
        return SpecializationApiFp(this.configuration).specializationControllerUpdateServiceForms(requestParameters.serviceId, requestParameters.specializationControllerUpdateServiceFormsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SterowaniePrzyjciemVoiceApi - axios parameter creator
 * @export
 */
export const SterowaniePrzyjciemVoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Zatwierdź kontrolowane wcześniejsze otwarcie kosztów
         * @param {ApproveVoiceSpendReopenDto} approveVoiceSpendReopenDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerApproveSpendReopen: async (approveVoiceSpendReopenDto: ApproveVoiceSpendReopenDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'approveVoiceSpendReopenDto' is not null or undefined
            assertParamExists('voiceAdmissionControlControllerApproveSpendReopen', 'approveVoiceSpendReopenDto', approveVoiceSpendReopenDto)
            const localVarPath = `/api/voice-platform/admission-controls/spend/reopen-approvals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveVoiceSpendReopenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zaproponuj kontrolowane wcześniejsze otwarcie kosztów
         * @param {ProposeVoiceSpendReopenDto} proposeVoiceSpendReopenDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerProposeSpendReopen: async (proposeVoiceSpendReopenDto: ProposeVoiceSpendReopenDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proposeVoiceSpendReopenDto' is not null or undefined
            assertParamExists('voiceAdmissionControlControllerProposeSpendReopen', 'proposeVoiceSpendReopenDto', proposeVoiceSpendReopenDto)
            const localVarPath = `/api/voice-platform/admission-controls/spend/reopen-proposals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proposeVoiceSpendReopenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Jawnie przydziel bazowe 500 minut pilota
         * @param {string} organizationId Identyfikator Organization
         * @param {ProvisionVoiceAllowanceDto} provisionVoiceAllowanceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerProvisionAllowance: async (organizationId: string, provisionVoiceAllowanceDto: ProvisionVoiceAllowanceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceAdmissionControlControllerProvisionAllowance', 'organizationId', organizationId)
            // verify required parameter 'provisionVoiceAllowanceDto' is not null or undefined
            assertParamExists('voiceAdmissionControlControllerProvisionAllowance', 'provisionVoiceAllowanceDto', provisionVoiceAllowanceDto)
            const localVarPath = `/api/voice-platform/admission-controls/organizations/{organizationId}/allowance/provision`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(provisionVoiceAllowanceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Opublikuj zakwalifikowane stawki kosztowe Voice
         * @param {PublishVoiceQualifiedRatesDto} publishVoiceQualifiedRatesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerPublishQualifiedRates: async (publishVoiceQualifiedRatesDto: PublishVoiceQualifiedRatesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publishVoiceQualifiedRatesDto' is not null or undefined
            assertParamExists('voiceAdmissionControlControllerPublishQualifiedRates', 'publishVoiceQualifiedRatesDto', publishVoiceQualifiedRatesDto)
            const localVarPath = `/api/voice-platform/admission-controls/rates/publications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishVoiceQualifiedRatesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz bieżący miesięczny przydział Voice
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerReadAllowance: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceAdmissionControlControllerReadAllowance', 'organizationId', organizationId)
            const localVarPath = `/api/voice-platform/admission-controls/organizations/{organizationId}/allowance`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz stan dziennego wyłącznika kosztowego Voice
         * @param {string} [warsawDay] Dzień kalendarzowy Europe/Warsaw; brak wartości oznacza bieżący dzień
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerReadSpendControl: async (warsawDay?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/admission-controls/spend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (warsawDay !== undefined) {
                localVarQueryParameter['warsawDay'] = warsawDay;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Uzgodnij przydział z bieżącym uprawnieniem pilota
         * @param {string} organizationId Identyfikator Organization
         * @param {ProvisionVoiceAllowanceDto} provisionVoiceAllowanceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerReconcileAllowanceEntitlement: async (organizationId: string, provisionVoiceAllowanceDto: ProvisionVoiceAllowanceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceAdmissionControlControllerReconcileAllowanceEntitlement', 'organizationId', organizationId)
            // verify required parameter 'provisionVoiceAllowanceDto' is not null or undefined
            assertParamExists('voiceAdmissionControlControllerReconcileAllowanceEntitlement', 'provisionVoiceAllowanceDto', provisionVoiceAllowanceDto)
            const localVarPath = `/api/voice-platform/admission-controls/organizations/{organizationId}/allowance/reconciliations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(provisionVoiceAllowanceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Ustaw niższy bazowy przydział od następnego miesiąca
         * @param {string} organizationId Identyfikator Organization
         * @param {ScheduleVoiceAllowanceReductionDto} scheduleVoiceAllowanceReductionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerScheduleAllowanceReduction: async (organizationId: string, scheduleVoiceAllowanceReductionDto: ScheduleVoiceAllowanceReductionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceAdmissionControlControllerScheduleAllowanceReduction', 'organizationId', organizationId)
            // verify required parameter 'scheduleVoiceAllowanceReductionDto' is not null or undefined
            assertParamExists('voiceAdmissionControlControllerScheduleAllowanceReduction', 'scheduleVoiceAllowanceReductionDto', scheduleVoiceAllowanceReductionDto)
            const localVarPath = `/api/voice-platform/admission-controls/organizations/{organizationId}/allowance/reductions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleVoiceAllowanceReductionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Dodaj przydział do bieżącego miesiąca Voice
         * @param {string} organizationId Identyfikator Organization
         * @param {TopUpVoiceAllowanceDto} topUpVoiceAllowanceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerTopUpAllowance: async (organizationId: string, topUpVoiceAllowanceDto: TopUpVoiceAllowanceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceAdmissionControlControllerTopUpAllowance', 'organizationId', organizationId)
            // verify required parameter 'topUpVoiceAllowanceDto' is not null or undefined
            assertParamExists('voiceAdmissionControlControllerTopUpAllowance', 'topUpVoiceAllowanceDto', topUpVoiceAllowanceDto)
            const localVarPath = `/api/voice-platform/admission-controls/organizations/{organizationId}/allowance/top-ups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(topUpVoiceAllowanceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SterowaniePrzyjciemVoiceApi - functional programming interface
 * @export
 */
export const SterowaniePrzyjciemVoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SterowaniePrzyjciemVoiceApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Zatwierdź kontrolowane wcześniejsze otwarcie kosztów
         * @param {ApproveVoiceSpendReopenDto} approveVoiceSpendReopenDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceAdmissionControlControllerApproveSpendReopen(approveVoiceSpendReopenDto: ApproveVoiceSpendReopenDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceSpendReopenProposalResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceAdmissionControlControllerApproveSpendReopen(approveVoiceSpendReopenDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zaproponuj kontrolowane wcześniejsze otwarcie kosztów
         * @param {ProposeVoiceSpendReopenDto} proposeVoiceSpendReopenDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceAdmissionControlControllerProposeSpendReopen(proposeVoiceSpendReopenDto: ProposeVoiceSpendReopenDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceSpendReopenProposalResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceAdmissionControlControllerProposeSpendReopen(proposeVoiceSpendReopenDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Jawnie przydziel bazowe 500 minut pilota
         * @param {string} organizationId Identyfikator Organization
         * @param {ProvisionVoiceAllowanceDto} provisionVoiceAllowanceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceAdmissionControlControllerProvisionAllowance(organizationId: string, provisionVoiceAllowanceDto: ProvisionVoiceAllowanceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceAllowanceMonthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceAdmissionControlControllerProvisionAllowance(organizationId, provisionVoiceAllowanceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Opublikuj zakwalifikowane stawki kosztowe Voice
         * @param {PublishVoiceQualifiedRatesDto} publishVoiceQualifiedRatesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceAdmissionControlControllerPublishQualifiedRates(publishVoiceQualifiedRatesDto: PublishVoiceQualifiedRatesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceQualifiedRatePublicationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceAdmissionControlControllerPublishQualifiedRates(publishVoiceQualifiedRatesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz bieżący miesięczny przydział Voice
         * @param {string} organizationId Identyfikator Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceAdmissionControlControllerReadAllowance(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceAllowanceMonthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceAdmissionControlControllerReadAllowance(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz stan dziennego wyłącznika kosztowego Voice
         * @param {string} [warsawDay] Dzień kalendarzowy Europe/Warsaw; brak wartości oznacza bieżący dzień
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceAdmissionControlControllerReadSpendControl(warsawDay?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceSpendControlResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceAdmissionControlControllerReadSpendControl(warsawDay, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Uzgodnij przydział z bieżącym uprawnieniem pilota
         * @param {string} organizationId Identyfikator Organization
         * @param {ProvisionVoiceAllowanceDto} provisionVoiceAllowanceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceAdmissionControlControllerReconcileAllowanceEntitlement(organizationId: string, provisionVoiceAllowanceDto: ProvisionVoiceAllowanceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceAllowanceMonthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceAdmissionControlControllerReconcileAllowanceEntitlement(organizationId, provisionVoiceAllowanceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Ustaw niższy bazowy przydział od następnego miesiąca
         * @param {string} organizationId Identyfikator Organization
         * @param {ScheduleVoiceAllowanceReductionDto} scheduleVoiceAllowanceReductionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceAdmissionControlControllerScheduleAllowanceReduction(organizationId: string, scheduleVoiceAllowanceReductionDto: ScheduleVoiceAllowanceReductionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceAllowanceMonthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceAdmissionControlControllerScheduleAllowanceReduction(organizationId, scheduleVoiceAllowanceReductionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Dodaj przydział do bieżącego miesiąca Voice
         * @param {string} organizationId Identyfikator Organization
         * @param {TopUpVoiceAllowanceDto} topUpVoiceAllowanceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceAdmissionControlControllerTopUpAllowance(organizationId: string, topUpVoiceAllowanceDto: TopUpVoiceAllowanceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceAllowanceMonthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceAdmissionControlControllerTopUpAllowance(organizationId, topUpVoiceAllowanceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SterowaniePrzyjciemVoiceApi - factory interface
 * @export
 */
export const SterowaniePrzyjciemVoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SterowaniePrzyjciemVoiceApiFp(configuration)
    return {
        /**
         *
         * @summary Zatwierdź kontrolowane wcześniejsze otwarcie kosztów
         * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerApproveSpendReopenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerApproveSpendReopen(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerApproveSpendReopenRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceSpendReopenProposalResponseDto> {
            return localVarFp.voiceAdmissionControlControllerApproveSpendReopen(requestParameters.approveVoiceSpendReopenDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zaproponuj kontrolowane wcześniejsze otwarcie kosztów
         * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerProposeSpendReopenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerProposeSpendReopen(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerProposeSpendReopenRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceSpendReopenProposalResponseDto> {
            return localVarFp.voiceAdmissionControlControllerProposeSpendReopen(requestParameters.proposeVoiceSpendReopenDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Jawnie przydziel bazowe 500 minut pilota
         * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerProvisionAllowanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerProvisionAllowance(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerProvisionAllowanceRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceAllowanceMonthResponseDto> {
            return localVarFp.voiceAdmissionControlControllerProvisionAllowance(requestParameters.organizationId, requestParameters.provisionVoiceAllowanceDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opublikuj zakwalifikowane stawki kosztowe Voice
         * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerPublishQualifiedRatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerPublishQualifiedRates(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerPublishQualifiedRatesRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceQualifiedRatePublicationResponseDto> {
            return localVarFp.voiceAdmissionControlControllerPublishQualifiedRates(requestParameters.publishVoiceQualifiedRatesDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz bieżący miesięczny przydział Voice
         * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReadAllowanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerReadAllowance(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReadAllowanceRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceAllowanceMonthResponseDto> {
            return localVarFp.voiceAdmissionControlControllerReadAllowance(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz stan dziennego wyłącznika kosztowego Voice
         * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReadSpendControlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerReadSpendControl(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReadSpendControlRequest = {}, options?: AxiosRequestConfig): AxiosPromise<VoiceSpendControlResponseDto> {
            return localVarFp.voiceAdmissionControlControllerReadSpendControl(requestParameters.warsawDay, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Uzgodnij przydział z bieżącym uprawnieniem pilota
         * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReconcileAllowanceEntitlementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerReconcileAllowanceEntitlement(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReconcileAllowanceEntitlementRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceAllowanceMonthResponseDto> {
            return localVarFp.voiceAdmissionControlControllerReconcileAllowanceEntitlement(requestParameters.organizationId, requestParameters.provisionVoiceAllowanceDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Ustaw niższy bazowy przydział od następnego miesiąca
         * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerScheduleAllowanceReductionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerScheduleAllowanceReduction(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerScheduleAllowanceReductionRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceAllowanceMonthResponseDto> {
            return localVarFp.voiceAdmissionControlControllerScheduleAllowanceReduction(requestParameters.organizationId, requestParameters.scheduleVoiceAllowanceReductionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Dodaj przydział do bieżącego miesiąca Voice
         * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerTopUpAllowanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceAdmissionControlControllerTopUpAllowance(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerTopUpAllowanceRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceAllowanceMonthResponseDto> {
            return localVarFp.voiceAdmissionControlControllerTopUpAllowance(requestParameters.organizationId, requestParameters.topUpVoiceAllowanceDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceAdmissionControlControllerApproveSpendReopen operation in SterowaniePrzyjciemVoiceApi.
 * @export
 * @interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerApproveSpendReopenRequest
 */
export interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerApproveSpendReopenRequest {
    /**
     *
     * @type {ApproveVoiceSpendReopenDto}
     * @memberof SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerApproveSpendReopen
     */
    readonly approveVoiceSpendReopenDto: ApproveVoiceSpendReopenDto
}

/**
 * Request parameters for voiceAdmissionControlControllerProposeSpendReopen operation in SterowaniePrzyjciemVoiceApi.
 * @export
 * @interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerProposeSpendReopenRequest
 */
export interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerProposeSpendReopenRequest {
    /**
     *
     * @type {ProposeVoiceSpendReopenDto}
     * @memberof SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerProposeSpendReopen
     */
    readonly proposeVoiceSpendReopenDto: ProposeVoiceSpendReopenDto
}

/**
 * Request parameters for voiceAdmissionControlControllerProvisionAllowance operation in SterowaniePrzyjciemVoiceApi.
 * @export
 * @interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerProvisionAllowanceRequest
 */
export interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerProvisionAllowanceRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerProvisionAllowance
     */
    readonly organizationId: string

    /**
     *
     * @type {ProvisionVoiceAllowanceDto}
     * @memberof SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerProvisionAllowance
     */
    readonly provisionVoiceAllowanceDto: ProvisionVoiceAllowanceDto
}

/**
 * Request parameters for voiceAdmissionControlControllerPublishQualifiedRates operation in SterowaniePrzyjciemVoiceApi.
 * @export
 * @interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerPublishQualifiedRatesRequest
 */
export interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerPublishQualifiedRatesRequest {
    /**
     *
     * @type {PublishVoiceQualifiedRatesDto}
     * @memberof SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerPublishQualifiedRates
     */
    readonly publishVoiceQualifiedRatesDto: PublishVoiceQualifiedRatesDto
}

/**
 * Request parameters for voiceAdmissionControlControllerReadAllowance operation in SterowaniePrzyjciemVoiceApi.
 * @export
 * @interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReadAllowanceRequest
 */
export interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReadAllowanceRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReadAllowance
     */
    readonly organizationId: string
}

/**
 * Request parameters for voiceAdmissionControlControllerReadSpendControl operation in SterowaniePrzyjciemVoiceApi.
 * @export
 * @interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReadSpendControlRequest
 */
export interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReadSpendControlRequest {
    /**
     * Dzień kalendarzowy Europe/Warsaw; brak wartości oznacza bieżący dzień
     * @type {string}
     * @memberof SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReadSpendControl
     */
    readonly warsawDay?: string
}

/**
 * Request parameters for voiceAdmissionControlControllerReconcileAllowanceEntitlement operation in SterowaniePrzyjciemVoiceApi.
 * @export
 * @interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReconcileAllowanceEntitlementRequest
 */
export interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReconcileAllowanceEntitlementRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReconcileAllowanceEntitlement
     */
    readonly organizationId: string

    /**
     *
     * @type {ProvisionVoiceAllowanceDto}
     * @memberof SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReconcileAllowanceEntitlement
     */
    readonly provisionVoiceAllowanceDto: ProvisionVoiceAllowanceDto
}

/**
 * Request parameters for voiceAdmissionControlControllerScheduleAllowanceReduction operation in SterowaniePrzyjciemVoiceApi.
 * @export
 * @interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerScheduleAllowanceReductionRequest
 */
export interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerScheduleAllowanceReductionRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerScheduleAllowanceReduction
     */
    readonly organizationId: string

    /**
     *
     * @type {ScheduleVoiceAllowanceReductionDto}
     * @memberof SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerScheduleAllowanceReduction
     */
    readonly scheduleVoiceAllowanceReductionDto: ScheduleVoiceAllowanceReductionDto
}

/**
 * Request parameters for voiceAdmissionControlControllerTopUpAllowance operation in SterowaniePrzyjciemVoiceApi.
 * @export
 * @interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerTopUpAllowanceRequest
 */
export interface SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerTopUpAllowanceRequest {
    /**
     * Identyfikator Organization
     * @type {string}
     * @memberof SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerTopUpAllowance
     */
    readonly organizationId: string

    /**
     *
     * @type {TopUpVoiceAllowanceDto}
     * @memberof SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerTopUpAllowance
     */
    readonly topUpVoiceAllowanceDto: TopUpVoiceAllowanceDto
}

/**
 * SterowaniePrzyjciemVoiceApi - object-oriented interface
 * @export
 * @class SterowaniePrzyjciemVoiceApi
 * @extends {BaseAPI}
 */
export class SterowaniePrzyjciemVoiceApi extends BaseAPI {
    /**
     *
     * @summary Zatwierdź kontrolowane wcześniejsze otwarcie kosztów
     * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerApproveSpendReopenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SterowaniePrzyjciemVoiceApi
     */
    public voiceAdmissionControlControllerApproveSpendReopen(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerApproveSpendReopenRequest, options?: AxiosRequestConfig) {
        return SterowaniePrzyjciemVoiceApiFp(this.configuration).voiceAdmissionControlControllerApproveSpendReopen(requestParameters.approveVoiceSpendReopenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zaproponuj kontrolowane wcześniejsze otwarcie kosztów
     * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerProposeSpendReopenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SterowaniePrzyjciemVoiceApi
     */
    public voiceAdmissionControlControllerProposeSpendReopen(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerProposeSpendReopenRequest, options?: AxiosRequestConfig) {
        return SterowaniePrzyjciemVoiceApiFp(this.configuration).voiceAdmissionControlControllerProposeSpendReopen(requestParameters.proposeVoiceSpendReopenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Jawnie przydziel bazowe 500 minut pilota
     * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerProvisionAllowanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SterowaniePrzyjciemVoiceApi
     */
    public voiceAdmissionControlControllerProvisionAllowance(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerProvisionAllowanceRequest, options?: AxiosRequestConfig) {
        return SterowaniePrzyjciemVoiceApiFp(this.configuration).voiceAdmissionControlControllerProvisionAllowance(requestParameters.organizationId, requestParameters.provisionVoiceAllowanceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Opublikuj zakwalifikowane stawki kosztowe Voice
     * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerPublishQualifiedRatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SterowaniePrzyjciemVoiceApi
     */
    public voiceAdmissionControlControllerPublishQualifiedRates(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerPublishQualifiedRatesRequest, options?: AxiosRequestConfig) {
        return SterowaniePrzyjciemVoiceApiFp(this.configuration).voiceAdmissionControlControllerPublishQualifiedRates(requestParameters.publishVoiceQualifiedRatesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz bieżący miesięczny przydział Voice
     * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReadAllowanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SterowaniePrzyjciemVoiceApi
     */
    public voiceAdmissionControlControllerReadAllowance(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReadAllowanceRequest, options?: AxiosRequestConfig) {
        return SterowaniePrzyjciemVoiceApiFp(this.configuration).voiceAdmissionControlControllerReadAllowance(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz stan dziennego wyłącznika kosztowego Voice
     * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReadSpendControlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SterowaniePrzyjciemVoiceApi
     */
    public voiceAdmissionControlControllerReadSpendControl(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReadSpendControlRequest = {}, options?: AxiosRequestConfig) {
        return SterowaniePrzyjciemVoiceApiFp(this.configuration).voiceAdmissionControlControllerReadSpendControl(requestParameters.warsawDay, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Uzgodnij przydział z bieżącym uprawnieniem pilota
     * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReconcileAllowanceEntitlementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SterowaniePrzyjciemVoiceApi
     */
    public voiceAdmissionControlControllerReconcileAllowanceEntitlement(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerReconcileAllowanceEntitlementRequest, options?: AxiosRequestConfig) {
        return SterowaniePrzyjciemVoiceApiFp(this.configuration).voiceAdmissionControlControllerReconcileAllowanceEntitlement(requestParameters.organizationId, requestParameters.provisionVoiceAllowanceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Ustaw niższy bazowy przydział od następnego miesiąca
     * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerScheduleAllowanceReductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SterowaniePrzyjciemVoiceApi
     */
    public voiceAdmissionControlControllerScheduleAllowanceReduction(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerScheduleAllowanceReductionRequest, options?: AxiosRequestConfig) {
        return SterowaniePrzyjciemVoiceApiFp(this.configuration).voiceAdmissionControlControllerScheduleAllowanceReduction(requestParameters.organizationId, requestParameters.scheduleVoiceAllowanceReductionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Dodaj przydział do bieżącego miesiąca Voice
     * @param {SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerTopUpAllowanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SterowaniePrzyjciemVoiceApi
     */
    public voiceAdmissionControlControllerTopUpAllowance(requestParameters: SterowaniePrzyjciemVoiceApiVoiceAdmissionControlControllerTopUpAllowanceRequest, options?: AxiosRequestConfig) {
        return SterowaniePrzyjciemVoiceApiFp(this.configuration).voiceAdmissionControlControllerTopUpAllowance(requestParameters.organizationId, requestParameters.topUpVoiceAllowanceDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SterowanieVoiceMessagingApi - axios parameter creator
 * @export
 */
export const SterowanieVoiceMessagingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Pobierz bieżący stan Voice Messaging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceMessagingControlControllerCurrent: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/messaging/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz diagnostykę Voice Messaging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceMessagingControlControllerDiagnostics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/messaging/diagnostics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Nadaj organizacji beta dostęp do Voice Messaging
         * @param {string} organizationId
         * @param {ChangeVoiceMessagingOrganizationDto} changeVoiceMessagingOrganizationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceMessagingControlControllerGrantOrganization: async (organizationId: string, changeVoiceMessagingOrganizationDto: ChangeVoiceMessagingOrganizationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceMessagingControlControllerGrantOrganization', 'organizationId', organizationId)
            // verify required parameter 'changeVoiceMessagingOrganizationDto' is not null or undefined
            assertParamExists('voiceMessagingControlControllerGrantOrganization', 'changeVoiceMessagingOrganizationDto', changeVoiceMessagingOrganizationDto)
            const localVarPath = `/api/voice-platform/messaging/organizations/{organizationId}/grant`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeVoiceMessagingOrganizationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz historię sterowania Voice Messaging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceMessagingControlControllerHistory: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/messaging/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Opublikuj żądany stan Voice Messaging
         * @param {PublishVoiceMessagingDesiredDto} publishVoiceMessagingDesiredDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceMessagingControlControllerPublishDesired: async (publishVoiceMessagingDesiredDto: PublishVoiceMessagingDesiredDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publishVoiceMessagingDesiredDto' is not null or undefined
            assertParamExists('voiceMessagingControlControllerPublishDesired', 'publishVoiceMessagingDesiredDto', publishVoiceMessagingDesiredDto)
            const localVarPath = `/api/voice-platform/messaging/desired`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishVoiceMessagingDesiredDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Cofnij organizacji beta dostęp do Voice Messaging
         * @param {string} organizationId
         * @param {ChangeVoiceMessagingOrganizationDto} changeVoiceMessagingOrganizationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceMessagingControlControllerRevokeOrganization: async (organizationId: string, changeVoiceMessagingOrganizationDto: ChangeVoiceMessagingOrganizationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceMessagingControlControllerRevokeOrganization', 'organizationId', organizationId)
            // verify required parameter 'changeVoiceMessagingOrganizationDto' is not null or undefined
            assertParamExists('voiceMessagingControlControllerRevokeOrganization', 'changeVoiceMessagingOrganizationDto', changeVoiceMessagingOrganizationDto)
            const localVarPath = `/api/voice-platform/messaging/organizations/{organizationId}/revoke`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeVoiceMessagingOrganizationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SterowanieVoiceMessagingApi - functional programming interface
 * @export
 */
export const SterowanieVoiceMessagingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SterowanieVoiceMessagingApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Pobierz bieżący stan Voice Messaging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceMessagingControlControllerCurrent(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceMessagingControlCurrentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceMessagingControlControllerCurrent(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz diagnostykę Voice Messaging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceMessagingControlControllerDiagnostics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceMessagingControlDiagnosticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceMessagingControlControllerDiagnostics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Nadaj organizacji beta dostęp do Voice Messaging
         * @param {string} organizationId
         * @param {ChangeVoiceMessagingOrganizationDto} changeVoiceMessagingOrganizationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceMessagingControlControllerGrantOrganization(organizationId: string, changeVoiceMessagingOrganizationDto: ChangeVoiceMessagingOrganizationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceMessagingControlReceiptResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceMessagingControlControllerGrantOrganization(organizationId, changeVoiceMessagingOrganizationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz historię sterowania Voice Messaging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceMessagingControlControllerHistory(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoiceMessagingControlHistoryEntryResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceMessagingControlControllerHistory(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Opublikuj żądany stan Voice Messaging
         * @param {PublishVoiceMessagingDesiredDto} publishVoiceMessagingDesiredDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceMessagingControlControllerPublishDesired(publishVoiceMessagingDesiredDto: PublishVoiceMessagingDesiredDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceMessagingControlReceiptResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceMessagingControlControllerPublishDesired(publishVoiceMessagingDesiredDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Cofnij organizacji beta dostęp do Voice Messaging
         * @param {string} organizationId
         * @param {ChangeVoiceMessagingOrganizationDto} changeVoiceMessagingOrganizationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceMessagingControlControllerRevokeOrganization(organizationId: string, changeVoiceMessagingOrganizationDto: ChangeVoiceMessagingOrganizationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceMessagingControlReceiptResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceMessagingControlControllerRevokeOrganization(organizationId, changeVoiceMessagingOrganizationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SterowanieVoiceMessagingApi - factory interface
 * @export
 */
export const SterowanieVoiceMessagingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SterowanieVoiceMessagingApiFp(configuration)
    return {
        /**
         *
         * @summary Pobierz bieżący stan Voice Messaging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceMessagingControlControllerCurrent(options?: AxiosRequestConfig): AxiosPromise<VoiceMessagingControlCurrentResponseDto> {
            return localVarFp.voiceMessagingControlControllerCurrent(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz diagnostykę Voice Messaging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceMessagingControlControllerDiagnostics(options?: AxiosRequestConfig): AxiosPromise<VoiceMessagingControlDiagnosticsResponseDto> {
            return localVarFp.voiceMessagingControlControllerDiagnostics(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Nadaj organizacji beta dostęp do Voice Messaging
         * @param {SterowanieVoiceMessagingApiVoiceMessagingControlControllerGrantOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceMessagingControlControllerGrantOrganization(requestParameters: SterowanieVoiceMessagingApiVoiceMessagingControlControllerGrantOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceMessagingControlReceiptResponseDto> {
            return localVarFp.voiceMessagingControlControllerGrantOrganization(requestParameters.organizationId, requestParameters.changeVoiceMessagingOrganizationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz historię sterowania Voice Messaging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceMessagingControlControllerHistory(options?: AxiosRequestConfig): AxiosPromise<Array<VoiceMessagingControlHistoryEntryResponseDto>> {
            return localVarFp.voiceMessagingControlControllerHistory(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opublikuj żądany stan Voice Messaging
         * @param {SterowanieVoiceMessagingApiVoiceMessagingControlControllerPublishDesiredRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceMessagingControlControllerPublishDesired(requestParameters: SterowanieVoiceMessagingApiVoiceMessagingControlControllerPublishDesiredRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceMessagingControlReceiptResponseDto> {
            return localVarFp.voiceMessagingControlControllerPublishDesired(requestParameters.publishVoiceMessagingDesiredDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cofnij organizacji beta dostęp do Voice Messaging
         * @param {SterowanieVoiceMessagingApiVoiceMessagingControlControllerRevokeOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceMessagingControlControllerRevokeOrganization(requestParameters: SterowanieVoiceMessagingApiVoiceMessagingControlControllerRevokeOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceMessagingControlReceiptResponseDto> {
            return localVarFp.voiceMessagingControlControllerRevokeOrganization(requestParameters.organizationId, requestParameters.changeVoiceMessagingOrganizationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceMessagingControlControllerGrantOrganization operation in SterowanieVoiceMessagingApi.
 * @export
 * @interface SterowanieVoiceMessagingApiVoiceMessagingControlControllerGrantOrganizationRequest
 */
export interface SterowanieVoiceMessagingApiVoiceMessagingControlControllerGrantOrganizationRequest {
    /**
     *
     * @type {string}
     * @memberof SterowanieVoiceMessagingApiVoiceMessagingControlControllerGrantOrganization
     */
    readonly organizationId: string

    /**
     *
     * @type {ChangeVoiceMessagingOrganizationDto}
     * @memberof SterowanieVoiceMessagingApiVoiceMessagingControlControllerGrantOrganization
     */
    readonly changeVoiceMessagingOrganizationDto: ChangeVoiceMessagingOrganizationDto
}

/**
 * Request parameters for voiceMessagingControlControllerPublishDesired operation in SterowanieVoiceMessagingApi.
 * @export
 * @interface SterowanieVoiceMessagingApiVoiceMessagingControlControllerPublishDesiredRequest
 */
export interface SterowanieVoiceMessagingApiVoiceMessagingControlControllerPublishDesiredRequest {
    /**
     *
     * @type {PublishVoiceMessagingDesiredDto}
     * @memberof SterowanieVoiceMessagingApiVoiceMessagingControlControllerPublishDesired
     */
    readonly publishVoiceMessagingDesiredDto: PublishVoiceMessagingDesiredDto
}

/**
 * Request parameters for voiceMessagingControlControllerRevokeOrganization operation in SterowanieVoiceMessagingApi.
 * @export
 * @interface SterowanieVoiceMessagingApiVoiceMessagingControlControllerRevokeOrganizationRequest
 */
export interface SterowanieVoiceMessagingApiVoiceMessagingControlControllerRevokeOrganizationRequest {
    /**
     *
     * @type {string}
     * @memberof SterowanieVoiceMessagingApiVoiceMessagingControlControllerRevokeOrganization
     */
    readonly organizationId: string

    /**
     *
     * @type {ChangeVoiceMessagingOrganizationDto}
     * @memberof SterowanieVoiceMessagingApiVoiceMessagingControlControllerRevokeOrganization
     */
    readonly changeVoiceMessagingOrganizationDto: ChangeVoiceMessagingOrganizationDto
}

/**
 * SterowanieVoiceMessagingApi - object-oriented interface
 * @export
 * @class SterowanieVoiceMessagingApi
 * @extends {BaseAPI}
 */
export class SterowanieVoiceMessagingApi extends BaseAPI {
    /**
     *
     * @summary Pobierz bieżący stan Voice Messaging
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SterowanieVoiceMessagingApi
     */
    public voiceMessagingControlControllerCurrent(options?: AxiosRequestConfig) {
        return SterowanieVoiceMessagingApiFp(this.configuration).voiceMessagingControlControllerCurrent(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz diagnostykę Voice Messaging
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SterowanieVoiceMessagingApi
     */
    public voiceMessagingControlControllerDiagnostics(options?: AxiosRequestConfig) {
        return SterowanieVoiceMessagingApiFp(this.configuration).voiceMessagingControlControllerDiagnostics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Nadaj organizacji beta dostęp do Voice Messaging
     * @param {SterowanieVoiceMessagingApiVoiceMessagingControlControllerGrantOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SterowanieVoiceMessagingApi
     */
    public voiceMessagingControlControllerGrantOrganization(requestParameters: SterowanieVoiceMessagingApiVoiceMessagingControlControllerGrantOrganizationRequest, options?: AxiosRequestConfig) {
        return SterowanieVoiceMessagingApiFp(this.configuration).voiceMessagingControlControllerGrantOrganization(requestParameters.organizationId, requestParameters.changeVoiceMessagingOrganizationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz historię sterowania Voice Messaging
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SterowanieVoiceMessagingApi
     */
    public voiceMessagingControlControllerHistory(options?: AxiosRequestConfig) {
        return SterowanieVoiceMessagingApiFp(this.configuration).voiceMessagingControlControllerHistory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Opublikuj żądany stan Voice Messaging
     * @param {SterowanieVoiceMessagingApiVoiceMessagingControlControllerPublishDesiredRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SterowanieVoiceMessagingApi
     */
    public voiceMessagingControlControllerPublishDesired(requestParameters: SterowanieVoiceMessagingApiVoiceMessagingControlControllerPublishDesiredRequest, options?: AxiosRequestConfig) {
        return SterowanieVoiceMessagingApiFp(this.configuration).voiceMessagingControlControllerPublishDesired(requestParameters.publishVoiceMessagingDesiredDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Cofnij organizacji beta dostęp do Voice Messaging
     * @param {SterowanieVoiceMessagingApiVoiceMessagingControlControllerRevokeOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SterowanieVoiceMessagingApi
     */
    public voiceMessagingControlControllerRevokeOrganization(requestParameters: SterowanieVoiceMessagingApiVoiceMessagingControlControllerRevokeOrganizationRequest, options?: AxiosRequestConfig) {
        return SterowanieVoiceMessagingApiFp(this.configuration).voiceMessagingControlControllerRevokeOrganization(requestParameters.organizationId, requestParameters.changeVoiceMessagingOrganizationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SuggestionCronApi - axios parameter creator
 * @export
 */
export const SuggestionCronApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Generate a new pet fact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionCronControllerGeneratePetFact: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/suggestion/cron/pet-fact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate product recommendations for all profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionCronControllerGenerateProductRecommendations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/suggestion/cron/product-recommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate recommendations for all profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionCronControllerGenerateRecommendations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/suggestion/cron/recommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuggestionCronApi - functional programming interface
 * @export
 */
export const SuggestionCronApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuggestionCronApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Generate a new pet fact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionCronControllerGeneratePetFact(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionCronControllerGeneratePetFact(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Generate product recommendations for all profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionCronControllerGenerateProductRecommendations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionCronControllerGenerateProductRecommendations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Generate recommendations for all profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionCronControllerGenerateRecommendations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecommendationBatchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionCronControllerGenerateRecommendations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SuggestionCronApi - factory interface
 * @export
 */
export const SuggestionCronApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuggestionCronApiFp(configuration)
    return {
        /**
         *
         * @summary Generate a new pet fact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionCronControllerGeneratePetFact(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.suggestionCronControllerGeneratePetFact(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Generate product recommendations for all profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionCronControllerGenerateProductRecommendations(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.suggestionCronControllerGenerateProductRecommendations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Generate recommendations for all profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionCronControllerGenerateRecommendations(options?: AxiosRequestConfig): AxiosPromise<RecommendationBatchResultDto> {
            return localVarFp.suggestionCronControllerGenerateRecommendations(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SuggestionCronApi - object-oriented interface
 * @export
 * @class SuggestionCronApi
 * @extends {BaseAPI}
 */
export class SuggestionCronApi extends BaseAPI {
    /**
     *
     * @summary Generate a new pet fact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionCronApi
     */
    public suggestionCronControllerGeneratePetFact(options?: AxiosRequestConfig) {
        return SuggestionCronApiFp(this.configuration).suggestionCronControllerGeneratePetFact(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Generate product recommendations for all profiles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionCronApi
     */
    public suggestionCronControllerGenerateProductRecommendations(options?: AxiosRequestConfig) {
        return SuggestionCronApiFp(this.configuration).suggestionCronControllerGenerateProductRecommendations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Generate recommendations for all profiles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionCronApi
     */
    public suggestionCronControllerGenerateRecommendations(options?: AxiosRequestConfig) {
        return SuggestionCronApiFp(this.configuration).suggestionCronControllerGenerateRecommendations(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SuggestionsApi - axios parameter creator
 * @export
 */
export const SuggestionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get all suggestions for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerFindAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all suggestions for a specific profile
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerFindAllByProfileId: async (profileId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('suggestionControllerFindAllByProfileId', 'profileId', profileId)
            const localVarPath = `/api/suggestions/profile/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a specific suggestion by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('suggestionControllerFindOne', 'id', id)
            const localVarPath = `/api/suggestions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate a new suggestion for a profile
         * @param {GenerateSuggestionRequestDto} generateSuggestionRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerGenerate: async (generateSuggestionRequestDto: GenerateSuggestionRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateSuggestionRequestDto' is not null or undefined
            assertParamExists('suggestionControllerGenerate', 'generateSuggestionRequestDto', generateSuggestionRequestDto)
            const localVarPath = `/api/suggestions/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateSuggestionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate suggestions for all profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerGenerateAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/suggestions/generate-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Provides expert veterinary guidance for follow-up questions with clinical reasoning
         * @summary Generate followup response for professional question during visit
         * @param {ProfessionalAssistantFollowupRequestDto} professionalAssistantFollowupRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerGenerateProfessionalAssistantFollowup: async (professionalAssistantFollowupRequestDto: ProfessionalAssistantFollowupRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'professionalAssistantFollowupRequestDto' is not null or undefined
            assertParamExists('suggestionControllerGenerateProfessionalAssistantFollowup', 'professionalAssistantFollowupRequestDto', professionalAssistantFollowupRequestDto)
            const localVarPath = `/api/suggestions/professional-assistant/followup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(professionalAssistantFollowupRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the latest AI-generated clinical summary. If none exists, generates a new one.
         * @summary Get latest clinical summary for professional during visit
         * @param {ProfessionalAssistantInitialRequestDto} professionalAssistantInitialRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerGenerateProfessionalAssistantInitialSummary: async (professionalAssistantInitialRequestDto: ProfessionalAssistantInitialRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'professionalAssistantInitialRequestDto' is not null or undefined
            assertParamExists('suggestionControllerGenerateProfessionalAssistantInitialSummary', 'professionalAssistantInitialRequestDto', professionalAssistantInitialRequestDto)
            const localVarPath = `/api/suggestions/professional-assistant/initial-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(professionalAssistantInitialRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the latest pet fact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerGetLatestPetFact: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/suggestions/pet-fact/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a specific pet fact by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerGetPetFactById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('suggestionControllerGetPetFactById', 'id', id)
            const localVarPath = `/api/suggestions/pet-fact/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Mark a pet fact as read
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerMarkPetFactAsRead: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('suggestionControllerMarkPetFactAsRead', 'id', id)
            const localVarPath = `/api/suggestions/pet-facts/{id}/read`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a suggestion
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerRemove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('suggestionControllerRemove', 'id', id)
            const localVarPath = `/api/suggestions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Save conversation feedback
         * @param {ConversationFeedbackDto} conversationFeedbackDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerSaveConversationFeedback: async (conversationFeedbackDto: ConversationFeedbackDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationFeedbackDto' is not null or undefined
            assertParamExists('suggestionControllerSaveConversationFeedback', 'conversationFeedbackDto', conversationFeedbackDto)
            const localVarPath = `/api/suggestions/conversation-feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationFeedbackDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Submit a pet conversation input or question
         * @param {PetConversationRequestDto} petConversationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerSubmitPetConversation: async (petConversationRequestDto: PetConversationRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'petConversationRequestDto' is not null or undefined
            assertParamExists('suggestionControllerSubmitPetConversation', 'petConversationRequestDto', petConversationRequestDto)
            const localVarPath = `/api/suggestions/pet-conversation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(petConversationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Validate if a pet breed and category are valid
         * @param {ValidatePetDto} validatePetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerValidatePet: async (validatePetDto: ValidatePetDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validatePetDto' is not null or undefined
            assertParamExists('suggestionControllerValidatePet', 'validatePetDto', validatePetDto)
            const localVarPath = `/api/suggestions/validate-pet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validatePetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuggestionsApi - functional programming interface
 * @export
 */
export const SuggestionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuggestionsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get all suggestions for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionControllerFindAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionControllerFindAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all suggestions for a specific profile
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionControllerFindAllByProfileId(profileId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionControllerFindAllByProfileId(profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a specific suggestion by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionControllerFindOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Generate a new suggestion for a profile
         * @param {GenerateSuggestionRequestDto} generateSuggestionRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionControllerGenerate(generateSuggestionRequestDto: GenerateSuggestionRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateSuggestionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionControllerGenerate(generateSuggestionRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Generate suggestions for all profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionControllerGenerateAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionControllerGenerateAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Provides expert veterinary guidance for follow-up questions with clinical reasoning
         * @summary Generate followup response for professional question during visit
         * @param {ProfessionalAssistantFollowupRequestDto} professionalAssistantFollowupRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionControllerGenerateProfessionalAssistantFollowup(professionalAssistantFollowupRequestDto: ProfessionalAssistantFollowupRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalAssistantResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionControllerGenerateProfessionalAssistantFollowup(professionalAssistantFollowupRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the latest AI-generated clinical summary. If none exists, generates a new one.
         * @summary Get latest clinical summary for professional during visit
         * @param {ProfessionalAssistantInitialRequestDto} professionalAssistantInitialRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionControllerGenerateProfessionalAssistantInitialSummary(professionalAssistantInitialRequestDto: ProfessionalAssistantInitialRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalAssistantResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionControllerGenerateProfessionalAssistantInitialSummary(professionalAssistantInitialRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get the latest pet fact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionControllerGetLatestPetFact(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionControllerGetLatestPetFact(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a specific pet fact by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionControllerGetPetFactById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PetFact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionControllerGetPetFactById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Mark a pet fact as read
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionControllerMarkPetFactAsRead(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionControllerMarkPetFactAsRead(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a suggestion
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionControllerRemove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionControllerRemove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Save conversation feedback
         * @param {ConversationFeedbackDto} conversationFeedbackDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionControllerSaveConversationFeedback(conversationFeedbackDto: ConversationFeedbackDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionControllerSaveConversationFeedback(conversationFeedbackDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Submit a pet conversation input or question
         * @param {PetConversationRequestDto} petConversationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionControllerSubmitPetConversation(petConversationRequestDto: PetConversationRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PetConversationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionControllerSubmitPetConversation(petConversationRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Validate if a pet breed and category are valid
         * @param {ValidatePetDto} validatePetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionControllerValidatePet(validatePetDto: ValidatePetDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidatePetResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionControllerValidatePet(validatePetDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SuggestionsApi - factory interface
 * @export
 */
export const SuggestionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuggestionsApiFp(configuration)
    return {
        /**
         *
         * @summary Get all suggestions for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerFindAll(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.suggestionControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all suggestions for a specific profile
         * @param {SuggestionsApiSuggestionControllerFindAllByProfileIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerFindAllByProfileId(requestParameters: SuggestionsApiSuggestionControllerFindAllByProfileIdRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.suggestionControllerFindAllByProfileId(requestParameters.profileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a specific suggestion by ID
         * @param {SuggestionsApiSuggestionControllerFindOneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerFindOne(requestParameters: SuggestionsApiSuggestionControllerFindOneRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.suggestionControllerFindOne(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Generate a new suggestion for a profile
         * @param {SuggestionsApiSuggestionControllerGenerateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerGenerate(requestParameters: SuggestionsApiSuggestionControllerGenerateRequest, options?: AxiosRequestConfig): AxiosPromise<GenerateSuggestionResponseDto> {
            return localVarFp.suggestionControllerGenerate(requestParameters.generateSuggestionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Generate suggestions for all profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerGenerateAll(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.suggestionControllerGenerateAll(options).then((request) => request(axios, basePath));
        },
        /**
         * Provides expert veterinary guidance for follow-up questions with clinical reasoning
         * @summary Generate followup response for professional question during visit
         * @param {SuggestionsApiSuggestionControllerGenerateProfessionalAssistantFollowupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerGenerateProfessionalAssistantFollowup(requestParameters: SuggestionsApiSuggestionControllerGenerateProfessionalAssistantFollowupRequest, options?: AxiosRequestConfig): AxiosPromise<ProfessionalAssistantResponseDto> {
            return localVarFp.suggestionControllerGenerateProfessionalAssistantFollowup(requestParameters.professionalAssistantFollowupRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the latest AI-generated clinical summary. If none exists, generates a new one.
         * @summary Get latest clinical summary for professional during visit
         * @param {SuggestionsApiSuggestionControllerGenerateProfessionalAssistantInitialSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerGenerateProfessionalAssistantInitialSummary(requestParameters: SuggestionsApiSuggestionControllerGenerateProfessionalAssistantInitialSummaryRequest, options?: AxiosRequestConfig): AxiosPromise<ProfessionalAssistantResponseDto> {
            return localVarFp.suggestionControllerGenerateProfessionalAssistantInitialSummary(requestParameters.professionalAssistantInitialRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the latest pet fact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerGetLatestPetFact(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.suggestionControllerGetLatestPetFact(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a specific pet fact by ID
         * @param {SuggestionsApiSuggestionControllerGetPetFactByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerGetPetFactById(requestParameters: SuggestionsApiSuggestionControllerGetPetFactByIdRequest, options?: AxiosRequestConfig): AxiosPromise<PetFact> {
            return localVarFp.suggestionControllerGetPetFactById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Mark a pet fact as read
         * @param {SuggestionsApiSuggestionControllerMarkPetFactAsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerMarkPetFactAsRead(requestParameters: SuggestionsApiSuggestionControllerMarkPetFactAsReadRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.suggestionControllerMarkPetFactAsRead(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a suggestion
         * @param {SuggestionsApiSuggestionControllerRemoveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerRemove(requestParameters: SuggestionsApiSuggestionControllerRemoveRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.suggestionControllerRemove(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Save conversation feedback
         * @param {SuggestionsApiSuggestionControllerSaveConversationFeedbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerSaveConversationFeedback(requestParameters: SuggestionsApiSuggestionControllerSaveConversationFeedbackRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.suggestionControllerSaveConversationFeedback(requestParameters.conversationFeedbackDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Submit a pet conversation input or question
         * @param {SuggestionsApiSuggestionControllerSubmitPetConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerSubmitPetConversation(requestParameters: SuggestionsApiSuggestionControllerSubmitPetConversationRequest, options?: AxiosRequestConfig): AxiosPromise<PetConversationResponseDto> {
            return localVarFp.suggestionControllerSubmitPetConversation(requestParameters.petConversationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Validate if a pet breed and category are valid
         * @param {SuggestionsApiSuggestionControllerValidatePetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionControllerValidatePet(requestParameters: SuggestionsApiSuggestionControllerValidatePetRequest, options?: AxiosRequestConfig): AxiosPromise<ValidatePetResponseDto> {
            return localVarFp.suggestionControllerValidatePet(requestParameters.validatePetDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for suggestionControllerFindAllByProfileId operation in SuggestionsApi.
 * @export
 * @interface SuggestionsApiSuggestionControllerFindAllByProfileIdRequest
 */
export interface SuggestionsApiSuggestionControllerFindAllByProfileIdRequest {
    /**
     *
     * @type {string}
     * @memberof SuggestionsApiSuggestionControllerFindAllByProfileId
     */
    readonly profileId: string
}

/**
 * Request parameters for suggestionControllerFindOne operation in SuggestionsApi.
 * @export
 * @interface SuggestionsApiSuggestionControllerFindOneRequest
 */
export interface SuggestionsApiSuggestionControllerFindOneRequest {
    /**
     *
     * @type {string}
     * @memberof SuggestionsApiSuggestionControllerFindOne
     */
    readonly id: string
}

/**
 * Request parameters for suggestionControllerGenerate operation in SuggestionsApi.
 * @export
 * @interface SuggestionsApiSuggestionControllerGenerateRequest
 */
export interface SuggestionsApiSuggestionControllerGenerateRequest {
    /**
     *
     * @type {GenerateSuggestionRequestDto}
     * @memberof SuggestionsApiSuggestionControllerGenerate
     */
    readonly generateSuggestionRequestDto: GenerateSuggestionRequestDto
}

/**
 * Request parameters for suggestionControllerGenerateProfessionalAssistantFollowup operation in SuggestionsApi.
 * @export
 * @interface SuggestionsApiSuggestionControllerGenerateProfessionalAssistantFollowupRequest
 */
export interface SuggestionsApiSuggestionControllerGenerateProfessionalAssistantFollowupRequest {
    /**
     *
     * @type {ProfessionalAssistantFollowupRequestDto}
     * @memberof SuggestionsApiSuggestionControllerGenerateProfessionalAssistantFollowup
     */
    readonly professionalAssistantFollowupRequestDto: ProfessionalAssistantFollowupRequestDto
}

/**
 * Request parameters for suggestionControllerGenerateProfessionalAssistantInitialSummary operation in SuggestionsApi.
 * @export
 * @interface SuggestionsApiSuggestionControllerGenerateProfessionalAssistantInitialSummaryRequest
 */
export interface SuggestionsApiSuggestionControllerGenerateProfessionalAssistantInitialSummaryRequest {
    /**
     *
     * @type {ProfessionalAssistantInitialRequestDto}
     * @memberof SuggestionsApiSuggestionControllerGenerateProfessionalAssistantInitialSummary
     */
    readonly professionalAssistantInitialRequestDto: ProfessionalAssistantInitialRequestDto
}

/**
 * Request parameters for suggestionControllerGetPetFactById operation in SuggestionsApi.
 * @export
 * @interface SuggestionsApiSuggestionControllerGetPetFactByIdRequest
 */
export interface SuggestionsApiSuggestionControllerGetPetFactByIdRequest {
    /**
     *
     * @type {string}
     * @memberof SuggestionsApiSuggestionControllerGetPetFactById
     */
    readonly id: string
}

/**
 * Request parameters for suggestionControllerMarkPetFactAsRead operation in SuggestionsApi.
 * @export
 * @interface SuggestionsApiSuggestionControllerMarkPetFactAsReadRequest
 */
export interface SuggestionsApiSuggestionControllerMarkPetFactAsReadRequest {
    /**
     *
     * @type {string}
     * @memberof SuggestionsApiSuggestionControllerMarkPetFactAsRead
     */
    readonly id: string
}

/**
 * Request parameters for suggestionControllerRemove operation in SuggestionsApi.
 * @export
 * @interface SuggestionsApiSuggestionControllerRemoveRequest
 */
export interface SuggestionsApiSuggestionControllerRemoveRequest {
    /**
     *
     * @type {string}
     * @memberof SuggestionsApiSuggestionControllerRemove
     */
    readonly id: string
}

/**
 * Request parameters for suggestionControllerSaveConversationFeedback operation in SuggestionsApi.
 * @export
 * @interface SuggestionsApiSuggestionControllerSaveConversationFeedbackRequest
 */
export interface SuggestionsApiSuggestionControllerSaveConversationFeedbackRequest {
    /**
     *
     * @type {ConversationFeedbackDto}
     * @memberof SuggestionsApiSuggestionControllerSaveConversationFeedback
     */
    readonly conversationFeedbackDto: ConversationFeedbackDto
}

/**
 * Request parameters for suggestionControllerSubmitPetConversation operation in SuggestionsApi.
 * @export
 * @interface SuggestionsApiSuggestionControllerSubmitPetConversationRequest
 */
export interface SuggestionsApiSuggestionControllerSubmitPetConversationRequest {
    /**
     *
     * @type {PetConversationRequestDto}
     * @memberof SuggestionsApiSuggestionControllerSubmitPetConversation
     */
    readonly petConversationRequestDto: PetConversationRequestDto
}

/**
 * Request parameters for suggestionControllerValidatePet operation in SuggestionsApi.
 * @export
 * @interface SuggestionsApiSuggestionControllerValidatePetRequest
 */
export interface SuggestionsApiSuggestionControllerValidatePetRequest {
    /**
     *
     * @type {ValidatePetDto}
     * @memberof SuggestionsApiSuggestionControllerValidatePet
     */
    readonly validatePetDto: ValidatePetDto
}

/**
 * SuggestionsApi - object-oriented interface
 * @export
 * @class SuggestionsApi
 * @extends {BaseAPI}
 */
export class SuggestionsApi extends BaseAPI {
    /**
     *
     * @summary Get all suggestions for the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionsApi
     */
    public suggestionControllerFindAll(options?: AxiosRequestConfig) {
        return SuggestionsApiFp(this.configuration).suggestionControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all suggestions for a specific profile
     * @param {SuggestionsApiSuggestionControllerFindAllByProfileIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionsApi
     */
    public suggestionControllerFindAllByProfileId(requestParameters: SuggestionsApiSuggestionControllerFindAllByProfileIdRequest, options?: AxiosRequestConfig) {
        return SuggestionsApiFp(this.configuration).suggestionControllerFindAllByProfileId(requestParameters.profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get a specific suggestion by ID
     * @param {SuggestionsApiSuggestionControllerFindOneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionsApi
     */
    public suggestionControllerFindOne(requestParameters: SuggestionsApiSuggestionControllerFindOneRequest, options?: AxiosRequestConfig) {
        return SuggestionsApiFp(this.configuration).suggestionControllerFindOne(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Generate a new suggestion for a profile
     * @param {SuggestionsApiSuggestionControllerGenerateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionsApi
     */
    public suggestionControllerGenerate(requestParameters: SuggestionsApiSuggestionControllerGenerateRequest, options?: AxiosRequestConfig) {
        return SuggestionsApiFp(this.configuration).suggestionControllerGenerate(requestParameters.generateSuggestionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Generate suggestions for all profiles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionsApi
     */
    public suggestionControllerGenerateAll(options?: AxiosRequestConfig) {
        return SuggestionsApiFp(this.configuration).suggestionControllerGenerateAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Provides expert veterinary guidance for follow-up questions with clinical reasoning
     * @summary Generate followup response for professional question during visit
     * @param {SuggestionsApiSuggestionControllerGenerateProfessionalAssistantFollowupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionsApi
     */
    public suggestionControllerGenerateProfessionalAssistantFollowup(requestParameters: SuggestionsApiSuggestionControllerGenerateProfessionalAssistantFollowupRequest, options?: AxiosRequestConfig) {
        return SuggestionsApiFp(this.configuration).suggestionControllerGenerateProfessionalAssistantFollowup(requestParameters.professionalAssistantFollowupRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the latest AI-generated clinical summary. If none exists, generates a new one.
     * @summary Get latest clinical summary for professional during visit
     * @param {SuggestionsApiSuggestionControllerGenerateProfessionalAssistantInitialSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionsApi
     */
    public suggestionControllerGenerateProfessionalAssistantInitialSummary(requestParameters: SuggestionsApiSuggestionControllerGenerateProfessionalAssistantInitialSummaryRequest, options?: AxiosRequestConfig) {
        return SuggestionsApiFp(this.configuration).suggestionControllerGenerateProfessionalAssistantInitialSummary(requestParameters.professionalAssistantInitialRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get the latest pet fact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionsApi
     */
    public suggestionControllerGetLatestPetFact(options?: AxiosRequestConfig) {
        return SuggestionsApiFp(this.configuration).suggestionControllerGetLatestPetFact(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get a specific pet fact by ID
     * @param {SuggestionsApiSuggestionControllerGetPetFactByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionsApi
     */
    public suggestionControllerGetPetFactById(requestParameters: SuggestionsApiSuggestionControllerGetPetFactByIdRequest, options?: AxiosRequestConfig) {
        return SuggestionsApiFp(this.configuration).suggestionControllerGetPetFactById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Mark a pet fact as read
     * @param {SuggestionsApiSuggestionControllerMarkPetFactAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionsApi
     */
    public suggestionControllerMarkPetFactAsRead(requestParameters: SuggestionsApiSuggestionControllerMarkPetFactAsReadRequest, options?: AxiosRequestConfig) {
        return SuggestionsApiFp(this.configuration).suggestionControllerMarkPetFactAsRead(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete a suggestion
     * @param {SuggestionsApiSuggestionControllerRemoveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionsApi
     */
    public suggestionControllerRemove(requestParameters: SuggestionsApiSuggestionControllerRemoveRequest, options?: AxiosRequestConfig) {
        return SuggestionsApiFp(this.configuration).suggestionControllerRemove(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Save conversation feedback
     * @param {SuggestionsApiSuggestionControllerSaveConversationFeedbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionsApi
     */
    public suggestionControllerSaveConversationFeedback(requestParameters: SuggestionsApiSuggestionControllerSaveConversationFeedbackRequest, options?: AxiosRequestConfig) {
        return SuggestionsApiFp(this.configuration).suggestionControllerSaveConversationFeedback(requestParameters.conversationFeedbackDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Submit a pet conversation input or question
     * @param {SuggestionsApiSuggestionControllerSubmitPetConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionsApi
     */
    public suggestionControllerSubmitPetConversation(requestParameters: SuggestionsApiSuggestionControllerSubmitPetConversationRequest, options?: AxiosRequestConfig) {
        return SuggestionsApiFp(this.configuration).suggestionControllerSubmitPetConversation(requestParameters.petConversationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Validate if a pet breed and category are valid
     * @param {SuggestionsApiSuggestionControllerValidatePetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionsApi
     */
    public suggestionControllerValidatePet(requestParameters: SuggestionsApiSuggestionControllerValidatePetRequest, options?: AxiosRequestConfig) {
        return SuggestionsApiFp(this.configuration).suggestionControllerValidatePet(requestParameters.validatePetDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TemplatesApi - axios parameter creator
 * @export
 */
export const TemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create a new template
         * @param {CreateTemplateDto} createTemplateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateControllerCreateTemplate: async (createTemplateDto: CreateTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTemplateDto' is not null or undefined
            assertParamExists('templateControllerCreateTemplate', 'createTemplateDto', createTemplateDto)
            const localVarPath = `/api/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a template
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateControllerDeleteTemplate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('templateControllerDeleteTemplate', 'id', id)
            const localVarPath = `/api/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get template by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateControllerGetTemplateById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('templateControllerGetTemplateById', 'id', id)
            const localVarPath = `/api/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all template categories for organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateControllerGetTemplateCategories: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/templates/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get templates
         * @param {string} [category] Filter templates by category - can be any string category
         * @param {'initial_assessment' | 'follow_up' | 'general' | 'surgery' | 'vaccination' | 'emergency' | 'diagnostic' | 'prescription' | 'discharge' | 'checkup'} [templateType] Filter templates by type
         * @param {boolean} [includeShared] Include shared templates from other organizations within the same organization
         * @param {string} [name] Filter templates by name (case-insensitive)
         * @param {boolean} [includeDefaults] Include default organization templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateControllerGetTemplates: async (category?: string, templateType?: 'initial_assessment' | 'follow_up' | 'general' | 'surgery' | 'vaccination' | 'emergency' | 'diagnostic' | 'prescription' | 'discharge' | 'checkup', includeShared?: boolean, name?: string, includeDefaults?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (templateType !== undefined) {
                localVarQueryParameter['templateType'] = templateType;
            }

            if (includeShared !== undefined) {
                localVarQueryParameter['includeShared'] = includeShared;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (includeDefaults !== undefined) {
                localVarQueryParameter['includeDefaults'] = includeDefaults;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a template
         * @param {string} id
         * @param {UpdateTemplateDto} updateTemplateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateControllerUpdateTemplate: async (id: string, updateTemplateDto: UpdateTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('templateControllerUpdateTemplate', 'id', id)
            // verify required parameter 'updateTemplateDto' is not null or undefined
            assertParamExists('templateControllerUpdateTemplate', 'updateTemplateDto', updateTemplateDto)
            const localVarPath = `/api/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TemplatesApi - functional programming interface
 * @export
 */
export const TemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create a new template
         * @param {CreateTemplateDto} createTemplateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async templateControllerCreateTemplate(createTemplateDto: CreateTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.templateControllerCreateTemplate(createTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a template
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async templateControllerDeleteTemplate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.templateControllerDeleteTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get template by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async templateControllerGetTemplateById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.templateControllerGetTemplateById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all template categories for organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async templateControllerGetTemplateCategories(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.templateControllerGetTemplateCategories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get templates
         * @param {string} [category] Filter templates by category - can be any string category
         * @param {'initial_assessment' | 'follow_up' | 'general' | 'surgery' | 'vaccination' | 'emergency' | 'diagnostic' | 'prescription' | 'discharge' | 'checkup'} [templateType] Filter templates by type
         * @param {boolean} [includeShared] Include shared templates from other organizations within the same organization
         * @param {string} [name] Filter templates by name (case-insensitive)
         * @param {boolean} [includeDefaults] Include default organization templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async templateControllerGetTemplates(category?: string, templateType?: 'initial_assessment' | 'follow_up' | 'general' | 'surgery' | 'vaccination' | 'emergency' | 'diagnostic' | 'prescription' | 'discharge' | 'checkup', includeShared?: boolean, name?: string, includeDefaults?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTemplateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.templateControllerGetTemplates(category, templateType, includeShared, name, includeDefaults, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update a template
         * @param {string} id
         * @param {UpdateTemplateDto} updateTemplateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async templateControllerUpdateTemplate(id: string, updateTemplateDto: UpdateTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.templateControllerUpdateTemplate(id, updateTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TemplatesApi - factory interface
 * @export
 */
export const TemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TemplatesApiFp(configuration)
    return {
        /**
         *
         * @summary Create a new template
         * @param {TemplatesApiTemplateControllerCreateTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateControllerCreateTemplate(requestParameters: TemplatesApiTemplateControllerCreateTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<GetTemplateDto> {
            return localVarFp.templateControllerCreateTemplate(requestParameters.createTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a template
         * @param {TemplatesApiTemplateControllerDeleteTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateControllerDeleteTemplate(requestParameters: TemplatesApiTemplateControllerDeleteTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.templateControllerDeleteTemplate(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get template by ID
         * @param {TemplatesApiTemplateControllerGetTemplateByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateControllerGetTemplateById(requestParameters: TemplatesApiTemplateControllerGetTemplateByIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetTemplateDto> {
            return localVarFp.templateControllerGetTemplateById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all template categories for organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateControllerGetTemplateCategories(options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.templateControllerGetTemplateCategories(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get templates
         * @param {TemplatesApiTemplateControllerGetTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateControllerGetTemplates(requestParameters: TemplatesApiTemplateControllerGetTemplatesRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<GetTemplateDto>> {
            return localVarFp.templateControllerGetTemplates(requestParameters.category, requestParameters.templateType, requestParameters.includeShared, requestParameters.name, requestParameters.includeDefaults, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a template
         * @param {TemplatesApiTemplateControllerUpdateTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateControllerUpdateTemplate(requestParameters: TemplatesApiTemplateControllerUpdateTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<GetTemplateDto> {
            return localVarFp.templateControllerUpdateTemplate(requestParameters.id, requestParameters.updateTemplateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for templateControllerCreateTemplate operation in TemplatesApi.
 * @export
 * @interface TemplatesApiTemplateControllerCreateTemplateRequest
 */
export interface TemplatesApiTemplateControllerCreateTemplateRequest {
    /**
     *
     * @type {CreateTemplateDto}
     * @memberof TemplatesApiTemplateControllerCreateTemplate
     */
    readonly createTemplateDto: CreateTemplateDto
}

/**
 * Request parameters for templateControllerDeleteTemplate operation in TemplatesApi.
 * @export
 * @interface TemplatesApiTemplateControllerDeleteTemplateRequest
 */
export interface TemplatesApiTemplateControllerDeleteTemplateRequest {
    /**
     *
     * @type {string}
     * @memberof TemplatesApiTemplateControllerDeleteTemplate
     */
    readonly id: string
}

/**
 * Request parameters for templateControllerGetTemplateById operation in TemplatesApi.
 * @export
 * @interface TemplatesApiTemplateControllerGetTemplateByIdRequest
 */
export interface TemplatesApiTemplateControllerGetTemplateByIdRequest {
    /**
     *
     * @type {string}
     * @memberof TemplatesApiTemplateControllerGetTemplateById
     */
    readonly id: string
}

/**
 * Request parameters for templateControllerGetTemplates operation in TemplatesApi.
 * @export
 * @interface TemplatesApiTemplateControllerGetTemplatesRequest
 */
export interface TemplatesApiTemplateControllerGetTemplatesRequest {
    /**
     * Filter templates by category - can be any string category
     * @type {string}
     * @memberof TemplatesApiTemplateControllerGetTemplates
     */
    readonly category?: string

    /**
     * Filter templates by type
     * @type {'initial_assessment' | 'follow_up' | 'general' | 'surgery' | 'vaccination' | 'emergency' | 'diagnostic' | 'prescription' | 'discharge' | 'checkup'}
     * @memberof TemplatesApiTemplateControllerGetTemplates
     */
    readonly templateType?: 'initial_assessment' | 'follow_up' | 'general' | 'surgery' | 'vaccination' | 'emergency' | 'diagnostic' | 'prescription' | 'discharge' | 'checkup'

    /**
     * Include shared templates from other organizations within the same organization
     * @type {boolean}
     * @memberof TemplatesApiTemplateControllerGetTemplates
     */
    readonly includeShared?: boolean

    /**
     * Filter templates by name (case-insensitive)
     * @type {string}
     * @memberof TemplatesApiTemplateControllerGetTemplates
     */
    readonly name?: string

    /**
     * Include default organization templates
     * @type {boolean}
     * @memberof TemplatesApiTemplateControllerGetTemplates
     */
    readonly includeDefaults?: boolean
}

/**
 * Request parameters for templateControllerUpdateTemplate operation in TemplatesApi.
 * @export
 * @interface TemplatesApiTemplateControllerUpdateTemplateRequest
 */
export interface TemplatesApiTemplateControllerUpdateTemplateRequest {
    /**
     *
     * @type {string}
     * @memberof TemplatesApiTemplateControllerUpdateTemplate
     */
    readonly id: string

    /**
     *
     * @type {UpdateTemplateDto}
     * @memberof TemplatesApiTemplateControllerUpdateTemplate
     */
    readonly updateTemplateDto: UpdateTemplateDto
}

/**
 * TemplatesApi - object-oriented interface
 * @export
 * @class TemplatesApi
 * @extends {BaseAPI}
 */
export class TemplatesApi extends BaseAPI {
    /**
     *
     * @summary Create a new template
     * @param {TemplatesApiTemplateControllerCreateTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public templateControllerCreateTemplate(requestParameters: TemplatesApiTemplateControllerCreateTemplateRequest, options?: AxiosRequestConfig) {
        return TemplatesApiFp(this.configuration).templateControllerCreateTemplate(requestParameters.createTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete a template
     * @param {TemplatesApiTemplateControllerDeleteTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public templateControllerDeleteTemplate(requestParameters: TemplatesApiTemplateControllerDeleteTemplateRequest, options?: AxiosRequestConfig) {
        return TemplatesApiFp(this.configuration).templateControllerDeleteTemplate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get template by ID
     * @param {TemplatesApiTemplateControllerGetTemplateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public templateControllerGetTemplateById(requestParameters: TemplatesApiTemplateControllerGetTemplateByIdRequest, options?: AxiosRequestConfig) {
        return TemplatesApiFp(this.configuration).templateControllerGetTemplateById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all template categories for organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public templateControllerGetTemplateCategories(options?: AxiosRequestConfig) {
        return TemplatesApiFp(this.configuration).templateControllerGetTemplateCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get templates
     * @param {TemplatesApiTemplateControllerGetTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public templateControllerGetTemplates(requestParameters: TemplatesApiTemplateControllerGetTemplatesRequest = {}, options?: AxiosRequestConfig) {
        return TemplatesApiFp(this.configuration).templateControllerGetTemplates(requestParameters.category, requestParameters.templateType, requestParameters.includeShared, requestParameters.name, requestParameters.includeDefaults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update a template
     * @param {TemplatesApiTemplateControllerUpdateTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public templateControllerUpdateTemplate(requestParameters: TemplatesApiTemplateControllerUpdateTemplateRequest, options?: AxiosRequestConfig) {
        return TemplatesApiFp(this.configuration).templateControllerUpdateTemplate(requestParameters.id, requestParameters.updateTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TermsConditionsApi - axios parameter creator
 * @export
 */
export const TermsConditionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Accept terms and conditions and/or privacy policy
         * @param {AcceptTermsConditionsDto} acceptTermsConditionsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termsConditionsControllerAcceptTerms: async (acceptTermsConditionsDto: AcceptTermsConditionsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptTermsConditionsDto' is not null or undefined
            assertParamExists('termsConditionsControllerAcceptTerms', 'acceptTermsConditionsDto', acceptTermsConditionsDto)
            const localVarPath = `/api/terms-conditions/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptTermsConditionsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Check if current user needs to accept new terms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termsConditionsControllerCheckRequiresAcceptance: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/terms-conditions/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Close account (set inactive and schedule for deletion)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termsConditionsControllerCloseAccount: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/terms-conditions/close-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create new terms and conditions version (Admin)
         * @param {CreateTermsConditionsDto} createTermsConditionsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termsConditionsControllerCreate: async (createTermsConditionsDto: CreateTermsConditionsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTermsConditionsDto' is not null or undefined
            assertParamExists('termsConditionsControllerCreate', 'createTermsConditionsDto', createTermsConditionsDto)
            const localVarPath = `/api/terms-conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTermsConditionsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get active terms and conditions by type
         * @param {'USER' | 'PROFESSIONAL'} type Type of terms: USER or PROFESSIONAL
         * @param {'TERMS_CONDITIONS' | 'PRIVACY_POLICY'} [documentCategory]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termsConditionsControllerGetActiveByType: async (type: 'USER' | 'PROFESSIONAL', documentCategory?: 'TERMS_CONDITIONS' | 'PRIVACY_POLICY', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('termsConditionsControllerGetActiveByType', 'type', type)
            const localVarPath = `/api/terms-conditions/active/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (documentCategory !== undefined) {
                localVarQueryParameter['documentCategory'] = documentCategory;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get active privacy policy (defaults to USER type)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termsConditionsControllerGetActivePrivacyPolicy: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/terms-conditions/privacy-policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get active privacy policy by type
         * @param {'USER' | 'PROFESSIONAL'} type Type of privacy policy: USER or PROFESSIONAL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termsConditionsControllerGetActivePrivacyPolicyByType: async (type: 'USER' | 'PROFESSIONAL', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('termsConditionsControllerGetActivePrivacyPolicyByType', 'type', type)
            const localVarPath = `/api/terms-conditions/privacy-policy/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List all terms and conditions versions (Admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termsConditionsControllerGetAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/terms-conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TermsConditionsApi - functional programming interface
 * @export
 */
export const TermsConditionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TermsConditionsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Accept terms and conditions and/or privacy policy
         * @param {AcceptTermsConditionsDto} acceptTermsConditionsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async termsConditionsControllerAcceptTerms(acceptTermsConditionsDto: AcceptTermsConditionsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AcceptTermsConditionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.termsConditionsControllerAcceptTerms(acceptTermsConditionsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Check if current user needs to accept new terms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async termsConditionsControllerCheckRequiresAcceptance(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckTermsAcceptanceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.termsConditionsControllerCheckRequiresAcceptance(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Close account (set inactive and schedule for deletion)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async termsConditionsControllerCloseAccount(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AcceptTermsConditionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.termsConditionsControllerCloseAccount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Create new terms and conditions version (Admin)
         * @param {CreateTermsConditionsDto} createTermsConditionsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async termsConditionsControllerCreate(createTermsConditionsDto: CreateTermsConditionsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTermsConditionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.termsConditionsControllerCreate(createTermsConditionsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get active terms and conditions by type
         * @param {'USER' | 'PROFESSIONAL'} type Type of terms: USER or PROFESSIONAL
         * @param {'TERMS_CONDITIONS' | 'PRIVACY_POLICY'} [documentCategory]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async termsConditionsControllerGetActiveByType(type: 'USER' | 'PROFESSIONAL', documentCategory?: 'TERMS_CONDITIONS' | 'PRIVACY_POLICY', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTermsConditionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.termsConditionsControllerGetActiveByType(type, documentCategory, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get active privacy policy (defaults to USER type)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async termsConditionsControllerGetActivePrivacyPolicy(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTermsConditionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.termsConditionsControllerGetActivePrivacyPolicy(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get active privacy policy by type
         * @param {'USER' | 'PROFESSIONAL'} type Type of privacy policy: USER or PROFESSIONAL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async termsConditionsControllerGetActivePrivacyPolicyByType(type: 'USER' | 'PROFESSIONAL', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTermsConditionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.termsConditionsControllerGetActivePrivacyPolicyByType(type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List all terms and conditions versions (Admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async termsConditionsControllerGetAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTermsConditionsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.termsConditionsControllerGetAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TermsConditionsApi - factory interface
 * @export
 */
export const TermsConditionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TermsConditionsApiFp(configuration)
    return {
        /**
         *
         * @summary Accept terms and conditions and/or privacy policy
         * @param {TermsConditionsApiTermsConditionsControllerAcceptTermsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termsConditionsControllerAcceptTerms(requestParameters: TermsConditionsApiTermsConditionsControllerAcceptTermsRequest, options?: AxiosRequestConfig): AxiosPromise<AcceptTermsConditionsResponseDto> {
            return localVarFp.termsConditionsControllerAcceptTerms(requestParameters.acceptTermsConditionsDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check if current user needs to accept new terms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termsConditionsControllerCheckRequiresAcceptance(options?: AxiosRequestConfig): AxiosPromise<CheckTermsAcceptanceResponseDto> {
            return localVarFp.termsConditionsControllerCheckRequiresAcceptance(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Close account (set inactive and schedule for deletion)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termsConditionsControllerCloseAccount(options?: AxiosRequestConfig): AxiosPromise<AcceptTermsConditionsResponseDto> {
            return localVarFp.termsConditionsControllerCloseAccount(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create new terms and conditions version (Admin)
         * @param {TermsConditionsApiTermsConditionsControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termsConditionsControllerCreate(requestParameters: TermsConditionsApiTermsConditionsControllerCreateRequest, options?: AxiosRequestConfig): AxiosPromise<GetTermsConditionsDto> {
            return localVarFp.termsConditionsControllerCreate(requestParameters.createTermsConditionsDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get active terms and conditions by type
         * @param {TermsConditionsApiTermsConditionsControllerGetActiveByTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termsConditionsControllerGetActiveByType(requestParameters: TermsConditionsApiTermsConditionsControllerGetActiveByTypeRequest, options?: AxiosRequestConfig): AxiosPromise<GetTermsConditionsDto> {
            return localVarFp.termsConditionsControllerGetActiveByType(requestParameters.type, requestParameters.documentCategory, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get active privacy policy (defaults to USER type)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termsConditionsControllerGetActivePrivacyPolicy(options?: AxiosRequestConfig): AxiosPromise<GetTermsConditionsDto> {
            return localVarFp.termsConditionsControllerGetActivePrivacyPolicy(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get active privacy policy by type
         * @param {TermsConditionsApiTermsConditionsControllerGetActivePrivacyPolicyByTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termsConditionsControllerGetActivePrivacyPolicyByType(requestParameters: TermsConditionsApiTermsConditionsControllerGetActivePrivacyPolicyByTypeRequest, options?: AxiosRequestConfig): AxiosPromise<GetTermsConditionsDto> {
            return localVarFp.termsConditionsControllerGetActivePrivacyPolicyByType(requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all terms and conditions versions (Admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termsConditionsControllerGetAll(options?: AxiosRequestConfig): AxiosPromise<Array<GetTermsConditionsDto>> {
            return localVarFp.termsConditionsControllerGetAll(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for termsConditionsControllerAcceptTerms operation in TermsConditionsApi.
 * @export
 * @interface TermsConditionsApiTermsConditionsControllerAcceptTermsRequest
 */
export interface TermsConditionsApiTermsConditionsControllerAcceptTermsRequest {
    /**
     *
     * @type {AcceptTermsConditionsDto}
     * @memberof TermsConditionsApiTermsConditionsControllerAcceptTerms
     */
    readonly acceptTermsConditionsDto: AcceptTermsConditionsDto
}

/**
 * Request parameters for termsConditionsControllerCreate operation in TermsConditionsApi.
 * @export
 * @interface TermsConditionsApiTermsConditionsControllerCreateRequest
 */
export interface TermsConditionsApiTermsConditionsControllerCreateRequest {
    /**
     *
     * @type {CreateTermsConditionsDto}
     * @memberof TermsConditionsApiTermsConditionsControllerCreate
     */
    readonly createTermsConditionsDto: CreateTermsConditionsDto
}

/**
 * Request parameters for termsConditionsControllerGetActiveByType operation in TermsConditionsApi.
 * @export
 * @interface TermsConditionsApiTermsConditionsControllerGetActiveByTypeRequest
 */
export interface TermsConditionsApiTermsConditionsControllerGetActiveByTypeRequest {
    /**
     * Type of terms: USER or PROFESSIONAL
     * @type {'USER' | 'PROFESSIONAL'}
     * @memberof TermsConditionsApiTermsConditionsControllerGetActiveByType
     */
    readonly type: 'USER' | 'PROFESSIONAL'

    /**
     *
     * @type {'TERMS_CONDITIONS' | 'PRIVACY_POLICY'}
     * @memberof TermsConditionsApiTermsConditionsControllerGetActiveByType
     */
    readonly documentCategory?: 'TERMS_CONDITIONS' | 'PRIVACY_POLICY'
}

/**
 * Request parameters for termsConditionsControllerGetActivePrivacyPolicyByType operation in TermsConditionsApi.
 * @export
 * @interface TermsConditionsApiTermsConditionsControllerGetActivePrivacyPolicyByTypeRequest
 */
export interface TermsConditionsApiTermsConditionsControllerGetActivePrivacyPolicyByTypeRequest {
    /**
     * Type of privacy policy: USER or PROFESSIONAL
     * @type {'USER' | 'PROFESSIONAL'}
     * @memberof TermsConditionsApiTermsConditionsControllerGetActivePrivacyPolicyByType
     */
    readonly type: 'USER' | 'PROFESSIONAL'
}

/**
 * TermsConditionsApi - object-oriented interface
 * @export
 * @class TermsConditionsApi
 * @extends {BaseAPI}
 */
export class TermsConditionsApi extends BaseAPI {
    /**
     *
     * @summary Accept terms and conditions and/or privacy policy
     * @param {TermsConditionsApiTermsConditionsControllerAcceptTermsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsConditionsApi
     */
    public termsConditionsControllerAcceptTerms(requestParameters: TermsConditionsApiTermsConditionsControllerAcceptTermsRequest, options?: AxiosRequestConfig) {
        return TermsConditionsApiFp(this.configuration).termsConditionsControllerAcceptTerms(requestParameters.acceptTermsConditionsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Check if current user needs to accept new terms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsConditionsApi
     */
    public termsConditionsControllerCheckRequiresAcceptance(options?: AxiosRequestConfig) {
        return TermsConditionsApiFp(this.configuration).termsConditionsControllerCheckRequiresAcceptance(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Close account (set inactive and schedule for deletion)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsConditionsApi
     */
    public termsConditionsControllerCloseAccount(options?: AxiosRequestConfig) {
        return TermsConditionsApiFp(this.configuration).termsConditionsControllerCloseAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create new terms and conditions version (Admin)
     * @param {TermsConditionsApiTermsConditionsControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsConditionsApi
     */
    public termsConditionsControllerCreate(requestParameters: TermsConditionsApiTermsConditionsControllerCreateRequest, options?: AxiosRequestConfig) {
        return TermsConditionsApiFp(this.configuration).termsConditionsControllerCreate(requestParameters.createTermsConditionsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get active terms and conditions by type
     * @param {TermsConditionsApiTermsConditionsControllerGetActiveByTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsConditionsApi
     */
    public termsConditionsControllerGetActiveByType(requestParameters: TermsConditionsApiTermsConditionsControllerGetActiveByTypeRequest, options?: AxiosRequestConfig) {
        return TermsConditionsApiFp(this.configuration).termsConditionsControllerGetActiveByType(requestParameters.type, requestParameters.documentCategory, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get active privacy policy (defaults to USER type)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsConditionsApi
     */
    public termsConditionsControllerGetActivePrivacyPolicy(options?: AxiosRequestConfig) {
        return TermsConditionsApiFp(this.configuration).termsConditionsControllerGetActivePrivacyPolicy(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get active privacy policy by type
     * @param {TermsConditionsApiTermsConditionsControllerGetActivePrivacyPolicyByTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsConditionsApi
     */
    public termsConditionsControllerGetActivePrivacyPolicyByType(requestParameters: TermsConditionsApiTermsConditionsControllerGetActivePrivacyPolicyByTypeRequest, options?: AxiosRequestConfig) {
        return TermsConditionsApiFp(this.configuration).termsConditionsControllerGetActivePrivacyPolicyByType(requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List all terms and conditions versions (Admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsConditionsApi
     */
    public termsConditionsControllerGetAll(options?: AxiosRequestConfig) {
        return TermsConditionsApiFp(this.configuration).termsConditionsControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TreatmentApi - axios parameter creator
 * @export
 */
export const TreatmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create a new treatment catalog entry
         * @param {CreateTreatmentDto} createTreatmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentControllerCreateTreatment: async (createTreatmentDto: CreateTreatmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTreatmentDto' is not null or undefined
            assertParamExists('treatmentControllerCreateTreatment', 'createTreatmentDto', createTreatmentDto)
            const localVarPath = `/api/treatment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTreatmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a treatment catalog entry
         * @param {string} treatmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentControllerDeleteTreatment: async (treatmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('treatmentControllerDeleteTreatment', 'treatmentId', treatmentId)
            const localVarPath = `/api/treatment/{treatmentId}`
                .replace(`{${"treatmentId"}}`, encodeURIComponent(String(treatmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get active catalog treatments for autocomplete
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentControllerGetCatalog: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('treatmentControllerGetCatalog', 'organizationId', organizationId)
            const localVarPath = `/api/treatment/catalog/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all treatments for an organization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentControllerGetOrganizationTreatments: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('treatmentControllerGetOrganizationTreatments', 'organizationId', organizationId)
            const localVarPath = `/api/treatment/organization/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a single treatment
         * @param {string} treatmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentControllerGetTreatment: async (treatmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('treatmentControllerGetTreatment', 'treatmentId', treatmentId)
            const localVarPath = `/api/treatment/{treatmentId}`
                .replace(`{${"treatmentId"}}`, encodeURIComponent(String(treatmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a treatment catalog entry
         * @param {string} treatmentId
         * @param {UpdateTreatmentDto} updateTreatmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentControllerUpdateTreatment: async (treatmentId: string, updateTreatmentDto: UpdateTreatmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('treatmentControllerUpdateTreatment', 'treatmentId', treatmentId)
            // verify required parameter 'updateTreatmentDto' is not null or undefined
            assertParamExists('treatmentControllerUpdateTreatment', 'updateTreatmentDto', updateTreatmentDto)
            const localVarPath = `/api/treatment/{treatmentId}`
                .replace(`{${"treatmentId"}}`, encodeURIComponent(String(treatmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTreatmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Add treatment to profile
         * @param {string} profileId
         * @param {AddProfileTreatmentDto} addProfileTreatmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerAddProfileTreatment: async (profileId: string, addProfileTreatmentDto: AddProfileTreatmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('treatmentRecordControllerAddProfileTreatment', 'profileId', profileId)
            // verify required parameter 'addProfileTreatmentDto' is not null or undefined
            assertParamExists('treatmentRecordControllerAddProfileTreatment', 'addProfileTreatmentDto', addProfileTreatmentDto)
            const localVarPath = `/api/profile/{profileId}/treatments`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addProfileTreatmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Add a treatment record during a visit.
         * @param {string} visitId
         * @param {AddProfileTreatmentDto} addProfileTreatmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerAddVisitTreatment: async (visitId: string, addProfileTreatmentDto: AddProfileTreatmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('treatmentRecordControllerAddVisitTreatment', 'visitId', visitId)
            // verify required parameter 'addProfileTreatmentDto' is not null or undefined
            assertParamExists('treatmentRecordControllerAddVisitTreatment', 'addProfileTreatmentDto', addProfileTreatmentDto)
            const localVarPath = `/api/organization-profile/visit/{visitId}/treatment`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addProfileTreatmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a profile treatment
         * @param {string} profileId
         * @param {string} treatmentId
         * @param {string} [visitId] Optional visit ID to track deletion as visit activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerDeleteProfileTreatment: async (profileId: string, treatmentId: string, visitId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('treatmentRecordControllerDeleteProfileTreatment', 'profileId', profileId)
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('treatmentRecordControllerDeleteProfileTreatment', 'treatmentId', treatmentId)
            const localVarPath = `/api/profile/{profileId}/treatments/{treatmentId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"treatmentId"}}`, encodeURIComponent(String(treatmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (visitId !== undefined) {
                localVarQueryParameter['visitId'] = visitId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get profile treatments
         * @param {string} profileId
         * @param {number} [page] Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
         * @param {number} [limit] Rows per page. Omit together with &#x60;page&#x60; to get every row.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerGetProfileTreatments: async (profileId: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('treatmentRecordControllerGetProfileTreatments', 'profileId', profileId)
            const localVarPath = `/api/profile/{profileId}/treatments`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get treatments overview across all patients
         * @param {string} organizationId
         * @param {string} [page]
         * @param {string} [limit]
         * @param {string} [name]
         * @param {string} [profileName]
         * @param {string} [professionalId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerGetTreatmentsOverview: async (organizationId: string, page?: string, limit?: string, name?: string, profileName?: string, professionalId?: string, dateFrom?: string, dateTo?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('treatmentRecordControllerGetTreatmentsOverview', 'organizationId', organizationId)
            const localVarPath = `/api/profile/treatments/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (profileName !== undefined) {
                localVarQueryParameter['profileName'] = profileName;
            }

            if (professionalId !== undefined) {
                localVarQueryParameter['professionalId'] = professionalId;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = dateTo;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List treatment records attached to a visit.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerListVisitTreatments: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('treatmentRecordControllerListVisitTreatments', 'visitId', visitId)
            const localVarPath = `/api/organization-profile/visit/{visitId}/treatments`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Remove a treatment record from a visit.
         * @param {string} visitId
         * @param {string} treatmentRecordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerRemoveVisitTreatment: async (visitId: string, treatmentRecordId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('treatmentRecordControllerRemoveVisitTreatment', 'visitId', visitId)
            // verify required parameter 'treatmentRecordId' is not null or undefined
            assertParamExists('treatmentRecordControllerRemoveVisitTreatment', 'treatmentRecordId', treatmentRecordId)
            const localVarPath = `/api/organization-profile/visit/{visitId}/treatment/{treatmentRecordId}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)))
                .replace(`{${"treatmentRecordId"}}`, encodeURIComponent(String(treatmentRecordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a profile treatment
         * @param {string} profileId
         * @param {string} treatmentId
         * @param {UpdateProfileTreatmentDto} updateProfileTreatmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerUpdateProfileTreatment: async (profileId: string, treatmentId: string, updateProfileTreatmentDto: UpdateProfileTreatmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('treatmentRecordControllerUpdateProfileTreatment', 'profileId', profileId)
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('treatmentRecordControllerUpdateProfileTreatment', 'treatmentId', treatmentId)
            // verify required parameter 'updateProfileTreatmentDto' is not null or undefined
            assertParamExists('treatmentRecordControllerUpdateProfileTreatment', 'updateProfileTreatmentDto', updateProfileTreatmentDto)
            const localVarPath = `/api/profile/{profileId}/treatments/{treatmentId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"treatmentId"}}`, encodeURIComponent(String(treatmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileTreatmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a treatment record on a visit.
         * @param {string} visitId
         * @param {string} treatmentRecordId
         * @param {UpdateProfileTreatmentDto} updateProfileTreatmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerUpdateVisitTreatment: async (visitId: string, treatmentRecordId: string, updateProfileTreatmentDto: UpdateProfileTreatmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('treatmentRecordControllerUpdateVisitTreatment', 'visitId', visitId)
            // verify required parameter 'treatmentRecordId' is not null or undefined
            assertParamExists('treatmentRecordControllerUpdateVisitTreatment', 'treatmentRecordId', treatmentRecordId)
            // verify required parameter 'updateProfileTreatmentDto' is not null or undefined
            assertParamExists('treatmentRecordControllerUpdateVisitTreatment', 'updateProfileTreatmentDto', updateProfileTreatmentDto)
            const localVarPath = `/api/organization-profile/visit/{visitId}/treatment/{treatmentRecordId}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)))
                .replace(`{${"treatmentRecordId"}}`, encodeURIComponent(String(treatmentRecordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileTreatmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TreatmentApi - functional programming interface
 * @export
 */
export const TreatmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TreatmentApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create a new treatment catalog entry
         * @param {CreateTreatmentDto} createTreatmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async treatmentControllerCreateTreatment(createTreatmentDto: CreateTreatmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.treatmentControllerCreateTreatment(createTreatmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a treatment catalog entry
         * @param {string} treatmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async treatmentControllerDeleteTreatment(treatmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.treatmentControllerDeleteTreatment(treatmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get active catalog treatments for autocomplete
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async treatmentControllerGetCatalog(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTreatmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.treatmentControllerGetCatalog(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all treatments for an organization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async treatmentControllerGetOrganizationTreatments(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTreatmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.treatmentControllerGetOrganizationTreatments(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a single treatment
         * @param {string} treatmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async treatmentControllerGetTreatment(treatmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.treatmentControllerGetTreatment(treatmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update a treatment catalog entry
         * @param {string} treatmentId
         * @param {UpdateTreatmentDto} updateTreatmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async treatmentControllerUpdateTreatment(treatmentId: string, updateTreatmentDto: UpdateTreatmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.treatmentControllerUpdateTreatment(treatmentId, updateTreatmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Add treatment to profile
         * @param {string} profileId
         * @param {AddProfileTreatmentDto} addProfileTreatmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async treatmentRecordControllerAddProfileTreatment(profileId: string, addProfileTreatmentDto: AddProfileTreatmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProfileTreatmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.treatmentRecordControllerAddProfileTreatment(profileId, addProfileTreatmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Add a treatment record during a visit.
         * @param {string} visitId
         * @param {AddProfileTreatmentDto} addProfileTreatmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async treatmentRecordControllerAddVisitTreatment(visitId: string, addProfileTreatmentDto: AddProfileTreatmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.treatmentRecordControllerAddVisitTreatment(visitId, addProfileTreatmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a profile treatment
         * @param {string} profileId
         * @param {string} treatmentId
         * @param {string} [visitId] Optional visit ID to track deletion as visit activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async treatmentRecordControllerDeleteProfileTreatment(profileId: string, treatmentId: string, visitId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProfileTreatmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.treatmentRecordControllerDeleteProfileTreatment(profileId, treatmentId, visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get profile treatments
         * @param {string} profileId
         * @param {number} [page] Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
         * @param {number} [limit] Rows per page. Omit together with &#x60;page&#x60; to get every row.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async treatmentRecordControllerGetProfileTreatments(profileId: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTreatmentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.treatmentRecordControllerGetProfileTreatments(profileId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get treatments overview across all patients
         * @param {string} organizationId
         * @param {string} [page]
         * @param {string} [limit]
         * @param {string} [name]
         * @param {string} [profileName]
         * @param {string} [professionalId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async treatmentRecordControllerGetTreatmentsOverview(organizationId: string, page?: string, limit?: string, name?: string, profileName?: string, professionalId?: string, dateFrom?: string, dateTo?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentOverviewResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.treatmentRecordControllerGetTreatmentsOverview(organizationId, page, limit, name, profileName, professionalId, dateFrom, dateTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List treatment records attached to a visit.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async treatmentRecordControllerListVisitTreatments(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProfileTreatmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.treatmentRecordControllerListVisitTreatments(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Remove a treatment record from a visit.
         * @param {string} visitId
         * @param {string} treatmentRecordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async treatmentRecordControllerRemoveVisitTreatment(visitId: string, treatmentRecordId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.treatmentRecordControllerRemoveVisitTreatment(visitId, treatmentRecordId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update a profile treatment
         * @param {string} profileId
         * @param {string} treatmentId
         * @param {UpdateProfileTreatmentDto} updateProfileTreatmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async treatmentRecordControllerUpdateProfileTreatment(profileId: string, treatmentId: string, updateProfileTreatmentDto: UpdateProfileTreatmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProfileTreatmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.treatmentRecordControllerUpdateProfileTreatment(profileId, treatmentId, updateProfileTreatmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update a treatment record on a visit.
         * @param {string} visitId
         * @param {string} treatmentRecordId
         * @param {UpdateProfileTreatmentDto} updateProfileTreatmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async treatmentRecordControllerUpdateVisitTreatment(visitId: string, treatmentRecordId: string, updateProfileTreatmentDto: UpdateProfileTreatmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.treatmentRecordControllerUpdateVisitTreatment(visitId, treatmentRecordId, updateProfileTreatmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TreatmentApi - factory interface
 * @export
 */
export const TreatmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TreatmentApiFp(configuration)
    return {
        /**
         *
         * @summary Create a new treatment catalog entry
         * @param {TreatmentApiTreatmentControllerCreateTreatmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentControllerCreateTreatment(requestParameters: TreatmentApiTreatmentControllerCreateTreatmentRequest, options?: AxiosRequestConfig): AxiosPromise<GetTreatmentDto> {
            return localVarFp.treatmentControllerCreateTreatment(requestParameters.createTreatmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a treatment catalog entry
         * @param {TreatmentApiTreatmentControllerDeleteTreatmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentControllerDeleteTreatment(requestParameters: TreatmentApiTreatmentControllerDeleteTreatmentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.treatmentControllerDeleteTreatment(requestParameters.treatmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get active catalog treatments for autocomplete
         * @param {TreatmentApiTreatmentControllerGetCatalogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentControllerGetCatalog(requestParameters: TreatmentApiTreatmentControllerGetCatalogRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetTreatmentDto>> {
            return localVarFp.treatmentControllerGetCatalog(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all treatments for an organization
         * @param {TreatmentApiTreatmentControllerGetOrganizationTreatmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentControllerGetOrganizationTreatments(requestParameters: TreatmentApiTreatmentControllerGetOrganizationTreatmentsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetTreatmentDto>> {
            return localVarFp.treatmentControllerGetOrganizationTreatments(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a single treatment
         * @param {TreatmentApiTreatmentControllerGetTreatmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentControllerGetTreatment(requestParameters: TreatmentApiTreatmentControllerGetTreatmentRequest, options?: AxiosRequestConfig): AxiosPromise<GetTreatmentDto> {
            return localVarFp.treatmentControllerGetTreatment(requestParameters.treatmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a treatment catalog entry
         * @param {TreatmentApiTreatmentControllerUpdateTreatmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentControllerUpdateTreatment(requestParameters: TreatmentApiTreatmentControllerUpdateTreatmentRequest, options?: AxiosRequestConfig): AxiosPromise<GetTreatmentDto> {
            return localVarFp.treatmentControllerUpdateTreatment(requestParameters.treatmentId, requestParameters.updateTreatmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add treatment to profile
         * @param {TreatmentApiTreatmentRecordControllerAddProfileTreatmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerAddProfileTreatment(requestParameters: TreatmentApiTreatmentRecordControllerAddProfileTreatmentRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetProfileTreatmentDto>> {
            return localVarFp.treatmentRecordControllerAddProfileTreatment(requestParameters.profileId, requestParameters.addProfileTreatmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add a treatment record during a visit.
         * @param {TreatmentApiTreatmentRecordControllerAddVisitTreatmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerAddVisitTreatment(requestParameters: TreatmentApiTreatmentRecordControllerAddVisitTreatmentRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.treatmentRecordControllerAddVisitTreatment(requestParameters.visitId, requestParameters.addProfileTreatmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a profile treatment
         * @param {TreatmentApiTreatmentRecordControllerDeleteProfileTreatmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerDeleteProfileTreatment(requestParameters: TreatmentApiTreatmentRecordControllerDeleteProfileTreatmentRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetProfileTreatmentDto>> {
            return localVarFp.treatmentRecordControllerDeleteProfileTreatment(requestParameters.profileId, requestParameters.treatmentId, requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get profile treatments
         * @param {TreatmentApiTreatmentRecordControllerGetProfileTreatmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerGetProfileTreatments(requestParameters: TreatmentApiTreatmentRecordControllerGetProfileTreatmentsRequest, options?: AxiosRequestConfig): AxiosPromise<PaginatedTreatmentsResponseDto> {
            return localVarFp.treatmentRecordControllerGetProfileTreatments(requestParameters.profileId, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get treatments overview across all patients
         * @param {TreatmentApiTreatmentRecordControllerGetTreatmentsOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerGetTreatmentsOverview(requestParameters: TreatmentApiTreatmentRecordControllerGetTreatmentsOverviewRequest, options?: AxiosRequestConfig): AxiosPromise<GetTreatmentOverviewResponseDto> {
            return localVarFp.treatmentRecordControllerGetTreatmentsOverview(requestParameters.organizationId, requestParameters.page, requestParameters.limit, requestParameters.name, requestParameters.profileName, requestParameters.professionalId, requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List treatment records attached to a visit.
         * @param {TreatmentApiTreatmentRecordControllerListVisitTreatmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerListVisitTreatments(requestParameters: TreatmentApiTreatmentRecordControllerListVisitTreatmentsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetProfileTreatmentDto>> {
            return localVarFp.treatmentRecordControllerListVisitTreatments(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove a treatment record from a visit.
         * @param {TreatmentApiTreatmentRecordControllerRemoveVisitTreatmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerRemoveVisitTreatment(requestParameters: TreatmentApiTreatmentRecordControllerRemoveVisitTreatmentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.treatmentRecordControllerRemoveVisitTreatment(requestParameters.visitId, requestParameters.treatmentRecordId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a profile treatment
         * @param {TreatmentApiTreatmentRecordControllerUpdateProfileTreatmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerUpdateProfileTreatment(requestParameters: TreatmentApiTreatmentRecordControllerUpdateProfileTreatmentRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetProfileTreatmentDto>> {
            return localVarFp.treatmentRecordControllerUpdateProfileTreatment(requestParameters.profileId, requestParameters.treatmentId, requestParameters.updateProfileTreatmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a treatment record on a visit.
         * @param {TreatmentApiTreatmentRecordControllerUpdateVisitTreatmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentRecordControllerUpdateVisitTreatment(requestParameters: TreatmentApiTreatmentRecordControllerUpdateVisitTreatmentRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.treatmentRecordControllerUpdateVisitTreatment(requestParameters.visitId, requestParameters.treatmentRecordId, requestParameters.updateProfileTreatmentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for treatmentControllerCreateTreatment operation in TreatmentApi.
 * @export
 * @interface TreatmentApiTreatmentControllerCreateTreatmentRequest
 */
export interface TreatmentApiTreatmentControllerCreateTreatmentRequest {
    /**
     *
     * @type {CreateTreatmentDto}
     * @memberof TreatmentApiTreatmentControllerCreateTreatment
     */
    readonly createTreatmentDto: CreateTreatmentDto
}

/**
 * Request parameters for treatmentControllerDeleteTreatment operation in TreatmentApi.
 * @export
 * @interface TreatmentApiTreatmentControllerDeleteTreatmentRequest
 */
export interface TreatmentApiTreatmentControllerDeleteTreatmentRequest {
    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentControllerDeleteTreatment
     */
    readonly treatmentId: string
}

/**
 * Request parameters for treatmentControllerGetCatalog operation in TreatmentApi.
 * @export
 * @interface TreatmentApiTreatmentControllerGetCatalogRequest
 */
export interface TreatmentApiTreatmentControllerGetCatalogRequest {
    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentControllerGetCatalog
     */
    readonly organizationId: string
}

/**
 * Request parameters for treatmentControllerGetOrganizationTreatments operation in TreatmentApi.
 * @export
 * @interface TreatmentApiTreatmentControllerGetOrganizationTreatmentsRequest
 */
export interface TreatmentApiTreatmentControllerGetOrganizationTreatmentsRequest {
    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentControllerGetOrganizationTreatments
     */
    readonly organizationId: string
}

/**
 * Request parameters for treatmentControllerGetTreatment operation in TreatmentApi.
 * @export
 * @interface TreatmentApiTreatmentControllerGetTreatmentRequest
 */
export interface TreatmentApiTreatmentControllerGetTreatmentRequest {
    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentControllerGetTreatment
     */
    readonly treatmentId: string
}

/**
 * Request parameters for treatmentControllerUpdateTreatment operation in TreatmentApi.
 * @export
 * @interface TreatmentApiTreatmentControllerUpdateTreatmentRequest
 */
export interface TreatmentApiTreatmentControllerUpdateTreatmentRequest {
    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentControllerUpdateTreatment
     */
    readonly treatmentId: string

    /**
     *
     * @type {UpdateTreatmentDto}
     * @memberof TreatmentApiTreatmentControllerUpdateTreatment
     */
    readonly updateTreatmentDto: UpdateTreatmentDto
}

/**
 * Request parameters for treatmentRecordControllerAddProfileTreatment operation in TreatmentApi.
 * @export
 * @interface TreatmentApiTreatmentRecordControllerAddProfileTreatmentRequest
 */
export interface TreatmentApiTreatmentRecordControllerAddProfileTreatmentRequest {
    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerAddProfileTreatment
     */
    readonly profileId: string

    /**
     *
     * @type {AddProfileTreatmentDto}
     * @memberof TreatmentApiTreatmentRecordControllerAddProfileTreatment
     */
    readonly addProfileTreatmentDto: AddProfileTreatmentDto
}

/**
 * Request parameters for treatmentRecordControllerAddVisitTreatment operation in TreatmentApi.
 * @export
 * @interface TreatmentApiTreatmentRecordControllerAddVisitTreatmentRequest
 */
export interface TreatmentApiTreatmentRecordControllerAddVisitTreatmentRequest {
    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerAddVisitTreatment
     */
    readonly visitId: string

    /**
     *
     * @type {AddProfileTreatmentDto}
     * @memberof TreatmentApiTreatmentRecordControllerAddVisitTreatment
     */
    readonly addProfileTreatmentDto: AddProfileTreatmentDto
}

/**
 * Request parameters for treatmentRecordControllerDeleteProfileTreatment operation in TreatmentApi.
 * @export
 * @interface TreatmentApiTreatmentRecordControllerDeleteProfileTreatmentRequest
 */
export interface TreatmentApiTreatmentRecordControllerDeleteProfileTreatmentRequest {
    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerDeleteProfileTreatment
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerDeleteProfileTreatment
     */
    readonly treatmentId: string

    /**
     * Optional visit ID to track deletion as visit activity
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerDeleteProfileTreatment
     */
    readonly visitId?: string
}

/**
 * Request parameters for treatmentRecordControllerGetProfileTreatments operation in TreatmentApi.
 * @export
 * @interface TreatmentApiTreatmentRecordControllerGetProfileTreatmentsRequest
 */
export interface TreatmentApiTreatmentRecordControllerGetProfileTreatmentsRequest {
    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerGetProfileTreatments
     */
    readonly profileId: string

    /**
     * Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
     * @type {number}
     * @memberof TreatmentApiTreatmentRecordControllerGetProfileTreatments
     */
    readonly page?: number

    /**
     * Rows per page. Omit together with &#x60;page&#x60; to get every row.
     * @type {number}
     * @memberof TreatmentApiTreatmentRecordControllerGetProfileTreatments
     */
    readonly limit?: number
}

/**
 * Request parameters for treatmentRecordControllerGetTreatmentsOverview operation in TreatmentApi.
 * @export
 * @interface TreatmentApiTreatmentRecordControllerGetTreatmentsOverviewRequest
 */
export interface TreatmentApiTreatmentRecordControllerGetTreatmentsOverviewRequest {
    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerGetTreatmentsOverview
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerGetTreatmentsOverview
     */
    readonly page?: string

    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerGetTreatmentsOverview
     */
    readonly limit?: string

    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerGetTreatmentsOverview
     */
    readonly name?: string

    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerGetTreatmentsOverview
     */
    readonly profileName?: string

    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerGetTreatmentsOverview
     */
    readonly professionalId?: string

    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerGetTreatmentsOverview
     */
    readonly dateFrom?: string

    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerGetTreatmentsOverview
     */
    readonly dateTo?: string
}

/**
 * Request parameters for treatmentRecordControllerListVisitTreatments operation in TreatmentApi.
 * @export
 * @interface TreatmentApiTreatmentRecordControllerListVisitTreatmentsRequest
 */
export interface TreatmentApiTreatmentRecordControllerListVisitTreatmentsRequest {
    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerListVisitTreatments
     */
    readonly visitId: string
}

/**
 * Request parameters for treatmentRecordControllerRemoveVisitTreatment operation in TreatmentApi.
 * @export
 * @interface TreatmentApiTreatmentRecordControllerRemoveVisitTreatmentRequest
 */
export interface TreatmentApiTreatmentRecordControllerRemoveVisitTreatmentRequest {
    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerRemoveVisitTreatment
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerRemoveVisitTreatment
     */
    readonly treatmentRecordId: string
}

/**
 * Request parameters for treatmentRecordControllerUpdateProfileTreatment operation in TreatmentApi.
 * @export
 * @interface TreatmentApiTreatmentRecordControllerUpdateProfileTreatmentRequest
 */
export interface TreatmentApiTreatmentRecordControllerUpdateProfileTreatmentRequest {
    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerUpdateProfileTreatment
     */
    readonly profileId: string

    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerUpdateProfileTreatment
     */
    readonly treatmentId: string

    /**
     *
     * @type {UpdateProfileTreatmentDto}
     * @memberof TreatmentApiTreatmentRecordControllerUpdateProfileTreatment
     */
    readonly updateProfileTreatmentDto: UpdateProfileTreatmentDto
}

/**
 * Request parameters for treatmentRecordControllerUpdateVisitTreatment operation in TreatmentApi.
 * @export
 * @interface TreatmentApiTreatmentRecordControllerUpdateVisitTreatmentRequest
 */
export interface TreatmentApiTreatmentRecordControllerUpdateVisitTreatmentRequest {
    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerUpdateVisitTreatment
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof TreatmentApiTreatmentRecordControllerUpdateVisitTreatment
     */
    readonly treatmentRecordId: string

    /**
     *
     * @type {UpdateProfileTreatmentDto}
     * @memberof TreatmentApiTreatmentRecordControllerUpdateVisitTreatment
     */
    readonly updateProfileTreatmentDto: UpdateProfileTreatmentDto
}

/**
 * TreatmentApi - object-oriented interface
 * @export
 * @class TreatmentApi
 * @extends {BaseAPI}
 */
export class TreatmentApi extends BaseAPI {
    /**
     *
     * @summary Create a new treatment catalog entry
     * @param {TreatmentApiTreatmentControllerCreateTreatmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentApi
     */
    public treatmentControllerCreateTreatment(requestParameters: TreatmentApiTreatmentControllerCreateTreatmentRequest, options?: AxiosRequestConfig) {
        return TreatmentApiFp(this.configuration).treatmentControllerCreateTreatment(requestParameters.createTreatmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete a treatment catalog entry
     * @param {TreatmentApiTreatmentControllerDeleteTreatmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentApi
     */
    public treatmentControllerDeleteTreatment(requestParameters: TreatmentApiTreatmentControllerDeleteTreatmentRequest, options?: AxiosRequestConfig) {
        return TreatmentApiFp(this.configuration).treatmentControllerDeleteTreatment(requestParameters.treatmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get active catalog treatments for autocomplete
     * @param {TreatmentApiTreatmentControllerGetCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentApi
     */
    public treatmentControllerGetCatalog(requestParameters: TreatmentApiTreatmentControllerGetCatalogRequest, options?: AxiosRequestConfig) {
        return TreatmentApiFp(this.configuration).treatmentControllerGetCatalog(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all treatments for an organization
     * @param {TreatmentApiTreatmentControllerGetOrganizationTreatmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentApi
     */
    public treatmentControllerGetOrganizationTreatments(requestParameters: TreatmentApiTreatmentControllerGetOrganizationTreatmentsRequest, options?: AxiosRequestConfig) {
        return TreatmentApiFp(this.configuration).treatmentControllerGetOrganizationTreatments(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get a single treatment
     * @param {TreatmentApiTreatmentControllerGetTreatmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentApi
     */
    public treatmentControllerGetTreatment(requestParameters: TreatmentApiTreatmentControllerGetTreatmentRequest, options?: AxiosRequestConfig) {
        return TreatmentApiFp(this.configuration).treatmentControllerGetTreatment(requestParameters.treatmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update a treatment catalog entry
     * @param {TreatmentApiTreatmentControllerUpdateTreatmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentApi
     */
    public treatmentControllerUpdateTreatment(requestParameters: TreatmentApiTreatmentControllerUpdateTreatmentRequest, options?: AxiosRequestConfig) {
        return TreatmentApiFp(this.configuration).treatmentControllerUpdateTreatment(requestParameters.treatmentId, requestParameters.updateTreatmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Add treatment to profile
     * @param {TreatmentApiTreatmentRecordControllerAddProfileTreatmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentApi
     */
    public treatmentRecordControllerAddProfileTreatment(requestParameters: TreatmentApiTreatmentRecordControllerAddProfileTreatmentRequest, options?: AxiosRequestConfig) {
        return TreatmentApiFp(this.configuration).treatmentRecordControllerAddProfileTreatment(requestParameters.profileId, requestParameters.addProfileTreatmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Add a treatment record during a visit.
     * @param {TreatmentApiTreatmentRecordControllerAddVisitTreatmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentApi
     */
    public treatmentRecordControllerAddVisitTreatment(requestParameters: TreatmentApiTreatmentRecordControllerAddVisitTreatmentRequest, options?: AxiosRequestConfig) {
        return TreatmentApiFp(this.configuration).treatmentRecordControllerAddVisitTreatment(requestParameters.visitId, requestParameters.addProfileTreatmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete a profile treatment
     * @param {TreatmentApiTreatmentRecordControllerDeleteProfileTreatmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentApi
     */
    public treatmentRecordControllerDeleteProfileTreatment(requestParameters: TreatmentApiTreatmentRecordControllerDeleteProfileTreatmentRequest, options?: AxiosRequestConfig) {
        return TreatmentApiFp(this.configuration).treatmentRecordControllerDeleteProfileTreatment(requestParameters.profileId, requestParameters.treatmentId, requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get profile treatments
     * @param {TreatmentApiTreatmentRecordControllerGetProfileTreatmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentApi
     */
    public treatmentRecordControllerGetProfileTreatments(requestParameters: TreatmentApiTreatmentRecordControllerGetProfileTreatmentsRequest, options?: AxiosRequestConfig) {
        return TreatmentApiFp(this.configuration).treatmentRecordControllerGetProfileTreatments(requestParameters.profileId, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get treatments overview across all patients
     * @param {TreatmentApiTreatmentRecordControllerGetTreatmentsOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentApi
     */
    public treatmentRecordControllerGetTreatmentsOverview(requestParameters: TreatmentApiTreatmentRecordControllerGetTreatmentsOverviewRequest, options?: AxiosRequestConfig) {
        return TreatmentApiFp(this.configuration).treatmentRecordControllerGetTreatmentsOverview(requestParameters.organizationId, requestParameters.page, requestParameters.limit, requestParameters.name, requestParameters.profileName, requestParameters.professionalId, requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List treatment records attached to a visit.
     * @param {TreatmentApiTreatmentRecordControllerListVisitTreatmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentApi
     */
    public treatmentRecordControllerListVisitTreatments(requestParameters: TreatmentApiTreatmentRecordControllerListVisitTreatmentsRequest, options?: AxiosRequestConfig) {
        return TreatmentApiFp(this.configuration).treatmentRecordControllerListVisitTreatments(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Remove a treatment record from a visit.
     * @param {TreatmentApiTreatmentRecordControllerRemoveVisitTreatmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentApi
     */
    public treatmentRecordControllerRemoveVisitTreatment(requestParameters: TreatmentApiTreatmentRecordControllerRemoveVisitTreatmentRequest, options?: AxiosRequestConfig) {
        return TreatmentApiFp(this.configuration).treatmentRecordControllerRemoveVisitTreatment(requestParameters.visitId, requestParameters.treatmentRecordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update a profile treatment
     * @param {TreatmentApiTreatmentRecordControllerUpdateProfileTreatmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentApi
     */
    public treatmentRecordControllerUpdateProfileTreatment(requestParameters: TreatmentApiTreatmentRecordControllerUpdateProfileTreatmentRequest, options?: AxiosRequestConfig) {
        return TreatmentApiFp(this.configuration).treatmentRecordControllerUpdateProfileTreatment(requestParameters.profileId, requestParameters.treatmentId, requestParameters.updateProfileTreatmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update a treatment record on a visit.
     * @param {TreatmentApiTreatmentRecordControllerUpdateVisitTreatmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentApi
     */
    public treatmentRecordControllerUpdateVisitTreatment(requestParameters: TreatmentApiTreatmentRecordControllerUpdateVisitTreatmentRequest, options?: AxiosRequestConfig) {
        return TreatmentApiFp(this.configuration).treatmentRecordControllerUpdateVisitTreatment(requestParameters.visitId, requestParameters.treatmentRecordId, requestParameters.updateProfileTreatmentDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UploadApi - axios parameter creator
 * @export
 */
export const UploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Authenticated booking-time attachment upload. Same private-bucket semantics as POST /upload/guest-attachment on the public BE, but requires a Firebase token. Returns filename only; the booking-submit endpoint claims it later via the documents array.
         * @param {File} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerUploadBookingAttachment: async (file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/upload/booking-attachment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }


            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Upload file for authenticated users (private, requires profileId XOR visitId)
         * @param {File} file File to upload
         * @param {string} [profileId] Profile ID for document association (optional for quick booking)
         * @param {string} [visitId] Visit ID for document association (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerUploadPrivate: async (file: File, profileId?: string, visitId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadControllerUploadPrivate', 'file', file)
            const localVarPath = `/api/upload/private`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            if (profileId !== undefined) {
                localVarFormParams.append('profileId', profileId as any);
            }

            if (visitId !== undefined) {
                localVarFormParams.append('visitId', visitId as any);
            }


            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Upload file for public users (5MB max, no videos, only PDFs and images)
         * @param {File} file File to upload
         * @param {string} [profileId] Profile ID for document association (optional for quick booking)
         * @param {string} [visitId] Visit ID for document association (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerUploadPublic: async (file: File, profileId?: string, visitId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadControllerUploadPublic', 'file', file)
            const localVarPath = `/api/upload/public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            if (profileId !== undefined) {
                localVarFormParams.append('profileId', profileId as any);
            }

            if (visitId !== undefined) {
                localVarFormParams.append('visitId', visitId as any);
            }


            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadApi - functional programming interface
 * @export
 */
export const UploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Authenticated booking-time attachment upload. Same private-bucket semantics as POST /upload/guest-attachment on the public BE, but requires a Firebase token. Returns filename only; the booking-submit endpoint claims it later via the documents array.
         * @param {File} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadControllerUploadBookingAttachment(file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadFileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadControllerUploadBookingAttachment(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Upload file for authenticated users (private, requires profileId XOR visitId)
         * @param {File} file File to upload
         * @param {string} [profileId] Profile ID for document association (optional for quick booking)
         * @param {string} [visitId] Visit ID for document association (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadControllerUploadPrivate(file: File, profileId?: string, visitId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadFileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadControllerUploadPrivate(file, profileId, visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Upload file for public users (5MB max, no videos, only PDFs and images)
         * @param {File} file File to upload
         * @param {string} [profileId] Profile ID for document association (optional for quick booking)
         * @param {string} [visitId] Visit ID for document association (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadControllerUploadPublic(file: File, profileId?: string, visitId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadFileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadControllerUploadPublic(file, profileId, visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UploadApi - factory interface
 * @export
 */
export const UploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadApiFp(configuration)
    return {
        /**
         *
         * @summary Authenticated booking-time attachment upload. Same private-bucket semantics as POST /upload/guest-attachment on the public BE, but requires a Firebase token. Returns filename only; the booking-submit endpoint claims it later via the documents array.
         * @param {UploadApiUploadControllerUploadBookingAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerUploadBookingAttachment(requestParameters: UploadApiUploadControllerUploadBookingAttachmentRequest = {}, options?: AxiosRequestConfig): AxiosPromise<UploadFileResponseDto> {
            return localVarFp.uploadControllerUploadBookingAttachment(requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Upload file for authenticated users (private, requires profileId XOR visitId)
         * @param {UploadApiUploadControllerUploadPrivateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerUploadPrivate(requestParameters: UploadApiUploadControllerUploadPrivateRequest, options?: AxiosRequestConfig): AxiosPromise<UploadFileResponseDto> {
            return localVarFp.uploadControllerUploadPrivate(requestParameters.file, requestParameters.profileId, requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Upload file for public users (5MB max, no videos, only PDFs and images)
         * @param {UploadApiUploadControllerUploadPublicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerUploadPublic(requestParameters: UploadApiUploadControllerUploadPublicRequest, options?: AxiosRequestConfig): AxiosPromise<UploadFileResponseDto> {
            return localVarFp.uploadControllerUploadPublic(requestParameters.file, requestParameters.profileId, requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for uploadControllerUploadBookingAttachment operation in UploadApi.
 * @export
 * @interface UploadApiUploadControllerUploadBookingAttachmentRequest
 */
export interface UploadApiUploadControllerUploadBookingAttachmentRequest {
    /**
     *
     * @type {File}
     * @memberof UploadApiUploadControllerUploadBookingAttachment
     */
    readonly file?: File
}

/**
 * Request parameters for uploadControllerUploadPrivate operation in UploadApi.
 * @export
 * @interface UploadApiUploadControllerUploadPrivateRequest
 */
export interface UploadApiUploadControllerUploadPrivateRequest {
    /**
     * File to upload
     * @type {File}
     * @memberof UploadApiUploadControllerUploadPrivate
     */
    readonly file: File

    /**
     * Profile ID for document association (optional for quick booking)
     * @type {string}
     * @memberof UploadApiUploadControllerUploadPrivate
     */
    readonly profileId?: string

    /**
     * Visit ID for document association (optional)
     * @type {string}
     * @memberof UploadApiUploadControllerUploadPrivate
     */
    readonly visitId?: string
}

/**
 * Request parameters for uploadControllerUploadPublic operation in UploadApi.
 * @export
 * @interface UploadApiUploadControllerUploadPublicRequest
 */
export interface UploadApiUploadControllerUploadPublicRequest {
    /**
     * File to upload
     * @type {File}
     * @memberof UploadApiUploadControllerUploadPublic
     */
    readonly file: File

    /**
     * Profile ID for document association (optional for quick booking)
     * @type {string}
     * @memberof UploadApiUploadControllerUploadPublic
     */
    readonly profileId?: string

    /**
     * Visit ID for document association (optional)
     * @type {string}
     * @memberof UploadApiUploadControllerUploadPublic
     */
    readonly visitId?: string
}

/**
 * UploadApi - object-oriented interface
 * @export
 * @class UploadApi
 * @extends {BaseAPI}
 */
export class UploadApi extends BaseAPI {
    /**
     *
     * @summary Authenticated booking-time attachment upload. Same private-bucket semantics as POST /upload/guest-attachment on the public BE, but requires a Firebase token. Returns filename only; the booking-submit endpoint claims it later via the documents array.
     * @param {UploadApiUploadControllerUploadBookingAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    public uploadControllerUploadBookingAttachment(requestParameters: UploadApiUploadControllerUploadBookingAttachmentRequest = {}, options?: AxiosRequestConfig) {
        return UploadApiFp(this.configuration).uploadControllerUploadBookingAttachment(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Upload file for authenticated users (private, requires profileId XOR visitId)
     * @param {UploadApiUploadControllerUploadPrivateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    public uploadControllerUploadPrivate(requestParameters: UploadApiUploadControllerUploadPrivateRequest, options?: AxiosRequestConfig) {
        return UploadApiFp(this.configuration).uploadControllerUploadPrivate(requestParameters.file, requestParameters.profileId, requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Upload file for public users (5MB max, no videos, only PDFs and images)
     * @param {UploadApiUploadControllerUploadPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    public uploadControllerUploadPublic(requestParameters: UploadApiUploadControllerUploadPublicRequest, options?: AxiosRequestConfig) {
        return UploadApiFp(this.configuration).uploadControllerUploadPublic(requestParameters.file, requestParameters.profileId, requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UploadInternalApi - axios parameter creator
 * @export
 */
export const UploadInternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Server-to-server: mint a signed URL for a storage filename. Auth via x-internal-api-key shared secret.
         * @param {string} xInternalApiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadInternalControllerGetInternalSignedUrl: async (xInternalApiKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xInternalApiKey' is not null or undefined
            assertParamExists('uploadInternalControllerGetInternalSignedUrl', 'xInternalApiKey', xInternalApiKey)
            const localVarPath = `/api/internal/upload/signed-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xInternalApiKey != null) {
                localVarHeaderParameter['x-internal-api-key'] = String(xInternalApiKey);
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadInternalApi - functional programming interface
 * @export
 */
export const UploadInternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadInternalApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Server-to-server: mint a signed URL for a storage filename. Auth via x-internal-api-key shared secret.
         * @param {string} xInternalApiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadInternalControllerGetInternalSignedUrl(xInternalApiKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisitControllerGetVisitFileSignedUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadInternalControllerGetInternalSignedUrl(xInternalApiKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UploadInternalApi - factory interface
 * @export
 */
export const UploadInternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadInternalApiFp(configuration)
    return {
        /**
         *
         * @summary Server-to-server: mint a signed URL for a storage filename. Auth via x-internal-api-key shared secret.
         * @param {UploadInternalApiUploadInternalControllerGetInternalSignedUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadInternalControllerGetInternalSignedUrl(requestParameters: UploadInternalApiUploadInternalControllerGetInternalSignedUrlRequest, options?: AxiosRequestConfig): AxiosPromise<VisitControllerGetVisitFileSignedUrl200Response> {
            return localVarFp.uploadInternalControllerGetInternalSignedUrl(requestParameters.xInternalApiKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for uploadInternalControllerGetInternalSignedUrl operation in UploadInternalApi.
 * @export
 * @interface UploadInternalApiUploadInternalControllerGetInternalSignedUrlRequest
 */
export interface UploadInternalApiUploadInternalControllerGetInternalSignedUrlRequest {
    /**
     *
     * @type {string}
     * @memberof UploadInternalApiUploadInternalControllerGetInternalSignedUrl
     */
    readonly xInternalApiKey: string
}

/**
 * UploadInternalApi - object-oriented interface
 * @export
 * @class UploadInternalApi
 * @extends {BaseAPI}
 */
export class UploadInternalApi extends BaseAPI {
    /**
     *
     * @summary Server-to-server: mint a signed URL for a storage filename. Auth via x-internal-api-key shared secret.
     * @param {UploadInternalApiUploadInternalControllerGetInternalSignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadInternalApi
     */
    public uploadInternalControllerGetInternalSignedUrl(requestParameters: UploadInternalApiUploadInternalControllerGetInternalSignedUrlRequest, options?: AxiosRequestConfig) {
        return UploadInternalApiFp(this.configuration).uploadInternalControllerGetInternalSignedUrl(requestParameters.xInternalApiKey, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UprawnieniaPlatformyGosowejApi - axios parameter creator
 * @export
 */
export const UprawnieniaPlatformyGosowejApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Zatwierdź przypisanie uprawnienia
         * @param {'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER'} capability
         * @param {string} assignmentId Identyfikator przypisania uprawnienia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePlatformCapabilityControllerApproveAssignment: async (capability: 'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER', assignmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'capability' is not null or undefined
            assertParamExists('voicePlatformCapabilityControllerApproveAssignment', 'capability', capability)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('voicePlatformCapabilityControllerApproveAssignment', 'assignmentId', assignmentId)
            const localVarPath = `/api/voice-platform/capabilities/{capability}/assignments/{assignmentId}/approve`
                .replace(`{${"capability"}}`, encodeURIComponent(String(capability)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Sprawdź uprawnienie Voice Operations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePlatformCapabilityControllerAuthorizeOperations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/capabilities/operations/authorization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz własne bieżące uprawnienia Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePlatformCapabilityControllerCurrent: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/capabilities/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz przypisania wybranego uprawnienia
         * @param {'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER'} capability Uprawnienie, którego historię należy zwrócić
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePlatformCapabilityControllerListAssignments: async (capability: 'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'capability' is not null or undefined
            assertParamExists('voicePlatformCapabilityControllerListAssignments', 'capability', capability)
            const localVarPath = `/api/voice-platform/capabilities/assignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (capability !== undefined) {
                localVarQueryParameter['capability'] = capability;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zgłoś przypisanie uprawnienia
         * @param {ProposeVoicePlatformCapabilityAssignmentDto} proposeVoicePlatformCapabilityAssignmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePlatformCapabilityControllerProposeAssignment: async (proposeVoicePlatformCapabilityAssignmentDto: ProposeVoicePlatformCapabilityAssignmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proposeVoicePlatformCapabilityAssignmentDto' is not null or undefined
            assertParamExists('voicePlatformCapabilityControllerProposeAssignment', 'proposeVoicePlatformCapabilityAssignmentDto', proposeVoicePlatformCapabilityAssignmentDto)
            const localVarPath = `/api/voice-platform/capabilities/assignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proposeVoicePlatformCapabilityAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Cofnij przypisanie uprawnienia
         * @param {'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER'} capability
         * @param {string} assignmentId Identyfikator przypisania uprawnienia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePlatformCapabilityControllerRevokeAssignment: async (capability: 'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER', assignmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'capability' is not null or undefined
            assertParamExists('voicePlatformCapabilityControllerRevokeAssignment', 'capability', capability)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('voicePlatformCapabilityControllerRevokeAssignment', 'assignmentId', assignmentId)
            const localVarPath = `/api/voice-platform/capabilities/{capability}/assignments/{assignmentId}/revoke`
                .replace(`{${"capability"}}`, encodeURIComponent(String(capability)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UprawnieniaPlatformyGosowejApi - functional programming interface
 * @export
 */
export const UprawnieniaPlatformyGosowejApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UprawnieniaPlatformyGosowejApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Zatwierdź przypisanie uprawnienia
         * @param {'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER'} capability
         * @param {string} assignmentId Identyfikator przypisania uprawnienia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePlatformCapabilityControllerApproveAssignment(capability: 'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER', assignmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePlatformCapabilityAssignmentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePlatformCapabilityControllerApproveAssignment(capability, assignmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Sprawdź uprawnienie Voice Operations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePlatformCapabilityControllerAuthorizeOperations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePlatformCapabilityAuthorizationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePlatformCapabilityControllerAuthorizeOperations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz własne bieżące uprawnienia Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePlatformCapabilityControllerCurrent(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentVoicePlatformCapabilitiesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePlatformCapabilityControllerCurrent(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz przypisania wybranego uprawnienia
         * @param {'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER'} capability Uprawnienie, którego historię należy zwrócić
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePlatformCapabilityControllerListAssignments(capability: 'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoicePlatformCapabilityAssignmentResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePlatformCapabilityControllerListAssignments(capability, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zgłoś przypisanie uprawnienia
         * @param {ProposeVoicePlatformCapabilityAssignmentDto} proposeVoicePlatformCapabilityAssignmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePlatformCapabilityControllerProposeAssignment(proposeVoicePlatformCapabilityAssignmentDto: ProposeVoicePlatformCapabilityAssignmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePlatformCapabilityAssignmentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePlatformCapabilityControllerProposeAssignment(proposeVoicePlatformCapabilityAssignmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Cofnij przypisanie uprawnienia
         * @param {'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER'} capability
         * @param {string} assignmentId Identyfikator przypisania uprawnienia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePlatformCapabilityControllerRevokeAssignment(capability: 'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER', assignmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePlatformCapabilityAssignmentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePlatformCapabilityControllerRevokeAssignment(capability, assignmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UprawnieniaPlatformyGosowejApi - factory interface
 * @export
 */
export const UprawnieniaPlatformyGosowejApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UprawnieniaPlatformyGosowejApiFp(configuration)
    return {
        /**
         *
         * @summary Zatwierdź przypisanie uprawnienia
         * @param {UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerApproveAssignmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePlatformCapabilityControllerApproveAssignment(requestParameters: UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerApproveAssignmentRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePlatformCapabilityAssignmentResponseDto> {
            return localVarFp.voicePlatformCapabilityControllerApproveAssignment(requestParameters.capability, requestParameters.assignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sprawdź uprawnienie Voice Operations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePlatformCapabilityControllerAuthorizeOperations(options?: AxiosRequestConfig): AxiosPromise<VoicePlatformCapabilityAuthorizationResponseDto> {
            return localVarFp.voicePlatformCapabilityControllerAuthorizeOperations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz własne bieżące uprawnienia Voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePlatformCapabilityControllerCurrent(options?: AxiosRequestConfig): AxiosPromise<CurrentVoicePlatformCapabilitiesResponseDto> {
            return localVarFp.voicePlatformCapabilityControllerCurrent(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz przypisania wybranego uprawnienia
         * @param {UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerListAssignmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePlatformCapabilityControllerListAssignments(requestParameters: UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerListAssignmentsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<VoicePlatformCapabilityAssignmentResponseDto>> {
            return localVarFp.voicePlatformCapabilityControllerListAssignments(requestParameters.capability, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zgłoś przypisanie uprawnienia
         * @param {UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerProposeAssignmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePlatformCapabilityControllerProposeAssignment(requestParameters: UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerProposeAssignmentRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePlatformCapabilityAssignmentResponseDto> {
            return localVarFp.voicePlatformCapabilityControllerProposeAssignment(requestParameters.proposeVoicePlatformCapabilityAssignmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cofnij przypisanie uprawnienia
         * @param {UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerRevokeAssignmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePlatformCapabilityControllerRevokeAssignment(requestParameters: UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerRevokeAssignmentRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePlatformCapabilityAssignmentResponseDto> {
            return localVarFp.voicePlatformCapabilityControllerRevokeAssignment(requestParameters.capability, requestParameters.assignmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voicePlatformCapabilityControllerApproveAssignment operation in UprawnieniaPlatformyGosowejApi.
 * @export
 * @interface UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerApproveAssignmentRequest
 */
export interface UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerApproveAssignmentRequest {
    /**
     *
     * @type {'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER'}
     * @memberof UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerApproveAssignment
     */
    readonly capability: 'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER'

    /**
     * Identyfikator przypisania uprawnienia
     * @type {string}
     * @memberof UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerApproveAssignment
     */
    readonly assignmentId: string
}

/**
 * Request parameters for voicePlatformCapabilityControllerListAssignments operation in UprawnieniaPlatformyGosowejApi.
 * @export
 * @interface UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerListAssignmentsRequest
 */
export interface UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerListAssignmentsRequest {
    /**
     * Uprawnienie, którego historię należy zwrócić
     * @type {'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER'}
     * @memberof UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerListAssignments
     */
    readonly capability: 'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER'
}

/**
 * Request parameters for voicePlatformCapabilityControllerProposeAssignment operation in UprawnieniaPlatformyGosowejApi.
 * @export
 * @interface UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerProposeAssignmentRequest
 */
export interface UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerProposeAssignmentRequest {
    /**
     *
     * @type {ProposeVoicePlatformCapabilityAssignmentDto}
     * @memberof UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerProposeAssignment
     */
    readonly proposeVoicePlatformCapabilityAssignmentDto: ProposeVoicePlatformCapabilityAssignmentDto
}

/**
 * Request parameters for voicePlatformCapabilityControllerRevokeAssignment operation in UprawnieniaPlatformyGosowejApi.
 * @export
 * @interface UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerRevokeAssignmentRequest
 */
export interface UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerRevokeAssignmentRequest {
    /**
     *
     * @type {'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER'}
     * @memberof UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerRevokeAssignment
     */
    readonly capability: 'VOICE_PRODUCT_PUBLISHER' | 'VOICE_OPERATIONS' | 'VOICE_PRIVACY_REVIEWER' | 'VOICE_SAFETY_REVIEWER' | 'VOICE_INCIDENT_COMMANDER'

    /**
     * Identyfikator przypisania uprawnienia
     * @type {string}
     * @memberof UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerRevokeAssignment
     */
    readonly assignmentId: string
}

/**
 * UprawnieniaPlatformyGosowejApi - object-oriented interface
 * @export
 * @class UprawnieniaPlatformyGosowejApi
 * @extends {BaseAPI}
 */
export class UprawnieniaPlatformyGosowejApi extends BaseAPI {
    /**
     *
     * @summary Zatwierdź przypisanie uprawnienia
     * @param {UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerApproveAssignmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UprawnieniaPlatformyGosowejApi
     */
    public voicePlatformCapabilityControllerApproveAssignment(requestParameters: UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerApproveAssignmentRequest, options?: AxiosRequestConfig) {
        return UprawnieniaPlatformyGosowejApiFp(this.configuration).voicePlatformCapabilityControllerApproveAssignment(requestParameters.capability, requestParameters.assignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Sprawdź uprawnienie Voice Operations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UprawnieniaPlatformyGosowejApi
     */
    public voicePlatformCapabilityControllerAuthorizeOperations(options?: AxiosRequestConfig) {
        return UprawnieniaPlatformyGosowejApiFp(this.configuration).voicePlatformCapabilityControllerAuthorizeOperations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz własne bieżące uprawnienia Voice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UprawnieniaPlatformyGosowejApi
     */
    public voicePlatformCapabilityControllerCurrent(options?: AxiosRequestConfig) {
        return UprawnieniaPlatformyGosowejApiFp(this.configuration).voicePlatformCapabilityControllerCurrent(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz przypisania wybranego uprawnienia
     * @param {UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerListAssignmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UprawnieniaPlatformyGosowejApi
     */
    public voicePlatformCapabilityControllerListAssignments(requestParameters: UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerListAssignmentsRequest, options?: AxiosRequestConfig) {
        return UprawnieniaPlatformyGosowejApiFp(this.configuration).voicePlatformCapabilityControllerListAssignments(requestParameters.capability, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zgłoś przypisanie uprawnienia
     * @param {UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerProposeAssignmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UprawnieniaPlatformyGosowejApi
     */
    public voicePlatformCapabilityControllerProposeAssignment(requestParameters: UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerProposeAssignmentRequest, options?: AxiosRequestConfig) {
        return UprawnieniaPlatformyGosowejApiFp(this.configuration).voicePlatformCapabilityControllerProposeAssignment(requestParameters.proposeVoicePlatformCapabilityAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Cofnij przypisanie uprawnienia
     * @param {UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerRevokeAssignmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UprawnieniaPlatformyGosowejApi
     */
    public voicePlatformCapabilityControllerRevokeAssignment(requestParameters: UprawnieniaPlatformyGosowejApiVoicePlatformCapabilityControllerRevokeAssignmentRequest, options?: AxiosRequestConfig) {
        return UprawnieniaPlatformyGosowejApiFp(this.configuration).voicePlatformCapabilityControllerRevokeAssignment(requestParameters.capability, requestParameters.assignmentId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Activate a professional user. Available for organization admin and owner only
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerActivateProfessional: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerActivateProfessional', 'userId', userId)
            const localVarPath = `/api/user/organization/user/{userId}/activate`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Admin-only: create default organization for professional without one and migrate claims
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerCreateOrganizationForProfessional: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerCreateOrganizationForProfessional', 'userId', userId)
            const localVarPath = `/api/user/{userId}/create-organization`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create professional after successfully logging in with Firebase
         * @param {CreateProfessionalDto} createProfessionalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerCreateProfessionalUser: async (createProfessionalDto: CreateProfessionalDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProfessionalDto' is not null or undefined
            assertParamExists('userControllerCreateProfessionalUser', 'createProfessionalDto', createProfessionalDto)
            const localVarPath = `/api/user/professional`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProfessionalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create user after successfully logging in with Firebase
         * @param {CreateUserDto} createUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerCreateUser: async (createUserDto: CreateUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserDto' is not null or undefined
            assertParamExists('userControllerCreateUser', 'createUserDto', createUserDto)
            const localVarPath = `/api/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Deactivate a professional user. Available for organization admin and owner only
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerDeactivateProfessional: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerDeactivateProfessional', 'userId', userId)
            const localVarPath = `/api/user/organization/user/{userId}/deactivate`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary DEPRECATED: Get availability slots for professional. Use OrganizationAvailabilityController endpoints instead.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        userControllerGetAvailability: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get logged in user data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetCurrentUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get user fact preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetFactPreferences: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/fact-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get organization professional details. Available for organization admin and owner only
         * @param {string} organizationId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetOrganizationProfessionalDetails: async (organizationId: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('userControllerGetOrganizationProfessionalDetails', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerGetOrganizationProfessionalDetails', 'userId', userId)
            const localVarPath = `/api/user/organization/{organizationId}/user/{userId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all users assigned to the organization from context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetOrganizationUsers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/organization/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all read facts for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetReadFacts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/read-facts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Mark a fact as read for the user
         * @param {FactReadStatusDto} factReadStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerMarkFactAsRead: async (factReadStatusDto: FactReadStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factReadStatusDto' is not null or undefined
            assertParamExists('userControllerMarkFactAsRead', 'factReadStatusDto', factReadStatusDto)
            const localVarPath = `/api/user/mark-fact-read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(factReadStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set user as onboarded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerOnboardUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/onboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Preview user. Available for professional only
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerPreviewUser: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerPreviewUser', 'userId', userId)
            const localVarPath = `/api/user/{userId}/preview`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Preview user by profile ID.
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerPreviewUserByProfile: async (profileId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('userControllerPreviewUserByProfile', 'profileId', profileId)
            const localVarPath = `/api/user/profile/{profileId}/preview`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for users with role USER across the platform. Only accessible by admins, organization admins, and professionals.
         * @summary Look up a user by exact email, phone, or id.
         * @param {SearchGlobalUsersDto} searchGlobalUsersDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSearchGlobalUsers: async (searchGlobalUsersDto: SearchGlobalUsersDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchGlobalUsersDto' is not null or undefined
            assertParamExists('userControllerSearchGlobalUsers', 'searchGlobalUsersDto', searchGlobalUsersDto)
            const localVarPath = `/api/user/search/global`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchGlobalUsersDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set existing user as an admin. Requires an existing admin user in database to execute
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSetAsAdmin: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerSetAsAdmin', 'userId', userId)
            const localVarPath = `/api/user/{userId}/set-as-admin`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set existing user as professional. Requires admin role to execute
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSetAsProfessional: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerSetAsProfessional', 'userId', userId)
            const localVarPath = `/api/user/{userId}/set-as-professional`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft delete a professional user. Available for organization admin and owner only
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSoftDeleteProfessional: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerSoftDeleteProfessional', 'userId', userId)
            const localVarPath = `/api/user/organization/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update availability slots for non-organization professional
         * @param {UpdateAvailabilityDto} updateAvailabilityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdateAvailability: async (updateAvailabilityDto: UpdateAvailabilityDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAvailabilityDto' is not null or undefined
            assertParamExists('userControllerUpdateAvailability', 'updateAvailabilityDto', updateAvailabilityDto)
            const localVarPath = `/api/user/availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAvailabilityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update user fact preferences
         * @param {UpdateFactPreferencesDto} updateFactPreferencesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdateFactPreferences: async (updateFactPreferencesDto: UpdateFactPreferencesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateFactPreferencesDto' is not null or undefined
            assertParamExists('userControllerUpdateFactPreferences', 'updateFactPreferencesDto', updateFactPreferencesDto)
            const localVarPath = `/api/user/fact-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFactPreferencesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update professional availability slots. Available for organization admin and owner only
         * @param {string} organizationId
         * @param {string} userId
         * @param {UpdateAvailabilityDto} updateAvailabilityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdateOrganizationProfessionalAvailability: async (organizationId: string, userId: string, updateAvailabilityDto: UpdateAvailabilityDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('userControllerUpdateOrganizationProfessionalAvailability', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerUpdateOrganizationProfessionalAvailability', 'userId', userId)
            // verify required parameter 'updateAvailabilityDto' is not null or undefined
            assertParamExists('userControllerUpdateOrganizationProfessionalAvailability', 'updateAvailabilityDto', updateAvailabilityDto)
            const localVarPath = `/api/user/organization/{organizationId}/user/{userId}/availability`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAvailabilityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary DEPRECATED: Update professional time off. Use OrganizationAvailabilityController endpoints instead. Available for organization admin and owner only
         * @param {string} organizationId
         * @param {string} userId
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        userControllerUpdateOrganizationProfessionalTimeOff: async (organizationId: string, userId: string, requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('userControllerUpdateOrganizationProfessionalTimeOff', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerUpdateOrganizationProfessionalTimeOff', 'userId', userId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('userControllerUpdateOrganizationProfessionalTimeOff', 'requestBody', requestBody)
            const localVarPath = `/api/user/organization/{organizationId}/user/{userId}/time-off`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update logged in user
         * @param {UpdateUserDto} updateUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdateUser: async (updateUserDto: UpdateUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserDto' is not null or undefined
            assertParamExists('userControllerUpdateUser', 'updateUserDto', updateUserDto)
            const localVarPath = `/api/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Activate a professional user. Available for organization admin and owner only
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerActivateProfessional(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerActivateProfessional(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Admin-only: create default organization for professional without one and migrate claims
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerCreateOrganizationForProfessional(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerCreateOrganizationForProfessional(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Create professional after successfully logging in with Firebase
         * @param {CreateProfessionalDto} createProfessionalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerCreateProfessionalUser(createProfessionalDto: CreateProfessionalDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerCreateProfessionalUser(createProfessionalDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Create user after successfully logging in with Firebase
         * @param {CreateUserDto} createUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerCreateUser(createUserDto: CreateUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerCreateUser(createUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Deactivate a professional user. Available for organization admin and owner only
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerDeactivateProfessional(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerDeactivateProfessional(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary DEPRECATED: Get availability slots for professional. Use OrganizationAvailabilityController endpoints instead.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async userControllerGetAvailability(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetAvailability(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get logged in user data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetCurrentUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetCurrentUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get user fact preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetFactPreferences(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetFactPreferences(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get organization professional details. Available for organization admin and owner only
         * @param {string} organizationId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetOrganizationProfessionalDetails(organizationId: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetOrganizationProfessionalDetails(organizationId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all users assigned to the organization from context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetOrganizationUsers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationUsersForScheduleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetOrganizationUsers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all read facts for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetReadFacts(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetReadFacts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Mark a fact as read for the user
         * @param {FactReadStatusDto} factReadStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerMarkFactAsRead(factReadStatusDto: FactReadStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerMarkFactAsRead(factReadStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Set user as onboarded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerOnboardUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerOnboardUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Preview user. Available for professional only
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerPreviewUser(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerPreviewUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Preview user by profile ID.
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerPreviewUserByProfile(profileId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerPreviewUserByProfile(profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search for users with role USER across the platform. Only accessible by admins, organization admins, and professionals.
         * @summary Look up a user by exact email, phone, or id.
         * @param {SearchGlobalUsersDto} searchGlobalUsersDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerSearchGlobalUsers(searchGlobalUsersDto: SearchGlobalUsersDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GlobalUserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerSearchGlobalUsers(searchGlobalUsersDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Set existing user as an admin. Requires an existing admin user in database to execute
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerSetAsAdmin(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerSetAsAdmin(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Set existing user as professional. Requires admin role to execute
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerSetAsProfessional(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerSetAsProfessional(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Soft delete a professional user. Available for organization admin and owner only
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerSoftDeleteProfessional(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerSoftDeleteProfessional(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update availability slots for non-organization professional
         * @param {UpdateAvailabilityDto} updateAvailabilityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerUpdateAvailability(updateAvailabilityDto: UpdateAvailabilityDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUpdateAvailability(updateAvailabilityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update user fact preferences
         * @param {UpdateFactPreferencesDto} updateFactPreferencesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerUpdateFactPreferences(updateFactPreferencesDto: UpdateFactPreferencesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUpdateFactPreferences(updateFactPreferencesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update professional availability slots. Available for organization admin and owner only
         * @param {string} organizationId
         * @param {string} userId
         * @param {UpdateAvailabilityDto} updateAvailabilityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerUpdateOrganizationProfessionalAvailability(organizationId: string, userId: string, updateAvailabilityDto: UpdateAvailabilityDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUpdateOrganizationProfessionalAvailability(organizationId, userId, updateAvailabilityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary DEPRECATED: Update professional time off. Use OrganizationAvailabilityController endpoints instead. Available for organization admin and owner only
         * @param {string} organizationId
         * @param {string} userId
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async userControllerUpdateOrganizationProfessionalTimeOff(organizationId: string, userId: string, requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUpdateOrganizationProfessionalTimeOff(organizationId, userId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update logged in user
         * @param {UpdateUserDto} updateUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerUpdateUser(updateUserDto: UpdateUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUpdateUser(updateUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         *
         * @summary Activate a professional user. Available for organization admin and owner only
         * @param {UserApiUserControllerActivateProfessionalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerActivateProfessional(requestParameters: UserApiUserControllerActivateProfessionalRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerActivateProfessional(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Admin-only: create default organization for professional without one and migrate claims
         * @param {UserApiUserControllerCreateOrganizationForProfessionalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerCreateOrganizationForProfessional(requestParameters: UserApiUserControllerCreateOrganizationForProfessionalRequest, options?: AxiosRequestConfig): AxiosPromise<GetUserDto> {
            return localVarFp.userControllerCreateOrganizationForProfessional(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create professional after successfully logging in with Firebase
         * @param {UserApiUserControllerCreateProfessionalUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerCreateProfessionalUser(requestParameters: UserApiUserControllerCreateProfessionalUserRequest, options?: AxiosRequestConfig): AxiosPromise<GetUserDto> {
            return localVarFp.userControllerCreateProfessionalUser(requestParameters.createProfessionalDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create user after successfully logging in with Firebase
         * @param {UserApiUserControllerCreateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerCreateUser(requestParameters: UserApiUserControllerCreateUserRequest, options?: AxiosRequestConfig): AxiosPromise<GetUserDto> {
            return localVarFp.userControllerCreateUser(requestParameters.createUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Deactivate a professional user. Available for organization admin and owner only
         * @param {UserApiUserControllerDeactivateProfessionalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerDeactivateProfessional(requestParameters: UserApiUserControllerDeactivateProfessionalRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerDeactivateProfessional(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary DEPRECATED: Get availability slots for professional. Use OrganizationAvailabilityController endpoints instead.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        userControllerGetAvailability(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerGetAvailability(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get logged in user data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetCurrentUser(options?: AxiosRequestConfig): AxiosPromise<GetUserDto> {
            return localVarFp.userControllerGetCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get user fact preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetFactPreferences(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerGetFactPreferences(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get organization professional details. Available for organization admin and owner only
         * @param {UserApiUserControllerGetOrganizationProfessionalDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetOrganizationProfessionalDetails(requestParameters: UserApiUserControllerGetOrganizationProfessionalDetailsRequest, options?: AxiosRequestConfig): AxiosPromise<ProfessionalDetailsDto> {
            return localVarFp.userControllerGetOrganizationProfessionalDetails(requestParameters.organizationId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all users assigned to the organization from context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetOrganizationUsers(options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationUsersForScheduleDto>> {
            return localVarFp.userControllerGetOrganizationUsers(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all read facts for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetReadFacts(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerGetReadFacts(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Mark a fact as read for the user
         * @param {UserApiUserControllerMarkFactAsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerMarkFactAsRead(requestParameters: UserApiUserControllerMarkFactAsReadRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerMarkFactAsRead(requestParameters.factReadStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set user as onboarded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerOnboardUser(options?: AxiosRequestConfig): AxiosPromise<GetUserDto> {
            return localVarFp.userControllerOnboardUser(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Preview user. Available for professional only
         * @param {UserApiUserControllerPreviewUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerPreviewUser(requestParameters: UserApiUserControllerPreviewUserRequest, options?: AxiosRequestConfig): AxiosPromise<PreviewUserDto> {
            return localVarFp.userControllerPreviewUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Preview user by profile ID.
         * @param {UserApiUserControllerPreviewUserByProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerPreviewUserByProfile(requestParameters: UserApiUserControllerPreviewUserByProfileRequest, options?: AxiosRequestConfig): AxiosPromise<PreviewUserDto> {
            return localVarFp.userControllerPreviewUserByProfile(requestParameters.profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for users with role USER across the platform. Only accessible by admins, organization admins, and professionals.
         * @summary Look up a user by exact email, phone, or id.
         * @param {UserApiUserControllerSearchGlobalUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSearchGlobalUsers(requestParameters: UserApiUserControllerSearchGlobalUsersRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GlobalUserDto>> {
            return localVarFp.userControllerSearchGlobalUsers(requestParameters.searchGlobalUsersDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set existing user as an admin. Requires an existing admin user in database to execute
         * @param {UserApiUserControllerSetAsAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSetAsAdmin(requestParameters: UserApiUserControllerSetAsAdminRequest, options?: AxiosRequestConfig): AxiosPromise<GetUserDto> {
            return localVarFp.userControllerSetAsAdmin(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set existing user as professional. Requires admin role to execute
         * @param {UserApiUserControllerSetAsProfessionalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSetAsProfessional(requestParameters: UserApiUserControllerSetAsProfessionalRequest, options?: AxiosRequestConfig): AxiosPromise<GetUserDto> {
            return localVarFp.userControllerSetAsProfessional(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft delete a professional user. Available for organization admin and owner only
         * @param {UserApiUserControllerSoftDeleteProfessionalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSoftDeleteProfessional(requestParameters: UserApiUserControllerSoftDeleteProfessionalRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerSoftDeleteProfessional(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update availability slots for non-organization professional
         * @param {UserApiUserControllerUpdateAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdateAvailability(requestParameters: UserApiUserControllerUpdateAvailabilityRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerUpdateAvailability(requestParameters.updateAvailabilityDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update user fact preferences
         * @param {UserApiUserControllerUpdateFactPreferencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdateFactPreferences(requestParameters: UserApiUserControllerUpdateFactPreferencesRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerUpdateFactPreferences(requestParameters.updateFactPreferencesDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update professional availability slots. Available for organization admin and owner only
         * @param {UserApiUserControllerUpdateOrganizationProfessionalAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdateOrganizationProfessionalAvailability(requestParameters: UserApiUserControllerUpdateOrganizationProfessionalAvailabilityRequest, options?: AxiosRequestConfig): AxiosPromise<ProfessionalDetailsDto> {
            return localVarFp.userControllerUpdateOrganizationProfessionalAvailability(requestParameters.organizationId, requestParameters.userId, requestParameters.updateAvailabilityDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary DEPRECATED: Update professional time off. Use OrganizationAvailabilityController endpoints instead. Available for organization admin and owner only
         * @param {UserApiUserControllerUpdateOrganizationProfessionalTimeOffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        userControllerUpdateOrganizationProfessionalTimeOff(requestParameters: UserApiUserControllerUpdateOrganizationProfessionalTimeOffRequest, options?: AxiosRequestConfig): AxiosPromise<ProfessionalDetailsDto> {
            return localVarFp.userControllerUpdateOrganizationProfessionalTimeOff(requestParameters.organizationId, requestParameters.userId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update logged in user
         * @param {UserApiUserControllerUpdateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdateUser(requestParameters: UserApiUserControllerUpdateUserRequest, options?: AxiosRequestConfig): AxiosPromise<GetUserDto> {
            return localVarFp.userControllerUpdateUser(requestParameters.updateUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for userControllerActivateProfessional operation in UserApi.
 * @export
 * @interface UserApiUserControllerActivateProfessionalRequest
 */
export interface UserApiUserControllerActivateProfessionalRequest {
    /**
     *
     * @type {string}
     * @memberof UserApiUserControllerActivateProfessional
     */
    readonly userId: string
}

/**
 * Request parameters for userControllerCreateOrganizationForProfessional operation in UserApi.
 * @export
 * @interface UserApiUserControllerCreateOrganizationForProfessionalRequest
 */
export interface UserApiUserControllerCreateOrganizationForProfessionalRequest {
    /**
     *
     * @type {string}
     * @memberof UserApiUserControllerCreateOrganizationForProfessional
     */
    readonly userId: string
}

/**
 * Request parameters for userControllerCreateProfessionalUser operation in UserApi.
 * @export
 * @interface UserApiUserControllerCreateProfessionalUserRequest
 */
export interface UserApiUserControllerCreateProfessionalUserRequest {
    /**
     *
     * @type {CreateProfessionalDto}
     * @memberof UserApiUserControllerCreateProfessionalUser
     */
    readonly createProfessionalDto: CreateProfessionalDto
}

/**
 * Request parameters for userControllerCreateUser operation in UserApi.
 * @export
 * @interface UserApiUserControllerCreateUserRequest
 */
export interface UserApiUserControllerCreateUserRequest {
    /**
     *
     * @type {CreateUserDto}
     * @memberof UserApiUserControllerCreateUser
     */
    readonly createUserDto: CreateUserDto
}

/**
 * Request parameters for userControllerDeactivateProfessional operation in UserApi.
 * @export
 * @interface UserApiUserControllerDeactivateProfessionalRequest
 */
export interface UserApiUserControllerDeactivateProfessionalRequest {
    /**
     *
     * @type {string}
     * @memberof UserApiUserControllerDeactivateProfessional
     */
    readonly userId: string
}

/**
 * Request parameters for userControllerGetOrganizationProfessionalDetails operation in UserApi.
 * @export
 * @interface UserApiUserControllerGetOrganizationProfessionalDetailsRequest
 */
export interface UserApiUserControllerGetOrganizationProfessionalDetailsRequest {
    /**
     *
     * @type {string}
     * @memberof UserApiUserControllerGetOrganizationProfessionalDetails
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof UserApiUserControllerGetOrganizationProfessionalDetails
     */
    readonly userId: string
}

/**
 * Request parameters for userControllerMarkFactAsRead operation in UserApi.
 * @export
 * @interface UserApiUserControllerMarkFactAsReadRequest
 */
export interface UserApiUserControllerMarkFactAsReadRequest {
    /**
     *
     * @type {FactReadStatusDto}
     * @memberof UserApiUserControllerMarkFactAsRead
     */
    readonly factReadStatusDto: FactReadStatusDto
}

/**
 * Request parameters for userControllerPreviewUser operation in UserApi.
 * @export
 * @interface UserApiUserControllerPreviewUserRequest
 */
export interface UserApiUserControllerPreviewUserRequest {
    /**
     *
     * @type {string}
     * @memberof UserApiUserControllerPreviewUser
     */
    readonly userId: string
}

/**
 * Request parameters for userControllerPreviewUserByProfile operation in UserApi.
 * @export
 * @interface UserApiUserControllerPreviewUserByProfileRequest
 */
export interface UserApiUserControllerPreviewUserByProfileRequest {
    /**
     *
     * @type {string}
     * @memberof UserApiUserControllerPreviewUserByProfile
     */
    readonly profileId: string
}

/**
 * Request parameters for userControllerSearchGlobalUsers operation in UserApi.
 * @export
 * @interface UserApiUserControllerSearchGlobalUsersRequest
 */
export interface UserApiUserControllerSearchGlobalUsersRequest {
    /**
     *
     * @type {SearchGlobalUsersDto}
     * @memberof UserApiUserControllerSearchGlobalUsers
     */
    readonly searchGlobalUsersDto: SearchGlobalUsersDto
}

/**
 * Request parameters for userControllerSetAsAdmin operation in UserApi.
 * @export
 * @interface UserApiUserControllerSetAsAdminRequest
 */
export interface UserApiUserControllerSetAsAdminRequest {
    /**
     *
     * @type {string}
     * @memberof UserApiUserControllerSetAsAdmin
     */
    readonly userId: string
}

/**
 * Request parameters for userControllerSetAsProfessional operation in UserApi.
 * @export
 * @interface UserApiUserControllerSetAsProfessionalRequest
 */
export interface UserApiUserControllerSetAsProfessionalRequest {
    /**
     *
     * @type {string}
     * @memberof UserApiUserControllerSetAsProfessional
     */
    readonly userId: string
}

/**
 * Request parameters for userControllerSoftDeleteProfessional operation in UserApi.
 * @export
 * @interface UserApiUserControllerSoftDeleteProfessionalRequest
 */
export interface UserApiUserControllerSoftDeleteProfessionalRequest {
    /**
     *
     * @type {string}
     * @memberof UserApiUserControllerSoftDeleteProfessional
     */
    readonly userId: string
}

/**
 * Request parameters for userControllerUpdateAvailability operation in UserApi.
 * @export
 * @interface UserApiUserControllerUpdateAvailabilityRequest
 */
export interface UserApiUserControllerUpdateAvailabilityRequest {
    /**
     *
     * @type {UpdateAvailabilityDto}
     * @memberof UserApiUserControllerUpdateAvailability
     */
    readonly updateAvailabilityDto: UpdateAvailabilityDto
}

/**
 * Request parameters for userControllerUpdateFactPreferences operation in UserApi.
 * @export
 * @interface UserApiUserControllerUpdateFactPreferencesRequest
 */
export interface UserApiUserControllerUpdateFactPreferencesRequest {
    /**
     *
     * @type {UpdateFactPreferencesDto}
     * @memberof UserApiUserControllerUpdateFactPreferences
     */
    readonly updateFactPreferencesDto: UpdateFactPreferencesDto
}

/**
 * Request parameters for userControllerUpdateOrganizationProfessionalAvailability operation in UserApi.
 * @export
 * @interface UserApiUserControllerUpdateOrganizationProfessionalAvailabilityRequest
 */
export interface UserApiUserControllerUpdateOrganizationProfessionalAvailabilityRequest {
    /**
     *
     * @type {string}
     * @memberof UserApiUserControllerUpdateOrganizationProfessionalAvailability
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof UserApiUserControllerUpdateOrganizationProfessionalAvailability
     */
    readonly userId: string

    /**
     *
     * @type {UpdateAvailabilityDto}
     * @memberof UserApiUserControllerUpdateOrganizationProfessionalAvailability
     */
    readonly updateAvailabilityDto: UpdateAvailabilityDto
}

/**
 * Request parameters for userControllerUpdateOrganizationProfessionalTimeOff operation in UserApi.
 * @export
 * @interface UserApiUserControllerUpdateOrganizationProfessionalTimeOffRequest
 */
export interface UserApiUserControllerUpdateOrganizationProfessionalTimeOffRequest {
    /**
     *
     * @type {string}
     * @memberof UserApiUserControllerUpdateOrganizationProfessionalTimeOff
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof UserApiUserControllerUpdateOrganizationProfessionalTimeOff
     */
    readonly userId: string

    /**
     *
     * @type {Array<string>}
     * @memberof UserApiUserControllerUpdateOrganizationProfessionalTimeOff
     */
    readonly requestBody: Array<string>
}

/**
 * Request parameters for userControllerUpdateUser operation in UserApi.
 * @export
 * @interface UserApiUserControllerUpdateUserRequest
 */
export interface UserApiUserControllerUpdateUserRequest {
    /**
     *
     * @type {UpdateUserDto}
     * @memberof UserApiUserControllerUpdateUser
     */
    readonly updateUserDto: UpdateUserDto
}

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     *
     * @summary Activate a professional user. Available for organization admin and owner only
     * @param {UserApiUserControllerActivateProfessionalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerActivateProfessional(requestParameters: UserApiUserControllerActivateProfessionalRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerActivateProfessional(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Admin-only: create default organization for professional without one and migrate claims
     * @param {UserApiUserControllerCreateOrganizationForProfessionalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerCreateOrganizationForProfessional(requestParameters: UserApiUserControllerCreateOrganizationForProfessionalRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerCreateOrganizationForProfessional(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create professional after successfully logging in with Firebase
     * @param {UserApiUserControllerCreateProfessionalUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerCreateProfessionalUser(requestParameters: UserApiUserControllerCreateProfessionalUserRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerCreateProfessionalUser(requestParameters.createProfessionalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create user after successfully logging in with Firebase
     * @param {UserApiUserControllerCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerCreateUser(requestParameters: UserApiUserControllerCreateUserRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerCreateUser(requestParameters.createUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Deactivate a professional user. Available for organization admin and owner only
     * @param {UserApiUserControllerDeactivateProfessionalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerDeactivateProfessional(requestParameters: UserApiUserControllerDeactivateProfessionalRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerDeactivateProfessional(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary DEPRECATED: Get availability slots for professional. Use OrganizationAvailabilityController endpoints instead.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerGetAvailability(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerGetAvailability(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get logged in user data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerGetCurrentUser(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerGetCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get user fact preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerGetFactPreferences(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerGetFactPreferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get organization professional details. Available for organization admin and owner only
     * @param {UserApiUserControllerGetOrganizationProfessionalDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerGetOrganizationProfessionalDetails(requestParameters: UserApiUserControllerGetOrganizationProfessionalDetailsRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerGetOrganizationProfessionalDetails(requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all users assigned to the organization from context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerGetOrganizationUsers(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerGetOrganizationUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all read facts for the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerGetReadFacts(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerGetReadFacts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Mark a fact as read for the user
     * @param {UserApiUserControllerMarkFactAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerMarkFactAsRead(requestParameters: UserApiUserControllerMarkFactAsReadRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerMarkFactAsRead(requestParameters.factReadStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Set user as onboarded
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerOnboardUser(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerOnboardUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Preview user. Available for professional only
     * @param {UserApiUserControllerPreviewUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerPreviewUser(requestParameters: UserApiUserControllerPreviewUserRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerPreviewUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Preview user by profile ID.
     * @param {UserApiUserControllerPreviewUserByProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerPreviewUserByProfile(requestParameters: UserApiUserControllerPreviewUserByProfileRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerPreviewUserByProfile(requestParameters.profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for users with role USER across the platform. Only accessible by admins, organization admins, and professionals.
     * @summary Look up a user by exact email, phone, or id.
     * @param {UserApiUserControllerSearchGlobalUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerSearchGlobalUsers(requestParameters: UserApiUserControllerSearchGlobalUsersRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerSearchGlobalUsers(requestParameters.searchGlobalUsersDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Set existing user as an admin. Requires an existing admin user in database to execute
     * @param {UserApiUserControllerSetAsAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerSetAsAdmin(requestParameters: UserApiUserControllerSetAsAdminRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerSetAsAdmin(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Set existing user as professional. Requires admin role to execute
     * @param {UserApiUserControllerSetAsProfessionalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerSetAsProfessional(requestParameters: UserApiUserControllerSetAsProfessionalRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerSetAsProfessional(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Soft delete a professional user. Available for organization admin and owner only
     * @param {UserApiUserControllerSoftDeleteProfessionalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerSoftDeleteProfessional(requestParameters: UserApiUserControllerSoftDeleteProfessionalRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerSoftDeleteProfessional(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update availability slots for non-organization professional
     * @param {UserApiUserControllerUpdateAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerUpdateAvailability(requestParameters: UserApiUserControllerUpdateAvailabilityRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerUpdateAvailability(requestParameters.updateAvailabilityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update user fact preferences
     * @param {UserApiUserControllerUpdateFactPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerUpdateFactPreferences(requestParameters: UserApiUserControllerUpdateFactPreferencesRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerUpdateFactPreferences(requestParameters.updateFactPreferencesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update professional availability slots. Available for organization admin and owner only
     * @param {UserApiUserControllerUpdateOrganizationProfessionalAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerUpdateOrganizationProfessionalAvailability(requestParameters: UserApiUserControllerUpdateOrganizationProfessionalAvailabilityRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerUpdateOrganizationProfessionalAvailability(requestParameters.organizationId, requestParameters.userId, requestParameters.updateAvailabilityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary DEPRECATED: Update professional time off. Use OrganizationAvailabilityController endpoints instead. Available for organization admin and owner only
     * @param {UserApiUserControllerUpdateOrganizationProfessionalTimeOffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerUpdateOrganizationProfessionalTimeOff(requestParameters: UserApiUserControllerUpdateOrganizationProfessionalTimeOffRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerUpdateOrganizationProfessionalTimeOff(requestParameters.organizationId, requestParameters.userId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update logged in user
     * @param {UserApiUserControllerUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerUpdateUser(requestParameters: UserApiUserControllerUpdateUserRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerUpdateUser(requestParameters.updateUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VisitApi - axios parameter creator
 * @export
 */
export const VisitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Abort ongoing visit
         * @param {AbortVisitDto} abortVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerAbortVisit: async (abortVisitDto: AbortVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'abortVisitDto' is not null or undefined
            assertParamExists('visitControllerAbortVisit', 'abortVisitDto', abortVisitDto)
            const localVarPath = `/api/visit/abort`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(abortVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Add documents to a visit. Writes to the Document collection with visitId + (optional) profileId for guest visits.
         * @param {string} visitId
         * @param {Array<DocumentFileDto>} documentFileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerAddDocuments: async (visitId: string, documentFileDto: Array<DocumentFileDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerAddDocuments', 'visitId', visitId)
            // verify required parameter 'documentFileDto' is not null or undefined
            assertParamExists('visitControllerAddDocuments', 'documentFileDto', documentFileDto)
            const localVarPath = `/api/visit/{visitId}/documents`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Save patient notes as a draft, without sending them to the owner. Professional only.
         * @param {string} visitId
         * @param {AddDraftNotesDto} addDraftNotesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerAddDraftNotes: async (visitId: string, addDraftNotesDto: AddDraftNotesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerAddDraftNotes', 'visitId', visitId)
            // verify required parameter 'addDraftNotesDto' is not null or undefined
            assertParamExists('visitControllerAddDraftNotes', 'addDraftNotesDto', addDraftNotesDto)
            const localVarPath = `/api/visit/{visitId}/addDraftNotes`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDraftNotesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Add internal notes to a visit. Professional only. No notification sent to patient.
         * @param {string} visitId
         * @param {AddInternalNotesDto} addInternalNotesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerAddInternalNotes: async (visitId: string, addInternalNotesDto: AddInternalNotesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerAddInternalNotes', 'visitId', visitId)
            // verify required parameter 'addInternalNotesDto' is not null or undefined
            assertParamExists('visitControllerAddInternalNotes', 'addInternalNotesDto', addInternalNotesDto)
            const localVarPath = `/api/visit/{visitId}/addInternalNotes`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addInternalNotesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Add notes to a visit. Professional only.
         * @param {string} visitId
         * @param {AddNotesDto} addNotesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerAddNotes: async (visitId: string, addNotesDto: AddNotesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerAddNotes', 'visitId', visitId)
            // verify required parameter 'addNotesDto' is not null or undefined
            assertParamExists('visitControllerAddNotes', 'addNotesDto', addNotesDto)
            const localVarPath = `/api/visit/{visitId}/addNotes`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addNotesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Add patient notes to a visit. Professional only. Sends notification to patient.
         * @param {string} visitId
         * @param {AddPatientNotesDto} addPatientNotesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerAddPatientNotes: async (visitId: string, addPatientNotesDto: AddPatientNotesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerAddPatientNotes', 'visitId', visitId)
            // verify required parameter 'addPatientNotesDto' is not null or undefined
            assertParamExists('visitControllerAddPatientNotes', 'addPatientNotesDto', addPatientNotesDto)
            const localVarPath = `/api/visit/{visitId}/addPatientNotes`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPatientNotesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Attach visit summary PDF to profile. Professional and organization admin only.
         * @param {string} visitId
         * @param {VisitControllerAttachVisitSummaryRequest} visitControllerAttachVisitSummaryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerAttachVisitSummary: async (visitId: string, visitControllerAttachVisitSummaryRequest: VisitControllerAttachVisitSummaryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerAttachVisitSummary', 'visitId', visitId)
            // verify required parameter 'visitControllerAttachVisitSummaryRequest' is not null or undefined
            assertParamExists('visitControllerAttachVisitSummary', 'visitControllerAttachVisitSummaryRequest', visitControllerAttachVisitSummaryRequest)
            const localVarPath = `/api/visit/{visitId}/attach-summary`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(visitControllerAttachVisitSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Cancel existing visit
         * @param {string} visitId
         * @param {CancelVisitDto} cancelVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerCancelVisit: async (visitId: string, cancelVisitDto: CancelVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerCancelVisit', 'visitId', visitId)
            // verify required parameter 'cancelVisitDto' is not null or undefined
            assertParamExists('visitControllerCancelVisit', 'cancelVisitDto', cancelVisitDto)
            const localVarPath = `/api/visit/cancel/{visitId}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows admins, organization admins, and professionals to cancel a created visit. Professionals can only cancel their own visits.
         * @summary Cancel upcoming visit (staff)
         * @param {string} visitId ID of the visit to cancel
         * @param {CancelStaffVisitDto} cancelStaffVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerCancelVisitByStaff: async (visitId: string, cancelStaffVisitDto: CancelStaffVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerCancelVisitByStaff', 'visitId', visitId)
            // verify required parameter 'cancelStaffVisitDto' is not null or undefined
            assertParamExists('visitControllerCancelVisitByStaff', 'cancelStaffVisitDto', cancelStaffVisitDto)
            const localVarPath = `/api/visit/{visitId}/cancel/staff`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelStaffVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns basic user information if the user exists, null otherwise
         * @summary Check if user exists by email for staff scheduling
         * @param {string} email Email address to check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerCheckUserByEmail: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('visitControllerCheckUserByEmail', 'email', email)
            const localVarPath = `/api/visit/user-check/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a text note attached to a visit. Resolves profileId/organizationId from the visit (null-safe for guest visits).
         * @param {string} visitId
         * @param {CreateTextNoteDto} createTextNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerCreateVisitTextNote: async (visitId: string, createTextNoteDto: CreateTextNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerCreateVisitTextNote', 'visitId', visitId)
            // verify required parameter 'createTextNoteDto' is not null or undefined
            assertParamExists('visitControllerCreateVisitTextNote', 'createTextNoteDto', createTextNoteDto)
            const localVarPath = `/api/visit/{visitId}/text-notes`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTextNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a visit-scoped document by filename (passed as a query param because filenames may contain slashes). Cleans up matching embeddings and any DOCUMENT/ADDED activity for the same filename. Works for both guest and authed visits.
         * @param {string} visitId
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerDeleteVisitDocument: async (visitId: string, filename: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerDeleteVisitDocument', 'visitId', visitId)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('visitControllerDeleteVisitDocument', 'filename', filename)
            const localVarPath = `/api/visit/{visitId}/documents`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get users associated with a visit
         * @param {string} visitId Visit ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerFetchUserByVisitId: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerFetchUserByVisitId', 'visitId', visitId)
            const localVarPath = `/api/visit/{visitId}/users`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all completed and cancelled visits for all profiles assigned to the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetAllUserVisitsHistory: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/visit/history/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all visits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetAllVisits: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/visit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all available time slots
         * @param {string} startDate
         * @param {string} category
         * @param {string} endDate
         * @param {string} professionalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetAvailableVisitSlots: async (startDate: string, category: string, endDate: string, professionalId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('visitControllerGetAvailableVisitSlots', 'startDate', startDate)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('visitControllerGetAvailableVisitSlots', 'category', category)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('visitControllerGetAvailableVisitSlots', 'endDate', endDate)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('visitControllerGetAvailableVisitSlots', 'professionalId', professionalId)
            const localVarPath = `/api/visit/available-slots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (professionalId !== undefined) {
                localVarQueryParameter['professionalId'] = professionalId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns visits optimized for calendar view with date range filtering. Excludes heavy data like avatars.
         * @summary Get calendar visits for organization (lightweight, no avatars)
         * @param {string} organizationId Organization ID
         * @param {string} [startDate] Start date for filtering (ISO string)
         * @param {string} [endDate] End date for filtering (ISO string)
         * @param {'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED'} [status] Filter by visit status
         * @param {string} [professionalId] Filter by professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetCalendarVisits: async (organizationId: string, startDate?: string, endDate?: string, status?: 'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED', professionalId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('visitControllerGetCalendarVisits', 'organizationId', organizationId)
            const localVarPath = `/api/visit/organization/{organizationId}/calendar`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (professionalId !== undefined) {
                localVarQueryParameter['professionalId'] = professionalId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns visits for the current professional optimized for calendar view.
         * @summary Get calendar visits for current professional (lightweight, no avatars)
         * @param {string} organizationId Organization ID
         * @param {string} [startDate] Start date for filtering (ISO string)
         * @param {string} [endDate] End date for filtering (ISO string)
         * @param {'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED'} [status] Filter by visit status
         * @param {string} [professionalId] Filter by professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetCalendarVisitsForProfessional: async (organizationId: string, startDate?: string, endDate?: string, status?: 'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED', professionalId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('visitControllerGetCalendarVisitsForProfessional', 'organizationId', organizationId)
            const localVarPath = `/api/visit/organization/{organizationId}/calendar/professional`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (professionalId !== undefined) {
                localVarQueryParameter['professionalId'] = professionalId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get current pending approval visit for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetCurrentPendingApprovalVisit: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/visit/date/pending-approval`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get pending visit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetCurrentPendingVisit: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/visit/date/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get professional visit history within organization
         * @param {number} [page] Page number (0-indexed)
         * @param {number} [limit] Number of items per page
         * @param {string} [userName] Filter by user name (first or last name)
         * @param {string} [profileName] Filter by profile name (pet name)
         * @param {string} [startDate] Filter by start date (ISO 8601)
         * @param {string} [endDate] Filter by end date (ISO 8601)
         * @param {string} [closedFrom] Only visits closed on or after this Europe/Warsaw calendar day (YYYY-MM-DD). Inclusive. Legacy ISO 8601 timestamps are interpreted by their Warsaw date. Closure is when the visit reached a terminal status, which is not the day it was booked for — &#x60;startDate&#x60;/&#x60;endDate&#x60; still filter that.
         * @param {string} [closedTo] Only visits closed on or before this Europe/Warsaw calendar day (YYYY-MM-DD). Includes the entire local day, accounting for daylight saving time. Legacy ISO 8601 timestamps are interpreted by their Warsaw date.
         * @param {string} [noteStatuses] Comma-separated note states to keep: SENT (a note the owner has), DRAFT (an unsent draft), NONE (neither). Omit for all of them. Implies COMPLETED/ABORTED — a cancelled visit has no note state.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetOrganizationProfessionalVisitHistory: async (page?: number, limit?: number, userName?: string, profileName?: string, startDate?: string, endDate?: string, closedFrom?: string, closedTo?: string, noteStatuses?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/visit/history/organization/professional`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }

            if (profileName !== undefined) {
                localVarQueryParameter['profileName'] = profileName;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (closedFrom !== undefined) {
                localVarQueryParameter['closedFrom'] = closedFrom;
            }

            if (closedTo !== undefined) {
                localVarQueryParameter['closedTo'] = closedTo;
            }

            if (noteStatuses !== undefined) {
                localVarQueryParameter['noteStatuses'] = noteStatuses;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get professional visit history within organization by professional id param
         * @param {string} professionalId Professional ID
         * @param {number} [page] Page number (0-indexed)
         * @param {number} [limit] Number of items per page
         * @param {string} [userName] Filter by user name (first or last name)
         * @param {string} [profileName] Filter by profile name (pet name)
         * @param {string} [startDate] Filter by start date (ISO 8601)
         * @param {string} [endDate] Filter by end date (ISO 8601)
         * @param {string} [closedFrom] Only visits closed on or after this Europe/Warsaw calendar day (YYYY-MM-DD). Inclusive. Legacy ISO 8601 timestamps are interpreted by their Warsaw date. Closure is when the visit reached a terminal status, which is not the day it was booked for — &#x60;startDate&#x60;/&#x60;endDate&#x60; still filter that.
         * @param {string} [closedTo] Only visits closed on or before this Europe/Warsaw calendar day (YYYY-MM-DD). Includes the entire local day, accounting for daylight saving time. Legacy ISO 8601 timestamps are interpreted by their Warsaw date.
         * @param {string} [noteStatuses] Comma-separated note states to keep: SENT (a note the owner has), DRAFT (an unsent draft), NONE (neither). Omit for all of them. Implies COMPLETED/ABORTED — a cancelled visit has no note state.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam: async (professionalId: string, page?: number, limit?: number, userName?: string, profileName?: string, startDate?: string, endDate?: string, closedFrom?: string, closedTo?: string, noteStatuses?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('visitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam', 'professionalId', professionalId)
            const localVarPath = `/api/visit/history/organization/professional/{professionalId}`
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }

            if (profileName !== undefined) {
                localVarQueryParameter['profileName'] = profileName;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (closedFrom !== undefined) {
                localVarQueryParameter['closedFrom'] = closedFrom;
            }

            if (closedTo !== undefined) {
                localVarQueryParameter['closedTo'] = closedTo;
            }

            if (noteStatuses !== undefined) {
                localVarQueryParameter['noteStatuses'] = noteStatuses;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get organization visit history
         * @param {number} [page] Page number (0-indexed)
         * @param {number} [limit] Number of items per page
         * @param {string} [userName] Filter by user name (first or last name)
         * @param {string} [profileName] Filter by profile name (pet name)
         * @param {string} [startDate] Filter by start date (ISO 8601)
         * @param {string} [endDate] Filter by end date (ISO 8601)
         * @param {string} [closedFrom] Only visits closed on or after this Europe/Warsaw calendar day (YYYY-MM-DD). Inclusive. Legacy ISO 8601 timestamps are interpreted by their Warsaw date. Closure is when the visit reached a terminal status, which is not the day it was booked for — &#x60;startDate&#x60;/&#x60;endDate&#x60; still filter that.
         * @param {string} [closedTo] Only visits closed on or before this Europe/Warsaw calendar day (YYYY-MM-DD). Includes the entire local day, accounting for daylight saving time. Legacy ISO 8601 timestamps are interpreted by their Warsaw date.
         * @param {string} [noteStatuses] Comma-separated note states to keep: SENT (a note the owner has), DRAFT (an unsent draft), NONE (neither). Omit for all of them. Implies COMPLETED/ABORTED — a cancelled visit has no note state.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetOrganizationVisitHistory: async (page?: number, limit?: number, userName?: string, profileName?: string, startDate?: string, endDate?: string, closedFrom?: string, closedTo?: string, noteStatuses?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/visit/history/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }

            if (profileName !== undefined) {
                localVarQueryParameter['profileName'] = profileName;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (closedFrom !== undefined) {
                localVarQueryParameter['closedFrom'] = closedFrom;
            }

            if (closedTo !== undefined) {
                localVarQueryParameter['closedTo'] = closedTo;
            }

            if (noteStatuses !== undefined) {
                localVarQueryParameter['noteStatuses'] = noteStatuses;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Read-only activity log for a visit, accessible to the visit owner. Mirrors the org-scoped activity endpoint but validates visit ownership via req.user.id instead of an organization membership.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetOwnerVisitActivity: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerGetOwnerVisitActivity', 'visitId', visitId)
            const localVarPath = `/api/visit/{visitId}/owner-activity`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all pending visits for professional
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetPendingProfessionalVisits: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/visit/date/organization/professional/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns upcoming visit slots for a professional by ID, with optional limit on slots per day
         * @summary Get available visit slots for a specific professional
         * @param {string} professionalId
         * @param {string} category
         * @param {'video' | 'chat' | 'onsite' | 'mobile'} [visitType] Visit mode required for the availability window
         * @param {number} [slotsPerDay] Maximum number of slots to return per day
         * @param {string} [organizationId] Organization ID to get professional availability from
         * @param {number} [duration] Custom duration in minutes (overrides category default duration)
         * @param {string} [startDate] Earliest start date/time to consider for slots (ISO string). Defaults to now.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetProfessionalAvailableSlots: async (professionalId: string, category: string, visitType?: 'video' | 'chat' | 'onsite' | 'mobile', slotsPerDay?: number, organizationId?: string, duration?: number, startDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('visitControllerGetProfessionalAvailableSlots', 'professionalId', professionalId)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('visitControllerGetProfessionalAvailableSlots', 'category', category)
            const localVarPath = `/api/visit/professional/{professionalId}/slots/{category}`
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)))
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (visitType !== undefined) {
                localVarQueryParameter['visitType'] = visitType;
            }

            if (slotsPerDay !== undefined) {
                localVarQueryParameter['slotsPerDay'] = slotsPerDay;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (duration !== undefined) {
                localVarQueryParameter['duration'] = duration;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get profile visit history. Organization admin/owner/professional only.
         * @param {string} profileId Profile ID
         * @param {number} [page] Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
         * @param {number} [limit] Rows per page. Omit together with &#x60;page&#x60; to get every row.
         * @param {string} [startDate] Only visits on or after this day (ISO 8601). Inclusive.
         * @param {string} [endDate] Only visits on or before this day (ISO 8601). Inclusive.
         * @param {string} [closedFrom] Only visits closed on or after this Europe/Warsaw calendar day (YYYY-MM-DD). Inclusive. Legacy ISO 8601 timestamps are interpreted by their Warsaw date. Closure is when the visit reached a terminal status, which is not the day it was booked for — &#x60;startDate&#x60;/&#x60;endDate&#x60; still filter that.
         * @param {string} [closedTo] Only visits closed on or before this Europe/Warsaw calendar day (YYYY-MM-DD). Includes the entire local day, accounting for daylight saving time. Legacy ISO 8601 timestamps are interpreted by their Warsaw date.
         * @param {string} [statuses] Comma-separated visit statuses to keep, e.g. &#x60;COMPLETED,CANCELLED&#x60;. Narrows the finished/cancelled/aborted set the history already shows — it can never widen it. Omit for all three.
         * @param {string} [noteStatuses] Comma-separated note states to keep: SENT, DRAFT, NONE. Omit for all of them. Selecting any also implies COMPLETED/ABORTED, since a cancelled visit has no note state.
         * @param {string} [professionalName] Only visits whose professional\&#39;s first and last name contain this text, case-insensitive. Matched against the two joined with a space, so &#x60;jan kow&#x60; matches Jan Kowalski.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetProfileVisitHistoryPreview: async (profileId: string, page?: number, limit?: number, startDate?: string, endDate?: string, closedFrom?: string, closedTo?: string, statuses?: string, noteStatuses?: string, professionalName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('visitControllerGetProfileVisitHistoryPreview', 'profileId', profileId)
            const localVarPath = `/api/visit/history/profile/{profileId}/preview`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (closedFrom !== undefined) {
                localVarQueryParameter['closedFrom'] = closedFrom;
            }

            if (closedTo !== undefined) {
                localVarQueryParameter['closedTo'] = closedTo;
            }

            if (statuses !== undefined) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (noteStatuses !== undefined) {
                localVarQueryParameter['noteStatuses'] = noteStatuses;
            }

            if (professionalName !== undefined) {
                localVarQueryParameter['professionalName'] = professionalName;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get today visits for a professional in an organization
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetTodaysVisitsByOrganizationAndProfessionalId: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('visitControllerGetTodaysVisitsByOrganizationAndProfessionalId', 'organizationId', organizationId)
            const localVarPath = `/api/visit/organization/{organizationId}/professional/date/today`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get today visits for a professional by professional id param in an organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParam: async (organizationId: string, professionalId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('visitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParam', 'organizationId', organizationId)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('visitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParam', 'professionalId', professionalId)
            const localVarPath = `/api/visit/organization/{organizationId}/professional/{professionalId}/date/today`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get organization today visits
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetTodaysVisitsByOrganizationId: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('visitControllerGetTodaysVisitsByOrganizationId', 'organizationId', organizationId)
            const localVarPath = `/api/visit/organization/{organizationId}/date/today`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get upcoming visits for a profile in an organization
         * @param {string} organizationId Organization ID
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetUpcomingVisitsByOrganizationAndProfileId: async (organizationId: string, profileId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('visitControllerGetUpcomingVisitsByOrganizationAndProfileId', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('visitControllerGetUpcomingVisitsByOrganizationAndProfileId', 'profileId', profileId)
            const localVarPath = `/api/visit/organization/{organizationId}/profile/{profileId}/date/upcoming`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all pet profiles belonging to the specified user
         * @summary Get all profiles for a specific user for staff scheduling
         * @param {string} userId User ID to get profiles for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetUserProfiles: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('visitControllerGetUserProfiles', 'userId', userId)
            const localVarPath = `/api/visit/user-profiles/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get user upcoming visits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetUserUpcomingVisits: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/visit/date/upcoming`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get visit by id
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitById: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerGetVisitById', 'visitId', visitId)
            const localVarPath = `/api/visit/{visitId}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Signed URL for a file in the documents collection scoped to a visit
         * @param {string} visitId
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitFileSignedUrl: async (visitId: string, filename: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerGetVisitFileSignedUrl', 'visitId', visitId)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('visitControllerGetVisitFileSignedUrl', 'filename', filename)
            const localVarPath = `/api/visit/{visitId}/document-files/{filename}/signed-url`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)))
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get profile visit history
         * @param {string} profileId
         * @param {number} [page] Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
         * @param {number} [limit] Rows per page. Omit together with &#x60;page&#x60; to get every row.
         * @param {string} [startDate] Only visits on or after this day (ISO 8601). Inclusive.
         * @param {string} [endDate] Only visits on or before this day (ISO 8601). Inclusive.
         * @param {string} [closedFrom] Only visits closed on or after this Europe/Warsaw calendar day (YYYY-MM-DD). Inclusive. Legacy ISO 8601 timestamps are interpreted by their Warsaw date. Closure is when the visit reached a terminal status, which is not the day it was booked for — &#x60;startDate&#x60;/&#x60;endDate&#x60; still filter that.
         * @param {string} [closedTo] Only visits closed on or before this Europe/Warsaw calendar day (YYYY-MM-DD). Includes the entire local day, accounting for daylight saving time. Legacy ISO 8601 timestamps are interpreted by their Warsaw date.
         * @param {string} [statuses] Comma-separated visit statuses to keep, e.g. &#x60;COMPLETED,CANCELLED&#x60;. Narrows the finished/cancelled/aborted set the history already shows — it can never widen it. Omit for all three.
         * @param {string} [noteStatuses] Comma-separated note states to keep: SENT, DRAFT, NONE. Omit for all of them. Selecting any also implies COMPLETED/ABORTED, since a cancelled visit has no note state.
         * @param {string} [professionalName] Only visits whose professional\&#39;s first and last name contain this text, case-insensitive. Matched against the two joined with a space, so &#x60;jan kow&#x60; matches Jan Kowalski.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitHistory: async (profileId: string, page?: number, limit?: number, startDate?: string, endDate?: string, closedFrom?: string, closedTo?: string, statuses?: string, noteStatuses?: string, professionalName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('visitControllerGetVisitHistory', 'profileId', profileId)
            const localVarPath = `/api/visit/history/profile/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (closedFrom !== undefined) {
                localVarQueryParameter['closedFrom'] = closedFrom;
            }

            if (closedTo !== undefined) {
                localVarQueryParameter['closedTo'] = closedTo;
            }

            if (statuses !== undefined) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (noteStatuses !== undefined) {
                localVarQueryParameter['noteStatuses'] = noteStatuses;
            }

            if (professionalName !== undefined) {
                localVarQueryParameter['professionalName'] = professionalName;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get professional visit summary a.k.a. stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitStats: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/visit/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get visit summary data for PDF generation. Professional and organization admin only.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitSummaryData: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerGetVisitSummaryData', 'visitId', visitId)
            const localVarPath = `/api/visit/{visitId}/summary-data`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get visit audio transcription
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitTranscription: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerGetVisitTranscription', 'visitId', visitId)
            const localVarPath = `/api/visit/{visitId}/transcription`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all visits for a specific professional in an organization
         * @param {string} organizationId Organization ID
         * @param {'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED'} [status] Filter by visit status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitsByOrganizationAndProfessionalId: async (organizationId: string, status?: 'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('visitControllerGetVisitsByOrganizationAndProfessionalId', 'organizationId', organizationId)
            const localVarPath = `/api/visit/organization/{organizationId}/professional`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all visits for a specific professional in an organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitsByOrganizationAndProfessionalIdParam: async (organizationId: string, professionalId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('visitControllerGetVisitsByOrganizationAndProfessionalIdParam', 'organizationId', organizationId)
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('visitControllerGetVisitsByOrganizationAndProfessionalIdParam', 'professionalId', professionalId)
            const localVarPath = `/api/visit/organization/{organizationId}/professional/{professionalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all visits for a specific organization
         * @param {string} organizationId Organization ID
         * @param {'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED'} [status] Filter by visit status
         * @param {string} [professionalId] Filter by professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitsByOrganizationId: async (organizationId: string, status?: 'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED', professionalId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('visitControllerGetVisitsByOrganizationId', 'organizationId', organizationId)
            const localVarPath = `/api/visit/organization/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (professionalId !== undefined) {
                localVarQueryParameter['professionalId'] = professionalId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List all documents attached to a visit (from the Document collection, keyed by visitId). Works for both guest and authed visits.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerListVisitDocuments: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerListVisitDocuments', 'visitId', visitId)
            const localVarPath = `/api/visit/{visitId}/documents`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Rate visit after completed.
         * @param {string} visitId
         * @param {RateVisitDto} rateVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerRateVisit: async (visitId: string, rateVisitDto: RateVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerRateVisit', 'visitId', visitId)
            // verify required parameter 'rateVisitDto' is not null or undefined
            assertParamExists('visitControllerRateVisit', 'rateVisitDto', rateVisitDto)
            const localVarPath = `/api/visit/{visitId}/rate`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rateVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows admins and organization admins to reassign a created visit to a different professional
         * @summary Reassign upcoming visit to another professional within organization
         * @param {string} visitId ID of the visit to reassign
         * @param {ReassignVisitDto} reassignVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerReassignVisit: async (visitId: string, reassignVisitDto: ReassignVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerReassignVisit', 'visitId', visitId)
            // verify required parameter 'reassignVisitDto' is not null or undefined
            assertParamExists('visitControllerReassignVisit', 'reassignVisitDto', reassignVisitDto)
            const localVarPath = `/api/visit/{visitId}/reassign`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reassignVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reschedule existing visit
         * @param {RescheduleVisitDto} rescheduleVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerRescheduleVisit: async (rescheduleVisitDto: RescheduleVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rescheduleVisitDto' is not null or undefined
            assertParamExists('visitControllerRescheduleVisit', 'rescheduleVisitDto', rescheduleVisitDto)
            const localVarPath = `/api/visit/reschedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescheduleVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows admins, organization admins, and professionals to reschedule a created visit. Professionals can only reschedule their own visits.
         * @summary Reschedule upcoming visit to another time (staff)
         * @param {string} visitId ID of the visit to reschedule
         * @param {RescheduleStaffVisitDto} rescheduleStaffVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerRescheduleVisitByStaff: async (visitId: string, rescheduleStaffVisitDto: RescheduleStaffVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerRescheduleVisitByStaff', 'visitId', visitId)
            // verify required parameter 'rescheduleStaffVisitDto' is not null or undefined
            assertParamExists('visitControllerRescheduleVisitByStaff', 'rescheduleStaffVisitDto', rescheduleStaffVisitDto)
            const localVarPath = `/api/visit/{visitId}/reschedule/staff`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescheduleStaffVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Schedule a new visit by staff (professional or admin)
         * @param {StaffScheduleVisitDto} staffScheduleVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerScheduleStaffVisit: async (staffScheduleVisitDto: StaffScheduleVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffScheduleVisitDto' is not null or undefined
            assertParamExists('visitControllerScheduleStaffVisit', 'staffScheduleVisitDto', staffScheduleVisitDto)
            const localVarPath = `/api/visit/schedule/staff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(staffScheduleVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Schedule a new visit
         * @param {ScheduleVisitDto} scheduleVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerScheduleVisit: async (scheduleVisitDto: ScheduleVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduleVisitDto' is not null or undefined
            assertParamExists('visitControllerScheduleVisit', 'scheduleVisitDto', scheduleVisitDto)
            const localVarPath = `/api/visit/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Send a visit\'s draft notes to the owner. Any member of the organisation that owns the visit may finish a draft.
         * @param {string} visitId
         * @param {AddPatientNotesDto} addPatientNotesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerSendDraftNotes: async (visitId: string, addPatientNotesDto: AddPatientNotesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerSendDraftNotes', 'visitId', visitId)
            // verify required parameter 'addPatientNotesDto' is not null or undefined
            assertParamExists('visitControllerSendDraftNotes', 'addPatientNotesDto', addPatientNotesDto)
            const localVarPath = `/api/visit/{visitId}/sendDraftNotes`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPatientNotesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Start live audio transcription for a visit
         * @param {string} visitId
         * @param {StartVisitTranscriptionDto} startVisitTranscriptionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerStartVisitTranscription: async (visitId: string, startVisitTranscriptionDto: StartVisitTranscriptionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerStartVisitTranscription', 'visitId', visitId)
            // verify required parameter 'startVisitTranscriptionDto' is not null or undefined
            assertParamExists('visitControllerStartVisitTranscription', 'startVisitTranscriptionDto', startVisitTranscriptionDto)
            const localVarPath = `/api/visit/{visitId}/transcription/start`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startVisitTranscriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Stop live audio transcription for a visit
         * @param {string} visitId
         * @param {StopVisitTranscriptionDto} stopVisitTranscriptionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerStopVisitTranscription: async (visitId: string, stopVisitTranscriptionDto: StopVisitTranscriptionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerStopVisitTranscription', 'visitId', visitId)
            // verify required parameter 'stopVisitTranscriptionDto' is not null or undefined
            assertParamExists('visitControllerStopVisitTranscription', 'stopVisitTranscriptionDto', stopVisitTranscriptionDto)
            const localVarPath = `/api/visit/{visitId}/transcription/stop`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stopVisitTranscriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows the pet owner to accept or reject an appointment scheduled by staff
         * @summary Accept or reject a scheduled appointment
         * @param {string} visitId ID of the visit to approve/reject
         * @param {VisitApprovalDto} visitApprovalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerUpdateVisitApproval: async (visitId: string, visitApprovalDto: VisitApprovalDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerUpdateVisitApproval', 'visitId', visitId)
            // verify required parameter 'visitApprovalDto' is not null or undefined
            assertParamExists('visitControllerUpdateVisitApproval', 'visitApprovalDto', visitApprovalDto)
            const localVarPath = `/api/visit/{visitId}/approval`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(visitApprovalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Owner-side edit of the visit description (\"Dolegliwości\") and attached documents. Diff-based: optional description replace + documentsToAdd + documentIdsToRemove.
         * @param {string} visitId
         * @param {UpdateVisitDetailsDto} updateVisitDetailsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerUpdateVisitDetails: async (visitId: string, updateVisitDetailsDto: UpdateVisitDetailsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerUpdateVisitDetails', 'visitId', visitId)
            // verify required parameter 'updateVisitDetailsDto' is not null or undefined
            assertParamExists('visitControllerUpdateVisitDetails', 'updateVisitDetailsDto', updateVisitDetailsDto)
            const localVarPath = `/api/visit/{visitId}/details`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVisitDetailsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the visit\'s embedded profileData (name, breed, petCategory, weight, gender, dob, chipNumber). Only valid for guest visits (no linked Profile). Authed visits must use the profile update endpoints instead.
         * @summary Update guest-visit profile data (pet info) during a live visit
         * @param {string} visitId
         * @param {UpdateVisitProfileDataDto} updateVisitProfileDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerUpdateVisitProfileData: async (visitId: string, updateVisitProfileDataDto: UpdateVisitProfileDataDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerUpdateVisitProfileData', 'visitId', visitId)
            // verify required parameter 'updateVisitProfileDataDto' is not null or undefined
            assertParamExists('visitControllerUpdateVisitProfileData', 'updateVisitProfileDataDto', updateVisitProfileDataDto)
            const localVarPath = `/api/visit/{visitId}/profile-data`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVisitProfileDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a text note attached to a visit (identified by filename). Verifies the note belongs to this visit before updating.
         * @param {string} visitId
         * @param {string} filename
         * @param {UpdateTextNoteDto} updateTextNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerUpdateVisitTextNote: async (visitId: string, filename: string, updateTextNoteDto: UpdateTextNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerUpdateVisitTextNote', 'visitId', visitId)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('visitControllerUpdateVisitTextNote', 'filename', filename)
            // verify required parameter 'updateTextNoteDto' is not null or undefined
            assertParamExists('visitControllerUpdateVisitTextNote', 'updateTextNoteDto', updateTextNoteDto)
            const localVarPath = `/api/visit/{visitId}/text-notes/{filename}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)))
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTextNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a visit transcription segment
         * @param {string} visitId
         * @param {UpdateVisitTranscriptionSegmentDto} updateVisitTranscriptionSegmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerUpdateVisitTranscriptionSegment: async (visitId: string, updateVisitTranscriptionSegmentDto: UpdateVisitTranscriptionSegmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerUpdateVisitTranscriptionSegment', 'visitId', visitId)
            // verify required parameter 'updateVisitTranscriptionSegmentDto' is not null or undefined
            assertParamExists('visitControllerUpdateVisitTranscriptionSegment', 'updateVisitTranscriptionSegmentDto', updateVisitTranscriptionSegmentDto)
            const localVarPath = `/api/visit/{visitId}/transcription/segment`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVisitTranscriptionSegmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the visit\'s embedded userData (firstName, lastName, email, phoneNumber). Only valid for guest visits (no linked User). Authed visits must use the user profile endpoints instead.
         * @summary Update guest-visit owner contact data during a live visit
         * @param {string} visitId
         * @param {UpdateVisitUserDataDto} updateVisitUserDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerUpdateVisitUserDataByStaff: async (visitId: string, updateVisitUserDataDto: UpdateVisitUserDataDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitControllerUpdateVisitUserDataByStaff', 'visitId', visitId)
            // verify required parameter 'updateVisitUserDataDto' is not null or undefined
            assertParamExists('visitControllerUpdateVisitUserDataByStaff', 'updateVisitUserDataDto', updateVisitUserDataDto)
            const localVarPath = `/api/visit/{visitId}/user-data`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVisitUserDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create and immediately start a visit with no prior booking. The professional is always the caller.
         * @param {WalkInVisitDto} walkInVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitWalkInControllerStartWalkInVisit: async (walkInVisitDto: WalkInVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'walkInVisitDto' is not null or undefined
            assertParamExists('visitWalkInControllerStartWalkInVisit', 'walkInVisitDto', walkInVisitDto)
            const localVarPath = `/api/visit/walk-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(walkInVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VisitApi - functional programming interface
 * @export
 */
export const VisitApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VisitApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Abort ongoing visit
         * @param {AbortVisitDto} abortVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerAbortVisit(abortVisitDto: AbortVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerAbortVisit(abortVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Add documents to a visit. Writes to the Document collection with visitId + (optional) profileId for guest visits.
         * @param {string} visitId
         * @param {Array<DocumentFileDto>} documentFileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerAddDocuments(visitId: string, documentFileDto: Array<DocumentFileDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentFileResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerAddDocuments(visitId, documentFileDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Save patient notes as a draft, without sending them to the owner. Professional only.
         * @param {string} visitId
         * @param {AddDraftNotesDto} addDraftNotesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerAddDraftNotes(visitId: string, addDraftNotesDto: AddDraftNotesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerAddDraftNotes(visitId, addDraftNotesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Add internal notes to a visit. Professional only. No notification sent to patient.
         * @param {string} visitId
         * @param {AddInternalNotesDto} addInternalNotesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerAddInternalNotes(visitId: string, addInternalNotesDto: AddInternalNotesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerAddInternalNotes(visitId, addInternalNotesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Add notes to a visit. Professional only.
         * @param {string} visitId
         * @param {AddNotesDto} addNotesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerAddNotes(visitId: string, addNotesDto: AddNotesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerAddNotes(visitId, addNotesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Add patient notes to a visit. Professional only. Sends notification to patient.
         * @param {string} visitId
         * @param {AddPatientNotesDto} addPatientNotesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerAddPatientNotes(visitId: string, addPatientNotesDto: AddPatientNotesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerAddPatientNotes(visitId, addPatientNotesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Attach visit summary PDF to profile. Professional and organization admin only.
         * @param {string} visitId
         * @param {VisitControllerAttachVisitSummaryRequest} visitControllerAttachVisitSummaryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerAttachVisitSummary(visitId: string, visitControllerAttachVisitSummaryRequest: VisitControllerAttachVisitSummaryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisitControllerAttachVisitSummary200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerAttachVisitSummary(visitId, visitControllerAttachVisitSummaryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Cancel existing visit
         * @param {string} visitId
         * @param {CancelVisitDto} cancelVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerCancelVisit(visitId: string, cancelVisitDto: CancelVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerCancelVisit(visitId, cancelVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows admins, organization admins, and professionals to cancel a created visit. Professionals can only cancel their own visits.
         * @summary Cancel upcoming visit (staff)
         * @param {string} visitId ID of the visit to cancel
         * @param {CancelStaffVisitDto} cancelStaffVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerCancelVisitByStaff(visitId: string, cancelStaffVisitDto: CancelStaffVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVisitById>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerCancelVisitByStaff(visitId, cancelStaffVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns basic user information if the user exists, null otherwise
         * @summary Check if user exists by email for staff scheduling
         * @param {string} email Email address to check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerCheckUserByEmail(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisitControllerCheckUserByEmail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerCheckUserByEmail(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Create a text note attached to a visit. Resolves profileId/organizationId from the visit (null-safe for guest visits).
         * @param {string} visitId
         * @param {CreateTextNoteDto} createTextNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerCreateVisitTextNote(visitId: string, createTextNoteDto: CreateTextNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentFileResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerCreateVisitTextNote(visitId, createTextNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a visit-scoped document by filename (passed as a query param because filenames may contain slashes). Cleans up matching embeddings and any DOCUMENT/ADDED activity for the same filename. Works for both guest and authed visits.
         * @param {string} visitId
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerDeleteVisitDocument(visitId: string, filename: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentFileResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerDeleteVisitDocument(visitId, filename, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get users associated with a visit
         * @param {string} visitId Visit ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerFetchUserByVisitId(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerFetchUserByVisitId(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all completed and cancelled visits for all profiles assigned to the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetAllUserVisitsHistory(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVisitById>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetAllUserVisitsHistory(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all visits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetAllVisits(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVisitById>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetAllVisits(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all available time slots
         * @param {string} startDate
         * @param {string} category
         * @param {string} endDate
         * @param {string} professionalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetAvailableVisitSlots(startDate: string, category: string, endDate: string, professionalId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailableSlotsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetAvailableVisitSlots(startDate, category, endDate, professionalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns visits optimized for calendar view with date range filtering. Excludes heavy data like avatars.
         * @summary Get calendar visits for organization (lightweight, no avatars)
         * @param {string} organizationId Organization ID
         * @param {string} [startDate] Start date for filtering (ISO string)
         * @param {string} [endDate] End date for filtering (ISO string)
         * @param {'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED'} [status] Filter by visit status
         * @param {string} [professionalId] Filter by professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetCalendarVisits(organizationId: string, startDate?: string, endDate?: string, status?: 'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED', professionalId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarVisitsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetCalendarVisits(organizationId, startDate, endDate, status, professionalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns visits for the current professional optimized for calendar view.
         * @summary Get calendar visits for current professional (lightweight, no avatars)
         * @param {string} organizationId Organization ID
         * @param {string} [startDate] Start date for filtering (ISO string)
         * @param {string} [endDate] End date for filtering (ISO string)
         * @param {'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED'} [status] Filter by visit status
         * @param {string} [professionalId] Filter by professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetCalendarVisitsForProfessional(organizationId: string, startDate?: string, endDate?: string, status?: 'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED', professionalId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarVisitsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetCalendarVisitsForProfessional(organizationId, startDate, endDate, status, professionalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get current pending approval visit for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetCurrentPendingApprovalVisit(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVisitById>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetCurrentPendingApprovalVisit(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get pending visit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetCurrentPendingVisit(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVisitById>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetCurrentPendingVisit(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get professional visit history within organization
         * @param {number} [page] Page number (0-indexed)
         * @param {number} [limit] Number of items per page
         * @param {string} [userName] Filter by user name (first or last name)
         * @param {string} [profileName] Filter by profile name (pet name)
         * @param {string} [startDate] Filter by start date (ISO 8601)
         * @param {string} [endDate] Filter by end date (ISO 8601)
         * @param {string} [closedFrom] Only visits closed on or after this Europe/Warsaw calendar day (YYYY-MM-DD). Inclusive. Legacy ISO 8601 timestamps are interpreted by their Warsaw date. Closure is when the visit reached a terminal status, which is not the day it was booked for — &#x60;startDate&#x60;/&#x60;endDate&#x60; still filter that.
         * @param {string} [closedTo] Only visits closed on or before this Europe/Warsaw calendar day (YYYY-MM-DD). Includes the entire local day, accounting for daylight saving time. Legacy ISO 8601 timestamps are interpreted by their Warsaw date.
         * @param {string} [noteStatuses] Comma-separated note states to keep: SENT (a note the owner has), DRAFT (an unsent draft), NONE (neither). Omit for all of them. Implies COMPLETED/ABORTED — a cancelled visit has no note state.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetOrganizationProfessionalVisitHistory(page?: number, limit?: number, userName?: string, profileName?: string, startDate?: string, endDate?: string, closedFrom?: string, closedTo?: string, noteStatuses?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedVisitsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetOrganizationProfessionalVisitHistory(page, limit, userName, profileName, startDate, endDate, closedFrom, closedTo, noteStatuses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get professional visit history within organization by professional id param
         * @param {string} professionalId Professional ID
         * @param {number} [page] Page number (0-indexed)
         * @param {number} [limit] Number of items per page
         * @param {string} [userName] Filter by user name (first or last name)
         * @param {string} [profileName] Filter by profile name (pet name)
         * @param {string} [startDate] Filter by start date (ISO 8601)
         * @param {string} [endDate] Filter by end date (ISO 8601)
         * @param {string} [closedFrom] Only visits closed on or after this Europe/Warsaw calendar day (YYYY-MM-DD). Inclusive. Legacy ISO 8601 timestamps are interpreted by their Warsaw date. Closure is when the visit reached a terminal status, which is not the day it was booked for — &#x60;startDate&#x60;/&#x60;endDate&#x60; still filter that.
         * @param {string} [closedTo] Only visits closed on or before this Europe/Warsaw calendar day (YYYY-MM-DD). Includes the entire local day, accounting for daylight saving time. Legacy ISO 8601 timestamps are interpreted by their Warsaw date.
         * @param {string} [noteStatuses] Comma-separated note states to keep: SENT (a note the owner has), DRAFT (an unsent draft), NONE (neither). Omit for all of them. Implies COMPLETED/ABORTED — a cancelled visit has no note state.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam(professionalId: string, page?: number, limit?: number, userName?: string, profileName?: string, startDate?: string, endDate?: string, closedFrom?: string, closedTo?: string, noteStatuses?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedVisitsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam(professionalId, page, limit, userName, profileName, startDate, endDate, closedFrom, closedTo, noteStatuses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get organization visit history
         * @param {number} [page] Page number (0-indexed)
         * @param {number} [limit] Number of items per page
         * @param {string} [userName] Filter by user name (first or last name)
         * @param {string} [profileName] Filter by profile name (pet name)
         * @param {string} [startDate] Filter by start date (ISO 8601)
         * @param {string} [endDate] Filter by end date (ISO 8601)
         * @param {string} [closedFrom] Only visits closed on or after this Europe/Warsaw calendar day (YYYY-MM-DD). Inclusive. Legacy ISO 8601 timestamps are interpreted by their Warsaw date. Closure is when the visit reached a terminal status, which is not the day it was booked for — &#x60;startDate&#x60;/&#x60;endDate&#x60; still filter that.
         * @param {string} [closedTo] Only visits closed on or before this Europe/Warsaw calendar day (YYYY-MM-DD). Includes the entire local day, accounting for daylight saving time. Legacy ISO 8601 timestamps are interpreted by their Warsaw date.
         * @param {string} [noteStatuses] Comma-separated note states to keep: SENT (a note the owner has), DRAFT (an unsent draft), NONE (neither). Omit for all of them. Implies COMPLETED/ABORTED — a cancelled visit has no note state.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetOrganizationVisitHistory(page?: number, limit?: number, userName?: string, profileName?: string, startDate?: string, endDate?: string, closedFrom?: string, closedTo?: string, noteStatuses?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedVisitsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetOrganizationVisitHistory(page, limit, userName, profileName, startDate, endDate, closedFrom, closedTo, noteStatuses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Read-only activity log for a visit, accessible to the visit owner. Mirrors the org-scoped activity endpoint but validates visit ownership via req.user.id instead of an organization membership.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetOwnerVisitActivity(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VisitActivityResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetOwnerVisitActivity(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all pending visits for professional
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetPendingProfessionalVisits(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVisitById>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetPendingProfessionalVisits(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns upcoming visit slots for a professional by ID, with optional limit on slots per day
         * @summary Get available visit slots for a specific professional
         * @param {string} professionalId
         * @param {string} category
         * @param {'video' | 'chat' | 'onsite' | 'mobile'} [visitType] Visit mode required for the availability window
         * @param {number} [slotsPerDay] Maximum number of slots to return per day
         * @param {string} [organizationId] Organization ID to get professional availability from
         * @param {number} [duration] Custom duration in minutes (overrides category default duration)
         * @param {string} [startDate] Earliest start date/time to consider for slots (ISO string). Defaults to now.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetProfessionalAvailableSlots(professionalId: string, category: string, visitType?: 'video' | 'chat' | 'onsite' | 'mobile', slotsPerDay?: number, organizationId?: string, duration?: number, startDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalSlotsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetProfessionalAvailableSlots(professionalId, category, visitType, slotsPerDay, organizationId, duration, startDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get profile visit history. Organization admin/owner/professional only.
         * @param {string} profileId Profile ID
         * @param {number} [page] Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
         * @param {number} [limit] Rows per page. Omit together with &#x60;page&#x60; to get every row.
         * @param {string} [startDate] Only visits on or after this day (ISO 8601). Inclusive.
         * @param {string} [endDate] Only visits on or before this day (ISO 8601). Inclusive.
         * @param {string} [closedFrom] Only visits closed on or after this Europe/Warsaw calendar day (YYYY-MM-DD). Inclusive. Legacy ISO 8601 timestamps are interpreted by their Warsaw date. Closure is when the visit reached a terminal status, which is not the day it was booked for — &#x60;startDate&#x60;/&#x60;endDate&#x60; still filter that.
         * @param {string} [closedTo] Only visits closed on or before this Europe/Warsaw calendar day (YYYY-MM-DD). Includes the entire local day, accounting for daylight saving time. Legacy ISO 8601 timestamps are interpreted by their Warsaw date.
         * @param {string} [statuses] Comma-separated visit statuses to keep, e.g. &#x60;COMPLETED,CANCELLED&#x60;. Narrows the finished/cancelled/aborted set the history already shows — it can never widen it. Omit for all three.
         * @param {string} [noteStatuses] Comma-separated note states to keep: SENT, DRAFT, NONE. Omit for all of them. Selecting any also implies COMPLETED/ABORTED, since a cancelled visit has no note state.
         * @param {string} [professionalName] Only visits whose professional\&#39;s first and last name contain this text, case-insensitive. Matched against the two joined with a space, so &#x60;jan kow&#x60; matches Jan Kowalski.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetProfileVisitHistoryPreview(profileId: string, page?: number, limit?: number, startDate?: string, endDate?: string, closedFrom?: string, closedTo?: string, statuses?: string, noteStatuses?: string, professionalName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedVisitHistoryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetProfileVisitHistoryPreview(profileId, page, limit, startDate, endDate, closedFrom, closedTo, statuses, noteStatuses, professionalName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get today visits for a professional in an organization
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetTodaysVisitsByOrganizationAndProfessionalId(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVisitById>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetTodaysVisitsByOrganizationAndProfessionalId(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get today visits for a professional by professional id param in an organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParam(organizationId: string, professionalId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVisitById>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParam(organizationId, professionalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get organization today visits
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetTodaysVisitsByOrganizationId(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVisitById>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetTodaysVisitsByOrganizationId(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get upcoming visits for a profile in an organization
         * @param {string} organizationId Organization ID
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetUpcomingVisitsByOrganizationAndProfileId(organizationId: string, profileId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVisitById>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetUpcomingVisitsByOrganizationAndProfileId(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all pet profiles belonging to the specified user
         * @summary Get all profiles for a specific user for staff scheduling
         * @param {string} userId User ID to get profiles for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetUserProfiles(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VisitControllerGetUserProfiles200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetUserProfiles(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get user upcoming visits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetUserUpcomingVisits(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVisitById>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetUserUpcomingVisits(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get visit by id
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetVisitById(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVisitById>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetVisitById(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Signed URL for a file in the documents collection scoped to a visit
         * @param {string} visitId
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetVisitFileSignedUrl(visitId: string, filename: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisitControllerGetVisitFileSignedUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetVisitFileSignedUrl(visitId, filename, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get profile visit history
         * @param {string} profileId
         * @param {number} [page] Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
         * @param {number} [limit] Rows per page. Omit together with &#x60;page&#x60; to get every row.
         * @param {string} [startDate] Only visits on or after this day (ISO 8601). Inclusive.
         * @param {string} [endDate] Only visits on or before this day (ISO 8601). Inclusive.
         * @param {string} [closedFrom] Only visits closed on or after this Europe/Warsaw calendar day (YYYY-MM-DD). Inclusive. Legacy ISO 8601 timestamps are interpreted by their Warsaw date. Closure is when the visit reached a terminal status, which is not the day it was booked for — &#x60;startDate&#x60;/&#x60;endDate&#x60; still filter that.
         * @param {string} [closedTo] Only visits closed on or before this Europe/Warsaw calendar day (YYYY-MM-DD). Includes the entire local day, accounting for daylight saving time. Legacy ISO 8601 timestamps are interpreted by their Warsaw date.
         * @param {string} [statuses] Comma-separated visit statuses to keep, e.g. &#x60;COMPLETED,CANCELLED&#x60;. Narrows the finished/cancelled/aborted set the history already shows — it can never widen it. Omit for all three.
         * @param {string} [noteStatuses] Comma-separated note states to keep: SENT, DRAFT, NONE. Omit for all of them. Selecting any also implies COMPLETED/ABORTED, since a cancelled visit has no note state.
         * @param {string} [professionalName] Only visits whose professional\&#39;s first and last name contain this text, case-insensitive. Matched against the two joined with a space, so &#x60;jan kow&#x60; matches Jan Kowalski.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetVisitHistory(profileId: string, page?: number, limit?: number, startDate?: string, endDate?: string, closedFrom?: string, closedTo?: string, statuses?: string, noteStatuses?: string, professionalName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedVisitHistoryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetVisitHistory(profileId, page, limit, startDate, endDate, closedFrom, closedTo, statuses, noteStatuses, professionalName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get professional visit summary a.k.a. stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetVisitStats(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisitStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetVisitStats(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get visit summary data for PDF generation. Professional and organization admin only.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetVisitSummaryData(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisitSummaryDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetVisitSummaryData(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get visit audio transcription
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetVisitTranscription(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisitTranscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetVisitTranscription(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all visits for a specific professional in an organization
         * @param {string} organizationId Organization ID
         * @param {'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED'} [status] Filter by visit status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetVisitsByOrganizationAndProfessionalId(organizationId: string, status?: 'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVisitById>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetVisitsByOrganizationAndProfessionalId(organizationId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all visits for a specific professional in an organization
         * @param {string} organizationId Organization ID
         * @param {string} professionalId Professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetVisitsByOrganizationAndProfessionalIdParam(organizationId: string, professionalId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVisitById>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetVisitsByOrganizationAndProfessionalIdParam(organizationId, professionalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all visits for a specific organization
         * @param {string} organizationId Organization ID
         * @param {'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED'} [status] Filter by visit status
         * @param {string} [professionalId] Filter by professional ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerGetVisitsByOrganizationId(organizationId: string, status?: 'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED', professionalId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVisitById>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerGetVisitsByOrganizationId(organizationId, status, professionalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List all documents attached to a visit (from the Document collection, keyed by visitId). Works for both guest and authed visits.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerListVisitDocuments(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentFileResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerListVisitDocuments(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Rate visit after completed.
         * @param {string} visitId
         * @param {RateVisitDto} rateVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerRateVisit(visitId: string, rateVisitDto: RateVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerRateVisit(visitId, rateVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows admins and organization admins to reassign a created visit to a different professional
         * @summary Reassign upcoming visit to another professional within organization
         * @param {string} visitId ID of the visit to reassign
         * @param {ReassignVisitDto} reassignVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerReassignVisit(visitId: string, reassignVisitDto: ReassignVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVisitById>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerReassignVisit(visitId, reassignVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Reschedule existing visit
         * @param {RescheduleVisitDto} rescheduleVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerRescheduleVisit(rescheduleVisitDto: RescheduleVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerRescheduleVisit(rescheduleVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows admins, organization admins, and professionals to reschedule a created visit. Professionals can only reschedule their own visits.
         * @summary Reschedule upcoming visit to another time (staff)
         * @param {string} visitId ID of the visit to reschedule
         * @param {RescheduleStaffVisitDto} rescheduleStaffVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerRescheduleVisitByStaff(visitId: string, rescheduleStaffVisitDto: RescheduleStaffVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVisitById>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerRescheduleVisitByStaff(visitId, rescheduleStaffVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Schedule a new visit by staff (professional or admin)
         * @param {StaffScheduleVisitDto} staffScheduleVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerScheduleStaffVisit(staffScheduleVisitDto: StaffScheduleVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StaffScheduleVisitResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerScheduleStaffVisit(staffScheduleVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Schedule a new visit
         * @param {ScheduleVisitDto} scheduleVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerScheduleVisit(scheduleVisitDto: ScheduleVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleVisitResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerScheduleVisit(scheduleVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Send a visit\'s draft notes to the owner. Any member of the organisation that owns the visit may finish a draft.
         * @param {string} visitId
         * @param {AddPatientNotesDto} addPatientNotesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerSendDraftNotes(visitId: string, addPatientNotesDto: AddPatientNotesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerSendDraftNotes(visitId, addPatientNotesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Start live audio transcription for a visit
         * @param {string} visitId
         * @param {StartVisitTranscriptionDto} startVisitTranscriptionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerStartVisitTranscription(visitId: string, startVisitTranscriptionDto: StartVisitTranscriptionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartVisitTranscriptionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerStartVisitTranscription(visitId, startVisitTranscriptionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Stop live audio transcription for a visit
         * @param {string} visitId
         * @param {StopVisitTranscriptionDto} stopVisitTranscriptionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerStopVisitTranscription(visitId: string, stopVisitTranscriptionDto: StopVisitTranscriptionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisitTranscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerStopVisitTranscription(visitId, stopVisitTranscriptionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows the pet owner to accept or reject an appointment scheduled by staff
         * @summary Accept or reject a scheduled appointment
         * @param {string} visitId ID of the visit to approve/reject
         * @param {VisitApprovalDto} visitApprovalDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerUpdateVisitApproval(visitId: string, visitApprovalDto: VisitApprovalDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerUpdateVisitApproval(visitId, visitApprovalDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Owner-side edit of the visit description (\"Dolegliwości\") and attached documents. Diff-based: optional description replace + documentsToAdd + documentIdsToRemove.
         * @param {string} visitId
         * @param {UpdateVisitDetailsDto} updateVisitDetailsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerUpdateVisitDetails(visitId: string, updateVisitDetailsDto: UpdateVisitDetailsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerUpdateVisitDetails(visitId, updateVisitDetailsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the visit\'s embedded profileData (name, breed, petCategory, weight, gender, dob, chipNumber). Only valid for guest visits (no linked Profile). Authed visits must use the profile update endpoints instead.
         * @summary Update guest-visit profile data (pet info) during a live visit
         * @param {string} visitId
         * @param {UpdateVisitProfileDataDto} updateVisitProfileDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerUpdateVisitProfileData(visitId: string, updateVisitProfileDataDto: UpdateVisitProfileDataDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVisitById>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerUpdateVisitProfileData(visitId, updateVisitProfileDataDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update a text note attached to a visit (identified by filename). Verifies the note belongs to this visit before updating.
         * @param {string} visitId
         * @param {string} filename
         * @param {UpdateTextNoteDto} updateTextNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerUpdateVisitTextNote(visitId: string, filename: string, updateTextNoteDto: UpdateTextNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentFileResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerUpdateVisitTextNote(visitId, filename, updateTextNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update a visit transcription segment
         * @param {string} visitId
         * @param {UpdateVisitTranscriptionSegmentDto} updateVisitTranscriptionSegmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerUpdateVisitTranscriptionSegment(visitId: string, updateVisitTranscriptionSegmentDto: UpdateVisitTranscriptionSegmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisitTranscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerUpdateVisitTranscriptionSegment(visitId, updateVisitTranscriptionSegmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the visit\'s embedded userData (firstName, lastName, email, phoneNumber). Only valid for guest visits (no linked User). Authed visits must use the user profile endpoints instead.
         * @summary Update guest-visit owner contact data during a live visit
         * @param {string} visitId
         * @param {UpdateVisitUserDataDto} updateVisitUserDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitControllerUpdateVisitUserDataByStaff(visitId: string, updateVisitUserDataDto: UpdateVisitUserDataDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVisitById>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitControllerUpdateVisitUserDataByStaff(visitId, updateVisitUserDataDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Create and immediately start a visit with no prior booking. The professional is always the caller.
         * @param {WalkInVisitDto} walkInVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitWalkInControllerStartWalkInVisit(walkInVisitDto: WalkInVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WalkInVisitResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitWalkInControllerStartWalkInVisit(walkInVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VisitApi - factory interface
 * @export
 */
export const VisitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VisitApiFp(configuration)
    return {
        /**
         *
         * @summary Abort ongoing visit
         * @param {VisitApiVisitControllerAbortVisitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerAbortVisit(requestParameters: VisitApiVisitControllerAbortVisitRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitControllerAbortVisit(requestParameters.abortVisitDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add documents to a visit. Writes to the Document collection with visitId + (optional) profileId for guest visits.
         * @param {VisitApiVisitControllerAddDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerAddDocuments(requestParameters: VisitApiVisitControllerAddDocumentsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<DocumentFileResponseDto>> {
            return localVarFp.visitControllerAddDocuments(requestParameters.visitId, requestParameters.documentFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Save patient notes as a draft, without sending them to the owner. Professional only.
         * @param {VisitApiVisitControllerAddDraftNotesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerAddDraftNotes(requestParameters: VisitApiVisitControllerAddDraftNotesRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitControllerAddDraftNotes(requestParameters.visitId, requestParameters.addDraftNotesDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add internal notes to a visit. Professional only. No notification sent to patient.
         * @param {VisitApiVisitControllerAddInternalNotesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerAddInternalNotes(requestParameters: VisitApiVisitControllerAddInternalNotesRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitControllerAddInternalNotes(requestParameters.visitId, requestParameters.addInternalNotesDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add notes to a visit. Professional only.
         * @param {VisitApiVisitControllerAddNotesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerAddNotes(requestParameters: VisitApiVisitControllerAddNotesRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitControllerAddNotes(requestParameters.visitId, requestParameters.addNotesDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add patient notes to a visit. Professional only. Sends notification to patient.
         * @param {VisitApiVisitControllerAddPatientNotesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerAddPatientNotes(requestParameters: VisitApiVisitControllerAddPatientNotesRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitControllerAddPatientNotes(requestParameters.visitId, requestParameters.addPatientNotesDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Attach visit summary PDF to profile. Professional and organization admin only.
         * @param {VisitApiVisitControllerAttachVisitSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerAttachVisitSummary(requestParameters: VisitApiVisitControllerAttachVisitSummaryRequest, options?: AxiosRequestConfig): AxiosPromise<VisitControllerAttachVisitSummary200Response> {
            return localVarFp.visitControllerAttachVisitSummary(requestParameters.visitId, requestParameters.visitControllerAttachVisitSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cancel existing visit
         * @param {VisitApiVisitControllerCancelVisitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerCancelVisit(requestParameters: VisitApiVisitControllerCancelVisitRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitControllerCancelVisit(requestParameters.visitId, requestParameters.cancelVisitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows admins, organization admins, and professionals to cancel a created visit. Professionals can only cancel their own visits.
         * @summary Cancel upcoming visit (staff)
         * @param {VisitApiVisitControllerCancelVisitByStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerCancelVisitByStaff(requestParameters: VisitApiVisitControllerCancelVisitByStaffRequest, options?: AxiosRequestConfig): AxiosPromise<GetVisitById> {
            return localVarFp.visitControllerCancelVisitByStaff(requestParameters.visitId, requestParameters.cancelStaffVisitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns basic user information if the user exists, null otherwise
         * @summary Check if user exists by email for staff scheduling
         * @param {VisitApiVisitControllerCheckUserByEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerCheckUserByEmail(requestParameters: VisitApiVisitControllerCheckUserByEmailRequest, options?: AxiosRequestConfig): AxiosPromise<VisitControllerCheckUserByEmail200Response> {
            return localVarFp.visitControllerCheckUserByEmail(requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a text note attached to a visit. Resolves profileId/organizationId from the visit (null-safe for guest visits).
         * @param {VisitApiVisitControllerCreateVisitTextNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerCreateVisitTextNote(requestParameters: VisitApiVisitControllerCreateVisitTextNoteRequest, options?: AxiosRequestConfig): AxiosPromise<Array<DocumentFileResponseDto>> {
            return localVarFp.visitControllerCreateVisitTextNote(requestParameters.visitId, requestParameters.createTextNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a visit-scoped document by filename (passed as a query param because filenames may contain slashes). Cleans up matching embeddings and any DOCUMENT/ADDED activity for the same filename. Works for both guest and authed visits.
         * @param {VisitApiVisitControllerDeleteVisitDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerDeleteVisitDocument(requestParameters: VisitApiVisitControllerDeleteVisitDocumentRequest, options?: AxiosRequestConfig): AxiosPromise<Array<DocumentFileResponseDto>> {
            return localVarFp.visitControllerDeleteVisitDocument(requestParameters.visitId, requestParameters.filename, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get users associated with a visit
         * @param {VisitApiVisitControllerFetchUserByVisitIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerFetchUserByVisitId(requestParameters: VisitApiVisitControllerFetchUserByVisitIdRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitControllerFetchUserByVisitId(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all completed and cancelled visits for all profiles assigned to the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetAllUserVisitsHistory(options?: AxiosRequestConfig): AxiosPromise<Array<GetVisitById>> {
            return localVarFp.visitControllerGetAllUserVisitsHistory(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all visits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetAllVisits(options?: AxiosRequestConfig): AxiosPromise<Array<GetVisitById>> {
            return localVarFp.visitControllerGetAllVisits(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all available time slots
         * @param {VisitApiVisitControllerGetAvailableVisitSlotsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetAvailableVisitSlots(requestParameters: VisitApiVisitControllerGetAvailableVisitSlotsRequest, options?: AxiosRequestConfig): AxiosPromise<AvailableSlotsDto> {
            return localVarFp.visitControllerGetAvailableVisitSlots(requestParameters.startDate, requestParameters.category, requestParameters.endDate, requestParameters.professionalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns visits optimized for calendar view with date range filtering. Excludes heavy data like avatars.
         * @summary Get calendar visits for organization (lightweight, no avatars)
         * @param {VisitApiVisitControllerGetCalendarVisitsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetCalendarVisits(requestParameters: VisitApiVisitControllerGetCalendarVisitsRequest, options?: AxiosRequestConfig): AxiosPromise<CalendarVisitsResponseDto> {
            return localVarFp.visitControllerGetCalendarVisits(requestParameters.organizationId, requestParameters.startDate, requestParameters.endDate, requestParameters.status, requestParameters.professionalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns visits for the current professional optimized for calendar view.
         * @summary Get calendar visits for current professional (lightweight, no avatars)
         * @param {VisitApiVisitControllerGetCalendarVisitsForProfessionalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetCalendarVisitsForProfessional(requestParameters: VisitApiVisitControllerGetCalendarVisitsForProfessionalRequest, options?: AxiosRequestConfig): AxiosPromise<CalendarVisitsResponseDto> {
            return localVarFp.visitControllerGetCalendarVisitsForProfessional(requestParameters.organizationId, requestParameters.startDate, requestParameters.endDate, requestParameters.status, requestParameters.professionalId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get current pending approval visit for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetCurrentPendingApprovalVisit(options?: AxiosRequestConfig): AxiosPromise<GetVisitById> {
            return localVarFp.visitControllerGetCurrentPendingApprovalVisit(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get pending visit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetCurrentPendingVisit(options?: AxiosRequestConfig): AxiosPromise<GetVisitById> {
            return localVarFp.visitControllerGetCurrentPendingVisit(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get professional visit history within organization
         * @param {VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetOrganizationProfessionalVisitHistory(requestParameters: VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedVisitsResponseDto> {
            return localVarFp.visitControllerGetOrganizationProfessionalVisitHistory(requestParameters.page, requestParameters.limit, requestParameters.userName, requestParameters.profileName, requestParameters.startDate, requestParameters.endDate, requestParameters.closedFrom, requestParameters.closedTo, requestParameters.noteStatuses, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get professional visit history within organization by professional id param
         * @param {VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam(requestParameters: VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParamRequest, options?: AxiosRequestConfig): AxiosPromise<PaginatedVisitsResponseDto> {
            return localVarFp.visitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam(requestParameters.professionalId, requestParameters.page, requestParameters.limit, requestParameters.userName, requestParameters.profileName, requestParameters.startDate, requestParameters.endDate, requestParameters.closedFrom, requestParameters.closedTo, requestParameters.noteStatuses, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get organization visit history
         * @param {VisitApiVisitControllerGetOrganizationVisitHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetOrganizationVisitHistory(requestParameters: VisitApiVisitControllerGetOrganizationVisitHistoryRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedVisitsResponseDto> {
            return localVarFp.visitControllerGetOrganizationVisitHistory(requestParameters.page, requestParameters.limit, requestParameters.userName, requestParameters.profileName, requestParameters.startDate, requestParameters.endDate, requestParameters.closedFrom, requestParameters.closedTo, requestParameters.noteStatuses, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Read-only activity log for a visit, accessible to the visit owner. Mirrors the org-scoped activity endpoint but validates visit ownership via req.user.id instead of an organization membership.
         * @param {VisitApiVisitControllerGetOwnerVisitActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetOwnerVisitActivity(requestParameters: VisitApiVisitControllerGetOwnerVisitActivityRequest, options?: AxiosRequestConfig): AxiosPromise<Array<VisitActivityResponseDto>> {
            return localVarFp.visitControllerGetOwnerVisitActivity(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all pending visits for professional
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetPendingProfessionalVisits(options?: AxiosRequestConfig): AxiosPromise<Array<GetVisitById>> {
            return localVarFp.visitControllerGetPendingProfessionalVisits(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns upcoming visit slots for a professional by ID, with optional limit on slots per day
         * @summary Get available visit slots for a specific professional
         * @param {VisitApiVisitControllerGetProfessionalAvailableSlotsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetProfessionalAvailableSlots(requestParameters: VisitApiVisitControllerGetProfessionalAvailableSlotsRequest, options?: AxiosRequestConfig): AxiosPromise<ProfessionalSlotsResponseDto> {
            return localVarFp.visitControllerGetProfessionalAvailableSlots(requestParameters.professionalId, requestParameters.category, requestParameters.visitType, requestParameters.slotsPerDay, requestParameters.organizationId, requestParameters.duration, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get profile visit history. Organization admin/owner/professional only.
         * @param {VisitApiVisitControllerGetProfileVisitHistoryPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetProfileVisitHistoryPreview(requestParameters: VisitApiVisitControllerGetProfileVisitHistoryPreviewRequest, options?: AxiosRequestConfig): AxiosPromise<PaginatedVisitHistoryResponseDto> {
            return localVarFp.visitControllerGetProfileVisitHistoryPreview(requestParameters.profileId, requestParameters.page, requestParameters.limit, requestParameters.startDate, requestParameters.endDate, requestParameters.closedFrom, requestParameters.closedTo, requestParameters.statuses, requestParameters.noteStatuses, requestParameters.professionalName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get today visits for a professional in an organization
         * @param {VisitApiVisitControllerGetTodaysVisitsByOrganizationAndProfessionalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetTodaysVisitsByOrganizationAndProfessionalId(requestParameters: VisitApiVisitControllerGetTodaysVisitsByOrganizationAndProfessionalIdRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetVisitById>> {
            return localVarFp.visitControllerGetTodaysVisitsByOrganizationAndProfessionalId(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get today visits for a professional by professional id param in an organization
         * @param {VisitApiVisitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParam(requestParameters: VisitApiVisitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParamRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetVisitById>> {
            return localVarFp.visitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParam(requestParameters.organizationId, requestParameters.professionalId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get organization today visits
         * @param {VisitApiVisitControllerGetTodaysVisitsByOrganizationIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetTodaysVisitsByOrganizationId(requestParameters: VisitApiVisitControllerGetTodaysVisitsByOrganizationIdRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetVisitById>> {
            return localVarFp.visitControllerGetTodaysVisitsByOrganizationId(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get upcoming visits for a profile in an organization
         * @param {VisitApiVisitControllerGetUpcomingVisitsByOrganizationAndProfileIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetUpcomingVisitsByOrganizationAndProfileId(requestParameters: VisitApiVisitControllerGetUpcomingVisitsByOrganizationAndProfileIdRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetVisitById>> {
            return localVarFp.visitControllerGetUpcomingVisitsByOrganizationAndProfileId(requestParameters.organizationId, requestParameters.profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all pet profiles belonging to the specified user
         * @summary Get all profiles for a specific user for staff scheduling
         * @param {VisitApiVisitControllerGetUserProfilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetUserProfiles(requestParameters: VisitApiVisitControllerGetUserProfilesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<VisitControllerGetUserProfiles200ResponseInner>> {
            return localVarFp.visitControllerGetUserProfiles(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get user upcoming visits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetUserUpcomingVisits(options?: AxiosRequestConfig): AxiosPromise<Array<GetVisitById>> {
            return localVarFp.visitControllerGetUserUpcomingVisits(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get visit by id
         * @param {VisitApiVisitControllerGetVisitByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitById(requestParameters: VisitApiVisitControllerGetVisitByIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetVisitById> {
            return localVarFp.visitControllerGetVisitById(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Signed URL for a file in the documents collection scoped to a visit
         * @param {VisitApiVisitControllerGetVisitFileSignedUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitFileSignedUrl(requestParameters: VisitApiVisitControllerGetVisitFileSignedUrlRequest, options?: AxiosRequestConfig): AxiosPromise<VisitControllerGetVisitFileSignedUrl200Response> {
            return localVarFp.visitControllerGetVisitFileSignedUrl(requestParameters.visitId, requestParameters.filename, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get profile visit history
         * @param {VisitApiVisitControllerGetVisitHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitHistory(requestParameters: VisitApiVisitControllerGetVisitHistoryRequest, options?: AxiosRequestConfig): AxiosPromise<PaginatedVisitHistoryResponseDto> {
            return localVarFp.visitControllerGetVisitHistory(requestParameters.profileId, requestParameters.page, requestParameters.limit, requestParameters.startDate, requestParameters.endDate, requestParameters.closedFrom, requestParameters.closedTo, requestParameters.statuses, requestParameters.noteStatuses, requestParameters.professionalName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get professional visit summary a.k.a. stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitStats(options?: AxiosRequestConfig): AxiosPromise<VisitStats> {
            return localVarFp.visitControllerGetVisitStats(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get visit summary data for PDF generation. Professional and organization admin only.
         * @param {VisitApiVisitControllerGetVisitSummaryDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitSummaryData(requestParameters: VisitApiVisitControllerGetVisitSummaryDataRequest, options?: AxiosRequestConfig): AxiosPromise<VisitSummaryDataDto> {
            return localVarFp.visitControllerGetVisitSummaryData(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get visit audio transcription
         * @param {VisitApiVisitControllerGetVisitTranscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitTranscription(requestParameters: VisitApiVisitControllerGetVisitTranscriptionRequest, options?: AxiosRequestConfig): AxiosPromise<VisitTranscriptionDto> {
            return localVarFp.visitControllerGetVisitTranscription(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all visits for a specific professional in an organization
         * @param {VisitApiVisitControllerGetVisitsByOrganizationAndProfessionalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitsByOrganizationAndProfessionalId(requestParameters: VisitApiVisitControllerGetVisitsByOrganizationAndProfessionalIdRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetVisitById>> {
            return localVarFp.visitControllerGetVisitsByOrganizationAndProfessionalId(requestParameters.organizationId, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all visits for a specific professional in an organization
         * @param {VisitApiVisitControllerGetVisitsByOrganizationAndProfessionalIdParamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitsByOrganizationAndProfessionalIdParam(requestParameters: VisitApiVisitControllerGetVisitsByOrganizationAndProfessionalIdParamRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetVisitById>> {
            return localVarFp.visitControllerGetVisitsByOrganizationAndProfessionalIdParam(requestParameters.organizationId, requestParameters.professionalId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all visits for a specific organization
         * @param {VisitApiVisitControllerGetVisitsByOrganizationIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerGetVisitsByOrganizationId(requestParameters: VisitApiVisitControllerGetVisitsByOrganizationIdRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetVisitById>> {
            return localVarFp.visitControllerGetVisitsByOrganizationId(requestParameters.organizationId, requestParameters.status, requestParameters.professionalId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all documents attached to a visit (from the Document collection, keyed by visitId). Works for both guest and authed visits.
         * @param {VisitApiVisitControllerListVisitDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerListVisitDocuments(requestParameters: VisitApiVisitControllerListVisitDocumentsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<DocumentFileResponseDto>> {
            return localVarFp.visitControllerListVisitDocuments(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Rate visit after completed.
         * @param {VisitApiVisitControllerRateVisitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerRateVisit(requestParameters: VisitApiVisitControllerRateVisitRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitControllerRateVisit(requestParameters.visitId, requestParameters.rateVisitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows admins and organization admins to reassign a created visit to a different professional
         * @summary Reassign upcoming visit to another professional within organization
         * @param {VisitApiVisitControllerReassignVisitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerReassignVisit(requestParameters: VisitApiVisitControllerReassignVisitRequest, options?: AxiosRequestConfig): AxiosPromise<GetVisitById> {
            return localVarFp.visitControllerReassignVisit(requestParameters.visitId, requestParameters.reassignVisitDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reschedule existing visit
         * @param {VisitApiVisitControllerRescheduleVisitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerRescheduleVisit(requestParameters: VisitApiVisitControllerRescheduleVisitRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitControllerRescheduleVisit(requestParameters.rescheduleVisitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows admins, organization admins, and professionals to reschedule a created visit. Professionals can only reschedule their own visits.
         * @summary Reschedule upcoming visit to another time (staff)
         * @param {VisitApiVisitControllerRescheduleVisitByStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerRescheduleVisitByStaff(requestParameters: VisitApiVisitControllerRescheduleVisitByStaffRequest, options?: AxiosRequestConfig): AxiosPromise<GetVisitById> {
            return localVarFp.visitControllerRescheduleVisitByStaff(requestParameters.visitId, requestParameters.rescheduleStaffVisitDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Schedule a new visit by staff (professional or admin)
         * @param {VisitApiVisitControllerScheduleStaffVisitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerScheduleStaffVisit(requestParameters: VisitApiVisitControllerScheduleStaffVisitRequest, options?: AxiosRequestConfig): AxiosPromise<StaffScheduleVisitResponseDto> {
            return localVarFp.visitControllerScheduleStaffVisit(requestParameters.staffScheduleVisitDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Schedule a new visit
         * @param {VisitApiVisitControllerScheduleVisitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerScheduleVisit(requestParameters: VisitApiVisitControllerScheduleVisitRequest, options?: AxiosRequestConfig): AxiosPromise<ScheduleVisitResponseDto> {
            return localVarFp.visitControllerScheduleVisit(requestParameters.scheduleVisitDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Send a visit\'s draft notes to the owner. Any member of the organisation that owns the visit may finish a draft.
         * @param {VisitApiVisitControllerSendDraftNotesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerSendDraftNotes(requestParameters: VisitApiVisitControllerSendDraftNotesRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitControllerSendDraftNotes(requestParameters.visitId, requestParameters.addPatientNotesDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Start live audio transcription for a visit
         * @param {VisitApiVisitControllerStartVisitTranscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerStartVisitTranscription(requestParameters: VisitApiVisitControllerStartVisitTranscriptionRequest, options?: AxiosRequestConfig): AxiosPromise<StartVisitTranscriptionResponseDto> {
            return localVarFp.visitControllerStartVisitTranscription(requestParameters.visitId, requestParameters.startVisitTranscriptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Stop live audio transcription for a visit
         * @param {VisitApiVisitControllerStopVisitTranscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerStopVisitTranscription(requestParameters: VisitApiVisitControllerStopVisitTranscriptionRequest, options?: AxiosRequestConfig): AxiosPromise<VisitTranscriptionDto> {
            return localVarFp.visitControllerStopVisitTranscription(requestParameters.visitId, requestParameters.stopVisitTranscriptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows the pet owner to accept or reject an appointment scheduled by staff
         * @summary Accept or reject a scheduled appointment
         * @param {VisitApiVisitControllerUpdateVisitApprovalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerUpdateVisitApproval(requestParameters: VisitApiVisitControllerUpdateVisitApprovalRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitControllerUpdateVisitApproval(requestParameters.visitId, requestParameters.visitApprovalDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Owner-side edit of the visit description (\"Dolegliwości\") and attached documents. Diff-based: optional description replace + documentsToAdd + documentIdsToRemove.
         * @param {VisitApiVisitControllerUpdateVisitDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerUpdateVisitDetails(requestParameters: VisitApiVisitControllerUpdateVisitDetailsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitControllerUpdateVisitDetails(requestParameters.visitId, requestParameters.updateVisitDetailsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the visit\'s embedded profileData (name, breed, petCategory, weight, gender, dob, chipNumber). Only valid for guest visits (no linked Profile). Authed visits must use the profile update endpoints instead.
         * @summary Update guest-visit profile data (pet info) during a live visit
         * @param {VisitApiVisitControllerUpdateVisitProfileDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerUpdateVisitProfileData(requestParameters: VisitApiVisitControllerUpdateVisitProfileDataRequest, options?: AxiosRequestConfig): AxiosPromise<GetVisitById> {
            return localVarFp.visitControllerUpdateVisitProfileData(requestParameters.visitId, requestParameters.updateVisitProfileDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a text note attached to a visit (identified by filename). Verifies the note belongs to this visit before updating.
         * @param {VisitApiVisitControllerUpdateVisitTextNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerUpdateVisitTextNote(requestParameters: VisitApiVisitControllerUpdateVisitTextNoteRequest, options?: AxiosRequestConfig): AxiosPromise<Array<DocumentFileResponseDto>> {
            return localVarFp.visitControllerUpdateVisitTextNote(requestParameters.visitId, requestParameters.filename, requestParameters.updateTextNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a visit transcription segment
         * @param {VisitApiVisitControllerUpdateVisitTranscriptionSegmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerUpdateVisitTranscriptionSegment(requestParameters: VisitApiVisitControllerUpdateVisitTranscriptionSegmentRequest, options?: AxiosRequestConfig): AxiosPromise<VisitTranscriptionDto> {
            return localVarFp.visitControllerUpdateVisitTranscriptionSegment(requestParameters.visitId, requestParameters.updateVisitTranscriptionSegmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the visit\'s embedded userData (firstName, lastName, email, phoneNumber). Only valid for guest visits (no linked User). Authed visits must use the user profile endpoints instead.
         * @summary Update guest-visit owner contact data during a live visit
         * @param {VisitApiVisitControllerUpdateVisitUserDataByStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitControllerUpdateVisitUserDataByStaff(requestParameters: VisitApiVisitControllerUpdateVisitUserDataByStaffRequest, options?: AxiosRequestConfig): AxiosPromise<GetVisitById> {
            return localVarFp.visitControllerUpdateVisitUserDataByStaff(requestParameters.visitId, requestParameters.updateVisitUserDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create and immediately start a visit with no prior booking. The professional is always the caller.
         * @param {VisitApiVisitWalkInControllerStartWalkInVisitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitWalkInControllerStartWalkInVisit(requestParameters: VisitApiVisitWalkInControllerStartWalkInVisitRequest, options?: AxiosRequestConfig): AxiosPromise<WalkInVisitResponseDto> {
            return localVarFp.visitWalkInControllerStartWalkInVisit(requestParameters.walkInVisitDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for visitControllerAbortVisit operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerAbortVisitRequest
 */
export interface VisitApiVisitControllerAbortVisitRequest {
    /**
     *
     * @type {AbortVisitDto}
     * @memberof VisitApiVisitControllerAbortVisit
     */
    readonly abortVisitDto: AbortVisitDto
}

/**
 * Request parameters for visitControllerAddDocuments operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerAddDocumentsRequest
 */
export interface VisitApiVisitControllerAddDocumentsRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerAddDocuments
     */
    readonly visitId: string

    /**
     *
     * @type {Array<DocumentFileDto>}
     * @memberof VisitApiVisitControllerAddDocuments
     */
    readonly documentFileDto: Array<DocumentFileDto>
}

/**
 * Request parameters for visitControllerAddDraftNotes operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerAddDraftNotesRequest
 */
export interface VisitApiVisitControllerAddDraftNotesRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerAddDraftNotes
     */
    readonly visitId: string

    /**
     *
     * @type {AddDraftNotesDto}
     * @memberof VisitApiVisitControllerAddDraftNotes
     */
    readonly addDraftNotesDto: AddDraftNotesDto
}

/**
 * Request parameters for visitControllerAddInternalNotes operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerAddInternalNotesRequest
 */
export interface VisitApiVisitControllerAddInternalNotesRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerAddInternalNotes
     */
    readonly visitId: string

    /**
     *
     * @type {AddInternalNotesDto}
     * @memberof VisitApiVisitControllerAddInternalNotes
     */
    readonly addInternalNotesDto: AddInternalNotesDto
}

/**
 * Request parameters for visitControllerAddNotes operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerAddNotesRequest
 */
export interface VisitApiVisitControllerAddNotesRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerAddNotes
     */
    readonly visitId: string

    /**
     *
     * @type {AddNotesDto}
     * @memberof VisitApiVisitControllerAddNotes
     */
    readonly addNotesDto: AddNotesDto
}

/**
 * Request parameters for visitControllerAddPatientNotes operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerAddPatientNotesRequest
 */
export interface VisitApiVisitControllerAddPatientNotesRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerAddPatientNotes
     */
    readonly visitId: string

    /**
     *
     * @type {AddPatientNotesDto}
     * @memberof VisitApiVisitControllerAddPatientNotes
     */
    readonly addPatientNotesDto: AddPatientNotesDto
}

/**
 * Request parameters for visitControllerAttachVisitSummary operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerAttachVisitSummaryRequest
 */
export interface VisitApiVisitControllerAttachVisitSummaryRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerAttachVisitSummary
     */
    readonly visitId: string

    /**
     *
     * @type {VisitControllerAttachVisitSummaryRequest}
     * @memberof VisitApiVisitControllerAttachVisitSummary
     */
    readonly visitControllerAttachVisitSummaryRequest: VisitControllerAttachVisitSummaryRequest
}

/**
 * Request parameters for visitControllerCancelVisit operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerCancelVisitRequest
 */
export interface VisitApiVisitControllerCancelVisitRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerCancelVisit
     */
    readonly visitId: string

    /**
     *
     * @type {CancelVisitDto}
     * @memberof VisitApiVisitControllerCancelVisit
     */
    readonly cancelVisitDto: CancelVisitDto
}

/**
 * Request parameters for visitControllerCancelVisitByStaff operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerCancelVisitByStaffRequest
 */
export interface VisitApiVisitControllerCancelVisitByStaffRequest {
    /**
     * ID of the visit to cancel
     * @type {string}
     * @memberof VisitApiVisitControllerCancelVisitByStaff
     */
    readonly visitId: string

    /**
     *
     * @type {CancelStaffVisitDto}
     * @memberof VisitApiVisitControllerCancelVisitByStaff
     */
    readonly cancelStaffVisitDto: CancelStaffVisitDto
}

/**
 * Request parameters for visitControllerCheckUserByEmail operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerCheckUserByEmailRequest
 */
export interface VisitApiVisitControllerCheckUserByEmailRequest {
    /**
     * Email address to check
     * @type {string}
     * @memberof VisitApiVisitControllerCheckUserByEmail
     */
    readonly email: string
}

/**
 * Request parameters for visitControllerCreateVisitTextNote operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerCreateVisitTextNoteRequest
 */
export interface VisitApiVisitControllerCreateVisitTextNoteRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerCreateVisitTextNote
     */
    readonly visitId: string

    /**
     *
     * @type {CreateTextNoteDto}
     * @memberof VisitApiVisitControllerCreateVisitTextNote
     */
    readonly createTextNoteDto: CreateTextNoteDto
}

/**
 * Request parameters for visitControllerDeleteVisitDocument operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerDeleteVisitDocumentRequest
 */
export interface VisitApiVisitControllerDeleteVisitDocumentRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerDeleteVisitDocument
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerDeleteVisitDocument
     */
    readonly filename: string
}

/**
 * Request parameters for visitControllerFetchUserByVisitId operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerFetchUserByVisitIdRequest
 */
export interface VisitApiVisitControllerFetchUserByVisitIdRequest {
    /**
     * Visit ID
     * @type {string}
     * @memberof VisitApiVisitControllerFetchUserByVisitId
     */
    readonly visitId: string
}

/**
 * Request parameters for visitControllerGetAvailableVisitSlots operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetAvailableVisitSlotsRequest
 */
export interface VisitApiVisitControllerGetAvailableVisitSlotsRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerGetAvailableVisitSlots
     */
    readonly startDate: string

    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerGetAvailableVisitSlots
     */
    readonly category: string

    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerGetAvailableVisitSlots
     */
    readonly endDate: string

    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerGetAvailableVisitSlots
     */
    readonly professionalId: string
}

/**
 * Request parameters for visitControllerGetCalendarVisits operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetCalendarVisitsRequest
 */
export interface VisitApiVisitControllerGetCalendarVisitsRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetCalendarVisits
     */
    readonly organizationId: string

    /**
     * Start date for filtering (ISO string)
     * @type {string}
     * @memberof VisitApiVisitControllerGetCalendarVisits
     */
    readonly startDate?: string

    /**
     * End date for filtering (ISO string)
     * @type {string}
     * @memberof VisitApiVisitControllerGetCalendarVisits
     */
    readonly endDate?: string

    /**
     * Filter by visit status
     * @type {'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED'}
     * @memberof VisitApiVisitControllerGetCalendarVisits
     */
    readonly status?: 'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED'

    /**
     * Filter by professional ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetCalendarVisits
     */
    readonly professionalId?: string
}

/**
 * Request parameters for visitControllerGetCalendarVisitsForProfessional operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetCalendarVisitsForProfessionalRequest
 */
export interface VisitApiVisitControllerGetCalendarVisitsForProfessionalRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetCalendarVisitsForProfessional
     */
    readonly organizationId: string

    /**
     * Start date for filtering (ISO string)
     * @type {string}
     * @memberof VisitApiVisitControllerGetCalendarVisitsForProfessional
     */
    readonly startDate?: string

    /**
     * End date for filtering (ISO string)
     * @type {string}
     * @memberof VisitApiVisitControllerGetCalendarVisitsForProfessional
     */
    readonly endDate?: string

    /**
     * Filter by visit status
     * @type {'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED'}
     * @memberof VisitApiVisitControllerGetCalendarVisitsForProfessional
     */
    readonly status?: 'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED'

    /**
     * Filter by professional ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetCalendarVisitsForProfessional
     */
    readonly professionalId?: string
}

/**
 * Request parameters for visitControllerGetOrganizationProfessionalVisitHistory operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryRequest
 */
export interface VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryRequest {
    /**
     * Page number (0-indexed)
     * @type {number}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistory
     */
    readonly page?: number

    /**
     * Number of items per page
     * @type {number}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistory
     */
    readonly limit?: number

    /**
     * Filter by user name (first or last name)
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistory
     */
    readonly userName?: string

    /**
     * Filter by profile name (pet name)
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistory
     */
    readonly profileName?: string

    /**
     * Filter by start date (ISO 8601)
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistory
     */
    readonly startDate?: string

    /**
     * Filter by end date (ISO 8601)
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistory
     */
    readonly endDate?: string

    /**
     * Only visits closed on or after this Europe/Warsaw calendar day (YYYY-MM-DD). Inclusive. Legacy ISO 8601 timestamps are interpreted by their Warsaw date. Closure is when the visit reached a terminal status, which is not the day it was booked for — &#x60;startDate&#x60;/&#x60;endDate&#x60; still filter that.
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistory
     */
    readonly closedFrom?: string

    /**
     * Only visits closed on or before this Europe/Warsaw calendar day (YYYY-MM-DD). Includes the entire local day, accounting for daylight saving time. Legacy ISO 8601 timestamps are interpreted by their Warsaw date.
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistory
     */
    readonly closedTo?: string

    /**
     * Comma-separated note states to keep: SENT (a note the owner has), DRAFT (an unsent draft), NONE (neither). Omit for all of them. Implies COMPLETED/ABORTED — a cancelled visit has no note state.
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistory
     */
    readonly noteStatuses?: string
}

/**
 * Request parameters for visitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParamRequest
 */
export interface VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParamRequest {
    /**
     * Professional ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam
     */
    readonly professionalId: string

    /**
     * Page number (0-indexed)
     * @type {number}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam
     */
    readonly page?: number

    /**
     * Number of items per page
     * @type {number}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam
     */
    readonly limit?: number

    /**
     * Filter by user name (first or last name)
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam
     */
    readonly userName?: string

    /**
     * Filter by profile name (pet name)
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam
     */
    readonly profileName?: string

    /**
     * Filter by start date (ISO 8601)
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam
     */
    readonly startDate?: string

    /**
     * Filter by end date (ISO 8601)
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam
     */
    readonly endDate?: string

    /**
     * Only visits closed on or after this Europe/Warsaw calendar day (YYYY-MM-DD). Inclusive. Legacy ISO 8601 timestamps are interpreted by their Warsaw date. Closure is when the visit reached a terminal status, which is not the day it was booked for — &#x60;startDate&#x60;/&#x60;endDate&#x60; still filter that.
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam
     */
    readonly closedFrom?: string

    /**
     * Only visits closed on or before this Europe/Warsaw calendar day (YYYY-MM-DD). Includes the entire local day, accounting for daylight saving time. Legacy ISO 8601 timestamps are interpreted by their Warsaw date.
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam
     */
    readonly closedTo?: string

    /**
     * Comma-separated note states to keep: SENT (a note the owner has), DRAFT (an unsent draft), NONE (neither). Omit for all of them. Implies COMPLETED/ABORTED — a cancelled visit has no note state.
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam
     */
    readonly noteStatuses?: string
}

/**
 * Request parameters for visitControllerGetOrganizationVisitHistory operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetOrganizationVisitHistoryRequest
 */
export interface VisitApiVisitControllerGetOrganizationVisitHistoryRequest {
    /**
     * Page number (0-indexed)
     * @type {number}
     * @memberof VisitApiVisitControllerGetOrganizationVisitHistory
     */
    readonly page?: number

    /**
     * Number of items per page
     * @type {number}
     * @memberof VisitApiVisitControllerGetOrganizationVisitHistory
     */
    readonly limit?: number

    /**
     * Filter by user name (first or last name)
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationVisitHistory
     */
    readonly userName?: string

    /**
     * Filter by profile name (pet name)
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationVisitHistory
     */
    readonly profileName?: string

    /**
     * Filter by start date (ISO 8601)
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationVisitHistory
     */
    readonly startDate?: string

    /**
     * Filter by end date (ISO 8601)
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationVisitHistory
     */
    readonly endDate?: string

    /**
     * Only visits closed on or after this Europe/Warsaw calendar day (YYYY-MM-DD). Inclusive. Legacy ISO 8601 timestamps are interpreted by their Warsaw date. Closure is when the visit reached a terminal status, which is not the day it was booked for — &#x60;startDate&#x60;/&#x60;endDate&#x60; still filter that.
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationVisitHistory
     */
    readonly closedFrom?: string

    /**
     * Only visits closed on or before this Europe/Warsaw calendar day (YYYY-MM-DD). Includes the entire local day, accounting for daylight saving time. Legacy ISO 8601 timestamps are interpreted by their Warsaw date.
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationVisitHistory
     */
    readonly closedTo?: string

    /**
     * Comma-separated note states to keep: SENT (a note the owner has), DRAFT (an unsent draft), NONE (neither). Omit for all of them. Implies COMPLETED/ABORTED — a cancelled visit has no note state.
     * @type {string}
     * @memberof VisitApiVisitControllerGetOrganizationVisitHistory
     */
    readonly noteStatuses?: string
}

/**
 * Request parameters for visitControllerGetOwnerVisitActivity operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetOwnerVisitActivityRequest
 */
export interface VisitApiVisitControllerGetOwnerVisitActivityRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerGetOwnerVisitActivity
     */
    readonly visitId: string
}

/**
 * Request parameters for visitControllerGetProfessionalAvailableSlots operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetProfessionalAvailableSlotsRequest
 */
export interface VisitApiVisitControllerGetProfessionalAvailableSlotsRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerGetProfessionalAvailableSlots
     */
    readonly professionalId: string

    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerGetProfessionalAvailableSlots
     */
    readonly category: string

    /**
     * Visit mode required for the availability window
     * @type {'video' | 'chat' | 'onsite' | 'mobile'}
     * @memberof VisitApiVisitControllerGetProfessionalAvailableSlots
     */
    readonly visitType?: 'video' | 'chat' | 'onsite' | 'mobile'

    /**
     * Maximum number of slots to return per day
     * @type {number}
     * @memberof VisitApiVisitControllerGetProfessionalAvailableSlots
     */
    readonly slotsPerDay?: number

    /**
     * Organization ID to get professional availability from
     * @type {string}
     * @memberof VisitApiVisitControllerGetProfessionalAvailableSlots
     */
    readonly organizationId?: string

    /**
     * Custom duration in minutes (overrides category default duration)
     * @type {number}
     * @memberof VisitApiVisitControllerGetProfessionalAvailableSlots
     */
    readonly duration?: number

    /**
     * Earliest start date/time to consider for slots (ISO string). Defaults to now.
     * @type {string}
     * @memberof VisitApiVisitControllerGetProfessionalAvailableSlots
     */
    readonly startDate?: string
}

/**
 * Request parameters for visitControllerGetProfileVisitHistoryPreview operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetProfileVisitHistoryPreviewRequest
 */
export interface VisitApiVisitControllerGetProfileVisitHistoryPreviewRequest {
    /**
     * Profile ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetProfileVisitHistoryPreview
     */
    readonly profileId: string

    /**
     * Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
     * @type {number}
     * @memberof VisitApiVisitControllerGetProfileVisitHistoryPreview
     */
    readonly page?: number

    /**
     * Rows per page. Omit together with &#x60;page&#x60; to get every row.
     * @type {number}
     * @memberof VisitApiVisitControllerGetProfileVisitHistoryPreview
     */
    readonly limit?: number

    /**
     * Only visits on or after this day (ISO 8601). Inclusive.
     * @type {string}
     * @memberof VisitApiVisitControllerGetProfileVisitHistoryPreview
     */
    readonly startDate?: string

    /**
     * Only visits on or before this day (ISO 8601). Inclusive.
     * @type {string}
     * @memberof VisitApiVisitControllerGetProfileVisitHistoryPreview
     */
    readonly endDate?: string

    /**
     * Only visits closed on or after this Europe/Warsaw calendar day (YYYY-MM-DD). Inclusive. Legacy ISO 8601 timestamps are interpreted by their Warsaw date. Closure is when the visit reached a terminal status, which is not the day it was booked for — &#x60;startDate&#x60;/&#x60;endDate&#x60; still filter that.
     * @type {string}
     * @memberof VisitApiVisitControllerGetProfileVisitHistoryPreview
     */
    readonly closedFrom?: string

    /**
     * Only visits closed on or before this Europe/Warsaw calendar day (YYYY-MM-DD). Includes the entire local day, accounting for daylight saving time. Legacy ISO 8601 timestamps are interpreted by their Warsaw date.
     * @type {string}
     * @memberof VisitApiVisitControllerGetProfileVisitHistoryPreview
     */
    readonly closedTo?: string

    /**
     * Comma-separated visit statuses to keep, e.g. &#x60;COMPLETED,CANCELLED&#x60;. Narrows the finished/cancelled/aborted set the history already shows — it can never widen it. Omit for all three.
     * @type {string}
     * @memberof VisitApiVisitControllerGetProfileVisitHistoryPreview
     */
    readonly statuses?: string

    /**
     * Comma-separated note states to keep: SENT, DRAFT, NONE. Omit for all of them. Selecting any also implies COMPLETED/ABORTED, since a cancelled visit has no note state.
     * @type {string}
     * @memberof VisitApiVisitControllerGetProfileVisitHistoryPreview
     */
    readonly noteStatuses?: string

    /**
     * Only visits whose professional\&#39;s first and last name contain this text, case-insensitive. Matched against the two joined with a space, so &#x60;jan kow&#x60; matches Jan Kowalski.
     * @type {string}
     * @memberof VisitApiVisitControllerGetProfileVisitHistoryPreview
     */
    readonly professionalName?: string
}

/**
 * Request parameters for visitControllerGetTodaysVisitsByOrganizationAndProfessionalId operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetTodaysVisitsByOrganizationAndProfessionalIdRequest
 */
export interface VisitApiVisitControllerGetTodaysVisitsByOrganizationAndProfessionalIdRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetTodaysVisitsByOrganizationAndProfessionalId
     */
    readonly organizationId: string
}

/**
 * Request parameters for visitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParam operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParamRequest
 */
export interface VisitApiVisitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParamRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParam
     */
    readonly organizationId: string

    /**
     * Professional ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParam
     */
    readonly professionalId: string
}

/**
 * Request parameters for visitControllerGetTodaysVisitsByOrganizationId operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetTodaysVisitsByOrganizationIdRequest
 */
export interface VisitApiVisitControllerGetTodaysVisitsByOrganizationIdRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetTodaysVisitsByOrganizationId
     */
    readonly organizationId: string
}

/**
 * Request parameters for visitControllerGetUpcomingVisitsByOrganizationAndProfileId operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetUpcomingVisitsByOrganizationAndProfileIdRequest
 */
export interface VisitApiVisitControllerGetUpcomingVisitsByOrganizationAndProfileIdRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetUpcomingVisitsByOrganizationAndProfileId
     */
    readonly organizationId: string

    /**
     * Profile ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetUpcomingVisitsByOrganizationAndProfileId
     */
    readonly profileId: string
}

/**
 * Request parameters for visitControllerGetUserProfiles operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetUserProfilesRequest
 */
export interface VisitApiVisitControllerGetUserProfilesRequest {
    /**
     * User ID to get profiles for
     * @type {string}
     * @memberof VisitApiVisitControllerGetUserProfiles
     */
    readonly userId: string
}

/**
 * Request parameters for visitControllerGetVisitById operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetVisitByIdRequest
 */
export interface VisitApiVisitControllerGetVisitByIdRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitById
     */
    readonly visitId: string
}

/**
 * Request parameters for visitControllerGetVisitFileSignedUrl operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetVisitFileSignedUrlRequest
 */
export interface VisitApiVisitControllerGetVisitFileSignedUrlRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitFileSignedUrl
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitFileSignedUrl
     */
    readonly filename: string
}

/**
 * Request parameters for visitControllerGetVisitHistory operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetVisitHistoryRequest
 */
export interface VisitApiVisitControllerGetVisitHistoryRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitHistory
     */
    readonly profileId: string

    /**
     * Page number (0-indexed). Omit together with &#x60;limit&#x60; to get every row.
     * @type {number}
     * @memberof VisitApiVisitControllerGetVisitHistory
     */
    readonly page?: number

    /**
     * Rows per page. Omit together with &#x60;page&#x60; to get every row.
     * @type {number}
     * @memberof VisitApiVisitControllerGetVisitHistory
     */
    readonly limit?: number

    /**
     * Only visits on or after this day (ISO 8601). Inclusive.
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitHistory
     */
    readonly startDate?: string

    /**
     * Only visits on or before this day (ISO 8601). Inclusive.
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitHistory
     */
    readonly endDate?: string

    /**
     * Only visits closed on or after this Europe/Warsaw calendar day (YYYY-MM-DD). Inclusive. Legacy ISO 8601 timestamps are interpreted by their Warsaw date. Closure is when the visit reached a terminal status, which is not the day it was booked for — &#x60;startDate&#x60;/&#x60;endDate&#x60; still filter that.
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitHistory
     */
    readonly closedFrom?: string

    /**
     * Only visits closed on or before this Europe/Warsaw calendar day (YYYY-MM-DD). Includes the entire local day, accounting for daylight saving time. Legacy ISO 8601 timestamps are interpreted by their Warsaw date.
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitHistory
     */
    readonly closedTo?: string

    /**
     * Comma-separated visit statuses to keep, e.g. &#x60;COMPLETED,CANCELLED&#x60;. Narrows the finished/cancelled/aborted set the history already shows — it can never widen it. Omit for all three.
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitHistory
     */
    readonly statuses?: string

    /**
     * Comma-separated note states to keep: SENT, DRAFT, NONE. Omit for all of them. Selecting any also implies COMPLETED/ABORTED, since a cancelled visit has no note state.
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitHistory
     */
    readonly noteStatuses?: string

    /**
     * Only visits whose professional\&#39;s first and last name contain this text, case-insensitive. Matched against the two joined with a space, so &#x60;jan kow&#x60; matches Jan Kowalski.
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitHistory
     */
    readonly professionalName?: string
}

/**
 * Request parameters for visitControllerGetVisitSummaryData operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetVisitSummaryDataRequest
 */
export interface VisitApiVisitControllerGetVisitSummaryDataRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitSummaryData
     */
    readonly visitId: string
}

/**
 * Request parameters for visitControllerGetVisitTranscription operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetVisitTranscriptionRequest
 */
export interface VisitApiVisitControllerGetVisitTranscriptionRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitTranscription
     */
    readonly visitId: string
}

/**
 * Request parameters for visitControllerGetVisitsByOrganizationAndProfessionalId operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetVisitsByOrganizationAndProfessionalIdRequest
 */
export interface VisitApiVisitControllerGetVisitsByOrganizationAndProfessionalIdRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitsByOrganizationAndProfessionalId
     */
    readonly organizationId: string

    /**
     * Filter by visit status
     * @type {'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED'}
     * @memberof VisitApiVisitControllerGetVisitsByOrganizationAndProfessionalId
     */
    readonly status?: 'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED'
}

/**
 * Request parameters for visitControllerGetVisitsByOrganizationAndProfessionalIdParam operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetVisitsByOrganizationAndProfessionalIdParamRequest
 */
export interface VisitApiVisitControllerGetVisitsByOrganizationAndProfessionalIdParamRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitsByOrganizationAndProfessionalIdParam
     */
    readonly organizationId: string

    /**
     * Professional ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitsByOrganizationAndProfessionalIdParam
     */
    readonly professionalId: string
}

/**
 * Request parameters for visitControllerGetVisitsByOrganizationId operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerGetVisitsByOrganizationIdRequest
 */
export interface VisitApiVisitControllerGetVisitsByOrganizationIdRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitsByOrganizationId
     */
    readonly organizationId: string

    /**
     * Filter by visit status
     * @type {'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED'}
     * @memberof VisitApiVisitControllerGetVisitsByOrganizationId
     */
    readonly status?: 'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PENDING_APPROVAL' | 'ACCEPTED' | 'REJECTED' | 'ABORTED'

    /**
     * Filter by professional ID
     * @type {string}
     * @memberof VisitApiVisitControllerGetVisitsByOrganizationId
     */
    readonly professionalId?: string
}

/**
 * Request parameters for visitControllerListVisitDocuments operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerListVisitDocumentsRequest
 */
export interface VisitApiVisitControllerListVisitDocumentsRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerListVisitDocuments
     */
    readonly visitId: string
}

/**
 * Request parameters for visitControllerRateVisit operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerRateVisitRequest
 */
export interface VisitApiVisitControllerRateVisitRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerRateVisit
     */
    readonly visitId: string

    /**
     *
     * @type {RateVisitDto}
     * @memberof VisitApiVisitControllerRateVisit
     */
    readonly rateVisitDto: RateVisitDto
}

/**
 * Request parameters for visitControllerReassignVisit operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerReassignVisitRequest
 */
export interface VisitApiVisitControllerReassignVisitRequest {
    /**
     * ID of the visit to reassign
     * @type {string}
     * @memberof VisitApiVisitControllerReassignVisit
     */
    readonly visitId: string

    /**
     *
     * @type {ReassignVisitDto}
     * @memberof VisitApiVisitControllerReassignVisit
     */
    readonly reassignVisitDto: ReassignVisitDto
}

/**
 * Request parameters for visitControllerRescheduleVisit operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerRescheduleVisitRequest
 */
export interface VisitApiVisitControllerRescheduleVisitRequest {
    /**
     *
     * @type {RescheduleVisitDto}
     * @memberof VisitApiVisitControllerRescheduleVisit
     */
    readonly rescheduleVisitDto: RescheduleVisitDto
}

/**
 * Request parameters for visitControllerRescheduleVisitByStaff operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerRescheduleVisitByStaffRequest
 */
export interface VisitApiVisitControllerRescheduleVisitByStaffRequest {
    /**
     * ID of the visit to reschedule
     * @type {string}
     * @memberof VisitApiVisitControllerRescheduleVisitByStaff
     */
    readonly visitId: string

    /**
     *
     * @type {RescheduleStaffVisitDto}
     * @memberof VisitApiVisitControllerRescheduleVisitByStaff
     */
    readonly rescheduleStaffVisitDto: RescheduleStaffVisitDto
}

/**
 * Request parameters for visitControllerScheduleStaffVisit operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerScheduleStaffVisitRequest
 */
export interface VisitApiVisitControllerScheduleStaffVisitRequest {
    /**
     *
     * @type {StaffScheduleVisitDto}
     * @memberof VisitApiVisitControllerScheduleStaffVisit
     */
    readonly staffScheduleVisitDto: StaffScheduleVisitDto
}

/**
 * Request parameters for visitControllerScheduleVisit operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerScheduleVisitRequest
 */
export interface VisitApiVisitControllerScheduleVisitRequest {
    /**
     *
     * @type {ScheduleVisitDto}
     * @memberof VisitApiVisitControllerScheduleVisit
     */
    readonly scheduleVisitDto: ScheduleVisitDto
}

/**
 * Request parameters for visitControllerSendDraftNotes operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerSendDraftNotesRequest
 */
export interface VisitApiVisitControllerSendDraftNotesRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerSendDraftNotes
     */
    readonly visitId: string

    /**
     *
     * @type {AddPatientNotesDto}
     * @memberof VisitApiVisitControllerSendDraftNotes
     */
    readonly addPatientNotesDto: AddPatientNotesDto
}

/**
 * Request parameters for visitControllerStartVisitTranscription operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerStartVisitTranscriptionRequest
 */
export interface VisitApiVisitControllerStartVisitTranscriptionRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerStartVisitTranscription
     */
    readonly visitId: string

    /**
     *
     * @type {StartVisitTranscriptionDto}
     * @memberof VisitApiVisitControllerStartVisitTranscription
     */
    readonly startVisitTranscriptionDto: StartVisitTranscriptionDto
}

/**
 * Request parameters for visitControllerStopVisitTranscription operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerStopVisitTranscriptionRequest
 */
export interface VisitApiVisitControllerStopVisitTranscriptionRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerStopVisitTranscription
     */
    readonly visitId: string

    /**
     *
     * @type {StopVisitTranscriptionDto}
     * @memberof VisitApiVisitControllerStopVisitTranscription
     */
    readonly stopVisitTranscriptionDto: StopVisitTranscriptionDto
}

/**
 * Request parameters for visitControllerUpdateVisitApproval operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerUpdateVisitApprovalRequest
 */
export interface VisitApiVisitControllerUpdateVisitApprovalRequest {
    /**
     * ID of the visit to approve/reject
     * @type {string}
     * @memberof VisitApiVisitControllerUpdateVisitApproval
     */
    readonly visitId: string

    /**
     *
     * @type {VisitApprovalDto}
     * @memberof VisitApiVisitControllerUpdateVisitApproval
     */
    readonly visitApprovalDto: VisitApprovalDto
}

/**
 * Request parameters for visitControllerUpdateVisitDetails operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerUpdateVisitDetailsRequest
 */
export interface VisitApiVisitControllerUpdateVisitDetailsRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerUpdateVisitDetails
     */
    readonly visitId: string

    /**
     *
     * @type {UpdateVisitDetailsDto}
     * @memberof VisitApiVisitControllerUpdateVisitDetails
     */
    readonly updateVisitDetailsDto: UpdateVisitDetailsDto
}

/**
 * Request parameters for visitControllerUpdateVisitProfileData operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerUpdateVisitProfileDataRequest
 */
export interface VisitApiVisitControllerUpdateVisitProfileDataRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerUpdateVisitProfileData
     */
    readonly visitId: string

    /**
     *
     * @type {UpdateVisitProfileDataDto}
     * @memberof VisitApiVisitControllerUpdateVisitProfileData
     */
    readonly updateVisitProfileDataDto: UpdateVisitProfileDataDto
}

/**
 * Request parameters for visitControllerUpdateVisitTextNote operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerUpdateVisitTextNoteRequest
 */
export interface VisitApiVisitControllerUpdateVisitTextNoteRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerUpdateVisitTextNote
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerUpdateVisitTextNote
     */
    readonly filename: string

    /**
     *
     * @type {UpdateTextNoteDto}
     * @memberof VisitApiVisitControllerUpdateVisitTextNote
     */
    readonly updateTextNoteDto: UpdateTextNoteDto
}

/**
 * Request parameters for visitControllerUpdateVisitTranscriptionSegment operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerUpdateVisitTranscriptionSegmentRequest
 */
export interface VisitApiVisitControllerUpdateVisitTranscriptionSegmentRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerUpdateVisitTranscriptionSegment
     */
    readonly visitId: string

    /**
     *
     * @type {UpdateVisitTranscriptionSegmentDto}
     * @memberof VisitApiVisitControllerUpdateVisitTranscriptionSegment
     */
    readonly updateVisitTranscriptionSegmentDto: UpdateVisitTranscriptionSegmentDto
}

/**
 * Request parameters for visitControllerUpdateVisitUserDataByStaff operation in VisitApi.
 * @export
 * @interface VisitApiVisitControllerUpdateVisitUserDataByStaffRequest
 */
export interface VisitApiVisitControllerUpdateVisitUserDataByStaffRequest {
    /**
     *
     * @type {string}
     * @memberof VisitApiVisitControllerUpdateVisitUserDataByStaff
     */
    readonly visitId: string

    /**
     *
     * @type {UpdateVisitUserDataDto}
     * @memberof VisitApiVisitControllerUpdateVisitUserDataByStaff
     */
    readonly updateVisitUserDataDto: UpdateVisitUserDataDto
}

/**
 * Request parameters for visitWalkInControllerStartWalkInVisit operation in VisitApi.
 * @export
 * @interface VisitApiVisitWalkInControllerStartWalkInVisitRequest
 */
export interface VisitApiVisitWalkInControllerStartWalkInVisitRequest {
    /**
     *
     * @type {WalkInVisitDto}
     * @memberof VisitApiVisitWalkInControllerStartWalkInVisit
     */
    readonly walkInVisitDto: WalkInVisitDto
}

/**
 * VisitApi - object-oriented interface
 * @export
 * @class VisitApi
 * @extends {BaseAPI}
 */
export class VisitApi extends BaseAPI {
    /**
     *
     * @summary Abort ongoing visit
     * @param {VisitApiVisitControllerAbortVisitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerAbortVisit(requestParameters: VisitApiVisitControllerAbortVisitRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerAbortVisit(requestParameters.abortVisitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Add documents to a visit. Writes to the Document collection with visitId + (optional) profileId for guest visits.
     * @param {VisitApiVisitControllerAddDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerAddDocuments(requestParameters: VisitApiVisitControllerAddDocumentsRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerAddDocuments(requestParameters.visitId, requestParameters.documentFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Save patient notes as a draft, without sending them to the owner. Professional only.
     * @param {VisitApiVisitControllerAddDraftNotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerAddDraftNotes(requestParameters: VisitApiVisitControllerAddDraftNotesRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerAddDraftNotes(requestParameters.visitId, requestParameters.addDraftNotesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Add internal notes to a visit. Professional only. No notification sent to patient.
     * @param {VisitApiVisitControllerAddInternalNotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerAddInternalNotes(requestParameters: VisitApiVisitControllerAddInternalNotesRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerAddInternalNotes(requestParameters.visitId, requestParameters.addInternalNotesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Add notes to a visit. Professional only.
     * @param {VisitApiVisitControllerAddNotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerAddNotes(requestParameters: VisitApiVisitControllerAddNotesRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerAddNotes(requestParameters.visitId, requestParameters.addNotesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Add patient notes to a visit. Professional only. Sends notification to patient.
     * @param {VisitApiVisitControllerAddPatientNotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerAddPatientNotes(requestParameters: VisitApiVisitControllerAddPatientNotesRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerAddPatientNotes(requestParameters.visitId, requestParameters.addPatientNotesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Attach visit summary PDF to profile. Professional and organization admin only.
     * @param {VisitApiVisitControllerAttachVisitSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerAttachVisitSummary(requestParameters: VisitApiVisitControllerAttachVisitSummaryRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerAttachVisitSummary(requestParameters.visitId, requestParameters.visitControllerAttachVisitSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Cancel existing visit
     * @param {VisitApiVisitControllerCancelVisitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerCancelVisit(requestParameters: VisitApiVisitControllerCancelVisitRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerCancelVisit(requestParameters.visitId, requestParameters.cancelVisitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows admins, organization admins, and professionals to cancel a created visit. Professionals can only cancel their own visits.
     * @summary Cancel upcoming visit (staff)
     * @param {VisitApiVisitControllerCancelVisitByStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerCancelVisitByStaff(requestParameters: VisitApiVisitControllerCancelVisitByStaffRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerCancelVisitByStaff(requestParameters.visitId, requestParameters.cancelStaffVisitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns basic user information if the user exists, null otherwise
     * @summary Check if user exists by email for staff scheduling
     * @param {VisitApiVisitControllerCheckUserByEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerCheckUserByEmail(requestParameters: VisitApiVisitControllerCheckUserByEmailRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerCheckUserByEmail(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create a text note attached to a visit. Resolves profileId/organizationId from the visit (null-safe for guest visits).
     * @param {VisitApiVisitControllerCreateVisitTextNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerCreateVisitTextNote(requestParameters: VisitApiVisitControllerCreateVisitTextNoteRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerCreateVisitTextNote(requestParameters.visitId, requestParameters.createTextNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete a visit-scoped document by filename (passed as a query param because filenames may contain slashes). Cleans up matching embeddings and any DOCUMENT/ADDED activity for the same filename. Works for both guest and authed visits.
     * @param {VisitApiVisitControllerDeleteVisitDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerDeleteVisitDocument(requestParameters: VisitApiVisitControllerDeleteVisitDocumentRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerDeleteVisitDocument(requestParameters.visitId, requestParameters.filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get users associated with a visit
     * @param {VisitApiVisitControllerFetchUserByVisitIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerFetchUserByVisitId(requestParameters: VisitApiVisitControllerFetchUserByVisitIdRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerFetchUserByVisitId(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all completed and cancelled visits for all profiles assigned to the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetAllUserVisitsHistory(options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetAllUserVisitsHistory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all visits
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetAllVisits(options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetAllVisits(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all available time slots
     * @param {VisitApiVisitControllerGetAvailableVisitSlotsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetAvailableVisitSlots(requestParameters: VisitApiVisitControllerGetAvailableVisitSlotsRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetAvailableVisitSlots(requestParameters.startDate, requestParameters.category, requestParameters.endDate, requestParameters.professionalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns visits optimized for calendar view with date range filtering. Excludes heavy data like avatars.
     * @summary Get calendar visits for organization (lightweight, no avatars)
     * @param {VisitApiVisitControllerGetCalendarVisitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetCalendarVisits(requestParameters: VisitApiVisitControllerGetCalendarVisitsRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetCalendarVisits(requestParameters.organizationId, requestParameters.startDate, requestParameters.endDate, requestParameters.status, requestParameters.professionalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns visits for the current professional optimized for calendar view.
     * @summary Get calendar visits for current professional (lightweight, no avatars)
     * @param {VisitApiVisitControllerGetCalendarVisitsForProfessionalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetCalendarVisitsForProfessional(requestParameters: VisitApiVisitControllerGetCalendarVisitsForProfessionalRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetCalendarVisitsForProfessional(requestParameters.organizationId, requestParameters.startDate, requestParameters.endDate, requestParameters.status, requestParameters.professionalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get current pending approval visit for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetCurrentPendingApprovalVisit(options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetCurrentPendingApprovalVisit(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get pending visit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetCurrentPendingVisit(options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetCurrentPendingVisit(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get professional visit history within organization
     * @param {VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetOrganizationProfessionalVisitHistory(requestParameters: VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryRequest = {}, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetOrganizationProfessionalVisitHistory(requestParameters.page, requestParameters.limit, requestParameters.userName, requestParameters.profileName, requestParameters.startDate, requestParameters.endDate, requestParameters.closedFrom, requestParameters.closedTo, requestParameters.noteStatuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get professional visit history within organization by professional id param
     * @param {VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam(requestParameters: VisitApiVisitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParamRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetOrganizationProfessionalVisitHistoryByProfessionalIdParam(requestParameters.professionalId, requestParameters.page, requestParameters.limit, requestParameters.userName, requestParameters.profileName, requestParameters.startDate, requestParameters.endDate, requestParameters.closedFrom, requestParameters.closedTo, requestParameters.noteStatuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get organization visit history
     * @param {VisitApiVisitControllerGetOrganizationVisitHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetOrganizationVisitHistory(requestParameters: VisitApiVisitControllerGetOrganizationVisitHistoryRequest = {}, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetOrganizationVisitHistory(requestParameters.page, requestParameters.limit, requestParameters.userName, requestParameters.profileName, requestParameters.startDate, requestParameters.endDate, requestParameters.closedFrom, requestParameters.closedTo, requestParameters.noteStatuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Read-only activity log for a visit, accessible to the visit owner. Mirrors the org-scoped activity endpoint but validates visit ownership via req.user.id instead of an organization membership.
     * @param {VisitApiVisitControllerGetOwnerVisitActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetOwnerVisitActivity(requestParameters: VisitApiVisitControllerGetOwnerVisitActivityRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetOwnerVisitActivity(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all pending visits for professional
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetPendingProfessionalVisits(options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetPendingProfessionalVisits(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns upcoming visit slots for a professional by ID, with optional limit on slots per day
     * @summary Get available visit slots for a specific professional
     * @param {VisitApiVisitControllerGetProfessionalAvailableSlotsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetProfessionalAvailableSlots(requestParameters: VisitApiVisitControllerGetProfessionalAvailableSlotsRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetProfessionalAvailableSlots(requestParameters.professionalId, requestParameters.category, requestParameters.visitType, requestParameters.slotsPerDay, requestParameters.organizationId, requestParameters.duration, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get profile visit history. Organization admin/owner/professional only.
     * @param {VisitApiVisitControllerGetProfileVisitHistoryPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetProfileVisitHistoryPreview(requestParameters: VisitApiVisitControllerGetProfileVisitHistoryPreviewRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetProfileVisitHistoryPreview(requestParameters.profileId, requestParameters.page, requestParameters.limit, requestParameters.startDate, requestParameters.endDate, requestParameters.closedFrom, requestParameters.closedTo, requestParameters.statuses, requestParameters.noteStatuses, requestParameters.professionalName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get today visits for a professional in an organization
     * @param {VisitApiVisitControllerGetTodaysVisitsByOrganizationAndProfessionalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetTodaysVisitsByOrganizationAndProfessionalId(requestParameters: VisitApiVisitControllerGetTodaysVisitsByOrganizationAndProfessionalIdRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetTodaysVisitsByOrganizationAndProfessionalId(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get today visits for a professional by professional id param in an organization
     * @param {VisitApiVisitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParam(requestParameters: VisitApiVisitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParamRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParam(requestParameters.organizationId, requestParameters.professionalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get organization today visits
     * @param {VisitApiVisitControllerGetTodaysVisitsByOrganizationIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetTodaysVisitsByOrganizationId(requestParameters: VisitApiVisitControllerGetTodaysVisitsByOrganizationIdRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetTodaysVisitsByOrganizationId(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get upcoming visits for a profile in an organization
     * @param {VisitApiVisitControllerGetUpcomingVisitsByOrganizationAndProfileIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetUpcomingVisitsByOrganizationAndProfileId(requestParameters: VisitApiVisitControllerGetUpcomingVisitsByOrganizationAndProfileIdRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetUpcomingVisitsByOrganizationAndProfileId(requestParameters.organizationId, requestParameters.profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all pet profiles belonging to the specified user
     * @summary Get all profiles for a specific user for staff scheduling
     * @param {VisitApiVisitControllerGetUserProfilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetUserProfiles(requestParameters: VisitApiVisitControllerGetUserProfilesRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetUserProfiles(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get user upcoming visits
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetUserUpcomingVisits(options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetUserUpcomingVisits(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get visit by id
     * @param {VisitApiVisitControllerGetVisitByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetVisitById(requestParameters: VisitApiVisitControllerGetVisitByIdRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetVisitById(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Signed URL for a file in the documents collection scoped to a visit
     * @param {VisitApiVisitControllerGetVisitFileSignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetVisitFileSignedUrl(requestParameters: VisitApiVisitControllerGetVisitFileSignedUrlRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetVisitFileSignedUrl(requestParameters.visitId, requestParameters.filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get profile visit history
     * @param {VisitApiVisitControllerGetVisitHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetVisitHistory(requestParameters: VisitApiVisitControllerGetVisitHistoryRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetVisitHistory(requestParameters.profileId, requestParameters.page, requestParameters.limit, requestParameters.startDate, requestParameters.endDate, requestParameters.closedFrom, requestParameters.closedTo, requestParameters.statuses, requestParameters.noteStatuses, requestParameters.professionalName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get professional visit summary a.k.a. stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetVisitStats(options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetVisitStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get visit summary data for PDF generation. Professional and organization admin only.
     * @param {VisitApiVisitControllerGetVisitSummaryDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetVisitSummaryData(requestParameters: VisitApiVisitControllerGetVisitSummaryDataRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetVisitSummaryData(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get visit audio transcription
     * @param {VisitApiVisitControllerGetVisitTranscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetVisitTranscription(requestParameters: VisitApiVisitControllerGetVisitTranscriptionRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetVisitTranscription(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all visits for a specific professional in an organization
     * @param {VisitApiVisitControllerGetVisitsByOrganizationAndProfessionalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetVisitsByOrganizationAndProfessionalId(requestParameters: VisitApiVisitControllerGetVisitsByOrganizationAndProfessionalIdRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetVisitsByOrganizationAndProfessionalId(requestParameters.organizationId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all visits for a specific professional in an organization
     * @param {VisitApiVisitControllerGetVisitsByOrganizationAndProfessionalIdParamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetVisitsByOrganizationAndProfessionalIdParam(requestParameters: VisitApiVisitControllerGetVisitsByOrganizationAndProfessionalIdParamRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetVisitsByOrganizationAndProfessionalIdParam(requestParameters.organizationId, requestParameters.professionalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all visits for a specific organization
     * @param {VisitApiVisitControllerGetVisitsByOrganizationIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerGetVisitsByOrganizationId(requestParameters: VisitApiVisitControllerGetVisitsByOrganizationIdRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerGetVisitsByOrganizationId(requestParameters.organizationId, requestParameters.status, requestParameters.professionalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List all documents attached to a visit (from the Document collection, keyed by visitId). Works for both guest and authed visits.
     * @param {VisitApiVisitControllerListVisitDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerListVisitDocuments(requestParameters: VisitApiVisitControllerListVisitDocumentsRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerListVisitDocuments(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Rate visit after completed.
     * @param {VisitApiVisitControllerRateVisitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerRateVisit(requestParameters: VisitApiVisitControllerRateVisitRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerRateVisit(requestParameters.visitId, requestParameters.rateVisitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows admins and organization admins to reassign a created visit to a different professional
     * @summary Reassign upcoming visit to another professional within organization
     * @param {VisitApiVisitControllerReassignVisitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerReassignVisit(requestParameters: VisitApiVisitControllerReassignVisitRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerReassignVisit(requestParameters.visitId, requestParameters.reassignVisitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Reschedule existing visit
     * @param {VisitApiVisitControllerRescheduleVisitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerRescheduleVisit(requestParameters: VisitApiVisitControllerRescheduleVisitRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerRescheduleVisit(requestParameters.rescheduleVisitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows admins, organization admins, and professionals to reschedule a created visit. Professionals can only reschedule their own visits.
     * @summary Reschedule upcoming visit to another time (staff)
     * @param {VisitApiVisitControllerRescheduleVisitByStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerRescheduleVisitByStaff(requestParameters: VisitApiVisitControllerRescheduleVisitByStaffRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerRescheduleVisitByStaff(requestParameters.visitId, requestParameters.rescheduleStaffVisitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Schedule a new visit by staff (professional or admin)
     * @param {VisitApiVisitControllerScheduleStaffVisitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerScheduleStaffVisit(requestParameters: VisitApiVisitControllerScheduleStaffVisitRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerScheduleStaffVisit(requestParameters.staffScheduleVisitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Schedule a new visit
     * @param {VisitApiVisitControllerScheduleVisitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerScheduleVisit(requestParameters: VisitApiVisitControllerScheduleVisitRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerScheduleVisit(requestParameters.scheduleVisitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Send a visit\'s draft notes to the owner. Any member of the organisation that owns the visit may finish a draft.
     * @param {VisitApiVisitControllerSendDraftNotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerSendDraftNotes(requestParameters: VisitApiVisitControllerSendDraftNotesRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerSendDraftNotes(requestParameters.visitId, requestParameters.addPatientNotesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Start live audio transcription for a visit
     * @param {VisitApiVisitControllerStartVisitTranscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerStartVisitTranscription(requestParameters: VisitApiVisitControllerStartVisitTranscriptionRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerStartVisitTranscription(requestParameters.visitId, requestParameters.startVisitTranscriptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Stop live audio transcription for a visit
     * @param {VisitApiVisitControllerStopVisitTranscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerStopVisitTranscription(requestParameters: VisitApiVisitControllerStopVisitTranscriptionRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerStopVisitTranscription(requestParameters.visitId, requestParameters.stopVisitTranscriptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows the pet owner to accept or reject an appointment scheduled by staff
     * @summary Accept or reject a scheduled appointment
     * @param {VisitApiVisitControllerUpdateVisitApprovalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerUpdateVisitApproval(requestParameters: VisitApiVisitControllerUpdateVisitApprovalRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerUpdateVisitApproval(requestParameters.visitId, requestParameters.visitApprovalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Owner-side edit of the visit description (\"Dolegliwości\") and attached documents. Diff-based: optional description replace + documentsToAdd + documentIdsToRemove.
     * @param {VisitApiVisitControllerUpdateVisitDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerUpdateVisitDetails(requestParameters: VisitApiVisitControllerUpdateVisitDetailsRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerUpdateVisitDetails(requestParameters.visitId, requestParameters.updateVisitDetailsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the visit\'s embedded profileData (name, breed, petCategory, weight, gender, dob, chipNumber). Only valid for guest visits (no linked Profile). Authed visits must use the profile update endpoints instead.
     * @summary Update guest-visit profile data (pet info) during a live visit
     * @param {VisitApiVisitControllerUpdateVisitProfileDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerUpdateVisitProfileData(requestParameters: VisitApiVisitControllerUpdateVisitProfileDataRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerUpdateVisitProfileData(requestParameters.visitId, requestParameters.updateVisitProfileDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update a text note attached to a visit (identified by filename). Verifies the note belongs to this visit before updating.
     * @param {VisitApiVisitControllerUpdateVisitTextNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerUpdateVisitTextNote(requestParameters: VisitApiVisitControllerUpdateVisitTextNoteRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerUpdateVisitTextNote(requestParameters.visitId, requestParameters.filename, requestParameters.updateTextNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update a visit transcription segment
     * @param {VisitApiVisitControllerUpdateVisitTranscriptionSegmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerUpdateVisitTranscriptionSegment(requestParameters: VisitApiVisitControllerUpdateVisitTranscriptionSegmentRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerUpdateVisitTranscriptionSegment(requestParameters.visitId, requestParameters.updateVisitTranscriptionSegmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the visit\'s embedded userData (firstName, lastName, email, phoneNumber). Only valid for guest visits (no linked User). Authed visits must use the user profile endpoints instead.
     * @summary Update guest-visit owner contact data during a live visit
     * @param {VisitApiVisitControllerUpdateVisitUserDataByStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitControllerUpdateVisitUserDataByStaff(requestParameters: VisitApiVisitControllerUpdateVisitUserDataByStaffRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitControllerUpdateVisitUserDataByStaff(requestParameters.visitId, requestParameters.updateVisitUserDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create and immediately start a visit with no prior booking. The professional is always the caller.
     * @param {VisitApiVisitWalkInControllerStartWalkInVisitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitApi
     */
    public visitWalkInControllerStartWalkInVisit(requestParameters: VisitApiVisitWalkInControllerStartWalkInVisitRequest, options?: AxiosRequestConfig) {
        return VisitApiFp(this.configuration).visitWalkInControllerStartWalkInVisit(requestParameters.walkInVisitDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VisitCategoriesApi - axios parameter creator
 * @export
 */
export const VisitCategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get visit categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitCategoriesControllerGetAllVisitCategories: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/visit/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VisitCategoriesApi - functional programming interface
 * @export
 */
export const VisitCategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VisitCategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get visit categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitCategoriesControllerGetAllVisitCategories(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVisitCategoriesDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitCategoriesControllerGetAllVisitCategories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VisitCategoriesApi - factory interface
 * @export
 */
export const VisitCategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VisitCategoriesApiFp(configuration)
    return {
        /**
         *
         * @summary Get visit categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitCategoriesControllerGetAllVisitCategories(options?: AxiosRequestConfig): AxiosPromise<Array<GetVisitCategoriesDto>> {
            return localVarFp.visitCategoriesControllerGetAllVisitCategories(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VisitCategoriesApi - object-oriented interface
 * @export
 * @class VisitCategoriesApi
 * @extends {BaseAPI}
 */
export class VisitCategoriesApi extends BaseAPI {
    /**
     *
     * @summary Get visit categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitCategoriesApi
     */
    public visitCategoriesControllerGetAllVisitCategories(options?: AxiosRequestConfig) {
        return VisitCategoriesApiFp(this.configuration).visitCategoriesControllerGetAllVisitCategories(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VisitCronApi - axios parameter creator
 * @export
 */
export const VisitCronApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Cancel CREATED visits past end time (daily)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitCronControllerCancelCreatedPastVisits: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/visit/cron/created-past`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Cancel PENDING_APPROVAL visits past end time (frequent)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitCronControllerCancelPendingApprovalPastEnd: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/visit/cron/pending-approval-past-end`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Cancel CREATED visits whose payment never completed (frequent)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitCronControllerCancelStaleUnpaidVisits: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/visit/cron/stale-unpaid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Run Visit Cron Job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitCronControllerRun: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/visit/cron`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Run Visit Reminder Cron Job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitCronControllerRunReminders: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/visit/cron/reminders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VisitCronApi - functional programming interface
 * @export
 */
export const VisitCronApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VisitCronApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Cancel CREATED visits past end time (daily)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitCronControllerCancelCreatedPastVisits(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitCronControllerCancelCreatedPastVisits(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Cancel PENDING_APPROVAL visits past end time (frequent)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitCronControllerCancelPendingApprovalPastEnd(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitCronControllerCancelPendingApprovalPastEnd(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Cancel CREATED visits whose payment never completed (frequent)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitCronControllerCancelStaleUnpaidVisits(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitCronControllerCancelStaleUnpaidVisits(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Run Visit Cron Job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitCronControllerRun(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitCronControllerRun(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Run Visit Reminder Cron Job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitCronControllerRunReminders(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitCronControllerRunReminders(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VisitCronApi - factory interface
 * @export
 */
export const VisitCronApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VisitCronApiFp(configuration)
    return {
        /**
         *
         * @summary Cancel CREATED visits past end time (daily)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitCronControllerCancelCreatedPastVisits(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitCronControllerCancelCreatedPastVisits(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cancel PENDING_APPROVAL visits past end time (frequent)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitCronControllerCancelPendingApprovalPastEnd(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitCronControllerCancelPendingApprovalPastEnd(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cancel CREATED visits whose payment never completed (frequent)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitCronControllerCancelStaleUnpaidVisits(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitCronControllerCancelStaleUnpaidVisits(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Run Visit Cron Job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitCronControllerRun(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitCronControllerRun(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Run Visit Reminder Cron Job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitCronControllerRunReminders(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitCronControllerRunReminders(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VisitCronApi - object-oriented interface
 * @export
 * @class VisitCronApi
 * @extends {BaseAPI}
 */
export class VisitCronApi extends BaseAPI {
    /**
     *
     * @summary Cancel CREATED visits past end time (daily)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitCronApi
     */
    public visitCronControllerCancelCreatedPastVisits(options?: AxiosRequestConfig) {
        return VisitCronApiFp(this.configuration).visitCronControllerCancelCreatedPastVisits(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Cancel PENDING_APPROVAL visits past end time (frequent)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitCronApi
     */
    public visitCronControllerCancelPendingApprovalPastEnd(options?: AxiosRequestConfig) {
        return VisitCronApiFp(this.configuration).visitCronControllerCancelPendingApprovalPastEnd(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Cancel CREATED visits whose payment never completed (frequent)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitCronApi
     */
    public visitCronControllerCancelStaleUnpaidVisits(options?: AxiosRequestConfig) {
        return VisitCronApiFp(this.configuration).visitCronControllerCancelStaleUnpaidVisits(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Run Visit Cron Job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitCronApi
     */
    public visitCronControllerRun(options?: AxiosRequestConfig) {
        return VisitCronApiFp(this.configuration).visitCronControllerRun(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Run Visit Reminder Cron Job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitCronApi
     */
    public visitCronControllerRunReminders(options?: AxiosRequestConfig) {
        return VisitCronApiFp(this.configuration).visitCronControllerRunReminders(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VisitGuestPaymentApi - axios parameter creator
 * @export
 */
export const VisitGuestPaymentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new payment session for a guest visit whose previous payment failed. Returns the new checkout URL.
         * @summary Retry a failed guest payment
         * @param {string} visitId
         * @param {string} guestAccessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestPaymentControllerRetryGuestPayment: async (visitId: string, guestAccessToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestPaymentControllerRetryGuestPayment', 'visitId', visitId)
            // verify required parameter 'guestAccessToken' is not null or undefined
            assertParamExists('visitGuestPaymentControllerRetryGuestPayment', 'guestAccessToken', guestAccessToken)
            const localVarPath = `/visit/public/guest-payment/{visitId}/retry`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (guestAccessToken !== undefined) {
                localVarQueryParameter['guestAccessToken'] = guestAccessToken;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VisitGuestPaymentApi - functional programming interface
 * @export
 */
export const VisitGuestPaymentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VisitGuestPaymentApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new payment session for a guest visit whose previous payment failed. Returns the new checkout URL.
         * @summary Retry a failed guest payment
         * @param {string} visitId
         * @param {string} guestAccessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestPaymentControllerRetryGuestPayment(visitId: string, guestAccessToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestPaymentControllerRetryGuestPayment(visitId, guestAccessToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VisitGuestPaymentApi - factory interface
 * @export
 */
export const VisitGuestPaymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VisitGuestPaymentApiFp(configuration)
    return {
        /**
         * Creates a new payment session for a guest visit whose previous payment failed. Returns the new checkout URL.
         * @summary Retry a failed guest payment
         * @param {VisitGuestPaymentApiVisitGuestPaymentControllerRetryGuestPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestPaymentControllerRetryGuestPayment(requestParameters: VisitGuestPaymentApiVisitGuestPaymentControllerRetryGuestPaymentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestPaymentControllerRetryGuestPayment(requestParameters.visitId, requestParameters.guestAccessToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for visitGuestPaymentControllerRetryGuestPayment operation in VisitGuestPaymentApi.
 * @export
 * @interface VisitGuestPaymentApiVisitGuestPaymentControllerRetryGuestPaymentRequest
 */
export interface VisitGuestPaymentApiVisitGuestPaymentControllerRetryGuestPaymentRequest {
    /**
     *
     * @type {string}
     * @memberof VisitGuestPaymentApiVisitGuestPaymentControllerRetryGuestPayment
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof VisitGuestPaymentApiVisitGuestPaymentControllerRetryGuestPayment
     */
    readonly guestAccessToken: string
}

/**
 * VisitGuestPaymentApi - object-oriented interface
 * @export
 * @class VisitGuestPaymentApi
 * @extends {BaseAPI}
 */
export class VisitGuestPaymentApi extends BaseAPI {
    /**
     * Creates a new payment session for a guest visit whose previous payment failed. Returns the new checkout URL.
     * @summary Retry a failed guest payment
     * @param {VisitGuestPaymentApiVisitGuestPaymentControllerRetryGuestPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitGuestPaymentApi
     */
    public visitGuestPaymentControllerRetryGuestPayment(requestParameters: VisitGuestPaymentApiVisitGuestPaymentControllerRetryGuestPaymentRequest, options?: AxiosRequestConfig) {
        return VisitGuestPaymentApiFp(this.configuration).visitGuestPaymentControllerRetryGuestPayment(requestParameters.visitId, requestParameters.guestAccessToken, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VisitTypesApi - axios parameter creator
 * @export
 */
export const VisitTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get all visit types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitTypesControllerGetAllVisitTypes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/visit/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get categories by visit type
         * @param {'video' | 'chat' | 'onsite' | 'mobile'} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitTypesControllerGetCategoriesByVisitType: async (type: 'video' | 'chat' | 'onsite' | 'mobile', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('visitTypesControllerGetCategoriesByVisitType', 'type', type)
            const localVarPath = `/visit/types/categories-by-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get visit types by category
         * @param {'veterinarian' | 'dietitian' | 'behaviorist' | 'physiotherapist'} category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitTypesControllerGetVisitTypesByCategory: async (category: 'veterinarian' | 'dietitian' | 'behaviorist' | 'physiotherapist', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('visitTypesControllerGetVisitTypesByCategory', 'category', category)
            const localVarPath = `/visit/types/by-category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VisitTypesApi - functional programming interface
 * @export
 */
export const VisitTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VisitTypesApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get all visit types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitTypesControllerGetAllVisitTypes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVisitTypesDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitTypesControllerGetAllVisitTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get categories by visit type
         * @param {'video' | 'chat' | 'onsite' | 'mobile'} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitTypesControllerGetCategoriesByVisitType(type: 'video' | 'chat' | 'onsite' | 'mobile', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitTypesControllerGetCategoriesByVisitType(type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get visit types by category
         * @param {'veterinarian' | 'dietitian' | 'behaviorist' | 'physiotherapist'} category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitTypesControllerGetVisitTypesByCategory(category: 'veterinarian' | 'dietitian' | 'behaviorist' | 'physiotherapist', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVisitTypesDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitTypesControllerGetVisitTypesByCategory(category, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VisitTypesApi - factory interface
 * @export
 */
export const VisitTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VisitTypesApiFp(configuration)
    return {
        /**
         *
         * @summary Get all visit types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitTypesControllerGetAllVisitTypes(options?: AxiosRequestConfig): AxiosPromise<Array<GetVisitTypesDto>> {
            return localVarFp.visitTypesControllerGetAllVisitTypes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get categories by visit type
         * @param {VisitTypesApiVisitTypesControllerGetCategoriesByVisitTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitTypesControllerGetCategoriesByVisitType(requestParameters: VisitTypesApiVisitTypesControllerGetCategoriesByVisitTypeRequest, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.visitTypesControllerGetCategoriesByVisitType(requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get visit types by category
         * @param {VisitTypesApiVisitTypesControllerGetVisitTypesByCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitTypesControllerGetVisitTypesByCategory(requestParameters: VisitTypesApiVisitTypesControllerGetVisitTypesByCategoryRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetVisitTypesDto>> {
            return localVarFp.visitTypesControllerGetVisitTypesByCategory(requestParameters.category, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for visitTypesControllerGetCategoriesByVisitType operation in VisitTypesApi.
 * @export
 * @interface VisitTypesApiVisitTypesControllerGetCategoriesByVisitTypeRequest
 */
export interface VisitTypesApiVisitTypesControllerGetCategoriesByVisitTypeRequest {
    /**
     *
     * @type {'video' | 'chat' | 'onsite' | 'mobile'}
     * @memberof VisitTypesApiVisitTypesControllerGetCategoriesByVisitType
     */
    readonly type: 'video' | 'chat' | 'onsite' | 'mobile'
}

/**
 * Request parameters for visitTypesControllerGetVisitTypesByCategory operation in VisitTypesApi.
 * @export
 * @interface VisitTypesApiVisitTypesControllerGetVisitTypesByCategoryRequest
 */
export interface VisitTypesApiVisitTypesControllerGetVisitTypesByCategoryRequest {
    /**
     *
     * @type {'veterinarian' | 'dietitian' | 'behaviorist' | 'physiotherapist'}
     * @memberof VisitTypesApiVisitTypesControllerGetVisitTypesByCategory
     */
    readonly category: 'veterinarian' | 'dietitian' | 'behaviorist' | 'physiotherapist'
}

/**
 * VisitTypesApi - object-oriented interface
 * @export
 * @class VisitTypesApi
 * @extends {BaseAPI}
 */
export class VisitTypesApi extends BaseAPI {
    /**
     *
     * @summary Get all visit types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitTypesApi
     */
    public visitTypesControllerGetAllVisitTypes(options?: AxiosRequestConfig) {
        return VisitTypesApiFp(this.configuration).visitTypesControllerGetAllVisitTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get categories by visit type
     * @param {VisitTypesApiVisitTypesControllerGetCategoriesByVisitTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitTypesApi
     */
    public visitTypesControllerGetCategoriesByVisitType(requestParameters: VisitTypesApiVisitTypesControllerGetCategoriesByVisitTypeRequest, options?: AxiosRequestConfig) {
        return VisitTypesApiFp(this.configuration).visitTypesControllerGetCategoriesByVisitType(requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get visit types by category
     * @param {VisitTypesApiVisitTypesControllerGetVisitTypesByCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitTypesApi
     */
    public visitTypesControllerGetVisitTypesByCategory(requestParameters: VisitTypesApiVisitTypesControllerGetVisitTypesByCategoryRequest, options?: AxiosRequestConfig) {
        return VisitTypesApiFp(this.configuration).visitTypesControllerGetVisitTypesByCategory(requestParameters.category, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VoicePlatformCallbackSupportAccessApi - axios parameter creator
 * @export
 */
export const VoicePlatformCallbackSupportAccessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Zatwierdź Callback Support Access
         * @param {string} organizationId
         * @param {string} grantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackSupportControllerApprove: async (organizationId: string, grantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('callbackSupportControllerApprove', 'organizationId', organizationId)
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('callbackSupportControllerApprove', 'grantId', grantId)
            const localVarPath = `/api/voice-platform/break-glass/callback-support/organizations/{organizationId}/grants/{grantId}/approve`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Odrzuć Callback Support Access
         * @param {string} organizationId
         * @param {string} grantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackSupportControllerDeny: async (organizationId: string, grantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('callbackSupportControllerDeny', 'organizationId', organizationId)
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('callbackSupportControllerDeny', 'grantId', grantId)
            const localVarPath = `/api/voice-platform/break-glass/callback-support/organizations/{organizationId}/grants/{grantId}/deny`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Odczytaj Callback Request w Support Access
         * @param {string} organizationId
         * @param {string} grantId
         * @param {string} callbackId
         * @param {string} supportSessionId
         * @param {'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackSupportControllerGetCallback: async (organizationId: string, grantId: string, callbackId: string, supportSessionId: string, status?: 'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('callbackSupportControllerGetCallback', 'organizationId', organizationId)
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('callbackSupportControllerGetCallback', 'grantId', grantId)
            // verify required parameter 'callbackId' is not null or undefined
            assertParamExists('callbackSupportControllerGetCallback', 'callbackId', callbackId)
            // verify required parameter 'supportSessionId' is not null or undefined
            assertParamExists('callbackSupportControllerGetCallback', 'supportSessionId', supportSessionId)
            const localVarPath = `/api/voice-platform/break-glass/callback-support/organizations/{organizationId}/grants/{grantId}/callbacks/{callbackId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)))
                .replace(`{${"callbackId"}}`, encodeURIComponent(String(callbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (supportSessionId !== undefined) {
                localVarQueryParameter['supportSessionId'] = supportSessionId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Odczytaj kolejkę w Callback Support Access
         * @param {string} organizationId
         * @param {string} grantId
         * @param {string} supportSessionId
         * @param {'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackSupportControllerListCallbacks: async (organizationId: string, grantId: string, supportSessionId: string, status?: 'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('callbackSupportControllerListCallbacks', 'organizationId', organizationId)
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('callbackSupportControllerListCallbacks', 'grantId', grantId)
            // verify required parameter 'supportSessionId' is not null or undefined
            assertParamExists('callbackSupportControllerListCallbacks', 'supportSessionId', supportSessionId)
            const localVarPath = `/api/voice-platform/break-glass/callback-support/organizations/{organizationId}/grants/{grantId}/callbacks`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (supportSessionId !== undefined) {
                localVarQueryParameter['supportSessionId'] = supportSessionId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz kolejkę dostępów do Callback Request
         * @param {string} organizationId
         * @param {'REQUESTED' | 'ACTIVE'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackSupportControllerListGrants: async (organizationId: string, status?: 'REQUESTED' | 'ACTIVE', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('callbackSupportControllerListGrants', 'organizationId', organizationId)
            const localVarPath = `/api/voice-platform/break-glass/callback-support/organizations/{organizationId}/grants`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zażądaj odrębnego Callback Support Access
         * @param {string} organizationId
         * @param {RequestCallbackSupportGrantDto} requestCallbackSupportGrantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackSupportControllerRequestGrant: async (organizationId: string, requestCallbackSupportGrantDto: RequestCallbackSupportGrantDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('callbackSupportControllerRequestGrant', 'organizationId', organizationId)
            // verify required parameter 'requestCallbackSupportGrantDto' is not null or undefined
            assertParamExists('callbackSupportControllerRequestGrant', 'requestCallbackSupportGrantDto', requestCallbackSupportGrantDto)
            const localVarPath = `/api/voice-platform/break-glass/callback-support/organizations/{organizationId}/grants`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestCallbackSupportGrantDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Odwołaj Callback Support Access
         * @param {string} organizationId
         * @param {string} grantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackSupportControllerRevoke: async (organizationId: string, grantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('callbackSupportControllerRevoke', 'organizationId', organizationId)
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('callbackSupportControllerRevoke', 'grantId', grantId)
            const localVarPath = `/api/voice-platform/break-glass/callback-support/organizations/{organizationId}/grants/{grantId}/revoke`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VoicePlatformCallbackSupportAccessApi - functional programming interface
 * @export
 */
export const VoicePlatformCallbackSupportAccessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VoicePlatformCallbackSupportAccessApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Zatwierdź Callback Support Access
         * @param {string} organizationId
         * @param {string} grantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackSupportControllerApprove(organizationId: string, grantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackSupportGrantResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackSupportControllerApprove(organizationId, grantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Odrzuć Callback Support Access
         * @param {string} organizationId
         * @param {string} grantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackSupportControllerDeny(organizationId: string, grantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackSupportGrantResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackSupportControllerDeny(organizationId, grantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Odczytaj Callback Request w Support Access
         * @param {string} organizationId
         * @param {string} grantId
         * @param {string} callbackId
         * @param {string} supportSessionId
         * @param {'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackSupportControllerGetCallback(organizationId: string, grantId: string, callbackId: string, supportSessionId: string, status?: 'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackSupportControllerGetCallback(organizationId, grantId, callbackId, supportSessionId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Odczytaj kolejkę w Callback Support Access
         * @param {string} organizationId
         * @param {string} grantId
         * @param {string} supportSessionId
         * @param {'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackSupportControllerListCallbacks(organizationId: string, grantId: string, supportSessionId: string, status?: 'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackRequestListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackSupportControllerListCallbacks(organizationId, grantId, supportSessionId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz kolejkę dostępów do Callback Request
         * @param {string} organizationId
         * @param {'REQUESTED' | 'ACTIVE'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackSupportControllerListGrants(organizationId: string, status?: 'REQUESTED' | 'ACTIVE', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CallbackSupportGrantQueueItemResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackSupportControllerListGrants(organizationId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zażądaj odrębnego Callback Support Access
         * @param {string} organizationId
         * @param {RequestCallbackSupportGrantDto} requestCallbackSupportGrantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackSupportControllerRequestGrant(organizationId: string, requestCallbackSupportGrantDto: RequestCallbackSupportGrantDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackSupportGrantResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackSupportControllerRequestGrant(organizationId, requestCallbackSupportGrantDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Odwołaj Callback Support Access
         * @param {string} organizationId
         * @param {string} grantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackSupportControllerRevoke(organizationId: string, grantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackSupportGrantResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackSupportControllerRevoke(organizationId, grantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VoicePlatformCallbackSupportAccessApi - factory interface
 * @export
 */
export const VoicePlatformCallbackSupportAccessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VoicePlatformCallbackSupportAccessApiFp(configuration)
    return {
        /**
         *
         * @summary Zatwierdź Callback Support Access
         * @param {VoicePlatformCallbackSupportAccessApiCallbackSupportControllerApproveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackSupportControllerApprove(requestParameters: VoicePlatformCallbackSupportAccessApiCallbackSupportControllerApproveRequest, options?: AxiosRequestConfig): AxiosPromise<CallbackSupportGrantResponseDto> {
            return localVarFp.callbackSupportControllerApprove(requestParameters.organizationId, requestParameters.grantId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Odrzuć Callback Support Access
         * @param {VoicePlatformCallbackSupportAccessApiCallbackSupportControllerDenyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackSupportControllerDeny(requestParameters: VoicePlatformCallbackSupportAccessApiCallbackSupportControllerDenyRequest, options?: AxiosRequestConfig): AxiosPromise<CallbackSupportGrantResponseDto> {
            return localVarFp.callbackSupportControllerDeny(requestParameters.organizationId, requestParameters.grantId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Odczytaj Callback Request w Support Access
         * @param {VoicePlatformCallbackSupportAccessApiCallbackSupportControllerGetCallbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackSupportControllerGetCallback(requestParameters: VoicePlatformCallbackSupportAccessApiCallbackSupportControllerGetCallbackRequest, options?: AxiosRequestConfig): AxiosPromise<CallbackRequestResponseDto> {
            return localVarFp.callbackSupportControllerGetCallback(requestParameters.organizationId, requestParameters.grantId, requestParameters.callbackId, requestParameters.supportSessionId, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Odczytaj kolejkę w Callback Support Access
         * @param {VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListCallbacksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackSupportControllerListCallbacks(requestParameters: VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListCallbacksRequest, options?: AxiosRequestConfig): AxiosPromise<CallbackRequestListResponseDto> {
            return localVarFp.callbackSupportControllerListCallbacks(requestParameters.organizationId, requestParameters.grantId, requestParameters.supportSessionId, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz kolejkę dostępów do Callback Request
         * @param {VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListGrantsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackSupportControllerListGrants(requestParameters: VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListGrantsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<CallbackSupportGrantQueueItemResponseDto>> {
            return localVarFp.callbackSupportControllerListGrants(requestParameters.organizationId, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zażądaj odrębnego Callback Support Access
         * @param {VoicePlatformCallbackSupportAccessApiCallbackSupportControllerRequestGrantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackSupportControllerRequestGrant(requestParameters: VoicePlatformCallbackSupportAccessApiCallbackSupportControllerRequestGrantRequest, options?: AxiosRequestConfig): AxiosPromise<CallbackSupportGrantResponseDto> {
            return localVarFp.callbackSupportControllerRequestGrant(requestParameters.organizationId, requestParameters.requestCallbackSupportGrantDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Odwołaj Callback Support Access
         * @param {VoicePlatformCallbackSupportAccessApiCallbackSupportControllerRevokeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackSupportControllerRevoke(requestParameters: VoicePlatformCallbackSupportAccessApiCallbackSupportControllerRevokeRequest, options?: AxiosRequestConfig): AxiosPromise<CallbackSupportGrantResponseDto> {
            return localVarFp.callbackSupportControllerRevoke(requestParameters.organizationId, requestParameters.grantId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for callbackSupportControllerApprove operation in VoicePlatformCallbackSupportAccessApi.
 * @export
 * @interface VoicePlatformCallbackSupportAccessApiCallbackSupportControllerApproveRequest
 */
export interface VoicePlatformCallbackSupportAccessApiCallbackSupportControllerApproveRequest {
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerApprove
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerApprove
     */
    readonly grantId: string
}

/**
 * Request parameters for callbackSupportControllerDeny operation in VoicePlatformCallbackSupportAccessApi.
 * @export
 * @interface VoicePlatformCallbackSupportAccessApiCallbackSupportControllerDenyRequest
 */
export interface VoicePlatformCallbackSupportAccessApiCallbackSupportControllerDenyRequest {
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerDeny
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerDeny
     */
    readonly grantId: string
}

/**
 * Request parameters for callbackSupportControllerGetCallback operation in VoicePlatformCallbackSupportAccessApi.
 * @export
 * @interface VoicePlatformCallbackSupportAccessApiCallbackSupportControllerGetCallbackRequest
 */
export interface VoicePlatformCallbackSupportAccessApiCallbackSupportControllerGetCallbackRequest {
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerGetCallback
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerGetCallback
     */
    readonly grantId: string

    /**
     *
     * @type {string}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerGetCallback
     */
    readonly callbackId: string

    /**
     *
     * @type {string}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerGetCallback
     */
    readonly supportSessionId: string

    /**
     *
     * @type {'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED'}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerGetCallback
     */
    readonly status?: 'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED'
}

/**
 * Request parameters for callbackSupportControllerListCallbacks operation in VoicePlatformCallbackSupportAccessApi.
 * @export
 * @interface VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListCallbacksRequest
 */
export interface VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListCallbacksRequest {
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListCallbacks
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListCallbacks
     */
    readonly grantId: string

    /**
     *
     * @type {string}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListCallbacks
     */
    readonly supportSessionId: string

    /**
     *
     * @type {'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED'}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListCallbacks
     */
    readonly status?: 'OPEN' | 'CLAIMED' | 'COMPLETED' | 'UNREACHABLE' | 'CANCELLED'
}

/**
 * Request parameters for callbackSupportControllerListGrants operation in VoicePlatformCallbackSupportAccessApi.
 * @export
 * @interface VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListGrantsRequest
 */
export interface VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListGrantsRequest {
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListGrants
     */
    readonly organizationId: string

    /**
     *
     * @type {'REQUESTED' | 'ACTIVE'}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListGrants
     */
    readonly status?: 'REQUESTED' | 'ACTIVE'
}

/**
 * Request parameters for callbackSupportControllerRequestGrant operation in VoicePlatformCallbackSupportAccessApi.
 * @export
 * @interface VoicePlatformCallbackSupportAccessApiCallbackSupportControllerRequestGrantRequest
 */
export interface VoicePlatformCallbackSupportAccessApiCallbackSupportControllerRequestGrantRequest {
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerRequestGrant
     */
    readonly organizationId: string

    /**
     *
     * @type {RequestCallbackSupportGrantDto}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerRequestGrant
     */
    readonly requestCallbackSupportGrantDto: RequestCallbackSupportGrantDto
}

/**
 * Request parameters for callbackSupportControllerRevoke operation in VoicePlatformCallbackSupportAccessApi.
 * @export
 * @interface VoicePlatformCallbackSupportAccessApiCallbackSupportControllerRevokeRequest
 */
export interface VoicePlatformCallbackSupportAccessApiCallbackSupportControllerRevokeRequest {
    /**
     *
     * @type {string}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerRevoke
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof VoicePlatformCallbackSupportAccessApiCallbackSupportControllerRevoke
     */
    readonly grantId: string
}

/**
 * VoicePlatformCallbackSupportAccessApi - object-oriented interface
 * @export
 * @class VoicePlatformCallbackSupportAccessApi
 * @extends {BaseAPI}
 */
export class VoicePlatformCallbackSupportAccessApi extends BaseAPI {
    /**
     *
     * @summary Zatwierdź Callback Support Access
     * @param {VoicePlatformCallbackSupportAccessApiCallbackSupportControllerApproveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicePlatformCallbackSupportAccessApi
     */
    public callbackSupportControllerApprove(requestParameters: VoicePlatformCallbackSupportAccessApiCallbackSupportControllerApproveRequest, options?: AxiosRequestConfig) {
        return VoicePlatformCallbackSupportAccessApiFp(this.configuration).callbackSupportControllerApprove(requestParameters.organizationId, requestParameters.grantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Odrzuć Callback Support Access
     * @param {VoicePlatformCallbackSupportAccessApiCallbackSupportControllerDenyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicePlatformCallbackSupportAccessApi
     */
    public callbackSupportControllerDeny(requestParameters: VoicePlatformCallbackSupportAccessApiCallbackSupportControllerDenyRequest, options?: AxiosRequestConfig) {
        return VoicePlatformCallbackSupportAccessApiFp(this.configuration).callbackSupportControllerDeny(requestParameters.organizationId, requestParameters.grantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Odczytaj Callback Request w Support Access
     * @param {VoicePlatformCallbackSupportAccessApiCallbackSupportControllerGetCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicePlatformCallbackSupportAccessApi
     */
    public callbackSupportControllerGetCallback(requestParameters: VoicePlatformCallbackSupportAccessApiCallbackSupportControllerGetCallbackRequest, options?: AxiosRequestConfig) {
        return VoicePlatformCallbackSupportAccessApiFp(this.configuration).callbackSupportControllerGetCallback(requestParameters.organizationId, requestParameters.grantId, requestParameters.callbackId, requestParameters.supportSessionId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Odczytaj kolejkę w Callback Support Access
     * @param {VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListCallbacksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicePlatformCallbackSupportAccessApi
     */
    public callbackSupportControllerListCallbacks(requestParameters: VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListCallbacksRequest, options?: AxiosRequestConfig) {
        return VoicePlatformCallbackSupportAccessApiFp(this.configuration).callbackSupportControllerListCallbacks(requestParameters.organizationId, requestParameters.grantId, requestParameters.supportSessionId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz kolejkę dostępów do Callback Request
     * @param {VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListGrantsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicePlatformCallbackSupportAccessApi
     */
    public callbackSupportControllerListGrants(requestParameters: VoicePlatformCallbackSupportAccessApiCallbackSupportControllerListGrantsRequest, options?: AxiosRequestConfig) {
        return VoicePlatformCallbackSupportAccessApiFp(this.configuration).callbackSupportControllerListGrants(requestParameters.organizationId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zażądaj odrębnego Callback Support Access
     * @param {VoicePlatformCallbackSupportAccessApiCallbackSupportControllerRequestGrantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicePlatformCallbackSupportAccessApi
     */
    public callbackSupportControllerRequestGrant(requestParameters: VoicePlatformCallbackSupportAccessApiCallbackSupportControllerRequestGrantRequest, options?: AxiosRequestConfig) {
        return VoicePlatformCallbackSupportAccessApiFp(this.configuration).callbackSupportControllerRequestGrant(requestParameters.organizationId, requestParameters.requestCallbackSupportGrantDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Odwołaj Callback Support Access
     * @param {VoicePlatformCallbackSupportAccessApiCallbackSupportControllerRevokeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicePlatformCallbackSupportAccessApi
     */
    public callbackSupportControllerRevoke(requestParameters: VoicePlatformCallbackSupportAccessApiCallbackSupportControllerRevokeRequest, options?: AxiosRequestConfig) {
        return VoicePlatformCallbackSupportAccessApiFp(this.configuration).callbackSupportControllerRevoke(requestParameters.organizationId, requestParameters.grantId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VoicePlatformDostpWsparciaDoTranskrypcjiApi - axios parameter creator
 * @export
 */
export const VoicePlatformDostpWsparciaDoTranskrypcjiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Zatwierdź dostęp wsparcia do transkrypcji
         * @param {string} organizationId Identyfikator organizacji
         * @param {string} grantId Identyfikator dostępu wsparcia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transcriptSupportControllerApprove: async (organizationId: string, grantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('transcriptSupportControllerApprove', 'organizationId', organizationId)
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('transcriptSupportControllerApprove', 'grantId', grantId)
            const localVarPath = `/api/voice-platform/break-glass/transcript-support/organizations/{organizationId}/grants/{grantId}/approve`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Odrzuć dostęp wsparcia do transkrypcji
         * @param {string} organizationId Identyfikator organizacji
         * @param {string} grantId Identyfikator dostępu wsparcia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transcriptSupportControllerDeny: async (organizationId: string, grantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('transcriptSupportControllerDeny', 'organizationId', organizationId)
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('transcriptSupportControllerDeny', 'grantId', grantId)
            const localVarPath = `/api/voice-platform/break-glass/transcript-support/organizations/{organizationId}/grants/{grantId}/deny`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz kolejkę dostępów do transkrypcji
         * @param {string} organizationId Identyfikator organizacji
         * @param {'REQUESTED' | 'ACTIVE'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transcriptSupportControllerListGrants: async (organizationId: string, status?: 'REQUESTED' | 'ACTIVE', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('transcriptSupportControllerListGrants', 'organizationId', organizationId)
            const localVarPath = `/api/voice-platform/break-glass/transcript-support/organizations/{organizationId}/grants`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Poproś o odrębny dostęp do transkrypcji
         * @param {string} organizationId Identyfikator organizacji
         * @param {RequestTranscriptSupportGrantDto} requestTranscriptSupportGrantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transcriptSupportControllerRequestGrant: async (organizationId: string, requestTranscriptSupportGrantDto: RequestTranscriptSupportGrantDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('transcriptSupportControllerRequestGrant', 'organizationId', organizationId)
            // verify required parameter 'requestTranscriptSupportGrantDto' is not null or undefined
            assertParamExists('transcriptSupportControllerRequestGrant', 'requestTranscriptSupportGrantDto', requestTranscriptSupportGrantDto)
            const localVarPath = `/api/voice-platform/break-glass/transcript-support/organizations/{organizationId}/grants`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestTranscriptSupportGrantDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Odwołaj dostęp wsparcia do transkrypcji
         * @param {string} organizationId Identyfikator organizacji
         * @param {string} grantId Identyfikator dostępu wsparcia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transcriptSupportControllerRevoke: async (organizationId: string, grantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('transcriptSupportControllerRevoke', 'organizationId', organizationId)
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('transcriptSupportControllerRevoke', 'grantId', grantId)
            const localVarPath = `/api/voice-platform/break-glass/transcript-support/organizations/{organizationId}/grants/{grantId}/revoke`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Jednorazowo odczytaj wskazaną transkrypcję
         * @param {string} organizationId Identyfikator organizacji
         * @param {string} grantId Identyfikator dostępu wsparcia
         * @param {string} sessionId Identyfikator sesji recepcji głosowej
         * @param {string} supportSessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transcriptSupportControllerTranscript: async (organizationId: string, grantId: string, sessionId: string, supportSessionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('transcriptSupportControllerTranscript', 'organizationId', organizationId)
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('transcriptSupportControllerTranscript', 'grantId', grantId)
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('transcriptSupportControllerTranscript', 'sessionId', sessionId)
            // verify required parameter 'supportSessionId' is not null or undefined
            assertParamExists('transcriptSupportControllerTranscript', 'supportSessionId', supportSessionId)
            const localVarPath = `/api/voice-platform/break-glass/transcript-support/organizations/{organizationId}/grants/{grantId}/sessions/{sessionId}/transcript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)))
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (supportSessionId !== undefined) {
                localVarQueryParameter['supportSessionId'] = supportSessionId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VoicePlatformDostpWsparciaDoTranskrypcjiApi - functional programming interface
 * @export
 */
export const VoicePlatformDostpWsparciaDoTranskrypcjiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VoicePlatformDostpWsparciaDoTranskrypcjiApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Zatwierdź dostęp wsparcia do transkrypcji
         * @param {string} organizationId Identyfikator organizacji
         * @param {string} grantId Identyfikator dostępu wsparcia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transcriptSupportControllerApprove(organizationId: string, grantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TranscriptSupportGrantResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transcriptSupportControllerApprove(organizationId, grantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Odrzuć dostęp wsparcia do transkrypcji
         * @param {string} organizationId Identyfikator organizacji
         * @param {string} grantId Identyfikator dostępu wsparcia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transcriptSupportControllerDeny(organizationId: string, grantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TranscriptSupportGrantResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transcriptSupportControllerDeny(organizationId, grantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz kolejkę dostępów do transkrypcji
         * @param {string} organizationId Identyfikator organizacji
         * @param {'REQUESTED' | 'ACTIVE'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transcriptSupportControllerListGrants(organizationId: string, status?: 'REQUESTED' | 'ACTIVE', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TranscriptSupportGrantQueueItemResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transcriptSupportControllerListGrants(organizationId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Poproś o odrębny dostęp do transkrypcji
         * @param {string} organizationId Identyfikator organizacji
         * @param {RequestTranscriptSupportGrantDto} requestTranscriptSupportGrantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transcriptSupportControllerRequestGrant(organizationId: string, requestTranscriptSupportGrantDto: RequestTranscriptSupportGrantDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TranscriptSupportGrantResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transcriptSupportControllerRequestGrant(organizationId, requestTranscriptSupportGrantDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Odwołaj dostęp wsparcia do transkrypcji
         * @param {string} organizationId Identyfikator organizacji
         * @param {string} grantId Identyfikator dostępu wsparcia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transcriptSupportControllerRevoke(organizationId: string, grantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TranscriptSupportGrantResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transcriptSupportControllerRevoke(organizationId, grantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Jednorazowo odczytaj wskazaną transkrypcję
         * @param {string} organizationId Identyfikator organizacji
         * @param {string} grantId Identyfikator dostępu wsparcia
         * @param {string} sessionId Identyfikator sesji recepcji głosowej
         * @param {string} supportSessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transcriptSupportControllerTranscript(organizationId: string, grantId: string, sessionId: string, supportSessionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionSessionTranscriptResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transcriptSupportControllerTranscript(organizationId, grantId, sessionId, supportSessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VoicePlatformDostpWsparciaDoTranskrypcjiApi - factory interface
 * @export
 */
export const VoicePlatformDostpWsparciaDoTranskrypcjiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VoicePlatformDostpWsparciaDoTranskrypcjiApiFp(configuration)
    return {
        /**
         *
         * @summary Zatwierdź dostęp wsparcia do transkrypcji
         * @param {VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerApproveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transcriptSupportControllerApprove(requestParameters: VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerApproveRequest, options?: AxiosRequestConfig): AxiosPromise<TranscriptSupportGrantResponseDto> {
            return localVarFp.transcriptSupportControllerApprove(requestParameters.organizationId, requestParameters.grantId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Odrzuć dostęp wsparcia do transkrypcji
         * @param {VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerDenyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transcriptSupportControllerDeny(requestParameters: VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerDenyRequest, options?: AxiosRequestConfig): AxiosPromise<TranscriptSupportGrantResponseDto> {
            return localVarFp.transcriptSupportControllerDeny(requestParameters.organizationId, requestParameters.grantId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz kolejkę dostępów do transkrypcji
         * @param {VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerListGrantsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transcriptSupportControllerListGrants(requestParameters: VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerListGrantsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<TranscriptSupportGrantQueueItemResponseDto>> {
            return localVarFp.transcriptSupportControllerListGrants(requestParameters.organizationId, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Poproś o odrębny dostęp do transkrypcji
         * @param {VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerRequestGrantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transcriptSupportControllerRequestGrant(requestParameters: VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerRequestGrantRequest, options?: AxiosRequestConfig): AxiosPromise<TranscriptSupportGrantResponseDto> {
            return localVarFp.transcriptSupportControllerRequestGrant(requestParameters.organizationId, requestParameters.requestTranscriptSupportGrantDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Odwołaj dostęp wsparcia do transkrypcji
         * @param {VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerRevokeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transcriptSupportControllerRevoke(requestParameters: VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerRevokeRequest, options?: AxiosRequestConfig): AxiosPromise<TranscriptSupportGrantResponseDto> {
            return localVarFp.transcriptSupportControllerRevoke(requestParameters.organizationId, requestParameters.grantId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Jednorazowo odczytaj wskazaną transkrypcję
         * @param {VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerTranscriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transcriptSupportControllerTranscript(requestParameters: VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerTranscriptRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionSessionTranscriptResponseDto> {
            return localVarFp.transcriptSupportControllerTranscript(requestParameters.organizationId, requestParameters.grantId, requestParameters.sessionId, requestParameters.supportSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for transcriptSupportControllerApprove operation in VoicePlatformDostpWsparciaDoTranskrypcjiApi.
 * @export
 * @interface VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerApproveRequest
 */
export interface VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerApproveRequest {
    /**
     * Identyfikator organizacji
     * @type {string}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerApprove
     */
    readonly organizationId: string

    /**
     * Identyfikator dostępu wsparcia
     * @type {string}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerApprove
     */
    readonly grantId: string
}

/**
 * Request parameters for transcriptSupportControllerDeny operation in VoicePlatformDostpWsparciaDoTranskrypcjiApi.
 * @export
 * @interface VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerDenyRequest
 */
export interface VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerDenyRequest {
    /**
     * Identyfikator organizacji
     * @type {string}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerDeny
     */
    readonly organizationId: string

    /**
     * Identyfikator dostępu wsparcia
     * @type {string}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerDeny
     */
    readonly grantId: string
}

/**
 * Request parameters for transcriptSupportControllerListGrants operation in VoicePlatformDostpWsparciaDoTranskrypcjiApi.
 * @export
 * @interface VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerListGrantsRequest
 */
export interface VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerListGrantsRequest {
    /**
     * Identyfikator organizacji
     * @type {string}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerListGrants
     */
    readonly organizationId: string

    /**
     *
     * @type {'REQUESTED' | 'ACTIVE'}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerListGrants
     */
    readonly status?: 'REQUESTED' | 'ACTIVE'
}

/**
 * Request parameters for transcriptSupportControllerRequestGrant operation in VoicePlatformDostpWsparciaDoTranskrypcjiApi.
 * @export
 * @interface VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerRequestGrantRequest
 */
export interface VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerRequestGrantRequest {
    /**
     * Identyfikator organizacji
     * @type {string}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerRequestGrant
     */
    readonly organizationId: string

    /**
     *
     * @type {RequestTranscriptSupportGrantDto}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerRequestGrant
     */
    readonly requestTranscriptSupportGrantDto: RequestTranscriptSupportGrantDto
}

/**
 * Request parameters for transcriptSupportControllerRevoke operation in VoicePlatformDostpWsparciaDoTranskrypcjiApi.
 * @export
 * @interface VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerRevokeRequest
 */
export interface VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerRevokeRequest {
    /**
     * Identyfikator organizacji
     * @type {string}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerRevoke
     */
    readonly organizationId: string

    /**
     * Identyfikator dostępu wsparcia
     * @type {string}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerRevoke
     */
    readonly grantId: string
}

/**
 * Request parameters for transcriptSupportControllerTranscript operation in VoicePlatformDostpWsparciaDoTranskrypcjiApi.
 * @export
 * @interface VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerTranscriptRequest
 */
export interface VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerTranscriptRequest {
    /**
     * Identyfikator organizacji
     * @type {string}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerTranscript
     */
    readonly organizationId: string

    /**
     * Identyfikator dostępu wsparcia
     * @type {string}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerTranscript
     */
    readonly grantId: string

    /**
     * Identyfikator sesji recepcji głosowej
     * @type {string}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerTranscript
     */
    readonly sessionId: string

    /**
     *
     * @type {string}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerTranscript
     */
    readonly supportSessionId: string
}

/**
 * VoicePlatformDostpWsparciaDoTranskrypcjiApi - object-oriented interface
 * @export
 * @class VoicePlatformDostpWsparciaDoTranskrypcjiApi
 * @extends {BaseAPI}
 */
export class VoicePlatformDostpWsparciaDoTranskrypcjiApi extends BaseAPI {
    /**
     *
     * @summary Zatwierdź dostęp wsparcia do transkrypcji
     * @param {VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerApproveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApi
     */
    public transcriptSupportControllerApprove(requestParameters: VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerApproveRequest, options?: AxiosRequestConfig) {
        return VoicePlatformDostpWsparciaDoTranskrypcjiApiFp(this.configuration).transcriptSupportControllerApprove(requestParameters.organizationId, requestParameters.grantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Odrzuć dostęp wsparcia do transkrypcji
     * @param {VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerDenyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApi
     */
    public transcriptSupportControllerDeny(requestParameters: VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerDenyRequest, options?: AxiosRequestConfig) {
        return VoicePlatformDostpWsparciaDoTranskrypcjiApiFp(this.configuration).transcriptSupportControllerDeny(requestParameters.organizationId, requestParameters.grantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz kolejkę dostępów do transkrypcji
     * @param {VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerListGrantsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApi
     */
    public transcriptSupportControllerListGrants(requestParameters: VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerListGrantsRequest, options?: AxiosRequestConfig) {
        return VoicePlatformDostpWsparciaDoTranskrypcjiApiFp(this.configuration).transcriptSupportControllerListGrants(requestParameters.organizationId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Poproś o odrębny dostęp do transkrypcji
     * @param {VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerRequestGrantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApi
     */
    public transcriptSupportControllerRequestGrant(requestParameters: VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerRequestGrantRequest, options?: AxiosRequestConfig) {
        return VoicePlatformDostpWsparciaDoTranskrypcjiApiFp(this.configuration).transcriptSupportControllerRequestGrant(requestParameters.organizationId, requestParameters.requestTranscriptSupportGrantDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Odwołaj dostęp wsparcia do transkrypcji
     * @param {VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerRevokeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApi
     */
    public transcriptSupportControllerRevoke(requestParameters: VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerRevokeRequest, options?: AxiosRequestConfig) {
        return VoicePlatformDostpWsparciaDoTranskrypcjiApiFp(this.configuration).transcriptSupportControllerRevoke(requestParameters.organizationId, requestParameters.grantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Jednorazowo odczytaj wskazaną transkrypcję
     * @param {VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerTranscriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicePlatformDostpWsparciaDoTranskrypcjiApi
     */
    public transcriptSupportControllerTranscript(requestParameters: VoicePlatformDostpWsparciaDoTranskrypcjiApiTranscriptSupportControllerTranscriptRequest, options?: AxiosRequestConfig) {
        return VoicePlatformDostpWsparciaDoTranskrypcjiApiFp(this.configuration).transcriptSupportControllerTranscript(requestParameters.organizationId, requestParameters.grantId, requestParameters.sessionId, requestParameters.supportSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WarehouseApi - axios parameter creator
 * @export
 */
export const WarehouseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Whether the warehouse of the header organization accepts stock writes
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseActivationControllerGetActivation: async (body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/warehouse/activation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Enable or disable the warehouse of an organization (platform admin)
         * @param {string} organizationId
         * @param {SetWarehouseActivationDto} setWarehouseActivationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseActivationControllerSetEnabled: async (organizationId: string, setWarehouseActivationDto: SetWarehouseActivationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('warehouseActivationControllerSetEnabled', 'organizationId', organizationId)
            // verify required parameter 'setWarehouseActivationDto' is not null or undefined
            assertParamExists('warehouseActivationControllerSetEnabled', 'setWarehouseActivationDto', setWarehouseActivationDto)
            const localVarPath = `/api/warehouse/activation/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setWarehouseActivationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Oznacz zapotrzebowanie jako zamówione albo je zamknij.
         * @param {string} id
         * @param {ChangeWarehouseDemandRequestStatusDto} changeWarehouseDemandRequestStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDemandRequestControllerChangeStatus: async (id: string, changeWarehouseDemandRequestStatusDto: ChangeWarehouseDemandRequestStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseDemandRequestControllerChangeStatus', 'id', id)
            // verify required parameter 'changeWarehouseDemandRequestStatusDto' is not null or undefined
            assertParamExists('warehouseDemandRequestControllerChangeStatus', 'changeWarehouseDemandRequestStatusDto', changeWarehouseDemandRequestStatusDto)
            const localVarPath = `/api/warehouse/demand-requests/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeWarehouseDemandRequestStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zgłoś zapotrzebowanie na produkt.
         * @param {CreateWarehouseDemandRequestDto} createWarehouseDemandRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDemandRequestControllerCreate: async (createWarehouseDemandRequestDto: CreateWarehouseDemandRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWarehouseDemandRequestDto' is not null or undefined
            assertParamExists('warehouseDemandRequestControllerCreate', 'createWarehouseDemandRequestDto', createWarehouseDemandRequestDto)
            const localVarPath = `/api/warehouse/demand-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWarehouseDemandRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zgłoś zapotrzebowanie na kilka produktów naraz: jedno zapotrzebowanie na pozycję, jeden email do administratorów.
         * @param {CreateWarehouseDemandRequestBatchDto} createWarehouseDemandRequestBatchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDemandRequestControllerCreateBatch: async (createWarehouseDemandRequestBatchDto: CreateWarehouseDemandRequestBatchDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWarehouseDemandRequestBatchDto' is not null or undefined
            assertParamExists('warehouseDemandRequestControllerCreateBatch', 'createWarehouseDemandRequestBatchDto', createWarehouseDemandRequestBatchDto)
            const localVarPath = `/api/warehouse/demand-requests/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWarehouseDemandRequestBatchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Połącz zapotrzebowanie spoza magazynu z produktem z katalogu, aby przyjęcie PZ tego produktu je zamknęło.
         * @param {string} id
         * @param {LinkWarehouseDemandRequestProductDto} linkWarehouseDemandRequestProductDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDemandRequestControllerLinkProduct: async (id: string, linkWarehouseDemandRequestProductDto: LinkWarehouseDemandRequestProductDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseDemandRequestControllerLinkProduct', 'id', id)
            // verify required parameter 'linkWarehouseDemandRequestProductDto' is not null or undefined
            assertParamExists('warehouseDemandRequestControllerLinkProduct', 'linkWarehouseDemandRequestProductDto', linkWarehouseDemandRequestProductDto)
            const localVarPath = `/api/warehouse/demand-requests/{id}/product`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkWarehouseDemandRequestProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Lista zapotrzebowań magazynu placówki.
         * @param {number} [page] Page number, 0-based. Defaults to 0.
         * @param {number} [limit] Rows per page. Defaults to 25, at most 100.
         * @param {WarehouseDemandRequestStatus} [status] Only requests in this status; every status when absent.
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDemandRequestControllerList: async (page?: number, limit?: number, status?: WarehouseDemandRequestStatus, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/warehouse/demand-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Odepnij produkt z katalogu od zapotrzebowania spoza magazynu. Wraca ono do wpisanej nazwy i ilości.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDemandRequestControllerUnlinkProduct: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseDemandRequestControllerUnlinkProduct', 'id', id)
            const localVarPath = `/api/warehouse/demand-requests/{id}/product`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Approve a draft: number it and raise stock
         * @param {string} id
         * @param {ApproveWarehouseReceiptDto} approveWarehouseReceiptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerApproveReceipt: async (id: string, approveWarehouseReceiptDto: ApproveWarehouseReceiptDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseDocumentControllerApproveReceipt', 'id', id)
            // verify required parameter 'approveWarehouseReceiptDto' is not null or undefined
            assertParamExists('warehouseDocumentControllerApproveReceipt', 'approveWarehouseReceiptDto', approveWarehouseReceiptDto)
            const localVarPath = `/api/warehouse/documents/receipts/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveWarehouseReceiptDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Cancel a document; approved stock is reversed, the number kept. Professionals may cancel only a Sale (WZ).
         * @param {string} id
         * @param {CancelWarehouseDocumentDto} cancelWarehouseDocumentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerCancel: async (id: string, cancelWarehouseDocumentDto: CancelWarehouseDocumentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseDocumentControllerCancel', 'id', id)
            // verify required parameter 'cancelWarehouseDocumentDto' is not null or undefined
            assertParamExists('warehouseDocumentControllerCancel', 'cancelWarehouseDocumentDto', cancelWarehouseDocumentDto)
            const localVarPath = `/api/warehouse/documents/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelWarehouseDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Record a numbered stock adjustment (KOR)
         * @param {CreateWarehouseAdjustmentDto} createWarehouseAdjustmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerCreateAdjustment: async (createWarehouseAdjustmentDto: CreateWarehouseAdjustmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWarehouseAdjustmentDto' is not null or undefined
            assertParamExists('warehouseDocumentControllerCreateAdjustment', 'createWarehouseAdjustmentDto', createWarehouseAdjustmentDto)
            const localVarPath = `/api/warehouse/documents/adjustments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWarehouseAdjustmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a PZ or BO draft
         * @param {CreateWarehouseReceiptDto} createWarehouseReceiptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerCreateReceipt: async (createWarehouseReceiptDto: CreateWarehouseReceiptDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWarehouseReceiptDto' is not null or undefined
            assertParamExists('warehouseDocumentControllerCreateReceipt', 'createWarehouseReceiptDto', createWarehouseReceiptDto)
            const localVarPath = `/api/warehouse/documents/receipts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWarehouseReceiptDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Short-lived signed URL of the attachment
         * @param {string} id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerGetAttachmentUrl: async (id: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseDocumentControllerGetAttachmentUrl', 'id', id)
            const localVarPath = `/api/warehouse/documents/{id}/attachment-url`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a warehouse document
         * @param {string} id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerGetDocument: async (id: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseDocumentControllerGetDocument', 'id', id)
            const localVarPath = `/api/warehouse/documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List warehouse documents
         * @param {number} [page] Page number, 0-based. Defaults to 0.
         * @param {number} [limit] Rows per page. Defaults to 25, at most 100.
         * @param {WarehouseDocumentType} [type]
         * @param {WarehouseDocumentStatus} [status]
         * @param {string} [from] Document date from, YYYY-MM-DD, inclusive
         * @param {string} [to] Document date to, YYYY-MM-DD, inclusive
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerList: async (page?: number, limit?: number, type?: WarehouseDocumentType, status?: WarehouseDocumentStatus, from?: string, to?: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/warehouse/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Replace a PZ or BO draft (drafts only)
         * @param {string} id
         * @param {UpdateWarehouseReceiptDto} updateWarehouseReceiptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerUpdateReceipt: async (id: string, updateWarehouseReceiptDto: UpdateWarehouseReceiptDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseDocumentControllerUpdateReceipt', 'id', id)
            // verify required parameter 'updateWarehouseReceiptDto' is not null or undefined
            assertParamExists('warehouseDocumentControllerUpdateReceipt', 'updateWarehouseReceiptDto', updateWarehouseReceiptDto)
            const localVarPath = `/api/warehouse/documents/receipts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWarehouseReceiptDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Attach the invoice scan (PDF, JPEG or PNG, max 15 MB)
         * @param {string} id
         * @param {File} file Invoice scan: PDF, JPEG or PNG, at most 15 MB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerUploadAttachment: async (id: string, file: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseDocumentControllerUploadAttachment', 'id', id)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('warehouseDocumentControllerUploadAttachment', 'file', file)
            const localVarPath = `/api/warehouse/documents/{id}/attachment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }


            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Medicine search of the medication form: the organization\'s drug Products (in stock first) with their stock, then the registry medicines none of them covers
         * @param {string} [query] Name, active substance or GTIN, trimmed. Empty: the organization\&#39;s drug Products and the first registry medicines.
         * @param {number} [limit] Registry medicines for a non-empty query (5 for an empty one); the Warehouse part is capped at 10.
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseMedicineSearchControllerSearch: async (query?: string, limit?: number, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/warehouse/medicine-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Assign the real batch to an unassigned drug issue (\"Wskaż partię\")
         * @param {string} id The batch-less outgoing movement
         * @param {AssignWarehouseBatchDto} assignWarehouseBatchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseMovementControllerAssignBatch: async (id: string, assignWarehouseBatchDto: AssignWarehouseBatchDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseMovementControllerAssignBatch', 'id', id)
            // verify required parameter 'assignWarehouseBatchDto' is not null or undefined
            assertParamExists('warehouseMovementControllerAssignBatch', 'assignWarehouseBatchDto', assignWarehouseBatchDto)
            const localVarPath = `/api/warehouse/movements/{id}/assign-batch`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignWarehouseBatchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Archive a product (history is kept)
         * @param {string} id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerArchive: async (id: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseProductControllerArchive', 'id', id)
            const localVarPath = `/api/warehouse/products/{id}/archive`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a product
         * @param {CreateWarehouseProductDto} createWarehouseProductDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerCreate: async (createWarehouseProductDto: CreateWarehouseProductDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWarehouseProductDto' is not null or undefined
            assertParamExists('warehouseProductControllerCreate', 'createWarehouseProductDto', createWarehouseProductDto)
            const localVarPath = `/api/warehouse/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWarehouseProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a product with its batches
         * @param {string} id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerGetProduct: async (id: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseProductControllerGetProduct', 'id', id)
            const localVarPath = `/api/warehouse/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List warehouse products with filters and paging
         * @param {number} [page] Page number, 0-based. Defaults to 0.
         * @param {number} [limit] Rows per page. Defaults to 25, at most 100.
         * @param {string} [search]
         * @param {WarehouseProductKind} [kind]
         * @param {boolean} [belowMinimum] \&quot;Do zamówienia\&quot;: below minimum
         * @param {boolean} [negative]
         * @param {boolean} [expiring] A batch with stock expires within 60 days
         * @param {boolean} [archived] Archived products instead of active ones
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerList: async (page?: number, limit?: number, search?: string, kind?: WarehouseProductKind, belowMinimum?: boolean, negative?: boolean, expiring?: boolean, archived?: boolean, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/warehouse/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (belowMinimum !== undefined) {
                localVarQueryParameter['belowMinimum'] = belowMinimum;
            }

            if (negative !== undefined) {
                localVarQueryParameter['negative'] = negative;
            }

            if (expiring !== undefined) {
                localVarQueryParameter['expiring'] = expiring;
            }

            if (archived !== undefined) {
                localVarQueryParameter['archived'] = archived;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List the batches of a drug product by expiry
         * @param {string} id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerListBatches: async (id: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseProductControllerListBatches', 'id', id)
            const localVarPath = `/api/warehouse/products/{id}/batches`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Page through the stock movements of a product
         * @param {string} id
         * @param {number} [page] Page number, 0-based. Defaults to 0.
         * @param {number} [limit] Rows per page. Defaults to 25, at most 100.
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerListMovements: async (id: string, page?: number, limit?: number, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseProductControllerListMovements', 'id', id)
            const localVarPath = `/api/warehouse/products/{id}/movements`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Drug issues still without a batch (\"Wydania bez partii\")
         * @param {string} id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerListUnassignedIssues: async (id: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseProductControllerListUnassignedIssues', 'id', id)
            const localVarPath = `/api/warehouse/products/{id}/unassigned-issues`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Draft a drug product from the medicine registry
         * @param {string} medicineProductId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerPrefill: async (medicineProductId: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicineProductId' is not null or undefined
            assertParamExists('warehouseProductControllerPrefill', 'medicineProductId', medicineProductId)
            const localVarPath = `/api/warehouse/products/prefill/{medicineProductId}`
                .replace(`{${"medicineProductId"}}`, encodeURIComponent(String(medicineProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Replace the editable fields of a product
         * @param {string} id
         * @param {UpdateWarehouseProductDto} updateWarehouseProductDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerUpdate: async (id: string, updateWarehouseProductDto: UpdateWarehouseProductDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseProductControllerUpdate', 'id', id)
            // verify required parameter 'updateWarehouseProductDto' is not null or undefined
            assertParamExists('warehouseProductControllerUpdate', 'updateWarehouseProductDto', updateWarehouseProductDto)
            const localVarPath = `/api/warehouse/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWarehouseProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Batch trace: unreversed usages and sales of one Batch with patient, visit, recipient and prescriber
         * @param {string} id Warehouse Batch id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseRecordCardControllerGetBatchRecipients: async (id: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseRecordCardControllerGetBatchRecipients', 'id', id)
            const localVarPath = `/api/warehouse/batches/{id}/recipients`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Drug Record Card (karta ewidencji) of one drug Product for an inclusive Europe/Warsaw date range; defaults to the current year
         * @param {string} id Warehouse Product id
         * @param {string} [from] Inclusive Europe/Warsaw start date; defaults to 1 January of the year of &#x60;to&#x60;, or of the current Warsaw year
         * @param {string} [to] Inclusive Europe/Warsaw end date; defaults to 31 December of the year of &#x60;from&#x60;, or of the current Warsaw year
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseRecordCardControllerGetRecordCard: async (id: string, from?: string, to?: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseRecordCardControllerGetRecordCard', 'id', id)
            const localVarPath = `/api/warehouse/products/{id}/record-card`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a Sale (WZ), standalone or linked to a visit of the organization
         * @param {CreateWarehouseSaleDto} createWarehouseSaleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseSaleControllerCreate: async (createWarehouseSaleDto: CreateWarehouseSaleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWarehouseSaleDto' is not null or undefined
            assertParamExists('warehouseSaleControllerCreate', 'createWarehouseSaleDto', createWarehouseSaleDto)
            const localVarPath = `/api/warehouse/sales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWarehouseSaleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List sold Products: one row per Sale (WZ) line, newest first
         * @param {number} [page] Page number, 0-based. Defaults to 0.
         * @param {number} [limit] Rows per page. Defaults to 25, at most 100.
         * @param {WarehouseDocumentStatus} [status] Status of the Sale (WZ); every status when omitted
         * @param {string} [from] Sale date from, YYYY-MM-DD, inclusive
         * @param {string} [to] Sale date to, YYYY-MM-DD, inclusive
         * @param {string} [search] Product name contains, ignoring letter case and Polish diacritics
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseSaleControllerListLines: async (page?: number, limit?: number, status?: WarehouseDocumentStatus, from?: string, to?: string, search?: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/warehouse/sales/lines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a supplier
         * @param {CreateWarehouseSupplierDto} createWarehouseSupplierDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseSupplierControllerCreate: async (createWarehouseSupplierDto: CreateWarehouseSupplierDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWarehouseSupplierDto' is not null or undefined
            assertParamExists('warehouseSupplierControllerCreate', 'createWarehouseSupplierDto', createWarehouseSupplierDto)
            const localVarPath = `/api/warehouse/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWarehouseSupplierDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search suppliers by name or NIP
         * @param {string} [search]
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseSupplierControllerList: async (search?: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/warehouse/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Page through suppliers by name, optionally searching name or NIP
         * @param {number} [page] Page number, 0-based. Defaults to 0.
         * @param {number} [limit] Rows per page. Defaults to 25, at most 100.
         * @param {string} [search]
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseSupplierControllerPage: async (page?: number, limit?: number, search?: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/warehouse/suppliers/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Replace a supplier name, NIP and address
         * @param {string} id
         * @param {UpdateWarehouseSupplierDto} updateWarehouseSupplierDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseSupplierControllerUpdate: async (id: string, updateWarehouseSupplierDto: UpdateWarehouseSupplierDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('warehouseSupplierControllerUpdate', 'id', id)
            // verify required parameter 'updateWarehouseSupplierDto' is not null or undefined
            assertParamExists('warehouseSupplierControllerUpdate', 'updateWarehouseSupplierDto', updateWarehouseSupplierDto)
            const localVarPath = `/api/warehouse/suppliers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWarehouseSupplierDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WarehouseApi - functional programming interface
 * @export
 */
export const WarehouseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WarehouseApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Whether the warehouse of the header organization accepts stock writes
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseActivationControllerGetActivation(body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseActivationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseActivationControllerGetActivation(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Enable or disable the warehouse of an organization (platform admin)
         * @param {string} organizationId
         * @param {SetWarehouseActivationDto} setWarehouseActivationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseActivationControllerSetEnabled(organizationId: string, setWarehouseActivationDto: SetWarehouseActivationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseActivationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseActivationControllerSetEnabled(organizationId, setWarehouseActivationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Oznacz zapotrzebowanie jako zamówione albo je zamknij.
         * @param {string} id
         * @param {ChangeWarehouseDemandRequestStatusDto} changeWarehouseDemandRequestStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseDemandRequestControllerChangeStatus(id: string, changeWarehouseDemandRequestStatusDto: ChangeWarehouseDemandRequestStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDemandRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseDemandRequestControllerChangeStatus(id, changeWarehouseDemandRequestStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zgłoś zapotrzebowanie na produkt.
         * @param {CreateWarehouseDemandRequestDto} createWarehouseDemandRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseDemandRequestControllerCreate(createWarehouseDemandRequestDto: CreateWarehouseDemandRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDemandRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseDemandRequestControllerCreate(createWarehouseDemandRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zgłoś zapotrzebowanie na kilka produktów naraz: jedno zapotrzebowanie na pozycję, jeden email do administratorów.
         * @param {CreateWarehouseDemandRequestBatchDto} createWarehouseDemandRequestBatchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseDemandRequestControllerCreateBatch(createWarehouseDemandRequestBatchDto: CreateWarehouseDemandRequestBatchDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDemandRequestBatchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseDemandRequestControllerCreateBatch(createWarehouseDemandRequestBatchDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Połącz zapotrzebowanie spoza magazynu z produktem z katalogu, aby przyjęcie PZ tego produktu je zamknęło.
         * @param {string} id
         * @param {LinkWarehouseDemandRequestProductDto} linkWarehouseDemandRequestProductDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseDemandRequestControllerLinkProduct(id: string, linkWarehouseDemandRequestProductDto: LinkWarehouseDemandRequestProductDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDemandRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseDemandRequestControllerLinkProduct(id, linkWarehouseDemandRequestProductDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Lista zapotrzebowań magazynu placówki.
         * @param {number} [page] Page number, 0-based. Defaults to 0.
         * @param {number} [limit] Rows per page. Defaults to 25, at most 100.
         * @param {WarehouseDemandRequestStatus} [status] Only requests in this status; every status when absent.
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseDemandRequestControllerList(page?: number, limit?: number, status?: WarehouseDemandRequestStatus, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedWarehouseDemandRequestsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseDemandRequestControllerList(page, limit, status, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Odepnij produkt z katalogu od zapotrzebowania spoza magazynu. Wraca ono do wpisanej nazwy i ilości.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseDemandRequestControllerUnlinkProduct(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDemandRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseDemandRequestControllerUnlinkProduct(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Approve a draft: number it and raise stock
         * @param {string} id
         * @param {ApproveWarehouseReceiptDto} approveWarehouseReceiptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseDocumentControllerApproveReceipt(id: string, approveWarehouseReceiptDto: ApproveWarehouseReceiptDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDocumentMutationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseDocumentControllerApproveReceipt(id, approveWarehouseReceiptDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Cancel a document; approved stock is reversed, the number kept. Professionals may cancel only a Sale (WZ).
         * @param {string} id
         * @param {CancelWarehouseDocumentDto} cancelWarehouseDocumentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseDocumentControllerCancel(id: string, cancelWarehouseDocumentDto: CancelWarehouseDocumentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseDocumentControllerCancel(id, cancelWarehouseDocumentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Record a numbered stock adjustment (KOR)
         * @param {CreateWarehouseAdjustmentDto} createWarehouseAdjustmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseDocumentControllerCreateAdjustment(createWarehouseAdjustmentDto: CreateWarehouseAdjustmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDocumentMutationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseDocumentControllerCreateAdjustment(createWarehouseAdjustmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Create a PZ or BO draft
         * @param {CreateWarehouseReceiptDto} createWarehouseReceiptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseDocumentControllerCreateReceipt(createWarehouseReceiptDto: CreateWarehouseReceiptDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseDocumentControllerCreateReceipt(createWarehouseReceiptDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Short-lived signed URL of the attachment
         * @param {string} id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseDocumentControllerGetAttachmentUrl(id: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseAttachmentUrlDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseDocumentControllerGetAttachmentUrl(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a warehouse document
         * @param {string} id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseDocumentControllerGetDocument(id: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseDocumentControllerGetDocument(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List warehouse documents
         * @param {number} [page] Page number, 0-based. Defaults to 0.
         * @param {number} [limit] Rows per page. Defaults to 25, at most 100.
         * @param {WarehouseDocumentType} [type]
         * @param {WarehouseDocumentStatus} [status]
         * @param {string} [from] Document date from, YYYY-MM-DD, inclusive
         * @param {string} [to] Document date to, YYYY-MM-DD, inclusive
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseDocumentControllerList(page?: number, limit?: number, type?: WarehouseDocumentType, status?: WarehouseDocumentStatus, from?: string, to?: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedWarehouseDocumentsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseDocumentControllerList(page, limit, type, status, from, to, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Replace a PZ or BO draft (drafts only)
         * @param {string} id
         * @param {UpdateWarehouseReceiptDto} updateWarehouseReceiptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseDocumentControllerUpdateReceipt(id: string, updateWarehouseReceiptDto: UpdateWarehouseReceiptDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseDocumentControllerUpdateReceipt(id, updateWarehouseReceiptDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Attach the invoice scan (PDF, JPEG or PNG, max 15 MB)
         * @param {string} id
         * @param {File} file Invoice scan: PDF, JPEG or PNG, at most 15 MB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseDocumentControllerUploadAttachment(id: string, file: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseDocumentControllerUploadAttachment(id, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Medicine search of the medication form: the organization\'s drug Products (in stock first) with their stock, then the registry medicines none of them covers
         * @param {string} [query] Name, active substance or GTIN, trimmed. Empty: the organization\&#39;s drug Products and the first registry medicines.
         * @param {number} [limit] Registry medicines for a non-empty query (5 for an empty one); the Warehouse part is capped at 10.
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseMedicineSearchControllerSearch(query?: string, limit?: number, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseMedicineSearchDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseMedicineSearchControllerSearch(query, limit, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Assign the real batch to an unassigned drug issue (\"Wskaż partię\")
         * @param {string} id The batch-less outgoing movement
         * @param {AssignWarehouseBatchDto} assignWarehouseBatchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseMovementControllerAssignBatch(id: string, assignWarehouseBatchDto: AssignWarehouseBatchDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseBatchAssignmentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseMovementControllerAssignBatch(id, assignWarehouseBatchDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Archive a product (history is kept)
         * @param {string} id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseProductControllerArchive(id: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseProductDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseProductControllerArchive(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Create a product
         * @param {CreateWarehouseProductDto} createWarehouseProductDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseProductControllerCreate(createWarehouseProductDto: CreateWarehouseProductDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseProductDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseProductControllerCreate(createWarehouseProductDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a product with its batches
         * @param {string} id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseProductControllerGetProduct(id: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseProductDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseProductControllerGetProduct(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List warehouse products with filters and paging
         * @param {number} [page] Page number, 0-based. Defaults to 0.
         * @param {number} [limit] Rows per page. Defaults to 25, at most 100.
         * @param {string} [search]
         * @param {WarehouseProductKind} [kind]
         * @param {boolean} [belowMinimum] \&quot;Do zamówienia\&quot;: below minimum
         * @param {boolean} [negative]
         * @param {boolean} [expiring] A batch with stock expires within 60 days
         * @param {boolean} [archived] Archived products instead of active ones
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseProductControllerList(page?: number, limit?: number, search?: string, kind?: WarehouseProductKind, belowMinimum?: boolean, negative?: boolean, expiring?: boolean, archived?: boolean, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedWarehouseProductsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseProductControllerList(page, limit, search, kind, belowMinimum, negative, expiring, archived, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List the batches of a drug product by expiry
         * @param {string} id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseProductControllerListBatches(id: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WarehouseBatchDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseProductControllerListBatches(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Page through the stock movements of a product
         * @param {string} id
         * @param {number} [page] Page number, 0-based. Defaults to 0.
         * @param {number} [limit] Rows per page. Defaults to 25, at most 100.
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseProductControllerListMovements(id: string, page?: number, limit?: number, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedWarehouseMovementsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseProductControllerListMovements(id, page, limit, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Drug issues still without a batch (\"Wydania bez partii\")
         * @param {string} id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseProductControllerListUnassignedIssues(id: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WarehouseMovementDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseProductControllerListUnassignedIssues(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Draft a drug product from the medicine registry
         * @param {string} medicineProductId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseProductControllerPrefill(medicineProductId: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseProductPrefillDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseProductControllerPrefill(medicineProductId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Replace the editable fields of a product
         * @param {string} id
         * @param {UpdateWarehouseProductDto} updateWarehouseProductDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseProductControllerUpdate(id: string, updateWarehouseProductDto: UpdateWarehouseProductDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseProductDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseProductControllerUpdate(id, updateWarehouseProductDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Batch trace: unreversed usages and sales of one Batch with patient, visit, recipient and prescriber
         * @param {string} id Warehouse Batch id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseRecordCardControllerGetBatchRecipients(id: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchRecipientsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseRecordCardControllerGetBatchRecipients(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Drug Record Card (karta ewidencji) of one drug Product for an inclusive Europe/Warsaw date range; defaults to the current year
         * @param {string} id Warehouse Product id
         * @param {string} [from] Inclusive Europe/Warsaw start date; defaults to 1 January of the year of &#x60;to&#x60;, or of the current Warsaw year
         * @param {string} [to] Inclusive Europe/Warsaw end date; defaults to 31 December of the year of &#x60;from&#x60;, or of the current Warsaw year
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseRecordCardControllerGetRecordCard(id: string, from?: string, to?: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordCardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseRecordCardControllerGetRecordCard(id, from, to, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Create a Sale (WZ), standalone or linked to a visit of the organization
         * @param {CreateWarehouseSaleDto} createWarehouseSaleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseSaleControllerCreate(createWarehouseSaleDto: CreateWarehouseSaleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDocumentMutationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseSaleControllerCreate(createWarehouseSaleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List sold Products: one row per Sale (WZ) line, newest first
         * @param {number} [page] Page number, 0-based. Defaults to 0.
         * @param {number} [limit] Rows per page. Defaults to 25, at most 100.
         * @param {WarehouseDocumentStatus} [status] Status of the Sale (WZ); every status when omitted
         * @param {string} [from] Sale date from, YYYY-MM-DD, inclusive
         * @param {string} [to] Sale date to, YYYY-MM-DD, inclusive
         * @param {string} [search] Product name contains, ignoring letter case and Polish diacritics
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseSaleControllerListLines(page?: number, limit?: number, status?: WarehouseDocumentStatus, from?: string, to?: string, search?: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedWarehouseSaleLinesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseSaleControllerListLines(page, limit, status, from, to, search, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Create a supplier
         * @param {CreateWarehouseSupplierDto} createWarehouseSupplierDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseSupplierControllerCreate(createWarehouseSupplierDto: CreateWarehouseSupplierDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseSupplierDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseSupplierControllerCreate(createWarehouseSupplierDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Search suppliers by name or NIP
         * @param {string} [search]
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseSupplierControllerList(search?: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WarehouseSupplierDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseSupplierControllerList(search, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Page through suppliers by name, optionally searching name or NIP
         * @param {number} [page] Page number, 0-based. Defaults to 0.
         * @param {number} [limit] Rows per page. Defaults to 25, at most 100.
         * @param {string} [search]
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseSupplierControllerPage(page?: number, limit?: number, search?: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedWarehouseSuppliersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseSupplierControllerPage(page, limit, search, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Replace a supplier name, NIP and address
         * @param {string} id
         * @param {UpdateWarehouseSupplierDto} updateWarehouseSupplierDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseSupplierControllerUpdate(id: string, updateWarehouseSupplierDto: UpdateWarehouseSupplierDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseSupplierDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseSupplierControllerUpdate(id, updateWarehouseSupplierDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WarehouseApi - factory interface
 * @export
 */
export const WarehouseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WarehouseApiFp(configuration)
    return {
        /**
         *
         * @summary Whether the warehouse of the header organization accepts stock writes
         * @param {WarehouseApiWarehouseActivationControllerGetActivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseActivationControllerGetActivation(requestParameters: WarehouseApiWarehouseActivationControllerGetActivationRequest = {}, options?: AxiosRequestConfig): AxiosPromise<WarehouseActivationDto> {
            return localVarFp.warehouseActivationControllerGetActivation(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Enable or disable the warehouse of an organization (platform admin)
         * @param {WarehouseApiWarehouseActivationControllerSetEnabledRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseActivationControllerSetEnabled(requestParameters: WarehouseApiWarehouseActivationControllerSetEnabledRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseActivationDto> {
            return localVarFp.warehouseActivationControllerSetEnabled(requestParameters.organizationId, requestParameters.setWarehouseActivationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Oznacz zapotrzebowanie jako zamówione albo je zamknij.
         * @param {WarehouseApiWarehouseDemandRequestControllerChangeStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDemandRequestControllerChangeStatus(requestParameters: WarehouseApiWarehouseDemandRequestControllerChangeStatusRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseDemandRequestResponseDto> {
            return localVarFp.warehouseDemandRequestControllerChangeStatus(requestParameters.id, requestParameters.changeWarehouseDemandRequestStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zgłoś zapotrzebowanie na produkt.
         * @param {WarehouseApiWarehouseDemandRequestControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDemandRequestControllerCreate(requestParameters: WarehouseApiWarehouseDemandRequestControllerCreateRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseDemandRequestResponseDto> {
            return localVarFp.warehouseDemandRequestControllerCreate(requestParameters.createWarehouseDemandRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zgłoś zapotrzebowanie na kilka produktów naraz: jedno zapotrzebowanie na pozycję, jeden email do administratorów.
         * @param {WarehouseApiWarehouseDemandRequestControllerCreateBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDemandRequestControllerCreateBatch(requestParameters: WarehouseApiWarehouseDemandRequestControllerCreateBatchRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseDemandRequestBatchResponseDto> {
            return localVarFp.warehouseDemandRequestControllerCreateBatch(requestParameters.createWarehouseDemandRequestBatchDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Połącz zapotrzebowanie spoza magazynu z produktem z katalogu, aby przyjęcie PZ tego produktu je zamknęło.
         * @param {WarehouseApiWarehouseDemandRequestControllerLinkProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDemandRequestControllerLinkProduct(requestParameters: WarehouseApiWarehouseDemandRequestControllerLinkProductRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseDemandRequestResponseDto> {
            return localVarFp.warehouseDemandRequestControllerLinkProduct(requestParameters.id, requestParameters.linkWarehouseDemandRequestProductDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Lista zapotrzebowań magazynu placówki.
         * @param {WarehouseApiWarehouseDemandRequestControllerListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDemandRequestControllerList(requestParameters: WarehouseApiWarehouseDemandRequestControllerListRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedWarehouseDemandRequestsDto> {
            return localVarFp.warehouseDemandRequestControllerList(requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Odepnij produkt z katalogu od zapotrzebowania spoza magazynu. Wraca ono do wpisanej nazwy i ilości.
         * @param {WarehouseApiWarehouseDemandRequestControllerUnlinkProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDemandRequestControllerUnlinkProduct(requestParameters: WarehouseApiWarehouseDemandRequestControllerUnlinkProductRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseDemandRequestResponseDto> {
            return localVarFp.warehouseDemandRequestControllerUnlinkProduct(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Approve a draft: number it and raise stock
         * @param {WarehouseApiWarehouseDocumentControllerApproveReceiptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerApproveReceipt(requestParameters: WarehouseApiWarehouseDocumentControllerApproveReceiptRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseDocumentMutationResponseDto> {
            return localVarFp.warehouseDocumentControllerApproveReceipt(requestParameters.id, requestParameters.approveWarehouseReceiptDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cancel a document; approved stock is reversed, the number kept. Professionals may cancel only a Sale (WZ).
         * @param {WarehouseApiWarehouseDocumentControllerCancelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerCancel(requestParameters: WarehouseApiWarehouseDocumentControllerCancelRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseDocumentDto> {
            return localVarFp.warehouseDocumentControllerCancel(requestParameters.id, requestParameters.cancelWarehouseDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Record a numbered stock adjustment (KOR)
         * @param {WarehouseApiWarehouseDocumentControllerCreateAdjustmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerCreateAdjustment(requestParameters: WarehouseApiWarehouseDocumentControllerCreateAdjustmentRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseDocumentMutationResponseDto> {
            return localVarFp.warehouseDocumentControllerCreateAdjustment(requestParameters.createWarehouseAdjustmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a PZ or BO draft
         * @param {WarehouseApiWarehouseDocumentControllerCreateReceiptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerCreateReceipt(requestParameters: WarehouseApiWarehouseDocumentControllerCreateReceiptRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseDocumentDto> {
            return localVarFp.warehouseDocumentControllerCreateReceipt(requestParameters.createWarehouseReceiptDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Short-lived signed URL of the attachment
         * @param {WarehouseApiWarehouseDocumentControllerGetAttachmentUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerGetAttachmentUrl(requestParameters: WarehouseApiWarehouseDocumentControllerGetAttachmentUrlRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseAttachmentUrlDto> {
            return localVarFp.warehouseDocumentControllerGetAttachmentUrl(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a warehouse document
         * @param {WarehouseApiWarehouseDocumentControllerGetDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerGetDocument(requestParameters: WarehouseApiWarehouseDocumentControllerGetDocumentRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseDocumentDto> {
            return localVarFp.warehouseDocumentControllerGetDocument(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List warehouse documents
         * @param {WarehouseApiWarehouseDocumentControllerListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerList(requestParameters: WarehouseApiWarehouseDocumentControllerListRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedWarehouseDocumentsDto> {
            return localVarFp.warehouseDocumentControllerList(requestParameters.page, requestParameters.limit, requestParameters.type, requestParameters.status, requestParameters.from, requestParameters.to, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Replace a PZ or BO draft (drafts only)
         * @param {WarehouseApiWarehouseDocumentControllerUpdateReceiptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerUpdateReceipt(requestParameters: WarehouseApiWarehouseDocumentControllerUpdateReceiptRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseDocumentDto> {
            return localVarFp.warehouseDocumentControllerUpdateReceipt(requestParameters.id, requestParameters.updateWarehouseReceiptDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Attach the invoice scan (PDF, JPEG or PNG, max 15 MB)
         * @param {WarehouseApiWarehouseDocumentControllerUploadAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseDocumentControllerUploadAttachment(requestParameters: WarehouseApiWarehouseDocumentControllerUploadAttachmentRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseDocumentDto> {
            return localVarFp.warehouseDocumentControllerUploadAttachment(requestParameters.id, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Medicine search of the medication form: the organization\'s drug Products (in stock first) with their stock, then the registry medicines none of them covers
         * @param {WarehouseApiWarehouseMedicineSearchControllerSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseMedicineSearchControllerSearch(requestParameters: WarehouseApiWarehouseMedicineSearchControllerSearchRequest = {}, options?: AxiosRequestConfig): AxiosPromise<WarehouseMedicineSearchDto> {
            return localVarFp.warehouseMedicineSearchControllerSearch(requestParameters.query, requestParameters.limit, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Assign the real batch to an unassigned drug issue (\"Wskaż partię\")
         * @param {WarehouseApiWarehouseMovementControllerAssignBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseMovementControllerAssignBatch(requestParameters: WarehouseApiWarehouseMovementControllerAssignBatchRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseBatchAssignmentResponseDto> {
            return localVarFp.warehouseMovementControllerAssignBatch(requestParameters.id, requestParameters.assignWarehouseBatchDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Archive a product (history is kept)
         * @param {WarehouseApiWarehouseProductControllerArchiveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerArchive(requestParameters: WarehouseApiWarehouseProductControllerArchiveRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseProductDetailDto> {
            return localVarFp.warehouseProductControllerArchive(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a product
         * @param {WarehouseApiWarehouseProductControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerCreate(requestParameters: WarehouseApiWarehouseProductControllerCreateRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseProductDetailDto> {
            return localVarFp.warehouseProductControllerCreate(requestParameters.createWarehouseProductDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a product with its batches
         * @param {WarehouseApiWarehouseProductControllerGetProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerGetProduct(requestParameters: WarehouseApiWarehouseProductControllerGetProductRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseProductDetailDto> {
            return localVarFp.warehouseProductControllerGetProduct(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List warehouse products with filters and paging
         * @param {WarehouseApiWarehouseProductControllerListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerList(requestParameters: WarehouseApiWarehouseProductControllerListRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedWarehouseProductsDto> {
            return localVarFp.warehouseProductControllerList(requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.kind, requestParameters.belowMinimum, requestParameters.negative, requestParameters.expiring, requestParameters.archived, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List the batches of a drug product by expiry
         * @param {WarehouseApiWarehouseProductControllerListBatchesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerListBatches(requestParameters: WarehouseApiWarehouseProductControllerListBatchesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<WarehouseBatchDto>> {
            return localVarFp.warehouseProductControllerListBatches(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Page through the stock movements of a product
         * @param {WarehouseApiWarehouseProductControllerListMovementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerListMovements(requestParameters: WarehouseApiWarehouseProductControllerListMovementsRequest, options?: AxiosRequestConfig): AxiosPromise<PaginatedWarehouseMovementsDto> {
            return localVarFp.warehouseProductControllerListMovements(requestParameters.id, requestParameters.page, requestParameters.limit, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Drug issues still without a batch (\"Wydania bez partii\")
         * @param {WarehouseApiWarehouseProductControllerListUnassignedIssuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerListUnassignedIssues(requestParameters: WarehouseApiWarehouseProductControllerListUnassignedIssuesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<WarehouseMovementDto>> {
            return localVarFp.warehouseProductControllerListUnassignedIssues(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Draft a drug product from the medicine registry
         * @param {WarehouseApiWarehouseProductControllerPrefillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerPrefill(requestParameters: WarehouseApiWarehouseProductControllerPrefillRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseProductPrefillDto> {
            return localVarFp.warehouseProductControllerPrefill(requestParameters.medicineProductId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Replace the editable fields of a product
         * @param {WarehouseApiWarehouseProductControllerUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseProductControllerUpdate(requestParameters: WarehouseApiWarehouseProductControllerUpdateRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseProductDetailDto> {
            return localVarFp.warehouseProductControllerUpdate(requestParameters.id, requestParameters.updateWarehouseProductDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Batch trace: unreversed usages and sales of one Batch with patient, visit, recipient and prescriber
         * @param {WarehouseApiWarehouseRecordCardControllerGetBatchRecipientsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseRecordCardControllerGetBatchRecipients(requestParameters: WarehouseApiWarehouseRecordCardControllerGetBatchRecipientsRequest, options?: AxiosRequestConfig): AxiosPromise<BatchRecipientsDto> {
            return localVarFp.warehouseRecordCardControllerGetBatchRecipients(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Drug Record Card (karta ewidencji) of one drug Product for an inclusive Europe/Warsaw date range; defaults to the current year
         * @param {WarehouseApiWarehouseRecordCardControllerGetRecordCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseRecordCardControllerGetRecordCard(requestParameters: WarehouseApiWarehouseRecordCardControllerGetRecordCardRequest, options?: AxiosRequestConfig): AxiosPromise<RecordCardDto> {
            return localVarFp.warehouseRecordCardControllerGetRecordCard(requestParameters.id, requestParameters.from, requestParameters.to, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a Sale (WZ), standalone or linked to a visit of the organization
         * @param {WarehouseApiWarehouseSaleControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseSaleControllerCreate(requestParameters: WarehouseApiWarehouseSaleControllerCreateRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseDocumentMutationResponseDto> {
            return localVarFp.warehouseSaleControllerCreate(requestParameters.createWarehouseSaleDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List sold Products: one row per Sale (WZ) line, newest first
         * @param {WarehouseApiWarehouseSaleControllerListLinesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseSaleControllerListLines(requestParameters: WarehouseApiWarehouseSaleControllerListLinesRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedWarehouseSaleLinesDto> {
            return localVarFp.warehouseSaleControllerListLines(requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.from, requestParameters.to, requestParameters.search, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a supplier
         * @param {WarehouseApiWarehouseSupplierControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseSupplierControllerCreate(requestParameters: WarehouseApiWarehouseSupplierControllerCreateRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseSupplierDto> {
            return localVarFp.warehouseSupplierControllerCreate(requestParameters.createWarehouseSupplierDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search suppliers by name or NIP
         * @param {WarehouseApiWarehouseSupplierControllerListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseSupplierControllerList(requestParameters: WarehouseApiWarehouseSupplierControllerListRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<WarehouseSupplierDto>> {
            return localVarFp.warehouseSupplierControllerList(requestParameters.search, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Page through suppliers by name, optionally searching name or NIP
         * @param {WarehouseApiWarehouseSupplierControllerPageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseSupplierControllerPage(requestParameters: WarehouseApiWarehouseSupplierControllerPageRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedWarehouseSuppliersDto> {
            return localVarFp.warehouseSupplierControllerPage(requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Replace a supplier name, NIP and address
         * @param {WarehouseApiWarehouseSupplierControllerUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseSupplierControllerUpdate(requestParameters: WarehouseApiWarehouseSupplierControllerUpdateRequest, options?: AxiosRequestConfig): AxiosPromise<WarehouseSupplierDto> {
            return localVarFp.warehouseSupplierControllerUpdate(requestParameters.id, requestParameters.updateWarehouseSupplierDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for warehouseActivationControllerGetActivation operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseActivationControllerGetActivationRequest
 */
export interface WarehouseApiWarehouseActivationControllerGetActivationRequest {
    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseActivationControllerGetActivation
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseActivationControllerSetEnabled operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseActivationControllerSetEnabledRequest
 */
export interface WarehouseApiWarehouseActivationControllerSetEnabledRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseActivationControllerSetEnabled
     */
    readonly organizationId: string

    /**
     *
     * @type {SetWarehouseActivationDto}
     * @memberof WarehouseApiWarehouseActivationControllerSetEnabled
     */
    readonly setWarehouseActivationDto: SetWarehouseActivationDto
}

/**
 * Request parameters for warehouseDemandRequestControllerChangeStatus operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseDemandRequestControllerChangeStatusRequest
 */
export interface WarehouseApiWarehouseDemandRequestControllerChangeStatusRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseDemandRequestControllerChangeStatus
     */
    readonly id: string

    /**
     *
     * @type {ChangeWarehouseDemandRequestStatusDto}
     * @memberof WarehouseApiWarehouseDemandRequestControllerChangeStatus
     */
    readonly changeWarehouseDemandRequestStatusDto: ChangeWarehouseDemandRequestStatusDto
}

/**
 * Request parameters for warehouseDemandRequestControllerCreate operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseDemandRequestControllerCreateRequest
 */
export interface WarehouseApiWarehouseDemandRequestControllerCreateRequest {
    /**
     *
     * @type {CreateWarehouseDemandRequestDto}
     * @memberof WarehouseApiWarehouseDemandRequestControllerCreate
     */
    readonly createWarehouseDemandRequestDto: CreateWarehouseDemandRequestDto
}

/**
 * Request parameters for warehouseDemandRequestControllerCreateBatch operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseDemandRequestControllerCreateBatchRequest
 */
export interface WarehouseApiWarehouseDemandRequestControllerCreateBatchRequest {
    /**
     *
     * @type {CreateWarehouseDemandRequestBatchDto}
     * @memberof WarehouseApiWarehouseDemandRequestControllerCreateBatch
     */
    readonly createWarehouseDemandRequestBatchDto: CreateWarehouseDemandRequestBatchDto
}

/**
 * Request parameters for warehouseDemandRequestControllerLinkProduct operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseDemandRequestControllerLinkProductRequest
 */
export interface WarehouseApiWarehouseDemandRequestControllerLinkProductRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseDemandRequestControllerLinkProduct
     */
    readonly id: string

    /**
     *
     * @type {LinkWarehouseDemandRequestProductDto}
     * @memberof WarehouseApiWarehouseDemandRequestControllerLinkProduct
     */
    readonly linkWarehouseDemandRequestProductDto: LinkWarehouseDemandRequestProductDto
}

/**
 * Request parameters for warehouseDemandRequestControllerList operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseDemandRequestControllerListRequest
 */
export interface WarehouseApiWarehouseDemandRequestControllerListRequest {
    /**
     * Page number, 0-based. Defaults to 0.
     * @type {number}
     * @memberof WarehouseApiWarehouseDemandRequestControllerList
     */
    readonly page?: number

    /**
     * Rows per page. Defaults to 25, at most 100.
     * @type {number}
     * @memberof WarehouseApiWarehouseDemandRequestControllerList
     */
    readonly limit?: number

    /**
     * Only requests in this status; every status when absent.
     * @type {WarehouseDemandRequestStatus}
     * @memberof WarehouseApiWarehouseDemandRequestControllerList
     */
    readonly status?: WarehouseDemandRequestStatus

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseDemandRequestControllerList
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseDemandRequestControllerUnlinkProduct operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseDemandRequestControllerUnlinkProductRequest
 */
export interface WarehouseApiWarehouseDemandRequestControllerUnlinkProductRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseDemandRequestControllerUnlinkProduct
     */
    readonly id: string
}

/**
 * Request parameters for warehouseDocumentControllerApproveReceipt operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseDocumentControllerApproveReceiptRequest
 */
export interface WarehouseApiWarehouseDocumentControllerApproveReceiptRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseDocumentControllerApproveReceipt
     */
    readonly id: string

    /**
     *
     * @type {ApproveWarehouseReceiptDto}
     * @memberof WarehouseApiWarehouseDocumentControllerApproveReceipt
     */
    readonly approveWarehouseReceiptDto: ApproveWarehouseReceiptDto
}

/**
 * Request parameters for warehouseDocumentControllerCancel operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseDocumentControllerCancelRequest
 */
export interface WarehouseApiWarehouseDocumentControllerCancelRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseDocumentControllerCancel
     */
    readonly id: string

    /**
     *
     * @type {CancelWarehouseDocumentDto}
     * @memberof WarehouseApiWarehouseDocumentControllerCancel
     */
    readonly cancelWarehouseDocumentDto: CancelWarehouseDocumentDto
}

/**
 * Request parameters for warehouseDocumentControllerCreateAdjustment operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseDocumentControllerCreateAdjustmentRequest
 */
export interface WarehouseApiWarehouseDocumentControllerCreateAdjustmentRequest {
    /**
     *
     * @type {CreateWarehouseAdjustmentDto}
     * @memberof WarehouseApiWarehouseDocumentControllerCreateAdjustment
     */
    readonly createWarehouseAdjustmentDto: CreateWarehouseAdjustmentDto
}

/**
 * Request parameters for warehouseDocumentControllerCreateReceipt operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseDocumentControllerCreateReceiptRequest
 */
export interface WarehouseApiWarehouseDocumentControllerCreateReceiptRequest {
    /**
     *
     * @type {CreateWarehouseReceiptDto}
     * @memberof WarehouseApiWarehouseDocumentControllerCreateReceipt
     */
    readonly createWarehouseReceiptDto: CreateWarehouseReceiptDto
}

/**
 * Request parameters for warehouseDocumentControllerGetAttachmentUrl operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseDocumentControllerGetAttachmentUrlRequest
 */
export interface WarehouseApiWarehouseDocumentControllerGetAttachmentUrlRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseDocumentControllerGetAttachmentUrl
     */
    readonly id: string

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseDocumentControllerGetAttachmentUrl
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseDocumentControllerGetDocument operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseDocumentControllerGetDocumentRequest
 */
export interface WarehouseApiWarehouseDocumentControllerGetDocumentRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseDocumentControllerGetDocument
     */
    readonly id: string

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseDocumentControllerGetDocument
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseDocumentControllerList operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseDocumentControllerListRequest
 */
export interface WarehouseApiWarehouseDocumentControllerListRequest {
    /**
     * Page number, 0-based. Defaults to 0.
     * @type {number}
     * @memberof WarehouseApiWarehouseDocumentControllerList
     */
    readonly page?: number

    /**
     * Rows per page. Defaults to 25, at most 100.
     * @type {number}
     * @memberof WarehouseApiWarehouseDocumentControllerList
     */
    readonly limit?: number

    /**
     *
     * @type {WarehouseDocumentType}
     * @memberof WarehouseApiWarehouseDocumentControllerList
     */
    readonly type?: WarehouseDocumentType

    /**
     *
     * @type {WarehouseDocumentStatus}
     * @memberof WarehouseApiWarehouseDocumentControllerList
     */
    readonly status?: WarehouseDocumentStatus

    /**
     * Document date from, YYYY-MM-DD, inclusive
     * @type {string}
     * @memberof WarehouseApiWarehouseDocumentControllerList
     */
    readonly from?: string

    /**
     * Document date to, YYYY-MM-DD, inclusive
     * @type {string}
     * @memberof WarehouseApiWarehouseDocumentControllerList
     */
    readonly to?: string

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseDocumentControllerList
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseDocumentControllerUpdateReceipt operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseDocumentControllerUpdateReceiptRequest
 */
export interface WarehouseApiWarehouseDocumentControllerUpdateReceiptRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseDocumentControllerUpdateReceipt
     */
    readonly id: string

    /**
     *
     * @type {UpdateWarehouseReceiptDto}
     * @memberof WarehouseApiWarehouseDocumentControllerUpdateReceipt
     */
    readonly updateWarehouseReceiptDto: UpdateWarehouseReceiptDto
}

/**
 * Request parameters for warehouseDocumentControllerUploadAttachment operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseDocumentControllerUploadAttachmentRequest
 */
export interface WarehouseApiWarehouseDocumentControllerUploadAttachmentRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseDocumentControllerUploadAttachment
     */
    readonly id: string

    /**
     * Invoice scan: PDF, JPEG or PNG, at most 15 MB
     * @type {File}
     * @memberof WarehouseApiWarehouseDocumentControllerUploadAttachment
     */
    readonly file: File
}

/**
 * Request parameters for warehouseMedicineSearchControllerSearch operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseMedicineSearchControllerSearchRequest
 */
export interface WarehouseApiWarehouseMedicineSearchControllerSearchRequest {
    /**
     * Name, active substance or GTIN, trimmed. Empty: the organization\&#39;s drug Products and the first registry medicines.
     * @type {string}
     * @memberof WarehouseApiWarehouseMedicineSearchControllerSearch
     */
    readonly query?: string

    /**
     * Registry medicines for a non-empty query (5 for an empty one); the Warehouse part is capped at 10.
     * @type {number}
     * @memberof WarehouseApiWarehouseMedicineSearchControllerSearch
     */
    readonly limit?: number

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseMedicineSearchControllerSearch
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseMovementControllerAssignBatch operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseMovementControllerAssignBatchRequest
 */
export interface WarehouseApiWarehouseMovementControllerAssignBatchRequest {
    /**
     * The batch-less outgoing movement
     * @type {string}
     * @memberof WarehouseApiWarehouseMovementControllerAssignBatch
     */
    readonly id: string

    /**
     *
     * @type {AssignWarehouseBatchDto}
     * @memberof WarehouseApiWarehouseMovementControllerAssignBatch
     */
    readonly assignWarehouseBatchDto: AssignWarehouseBatchDto
}

/**
 * Request parameters for warehouseProductControllerArchive operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseProductControllerArchiveRequest
 */
export interface WarehouseApiWarehouseProductControllerArchiveRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseProductControllerArchive
     */
    readonly id: string

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseProductControllerArchive
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseProductControllerCreate operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseProductControllerCreateRequest
 */
export interface WarehouseApiWarehouseProductControllerCreateRequest {
    /**
     *
     * @type {CreateWarehouseProductDto}
     * @memberof WarehouseApiWarehouseProductControllerCreate
     */
    readonly createWarehouseProductDto: CreateWarehouseProductDto
}

/**
 * Request parameters for warehouseProductControllerGetProduct operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseProductControllerGetProductRequest
 */
export interface WarehouseApiWarehouseProductControllerGetProductRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseProductControllerGetProduct
     */
    readonly id: string

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseProductControllerGetProduct
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseProductControllerList operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseProductControllerListRequest
 */
export interface WarehouseApiWarehouseProductControllerListRequest {
    /**
     * Page number, 0-based. Defaults to 0.
     * @type {number}
     * @memberof WarehouseApiWarehouseProductControllerList
     */
    readonly page?: number

    /**
     * Rows per page. Defaults to 25, at most 100.
     * @type {number}
     * @memberof WarehouseApiWarehouseProductControllerList
     */
    readonly limit?: number

    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseProductControllerList
     */
    readonly search?: string

    /**
     *
     * @type {WarehouseProductKind}
     * @memberof WarehouseApiWarehouseProductControllerList
     */
    readonly kind?: WarehouseProductKind

    /**
     * \&quot;Do zamówienia\&quot;: below minimum
     * @type {boolean}
     * @memberof WarehouseApiWarehouseProductControllerList
     */
    readonly belowMinimum?: boolean

    /**
     *
     * @type {boolean}
     * @memberof WarehouseApiWarehouseProductControllerList
     */
    readonly negative?: boolean

    /**
     * A batch with stock expires within 60 days
     * @type {boolean}
     * @memberof WarehouseApiWarehouseProductControllerList
     */
    readonly expiring?: boolean

    /**
     * Archived products instead of active ones
     * @type {boolean}
     * @memberof WarehouseApiWarehouseProductControllerList
     */
    readonly archived?: boolean

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseProductControllerList
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseProductControllerListBatches operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseProductControllerListBatchesRequest
 */
export interface WarehouseApiWarehouseProductControllerListBatchesRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseProductControllerListBatches
     */
    readonly id: string

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseProductControllerListBatches
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseProductControllerListMovements operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseProductControllerListMovementsRequest
 */
export interface WarehouseApiWarehouseProductControllerListMovementsRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseProductControllerListMovements
     */
    readonly id: string

    /**
     * Page number, 0-based. Defaults to 0.
     * @type {number}
     * @memberof WarehouseApiWarehouseProductControllerListMovements
     */
    readonly page?: number

    /**
     * Rows per page. Defaults to 25, at most 100.
     * @type {number}
     * @memberof WarehouseApiWarehouseProductControllerListMovements
     */
    readonly limit?: number

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseProductControllerListMovements
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseProductControllerListUnassignedIssues operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseProductControllerListUnassignedIssuesRequest
 */
export interface WarehouseApiWarehouseProductControllerListUnassignedIssuesRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseProductControllerListUnassignedIssues
     */
    readonly id: string

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseProductControllerListUnassignedIssues
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseProductControllerPrefill operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseProductControllerPrefillRequest
 */
export interface WarehouseApiWarehouseProductControllerPrefillRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseProductControllerPrefill
     */
    readonly medicineProductId: string

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseProductControllerPrefill
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseProductControllerUpdate operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseProductControllerUpdateRequest
 */
export interface WarehouseApiWarehouseProductControllerUpdateRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseProductControllerUpdate
     */
    readonly id: string

    /**
     *
     * @type {UpdateWarehouseProductDto}
     * @memberof WarehouseApiWarehouseProductControllerUpdate
     */
    readonly updateWarehouseProductDto: UpdateWarehouseProductDto
}

/**
 * Request parameters for warehouseRecordCardControllerGetBatchRecipients operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseRecordCardControllerGetBatchRecipientsRequest
 */
export interface WarehouseApiWarehouseRecordCardControllerGetBatchRecipientsRequest {
    /**
     * Warehouse Batch id
     * @type {string}
     * @memberof WarehouseApiWarehouseRecordCardControllerGetBatchRecipients
     */
    readonly id: string

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseRecordCardControllerGetBatchRecipients
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseRecordCardControllerGetRecordCard operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseRecordCardControllerGetRecordCardRequest
 */
export interface WarehouseApiWarehouseRecordCardControllerGetRecordCardRequest {
    /**
     * Warehouse Product id
     * @type {string}
     * @memberof WarehouseApiWarehouseRecordCardControllerGetRecordCard
     */
    readonly id: string

    /**
     * Inclusive Europe/Warsaw start date; defaults to 1 January of the year of &#x60;to&#x60;, or of the current Warsaw year
     * @type {string}
     * @memberof WarehouseApiWarehouseRecordCardControllerGetRecordCard
     */
    readonly from?: string

    /**
     * Inclusive Europe/Warsaw end date; defaults to 31 December of the year of &#x60;from&#x60;, or of the current Warsaw year
     * @type {string}
     * @memberof WarehouseApiWarehouseRecordCardControllerGetRecordCard
     */
    readonly to?: string

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseRecordCardControllerGetRecordCard
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseSaleControllerCreate operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseSaleControllerCreateRequest
 */
export interface WarehouseApiWarehouseSaleControllerCreateRequest {
    /**
     *
     * @type {CreateWarehouseSaleDto}
     * @memberof WarehouseApiWarehouseSaleControllerCreate
     */
    readonly createWarehouseSaleDto: CreateWarehouseSaleDto
}

/**
 * Request parameters for warehouseSaleControllerListLines operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseSaleControllerListLinesRequest
 */
export interface WarehouseApiWarehouseSaleControllerListLinesRequest {
    /**
     * Page number, 0-based. Defaults to 0.
     * @type {number}
     * @memberof WarehouseApiWarehouseSaleControllerListLines
     */
    readonly page?: number

    /**
     * Rows per page. Defaults to 25, at most 100.
     * @type {number}
     * @memberof WarehouseApiWarehouseSaleControllerListLines
     */
    readonly limit?: number

    /**
     * Status of the Sale (WZ); every status when omitted
     * @type {WarehouseDocumentStatus}
     * @memberof WarehouseApiWarehouseSaleControllerListLines
     */
    readonly status?: WarehouseDocumentStatus

    /**
     * Sale date from, YYYY-MM-DD, inclusive
     * @type {string}
     * @memberof WarehouseApiWarehouseSaleControllerListLines
     */
    readonly from?: string

    /**
     * Sale date to, YYYY-MM-DD, inclusive
     * @type {string}
     * @memberof WarehouseApiWarehouseSaleControllerListLines
     */
    readonly to?: string

    /**
     * Product name contains, ignoring letter case and Polish diacritics
     * @type {string}
     * @memberof WarehouseApiWarehouseSaleControllerListLines
     */
    readonly search?: string

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseSaleControllerListLines
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseSupplierControllerCreate operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseSupplierControllerCreateRequest
 */
export interface WarehouseApiWarehouseSupplierControllerCreateRequest {
    /**
     *
     * @type {CreateWarehouseSupplierDto}
     * @memberof WarehouseApiWarehouseSupplierControllerCreate
     */
    readonly createWarehouseSupplierDto: CreateWarehouseSupplierDto
}

/**
 * Request parameters for warehouseSupplierControllerList operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseSupplierControllerListRequest
 */
export interface WarehouseApiWarehouseSupplierControllerListRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseSupplierControllerList
     */
    readonly search?: string

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseSupplierControllerList
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseSupplierControllerPage operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseSupplierControllerPageRequest
 */
export interface WarehouseApiWarehouseSupplierControllerPageRequest {
    /**
     * Page number, 0-based. Defaults to 0.
     * @type {number}
     * @memberof WarehouseApiWarehouseSupplierControllerPage
     */
    readonly page?: number

    /**
     * Rows per page. Defaults to 25, at most 100.
     * @type {number}
     * @memberof WarehouseApiWarehouseSupplierControllerPage
     */
    readonly limit?: number

    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseSupplierControllerPage
     */
    readonly search?: string

    /**
     *
     * @type {object}
     * @memberof WarehouseApiWarehouseSupplierControllerPage
     */
    readonly body?: object
}

/**
 * Request parameters for warehouseSupplierControllerUpdate operation in WarehouseApi.
 * @export
 * @interface WarehouseApiWarehouseSupplierControllerUpdateRequest
 */
export interface WarehouseApiWarehouseSupplierControllerUpdateRequest {
    /**
     *
     * @type {string}
     * @memberof WarehouseApiWarehouseSupplierControllerUpdate
     */
    readonly id: string

    /**
     *
     * @type {UpdateWarehouseSupplierDto}
     * @memberof WarehouseApiWarehouseSupplierControllerUpdate
     */
    readonly updateWarehouseSupplierDto: UpdateWarehouseSupplierDto
}

/**
 * WarehouseApi - object-oriented interface
 * @export
 * @class WarehouseApi
 * @extends {BaseAPI}
 */
export class WarehouseApi extends BaseAPI {
    /**
     *
     * @summary Whether the warehouse of the header organization accepts stock writes
     * @param {WarehouseApiWarehouseActivationControllerGetActivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseActivationControllerGetActivation(requestParameters: WarehouseApiWarehouseActivationControllerGetActivationRequest = {}, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseActivationControllerGetActivation(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Enable or disable the warehouse of an organization (platform admin)
     * @param {WarehouseApiWarehouseActivationControllerSetEnabledRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseActivationControllerSetEnabled(requestParameters: WarehouseApiWarehouseActivationControllerSetEnabledRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseActivationControllerSetEnabled(requestParameters.organizationId, requestParameters.setWarehouseActivationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Oznacz zapotrzebowanie jako zamówione albo je zamknij.
     * @param {WarehouseApiWarehouseDemandRequestControllerChangeStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseDemandRequestControllerChangeStatus(requestParameters: WarehouseApiWarehouseDemandRequestControllerChangeStatusRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseDemandRequestControllerChangeStatus(requestParameters.id, requestParameters.changeWarehouseDemandRequestStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zgłoś zapotrzebowanie na produkt.
     * @param {WarehouseApiWarehouseDemandRequestControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseDemandRequestControllerCreate(requestParameters: WarehouseApiWarehouseDemandRequestControllerCreateRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseDemandRequestControllerCreate(requestParameters.createWarehouseDemandRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zgłoś zapotrzebowanie na kilka produktów naraz: jedno zapotrzebowanie na pozycję, jeden email do administratorów.
     * @param {WarehouseApiWarehouseDemandRequestControllerCreateBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseDemandRequestControllerCreateBatch(requestParameters: WarehouseApiWarehouseDemandRequestControllerCreateBatchRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseDemandRequestControllerCreateBatch(requestParameters.createWarehouseDemandRequestBatchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Połącz zapotrzebowanie spoza magazynu z produktem z katalogu, aby przyjęcie PZ tego produktu je zamknęło.
     * @param {WarehouseApiWarehouseDemandRequestControllerLinkProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseDemandRequestControllerLinkProduct(requestParameters: WarehouseApiWarehouseDemandRequestControllerLinkProductRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseDemandRequestControllerLinkProduct(requestParameters.id, requestParameters.linkWarehouseDemandRequestProductDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Lista zapotrzebowań magazynu placówki.
     * @param {WarehouseApiWarehouseDemandRequestControllerListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseDemandRequestControllerList(requestParameters: WarehouseApiWarehouseDemandRequestControllerListRequest = {}, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseDemandRequestControllerList(requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Odepnij produkt z katalogu od zapotrzebowania spoza magazynu. Wraca ono do wpisanej nazwy i ilości.
     * @param {WarehouseApiWarehouseDemandRequestControllerUnlinkProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseDemandRequestControllerUnlinkProduct(requestParameters: WarehouseApiWarehouseDemandRequestControllerUnlinkProductRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseDemandRequestControllerUnlinkProduct(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Approve a draft: number it and raise stock
     * @param {WarehouseApiWarehouseDocumentControllerApproveReceiptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseDocumentControllerApproveReceipt(requestParameters: WarehouseApiWarehouseDocumentControllerApproveReceiptRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseDocumentControllerApproveReceipt(requestParameters.id, requestParameters.approveWarehouseReceiptDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Cancel a document; approved stock is reversed, the number kept. Professionals may cancel only a Sale (WZ).
     * @param {WarehouseApiWarehouseDocumentControllerCancelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseDocumentControllerCancel(requestParameters: WarehouseApiWarehouseDocumentControllerCancelRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseDocumentControllerCancel(requestParameters.id, requestParameters.cancelWarehouseDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Record a numbered stock adjustment (KOR)
     * @param {WarehouseApiWarehouseDocumentControllerCreateAdjustmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseDocumentControllerCreateAdjustment(requestParameters: WarehouseApiWarehouseDocumentControllerCreateAdjustmentRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseDocumentControllerCreateAdjustment(requestParameters.createWarehouseAdjustmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create a PZ or BO draft
     * @param {WarehouseApiWarehouseDocumentControllerCreateReceiptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseDocumentControllerCreateReceipt(requestParameters: WarehouseApiWarehouseDocumentControllerCreateReceiptRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseDocumentControllerCreateReceipt(requestParameters.createWarehouseReceiptDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Short-lived signed URL of the attachment
     * @param {WarehouseApiWarehouseDocumentControllerGetAttachmentUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseDocumentControllerGetAttachmentUrl(requestParameters: WarehouseApiWarehouseDocumentControllerGetAttachmentUrlRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseDocumentControllerGetAttachmentUrl(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get a warehouse document
     * @param {WarehouseApiWarehouseDocumentControllerGetDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseDocumentControllerGetDocument(requestParameters: WarehouseApiWarehouseDocumentControllerGetDocumentRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseDocumentControllerGetDocument(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List warehouse documents
     * @param {WarehouseApiWarehouseDocumentControllerListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseDocumentControllerList(requestParameters: WarehouseApiWarehouseDocumentControllerListRequest = {}, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseDocumentControllerList(requestParameters.page, requestParameters.limit, requestParameters.type, requestParameters.status, requestParameters.from, requestParameters.to, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Replace a PZ or BO draft (drafts only)
     * @param {WarehouseApiWarehouseDocumentControllerUpdateReceiptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseDocumentControllerUpdateReceipt(requestParameters: WarehouseApiWarehouseDocumentControllerUpdateReceiptRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseDocumentControllerUpdateReceipt(requestParameters.id, requestParameters.updateWarehouseReceiptDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Attach the invoice scan (PDF, JPEG or PNG, max 15 MB)
     * @param {WarehouseApiWarehouseDocumentControllerUploadAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseDocumentControllerUploadAttachment(requestParameters: WarehouseApiWarehouseDocumentControllerUploadAttachmentRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseDocumentControllerUploadAttachment(requestParameters.id, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Medicine search of the medication form: the organization\'s drug Products (in stock first) with their stock, then the registry medicines none of them covers
     * @param {WarehouseApiWarehouseMedicineSearchControllerSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseMedicineSearchControllerSearch(requestParameters: WarehouseApiWarehouseMedicineSearchControllerSearchRequest = {}, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseMedicineSearchControllerSearch(requestParameters.query, requestParameters.limit, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Assign the real batch to an unassigned drug issue (\"Wskaż partię\")
     * @param {WarehouseApiWarehouseMovementControllerAssignBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseMovementControllerAssignBatch(requestParameters: WarehouseApiWarehouseMovementControllerAssignBatchRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseMovementControllerAssignBatch(requestParameters.id, requestParameters.assignWarehouseBatchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Archive a product (history is kept)
     * @param {WarehouseApiWarehouseProductControllerArchiveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseProductControllerArchive(requestParameters: WarehouseApiWarehouseProductControllerArchiveRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseProductControllerArchive(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create a product
     * @param {WarehouseApiWarehouseProductControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseProductControllerCreate(requestParameters: WarehouseApiWarehouseProductControllerCreateRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseProductControllerCreate(requestParameters.createWarehouseProductDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get a product with its batches
     * @param {WarehouseApiWarehouseProductControllerGetProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseProductControllerGetProduct(requestParameters: WarehouseApiWarehouseProductControllerGetProductRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseProductControllerGetProduct(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List warehouse products with filters and paging
     * @param {WarehouseApiWarehouseProductControllerListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseProductControllerList(requestParameters: WarehouseApiWarehouseProductControllerListRequest = {}, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseProductControllerList(requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.kind, requestParameters.belowMinimum, requestParameters.negative, requestParameters.expiring, requestParameters.archived, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List the batches of a drug product by expiry
     * @param {WarehouseApiWarehouseProductControllerListBatchesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseProductControllerListBatches(requestParameters: WarehouseApiWarehouseProductControllerListBatchesRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseProductControllerListBatches(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Page through the stock movements of a product
     * @param {WarehouseApiWarehouseProductControllerListMovementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseProductControllerListMovements(requestParameters: WarehouseApiWarehouseProductControllerListMovementsRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseProductControllerListMovements(requestParameters.id, requestParameters.page, requestParameters.limit, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Drug issues still without a batch (\"Wydania bez partii\")
     * @param {WarehouseApiWarehouseProductControllerListUnassignedIssuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseProductControllerListUnassignedIssues(requestParameters: WarehouseApiWarehouseProductControllerListUnassignedIssuesRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseProductControllerListUnassignedIssues(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Draft a drug product from the medicine registry
     * @param {WarehouseApiWarehouseProductControllerPrefillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseProductControllerPrefill(requestParameters: WarehouseApiWarehouseProductControllerPrefillRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseProductControllerPrefill(requestParameters.medicineProductId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Replace the editable fields of a product
     * @param {WarehouseApiWarehouseProductControllerUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseProductControllerUpdate(requestParameters: WarehouseApiWarehouseProductControllerUpdateRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseProductControllerUpdate(requestParameters.id, requestParameters.updateWarehouseProductDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Batch trace: unreversed usages and sales of one Batch with patient, visit, recipient and prescriber
     * @param {WarehouseApiWarehouseRecordCardControllerGetBatchRecipientsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseRecordCardControllerGetBatchRecipients(requestParameters: WarehouseApiWarehouseRecordCardControllerGetBatchRecipientsRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseRecordCardControllerGetBatchRecipients(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Drug Record Card (karta ewidencji) of one drug Product for an inclusive Europe/Warsaw date range; defaults to the current year
     * @param {WarehouseApiWarehouseRecordCardControllerGetRecordCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseRecordCardControllerGetRecordCard(requestParameters: WarehouseApiWarehouseRecordCardControllerGetRecordCardRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseRecordCardControllerGetRecordCard(requestParameters.id, requestParameters.from, requestParameters.to, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create a Sale (WZ), standalone or linked to a visit of the organization
     * @param {WarehouseApiWarehouseSaleControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseSaleControllerCreate(requestParameters: WarehouseApiWarehouseSaleControllerCreateRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseSaleControllerCreate(requestParameters.createWarehouseSaleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List sold Products: one row per Sale (WZ) line, newest first
     * @param {WarehouseApiWarehouseSaleControllerListLinesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseSaleControllerListLines(requestParameters: WarehouseApiWarehouseSaleControllerListLinesRequest = {}, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseSaleControllerListLines(requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.from, requestParameters.to, requestParameters.search, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create a supplier
     * @param {WarehouseApiWarehouseSupplierControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseSupplierControllerCreate(requestParameters: WarehouseApiWarehouseSupplierControllerCreateRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseSupplierControllerCreate(requestParameters.createWarehouseSupplierDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Search suppliers by name or NIP
     * @param {WarehouseApiWarehouseSupplierControllerListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseSupplierControllerList(requestParameters: WarehouseApiWarehouseSupplierControllerListRequest = {}, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseSupplierControllerList(requestParameters.search, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Page through suppliers by name, optionally searching name or NIP
     * @param {WarehouseApiWarehouseSupplierControllerPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseSupplierControllerPage(requestParameters: WarehouseApiWarehouseSupplierControllerPageRequest = {}, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseSupplierControllerPage(requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Replace a supplier name, NIP and address
     * @param {WarehouseApiWarehouseSupplierControllerUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseSupplierControllerUpdate(requestParameters: WarehouseApiWarehouseSupplierControllerUpdateRequest, options?: AxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseSupplierControllerUpdate(requestParameters.id, requestParameters.updateWarehouseSupplierDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WebinarRehearsalsApi - axios parameter creator
 * @export
 */
export const WebinarRehearsalsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {CreateWebinarRehearsalInvitationDto} createWebinarRehearsalInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarRehearsalControllerCreate: async (id: string, createWebinarRehearsalInvitationDto: CreateWebinarRehearsalInvitationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarRehearsalControllerCreate', 'id', id)
            // verify required parameter 'createWebinarRehearsalInvitationDto' is not null or undefined
            assertParamExists('webinarRehearsalControllerCreate', 'createWebinarRehearsalInvitationDto', createWebinarRehearsalInvitationDto)
            const localVarPath = `/api/webinars/events/{id}/rehearsal-invitations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWebinarRehearsalInvitationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarRehearsalControllerList: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarRehearsalControllerList', 'id', id)
            const localVarPath = `/api/webinars/events/{id}/rehearsal-invitations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} invitationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarRehearsalControllerRevoke: async (id: string, invitationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarRehearsalControllerRevoke', 'id', id)
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('webinarRehearsalControllerRevoke', 'invitationId', invitationId)
            const localVarPath = `/api/webinars/events/{id}/rehearsal-invitations/{invitationId}/revoke`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"invitationId"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebinarRehearsalsApi - functional programming interface
 * @export
 */
export const WebinarRehearsalsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebinarRehearsalsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {string} id
         * @param {CreateWebinarRehearsalInvitationDto} createWebinarRehearsalInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarRehearsalControllerCreate(id: string, createWebinarRehearsalInvitationDto: CreateWebinarRehearsalInvitationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarRehearsalInvitationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarRehearsalControllerCreate(id, createWebinarRehearsalInvitationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarRehearsalControllerList(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebinarRehearsalInvitationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarRehearsalControllerList(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} invitationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarRehearsalControllerRevoke(id: string, invitationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarRehearsalControllerRevoke(id, invitationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WebinarRehearsalsApi - factory interface
 * @export
 */
export const WebinarRehearsalsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebinarRehearsalsApiFp(configuration)
    return {
        /**
         *
         * @param {WebinarRehearsalsApiWebinarRehearsalControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarRehearsalControllerCreate(requestParameters: WebinarRehearsalsApiWebinarRehearsalControllerCreateRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarRehearsalInvitationDto> {
            return localVarFp.webinarRehearsalControllerCreate(requestParameters.id, requestParameters.createWebinarRehearsalInvitationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarRehearsalsApiWebinarRehearsalControllerListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarRehearsalControllerList(requestParameters: WebinarRehearsalsApiWebinarRehearsalControllerListRequest, options?: AxiosRequestConfig): AxiosPromise<Array<WebinarRehearsalInvitationDto>> {
            return localVarFp.webinarRehearsalControllerList(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarRehearsalsApiWebinarRehearsalControllerRevokeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarRehearsalControllerRevoke(requestParameters: WebinarRehearsalsApiWebinarRehearsalControllerRevokeRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.webinarRehearsalControllerRevoke(requestParameters.id, requestParameters.invitationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for webinarRehearsalControllerCreate operation in WebinarRehearsalsApi.
 * @export
 * @interface WebinarRehearsalsApiWebinarRehearsalControllerCreateRequest
 */
export interface WebinarRehearsalsApiWebinarRehearsalControllerCreateRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalsApiWebinarRehearsalControllerCreate
     */
    readonly id: string

    /**
     *
     * @type {CreateWebinarRehearsalInvitationDto}
     * @memberof WebinarRehearsalsApiWebinarRehearsalControllerCreate
     */
    readonly createWebinarRehearsalInvitationDto: CreateWebinarRehearsalInvitationDto
}

/**
 * Request parameters for webinarRehearsalControllerList operation in WebinarRehearsalsApi.
 * @export
 * @interface WebinarRehearsalsApiWebinarRehearsalControllerListRequest
 */
export interface WebinarRehearsalsApiWebinarRehearsalControllerListRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalsApiWebinarRehearsalControllerList
     */
    readonly id: string
}

/**
 * Request parameters for webinarRehearsalControllerRevoke operation in WebinarRehearsalsApi.
 * @export
 * @interface WebinarRehearsalsApiWebinarRehearsalControllerRevokeRequest
 */
export interface WebinarRehearsalsApiWebinarRehearsalControllerRevokeRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalsApiWebinarRehearsalControllerRevoke
     */
    readonly id: string

    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalsApiWebinarRehearsalControllerRevoke
     */
    readonly invitationId: string
}

/**
 * WebinarRehearsalsApi - object-oriented interface
 * @export
 * @class WebinarRehearsalsApi
 * @extends {BaseAPI}
 */
export class WebinarRehearsalsApi extends BaseAPI {
    /**
     *
     * @param {WebinarRehearsalsApiWebinarRehearsalControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarRehearsalsApi
     */
    public webinarRehearsalControllerCreate(requestParameters: WebinarRehearsalsApiWebinarRehearsalControllerCreateRequest, options?: AxiosRequestConfig) {
        return WebinarRehearsalsApiFp(this.configuration).webinarRehearsalControllerCreate(requestParameters.id, requestParameters.createWebinarRehearsalInvitationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarRehearsalsApiWebinarRehearsalControllerListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarRehearsalsApi
     */
    public webinarRehearsalControllerList(requestParameters: WebinarRehearsalsApiWebinarRehearsalControllerListRequest, options?: AxiosRequestConfig) {
        return WebinarRehearsalsApiFp(this.configuration).webinarRehearsalControllerList(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarRehearsalsApiWebinarRehearsalControllerRevokeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarRehearsalsApi
     */
    public webinarRehearsalControllerRevoke(requestParameters: WebinarRehearsalsApiWebinarRehearsalControllerRevokeRequest, options?: AxiosRequestConfig) {
        return WebinarRehearsalsApiFp(this.configuration).webinarRehearsalControllerRevoke(requestParameters.id, requestParameters.invitationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WebinarStaffInvitationsApi - axios parameter creator
 * @export
 */
export const WebinarStaffInvitationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {CreateWebinarStaffInvitationDto} createWebinarStaffInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarStaffInvitationControllerCreate: async (id: string, createWebinarStaffInvitationDto: CreateWebinarStaffInvitationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarStaffInvitationControllerCreate', 'id', id)
            // verify required parameter 'createWebinarStaffInvitationDto' is not null or undefined
            assertParamExists('webinarStaffInvitationControllerCreate', 'createWebinarStaffInvitationDto', createWebinarStaffInvitationDto)
            const localVarPath = `/api/webinars/events/{id}/staff-invitations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWebinarStaffInvitationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} invitationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarStaffInvitationControllerEmailPreview: async (id: string, invitationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarStaffInvitationControllerEmailPreview', 'id', id)
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('webinarStaffInvitationControllerEmailPreview', 'invitationId', invitationId)
            const localVarPath = `/api/webinars/events/{id}/staff-invitations/{invitationId}/email-preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"invitationId"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarStaffInvitationControllerList: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarStaffInvitationControllerList', 'id', id)
            const localVarPath = `/api/webinars/events/{id}/staff-invitations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} invitationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarStaffInvitationControllerRevoke: async (id: string, invitationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarStaffInvitationControllerRevoke', 'id', id)
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('webinarStaffInvitationControllerRevoke', 'invitationId', invitationId)
            const localVarPath = `/api/webinars/events/{id}/staff-invitations/{invitationId}/revoke`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"invitationId"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} invitationId
         * @param {SendWebinarStaffInvitationDto} sendWebinarStaffInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarStaffInvitationControllerSend: async (id: string, invitationId: string, sendWebinarStaffInvitationDto: SendWebinarStaffInvitationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarStaffInvitationControllerSend', 'id', id)
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('webinarStaffInvitationControllerSend', 'invitationId', invitationId)
            // verify required parameter 'sendWebinarStaffInvitationDto' is not null or undefined
            assertParamExists('webinarStaffInvitationControllerSend', 'sendWebinarStaffInvitationDto', sendWebinarStaffInvitationDto)
            const localVarPath = `/api/webinars/events/{id}/staff-invitations/{invitationId}/send`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"invitationId"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendWebinarStaffInvitationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebinarStaffInvitationsApi - functional programming interface
 * @export
 */
export const WebinarStaffInvitationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebinarStaffInvitationsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {string} id
         * @param {CreateWebinarStaffInvitationDto} createWebinarStaffInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarStaffInvitationControllerCreate(id: string, createWebinarStaffInvitationDto: CreateWebinarStaffInvitationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarStaffInvitationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarStaffInvitationControllerCreate(id, createWebinarStaffInvitationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} invitationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarStaffInvitationControllerEmailPreview(id: string, invitationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarStaffEmailPreviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarStaffInvitationControllerEmailPreview(id, invitationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarStaffInvitationControllerList(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebinarStaffInvitationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarStaffInvitationControllerList(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} invitationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarStaffInvitationControllerRevoke(id: string, invitationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarStaffInvitationControllerRevoke(id, invitationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} invitationId
         * @param {SendWebinarStaffInvitationDto} sendWebinarStaffInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarStaffInvitationControllerSend(id: string, invitationId: string, sendWebinarStaffInvitationDto: SendWebinarStaffInvitationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarStaffMailStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarStaffInvitationControllerSend(id, invitationId, sendWebinarStaffInvitationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WebinarStaffInvitationsApi - factory interface
 * @export
 */
export const WebinarStaffInvitationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebinarStaffInvitationsApiFp(configuration)
    return {
        /**
         *
         * @param {WebinarStaffInvitationsApiWebinarStaffInvitationControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarStaffInvitationControllerCreate(requestParameters: WebinarStaffInvitationsApiWebinarStaffInvitationControllerCreateRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarStaffInvitationDto> {
            return localVarFp.webinarStaffInvitationControllerCreate(requestParameters.id, requestParameters.createWebinarStaffInvitationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarStaffInvitationsApiWebinarStaffInvitationControllerEmailPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarStaffInvitationControllerEmailPreview(requestParameters: WebinarStaffInvitationsApiWebinarStaffInvitationControllerEmailPreviewRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarStaffEmailPreviewDto> {
            return localVarFp.webinarStaffInvitationControllerEmailPreview(requestParameters.id, requestParameters.invitationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarStaffInvitationsApiWebinarStaffInvitationControllerListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarStaffInvitationControllerList(requestParameters: WebinarStaffInvitationsApiWebinarStaffInvitationControllerListRequest, options?: AxiosRequestConfig): AxiosPromise<Array<WebinarStaffInvitationDto>> {
            return localVarFp.webinarStaffInvitationControllerList(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarStaffInvitationsApiWebinarStaffInvitationControllerRevokeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarStaffInvitationControllerRevoke(requestParameters: WebinarStaffInvitationsApiWebinarStaffInvitationControllerRevokeRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.webinarStaffInvitationControllerRevoke(requestParameters.id, requestParameters.invitationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarStaffInvitationsApiWebinarStaffInvitationControllerSendRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarStaffInvitationControllerSend(requestParameters: WebinarStaffInvitationsApiWebinarStaffInvitationControllerSendRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarStaffMailStatusDto> {
            return localVarFp.webinarStaffInvitationControllerSend(requestParameters.id, requestParameters.invitationId, requestParameters.sendWebinarStaffInvitationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for webinarStaffInvitationControllerCreate operation in WebinarStaffInvitationsApi.
 * @export
 * @interface WebinarStaffInvitationsApiWebinarStaffInvitationControllerCreateRequest
 */
export interface WebinarStaffInvitationsApiWebinarStaffInvitationControllerCreateRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationsApiWebinarStaffInvitationControllerCreate
     */
    readonly id: string

    /**
     *
     * @type {CreateWebinarStaffInvitationDto}
     * @memberof WebinarStaffInvitationsApiWebinarStaffInvitationControllerCreate
     */
    readonly createWebinarStaffInvitationDto: CreateWebinarStaffInvitationDto
}

/**
 * Request parameters for webinarStaffInvitationControllerEmailPreview operation in WebinarStaffInvitationsApi.
 * @export
 * @interface WebinarStaffInvitationsApiWebinarStaffInvitationControllerEmailPreviewRequest
 */
export interface WebinarStaffInvitationsApiWebinarStaffInvitationControllerEmailPreviewRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationsApiWebinarStaffInvitationControllerEmailPreview
     */
    readonly id: string

    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationsApiWebinarStaffInvitationControllerEmailPreview
     */
    readonly invitationId: string
}

/**
 * Request parameters for webinarStaffInvitationControllerList operation in WebinarStaffInvitationsApi.
 * @export
 * @interface WebinarStaffInvitationsApiWebinarStaffInvitationControllerListRequest
 */
export interface WebinarStaffInvitationsApiWebinarStaffInvitationControllerListRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationsApiWebinarStaffInvitationControllerList
     */
    readonly id: string
}

/**
 * Request parameters for webinarStaffInvitationControllerRevoke operation in WebinarStaffInvitationsApi.
 * @export
 * @interface WebinarStaffInvitationsApiWebinarStaffInvitationControllerRevokeRequest
 */
export interface WebinarStaffInvitationsApiWebinarStaffInvitationControllerRevokeRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationsApiWebinarStaffInvitationControllerRevoke
     */
    readonly id: string

    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationsApiWebinarStaffInvitationControllerRevoke
     */
    readonly invitationId: string
}

/**
 * Request parameters for webinarStaffInvitationControllerSend operation in WebinarStaffInvitationsApi.
 * @export
 * @interface WebinarStaffInvitationsApiWebinarStaffInvitationControllerSendRequest
 */
export interface WebinarStaffInvitationsApiWebinarStaffInvitationControllerSendRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationsApiWebinarStaffInvitationControllerSend
     */
    readonly id: string

    /**
     *
     * @type {string}
     * @memberof WebinarStaffInvitationsApiWebinarStaffInvitationControllerSend
     */
    readonly invitationId: string

    /**
     *
     * @type {SendWebinarStaffInvitationDto}
     * @memberof WebinarStaffInvitationsApiWebinarStaffInvitationControllerSend
     */
    readonly sendWebinarStaffInvitationDto: SendWebinarStaffInvitationDto
}

/**
 * WebinarStaffInvitationsApi - object-oriented interface
 * @export
 * @class WebinarStaffInvitationsApi
 * @extends {BaseAPI}
 */
export class WebinarStaffInvitationsApi extends BaseAPI {
    /**
     *
     * @param {WebinarStaffInvitationsApiWebinarStaffInvitationControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarStaffInvitationsApi
     */
    public webinarStaffInvitationControllerCreate(requestParameters: WebinarStaffInvitationsApiWebinarStaffInvitationControllerCreateRequest, options?: AxiosRequestConfig) {
        return WebinarStaffInvitationsApiFp(this.configuration).webinarStaffInvitationControllerCreate(requestParameters.id, requestParameters.createWebinarStaffInvitationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarStaffInvitationsApiWebinarStaffInvitationControllerEmailPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarStaffInvitationsApi
     */
    public webinarStaffInvitationControllerEmailPreview(requestParameters: WebinarStaffInvitationsApiWebinarStaffInvitationControllerEmailPreviewRequest, options?: AxiosRequestConfig) {
        return WebinarStaffInvitationsApiFp(this.configuration).webinarStaffInvitationControllerEmailPreview(requestParameters.id, requestParameters.invitationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarStaffInvitationsApiWebinarStaffInvitationControllerListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarStaffInvitationsApi
     */
    public webinarStaffInvitationControllerList(requestParameters: WebinarStaffInvitationsApiWebinarStaffInvitationControllerListRequest, options?: AxiosRequestConfig) {
        return WebinarStaffInvitationsApiFp(this.configuration).webinarStaffInvitationControllerList(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarStaffInvitationsApiWebinarStaffInvitationControllerRevokeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarStaffInvitationsApi
     */
    public webinarStaffInvitationControllerRevoke(requestParameters: WebinarStaffInvitationsApiWebinarStaffInvitationControllerRevokeRequest, options?: AxiosRequestConfig) {
        return WebinarStaffInvitationsApiFp(this.configuration).webinarStaffInvitationControllerRevoke(requestParameters.id, requestParameters.invitationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarStaffInvitationsApiWebinarStaffInvitationControllerSendRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarStaffInvitationsApi
     */
    public webinarStaffInvitationControllerSend(requestParameters: WebinarStaffInvitationsApiWebinarStaffInvitationControllerSendRequest, options?: AxiosRequestConfig) {
        return WebinarStaffInvitationsApiFp(this.configuration).webinarStaffInvitationControllerSend(requestParameters.id, requestParameters.invitationId, requestParameters.sendWebinarStaffInvitationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WebinarsApi - axios parameter creator
 * @export
 */
export const WebinarsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerAssigned: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/webinars/assigned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerCancel: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerCancel', 'id', id)
            const localVarPath = `/api/webinars/events/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerClosePreparation: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerClosePreparation', 'id', id)
            const localVarPath = `/api/webinars/events/{id}/close-preparation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateWebinarDto} createWebinarDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerCreate: async (createWebinarDto: CreateWebinarDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWebinarDto' is not null or undefined
            assertParamExists('webinarControllerCreate', 'createWebinarDto', createWebinarDto)
            const localVarPath = `/api/webinars/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWebinarDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} recordingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerDeleteRecording: async (recordingId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordingId' is not null or undefined
            assertParamExists('webinarControllerDeleteRecording', 'recordingId', recordingId)
            const localVarPath = `/api/webinars/recordings/{recordingId}`
                .replace(`{${"recordingId"}}`, encodeURIComponent(String(recordingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} recordingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerDownload: async (recordingId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordingId' is not null or undefined
            assertParamExists('webinarControllerDownload', 'recordingId', recordingId)
            const localVarPath = `/api/webinars/recordings/{recordingId}/download`
                .replace(`{${"recordingId"}}`, encodeURIComponent(String(recordingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerEnd: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerEnd', 'id', id)
            const localVarPath = `/api/webinars/events/{id}/end`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerGet', 'id', id)
            const localVarPath = `/api/webinars/events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerJoin: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerJoin', 'id', id)
            const localVarPath = `/api/webinars/events/{id}/join`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/webinars/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerOpen: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerOpen', 'id', id)
            const localVarPath = `/api/webinars/events/{id}/open`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerPrepare: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerPrepare', 'id', id)
            const localVarPath = `/api/webinars/events/{id}/prepare`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerPresenter: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('webinarControllerPresenter', 'email', email)
            const localVarPath = `/api/webinars/presenters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerPublish: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerPublish', 'id', id)
            const localVarPath = `/api/webinars/events/{id}/publish`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerReadiness: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerReadiness', 'id', id)
            const localVarPath = `/api/webinars/events/{id}/readiness`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerRecordingList: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerRecordingList', 'id', id)
            const localVarPath = `/api/webinars/events/{id}/recordings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerRegistrations: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerRegistrations', 'id', id)
            const localVarPath = `/api/webinars/events/{id}/registrations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerRehearsal: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerRehearsal', 'id', id)
            const localVarPath = `/api/webinars/events/{id}/rehearsal`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerRemove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerRemove', 'id', id)
            const localVarPath = `/api/webinars/events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} registrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerResendConfirmation: async (id: string, registrationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerResendConfirmation', 'id', id)
            // verify required parameter 'registrationId' is not null or undefined
            assertParamExists('webinarControllerResendConfirmation', 'registrationId', registrationId)
            const localVarPath = `/api/webinars/events/{id}/registrations/{registrationId}/resend-confirmation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"registrationId"}}`, encodeURIComponent(String(registrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} registrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerRevoke: async (id: string, registrationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerRevoke', 'id', id)
            // verify required parameter 'registrationId' is not null or undefined
            assertParamExists('webinarControllerRevoke', 'registrationId', registrationId)
            const localVarPath = `/api/webinars/events/{id}/registrations/{registrationId}/revoke`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"registrationId"}}`, encodeURIComponent(String(registrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateWebinarDto} updateWebinarDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerUpdate: async (id: string, updateWebinarDto: UpdateWebinarDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerUpdate', 'id', id)
            // verify required parameter 'updateWebinarDto' is not null or undefined
            assertParamExists('webinarControllerUpdate', 'updateWebinarDto', updateWebinarDto)
            const localVarPath = `/api/webinars/events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWebinarDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerWithdrawAudience: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarControllerWithdrawAudience', 'id', id)
            const localVarPath = `/api/webinars/events/{id}/withdraw-audience`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarRecordingPublicationControllerGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarRecordingPublicationControllerGet', 'id', id)
            const localVarPath = `/api/webinars/events/{id}/recording-publication`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {PreviewWebinarRecordingPublicationDto} previewWebinarRecordingPublicationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarRecordingPublicationControllerPreview: async (id: string, previewWebinarRecordingPublicationDto: PreviewWebinarRecordingPublicationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarRecordingPublicationControllerPreview', 'id', id)
            // verify required parameter 'previewWebinarRecordingPublicationDto' is not null or undefined
            assertParamExists('webinarRecordingPublicationControllerPreview', 'previewWebinarRecordingPublicationDto', previewWebinarRecordingPublicationDto)
            const localVarPath = `/api/webinars/events/{id}/recording-publication/preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewWebinarRecordingPublicationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {PublishWebinarRecordingDto} publishWebinarRecordingDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarRecordingPublicationControllerPublish: async (id: string, publishWebinarRecordingDto: PublishWebinarRecordingDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarRecordingPublicationControllerPublish', 'id', id)
            // verify required parameter 'publishWebinarRecordingDto' is not null or undefined
            assertParamExists('webinarRecordingPublicationControllerPublish', 'publishWebinarRecordingDto', publishWebinarRecordingDto)
            const localVarPath = `/api/webinars/events/{id}/recording-publication`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishWebinarRecordingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarRecordingPublicationControllerRevoke: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webinarRecordingPublicationControllerRevoke', 'id', id)
            const localVarPath = `/api/webinars/events/{id}/recording-publication`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebinarsApi - functional programming interface
 * @export
 */
export const WebinarsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebinarsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerAssigned(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebinarEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerAssigned(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerCancel(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerCancel(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerClosePreparation(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerClosePreparation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateWebinarDto} createWebinarDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerCreate(createWebinarDto: CreateWebinarDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerCreate(createWebinarDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} recordingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerDeleteRecording(recordingId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerDeleteRecording(recordingId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} recordingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerDownload(recordingId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarDownloadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerDownload(recordingId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerEnd(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerEnd(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerJoin(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarAdmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerJoin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebinarEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerOpen(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerOpen(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerPrepare(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerPrepare(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerPresenter(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarPresenterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerPresenter(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerPublish(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerPublish(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerReadiness(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarReadinessDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerReadiness(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerRecordingList(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebinarRecordingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerRecordingList(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerRegistrations(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebinarRegistrationAdminDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerRegistrations(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerRehearsal(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerRehearsal(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerRemove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerRemove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} registrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerResendConfirmation(id: string, registrationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarConfirmationEmailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerResendConfirmation(id, registrationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} registrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerRevoke(id: string, registrationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerRevoke(id, registrationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateWebinarDto} updateWebinarDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerUpdate(id: string, updateWebinarDto: UpdateWebinarDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerUpdate(id, updateWebinarDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerWithdrawAudience(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerWithdrawAudience(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarRecordingPublicationControllerGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarRecordingPublicationReviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarRecordingPublicationControllerGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {PreviewWebinarRecordingPublicationDto} previewWebinarRecordingPublicationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarRecordingPublicationControllerPreview(id: string, previewWebinarRecordingPublicationDto: PreviewWebinarRecordingPublicationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarRecordingPublicationPreviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarRecordingPublicationControllerPreview(id, previewWebinarRecordingPublicationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {PublishWebinarRecordingDto} publishWebinarRecordingDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarRecordingPublicationControllerPublish(id: string, publishWebinarRecordingDto: PublishWebinarRecordingDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarRecordingPublicationReviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarRecordingPublicationControllerPublish(id, publishWebinarRecordingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarRecordingPublicationControllerRevoke(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarRecordingPublicationControllerRevoke(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WebinarsApi - factory interface
 * @export
 */
export const WebinarsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebinarsApiFp(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerAssigned(options?: AxiosRequestConfig): AxiosPromise<Array<WebinarEventDto>> {
            return localVarFp.webinarControllerAssigned(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerCancelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerCancel(requestParameters: WebinarsApiWebinarControllerCancelRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarEventDto> {
            return localVarFp.webinarControllerCancel(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerClosePreparationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerClosePreparation(requestParameters: WebinarsApiWebinarControllerClosePreparationRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarEventDto> {
            return localVarFp.webinarControllerClosePreparation(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerCreate(requestParameters: WebinarsApiWebinarControllerCreateRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarEventDto> {
            return localVarFp.webinarControllerCreate(requestParameters.createWebinarDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerDeleteRecordingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerDeleteRecording(requestParameters: WebinarsApiWebinarControllerDeleteRecordingRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.webinarControllerDeleteRecording(requestParameters.recordingId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerDownloadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerDownload(requestParameters: WebinarsApiWebinarControllerDownloadRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarDownloadDto> {
            return localVarFp.webinarControllerDownload(requestParameters.recordingId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerEndRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerEnd(requestParameters: WebinarsApiWebinarControllerEndRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarEventDto> {
            return localVarFp.webinarControllerEnd(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerGet(requestParameters: WebinarsApiWebinarControllerGetRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarEventDto> {
            return localVarFp.webinarControllerGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerJoinRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerJoin(requestParameters: WebinarsApiWebinarControllerJoinRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarAdmissionDto> {
            return localVarFp.webinarControllerJoin(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerList(options?: AxiosRequestConfig): AxiosPromise<Array<WebinarEventDto>> {
            return localVarFp.webinarControllerList(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerOpenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerOpen(requestParameters: WebinarsApiWebinarControllerOpenRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarEventDto> {
            return localVarFp.webinarControllerOpen(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerPrepareRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerPrepare(requestParameters: WebinarsApiWebinarControllerPrepareRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarEventDto> {
            return localVarFp.webinarControllerPrepare(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerPresenterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerPresenter(requestParameters: WebinarsApiWebinarControllerPresenterRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarPresenterDto> {
            return localVarFp.webinarControllerPresenter(requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerPublishRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerPublish(requestParameters: WebinarsApiWebinarControllerPublishRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarEventDto> {
            return localVarFp.webinarControllerPublish(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerReadinessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerReadiness(requestParameters: WebinarsApiWebinarControllerReadinessRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarReadinessDto> {
            return localVarFp.webinarControllerReadiness(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerRecordingListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerRecordingList(requestParameters: WebinarsApiWebinarControllerRecordingListRequest, options?: AxiosRequestConfig): AxiosPromise<Array<WebinarRecordingDto>> {
            return localVarFp.webinarControllerRecordingList(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerRegistrationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerRegistrations(requestParameters: WebinarsApiWebinarControllerRegistrationsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<WebinarRegistrationAdminDto>> {
            return localVarFp.webinarControllerRegistrations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerRehearsalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerRehearsal(requestParameters: WebinarsApiWebinarControllerRehearsalRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarEventDto> {
            return localVarFp.webinarControllerRehearsal(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerRemoveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerRemove(requestParameters: WebinarsApiWebinarControllerRemoveRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.webinarControllerRemove(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerResendConfirmationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerResendConfirmation(requestParameters: WebinarsApiWebinarControllerResendConfirmationRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarConfirmationEmailDto> {
            return localVarFp.webinarControllerResendConfirmation(requestParameters.id, requestParameters.registrationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerRevokeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerRevoke(requestParameters: WebinarsApiWebinarControllerRevokeRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.webinarControllerRevoke(requestParameters.id, requestParameters.registrationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerUpdate(requestParameters: WebinarsApiWebinarControllerUpdateRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarEventDto> {
            return localVarFp.webinarControllerUpdate(requestParameters.id, requestParameters.updateWebinarDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarControllerWithdrawAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerWithdrawAudience(requestParameters: WebinarsApiWebinarControllerWithdrawAudienceRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarEventDto> {
            return localVarFp.webinarControllerWithdrawAudience(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarRecordingPublicationControllerGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarRecordingPublicationControllerGet(requestParameters: WebinarsApiWebinarRecordingPublicationControllerGetRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarRecordingPublicationReviewDto> {
            return localVarFp.webinarRecordingPublicationControllerGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarRecordingPublicationControllerPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarRecordingPublicationControllerPreview(requestParameters: WebinarsApiWebinarRecordingPublicationControllerPreviewRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarRecordingPublicationPreviewDto> {
            return localVarFp.webinarRecordingPublicationControllerPreview(requestParameters.id, requestParameters.previewWebinarRecordingPublicationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarRecordingPublicationControllerPublishRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarRecordingPublicationControllerPublish(requestParameters: WebinarsApiWebinarRecordingPublicationControllerPublishRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarRecordingPublicationReviewDto> {
            return localVarFp.webinarRecordingPublicationControllerPublish(requestParameters.id, requestParameters.publishWebinarRecordingDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebinarsApiWebinarRecordingPublicationControllerRevokeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarRecordingPublicationControllerRevoke(requestParameters: WebinarsApiWebinarRecordingPublicationControllerRevokeRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.webinarRecordingPublicationControllerRevoke(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for webinarControllerCancel operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerCancelRequest
 */
export interface WebinarsApiWebinarControllerCancelRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerCancel
     */
    readonly id: string
}

/**
 * Request parameters for webinarControllerClosePreparation operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerClosePreparationRequest
 */
export interface WebinarsApiWebinarControllerClosePreparationRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerClosePreparation
     */
    readonly id: string
}

/**
 * Request parameters for webinarControllerCreate operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerCreateRequest
 */
export interface WebinarsApiWebinarControllerCreateRequest {
    /**
     *
     * @type {CreateWebinarDto}
     * @memberof WebinarsApiWebinarControllerCreate
     */
    readonly createWebinarDto: CreateWebinarDto
}

/**
 * Request parameters for webinarControllerDeleteRecording operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerDeleteRecordingRequest
 */
export interface WebinarsApiWebinarControllerDeleteRecordingRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerDeleteRecording
     */
    readonly recordingId: string
}

/**
 * Request parameters for webinarControllerDownload operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerDownloadRequest
 */
export interface WebinarsApiWebinarControllerDownloadRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerDownload
     */
    readonly recordingId: string
}

/**
 * Request parameters for webinarControllerEnd operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerEndRequest
 */
export interface WebinarsApiWebinarControllerEndRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerEnd
     */
    readonly id: string
}

/**
 * Request parameters for webinarControllerGet operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerGetRequest
 */
export interface WebinarsApiWebinarControllerGetRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerGet
     */
    readonly id: string
}

/**
 * Request parameters for webinarControllerJoin operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerJoinRequest
 */
export interface WebinarsApiWebinarControllerJoinRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerJoin
     */
    readonly id: string
}

/**
 * Request parameters for webinarControllerOpen operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerOpenRequest
 */
export interface WebinarsApiWebinarControllerOpenRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerOpen
     */
    readonly id: string
}

/**
 * Request parameters for webinarControllerPrepare operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerPrepareRequest
 */
export interface WebinarsApiWebinarControllerPrepareRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerPrepare
     */
    readonly id: string
}

/**
 * Request parameters for webinarControllerPresenter operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerPresenterRequest
 */
export interface WebinarsApiWebinarControllerPresenterRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerPresenter
     */
    readonly email: string
}

/**
 * Request parameters for webinarControllerPublish operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerPublishRequest
 */
export interface WebinarsApiWebinarControllerPublishRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerPublish
     */
    readonly id: string
}

/**
 * Request parameters for webinarControllerReadiness operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerReadinessRequest
 */
export interface WebinarsApiWebinarControllerReadinessRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerReadiness
     */
    readonly id: string
}

/**
 * Request parameters for webinarControllerRecordingList operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerRecordingListRequest
 */
export interface WebinarsApiWebinarControllerRecordingListRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerRecordingList
     */
    readonly id: string
}

/**
 * Request parameters for webinarControllerRegistrations operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerRegistrationsRequest
 */
export interface WebinarsApiWebinarControllerRegistrationsRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerRegistrations
     */
    readonly id: string
}

/**
 * Request parameters for webinarControllerRehearsal operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerRehearsalRequest
 */
export interface WebinarsApiWebinarControllerRehearsalRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerRehearsal
     */
    readonly id: string
}

/**
 * Request parameters for webinarControllerRemove operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerRemoveRequest
 */
export interface WebinarsApiWebinarControllerRemoveRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerRemove
     */
    readonly id: string
}

/**
 * Request parameters for webinarControllerResendConfirmation operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerResendConfirmationRequest
 */
export interface WebinarsApiWebinarControllerResendConfirmationRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerResendConfirmation
     */
    readonly id: string

    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerResendConfirmation
     */
    readonly registrationId: string
}

/**
 * Request parameters for webinarControllerRevoke operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerRevokeRequest
 */
export interface WebinarsApiWebinarControllerRevokeRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerRevoke
     */
    readonly id: string

    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerRevoke
     */
    readonly registrationId: string
}

/**
 * Request parameters for webinarControllerUpdate operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerUpdateRequest
 */
export interface WebinarsApiWebinarControllerUpdateRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerUpdate
     */
    readonly id: string

    /**
     *
     * @type {UpdateWebinarDto}
     * @memberof WebinarsApiWebinarControllerUpdate
     */
    readonly updateWebinarDto: UpdateWebinarDto
}

/**
 * Request parameters for webinarControllerWithdrawAudience operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarControllerWithdrawAudienceRequest
 */
export interface WebinarsApiWebinarControllerWithdrawAudienceRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarControllerWithdrawAudience
     */
    readonly id: string
}

/**
 * Request parameters for webinarRecordingPublicationControllerGet operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarRecordingPublicationControllerGetRequest
 */
export interface WebinarsApiWebinarRecordingPublicationControllerGetRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarRecordingPublicationControllerGet
     */
    readonly id: string
}

/**
 * Request parameters for webinarRecordingPublicationControllerPreview operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarRecordingPublicationControllerPreviewRequest
 */
export interface WebinarsApiWebinarRecordingPublicationControllerPreviewRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarRecordingPublicationControllerPreview
     */
    readonly id: string

    /**
     *
     * @type {PreviewWebinarRecordingPublicationDto}
     * @memberof WebinarsApiWebinarRecordingPublicationControllerPreview
     */
    readonly previewWebinarRecordingPublicationDto: PreviewWebinarRecordingPublicationDto
}

/**
 * Request parameters for webinarRecordingPublicationControllerPublish operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarRecordingPublicationControllerPublishRequest
 */
export interface WebinarsApiWebinarRecordingPublicationControllerPublishRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarRecordingPublicationControllerPublish
     */
    readonly id: string

    /**
     *
     * @type {PublishWebinarRecordingDto}
     * @memberof WebinarsApiWebinarRecordingPublicationControllerPublish
     */
    readonly publishWebinarRecordingDto: PublishWebinarRecordingDto
}

/**
 * Request parameters for webinarRecordingPublicationControllerRevoke operation in WebinarsApi.
 * @export
 * @interface WebinarsApiWebinarRecordingPublicationControllerRevokeRequest
 */
export interface WebinarsApiWebinarRecordingPublicationControllerRevokeRequest {
    /**
     *
     * @type {string}
     * @memberof WebinarsApiWebinarRecordingPublicationControllerRevoke
     */
    readonly id: string
}

/**
 * WebinarsApi - object-oriented interface
 * @export
 * @class WebinarsApi
 * @extends {BaseAPI}
 */
export class WebinarsApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerAssigned(options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerAssigned(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerCancelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerCancel(requestParameters: WebinarsApiWebinarControllerCancelRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerCancel(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerClosePreparationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerClosePreparation(requestParameters: WebinarsApiWebinarControllerClosePreparationRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerClosePreparation(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerCreate(requestParameters: WebinarsApiWebinarControllerCreateRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerCreate(requestParameters.createWebinarDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerDeleteRecordingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerDeleteRecording(requestParameters: WebinarsApiWebinarControllerDeleteRecordingRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerDeleteRecording(requestParameters.recordingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerDownloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerDownload(requestParameters: WebinarsApiWebinarControllerDownloadRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerDownload(requestParameters.recordingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerEndRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerEnd(requestParameters: WebinarsApiWebinarControllerEndRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerEnd(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerGet(requestParameters: WebinarsApiWebinarControllerGetRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerJoinRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerJoin(requestParameters: WebinarsApiWebinarControllerJoinRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerJoin(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerList(options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerOpenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerOpen(requestParameters: WebinarsApiWebinarControllerOpenRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerOpen(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerPrepareRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerPrepare(requestParameters: WebinarsApiWebinarControllerPrepareRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerPrepare(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerPresenterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerPresenter(requestParameters: WebinarsApiWebinarControllerPresenterRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerPresenter(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerPublishRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerPublish(requestParameters: WebinarsApiWebinarControllerPublishRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerPublish(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerReadinessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerReadiness(requestParameters: WebinarsApiWebinarControllerReadinessRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerReadiness(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerRecordingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerRecordingList(requestParameters: WebinarsApiWebinarControllerRecordingListRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerRecordingList(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerRegistrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerRegistrations(requestParameters: WebinarsApiWebinarControllerRegistrationsRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerRegistrations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerRehearsalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerRehearsal(requestParameters: WebinarsApiWebinarControllerRehearsalRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerRehearsal(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerRemoveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerRemove(requestParameters: WebinarsApiWebinarControllerRemoveRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerRemove(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerResendConfirmationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerResendConfirmation(requestParameters: WebinarsApiWebinarControllerResendConfirmationRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerResendConfirmation(requestParameters.id, requestParameters.registrationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerRevokeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerRevoke(requestParameters: WebinarsApiWebinarControllerRevokeRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerRevoke(requestParameters.id, requestParameters.registrationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerUpdate(requestParameters: WebinarsApiWebinarControllerUpdateRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerUpdate(requestParameters.id, requestParameters.updateWebinarDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarControllerWithdrawAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarControllerWithdrawAudience(requestParameters: WebinarsApiWebinarControllerWithdrawAudienceRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarControllerWithdrawAudience(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarRecordingPublicationControllerGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarRecordingPublicationControllerGet(requestParameters: WebinarsApiWebinarRecordingPublicationControllerGetRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarRecordingPublicationControllerGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarRecordingPublicationControllerPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarRecordingPublicationControllerPreview(requestParameters: WebinarsApiWebinarRecordingPublicationControllerPreviewRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarRecordingPublicationControllerPreview(requestParameters.id, requestParameters.previewWebinarRecordingPublicationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarRecordingPublicationControllerPublishRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarRecordingPublicationControllerPublish(requestParameters: WebinarsApiWebinarRecordingPublicationControllerPublishRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarRecordingPublicationControllerPublish(requestParameters.id, requestParameters.publishWebinarRecordingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {WebinarsApiWebinarRecordingPublicationControllerRevokeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public webinarRecordingPublicationControllerRevoke(requestParameters: WebinarsApiWebinarRecordingPublicationControllerRevokeRequest, options?: AxiosRequestConfig) {
        return WebinarsApiFp(this.configuration).webinarRecordingPublicationControllerRevoke(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApi - axios parameter creator
 * @export
 */
export const WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Zapisz uwierzytelnioną obserwację konfiguracji dostawcy
         * @param {string} organizationId
         * @param {'ORDINARY' | 'EMERGENCY'} kind
         * @param {string} xVoiceInternalToken
         * @param {RecordReceptionDestinationProviderObservationDto} recordReceptionDestinationProviderObservationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionDestinationInternalControllerRecordProviderObservation: async (organizationId: string, kind: 'ORDINARY' | 'EMERGENCY', xVoiceInternalToken: string, recordReceptionDestinationProviderObservationDto: RecordReceptionDestinationProviderObservationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('receptionDestinationInternalControllerRecordProviderObservation', 'organizationId', organizationId)
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('receptionDestinationInternalControllerRecordProviderObservation', 'kind', kind)
            // verify required parameter 'xVoiceInternalToken' is not null or undefined
            assertParamExists('receptionDestinationInternalControllerRecordProviderObservation', 'xVoiceInternalToken', xVoiceInternalToken)
            // verify required parameter 'recordReceptionDestinationProviderObservationDto' is not null or undefined
            assertParamExists('receptionDestinationInternalControllerRecordProviderObservation', 'recordReceptionDestinationProviderObservationDto', recordReceptionDestinationProviderObservationDto)
            const localVarPath = `/api/internal/voice-reception/organizations/{organizationId}/destinations/{kind}/provider-observations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"kind"}}`, encodeURIComponent(String(kind)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xVoiceInternalToken != null) {
                localVarHeaderParameter['x-voice-internal-token'] = String(xVoiceInternalToken);
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordReceptionDestinationProviderObservationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApi - functional programming interface
 * @export
 */
export const WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Zapisz uwierzytelnioną obserwację konfiguracji dostawcy
         * @param {string} organizationId
         * @param {'ORDINARY' | 'EMERGENCY'} kind
         * @param {string} xVoiceInternalToken
         * @param {RecordReceptionDestinationProviderObservationDto} recordReceptionDestinationProviderObservationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receptionDestinationInternalControllerRecordProviderObservation(organizationId: string, kind: 'ORDINARY' | 'EMERGENCY', xVoiceInternalToken: string, recordReceptionDestinationProviderObservationDto: RecordReceptionDestinationProviderObservationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceptionDestinationRevisionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receptionDestinationInternalControllerRecordProviderObservation(organizationId, kind, xVoiceInternalToken, recordReceptionDestinationProviderObservationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApi - factory interface
 * @export
 */
export const WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApiFp(configuration)
    return {
        /**
         *
         * @summary Zapisz uwierzytelnioną obserwację konfiguracji dostawcy
         * @param {WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApiReceptionDestinationInternalControllerRecordProviderObservationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receptionDestinationInternalControllerRecordProviderObservation(requestParameters: WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApiReceptionDestinationInternalControllerRecordProviderObservationRequest, options?: AxiosRequestConfig): AxiosPromise<ReceptionDestinationRevisionResponseDto> {
            return localVarFp.receptionDestinationInternalControllerRecordProviderObservation(requestParameters.organizationId, requestParameters.kind, requestParameters.xVoiceInternalToken, requestParameters.recordReceptionDestinationProviderObservationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for receptionDestinationInternalControllerRecordProviderObservation operation in WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApi.
 * @export
 * @interface WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApiReceptionDestinationInternalControllerRecordProviderObservationRequest
 */
export interface WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApiReceptionDestinationInternalControllerRecordProviderObservationRequest {
    /**
     *
     * @type {string}
     * @memberof WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApiReceptionDestinationInternalControllerRecordProviderObservation
     */
    readonly organizationId: string

    /**
     *
     * @type {'ORDINARY' | 'EMERGENCY'}
     * @memberof WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApiReceptionDestinationInternalControllerRecordProviderObservation
     */
    readonly kind: 'ORDINARY' | 'EMERGENCY'

    /**
     *
     * @type {string}
     * @memberof WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApiReceptionDestinationInternalControllerRecordProviderObservation
     */
    readonly xVoiceInternalToken: string

    /**
     *
     * @type {RecordReceptionDestinationProviderObservationDto}
     * @memberof WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApiReceptionDestinationInternalControllerRecordProviderObservation
     */
    readonly recordReceptionDestinationProviderObservationDto: RecordReceptionDestinationProviderObservationDto
}

/**
 * WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApi - object-oriented interface
 * @export
 * @class WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApi
 * @extends {BaseAPI}
 */
export class WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApi extends BaseAPI {
    /**
     *
     * @summary Zapisz uwierzytelnioną obserwację konfiguracji dostawcy
     * @param {WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApiReceptionDestinationInternalControllerRecordProviderObservationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApi
     */
    public receptionDestinationInternalControllerRecordProviderObservation(requestParameters: WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApiReceptionDestinationInternalControllerRecordProviderObservationRequest, options?: AxiosRequestConfig) {
        return WewntrznaRekoncyliacjaKierunkwRecepcjiGosowejApiFp(this.configuration).receptionDestinationInternalControllerRecordProviderObservation(requestParameters.organizationId, requestParameters.kind, requestParameters.xVoiceInternalToken, requestParameters.recordReceptionDestinationProviderObservationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApi - axios parameter creator
 * @export
 */
export const WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Zapisz uwierzytelniony odbiór artefaktu dokładnego tekstu
         * @param {string} xVoiceInternalToken
         * @param {RecordAuthenticatedVoiceExactTextArtifactDto} recordAuthenticatedVoiceExactTextArtifactDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceExactTextArtifactInternalControllerRecord: async (xVoiceInternalToken: string, recordAuthenticatedVoiceExactTextArtifactDto: RecordAuthenticatedVoiceExactTextArtifactDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xVoiceInternalToken' is not null or undefined
            assertParamExists('voiceExactTextArtifactInternalControllerRecord', 'xVoiceInternalToken', xVoiceInternalToken)
            // verify required parameter 'recordAuthenticatedVoiceExactTextArtifactDto' is not null or undefined
            assertParamExists('voiceExactTextArtifactInternalControllerRecord', 'recordAuthenticatedVoiceExactTextArtifactDto', recordAuthenticatedVoiceExactTextArtifactDto)
            const localVarPath = `/api/internal/voice-reception/exact-text-artifacts/receipts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xVoiceInternalToken != null) {
                localVarHeaderParameter['x-voice-internal-token'] = String(xVoiceInternalToken);
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordAuthenticatedVoiceExactTextArtifactDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApi - functional programming interface
 * @export
 */
export const WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Zapisz uwierzytelniony odbiór artefaktu dokładnego tekstu
         * @param {string} xVoiceInternalToken
         * @param {RecordAuthenticatedVoiceExactTextArtifactDto} recordAuthenticatedVoiceExactTextArtifactDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceExactTextArtifactInternalControllerRecord(xVoiceInternalToken: string, recordAuthenticatedVoiceExactTextArtifactDto: RecordAuthenticatedVoiceExactTextArtifactDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceExactTextArtifactResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceExactTextArtifactInternalControllerRecord(xVoiceInternalToken, recordAuthenticatedVoiceExactTextArtifactDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApi - factory interface
 * @export
 */
export const WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApiFp(configuration)
    return {
        /**
         *
         * @summary Zapisz uwierzytelniony odbiór artefaktu dokładnego tekstu
         * @param {WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApiVoiceExactTextArtifactInternalControllerRecordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceExactTextArtifactInternalControllerRecord(requestParameters: WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApiVoiceExactTextArtifactInternalControllerRecordRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceExactTextArtifactResponseDto> {
            return localVarFp.voiceExactTextArtifactInternalControllerRecord(requestParameters.xVoiceInternalToken, requestParameters.recordAuthenticatedVoiceExactTextArtifactDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceExactTextArtifactInternalControllerRecord operation in WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApi.
 * @export
 * @interface WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApiVoiceExactTextArtifactInternalControllerRecordRequest
 */
export interface WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApiVoiceExactTextArtifactInternalControllerRecordRequest {
    /**
     *
     * @type {string}
     * @memberof WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApiVoiceExactTextArtifactInternalControllerRecord
     */
    readonly xVoiceInternalToken: string

    /**
     *
     * @type {RecordAuthenticatedVoiceExactTextArtifactDto}
     * @memberof WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApiVoiceExactTextArtifactInternalControllerRecord
     */
    readonly recordAuthenticatedVoiceExactTextArtifactDto: RecordAuthenticatedVoiceExactTextArtifactDto
}

/**
 * WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApi - object-oriented interface
 * @export
 * @class WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApi
 * @extends {BaseAPI}
 */
export class WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApi extends BaseAPI {
    /**
     *
     * @summary Zapisz uwierzytelniony odbiór artefaktu dokładnego tekstu
     * @param {WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApiVoiceExactTextArtifactInternalControllerRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApi
     */
    public voiceExactTextArtifactInternalControllerRecord(requestParameters: WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApiVoiceExactTextArtifactInternalControllerRecordRequest, options?: AxiosRequestConfig) {
        return WewntrzneArtefaktyDokadnegoTekstuRecepcjiGosowejApiFp(this.configuration).voiceExactTextArtifactInternalControllerRecord(requestParameters.xVoiceInternalToken, requestParameters.recordAuthenticatedVoiceExactTextArtifactDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WewntrzneUzgodnienieKosztwVoiceApi - axios parameter creator
 * @export
 */
export const WewntrzneUzgodnienieKosztwVoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Zapisz uwierzytelniony dowód kosztu dostawcy
         * @param {string} xVoiceInternalToken
         * @param {IngestVoiceCostReconciliationDto} ingestVoiceCostReconciliationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceCostReconciliationInternalControllerIngest: async (xVoiceInternalToken: string, ingestVoiceCostReconciliationDto: IngestVoiceCostReconciliationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xVoiceInternalToken' is not null or undefined
            assertParamExists('voiceCostReconciliationInternalControllerIngest', 'xVoiceInternalToken', xVoiceInternalToken)
            // verify required parameter 'ingestVoiceCostReconciliationDto' is not null or undefined
            assertParamExists('voiceCostReconciliationInternalControllerIngest', 'ingestVoiceCostReconciliationDto', ingestVoiceCostReconciliationDto)
            const localVarPath = `/api/internal/voice-reception/cost-reconciliations/receipts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xVoiceInternalToken != null) {
                localVarHeaderParameter['x-voice-internal-token'] = String(xVoiceInternalToken);
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ingestVoiceCostReconciliationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WewntrzneUzgodnienieKosztwVoiceApi - functional programming interface
 * @export
 */
export const WewntrzneUzgodnienieKosztwVoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WewntrzneUzgodnienieKosztwVoiceApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Zapisz uwierzytelniony dowód kosztu dostawcy
         * @param {string} xVoiceInternalToken
         * @param {IngestVoiceCostReconciliationDto} ingestVoiceCostReconciliationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceCostReconciliationInternalControllerIngest(xVoiceInternalToken: string, ingestVoiceCostReconciliationDto: IngestVoiceCostReconciliationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceCostReconciliationReceiptResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceCostReconciliationInternalControllerIngest(xVoiceInternalToken, ingestVoiceCostReconciliationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WewntrzneUzgodnienieKosztwVoiceApi - factory interface
 * @export
 */
export const WewntrzneUzgodnienieKosztwVoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WewntrzneUzgodnienieKosztwVoiceApiFp(configuration)
    return {
        /**
         *
         * @summary Zapisz uwierzytelniony dowód kosztu dostawcy
         * @param {WewntrzneUzgodnienieKosztwVoiceApiVoiceCostReconciliationInternalControllerIngestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceCostReconciliationInternalControllerIngest(requestParameters: WewntrzneUzgodnienieKosztwVoiceApiVoiceCostReconciliationInternalControllerIngestRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceCostReconciliationReceiptResponseDto> {
            return localVarFp.voiceCostReconciliationInternalControllerIngest(requestParameters.xVoiceInternalToken, requestParameters.ingestVoiceCostReconciliationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceCostReconciliationInternalControllerIngest operation in WewntrzneUzgodnienieKosztwVoiceApi.
 * @export
 * @interface WewntrzneUzgodnienieKosztwVoiceApiVoiceCostReconciliationInternalControllerIngestRequest
 */
export interface WewntrzneUzgodnienieKosztwVoiceApiVoiceCostReconciliationInternalControllerIngestRequest {
    /**
     *
     * @type {string}
     * @memberof WewntrzneUzgodnienieKosztwVoiceApiVoiceCostReconciliationInternalControllerIngest
     */
    readonly xVoiceInternalToken: string

    /**
     *
     * @type {IngestVoiceCostReconciliationDto}
     * @memberof WewntrzneUzgodnienieKosztwVoiceApiVoiceCostReconciliationInternalControllerIngest
     */
    readonly ingestVoiceCostReconciliationDto: IngestVoiceCostReconciliationDto
}

/**
 * WewntrzneUzgodnienieKosztwVoiceApi - object-oriented interface
 * @export
 * @class WewntrzneUzgodnienieKosztwVoiceApi
 * @extends {BaseAPI}
 */
export class WewntrzneUzgodnienieKosztwVoiceApi extends BaseAPI {
    /**
     *
     * @summary Zapisz uwierzytelniony dowód kosztu dostawcy
     * @param {WewntrzneUzgodnienieKosztwVoiceApiVoiceCostReconciliationInternalControllerIngestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WewntrzneUzgodnienieKosztwVoiceApi
     */
    public voiceCostReconciliationInternalControllerIngest(requestParameters: WewntrzneUzgodnienieKosztwVoiceApiVoiceCostReconciliationInternalControllerIngestRequest, options?: AxiosRequestConfig) {
        return WewntrzneUzgodnienieKosztwVoiceApiFp(this.configuration).voiceCostReconciliationInternalControllerIngest(requestParameters.xVoiceInternalToken, requestParameters.ingestVoiceCostReconciliationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WewntrznyAudytGotowociVoiceApi - axios parameter creator
 * @export
 */
export const WewntrznyAudytGotowociVoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Pobierz bieżący kanoniczny dowód audytu bez ruchu
         * @param {string} organizationId
         * @param {string} xVoiceInternalToken
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReadinessAuditInternalControllerCurrent: async (organizationId: string, xVoiceInternalToken: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReadinessAuditInternalControllerCurrent', 'organizationId', organizationId)
            // verify required parameter 'xVoiceInternalToken' is not null or undefined
            assertParamExists('voiceReadinessAuditInternalControllerCurrent', 'xVoiceInternalToken', xVoiceInternalToken)
            const localVarPath = `/api/internal/voice/readiness-audit/organizations/{organizationId}/zero-traffic-evidence`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xVoiceInternalToken != null) {
                localVarHeaderParameter['x-voice-internal-token'] = String(xVoiceInternalToken);
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WewntrznyAudytGotowociVoiceApi - functional programming interface
 * @export
 */
export const WewntrznyAudytGotowociVoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WewntrznyAudytGotowociVoiceApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Pobierz bieżący kanoniczny dowód audytu bez ruchu
         * @param {string} organizationId
         * @param {string} xVoiceInternalToken
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReadinessAuditInternalControllerCurrent(organizationId: string, xVoiceInternalToken: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReadinessAuditApplicationSnapshotResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReadinessAuditInternalControllerCurrent(organizationId, xVoiceInternalToken, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WewntrznyAudytGotowociVoiceApi - factory interface
 * @export
 */
export const WewntrznyAudytGotowociVoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WewntrznyAudytGotowociVoiceApiFp(configuration)
    return {
        /**
         *
         * @summary Pobierz bieżący kanoniczny dowód audytu bez ruchu
         * @param {WewntrznyAudytGotowociVoiceApiVoiceReadinessAuditInternalControllerCurrentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReadinessAuditInternalControllerCurrent(requestParameters: WewntrznyAudytGotowociVoiceApiVoiceReadinessAuditInternalControllerCurrentRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReadinessAuditApplicationSnapshotResponseDto> {
            return localVarFp.voiceReadinessAuditInternalControllerCurrent(requestParameters.organizationId, requestParameters.xVoiceInternalToken, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceReadinessAuditInternalControllerCurrent operation in WewntrznyAudytGotowociVoiceApi.
 * @export
 * @interface WewntrznyAudytGotowociVoiceApiVoiceReadinessAuditInternalControllerCurrentRequest
 */
export interface WewntrznyAudytGotowociVoiceApiVoiceReadinessAuditInternalControllerCurrentRequest {
    /**
     *
     * @type {string}
     * @memberof WewntrznyAudytGotowociVoiceApiVoiceReadinessAuditInternalControllerCurrent
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof WewntrznyAudytGotowociVoiceApiVoiceReadinessAuditInternalControllerCurrent
     */
    readonly xVoiceInternalToken: string

    /**
     *
     * @type {string}
     * @memberof WewntrznyAudytGotowociVoiceApiVoiceReadinessAuditInternalControllerCurrent
     */
    readonly body?: string
}

/**
 * WewntrznyAudytGotowociVoiceApi - object-oriented interface
 * @export
 * @class WewntrznyAudytGotowociVoiceApi
 * @extends {BaseAPI}
 */
export class WewntrznyAudytGotowociVoiceApi extends BaseAPI {
    /**
     *
     * @summary Pobierz bieżący kanoniczny dowód audytu bez ruchu
     * @param {WewntrznyAudytGotowociVoiceApiVoiceReadinessAuditInternalControllerCurrentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WewntrznyAudytGotowociVoiceApi
     */
    public voiceReadinessAuditInternalControllerCurrent(requestParameters: WewntrznyAudytGotowociVoiceApiVoiceReadinessAuditInternalControllerCurrentRequest, options?: AxiosRequestConfig) {
        return WewntrznyAudytGotowociVoiceApiFp(this.configuration).voiceReadinessAuditInternalControllerCurrent(requestParameters.organizationId, requestParameters.xVoiceInternalToken, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WirtualnaRecepcjaAdministracjaPlatformyApi - axios parameter creator
 * @export
 */
export const WirtualnaRecepcjaAdministracjaPlatformyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Wyłącz obsługę AI i zachowaj trasę ludzką
         * @param {string} organizationId
         * @param {string} idempotencyKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerDisable: async (organizationId: string, idempotencyKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerDisable', 'organizationId', organizationId)
            // verify required parameter 'idempotencyKey' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerDisable', 'idempotencyKey', idempotencyKey)
            const localVarPath = `/api/voice-platform/organizations/{organizationId}/voice-receptionist/disable`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz konfigurację Wirtualnej recepcji
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerGet: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerGet', 'organizationId', organizationId)
            const localVarPath = `/api/voice-platform/organizations/{organizationId}/voice-receptionist`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz szczegóły rozmowy organizacji
         * @param {string} organizationId
         * @param {string} callRef
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerGetCall: async (organizationId: string, callRef: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerGetCall', 'organizationId', organizationId)
            // verify required parameter 'callRef' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerGetCall', 'callRef', callRef)
            const localVarPath = `/api/voice-platform/organizations/{organizationId}/voice-receptionist/calls/{callRef}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"callRef"}}`, encodeURIComponent(String(callRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz transkrypcję rozmowy organizacji
         * @param {string} organizationId
         * @param {string} callRef
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerGetCallTranscript: async (organizationId: string, callRef: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerGetCallTranscript', 'organizationId', organizationId)
            // verify required parameter 'callRef' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerGetCallTranscript', 'callRef', callRef)
            const localVarPath = `/api/voice-platform/organizations/{organizationId}/voice-receptionist/calls/{callRef}/transcript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"callRef"}}`, encodeURIComponent(String(callRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz historię rozmów organizacji
         * @param {string} organizationId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerListCalls: async (organizationId: string, page?: number, limit?: number, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerListCalls', 'organizationId', organizationId)
            const localVarPath = `/api/voice-platform/organizations/{organizationId}/voice-receptionist/calls`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Rozpocznij bezpieczne nadanie numeru
         * @param {string} organizationId
         * @param {string} idempotencyKey
         * @param {VoiceReceptionistProvisionDto} voiceReceptionistProvisionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerProvision: async (organizationId: string, idempotencyKey: string, voiceReceptionistProvisionDto: VoiceReceptionistProvisionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerProvision', 'organizationId', organizationId)
            // verify required parameter 'idempotencyKey' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerProvision', 'idempotencyKey', idempotencyKey)
            // verify required parameter 'voiceReceptionistProvisionDto' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerProvision', 'voiceReceptionistProvisionDto', voiceReceptionistProvisionDto)
            const localVarPath = `/api/voice-platform/organizations/{organizationId}/voice-receptionist/provision`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceReceptionistProvisionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Bezpiecznie zastąp przypisany numer
         * @param {string} organizationId
         * @param {string} idempotencyKey
         * @param {VoiceReceptionistReplaceNumberDto} voiceReceptionistReplaceNumberDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerReplaceNumber: async (organizationId: string, idempotencyKey: string, voiceReceptionistReplaceNumberDto: VoiceReceptionistReplaceNumberDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerReplaceNumber', 'organizationId', organizationId)
            // verify required parameter 'idempotencyKey' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerReplaceNumber', 'idempotencyKey', idempotencyKey)
            // verify required parameter 'voiceReceptionistReplaceNumberDto' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerReplaceNumber', 'voiceReceptionistReplaceNumberDto', voiceReceptionistReplaceNumberDto)
            const localVarPath = `/api/voice-platform/organizations/{organizationId}/voice-receptionist/replace-number`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceReceptionistReplaceNumberDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Ponów przerwane nadanie numeru
         * @param {string} organizationId
         * @param {string} operationRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerRetry: async (organizationId: string, operationRef: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerRetry', 'organizationId', organizationId)
            // verify required parameter 'operationRef' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerRetry', 'operationRef', operationRef)
            const localVarPath = `/api/voice-platform/organizations/{organizationId}/voice-receptionist/operations/{operationRef}/retry`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"operationRef"}}`, encodeURIComponent(String(operationRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Przenieś wyłączony numer do organizacji
         * @param {string} organizationId
         * @param {string} idempotencyKey
         * @param {VoiceReceptionistTransferDto} voiceReceptionistTransferDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerTransfer: async (organizationId: string, idempotencyKey: string, voiceReceptionistTransferDto: VoiceReceptionistTransferDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerTransfer', 'organizationId', organizationId)
            // verify required parameter 'idempotencyKey' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerTransfer', 'idempotencyKey', idempotencyKey)
            // verify required parameter 'voiceReceptionistTransferDto' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerTransfer', 'voiceReceptionistTransferDto', voiceReceptionistTransferDto)
            const localVarPath = `/api/voice-platform/organizations/{organizationId}/voice-receptionist/transfer`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceReceptionistTransferDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zmień numer eskalacji
         * @param {string} organizationId
         * @param {string} idempotencyKey
         * @param {VoiceReceptionistUpdateEscalationDto} voiceReceptionistUpdateEscalationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerUpdateEscalation: async (organizationId: string, idempotencyKey: string, voiceReceptionistUpdateEscalationDto: VoiceReceptionistUpdateEscalationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerUpdateEscalation', 'organizationId', organizationId)
            // verify required parameter 'idempotencyKey' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerUpdateEscalation', 'idempotencyKey', idempotencyKey)
            // verify required parameter 'voiceReceptionistUpdateEscalationDto' is not null or undefined
            assertParamExists('voiceReceptionistPlatformControllerUpdateEscalation', 'voiceReceptionistUpdateEscalationDto', voiceReceptionistUpdateEscalationDto)
            const localVarPath = `/api/voice-platform/organizations/{organizationId}/voice-receptionist/escalation`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceReceptionistUpdateEscalationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WirtualnaRecepcjaAdministracjaPlatformyApi - functional programming interface
 * @export
 */
export const WirtualnaRecepcjaAdministracjaPlatformyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WirtualnaRecepcjaAdministracjaPlatformyApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Wyłącz obsługę AI i zachowaj trasę ludzką
         * @param {string} organizationId
         * @param {string} idempotencyKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistPlatformControllerDisable(organizationId: string, idempotencyKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistConfigurationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistPlatformControllerDisable(organizationId, idempotencyKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz konfigurację Wirtualnej recepcji
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistPlatformControllerGet(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistManagedConfigurationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistPlatformControllerGet(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz szczegóły rozmowy organizacji
         * @param {string} organizationId
         * @param {string} callRef
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistPlatformControllerGetCall(organizationId: string, callRef: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistCallDetailResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistPlatformControllerGetCall(organizationId, callRef, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz transkrypcję rozmowy organizacji
         * @param {string} organizationId
         * @param {string} callRef
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistPlatformControllerGetCallTranscript(organizationId: string, callRef: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistCallTranscriptResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistPlatformControllerGetCallTranscript(organizationId, callRef, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz historię rozmów organizacji
         * @param {string} organizationId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistPlatformControllerListCalls(organizationId: string, page?: number, limit?: number, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistCallListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistPlatformControllerListCalls(organizationId, page, limit, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Rozpocznij bezpieczne nadanie numeru
         * @param {string} organizationId
         * @param {string} idempotencyKey
         * @param {VoiceReceptionistProvisionDto} voiceReceptionistProvisionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistPlatformControllerProvision(organizationId: string, idempotencyKey: string, voiceReceptionistProvisionDto: VoiceReceptionistProvisionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistProvisioningResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistPlatformControllerProvision(organizationId, idempotencyKey, voiceReceptionistProvisionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Bezpiecznie zastąp przypisany numer
         * @param {string} organizationId
         * @param {string} idempotencyKey
         * @param {VoiceReceptionistReplaceNumberDto} voiceReceptionistReplaceNumberDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistPlatformControllerReplaceNumber(organizationId: string, idempotencyKey: string, voiceReceptionistReplaceNumberDto: VoiceReceptionistReplaceNumberDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistProvisioningResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistPlatformControllerReplaceNumber(organizationId, idempotencyKey, voiceReceptionistReplaceNumberDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Ponów przerwane nadanie numeru
         * @param {string} organizationId
         * @param {string} operationRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistPlatformControllerRetry(organizationId: string, operationRef: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistProvisioningResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistPlatformControllerRetry(organizationId, operationRef, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Przenieś wyłączony numer do organizacji
         * @param {string} organizationId
         * @param {string} idempotencyKey
         * @param {VoiceReceptionistTransferDto} voiceReceptionistTransferDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistPlatformControllerTransfer(organizationId: string, idempotencyKey: string, voiceReceptionistTransferDto: VoiceReceptionistTransferDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistProvisioningResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistPlatformControllerTransfer(organizationId, idempotencyKey, voiceReceptionistTransferDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zmień numer eskalacji
         * @param {string} organizationId
         * @param {string} idempotencyKey
         * @param {VoiceReceptionistUpdateEscalationDto} voiceReceptionistUpdateEscalationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistPlatformControllerUpdateEscalation(organizationId: string, idempotencyKey: string, voiceReceptionistUpdateEscalationDto: VoiceReceptionistUpdateEscalationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistProvisioningResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistPlatformControllerUpdateEscalation(organizationId, idempotencyKey, voiceReceptionistUpdateEscalationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WirtualnaRecepcjaAdministracjaPlatformyApi - factory interface
 * @export
 */
export const WirtualnaRecepcjaAdministracjaPlatformyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WirtualnaRecepcjaAdministracjaPlatformyApiFp(configuration)
    return {
        /**
         *
         * @summary Wyłącz obsługę AI i zachowaj trasę ludzką
         * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerDisableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerDisable(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerDisableRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistConfigurationResponseDto> {
            return localVarFp.voiceReceptionistPlatformControllerDisable(requestParameters.organizationId, requestParameters.idempotencyKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz konfigurację Wirtualnej recepcji
         * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerGet(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistManagedConfigurationResponseDto> {
            return localVarFp.voiceReceptionistPlatformControllerGet(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz szczegóły rozmowy organizacji
         * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCallRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerGetCall(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCallRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistCallDetailResponseDto> {
            return localVarFp.voiceReceptionistPlatformControllerGetCall(requestParameters.organizationId, requestParameters.callRef, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz transkrypcję rozmowy organizacji
         * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCallTranscriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerGetCallTranscript(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCallTranscriptRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistCallTranscriptResponseDto> {
            return localVarFp.voiceReceptionistPlatformControllerGetCallTranscript(requestParameters.organizationId, requestParameters.callRef, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz historię rozmów organizacji
         * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerListCallsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerListCalls(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerListCallsRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistCallListResponseDto> {
            return localVarFp.voiceReceptionistPlatformControllerListCalls(requestParameters.organizationId, requestParameters.page, requestParameters.limit, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Rozpocznij bezpieczne nadanie numeru
         * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerProvisionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerProvision(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerProvisionRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistProvisioningResponseDto> {
            return localVarFp.voiceReceptionistPlatformControllerProvision(requestParameters.organizationId, requestParameters.idempotencyKey, requestParameters.voiceReceptionistProvisionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Bezpiecznie zastąp przypisany numer
         * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerReplaceNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerReplaceNumber(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerReplaceNumberRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistProvisioningResponseDto> {
            return localVarFp.voiceReceptionistPlatformControllerReplaceNumber(requestParameters.organizationId, requestParameters.idempotencyKey, requestParameters.voiceReceptionistReplaceNumberDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Ponów przerwane nadanie numeru
         * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerRetryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerRetry(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerRetryRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistProvisioningResponseDto> {
            return localVarFp.voiceReceptionistPlatformControllerRetry(requestParameters.organizationId, requestParameters.operationRef, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Przenieś wyłączony numer do organizacji
         * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerTransferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerTransfer(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerTransferRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistProvisioningResponseDto> {
            return localVarFp.voiceReceptionistPlatformControllerTransfer(requestParameters.organizationId, requestParameters.idempotencyKey, requestParameters.voiceReceptionistTransferDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zmień numer eskalacji
         * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerUpdateEscalationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistPlatformControllerUpdateEscalation(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerUpdateEscalationRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistProvisioningResponseDto> {
            return localVarFp.voiceReceptionistPlatformControllerUpdateEscalation(requestParameters.organizationId, requestParameters.idempotencyKey, requestParameters.voiceReceptionistUpdateEscalationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceReceptionistPlatformControllerDisable operation in WirtualnaRecepcjaAdministracjaPlatformyApi.
 * @export
 * @interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerDisableRequest
 */
export interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerDisableRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerDisable
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerDisable
     */
    readonly idempotencyKey: string
}

/**
 * Request parameters for voiceReceptionistPlatformControllerGet operation in WirtualnaRecepcjaAdministracjaPlatformyApi.
 * @export
 * @interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetRequest
 */
export interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGet
     */
    readonly organizationId: string
}

/**
 * Request parameters for voiceReceptionistPlatformControllerGetCall operation in WirtualnaRecepcjaAdministracjaPlatformyApi.
 * @export
 * @interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCallRequest
 */
export interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCallRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCall
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCall
     */
    readonly callRef: string

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCall
     */
    readonly body?: string
}

/**
 * Request parameters for voiceReceptionistPlatformControllerGetCallTranscript operation in WirtualnaRecepcjaAdministracjaPlatformyApi.
 * @export
 * @interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCallTranscriptRequest
 */
export interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCallTranscriptRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCallTranscript
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCallTranscript
     */
    readonly callRef: string

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCallTranscript
     */
    readonly body?: string
}

/**
 * Request parameters for voiceReceptionistPlatformControllerListCalls operation in WirtualnaRecepcjaAdministracjaPlatformyApi.
 * @export
 * @interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerListCallsRequest
 */
export interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerListCallsRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerListCalls
     */
    readonly organizationId: string

    /**
     *
     * @type {number}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerListCalls
     */
    readonly page?: number

    /**
     *
     * @type {number}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerListCalls
     */
    readonly limit?: number

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerListCalls
     */
    readonly body?: string
}

/**
 * Request parameters for voiceReceptionistPlatformControllerProvision operation in WirtualnaRecepcjaAdministracjaPlatformyApi.
 * @export
 * @interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerProvisionRequest
 */
export interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerProvisionRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerProvision
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerProvision
     */
    readonly idempotencyKey: string

    /**
     *
     * @type {VoiceReceptionistProvisionDto}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerProvision
     */
    readonly voiceReceptionistProvisionDto: VoiceReceptionistProvisionDto
}

/**
 * Request parameters for voiceReceptionistPlatformControllerReplaceNumber operation in WirtualnaRecepcjaAdministracjaPlatformyApi.
 * @export
 * @interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerReplaceNumberRequest
 */
export interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerReplaceNumberRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerReplaceNumber
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerReplaceNumber
     */
    readonly idempotencyKey: string

    /**
     *
     * @type {VoiceReceptionistReplaceNumberDto}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerReplaceNumber
     */
    readonly voiceReceptionistReplaceNumberDto: VoiceReceptionistReplaceNumberDto
}

/**
 * Request parameters for voiceReceptionistPlatformControllerRetry operation in WirtualnaRecepcjaAdministracjaPlatformyApi.
 * @export
 * @interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerRetryRequest
 */
export interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerRetryRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerRetry
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerRetry
     */
    readonly operationRef: string
}

/**
 * Request parameters for voiceReceptionistPlatformControllerTransfer operation in WirtualnaRecepcjaAdministracjaPlatformyApi.
 * @export
 * @interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerTransferRequest
 */
export interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerTransferRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerTransfer
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerTransfer
     */
    readonly idempotencyKey: string

    /**
     *
     * @type {VoiceReceptionistTransferDto}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerTransfer
     */
    readonly voiceReceptionistTransferDto: VoiceReceptionistTransferDto
}

/**
 * Request parameters for voiceReceptionistPlatformControllerUpdateEscalation operation in WirtualnaRecepcjaAdministracjaPlatformyApi.
 * @export
 * @interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerUpdateEscalationRequest
 */
export interface WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerUpdateEscalationRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerUpdateEscalation
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerUpdateEscalation
     */
    readonly idempotencyKey: string

    /**
     *
     * @type {VoiceReceptionistUpdateEscalationDto}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerUpdateEscalation
     */
    readonly voiceReceptionistUpdateEscalationDto: VoiceReceptionistUpdateEscalationDto
}

/**
 * WirtualnaRecepcjaAdministracjaPlatformyApi - object-oriented interface
 * @export
 * @class WirtualnaRecepcjaAdministracjaPlatformyApi
 * @extends {BaseAPI}
 */
export class WirtualnaRecepcjaAdministracjaPlatformyApi extends BaseAPI {
    /**
     *
     * @summary Wyłącz obsługę AI i zachowaj trasę ludzką
     * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerDisableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApi
     */
    public voiceReceptionistPlatformControllerDisable(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerDisableRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaAdministracjaPlatformyApiFp(this.configuration).voiceReceptionistPlatformControllerDisable(requestParameters.organizationId, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz konfigurację Wirtualnej recepcji
     * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApi
     */
    public voiceReceptionistPlatformControllerGet(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaAdministracjaPlatformyApiFp(this.configuration).voiceReceptionistPlatformControllerGet(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz szczegóły rozmowy organizacji
     * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCallRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApi
     */
    public voiceReceptionistPlatformControllerGetCall(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCallRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaAdministracjaPlatformyApiFp(this.configuration).voiceReceptionistPlatformControllerGetCall(requestParameters.organizationId, requestParameters.callRef, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz transkrypcję rozmowy organizacji
     * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCallTranscriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApi
     */
    public voiceReceptionistPlatformControllerGetCallTranscript(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerGetCallTranscriptRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaAdministracjaPlatformyApiFp(this.configuration).voiceReceptionistPlatformControllerGetCallTranscript(requestParameters.organizationId, requestParameters.callRef, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz historię rozmów organizacji
     * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerListCallsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApi
     */
    public voiceReceptionistPlatformControllerListCalls(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerListCallsRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaAdministracjaPlatformyApiFp(this.configuration).voiceReceptionistPlatformControllerListCalls(requestParameters.organizationId, requestParameters.page, requestParameters.limit, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Rozpocznij bezpieczne nadanie numeru
     * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerProvisionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApi
     */
    public voiceReceptionistPlatformControllerProvision(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerProvisionRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaAdministracjaPlatformyApiFp(this.configuration).voiceReceptionistPlatformControllerProvision(requestParameters.organizationId, requestParameters.idempotencyKey, requestParameters.voiceReceptionistProvisionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Bezpiecznie zastąp przypisany numer
     * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerReplaceNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApi
     */
    public voiceReceptionistPlatformControllerReplaceNumber(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerReplaceNumberRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaAdministracjaPlatformyApiFp(this.configuration).voiceReceptionistPlatformControllerReplaceNumber(requestParameters.organizationId, requestParameters.idempotencyKey, requestParameters.voiceReceptionistReplaceNumberDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Ponów przerwane nadanie numeru
     * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerRetryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApi
     */
    public voiceReceptionistPlatformControllerRetry(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerRetryRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaAdministracjaPlatformyApiFp(this.configuration).voiceReceptionistPlatformControllerRetry(requestParameters.organizationId, requestParameters.operationRef, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Przenieś wyłączony numer do organizacji
     * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerTransferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApi
     */
    public voiceReceptionistPlatformControllerTransfer(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerTransferRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaAdministracjaPlatformyApiFp(this.configuration).voiceReceptionistPlatformControllerTransfer(requestParameters.organizationId, requestParameters.idempotencyKey, requestParameters.voiceReceptionistTransferDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zmień numer eskalacji
     * @param {WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerUpdateEscalationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaAdministracjaPlatformyApi
     */
    public voiceReceptionistPlatformControllerUpdateEscalation(requestParameters: WirtualnaRecepcjaAdministracjaPlatformyApiVoiceReceptionistPlatformControllerUpdateEscalationRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaAdministracjaPlatformyApiFp(this.configuration).voiceReceptionistPlatformControllerUpdateEscalation(requestParameters.organizationId, requestParameters.idempotencyKey, requestParameters.voiceReceptionistUpdateEscalationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WirtualnaRecepcjaOrganizacjaApi - axios parameter creator
 * @export
 */
export const WirtualnaRecepcjaOrganizacjaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Pobierz ustawienia Wirtualnej recepcji
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistOrganizationControllerGet: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistOrganizationControllerGet', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-receptionist`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz szczegóły rozmowy recepcji
         * @param {string} organizationId
         * @param {string} callRef
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistOrganizationControllerGetCall: async (organizationId: string, callRef: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistOrganizationControllerGetCall', 'organizationId', organizationId)
            // verify required parameter 'callRef' is not null or undefined
            assertParamExists('voiceReceptionistOrganizationControllerGetCall', 'callRef', callRef)
            const localVarPath = `/api/organizations/{organizationId}/voice-receptionist/calls/{callRef}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"callRef"}}`, encodeURIComponent(String(callRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz transkrypcję rozmowy recepcji
         * @param {string} organizationId
         * @param {string} callRef
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistOrganizationControllerGetCallTranscript: async (organizationId: string, callRef: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistOrganizationControllerGetCallTranscript', 'organizationId', organizationId)
            // verify required parameter 'callRef' is not null or undefined
            assertParamExists('voiceReceptionistOrganizationControllerGetCallTranscript', 'callRef', callRef)
            const localVarPath = `/api/organizations/{organizationId}/voice-receptionist/calls/{callRef}/transcript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"callRef"}}`, encodeURIComponent(String(callRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz historię rozmów recepcji
         * @param {string} organizationId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistOrganizationControllerListCalls: async (organizationId: string, page?: number, limit?: number, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistOrganizationControllerListCalls', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-receptionist/calls`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz usługi dostępne dla recepcji
         * @param {string} organizationId
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistOrganizationControllerListSelectableServices: async (organizationId: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistOrganizationControllerListSelectableServices', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organizationId}/voice-receptionist/selectable-services`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zmień numer eskalacji
         * @param {string} organizationId
         * @param {string} idempotencyKey
         * @param {VoiceReceptionistUpdateEscalationDto} voiceReceptionistUpdateEscalationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistOrganizationControllerUpdateEscalation: async (organizationId: string, idempotencyKey: string, voiceReceptionistUpdateEscalationDto: VoiceReceptionistUpdateEscalationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistOrganizationControllerUpdateEscalation', 'organizationId', organizationId)
            // verify required parameter 'idempotencyKey' is not null or undefined
            assertParamExists('voiceReceptionistOrganizationControllerUpdateEscalation', 'idempotencyKey', idempotencyKey)
            // verify required parameter 'voiceReceptionistUpdateEscalationDto' is not null or undefined
            assertParamExists('voiceReceptionistOrganizationControllerUpdateEscalation', 'voiceReceptionistUpdateEscalationDto', voiceReceptionistUpdateEscalationDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-receptionist/escalation`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceReceptionistUpdateEscalationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zmień powitanie i aktywne usługi
         * @param {string} organizationId
         * @param {VoiceReceptionistUpdateSettingsDto} voiceReceptionistUpdateSettingsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistOrganizationControllerUpdateSettings: async (organizationId: string, voiceReceptionistUpdateSettingsDto: VoiceReceptionistUpdateSettingsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceReceptionistOrganizationControllerUpdateSettings', 'organizationId', organizationId)
            // verify required parameter 'voiceReceptionistUpdateSettingsDto' is not null or undefined
            assertParamExists('voiceReceptionistOrganizationControllerUpdateSettings', 'voiceReceptionistUpdateSettingsDto', voiceReceptionistUpdateSettingsDto)
            const localVarPath = `/api/organizations/{organizationId}/voice-receptionist/settings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceReceptionistUpdateSettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WirtualnaRecepcjaOrganizacjaApi - functional programming interface
 * @export
 */
export const WirtualnaRecepcjaOrganizacjaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WirtualnaRecepcjaOrganizacjaApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Pobierz ustawienia Wirtualnej recepcji
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistOrganizationControllerGet(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistManagedConfigurationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistOrganizationControllerGet(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz szczegóły rozmowy recepcji
         * @param {string} organizationId
         * @param {string} callRef
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistOrganizationControllerGetCall(organizationId: string, callRef: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistCallDetailResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistOrganizationControllerGetCall(organizationId, callRef, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz transkrypcję rozmowy recepcji
         * @param {string} organizationId
         * @param {string} callRef
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistOrganizationControllerGetCallTranscript(organizationId: string, callRef: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistCallTranscriptResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistOrganizationControllerGetCallTranscript(organizationId, callRef, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz historię rozmów recepcji
         * @param {string} organizationId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistOrganizationControllerListCalls(organizationId: string, page?: number, limit?: number, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistCallListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistOrganizationControllerListCalls(organizationId, page, limit, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz usługi dostępne dla recepcji
         * @param {string} organizationId
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistOrganizationControllerListSelectableServices(organizationId: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistSelectableServicesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistOrganizationControllerListSelectableServices(organizationId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zmień numer eskalacji
         * @param {string} organizationId
         * @param {string} idempotencyKey
         * @param {VoiceReceptionistUpdateEscalationDto} voiceReceptionistUpdateEscalationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistOrganizationControllerUpdateEscalation(organizationId: string, idempotencyKey: string, voiceReceptionistUpdateEscalationDto: VoiceReceptionistUpdateEscalationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistProvisioningResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistOrganizationControllerUpdateEscalation(organizationId, idempotencyKey, voiceReceptionistUpdateEscalationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zmień powitanie i aktywne usługi
         * @param {string} organizationId
         * @param {VoiceReceptionistUpdateSettingsDto} voiceReceptionistUpdateSettingsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceReceptionistOrganizationControllerUpdateSettings(organizationId: string, voiceReceptionistUpdateSettingsDto: VoiceReceptionistUpdateSettingsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceReceptionistManagedConfigurationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceReceptionistOrganizationControllerUpdateSettings(organizationId, voiceReceptionistUpdateSettingsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WirtualnaRecepcjaOrganizacjaApi - factory interface
 * @export
 */
export const WirtualnaRecepcjaOrganizacjaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WirtualnaRecepcjaOrganizacjaApiFp(configuration)
    return {
        /**
         *
         * @summary Pobierz ustawienia Wirtualnej recepcji
         * @param {WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistOrganizationControllerGet(requestParameters: WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistManagedConfigurationResponseDto> {
            return localVarFp.voiceReceptionistOrganizationControllerGet(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz szczegóły rozmowy recepcji
         * @param {WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCallRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistOrganizationControllerGetCall(requestParameters: WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCallRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistCallDetailResponseDto> {
            return localVarFp.voiceReceptionistOrganizationControllerGetCall(requestParameters.organizationId, requestParameters.callRef, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz transkrypcję rozmowy recepcji
         * @param {WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCallTranscriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistOrganizationControllerGetCallTranscript(requestParameters: WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCallTranscriptRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistCallTranscriptResponseDto> {
            return localVarFp.voiceReceptionistOrganizationControllerGetCallTranscript(requestParameters.organizationId, requestParameters.callRef, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz historię rozmów recepcji
         * @param {WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListCallsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistOrganizationControllerListCalls(requestParameters: WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListCallsRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistCallListResponseDto> {
            return localVarFp.voiceReceptionistOrganizationControllerListCalls(requestParameters.organizationId, requestParameters.page, requestParameters.limit, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz usługi dostępne dla recepcji
         * @param {WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListSelectableServicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistOrganizationControllerListSelectableServices(requestParameters: WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListSelectableServicesRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistSelectableServicesResponseDto> {
            return localVarFp.voiceReceptionistOrganizationControllerListSelectableServices(requestParameters.organizationId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zmień numer eskalacji
         * @param {WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateEscalationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistOrganizationControllerUpdateEscalation(requestParameters: WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateEscalationRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistProvisioningResponseDto> {
            return localVarFp.voiceReceptionistOrganizationControllerUpdateEscalation(requestParameters.organizationId, requestParameters.idempotencyKey, requestParameters.voiceReceptionistUpdateEscalationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zmień powitanie i aktywne usługi
         * @param {WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceReceptionistOrganizationControllerUpdateSettings(requestParameters: WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateSettingsRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceReceptionistManagedConfigurationResponseDto> {
            return localVarFp.voiceReceptionistOrganizationControllerUpdateSettings(requestParameters.organizationId, requestParameters.voiceReceptionistUpdateSettingsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceReceptionistOrganizationControllerGet operation in WirtualnaRecepcjaOrganizacjaApi.
 * @export
 * @interface WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetRequest
 */
export interface WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGet
     */
    readonly organizationId: string
}

/**
 * Request parameters for voiceReceptionistOrganizationControllerGetCall operation in WirtualnaRecepcjaOrganizacjaApi.
 * @export
 * @interface WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCallRequest
 */
export interface WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCallRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCall
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCall
     */
    readonly callRef: string

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCall
     */
    readonly body?: string
}

/**
 * Request parameters for voiceReceptionistOrganizationControllerGetCallTranscript operation in WirtualnaRecepcjaOrganizacjaApi.
 * @export
 * @interface WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCallTranscriptRequest
 */
export interface WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCallTranscriptRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCallTranscript
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCallTranscript
     */
    readonly callRef: string

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCallTranscript
     */
    readonly body?: string
}

/**
 * Request parameters for voiceReceptionistOrganizationControllerListCalls operation in WirtualnaRecepcjaOrganizacjaApi.
 * @export
 * @interface WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListCallsRequest
 */
export interface WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListCallsRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListCalls
     */
    readonly organizationId: string

    /**
     *
     * @type {number}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListCalls
     */
    readonly page?: number

    /**
     *
     * @type {number}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListCalls
     */
    readonly limit?: number

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListCalls
     */
    readonly body?: string
}

/**
 * Request parameters for voiceReceptionistOrganizationControllerListSelectableServices operation in WirtualnaRecepcjaOrganizacjaApi.
 * @export
 * @interface WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListSelectableServicesRequest
 */
export interface WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListSelectableServicesRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListSelectableServices
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListSelectableServices
     */
    readonly body?: string
}

/**
 * Request parameters for voiceReceptionistOrganizationControllerUpdateEscalation operation in WirtualnaRecepcjaOrganizacjaApi.
 * @export
 * @interface WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateEscalationRequest
 */
export interface WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateEscalationRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateEscalation
     */
    readonly organizationId: string

    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateEscalation
     */
    readonly idempotencyKey: string

    /**
     *
     * @type {VoiceReceptionistUpdateEscalationDto}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateEscalation
     */
    readonly voiceReceptionistUpdateEscalationDto: VoiceReceptionistUpdateEscalationDto
}

/**
 * Request parameters for voiceReceptionistOrganizationControllerUpdateSettings operation in WirtualnaRecepcjaOrganizacjaApi.
 * @export
 * @interface WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateSettingsRequest
 */
export interface WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateSettingsRequest {
    /**
     *
     * @type {string}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateSettings
     */
    readonly organizationId: string

    /**
     *
     * @type {VoiceReceptionistUpdateSettingsDto}
     * @memberof WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateSettings
     */
    readonly voiceReceptionistUpdateSettingsDto: VoiceReceptionistUpdateSettingsDto
}

/**
 * WirtualnaRecepcjaOrganizacjaApi - object-oriented interface
 * @export
 * @class WirtualnaRecepcjaOrganizacjaApi
 * @extends {BaseAPI}
 */
export class WirtualnaRecepcjaOrganizacjaApi extends BaseAPI {
    /**
     *
     * @summary Pobierz ustawienia Wirtualnej recepcji
     * @param {WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaOrganizacjaApi
     */
    public voiceReceptionistOrganizationControllerGet(requestParameters: WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaOrganizacjaApiFp(this.configuration).voiceReceptionistOrganizationControllerGet(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz szczegóły rozmowy recepcji
     * @param {WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCallRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaOrganizacjaApi
     */
    public voiceReceptionistOrganizationControllerGetCall(requestParameters: WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCallRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaOrganizacjaApiFp(this.configuration).voiceReceptionistOrganizationControllerGetCall(requestParameters.organizationId, requestParameters.callRef, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz transkrypcję rozmowy recepcji
     * @param {WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCallTranscriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaOrganizacjaApi
     */
    public voiceReceptionistOrganizationControllerGetCallTranscript(requestParameters: WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerGetCallTranscriptRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaOrganizacjaApiFp(this.configuration).voiceReceptionistOrganizationControllerGetCallTranscript(requestParameters.organizationId, requestParameters.callRef, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz historię rozmów recepcji
     * @param {WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListCallsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaOrganizacjaApi
     */
    public voiceReceptionistOrganizationControllerListCalls(requestParameters: WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListCallsRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaOrganizacjaApiFp(this.configuration).voiceReceptionistOrganizationControllerListCalls(requestParameters.organizationId, requestParameters.page, requestParameters.limit, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz usługi dostępne dla recepcji
     * @param {WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListSelectableServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaOrganizacjaApi
     */
    public voiceReceptionistOrganizationControllerListSelectableServices(requestParameters: WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerListSelectableServicesRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaOrganizacjaApiFp(this.configuration).voiceReceptionistOrganizationControllerListSelectableServices(requestParameters.organizationId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zmień numer eskalacji
     * @param {WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateEscalationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaOrganizacjaApi
     */
    public voiceReceptionistOrganizationControllerUpdateEscalation(requestParameters: WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateEscalationRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaOrganizacjaApiFp(this.configuration).voiceReceptionistOrganizationControllerUpdateEscalation(requestParameters.organizationId, requestParameters.idempotencyKey, requestParameters.voiceReceptionistUpdateEscalationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zmień powitanie i aktywne usługi
     * @param {WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WirtualnaRecepcjaOrganizacjaApi
     */
    public voiceReceptionistOrganizationControllerUpdateSettings(requestParameters: WirtualnaRecepcjaOrganizacjaApiVoiceReceptionistOrganizationControllerUpdateSettingsRequest, options?: AxiosRequestConfig) {
        return WirtualnaRecepcjaOrganizacjaApiFp(this.configuration).voiceReceptionistOrganizationControllerUpdateSettings(requestParameters.organizationId, requestParameters.voiceReceptionistUpdateSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WoocommerceApi - axios parameter creator
 * @export
 */
export const WoocommerceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get all WooCommerce categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wooCommerceControllerGetCategories: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/woocommerce/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get product details by ID
         * @param {number} productId Product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wooCommerceControllerGetProductById: async (productId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('wooCommerceControllerGetProductById', 'productId', productId)
            const localVarPath = `/api/woocommerce/products/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get products by category ID or all products with optional search
         * @param {number} [categoryId] Category ID (optional - if not provided, returns all products)
         * @param {number} [page] Page number
         * @param {number} [perPage] Products per page
         * @param {string} [search] Search query to filter products by name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wooCommerceControllerGetProductsByCategory: async (categoryId?: number, page?: number, perPage?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/woocommerce/products/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get random products filtered by user pet categories
         * @param {number} [count] Number of random products to fetch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wooCommerceControllerGetRandomProducts: async (count?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/woocommerce/products/random`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WoocommerceApi - functional programming interface
 * @export
 */
export const WoocommerceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WoocommerceApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get all WooCommerce categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wooCommerceControllerGetCategories(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wooCommerceControllerGetCategories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get product details by ID
         * @param {number} productId Product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wooCommerceControllerGetProductById(productId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wooCommerceControllerGetProductById(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get products by category ID or all products with optional search
         * @param {number} [categoryId] Category ID (optional - if not provided, returns all products)
         * @param {number} [page] Page number
         * @param {number} [perPage] Products per page
         * @param {string} [search] Search query to filter products by name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wooCommerceControllerGetProductsByCategory(categoryId?: number, page?: number, perPage?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wooCommerceControllerGetProductsByCategory(categoryId, page, perPage, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get random products filtered by user pet categories
         * @param {number} [count] Number of random products to fetch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wooCommerceControllerGetRandomProducts(count?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wooCommerceControllerGetRandomProducts(count, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WoocommerceApi - factory interface
 * @export
 */
export const WoocommerceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WoocommerceApiFp(configuration)
    return {
        /**
         *
         * @summary Get all WooCommerce categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wooCommerceControllerGetCategories(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.wooCommerceControllerGetCategories(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get product details by ID
         * @param {WoocommerceApiWooCommerceControllerGetProductByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wooCommerceControllerGetProductById(requestParameters: WoocommerceApiWooCommerceControllerGetProductByIdRequest, options?: AxiosRequestConfig): AxiosPromise<ProductResponseDto> {
            return localVarFp.wooCommerceControllerGetProductById(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get products by category ID or all products with optional search
         * @param {WoocommerceApiWooCommerceControllerGetProductsByCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wooCommerceControllerGetProductsByCategory(requestParameters: WoocommerceApiWooCommerceControllerGetProductsByCategoryRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ProductsListResponseDto> {
            return localVarFp.wooCommerceControllerGetProductsByCategory(requestParameters.categoryId, requestParameters.page, requestParameters.perPage, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get random products filtered by user pet categories
         * @param {WoocommerceApiWooCommerceControllerGetRandomProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wooCommerceControllerGetRandomProducts(requestParameters: WoocommerceApiWooCommerceControllerGetRandomProductsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ProductResponseDto>> {
            return localVarFp.wooCommerceControllerGetRandomProducts(requestParameters.count, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for wooCommerceControllerGetProductById operation in WoocommerceApi.
 * @export
 * @interface WoocommerceApiWooCommerceControllerGetProductByIdRequest
 */
export interface WoocommerceApiWooCommerceControllerGetProductByIdRequest {
    /**
     * Product ID
     * @type {number}
     * @memberof WoocommerceApiWooCommerceControllerGetProductById
     */
    readonly productId: number
}

/**
 * Request parameters for wooCommerceControllerGetProductsByCategory operation in WoocommerceApi.
 * @export
 * @interface WoocommerceApiWooCommerceControllerGetProductsByCategoryRequest
 */
export interface WoocommerceApiWooCommerceControllerGetProductsByCategoryRequest {
    /**
     * Category ID (optional - if not provided, returns all products)
     * @type {number}
     * @memberof WoocommerceApiWooCommerceControllerGetProductsByCategory
     */
    readonly categoryId?: number

    /**
     * Page number
     * @type {number}
     * @memberof WoocommerceApiWooCommerceControllerGetProductsByCategory
     */
    readonly page?: number

    /**
     * Products per page
     * @type {number}
     * @memberof WoocommerceApiWooCommerceControllerGetProductsByCategory
     */
    readonly perPage?: number

    /**
     * Search query to filter products by name
     * @type {string}
     * @memberof WoocommerceApiWooCommerceControllerGetProductsByCategory
     */
    readonly search?: string
}

/**
 * Request parameters for wooCommerceControllerGetRandomProducts operation in WoocommerceApi.
 * @export
 * @interface WoocommerceApiWooCommerceControllerGetRandomProductsRequest
 */
export interface WoocommerceApiWooCommerceControllerGetRandomProductsRequest {
    /**
     * Number of random products to fetch
     * @type {number}
     * @memberof WoocommerceApiWooCommerceControllerGetRandomProducts
     */
    readonly count?: number
}

/**
 * WoocommerceApi - object-oriented interface
 * @export
 * @class WoocommerceApi
 * @extends {BaseAPI}
 */
export class WoocommerceApi extends BaseAPI {
    /**
     *
     * @summary Get all WooCommerce categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WoocommerceApi
     */
    public wooCommerceControllerGetCategories(options?: AxiosRequestConfig) {
        return WoocommerceApiFp(this.configuration).wooCommerceControllerGetCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get product details by ID
     * @param {WoocommerceApiWooCommerceControllerGetProductByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WoocommerceApi
     */
    public wooCommerceControllerGetProductById(requestParameters: WoocommerceApiWooCommerceControllerGetProductByIdRequest, options?: AxiosRequestConfig) {
        return WoocommerceApiFp(this.configuration).wooCommerceControllerGetProductById(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get products by category ID or all products with optional search
     * @param {WoocommerceApiWooCommerceControllerGetProductsByCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WoocommerceApi
     */
    public wooCommerceControllerGetProductsByCategory(requestParameters: WoocommerceApiWooCommerceControllerGetProductsByCategoryRequest = {}, options?: AxiosRequestConfig) {
        return WoocommerceApiFp(this.configuration).wooCommerceControllerGetProductsByCategory(requestParameters.categoryId, requestParameters.page, requestParameters.perPage, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get random products filtered by user pet categories
     * @param {WoocommerceApiWooCommerceControllerGetRandomProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WoocommerceApi
     */
    public wooCommerceControllerGetRandomProducts(requestParameters: WoocommerceApiWooCommerceControllerGetRandomProductsRequest = {}, options?: AxiosRequestConfig) {
        return WoocommerceApiFp(this.configuration).wooCommerceControllerGetRandomProducts(requestParameters.count, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ZarzdzanieWnioskamiODaneRecepcjiGosowejApi - axios parameter creator
 * @export
 */
export const ZarzdzanieWnioskamiODaneRecepcjiGosowejApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Rozpocznij ocenę zweryfikowanego wniosku
         * @param {string} requestId
         * @param {VoiceDsrRevisionCommandDto} voiceDsrRevisionCommandDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDataSubjectGovernanceControllerBeginReview: async (requestId: string, voiceDsrRevisionCommandDto: VoiceDsrRevisionCommandDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('voiceDataSubjectGovernanceControllerBeginReview', 'requestId', requestId)
            // verify required parameter 'voiceDsrRevisionCommandDto' is not null or undefined
            assertParamExists('voiceDataSubjectGovernanceControllerBeginReview', 'voiceDsrRevisionCommandDto', voiceDsrRevisionCommandDto)
            const localVarPath = `/api/voice-platform/privacy/data-subject-requests/{requestId}/review/start`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceDsrRevisionCommandDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zakończ wniosek z kontrolowanym wynikiem
         * @param {string} requestId
         * @param {CompleteVoiceDsrDto} completeVoiceDsrDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDataSubjectGovernanceControllerComplete: async (requestId: string, completeVoiceDsrDto: CompleteVoiceDsrDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('voiceDataSubjectGovernanceControllerComplete', 'requestId', requestId)
            // verify required parameter 'completeVoiceDsrDto' is not null or undefined
            assertParamExists('voiceDataSubjectGovernanceControllerComplete', 'completeVoiceDsrDto', completeVoiceDsrDto)
            const localVarPath = `/api/voice-platform/privacy/data-subject-requests/{requestId}/complete`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeVoiceDsrDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz zminimalizowaną kolejkę wniosków o dane
         * @param {'PENDING_HUMAN_REVIEW' | 'IN_REVIEW' | 'RESTRICTED' | 'DEFERRED_BY_LEGAL_HOLD' | 'COMPLETED' | 'REJECTED'} [status]
         * @param {'ACCESS' | 'CORRECTION' | 'RESTRICTION' | 'ERASURE'} [right]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDataSubjectGovernanceControllerList: async (status?: 'PENDING_HUMAN_REVIEW' | 'IN_REVIEW' | 'RESTRICTED' | 'DEFERRED_BY_LEGAL_HOLD' | 'COMPLETED' | 'REJECTED', right?: 'ACCESS' | 'CORRECTION' | 'RESTRICTION' | 'ERASURE', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voice-platform/privacy/data-subject-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (right !== undefined) {
                localVarQueryParameter['right'] = right;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Nałóż ograniczone czasowo wstrzymanie usunięcia
         * @param {string} requestId
         * @param {PlaceVoiceDsrLegalHoldDto} placeVoiceDsrLegalHoldDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDataSubjectGovernanceControllerPlaceLegalHold: async (requestId: string, placeVoiceDsrLegalHoldDto: PlaceVoiceDsrLegalHoldDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('voiceDataSubjectGovernanceControllerPlaceLegalHold', 'requestId', requestId)
            // verify required parameter 'placeVoiceDsrLegalHoldDto' is not null or undefined
            assertParamExists('voiceDataSubjectGovernanceControllerPlaceLegalHold', 'placeVoiceDsrLegalHoldDto', placeVoiceDsrLegalHoldDto)
            const localVarPath = `/api/voice-platform/privacy/data-subject-requests/{requestId}/legal-hold`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeVoiceDsrLegalHoldDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Odrzuć wniosek z kontrolowanym powodem
         * @param {string} requestId
         * @param {RejectVoiceDsrDto} rejectVoiceDsrDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDataSubjectGovernanceControllerReject: async (requestId: string, rejectVoiceDsrDto: RejectVoiceDsrDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('voiceDataSubjectGovernanceControllerReject', 'requestId', requestId)
            // verify required parameter 'rejectVoiceDsrDto' is not null or undefined
            assertParamExists('voiceDataSubjectGovernanceControllerReject', 'rejectVoiceDsrDto', rejectVoiceDsrDto)
            const localVarPath = `/api/voice-platform/privacy/data-subject-requests/{requestId}/reject`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectVoiceDsrDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zwolnij wstrzymanie usunięcia
         * @param {string} requestId
         * @param {VoiceDsrRevisionCommandDto} voiceDsrRevisionCommandDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDataSubjectGovernanceControllerReleaseLegalHold: async (requestId: string, voiceDsrRevisionCommandDto: VoiceDsrRevisionCommandDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('voiceDataSubjectGovernanceControllerReleaseLegalHold', 'requestId', requestId)
            // verify required parameter 'voiceDsrRevisionCommandDto' is not null or undefined
            assertParamExists('voiceDataSubjectGovernanceControllerReleaseLegalHold', 'voiceDsrRevisionCommandDto', voiceDsrRevisionCommandDto)
            const localVarPath = `/api/voice-platform/privacy/data-subject-requests/{requestId}/legal-hold/release`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceDsrRevisionCommandDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Zaplanuj usunięcie wyłącznie dopasowanych zasobów
         * @param {string} requestId
         * @param {ScheduleVoiceDsrErasureDto} scheduleVoiceDsrErasureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDataSubjectGovernanceControllerScheduleErasure: async (requestId: string, scheduleVoiceDsrErasureDto: ScheduleVoiceDsrErasureDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('voiceDataSubjectGovernanceControllerScheduleErasure', 'requestId', requestId)
            // verify required parameter 'scheduleVoiceDsrErasureDto' is not null or undefined
            assertParamExists('voiceDataSubjectGovernanceControllerScheduleErasure', 'scheduleVoiceDsrErasureDto', scheduleVoiceDsrErasureDto)
            const localVarPath = `/api/voice-platform/privacy/data-subject-requests/{requestId}/erasure/schedule`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleVoiceDsrErasureDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZarzdzanieWnioskamiODaneRecepcjiGosowejApi - functional programming interface
 * @export
 */
export const ZarzdzanieWnioskamiODaneRecepcjiGosowejApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZarzdzanieWnioskamiODaneRecepcjiGosowejApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Rozpocznij ocenę zweryfikowanego wniosku
         * @param {string} requestId
         * @param {VoiceDsrRevisionCommandDto} voiceDsrRevisionCommandDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceDataSubjectGovernanceControllerBeginReview(requestId: string, voiceDsrRevisionCommandDto: VoiceDsrRevisionCommandDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceDsrGovernanceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceDataSubjectGovernanceControllerBeginReview(requestId, voiceDsrRevisionCommandDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zakończ wniosek z kontrolowanym wynikiem
         * @param {string} requestId
         * @param {CompleteVoiceDsrDto} completeVoiceDsrDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceDataSubjectGovernanceControllerComplete(requestId: string, completeVoiceDsrDto: CompleteVoiceDsrDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceDsrGovernanceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceDataSubjectGovernanceControllerComplete(requestId, completeVoiceDsrDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz zminimalizowaną kolejkę wniosków o dane
         * @param {'PENDING_HUMAN_REVIEW' | 'IN_REVIEW' | 'RESTRICTED' | 'DEFERRED_BY_LEGAL_HOLD' | 'COMPLETED' | 'REJECTED'} [status]
         * @param {'ACCESS' | 'CORRECTION' | 'RESTRICTION' | 'ERASURE'} [right]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceDataSubjectGovernanceControllerList(status?: 'PENDING_HUMAN_REVIEW' | 'IN_REVIEW' | 'RESTRICTED' | 'DEFERRED_BY_LEGAL_HOLD' | 'COMPLETED' | 'REJECTED', right?: 'ACCESS' | 'CORRECTION' | 'RESTRICTION' | 'ERASURE', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoiceDsrGovernanceResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceDataSubjectGovernanceControllerList(status, right, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Nałóż ograniczone czasowo wstrzymanie usunięcia
         * @param {string} requestId
         * @param {PlaceVoiceDsrLegalHoldDto} placeVoiceDsrLegalHoldDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceDataSubjectGovernanceControllerPlaceLegalHold(requestId: string, placeVoiceDsrLegalHoldDto: PlaceVoiceDsrLegalHoldDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceDsrGovernanceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceDataSubjectGovernanceControllerPlaceLegalHold(requestId, placeVoiceDsrLegalHoldDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Odrzuć wniosek z kontrolowanym powodem
         * @param {string} requestId
         * @param {RejectVoiceDsrDto} rejectVoiceDsrDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceDataSubjectGovernanceControllerReject(requestId: string, rejectVoiceDsrDto: RejectVoiceDsrDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceDsrGovernanceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceDataSubjectGovernanceControllerReject(requestId, rejectVoiceDsrDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zwolnij wstrzymanie usunięcia
         * @param {string} requestId
         * @param {VoiceDsrRevisionCommandDto} voiceDsrRevisionCommandDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceDataSubjectGovernanceControllerReleaseLegalHold(requestId: string, voiceDsrRevisionCommandDto: VoiceDsrRevisionCommandDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceDsrGovernanceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceDataSubjectGovernanceControllerReleaseLegalHold(requestId, voiceDsrRevisionCommandDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Zaplanuj usunięcie wyłącznie dopasowanych zasobów
         * @param {string} requestId
         * @param {ScheduleVoiceDsrErasureDto} scheduleVoiceDsrErasureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceDataSubjectGovernanceControllerScheduleErasure(requestId: string, scheduleVoiceDsrErasureDto: ScheduleVoiceDsrErasureDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceDsrGovernanceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceDataSubjectGovernanceControllerScheduleErasure(requestId, scheduleVoiceDsrErasureDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ZarzdzanieWnioskamiODaneRecepcjiGosowejApi - factory interface
 * @export
 */
export const ZarzdzanieWnioskamiODaneRecepcjiGosowejApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZarzdzanieWnioskamiODaneRecepcjiGosowejApiFp(configuration)
    return {
        /**
         *
         * @summary Rozpocznij ocenę zweryfikowanego wniosku
         * @param {ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerBeginReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDataSubjectGovernanceControllerBeginReview(requestParameters: ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerBeginReviewRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceDsrGovernanceResponseDto> {
            return localVarFp.voiceDataSubjectGovernanceControllerBeginReview(requestParameters.requestId, requestParameters.voiceDsrRevisionCommandDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zakończ wniosek z kontrolowanym wynikiem
         * @param {ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerCompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDataSubjectGovernanceControllerComplete(requestParameters: ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerCompleteRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceDsrGovernanceResponseDto> {
            return localVarFp.voiceDataSubjectGovernanceControllerComplete(requestParameters.requestId, requestParameters.completeVoiceDsrDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz zminimalizowaną kolejkę wniosków o dane
         * @param {ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDataSubjectGovernanceControllerList(requestParameters: ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerListRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<VoiceDsrGovernanceResponseDto>> {
            return localVarFp.voiceDataSubjectGovernanceControllerList(requestParameters.status, requestParameters.right, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Nałóż ograniczone czasowo wstrzymanie usunięcia
         * @param {ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerPlaceLegalHoldRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDataSubjectGovernanceControllerPlaceLegalHold(requestParameters: ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerPlaceLegalHoldRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceDsrGovernanceResponseDto> {
            return localVarFp.voiceDataSubjectGovernanceControllerPlaceLegalHold(requestParameters.requestId, requestParameters.placeVoiceDsrLegalHoldDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Odrzuć wniosek z kontrolowanym powodem
         * @param {ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerRejectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDataSubjectGovernanceControllerReject(requestParameters: ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerRejectRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceDsrGovernanceResponseDto> {
            return localVarFp.voiceDataSubjectGovernanceControllerReject(requestParameters.requestId, requestParameters.rejectVoiceDsrDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zwolnij wstrzymanie usunięcia
         * @param {ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerReleaseLegalHoldRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDataSubjectGovernanceControllerReleaseLegalHold(requestParameters: ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerReleaseLegalHoldRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceDsrGovernanceResponseDto> {
            return localVarFp.voiceDataSubjectGovernanceControllerReleaseLegalHold(requestParameters.requestId, requestParameters.voiceDsrRevisionCommandDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Zaplanuj usunięcie wyłącznie dopasowanych zasobów
         * @param {ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerScheduleErasureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDataSubjectGovernanceControllerScheduleErasure(requestParameters: ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerScheduleErasureRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceDsrGovernanceResponseDto> {
            return localVarFp.voiceDataSubjectGovernanceControllerScheduleErasure(requestParameters.requestId, requestParameters.scheduleVoiceDsrErasureDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceDataSubjectGovernanceControllerBeginReview operation in ZarzdzanieWnioskamiODaneRecepcjiGosowejApi.
 * @export
 * @interface ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerBeginReviewRequest
 */
export interface ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerBeginReviewRequest {
    /**
     *
     * @type {string}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerBeginReview
     */
    readonly requestId: string

    /**
     *
     * @type {VoiceDsrRevisionCommandDto}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerBeginReview
     */
    readonly voiceDsrRevisionCommandDto: VoiceDsrRevisionCommandDto
}

/**
 * Request parameters for voiceDataSubjectGovernanceControllerComplete operation in ZarzdzanieWnioskamiODaneRecepcjiGosowejApi.
 * @export
 * @interface ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerCompleteRequest
 */
export interface ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerCompleteRequest {
    /**
     *
     * @type {string}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerComplete
     */
    readonly requestId: string

    /**
     *
     * @type {CompleteVoiceDsrDto}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerComplete
     */
    readonly completeVoiceDsrDto: CompleteVoiceDsrDto
}

/**
 * Request parameters for voiceDataSubjectGovernanceControllerList operation in ZarzdzanieWnioskamiODaneRecepcjiGosowejApi.
 * @export
 * @interface ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerListRequest
 */
export interface ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerListRequest {
    /**
     *
     * @type {'PENDING_HUMAN_REVIEW' | 'IN_REVIEW' | 'RESTRICTED' | 'DEFERRED_BY_LEGAL_HOLD' | 'COMPLETED' | 'REJECTED'}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerList
     */
    readonly status?: 'PENDING_HUMAN_REVIEW' | 'IN_REVIEW' | 'RESTRICTED' | 'DEFERRED_BY_LEGAL_HOLD' | 'COMPLETED' | 'REJECTED'

    /**
     *
     * @type {'ACCESS' | 'CORRECTION' | 'RESTRICTION' | 'ERASURE'}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerList
     */
    readonly right?: 'ACCESS' | 'CORRECTION' | 'RESTRICTION' | 'ERASURE'
}

/**
 * Request parameters for voiceDataSubjectGovernanceControllerPlaceLegalHold operation in ZarzdzanieWnioskamiODaneRecepcjiGosowejApi.
 * @export
 * @interface ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerPlaceLegalHoldRequest
 */
export interface ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerPlaceLegalHoldRequest {
    /**
     *
     * @type {string}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerPlaceLegalHold
     */
    readonly requestId: string

    /**
     *
     * @type {PlaceVoiceDsrLegalHoldDto}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerPlaceLegalHold
     */
    readonly placeVoiceDsrLegalHoldDto: PlaceVoiceDsrLegalHoldDto
}

/**
 * Request parameters for voiceDataSubjectGovernanceControllerReject operation in ZarzdzanieWnioskamiODaneRecepcjiGosowejApi.
 * @export
 * @interface ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerRejectRequest
 */
export interface ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerRejectRequest {
    /**
     *
     * @type {string}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerReject
     */
    readonly requestId: string

    /**
     *
     * @type {RejectVoiceDsrDto}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerReject
     */
    readonly rejectVoiceDsrDto: RejectVoiceDsrDto
}

/**
 * Request parameters for voiceDataSubjectGovernanceControllerReleaseLegalHold operation in ZarzdzanieWnioskamiODaneRecepcjiGosowejApi.
 * @export
 * @interface ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerReleaseLegalHoldRequest
 */
export interface ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerReleaseLegalHoldRequest {
    /**
     *
     * @type {string}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerReleaseLegalHold
     */
    readonly requestId: string

    /**
     *
     * @type {VoiceDsrRevisionCommandDto}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerReleaseLegalHold
     */
    readonly voiceDsrRevisionCommandDto: VoiceDsrRevisionCommandDto
}

/**
 * Request parameters for voiceDataSubjectGovernanceControllerScheduleErasure operation in ZarzdzanieWnioskamiODaneRecepcjiGosowejApi.
 * @export
 * @interface ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerScheduleErasureRequest
 */
export interface ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerScheduleErasureRequest {
    /**
     *
     * @type {string}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerScheduleErasure
     */
    readonly requestId: string

    /**
     *
     * @type {ScheduleVoiceDsrErasureDto}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerScheduleErasure
     */
    readonly scheduleVoiceDsrErasureDto: ScheduleVoiceDsrErasureDto
}

/**
 * ZarzdzanieWnioskamiODaneRecepcjiGosowejApi - object-oriented interface
 * @export
 * @class ZarzdzanieWnioskamiODaneRecepcjiGosowejApi
 * @extends {BaseAPI}
 */
export class ZarzdzanieWnioskamiODaneRecepcjiGosowejApi extends BaseAPI {
    /**
     *
     * @summary Rozpocznij ocenę zweryfikowanego wniosku
     * @param {ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerBeginReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApi
     */
    public voiceDataSubjectGovernanceControllerBeginReview(requestParameters: ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerBeginReviewRequest, options?: AxiosRequestConfig) {
        return ZarzdzanieWnioskamiODaneRecepcjiGosowejApiFp(this.configuration).voiceDataSubjectGovernanceControllerBeginReview(requestParameters.requestId, requestParameters.voiceDsrRevisionCommandDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zakończ wniosek z kontrolowanym wynikiem
     * @param {ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerCompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApi
     */
    public voiceDataSubjectGovernanceControllerComplete(requestParameters: ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerCompleteRequest, options?: AxiosRequestConfig) {
        return ZarzdzanieWnioskamiODaneRecepcjiGosowejApiFp(this.configuration).voiceDataSubjectGovernanceControllerComplete(requestParameters.requestId, requestParameters.completeVoiceDsrDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz zminimalizowaną kolejkę wniosków o dane
     * @param {ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApi
     */
    public voiceDataSubjectGovernanceControllerList(requestParameters: ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerListRequest = {}, options?: AxiosRequestConfig) {
        return ZarzdzanieWnioskamiODaneRecepcjiGosowejApiFp(this.configuration).voiceDataSubjectGovernanceControllerList(requestParameters.status, requestParameters.right, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Nałóż ograniczone czasowo wstrzymanie usunięcia
     * @param {ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerPlaceLegalHoldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApi
     */
    public voiceDataSubjectGovernanceControllerPlaceLegalHold(requestParameters: ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerPlaceLegalHoldRequest, options?: AxiosRequestConfig) {
        return ZarzdzanieWnioskamiODaneRecepcjiGosowejApiFp(this.configuration).voiceDataSubjectGovernanceControllerPlaceLegalHold(requestParameters.requestId, requestParameters.placeVoiceDsrLegalHoldDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Odrzuć wniosek z kontrolowanym powodem
     * @param {ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerRejectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApi
     */
    public voiceDataSubjectGovernanceControllerReject(requestParameters: ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerRejectRequest, options?: AxiosRequestConfig) {
        return ZarzdzanieWnioskamiODaneRecepcjiGosowejApiFp(this.configuration).voiceDataSubjectGovernanceControllerReject(requestParameters.requestId, requestParameters.rejectVoiceDsrDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zwolnij wstrzymanie usunięcia
     * @param {ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerReleaseLegalHoldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApi
     */
    public voiceDataSubjectGovernanceControllerReleaseLegalHold(requestParameters: ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerReleaseLegalHoldRequest, options?: AxiosRequestConfig) {
        return ZarzdzanieWnioskamiODaneRecepcjiGosowejApiFp(this.configuration).voiceDataSubjectGovernanceControllerReleaseLegalHold(requestParameters.requestId, requestParameters.voiceDsrRevisionCommandDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Zaplanuj usunięcie wyłącznie dopasowanych zasobów
     * @param {ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerScheduleErasureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZarzdzanieWnioskamiODaneRecepcjiGosowejApi
     */
    public voiceDataSubjectGovernanceControllerScheduleErasure(requestParameters: ZarzdzanieWnioskamiODaneRecepcjiGosowejApiVoiceDataSubjectGovernanceControllerScheduleErasureRequest, options?: AxiosRequestConfig) {
        return ZarzdzanieWnioskamiODaneRecepcjiGosowejApiFp(this.configuration).voiceDataSubjectGovernanceControllerScheduleErasure(requestParameters.requestId, requestParameters.scheduleVoiceDsrErasureDto, options).then((request) => request(this.axios, this.basePath));
    }
}


